/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 270);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(463);
} else {
  module.exports = require('./cjs/react.development.js');
}


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(469)();
}


/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(process, module) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "css", function() { return css; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "keyframes", function() { return keyframes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "injectGlobal", function() { return injectGlobal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isStyledComponent", function() { return isStyledComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "consolidateStreamedStyles", function() { return consolidateStreamedStyles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ThemeProvider", function() { return ThemeProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "withTheme", function() { return withTheme; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ServerStyleSheet", function() { return ServerStyleSheet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StyleSheetManager", function() { return StyleSheetManager; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__DO_NOT_USE_OR_YOU_WILL_BE_HAUNTED_BY_SPOOKY_GHOSTS", function() { return __DO_NOT_USE_OR_YOU_WILL_BE_HAUNTED_BY_SPOOKY_GHOSTS; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fbjs_lib_hyphenateStyleName__ = __webpack_require__(538);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fbjs_lib_hyphenateStyleName___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_fbjs_lib_hyphenateStyleName__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_stylis__ = __webpack_require__(540);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_stylis___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_stylis__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_stylis_rule_sheet__ = __webpack_require__(541);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_stylis_rule_sheet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_stylis_rule_sheet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics__ = __webpack_require__(542);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_is__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_is__);








var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

// 
var isPlainObject = (function (x) {
  return (typeof x === 'undefined' ? 'undefined' : _typeof(x)) === 'object' && x.constructor === Object;
});

// 


/**
 * Parse errors.md and turn it into a simple hash of code: message
 */
var ERRORS =  false ? {
  "1": "Cannot create styled-component for component: %s.\n\n",
  "2": "Can't collect styles once you've consumed a `ServerStyleSheet`'s styles! `ServerStyleSheet` is a one off instance for each server-side render cycle.\n\n* Are you trying to reuse it across renders?\n* Are you accidentally calling collectStyles twice?\n\n",
  "3": "Streaming SSR is only supported in a Node.js environment; Please do not try to call this method in the browser.\n\n",
  "4": "The `StyleSheetManager` expects a valid target or sheet prop!\n\n* Does this error occur on the client and is your target falsy?\n* Does this error occur on the server and is the sheet falsy?\n\n",
  "5": "The clone method cannot be used on the client!\n\n* Are you running in a client-like environment on the server?\n* Are you trying to run SSR on the client?\n\n",
  "6": "Trying to insert a new style tag, but the given Node is unmounted!\n\n* Are you using a custom target that isn't mounted?\n* Does your document not have a valid head element?\n* Have you accidentally removed a style tag manually?\n\n",
  "7": "ThemeProvider: Please return an object from your \"theme\" prop function, e.g.\n\n```js\ntheme={() => ({})}\n```\n\n",
  "8": "ThemeProvider: Please make your \"theme\" prop an object.\n\n",
  "9": "Missing document `<head>`\n\n",
  "10": "Cannot find a StyleSheet instance. Usually this happens if there are multiple copies of styled-components loaded at once. Check out this issue for how to troubleshoot and fix the common cases where this situation can happen: https://github.com/styled-components/styled-components/issues/1941#issuecomment-417862021\n\n",
  "11": "A plain React class (%s) has been interpolated into styles, probably as a component selector (https://www.styled-components.com/docs/advanced#referring-to-other-components). Only styled-component classes can be targeted in this fashion."
} : {};

/**
 * super basic version of sprintf
 */
function format() {
  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  var a = args[0];
  var b = [];
  var c = void 0;

  for (c = 1; c < args.length; c += 1) {
    b.push(args[c]);
  }

  b.forEach(function (d) {
    a = a.replace(/%[a-z]/, d);
  });

  return a;
}

/**
 * Create an error file out of errors.md for development and a simple web link to the full errors
 * in production mode.
 */

var StyledComponentsError = function (_Error) {
  inherits(StyledComponentsError, _Error);

  function StyledComponentsError(code) {
    classCallCheck(this, StyledComponentsError);

    for (var _len2 = arguments.length, interpolations = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      interpolations[_key2 - 1] = arguments[_key2];
    }

    if (true) {
      var _this = possibleConstructorReturn(this, _Error.call(this, 'An error occurred. See https://github.com/styled-components/styled-components/blob/master/src/utils/errors.md#' + code + ' for more information. ' + (interpolations ? 'Additional arguments: ' + interpolations.join(', ') : '')));
    } else {
      var _this = possibleConstructorReturn(this, _Error.call(this, format.apply(undefined, [ERRORS[code]].concat(interpolations))));
    }
    return possibleConstructorReturn(_this);
  }

  return StyledComponentsError;
}(Error);

// 

var objToCss = function objToCss(obj, prevKey) {
  var css = Object.keys(obj).filter(function (key) {
    var chunk = obj[key];
    return chunk !== undefined && chunk !== null && chunk !== false && chunk !== '';
  }).map(function (key) {
    if (isPlainObject(obj[key])) return objToCss(obj[key], key);
    return __WEBPACK_IMPORTED_MODULE_0_fbjs_lib_hyphenateStyleName___default()(key) + ': ' + obj[key] + ';';
  }).join(' ');
  return prevKey ? prevKey + ' {\n  ' + css + '\n}' : css;
};

var flatten = function flatten(chunks, executionContext) {
  return chunks.reduce(function (ruleSet, chunk) {
    /* Remove falsey values */
    if (chunk === undefined || chunk === null || chunk === false || chunk === '') {
      return ruleSet;
    }

    /* Flatten ruleSet */
    if (Array.isArray(chunk)) {
      ruleSet.push.apply(ruleSet, flatten(chunk, executionContext));
      return ruleSet;
    }

    /* Handle other components */
    if (chunk.hasOwnProperty('styledComponentId')) {
      // $FlowFixMe not sure how to make this pass
      ruleSet.push('.' + chunk.styledComponentId);
      return ruleSet;
    }

    /* Either execute or defer the function */
    if (typeof chunk === 'function') {
      if (executionContext) {
        var nextChunk = chunk(executionContext);
        /* Throw if a React Element was given styles */
        if (__WEBPACK_IMPORTED_MODULE_1_react___default.a.isValidElement(nextChunk)) {
          var elementName = chunk.displayName || chunk.name;
          throw new StyledComponentsError(11, elementName);
        }
        ruleSet.push.apply(ruleSet, flatten([nextChunk], executionContext));
      } else ruleSet.push(chunk);

      return ruleSet;
    }

    /* Handle objects */
    ruleSet.push(
    // $FlowFixMe have to add %checks somehow to isPlainObject
    isPlainObject(chunk) ? objToCss(chunk) : chunk.toString());

    return ruleSet;
  }, []);
};

// 

var COMMENT_REGEX = /^\s*\/\/.*$/gm;

// NOTE: This stylis instance is only used to split rules from SSR'd style tags
var stylisSplitter = new __WEBPACK_IMPORTED_MODULE_2_stylis___default.a({
  global: false,
  cascade: true,
  keyframe: false,
  prefix: false,
  compress: false,
  semicolon: true
});

var stylis = new __WEBPACK_IMPORTED_MODULE_2_stylis___default.a({
  global: false,
  cascade: true,
  keyframe: false,
  prefix: true,
  compress: false,
  semicolon: false // NOTE: This means "autocomplete missing semicolons"
});

// Wrap `insertRulePlugin to build a list of rules,
// and then make our own plugin to return the rules. This
// makes it easier to hook into the existing SSR architecture

var parsingRules = [];
// eslint-disable-next-line consistent-return
var returnRulesPlugin = function returnRulesPlugin(context) {
  if (context === -2) {
    var parsedRules = parsingRules;
    parsingRules = [];
    return parsedRules;
  }
};

var parseRulesPlugin = __WEBPACK_IMPORTED_MODULE_3_stylis_rule_sheet___default()(function (rule) {
  parsingRules.push(rule);
});

stylis.use([parseRulesPlugin, returnRulesPlugin]);
stylisSplitter.use([parseRulesPlugin, returnRulesPlugin]);

var stringifyRules = function stringifyRules(rules, selector, prefix) {
  var flatCSS = rules.join('').replace(COMMENT_REGEX, ''); // replace JS comments

  var cssStr = selector && prefix ? prefix + ' ' + selector + ' { ' + flatCSS + ' }' : flatCSS;

  return stylis(prefix || !selector ? '' : selector, cssStr);
};

var splitByRules = function splitByRules(css) {
  return stylisSplitter('', css);
};

// 

function isStyledComponent(target) /* : %checks */{
  return (
    // $FlowFixMe TODO: flow for styledComponentId
    typeof target === 'function' && typeof target.styledComponentId === 'string'
  );
}

// 

/* This function is DEPRECATED and will be removed on the next major version release.
 * It was needed to rehydrate all style blocks prepended to chunks before React
 * tries to rehydrate its HTML stream. Since the master StyleSheet will now detect
 * the use of streamed style tags and will perform the rehydration earlier when needed
 * this function will not be needed anymore */
function consolidateStreamedStyles() {
  if (false) {
    // eslint-disable-next-line no-console
    console.warn('styled-components automatically does streaming SSR rehydration now.\n' + 'Calling consolidateStreamedStyles manually is no longer necessary and a noop now.\n' + '- Please remove the consolidateStreamedStyles call from your client.');
  }
}

// 
/* eslint-disable no-bitwise */

/* This is the "capacity" of our alphabet i.e. 2x26 for all letters plus their capitalised
 * counterparts */
var charsLength = 52;

/* start at 75 for 'a' until 'z' (25) and then start at 65 for capitalised letters */
var getAlphabeticChar = function getAlphabeticChar(code) {
  return String.fromCharCode(code + (code > 25 ? 39 : 97));
};

/* input a number, usually a hash and convert it to base-52 */
var generateAlphabeticName = function generateAlphabeticName(code) {
  var name = '';
  var x = void 0;

  /* get a char and divide by alphabet-length */
  for (x = code; x > charsLength; x = Math.floor(x / charsLength)) {
    name = getAlphabeticChar(x % charsLength) + name;
  }

  return getAlphabeticChar(x % charsLength) + name;
};

// 

var interleave = (function (strings, interpolations) {
  var result = [strings[0]];

  for (var i = 0, len = interpolations.length; i < len; i += 1) {
    result.push(interpolations[i], strings[i + 1]);
  }

  return result;
});

// 
var EMPTY_ARRAY = Object.freeze([]);
var EMPTY_OBJECT = Object.freeze({});

// 

var css = (function (styles) {
  for (var _len = arguments.length, interpolations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    interpolations[_key - 1] = arguments[_key];
  }

  if (typeof styles === 'function' || isPlainObject(styles)) {
    // $FlowFixMe
    return flatten(interleave(EMPTY_ARRAY, [styles].concat(interpolations)));
  }

  // $FlowFixMe
  return flatten(interleave(styles, interpolations));
});

// 


var SC_ATTR = typeof process !== 'undefined' && Object({"NODE_ENV":"production","PUBLIC_URL":""}).SC_ATTR || 'data-styled-components';
var SC_STREAM_ATTR = 'data-styled-streamed';
var CONTEXT_KEY = '__styled-components-stylesheet__';

var IS_BROWSER = typeof window !== 'undefined' && 'HTMLElement' in window;

var DISABLE_SPEEDY = "production" !== 'production';

// 
var SC_COMPONENT_ID = /^[^\S\n]*?\/\* sc-component-id:\s*(\S+)\s+\*\//gm;

var extractComps = (function (maybeCSS) {
  var css = '' + (maybeCSS || ''); // Definitely a string, and a clone
  var existingComponents = [];
  css.replace(SC_COMPONENT_ID, function (match, componentId, matchIndex) {
    existingComponents.push({ componentId: componentId, matchIndex: matchIndex });
    return match;
  });
  return existingComponents.map(function (_ref, i) {
    var componentId = _ref.componentId,
        matchIndex = _ref.matchIndex;

    var nextComp = existingComponents[i + 1];
    var cssFromDOM = nextComp ? css.slice(matchIndex, nextComp.matchIndex) : css.slice(matchIndex);
    return { componentId: componentId, cssFromDOM: cssFromDOM };
  });
});

// 
/* eslint-disable camelcase, no-undef */

var getNonce = (function () {
  return  true ? __webpack_require__.nc : null;
});

// 
// Helper to call a given function, only once
var once = (function (cb) {
  var called = false;

  return function () {
    if (!called) {
      called = true;
      cb();
    }
  };
});

// 
/* These are helpers for the StyleTags to keep track of the injected
 * rule names for each (component) ID that they're keeping track of.
 * They're crucial for detecting whether a name has already been
 * injected.
 * (This excludes rehydrated names) */

/* adds a new ID:name pairing to a names dictionary */
var addNameForId = function addNameForId(names, id, name) {
  if (name) {
    // eslint-disable-next-line no-param-reassign
    var namesForId = names[id] || (names[id] = Object.create(null));
    namesForId[name] = true;
  }
};

/* resets an ID entirely by overwriting it in the dictionary */
var resetIdNames = function resetIdNames(names, id) {
  // eslint-disable-next-line no-param-reassign
  names[id] = Object.create(null);
};

/* factory for a names dictionary checking the existance of an ID:name pairing */
var hasNameForId = function hasNameForId(names) {
  return function (id, name) {
    return names[id] !== undefined && names[id][name];
  };
};

/* stringifies names for the html/element output */
var stringifyNames = function stringifyNames(names) {
  var str = '';
  // eslint-disable-next-line guard-for-in
  for (var id in names) {
    str += Object.keys(names[id]).join(' ') + ' ';
  }
  return str.trim();
};

/* clones the nested names dictionary */
var cloneNames = function cloneNames(names) {
  var clone = Object.create(null);
  // eslint-disable-next-line guard-for-in
  for (var id in names) {
    clone[id] = _extends({}, names[id]);
  }
  return clone;
};

// 

/* These are helpers that deal with the insertRule (aka speedy) API
 * They are used in the StyleTags and specifically the speedy tag
 */

/* retrieve a sheet for a given style tag */
var sheetForTag = function sheetForTag(tag) {
  // $FlowFixMe
  if (tag.sheet) return tag.sheet;

  /* Firefox quirk requires us to step through all stylesheets to find one owned by the given tag */
  var size = document.styleSheets.length;
  for (var i = 0; i < size; i += 1) {
    var sheet = document.styleSheets[i];
    // $FlowFixMe
    if (sheet.ownerNode === tag) return sheet;
  }

  /* we should always be able to find a tag */
  throw new StyledComponentsError(10);
};

/* insert a rule safely and return whether it was actually injected */
var safeInsertRule = function safeInsertRule(sheet, cssRule, index) {
  /* abort early if cssRule string is falsy */
  if (!cssRule) return false;

  var maxIndex = sheet.cssRules.length;

  try {
    /* use insertRule and cap passed index with maxIndex (no of cssRules) */
    sheet.insertRule(cssRule, index <= maxIndex ? index : maxIndex);
  } catch (err) {
    /* any error indicates an invalid rule */
    return false;
  }

  return true;
};

/* deletes `size` rules starting from `removalIndex` */
var deleteRules = function deleteRules(sheet, removalIndex, size) {
  var lowerBound = removalIndex - size;
  for (var i = removalIndex; i > lowerBound; i -= 1) {
    sheet.deleteRule(i);
  }
};

// 

/* this marker separates component styles and is important for rehydration */
var makeTextMarker = function makeTextMarker(id) {
  return '\n/* sc-component-id: ' + id + ' */\n';
};

/* add up all numbers in array up until and including the index */
var addUpUntilIndex = function addUpUntilIndex(sizes, index) {
  var totalUpToIndex = 0;
  for (var i = 0; i <= index; i += 1) {
    totalUpToIndex += sizes[i];
  }

  return totalUpToIndex;
};

/* create a new style tag after lastEl */
var makeStyleTag = function makeStyleTag(target, tagEl, insertBefore) {
  var el = document.createElement('style');
  el.setAttribute(SC_ATTR, '');

  var nonce = getNonce();
  if (nonce) {
    el.setAttribute('nonce', nonce);
  }

  /* Work around insertRule quirk in EdgeHTML */
  el.appendChild(document.createTextNode(''));

  if (target && !tagEl) {
    /* Append to target when no previous element was passed */
    target.appendChild(el);
  } else {
    if (!tagEl || !target || !tagEl.parentNode) {
      throw new StyledComponentsError(6);
    }

    /* Insert new style tag after the previous one */
    tagEl.parentNode.insertBefore(el, insertBefore ? tagEl : tagEl.nextSibling);
  }

  return el;
};

/* takes a css factory function and outputs an html styled tag factory */
var wrapAsHtmlTag = function wrapAsHtmlTag(css, names) {
  return function (additionalAttrs) {
    var nonce = getNonce();
    var attrs = [nonce && 'nonce="' + nonce + '"', SC_ATTR + '="' + stringifyNames(names) + '"', additionalAttrs];

    var htmlAttr = attrs.filter(Boolean).join(' ');
    return '<style ' + htmlAttr + '>' + css() + '</style>';
  };
};

/* takes a css factory function and outputs an element factory */
var wrapAsElement = function wrapAsElement(css, names) {
  return function () {
    var _props;

    var props = (_props = {}, _props[SC_ATTR] = stringifyNames(names), _props);

    var nonce = getNonce();
    if (nonce) {
      // $FlowFixMe
      props.nonce = nonce;
    }

    // eslint-disable-next-line react/no-danger
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('style', _extends({}, props, { dangerouslySetInnerHTML: { __html: css() } }));
  };
};

var getIdsFromMarkersFactory = function getIdsFromMarkersFactory(markers) {
  return function () {
    return Object.keys(markers);
  };
};

/* speedy tags utilise insertRule */
var makeSpeedyTag = function makeSpeedyTag(el, getImportRuleTag) {
  var names = Object.create(null);
  var markers = Object.create(null);
  var sizes = [];

  var extractImport = getImportRuleTag !== undefined;
  /* indicates whther getImportRuleTag was called */
  var usedImportRuleTag = false;

  var insertMarker = function insertMarker(id) {
    var prev = markers[id];
    if (prev !== undefined) {
      return prev;
    }

    markers[id] = sizes.length;
    sizes.push(0);
    resetIdNames(names, id);

    return markers[id];
  };

  var insertRules = function insertRules(id, cssRules, name) {
    var marker = insertMarker(id);
    var sheet = sheetForTag(el);
    var insertIndex = addUpUntilIndex(sizes, marker);

    var injectedRules = 0;
    var importRules = [];
    var cssRulesSize = cssRules.length;

    for (var i = 0; i < cssRulesSize; i += 1) {
      var cssRule = cssRules[i];
      var mayHaveImport = extractImport; /* @import rules are reordered to appear first */
      if (mayHaveImport && cssRule.indexOf('@import') !== -1) {
        importRules.push(cssRule);
      } else if (safeInsertRule(sheet, cssRule, insertIndex + injectedRules)) {
        mayHaveImport = false;
        injectedRules += 1;
      }
    }

    if (extractImport && importRules.length > 0) {
      usedImportRuleTag = true;
      // $FlowFixMe
      getImportRuleTag().insertRules(id + '-import', importRules);
    }

    sizes[marker] += injectedRules; /* add up no of injected rules */
    addNameForId(names, id, name);
  };

  var removeRules = function removeRules(id) {
    var marker = markers[id];
    if (marker === undefined) return;

    var size = sizes[marker];
    var sheet = sheetForTag(el);
    var removalIndex = addUpUntilIndex(sizes, marker);
    deleteRules(sheet, removalIndex, size);
    sizes[marker] = 0;
    resetIdNames(names, id);

    if (extractImport && usedImportRuleTag) {
      // $FlowFixMe
      getImportRuleTag().removeRules(id + '-import');
    }
  };

  var css = function css() {
    var _sheetForTag = sheetForTag(el),
        cssRules = _sheetForTag.cssRules;

    var str = '';

    // eslint-disable-next-line guard-for-in
    for (var id in markers) {
      str += makeTextMarker(id);
      var marker = markers[id];
      var end = addUpUntilIndex(sizes, marker);
      var size = sizes[marker];
      for (var i = end - size; i < end; i += 1) {
        var rule = cssRules[i];
        if (rule !== undefined) {
          str += rule.cssText;
        }
      }
    }

    return str;
  };

  return {
    clone: function clone() {
      throw new StyledComponentsError(5);
    },

    css: css,
    getIds: getIdsFromMarkersFactory(markers),
    hasNameForId: hasNameForId(names),
    insertMarker: insertMarker,
    insertRules: insertRules,
    removeRules: removeRules,
    sealed: false,
    styleTag: el,
    toElement: wrapAsElement(css, names),
    toHTML: wrapAsHtmlTag(css, names)
  };
};

var makeTextNode = function makeTextNode(id) {
  return document.createTextNode(makeTextMarker(id));
};

var makeBrowserTag = function makeBrowserTag(el, getImportRuleTag) {
  var names = Object.create(null);
  var markers = Object.create(null);

  var extractImport = getImportRuleTag !== undefined;

  /* indicates whther getImportRuleTag was called */
  var usedImportRuleTag = false;

  var insertMarker = function insertMarker(id) {
    var prev = markers[id];
    if (prev !== undefined) {
      return prev;
    }

    markers[id] = makeTextNode(id);
    el.appendChild(markers[id]);
    names[id] = Object.create(null);

    return markers[id];
  };

  var insertRules = function insertRules(id, cssRules, name) {
    var marker = insertMarker(id);
    var importRules = [];
    var cssRulesSize = cssRules.length;

    for (var i = 0; i < cssRulesSize; i += 1) {
      var rule = cssRules[i];
      var mayHaveImport = extractImport;
      if (mayHaveImport && rule.indexOf('@import') !== -1) {
        importRules.push(rule);
      } else {
        mayHaveImport = false;
        var separator = i === cssRulesSize - 1 ? '' : ' ';
        marker.appendData('' + rule + separator);
      }
    }

    addNameForId(names, id, name);

    if (extractImport && importRules.length > 0) {
      usedImportRuleTag = true;
      // $FlowFixMe
      getImportRuleTag().insertRules(id + '-import', importRules);
    }
  };

  var removeRules = function removeRules(id) {
    var marker = markers[id];
    if (marker === undefined) return;

    /* create new empty text node and replace the current one */
    var newMarker = makeTextNode(id);
    el.replaceChild(newMarker, marker);
    markers[id] = newMarker;
    resetIdNames(names, id);

    if (extractImport && usedImportRuleTag) {
      // $FlowFixMe
      getImportRuleTag().removeRules(id + '-import');
    }
  };

  var css = function css() {
    var str = '';
    // eslint-disable-next-line guard-for-in
    for (var id in markers) {
      str += markers[id].data;
    }
    return str;
  };

  return {
    clone: function clone() {
      throw new StyledComponentsError(5);
    },

    css: css,
    getIds: getIdsFromMarkersFactory(markers),
    hasNameForId: hasNameForId(names),
    insertMarker: insertMarker,
    insertRules: insertRules,
    removeRules: removeRules,
    sealed: false,
    styleTag: el,
    toElement: wrapAsElement(css, names),
    toHTML: wrapAsHtmlTag(css, names)
  };
};

var makeServerTagInternal = function makeServerTagInternal(namesArg, markersArg) {
  var names = namesArg === undefined ? Object.create(null) : namesArg;
  var markers = markersArg === undefined ? Object.create(null) : markersArg;

  var insertMarker = function insertMarker(id) {
    var prev = markers[id];
    if (prev !== undefined) {
      return prev;
    }

    return markers[id] = [''];
  };

  var insertRules = function insertRules(id, cssRules, name) {
    var marker = insertMarker(id);
    marker[0] += cssRules.join(' ');
    addNameForId(names, id, name);
  };

  var removeRules = function removeRules(id) {
    var marker = markers[id];
    if (marker === undefined) return;
    marker[0] = '';
    resetIdNames(names, id);
  };

  var css = function css() {
    var str = '';
    // eslint-disable-next-line guard-for-in
    for (var id in markers) {
      var cssForId = markers[id][0];
      if (cssForId) {
        str += makeTextMarker(id) + cssForId;
      }
    }
    return str;
  };

  var clone = function clone() {
    var namesClone = cloneNames(names);
    var markersClone = Object.create(null);

    // eslint-disable-next-line guard-for-in
    for (var id in markers) {
      markersClone[id] = [markers[id][0]];
    }

    return makeServerTagInternal(namesClone, markersClone);
  };

  var tag = {
    clone: clone,
    css: css,
    getIds: getIdsFromMarkersFactory(markers),
    hasNameForId: hasNameForId(names),
    insertMarker: insertMarker,
    insertRules: insertRules,
    removeRules: removeRules,
    sealed: false,
    styleTag: null,
    toElement: wrapAsElement(css, names),
    toHTML: wrapAsHtmlTag(css, names)
  };

  return tag;
};

var makeServerTag = function makeServerTag() {
  return makeServerTagInternal();
};

var makeTag = function makeTag(target, tagEl, forceServer, insertBefore, getImportRuleTag) {
  if (IS_BROWSER && !forceServer) {
    var el = makeStyleTag(target, tagEl, insertBefore);

    if (DISABLE_SPEEDY) {
      return makeBrowserTag(el, getImportRuleTag);
    } else {
      return makeSpeedyTag(el, getImportRuleTag);
    }
  }

  return makeServerTag();
};

/* wraps a given tag so that rehydration is performed once when necessary */
var makeRehydrationTag = function makeRehydrationTag(tag, els, extracted, immediateRehydration) {
  /* rehydration function that adds all rules to the new tag */
  var rehydrate = once(function () {
    /* add all extracted components to the new tag */
    for (var i = 0, len = extracted.length; i < len; i += 1) {
      var _extracted$i = extracted[i],
          componentId = _extracted$i.componentId,
          cssFromDOM = _extracted$i.cssFromDOM;

      var cssRules = splitByRules(cssFromDOM);
      tag.insertRules(componentId, cssRules);
    }

    /* remove old HTMLStyleElements, since they have been rehydrated */
    for (var _i = 0, _len = els.length; _i < _len; _i += 1) {
      var el = els[_i];
      if (el.parentNode) {
        el.parentNode.removeChild(el);
      }
    }
  });

  if (immediateRehydration) rehydrate();

  return _extends({}, tag, {
    /* add rehydration hook to insertion methods */
    insertMarker: function insertMarker(id) {
      rehydrate();
      return tag.insertMarker(id);
    },
    insertRules: function insertRules(id, cssRules, name) {
      rehydrate();
      return tag.insertRules(id, cssRules, name);
    }
  });
};

// 

var SPLIT_REGEX = /\s+/;

/* determine the maximum number of components before tags are sharded */
var MAX_SIZE = void 0;
if (IS_BROWSER) {
  /* in speedy mode we can keep a lot more rules in a sheet before a slowdown can be expected */
  MAX_SIZE = DISABLE_SPEEDY ? 40 : 1000;
} else {
  /* for servers we do not need to shard at all */
  MAX_SIZE = -1;
}

var sheetRunningId = 0;
var master = void 0;

var StyleSheet = function () {
  /* a map from ids to tags */
  /* deferred rules for a given id */
  /* this is used for not reinjecting rules via hasNameForId() */
  /* when rules for an id are removed using remove() we have to ignore rehydratedNames for it */
  /* a list of tags belonging to this StyleSheet */
  /* a tag for import rules */
  /* current capacity until a new tag must be created */
  /* children (aka clones) of this StyleSheet inheriting all and future injections */

  function StyleSheet() {
    var _this = this;

    var target = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : IS_BROWSER ? document.head : null;
    var forceServer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    classCallCheck(this, StyleSheet);

    this.getImportRuleTag = function () {
      var importRuleTag = _this.importRuleTag;

      if (importRuleTag !== undefined) {
        return importRuleTag;
      }

      var firstTag = _this.tags[0];
      var insertBefore = true;

      return _this.importRuleTag = makeTag(_this.target, firstTag ? firstTag.styleTag : null, _this.forceServer, insertBefore);
    };

    sheetRunningId += 1;
    this.id = sheetRunningId;
    this.forceServer = forceServer;
    this.target = forceServer ? null : target;
    this.tagMap = {};
    this.deferred = {};
    this.rehydratedNames = {};
    this.ignoreRehydratedNames = {};
    this.tags = [];
    this.capacity = 1;
    this.clones = [];
  }

  /* rehydrate all SSR'd style tags */


  StyleSheet.prototype.rehydrate = function rehydrate() {
    if (!IS_BROWSER || this.forceServer) {
      return this;
    }

    var els = [];
    var extracted = [];
    var isStreamed = false;

    /* retrieve all of our SSR style elements from the DOM */
    var nodes = document.querySelectorAll('style[' + SC_ATTR + ']');
    var nodesSize = nodes.length;

    /* abort rehydration if no previous style tags were found */
    if (nodesSize === 0) {
      return this;
    }

    for (var i = 0; i < nodesSize; i += 1) {
      // $FlowFixMe: We can trust that all elements in this query are style elements
      var el = nodes[i];

      /* check if style tag is a streamed tag */
      if (!isStreamed) isStreamed = !!el.getAttribute(SC_STREAM_ATTR);

      /* retrieve all component names */
      var elNames = (el.getAttribute(SC_ATTR) || '').trim().split(SPLIT_REGEX);
      var elNamesSize = elNames.length;
      for (var j = 0; j < elNamesSize; j += 1) {
        var name = elNames[j];
        /* add rehydrated name to sheet to avoid readding styles */
        this.rehydratedNames[name] = true;
      }

      /* extract all components and their CSS */
      extracted.push.apply(extracted, extractComps(el.textContent));

      /* store original HTMLStyleElement */
      els.push(el);
    }

    /* abort rehydration if nothing was extracted */
    var extractedSize = extracted.length;
    if (extractedSize === 0) {
      return this;
    }

    /* create a tag to be used for rehydration */
    var tag = this.makeTag(null);
    var rehydrationTag = makeRehydrationTag(tag, els, extracted, isStreamed);

    /* reset capacity and adjust MAX_SIZE by the initial size of the rehydration */
    this.capacity = Math.max(1, MAX_SIZE - extractedSize);
    this.tags.push(rehydrationTag);

    /* retrieve all component ids */
    for (var _j = 0; _j < extractedSize; _j += 1) {
      this.tagMap[extracted[_j].componentId] = rehydrationTag;
    }

    return this;
  };

  /* retrieve a "master" instance of StyleSheet which is typically used when no other is available
   * The master StyleSheet is targeted by injectGlobal, keyframes, and components outside of any
    * StyleSheetManager's context */


  /* reset the internal "master" instance */
  StyleSheet.reset = function reset() {
    var forceServer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    master = new StyleSheet(undefined, forceServer).rehydrate();
  };

  /* adds "children" to the StyleSheet that inherit all of the parents' rules
   * while their own rules do not affect the parent */


  StyleSheet.prototype.clone = function clone() {
    var sheet = new StyleSheet(this.target, this.forceServer);

    /* add to clone array */
    this.clones.push(sheet);

    /* clone all tags */
    sheet.tags = this.tags.map(function (tag) {
      var ids = tag.getIds();
      var newTag = tag.clone();

      /* reconstruct tagMap */
      for (var i = 0; i < ids.length; i += 1) {
        sheet.tagMap[ids[i]] = newTag;
      }

      return newTag;
    });

    /* clone other maps */
    sheet.rehydratedNames = _extends({}, this.rehydratedNames);
    sheet.deferred = _extends({}, this.deferred);

    return sheet;
  };

  /* force StyleSheet to create a new tag on the next injection */


  StyleSheet.prototype.sealAllTags = function sealAllTags() {
    this.capacity = 1;

    this.tags.forEach(function (tag) {
      // eslint-disable-next-line no-param-reassign
      tag.sealed = true;
    });
  };

  StyleSheet.prototype.makeTag = function makeTag$$1(tag) {
    var lastEl = tag ? tag.styleTag : null;
    var insertBefore = false;

    return makeTag(this.target, lastEl, this.forceServer, insertBefore, this.getImportRuleTag);
  };

  /* get a tag for a given componentId, assign the componentId to one, or shard */
  StyleSheet.prototype.getTagForId = function getTagForId(id) {
    /* simply return a tag, when the componentId was already assigned one */
    var prev = this.tagMap[id];
    if (prev !== undefined && !prev.sealed) {
      return prev;
    }

    var tag = this.tags[this.tags.length - 1];

    /* shard (create a new tag) if the tag is exhausted (See MAX_SIZE) */
    this.capacity -= 1;

    if (this.capacity === 0) {
      this.capacity = MAX_SIZE;
      tag = this.makeTag(tag);
      this.tags.push(tag);
    }

    return this.tagMap[id] = tag;
  };

  /* mainly for injectGlobal to check for its id */


  StyleSheet.prototype.hasId = function hasId(id) {
    return this.tagMap[id] !== undefined;
  };

  /* caching layer checking id+name to already have a corresponding tag and injected rules */


  StyleSheet.prototype.hasNameForId = function hasNameForId(id, name) {
    /* exception for rehydrated names which are checked separately */
    if (this.ignoreRehydratedNames[id] === undefined && this.rehydratedNames[name]) {
      return true;
    }

    var tag = this.tagMap[id];
    return tag !== undefined && tag.hasNameForId(id, name);
  };

  /* registers a componentId and registers it on its tag */


  StyleSheet.prototype.deferredInject = function deferredInject(id, cssRules) {
    /* don't inject when the id is already registered */
    if (this.tagMap[id] !== undefined) return;

    var clones = this.clones;

    for (var i = 0; i < clones.length; i += 1) {
      clones[i].deferredInject(id, cssRules);
    }

    this.getTagForId(id).insertMarker(id);
    this.deferred[id] = cssRules;
  };

  /* injects rules for a given id with a name that will need to be cached */


  StyleSheet.prototype.inject = function inject(id, cssRules, name) {
    var clones = this.clones;


    for (var i = 0; i < clones.length; i += 1) {
      clones[i].inject(id, cssRules, name);
    }

    var tag = this.getTagForId(id);

    /* add deferred rules for component */
    if (this.deferred[id] !== undefined) {
      // Combine passed cssRules with previously deferred CSS rules
      // NOTE: We cannot mutate the deferred array itself as all clones
      // do the same (see clones[i].inject)
      var rules = this.deferred[id].concat(cssRules);
      tag.insertRules(id, rules, name);

      this.deferred[id] = undefined;
    } else {
      tag.insertRules(id, cssRules, name);
    }
  };

  /* removes all rules for a given id, which doesn't remove its marker but resets it */


  StyleSheet.prototype.remove = function remove(id) {
    var tag = this.tagMap[id];
    if (tag === undefined) return;

    var clones = this.clones;

    for (var i = 0; i < clones.length; i += 1) {
      clones[i].remove(id);
    }

    /* remove all rules from the tag */
    tag.removeRules(id);
    /* ignore possible rehydrated names */
    this.ignoreRehydratedNames[id] = true;
    /* delete possible deferred rules */
    this.deferred[id] = undefined;
  };

  StyleSheet.prototype.toHTML = function toHTML() {
    return this.tags.map(function (tag) {
      return tag.toHTML();
    }).join('');
  };

  StyleSheet.prototype.toReactElements = function toReactElements() {
    var id = this.id;


    return this.tags.map(function (tag, i) {
      var key = 'sc-' + id + '-' + i;
      return Object(__WEBPACK_IMPORTED_MODULE_1_react__["cloneElement"])(tag.toElement(), { key: key });
    });
  };

  createClass(StyleSheet, null, [{
    key: 'master',
    get: function get$$1() {
      return master || (master = new StyleSheet().rehydrate());
    }

    /* NOTE: This is just for backwards-compatibility with jest-styled-components */

  }, {
    key: 'instance',
    get: function get$$1() {
      return StyleSheet.master;
    }
  }]);
  return StyleSheet;
}();

var _StyleSheetManager$ch;

var StyleSheetManager = function (_Component) {
  inherits(StyleSheetManager, _Component);

  function StyleSheetManager() {
    classCallCheck(this, StyleSheetManager);
    return possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  StyleSheetManager.prototype.getChildContext = function getChildContext() {
    var _ref;

    return _ref = {}, _ref[CONTEXT_KEY] = this.sheetInstance, _ref;
  };

  StyleSheetManager.prototype.componentWillMount = function componentWillMount() {
    if (this.props.sheet) {
      this.sheetInstance = this.props.sheet;
    } else if (this.props.target) {
      this.sheetInstance = new StyleSheet(this.props.target);
    } else {
      throw new StyledComponentsError(4);
    }
  };

  StyleSheetManager.prototype.render = function render() {
    /* eslint-disable react/prop-types */
    // Flow v0.43.1 will report an error accessing the `children` property,
    // but v0.47.0 will not. It is necessary to use a type cast instead of
    // a "fixme" comment to satisfy both Flow versions.
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.Children.only(this.props.children);
  };

  return StyleSheetManager;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

StyleSheetManager.childContextTypes = (_StyleSheetManager$ch = {}, _StyleSheetManager$ch[CONTEXT_KEY] = __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.instanceOf(StyleSheet), __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.instanceOf(ServerStyleSheet)]).isRequired, _StyleSheetManager$ch);
 false ? StyleSheetManager.propTypes = {
  sheet: PropTypes.oneOfType([PropTypes.instanceOf(StyleSheet), PropTypes.instanceOf(ServerStyleSheet)]),
  target: PropTypes.shape({
    appendChild: PropTypes.func.isRequired
  })
} : void 0;

// 

var ServerStyleSheet = function () {
  function ServerStyleSheet() {
    classCallCheck(this, ServerStyleSheet);

    /* The master sheet might be reset, so keep a reference here */
    this.masterSheet = StyleSheet.master;
    this.instance = this.masterSheet.clone();
    this.closed = false;
  }

  ServerStyleSheet.prototype.complete = function complete() {
    if (!this.closed) {
      /* Remove closed StyleSheets from the master sheet */
      var index = this.masterSheet.clones.indexOf(this.instance);
      this.masterSheet.clones.splice(index, 1);
      this.closed = true;
    }
  };

  ServerStyleSheet.prototype.collectStyles = function collectStyles(children) {
    if (this.closed) {
      throw new StyledComponentsError(2);
    }

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      StyleSheetManager,
      { sheet: this.instance },
      children
    );
  };

  ServerStyleSheet.prototype.getStyleTags = function getStyleTags() {
    this.complete();
    return this.instance.toHTML();
  };

  ServerStyleSheet.prototype.getStyleElement = function getStyleElement() {
    this.complete();
    return this.instance.toReactElements();
  };

  ServerStyleSheet.prototype.interleaveWithNodeStream = function interleaveWithNodeStream(readableStream) {
    var _this = this;

    {
      throw new StyledComponentsError(3);
    }

    /* the tag index keeps track of which tags have already been emitted */
    var instance = this.instance;

    var instanceTagIndex = 0;

    var streamAttr = SC_STREAM_ATTR + '="true"';

    var transformer = new stream.Transform({
      transform: function appendStyleChunks(chunk, /* encoding */_, callback) {
        var tags = instance.tags;

        var html = '';

        /* retrieve html for each new style tag */
        for (; instanceTagIndex < tags.length; instanceTagIndex += 1) {
          var tag = tags[instanceTagIndex];
          html += tag.toHTML(streamAttr);
        }

        /* force our StyleSheets to emit entirely new tags */
        instance.sealAllTags();

        /* prepend style html to chunk */
        this.push(html + chunk);
        callback();
      }
    });

    readableStream.on('end', function () {
      return _this.complete();
    });
    readableStream.on('error', function (err) {
      _this.complete();

      // forward the error to the transform stream
      transformer.emit('error', err);
    });

    return readableStream.pipe(transformer);
  };

  return ServerStyleSheet;
}();

// 

var LIMIT = 200;

var createWarnTooManyClasses = (function (displayName) {
  var generatedClasses = {};
  var warningSeen = false;

  return function (className) {
    if (!warningSeen) {
      generatedClasses[className] = true;
      if (Object.keys(generatedClasses).length >= LIMIT) {
        // Unable to find latestRule in test environment.
        /* eslint-disable no-console, prefer-template */
        console.warn('Over ' + LIMIT + ' classes were generated for component ' + displayName + '. \n' + 'Consider using the attrs method, together with a style object for frequently changed styles.\n' + 'Example:\n' + '  const Component = styled.div.attrs({\n' + '    style: ({ background }) => ({\n' + '      background,\n' + '    }),\n' + '  })`width: 100%;`\n\n' + '  <Component />');
        warningSeen = true;
        generatedClasses = {};
      }
    }
  };
});

// 

var determineTheme = (function (props, fallbackTheme, defaultProps) {
  // Props should take precedence over ThemeProvider, which should take precedence over
  // defaultProps, but React automatically puts defaultProps on props.

  /* eslint-disable react/prop-types */
  var isDefaultTheme = defaultProps && props.theme === defaultProps.theme;
  var theme = props.theme && !isDefaultTheme ? props.theme : fallbackTheme;
  /* eslint-enable */

  return theme;
});

// 
var escapeRegex = /[[\].#*$><+~=|^:(),"'`-]+/g;
var dashesAtEnds = /(^-|-$)/g;

/**
 * TODO: Explore using CSS.escape when it becomes more available
 * in evergreen browsers.
 */
function escape(str) {
  return str
  // Replace all possible CSS selectors
  .replace(escapeRegex, '-')

  // Remove extraneous hyphens at the start and end
  .replace(dashesAtEnds, '');
}

// 

function getComponentName(target) {
  return target.displayName || target.name || 'Component';
}

// 

function isTag(target) /* : %checks */{
  return typeof target === 'string';
}

// 

function generateDisplayName(target) {
  return isTag(target) ? 'styled.' + target : 'Styled(' + getComponentName(target) + ')';
}

// 
/* eslint-disable max-len */
/**
 * Trying to avoid the unknown-prop errors on styled components by filtering by
 * React's attribute whitelist.
 *
 * To regenerate this regex:
 *
 * 1. `npm i -g regexgen` (https://github.com/devongovett/regexgen)
 * 2. Run `regexgen` with the list of space-separated words below as input
 * 3. Surround the emitted regex with this: `/^(GENERATED_REGEX)$/` -- this will ensure a full string match
 *    and no false positives from partials
 * */
/*
children dangerouslySetInnerHTML key ref autoFocus defaultValue valueLink defaultChecked checkedLink innerHTML suppressContentEditableWarning onFocusIn onFocusOut className onCopy onCut onPaste onCompositionEnd onCompositionStart onCompositionUpdate onKeyDown onKeyPress onKeyUp onFocus onBlur onChange onInput onInvalid onSubmit onReset onClick onContextMenu onDoubleClick onDrag onDragEnd onDragEnter onDragExit onDragLeave onDragOver onDragStart onDrop onMouseDown onMouseEnter onMouseLeave onMouseMove onMouseOut onMouseOver onMouseUp onSelect onTouchCancel onTouchEnd onTouchMove onTouchStart onScroll onWheel onAbort onCanPlay onCanPlayThrough onDurationChange onEmptied onEncrypted onEnded onError onLoadedData onLoadedMetadata onLoadStart onPause onPlay onPlaying onProgress onRateChange onSeeked onSeeking onStalled onSuspend onTimeUpdate onVolumeChange onWaiting onLoad onAnimationStart onAnimationEnd onAnimationIteration onTransitionEnd onCopyCapture onCutCapture onPasteCapture onCompositionEndCapture onCompositionStartCapture onCompositionUpdateCapture onKeyDownCapture onKeyPressCapture onKeyUpCapture onFocusCapture onBlurCapture onChangeCapture onInputCapture onSubmitCapture onResetCapture onClickCapture onContextMenuCapture onDoubleClickCapture onDragCapture onDragEndCapture onDragEnterCapture onDragExitCapture onDragLeaveCapture onDragOverCapture onDragStartCapture onDropCapture onMouseDownCapture onMouseEnterCapture onMouseLeaveCapture onMouseMoveCapture onMouseOutCapture onMouseOverCapture onMouseUpCapture onSelectCapture onTouchCancelCapture onTouchEndCapture onTouchMoveCapture onTouchStartCapture onScrollCapture onWheelCapture onAbortCapture onCanPlayCapture onCanPlayThroughCapture onDurationChangeCapture onEmptiedCapture onEncryptedCapture onEndedCapture onErrorCapture onLoadedDataCapture onLoadedMetadataCapture onLoadStartCapture onPauseCapture onPlayCapture onPlayingCapture onProgressCapture onRateChangeCapture onSeekedCapture onSeekingCapture onStalledCapture onSuspendCapture onTimeUpdateCapture onVolumeChangeCapture onWaitingCapture onLoadCapture onAnimationStartCapture onAnimationEndCapture onAnimationIterationCapture onTransitionEndCapture accept acceptCharset accessKey action allowFullScreen allowTransparency alt as async autoComplete autoPlay capture cellPadding cellSpacing charSet challenge checked cite classID className cols colSpan content contentEditable contextMenu controlsList controls coords crossOrigin data dateTime default defer dir disabled download draggable encType form formAction formEncType formMethod formNoValidate formTarget frameBorder headers height hidden high href hrefLang htmlFor httpEquiv icon id inputMode integrity is keyParams keyType kind label lang list loop low manifest marginHeight marginWidth max maxLength media mediaGroup method min minLength multiple muted name nonce noValidate open optimum pattern placeholder playsInline poster preload profile radioGroup readOnly referrerPolicy rel required reversed role rows rowSpan sandbox scope scoped scrolling seamless selected shape size sizes span spellCheck src srcDoc srcLang srcSet start step style summary tabIndex target title type useMap value width wmode wrap about datatype inlist prefix property resource typeof vocab autoCapitalize autoCorrect autoSave color itemProp itemScope itemType itemID itemRef results security unselectable accentHeight accumulate additive alignmentBaseline allowReorder alphabetic amplitude arabicForm ascent attributeName attributeType autoReverse azimuth baseFrequency baseProfile baselineShift bbox begin bias by calcMode capHeight clip clipPath clipRule clipPathUnits colorInterpolation colorInterpolationFilters colorProfile colorRendering contentScriptType contentStyleType cursor cx cy d decelerate descent diffuseConstant direction display divisor dominantBaseline dur dx dy edgeMode elevation enableBackground end exponent externalResourcesRequired fill fillOpacity fillRule filter filterRes filterUnits floodColor floodOpacity focusable fontFamily fontSize fontSizeAdjust fontStretch fontStyle fontVariant fontWeight format from fx fy g1 g2 glyphName glyphOrientationHorizontal glyphOrientationVertical glyphRef gradientTransform gradientUnits hanging horizAdvX horizOriginX ideographic imageRendering in in2 intercept k k1 k2 k3 k4 kernelMatrix kernelUnitLength kerning keyPoints keySplines keyTimes lengthAdjust letterSpacing lightingColor limitingConeAngle local markerEnd markerMid markerStart markerHeight markerUnits markerWidth mask maskContentUnits maskUnits mathematical mode numOctaves offset opacity operator order orient orientation origin overflow overlinePosition overlineThickness paintOrder panose1 pathLength patternContentUnits patternTransform patternUnits pointerEvents points pointsAtX pointsAtY pointsAtZ preserveAlpha preserveAspectRatio primitiveUnits r radius refX refY renderingIntent repeatCount repeatDur requiredExtensions requiredFeatures restart result rotate rx ry scale seed shapeRendering slope spacing specularConstant specularExponent speed spreadMethod startOffset stdDeviation stemh stemv stitchTiles stopColor stopOpacity strikethroughPosition strikethroughThickness string stroke strokeDasharray strokeDashoffset strokeLinecap strokeLinejoin strokeMiterlimit strokeOpacity strokeWidth surfaceScale systemLanguage tableValues targetX targetY textAnchor textDecoration textRendering textLength to transform u1 u2 underlinePosition underlineThickness unicode unicodeBidi unicodeRange unitsPerEm vAlphabetic vHanging vIdeographic vMathematical values vectorEffect version vertAdvY vertOriginX vertOriginY viewBox viewTarget visibility widths wordSpacing writingMode x xHeight x1 x2 xChannelSelector xlinkActuate xlinkArcrole xlinkHref xlinkRole xlinkShow xlinkTitle xlinkType xmlBase xmlns xmlnsXlink xmlLang xmlSpace y y1 y2 yChannelSelector z zoomAndPan onPointerDown onPointerMove onPointerUp onPointerCancel onGotPointerCapture onLostPointerCapture onPointerEnter onPointerLeave onPointerOver onPointerOut class for autofocus allow allowUserMedia allowPaymentRequest
*/
/* eslint-enable max-len */

var ATTRIBUTE_REGEX = /^((?:s(?:uppressContentEditableWarn|croll|pac)|(?:shape|image|text)Render|(?:letter|word)Spac|vHang|hang)ing|(?:on(?:AnimationIteration|C(?:o(?:mposition(?:Update|Start|End)|ntextMenu|py)|anPlayThrough|anPlay|hange|lick|ut)|(?:Animation|Touch|Load|Drag)Start|(?:(?:Duration|Volume|Rate)Chang|(?:MouseLea|(?:Touch|Mouse)Mo|DragLea)v|Paus)e|Loaded(?:Metad|D)ata|(?:(?:T(?:ransition|ouch)|Animation)E|Suspe)nd|DoubleClick|(?:TouchCanc|Whe)el|Lo(?:stPointer|ad)|TimeUpdate|(?:Mouse(?:Ent|Ov)e|Drag(?:Ent|Ov)e|Erro)r|GotPointer|MouseDown|(?:E(?:n(?:crypt|d)|mpti)|S(?:tall|eek))ed|KeyPress|(?:MouseOu|DragExi|S(?:elec|ubmi)|Rese|Inpu)t|P(?:rogress|laying)|DragEnd|Key(?:Down|Up)|(?:MouseU|Dro)p|(?:Wait|Seek)ing|Scroll|Focus|Paste|Abort|Drag|Play|Blur)Captur|alignmentBaselin|(?:limitingConeAng|xlink(?:(?:Arcr|R)o|Tit)|s(?:urfaceSca|ty|ca)|unselectab|baseProfi|fontSty|(?:focus|dragg)ab|multip|profi|tit)l|d(?:ominantBaselin|efaultValu)|onPointerLeav|a(?:uto(?:Capitaliz|Revers|Sav)|dditiv)|(?:(?:formNoValid|xlinkActu|noValid|accumul|rot)a|autoComple|decelera)t|(?:(?:attribute|item)T|datat)yp|onPointerMov|(?:attribute|glyph)Nam|playsInlin|(?:writing|input|edge)Mod|(?:formE|e)ncTyp|(?:amplitu|mo)d|(?:xlinkTy|itemSco|keyTy|slo)p|(?:xmlSpa|non)c|fillRul|(?:dateTi|na)m|r(?:esourc|ol)|xmlBas|wmod)e|(?:glyphOrientationHorizont|loc)al|(?:externalResourcesRequir|select|revers|mut)ed|c(?:o(?:lorInterpolationFilter|ord)s|o(?:lor(?:Interpolation)?|nt(?:rols|ent))|(?:ontentS(?:cript|tyle)Typ|o(?:ntentEditab|lorProfi)l|l(?:assNam|ipRul)|a(?:lcMod|ptur)|it)e|olorRendering|l(?:ipPathUnits|assID)|(?:ontrolsLis|apHeigh)t|h(?:eckedLink|a(?:llenge|rSet)|ildren|ecked)|ell(?:Spac|Padd)ing|o(?:ntextMenu|ls)|(?:rossOrigi|olSpa)n|l(?:ip(?:Path)?|ass)|ursor|[xy])|glyphOrientationVertical|d(?:angerouslySetInnerHTML|efaultChecked|ownload|isabled|isplay|[xy])|(?:s(?:trikethroughThickn|eaml)es|(?:und|ov)erlineThicknes|r(?:equiredExtension|adiu)|(?:requiredFeatur|tableValu|stitchTil|numOctav|filterR)e|key(?:(?:Splin|Tim)e|Param)|auto[Ff]ocu|header|bia)s|(?:(?:st(?:rikethroughPosi|dDevia)|(?:und|ov)erlinePosi|(?:textDecor|elev)a|orienta)tio|(?:strokeLinejo|orig)i|on(?:PointerDow|FocusI)|formActio|zoomAndPa|directio|(?:vers|act)io|rowSpa|begi|ico)n|o(?:n(?:AnimationIteration|C(?:o(?:mposition(?:Update|Start|End)|ntextMenu|py)|anPlayThrough|anPlay|hange|lick|ut)|(?:(?:Duration|Volume|Rate)Chang|(?:MouseLea|(?:Touch|Mouse)Mo|DragLea)v|Paus)e|Loaded(?:Metad|D)ata|(?:Animation|Touch|Load|Drag)Start|(?:(?:T(?:ransition|ouch)|Animation)E|Suspe)nd|DoubleClick|(?:TouchCanc|Whe)el|(?:Mouse(?:Ent|Ov)e|Drag(?:Ent|Ov)e|Erro)r|TimeUpdate|(?:E(?:n(?:crypt|d)|mpti)|S(?:tall|eek))ed|MouseDown|P(?:rogress|laying)|(?:MouseOu|DragExi|S(?:elec|ubmi)|Rese|Inpu)t|KeyPress|DragEnd|Key(?:Down|Up)|(?:Wait|Seek)ing|(?:MouseU|Dro)p|Scroll|Paste|Focus|Abort|Drag|Play|Load|Blur)|rient)|p(?:reserveAspectRatio|ointsAt[X-Z]|anose1)|(?:(?:allowPaymentReque|(?:fontSize|length)Adju|manife)s|strokeMiterlimi|(?:(?:specularE|e)xpon|renderingInt|asc)en|(?:specularConsta|repeatCou|fontVaria)n|d(?:iffuseConsta|esce)n|baselineShif|vectorEffec|onPointerOu|(?:(?:mar(?:ker|gin)|x)H|accentH|fontW)eigh|markerStar|a(?:utoCorrec|bou)|onFocusOu|intercep|restar|forma|inlis|heigh|lis)t|(?:patternContent|ma(?:sk(?:Content)?|rker)|primitive|gradient|pattern|filter)Units|(?:(?:allowTranspar|baseFrequ)enc|re(?:ferrerPolic|adOnl)|(?:(?:st(?:roke|op)O|floodO|fillO|o)pac|integr|secur)it|visibilit|fontFamil|accessKe|propert|summar)y|(?:gradientT|patternT|t)ransform|(?:(?:st(?:rokeDasho|artO)|o)ffs|acceptChars|formTarg|viewTarg|srcS)et|(?:[xy]ChannelSelect|lightingCol|textAnch|floodCol|stopCol|operat|htmlF)or|(?:(?:enableBackgrou|markerE)n|s(?:p(?:readMetho|ee)|ee)|formMetho|(?:markerM|onInval)i|preloa|metho|kin)d|k(?:ernel(?:UnitLength|Matrix)|[1-4])|strokeDasharray|(?:onPointerCanc|lab)el|(?:allowFullScre|hidd)en|a(?:l(?:lowUserMedia|phabetic|t)|rabicForm|sync)|systemLanguage|(?:(?:o(?:nPointer(?:Ent|Ov)|rd)|allowReord|placehold|frameBord|paintOrd|post)e|repeatDu|d(?:efe|u))r|(?:pointerEve|keyPoi)nts|preserveAlpha|(?:strokeLineca|onPointerU|itemPro|useMa|wra|loo)p|v(?:Mathematical|ert(?:Origin[XY]|AdvY)|alues|ocab)|unicodeRange|h(?:oriz(?:Origin|Adv)X|ttpEquiv)|(?:vI|i)deographic|mathematical|u(?:nicodeBidi|[12])|(?:fontStretc|hig)h|vAlphabetic|(?:(?:mar(?:ker|gin)W|strokeW)id|azimu)th|(?:xmlnsXl|valueL)ink|mediaGroup|spellCheck|(?:text|m(?:in|ax))Length|(?:unitsPerE|optimu|fro)m|r(?:adioGroup|e(?:sults|f[XY]|l)|ows|[xy])|pathLength|(?:xlinkHr|glyphR)ef|innerHTML|xlinkShow|f(?:o(?:ntSize|rm?)|il(?:ter|l))|(?:tabInde|(?:sand|b)bo|viewBo)x|autoPlay|r(?:e(?:quired|sult|f))?|(?:(?:href|xml|src)La|kerni)ng|o(?:verflow|pen)|i(?:temRef|n2|s)|p(?:attern|oints)|unicode|d(?:efault|ata|ir)?|divisor|t(?:arget[XY]|o)|(?:stri|la)ng|(?:width|size)s|prefix|typeof|srcDoc|s(?:coped|te(?:m[hv]|p)|pan)|s(?:t(?:roke|art)|hape|cope|rc)|a(?:ccept|llow|s)|itemID|t(?:arget|ype)|m(?:edia|a(?:sk|x)|in)|value|width|x(?:mlns)?|size|href|k(?:ey)?|end|low|by|x[12]|y[12]|g[12]|i[dn]|f[xy]|[yz])$/;
/* From DOMProperty */
var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
var ATTRIBUTE_NAME_CHAR = ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040';
var isCustomAttribute = RegExp.prototype.test.bind(new RegExp('^(x|data|aria)-[' + ATTRIBUTE_NAME_CHAR + ']*$'));

var validAttr = (function (name) {
  return ATTRIBUTE_REGEX.test(name) || isCustomAttribute(name.toLowerCase());
});

// 

function hasInInheritanceChain(child, parent) {
  var target = child;

  while (target) {
    target = Object.getPrototypeOf(target);

    if (target && target === parent) {
      return true;
    }
  }

  return false;
}

// 
/**
 * Creates a broadcast that can be listened to, i.e. simple event emitter
 *
 * @see https://github.com/ReactTraining/react-broadcast
 */

var createBroadcast = function createBroadcast(initialState) {
  var listeners = {};
  var id = 0;
  var state = initialState;

  function publish(nextState) {
    state = nextState;

    // eslint-disable-next-line guard-for-in, no-restricted-syntax
    for (var key in listeners) {
      var listener = listeners[key];
      if (listener === undefined) {
        // eslint-disable-next-line no-continue
        continue;
      }

      listener(state);
    }
  }

  function subscribe(listener) {
    var currentId = id;
    listeners[currentId] = listener;
    id += 1;
    listener(state);
    return currentId;
  }

  function unsubscribe(unsubID) {
    listeners[unsubID] = undefined;
  }

  return { publish: publish, subscribe: subscribe, unsubscribe: unsubscribe };
};

var _contextShape, _ThemeProvider$contex;

// NOTE: DO NOT CHANGE, changing this is a semver major change!
var CHANNEL = '__styled-components__';
var CHANNEL_NEXT = CHANNEL + 'next__';

var CONTEXT_CHANNEL_SHAPE = __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.shape({
  getTheme: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  subscribe: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  unsubscribe: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func
});

var contextShape = (_contextShape = {}, _contextShape[CHANNEL] = __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func, _contextShape[CHANNEL_NEXT] = CONTEXT_CHANNEL_SHAPE, _contextShape);

var warnChannelDeprecated = void 0;
if (false) {
  warnChannelDeprecated = once(function () {
    // eslint-disable-next-line no-console
    console.warn('Warning: Usage of `context.' + CHANNEL + '` as a function is deprecated. It will be replaced with the object on `.context.' + CHANNEL_NEXT + '` in a future version.');
  });
}

var isFunction = function isFunction(test) {
  return typeof test === 'function';
};

/**
 * Provide a theme to an entire react component tree via context and event listeners (have to do
 * both context and event emitter as pure components block context updates)
 */

var ThemeProvider = function (_Component) {
  inherits(ThemeProvider, _Component);

  function ThemeProvider() {
    classCallCheck(this, ThemeProvider);

    var _this = possibleConstructorReturn(this, _Component.call(this));

    _this.unsubscribeToOuterId = -1;

    _this.getTheme = _this.getTheme.bind(_this);
    return _this;
  }

  ThemeProvider.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    // If there is a ThemeProvider wrapper anywhere around this theme provider, merge this theme
    // with the outer theme
    var outerContext = this.context[CHANNEL_NEXT];
    if (outerContext !== undefined) {
      this.unsubscribeToOuterId = outerContext.subscribe(function (theme) {
        _this2.outerTheme = theme;

        if (_this2.broadcast !== undefined) {
          _this2.publish(_this2.props.theme);
        }
      });
    }

    this.broadcast = createBroadcast(this.getTheme());
  };

  ThemeProvider.prototype.getChildContext = function getChildContext() {
    var _this3 = this,
        _babelHelpers$extends;

    return _extends({}, this.context, (_babelHelpers$extends = {}, _babelHelpers$extends[CHANNEL_NEXT] = {
      getTheme: this.getTheme,
      subscribe: this.broadcast.subscribe,
      unsubscribe: this.broadcast.unsubscribe
    }, _babelHelpers$extends[CHANNEL] = function (subscriber) {
      if (false) {
        warnChannelDeprecated();
      }

      // Patch the old `subscribe` provide via `CHANNEL` for older clients.
      var unsubscribeId = _this3.broadcast.subscribe(subscriber);
      return function () {
        return _this3.broadcast.unsubscribe(unsubscribeId);
      };
    }, _babelHelpers$extends));
  };

  ThemeProvider.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (this.props.theme !== nextProps.theme) {
      this.publish(nextProps.theme);
    }
  };

  ThemeProvider.prototype.componentWillUnmount = function componentWillUnmount() {
    if (this.unsubscribeToOuterId !== -1) {
      this.context[CHANNEL_NEXT].unsubscribe(this.unsubscribeToOuterId);
    }
  };

  // Get the theme from the props, supporting both (outerTheme) => {} as well as object notation


  ThemeProvider.prototype.getTheme = function getTheme(passedTheme) {
    var theme = passedTheme || this.props.theme;

    if (isFunction(theme)) {
      var mergedTheme = theme(this.outerTheme);

      if (false) {
        throw new StyledComponentsError(7);
      }

      return mergedTheme;
    }

    if (theme === null || Array.isArray(theme) || (typeof theme === 'undefined' ? 'undefined' : _typeof(theme)) !== 'object') {
      throw new StyledComponentsError(8);
    }

    return _extends({}, this.outerTheme, theme);
  };

  ThemeProvider.prototype.publish = function publish(theme) {
    this.broadcast.publish(this.getTheme(theme));
  };

  ThemeProvider.prototype.render = function render() {
    if (!this.props.children) {
      return null;
    }

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.Children.only(this.props.children);
  };

  return ThemeProvider;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

ThemeProvider.childContextTypes = contextShape;
ThemeProvider.contextTypes = (_ThemeProvider$contex = {}, _ThemeProvider$contex[CHANNEL_NEXT] = CONTEXT_CHANNEL_SHAPE, _ThemeProvider$contex);

var _babelHelpers$extends;

// HACK for generating all static styles without needing to allocate
// an empty execution context every single time...
var STATIC_EXECUTION_CONTEXT = {};

var modifiedContextShape = _extends({}, contextShape, (_babelHelpers$extends = {}, _babelHelpers$extends[CONTEXT_KEY] = __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.instanceOf(StyleSheet), __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.instanceOf(ServerStyleSheet)]), _babelHelpers$extends));

var identifiers = {};

/* We depend on components having unique IDs */
var generateId = function generateId(ComponentStyle, _displayName, parentComponentId) {
  var displayName = typeof _displayName !== 'string' ? 'sc' : escape(_displayName);

  /**
   * This ensures uniqueness if two components happen to share
   * the same displayName.
   */
  var nr = (identifiers[displayName] || 0) + 1;
  identifiers[displayName] = nr;

  var componentId = displayName + '-' + ComponentStyle.generateName(displayName + nr);

  return parentComponentId !== undefined ? parentComponentId + '-' + componentId : componentId;
};

var warnExtendDeprecated = function warnExtendDeprecated() {};
if (false) {
  warnExtendDeprecated = once(function () {
    // eslint-disable-next-line no-console
    console.warn('Warning: The "extend" API will be removed in the upcoming v4.0 release. Use styled(StyledComponent) instead. You can find more information here: https://github.com/styled-components/styled-components/issues/1546');
  });
}

// $FlowFixMe

var BaseStyledComponent = function (_Component) {
  inherits(BaseStyledComponent, _Component);

  function BaseStyledComponent() {
    var _temp, _this, _ret;

    classCallCheck(this, BaseStyledComponent);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.attrs = {}, _this.state = {
      theme: null,
      generatedClassName: ''
    }, _this.unsubscribeId = -1, _temp), possibleConstructorReturn(_this, _ret);
  }

  BaseStyledComponent.prototype.unsubscribeFromContext = function unsubscribeFromContext() {
    if (this.unsubscribeId !== -1) {
      this.context[CHANNEL_NEXT].unsubscribe(this.unsubscribeId);
    }
  };

  BaseStyledComponent.prototype.buildExecutionContext = function buildExecutionContext(theme, props) {
    var attrs = this.constructor.attrs;

    var context = _extends({}, props, { theme: theme });
    if (attrs === undefined) {
      return context;
    }

    this.attrs = Object.keys(attrs).reduce(function (acc, key) {
      var attr = attrs[key];

      // eslint-disable-next-line no-param-reassign
      acc[key] = typeof attr === 'function' && !hasInInheritanceChain(attr, __WEBPACK_IMPORTED_MODULE_1_react__["Component"]) ? attr(context) : attr;
      return acc;
    }, {});

    return _extends({}, context, this.attrs);
  };

  BaseStyledComponent.prototype.generateAndInjectStyles = function generateAndInjectStyles(theme, props) {
    var _constructor = this.constructor,
        attrs = _constructor.attrs,
        componentStyle = _constructor.componentStyle,
        warnTooManyClasses = _constructor.warnTooManyClasses;

    var styleSheet = this.context[CONTEXT_KEY] || StyleSheet.master;

    // statically styled-components don't need to build an execution context object,
    // and shouldn't be increasing the number of class names
    if (componentStyle.isStatic && attrs === undefined) {
      return componentStyle.generateAndInjectStyles(STATIC_EXECUTION_CONTEXT, styleSheet);
    } else {
      var executionContext = this.buildExecutionContext(theme, props);
      var className = componentStyle.generateAndInjectStyles(executionContext, styleSheet);

      if (false) {
        warnTooManyClasses(className);
      }

      return className;
    }
  };

  BaseStyledComponent.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    var componentStyle = this.constructor.componentStyle;

    var styledContext = this.context[CHANNEL_NEXT];

    // If this is a statically-styled component, we don't need to the theme
    // to generate or build styles.
    if (componentStyle.isStatic) {
      var generatedClassName = this.generateAndInjectStyles(STATIC_EXECUTION_CONTEXT, this.props);
      this.setState({ generatedClassName: generatedClassName });
      // If there is a theme in the context, subscribe to the event emitter. This
      // is necessary due to pure components blocking context updates, this circumvents
      // that by updating when an event is emitted
    } else if (styledContext !== undefined) {
      var subscribe = styledContext.subscribe;

      this.unsubscribeId = subscribe(function (nextTheme) {
        // This will be called once immediately
        var theme = determineTheme(_this2.props, nextTheme, _this2.constructor.defaultProps);

        var generatedClassName = _this2.generateAndInjectStyles(theme, _this2.props);

        _this2.setState({ theme: theme, generatedClassName: generatedClassName });
      });
    } else {
      // eslint-disable-next-line react/prop-types
      var theme = this.props.theme || EMPTY_OBJECT;
      var _generatedClassName = this.generateAndInjectStyles(theme, this.props);
      this.setState({ theme: theme, generatedClassName: _generatedClassName });
    }
  };

  BaseStyledComponent.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var _this3 = this;

    // If this is a statically-styled component, we don't need to listen to
    // props changes to update styles
    var componentStyle = this.constructor.componentStyle;

    if (componentStyle.isStatic) {
      return;
    }

    this.setState(function (prevState) {
      var theme = determineTheme(nextProps, prevState.theme, _this3.constructor.defaultProps);
      var generatedClassName = _this3.generateAndInjectStyles(theme, nextProps);

      return { theme: theme, generatedClassName: generatedClassName };
    });
  };

  BaseStyledComponent.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unsubscribeFromContext();
  };

  BaseStyledComponent.prototype.render = function render() {
    // eslint-disable-next-line react/prop-types
    var innerRef = this.props.innerRef;
    var generatedClassName = this.state.generatedClassName;
    var _constructor2 = this.constructor,
        styledComponentId = _constructor2.styledComponentId,
        target = _constructor2.target;


    var isTargetTag = isTag(target);

    var className = [
    // eslint-disable-next-line react/prop-types
    this.props.className, styledComponentId, this.attrs.className, generatedClassName].filter(Boolean).join(' ');

    var baseProps = _extends({}, this.attrs, {
      className: className
    });

    if (isStyledComponent(target)) {
      baseProps.innerRef = innerRef;
    } else {
      baseProps.ref = innerRef;
    }

    var propsForElement = baseProps;
    var key = void 0;

    for (key in this.props) {
      // Don't pass through non HTML tags through to HTML elements
      // always omit innerRef
      if (key !== 'innerRef' && key !== 'className' && (!isTargetTag || validAttr(key))) {
        propsForElement[key] = key === 'style' && key in this.attrs ? _extends({}, this.attrs[key], this.props[key]) : this.props[key];
      }
    }

    return Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])(target, propsForElement);
  };

  return BaseStyledComponent;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

var _StyledComponent = (function (ComponentStyle, constructWithOptions) {
  var createStyledComponent = function createStyledComponent(target, options, rules) {
    var _options$isClass = options.isClass,
        isClass = _options$isClass === undefined ? !isTag(target) : _options$isClass,
        _options$displayName = options.displayName,
        displayName = _options$displayName === undefined ? generateDisplayName(target) : _options$displayName,
        _options$componentId = options.componentId,
        componentId = _options$componentId === undefined ? generateId(ComponentStyle, options.displayName, options.parentComponentId) : _options$componentId,
        _options$ParentCompon = options.ParentComponent,
        ParentComponent = _options$ParentCompon === undefined ? BaseStyledComponent : _options$ParentCompon,
        extendingRules = options.rules,
        attrs = options.attrs;


    var styledComponentId = options.displayName && options.componentId ? escape(options.displayName) + '-' + options.componentId : options.componentId || componentId;

    var componentStyle = new ComponentStyle(extendingRules === undefined ? rules : extendingRules.concat(rules), attrs, styledComponentId);

    var StyledComponent = function (_ParentComponent) {
      inherits(StyledComponent, _ParentComponent);

      function StyledComponent() {
        classCallCheck(this, StyledComponent);
        return possibleConstructorReturn(this, _ParentComponent.apply(this, arguments));
      }

      StyledComponent.withComponent = function withComponent(tag) {
        var previousComponentId = options.componentId,
            optionsToCopy = objectWithoutProperties(options, ['componentId']);


        var newComponentId = previousComponentId && previousComponentId + '-' + (isTag(tag) ? tag : escape(getComponentName(tag)));

        var newOptions = _extends({}, optionsToCopy, {
          componentId: newComponentId,
          ParentComponent: StyledComponent
        });

        return createStyledComponent(tag, newOptions, rules);
      };

      createClass(StyledComponent, null, [{
        key: 'extend',
        get: function get$$1() {
          var rulesFromOptions = options.rules,
              parentComponentId = options.componentId,
              optionsToCopy = objectWithoutProperties(options, ['rules', 'componentId']);


          var newRules = rulesFromOptions === undefined ? rules : rulesFromOptions.concat(rules);

          var newOptions = _extends({}, optionsToCopy, {
            rules: newRules,
            parentComponentId: parentComponentId,
            ParentComponent: StyledComponent
          });

          warnExtendDeprecated();

          return constructWithOptions(createStyledComponent, target, newOptions);
        }
      }]);
      return StyledComponent;
    }(ParentComponent);

    StyledComponent.attrs = attrs;
    StyledComponent.componentStyle = componentStyle;
    StyledComponent.contextTypes = modifiedContextShape;
    StyledComponent.displayName = displayName;
    StyledComponent.styledComponentId = styledComponentId;
    StyledComponent.target = target;


    if (false) {
      StyledComponent.warnTooManyClasses = createWarnTooManyClasses(displayName);
    }

    if (isClass) {
      __WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics___default()(StyledComponent, target, {
        // all SC-specific things should not be hoisted
        attrs: true,
        componentStyle: true,
        displayName: true,
        extend: true,
        styledComponentId: true,
        target: true,
        warnTooManyClasses: true,
        withComponent: true
      });
    }

    return StyledComponent;
  };

  return createStyledComponent;
});

// Source: https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
function murmurhash(str) {
  var l = str.length | 0,
      h = l | 0,
      i = 0,
      k;

  while (l >= 4) {
    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;

    k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    k ^= k >>> 24;
    k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);

    h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16) ^ k;

    l -= 4;
    ++i;
  }

  switch (l) {
    case 3:
      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
    case 2:
      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
    case 1:
      h ^= str.charCodeAt(i) & 0xff;
      h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
  }

  h ^= h >>> 13;
  h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
  h ^= h >>> 15;

  return h >>> 0;
}

// 

var areStylesCacheable = IS_BROWSER;

var isStaticRules = function isStaticRules(rules, attrs) {
  for (var i = 0, len = rules.length; i < len; i += 1) {
    var rule = rules[i];

    // recursive case
    if (Array.isArray(rule) && !isStaticRules(rule)) {
      return false;
    } else if (typeof rule === 'function' && !isStyledComponent(rule)) {
      // functions are allowed to be static if they're just being
      // used to get the classname of a nested styled component
      return false;
    }
  }

  if (attrs !== undefined) {
    // eslint-disable-next-line guard-for-in, no-restricted-syntax
    for (var key in attrs) {
      if (typeof attrs[key] === 'function') {
        return false;
      }
    }
  }

  return true;
};

var isHMREnabled = typeof module !== 'undefined' && module.hot && "production" !== 'production';

/*
 ComponentStyle is all the CSS-specific stuff, not
 the React-specific stuff.
 */
var _ComponentStyle = (function (nameGenerator, flatten, stringifyRules) {
  /* combines hashStr (murmurhash) and nameGenerator for convenience */
  var generateRuleHash = function generateRuleHash(str) {
    return nameGenerator(murmurhash(str));
  };

  var ComponentStyle = function () {
    function ComponentStyle(rules, attrs, componentId) {
      classCallCheck(this, ComponentStyle);

      this.rules = rules;
      this.isStatic = !isHMREnabled && isStaticRules(rules, attrs);
      this.componentId = componentId;

      if (!StyleSheet.master.hasId(componentId)) {
        var placeholder =  false ? ['.' + componentId + ' {}'] : [];

        StyleSheet.master.deferredInject(componentId, placeholder);
      }
    }

    /*
     * Flattens a rule set into valid CSS
     * Hashes it, wraps the whole chunk in a .hash1234 {}
     * Returns the hash to be injected on render()
     * */


    ComponentStyle.prototype.generateAndInjectStyles = function generateAndInjectStyles(executionContext, styleSheet) {
      var isStatic = this.isStatic,
          componentId = this.componentId,
          lastClassName = this.lastClassName;

      if (areStylesCacheable && isStatic && lastClassName !== undefined && styleSheet.hasNameForId(componentId, lastClassName)) {
        return lastClassName;
      }

      var flatCSS = flatten(this.rules, executionContext);
      var name = generateRuleHash(this.componentId + flatCSS.join(''));

      if (!styleSheet.hasNameForId(componentId, name)) {
        styleSheet.inject(this.componentId, stringifyRules(flatCSS, '.' + name), name);
      }

      this.lastClassName = name;
      return name;
    };

    ComponentStyle.generateName = function generateName(str) {
      return generateRuleHash(str);
    };

    return ComponentStyle;
  }();

  return ComponentStyle;
});

// 
// Thanks to ReactDOMFactories for this handy list!

var domElements = ['a', 'abbr', 'address', 'area', 'article', 'aside', 'audio', 'b', 'base', 'bdi', 'bdo', 'big', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'cite', 'code', 'col', 'colgroup', 'data', 'datalist', 'dd', 'del', 'details', 'dfn', 'dialog', 'div', 'dl', 'dt', 'em', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'iframe', 'img', 'input', 'ins', 'kbd', 'keygen', 'label', 'legend', 'li', 'link', 'main', 'map', 'mark', 'marquee', 'menu', 'menuitem', 'meta', 'meter', 'nav', 'noscript', 'object', 'ol', 'optgroup', 'option', 'output', 'p', 'param', 'picture', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'script', 'section', 'select', 'small', 'source', 'span', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'textarea', 'tfoot', 'th', 'thead', 'time', 'title', 'tr', 'track', 'u', 'ul', 'var', 'video', 'wbr',

// SVG
'circle', 'clipPath', 'defs', 'ellipse', 'foreignObject', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'svg', 'text', 'tspan'];

// 

var _styled = (function (styledComponent, constructWithOptions) {
  var styled = function styled(tag) {
    return constructWithOptions(styledComponent, tag);
  };

  // Shorthands for all valid HTML Elements
  domElements.forEach(function (domElement) {
    styled[domElement] = styled(domElement);
  });

  return styled;
});

// 

var replaceWhitespace = function replaceWhitespace(str) {
  return str.replace(/\s|\\n/g, '');
};

var _keyframes = (function (nameGenerator, stringifyRules, css) {
  return function () {
    var styleSheet = StyleSheet.master;
    var rules = css.apply(undefined, arguments);
    var name = nameGenerator(murmurhash(replaceWhitespace(JSON.stringify(rules))));
    var id = 'sc-keyframes-' + name;

    if (!styleSheet.hasNameForId(id, name)) {
      styleSheet.inject(id, stringifyRules(rules, name, '@keyframes'), name);
    }

    return name;
  };
});

// 

var _injectGlobal = (function (stringifyRules, css) {
  var injectGlobal = function injectGlobal() {
    var styleSheet = StyleSheet.master;
    var rules = css.apply(undefined, arguments);
    var hash = murmurhash(JSON.stringify(rules));
    var id = 'sc-global-' + hash;

    if (!styleSheet.hasId(id)) {
      styleSheet.inject(id, stringifyRules(rules));
    }
  };

  return injectGlobal;
});

// 

var _constructWithOptions = (function (css) {
  var constructWithOptions = function constructWithOptions(componentConstructor, tag) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : EMPTY_OBJECT;

    if (!Object(__WEBPACK_IMPORTED_MODULE_6_react_is__["isValidElementType"])(tag)) {
      throw new StyledComponentsError(1, String(tag));
    }

    /* This is callable directly as a template function */
    // $FlowFixMe: Not typed to avoid destructuring arguments
    var templateFunction = function templateFunction() {
      return componentConstructor(tag, options, css.apply(undefined, arguments));
    };

    /* If config methods are called, wrap up a new template function and merge options */
    templateFunction.withConfig = function (config) {
      return constructWithOptions(componentConstructor, tag, _extends({}, options, config));
    };
    templateFunction.attrs = function (attrs) {
      return constructWithOptions(componentConstructor, tag, _extends({}, options, {
        attrs: _extends({}, options.attrs || EMPTY_OBJECT, attrs)
      }));
    };

    return templateFunction;
  };

  return constructWithOptions;
});

// 

var withTheme = (function (Component$$1) {
  var isStatelessFunctionalComponent = typeof Component$$1 === 'function' &&
  // $FlowFixMe TODO: flow for prototype
  !(Component$$1.prototype && 'isReactComponent' in Component$$1.prototype);

  // NOTE: We can't pass a ref to a stateless functional component
  var shouldSetInnerRef = isStyledComponent(Component$$1) || isStatelessFunctionalComponent;

  var WithTheme = function (_React$Component) {
    inherits(WithTheme, _React$Component);

    function WithTheme() {
      var _temp, _this, _ret;

      classCallCheck(this, WithTheme);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = EMPTY_OBJECT, _this.unsubscribeId = -1, _temp), possibleConstructorReturn(_this, _ret);
    }

    // NOTE: This is so that isStyledComponent passes for the innerRef unwrapping


    WithTheme.prototype.componentWillMount = function componentWillMount() {
      var _this2 = this;

      var defaultProps = this.constructor.defaultProps;

      var styledContext = this.context[CHANNEL_NEXT];
      var themeProp = determineTheme(this.props, undefined, defaultProps);
      if (styledContext === undefined && themeProp === undefined && "production" !== 'production') {
        // eslint-disable-next-line no-console
        console.warn('[withTheme] You are not using a ThemeProvider nor passing a theme prop or a theme in defaultProps');
      } else if (styledContext === undefined && themeProp !== undefined) {
        this.setState({ theme: themeProp });
      } else {
        var subscribe = styledContext.subscribe;

        this.unsubscribeId = subscribe(function (nextTheme) {
          var theme = determineTheme(_this2.props, nextTheme, defaultProps);
          _this2.setState({ theme: theme });
        });
      }
    };

    WithTheme.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      var defaultProps = this.constructor.defaultProps;

      this.setState(function (oldState) {
        var theme = determineTheme(nextProps, oldState.theme, defaultProps);

        return { theme: theme };
      });
    };

    WithTheme.prototype.componentWillUnmount = function componentWillUnmount() {
      if (this.unsubscribeId !== -1) {
        this.context[CHANNEL_NEXT].unsubscribe(this.unsubscribeId);
      }
    };

    WithTheme.prototype.render = function render() {
      var props = _extends({
        theme: this.state.theme
      }, this.props);

      if (!shouldSetInnerRef) {
        props.ref = props.innerRef;
        delete props.innerRef;
      }

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Component$$1, props);
    };

    return WithTheme;
  }(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

  WithTheme.contextTypes = contextShape;
  WithTheme.displayName = 'WithTheme(' + getComponentName(Component$$1) + ')';
  WithTheme.styledComponentId = 'withTheme';


  return __WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics___default()(WithTheme, Component$$1);
});

// 

/* eslint-disable */
var __DO_NOT_USE_OR_YOU_WILL_BE_HAUNTED_BY_SPOOKY_GHOSTS = {
  StyleSheet: StyleSheet
};

// 

/* Warning if you've imported this file on React Native */
if (false) {
  // eslint-disable-next-line no-console
  console.warn("It looks like you've imported 'styled-components' on React Native.\n" + "Perhaps you're looking to import 'styled-components/native'?\n" + 'Read more about this at https://www.styled-components.com/docs/basics#react-native');
}

/* Warning if there are several instances of styled-components */
if (false) {
  window['__styled-components-init__'] = window['__styled-components-init__'] || 0;

  if (window['__styled-components-init__'] === 1) {
    // eslint-disable-next-line no-console
    console.warn("It looks like there are several instances of 'styled-components' initialized in this application. " + 'This may cause dynamic styles not rendering properly, errors happening during rehydration process ' + 'and makes your application bigger without a good reason.\n\n' + 'See https://s-c.sh/2BAXzed for more info.');
  }

  window['__styled-components-init__'] += 1;
}

/* Instantiate singletons */
var ComponentStyle = _ComponentStyle(generateAlphabeticName, flatten, stringifyRules);
var constructWithOptions = _constructWithOptions(css);
var StyledComponent = _StyledComponent(ComponentStyle, constructWithOptions);

/* Instantiate exported singletons */
var keyframes = _keyframes(generateAlphabeticName, stringifyRules, css);
var injectGlobal = _injectGlobal(stringifyRules, css);
var styled = _styled(StyledComponent, constructWithOptions);

/* harmony default export */ __webpack_exports__["default"] = (styled);

//# sourceMappingURL=styled-components.browser.esm.js.map

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(230), __webpack_require__(212)(module)))

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(11);
var core = __webpack_require__(20);
var hide = __webpack_require__(32);
var redefine = __webpack_require__(27);
var ctx = __webpack_require__(40);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if (target) redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return color; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return size; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return breakpoint; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return animation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return responsiveListPadding; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return header; });
var color={black:'#000000',lightBlack:'#2a2a2a',white:'#ffffff',grey:'#c5c5c5',lightgrey:'#cecece',darkgrey:'#a7a7a7',darkerGrey:'#333333',lightGrey:'#f2f2f2',warning:'#9a2842',sale:'#9a2842',primary:'#779283',secondary:'#a1b3c1',success:'#779283',primaryDark:'#4d7560',blackTransparent:'rgba(0,0,0,.185)'};var size={small:320,medium:640,large:800,xLarge:960,xXLarge:1180,footerBreakPoint:850,articleSideMenuBreakPoint:1200,articleSideMenuWideBreakPoint:1600};var breakpoint={medium:640,extraMedium:640+(1024-640)/2,large:1024,extraLarge:1200};var animation={transitionTime:'.25s',easing:'ease-out'};var responsiveListPadding={rlpSmall:'4px',rlpMedium:'8px',rlpLarge:'10px',rlpXLarge:'14px'};var header={// values in pixels
logoAreaDesktopHeight:110,logoAreaMobileHeight:84,menuBarDesktopHeight:48,menuBarMobileHeight:44};

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

(function (global, factory) {
   true ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define(factory) :
  (global.Immutable = factory());
}(this, function () { 'use strict';var SLICE$0 = Array.prototype.slice;

  function createClass(ctor, superClass) {
    if (superClass) {
      ctor.prototype = Object.create(superClass.prototype);
    }
    ctor.prototype.constructor = ctor;
  }

  function Iterable(value) {
      return isIterable(value) ? value : Seq(value);
    }


  createClass(KeyedIterable, Iterable);
    function KeyedIterable(value) {
      return isKeyed(value) ? value : KeyedSeq(value);
    }


  createClass(IndexedIterable, Iterable);
    function IndexedIterable(value) {
      return isIndexed(value) ? value : IndexedSeq(value);
    }


  createClass(SetIterable, Iterable);
    function SetIterable(value) {
      return isIterable(value) && !isAssociative(value) ? value : SetSeq(value);
    }



  function isIterable(maybeIterable) {
    return !!(maybeIterable && maybeIterable[IS_ITERABLE_SENTINEL]);
  }

  function isKeyed(maybeKeyed) {
    return !!(maybeKeyed && maybeKeyed[IS_KEYED_SENTINEL]);
  }

  function isIndexed(maybeIndexed) {
    return !!(maybeIndexed && maybeIndexed[IS_INDEXED_SENTINEL]);
  }

  function isAssociative(maybeAssociative) {
    return isKeyed(maybeAssociative) || isIndexed(maybeAssociative);
  }

  function isOrdered(maybeOrdered) {
    return !!(maybeOrdered && maybeOrdered[IS_ORDERED_SENTINEL]);
  }

  Iterable.isIterable = isIterable;
  Iterable.isKeyed = isKeyed;
  Iterable.isIndexed = isIndexed;
  Iterable.isAssociative = isAssociative;
  Iterable.isOrdered = isOrdered;

  Iterable.Keyed = KeyedIterable;
  Iterable.Indexed = IndexedIterable;
  Iterable.Set = SetIterable;


  var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
  var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
  var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
  var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';

  // Used for setting prototype methods that IE8 chokes on.
  var DELETE = 'delete';

  // Constants describing the size of trie nodes.
  var SHIFT = 5; // Resulted in best performance after ______?
  var SIZE = 1 << SHIFT;
  var MASK = SIZE - 1;

  // A consistent shared value representing "not set" which equals nothing other
  // than itself, and nothing that could be provided externally.
  var NOT_SET = {};

  // Boolean references, Rough equivalent of `bool &`.
  var CHANGE_LENGTH = { value: false };
  var DID_ALTER = { value: false };

  function MakeRef(ref) {
    ref.value = false;
    return ref;
  }

  function SetRef(ref) {
    ref && (ref.value = true);
  }

  // A function which returns a value representing an "owner" for transient writes
  // to tries. The return value will only ever equal itself, and will not equal
  // the return of any subsequent call of this function.
  function OwnerID() {}

  // http://jsperf.com/copy-array-inline
  function arrCopy(arr, offset) {
    offset = offset || 0;
    var len = Math.max(0, arr.length - offset);
    var newArr = new Array(len);
    for (var ii = 0; ii < len; ii++) {
      newArr[ii] = arr[ii + offset];
    }
    return newArr;
  }

  function ensureSize(iter) {
    if (iter.size === undefined) {
      iter.size = iter.__iterate(returnTrue);
    }
    return iter.size;
  }

  function wrapIndex(iter, index) {
    // This implements "is array index" which the ECMAString spec defines as:
    //
    //     A String property name P is an array index if and only if
    //     ToString(ToUint32(P)) is equal to P and ToUint32(P) is not equal
    //     to 2^32−1.
    //
    // http://www.ecma-international.org/ecma-262/6.0/#sec-array-exotic-objects
    if (typeof index !== 'number') {
      var uint32Index = index >>> 0; // N >>> 0 is shorthand for ToUint32
      if ('' + uint32Index !== index || uint32Index === 4294967295) {
        return NaN;
      }
      index = uint32Index;
    }
    return index < 0 ? ensureSize(iter) + index : index;
  }

  function returnTrue() {
    return true;
  }

  function wholeSlice(begin, end, size) {
    return (begin === 0 || (size !== undefined && begin <= -size)) &&
      (end === undefined || (size !== undefined && end >= size));
  }

  function resolveBegin(begin, size) {
    return resolveIndex(begin, size, 0);
  }

  function resolveEnd(end, size) {
    return resolveIndex(end, size, size);
  }

  function resolveIndex(index, size, defaultIndex) {
    return index === undefined ?
      defaultIndex :
      index < 0 ?
        Math.max(0, size + index) :
        size === undefined ?
          index :
          Math.min(size, index);
  }

  /* global Symbol */

  var ITERATE_KEYS = 0;
  var ITERATE_VALUES = 1;
  var ITERATE_ENTRIES = 2;

  var REAL_ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator';

  var ITERATOR_SYMBOL = REAL_ITERATOR_SYMBOL || FAUX_ITERATOR_SYMBOL;


  function Iterator(next) {
      this.next = next;
    }

    Iterator.prototype.toString = function() {
      return '[Iterator]';
    };


  Iterator.KEYS = ITERATE_KEYS;
  Iterator.VALUES = ITERATE_VALUES;
  Iterator.ENTRIES = ITERATE_ENTRIES;

  Iterator.prototype.inspect =
  Iterator.prototype.toSource = function () { return this.toString(); }
  Iterator.prototype[ITERATOR_SYMBOL] = function () {
    return this;
  };


  function iteratorValue(type, k, v, iteratorResult) {
    var value = type === 0 ? k : type === 1 ? v : [k, v];
    iteratorResult ? (iteratorResult.value = value) : (iteratorResult = {
      value: value, done: false
    });
    return iteratorResult;
  }

  function iteratorDone() {
    return { value: undefined, done: true };
  }

  function hasIterator(maybeIterable) {
    return !!getIteratorFn(maybeIterable);
  }

  function isIterator(maybeIterator) {
    return maybeIterator && typeof maybeIterator.next === 'function';
  }

  function getIterator(iterable) {
    var iteratorFn = getIteratorFn(iterable);
    return iteratorFn && iteratorFn.call(iterable);
  }

  function getIteratorFn(iterable) {
    var iteratorFn = iterable && (
      (REAL_ITERATOR_SYMBOL && iterable[REAL_ITERATOR_SYMBOL]) ||
      iterable[FAUX_ITERATOR_SYMBOL]
    );
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  function isArrayLike(value) {
    return value && typeof value.length === 'number';
  }

  createClass(Seq, Iterable);
    function Seq(value) {
      return value === null || value === undefined ? emptySequence() :
        isIterable(value) ? value.toSeq() : seqFromValue(value);
    }

    Seq.of = function(/*...values*/) {
      return Seq(arguments);
    };

    Seq.prototype.toSeq = function() {
      return this;
    };

    Seq.prototype.toString = function() {
      return this.__toString('Seq {', '}');
    };

    Seq.prototype.cacheResult = function() {
      if (!this._cache && this.__iterateUncached) {
        this._cache = this.entrySeq().toArray();
        this.size = this._cache.length;
      }
      return this;
    };

    // abstract __iterateUncached(fn, reverse)

    Seq.prototype.__iterate = function(fn, reverse) {
      return seqIterate(this, fn, reverse, true);
    };

    // abstract __iteratorUncached(type, reverse)

    Seq.prototype.__iterator = function(type, reverse) {
      return seqIterator(this, type, reverse, true);
    };



  createClass(KeyedSeq, Seq);
    function KeyedSeq(value) {
      return value === null || value === undefined ?
        emptySequence().toKeyedSeq() :
        isIterable(value) ?
          (isKeyed(value) ? value.toSeq() : value.fromEntrySeq()) :
          keyedSeqFromValue(value);
    }

    KeyedSeq.prototype.toKeyedSeq = function() {
      return this;
    };



  createClass(IndexedSeq, Seq);
    function IndexedSeq(value) {
      return value === null || value === undefined ? emptySequence() :
        !isIterable(value) ? indexedSeqFromValue(value) :
        isKeyed(value) ? value.entrySeq() : value.toIndexedSeq();
    }

    IndexedSeq.of = function(/*...values*/) {
      return IndexedSeq(arguments);
    };

    IndexedSeq.prototype.toIndexedSeq = function() {
      return this;
    };

    IndexedSeq.prototype.toString = function() {
      return this.__toString('Seq [', ']');
    };

    IndexedSeq.prototype.__iterate = function(fn, reverse) {
      return seqIterate(this, fn, reverse, false);
    };

    IndexedSeq.prototype.__iterator = function(type, reverse) {
      return seqIterator(this, type, reverse, false);
    };



  createClass(SetSeq, Seq);
    function SetSeq(value) {
      return (
        value === null || value === undefined ? emptySequence() :
        !isIterable(value) ? indexedSeqFromValue(value) :
        isKeyed(value) ? value.entrySeq() : value
      ).toSetSeq();
    }

    SetSeq.of = function(/*...values*/) {
      return SetSeq(arguments);
    };

    SetSeq.prototype.toSetSeq = function() {
      return this;
    };



  Seq.isSeq = isSeq;
  Seq.Keyed = KeyedSeq;
  Seq.Set = SetSeq;
  Seq.Indexed = IndexedSeq;

  var IS_SEQ_SENTINEL = '@@__IMMUTABLE_SEQ__@@';

  Seq.prototype[IS_SEQ_SENTINEL] = true;



  createClass(ArraySeq, IndexedSeq);
    function ArraySeq(array) {
      this._array = array;
      this.size = array.length;
    }

    ArraySeq.prototype.get = function(index, notSetValue) {
      return this.has(index) ? this._array[wrapIndex(this, index)] : notSetValue;
    };

    ArraySeq.prototype.__iterate = function(fn, reverse) {
      var array = this._array;
      var maxIndex = array.length - 1;
      for (var ii = 0; ii <= maxIndex; ii++) {
        if (fn(array[reverse ? maxIndex - ii : ii], ii, this) === false) {
          return ii + 1;
        }
      }
      return ii;
    };

    ArraySeq.prototype.__iterator = function(type, reverse) {
      var array = this._array;
      var maxIndex = array.length - 1;
      var ii = 0;
      return new Iterator(function() 
        {return ii > maxIndex ?
          iteratorDone() :
          iteratorValue(type, ii, array[reverse ? maxIndex - ii++ : ii++])}
      );
    };



  createClass(ObjectSeq, KeyedSeq);
    function ObjectSeq(object) {
      var keys = Object.keys(object);
      this._object = object;
      this._keys = keys;
      this.size = keys.length;
    }

    ObjectSeq.prototype.get = function(key, notSetValue) {
      if (notSetValue !== undefined && !this.has(key)) {
        return notSetValue;
      }
      return this._object[key];
    };

    ObjectSeq.prototype.has = function(key) {
      return this._object.hasOwnProperty(key);
    };

    ObjectSeq.prototype.__iterate = function(fn, reverse) {
      var object = this._object;
      var keys = this._keys;
      var maxIndex = keys.length - 1;
      for (var ii = 0; ii <= maxIndex; ii++) {
        var key = keys[reverse ? maxIndex - ii : ii];
        if (fn(object[key], key, this) === false) {
          return ii + 1;
        }
      }
      return ii;
    };

    ObjectSeq.prototype.__iterator = function(type, reverse) {
      var object = this._object;
      var keys = this._keys;
      var maxIndex = keys.length - 1;
      var ii = 0;
      return new Iterator(function()  {
        var key = keys[reverse ? maxIndex - ii : ii];
        return ii++ > maxIndex ?
          iteratorDone() :
          iteratorValue(type, key, object[key]);
      });
    };

  ObjectSeq.prototype[IS_ORDERED_SENTINEL] = true;


  createClass(IterableSeq, IndexedSeq);
    function IterableSeq(iterable) {
      this._iterable = iterable;
      this.size = iterable.length || iterable.size;
    }

    IterableSeq.prototype.__iterateUncached = function(fn, reverse) {
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }
      var iterable = this._iterable;
      var iterator = getIterator(iterable);
      var iterations = 0;
      if (isIterator(iterator)) {
        var step;
        while (!(step = iterator.next()).done) {
          if (fn(step.value, iterations++, this) === false) {
            break;
          }
        }
      }
      return iterations;
    };

    IterableSeq.prototype.__iteratorUncached = function(type, reverse) {
      if (reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }
      var iterable = this._iterable;
      var iterator = getIterator(iterable);
      if (!isIterator(iterator)) {
        return new Iterator(iteratorDone);
      }
      var iterations = 0;
      return new Iterator(function()  {
        var step = iterator.next();
        return step.done ? step : iteratorValue(type, iterations++, step.value);
      });
    };



  createClass(IteratorSeq, IndexedSeq);
    function IteratorSeq(iterator) {
      this._iterator = iterator;
      this._iteratorCache = [];
    }

    IteratorSeq.prototype.__iterateUncached = function(fn, reverse) {
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }
      var iterator = this._iterator;
      var cache = this._iteratorCache;
      var iterations = 0;
      while (iterations < cache.length) {
        if (fn(cache[iterations], iterations++, this) === false) {
          return iterations;
        }
      }
      var step;
      while (!(step = iterator.next()).done) {
        var val = step.value;
        cache[iterations] = val;
        if (fn(val, iterations++, this) === false) {
          break;
        }
      }
      return iterations;
    };

    IteratorSeq.prototype.__iteratorUncached = function(type, reverse) {
      if (reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }
      var iterator = this._iterator;
      var cache = this._iteratorCache;
      var iterations = 0;
      return new Iterator(function()  {
        if (iterations >= cache.length) {
          var step = iterator.next();
          if (step.done) {
            return step;
          }
          cache[iterations] = step.value;
        }
        return iteratorValue(type, iterations, cache[iterations++]);
      });
    };




  // # pragma Helper functions

  function isSeq(maybeSeq) {
    return !!(maybeSeq && maybeSeq[IS_SEQ_SENTINEL]);
  }

  var EMPTY_SEQ;

  function emptySequence() {
    return EMPTY_SEQ || (EMPTY_SEQ = new ArraySeq([]));
  }

  function keyedSeqFromValue(value) {
    var seq =
      Array.isArray(value) ? new ArraySeq(value).fromEntrySeq() :
      isIterator(value) ? new IteratorSeq(value).fromEntrySeq() :
      hasIterator(value) ? new IterableSeq(value).fromEntrySeq() :
      typeof value === 'object' ? new ObjectSeq(value) :
      undefined;
    if (!seq) {
      throw new TypeError(
        'Expected Array or iterable object of [k, v] entries, '+
        'or keyed object: ' + value
      );
    }
    return seq;
  }

  function indexedSeqFromValue(value) {
    var seq = maybeIndexedSeqFromValue(value);
    if (!seq) {
      throw new TypeError(
        'Expected Array or iterable object of values: ' + value
      );
    }
    return seq;
  }

  function seqFromValue(value) {
    var seq = maybeIndexedSeqFromValue(value) ||
      (typeof value === 'object' && new ObjectSeq(value));
    if (!seq) {
      throw new TypeError(
        'Expected Array or iterable object of values, or keyed object: ' + value
      );
    }
    return seq;
  }

  function maybeIndexedSeqFromValue(value) {
    return (
      isArrayLike(value) ? new ArraySeq(value) :
      isIterator(value) ? new IteratorSeq(value) :
      hasIterator(value) ? new IterableSeq(value) :
      undefined
    );
  }

  function seqIterate(seq, fn, reverse, useKeys) {
    var cache = seq._cache;
    if (cache) {
      var maxIndex = cache.length - 1;
      for (var ii = 0; ii <= maxIndex; ii++) {
        var entry = cache[reverse ? maxIndex - ii : ii];
        if (fn(entry[1], useKeys ? entry[0] : ii, seq) === false) {
          return ii + 1;
        }
      }
      return ii;
    }
    return seq.__iterateUncached(fn, reverse);
  }

  function seqIterator(seq, type, reverse, useKeys) {
    var cache = seq._cache;
    if (cache) {
      var maxIndex = cache.length - 1;
      var ii = 0;
      return new Iterator(function()  {
        var entry = cache[reverse ? maxIndex - ii : ii];
        return ii++ > maxIndex ?
          iteratorDone() :
          iteratorValue(type, useKeys ? entry[0] : ii - 1, entry[1]);
      });
    }
    return seq.__iteratorUncached(type, reverse);
  }

  function fromJS(json, converter) {
    return converter ?
      fromJSWith(converter, json, '', {'': json}) :
      fromJSDefault(json);
  }

  function fromJSWith(converter, json, key, parentJSON) {
    if (Array.isArray(json)) {
      return converter.call(parentJSON, key, IndexedSeq(json).map(function(v, k)  {return fromJSWith(converter, v, k, json)}));
    }
    if (isPlainObj(json)) {
      return converter.call(parentJSON, key, KeyedSeq(json).map(function(v, k)  {return fromJSWith(converter, v, k, json)}));
    }
    return json;
  }

  function fromJSDefault(json) {
    if (Array.isArray(json)) {
      return IndexedSeq(json).map(fromJSDefault).toList();
    }
    if (isPlainObj(json)) {
      return KeyedSeq(json).map(fromJSDefault).toMap();
    }
    return json;
  }

  function isPlainObj(value) {
    return value && (value.constructor === Object || value.constructor === undefined);
  }

  /**
   * An extension of the "same-value" algorithm as [described for use by ES6 Map
   * and Set](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Map#Key_equality)
   *
   * NaN is considered the same as NaN, however -0 and 0 are considered the same
   * value, which is different from the algorithm described by
   * [`Object.is`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is).
   *
   * This is extended further to allow Objects to describe the values they
   * represent, by way of `valueOf` or `equals` (and `hashCode`).
   *
   * Note: because of this extension, the key equality of Immutable.Map and the
   * value equality of Immutable.Set will differ from ES6 Map and Set.
   *
   * ### Defining custom values
   *
   * The easiest way to describe the value an object represents is by implementing
   * `valueOf`. For example, `Date` represents a value by returning a unix
   * timestamp for `valueOf`:
   *
   *     var date1 = new Date(1234567890000); // Fri Feb 13 2009 ...
   *     var date2 = new Date(1234567890000);
   *     date1.valueOf(); // 1234567890000
   *     assert( date1 !== date2 );
   *     assert( Immutable.is( date1, date2 ) );
   *
   * Note: overriding `valueOf` may have other implications if you use this object
   * where JavaScript expects a primitive, such as implicit string coercion.
   *
   * For more complex types, especially collections, implementing `valueOf` may
   * not be performant. An alternative is to implement `equals` and `hashCode`.
   *
   * `equals` takes another object, presumably of similar type, and returns true
   * if the it is equal. Equality is symmetrical, so the same result should be
   * returned if this and the argument are flipped.
   *
   *     assert( a.equals(b) === b.equals(a) );
   *
   * `hashCode` returns a 32bit integer number representing the object which will
   * be used to determine how to store the value object in a Map or Set. You must
   * provide both or neither methods, one must not exist without the other.
   *
   * Also, an important relationship between these methods must be upheld: if two
   * values are equal, they *must* return the same hashCode. If the values are not
   * equal, they might have the same hashCode; this is called a hash collision,
   * and while undesirable for performance reasons, it is acceptable.
   *
   *     if (a.equals(b)) {
   *       assert( a.hashCode() === b.hashCode() );
   *     }
   *
   * All Immutable collections implement `equals` and `hashCode`.
   *
   */
  function is(valueA, valueB) {
    if (valueA === valueB || (valueA !== valueA && valueB !== valueB)) {
      return true;
    }
    if (!valueA || !valueB) {
      return false;
    }
    if (typeof valueA.valueOf === 'function' &&
        typeof valueB.valueOf === 'function') {
      valueA = valueA.valueOf();
      valueB = valueB.valueOf();
      if (valueA === valueB || (valueA !== valueA && valueB !== valueB)) {
        return true;
      }
      if (!valueA || !valueB) {
        return false;
      }
    }
    if (typeof valueA.equals === 'function' &&
        typeof valueB.equals === 'function' &&
        valueA.equals(valueB)) {
      return true;
    }
    return false;
  }

  function deepEqual(a, b) {
    if (a === b) {
      return true;
    }

    if (
      !isIterable(b) ||
      a.size !== undefined && b.size !== undefined && a.size !== b.size ||
      a.__hash !== undefined && b.__hash !== undefined && a.__hash !== b.__hash ||
      isKeyed(a) !== isKeyed(b) ||
      isIndexed(a) !== isIndexed(b) ||
      isOrdered(a) !== isOrdered(b)
    ) {
      return false;
    }

    if (a.size === 0 && b.size === 0) {
      return true;
    }

    var notAssociative = !isAssociative(a);

    if (isOrdered(a)) {
      var entries = a.entries();
      return b.every(function(v, k)  {
        var entry = entries.next().value;
        return entry && is(entry[1], v) && (notAssociative || is(entry[0], k));
      }) && entries.next().done;
    }

    var flipped = false;

    if (a.size === undefined) {
      if (b.size === undefined) {
        if (typeof a.cacheResult === 'function') {
          a.cacheResult();
        }
      } else {
        flipped = true;
        var _ = a;
        a = b;
        b = _;
      }
    }

    var allEqual = true;
    var bSize = b.__iterate(function(v, k)  {
      if (notAssociative ? !a.has(v) :
          flipped ? !is(v, a.get(k, NOT_SET)) : !is(a.get(k, NOT_SET), v)) {
        allEqual = false;
        return false;
      }
    });

    return allEqual && a.size === bSize;
  }

  createClass(Repeat, IndexedSeq);

    function Repeat(value, times) {
      if (!(this instanceof Repeat)) {
        return new Repeat(value, times);
      }
      this._value = value;
      this.size = times === undefined ? Infinity : Math.max(0, times);
      if (this.size === 0) {
        if (EMPTY_REPEAT) {
          return EMPTY_REPEAT;
        }
        EMPTY_REPEAT = this;
      }
    }

    Repeat.prototype.toString = function() {
      if (this.size === 0) {
        return 'Repeat []';
      }
      return 'Repeat [ ' + this._value + ' ' + this.size + ' times ]';
    };

    Repeat.prototype.get = function(index, notSetValue) {
      return this.has(index) ? this._value : notSetValue;
    };

    Repeat.prototype.includes = function(searchValue) {
      return is(this._value, searchValue);
    };

    Repeat.prototype.slice = function(begin, end) {
      var size = this.size;
      return wholeSlice(begin, end, size) ? this :
        new Repeat(this._value, resolveEnd(end, size) - resolveBegin(begin, size));
    };

    Repeat.prototype.reverse = function() {
      return this;
    };

    Repeat.prototype.indexOf = function(searchValue) {
      if (is(this._value, searchValue)) {
        return 0;
      }
      return -1;
    };

    Repeat.prototype.lastIndexOf = function(searchValue) {
      if (is(this._value, searchValue)) {
        return this.size;
      }
      return -1;
    };

    Repeat.prototype.__iterate = function(fn, reverse) {
      for (var ii = 0; ii < this.size; ii++) {
        if (fn(this._value, ii, this) === false) {
          return ii + 1;
        }
      }
      return ii;
    };

    Repeat.prototype.__iterator = function(type, reverse) {var this$0 = this;
      var ii = 0;
      return new Iterator(function() 
        {return ii < this$0.size ? iteratorValue(type, ii++, this$0._value) : iteratorDone()}
      );
    };

    Repeat.prototype.equals = function(other) {
      return other instanceof Repeat ?
        is(this._value, other._value) :
        deepEqual(other);
    };


  var EMPTY_REPEAT;

  function invariant(condition, error) {
    if (!condition) throw new Error(error);
  }

  createClass(Range, IndexedSeq);

    function Range(start, end, step) {
      if (!(this instanceof Range)) {
        return new Range(start, end, step);
      }
      invariant(step !== 0, 'Cannot step a Range by 0');
      start = start || 0;
      if (end === undefined) {
        end = Infinity;
      }
      step = step === undefined ? 1 : Math.abs(step);
      if (end < start) {
        step = -step;
      }
      this._start = start;
      this._end = end;
      this._step = step;
      this.size = Math.max(0, Math.ceil((end - start) / step - 1) + 1);
      if (this.size === 0) {
        if (EMPTY_RANGE) {
          return EMPTY_RANGE;
        }
        EMPTY_RANGE = this;
      }
    }

    Range.prototype.toString = function() {
      if (this.size === 0) {
        return 'Range []';
      }
      return 'Range [ ' +
        this._start + '...' + this._end +
        (this._step !== 1 ? ' by ' + this._step : '') +
      ' ]';
    };

    Range.prototype.get = function(index, notSetValue) {
      return this.has(index) ?
        this._start + wrapIndex(this, index) * this._step :
        notSetValue;
    };

    Range.prototype.includes = function(searchValue) {
      var possibleIndex = (searchValue - this._start) / this._step;
      return possibleIndex >= 0 &&
        possibleIndex < this.size &&
        possibleIndex === Math.floor(possibleIndex);
    };

    Range.prototype.slice = function(begin, end) {
      if (wholeSlice(begin, end, this.size)) {
        return this;
      }
      begin = resolveBegin(begin, this.size);
      end = resolveEnd(end, this.size);
      if (end <= begin) {
        return new Range(0, 0);
      }
      return new Range(this.get(begin, this._end), this.get(end, this._end), this._step);
    };

    Range.prototype.indexOf = function(searchValue) {
      var offsetValue = searchValue - this._start;
      if (offsetValue % this._step === 0) {
        var index = offsetValue / this._step;
        if (index >= 0 && index < this.size) {
          return index
        }
      }
      return -1;
    };

    Range.prototype.lastIndexOf = function(searchValue) {
      return this.indexOf(searchValue);
    };

    Range.prototype.__iterate = function(fn, reverse) {
      var maxIndex = this.size - 1;
      var step = this._step;
      var value = reverse ? this._start + maxIndex * step : this._start;
      for (var ii = 0; ii <= maxIndex; ii++) {
        if (fn(value, ii, this) === false) {
          return ii + 1;
        }
        value += reverse ? -step : step;
      }
      return ii;
    };

    Range.prototype.__iterator = function(type, reverse) {
      var maxIndex = this.size - 1;
      var step = this._step;
      var value = reverse ? this._start + maxIndex * step : this._start;
      var ii = 0;
      return new Iterator(function()  {
        var v = value;
        value += reverse ? -step : step;
        return ii > maxIndex ? iteratorDone() : iteratorValue(type, ii++, v);
      });
    };

    Range.prototype.equals = function(other) {
      return other instanceof Range ?
        this._start === other._start &&
        this._end === other._end &&
        this._step === other._step :
        deepEqual(this, other);
    };


  var EMPTY_RANGE;

  createClass(Collection, Iterable);
    function Collection() {
      throw TypeError('Abstract');
    }


  createClass(KeyedCollection, Collection);function KeyedCollection() {}

  createClass(IndexedCollection, Collection);function IndexedCollection() {}

  createClass(SetCollection, Collection);function SetCollection() {}


  Collection.Keyed = KeyedCollection;
  Collection.Indexed = IndexedCollection;
  Collection.Set = SetCollection;

  var imul =
    typeof Math.imul === 'function' && Math.imul(0xffffffff, 2) === -2 ?
    Math.imul :
    function imul(a, b) {
      a = a | 0; // int
      b = b | 0; // int
      var c = a & 0xffff;
      var d = b & 0xffff;
      // Shift by 0 fixes the sign on the high part.
      return (c * d) + ((((a >>> 16) * d + c * (b >>> 16)) << 16) >>> 0) | 0; // int
    };

  // v8 has an optimization for storing 31-bit signed numbers.
  // Values which have either 00 or 11 as the high order bits qualify.
  // This function drops the highest order bit in a signed number, maintaining
  // the sign bit.
  function smi(i32) {
    return ((i32 >>> 1) & 0x40000000) | (i32 & 0xBFFFFFFF);
  }

  function hash(o) {
    if (o === false || o === null || o === undefined) {
      return 0;
    }
    if (typeof o.valueOf === 'function') {
      o = o.valueOf();
      if (o === false || o === null || o === undefined) {
        return 0;
      }
    }
    if (o === true) {
      return 1;
    }
    var type = typeof o;
    if (type === 'number') {
      if (o !== o || o === Infinity) {
        return 0;
      }
      var h = o | 0;
      if (h !== o) {
        h ^= o * 0xFFFFFFFF;
      }
      while (o > 0xFFFFFFFF) {
        o /= 0xFFFFFFFF;
        h ^= o;
      }
      return smi(h);
    }
    if (type === 'string') {
      return o.length > STRING_HASH_CACHE_MIN_STRLEN ? cachedHashString(o) : hashString(o);
    }
    if (typeof o.hashCode === 'function') {
      return o.hashCode();
    }
    if (type === 'object') {
      return hashJSObj(o);
    }
    if (typeof o.toString === 'function') {
      return hashString(o.toString());
    }
    throw new Error('Value type ' + type + ' cannot be hashed.');
  }

  function cachedHashString(string) {
    var hash = stringHashCache[string];
    if (hash === undefined) {
      hash = hashString(string);
      if (STRING_HASH_CACHE_SIZE === STRING_HASH_CACHE_MAX_SIZE) {
        STRING_HASH_CACHE_SIZE = 0;
        stringHashCache = {};
      }
      STRING_HASH_CACHE_SIZE++;
      stringHashCache[string] = hash;
    }
    return hash;
  }

  // http://jsperf.com/hashing-strings
  function hashString(string) {
    // This is the hash from JVM
    // The hash code for a string is computed as
    // s[0] * 31 ^ (n - 1) + s[1] * 31 ^ (n - 2) + ... + s[n - 1],
    // where s[i] is the ith character of the string and n is the length of
    // the string. We "mod" the result to make it between 0 (inclusive) and 2^31
    // (exclusive) by dropping high bits.
    var hash = 0;
    for (var ii = 0; ii < string.length; ii++) {
      hash = 31 * hash + string.charCodeAt(ii) | 0;
    }
    return smi(hash);
  }

  function hashJSObj(obj) {
    var hash;
    if (usingWeakMap) {
      hash = weakMap.get(obj);
      if (hash !== undefined) {
        return hash;
      }
    }

    hash = obj[UID_HASH_KEY];
    if (hash !== undefined) {
      return hash;
    }

    if (!canDefineProperty) {
      hash = obj.propertyIsEnumerable && obj.propertyIsEnumerable[UID_HASH_KEY];
      if (hash !== undefined) {
        return hash;
      }

      hash = getIENodeHash(obj);
      if (hash !== undefined) {
        return hash;
      }
    }

    hash = ++objHashUID;
    if (objHashUID & 0x40000000) {
      objHashUID = 0;
    }

    if (usingWeakMap) {
      weakMap.set(obj, hash);
    } else if (isExtensible !== undefined && isExtensible(obj) === false) {
      throw new Error('Non-extensible objects are not allowed as keys.');
    } else if (canDefineProperty) {
      Object.defineProperty(obj, UID_HASH_KEY, {
        'enumerable': false,
        'configurable': false,
        'writable': false,
        'value': hash
      });
    } else if (obj.propertyIsEnumerable !== undefined &&
               obj.propertyIsEnumerable === obj.constructor.prototype.propertyIsEnumerable) {
      // Since we can't define a non-enumerable property on the object
      // we'll hijack one of the less-used non-enumerable properties to
      // save our hash on it. Since this is a function it will not show up in
      // `JSON.stringify` which is what we want.
      obj.propertyIsEnumerable = function() {
        return this.constructor.prototype.propertyIsEnumerable.apply(this, arguments);
      };
      obj.propertyIsEnumerable[UID_HASH_KEY] = hash;
    } else if (obj.nodeType !== undefined) {
      // At this point we couldn't get the IE `uniqueID` to use as a hash
      // and we couldn't use a non-enumerable property to exploit the
      // dontEnum bug so we simply add the `UID_HASH_KEY` on the node
      // itself.
      obj[UID_HASH_KEY] = hash;
    } else {
      throw new Error('Unable to set a non-enumerable property on object.');
    }

    return hash;
  }

  // Get references to ES5 object methods.
  var isExtensible = Object.isExtensible;

  // True if Object.defineProperty works as expected. IE8 fails this test.
  var canDefineProperty = (function() {
    try {
      Object.defineProperty({}, '@', {});
      return true;
    } catch (e) {
      return false;
    }
  }());

  // IE has a `uniqueID` property on DOM nodes. We can construct the hash from it
  // and avoid memory leaks from the IE cloneNode bug.
  function getIENodeHash(node) {
    if (node && node.nodeType > 0) {
      switch (node.nodeType) {
        case 1: // Element
          return node.uniqueID;
        case 9: // Document
          return node.documentElement && node.documentElement.uniqueID;
      }
    }
  }

  // If possible, use a WeakMap.
  var usingWeakMap = typeof WeakMap === 'function';
  var weakMap;
  if (usingWeakMap) {
    weakMap = new WeakMap();
  }

  var objHashUID = 0;

  var UID_HASH_KEY = '__immutablehash__';
  if (typeof Symbol === 'function') {
    UID_HASH_KEY = Symbol(UID_HASH_KEY);
  }

  var STRING_HASH_CACHE_MIN_STRLEN = 16;
  var STRING_HASH_CACHE_MAX_SIZE = 255;
  var STRING_HASH_CACHE_SIZE = 0;
  var stringHashCache = {};

  function assertNotInfinite(size) {
    invariant(
      size !== Infinity,
      'Cannot perform this action with an infinite size.'
    );
  }

  createClass(Map, KeyedCollection);

    // @pragma Construction

    function Map(value) {
      return value === null || value === undefined ? emptyMap() :
        isMap(value) && !isOrdered(value) ? value :
        emptyMap().withMutations(function(map ) {
          var iter = KeyedIterable(value);
          assertNotInfinite(iter.size);
          iter.forEach(function(v, k)  {return map.set(k, v)});
        });
    }

    Map.of = function() {var keyValues = SLICE$0.call(arguments, 0);
      return emptyMap().withMutations(function(map ) {
        for (var i = 0; i < keyValues.length; i += 2) {
          if (i + 1 >= keyValues.length) {
            throw new Error('Missing value for key: ' + keyValues[i]);
          }
          map.set(keyValues[i], keyValues[i + 1]);
        }
      });
    };

    Map.prototype.toString = function() {
      return this.__toString('Map {', '}');
    };

    // @pragma Access

    Map.prototype.get = function(k, notSetValue) {
      return this._root ?
        this._root.get(0, undefined, k, notSetValue) :
        notSetValue;
    };

    // @pragma Modification

    Map.prototype.set = function(k, v) {
      return updateMap(this, k, v);
    };

    Map.prototype.setIn = function(keyPath, v) {
      return this.updateIn(keyPath, NOT_SET, function()  {return v});
    };

    Map.prototype.remove = function(k) {
      return updateMap(this, k, NOT_SET);
    };

    Map.prototype.deleteIn = function(keyPath) {
      return this.updateIn(keyPath, function()  {return NOT_SET});
    };

    Map.prototype.update = function(k, notSetValue, updater) {
      return arguments.length === 1 ?
        k(this) :
        this.updateIn([k], notSetValue, updater);
    };

    Map.prototype.updateIn = function(keyPath, notSetValue, updater) {
      if (!updater) {
        updater = notSetValue;
        notSetValue = undefined;
      }
      var updatedValue = updateInDeepMap(
        this,
        forceIterator(keyPath),
        notSetValue,
        updater
      );
      return updatedValue === NOT_SET ? undefined : updatedValue;
    };

    Map.prototype.clear = function() {
      if (this.size === 0) {
        return this;
      }
      if (this.__ownerID) {
        this.size = 0;
        this._root = null;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return emptyMap();
    };

    // @pragma Composition

    Map.prototype.merge = function(/*...iters*/) {
      return mergeIntoMapWith(this, undefined, arguments);
    };

    Map.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
      return mergeIntoMapWith(this, merger, iters);
    };

    Map.prototype.mergeIn = function(keyPath) {var iters = SLICE$0.call(arguments, 1);
      return this.updateIn(
        keyPath,
        emptyMap(),
        function(m ) {return typeof m.merge === 'function' ?
          m.merge.apply(m, iters) :
          iters[iters.length - 1]}
      );
    };

    Map.prototype.mergeDeep = function(/*...iters*/) {
      return mergeIntoMapWith(this, deepMerger, arguments);
    };

    Map.prototype.mergeDeepWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
      return mergeIntoMapWith(this, deepMergerWith(merger), iters);
    };

    Map.prototype.mergeDeepIn = function(keyPath) {var iters = SLICE$0.call(arguments, 1);
      return this.updateIn(
        keyPath,
        emptyMap(),
        function(m ) {return typeof m.mergeDeep === 'function' ?
          m.mergeDeep.apply(m, iters) :
          iters[iters.length - 1]}
      );
    };

    Map.prototype.sort = function(comparator) {
      // Late binding
      return OrderedMap(sortFactory(this, comparator));
    };

    Map.prototype.sortBy = function(mapper, comparator) {
      // Late binding
      return OrderedMap(sortFactory(this, comparator, mapper));
    };

    // @pragma Mutability

    Map.prototype.withMutations = function(fn) {
      var mutable = this.asMutable();
      fn(mutable);
      return mutable.wasAltered() ? mutable.__ensureOwner(this.__ownerID) : this;
    };

    Map.prototype.asMutable = function() {
      return this.__ownerID ? this : this.__ensureOwner(new OwnerID());
    };

    Map.prototype.asImmutable = function() {
      return this.__ensureOwner();
    };

    Map.prototype.wasAltered = function() {
      return this.__altered;
    };

    Map.prototype.__iterator = function(type, reverse) {
      return new MapIterator(this, type, reverse);
    };

    Map.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      var iterations = 0;
      this._root && this._root.iterate(function(entry ) {
        iterations++;
        return fn(entry[1], entry[0], this$0);
      }, reverse);
      return iterations;
    };

    Map.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      if (!ownerID) {
        this.__ownerID = ownerID;
        this.__altered = false;
        return this;
      }
      return makeMap(this.size, this._root, ownerID, this.__hash);
    };


  function isMap(maybeMap) {
    return !!(maybeMap && maybeMap[IS_MAP_SENTINEL]);
  }

  Map.isMap = isMap;

  var IS_MAP_SENTINEL = '@@__IMMUTABLE_MAP__@@';

  var MapPrototype = Map.prototype;
  MapPrototype[IS_MAP_SENTINEL] = true;
  MapPrototype[DELETE] = MapPrototype.remove;
  MapPrototype.removeIn = MapPrototype.deleteIn;


  // #pragma Trie Nodes



    function ArrayMapNode(ownerID, entries) {
      this.ownerID = ownerID;
      this.entries = entries;
    }

    ArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
      var entries = this.entries;
      for (var ii = 0, len = entries.length; ii < len; ii++) {
        if (is(key, entries[ii][0])) {
          return entries[ii][1];
        }
      }
      return notSetValue;
    };

    ArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      var removed = value === NOT_SET;

      var entries = this.entries;
      var idx = 0;
      for (var len = entries.length; idx < len; idx++) {
        if (is(key, entries[idx][0])) {
          break;
        }
      }
      var exists = idx < len;

      if (exists ? entries[idx][1] === value : removed) {
        return this;
      }

      SetRef(didAlter);
      (removed || !exists) && SetRef(didChangeSize);

      if (removed && entries.length === 1) {
        return; // undefined
      }

      if (!exists && !removed && entries.length >= MAX_ARRAY_MAP_SIZE) {
        return createNodes(ownerID, entries, key, value);
      }

      var isEditable = ownerID && ownerID === this.ownerID;
      var newEntries = isEditable ? entries : arrCopy(entries);

      if (exists) {
        if (removed) {
          idx === len - 1 ? newEntries.pop() : (newEntries[idx] = newEntries.pop());
        } else {
          newEntries[idx] = [key, value];
        }
      } else {
        newEntries.push([key, value]);
      }

      if (isEditable) {
        this.entries = newEntries;
        return this;
      }

      return new ArrayMapNode(ownerID, newEntries);
    };




    function BitmapIndexedNode(ownerID, bitmap, nodes) {
      this.ownerID = ownerID;
      this.bitmap = bitmap;
      this.nodes = nodes;
    }

    BitmapIndexedNode.prototype.get = function(shift, keyHash, key, notSetValue) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }
      var bit = (1 << ((shift === 0 ? keyHash : keyHash >>> shift) & MASK));
      var bitmap = this.bitmap;
      return (bitmap & bit) === 0 ? notSetValue :
        this.nodes[popCount(bitmap & (bit - 1))].get(shift + SHIFT, keyHash, key, notSetValue);
    };

    BitmapIndexedNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }
      var keyHashFrag = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
      var bit = 1 << keyHashFrag;
      var bitmap = this.bitmap;
      var exists = (bitmap & bit) !== 0;

      if (!exists && value === NOT_SET) {
        return this;
      }

      var idx = popCount(bitmap & (bit - 1));
      var nodes = this.nodes;
      var node = exists ? nodes[idx] : undefined;
      var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);

      if (newNode === node) {
        return this;
      }

      if (!exists && newNode && nodes.length >= MAX_BITMAP_INDEXED_SIZE) {
        return expandNodes(ownerID, nodes, bitmap, keyHashFrag, newNode);
      }

      if (exists && !newNode && nodes.length === 2 && isLeafNode(nodes[idx ^ 1])) {
        return nodes[idx ^ 1];
      }

      if (exists && newNode && nodes.length === 1 && isLeafNode(newNode)) {
        return newNode;
      }

      var isEditable = ownerID && ownerID === this.ownerID;
      var newBitmap = exists ? newNode ? bitmap : bitmap ^ bit : bitmap | bit;
      var newNodes = exists ? newNode ?
        setIn(nodes, idx, newNode, isEditable) :
        spliceOut(nodes, idx, isEditable) :
        spliceIn(nodes, idx, newNode, isEditable);

      if (isEditable) {
        this.bitmap = newBitmap;
        this.nodes = newNodes;
        return this;
      }

      return new BitmapIndexedNode(ownerID, newBitmap, newNodes);
    };




    function HashArrayMapNode(ownerID, count, nodes) {
      this.ownerID = ownerID;
      this.count = count;
      this.nodes = nodes;
    }

    HashArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }
      var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
      var node = this.nodes[idx];
      return node ? node.get(shift + SHIFT, keyHash, key, notSetValue) : notSetValue;
    };

    HashArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }
      var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
      var removed = value === NOT_SET;
      var nodes = this.nodes;
      var node = nodes[idx];

      if (removed && !node) {
        return this;
      }

      var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);
      if (newNode === node) {
        return this;
      }

      var newCount = this.count;
      if (!node) {
        newCount++;
      } else if (!newNode) {
        newCount--;
        if (newCount < MIN_HASH_ARRAY_MAP_SIZE) {
          return packNodes(ownerID, nodes, newCount, idx);
        }
      }

      var isEditable = ownerID && ownerID === this.ownerID;
      var newNodes = setIn(nodes, idx, newNode, isEditable);

      if (isEditable) {
        this.count = newCount;
        this.nodes = newNodes;
        return this;
      }

      return new HashArrayMapNode(ownerID, newCount, newNodes);
    };




    function HashCollisionNode(ownerID, keyHash, entries) {
      this.ownerID = ownerID;
      this.keyHash = keyHash;
      this.entries = entries;
    }

    HashCollisionNode.prototype.get = function(shift, keyHash, key, notSetValue) {
      var entries = this.entries;
      for (var ii = 0, len = entries.length; ii < len; ii++) {
        if (is(key, entries[ii][0])) {
          return entries[ii][1];
        }
      }
      return notSetValue;
    };

    HashCollisionNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }

      var removed = value === NOT_SET;

      if (keyHash !== this.keyHash) {
        if (removed) {
          return this;
        }
        SetRef(didAlter);
        SetRef(didChangeSize);
        return mergeIntoNode(this, ownerID, shift, keyHash, [key, value]);
      }

      var entries = this.entries;
      var idx = 0;
      for (var len = entries.length; idx < len; idx++) {
        if (is(key, entries[idx][0])) {
          break;
        }
      }
      var exists = idx < len;

      if (exists ? entries[idx][1] === value : removed) {
        return this;
      }

      SetRef(didAlter);
      (removed || !exists) && SetRef(didChangeSize);

      if (removed && len === 2) {
        return new ValueNode(ownerID, this.keyHash, entries[idx ^ 1]);
      }

      var isEditable = ownerID && ownerID === this.ownerID;
      var newEntries = isEditable ? entries : arrCopy(entries);

      if (exists) {
        if (removed) {
          idx === len - 1 ? newEntries.pop() : (newEntries[idx] = newEntries.pop());
        } else {
          newEntries[idx] = [key, value];
        }
      } else {
        newEntries.push([key, value]);
      }

      if (isEditable) {
        this.entries = newEntries;
        return this;
      }

      return new HashCollisionNode(ownerID, this.keyHash, newEntries);
    };




    function ValueNode(ownerID, keyHash, entry) {
      this.ownerID = ownerID;
      this.keyHash = keyHash;
      this.entry = entry;
    }

    ValueNode.prototype.get = function(shift, keyHash, key, notSetValue) {
      return is(key, this.entry[0]) ? this.entry[1] : notSetValue;
    };

    ValueNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      var removed = value === NOT_SET;
      var keyMatch = is(key, this.entry[0]);
      if (keyMatch ? value === this.entry[1] : removed) {
        return this;
      }

      SetRef(didAlter);

      if (removed) {
        SetRef(didChangeSize);
        return; // undefined
      }

      if (keyMatch) {
        if (ownerID && ownerID === this.ownerID) {
          this.entry[1] = value;
          return this;
        }
        return new ValueNode(ownerID, this.keyHash, [key, value]);
      }

      SetRef(didChangeSize);
      return mergeIntoNode(this, ownerID, shift, hash(key), [key, value]);
    };



  // #pragma Iterators

  ArrayMapNode.prototype.iterate =
  HashCollisionNode.prototype.iterate = function (fn, reverse) {
    var entries = this.entries;
    for (var ii = 0, maxIndex = entries.length - 1; ii <= maxIndex; ii++) {
      if (fn(entries[reverse ? maxIndex - ii : ii]) === false) {
        return false;
      }
    }
  }

  BitmapIndexedNode.prototype.iterate =
  HashArrayMapNode.prototype.iterate = function (fn, reverse) {
    var nodes = this.nodes;
    for (var ii = 0, maxIndex = nodes.length - 1; ii <= maxIndex; ii++) {
      var node = nodes[reverse ? maxIndex - ii : ii];
      if (node && node.iterate(fn, reverse) === false) {
        return false;
      }
    }
  }

  ValueNode.prototype.iterate = function (fn, reverse) {
    return fn(this.entry);
  }

  createClass(MapIterator, Iterator);

    function MapIterator(map, type, reverse) {
      this._type = type;
      this._reverse = reverse;
      this._stack = map._root && mapIteratorFrame(map._root);
    }

    MapIterator.prototype.next = function() {
      var type = this._type;
      var stack = this._stack;
      while (stack) {
        var node = stack.node;
        var index = stack.index++;
        var maxIndex;
        if (node.entry) {
          if (index === 0) {
            return mapIteratorValue(type, node.entry);
          }
        } else if (node.entries) {
          maxIndex = node.entries.length - 1;
          if (index <= maxIndex) {
            return mapIteratorValue(type, node.entries[this._reverse ? maxIndex - index : index]);
          }
        } else {
          maxIndex = node.nodes.length - 1;
          if (index <= maxIndex) {
            var subNode = node.nodes[this._reverse ? maxIndex - index : index];
            if (subNode) {
              if (subNode.entry) {
                return mapIteratorValue(type, subNode.entry);
              }
              stack = this._stack = mapIteratorFrame(subNode, stack);
            }
            continue;
          }
        }
        stack = this._stack = this._stack.__prev;
      }
      return iteratorDone();
    };


  function mapIteratorValue(type, entry) {
    return iteratorValue(type, entry[0], entry[1]);
  }

  function mapIteratorFrame(node, prev) {
    return {
      node: node,
      index: 0,
      __prev: prev
    };
  }

  function makeMap(size, root, ownerID, hash) {
    var map = Object.create(MapPrototype);
    map.size = size;
    map._root = root;
    map.__ownerID = ownerID;
    map.__hash = hash;
    map.__altered = false;
    return map;
  }

  var EMPTY_MAP;
  function emptyMap() {
    return EMPTY_MAP || (EMPTY_MAP = makeMap(0));
  }

  function updateMap(map, k, v) {
    var newRoot;
    var newSize;
    if (!map._root) {
      if (v === NOT_SET) {
        return map;
      }
      newSize = 1;
      newRoot = new ArrayMapNode(map.__ownerID, [[k, v]]);
    } else {
      var didChangeSize = MakeRef(CHANGE_LENGTH);
      var didAlter = MakeRef(DID_ALTER);
      newRoot = updateNode(map._root, map.__ownerID, 0, undefined, k, v, didChangeSize, didAlter);
      if (!didAlter.value) {
        return map;
      }
      newSize = map.size + (didChangeSize.value ? v === NOT_SET ? -1 : 1 : 0);
    }
    if (map.__ownerID) {
      map.size = newSize;
      map._root = newRoot;
      map.__hash = undefined;
      map.__altered = true;
      return map;
    }
    return newRoot ? makeMap(newSize, newRoot) : emptyMap();
  }

  function updateNode(node, ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
    if (!node) {
      if (value === NOT_SET) {
        return node;
      }
      SetRef(didAlter);
      SetRef(didChangeSize);
      return new ValueNode(ownerID, keyHash, [key, value]);
    }
    return node.update(ownerID, shift, keyHash, key, value, didChangeSize, didAlter);
  }

  function isLeafNode(node) {
    return node.constructor === ValueNode || node.constructor === HashCollisionNode;
  }

  function mergeIntoNode(node, ownerID, shift, keyHash, entry) {
    if (node.keyHash === keyHash) {
      return new HashCollisionNode(ownerID, keyHash, [node.entry, entry]);
    }

    var idx1 = (shift === 0 ? node.keyHash : node.keyHash >>> shift) & MASK;
    var idx2 = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;

    var newNode;
    var nodes = idx1 === idx2 ?
      [mergeIntoNode(node, ownerID, shift + SHIFT, keyHash, entry)] :
      ((newNode = new ValueNode(ownerID, keyHash, entry)), idx1 < idx2 ? [node, newNode] : [newNode, node]);

    return new BitmapIndexedNode(ownerID, (1 << idx1) | (1 << idx2), nodes);
  }

  function createNodes(ownerID, entries, key, value) {
    if (!ownerID) {
      ownerID = new OwnerID();
    }
    var node = new ValueNode(ownerID, hash(key), [key, value]);
    for (var ii = 0; ii < entries.length; ii++) {
      var entry = entries[ii];
      node = node.update(ownerID, 0, undefined, entry[0], entry[1]);
    }
    return node;
  }

  function packNodes(ownerID, nodes, count, excluding) {
    var bitmap = 0;
    var packedII = 0;
    var packedNodes = new Array(count);
    for (var ii = 0, bit = 1, len = nodes.length; ii < len; ii++, bit <<= 1) {
      var node = nodes[ii];
      if (node !== undefined && ii !== excluding) {
        bitmap |= bit;
        packedNodes[packedII++] = node;
      }
    }
    return new BitmapIndexedNode(ownerID, bitmap, packedNodes);
  }

  function expandNodes(ownerID, nodes, bitmap, including, node) {
    var count = 0;
    var expandedNodes = new Array(SIZE);
    for (var ii = 0; bitmap !== 0; ii++, bitmap >>>= 1) {
      expandedNodes[ii] = bitmap & 1 ? nodes[count++] : undefined;
    }
    expandedNodes[including] = node;
    return new HashArrayMapNode(ownerID, count + 1, expandedNodes);
  }

  function mergeIntoMapWith(map, merger, iterables) {
    var iters = [];
    for (var ii = 0; ii < iterables.length; ii++) {
      var value = iterables[ii];
      var iter = KeyedIterable(value);
      if (!isIterable(value)) {
        iter = iter.map(function(v ) {return fromJS(v)});
      }
      iters.push(iter);
    }
    return mergeIntoCollectionWith(map, merger, iters);
  }

  function deepMerger(existing, value, key) {
    return existing && existing.mergeDeep && isIterable(value) ?
      existing.mergeDeep(value) :
      is(existing, value) ? existing : value;
  }

  function deepMergerWith(merger) {
    return function(existing, value, key)  {
      if (existing && existing.mergeDeepWith && isIterable(value)) {
        return existing.mergeDeepWith(merger, value);
      }
      var nextValue = merger(existing, value, key);
      return is(existing, nextValue) ? existing : nextValue;
    };
  }

  function mergeIntoCollectionWith(collection, merger, iters) {
    iters = iters.filter(function(x ) {return x.size !== 0});
    if (iters.length === 0) {
      return collection;
    }
    if (collection.size === 0 && !collection.__ownerID && iters.length === 1) {
      return collection.constructor(iters[0]);
    }
    return collection.withMutations(function(collection ) {
      var mergeIntoMap = merger ?
        function(value, key)  {
          collection.update(key, NOT_SET, function(existing )
            {return existing === NOT_SET ? value : merger(existing, value, key)}
          );
        } :
        function(value, key)  {
          collection.set(key, value);
        }
      for (var ii = 0; ii < iters.length; ii++) {
        iters[ii].forEach(mergeIntoMap);
      }
    });
  }

  function updateInDeepMap(existing, keyPathIter, notSetValue, updater) {
    var isNotSet = existing === NOT_SET;
    var step = keyPathIter.next();
    if (step.done) {
      var existingValue = isNotSet ? notSetValue : existing;
      var newValue = updater(existingValue);
      return newValue === existingValue ? existing : newValue;
    }
    invariant(
      isNotSet || (existing && existing.set),
      'invalid keyPath'
    );
    var key = step.value;
    var nextExisting = isNotSet ? NOT_SET : existing.get(key, NOT_SET);
    var nextUpdated = updateInDeepMap(
      nextExisting,
      keyPathIter,
      notSetValue,
      updater
    );
    return nextUpdated === nextExisting ? existing :
      nextUpdated === NOT_SET ? existing.remove(key) :
      (isNotSet ? emptyMap() : existing).set(key, nextUpdated);
  }

  function popCount(x) {
    x = x - ((x >> 1) & 0x55555555);
    x = (x & 0x33333333) + ((x >> 2) & 0x33333333);
    x = (x + (x >> 4)) & 0x0f0f0f0f;
    x = x + (x >> 8);
    x = x + (x >> 16);
    return x & 0x7f;
  }

  function setIn(array, idx, val, canEdit) {
    var newArray = canEdit ? array : arrCopy(array);
    newArray[idx] = val;
    return newArray;
  }

  function spliceIn(array, idx, val, canEdit) {
    var newLen = array.length + 1;
    if (canEdit && idx + 1 === newLen) {
      array[idx] = val;
      return array;
    }
    var newArray = new Array(newLen);
    var after = 0;
    for (var ii = 0; ii < newLen; ii++) {
      if (ii === idx) {
        newArray[ii] = val;
        after = -1;
      } else {
        newArray[ii] = array[ii + after];
      }
    }
    return newArray;
  }

  function spliceOut(array, idx, canEdit) {
    var newLen = array.length - 1;
    if (canEdit && idx === newLen) {
      array.pop();
      return array;
    }
    var newArray = new Array(newLen);
    var after = 0;
    for (var ii = 0; ii < newLen; ii++) {
      if (ii === idx) {
        after = 1;
      }
      newArray[ii] = array[ii + after];
    }
    return newArray;
  }

  var MAX_ARRAY_MAP_SIZE = SIZE / 4;
  var MAX_BITMAP_INDEXED_SIZE = SIZE / 2;
  var MIN_HASH_ARRAY_MAP_SIZE = SIZE / 4;

  createClass(List, IndexedCollection);

    // @pragma Construction

    function List(value) {
      var empty = emptyList();
      if (value === null || value === undefined) {
        return empty;
      }
      if (isList(value)) {
        return value;
      }
      var iter = IndexedIterable(value);
      var size = iter.size;
      if (size === 0) {
        return empty;
      }
      assertNotInfinite(size);
      if (size > 0 && size < SIZE) {
        return makeList(0, size, SHIFT, null, new VNode(iter.toArray()));
      }
      return empty.withMutations(function(list ) {
        list.setSize(size);
        iter.forEach(function(v, i)  {return list.set(i, v)});
      });
    }

    List.of = function(/*...values*/) {
      return this(arguments);
    };

    List.prototype.toString = function() {
      return this.__toString('List [', ']');
    };

    // @pragma Access

    List.prototype.get = function(index, notSetValue) {
      index = wrapIndex(this, index);
      if (index >= 0 && index < this.size) {
        index += this._origin;
        var node = listNodeFor(this, index);
        return node && node.array[index & MASK];
      }
      return notSetValue;
    };

    // @pragma Modification

    List.prototype.set = function(index, value) {
      return updateList(this, index, value);
    };

    List.prototype.remove = function(index) {
      return !this.has(index) ? this :
        index === 0 ? this.shift() :
        index === this.size - 1 ? this.pop() :
        this.splice(index, 1);
    };

    List.prototype.insert = function(index, value) {
      return this.splice(index, 0, value);
    };

    List.prototype.clear = function() {
      if (this.size === 0) {
        return this;
      }
      if (this.__ownerID) {
        this.size = this._origin = this._capacity = 0;
        this._level = SHIFT;
        this._root = this._tail = null;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return emptyList();
    };

    List.prototype.push = function(/*...values*/) {
      var values = arguments;
      var oldSize = this.size;
      return this.withMutations(function(list ) {
        setListBounds(list, 0, oldSize + values.length);
        for (var ii = 0; ii < values.length; ii++) {
          list.set(oldSize + ii, values[ii]);
        }
      });
    };

    List.prototype.pop = function() {
      return setListBounds(this, 0, -1);
    };

    List.prototype.unshift = function(/*...values*/) {
      var values = arguments;
      return this.withMutations(function(list ) {
        setListBounds(list, -values.length);
        for (var ii = 0; ii < values.length; ii++) {
          list.set(ii, values[ii]);
        }
      });
    };

    List.prototype.shift = function() {
      return setListBounds(this, 1);
    };

    // @pragma Composition

    List.prototype.merge = function(/*...iters*/) {
      return mergeIntoListWith(this, undefined, arguments);
    };

    List.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
      return mergeIntoListWith(this, merger, iters);
    };

    List.prototype.mergeDeep = function(/*...iters*/) {
      return mergeIntoListWith(this, deepMerger, arguments);
    };

    List.prototype.mergeDeepWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
      return mergeIntoListWith(this, deepMergerWith(merger), iters);
    };

    List.prototype.setSize = function(size) {
      return setListBounds(this, 0, size);
    };

    // @pragma Iteration

    List.prototype.slice = function(begin, end) {
      var size = this.size;
      if (wholeSlice(begin, end, size)) {
        return this;
      }
      return setListBounds(
        this,
        resolveBegin(begin, size),
        resolveEnd(end, size)
      );
    };

    List.prototype.__iterator = function(type, reverse) {
      var index = 0;
      var values = iterateList(this, reverse);
      return new Iterator(function()  {
        var value = values();
        return value === DONE ?
          iteratorDone() :
          iteratorValue(type, index++, value);
      });
    };

    List.prototype.__iterate = function(fn, reverse) {
      var index = 0;
      var values = iterateList(this, reverse);
      var value;
      while ((value = values()) !== DONE) {
        if (fn(value, index++, this) === false) {
          break;
        }
      }
      return index;
    };

    List.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      if (!ownerID) {
        this.__ownerID = ownerID;
        return this;
      }
      return makeList(this._origin, this._capacity, this._level, this._root, this._tail, ownerID, this.__hash);
    };


  function isList(maybeList) {
    return !!(maybeList && maybeList[IS_LIST_SENTINEL]);
  }

  List.isList = isList;

  var IS_LIST_SENTINEL = '@@__IMMUTABLE_LIST__@@';

  var ListPrototype = List.prototype;
  ListPrototype[IS_LIST_SENTINEL] = true;
  ListPrototype[DELETE] = ListPrototype.remove;
  ListPrototype.setIn = MapPrototype.setIn;
  ListPrototype.deleteIn =
  ListPrototype.removeIn = MapPrototype.removeIn;
  ListPrototype.update = MapPrototype.update;
  ListPrototype.updateIn = MapPrototype.updateIn;
  ListPrototype.mergeIn = MapPrototype.mergeIn;
  ListPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
  ListPrototype.withMutations = MapPrototype.withMutations;
  ListPrototype.asMutable = MapPrototype.asMutable;
  ListPrototype.asImmutable = MapPrototype.asImmutable;
  ListPrototype.wasAltered = MapPrototype.wasAltered;



    function VNode(array, ownerID) {
      this.array = array;
      this.ownerID = ownerID;
    }

    // TODO: seems like these methods are very similar

    VNode.prototype.removeBefore = function(ownerID, level, index) {
      if (index === level ? 1 << level : 0 || this.array.length === 0) {
        return this;
      }
      var originIndex = (index >>> level) & MASK;
      if (originIndex >= this.array.length) {
        return new VNode([], ownerID);
      }
      var removingFirst = originIndex === 0;
      var newChild;
      if (level > 0) {
        var oldChild = this.array[originIndex];
        newChild = oldChild && oldChild.removeBefore(ownerID, level - SHIFT, index);
        if (newChild === oldChild && removingFirst) {
          return this;
        }
      }
      if (removingFirst && !newChild) {
        return this;
      }
      var editable = editableVNode(this, ownerID);
      if (!removingFirst) {
        for (var ii = 0; ii < originIndex; ii++) {
          editable.array[ii] = undefined;
        }
      }
      if (newChild) {
        editable.array[originIndex] = newChild;
      }
      return editable;
    };

    VNode.prototype.removeAfter = function(ownerID, level, index) {
      if (index === (level ? 1 << level : 0) || this.array.length === 0) {
        return this;
      }
      var sizeIndex = ((index - 1) >>> level) & MASK;
      if (sizeIndex >= this.array.length) {
        return this;
      }

      var newChild;
      if (level > 0) {
        var oldChild = this.array[sizeIndex];
        newChild = oldChild && oldChild.removeAfter(ownerID, level - SHIFT, index);
        if (newChild === oldChild && sizeIndex === this.array.length - 1) {
          return this;
        }
      }

      var editable = editableVNode(this, ownerID);
      editable.array.splice(sizeIndex + 1);
      if (newChild) {
        editable.array[sizeIndex] = newChild;
      }
      return editable;
    };



  var DONE = {};

  function iterateList(list, reverse) {
    var left = list._origin;
    var right = list._capacity;
    var tailPos = getTailOffset(right);
    var tail = list._tail;

    return iterateNodeOrLeaf(list._root, list._level, 0);

    function iterateNodeOrLeaf(node, level, offset) {
      return level === 0 ?
        iterateLeaf(node, offset) :
        iterateNode(node, level, offset);
    }

    function iterateLeaf(node, offset) {
      var array = offset === tailPos ? tail && tail.array : node && node.array;
      var from = offset > left ? 0 : left - offset;
      var to = right - offset;
      if (to > SIZE) {
        to = SIZE;
      }
      return function()  {
        if (from === to) {
          return DONE;
        }
        var idx = reverse ? --to : from++;
        return array && array[idx];
      };
    }

    function iterateNode(node, level, offset) {
      var values;
      var array = node && node.array;
      var from = offset > left ? 0 : (left - offset) >> level;
      var to = ((right - offset) >> level) + 1;
      if (to > SIZE) {
        to = SIZE;
      }
      return function()  {
        do {
          if (values) {
            var value = values();
            if (value !== DONE) {
              return value;
            }
            values = null;
          }
          if (from === to) {
            return DONE;
          }
          var idx = reverse ? --to : from++;
          values = iterateNodeOrLeaf(
            array && array[idx], level - SHIFT, offset + (idx << level)
          );
        } while (true);
      };
    }
  }

  function makeList(origin, capacity, level, root, tail, ownerID, hash) {
    var list = Object.create(ListPrototype);
    list.size = capacity - origin;
    list._origin = origin;
    list._capacity = capacity;
    list._level = level;
    list._root = root;
    list._tail = tail;
    list.__ownerID = ownerID;
    list.__hash = hash;
    list.__altered = false;
    return list;
  }

  var EMPTY_LIST;
  function emptyList() {
    return EMPTY_LIST || (EMPTY_LIST = makeList(0, 0, SHIFT));
  }

  function updateList(list, index, value) {
    index = wrapIndex(list, index);

    if (index !== index) {
      return list;
    }

    if (index >= list.size || index < 0) {
      return list.withMutations(function(list ) {
        index < 0 ?
          setListBounds(list, index).set(0, value) :
          setListBounds(list, 0, index + 1).set(index, value)
      });
    }

    index += list._origin;

    var newTail = list._tail;
    var newRoot = list._root;
    var didAlter = MakeRef(DID_ALTER);
    if (index >= getTailOffset(list._capacity)) {
      newTail = updateVNode(newTail, list.__ownerID, 0, index, value, didAlter);
    } else {
      newRoot = updateVNode(newRoot, list.__ownerID, list._level, index, value, didAlter);
    }

    if (!didAlter.value) {
      return list;
    }

    if (list.__ownerID) {
      list._root = newRoot;
      list._tail = newTail;
      list.__hash = undefined;
      list.__altered = true;
      return list;
    }
    return makeList(list._origin, list._capacity, list._level, newRoot, newTail);
  }

  function updateVNode(node, ownerID, level, index, value, didAlter) {
    var idx = (index >>> level) & MASK;
    var nodeHas = node && idx < node.array.length;
    if (!nodeHas && value === undefined) {
      return node;
    }

    var newNode;

    if (level > 0) {
      var lowerNode = node && node.array[idx];
      var newLowerNode = updateVNode(lowerNode, ownerID, level - SHIFT, index, value, didAlter);
      if (newLowerNode === lowerNode) {
        return node;
      }
      newNode = editableVNode(node, ownerID);
      newNode.array[idx] = newLowerNode;
      return newNode;
    }

    if (nodeHas && node.array[idx] === value) {
      return node;
    }

    SetRef(didAlter);

    newNode = editableVNode(node, ownerID);
    if (value === undefined && idx === newNode.array.length - 1) {
      newNode.array.pop();
    } else {
      newNode.array[idx] = value;
    }
    return newNode;
  }

  function editableVNode(node, ownerID) {
    if (ownerID && node && ownerID === node.ownerID) {
      return node;
    }
    return new VNode(node ? node.array.slice() : [], ownerID);
  }

  function listNodeFor(list, rawIndex) {
    if (rawIndex >= getTailOffset(list._capacity)) {
      return list._tail;
    }
    if (rawIndex < 1 << (list._level + SHIFT)) {
      var node = list._root;
      var level = list._level;
      while (node && level > 0) {
        node = node.array[(rawIndex >>> level) & MASK];
        level -= SHIFT;
      }
      return node;
    }
  }

  function setListBounds(list, begin, end) {
    // Sanitize begin & end using this shorthand for ToInt32(argument)
    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
    if (begin !== undefined) {
      begin = begin | 0;
    }
    if (end !== undefined) {
      end = end | 0;
    }
    var owner = list.__ownerID || new OwnerID();
    var oldOrigin = list._origin;
    var oldCapacity = list._capacity;
    var newOrigin = oldOrigin + begin;
    var newCapacity = end === undefined ? oldCapacity : end < 0 ? oldCapacity + end : oldOrigin + end;
    if (newOrigin === oldOrigin && newCapacity === oldCapacity) {
      return list;
    }

    // If it's going to end after it starts, it's empty.
    if (newOrigin >= newCapacity) {
      return list.clear();
    }

    var newLevel = list._level;
    var newRoot = list._root;

    // New origin might need creating a higher root.
    var offsetShift = 0;
    while (newOrigin + offsetShift < 0) {
      newRoot = new VNode(newRoot && newRoot.array.length ? [undefined, newRoot] : [], owner);
      newLevel += SHIFT;
      offsetShift += 1 << newLevel;
    }
    if (offsetShift) {
      newOrigin += offsetShift;
      oldOrigin += offsetShift;
      newCapacity += offsetShift;
      oldCapacity += offsetShift;
    }

    var oldTailOffset = getTailOffset(oldCapacity);
    var newTailOffset = getTailOffset(newCapacity);

    // New size might need creating a higher root.
    while (newTailOffset >= 1 << (newLevel + SHIFT)) {
      newRoot = new VNode(newRoot && newRoot.array.length ? [newRoot] : [], owner);
      newLevel += SHIFT;
    }

    // Locate or create the new tail.
    var oldTail = list._tail;
    var newTail = newTailOffset < oldTailOffset ?
      listNodeFor(list, newCapacity - 1) :
      newTailOffset > oldTailOffset ? new VNode([], owner) : oldTail;

    // Merge Tail into tree.
    if (oldTail && newTailOffset > oldTailOffset && newOrigin < oldCapacity && oldTail.array.length) {
      newRoot = editableVNode(newRoot, owner);
      var node = newRoot;
      for (var level = newLevel; level > SHIFT; level -= SHIFT) {
        var idx = (oldTailOffset >>> level) & MASK;
        node = node.array[idx] = editableVNode(node.array[idx], owner);
      }
      node.array[(oldTailOffset >>> SHIFT) & MASK] = oldTail;
    }

    // If the size has been reduced, there's a chance the tail needs to be trimmed.
    if (newCapacity < oldCapacity) {
      newTail = newTail && newTail.removeAfter(owner, 0, newCapacity);
    }

    // If the new origin is within the tail, then we do not need a root.
    if (newOrigin >= newTailOffset) {
      newOrigin -= newTailOffset;
      newCapacity -= newTailOffset;
      newLevel = SHIFT;
      newRoot = null;
      newTail = newTail && newTail.removeBefore(owner, 0, newOrigin);

    // Otherwise, if the root has been trimmed, garbage collect.
    } else if (newOrigin > oldOrigin || newTailOffset < oldTailOffset) {
      offsetShift = 0;

      // Identify the new top root node of the subtree of the old root.
      while (newRoot) {
        var beginIndex = (newOrigin >>> newLevel) & MASK;
        if (beginIndex !== (newTailOffset >>> newLevel) & MASK) {
          break;
        }
        if (beginIndex) {
          offsetShift += (1 << newLevel) * beginIndex;
        }
        newLevel -= SHIFT;
        newRoot = newRoot.array[beginIndex];
      }

      // Trim the new sides of the new root.
      if (newRoot && newOrigin > oldOrigin) {
        newRoot = newRoot.removeBefore(owner, newLevel, newOrigin - offsetShift);
      }
      if (newRoot && newTailOffset < oldTailOffset) {
        newRoot = newRoot.removeAfter(owner, newLevel, newTailOffset - offsetShift);
      }
      if (offsetShift) {
        newOrigin -= offsetShift;
        newCapacity -= offsetShift;
      }
    }

    if (list.__ownerID) {
      list.size = newCapacity - newOrigin;
      list._origin = newOrigin;
      list._capacity = newCapacity;
      list._level = newLevel;
      list._root = newRoot;
      list._tail = newTail;
      list.__hash = undefined;
      list.__altered = true;
      return list;
    }
    return makeList(newOrigin, newCapacity, newLevel, newRoot, newTail);
  }

  function mergeIntoListWith(list, merger, iterables) {
    var iters = [];
    var maxSize = 0;
    for (var ii = 0; ii < iterables.length; ii++) {
      var value = iterables[ii];
      var iter = IndexedIterable(value);
      if (iter.size > maxSize) {
        maxSize = iter.size;
      }
      if (!isIterable(value)) {
        iter = iter.map(function(v ) {return fromJS(v)});
      }
      iters.push(iter);
    }
    if (maxSize > list.size) {
      list = list.setSize(maxSize);
    }
    return mergeIntoCollectionWith(list, merger, iters);
  }

  function getTailOffset(size) {
    return size < SIZE ? 0 : (((size - 1) >>> SHIFT) << SHIFT);
  }

  createClass(OrderedMap, Map);

    // @pragma Construction

    function OrderedMap(value) {
      return value === null || value === undefined ? emptyOrderedMap() :
        isOrderedMap(value) ? value :
        emptyOrderedMap().withMutations(function(map ) {
          var iter = KeyedIterable(value);
          assertNotInfinite(iter.size);
          iter.forEach(function(v, k)  {return map.set(k, v)});
        });
    }

    OrderedMap.of = function(/*...values*/) {
      return this(arguments);
    };

    OrderedMap.prototype.toString = function() {
      return this.__toString('OrderedMap {', '}');
    };

    // @pragma Access

    OrderedMap.prototype.get = function(k, notSetValue) {
      var index = this._map.get(k);
      return index !== undefined ? this._list.get(index)[1] : notSetValue;
    };

    // @pragma Modification

    OrderedMap.prototype.clear = function() {
      if (this.size === 0) {
        return this;
      }
      if (this.__ownerID) {
        this.size = 0;
        this._map.clear();
        this._list.clear();
        return this;
      }
      return emptyOrderedMap();
    };

    OrderedMap.prototype.set = function(k, v) {
      return updateOrderedMap(this, k, v);
    };

    OrderedMap.prototype.remove = function(k) {
      return updateOrderedMap(this, k, NOT_SET);
    };

    OrderedMap.prototype.wasAltered = function() {
      return this._map.wasAltered() || this._list.wasAltered();
    };

    OrderedMap.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      return this._list.__iterate(
        function(entry ) {return entry && fn(entry[1], entry[0], this$0)},
        reverse
      );
    };

    OrderedMap.prototype.__iterator = function(type, reverse) {
      return this._list.fromEntrySeq().__iterator(type, reverse);
    };

    OrderedMap.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      var newMap = this._map.__ensureOwner(ownerID);
      var newList = this._list.__ensureOwner(ownerID);
      if (!ownerID) {
        this.__ownerID = ownerID;
        this._map = newMap;
        this._list = newList;
        return this;
      }
      return makeOrderedMap(newMap, newList, ownerID, this.__hash);
    };


  function isOrderedMap(maybeOrderedMap) {
    return isMap(maybeOrderedMap) && isOrdered(maybeOrderedMap);
  }

  OrderedMap.isOrderedMap = isOrderedMap;

  OrderedMap.prototype[IS_ORDERED_SENTINEL] = true;
  OrderedMap.prototype[DELETE] = OrderedMap.prototype.remove;



  function makeOrderedMap(map, list, ownerID, hash) {
    var omap = Object.create(OrderedMap.prototype);
    omap.size = map ? map.size : 0;
    omap._map = map;
    omap._list = list;
    omap.__ownerID = ownerID;
    omap.__hash = hash;
    return omap;
  }

  var EMPTY_ORDERED_MAP;
  function emptyOrderedMap() {
    return EMPTY_ORDERED_MAP || (EMPTY_ORDERED_MAP = makeOrderedMap(emptyMap(), emptyList()));
  }

  function updateOrderedMap(omap, k, v) {
    var map = omap._map;
    var list = omap._list;
    var i = map.get(k);
    var has = i !== undefined;
    var newMap;
    var newList;
    if (v === NOT_SET) { // removed
      if (!has) {
        return omap;
      }
      if (list.size >= SIZE && list.size >= map.size * 2) {
        newList = list.filter(function(entry, idx)  {return entry !== undefined && i !== idx});
        newMap = newList.toKeyedSeq().map(function(entry ) {return entry[0]}).flip().toMap();
        if (omap.__ownerID) {
          newMap.__ownerID = newList.__ownerID = omap.__ownerID;
        }
      } else {
        newMap = map.remove(k);
        newList = i === list.size - 1 ? list.pop() : list.set(i, undefined);
      }
    } else {
      if (has) {
        if (v === list.get(i)[1]) {
          return omap;
        }
        newMap = map;
        newList = list.set(i, [k, v]);
      } else {
        newMap = map.set(k, list.size);
        newList = list.set(list.size, [k, v]);
      }
    }
    if (omap.__ownerID) {
      omap.size = newMap.size;
      omap._map = newMap;
      omap._list = newList;
      omap.__hash = undefined;
      return omap;
    }
    return makeOrderedMap(newMap, newList);
  }

  createClass(ToKeyedSequence, KeyedSeq);
    function ToKeyedSequence(indexed, useKeys) {
      this._iter = indexed;
      this._useKeys = useKeys;
      this.size = indexed.size;
    }

    ToKeyedSequence.prototype.get = function(key, notSetValue) {
      return this._iter.get(key, notSetValue);
    };

    ToKeyedSequence.prototype.has = function(key) {
      return this._iter.has(key);
    };

    ToKeyedSequence.prototype.valueSeq = function() {
      return this._iter.valueSeq();
    };

    ToKeyedSequence.prototype.reverse = function() {var this$0 = this;
      var reversedSequence = reverseFactory(this, true);
      if (!this._useKeys) {
        reversedSequence.valueSeq = function()  {return this$0._iter.toSeq().reverse()};
      }
      return reversedSequence;
    };

    ToKeyedSequence.prototype.map = function(mapper, context) {var this$0 = this;
      var mappedSequence = mapFactory(this, mapper, context);
      if (!this._useKeys) {
        mappedSequence.valueSeq = function()  {return this$0._iter.toSeq().map(mapper, context)};
      }
      return mappedSequence;
    };

    ToKeyedSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      var ii;
      return this._iter.__iterate(
        this._useKeys ?
          function(v, k)  {return fn(v, k, this$0)} :
          ((ii = reverse ? resolveSize(this) : 0),
            function(v ) {return fn(v, reverse ? --ii : ii++, this$0)}),
        reverse
      );
    };

    ToKeyedSequence.prototype.__iterator = function(type, reverse) {
      if (this._useKeys) {
        return this._iter.__iterator(type, reverse);
      }
      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
      var ii = reverse ? resolveSize(this) : 0;
      return new Iterator(function()  {
        var step = iterator.next();
        return step.done ? step :
          iteratorValue(type, reverse ? --ii : ii++, step.value, step);
      });
    };

  ToKeyedSequence.prototype[IS_ORDERED_SENTINEL] = true;


  createClass(ToIndexedSequence, IndexedSeq);
    function ToIndexedSequence(iter) {
      this._iter = iter;
      this.size = iter.size;
    }

    ToIndexedSequence.prototype.includes = function(value) {
      return this._iter.includes(value);
    };

    ToIndexedSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      var iterations = 0;
      return this._iter.__iterate(function(v ) {return fn(v, iterations++, this$0)}, reverse);
    };

    ToIndexedSequence.prototype.__iterator = function(type, reverse) {
      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
      var iterations = 0;
      return new Iterator(function()  {
        var step = iterator.next();
        return step.done ? step :
          iteratorValue(type, iterations++, step.value, step)
      });
    };



  createClass(ToSetSequence, SetSeq);
    function ToSetSequence(iter) {
      this._iter = iter;
      this.size = iter.size;
    }

    ToSetSequence.prototype.has = function(key) {
      return this._iter.includes(key);
    };

    ToSetSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      return this._iter.__iterate(function(v ) {return fn(v, v, this$0)}, reverse);
    };

    ToSetSequence.prototype.__iterator = function(type, reverse) {
      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
      return new Iterator(function()  {
        var step = iterator.next();
        return step.done ? step :
          iteratorValue(type, step.value, step.value, step);
      });
    };



  createClass(FromEntriesSequence, KeyedSeq);
    function FromEntriesSequence(entries) {
      this._iter = entries;
      this.size = entries.size;
    }

    FromEntriesSequence.prototype.entrySeq = function() {
      return this._iter.toSeq();
    };

    FromEntriesSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      return this._iter.__iterate(function(entry ) {
        // Check if entry exists first so array access doesn't throw for holes
        // in the parent iteration.
        if (entry) {
          validateEntry(entry);
          var indexedIterable = isIterable(entry);
          return fn(
            indexedIterable ? entry.get(1) : entry[1],
            indexedIterable ? entry.get(0) : entry[0],
            this$0
          );
        }
      }, reverse);
    };

    FromEntriesSequence.prototype.__iterator = function(type, reverse) {
      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
      return new Iterator(function()  {
        while (true) {
          var step = iterator.next();
          if (step.done) {
            return step;
          }
          var entry = step.value;
          // Check if entry exists first so array access doesn't throw for holes
          // in the parent iteration.
          if (entry) {
            validateEntry(entry);
            var indexedIterable = isIterable(entry);
            return iteratorValue(
              type,
              indexedIterable ? entry.get(0) : entry[0],
              indexedIterable ? entry.get(1) : entry[1],
              step
            );
          }
        }
      });
    };


  ToIndexedSequence.prototype.cacheResult =
  ToKeyedSequence.prototype.cacheResult =
  ToSetSequence.prototype.cacheResult =
  FromEntriesSequence.prototype.cacheResult =
    cacheResultThrough;


  function flipFactory(iterable) {
    var flipSequence = makeSequence(iterable);
    flipSequence._iter = iterable;
    flipSequence.size = iterable.size;
    flipSequence.flip = function()  {return iterable};
    flipSequence.reverse = function () {
      var reversedSequence = iterable.reverse.apply(this); // super.reverse()
      reversedSequence.flip = function()  {return iterable.reverse()};
      return reversedSequence;
    };
    flipSequence.has = function(key ) {return iterable.includes(key)};
    flipSequence.includes = function(key ) {return iterable.has(key)};
    flipSequence.cacheResult = cacheResultThrough;
    flipSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
      return iterable.__iterate(function(v, k)  {return fn(k, v, this$0) !== false}, reverse);
    }
    flipSequence.__iteratorUncached = function(type, reverse) {
      if (type === ITERATE_ENTRIES) {
        var iterator = iterable.__iterator(type, reverse);
        return new Iterator(function()  {
          var step = iterator.next();
          if (!step.done) {
            var k = step.value[0];
            step.value[0] = step.value[1];
            step.value[1] = k;
          }
          return step;
        });
      }
      return iterable.__iterator(
        type === ITERATE_VALUES ? ITERATE_KEYS : ITERATE_VALUES,
        reverse
      );
    }
    return flipSequence;
  }


  function mapFactory(iterable, mapper, context) {
    var mappedSequence = makeSequence(iterable);
    mappedSequence.size = iterable.size;
    mappedSequence.has = function(key ) {return iterable.has(key)};
    mappedSequence.get = function(key, notSetValue)  {
      var v = iterable.get(key, NOT_SET);
      return v === NOT_SET ?
        notSetValue :
        mapper.call(context, v, key, iterable);
    };
    mappedSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
      return iterable.__iterate(
        function(v, k, c)  {return fn(mapper.call(context, v, k, c), k, this$0) !== false},
        reverse
      );
    }
    mappedSequence.__iteratorUncached = function (type, reverse) {
      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
      return new Iterator(function()  {
        var step = iterator.next();
        if (step.done) {
          return step;
        }
        var entry = step.value;
        var key = entry[0];
        return iteratorValue(
          type,
          key,
          mapper.call(context, entry[1], key, iterable),
          step
        );
      });
    }
    return mappedSequence;
  }


  function reverseFactory(iterable, useKeys) {
    var reversedSequence = makeSequence(iterable);
    reversedSequence._iter = iterable;
    reversedSequence.size = iterable.size;
    reversedSequence.reverse = function()  {return iterable};
    if (iterable.flip) {
      reversedSequence.flip = function () {
        var flipSequence = flipFactory(iterable);
        flipSequence.reverse = function()  {return iterable.flip()};
        return flipSequence;
      };
    }
    reversedSequence.get = function(key, notSetValue) 
      {return iterable.get(useKeys ? key : -1 - key, notSetValue)};
    reversedSequence.has = function(key )
      {return iterable.has(useKeys ? key : -1 - key)};
    reversedSequence.includes = function(value ) {return iterable.includes(value)};
    reversedSequence.cacheResult = cacheResultThrough;
    reversedSequence.__iterate = function (fn, reverse) {var this$0 = this;
      return iterable.__iterate(function(v, k)  {return fn(v, k, this$0)}, !reverse);
    };
    reversedSequence.__iterator =
      function(type, reverse)  {return iterable.__iterator(type, !reverse)};
    return reversedSequence;
  }


  function filterFactory(iterable, predicate, context, useKeys) {
    var filterSequence = makeSequence(iterable);
    if (useKeys) {
      filterSequence.has = function(key ) {
        var v = iterable.get(key, NOT_SET);
        return v !== NOT_SET && !!predicate.call(context, v, key, iterable);
      };
      filterSequence.get = function(key, notSetValue)  {
        var v = iterable.get(key, NOT_SET);
        return v !== NOT_SET && predicate.call(context, v, key, iterable) ?
          v : notSetValue;
      };
    }
    filterSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
      var iterations = 0;
      iterable.__iterate(function(v, k, c)  {
        if (predicate.call(context, v, k, c)) {
          iterations++;
          return fn(v, useKeys ? k : iterations - 1, this$0);
        }
      }, reverse);
      return iterations;
    };
    filterSequence.__iteratorUncached = function (type, reverse) {
      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
      var iterations = 0;
      return new Iterator(function()  {
        while (true) {
          var step = iterator.next();
          if (step.done) {
            return step;
          }
          var entry = step.value;
          var key = entry[0];
          var value = entry[1];
          if (predicate.call(context, value, key, iterable)) {
            return iteratorValue(type, useKeys ? key : iterations++, value, step);
          }
        }
      });
    }
    return filterSequence;
  }


  function countByFactory(iterable, grouper, context) {
    var groups = Map().asMutable();
    iterable.__iterate(function(v, k)  {
      groups.update(
        grouper.call(context, v, k, iterable),
        0,
        function(a ) {return a + 1}
      );
    });
    return groups.asImmutable();
  }


  function groupByFactory(iterable, grouper, context) {
    var isKeyedIter = isKeyed(iterable);
    var groups = (isOrdered(iterable) ? OrderedMap() : Map()).asMutable();
    iterable.__iterate(function(v, k)  {
      groups.update(
        grouper.call(context, v, k, iterable),
        function(a ) {return (a = a || [], a.push(isKeyedIter ? [k, v] : v), a)}
      );
    });
    var coerce = iterableClass(iterable);
    return groups.map(function(arr ) {return reify(iterable, coerce(arr))});
  }


  function sliceFactory(iterable, begin, end, useKeys) {
    var originalSize = iterable.size;

    // Sanitize begin & end using this shorthand for ToInt32(argument)
    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
    if (begin !== undefined) {
      begin = begin | 0;
    }
    if (end !== undefined) {
      if (end === Infinity) {
        end = originalSize;
      } else {
        end = end | 0;
      }
    }

    if (wholeSlice(begin, end, originalSize)) {
      return iterable;
    }

    var resolvedBegin = resolveBegin(begin, originalSize);
    var resolvedEnd = resolveEnd(end, originalSize);

    // begin or end will be NaN if they were provided as negative numbers and
    // this iterable's size is unknown. In that case, cache first so there is
    // a known size and these do not resolve to NaN.
    if (resolvedBegin !== resolvedBegin || resolvedEnd !== resolvedEnd) {
      return sliceFactory(iterable.toSeq().cacheResult(), begin, end, useKeys);
    }

    // Note: resolvedEnd is undefined when the original sequence's length is
    // unknown and this slice did not supply an end and should contain all
    // elements after resolvedBegin.
    // In that case, resolvedSize will be NaN and sliceSize will remain undefined.
    var resolvedSize = resolvedEnd - resolvedBegin;
    var sliceSize;
    if (resolvedSize === resolvedSize) {
      sliceSize = resolvedSize < 0 ? 0 : resolvedSize;
    }

    var sliceSeq = makeSequence(iterable);

    // If iterable.size is undefined, the size of the realized sliceSeq is
    // unknown at this point unless the number of items to slice is 0
    sliceSeq.size = sliceSize === 0 ? sliceSize : iterable.size && sliceSize || undefined;

    if (!useKeys && isSeq(iterable) && sliceSize >= 0) {
      sliceSeq.get = function (index, notSetValue) {
        index = wrapIndex(this, index);
        return index >= 0 && index < sliceSize ?
          iterable.get(index + resolvedBegin, notSetValue) :
          notSetValue;
      }
    }

    sliceSeq.__iterateUncached = function(fn, reverse) {var this$0 = this;
      if (sliceSize === 0) {
        return 0;
      }
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }
      var skipped = 0;
      var isSkipping = true;
      var iterations = 0;
      iterable.__iterate(function(v, k)  {
        if (!(isSkipping && (isSkipping = skipped++ < resolvedBegin))) {
          iterations++;
          return fn(v, useKeys ? k : iterations - 1, this$0) !== false &&
                 iterations !== sliceSize;
        }
      });
      return iterations;
    };

    sliceSeq.__iteratorUncached = function(type, reverse) {
      if (sliceSize !== 0 && reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }
      // Don't bother instantiating parent iterator if taking 0.
      var iterator = sliceSize !== 0 && iterable.__iterator(type, reverse);
      var skipped = 0;
      var iterations = 0;
      return new Iterator(function()  {
        while (skipped++ < resolvedBegin) {
          iterator.next();
        }
        if (++iterations > sliceSize) {
          return iteratorDone();
        }
        var step = iterator.next();
        if (useKeys || type === ITERATE_VALUES) {
          return step;
        } else if (type === ITERATE_KEYS) {
          return iteratorValue(type, iterations - 1, undefined, step);
        } else {
          return iteratorValue(type, iterations - 1, step.value[1], step);
        }
      });
    }

    return sliceSeq;
  }


  function takeWhileFactory(iterable, predicate, context) {
    var takeSequence = makeSequence(iterable);
    takeSequence.__iterateUncached = function(fn, reverse) {var this$0 = this;
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }
      var iterations = 0;
      iterable.__iterate(function(v, k, c) 
        {return predicate.call(context, v, k, c) && ++iterations && fn(v, k, this$0)}
      );
      return iterations;
    };
    takeSequence.__iteratorUncached = function(type, reverse) {var this$0 = this;
      if (reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }
      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
      var iterating = true;
      return new Iterator(function()  {
        if (!iterating) {
          return iteratorDone();
        }
        var step = iterator.next();
        if (step.done) {
          return step;
        }
        var entry = step.value;
        var k = entry[0];
        var v = entry[1];
        if (!predicate.call(context, v, k, this$0)) {
          iterating = false;
          return iteratorDone();
        }
        return type === ITERATE_ENTRIES ? step :
          iteratorValue(type, k, v, step);
      });
    };
    return takeSequence;
  }


  function skipWhileFactory(iterable, predicate, context, useKeys) {
    var skipSequence = makeSequence(iterable);
    skipSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }
      var isSkipping = true;
      var iterations = 0;
      iterable.__iterate(function(v, k, c)  {
        if (!(isSkipping && (isSkipping = predicate.call(context, v, k, c)))) {
          iterations++;
          return fn(v, useKeys ? k : iterations - 1, this$0);
        }
      });
      return iterations;
    };
    skipSequence.__iteratorUncached = function(type, reverse) {var this$0 = this;
      if (reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }
      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
      var skipping = true;
      var iterations = 0;
      return new Iterator(function()  {
        var step, k, v;
        do {
          step = iterator.next();
          if (step.done) {
            if (useKeys || type === ITERATE_VALUES) {
              return step;
            } else if (type === ITERATE_KEYS) {
              return iteratorValue(type, iterations++, undefined, step);
            } else {
              return iteratorValue(type, iterations++, step.value[1], step);
            }
          }
          var entry = step.value;
          k = entry[0];
          v = entry[1];
          skipping && (skipping = predicate.call(context, v, k, this$0));
        } while (skipping);
        return type === ITERATE_ENTRIES ? step :
          iteratorValue(type, k, v, step);
      });
    };
    return skipSequence;
  }


  function concatFactory(iterable, values) {
    var isKeyedIterable = isKeyed(iterable);
    var iters = [iterable].concat(values).map(function(v ) {
      if (!isIterable(v)) {
        v = isKeyedIterable ?
          keyedSeqFromValue(v) :
          indexedSeqFromValue(Array.isArray(v) ? v : [v]);
      } else if (isKeyedIterable) {
        v = KeyedIterable(v);
      }
      return v;
    }).filter(function(v ) {return v.size !== 0});

    if (iters.length === 0) {
      return iterable;
    }

    if (iters.length === 1) {
      var singleton = iters[0];
      if (singleton === iterable ||
          isKeyedIterable && isKeyed(singleton) ||
          isIndexed(iterable) && isIndexed(singleton)) {
        return singleton;
      }
    }

    var concatSeq = new ArraySeq(iters);
    if (isKeyedIterable) {
      concatSeq = concatSeq.toKeyedSeq();
    } else if (!isIndexed(iterable)) {
      concatSeq = concatSeq.toSetSeq();
    }
    concatSeq = concatSeq.flatten(true);
    concatSeq.size = iters.reduce(
      function(sum, seq)  {
        if (sum !== undefined) {
          var size = seq.size;
          if (size !== undefined) {
            return sum + size;
          }
        }
      },
      0
    );
    return concatSeq;
  }


  function flattenFactory(iterable, depth, useKeys) {
    var flatSequence = makeSequence(iterable);
    flatSequence.__iterateUncached = function(fn, reverse) {
      var iterations = 0;
      var stopped = false;
      function flatDeep(iter, currentDepth) {var this$0 = this;
        iter.__iterate(function(v, k)  {
          if ((!depth || currentDepth < depth) && isIterable(v)) {
            flatDeep(v, currentDepth + 1);
          } else if (fn(v, useKeys ? k : iterations++, this$0) === false) {
            stopped = true;
          }
          return !stopped;
        }, reverse);
      }
      flatDeep(iterable, 0);
      return iterations;
    }
    flatSequence.__iteratorUncached = function(type, reverse) {
      var iterator = iterable.__iterator(type, reverse);
      var stack = [];
      var iterations = 0;
      return new Iterator(function()  {
        while (iterator) {
          var step = iterator.next();
          if (step.done !== false) {
            iterator = stack.pop();
            continue;
          }
          var v = step.value;
          if (type === ITERATE_ENTRIES) {
            v = v[1];
          }
          if ((!depth || stack.length < depth) && isIterable(v)) {
            stack.push(iterator);
            iterator = v.__iterator(type, reverse);
          } else {
            return useKeys ? step : iteratorValue(type, iterations++, v, step);
          }
        }
        return iteratorDone();
      });
    }
    return flatSequence;
  }


  function flatMapFactory(iterable, mapper, context) {
    var coerce = iterableClass(iterable);
    return iterable.toSeq().map(
      function(v, k)  {return coerce(mapper.call(context, v, k, iterable))}
    ).flatten(true);
  }


  function interposeFactory(iterable, separator) {
    var interposedSequence = makeSequence(iterable);
    interposedSequence.size = iterable.size && iterable.size * 2 -1;
    interposedSequence.__iterateUncached = function(fn, reverse) {var this$0 = this;
      var iterations = 0;
      iterable.__iterate(function(v, k) 
        {return (!iterations || fn(separator, iterations++, this$0) !== false) &&
        fn(v, iterations++, this$0) !== false},
        reverse
      );
      return iterations;
    };
    interposedSequence.__iteratorUncached = function(type, reverse) {
      var iterator = iterable.__iterator(ITERATE_VALUES, reverse);
      var iterations = 0;
      var step;
      return new Iterator(function()  {
        if (!step || iterations % 2) {
          step = iterator.next();
          if (step.done) {
            return step;
          }
        }
        return iterations % 2 ?
          iteratorValue(type, iterations++, separator) :
          iteratorValue(type, iterations++, step.value, step);
      });
    };
    return interposedSequence;
  }


  function sortFactory(iterable, comparator, mapper) {
    if (!comparator) {
      comparator = defaultComparator;
    }
    var isKeyedIterable = isKeyed(iterable);
    var index = 0;
    var entries = iterable.toSeq().map(
      function(v, k)  {return [k, v, index++, mapper ? mapper(v, k, iterable) : v]}
    ).toArray();
    entries.sort(function(a, b)  {return comparator(a[3], b[3]) || a[2] - b[2]}).forEach(
      isKeyedIterable ?
      function(v, i)  { entries[i].length = 2; } :
      function(v, i)  { entries[i] = v[1]; }
    );
    return isKeyedIterable ? KeyedSeq(entries) :
      isIndexed(iterable) ? IndexedSeq(entries) :
      SetSeq(entries);
  }


  function maxFactory(iterable, comparator, mapper) {
    if (!comparator) {
      comparator = defaultComparator;
    }
    if (mapper) {
      var entry = iterable.toSeq()
        .map(function(v, k)  {return [v, mapper(v, k, iterable)]})
        .reduce(function(a, b)  {return maxCompare(comparator, a[1], b[1]) ? b : a});
      return entry && entry[0];
    } else {
      return iterable.reduce(function(a, b)  {return maxCompare(comparator, a, b) ? b : a});
    }
  }

  function maxCompare(comparator, a, b) {
    var comp = comparator(b, a);
    // b is considered the new max if the comparator declares them equal, but
    // they are not equal and b is in fact a nullish value.
    return (comp === 0 && b !== a && (b === undefined || b === null || b !== b)) || comp > 0;
  }


  function zipWithFactory(keyIter, zipper, iters) {
    var zipSequence = makeSequence(keyIter);
    zipSequence.size = new ArraySeq(iters).map(function(i ) {return i.size}).min();
    // Note: this a generic base implementation of __iterate in terms of
    // __iterator which may be more generically useful in the future.
    zipSequence.__iterate = function(fn, reverse) {
      /* generic:
      var iterator = this.__iterator(ITERATE_ENTRIES, reverse);
      var step;
      var iterations = 0;
      while (!(step = iterator.next()).done) {
        iterations++;
        if (fn(step.value[1], step.value[0], this) === false) {
          break;
        }
      }
      return iterations;
      */
      // indexed:
      var iterator = this.__iterator(ITERATE_VALUES, reverse);
      var step;
      var iterations = 0;
      while (!(step = iterator.next()).done) {
        if (fn(step.value, iterations++, this) === false) {
          break;
        }
      }
      return iterations;
    };
    zipSequence.__iteratorUncached = function(type, reverse) {
      var iterators = iters.map(function(i )
        {return (i = Iterable(i), getIterator(reverse ? i.reverse() : i))}
      );
      var iterations = 0;
      var isDone = false;
      return new Iterator(function()  {
        var steps;
        if (!isDone) {
          steps = iterators.map(function(i ) {return i.next()});
          isDone = steps.some(function(s ) {return s.done});
        }
        if (isDone) {
          return iteratorDone();
        }
        return iteratorValue(
          type,
          iterations++,
          zipper.apply(null, steps.map(function(s ) {return s.value}))
        );
      });
    };
    return zipSequence
  }


  // #pragma Helper Functions

  function reify(iter, seq) {
    return isSeq(iter) ? seq : iter.constructor(seq);
  }

  function validateEntry(entry) {
    if (entry !== Object(entry)) {
      throw new TypeError('Expected [K, V] tuple: ' + entry);
    }
  }

  function resolveSize(iter) {
    assertNotInfinite(iter.size);
    return ensureSize(iter);
  }

  function iterableClass(iterable) {
    return isKeyed(iterable) ? KeyedIterable :
      isIndexed(iterable) ? IndexedIterable :
      SetIterable;
  }

  function makeSequence(iterable) {
    return Object.create(
      (
        isKeyed(iterable) ? KeyedSeq :
        isIndexed(iterable) ? IndexedSeq :
        SetSeq
      ).prototype
    );
  }

  function cacheResultThrough() {
    if (this._iter.cacheResult) {
      this._iter.cacheResult();
      this.size = this._iter.size;
      return this;
    } else {
      return Seq.prototype.cacheResult.call(this);
    }
  }

  function defaultComparator(a, b) {
    return a > b ? 1 : a < b ? -1 : 0;
  }

  function forceIterator(keyPath) {
    var iter = getIterator(keyPath);
    if (!iter) {
      // Array might not be iterable in this environment, so we need a fallback
      // to our wrapped type.
      if (!isArrayLike(keyPath)) {
        throw new TypeError('Expected iterable or array-like: ' + keyPath);
      }
      iter = getIterator(Iterable(keyPath));
    }
    return iter;
  }

  createClass(Record, KeyedCollection);

    function Record(defaultValues, name) {
      var hasInitialized;

      var RecordType = function Record(values) {
        if (values instanceof RecordType) {
          return values;
        }
        if (!(this instanceof RecordType)) {
          return new RecordType(values);
        }
        if (!hasInitialized) {
          hasInitialized = true;
          var keys = Object.keys(defaultValues);
          setProps(RecordTypePrototype, keys);
          RecordTypePrototype.size = keys.length;
          RecordTypePrototype._name = name;
          RecordTypePrototype._keys = keys;
          RecordTypePrototype._defaultValues = defaultValues;
        }
        this._map = Map(values);
      };

      var RecordTypePrototype = RecordType.prototype = Object.create(RecordPrototype);
      RecordTypePrototype.constructor = RecordType;

      return RecordType;
    }

    Record.prototype.toString = function() {
      return this.__toString(recordName(this) + ' {', '}');
    };

    // @pragma Access

    Record.prototype.has = function(k) {
      return this._defaultValues.hasOwnProperty(k);
    };

    Record.prototype.get = function(k, notSetValue) {
      if (!this.has(k)) {
        return notSetValue;
      }
      var defaultVal = this._defaultValues[k];
      return this._map ? this._map.get(k, defaultVal) : defaultVal;
    };

    // @pragma Modification

    Record.prototype.clear = function() {
      if (this.__ownerID) {
        this._map && this._map.clear();
        return this;
      }
      var RecordType = this.constructor;
      return RecordType._empty || (RecordType._empty = makeRecord(this, emptyMap()));
    };

    Record.prototype.set = function(k, v) {
      if (!this.has(k)) {
        throw new Error('Cannot set unknown key "' + k + '" on ' + recordName(this));
      }
      if (this._map && !this._map.has(k)) {
        var defaultVal = this._defaultValues[k];
        if (v === defaultVal) {
          return this;
        }
      }
      var newMap = this._map && this._map.set(k, v);
      if (this.__ownerID || newMap === this._map) {
        return this;
      }
      return makeRecord(this, newMap);
    };

    Record.prototype.remove = function(k) {
      if (!this.has(k)) {
        return this;
      }
      var newMap = this._map && this._map.remove(k);
      if (this.__ownerID || newMap === this._map) {
        return this;
      }
      return makeRecord(this, newMap);
    };

    Record.prototype.wasAltered = function() {
      return this._map.wasAltered();
    };

    Record.prototype.__iterator = function(type, reverse) {var this$0 = this;
      return KeyedIterable(this._defaultValues).map(function(_, k)  {return this$0.get(k)}).__iterator(type, reverse);
    };

    Record.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      return KeyedIterable(this._defaultValues).map(function(_, k)  {return this$0.get(k)}).__iterate(fn, reverse);
    };

    Record.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      var newMap = this._map && this._map.__ensureOwner(ownerID);
      if (!ownerID) {
        this.__ownerID = ownerID;
        this._map = newMap;
        return this;
      }
      return makeRecord(this, newMap, ownerID);
    };


  var RecordPrototype = Record.prototype;
  RecordPrototype[DELETE] = RecordPrototype.remove;
  RecordPrototype.deleteIn =
  RecordPrototype.removeIn = MapPrototype.removeIn;
  RecordPrototype.merge = MapPrototype.merge;
  RecordPrototype.mergeWith = MapPrototype.mergeWith;
  RecordPrototype.mergeIn = MapPrototype.mergeIn;
  RecordPrototype.mergeDeep = MapPrototype.mergeDeep;
  RecordPrototype.mergeDeepWith = MapPrototype.mergeDeepWith;
  RecordPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
  RecordPrototype.setIn = MapPrototype.setIn;
  RecordPrototype.update = MapPrototype.update;
  RecordPrototype.updateIn = MapPrototype.updateIn;
  RecordPrototype.withMutations = MapPrototype.withMutations;
  RecordPrototype.asMutable = MapPrototype.asMutable;
  RecordPrototype.asImmutable = MapPrototype.asImmutable;


  function makeRecord(likeRecord, map, ownerID) {
    var record = Object.create(Object.getPrototypeOf(likeRecord));
    record._map = map;
    record.__ownerID = ownerID;
    return record;
  }

  function recordName(record) {
    return record._name || record.constructor.name || 'Record';
  }

  function setProps(prototype, names) {
    try {
      names.forEach(setProp.bind(undefined, prototype));
    } catch (error) {
      // Object.defineProperty failed. Probably IE8.
    }
  }

  function setProp(prototype, name) {
    Object.defineProperty(prototype, name, {
      get: function() {
        return this.get(name);
      },
      set: function(value) {
        invariant(this.__ownerID, 'Cannot set on an immutable record.');
        this.set(name, value);
      }
    });
  }

  createClass(Set, SetCollection);

    // @pragma Construction

    function Set(value) {
      return value === null || value === undefined ? emptySet() :
        isSet(value) && !isOrdered(value) ? value :
        emptySet().withMutations(function(set ) {
          var iter = SetIterable(value);
          assertNotInfinite(iter.size);
          iter.forEach(function(v ) {return set.add(v)});
        });
    }

    Set.of = function(/*...values*/) {
      return this(arguments);
    };

    Set.fromKeys = function(value) {
      return this(KeyedIterable(value).keySeq());
    };

    Set.prototype.toString = function() {
      return this.__toString('Set {', '}');
    };

    // @pragma Access

    Set.prototype.has = function(value) {
      return this._map.has(value);
    };

    // @pragma Modification

    Set.prototype.add = function(value) {
      return updateSet(this, this._map.set(value, true));
    };

    Set.prototype.remove = function(value) {
      return updateSet(this, this._map.remove(value));
    };

    Set.prototype.clear = function() {
      return updateSet(this, this._map.clear());
    };

    // @pragma Composition

    Set.prototype.union = function() {var iters = SLICE$0.call(arguments, 0);
      iters = iters.filter(function(x ) {return x.size !== 0});
      if (iters.length === 0) {
        return this;
      }
      if (this.size === 0 && !this.__ownerID && iters.length === 1) {
        return this.constructor(iters[0]);
      }
      return this.withMutations(function(set ) {
        for (var ii = 0; ii < iters.length; ii++) {
          SetIterable(iters[ii]).forEach(function(value ) {return set.add(value)});
        }
      });
    };

    Set.prototype.intersect = function() {var iters = SLICE$0.call(arguments, 0);
      if (iters.length === 0) {
        return this;
      }
      iters = iters.map(function(iter ) {return SetIterable(iter)});
      var originalSet = this;
      return this.withMutations(function(set ) {
        originalSet.forEach(function(value ) {
          if (!iters.every(function(iter ) {return iter.includes(value)})) {
            set.remove(value);
          }
        });
      });
    };

    Set.prototype.subtract = function() {var iters = SLICE$0.call(arguments, 0);
      if (iters.length === 0) {
        return this;
      }
      iters = iters.map(function(iter ) {return SetIterable(iter)});
      var originalSet = this;
      return this.withMutations(function(set ) {
        originalSet.forEach(function(value ) {
          if (iters.some(function(iter ) {return iter.includes(value)})) {
            set.remove(value);
          }
        });
      });
    };

    Set.prototype.merge = function() {
      return this.union.apply(this, arguments);
    };

    Set.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
      return this.union.apply(this, iters);
    };

    Set.prototype.sort = function(comparator) {
      // Late binding
      return OrderedSet(sortFactory(this, comparator));
    };

    Set.prototype.sortBy = function(mapper, comparator) {
      // Late binding
      return OrderedSet(sortFactory(this, comparator, mapper));
    };

    Set.prototype.wasAltered = function() {
      return this._map.wasAltered();
    };

    Set.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      return this._map.__iterate(function(_, k)  {return fn(k, k, this$0)}, reverse);
    };

    Set.prototype.__iterator = function(type, reverse) {
      return this._map.map(function(_, k)  {return k}).__iterator(type, reverse);
    };

    Set.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      var newMap = this._map.__ensureOwner(ownerID);
      if (!ownerID) {
        this.__ownerID = ownerID;
        this._map = newMap;
        return this;
      }
      return this.__make(newMap, ownerID);
    };


  function isSet(maybeSet) {
    return !!(maybeSet && maybeSet[IS_SET_SENTINEL]);
  }

  Set.isSet = isSet;

  var IS_SET_SENTINEL = '@@__IMMUTABLE_SET__@@';

  var SetPrototype = Set.prototype;
  SetPrototype[IS_SET_SENTINEL] = true;
  SetPrototype[DELETE] = SetPrototype.remove;
  SetPrototype.mergeDeep = SetPrototype.merge;
  SetPrototype.mergeDeepWith = SetPrototype.mergeWith;
  SetPrototype.withMutations = MapPrototype.withMutations;
  SetPrototype.asMutable = MapPrototype.asMutable;
  SetPrototype.asImmutable = MapPrototype.asImmutable;

  SetPrototype.__empty = emptySet;
  SetPrototype.__make = makeSet;

  function updateSet(set, newMap) {
    if (set.__ownerID) {
      set.size = newMap.size;
      set._map = newMap;
      return set;
    }
    return newMap === set._map ? set :
      newMap.size === 0 ? set.__empty() :
      set.__make(newMap);
  }

  function makeSet(map, ownerID) {
    var set = Object.create(SetPrototype);
    set.size = map ? map.size : 0;
    set._map = map;
    set.__ownerID = ownerID;
    return set;
  }

  var EMPTY_SET;
  function emptySet() {
    return EMPTY_SET || (EMPTY_SET = makeSet(emptyMap()));
  }

  createClass(OrderedSet, Set);

    // @pragma Construction

    function OrderedSet(value) {
      return value === null || value === undefined ? emptyOrderedSet() :
        isOrderedSet(value) ? value :
        emptyOrderedSet().withMutations(function(set ) {
          var iter = SetIterable(value);
          assertNotInfinite(iter.size);
          iter.forEach(function(v ) {return set.add(v)});
        });
    }

    OrderedSet.of = function(/*...values*/) {
      return this(arguments);
    };

    OrderedSet.fromKeys = function(value) {
      return this(KeyedIterable(value).keySeq());
    };

    OrderedSet.prototype.toString = function() {
      return this.__toString('OrderedSet {', '}');
    };


  function isOrderedSet(maybeOrderedSet) {
    return isSet(maybeOrderedSet) && isOrdered(maybeOrderedSet);
  }

  OrderedSet.isOrderedSet = isOrderedSet;

  var OrderedSetPrototype = OrderedSet.prototype;
  OrderedSetPrototype[IS_ORDERED_SENTINEL] = true;

  OrderedSetPrototype.__empty = emptyOrderedSet;
  OrderedSetPrototype.__make = makeOrderedSet;

  function makeOrderedSet(map, ownerID) {
    var set = Object.create(OrderedSetPrototype);
    set.size = map ? map.size : 0;
    set._map = map;
    set.__ownerID = ownerID;
    return set;
  }

  var EMPTY_ORDERED_SET;
  function emptyOrderedSet() {
    return EMPTY_ORDERED_SET || (EMPTY_ORDERED_SET = makeOrderedSet(emptyOrderedMap()));
  }

  createClass(Stack, IndexedCollection);

    // @pragma Construction

    function Stack(value) {
      return value === null || value === undefined ? emptyStack() :
        isStack(value) ? value :
        emptyStack().unshiftAll(value);
    }

    Stack.of = function(/*...values*/) {
      return this(arguments);
    };

    Stack.prototype.toString = function() {
      return this.__toString('Stack [', ']');
    };

    // @pragma Access

    Stack.prototype.get = function(index, notSetValue) {
      var head = this._head;
      index = wrapIndex(this, index);
      while (head && index--) {
        head = head.next;
      }
      return head ? head.value : notSetValue;
    };

    Stack.prototype.peek = function() {
      return this._head && this._head.value;
    };

    // @pragma Modification

    Stack.prototype.push = function(/*...values*/) {
      if (arguments.length === 0) {
        return this;
      }
      var newSize = this.size + arguments.length;
      var head = this._head;
      for (var ii = arguments.length - 1; ii >= 0; ii--) {
        head = {
          value: arguments[ii],
          next: head
        };
      }
      if (this.__ownerID) {
        this.size = newSize;
        this._head = head;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return makeStack(newSize, head);
    };

    Stack.prototype.pushAll = function(iter) {
      iter = IndexedIterable(iter);
      if (iter.size === 0) {
        return this;
      }
      assertNotInfinite(iter.size);
      var newSize = this.size;
      var head = this._head;
      iter.reverse().forEach(function(value ) {
        newSize++;
        head = {
          value: value,
          next: head
        };
      });
      if (this.__ownerID) {
        this.size = newSize;
        this._head = head;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return makeStack(newSize, head);
    };

    Stack.prototype.pop = function() {
      return this.slice(1);
    };

    Stack.prototype.unshift = function(/*...values*/) {
      return this.push.apply(this, arguments);
    };

    Stack.prototype.unshiftAll = function(iter) {
      return this.pushAll(iter);
    };

    Stack.prototype.shift = function() {
      return this.pop.apply(this, arguments);
    };

    Stack.prototype.clear = function() {
      if (this.size === 0) {
        return this;
      }
      if (this.__ownerID) {
        this.size = 0;
        this._head = undefined;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return emptyStack();
    };

    Stack.prototype.slice = function(begin, end) {
      if (wholeSlice(begin, end, this.size)) {
        return this;
      }
      var resolvedBegin = resolveBegin(begin, this.size);
      var resolvedEnd = resolveEnd(end, this.size);
      if (resolvedEnd !== this.size) {
        // super.slice(begin, end);
        return IndexedCollection.prototype.slice.call(this, begin, end);
      }
      var newSize = this.size - resolvedBegin;
      var head = this._head;
      while (resolvedBegin--) {
        head = head.next;
      }
      if (this.__ownerID) {
        this.size = newSize;
        this._head = head;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return makeStack(newSize, head);
    };

    // @pragma Mutability

    Stack.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      if (!ownerID) {
        this.__ownerID = ownerID;
        this.__altered = false;
        return this;
      }
      return makeStack(this.size, this._head, ownerID, this.__hash);
    };

    // @pragma Iteration

    Stack.prototype.__iterate = function(fn, reverse) {
      if (reverse) {
        return this.reverse().__iterate(fn);
      }
      var iterations = 0;
      var node = this._head;
      while (node) {
        if (fn(node.value, iterations++, this) === false) {
          break;
        }
        node = node.next;
      }
      return iterations;
    };

    Stack.prototype.__iterator = function(type, reverse) {
      if (reverse) {
        return this.reverse().__iterator(type);
      }
      var iterations = 0;
      var node = this._head;
      return new Iterator(function()  {
        if (node) {
          var value = node.value;
          node = node.next;
          return iteratorValue(type, iterations++, value);
        }
        return iteratorDone();
      });
    };


  function isStack(maybeStack) {
    return !!(maybeStack && maybeStack[IS_STACK_SENTINEL]);
  }

  Stack.isStack = isStack;

  var IS_STACK_SENTINEL = '@@__IMMUTABLE_STACK__@@';

  var StackPrototype = Stack.prototype;
  StackPrototype[IS_STACK_SENTINEL] = true;
  StackPrototype.withMutations = MapPrototype.withMutations;
  StackPrototype.asMutable = MapPrototype.asMutable;
  StackPrototype.asImmutable = MapPrototype.asImmutable;
  StackPrototype.wasAltered = MapPrototype.wasAltered;


  function makeStack(size, head, ownerID, hash) {
    var map = Object.create(StackPrototype);
    map.size = size;
    map._head = head;
    map.__ownerID = ownerID;
    map.__hash = hash;
    map.__altered = false;
    return map;
  }

  var EMPTY_STACK;
  function emptyStack() {
    return EMPTY_STACK || (EMPTY_STACK = makeStack(0));
  }

  /**
   * Contributes additional methods to a constructor
   */
  function mixin(ctor, methods) {
    var keyCopier = function(key ) { ctor.prototype[key] = methods[key]; };
    Object.keys(methods).forEach(keyCopier);
    Object.getOwnPropertySymbols &&
      Object.getOwnPropertySymbols(methods).forEach(keyCopier);
    return ctor;
  }

  Iterable.Iterator = Iterator;

  mixin(Iterable, {

    // ### Conversion to other types

    toArray: function() {
      assertNotInfinite(this.size);
      var array = new Array(this.size || 0);
      this.valueSeq().__iterate(function(v, i)  { array[i] = v; });
      return array;
    },

    toIndexedSeq: function() {
      return new ToIndexedSequence(this);
    },

    toJS: function() {
      return this.toSeq().map(
        function(value ) {return value && typeof value.toJS === 'function' ? value.toJS() : value}
      ).__toJS();
    },

    toJSON: function() {
      return this.toSeq().map(
        function(value ) {return value && typeof value.toJSON === 'function' ? value.toJSON() : value}
      ).__toJS();
    },

    toKeyedSeq: function() {
      return new ToKeyedSequence(this, true);
    },

    toMap: function() {
      // Use Late Binding here to solve the circular dependency.
      return Map(this.toKeyedSeq());
    },

    toObject: function() {
      assertNotInfinite(this.size);
      var object = {};
      this.__iterate(function(v, k)  { object[k] = v; });
      return object;
    },

    toOrderedMap: function() {
      // Use Late Binding here to solve the circular dependency.
      return OrderedMap(this.toKeyedSeq());
    },

    toOrderedSet: function() {
      // Use Late Binding here to solve the circular dependency.
      return OrderedSet(isKeyed(this) ? this.valueSeq() : this);
    },

    toSet: function() {
      // Use Late Binding here to solve the circular dependency.
      return Set(isKeyed(this) ? this.valueSeq() : this);
    },

    toSetSeq: function() {
      return new ToSetSequence(this);
    },

    toSeq: function() {
      return isIndexed(this) ? this.toIndexedSeq() :
        isKeyed(this) ? this.toKeyedSeq() :
        this.toSetSeq();
    },

    toStack: function() {
      // Use Late Binding here to solve the circular dependency.
      return Stack(isKeyed(this) ? this.valueSeq() : this);
    },

    toList: function() {
      // Use Late Binding here to solve the circular dependency.
      return List(isKeyed(this) ? this.valueSeq() : this);
    },


    // ### Common JavaScript methods and properties

    toString: function() {
      return '[Iterable]';
    },

    __toString: function(head, tail) {
      if (this.size === 0) {
        return head + tail;
      }
      return head + ' ' + this.toSeq().map(this.__toStringMapper).join(', ') + ' ' + tail;
    },


    // ### ES6 Collection methods (ES6 Array and Map)

    concat: function() {var values = SLICE$0.call(arguments, 0);
      return reify(this, concatFactory(this, values));
    },

    includes: function(searchValue) {
      return this.some(function(value ) {return is(value, searchValue)});
    },

    entries: function() {
      return this.__iterator(ITERATE_ENTRIES);
    },

    every: function(predicate, context) {
      assertNotInfinite(this.size);
      var returnValue = true;
      this.__iterate(function(v, k, c)  {
        if (!predicate.call(context, v, k, c)) {
          returnValue = false;
          return false;
        }
      });
      return returnValue;
    },

    filter: function(predicate, context) {
      return reify(this, filterFactory(this, predicate, context, true));
    },

    find: function(predicate, context, notSetValue) {
      var entry = this.findEntry(predicate, context);
      return entry ? entry[1] : notSetValue;
    },

    forEach: function(sideEffect, context) {
      assertNotInfinite(this.size);
      return this.__iterate(context ? sideEffect.bind(context) : sideEffect);
    },

    join: function(separator) {
      assertNotInfinite(this.size);
      separator = separator !== undefined ? '' + separator : ',';
      var joined = '';
      var isFirst = true;
      this.__iterate(function(v ) {
        isFirst ? (isFirst = false) : (joined += separator);
        joined += v !== null && v !== undefined ? v.toString() : '';
      });
      return joined;
    },

    keys: function() {
      return this.__iterator(ITERATE_KEYS);
    },

    map: function(mapper, context) {
      return reify(this, mapFactory(this, mapper, context));
    },

    reduce: function(reducer, initialReduction, context) {
      assertNotInfinite(this.size);
      var reduction;
      var useFirst;
      if (arguments.length < 2) {
        useFirst = true;
      } else {
        reduction = initialReduction;
      }
      this.__iterate(function(v, k, c)  {
        if (useFirst) {
          useFirst = false;
          reduction = v;
        } else {
          reduction = reducer.call(context, reduction, v, k, c);
        }
      });
      return reduction;
    },

    reduceRight: function(reducer, initialReduction, context) {
      var reversed = this.toKeyedSeq().reverse();
      return reversed.reduce.apply(reversed, arguments);
    },

    reverse: function() {
      return reify(this, reverseFactory(this, true));
    },

    slice: function(begin, end) {
      return reify(this, sliceFactory(this, begin, end, true));
    },

    some: function(predicate, context) {
      return !this.every(not(predicate), context);
    },

    sort: function(comparator) {
      return reify(this, sortFactory(this, comparator));
    },

    values: function() {
      return this.__iterator(ITERATE_VALUES);
    },


    // ### More sequential methods

    butLast: function() {
      return this.slice(0, -1);
    },

    isEmpty: function() {
      return this.size !== undefined ? this.size === 0 : !this.some(function()  {return true});
    },

    count: function(predicate, context) {
      return ensureSize(
        predicate ? this.toSeq().filter(predicate, context) : this
      );
    },

    countBy: function(grouper, context) {
      return countByFactory(this, grouper, context);
    },

    equals: function(other) {
      return deepEqual(this, other);
    },

    entrySeq: function() {
      var iterable = this;
      if (iterable._cache) {
        // We cache as an entries array, so we can just return the cache!
        return new ArraySeq(iterable._cache);
      }
      var entriesSequence = iterable.toSeq().map(entryMapper).toIndexedSeq();
      entriesSequence.fromEntrySeq = function()  {return iterable.toSeq()};
      return entriesSequence;
    },

    filterNot: function(predicate, context) {
      return this.filter(not(predicate), context);
    },

    findEntry: function(predicate, context, notSetValue) {
      var found = notSetValue;
      this.__iterate(function(v, k, c)  {
        if (predicate.call(context, v, k, c)) {
          found = [k, v];
          return false;
        }
      });
      return found;
    },

    findKey: function(predicate, context) {
      var entry = this.findEntry(predicate, context);
      return entry && entry[0];
    },

    findLast: function(predicate, context, notSetValue) {
      return this.toKeyedSeq().reverse().find(predicate, context, notSetValue);
    },

    findLastEntry: function(predicate, context, notSetValue) {
      return this.toKeyedSeq().reverse().findEntry(predicate, context, notSetValue);
    },

    findLastKey: function(predicate, context) {
      return this.toKeyedSeq().reverse().findKey(predicate, context);
    },

    first: function() {
      return this.find(returnTrue);
    },

    flatMap: function(mapper, context) {
      return reify(this, flatMapFactory(this, mapper, context));
    },

    flatten: function(depth) {
      return reify(this, flattenFactory(this, depth, true));
    },

    fromEntrySeq: function() {
      return new FromEntriesSequence(this);
    },

    get: function(searchKey, notSetValue) {
      return this.find(function(_, key)  {return is(key, searchKey)}, undefined, notSetValue);
    },

    getIn: function(searchKeyPath, notSetValue) {
      var nested = this;
      // Note: in an ES6 environment, we would prefer:
      // for (var key of searchKeyPath) {
      var iter = forceIterator(searchKeyPath);
      var step;
      while (!(step = iter.next()).done) {
        var key = step.value;
        nested = nested && nested.get ? nested.get(key, NOT_SET) : NOT_SET;
        if (nested === NOT_SET) {
          return notSetValue;
        }
      }
      return nested;
    },

    groupBy: function(grouper, context) {
      return groupByFactory(this, grouper, context);
    },

    has: function(searchKey) {
      return this.get(searchKey, NOT_SET) !== NOT_SET;
    },

    hasIn: function(searchKeyPath) {
      return this.getIn(searchKeyPath, NOT_SET) !== NOT_SET;
    },

    isSubset: function(iter) {
      iter = typeof iter.includes === 'function' ? iter : Iterable(iter);
      return this.every(function(value ) {return iter.includes(value)});
    },

    isSuperset: function(iter) {
      iter = typeof iter.isSubset === 'function' ? iter : Iterable(iter);
      return iter.isSubset(this);
    },

    keyOf: function(searchValue) {
      return this.findKey(function(value ) {return is(value, searchValue)});
    },

    keySeq: function() {
      return this.toSeq().map(keyMapper).toIndexedSeq();
    },

    last: function() {
      return this.toSeq().reverse().first();
    },

    lastKeyOf: function(searchValue) {
      return this.toKeyedSeq().reverse().keyOf(searchValue);
    },

    max: function(comparator) {
      return maxFactory(this, comparator);
    },

    maxBy: function(mapper, comparator) {
      return maxFactory(this, comparator, mapper);
    },

    min: function(comparator) {
      return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator);
    },

    minBy: function(mapper, comparator) {
      return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator, mapper);
    },

    rest: function() {
      return this.slice(1);
    },

    skip: function(amount) {
      return this.slice(Math.max(0, amount));
    },

    skipLast: function(amount) {
      return reify(this, this.toSeq().reverse().skip(amount).reverse());
    },

    skipWhile: function(predicate, context) {
      return reify(this, skipWhileFactory(this, predicate, context, true));
    },

    skipUntil: function(predicate, context) {
      return this.skipWhile(not(predicate), context);
    },

    sortBy: function(mapper, comparator) {
      return reify(this, sortFactory(this, comparator, mapper));
    },

    take: function(amount) {
      return this.slice(0, Math.max(0, amount));
    },

    takeLast: function(amount) {
      return reify(this, this.toSeq().reverse().take(amount).reverse());
    },

    takeWhile: function(predicate, context) {
      return reify(this, takeWhileFactory(this, predicate, context));
    },

    takeUntil: function(predicate, context) {
      return this.takeWhile(not(predicate), context);
    },

    valueSeq: function() {
      return this.toIndexedSeq();
    },


    // ### Hashable Object

    hashCode: function() {
      return this.__hash || (this.__hash = hashIterable(this));
    }


    // ### Internal

    // abstract __iterate(fn, reverse)

    // abstract __iterator(type, reverse)
  });

  // var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
  // var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
  // var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
  // var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';

  var IterablePrototype = Iterable.prototype;
  IterablePrototype[IS_ITERABLE_SENTINEL] = true;
  IterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.values;
  IterablePrototype.__toJS = IterablePrototype.toArray;
  IterablePrototype.__toStringMapper = quoteString;
  IterablePrototype.inspect =
  IterablePrototype.toSource = function() { return this.toString(); };
  IterablePrototype.chain = IterablePrototype.flatMap;
  IterablePrototype.contains = IterablePrototype.includes;

  mixin(KeyedIterable, {

    // ### More sequential methods

    flip: function() {
      return reify(this, flipFactory(this));
    },

    mapEntries: function(mapper, context) {var this$0 = this;
      var iterations = 0;
      return reify(this,
        this.toSeq().map(
          function(v, k)  {return mapper.call(context, [k, v], iterations++, this$0)}
        ).fromEntrySeq()
      );
    },

    mapKeys: function(mapper, context) {var this$0 = this;
      return reify(this,
        this.toSeq().flip().map(
          function(k, v)  {return mapper.call(context, k, v, this$0)}
        ).flip()
      );
    }

  });

  var KeyedIterablePrototype = KeyedIterable.prototype;
  KeyedIterablePrototype[IS_KEYED_SENTINEL] = true;
  KeyedIterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.entries;
  KeyedIterablePrototype.__toJS = IterablePrototype.toObject;
  KeyedIterablePrototype.__toStringMapper = function(v, k)  {return JSON.stringify(k) + ': ' + quoteString(v)};



  mixin(IndexedIterable, {

    // ### Conversion to other types

    toKeyedSeq: function() {
      return new ToKeyedSequence(this, false);
    },


    // ### ES6 Collection methods (ES6 Array and Map)

    filter: function(predicate, context) {
      return reify(this, filterFactory(this, predicate, context, false));
    },

    findIndex: function(predicate, context) {
      var entry = this.findEntry(predicate, context);
      return entry ? entry[0] : -1;
    },

    indexOf: function(searchValue) {
      var key = this.keyOf(searchValue);
      return key === undefined ? -1 : key;
    },

    lastIndexOf: function(searchValue) {
      var key = this.lastKeyOf(searchValue);
      return key === undefined ? -1 : key;
    },

    reverse: function() {
      return reify(this, reverseFactory(this, false));
    },

    slice: function(begin, end) {
      return reify(this, sliceFactory(this, begin, end, false));
    },

    splice: function(index, removeNum /*, ...values*/) {
      var numArgs = arguments.length;
      removeNum = Math.max(removeNum | 0, 0);
      if (numArgs === 0 || (numArgs === 2 && !removeNum)) {
        return this;
      }
      // If index is negative, it should resolve relative to the size of the
      // collection. However size may be expensive to compute if not cached, so
      // only call count() if the number is in fact negative.
      index = resolveBegin(index, index < 0 ? this.count() : this.size);
      var spliced = this.slice(0, index);
      return reify(
        this,
        numArgs === 1 ?
          spliced :
          spliced.concat(arrCopy(arguments, 2), this.slice(index + removeNum))
      );
    },


    // ### More collection methods

    findLastIndex: function(predicate, context) {
      var entry = this.findLastEntry(predicate, context);
      return entry ? entry[0] : -1;
    },

    first: function() {
      return this.get(0);
    },

    flatten: function(depth) {
      return reify(this, flattenFactory(this, depth, false));
    },

    get: function(index, notSetValue) {
      index = wrapIndex(this, index);
      return (index < 0 || (this.size === Infinity ||
          (this.size !== undefined && index > this.size))) ?
        notSetValue :
        this.find(function(_, key)  {return key === index}, undefined, notSetValue);
    },

    has: function(index) {
      index = wrapIndex(this, index);
      return index >= 0 && (this.size !== undefined ?
        this.size === Infinity || index < this.size :
        this.indexOf(index) !== -1
      );
    },

    interpose: function(separator) {
      return reify(this, interposeFactory(this, separator));
    },

    interleave: function(/*...iterables*/) {
      var iterables = [this].concat(arrCopy(arguments));
      var zipped = zipWithFactory(this.toSeq(), IndexedSeq.of, iterables);
      var interleaved = zipped.flatten(true);
      if (zipped.size) {
        interleaved.size = zipped.size * iterables.length;
      }
      return reify(this, interleaved);
    },

    keySeq: function() {
      return Range(0, this.size);
    },

    last: function() {
      return this.get(-1);
    },

    skipWhile: function(predicate, context) {
      return reify(this, skipWhileFactory(this, predicate, context, false));
    },

    zip: function(/*, ...iterables */) {
      var iterables = [this].concat(arrCopy(arguments));
      return reify(this, zipWithFactory(this, defaultZipper, iterables));
    },

    zipWith: function(zipper/*, ...iterables */) {
      var iterables = arrCopy(arguments);
      iterables[0] = this;
      return reify(this, zipWithFactory(this, zipper, iterables));
    }

  });

  IndexedIterable.prototype[IS_INDEXED_SENTINEL] = true;
  IndexedIterable.prototype[IS_ORDERED_SENTINEL] = true;



  mixin(SetIterable, {

    // ### ES6 Collection methods (ES6 Array and Map)

    get: function(value, notSetValue) {
      return this.has(value) ? value : notSetValue;
    },

    includes: function(value) {
      return this.has(value);
    },


    // ### More sequential methods

    keySeq: function() {
      return this.valueSeq();
    }

  });

  SetIterable.prototype.has = IterablePrototype.includes;
  SetIterable.prototype.contains = SetIterable.prototype.includes;


  // Mixin subclasses

  mixin(KeyedSeq, KeyedIterable.prototype);
  mixin(IndexedSeq, IndexedIterable.prototype);
  mixin(SetSeq, SetIterable.prototype);

  mixin(KeyedCollection, KeyedIterable.prototype);
  mixin(IndexedCollection, IndexedIterable.prototype);
  mixin(SetCollection, SetIterable.prototype);


  // #pragma Helper functions

  function keyMapper(v, k) {
    return k;
  }

  function entryMapper(v, k) {
    return [k, v];
  }

  function not(predicate) {
    return function() {
      return !predicate.apply(this, arguments);
    }
  }

  function neg(predicate) {
    return function() {
      return -predicate.apply(this, arguments);
    }
  }

  function quoteString(value) {
    return typeof value === 'string' ? JSON.stringify(value) : String(value);
  }

  function defaultZipper() {
    return arrCopy(arguments);
  }

  function defaultNegComparator(a, b) {
    return a < b ? 1 : a > b ? -1 : 0;
  }

  function hashIterable(iterable) {
    if (iterable.size === Infinity) {
      return 0;
    }
    var ordered = isOrdered(iterable);
    var keyed = isKeyed(iterable);
    var h = ordered ? 1 : 0;
    var size = iterable.__iterate(
      keyed ?
        ordered ?
          function(v, k)  { h = 31 * h + hashMerge(hash(v), hash(k)) | 0; } :
          function(v, k)  { h = h + hashMerge(hash(v), hash(k)) | 0; } :
        ordered ?
          function(v ) { h = 31 * h + hash(v) | 0; } :
          function(v ) { h = h + hash(v) | 0; }
    );
    return murmurHashOfSize(size, h);
  }

  function murmurHashOfSize(size, h) {
    h = imul(h, 0xCC9E2D51);
    h = imul(h << 15 | h >>> -15, 0x1B873593);
    h = imul(h << 13 | h >>> -13, 5);
    h = (h + 0xE6546B64 | 0) ^ size;
    h = imul(h ^ h >>> 16, 0x85EBCA6B);
    h = imul(h ^ h >>> 13, 0xC2B2AE35);
    h = smi(h ^ h >>> 16);
    return h;
  }

  function hashMerge(a, b) {
    return a ^ b + 0x9E3779B9 + (a << 6) + (a >> 2) | 0; // int
  }

  var Immutable = {

    Iterable: Iterable,

    Seq: Seq,
    Collection: Collection,
    Map: Map,
    OrderedMap: OrderedMap,
    List: List,
    Stack: Stack,
    Set: Set,
    OrderedSet: OrderedSet,

    Record: Record,
    Range: Range,
    Repeat: Repeat,

    is: is,
    fromJS: fromJS

  };

  return Immutable;

}));

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ellipsis; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return dynamicFontSize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return selectedBackground; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return fontFamilyHeading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return fontFamilyBody; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return hideOnPrint; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return showOnPrint; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return hover; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return shadowOnHover; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return darkenOnHover; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__variables__ = __webpack_require__(4);
var _templateObject=_taggedTemplateLiteral(['\n      &:before {\n        opacity: 1;\n      }\n    '],['\n      &:before {\n        opacity: 1;\n      }\n    ']),_templateObject2=_taggedTemplateLiteral(['\n      &:after {\n        opacity: 1;\n      }\n    '],['\n      &:after {\n        opacity: 1;\n      }\n    ']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var ellipsis=function ellipsis(){return'\n    box-sizing:border-box;\n    width:100%;\n    padding: 0 5px;\n    overflow:hidden;\n    white-space: nowrap;\n    text-overflow:ellipsis;\n  ';};var dynamicFontSize=function dynamicFontSize(minFontSize,maxFontSize){var minScreenWidth=arguments.length>2&&arguments[2]!==undefined?arguments[2]:__WEBPACK_IMPORTED_MODULE_0__variables__["f" /* size */].small;var maxScreenWidth=arguments.length>3&&arguments[3]!==undefined?arguments[3]:__WEBPACK_IMPORTED_MODULE_0__variables__["f" /* size */].large;return'\n    font-size: '+minFontSize+'px;\n      @media screen and (min-width: '+minScreenWidth+'px) {\n        font-size: calc('+minFontSize+'px + ('+maxFontSize+' - '+minFontSize+') * ((100vw - '+minScreenWidth+'px) / ('+maxScreenWidth+' - '+minScreenWidth+')));\n      }\n      @media screen and (min-width: '+maxScreenWidth+'px) {\n        font-size: '+maxFontSize+'px;\n      }\n  ';};var selectedBackground=function selectedBackground(){return'\n    position: relative;\n    z-index: 1;\n    &:before {\n      content: \'\';\n      position: absolute;\n      right: -0.3em;\n      bottom: 0;\n      left: -0.3em;\n      height: 90%;\n      opacity: 1;\n      background-color: rgba(197,197,197,.4);\n      z-index: -1;\n    }\n';};var fontFamilyHeading=function fontFamilyHeading(){return'\n    font-family: \'Playfair Display\', Georgia, serif;\n    font-variant-ligatures: no-common-ligatures;\n  ';};var fontFamilyBody=function fontFamilyBody(){return'\n    font-family: \'Open Sans\', Helvetica, Arial, sans-serif;\n  ';};var hideOnPrint=function hideOnPrint(){return'\n  @media print {\n    display: none !important;\n  }\n';};var showOnPrint=function showOnPrint(){return'\n  display: none !important;\n  \n  @media print {\n    display: inherit !important;\n  }\n';};var hover=function hover(content){return'\n    @media not all and (hover: none) {\n      &:hover {\n        '+content+'\n      }\n    }\n  ';};var shadowOnHover=function shadowOnHover(){return'\n    position: relative;\n    z-index: 1;\n  \n    &:before {\n      content: \'\';\n      position: absolute;\n      top: 0;\n      right: 0;\n      bottom: 0;\n      left: 0;\n      z-index: -1;\n      opacity: 0;\n      box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.2);\n      transition: opacity 0.4s '+__WEBPACK_IMPORTED_MODULE_0__variables__["a" /* animation */].easing+';\n    }\n    \n    '+hover(_templateObject)+'\n  ';};var darkenOnHover=function darkenOnHover(){return'\n    position: relative;\n    z-index: 1;\n  \n    &:after {\n      content: \'\';\n      position: absolute;\n      top: 0;\n      right: 0;\n      bottom: 0;\n      left: 0;\n      background-color: rgba(0,0,0,.2);\n      \n      opacity: 0;\n      transition: opacity '+__WEBPACK_IMPORTED_MODULE_0__variables__["a" /* animation */].transitionTime+' '+__WEBPACK_IMPORTED_MODULE_0__variables__["a" /* animation */].easing+';\n    }\n    \n    '+hover(_templateObject2)+'\n  ';};

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["B"] = fetchGlobalSearch;
/* harmony export (immutable) */ __webpack_exports__["D"] = fetchGlobalSearchSuccess;
/* harmony export (immutable) */ __webpack_exports__["C"] = fetchGlobalSearchFail;
/* harmony export (immutable) */ __webpack_exports__["N"] = fetchQuickSearch;
/* harmony export (immutable) */ __webpack_exports__["P"] = fetchQuickSearchSuccess;
/* harmony export (immutable) */ __webpack_exports__["O"] = fetchQuickSearchFail;
/* harmony export (immutable) */ __webpack_exports__["U"] = removeQuickSearch;
/* harmony export (immutable) */ __webpack_exports__["T"] = removeGlobalSearch;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return fetchArticlePageView; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return fetchArticlePageViewSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return fetchArticlePageViewFail; });
/* unused harmony export fetchProductPageView */
/* unused harmony export fetchProductCategoryPageView */
/* unused harmony export fetchTestCart */
/* harmony export (immutable) */ __webpack_exports__["m"] = fetchCampaignProducts;
/* harmony export (immutable) */ __webpack_exports__["o"] = fetchCampaignProductsSuccess;
/* harmony export (immutable) */ __webpack_exports__["n"] = fetchCampaignProductsError;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return fetchProducts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return fetchProductsDataSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return fetchProductsDataError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return fetchProduct; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return fetchProductSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return fetchProductError; });
/* harmony export (immutable) */ __webpack_exports__["y"] = fetchDesignerData;
/* harmony export (immutable) */ __webpack_exports__["A"] = fetchDesignerDataSuccess;
/* harmony export (immutable) */ __webpack_exports__["z"] = fetchDesignerDataError;
/* harmony export (immutable) */ __webpack_exports__["W"] = setViewstate;
/* harmony export (immutable) */ __webpack_exports__["V"] = removeViewstate;
/* harmony export (immutable) */ __webpack_exports__["j"] = fetchBrandData;
/* harmony export (immutable) */ __webpack_exports__["l"] = fetchBrandDataSuccess;
/* harmony export (immutable) */ __webpack_exports__["k"] = fetchBrandDataFail;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return fetchCategoryMetaData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return fetchCategoryMetaDataSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return fetchCategoryMetaDataFail; });
/* harmony export (immutable) */ __webpack_exports__["p"] = fetchCart;
/* harmony export (immutable) */ __webpack_exports__["r"] = fetchCartSuccess;
/* harmony export (immutable) */ __webpack_exports__["q"] = fetchCartFail;
/* harmony export (immutable) */ __webpack_exports__["a"] = addCartItem;
/* harmony export (immutable) */ __webpack_exports__["c"] = addCartItemSuccess;
/* harmony export (immutable) */ __webpack_exports__["b"] = addCartItemFail;
/* harmony export (immutable) */ __webpack_exports__["Q"] = removeCartItem;
/* harmony export (immutable) */ __webpack_exports__["S"] = removeCartItemSuccess;
/* harmony export (immutable) */ __webpack_exports__["R"] = removeCartItemFail;
/* harmony export (immutable) */ __webpack_exports__["d"] = deleteCartRow;
/* harmony export (immutable) */ __webpack_exports__["f"] = deleteCartRowSuccess;
/* harmony export (immutable) */ __webpack_exports__["e"] = deleteCartRowFail;
/* harmony export (immutable) */ __webpack_exports__["E"] = fetchInstagramPosts;
/* harmony export (immutable) */ __webpack_exports__["G"] = fetchInstagramPostsSuccess;
/* harmony export (immutable) */ __webpack_exports__["F"] = fetchInstagramPostsFail;
/* harmony export (immutable) */ __webpack_exports__["v"] = fetchDeliveryMethods;
/* harmony export (immutable) */ __webpack_exports__["x"] = fetchDeliveryMethodsSuccess;
/* harmony export (immutable) */ __webpack_exports__["w"] = fetchDeliveryMethodsFail;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actionTypes__ = __webpack_require__(25);
function fetchGlobalSearch(payload){return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["B" /* FETCH_GLOBAL_SEARCH */],payload:payload};}function fetchGlobalSearchSuccess(payload){return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["D" /* FETCH_GLOBAL_SEARCH_SUCCESS */],payload:payload};}function fetchGlobalSearchFail(payload){return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["C" /* FETCH_GLOBAL_SEARCH_FAIL */],payload:payload};}function fetchQuickSearch(payload){return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["P" /* FETCH_QUICK_SEARCH */],payload:payload};}function fetchQuickSearchSuccess(payload){return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["R" /* FETCH_QUICK_SEARCH_SUCCESS */],payload:payload};}function fetchQuickSearchFail(payload){return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["Q" /* FETCH_QUICK_SEARCH_FAIL */],payload:payload};}function removeQuickSearch(){return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["X" /* REMOVE_QUICK_SEARCH */]};}function removeGlobalSearch(){return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["T" /* REMOVE_GLOBAL_SEARCH */]};}// ARTICLE PAGE
var fetchArticlePageView=function fetchArticlePageView(meta){return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["g" /* FETCH_ARTICLE_PAGE_VIEW */],meta:meta};};var fetchArticlePageViewSuccess=function fetchArticlePageViewSuccess(response){return Object.assign({type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["i" /* FETCH_ARTICLE_PAGE_VIEW_SUCCESS */]},response);};var fetchArticlePageViewFail=function fetchArticlePageViewFail(response){return Object.assign({type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["h" /* FETCH_ARTICLE_PAGE_VIEW_FAIL */]},response);};function fetchProductPageView(payload){return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["L" /* FETCH_PRODUCTS_PAGE_VIEW */],payload:payload};}function fetchProductCategoryPageView(payload){return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["J" /* FETCH_PRODUCTS_CATEGORY_PAGE_VIEW */],payload:payload};}function fetchTestCart(payload){return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["S" /* FETCH_TEST_CART */],payload:payload};}function fetchCampaignProducts(meta){return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["m" /* FETCH_CAMPAIGN_PRODUCTS */],meta:meta};}function fetchCampaignProductsSuccess(response){return Object.assign({type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["o" /* FETCH_CAMPAIGN_PRODUCTS_SUCCESS */]},response);}function fetchCampaignProductsError(response){return Object.assign({type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["n" /* FETCH_CAMPAIGN_PRODUCTS_FAIL */]},response);}// PRODUCT LIST
var fetchProducts=function fetchProducts(meta){return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["I" /* FETCH_PRODUCTS */],meta:meta};};var fetchProductsDataSuccess=function fetchProductsDataSuccess(response){return Object.assign({type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["M" /* FETCH_PRODUCTS_SUCCESS */]},response);};var fetchProductsDataError=function fetchProductsDataError(response){return Object.assign({type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["K" /* FETCH_PRODUCTS_FAIL */]},response);};// DETAILED PRODUCT
var fetchProduct=function fetchProduct(meta){return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["H" /* FETCH_PRODUCT */],meta:meta};};var fetchProductSuccess=function fetchProductSuccess(response){return Object.assign({type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["O" /* FETCH_PRODUCT_SUCCESS */]},response);};var fetchProductError=function fetchProductError(response){return Object.assign({type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["N" /* FETCH_PRODUCT_FAIL */]},response);};// DESIGNER
function fetchDesignerData(payload){return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["y" /* FETCH_DESIGNERS_DATA */],payload:payload};}function fetchDesignerDataSuccess(payload){return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["A" /* FETCH_DESIGNERS_DATA_SUCCESS */],payload:payload};}function fetchDesignerDataError(error){return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["z" /* FETCH_DESIGNERS_DATA_FAIL */],error:error};}function setViewstate(key,value){return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["Z" /* SET_VIEWSTATE */],payload:{key:key,value:value}};}function removeViewstate(key){return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["Y" /* REMOVE_VIEWSTATE */],payload:{key:key}};}function fetchBrandData(payload){return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["j" /* FETCH_BRAND_DATA */],payload:payload};}function fetchBrandDataSuccess(payload){return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["l" /* FETCH_BRAND_DATA_SUCCESS */],payload:payload};}function fetchBrandDataFail(error){return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["k" /* FETCH_BRAND_DATA_FAIL */],error:error};}var fetchCategoryMetaData=function fetchCategoryMetaData(meta){return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["s" /* FETCH_CATEGORY_META_DATA */],meta:meta};};var fetchCategoryMetaDataSuccess=function fetchCategoryMetaDataSuccess(response){return Object.assign({type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["u" /* FETCH_CATEGORY_META_DATA_SUCCESS */]},response);};var fetchCategoryMetaDataFail=function fetchCategoryMetaDataFail(response){return Object.assign({type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["t" /* FETCH_CATEGORY_META_DATA_FAIL */]},response);};// SHOPPING CART ACTIONS
function fetchCart(payload){return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["p" /* FETCH_CART */],payload:payload};}function fetchCartSuccess(payload){return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["r" /* FETCH_CART_SUCCESS */],payload:payload};}function fetchCartFail(error){return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["q" /* FETCH_CART_FAIL */],error:error};}function addCartItem(payload){return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["a" /* ADD_PRODUCT_TO_CART */],payload:payload};}function addCartItemSuccess(payload){return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["c" /* ADD_PRODUCT_TO_CART_SUCCESS */],payload:payload};}function addCartItemFail(error){return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["b" /* ADD_PRODUCT_TO_CART_FAIL */],error:error};}function removeCartItem(payload,cartRow){return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["U" /* REMOVE_PRODUCT_FROM_CART */],payload:payload,cartRow:cartRow};}function removeCartItemSuccess(payload,cartRow){return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["W" /* REMOVE_PRODUCT_FROM_CART_SUCCESS */],payload:payload,cartRow:cartRow};}function removeCartItemFail(error){return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["V" /* REMOVE_PRODUCT_FROM_CART_FAIL */],error:error};}function deleteCartRow(payload,cartRow){return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["d" /* DELETE_CART_ROW */],payload:payload,cartRow:cartRow};}function deleteCartRowSuccess(payload,cartRow){return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["f" /* DELETE_CART_ROW_SUCCESS */],payload:payload,cartRow:cartRow};}function deleteCartRowFail(error){return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["e" /* DELETE_CART_ROW_FAIL */],error:error};}// INSTAGRAM ACTIONS
function fetchInstagramPosts(payload){return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["E" /* FETCH_INSTAGRAM_POSTS */],payload:payload};}function fetchInstagramPostsSuccess(payload){return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["G" /* FETCH_INSTAGRAM_POSTS_SUCCESS */],payload:payload};}function fetchInstagramPostsFail(error){return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["F" /* FETCH_INSTAGRAM_POSTS_FAIL */],error:error};}function fetchDeliveryMethods(payload){return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["v" /* FETCH_DELIVERY_METHODS */],payload:payload};}function fetchDeliveryMethodsSuccess(payload){return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["x" /* FETCH_DELIVERY_METHODS_SUCCESS */],payload:payload};}function fetchDeliveryMethodsFail(error){return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["w" /* FETCH_DELIVERY_METHODS_FAIL */],error:error};}

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(15);
var _this=this;function mapDispatchToProps(actions,dispatch){return Object(__WEBPACK_IMPORTED_MODULE_0_redux__["b" /* bindActionCreators */])(actions,dispatch);}/* harmony default export */ __webpack_exports__["a"] = (function(component){var actions=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};var mapStateToProps=arguments[2];return Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["g" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps.bind(_this,actions))(component));});

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return SITE_ROOT_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BASE_API_URL; });
/* unused harmony export PAYMENT_API_BASE_URL */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return CHECKOUT_API_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return SET_DELIVERY_METHOD_URL; });
/* unused harmony export SET_PAYMENT_METHOD_URL */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return FINALIZE_PAYMENT_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return GET_DELIVERY_METHODS_URL; });
/* unused harmony export PRODUCTS_API_URL */
/* unused harmony export PRODUCT_LIST_API_URL */
/* unused harmony export CATEGORY_API_BASE_URL */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return BRANDS_API_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return DESIGNERS_API_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CART_API_BASE_URL; });
/* unused harmony export CART_GET_URL */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CART_ADD_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return CART_REMOVE_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return CART_DELETE_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return GLOBAL_SEARCH_BASE_API; });
/* unused harmony export CONTENT_API_BASE_URL */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return INSTAGRAM_API_URL; });
var SITE_ROOT_URL=window.apiBaseUrl;var BASE_API_URL=SITE_ROOT_URL+"/api";/*
PAYMENT-api endpoints
*/var PAYMENT_API_BASE_URL=BASE_API_URL+"/payment";var CHECKOUT_API_URL=PAYMENT_API_BASE_URL+"/InitializePayment";var SET_DELIVERY_METHOD_URL=PAYMENT_API_BASE_URL+"/deliverymethod";var SET_PAYMENT_METHOD_URL=PAYMENT_API_BASE_URL+"/paymentmethod";var FINALIZE_PAYMENT_URL=PAYMENT_API_BASE_URL+"/FinalizePayment";var GET_DELIVERY_METHODS_URL=PAYMENT_API_BASE_URL+"/deliverymethods";/*
PRODUCT-api endpoints
*/var PRODUCTS_API_URL=BASE_API_URL+"/products";var PRODUCT_LIST_API_URL=PRODUCTS_API_URL+"?productListId=";/*
CATEGORY-api endpoints
*/var CATEGORY_API_BASE_URL=BASE_API_URL+"/category";var BRANDS_API_URL=CATEGORY_API_BASE_URL+"/brands";var DESIGNERS_API_URL=CATEGORY_API_BASE_URL+"/designers";/*
CART-api endpoints
*/var CART_API_BASE_URL=BASE_API_URL+"/shoppingcart";var CART_GET_URL=CART_API_BASE_URL+"/get";var CART_ADD_URL=CART_API_BASE_URL+"/add";var CART_REMOVE_URL=CART_API_BASE_URL+"/remove";var CART_DELETE_URL=CART_API_BASE_URL+"/delete";/*
SEARCH-api endpoints
*/var GLOBAL_SEARCH_BASE_API=BASE_API_URL+"/search";/*
CONTENT-api endpoints
*/var CONTENT_API_BASE_URL=BASE_API_URL+"/content";var INSTAGRAM_API_URL=CONTENT_API_BASE_URL+"/instagram/get";

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Container; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_variables__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_mixins__ = __webpack_require__(6);
var _templateObject=_taggedTemplateLiteral(['\n  width: 100%;\n  max-width: ',';\n  padding-top: ',';\n  padding-bottom: ',';\n  padding-left: calc(8px + ((80 - 8) * ((100vw - ','px) / (',' - ','))));\n  padding-right: calc(8px + ((80 - 8) * ((100vw - ','px) / (',' - ','))));\n  margin: 0 auto;\n  position: ',';\n  margin-bottom: ',';\n  background-color: ',';\n\n  ',';\n\n  @media screen and (max-width: ','px) {\n    padding-left: 8px;\n    padding-right: 8px;\n  }\n\n  @media screen and (min-width: ','px) {\n    padding-left: 80px;\n    padding-right: 80px;\n  }\n\n  ','\n\n  ','\n\n  ','\n\n  ','\n\n  ','\n\n  ','\n\n  ','\n\n  ','\n\n    ','\n\n  ',';\n\n  ','\n  ','\n\n  ','\n'],['\n  width: 100%;\n  max-width: ',';\n  padding-top: ',';\n  padding-bottom: ',';\n  padding-left: calc(8px + ((80 - 8) * ((100vw - ','px) / (',' - ','))));\n  padding-right: calc(8px + ((80 - 8) * ((100vw - ','px) / (',' - ','))));\n  margin: 0 auto;\n  position: ',';\n  margin-bottom: ',';\n  background-color: ',';\n\n  ',';\n\n  @media screen and (max-width: ','px) {\n    padding-left: 8px;\n    padding-right: 8px;\n  }\n\n  @media screen and (min-width: ','px) {\n    padding-left: 80px;\n    padding-right: 80px;\n  }\n\n  ','\n\n  ','\n\n  ','\n\n  ','\n\n  ','\n\n  ','\n\n  ','\n\n  ','\n\n    ','\n\n  ',';\n\n  ','\n  ','\n\n  ','\n']),_templateObject2=_taggedTemplateLiteral(['\n      position: fixed;\n      z-index: 150;\n      top: 0;\n      width: 100%;\n    '],['\n      position: fixed;\n      z-index: 150;\n      top: 0;\n      width: 100%;\n    ']),_templateObject3=_taggedTemplateLiteral(['\n      background-color: ',';\n    '],['\n      background-color: ',';\n    ']),_templateObject4=_taggedTemplateLiteral(['\n      padding-top: 0;\n      padding-bottom: 0;\n    '],['\n      padding-top: 0;\n      padding-bottom: 0;\n    ']),_templateObject5=_taggedTemplateLiteral(['\n      padding-left: 0 !important;\n      padding-right: 0 !important;\n    '],['\n      padding-left: 0 !important;\n      padding-right: 0 !important;\n    ']),_templateObject6=_taggedTemplateLiteral(['\n      padding-top: 0 !important;\n    '],['\n      padding-top: 0 !important;\n    ']),_templateObject7=_taggedTemplateLiteral(['\n      padding-bottom: 0 !important;\n    '],['\n      padding-bottom: 0 !important;\n    ']),_templateObject8=_taggedTemplateLiteral(['\n      padding-top: 4rem;\n      padding-bottom: 4rem;\n    '],['\n      padding-top: 4rem;\n      padding-bottom: 4rem;\n    ']),_templateObject9=_taggedTemplateLiteral(['\n      padding-bottom: ','px;\n    '],['\n      padding-bottom: ','px;\n    ']),_templateObject10=_taggedTemplateLiteral(['\n      padding-top: ','px;\n    '],['\n      padding-top: ','px;\n    ']),_templateObject11=_taggedTemplateLiteral(['\n        background: url(',');\n        background-position: center;\n        background-size: cover;\n      '],['\n        background: url(',');\n        background-position: center;\n        background-size: cover;\n      ']),_templateObject12=_taggedTemplateLiteral(['\n      padding-top: 0;\n      padding-bottom: 60px;\n    '],['\n      padding-top: 0;\n      padding-bottom: 60px;\n    ']),_templateObject13=_taggedTemplateLiteral(['\n      padding-top: 20px;\n    '],['\n      padding-top: 20px;\n    ']),_templateObject14=_taggedTemplateLiteral(['\n      margin: 10px 0 -30px;\n    '],['\n      margin: 10px 0 -30px;\n    ']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Container=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].div(_templateObject,function(props){return props.fullWidth?'100%':'1580px';},function(props){return props.swipe?'0':'2rem';},function(props){return props.swipe?'0':'2rem';},__WEBPACK_IMPORTED_MODULE_2__helpers_variables__["f" /* size */].small,__WEBPACK_IMPORTED_MODULE_2__helpers_variables__["f" /* size */].xLarge,__WEBPACK_IMPORTED_MODULE_2__helpers_variables__["f" /* size */].small,__WEBPACK_IMPORTED_MODULE_2__helpers_variables__["f" /* size */].small,__WEBPACK_IMPORTED_MODULE_2__helpers_variables__["f" /* size */].xLarge,__WEBPACK_IMPORTED_MODULE_2__helpers_variables__["f" /* size */].small,function(props){return props.positionRelative?'relative':'initial';},function(props){return props.mb?props.mb+'px':0;},function(props){return props.bgColor?__WEBPACK_IMPORTED_MODULE_2__helpers_variables__["c" /* color */].black:'transparent';},function(props){return props.sticky&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(_templateObject2);},__WEBPACK_IMPORTED_MODULE_2__helpers_variables__["f" /* size */].small,__WEBPACK_IMPORTED_MODULE_2__helpers_variables__["f" /* size */].xLarge,function(props){return props.bgColor&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(_templateObject3,props.bgColor);},function(props){return props.noPadding&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(_templateObject4);},function(props){return props.noXPadding&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(_templateObject5);},function(props){return props.noPaddingTop&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(_templateObject6);},function(props){return props.noPaddingBottom&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(_templateObject7);},function(props){return props.padded&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(_templateObject8);},function(props){return props.pb&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(_templateObject9,props.pb);},function(props){return props.pt&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(_templateObject10,props.pt);},function(props){return props.bgImg&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(_templateObject11,props.bgImg);},function(props){return props.hideOnPrint&&__WEBPACK_IMPORTED_MODULE_3__helpers_mixins__["f" /* hideOnPrint */];},function(props){return props.productPage&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(_templateObject12);},function(props){return props.productPageFirst&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(_templateObject13);},function(props){return props.productPageMobileFirst&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(_templateObject14);});Container.propTypes={padded:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};

/***/ }),
/* 11 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 12 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(14);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 14 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BrowserRouter__ = __webpack_require__(495);
/* unused harmony reexport BrowserRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HashRouter__ = __webpack_require__(496);
/* unused harmony reexport HashRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Link__ = __webpack_require__(221);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__Link__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MemoryRouter__ = __webpack_require__(497);
/* unused harmony reexport MemoryRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NavLink__ = __webpack_require__(499);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_4__NavLink__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Prompt__ = __webpack_require__(501);
/* unused harmony reexport Prompt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Redirect__ = __webpack_require__(503);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_6__Redirect__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Route__ = __webpack_require__(222);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_7__Route__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Router__ = __webpack_require__(149);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_8__Router__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__StaticRouter__ = __webpack_require__(505);
/* unused harmony reexport StaticRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Switch__ = __webpack_require__(507);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_10__Switch__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__generatePath__ = __webpack_require__(509);
/* unused harmony reexport generatePath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__matchPath__ = __webpack_require__(510);
/* unused harmony reexport matchPath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__withRouter__ = __webpack_require__(511);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_13__withRouter__["a"]; });





























/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(97)('wks');
var uid = __webpack_require__(57);
var Symbol = __webpack_require__(11).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(42);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Heading; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_mixins__ = __webpack_require__(6);
var _templateObject=_taggedTemplateLiteral(['\n  ',';\n  ',';\n  font-weight: normal;\n  margin: ',';\n  text-align: ',';\n  font-variant-ligatures: no-common-ligatures;\n\n  // set min-height to 1.3333em to avoid jumping\n  min-height: 1.3333em;\n\n  ',';\n\n  ',';\n\n  ',';\n  ',';\n'],['\n  ',';\n  ',';\n  font-weight: normal;\n  margin: ',';\n  text-align: ',';\n  font-variant-ligatures: no-common-ligatures;\n\n  // set min-height to 1.3333em to avoid jumping\n  min-height: 1.3333em;\n\n  ',';\n\n  ',';\n\n  ',';\n  ',';\n']),_templateObject2=_taggedTemplateLiteral(['\n      ',';\n    '],['\n      ',';\n    ']),_templateObject3=_taggedTemplateLiteral(['\n      text-align: ',';\n    '],['\n      text-align: ',';\n    ']),_templateObject4=_taggedTemplateLiteral(['\n      margin: 0 0 7.5px;\n      font-size: 28px !important;\n      line-height: 1.25;\n      @media screen and (min-width: 1180px) {\n        font-size: 38px !important;\n      }\n    '],['\n      margin: 0 0 7.5px;\n      font-size: 28px !important;\n      line-height: 1.25;\n      @media screen and (min-width: 1180px) {\n        font-size: 38px !important;\n      }\n    ']),_templateObject5=_taggedTemplateLiteral(['\n      margin: 0;\n      font-size: 24px !important;\n      line-height: 1.25;\n    '],['\n      margin: 0;\n      font-size: 24px !important;\n      line-height: 1.25;\n    ']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Heading=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].h1(_templateObject,__WEBPACK_IMPORTED_MODULE_1__helpers_mixins__["e" /* fontFamilyHeading */],Object(__WEBPACK_IMPORTED_MODULE_1__helpers_mixins__["b" /* dynamicFontSize */])(22,36),function(props){return props.margin?props.margin:'0 0 1rem';},function(props){return props.center?'center':'left';},function(props){return props.big&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(_templateObject2,Object(__WEBPACK_IMPORTED_MODULE_1__helpers_mixins__["b" /* dynamicFontSize */])(32,52));},function(props){return props.textAlign&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(_templateObject3,props.textAlign);},function(props){return props.productPage&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(_templateObject4);},function(props){return props.productPageMoble&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(_templateObject5);});Heading.h1=Heading;Heading.h2=Heading.withComponent('h2');Heading.h3=Heading.withComponent('h3');Heading.h4=Heading.withComponent('h4');Heading.h5=Heading.withComponent('h5');Heading.h6=Heading.withComponent('h6');Heading.p=Heading.withComponent('p');

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Flex = exports.Box = undefined;

var _systemComponents = __webpack_require__(561);

var _systemComponents2 = _interopRequireDefault(_systemComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Box = exports.Box = (0, _systemComponents2.default)({}, {
  boxSizing: 'border-box'
}, 'width', 'space', 'fontSize', 'color', 'flex', 'order', 'alignSelf');

Box.displayName = 'Box';

var Flex = exports.Flex = (0, _systemComponents2.default)({
  is: Box
}, { display: 'flex' }, 'flexWrap', 'flexDirection', 'alignItems', 'justifyContent');

Flex.displayName = 'Flex';

/***/ }),
/* 20 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.12' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(12)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(13);
var IE8_DOM_DEFINE = __webpack_require__(171);
var toPrimitive = __webpack_require__(50);
var dP = Object.defineProperty;

exports.f = __webpack_require__(21) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_helmet__ = __webpack_require__(589);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_helmet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_helmet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_immutable__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_connect__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions_actionCreators__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Breadcrumbs__ = __webpack_require__(594);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Overlay__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_CookieBar__ = __webpack_require__(595);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_NewsletterWidget__ = __webpack_require__(601);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__constants_endpoints__ = __webpack_require__(9);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  background-color: ',';\n  position: relative;\n  padding: 0;\n  margin: 0;\n  ',';\n'],['\n  background-color: ',';\n  position: relative;\n  padding: 0;\n  margin: 0;\n  ',';\n']),_templateObject2=_taggedTemplateLiteral(['\n      background: url(',');\n      background-position: center;\n      background-size: cover;\n    '],['\n      background: url(',');\n      background-position: center;\n      background-size: cover;\n    ']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Page=function(_Component){_inherits(Page,_Component);function Page(props){_classCallCheck(this,Page);var _this=_possibleConstructorReturn(this,(Page.__proto__||Object.getPrototypeOf(Page)).call(this,props));_this.checkDevice=_this.checkDevice.bind(_this);return _this;}_createClass(Page,[{key:'componentWillMount',value:function componentWillMount(){this.checkDevice();}},{key:'componentDidMount',value:function componentDidMount(){window.addEventListener('resize',this.checkDevice);}},{key:'componentWillUnmount',value:function componentWillUnmount(){window.removeEventListener('resize',this.checkDevice);}},{key:'checkDevice',value:function checkDevice(){this.props.setViewstate('pageWidth',window.innerWidth);}},{key:'render',value:function render(){var _props=this.props,viewstate=_props.viewstate,meta=_props.meta,canonical=_props.canonical;var pageWidth=viewstate.get('pageWidth');var activeMenuItem=viewstate.get('activeMenuItem');return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PageContainer,{bgImg:this.props.bgImg,bgColor:this.props.bgColor,loadingState:this.props.loadingState},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_helmet__["Helmet"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('title',null,meta.get('metaTitle')),meta.get('metaTitle')&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('meta',{name:'title',property:'og:title',content:meta.get('metaTitle')}),meta.get('metaDescription')&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('meta',{name:'description',property:'og:description',content:meta.get('metaDescription')}),meta.get('imageUrl')&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('meta',{name:'image',property:'og:image',content:__WEBPACK_IMPORTED_MODULE_11__constants_endpoints__["n" /* SITE_ROOT_URL */]+meta.get('imageUrl')}),meta.get('keywords')&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('meta',{name:'keywords',content:meta.get('keywords')}),meta.get('url')&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('meta',{name:'url',content:window.location.origin+meta.get('url')}),canonical?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('link',{rel:'canonical',href:window.location.origin+canonical}):false),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Breadcrumbs__["a" /* default */],{pageWidth:pageWidth,disabled:this.props.noBreadcrumbs,currentItem:this.props.lastBreadcrumbItem}),this.props.children,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_Overlay__["a" /* default */],{active:activeMenuItem&&typeof activeMenuItem==='string'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_NewsletterWidget__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_CookieBar__["a" /* default */],null));}}]);return Page;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var PageContainer=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].div(_templateObject,function(props){return props.bgColor?props.bgColor:'transparent';},function(props){return props.bgImg&&Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["css"])(_templateObject2,props.bgImg);});Page.defaultProps={bgColor:'',bgImg:'',noBreadcrumbs:false,lastBreadcrumbItem:null,loadingState:false,meta:Object(__WEBPACK_IMPORTED_MODULE_4_immutable__["Map"])(),canonical:null};Page.propTypes={setViewstate:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,viewstate:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_4_immutable__["Map"]).isRequired,bgColor:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,bgImg:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,meta:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_4_immutable__["Map"]),canonical:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,noBreadcrumbs:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,lastBreadcrumbItem:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,loadingState:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,children:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node),__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node]).isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5__store_connect__["a" /* default */])(Page,{setViewstate:__WEBPACK_IMPORTED_MODULE_6__actions_actionCreators__["W" /* setViewstate */]},function(store){return{viewstate:store.viewstate};}));

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(47);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return FETCH_ARTICLE_PAGE_VIEW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return FETCH_PRODUCTS_PAGE_VIEW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return FETCH_PRODUCTS_CATEGORY_PAGE_VIEW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return FETCH_TEST_CART; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return FETCH_ARTICLE_PAGE_VIEW_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return FETCH_ARTICLE_PAGE_VIEW_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return FETCH_PRODUCTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return FETCH_PRODUCTS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return FETCH_PRODUCTS_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return FETCH_PRODUCT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return FETCH_PRODUCT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return FETCH_PRODUCT_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return FETCH_CART; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return FETCH_CART_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return FETCH_CART_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ADD_PRODUCT_TO_CART; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ADD_PRODUCT_TO_CART_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ADD_PRODUCT_TO_CART_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return REMOVE_PRODUCT_FROM_CART; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return REMOVE_PRODUCT_FROM_CART_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return REMOVE_PRODUCT_FROM_CART_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return DELETE_CART_ROW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return DELETE_CART_ROW_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return DELETE_CART_ROW_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return FETCH_INSTAGRAM_POSTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return FETCH_INSTAGRAM_POSTS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return FETCH_INSTAGRAM_POSTS_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return SET_VIEWSTATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return REMOVE_VIEWSTATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return FETCH_GLOBAL_SEARCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return FETCH_GLOBAL_SEARCH_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return FETCH_GLOBAL_SEARCH_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return REMOVE_GLOBAL_SEARCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return FETCH_QUICK_SEARCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return FETCH_QUICK_SEARCH_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return FETCH_QUICK_SEARCH_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return REMOVE_QUICK_SEARCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return FETCH_BRAND_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return FETCH_BRAND_DATA_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return FETCH_BRAND_DATA_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return FETCH_DESIGNERS_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return FETCH_DESIGNERS_DATA_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return FETCH_DESIGNERS_DATA_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return FETCH_CATEGORY_META_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return FETCH_CATEGORY_META_DATA_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return FETCH_CATEGORY_META_DATA_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return FETCH_DELIVERY_METHODS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return FETCH_DELIVERY_METHODS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return FETCH_DELIVERY_METHODS_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return FETCH_CAMPAIGN_PRODUCTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return FETCH_CAMPAIGN_PRODUCTS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return FETCH_CAMPAIGN_PRODUCTS_FAIL; });
var FETCH_ARTICLE_PAGE_VIEW='FETCH_ARTICLE_PAGE_VIEW';var FETCH_PRODUCTS_PAGE_VIEW='FETCH_PRODUCTS_PAGE_VIEW';var FETCH_PRODUCTS_CATEGORY_PAGE_VIEW='FETCH_PRODUCTS_CATEGORY_PAGE_VIEW';var FETCH_TEST_CART='FETCH_TEST_CART';var FETCH_ARTICLE_PAGE_VIEW_SUCCESS='FETCH_ARTICLE_PAGE_VIEW_SUCCESS';var FETCH_ARTICLE_PAGE_VIEW_FAIL='FETCH_ARTICLE_PAGE_VIEW_FAIL';// PRODUCT LIST
var FETCH_PRODUCTS='FETCH_PRODUCTS';var FETCH_PRODUCTS_SUCCESS='FETCH_PRODUCTS_SUCCESS';var FETCH_PRODUCTS_FAIL='FETCH_PRODUCTS_FAIL';// DETAILED PRODUCT
var FETCH_PRODUCT='FETCH_PRODUCT';var FETCH_PRODUCT_SUCCESS='FETCH_PRODUCT_SUCCESS';var FETCH_PRODUCT_FAIL='FETCH_PRODUCT_FAIL';// SHOPPING CART ACTIONS
var FETCH_CART='FETCH_CART';var FETCH_CART_SUCCESS='FETCH_CART_SUCCESS';var FETCH_CART_FAIL='FETCH_CART_FAIL';var ADD_PRODUCT_TO_CART='ADD_PRODUCT_TO_CART';var ADD_PRODUCT_TO_CART_SUCCESS='ADD_PRODUCT_TO_CART_SUCCESS';var ADD_PRODUCT_TO_CART_FAIL='ADD_PRODUCT_TO_CART_FAIL';var REMOVE_PRODUCT_FROM_CART='REMOVE_PRODUCT_FROM_CARTTE_CART_ROW';var REMOVE_PRODUCT_FROM_CART_SUCCESS='REMOVE_PRODUCT_FROM_CARTTE_CART_ROW_SUCCESS';var REMOVE_PRODUCT_FROM_CART_FAIL='REMOVE_PRODUCT_FROM_CARTTE_CART_ROW_FAIL';var DELETE_CART_ROW='DELETE_CART_ROW';var DELETE_CART_ROW_SUCCESS='DELETE_CART_ROW_SUCCESS';var DELETE_CART_ROW_FAIL='DELETE_CART_ROW_FAIL';// INSTAGRAM POSTS
var FETCH_INSTAGRAM_POSTS='FETCH_INSTAGRAM_POSTS';var FETCH_INSTAGRAM_POSTS_SUCCESS='FETCH_INSTAGRAM_POSTS_SUCCESS';var FETCH_INSTAGRAM_POSTS_FAIL='FETCH_INSTAGRAM_POSTS_FAIL';var SET_VIEWSTATE='SET_VIEWSTATE';var REMOVE_VIEWSTATE='REMOVE_VIEWSTATE';var FETCH_GLOBAL_SEARCH='FETCH_GLOBAL_SEARCH';var FETCH_GLOBAL_SEARCH_SUCCESS='FETCH_GLOBAL_SEARCH_SUCCESS';var FETCH_GLOBAL_SEARCH_FAIL='FETCH_GLOBAL_SEARCH_FAIL';var REMOVE_GLOBAL_SEARCH='REMOVE_GLOBAL_SEARCH';var FETCH_QUICK_SEARCH='FETCH_QUICK_SEARCH';var FETCH_QUICK_SEARCH_SUCCESS='FETCH_QUICK_SEARCH_SUCCESS';var FETCH_QUICK_SEARCH_FAIL='FETCH_QUICK_SEARCH_FAIL';var REMOVE_QUICK_SEARCH='REMOVE_QUICK_SEARCH';var FETCH_BRAND_DATA='FETCH_BRAND_DATA';var FETCH_BRAND_DATA_SUCCESS='FETCH_BRAND_DATA_SUCCESS';var FETCH_BRAND_DATA_FAIL='FETCH_BRAND_DATA_FAIL';var FETCH_DESIGNERS_DATA='FETCH_DESIGNERS_DATA';var FETCH_DESIGNERS_DATA_SUCCESS='FETCH_DESIGNERS_DATA_SUCCESS';var FETCH_DESIGNERS_DATA_FAIL='FETCH_DESIGNERS_DATA_FAIL';var FETCH_CATEGORY_META_DATA='FETCH_CATEGORY_META_DATA';var FETCH_CATEGORY_META_DATA_SUCCESS='FETCH_CATEGORY_META_DATA_SUCCESS';var FETCH_CATEGORY_META_DATA_FAIL='FETCH_CATEGORY_META_DATA_FAIL';// CHECKOUT ACTIONS
var FETCH_DELIVERY_METHODS='FETCH_DELIVERY_METHODS';var FETCH_DELIVERY_METHODS_SUCCESS='FETCH_DELIVERY_METHODS_SUCCESS';var FETCH_DELIVERY_METHODS_FAIL='FETCH_DELIVERY_METHODS_FAIL';var FETCH_CAMPAIGN_PRODUCTS='FETCH_CAMPAIGN_PRODUCTS';var FETCH_CAMPAIGN_PRODUCTS_SUCCESS='FETCH_CAMPAIGN_PRODUCTS_SUCCESS';var FETCH_CAMPAIGN_PRODUCTS_FAIL='FETCH_CAMPAIGN_PRODUCTS_FAIL';

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Conditional; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Conditional=function(_React$Component){_inherits(Conditional,_React$Component);function Conditional(){_classCallCheck(this,Conditional);return _possibleConstructorReturn(this,(Conditional.__proto__||Object.getPrototypeOf(Conditional)).apply(this,arguments));}_createClass(Conditional,[{key:'render',value:function render(){if(!this.props.show||__WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.count(this.props.children)===0){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,this.props.children);}}]);return Conditional;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);Conditional.defaultProps={show:false};Conditional.propTypes={show:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,children:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node),__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node]).isRequired};

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(11);
var hide = __webpack_require__(32);
var has = __webpack_require__(31);
var SRC = __webpack_require__(57)('src');
var $toString = __webpack_require__(281);
var TO_STRING = 'toString';
var TPL = ('' + $toString).split(TO_STRING);

__webpack_require__(20).inspectSource = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) has(val, 'name') || hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    hide(O, key, val);
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(3);
var fails = __webpack_require__(12);
var defined = __webpack_require__(47);
var quot = /"/g;
// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
var createHTML = function (string, tag, attribute, value) {
  var S = String(defined(string));
  var p1 = '<' + tag;
  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
  return p1 + '>' + S + '</' + tag + '>';
};
module.exports = function (NAME, exec) {
  var O = {};
  O[NAME] = exec(createHTML);
  $export($export.P + $export.F * fails(function () {
    var test = ''[NAME]('"');
    return test !== test.toLowerCase() || test.split('"').length > 3;
  }), 'String', O);
};


/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_io__ = __webpack_require__(54);
/* unused harmony reexport take */
/* unused harmony reexport takem */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["f"]; });
/* unused harmony reexport all */
/* unused harmony reexport race */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["c"]; });
/* unused harmony reexport apply */
/* unused harmony reexport cps */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["e"]; });
/* unused harmony reexport spawn */
/* unused harmony reexport join */
/* unused harmony reexport cancel */
/* unused harmony reexport select */
/* unused harmony reexport actionChannel */
/* unused harmony reexport cancelled */
/* unused harmony reexport flush */
/* unused harmony reexport getContext */
/* unused harmony reexport setContext */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_io_helpers__ = __webpack_require__(520);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_1__internal_io_helpers__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_1__internal_io_helpers__["b"]; });
/* unused harmony reexport throttle */




/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Preamble; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_variables__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_mixins__ = __webpack_require__(6);
var _templateObject=_taggedTemplateLiteral(['\n  ',';\n  font-weight: 300;\n  font-stretch: normal;\n  line-height: 1.67;\n  letter-spacing: normal;\n  text-align: center;\n  color: ',';\n  max-width: 620px;\n  margin: 1rem auto 0;\n\n  @media screen and (min-width: ','px) {\n    line-height: 1.56;\n    max-width: 80%;\n  }\n\n  @media screen and (min-width: ','px) {\n    max-width: 75%;\n    margin-bottom: 1rem;\n  }\n\n  @media screen and (min-width: ','px) {\n    max-width: 70%;\n  }\n\n  ',';\n'],['\n  ',';\n  font-weight: 300;\n  font-stretch: normal;\n  line-height: 1.67;\n  letter-spacing: normal;\n  text-align: center;\n  color: ',';\n  max-width: 620px;\n  margin: 1rem auto 0;\n\n  @media screen and (min-width: ','px) {\n    line-height: 1.56;\n    max-width: 80%;\n  }\n\n  @media screen and (min-width: ','px) {\n    max-width: 75%;\n    margin-bottom: 1rem;\n  }\n\n  @media screen and (min-width: ','px) {\n    max-width: 70%;\n  }\n\n  ',';\n']),_templateObject2=_taggedTemplateLiteral(['\n      text-align: ',';\n      margin: 1rem 0;\n      max-width: initial !important;\n    '],['\n      text-align: ',';\n      margin: 1rem 0;\n      max-width: initial !important;\n    ']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Preamble=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].p(_templateObject,Object(__WEBPACK_IMPORTED_MODULE_2__helpers_mixins__["b" /* dynamicFontSize */])(17,21,__WEBPACK_IMPORTED_MODULE_1__helpers_variables__["f" /* size */].small,__WEBPACK_IMPORTED_MODULE_1__helpers_variables__["f" /* size */].medium),__WEBPACK_IMPORTED_MODULE_1__helpers_variables__["c" /* color */].black,__WEBPACK_IMPORTED_MODULE_1__helpers_variables__["f" /* size */].medium,__WEBPACK_IMPORTED_MODULE_1__helpers_variables__["f" /* size */].large,__WEBPACK_IMPORTED_MODULE_1__helpers_variables__["f" /* size */].xLarge,function(props){return props.textAlign&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(_templateObject2,props.textAlign);});

/***/ }),
/* 31 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(22);
var createDesc = __webpack_require__(56);
module.exports = __webpack_require__(21) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(88);
var defined = __webpack_require__(47);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return sym; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return TASK; });
/* unused harmony export HELPER */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return MATCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CANCEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SAGA_ACTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SELF_CANCELLATION; });
/* unused harmony export konst */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return kTrue; });
/* unused harmony export kFalse */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return noop; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return ident; });
/* harmony export (immutable) */ __webpack_exports__["g"] = check;
/* unused harmony export hasOwn */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return is; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return object; });
/* harmony export (immutable) */ __webpack_exports__["t"] = remove;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return array; });
/* harmony export (immutable) */ __webpack_exports__["i"] = deferred;
/* unused harmony export arrayOfDeffered */
/* harmony export (immutable) */ __webpack_exports__["j"] = delay;
/* unused harmony export createMockTask */
/* unused harmony export autoInc */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return uid; });
/* harmony export (immutable) */ __webpack_exports__["q"] = makeIterator;
/* harmony export (immutable) */ __webpack_exports__["p"] = log;
/* harmony export (immutable) */ __webpack_exports__["k"] = deprecate;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return updateIncentive; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return internalErr; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return createSetContextWarning; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return wrapSagaDispatch; });
/* unused harmony export cloneableGenerator */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var sym = function sym(id) {
  return '@@redux-saga/' + id;
};

var TASK = /*#__PURE__*/sym('TASK');
var HELPER = /*#__PURE__*/sym('HELPER');
var MATCH = /*#__PURE__*/sym('MATCH');
var CANCEL = /*#__PURE__*/sym('CANCEL_PROMISE');
var SAGA_ACTION = /*#__PURE__*/sym('SAGA_ACTION');
var SELF_CANCELLATION = /*#__PURE__*/sym('SELF_CANCELLATION');
var konst = function konst(v) {
  return function () {
    return v;
  };
};
var kTrue = /*#__PURE__*/konst(true);
var kFalse = /*#__PURE__*/konst(false);
var noop = function noop() {};
var ident = function ident(v) {
  return v;
};

function check(value, predicate, error) {
  if (!predicate(value)) {
    log('error', 'uncaught at check', error);
    throw new Error(error);
  }
}

var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn(object, property) {
  return is.notUndef(object) && hasOwnProperty.call(object, property);
}

var is = {
  undef: function undef(v) {
    return v === null || v === undefined;
  },
  notUndef: function notUndef(v) {
    return v !== null && v !== undefined;
  },
  func: function func(f) {
    return typeof f === 'function';
  },
  number: function number(n) {
    return typeof n === 'number';
  },
  string: function string(s) {
    return typeof s === 'string';
  },
  array: Array.isArray,
  object: function object(obj) {
    return obj && !is.array(obj) && (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object';
  },
  promise: function promise(p) {
    return p && is.func(p.then);
  },
  iterator: function iterator(it) {
    return it && is.func(it.next) && is.func(it.throw);
  },
  iterable: function iterable(it) {
    return it && is.func(Symbol) ? is.func(it[Symbol.iterator]) : is.array(it);
  },
  task: function task(t) {
    return t && t[TASK];
  },
  observable: function observable(ob) {
    return ob && is.func(ob.subscribe);
  },
  buffer: function buffer(buf) {
    return buf && is.func(buf.isEmpty) && is.func(buf.take) && is.func(buf.put);
  },
  pattern: function pattern(pat) {
    return pat && (is.string(pat) || (typeof pat === 'undefined' ? 'undefined' : _typeof(pat)) === 'symbol' || is.func(pat) || is.array(pat));
  },
  channel: function channel(ch) {
    return ch && is.func(ch.take) && is.func(ch.close);
  },
  helper: function helper(it) {
    return it && it[HELPER];
  },
  stringableFunc: function stringableFunc(f) {
    return is.func(f) && hasOwn(f, 'toString');
  }
};

var object = {
  assign: function assign(target, source) {
    for (var i in source) {
      if (hasOwn(source, i)) {
        target[i] = source[i];
      }
    }
  }
};

function remove(array, item) {
  var index = array.indexOf(item);
  if (index >= 0) {
    array.splice(index, 1);
  }
}

var array = {
  from: function from(obj) {
    var arr = Array(obj.length);
    for (var i in obj) {
      if (hasOwn(obj, i)) {
        arr[i] = obj[i];
      }
    }
    return arr;
  }
};

function deferred() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var def = _extends({}, props);
  var promise = new Promise(function (resolve, reject) {
    def.resolve = resolve;
    def.reject = reject;
  });
  def.promise = promise;
  return def;
}

function arrayOfDeffered(length) {
  var arr = [];
  for (var i = 0; i < length; i++) {
    arr.push(deferred());
  }
  return arr;
}

function delay(ms) {
  var val = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  var timeoutId = void 0;
  var promise = new Promise(function (resolve) {
    timeoutId = setTimeout(function () {
      return resolve(val);
    }, ms);
  });

  promise[CANCEL] = function () {
    return clearTimeout(timeoutId);
  };

  return promise;
}

function createMockTask() {
  var _ref;

  var running = true;
  var _result = void 0,
      _error = void 0;

  return _ref = {}, _ref[TASK] = true, _ref.isRunning = function isRunning() {
    return running;
  }, _ref.result = function result() {
    return _result;
  }, _ref.error = function error() {
    return _error;
  }, _ref.setRunning = function setRunning(b) {
    return running = b;
  }, _ref.setResult = function setResult(r) {
    return _result = r;
  }, _ref.setError = function setError(e) {
    return _error = e;
  }, _ref;
}

function autoInc() {
  var seed = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

  return function () {
    return ++seed;
  };
}

var uid = /*#__PURE__*/autoInc();

var kThrow = function kThrow(err) {
  throw err;
};
var kReturn = function kReturn(value) {
  return { value: value, done: true };
};
function makeIterator(next) {
  var thro = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : kThrow;
  var name = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  var isHelper = arguments[3];

  var iterator = { name: name, next: next, throw: thro, return: kReturn };

  if (isHelper) {
    iterator[HELPER] = true;
  }
  if (typeof Symbol !== 'undefined') {
    iterator[Symbol.iterator] = function () {
      return iterator;
    };
  }
  return iterator;
}

/**
  Print error in a useful way whether in a browser environment
  (with expandable error stack traces), or in a node.js environment
  (text-only log output)
 **/
function log(level, message) {
  var error = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

  /*eslint-disable no-console*/
  if (typeof window === 'undefined') {
    console.log('redux-saga ' + level + ': ' + message + '\n' + (error && error.stack || error));
  } else {
    console[level](message, error);
  }
}

function deprecate(fn, deprecationWarning) {
  return function () {
    if (false) log('warn', deprecationWarning);
    return fn.apply(undefined, arguments);
  };
}

var updateIncentive = function updateIncentive(deprecated, preferred) {
  return deprecated + ' has been deprecated in favor of ' + preferred + ', please update your code';
};

var internalErr = function internalErr(err) {
  return new Error('\n  redux-saga: Error checking hooks detected an inconsistent state. This is likely a bug\n  in redux-saga code and not yours. Thanks for reporting this in the project\'s github repo.\n  Error: ' + err + '\n');
};

var createSetContextWarning = function createSetContextWarning(ctx, props) {
  return (ctx ? ctx + '.' : '') + 'setContext(props): argument ' + props + ' is not a plain object';
};

var wrapSagaDispatch = function wrapSagaDispatch(dispatch) {
  return function (action) {
    return dispatch(Object.defineProperty(action, SAGA_ACTION, { value: true }));
  };
};

var cloneableGenerator = function cloneableGenerator(generatorFunc) {
  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var history = [];
    var gen = generatorFunc.apply(undefined, args);
    return {
      next: function next(arg) {
        history.push(arg);
        return gen.next(arg);
      },
      clone: function clone() {
        var clonedGen = cloneableGenerator(generatorFunc).apply(undefined, args);
        history.forEach(function (arg) {
          return clonedGen.next(arg);
        });
        return clonedGen;
      },
      return: function _return(value) {
        return gen.return(value);
      },
      throw: function _throw(exception) {
        return gen.throw(exception);
      }
    };
  };
};

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(249);
var isBuffer = __webpack_require__(604);

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim
};


/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Page__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_Container__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_Heading__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_Preamble__ = __webpack_require__(30);
var ErrorPage=function ErrorPage(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Page__["a" /* default */],{title:'Error',bgColor:'#f2f2f2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__styles_Container__["a" /* Container */],{style:{minHeight:'450px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styles_Heading__["a" /* Heading */],{big:true,center:true},'N\xE5got gick fel!'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles_Preamble__["a" /* Preamble */],null,'N\xE5got gick fel n\xE4r vi f\xF6rs\xF6kte ladda in den h\xE4r sidan. Testa ladda om sidan p\xE5 nytt.')));};/* harmony default export */ __webpack_exports__["a"] = (ErrorPage);

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(729);


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(12);

module.exports = function (method, arg) {
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call
    arg ? method.call(null, function () { /* empty */ }, 1) : method.call(null);
  });
};


/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Page__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_Container__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_Heading__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_Preamble__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_Button__ = __webpack_require__(112);
var _templateObject=_taggedTemplateLiteral(['\n  width: auto;\n  display: block;\n  margin: 120px auto;\n  text-align: center;\n'],['\n  width: auto;\n  display: block;\n  margin: 120px auto;\n  text-align: center;\n']),_templateObject2=_taggedTemplateLiteral(['\n  width: auto;\n  display: inline-block;\n'],['\n  width: auto;\n  display: inline-block;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var NotFoundPage=function NotFoundPage(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Page__["a" /* default */],{title:'404',bgColor:'#f2f2f2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles_Container__["a" /* Container */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__styles_Heading__["a" /* Heading */],{big:true,center:true},'Sidan kunde inte hittas'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__styles_Preamble__["a" /* Preamble */],null,'Sidan du f\xF6rs\xF6kte bes\xF6ka kunde inte hittas.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ButtonContainer,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* Link */],{to:'/'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(BackButton,null,'Tillbaka till startsidan')))));};var ButtonContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject);var BackButton=__WEBPACK_IMPORTED_MODULE_7__styles_Button__["a" /* Button */].extend(_templateObject2);/* harmony default export */ __webpack_exports__["a"] = (NotFoundPage);

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(41);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 41 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 42 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(89);
var createDesc = __webpack_require__(56);
var toIObject = __webpack_require__(33);
var toPrimitive = __webpack_require__(50);
var has = __webpack_require__(31);
var IE8_DOM_DEFINE = __webpack_require__(171);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(21) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(3);
var core = __webpack_require__(20);
var fails = __webpack_require__(12);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__(40);
var IObject = __webpack_require__(88);
var toObject = __webpack_require__(24);
var toLength = __webpack_require__(17);
var asc = __webpack_require__(187);
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};


/***/ }),
/* 46 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 47 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

if (__webpack_require__(21)) {
  var LIBRARY = __webpack_require__(58);
  var global = __webpack_require__(11);
  var fails = __webpack_require__(12);
  var $export = __webpack_require__(3);
  var $typed = __webpack_require__(108);
  var $buffer = __webpack_require__(141);
  var ctx = __webpack_require__(40);
  var anInstance = __webpack_require__(77);
  var propertyDesc = __webpack_require__(56);
  var hide = __webpack_require__(32);
  var redefineAll = __webpack_require__(78);
  var toInteger = __webpack_require__(42);
  var toLength = __webpack_require__(17);
  var toIndex = __webpack_require__(198);
  var toAbsoluteIndex = __webpack_require__(60);
  var toPrimitive = __webpack_require__(50);
  var has = __webpack_require__(31);
  var classof = __webpack_require__(90);
  var isObject = __webpack_require__(14);
  var toObject = __webpack_require__(24);
  var isArrayIter = __webpack_require__(133);
  var create = __webpack_require__(61);
  var getPrototypeOf = __webpack_require__(63);
  var gOPN = __webpack_require__(62).f;
  var getIterFn = __webpack_require__(135);
  var uid = __webpack_require__(57);
  var wks = __webpack_require__(16);
  var createArrayMethod = __webpack_require__(45);
  var createArrayIncludes = __webpack_require__(98);
  var speciesConstructor = __webpack_require__(91);
  var ArrayIterators = __webpack_require__(137);
  var Iterators = __webpack_require__(75);
  var $iterDetect = __webpack_require__(101);
  var setSpecies = __webpack_require__(76);
  var arrayFill = __webpack_require__(136);
  var arrayCopyWithin = __webpack_require__(189);
  var $DP = __webpack_require__(22);
  var $GOPD = __webpack_require__(43);
  var dP = $DP.f;
  var gOPD = $GOPD.f;
  var RangeError = global.RangeError;
  var TypeError = global.TypeError;
  var Uint8Array = global.Uint8Array;
  var ARRAY_BUFFER = 'ArrayBuffer';
  var SHARED_BUFFER = 'Shared' + ARRAY_BUFFER;
  var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
  var PROTOTYPE = 'prototype';
  var ArrayProto = Array[PROTOTYPE];
  var $ArrayBuffer = $buffer.ArrayBuffer;
  var $DataView = $buffer.DataView;
  var arrayForEach = createArrayMethod(0);
  var arrayFilter = createArrayMethod(2);
  var arraySome = createArrayMethod(3);
  var arrayEvery = createArrayMethod(4);
  var arrayFind = createArrayMethod(5);
  var arrayFindIndex = createArrayMethod(6);
  var arrayIncludes = createArrayIncludes(true);
  var arrayIndexOf = createArrayIncludes(false);
  var arrayValues = ArrayIterators.values;
  var arrayKeys = ArrayIterators.keys;
  var arrayEntries = ArrayIterators.entries;
  var arrayLastIndexOf = ArrayProto.lastIndexOf;
  var arrayReduce = ArrayProto.reduce;
  var arrayReduceRight = ArrayProto.reduceRight;
  var arrayJoin = ArrayProto.join;
  var arraySort = ArrayProto.sort;
  var arraySlice = ArrayProto.slice;
  var arrayToString = ArrayProto.toString;
  var arrayToLocaleString = ArrayProto.toLocaleString;
  var ITERATOR = wks('iterator');
  var TAG = wks('toStringTag');
  var TYPED_CONSTRUCTOR = uid('typed_constructor');
  var DEF_CONSTRUCTOR = uid('def_constructor');
  var ALL_CONSTRUCTORS = $typed.CONSTR;
  var TYPED_ARRAY = $typed.TYPED;
  var VIEW = $typed.VIEW;
  var WRONG_LENGTH = 'Wrong length!';

  var $map = createArrayMethod(1, function (O, length) {
    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
  });

  var LITTLE_ENDIAN = fails(function () {
    // eslint-disable-next-line no-undef
    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
  });

  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function () {
    new Uint8Array(1).set({});
  });

  var toOffset = function (it, BYTES) {
    var offset = toInteger(it);
    if (offset < 0 || offset % BYTES) throw RangeError('Wrong offset!');
    return offset;
  };

  var validate = function (it) {
    if (isObject(it) && TYPED_ARRAY in it) return it;
    throw TypeError(it + ' is not a typed array!');
  };

  var allocate = function (C, length) {
    if (!(isObject(C) && TYPED_CONSTRUCTOR in C)) {
      throw TypeError('It is not a typed array constructor!');
    } return new C(length);
  };

  var speciesFromList = function (O, list) {
    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
  };

  var fromList = function (C, list) {
    var index = 0;
    var length = list.length;
    var result = allocate(C, length);
    while (length > index) result[index] = list[index++];
    return result;
  };

  var addGetter = function (it, key, internal) {
    dP(it, key, { get: function () { return this._d[internal]; } });
  };

  var $from = function from(source /* , mapfn, thisArg */) {
    var O = toObject(source);
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var iterFn = getIterFn(O);
    var i, length, values, result, step, iterator;
    if (iterFn != undefined && !isArrayIter(iterFn)) {
      for (iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++) {
        values.push(step.value);
      } O = values;
    }
    if (mapping && aLen > 2) mapfn = ctx(mapfn, arguments[2], 2);
    for (i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++) {
      result[i] = mapping ? mapfn(O[i], i) : O[i];
    }
    return result;
  };

  var $of = function of(/* ...items */) {
    var index = 0;
    var length = arguments.length;
    var result = allocate(this, length);
    while (length > index) result[index] = arguments[index++];
    return result;
  };

  // iOS Safari 6.x fails here
  var TO_LOCALE_BUG = !!Uint8Array && fails(function () { arrayToLocaleString.call(new Uint8Array(1)); });

  var $toLocaleString = function toLocaleString() {
    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
  };

  var proto = {
    copyWithin: function copyWithin(target, start /* , end */) {
      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
    },
    every: function every(callbackfn /* , thisArg */) {
      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    fill: function fill(value /* , start, end */) { // eslint-disable-line no-unused-vars
      return arrayFill.apply(validate(this), arguments);
    },
    filter: function filter(callbackfn /* , thisArg */) {
      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
        arguments.length > 1 ? arguments[1] : undefined));
    },
    find: function find(predicate /* , thisArg */) {
      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    findIndex: function findIndex(predicate /* , thisArg */) {
      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    forEach: function forEach(callbackfn /* , thisArg */) {
      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    indexOf: function indexOf(searchElement /* , fromIndex */) {
      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    includes: function includes(searchElement /* , fromIndex */) {
      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    join: function join(separator) { // eslint-disable-line no-unused-vars
      return arrayJoin.apply(validate(this), arguments);
    },
    lastIndexOf: function lastIndexOf(searchElement /* , fromIndex */) { // eslint-disable-line no-unused-vars
      return arrayLastIndexOf.apply(validate(this), arguments);
    },
    map: function map(mapfn /* , thisArg */) {
      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    reduce: function reduce(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduce.apply(validate(this), arguments);
    },
    reduceRight: function reduceRight(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduceRight.apply(validate(this), arguments);
    },
    reverse: function reverse() {
      var that = this;
      var length = validate(that).length;
      var middle = Math.floor(length / 2);
      var index = 0;
      var value;
      while (index < middle) {
        value = that[index];
        that[index++] = that[--length];
        that[length] = value;
      } return that;
    },
    some: function some(callbackfn /* , thisArg */) {
      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    sort: function sort(comparefn) {
      return arraySort.call(validate(this), comparefn);
    },
    subarray: function subarray(begin, end) {
      var O = validate(this);
      var length = O.length;
      var $begin = toAbsoluteIndex(begin, length);
      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
        O.buffer,
        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
        toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - $begin)
      );
    }
  };

  var $slice = function slice(start, end) {
    return speciesFromList(this, arraySlice.call(validate(this), start, end));
  };

  var $set = function set(arrayLike /* , offset */) {
    validate(this);
    var offset = toOffset(arguments[1], 1);
    var length = this.length;
    var src = toObject(arrayLike);
    var len = toLength(src.length);
    var index = 0;
    if (len + offset > length) throw RangeError(WRONG_LENGTH);
    while (index < len) this[offset + index] = src[index++];
  };

  var $iterators = {
    entries: function entries() {
      return arrayEntries.call(validate(this));
    },
    keys: function keys() {
      return arrayKeys.call(validate(this));
    },
    values: function values() {
      return arrayValues.call(validate(this));
    }
  };

  var isTAIndex = function (target, key) {
    return isObject(target)
      && target[TYPED_ARRAY]
      && typeof key != 'symbol'
      && key in target
      && String(+key) == String(key);
  };
  var $getDesc = function getOwnPropertyDescriptor(target, key) {
    return isTAIndex(target, key = toPrimitive(key, true))
      ? propertyDesc(2, target[key])
      : gOPD(target, key);
  };
  var $setDesc = function defineProperty(target, key, desc) {
    if (isTAIndex(target, key = toPrimitive(key, true))
      && isObject(desc)
      && has(desc, 'value')
      && !has(desc, 'get')
      && !has(desc, 'set')
      // TODO: add validation descriptor w/o calling accessors
      && !desc.configurable
      && (!has(desc, 'writable') || desc.writable)
      && (!has(desc, 'enumerable') || desc.enumerable)
    ) {
      target[key] = desc.value;
      return target;
    } return dP(target, key, desc);
  };

  if (!ALL_CONSTRUCTORS) {
    $GOPD.f = $getDesc;
    $DP.f = $setDesc;
  }

  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
    getOwnPropertyDescriptor: $getDesc,
    defineProperty: $setDesc
  });

  if (fails(function () { arrayToString.call({}); })) {
    arrayToString = arrayToLocaleString = function toString() {
      return arrayJoin.call(this);
    };
  }

  var $TypedArrayPrototype$ = redefineAll({}, proto);
  redefineAll($TypedArrayPrototype$, $iterators);
  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
  redefineAll($TypedArrayPrototype$, {
    slice: $slice,
    set: $set,
    constructor: function () { /* noop */ },
    toString: arrayToString,
    toLocaleString: $toLocaleString
  });
  addGetter($TypedArrayPrototype$, 'buffer', 'b');
  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
  addGetter($TypedArrayPrototype$, 'length', 'e');
  dP($TypedArrayPrototype$, TAG, {
    get: function () { return this[TYPED_ARRAY]; }
  });

  // eslint-disable-next-line max-statements
  module.exports = function (KEY, BYTES, wrapper, CLAMPED) {
    CLAMPED = !!CLAMPED;
    var NAME = KEY + (CLAMPED ? 'Clamped' : '') + 'Array';
    var GETTER = 'get' + KEY;
    var SETTER = 'set' + KEY;
    var TypedArray = global[NAME];
    var Base = TypedArray || {};
    var TAC = TypedArray && getPrototypeOf(TypedArray);
    var FORCED = !TypedArray || !$typed.ABV;
    var O = {};
    var TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
    var getter = function (that, index) {
      var data = that._d;
      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
    };
    var setter = function (that, index, value) {
      var data = that._d;
      if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
    };
    var addElement = function (that, index) {
      dP(that, index, {
        get: function () {
          return getter(this, index);
        },
        set: function (value) {
          return setter(this, index, value);
        },
        enumerable: true
      });
    };
    if (FORCED) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME, '_d');
        var index = 0;
        var offset = 0;
        var buffer, byteLength, length, klass;
        if (!isObject(data)) {
          length = toIndex(data);
          byteLength = length * BYTES;
          buffer = new $ArrayBuffer(byteLength);
        } else if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          buffer = data;
          offset = toOffset($offset, BYTES);
          var $len = data.byteLength;
          if ($length === undefined) {
            if ($len % BYTES) throw RangeError(WRONG_LENGTH);
            byteLength = $len - offset;
            if (byteLength < 0) throw RangeError(WRONG_LENGTH);
          } else {
            byteLength = toLength($length) * BYTES;
            if (byteLength + offset > $len) throw RangeError(WRONG_LENGTH);
          }
          length = byteLength / BYTES;
        } else if (TYPED_ARRAY in data) {
          return fromList(TypedArray, data);
        } else {
          return $from.call(TypedArray, data);
        }
        hide(that, '_d', {
          b: buffer,
          o: offset,
          l: byteLength,
          e: length,
          v: new $DataView(buffer)
        });
        while (index < length) addElement(that, index++);
      });
      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
      hide(TypedArrayPrototype, 'constructor', TypedArray);
    } else if (!fails(function () {
      TypedArray(1);
    }) || !fails(function () {
      new TypedArray(-1); // eslint-disable-line no-new
    }) || !$iterDetect(function (iter) {
      new TypedArray(); // eslint-disable-line no-new
      new TypedArray(null); // eslint-disable-line no-new
      new TypedArray(1.5); // eslint-disable-line no-new
      new TypedArray(iter); // eslint-disable-line no-new
    }, true)) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME);
        var klass;
        // `ws` module bug, temporarily remove validation length for Uint8Array
        // https://github.com/websockets/ws/pull/645
        if (!isObject(data)) return new Base(toIndex(data));
        if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          return $length !== undefined
            ? new Base(data, toOffset($offset, BYTES), $length)
            : $offset !== undefined
              ? new Base(data, toOffset($offset, BYTES))
              : new Base(data);
        }
        if (TYPED_ARRAY in data) return fromList(TypedArray, data);
        return $from.call(TypedArray, data);
      });
      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function (key) {
        if (!(key in TypedArray)) hide(TypedArray, key, Base[key]);
      });
      TypedArray[PROTOTYPE] = TypedArrayPrototype;
      if (!LIBRARY) TypedArrayPrototype.constructor = TypedArray;
    }
    var $nativeIterator = TypedArrayPrototype[ITERATOR];
    var CORRECT_ITER_NAME = !!$nativeIterator
      && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined);
    var $iterator = $iterators.values;
    hide(TypedArray, TYPED_CONSTRUCTOR, true);
    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
    hide(TypedArrayPrototype, VIEW, true);
    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);

    if (CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)) {
      dP(TypedArrayPrototype, TAG, {
        get: function () { return NAME; }
      });
    }

    O[NAME] = TypedArray;

    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);

    $export($export.S, NAME, {
      BYTES_PER_ELEMENT: BYTES
    });

    $export($export.S + $export.F * fails(function () { Base.of.call(TypedArray, 1); }), NAME, {
      from: $from,
      of: $of
    });

    if (!(BYTES_PER_ELEMENT in TypedArrayPrototype)) hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);

    $export($export.P, NAME, proto);

    setSpecies(NAME);

    $export($export.P + $export.F * FORCED_SET, NAME, { set: $set });

    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);

    if (!LIBRARY && TypedArrayPrototype.toString != arrayToString) TypedArrayPrototype.toString = arrayToString;

    $export($export.P + $export.F * fails(function () {
      new TypedArray(1).slice();
    }), NAME, { slice: $slice });

    $export($export.P + $export.F * (fails(function () {
      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString();
    }) || !fails(function () {
      TypedArrayPrototype.toLocaleString.call([1, 2]);
    })), NAME, { toLocaleString: $toLocaleString });

    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
    if (!LIBRARY && !CORRECT_ITER_NAME) hide(TypedArrayPrototype, ITERATOR, $iterator);
  };
} else module.exports = function () { /* empty */ };


/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__combineReducers__ = __webpack_require__(487);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bindActionCreators__ = __webpack_require__(488);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__applyMiddleware__ = __webpack_require__(489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__compose__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_warning__ = __webpack_require__(213);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_0__createStore__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__combineReducers__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__bindActionCreators__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_3__applyMiddleware__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_4__compose__["a"]; });







/*
* This is a dummy function to check if the function name has been altered by minification.
* If the function has been minified and NODE_ENV !== 'production', warn the user.
*/
function isCrushed() {}

if (false) {
  warning('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
}



/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(14);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(57)('meta');
var isObject = __webpack_require__(14);
var has = __webpack_require__(31);
var setDesc = __webpack_require__(22).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(12)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "production" !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  }

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;


/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export detach */
/* harmony export (immutable) */ __webpack_exports__["g"] = take;
/* unused harmony export takem */
/* harmony export (immutable) */ __webpack_exports__["f"] = put;
/* unused harmony export all */
/* unused harmony export race */
/* harmony export (immutable) */ __webpack_exports__["c"] = call;
/* unused harmony export apply */
/* unused harmony export cps */
/* harmony export (immutable) */ __webpack_exports__["e"] = fork;
/* unused harmony export spawn */
/* unused harmony export join */
/* harmony export (immutable) */ __webpack_exports__["d"] = cancel;
/* unused harmony export select */
/* harmony export (immutable) */ __webpack_exports__["a"] = actionChannel;
/* unused harmony export cancelled */
/* unused harmony export flush */
/* unused harmony export getContext */
/* unused harmony export setContext */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return asEffect; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(34);


var IO = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__utils__["u" /* sym */])('IO');
var TAKE = 'TAKE';
var PUT = 'PUT';
var ALL = 'ALL';
var RACE = 'RACE';
var CALL = 'CALL';
var CPS = 'CPS';
var FORK = 'FORK';
var JOIN = 'JOIN';
var CANCEL = 'CANCEL';
var SELECT = 'SELECT';
var ACTION_CHANNEL = 'ACTION_CHANNEL';
var CANCELLED = 'CANCELLED';
var FLUSH = 'FLUSH';
var GET_CONTEXT = 'GET_CONTEXT';
var SET_CONTEXT = 'SET_CONTEXT';

var TEST_HINT = '\n(HINT: if you are getting this errors in tests, consider using createMockTask from redux-saga/utils)';

var effect = function effect(type, payload) {
  var _ref;

  return _ref = {}, _ref[IO] = true, _ref[type] = payload, _ref;
};

var detach = function detach(eff) {
  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(asEffect.fork(eff), __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].object, 'detach(eff): argument must be a fork effect');
  eff[FORK].detached = true;
  return eff;
};

function take() {
  var patternOrChannel = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '*';

  if (arguments.length) {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(arguments[0], __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].notUndef, 'take(patternOrChannel): patternOrChannel is undefined');
  }
  if (__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].pattern(patternOrChannel)) {
    return effect(TAKE, { pattern: patternOrChannel });
  }
  if (__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].channel(patternOrChannel)) {
    return effect(TAKE, { channel: patternOrChannel });
  }
  throw new Error('take(patternOrChannel): argument ' + String(patternOrChannel) + ' is not valid channel or a valid pattern');
}

take.maybe = function () {
  var eff = take.apply(undefined, arguments);
  eff[TAKE].maybe = true;
  return eff;
};

var takem = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__utils__["k" /* deprecate */])(take.maybe, /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__utils__["w" /* updateIncentive */])('takem', 'take.maybe'));

function put(channel, action) {
  if (arguments.length > 1) {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(channel, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].notUndef, 'put(channel, action): argument channel is undefined');
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(channel, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].channel, 'put(channel, action): argument ' + channel + ' is not a valid channel');
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(action, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].notUndef, 'put(channel, action): argument action is undefined');
  } else {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(channel, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].notUndef, 'put(action): argument action is undefined');
    action = channel;
    channel = null;
  }
  return effect(PUT, { channel: channel, action: action });
}

put.resolve = function () {
  var eff = put.apply(undefined, arguments);
  eff[PUT].resolve = true;
  return eff;
};

put.sync = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__utils__["k" /* deprecate */])(put.resolve, /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__utils__["w" /* updateIncentive */])('put.sync', 'put.resolve'));

function all(effects) {
  return effect(ALL, effects);
}

function race(effects) {
  return effect(RACE, effects);
}

function getFnCallDesc(meth, fn, args) {
  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(fn, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].notUndef, meth + ': argument fn is undefined');

  var context = null;
  if (__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].array(fn)) {
    var _fn = fn;
    context = _fn[0];
    fn = _fn[1];
  } else if (fn.fn) {
    var _fn2 = fn;
    context = _fn2.context;
    fn = _fn2.fn;
  }
  if (context && __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].string(fn) && __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func(context[fn])) {
    fn = context[fn];
  }
  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(fn, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func, meth + ': argument ' + fn + ' is not a function');

  return { context: context, fn: fn, args: args };
}

function call(fn) {
  for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  return effect(CALL, getFnCallDesc('call', fn, args));
}

function apply(context, fn) {
  var args = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

  return effect(CALL, getFnCallDesc('apply', { context: context, fn: fn }, args));
}

function cps(fn) {
  for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    args[_key2 - 1] = arguments[_key2];
  }

  return effect(CPS, getFnCallDesc('cps', fn, args));
}

function fork(fn) {
  for (var _len3 = arguments.length, args = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
    args[_key3 - 1] = arguments[_key3];
  }

  return effect(FORK, getFnCallDesc('fork', fn, args));
}

function spawn(fn) {
  for (var _len4 = arguments.length, args = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
    args[_key4 - 1] = arguments[_key4];
  }

  return detach(fork.apply(undefined, [fn].concat(args)));
}

function join() {
  for (var _len5 = arguments.length, tasks = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
    tasks[_key5] = arguments[_key5];
  }

  if (tasks.length > 1) {
    return all(tasks.map(function (t) {
      return join(t);
    }));
  }
  var task = tasks[0];
  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(task, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].notUndef, 'join(task): argument task is undefined');
  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(task, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].task, 'join(task): argument ' + task + ' is not a valid Task object ' + TEST_HINT);
  return effect(JOIN, task);
}

function cancel() {
  for (var _len6 = arguments.length, tasks = Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
    tasks[_key6] = arguments[_key6];
  }

  if (tasks.length > 1) {
    return all(tasks.map(function (t) {
      return cancel(t);
    }));
  }
  var task = tasks[0];
  if (tasks.length === 1) {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(task, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].notUndef, 'cancel(task): argument task is undefined');
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(task, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].task, 'cancel(task): argument ' + task + ' is not a valid Task object ' + TEST_HINT);
  }
  return effect(CANCEL, task || __WEBPACK_IMPORTED_MODULE_0__utils__["d" /* SELF_CANCELLATION */]);
}

function select(selector) {
  for (var _len7 = arguments.length, args = Array(_len7 > 1 ? _len7 - 1 : 0), _key7 = 1; _key7 < _len7; _key7++) {
    args[_key7 - 1] = arguments[_key7];
  }

  if (arguments.length === 0) {
    selector = __WEBPACK_IMPORTED_MODULE_0__utils__["l" /* ident */];
  } else {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(selector, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].notUndef, 'select(selector,[...]): argument selector is undefined');
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(selector, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func, 'select(selector,[...]): argument ' + selector + ' is not a function');
  }
  return effect(SELECT, { selector: selector, args: args });
}

/**
  channel(pattern, [buffer])    => creates an event channel for store actions
**/
function actionChannel(pattern, buffer) {
  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(pattern, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].notUndef, 'actionChannel(pattern,...): argument pattern is undefined');
  if (arguments.length > 1) {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(buffer, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].notUndef, 'actionChannel(pattern, buffer): argument buffer is undefined');
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(buffer, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].buffer, 'actionChannel(pattern, buffer): argument ' + buffer + ' is not a valid buffer');
  }
  return effect(ACTION_CHANNEL, { pattern: pattern, buffer: buffer });
}

function cancelled() {
  return effect(CANCELLED, {});
}

function flush(channel) {
  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(channel, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].channel, 'flush(channel): argument ' + channel + ' is not valid channel');
  return effect(FLUSH, channel);
}

function getContext(prop) {
  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(prop, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].string, 'getContext(prop): argument ' + prop + ' is not a string');
  return effect(GET_CONTEXT, prop);
}

function setContext(props) {
  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(props, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].object, Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* createSetContextWarning */])(null, props));
  return effect(SET_CONTEXT, props);
}

var createAsEffectType = function createAsEffectType(type) {
  return function (effect) {
    return effect && effect[IO] && effect[type];
  };
};

var asEffect = {
  take: /*#__PURE__*/createAsEffectType(TAKE),
  put: /*#__PURE__*/createAsEffectType(PUT),
  all: /*#__PURE__*/createAsEffectType(ALL),
  race: /*#__PURE__*/createAsEffectType(RACE),
  call: /*#__PURE__*/createAsEffectType(CALL),
  cps: /*#__PURE__*/createAsEffectType(CPS),
  fork: /*#__PURE__*/createAsEffectType(FORK),
  join: /*#__PURE__*/createAsEffectType(JOIN),
  cancel: /*#__PURE__*/createAsEffectType(CANCEL),
  select: /*#__PURE__*/createAsEffectType(SELECT),
  actionChannel: /*#__PURE__*/createAsEffectType(ACTION_CHANNEL),
  cancelled: /*#__PURE__*/createAsEffectType(CANCELLED),
  flush: /*#__PURE__*/createAsEffectType(FLUSH),
  getContext: /*#__PURE__*/createAsEffectType(GET_CONTEXT),
  setContext: /*#__PURE__*/createAsEffectType(SET_CONTEXT)
};

/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getProductsByList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getProductsByArray; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getQuickSearchProductsByList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getProductsByKey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getProductsByKeys; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getFilteredProducts; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(558);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutable__);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var getProducts=function getProducts(store){return store.products.data||Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])();};var getSearchResult=function getSearchResult(store){return store.globalSearch.results||Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])();};var getQuickSearchResult=function getQuickSearchResult(store){return store.quickSearch.results||Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])();};var getProductsByArrayOfIds=function getProductsByArrayOfIds(store){var arrayOfIds=arguments.length>1&&arguments[1]!==undefined?arguments[1]:[];return arrayOfIds.reduce(function(memo,id){return Object.assign(_defineProperty({},id,store.products.data.get(id)),memo);},{});};var getProductsByFilter=function getProductsByFilter(store,filterKeyArray,filterValue){return store.products.data.filter(function(item){// If the product does not contain the filterValue, exclude it.
if(!item.getIn(filterKeyArray)){return false;}return item.getIn(filterKeyArray).includes(filterValue);});};var getProductsByFilters=function getProductsByFilters(store,filterKeyArray,filterValue){return store.products.data.filter(function(item){// If the product does not contain the filterValue, exclude it.
if(!item.getIn(filterKeyArray)){return false;}return item.getIn(filterKeyArray).includes(filterValue);});};var getSortOrder=function getSortOrder(store){return store.viewstate.get('sortBy','name');};var getSortAscending=function getSortAscending(store){return store.viewstate.get('sortAscending',false);};var getColorFilter=function getColorFilter(store){return store.viewstate.getIn(['filter','color'],Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["List"])()).keySeq();};var getMaterialFilter=function getMaterialFilter(store){return store.viewstate.getIn(['filter','material'],Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["List"])()).keySeq();};var getManufacturerFilter=function getManufacturerFilter(store){return store.viewstate.getIn(['filter','manufacturer'],Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["List"])()).keySeq();};var getCategoryFilter=function getCategoryFilter(store){return store.viewstate.getIn(['filter','category'],Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["List"])()).keySeq();};var getProductsByList=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([getProducts,getSearchResult],function(products,searchResult){return products.filter(function(product){return searchResult.getIn(['products','hits'],Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["List"])()).map(function(result){return result.get('id');}).includes(product.get('id'));});});var getProductsByArray=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([getProductsByArrayOfIds],function(products){return Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])(products);});var getQuickSearchProductsByList=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([getProducts,getQuickSearchResult],function(products,searchResult){return products.filter(function(product){return searchResult.getIn(['products','hits'],Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["List"])()).map(function(result){return result.get('id');}).includes(product.get('id'));});});var getProductsByKey=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([getProductsByFilter],function(products){return products;});var getProductsByKeys=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([getProductsByFilters],function(products){return products;});var dynamicProductList=function dynamicProductList(store,productList){return productList;};var checkColorOfVariants=function checkColorOfVariants(product,colorFilters){var matchedVariants=product.get('variants').filter(function(variant){return colorFilters.includes(variant.get('filterColor'));});return matchedVariants.size>0;};var getFilteredProducts=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([dynamicProductList,getColorFilter,getMaterialFilter,getManufacturerFilter,getCategoryFilter,getSortOrder,getSortAscending],function(products,colorFilter,materialFilter,manufacturerFilter,categoryFilter,sortOrder,sortAscending){return products.filter(function(p){return colorFilter.size===0||checkColorOfVariants(p,colorFilter);}).filter(function(p){return manufacturerFilter.size===0||manufacturerFilter.includes(p.getIn(['brand','name']));}).filter(function(p){return materialFilter.size===0||materialFilter.includes(p.getIn(['specifications','material']));}).filter(function(p){return categoryFilter.size===0||categoryFilter.includes(p.getIn(['category','name']));}).sort(function(a,b){var isAString=typeof a.get(sortOrder)==='string';var isBString=typeof b.get(sortOrder)==='string';if(isAString&&isBString){var aLowerCase=a.get(sortOrder).toLowerCase();var bLowerCase=b.get(sortOrder).toLowerCase();if(aLowerCase<bLowerCase){return sortAscending?1:-1;}else if(aLowerCase>bLowerCase){return sortAscending?-1:1;}}else if(a.get(sortOrder)<b.get(sortOrder)){return sortAscending?1:-1;}else if(a.get(sortOrder)>b.get(sortOrder)){return sortAscending?-1:1;}return 0;});});

/***/ }),
/* 56 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 57 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 58 */
/***/ (function(module, exports) {

module.exports = false;


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(173);
var enumBugKeys = __webpack_require__(120);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(42);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(13);
var dPs = __webpack_require__(174);
var enumBugKeys = __webpack_require__(120);
var IE_PROTO = __webpack_require__(119)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(117)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(121).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(173);
var hiddenKeys = __webpack_require__(120).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(31);
var toObject = __webpack_require__(24);
var IE_PROTO = __webpack_require__(119)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = __webpack_require__(16)('unscopables');
var ArrayProto = Array.prototype;
if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(32)(ArrayProto, UNSCOPABLES, {});
module.exports = function (key) {
  ArrayProto[UNSCOPABLES][key] = true;
};


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(14);
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};


/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_toCurrency__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_Price__ = __webpack_require__(587);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_helpers_variables__ = __webpack_require__(4);
var _templateObject=_taggedTemplateLiteral(['\n  margin-bottom: 1em;\n  margin-top: 0.35em;\n\n  ',';\n  ',';\n'],['\n  margin-bottom: 1em;\n  margin-top: 0.35em;\n\n  ',';\n  ',';\n']),_templateObject2=_taggedTemplateLiteral(['\n      display: inline-block;\n      margin: 0;\n    '],['\n      display: inline-block;\n      margin: 0;\n    ']),_templateObject3=_taggedTemplateLiteral(['\n      margin: 0 0 30px;\n    '],['\n      margin: 0 0 30px;\n    ']),_templateObject4=_taggedTemplateLiteral(['\n  color: ',';\n  font-size: 12px;\n  text-transform: uppercase;\n'],['\n  color: ',';\n  font-size: 12px;\n  text-transform: uppercase;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var RenderPrice=function RenderPrice(props){var isOnSale=props.originalPrice&&props.price<props.originalPrice;var priceWithCurrentOptions=props.price+props.currentOptionsPrice;var originalPriceWithCurrentOptions=props.originalPrice+props.currentOptionsPrice;if(isOnSale){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(RenderPriceContainer,{inline:props.inline,productPage:props.productPage},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles_Price__["a" /* Price */],{fontWeight:props.fontWeight,fontSize:props.fontSize,inline:true,small:props.small,sale:originalPriceWithCurrentOptions},props.priceFrom?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PriceFromText,null,'Fr\xE5n'):false,' ',Object(__WEBPACK_IMPORTED_MODULE_3__util_toCurrency__["a" /* toCurrency */])(priceWithCurrentOptions)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles_Price__["a" /* Price */],{fontSize:props.fontSize,small:props.small,inline:true,originalPrice:true},'(',Object(__WEBPACK_IMPORTED_MODULE_3__util_toCurrency__["a" /* toCurrency */])(originalPriceWithCurrentOptions),')'));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(RenderPriceContainer,{inline:props.inline,productPage:props.productPage},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles_Price__["a" /* Price */],{inline:props.inline,fontWeight:props.fontWeight,fontSize:props.fontSize,small:props.small,sale:isOnSale},props.priceFrom?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PriceFromText,null,'Fr\xE5n'):false,' ',Object(__WEBPACK_IMPORTED_MODULE_3__util_toCurrency__["a" /* toCurrency */])(priceWithCurrentOptions)));};var RenderPriceContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject,function(props){return props.inline&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject2);},function(props){return props.productPage&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject3);});var PriceFromText=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].span(_templateObject4,__WEBPACK_IMPORTED_MODULE_5__styles_helpers_variables__["c" /* color */].darkerGrey);RenderPrice.defaultProps={fontWeight:'600',inline:false,fontSize:null,small:false,currentOptionsPrice:null,price:null,originalPrice:null,priceFrom:false,productPage:false};RenderPrice.propTypes={inline:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,fontSize:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,small:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,fontWeight:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,currentOptionsPrice:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,price:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,originalPrice:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,priceFrom:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,productPage:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (RenderPrice);

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return toCurrency; });
var toCurrency=function toCurrency(priceAsNumber){// check if priceAsNumber has a value and is a number type
if(typeof priceAsNumber==='number'){// if the number has decimals, change it to always have 2 decimals
var priceAsNumberWithCorrectDecimals=priceAsNumber%1===0?priceAsNumber:priceAsNumber.toFixed(2);var priceString=priceAsNumberWithCorrectDecimals.toString()// stringify our price number
.replace(/\B(?=(\d{3})+(?!\d))/g,' ')// add space as thousand separator
.replace(/\.([0-9]{2})$/g,',$1');// replace decimal divider "." with a ","
return priceString+' kr';}return false;};

/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return analyticsPageViewEvent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return analyticsCheckoutEvent; });
/* unused harmony export checkoutOptionEvent */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return analyticsPurchaseEvent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return analyticsImpressionEvent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return analyticsDetailEvent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return analyticsProductClickEvent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutable__);
var analyticsPageViewEvent=function analyticsPageViewEvent(){if(window.dataLayer){return window.dataLayer.push({event:'pageView'});}return false;};var analyticsCheckoutEvent=function analyticsCheckoutEvent(event,step,cart){var products=cart.map(function(cartProducts){var product=cartProducts.get('product',Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])());return{id:product.get('id'),name:product.get('name'),price:product.get('price'),brand:product.getIn(['brand','name']),category:product.get('category'),quantity:cartProducts.get('quantity')};}).toArray();var eventObject={event:event,currencyCode:'SEK',actionField:{step:step},ecommerce:{checkout:{products:products}}};if(window.dataLayer){return window.dataLayer.push(eventObject);}return false;};analyticsCheckoutEvent.propTypes={eventName:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,listName:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,productList:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_1_immutable__["List"])};var checkoutOptionEvent=function checkoutOptionEvent(id){var actionField={};if(id==='a2900935-db16-4cfd-ba2e-a529317f4321'){actionField={step:1,option:'Standard'};}if(id==='a60cfdb6-c8a5-40df-8dca-e6fe9bf1f712'){actionField={step:2,option:'Store'};}if(window.dataLayer){return window.dataLayer.push({event:'checkoutOption',ecommerce:{checkout_option:{actionField:actionField}}});}return false;};var analyticsPurchaseEvent=function analyticsPurchaseEvent(purchaseId,cart){var productList=cart.get('cart',Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])()).map(function(item){return{name:item.getIn(['product','name']),id:item.getIn(['product','id']),price:item.getIn(['product','price']),brand:item.getIn(['product','brand','name']),category:item.get('categoryName'),quantity:item.get('quantity')};}).toArray();var eventObject={event:'purchase',ecommerce:{purchase:{actionField:{id:purchaseId,affiliation:'Online Store',revenue:cart.get('grandTotalPrice'),tax:cart.get('vat'),shipping:typeof cart.get('deliveryCost')==='number'?cart.get('deliveryCost'):0,coupon:cart.get('totalCampaignPrice')},products:productList}},eventCallback:function eventCallback(){return document.location.pathname==='/tack';}};if(window.dataLayer){return window.dataLayer.push(eventObject);}return false;};analyticsPurchaseEvent.propTypes={purchaseId:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,cart:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_1_immutable__["List"]).isRequired,revenue:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired,tax:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired,shipping:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired,coupon:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired};var analyticsImpressionEvent=function analyticsImpressionEvent(eventName,listName,productList){var position=0;var list=productList.toList();var impressionsList=list.map(function(baseProduct){position+=1;return{name:baseProduct.get('name'),id:baseProduct.get('defaultVariantId'),price:baseProduct.get('price'),brand:baseProduct.getIn(['brand','name']),category:baseProduct.getIn(['category','name']),list:listName||baseProduct.getIn(['category','name']),position:position,dimension1:'campaign price'};}// baseProduct.get('variants', List()).map(variant => {
//   position += 1;
//   return {
//     name: variant.get('name'),
//     id: variant.get('id'),
//     price: variant.get('price'),
//     brand: baseProduct.getIn(['brand', 'name']),
//     category: baseProduct.getIn(['category', 'name']),
//     list: listName,
//     position,
//     dimension1: 'campaign price'
//   };
// })
);// .reduce((memory, item) => [...memory, ...item], []);
var eventObject={event:eventName,ecommerce:{impressions:impressionsList.toJSON()}};if(window.dataLayer){return window.dataLayer.push(eventObject);}return false;};analyticsImpressionEvent.propTypes={eventName:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,listName:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,productList:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_1_immutable__["List"])};var analyticsDetailEvent=function analyticsDetailEvent(eventName,product){var productList=[{name:product.get('name'),id:product.get('id'),price:product.get('price'),brand:product.getIn(['brand','name']),category:product.getIn(['category','name']),dimension1:'campaign price'}];var eventObject={event:eventName,ecommerce:{detail:{actionField:{list:product.getIn(['category','name'])},products:productList}}};if(window.dataLayer){return window.dataLayer.push(eventObject);}return false;};analyticsDetailEvent.propTypes={eventName:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,product:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])};var analyticsProductClickEvent=function analyticsProductClickEvent(eventName,listName,product){var productList=[{name:product.get('name'),id:product.get('id'),price:product.get('price'),brand:product.getIn(['brand','name']),category:product.getIn(['category','name']),dimension1:'campaign price'}];var eventObject={event:eventName,ecommerce:{click:{actionField:{list:listName,action:'click'},products:productList}}};if(window.dataLayer){return window.dataLayer.push(eventObject);}return false;};

/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_LinedHeading__ = __webpack_require__(620);
var LinedHeading=function LinedHeading(props){return(/** adjustToScrollMargin: temporary solution for scrolling to correct pos. See handleScrollToElement in BrandListPage */__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__styles_LinedHeading__["a" /* LinedHeadingContainer */],{adjustToScrollMargin:props.adjustScroll,noMargin:props.noMargin,noBottomMargin:props.noBottomMargin,bgColor:props.bgColor},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__styles_LinedHeading__["b" /* LinedHeadingText */],{smallestFontSizeBound:props.smallestFontSizeBound,color:props.color},props.children)));};LinedHeading.defaultProps={noMargin:false,noBottomMargin:false,adjustScroll:false,smallestFontSizeBound:null,bgColor:null,color:null,children:[]};LinedHeading.propTypes={noMargin:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,noBottomMargin:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,bgColor:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,color:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,adjustScroll:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,smallestFontSizeBound:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,children:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node),__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node])};/* harmony default export */ __webpack_exports__["a"] = (LinedHeading);

/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_connect__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_ProductList__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Filters__ = __webpack_require__(653);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_MobileNav__ = __webpack_require__(655);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_Heading__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_SlideOutContainer__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Accordion__ = __webpack_require__(656);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_AccordionItemWithText__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_FiltersList__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_SortingList__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__styles_Pagination__ = __webpack_require__(657);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__styles_PaginationContainer__ = __webpack_require__(658);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__styles_Icon__ = __webpack_require__(659);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__styles_FilterOption__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__styles_Container__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__styles_DividerLine__ = __webpack_require__(660);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__styles_NoProductsFound__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__actions_actionCreators__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__LoadingSpinner__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__selectors_reselectCategory__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__styles_helpers_variables__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProductListWithFilters=function(_Component){_inherits(ProductListWithFilters,_Component);function ProductListWithFilters(props){_classCallCheck(this,ProductListWithFilters);var _this=_possibleConstructorReturn(this,(ProductListWithFilters.__proto__||Object.getPrototypeOf(ProductListWithFilters)).call(this,props));_this.state={isModalActive:false,scrollHeight:0,pages:1,productsPerPage:24};_this.toggleModal=_this.toggleModal.bind(_this);_this.setPages=_this.setPages.bind(_this);return _this;}_createClass(ProductListWithFilters,[{key:'componentDidMount',value:function componentDidMount(){var informationCardOffset=!this.props.informationCard.isEmpty()?2:0;this.setPages(this.props.filteredProducts,informationCardOffset);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var informationCardOffset=!nextProps.informationCard.isEmpty()?2:0;this.setPages(nextProps.filteredProducts,informationCardOffset);// commented out since it reset product list pagination on navigation - https://cloudnineab.freshdesk.com/a/tickets/7671
/*
    if (!nextProps.filteredProducts.equals(this.props.filteredProducts)) {
      this.props.setViewstate('pagination', 0);
    }
    */// this is a fix for when a pagination number is higher than the amount of pages
if(nextProps.filteredProducts.size>0&&nextProps.viewstate.get('pagination')*this.state.productsPerPage-informationCardOffset+1>nextProps.filteredProducts.size){this.props.setViewstate('pagination',0);}}},{key:'setPages',value:function setPages(filteredProducts,informationCardOffset){var _this2=this;this.setState(function(){return{pages:filteredProducts.size?Math.ceil((filteredProducts.size+informationCardOffset)/_this2.state.productsPerPage):1};});}},{key:'toggleModal',value:function toggleModal(modal){if(!this.state.isModalActive){this.setState({isModalActive:modal,scrollHeight:window.pageYOffset});}else{this.setState({isModalActive:false});}}},{key:'areProductsFiltered',value:function areProductsFiltered(originalProducts,filteredProducts){if(originalProducts&&filteredProducts){return originalProducts.size!==filteredProducts.size;}return false;}},{key:'changePage',value:function changePage(page){if(this.filterSection){this.filterSection.scrollIntoView({block:'start'});}this.props.setViewstate('pagination',page);}},{key:'paginate',value:function paginate(products){var productsPerPage=this.state.productsPerPage;var _props=this.props,viewstate=_props.viewstate,informationCard=_props.informationCard;var informationCardOffset=!informationCard.isEmpty()?-2:0;var start=viewstate.get('pagination')?viewstate.get('pagination')*productsPerPage+informationCardOffset:0;var end=start+productsPerPage+informationCardOffset;if(products.size){return products.slice(start,end);}return products;}},{key:'renderPagination',value:function renderPagination(){var _this3=this;var viewstate=this.props.viewstate;var paginationArray=[];var neighborPagesToShow=void 0;// show different amount of pagination links depending on screen size.
if(viewstate.get('pageWidth')<=__WEBPACK_IMPORTED_MODULE_23__styles_helpers_variables__["f" /* size */].small){neighborPagesToShow=1;}else if(viewstate.get('pageWidth')<=__WEBPACK_IMPORTED_MODULE_23__styles_helpers_variables__["f" /* size */].medium){neighborPagesToShow=2;}else if(viewstate.get('pageWidth')<=__WEBPACK_IMPORTED_MODULE_23__styles_helpers_variables__["f" /* size */].large){neighborPagesToShow=3;}else{neighborPagesToShow=4;}if(this.state.pages<=neighborPagesToShow*2+3){var _loop=function _loop(i){paginationArray.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__styles_Pagination__["a" /* Pagination */],{key:i,active:viewstate.get('pagination')===i,onClick:function onClick(){return _this3.changePage(i);}},i<9?'0'+(i+1):i+1));};// if there are less pages then the pagination will show, show all the pages.
for(var i=0;i<this.state.pages;i+=1){_loop(i);}}else{(function(){// else, we show the truncated version of our pagination pages.
var truncatedPagination=[0];for(var i=0;i<_this3.state.pages;i+=1){if(viewstate.get('pagination')>=i-neighborPagesToShow&&viewstate.get('pagination')<=i+neighborPagesToShow){if(!truncatedPagination.includes(i)){truncatedPagination.push(i);}}}// adds the last pagination page, because it should always be visible.
if(!truncatedPagination.includes(_this3.state.pages-1)){truncatedPagination.push(_this3.state.pages-1);}// a for loop that adds the components for the truncated pagination, including dividers when pagination numbers are not in a series.
var _loop2=function _loop2(_i){var difference=truncatedPagination[_i]-truncatedPagination[_i-1];if(difference!==1&&!Number.isNaN(difference)){paginationArray.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__styles_Pagination__["b" /* PaginationDivider */],null,'\u2026'));}paginationArray.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__styles_Pagination__["a" /* Pagination */],{key:truncatedPagination[_i],active:viewstate.get('pagination')===truncatedPagination[_i],onClick:function onClick(){return _this3.changePage(truncatedPagination[_i]);}},truncatedPagination[_i]<9?'0'+(truncatedPagination[_i]+1):truncatedPagination[_i]+1));};for(var _i=0;_i<truncatedPagination.length;_i+=1){_loop2(_i);}})();}return paginationArray;}},{key:'renderPaginationInModal',value:function renderPaginationInModal(){var _this4=this;var viewstate=this.props.viewstate;var paginations=[];var _loop3=function _loop3(i){paginations.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__styles_FilterOption__["a" /* FilterOption */],{radioButton:true,key:i,active:viewstate.get('pagination')===i,onClick:function onClick(){return _this4.changePage(i);}},'Sidan ',i+1));};for(var i=0;i<this.state.pages;i+=1){_loop3(i);}return paginations;}},{key:'render',value:function render(){var _this5=this;var _props2=this.props,filteredProducts=_props2.filteredProducts,allProducts=_props2.allProducts,viewstate=_props2.viewstate,includeRelevance=_props2.includeRelevance,informationCard=_props2.informationCard,request=_props2.request,includeCategoryFilter=_props2.includeCategoryFilter;var pages=this.state.pages;var pageWidth=viewstate.get('pageWidth');var sortAscending=viewstate.get('sortAscending');// const filteredCategoryProductsWithSplash = filteredProducts.size >= 6 ? filteredProducts.toList().insert(6, fromJS({ test: 'test' })) : filteredProducts;
var finalProducts=this.paginate(filteredProducts);var renderPagination=this.renderPagination();var paginationInModal=this.renderPaginationInModal();return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{paddingBottom:'30px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{ref:function ref(item){_this5.filterSection=item;}},pageWidth>=940?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_Filters__["a" /* default */],{includeRelevance:includeRelevance,products:this.props.allProducts,includeCategoryFilter:includeCategoryFilter}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_MobileNav__["a" /* default */],{toggleModal:this.toggleModal,color:'transparent',currentPage:viewstate.get('pagination')+1,pages:pages})),pageWidth<940&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_SlideOutContainer__["a" /* default */],{fromLeft:true,toggleModal:this.toggleModal,active:this.state.isModalActive==='filter',scrollHeight:this.state.scrollHeight},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__styles_Heading__["a" /* Heading */].p,null,'Filtrera'),includeCategoryFilter?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Accordion__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_AccordionItemWithText__["a" /* default */],{title:'Underkategori',number:viewstate.getIn(['filter','category'],Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["List"])()).size},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_FiltersList__["a" /* default */],{type:'category',products:this.props.allProducts,selector:['category','name'],margin:0,marginBottom:20,width:[1]})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_AccordionItemWithText__["a" /* default */],{title:'F\xE4rg',number:viewstate.getIn(['filter','color'],Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["List"])()).size},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_FiltersList__["a" /* default */],{forColor:true,type:'color',products:this.props.allProducts,selector:['specifications','color'],margin:0,marginBottom:20,width:[1]})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_AccordionItemWithText__["a" /* default */],{title:'Varum\xE4rke',number:viewstate.getIn(['filter','manufacturer'],Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["List"])()).size},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_FiltersList__["a" /* default */],{type:'manufacturer',products:this.props.allProducts,selector:['brand','name'],margin:0,marginBottom:20,width:[1]}))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Accordion__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_AccordionItemWithText__["a" /* default */],{title:'F\xE4rg',number:viewstate.getIn(['filter','color'],Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["List"])()).size},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_FiltersList__["a" /* default */],{forColor:true,type:'color',products:this.props.allProducts,selector:['specifications','color'],margin:0,marginBottom:20,width:[1]})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_AccordionItemWithText__["a" /* default */],{title:'Varum\xE4rke',number:viewstate.getIn(['filter','manufacturer'],Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["List"])()).size},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_FiltersList__["a" /* default */],{type:'manufacturer',products:this.props.allProducts,selector:['brand','name'],margin:0,marginBottom:20,width:[1]})))),pageWidth<940&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_SlideOutContainer__["a" /* default */],{toggleModal:this.toggleModal,active:this.state.isModalActive==='page',scrollHeight:this.state.scrollHeight},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__styles_Heading__["a" /* Heading */].p,null,'V\xE4lj sida'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__styles_DividerLine__["a" /* DividerLine */],null),paginationInModal,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__styles_DividerLine__["a" /* DividerLine */],null)),pageWidth<940&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_SlideOutContainer__["a" /* default */],{toggleModal:this.toggleModal,active:this.state.isModalActive==='sort',scrollHeight:this.state.scrollHeight},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__styles_Heading__["a" /* Heading */].p,null,'Sortera'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__styles_DividerLine__["a" /* DividerLine */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_SortingList__["a" /* default */],{includeRelevance:this.props.includeRelevance,margin:0,width:1,marginBottom:20}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__styles_DividerLine__["a" /* DividerLine */],null)),request.get('status')==='LOADING'&&allProducts.isEmpty()?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__LoadingSpinner__["a" /* LoadingSpinner */],null):false,request.get('status')==='ERROR'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__styles_Container__["a" /* Container */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__styles_NoProductsFound__["a" /* NoProductsFound */],null,'Vi jobbar med att berika v\xE5r webbplats med produkter. Nya produkter kommer inom kort under denna kategori.')):false,!allProducts.isEmpty()?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__styles_Container__["a" /* Container */],null,finalProducts.size>=1?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_ProductList__["a" /* default */],{includeRelevance:includeRelevance,data:finalProducts,pageWidth:pageWidth,onProductCardHover:this.props.productCardHover,modified:this.areProductsFiltered(allProducts,filteredProducts,sortAscending),informationCard:informationCard,activeFilterColor:viewstate.getIn(['filter','color'])&&Object.keys(viewstate.getIn(['filter','color']).toJS())[0]}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__styles_NoProductsFound__["a" /* NoProductsFound */],null,allProducts.size===0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Vi jobbar med att berika v\xE5r webbplats med produkter. Nya produkter kommer inom kort under denna kategori.'):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Tyv\xE4rr hittade vi inte produkter efter dina filtreringsval \u2013 Testa g\xF6ra andra val f\xF6r att uppdatera listan.')),pages>1&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__styles_PaginationContainer__["a" /* PaginationContainer */],null,viewstate.get('pagination')>0&&pageWidth>=940&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__styles_Icon__["a" /* Icon */],{left:true,onClick:function onClick(){return _this5.changePage(viewstate.get('pagination')-1);}}),renderPagination,viewstate.get('pagination')+1<pages&&pageWidth>=940&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__styles_Icon__["a" /* Icon */],{right:true,onClick:function onClick(){return _this5.changePage(viewstate.get('pagination')+1);}}))):false);}}]);return ProductListWithFilters;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ProductListWithFilters.defaultProps={includeCategoryFilter:false,allProducts:Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])(),filteredProducts:Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])(),productCardHover:function productCardHover(){},viewstate:Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])(),includeRelevance:false,informationCard:Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])(),request:Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])()};ProductListWithFilters.propTypes={includeCategoryFilter:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,setViewstate:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,viewstate:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"]),allProducts:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"]),filteredProducts:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"]),productCardHover:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,includeRelevance:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,informationCard:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"]),request:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3__store_connect__["a" /* default */])(ProductListWithFilters,{setViewstate:__WEBPACK_IMPORTED_MODULE_20__actions_actionCreators__["W" /* setViewstate */]},function(store,props){return{viewstate:store.viewstate,filteredProducts:Object(__WEBPACK_IMPORTED_MODULE_22__selectors_reselectCategory__["a" /* getFilteredProducts */])(store,props.allProducts)};}));

/***/ }),
/* 71 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(22).f;
var has = __webpack_require__(31);
var TAG = __webpack_require__(16)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(3);
var defined = __webpack_require__(47);
var fails = __webpack_require__(12);
var spaces = __webpack_require__(123);
var space = '[' + spaces + ']';
var non = '\u200b\u0085';
var ltrim = RegExp('^' + space + space + '*');
var rtrim = RegExp(space + space + '*$');

var exporter = function (KEY, exec, ALIAS) {
  var exp = {};
  var FORCE = fails(function () {
    return !!spaces[KEY]() || non[KEY]() != non;
  });
  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
  if (ALIAS) exp[ALIAS] = fn;
  $export($export.P + $export.F * FORCE, 'String', exp);
};

// 1 -> String#trimLeft
// 2 -> String#trimRight
// 3 -> String#trim
var trim = exporter.trim = function (string, TYPE) {
  string = String(defined(string));
  if (TYPE & 1) string = string.replace(ltrim, '');
  if (TYPE & 2) string = string.replace(rtrim, '');
  return string;
};

module.exports = exporter;


/***/ }),
/* 75 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(11);
var dP = __webpack_require__(22);
var DESCRIPTORS = __webpack_require__(21);
var SPECIES = __webpack_require__(16)('species');

module.exports = function (KEY) {
  var C = global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),
/* 77 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

var redefine = __webpack_require__(27);
module.exports = function (target, src, safe) {
  for (var key in src) redefine(target, key, src[key], safe);
  return target;
};


/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createBrowserHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createHashHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return createMemoryHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return createLocation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return locationsAreEqual; });
/* unused harmony export parsePath */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return createPath; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_resolve_pathname__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_value_equal__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_tiny_warning__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_tiny_invariant__ = __webpack_require__(220);






function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
}
function stripLeadingSlash(path) {
  return path.charAt(0) === '/' ? path.substr(1) : path;
}
function hasBasename(path, prefix) {
  return path.toLowerCase().indexOf(prefix.toLowerCase()) === 0 && '/?#'.indexOf(path.charAt(prefix.length)) !== -1;
}
function stripBasename(path, prefix) {
  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
}
function stripTrailingSlash(path) {
  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
}
function parsePath(path) {
  var pathname = path || '/';
  var search = '';
  var hash = '';
  var hashIndex = pathname.indexOf('#');

  if (hashIndex !== -1) {
    hash = pathname.substr(hashIndex);
    pathname = pathname.substr(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');

  if (searchIndex !== -1) {
    search = pathname.substr(searchIndex);
    pathname = pathname.substr(0, searchIndex);
  }

  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
}
function createPath(location) {
  var pathname = location.pathname,
      search = location.search,
      hash = location.hash;
  var path = pathname || '/';
  if (search && search !== '?') path += search.charAt(0) === '?' ? search : "?" + search;
  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : "#" + hash;
  return path;
}

function createLocation(path, state, key, currentLocation) {
  var location;

  if (typeof path === 'string') {
    // Two-arg form: push(path, state)
    location = parsePath(path);
    location.state = state;
  } else {
    // One-arg form: push(location)
    location = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, path);
    if (location.pathname === undefined) location.pathname = '';

    if (location.search) {
      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
    } else {
      location.search = '';
    }

    if (location.hash) {
      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
    } else {
      location.hash = '';
    }

    if (state !== undefined && location.state === undefined) location.state = state;
  }

  try {
    location.pathname = decodeURI(location.pathname);
  } catch (e) {
    if (e instanceof URIError) {
      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
    } else {
      throw e;
    }
  }

  if (key) location.key = key;

  if (currentLocation) {
    // Resolve incomplete/relative pathname relative to current location.
    if (!location.pathname) {
      location.pathname = currentLocation.pathname;
    } else if (location.pathname.charAt(0) !== '/') {
      location.pathname = Object(__WEBPACK_IMPORTED_MODULE_1_resolve_pathname__["default"])(location.pathname, currentLocation.pathname);
    }
  } else {
    // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) {
      location.pathname = '/';
    }
  }

  return location;
}
function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && Object(__WEBPACK_IMPORTED_MODULE_2_value_equal__["default"])(a.state, b.state);
}

function createTransitionManager() {
  var prompt = null;

  function setPrompt(nextPrompt) {
     false ? warning(prompt == null, 'A history supports only one prompt at a time') : void 0;
    prompt = nextPrompt;
    return function () {
      if (prompt === nextPrompt) prompt = null;
    };
  }

  function confirmTransitionTo(location, action, getUserConfirmation, callback) {
    // TODO: If another transition starts while we're still confirming
    // the previous one, we may end up in a weird state. Figure out the
    // best way to handle this.
    if (prompt != null) {
      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;

      if (typeof result === 'string') {
        if (typeof getUserConfirmation === 'function') {
          getUserConfirmation(result, callback);
        } else {
           false ? warning(false, 'A history needs a getUserConfirmation function in order to use a prompt message') : void 0;
          callback(true);
        }
      } else {
        // Return false from a transition hook to cancel the transition.
        callback(result !== false);
      }
    } else {
      callback(true);
    }
  }

  var listeners = [];

  function appendListener(fn) {
    var isActive = true;

    function listener() {
      if (isActive) fn.apply(void 0, arguments);
    }

    listeners.push(listener);
    return function () {
      isActive = false;
      listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  }

  function notifyListeners() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    listeners.forEach(function (listener) {
      return listener.apply(void 0, args);
    });
  }

  return {
    setPrompt: setPrompt,
    confirmTransitionTo: confirmTransitionTo,
    appendListener: appendListener,
    notifyListeners: notifyListeners
  };
}

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function getConfirmation(message, callback) {
  callback(window.confirm(message)); // eslint-disable-line no-alert
}
/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */

function supportsHistory() {
  var ua = window.navigator.userAgent;
  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
  return window.history && 'pushState' in window.history;
}
/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */

function supportsPopStateOnHashChange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
}
/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */

function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
}
/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */

function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
}

var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

function getHistoryState() {
  try {
    return window.history.state || {};
  } catch (e) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    return {};
  }
}
/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */


function createBrowserHistory(props) {
  if (props === void 0) {
    props = {};
  }

  !canUseDOM ?  false ? invariant(false, 'Browser history needs a DOM') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["default"])(false) : void 0;
  var globalHistory = window.history;
  var canUseHistory = supportsHistory();
  var needsHashChangeListener = !supportsPopStateOnHashChange();
  var _props = props,
      _props$forceRefresh = _props.forceRefresh,
      forceRefresh = _props$forceRefresh === void 0 ? false : _props$forceRefresh,
      _props$getUserConfirm = _props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm,
      _props$keyLength = _props.keyLength,
      keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
  var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';

  function getDOMLocation(historyState) {
    var _ref = historyState || {},
        key = _ref.key,
        state = _ref.state;

    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;
    var path = pathname + search + hash;
     false ? warning(!basename || hasBasename(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".') : void 0;
    if (basename) path = stripBasename(path, basename);
    return createLocation(path, state, key);
  }

  function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  }

  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = globalHistory.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  function handlePopState(event) {
    // Ignore extraneous popstate events in WebKit.
    if (isExtraneousPopstateEvent(event)) return;
    handlePop(getDOMLocation(event.state));
  }

  function handleHashChange() {
    handlePop(getDOMLocation(getHistoryState()));
  }

  var forceNextPop = false;

  function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';
      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({
            action: action,
            location: location
          });
        } else {
          revertPop(location);
        }
      });
    }
  }

  function revertPop(fromLocation) {
    var toLocation = history.location; // TODO: We could probably make this more reliable by
    // keeping a list of keys we've seen in sessionStorage.
    // Instead, we just default to 0 for keys we don't know.

    var toIndex = allKeys.indexOf(toLocation.key);
    if (toIndex === -1) toIndex = 0;
    var fromIndex = allKeys.indexOf(fromLocation.key);
    if (fromIndex === -1) fromIndex = 0;
    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  }

  var initialLocation = getDOMLocation(getHistoryState());
  var allKeys = [initialLocation.key]; // Public interface

  function createHref(location) {
    return basename + createPath(location);
  }

  function push(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var href = createHref(location);
      var key = location.key,
          state = location.state;

      if (canUseHistory) {
        globalHistory.pushState({
          key: key,
          state: state
        }, null, href);

        if (forceRefresh) {
          window.location.href = href;
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          var nextKeys = allKeys.slice(0, prevIndex + 1);
          nextKeys.push(location.key);
          allKeys = nextKeys;
          setState({
            action: action,
            location: location
          });
        }
      } else {
         false ? warning(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history') : void 0;
        window.location.href = href;
      }
    });
  }

  function replace(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var href = createHref(location);
      var key = location.key,
          state = location.state;

      if (canUseHistory) {
        globalHistory.replaceState({
          key: key,
          state: state
        }, null, href);

        if (forceRefresh) {
          window.location.replace(href);
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          if (prevIndex !== -1) allKeys[prevIndex] = location.key;
          setState({
            action: action,
            location: location
          });
        }
      } else {
         false ? warning(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history') : void 0;
        window.location.replace(href);
      }
    });
  }

  function go(n) {
    globalHistory.go(n);
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  var listenerCount = 0;

  function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1 && delta === 1) {
      window.addEventListener(PopStateEvent, handlePopState);
      if (needsHashChangeListener) window.addEventListener(HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      window.removeEventListener(PopStateEvent, handlePopState);
      if (needsHashChangeListener) window.removeEventListener(HashChangeEvent, handleHashChange);
    }
  }

  var isBlocked = false;

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  }

  function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);
    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  }

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };
  return history;
}

var HashChangeEvent$1 = 'hashchange';
var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!/' + stripLeadingSlash(path);
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substr(1) : path;
    }
  },
  noslash: {
    encodePath: stripLeadingSlash,
    decodePath: addLeadingSlash
  },
  slash: {
    encodePath: addLeadingSlash,
    decodePath: addLeadingSlash
  }
};

function stripHash(url) {
  var hashIndex = url.indexOf('#');
  return hashIndex === -1 ? url : url.slice(0, hashIndex);
}

function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
}

function pushHashPath(path) {
  window.location.hash = path;
}

function replaceHashPath(path) {
  window.location.replace(stripHash(window.location.href) + '#' + path);
}

function createHashHistory(props) {
  if (props === void 0) {
    props = {};
  }

  !canUseDOM ?  false ? invariant(false, 'Hash history needs a DOM') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["default"])(false) : void 0;
  var globalHistory = window.history;
  var canGoWithoutReload = supportsGoWithoutReloadUsingHash();
  var _props = props,
      _props$getUserConfirm = _props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm,
      _props$hashType = _props.hashType,
      hashType = _props$hashType === void 0 ? 'slash' : _props$hashType;
  var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';
  var _HashPathCoders$hashT = HashPathCoders[hashType],
      encodePath = _HashPathCoders$hashT.encodePath,
      decodePath = _HashPathCoders$hashT.decodePath;

  function getDOMLocation() {
    var path = decodePath(getHashPath());
     false ? warning(!basename || hasBasename(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".') : void 0;
    if (basename) path = stripBasename(path, basename);
    return createLocation(path);
  }

  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = globalHistory.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  var forceNextPop = false;
  var ignorePath = null;

  function locationsAreEqual$$1(a, b) {
    return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash;
  }

  function handleHashChange() {
    var path = getHashPath();
    var encodedPath = encodePath(path);

    if (path !== encodedPath) {
      // Ensure we always have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var location = getDOMLocation();
      var prevLocation = history.location;
      if (!forceNextPop && locationsAreEqual$$1(prevLocation, location)) return; // A hashchange doesn't always == location change.

      if (ignorePath === createPath(location)) return; // Ignore this change; we already setState in push/replace.

      ignorePath = null;
      handlePop(location);
    }
  }

  function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';
      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({
            action: action,
            location: location
          });
        } else {
          revertPop(location);
        }
      });
    }
  }

  function revertPop(fromLocation) {
    var toLocation = history.location; // TODO: We could probably make this more reliable by
    // keeping a list of paths we've seen in sessionStorage.
    // Instead, we just default to 0 for paths we don't know.

    var toIndex = allPaths.lastIndexOf(createPath(toLocation));
    if (toIndex === -1) toIndex = 0;
    var fromIndex = allPaths.lastIndexOf(createPath(fromLocation));
    if (fromIndex === -1) fromIndex = 0;
    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  } // Ensure the hash is encoded properly before doing anything else.


  var path = getHashPath();
  var encodedPath = encodePath(path);
  if (path !== encodedPath) replaceHashPath(encodedPath);
  var initialLocation = getDOMLocation();
  var allPaths = [createPath(initialLocation)]; // Public interface

  function createHref(location) {
    var baseTag = document.querySelector('base');
    var href = '';

    if (baseTag && baseTag.getAttribute('href')) {
      href = stripHash(window.location.href);
    }

    return href + '#' + encodePath(basename + createPath(location));
  }

  function push(path, state) {
     false ? warning(state === undefined, 'Hash history cannot push state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, undefined, undefined, history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var path = createPath(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a PUSH, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        pushHashPath(encodedPath);
        var prevIndex = allPaths.lastIndexOf(createPath(history.location));
        var nextPaths = allPaths.slice(0, prevIndex + 1);
        nextPaths.push(path);
        allPaths = nextPaths;
        setState({
          action: action,
          location: location
        });
      } else {
         false ? warning(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack') : void 0;
        setState();
      }
    });
  }

  function replace(path, state) {
     false ? warning(state === undefined, 'Hash history cannot replace state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, undefined, undefined, history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var path = createPath(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        replaceHashPath(encodedPath);
      }

      var prevIndex = allPaths.indexOf(createPath(history.location));
      if (prevIndex !== -1) allPaths[prevIndex] = path;
      setState({
        action: action,
        location: location
      });
    });
  }

  function go(n) {
     false ? warning(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : void 0;
    globalHistory.go(n);
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  var listenerCount = 0;

  function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1 && delta === 1) {
      window.addEventListener(HashChangeEvent$1, handleHashChange);
    } else if (listenerCount === 0) {
      window.removeEventListener(HashChangeEvent$1, handleHashChange);
    }
  }

  var isBlocked = false;

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  }

  function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);
    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  }

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };
  return history;
}

function clamp(n, lowerBound, upperBound) {
  return Math.min(Math.max(n, lowerBound), upperBound);
}
/**
 * Creates a history object that stores locations in memory.
 */


function createMemoryHistory(props) {
  if (props === void 0) {
    props = {};
  }

  var _props = props,
      getUserConfirmation = _props.getUserConfirmation,
      _props$initialEntries = _props.initialEntries,
      initialEntries = _props$initialEntries === void 0 ? ['/'] : _props$initialEntries,
      _props$initialIndex = _props.initialIndex,
      initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex,
      _props$keyLength = _props.keyLength,
      keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = history.entries.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  }

  var index = clamp(initialIndex, 0, initialEntries.length - 1);
  var entries = initialEntries.map(function (entry) {
    return typeof entry === 'string' ? createLocation(entry, undefined, createKey()) : createLocation(entry, undefined, entry.key || createKey());
  }); // Public interface

  var createHref = createPath;

  function push(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var prevIndex = history.index;
      var nextIndex = prevIndex + 1;
      var nextEntries = history.entries.slice(0);

      if (nextEntries.length > nextIndex) {
        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
      } else {
        nextEntries.push(location);
      }

      setState({
        action: action,
        location: location,
        index: nextIndex,
        entries: nextEntries
      });
    });
  }

  function replace(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      history.entries[history.index] = location;
      setState({
        action: action,
        location: location
      });
    });
  }

  function go(n) {
    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);
    var action = 'POP';
    var location = history.entries[nextIndex];
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (ok) {
        setState({
          action: action,
          location: location,
          index: nextIndex
        });
      } else {
        // Mimic the behavior of DOM histories by
        // causing a render after a cancelled POP.
        setState();
      }
    });
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  function canGo(n) {
    var nextIndex = history.index + n;
    return nextIndex >= 0 && nextIndex < history.entries.length;
  }

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    return transitionManager.setPrompt(prompt);
  }

  function listen(listener) {
    return transitionManager.appendListener(listener);
  }

  var history = {
    length: entries.length,
    action: 'POP',
    location: entries[index],
    index: index,
    entries: entries,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    canGo: canGo,
    block: block,
    listen: listen
  };
  return history;
}




/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return END; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return isEnd; });
/* harmony export (immutable) */ __webpack_exports__["b"] = emitter;
/* unused harmony export INVALID_BUFFER */
/* unused harmony export UNDEFINED_INPUT_ERROR */
/* unused harmony export channel */
/* harmony export (immutable) */ __webpack_exports__["c"] = eventChannel;
/* harmony export (immutable) */ __webpack_exports__["e"] = stdChannel;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__buffers__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__scheduler__ = __webpack_require__(226);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var CHANNEL_END_TYPE = '@@redux-saga/CHANNEL_END';
var END = { type: CHANNEL_END_TYPE };
var isEnd = function isEnd(a) {
  return a && a.type === CHANNEL_END_TYPE;
};

function emitter() {
  var subscribers = [];

  function subscribe(sub) {
    subscribers.push(sub);
    return function () {
      return Object(__WEBPACK_IMPORTED_MODULE_0__utils__["t" /* remove */])(subscribers, sub);
    };
  }

  function emit(item) {
    var arr = subscribers.slice();
    for (var i = 0, len = arr.length; i < len; i++) {
      arr[i](item);
    }
  }

  return {
    subscribe: subscribe,
    emit: emit
  };
}

var INVALID_BUFFER = 'invalid buffer passed to channel factory function';
var UNDEFINED_INPUT_ERROR = 'Saga was provided with an undefined action';

if (false) {
  UNDEFINED_INPUT_ERROR += '\nHints:\n    - check that your Action Creator returns a non-undefined value\n    - if the Saga was started using runSaga, check that your subscribe source provides the action to its listeners\n  ';
}

function channel() {
  var buffer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : __WEBPACK_IMPORTED_MODULE_1__buffers__["a" /* buffers */].fixed();

  var closed = false;
  var takers = [];

  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(buffer, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].buffer, INVALID_BUFFER);

  function checkForbiddenStates() {
    if (closed && takers.length) {
      throw Object(__WEBPACK_IMPORTED_MODULE_0__utils__["m" /* internalErr */])('Cannot have a closed channel with pending takers');
    }
    if (takers.length && !buffer.isEmpty()) {
      throw Object(__WEBPACK_IMPORTED_MODULE_0__utils__["m" /* internalErr */])('Cannot have pending takers with non empty buffer');
    }
  }

  function put(input) {
    checkForbiddenStates();
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(input, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].notUndef, UNDEFINED_INPUT_ERROR);
    if (closed) {
      return;
    }
    if (!takers.length) {
      return buffer.put(input);
    }
    for (var i = 0; i < takers.length; i++) {
      var cb = takers[i];
      if (!cb[__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* MATCH */]] || cb[__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* MATCH */]](input)) {
        takers.splice(i, 1);
        return cb(input);
      }
    }
  }

  function take(cb) {
    checkForbiddenStates();
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(cb, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func, "channel.take's callback must be a function");

    if (closed && buffer.isEmpty()) {
      cb(END);
    } else if (!buffer.isEmpty()) {
      cb(buffer.take());
    } else {
      takers.push(cb);
      cb.cancel = function () {
        return Object(__WEBPACK_IMPORTED_MODULE_0__utils__["t" /* remove */])(takers, cb);
      };
    }
  }

  function flush(cb) {
    checkForbiddenStates(); // TODO: check if some new state should be forbidden now
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(cb, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func, "channel.flush' callback must be a function");
    if (closed && buffer.isEmpty()) {
      cb(END);
      return;
    }
    cb(buffer.flush());
  }

  function close() {
    checkForbiddenStates();
    if (!closed) {
      closed = true;
      if (takers.length) {
        var arr = takers;
        takers = [];
        for (var i = 0, len = arr.length; i < len; i++) {
          arr[i](END);
        }
      }
    }
  }

  return {
    take: take,
    put: put,
    flush: flush,
    close: close,
    get __takers__() {
      return takers;
    },
    get __closed__() {
      return closed;
    }
  };
}

function eventChannel(subscribe) {
  var buffer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : __WEBPACK_IMPORTED_MODULE_1__buffers__["a" /* buffers */].none();
  var matcher = arguments[2];

  /**
    should be if(typeof matcher !== undefined) instead?
    see PR #273 for a background discussion
  **/
  if (arguments.length > 2) {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(matcher, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func, 'Invalid match function passed to eventChannel');
  }

  var chan = channel(buffer);
  var close = function close() {
    if (!chan.__closed__) {
      if (unsubscribe) {
        unsubscribe();
      }
      chan.close();
    }
  };
  var unsubscribe = subscribe(function (input) {
    if (isEnd(input)) {
      close();
      return;
    }
    if (matcher && !matcher(input)) {
      return;
    }
    chan.put(input);
  });
  if (chan.__closed__) {
    unsubscribe();
  }

  if (!__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func(unsubscribe)) {
    throw new Error('in eventChannel: subscribe should return a function to unsubscribe');
  }

  return {
    take: chan.take,
    flush: chan.flush,
    close: close
  };
}

function stdChannel(subscribe) {
  var chan = eventChannel(function (cb) {
    return subscribe(function (input) {
      if (input[__WEBPACK_IMPORTED_MODULE_0__utils__["c" /* SAGA_ACTION */]]) {
        cb(input);
        return;
      }
      Object(__WEBPACK_IMPORTED_MODULE_2__scheduler__["a" /* asap */])(function () {
        return cb(input);
      });
    });
  });

  return _extends({}, chan, {
    take: function take(cb, matcher) {
      if (arguments.length > 1) {
        Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(matcher, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func, "channel.take's matcher argument must be a function");
        cb[__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* MATCH */]] = matcher;
      }
      chan.take(cb);
    }
  });
}

/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ImageZoomAnimation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return SlideIn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FadeIn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return MagicGetaway; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FadeInInline; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return FadeInInline2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DynamicBackgroundFade; });
/* unused harmony export FadeInOut */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__geraldcloudnine_styled_transition_group__ = __webpack_require__(551);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__variables__ = __webpack_require__(4);
var _templateObject=_taggedTemplateLiteral(['\n  from {\n    transform: scale(1)\n  }\n\n  to {\n    transform: scale(1.2)\n  }\n'],['\n  from {\n    transform: scale(1)\n  }\n\n  to {\n    transform: scale(1.2)\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  animation: ',' 25s ease-out 1;\n  animation-fill-mode: forwards;\n'],['\n  animation: ',' 25s ease-out 1;\n  animation-fill-mode: forwards;\n']),_templateObject3=_taggedTemplateLiteral(['\n  &:enter { transform: translateX(','); }\n  &:enter-active {\n    transform: translateX(0);\n    transition: transform ',' ',';\n  }\n  &:exit { transform: translateX(0); }\n  &:exit-active {\n    transform: translateX(',');\n    transition: transform ',' ',';\n  }\n'],['\n  &:enter { transform: translateX(','); }\n  &:enter-active {\n    transform: translateX(0);\n    transition: transform ',' ',';\n  }\n  &:exit { transform: translateX(0); }\n  &:exit-active {\n    transform: translateX(',');\n    transition: transform ',' ',';\n  }\n']),_templateObject4=_taggedTemplateLiteral(['\n  &:enter { opacity: 0.01; }\n  &:enter-active {\n    opacity: 1;\n    transition: opacity ',' ',';\n  }\n  &:exit { opacity: 1; }\n  &:exit-active {\n    opacity: 0.01;\n    transition: opacity ',' ',';\n  }\n'],['\n  &:enter { opacity: 0.01; }\n  &:enter-active {\n    opacity: 1;\n    transition: opacity ',' ',';\n  }\n  &:exit { opacity: 1; }\n  &:exit-active {\n    opacity: 0.01;\n    transition: opacity ',' ',';\n  }\n']),_templateObject5=_taggedTemplateLiteral(['\n  max-height: 250px;\n  overflow:hidden;\n\n  &:enter {\n    opacity: 0.01;\n    max-height: 1px;\n  }\n  &:enter-active {\n    opacity: 1;\n    max-height: 250px;\n    transition: opacity .4s ease-in-out, max-height .4s ease-in-out;\n  }\n  &:exit {\n    opacity: 1;\n    max-height: 250px;\n  }\n  &:exit-active {\n    opacity: 0.01;\n    max-height: 1px;\n    transition: opacity .4s ease-in-out, max-height .4s ease-in-out;\n  }\n  ','\n'],['\n  max-height: 250px;\n  overflow:hidden;\n\n  &:enter {\n    opacity: 0.01;\n    max-height: 1px;\n  }\n  &:enter-active {\n    opacity: 1;\n    max-height: 250px;\n    transition: opacity .4s ease-in-out, max-height .4s ease-in-out;\n  }\n  &:exit {\n    opacity: 1;\n    max-height: 250px;\n  }\n  &:exit-active {\n    opacity: 0.01;\n    max-height: 1px;\n    transition: opacity .4s ease-in-out, max-height .4s ease-in-out;\n  }\n  ','\n']),_templateObject6=_taggedTemplateLiteral(['\n      max-height: ','px;\n      &:enter-active,\n      &:exit {\n        max-height: ','px;\n      }\n    '],['\n      max-height: ','px;\n      &:enter-active,\n      &:exit {\n        max-height: ','px;\n      }\n    ']),_templateObject7=_taggedTemplateLiteral(['\n  display: inline-block;\n\n  &:enter {\n    opacity: 0.01;\n    transform: translateY(-50%);\n  }\n  &:enter-active {\n    opacity: 1;\n    transform: translateY(0);\n    transition: all .25s ease-out;\n  }\n  &:exit {\n    opacity: 1;\n    transform: translateY(0);\n  }\n  &:exit-active {\n    opacity: 0.01;\n    transform: translateY(50%);\n    transition: all .25s ease-out;\n  }\n'],['\n  display: inline-block;\n\n  &:enter {\n    opacity: 0.01;\n    transform: translateY(-50%);\n  }\n  &:enter-active {\n    opacity: 1;\n    transform: translateY(0);\n    transition: all .25s ease-out;\n  }\n  &:exit {\n    opacity: 1;\n    transform: translateY(0);\n  }\n  &:exit-active {\n    opacity: 0.01;\n    transform: translateY(50%);\n    transition: all .25s ease-out;\n  }\n']),_templateObject8=_taggedTemplateLiteral(['\n  display: inline-block;\n\n  &:enter {\n    opacity: 0.01;\n  }\n  &:enter-active {\n    opacity: 1;\n    transition: opacity .25s ease-out;\n  }\n  &:exit {\n    opacity: 1;\n  }\n  &:exit-active {\n    opacity: 0.01;\n    transition: opacity .25s ease-out;\n  }\n'],['\n  display: inline-block;\n\n  &:enter {\n    opacity: 0.01;\n  }\n  &:enter-active {\n    opacity: 1;\n    transition: opacity .25s ease-out;\n  }\n  &:exit {\n    opacity: 1;\n  }\n  &:exit-active {\n    opacity: 0.01;\n    transition: opacity .25s ease-out;\n  }\n']),_templateObject9=_taggedTemplateLiteral(['\n  &:enter {\n    opacity: 0.01;\n  }\n  &:enter-active {\n    opacity: 1;\n    transition: opacity .4s linear;\n  }\n  &:exit {\n    opacity: 1;\n  }\n  &:exit-active {\n    opacity: 0.01;\n    transition: opacity .4s linear;\n  }\n'],['\n  &:enter {\n    opacity: 0.01;\n  }\n  &:enter-active {\n    opacity: 1;\n    transition: opacity .4s linear;\n  }\n  &:exit {\n    opacity: 1;\n  }\n  &:exit-active {\n    opacity: 0.01;\n    transition: opacity .4s linear;\n  }\n']),_templateObject10=_taggedTemplateLiteral(['\n  &:enter {\n    opacity: 0.01;\n  }\n  &:enter-active {\n    opacity: 1;\n    transition: opacity 250ms ease-out;\n  }\n  &:exit {\n    opacity: 1;\n  }\n  &:exit-active {\n    opacity: 0.01;\n    transition: opacity 250ms ease-out;\n  }\n\n  ','\n'],['\n  &:enter {\n    opacity: 0.01;\n  }\n  &:enter-active {\n    opacity: 1;\n    transition: opacity 250ms ease-out;\n  }\n  &:exit {\n    opacity: 1;\n  }\n  &:exit-active {\n    opacity: 0.01;\n    transition: opacity 250ms ease-out;\n  }\n\n  ','\n']),_templateObject11=_taggedTemplateLiteral(['\n      flex: 1;\n      height: 100%;\n    '],['\n      flex: 1;\n      height: 100%;\n    ']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var ImageZoom=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["keyframes"])(_templateObject);var ImageZoomAnimation=function ImageZoomAnimation(){return Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(_templateObject2,ImageZoom);};var SlideIn=__WEBPACK_IMPORTED_MODULE_1__geraldcloudnine_styled_transition_group__["a" /* default */].div.attrs({unmountOnExit:true,timeout:400})(_templateObject3,function(props){return props.translateX;},function(props){return props.transitionTime;},function(props){return props.easing;},function(props){return props.translateX;},function(props){return props.transitionTime;},function(props){return props.easing;});SlideIn.defaultProps={translateX:'100%',transitionTime:'400ms',easing:'ease-in-out'};var FadeIn=__WEBPACK_IMPORTED_MODULE_1__geraldcloudnine_styled_transition_group__["a" /* default */].div.attrs({unmountOnExit:true,timeout:400})(_templateObject4,function(props){return props.transitionTime;},function(props){return props.easing;},function(props){return props.transitionTime;},function(props){return props.easing;});FadeIn.defaultProps={transitionTime:'400ms',easing:'ease-in-out'};var MagicGetaway=__WEBPACK_IMPORTED_MODULE_1__geraldcloudnine_styled_transition_group__["a" /* default */].div.attrs({mountOnEnter:true,unmountOnExit:true,timeout:400})(_templateObject5,function(props){return props.numberOfOptions&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(_templateObject6,250+100*props.numberOfOptions,250+100*props.numberOfOptions);});MagicGetaway.defaultProps={transitionTime:__WEBPACK_IMPORTED_MODULE_2__variables__["a" /* animation */].transitionTime,easing:__WEBPACK_IMPORTED_MODULE_2__variables__["a" /* animation */].easing};var FadeInInline=__WEBPACK_IMPORTED_MODULE_1__geraldcloudnine_styled_transition_group__["a" /* default */].div.attrs({timeout:250})(_templateObject7);var FadeInInline2=__WEBPACK_IMPORTED_MODULE_1__geraldcloudnine_styled_transition_group__["a" /* default */].div.attrs({timeout:250})(_templateObject8);var DynamicBackgroundFade=__WEBPACK_IMPORTED_MODULE_1__geraldcloudnine_styled_transition_group__["a" /* default */].div.attrs({mountOnEnter:true,unmountOnExit:true,timeout:400})(_templateObject9);var FadeInOut=__WEBPACK_IMPORTED_MODULE_1__geraldcloudnine_styled_transition_group__["a" /* default */].div.attrs({mountOnEnter:true,unmountOnExit:true,timeout:250})(_templateObject10,function(props){return props.big&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(_templateObject11);});FadeInOut.defaultProps={transitionTime:__WEBPACK_IMPORTED_MODULE_2__variables__["a" /* animation */].transitionTime,easing:__WEBPACK_IMPORTED_MODULE_2__variables__["a" /* animation */].easing};

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_MainProductImage__ = __webpack_require__(556);
var MainProductImage=function MainProductImage(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__styles_MainProductImage__["a" /* MainProductImageContainer */],{selected:props.selected,small:props.small,insideList:props.insideList,swipe:props.swipe,round:props.round},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__styles_MainProductImage__["b" /* MainProductImageContent */],{small:props.small},props.children));};MainProductImage.defaultProps={selected:false,small:false,insideList:false,swipe:null,round:false};MainProductImage.propTypes={selected:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,small:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,insideList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,swipe:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,round:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,children:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node),__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node]).isRequired};/* harmony default export */ __webpack_exports__["a"] = (MainProductImage);

/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProductImage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_variables__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_mixins__ = __webpack_require__(6);
var _templateObject=_taggedTemplateLiteral(['\n  width: 100%;\n  max-height: 100%;\n  height: auto;\n  object-fit: contain;\n  display: block;\n  margin: ',';\n  transition: transform ',' ',';\n\n  padding-left: ',';\n  padding-right: ',';\n\n  ',';\n\n  ',';\n  \n  ',';\n\n  border: 1px solid transparent;\n\n  ',';\n\n  ',';\n  \n  ',';\n'],['\n  width: 100%;\n  max-height: 100%;\n  height: auto;\n  object-fit: contain;\n  display: block;\n  margin: ',';\n  transition: transform ',' ',';\n\n  padding-left: ',';\n  padding-right: ',';\n\n  ',';\n\n  ',';\n  \n  ',';\n\n  border: 1px solid transparent;\n\n  ',';\n\n  ',';\n  \n  ',';\n']),_templateObject2=_taggedTemplateLiteral(['\n      margin: ',';\n    '],['\n      margin: ',';\n    ']),_templateObject3=_taggedTemplateLiteral(['\n      max-height: unset;\n      border-radius: 100%;\n    '],['\n      max-height: unset;\n      border-radius: 100%;\n    ']),_templateObject4=_taggedTemplateLiteral(['\n    opacity: .6;\n  '],['\n    opacity: .6;\n  ']),_templateObject5=_taggedTemplateLiteral(['\n      border: 1px solid ',';\n    '],['\n      border: 1px solid ',';\n    ']),_templateObject6=_taggedTemplateLiteral(['\n      border-radius: 100%;\n      max-height: initial;\n    '],['\n      border-radius: 100%;\n      max-height: initial;\n    ']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var ProductImage=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].img(_templateObject,function(props){return props.swipe?'0':'2rem 0';},__WEBPACK_IMPORTED_MODULE_1__helpers_variables__["a" /* animation */].transitionTime,__WEBPACK_IMPORTED_MODULE_1__helpers_variables__["a" /* animation */].easing,function(props){return props.swipe?'calc(8px + ((80 - 8) * ((100vw - '+__WEBPACK_IMPORTED_MODULE_1__helpers_variables__["f" /* size */].small+'px) / ('+__WEBPACK_IMPORTED_MODULE_1__helpers_variables__["f" /* size */].large+' - '+__WEBPACK_IMPORTED_MODULE_1__helpers_variables__["f" /* size */].small+'))))':'0';},function(props){return props.swipe?'calc(8px + ((80 - 8) * ((100vw - '+__WEBPACK_IMPORTED_MODULE_1__helpers_variables__["f" /* size */].small+'px) / ('+__WEBPACK_IMPORTED_MODULE_1__helpers_variables__["f" /* size */].large+' - '+__WEBPACK_IMPORTED_MODULE_1__helpers_variables__["f" /* size */].small+'))))':'0';},function(props){return props.margin&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(_templateObject2,props.margin);},function(props){return props.round&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(_templateObject3);},function(props){return props.disabled&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(_templateObject4);},function(props){return props.selected&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(_templateObject5,__WEBPACK_IMPORTED_MODULE_1__helpers_variables__["c" /* color */].primary);},function(props){return props.round&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(_templateObject6);},function(props){return props.hideOnPrint&&__WEBPACK_IMPORTED_MODULE_2__helpers_mixins__["f" /* hideOnPrint */];});

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var undefined;

var $Error = __webpack_require__(569);
var $EvalError = __webpack_require__(570);
var $RangeError = __webpack_require__(571);
var $ReferenceError = __webpack_require__(572);
var $SyntaxError = __webpack_require__(239);
var $TypeError = __webpack_require__(93);
var $URIError = __webpack_require__(573);

var $Function = Function;

// eslint-disable-next-line consistent-return
var getEvalledConstructor = function (expressionSyntax) {
	try {
		return $Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
	} catch (e) {}
};

var $gOPD = Object.getOwnPropertyDescriptor;
if ($gOPD) {
	try {
		$gOPD({}, '');
	} catch (e) {
		$gOPD = null; // this is IE 8, which has a broken gOPD
	}
}

var throwTypeError = function () {
	throw new $TypeError();
};
var ThrowTypeError = $gOPD
	? (function () {
		try {
			// eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
			arguments.callee; // IE 8 does not throw here
			return throwTypeError;
		} catch (calleeThrows) {
			try {
				// IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
				return $gOPD(arguments, 'callee').get;
			} catch (gOPDthrows) {
				return throwTypeError;
			}
		}
	}())
	: throwTypeError;

var hasSymbols = __webpack_require__(574)();
var hasProto = __webpack_require__(576)();

var getProto = Object.getPrototypeOf || (
	hasProto
		? function (x) { return x.__proto__; } // eslint-disable-line no-proto
		: null
);

var needsEval = {};

var TypedArray = typeof Uint8Array === 'undefined' || !getProto ? undefined : getProto(Uint8Array);

var INTRINSICS = {
	__proto__: null,
	'%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
	'%Array%': Array,
	'%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
	'%ArrayIteratorPrototype%': hasSymbols && getProto ? getProto([][Symbol.iterator]()) : undefined,
	'%AsyncFromSyncIteratorPrototype%': undefined,
	'%AsyncFunction%': needsEval,
	'%AsyncGenerator%': needsEval,
	'%AsyncGeneratorFunction%': needsEval,
	'%AsyncIteratorPrototype%': needsEval,
	'%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
	'%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
	'%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined : BigInt64Array,
	'%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined : BigUint64Array,
	'%Boolean%': Boolean,
	'%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
	'%Date%': Date,
	'%decodeURI%': decodeURI,
	'%decodeURIComponent%': decodeURIComponent,
	'%encodeURI%': encodeURI,
	'%encodeURIComponent%': encodeURIComponent,
	'%Error%': $Error,
	'%eval%': eval, // eslint-disable-line no-eval
	'%EvalError%': $EvalError,
	'%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
	'%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
	'%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
	'%Function%': $Function,
	'%GeneratorFunction%': needsEval,
	'%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
	'%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
	'%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
	'%isFinite%': isFinite,
	'%isNaN%': isNaN,
	'%IteratorPrototype%': hasSymbols && getProto ? getProto(getProto([][Symbol.iterator]())) : undefined,
	'%JSON%': typeof JSON === 'object' ? JSON : undefined,
	'%Map%': typeof Map === 'undefined' ? undefined : Map,
	'%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols || !getProto ? undefined : getProto(new Map()[Symbol.iterator]()),
	'%Math%': Math,
	'%Number%': Number,
	'%Object%': Object,
	'%parseFloat%': parseFloat,
	'%parseInt%': parseInt,
	'%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
	'%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
	'%RangeError%': $RangeError,
	'%ReferenceError%': $ReferenceError,
	'%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
	'%RegExp%': RegExp,
	'%Set%': typeof Set === 'undefined' ? undefined : Set,
	'%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols || !getProto ? undefined : getProto(new Set()[Symbol.iterator]()),
	'%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
	'%String%': String,
	'%StringIteratorPrototype%': hasSymbols && getProto ? getProto(''[Symbol.iterator]()) : undefined,
	'%Symbol%': hasSymbols ? Symbol : undefined,
	'%SyntaxError%': $SyntaxError,
	'%ThrowTypeError%': ThrowTypeError,
	'%TypedArray%': TypedArray,
	'%TypeError%': $TypeError,
	'%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
	'%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
	'%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
	'%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
	'%URIError%': $URIError,
	'%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
	'%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
	'%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet
};

if (getProto) {
	try {
		null.error; // eslint-disable-line no-unused-expressions
	} catch (e) {
		// https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
		var errorProto = getProto(getProto(e));
		INTRINSICS['%Error.prototype%'] = errorProto;
	}
}

var doEval = function doEval(name) {
	var value;
	if (name === '%AsyncFunction%') {
		value = getEvalledConstructor('async function () {}');
	} else if (name === '%GeneratorFunction%') {
		value = getEvalledConstructor('function* () {}');
	} else if (name === '%AsyncGeneratorFunction%') {
		value = getEvalledConstructor('async function* () {}');
	} else if (name === '%AsyncGenerator%') {
		var fn = doEval('%AsyncGeneratorFunction%');
		if (fn) {
			value = fn.prototype;
		}
	} else if (name === '%AsyncIteratorPrototype%') {
		var gen = doEval('%AsyncGenerator%');
		if (gen && getProto) {
			value = getProto(gen.prototype);
		}
	}

	INTRINSICS[name] = value;

	return value;
};

var LEGACY_ALIASES = {
	__proto__: null,
	'%ArrayBufferPrototype%': ['ArrayBuffer', 'prototype'],
	'%ArrayPrototype%': ['Array', 'prototype'],
	'%ArrayProto_entries%': ['Array', 'prototype', 'entries'],
	'%ArrayProto_forEach%': ['Array', 'prototype', 'forEach'],
	'%ArrayProto_keys%': ['Array', 'prototype', 'keys'],
	'%ArrayProto_values%': ['Array', 'prototype', 'values'],
	'%AsyncFunctionPrototype%': ['AsyncFunction', 'prototype'],
	'%AsyncGenerator%': ['AsyncGeneratorFunction', 'prototype'],
	'%AsyncGeneratorPrototype%': ['AsyncGeneratorFunction', 'prototype', 'prototype'],
	'%BooleanPrototype%': ['Boolean', 'prototype'],
	'%DataViewPrototype%': ['DataView', 'prototype'],
	'%DatePrototype%': ['Date', 'prototype'],
	'%ErrorPrototype%': ['Error', 'prototype'],
	'%EvalErrorPrototype%': ['EvalError', 'prototype'],
	'%Float32ArrayPrototype%': ['Float32Array', 'prototype'],
	'%Float64ArrayPrototype%': ['Float64Array', 'prototype'],
	'%FunctionPrototype%': ['Function', 'prototype'],
	'%Generator%': ['GeneratorFunction', 'prototype'],
	'%GeneratorPrototype%': ['GeneratorFunction', 'prototype', 'prototype'],
	'%Int8ArrayPrototype%': ['Int8Array', 'prototype'],
	'%Int16ArrayPrototype%': ['Int16Array', 'prototype'],
	'%Int32ArrayPrototype%': ['Int32Array', 'prototype'],
	'%JSONParse%': ['JSON', 'parse'],
	'%JSONStringify%': ['JSON', 'stringify'],
	'%MapPrototype%': ['Map', 'prototype'],
	'%NumberPrototype%': ['Number', 'prototype'],
	'%ObjectPrototype%': ['Object', 'prototype'],
	'%ObjProto_toString%': ['Object', 'prototype', 'toString'],
	'%ObjProto_valueOf%': ['Object', 'prototype', 'valueOf'],
	'%PromisePrototype%': ['Promise', 'prototype'],
	'%PromiseProto_then%': ['Promise', 'prototype', 'then'],
	'%Promise_all%': ['Promise', 'all'],
	'%Promise_reject%': ['Promise', 'reject'],
	'%Promise_resolve%': ['Promise', 'resolve'],
	'%RangeErrorPrototype%': ['RangeError', 'prototype'],
	'%ReferenceErrorPrototype%': ['ReferenceError', 'prototype'],
	'%RegExpPrototype%': ['RegExp', 'prototype'],
	'%SetPrototype%': ['Set', 'prototype'],
	'%SharedArrayBufferPrototype%': ['SharedArrayBuffer', 'prototype'],
	'%StringPrototype%': ['String', 'prototype'],
	'%SymbolPrototype%': ['Symbol', 'prototype'],
	'%SyntaxErrorPrototype%': ['SyntaxError', 'prototype'],
	'%TypedArrayPrototype%': ['TypedArray', 'prototype'],
	'%TypeErrorPrototype%': ['TypeError', 'prototype'],
	'%Uint8ArrayPrototype%': ['Uint8Array', 'prototype'],
	'%Uint8ClampedArrayPrototype%': ['Uint8ClampedArray', 'prototype'],
	'%Uint16ArrayPrototype%': ['Uint16Array', 'prototype'],
	'%Uint32ArrayPrototype%': ['Uint32Array', 'prototype'],
	'%URIErrorPrototype%': ['URIError', 'prototype'],
	'%WeakMapPrototype%': ['WeakMap', 'prototype'],
	'%WeakSetPrototype%': ['WeakSet', 'prototype']
};

var bind = __webpack_require__(155);
var hasOwn = __webpack_require__(578);
var $concat = bind.call(Function.call, Array.prototype.concat);
var $spliceApply = bind.call(Function.apply, Array.prototype.splice);
var $replace = bind.call(Function.call, String.prototype.replace);
var $strSlice = bind.call(Function.call, String.prototype.slice);
var $exec = bind.call(Function.call, RegExp.prototype.exec);

/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */
var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */
var stringToPath = function stringToPath(string) {
	var first = $strSlice(string, 0, 1);
	var last = $strSlice(string, -1);
	if (first === '%' && last !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected closing `%`');
	} else if (last === '%' && first !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected opening `%`');
	}
	var result = [];
	$replace(string, rePropName, function (match, number, quote, subString) {
		result[result.length] = quote ? $replace(subString, reEscapeChar, '$1') : number || match;
	});
	return result;
};
/* end adaptation */

var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
	var intrinsicName = name;
	var alias;
	if (hasOwn(LEGACY_ALIASES, intrinsicName)) {
		alias = LEGACY_ALIASES[intrinsicName];
		intrinsicName = '%' + alias[0] + '%';
	}

	if (hasOwn(INTRINSICS, intrinsicName)) {
		var value = INTRINSICS[intrinsicName];
		if (value === needsEval) {
			value = doEval(intrinsicName);
		}
		if (typeof value === 'undefined' && !allowMissing) {
			throw new $TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
		}

		return {
			alias: alias,
			name: intrinsicName,
			value: value
		};
	}

	throw new $SyntaxError('intrinsic ' + name + ' does not exist!');
};

module.exports = function GetIntrinsic(name, allowMissing) {
	if (typeof name !== 'string' || name.length === 0) {
		throw new $TypeError('intrinsic name must be a non-empty string');
	}
	if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
		throw new $TypeError('"allowMissing" argument must be a boolean');
	}

	if ($exec(/^%?[^%]*%?$/, name) === null) {
		throw new $SyntaxError('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
	}
	var parts = stringToPath(name);
	var intrinsicBaseName = parts.length > 0 ? parts[0] : '';

	var intrinsic = getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
	var intrinsicRealName = intrinsic.name;
	var value = intrinsic.value;
	var skipFurtherCaching = false;

	var alias = intrinsic.alias;
	if (alias) {
		intrinsicBaseName = alias[0];
		$spliceApply(parts, $concat([0, 1], alias));
	}

	for (var i = 1, isOwn = true; i < parts.length; i += 1) {
		var part = parts[i];
		var first = $strSlice(part, 0, 1);
		var last = $strSlice(part, -1);
		if (
			(
				(first === '"' || first === "'" || first === '`')
				|| (last === '"' || last === "'" || last === '`')
			)
			&& first !== last
		) {
			throw new $SyntaxError('property names with quotes must have matching quotes');
		}
		if (part === 'constructor' || !isOwn) {
			skipFurtherCaching = true;
		}

		intrinsicBaseName += '.' + part;
		intrinsicRealName = '%' + intrinsicBaseName + '%';

		if (hasOwn(INTRINSICS, intrinsicRealName)) {
			value = INTRINSICS[intrinsicRealName];
		} else if (value != null) {
			if (!(part in value)) {
				if (!allowMissing) {
					throw new $TypeError('base intrinsic for ' + name + ' exists, but the property is not available.');
				}
				return void undefined;
			}
			if ($gOPD && (i + 1) >= parts.length) {
				var desc = $gOPD(value, part);
				isOwn = !!desc;

				// By convention, when a data property is converted to an accessor
				// property to emulate a data property that does not suffer from
				// the override mistake, that accessor's getter is marked with
				// an `originalValue` property. Here, when we detect this, we
				// uphold the illusion by pretending to see that original data
				// property, i.e., returning the value rather than the getter
				// itself.
				if (isOwn && 'get' in desc && !('originalValue' in desc.get)) {
					value = desc.get;
				} else {
					value = value[part];
				}
			} else {
				isOwn = hasOwn(value, part);
				value = value[part];
			}

			if (isOwn && !skipFurtherCaching) {
				INTRINSICS[intrinsicRealName] = value;
			}
		}
	}
	return value;
};


/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return axiosSingleton; });
/* unused harmony export generalPostRequest */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return generalGetRequest; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(602);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_endpoints__ = __webpack_require__(9);
var axiosSingleton=__WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({timeout:60000,baseURL:__WEBPACK_IMPORTED_MODULE_1__constants_endpoints__["a" /* BASE_API_URL */],withCredentials:true});var generalPostRequest=function generalPostRequest(args){var method='POST';var headers=new window.Headers();var credentials='include';var mode='cors';var url=args.endpointUrl;var body=JSON.stringify(args.body);headers.append('Accept','application/json');headers.append('Content-Type','application/json');var options={headers:headers,method:method,credentials:credentials,mode:mode,body:body};return window.fetch(url,options).then(function(response){if(response.ok){return response.json();}return response.error();}).then(function(json){return json;}).catch(function(error){throw error;});};var generalGetRequest=function generalGetRequest(args){var method='GET';var headers=new window.Headers();var url=args.endpointUrl;headers.append('Accept','application/json');headers.append('Content-Type','application/json');var options={headers:headers,method:method};return window.fetch(url,options).then(function(response){if(response.ok){return response.json();}return response.error();}).then(function(json){return json;}).catch(function(error){throw error;});};

/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NavigationButton; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_NavigationButton__ = __webpack_require__(621);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_helpers_variables__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants_endpoints__ = __webpack_require__(9);
var NavigationButton=function NavigationButton(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__styles_NavigationButton__["a" /* NavigationButtonContainer */],{to:props.url,style:{backgroundColor:props.bgColor?props.bgColor:__WEBPACK_IMPORTED_MODULE_3__styles_helpers_variables__["c" /* color */].white},mb:props.mb},props.image?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__styles_NavigationButton__["c" /* NavigationButtonImage */],{url:''+__WEBPACK_IMPORTED_MODULE_4__constants_endpoints__["n" /* SITE_ROOT_URL */]+props.image}):false,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__styles_NavigationButton__["b" /* NavigationButtonContent */],null,props.title));};NavigationButton.defaultProps={bgColor:null,image:null,mb:null};NavigationButton.propTypes={title:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,url:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,bgColor:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,image:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,mb:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number};

/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_createBrowserHistory__ = __webpack_require__(682);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_createBrowserHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_history_createBrowserHistory__);
var history=__WEBPACK_IMPORTED_MODULE_0_history_createBrowserHistory___default()();/* harmony default export */ __webpack_exports__["a"] = (history);

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(46);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 89 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(46);
var TAG = __webpack_require__(16)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__(13);
var aFunction = __webpack_require__(41);
var SPECIES = __webpack_require__(16)('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _extends; });
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('./type')} */
module.exports = TypeError;


/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LoadingSpinner; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_helpers_variables__ = __webpack_require__(4);
var _templateObject=_taggedTemplateLiteral(['\n  to {\n    transform: rotateZ(360deg);\n  }\n'],['\n  to {\n    transform: rotateZ(360deg);\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  margin: 100px auto;\n  width: 75px;\n  height: 75px;\n  border-radius: 100%;\n  border: 3px solid ',';\n  border-top-color: ',';\n  animation: ',' 1s linear infinite;\n\n  @media screen and (min-width: 768px) {\n    margin: 200px auto;\n  }\n\n  ',';\n'],['\n  margin: 100px auto;\n  width: 75px;\n  height: 75px;\n  border-radius: 100%;\n  border: 3px solid ',';\n  border-top-color: ',';\n  animation: ',' 1s linear infinite;\n\n  @media screen and (min-width: 768px) {\n    margin: 200px auto;\n  }\n\n  ',';\n']),_templateObject3=_taggedTemplateLiteral(['\n      margin: ',';\n    '],['\n      margin: ',';\n    ']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var LoadingSpinner=function LoadingSpinner(props){var margin=props.margin;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LoadingSpinnerRoot,{margin:margin});};LoadingSpinner.defaultProps={margin:undefined};LoadingSpinner.propTypes={margin:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};var Spin=Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["keyframes"])(_templateObject);var LoadingSpinnerRoot=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].div(_templateObject2,__WEBPACK_IMPORTED_MODULE_3__styles_helpers_variables__["c" /* color */].grey,__WEBPACK_IMPORTED_MODULE_3__styles_helpers_variables__["c" /* color */].black,Spin,function(props){return props.margin&&Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["css"])(_templateObject3,props.margin);});

/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StartPageBlock; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_variables__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_mixins__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Section__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Container__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Heading__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Paragraph__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helpers_animations__ = __webpack_require__(81);
var _templateObject=_taggedTemplateLiteral(['\n  position: relative;\n  font-weight: normal;\n  font-style: normal;\n  font-stretch: normal;\n  line-height: 1.88;\n  letter-spacing: normal;\n  text-align: center;\n  color: ',';\n  z-index: 1;\n  padding: 20px 0;\n  margin: 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  span {\n    ',';\n    position: relative;\n    z-index: 1;\n    background-color: #d8d9d1;\n    padding: 0 0.5em;\n    top: -1px;\n  }\n\n  &:before {\n    content: \'\';\n    position: absolute;\n    height: 1px;\n    width: 100%;\n    max-width: 480px;\n    background-color: ',';\n    z-index: -1;\n  }\n\n  @media screen and (min-width: ','px) {\n    padding: 34px 0;\n  }\n'],['\n  position: relative;\n  font-weight: normal;\n  font-style: normal;\n  font-stretch: normal;\n  line-height: 1.88;\n  letter-spacing: normal;\n  text-align: center;\n  color: ',';\n  z-index: 1;\n  padding: 20px 0;\n  margin: 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  span {\n    ',';\n    position: relative;\n    z-index: 1;\n    background-color: #d8d9d1;\n    padding: 0 0.5em;\n    top: -1px;\n  }\n\n  &:before {\n    content: \'\';\n    position: absolute;\n    height: 1px;\n    width: 100%;\n    max-width: 480px;\n    background-color: ',';\n    z-index: -1;\n  }\n\n  @media screen and (min-width: ','px) {\n    padding: 34px 0;\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  ',';\n  font-size: 36px;\n  font-weight: normal;\n  font-style: normal;\n  font-stretch: normal;\n  line-height: 1.33;\n  letter-spacing: normal;\n  text-align: center;\n  margin-bottom: 20px;\n  color: ',';\n  width: 100%;\n\n  @media screen and (min-width: ','px) {\n    color: ',';\n    margin-top: 20px;\n  }\n\n  @media screen and (min-width: ','px) {\n    font-size: 44px;\n  }\n\n  ',';\n'],['\n  ',';\n  font-size: 36px;\n  font-weight: normal;\n  font-style: normal;\n  font-stretch: normal;\n  line-height: 1.33;\n  letter-spacing: normal;\n  text-align: center;\n  margin-bottom: 20px;\n  color: ',';\n  width: 100%;\n\n  @media screen and (min-width: ','px) {\n    color: ',';\n    margin-top: 20px;\n  }\n\n  @media screen and (min-width: ','px) {\n    font-size: 44px;\n  }\n\n  ',';\n']),_templateObject3=_taggedTemplateLiteral(['\n      color: ',';\n    '],['\n      color: ',';\n    ']),_templateObject4=_taggedTemplateLiteral(['\n  text-decoration: none;\n  width: 280px;\n  height: 280px;\n  background-color: ',';\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  padding: 20px;\n  transition: opacity 250ms ease-out;\n\n  @media screen and (min-width: ','px) {\n    width: 360px;\n    height: 360px;\n  }\n'],['\n  text-decoration: none;\n  width: 280px;\n  height: 280px;\n  background-color: ',';\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  padding: 20px;\n  transition: opacity 250ms ease-out;\n\n  @media screen and (min-width: ','px) {\n    width: 360px;\n    height: 360px;\n  }\n']),_templateObject5=_taggedTemplateLiteral(['\n  font-size: 12px;\n  font-weight: 600;\n  font-style: normal;\n  font-stretch: normal;\n  line-height: normal;\n  letter-spacing: 1.5px;\n  text-align: center;\n  color: ',';\n  text-decoration: none;\n  text-transform: uppercase;\n  display: block;\n  padding: 10px;\n\n  @media screen and (min-width: ','px) {\n    font-size: 14px;\n  }\n\n  ',';\n'],['\n  font-size: 12px;\n  font-weight: 600;\n  font-style: normal;\n  font-stretch: normal;\n  line-height: normal;\n  letter-spacing: 1.5px;\n  text-align: center;\n  color: ',';\n  text-decoration: none;\n  text-transform: uppercase;\n  display: block;\n  padding: 10px;\n\n  @media screen and (min-width: ','px) {\n    font-size: 14px;\n  }\n\n  ',';\n']),_templateObject6=_taggedTemplateLiteral(['\n  position: relative;\n  &:before,\n  &:after {\n    content: \'\';\n    position: absolute;\n    right: 0;\n    left: 0;\n    height: 1px;\n    display: block;\n    opacity: 0;\n    transition: opacity 250ms ease-out, transform 250ms ease-out;\n    background-color: ',';\n  }\n  \n  &:before {\n    bottom: -5px;\n    transform: translateY(10px);\n  }\n  \n  &:after {\n    top: -5px;\n    transform: translateY(-10px);\n  }\n  \n  ',':hover & {\n    &:before,\n    &:after {\n      opacity: 1;\n      transform: translateY(0);\n    }\n  }\n  &:hover {\n    &:before,\n    &:after {\n      opacity: 1;\n      transform: translateY(0);\n    }\n  }\n'],['\n  position: relative;\n  &:before,\n  &:after {\n    content: \'\';\n    position: absolute;\n    right: 0;\n    left: 0;\n    height: 1px;\n    display: block;\n    opacity: 0;\n    transition: opacity 250ms ease-out, transform 250ms ease-out;\n    background-color: ',';\n  }\n  \n  &:before {\n    bottom: -5px;\n    transform: translateY(10px);\n  }\n  \n  &:after {\n    top: -5px;\n    transform: translateY(-10px);\n  }\n  \n  ',':hover & {\n    &:before,\n    &:after {\n      opacity: 1;\n      transform: translateY(0);\n    }\n  }\n  &:hover {\n    &:before,\n    &:after {\n      opacity: 1;\n      transform: translateY(0);\n    }\n  }\n']),_templateObject7=_taggedTemplateLiteral(['\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  height: 128px;\n  background: ',';\n'],['\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  height: 128px;\n  background: ',';\n']),_templateObject8=_taggedTemplateLiteral(['\n  padding-top: 0;\n  padding-bottom: 30px;\n\n  @media screen and (min-width: ','px) {\n    padding-bottom: 0;\n  }\n'],['\n  padding-top: 0;\n  padding-bottom: 30px;\n\n  @media screen and (min-width: ','px) {\n    padding-bottom: 0;\n  }\n']),_templateObject9=_taggedTemplateLiteral(['\n  width: 100%;\n  height: 0;\n  padding-bottom: 72.5%;\n  position: relative;\n  overflow: hidden;\n\n  @media screen and (min-width: ','px) {\n    padding-bottom: 47.16%;\n  }\n'],['\n  width: 100%;\n  height: 0;\n  padding-bottom: 72.5%;\n  position: relative;\n  overflow: hidden;\n\n  @media screen and (min-width: ','px) {\n    padding-bottom: 47.16%;\n  }\n']),_templateObject10=_taggedTemplateLiteral(['\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  display: flex;\n  align-items: center;\n  padding: 0 7%;\n  justify-content: ',';\n'],['\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  display: flex;\n  align-items: center;\n  padding: 0 7%;\n  justify-content: ',';\n']),_templateObject11=_taggedTemplateLiteral(['\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background-image: url("','");\n  background-size: cover;\n  background-position: center;\n  ',';\n'],['\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background-image: url("','");\n  background-size: cover;\n  background-position: center;\n  ',';\n']),_templateObject12=_taggedTemplateLiteral(['\n  display: block;\n  font-size: 12px;\n  font-weight: 600;\n  font-style: normal;\n  font-stretch: normal;\n  line-height: normal;\n  letter-spacing: 1.5px;\n  text-align: center;\n  text-decoration: none;\n  text-transform: uppercase;\n  color: ',';\n  margin-bottom: 30px;\n  margin-top: 10px;\n'],['\n  display: block;\n  font-size: 12px;\n  font-weight: 600;\n  font-style: normal;\n  font-stretch: normal;\n  line-height: normal;\n  letter-spacing: 1.5px;\n  text-align: center;\n  text-decoration: none;\n  text-transform: uppercase;\n  color: ',';\n  margin-bottom: 30px;\n  margin-top: 10px;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var StartPageBlock={};StartPageBlock.PageHeading=__WEBPACK_IMPORTED_MODULE_6__Heading__["a" /* Heading */].extend(_templateObject,__WEBPACK_IMPORTED_MODULE_2__helpers_variables__["c" /* color */].black,Object(__WEBPACK_IMPORTED_MODULE_3__helpers_mixins__["b" /* dynamicFontSize */])(16,24),__WEBPACK_IMPORTED_MODULE_2__helpers_variables__["c" /* color */].black,__WEBPACK_IMPORTED_MODULE_2__helpers_variables__["f" /* size */].large);StartPageBlock.Heading=__WEBPACK_IMPORTED_MODULE_6__Heading__["a" /* Heading */].h2;StartPageBlock.HeroHeading=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].p(_templateObject2,__WEBPACK_IMPORTED_MODULE_3__helpers_mixins__["e" /* fontFamilyHeading */],__WEBPACK_IMPORTED_MODULE_2__helpers_variables__["c" /* color */].black,__WEBPACK_IMPORTED_MODULE_2__helpers_variables__["f" /* size */].large,function(props){return props.isDark?__WEBPACK_IMPORTED_MODULE_2__helpers_variables__["c" /* color */].white:__WEBPACK_IMPORTED_MODULE_2__helpers_variables__["c" /* color */].black;},__WEBPACK_IMPORTED_MODULE_2__helpers_variables__["f" /* size */].xLarge+100,function(props){return props.onDarkBackground&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(_templateObject3,__WEBPACK_IMPORTED_MODULE_2__helpers_variables__["c" /* color */].white);});StartPageBlock.HeroContent=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* Link */])(_templateObject4,function(props){return props.isLight?'rgba(255, 255, 255, 0.6)':'rgba(0, 0, 0, 0.6)';},__WEBPACK_IMPORTED_MODULE_2__helpers_variables__["f" /* size */].xLarge+100);StartPageBlock.HeroLinkBase=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* Link */])(_templateObject5,function(props){return props.isDark?__WEBPACK_IMPORTED_MODULE_2__helpers_variables__["c" /* color */].white:__WEBPACK_IMPORTED_MODULE_2__helpers_variables__["c" /* color */].black;},__WEBPACK_IMPORTED_MODULE_2__helpers_variables__["f" /* size */].large,function(props){return props.onDarkBackground&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(_templateObject3,__WEBPACK_IMPORTED_MODULE_2__helpers_variables__["c" /* color */].white);});StartPageBlock.HeroLink=StartPageBlock.HeroLinkBase.withComponent(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* Link */]);StartPageBlock.HeroLinkAsP=StartPageBlock.HeroLinkBase.withComponent('p').extend(_templateObject6,function(props){return props.isDark?__WEBPACK_IMPORTED_MODULE_2__helpers_variables__["c" /* color */].white:__WEBPACK_IMPORTED_MODULE_2__helpers_variables__["c" /* color */].black;},StartPageBlock.HeroContent);StartPageBlock.Section=__WEBPACK_IMPORTED_MODULE_4__Section__["a" /* Section */];StartPageBlock.SectionFix=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].div(_templateObject7,function(props){return props.backgroundColor?props.backgroundColor:__WEBPACK_IMPORTED_MODULE_2__helpers_variables__["c" /* color */].white;});StartPageBlock.Container=__WEBPACK_IMPORTED_MODULE_5__Container__["a" /* Container */].extend(_templateObject8,__WEBPACK_IMPORTED_MODULE_2__helpers_variables__["f" /* size */].large);StartPageBlock.Paragraph=__WEBPACK_IMPORTED_MODULE_7__Paragraph__["a" /* Paragraph */];StartPageBlock.HeroImageContainer=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].div(_templateObject9,__WEBPACK_IMPORTED_MODULE_2__helpers_variables__["f" /* size */].large);StartPageBlock.HeroContentContainer=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].div(_templateObject10,function(props){return props.alignRight?'flex-end':'flex-start';});StartPageBlock.HeroImage=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].div(_templateObject11,function(props){return props.image;},__WEBPACK_IMPORTED_MODULE_8__helpers_animations__["e" /* ImageZoomAnimation */]);StartPageBlock.InstagramHashTag=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].a(_templateObject12,__WEBPACK_IMPORTED_MODULE_2__helpers_variables__["c" /* color */].white);

/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FullWidthContainer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_mixins__ = __webpack_require__(6);
var _templateObject=_taggedTemplateLiteral(['\n  width: 100%;\n  margin: 0;\n  padding: 0;\n  background-color: ',';\n\n  ',';\n'],['\n  width: 100%;\n  margin: 0;\n  padding: 0;\n  background-color: ',';\n\n  ',';\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var FullWidthContainer=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].div(_templateObject,function(props){return props.bgColor?props.bgColor:'transparent';},function(props){return props.hideOnPrint&&__WEBPACK_IMPORTED_MODULE_2__helpers_mixins__["f" /* hideOnPrint */];});FullWidthContainer.defaultProps={bgColor:null,hideOnPrint:false};FullWidthContainer.propTypes={bgColor:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,hideOnPrint:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(20);
var global = __webpack_require__(11);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(58) ? 'pure' : 'global',
  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(33);
var toLength = __webpack_require__(17);
var toAbsoluteIndex = __webpack_require__(60);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 99 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(46);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(16)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.2.5.3 get RegExp.prototype.flags
var anObject = __webpack_require__(13);
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var classof = __webpack_require__(90);
var builtinExec = RegExp.prototype.exec;

 // `RegExpExec` abstract operation
// https://tc39.github.io/ecma262/#sec-regexpexec
module.exports = function (R, S) {
  var exec = R.exec;
  if (typeof exec === 'function') {
    var result = exec.call(R, S);
    if (typeof result !== 'object') {
      throw new TypeError('RegExp exec method returned something other than an Object or null');
    }
    return result;
  }
  if (classof(R) !== 'RegExp') {
    throw new TypeError('RegExp#exec called on incompatible receiver');
  }
  return builtinExec.call(R, S);
};


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(191);
var redefine = __webpack_require__(27);
var hide = __webpack_require__(32);
var fails = __webpack_require__(12);
var defined = __webpack_require__(47);
var wks = __webpack_require__(16);
var regexpExec = __webpack_require__(138);

var SPECIES = wks('species');

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
  // #replace needs built-in support for named groups.
  // #match works fine because it just return the exec results, even if it has
  // a "grops" property.
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  return ''.replace(re, '$<a>') !== '7';
});

var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = (function () {
  // Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
  var re = /(?:)/;
  var originalExec = re.exec;
  re.exec = function () { return originalExec.apply(this, arguments); };
  var result = 'ab'.split(re);
  return result.length === 2 && result[0] === 'a' && result[1] === 'b';
})();

module.exports = function (KEY, length, exec) {
  var SYMBOL = wks(KEY);

  var DELEGATES_TO_SYMBOL = !fails(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL ? !fails(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;
    re.exec = function () { execCalled = true; return null; };
    if (KEY === 'split') {
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES] = function () { return re; };
    }
    re[SYMBOL]('');
    return !execCalled;
  }) : undefined;

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    (KEY === 'replace' && !REPLACE_SUPPORTS_NAMED_GROUPS) ||
    (KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC)
  ) {
    var nativeRegExpMethod = /./[SYMBOL];
    var fns = exec(
      defined,
      SYMBOL,
      ''[KEY],
      function maybeCallNative(nativeMethod, regexp, str, arg2, forceStringMethod) {
        if (regexp.exec === regexpExec) {
          if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
            // The native String method already delegates to @@method (this
            // polyfilled function), leasing to infinite recursion.
            // We avoid it by directly calling the native @@method method.
            return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
          }
          return { done: true, value: nativeMethod.call(str, regexp, arg2) };
        }
        return { done: false };
      }
    );
    var strfn = fns[0];
    var rxfn = fns[1];

    redefine(String.prototype, KEY, strfn);
    hide(RegExp.prototype, SYMBOL, length == 2
      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
      ? function (string, arg) { return rxfn.call(string, this, arg); }
      // 21.2.5.6 RegExp.prototype[@@match](string)
      // 21.2.5.9 RegExp.prototype[@@search](string)
      : function (string) { return rxfn.call(string, this); }
    );
  }
};


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(40);
var call = __webpack_require__(186);
var isArrayIter = __webpack_require__(133);
var anObject = __webpack_require__(13);
var toLength = __webpack_require__(17);
var getIterFn = __webpack_require__(135);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(11);
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(11);
var $export = __webpack_require__(3);
var redefine = __webpack_require__(27);
var redefineAll = __webpack_require__(78);
var meta = __webpack_require__(51);
var forOf = __webpack_require__(105);
var anInstance = __webpack_require__(77);
var isObject = __webpack_require__(14);
var fails = __webpack_require__(12);
var $iterDetect = __webpack_require__(101);
var setToStringTag = __webpack_require__(73);
var inheritIfRequired = __webpack_require__(124);

module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  var fixMethod = function (KEY) {
    var fn = proto[KEY];
    redefine(proto, KEY,
      KEY == 'delete' ? function (a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'has' ? function has(a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'get' ? function get(a) {
        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'add' ? function add(a) { fn.call(this, a === 0 ? 0 : a); return this; }
        : function set(a, b) { fn.call(this, a === 0 ? 0 : a, b); return this; }
    );
  };
  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    var instance = new C();
    // early implementations not supports chaining
    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
    // most early implementations doesn't supports iterables, most modern - not close it correctly
    var ACCEPT_ITERABLES = $iterDetect(function (iter) { new C(iter); }); // eslint-disable-line no-new
    // for early implementations -0 and +0 not the same
    var BUGGY_ZERO = !IS_WEAK && fails(function () {
      // V8 ~ Chromium 42- fails only with 5+ elements
      var $instance = new C();
      var index = 5;
      while (index--) $instance[ADDER](index, index);
      return !$instance.has(-0);
    });
    if (!ACCEPT_ITERABLES) {
      C = wrapper(function (target, iterable) {
        anInstance(target, C, NAME);
        var that = inheritIfRequired(new Base(), target, C);
        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
        return that;
      });
      C.prototype = proto;
      proto.constructor = C;
    }
    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }
    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
    // weak collections should not contains .clear method
    if (IS_WEAK && proto.clear) delete proto.clear;
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F * (C != Base), O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(11);
var hide = __webpack_require__(32);
var uid = __webpack_require__(57);
var TYPED = uid('typed_array');
var VIEW = uid('view');
var ABV = !!(global.ArrayBuffer && global.DataView);
var CONSTR = ABV;
var i = 0;
var l = 9;
var Typed;

var TypedArrayConstructors = (
  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
).split(',');

while (i < l) {
  if (Typed = global[TypedArrayConstructors[i++]]) {
    hide(Typed.prototype, TYPED, true);
    hide(Typed.prototype, VIEW, true);
  } else CONSTR = false;
}

module.exports = {
  ABV: ABV,
  CONSTR: CONSTR,
  TYPED: TYPED,
  VIEW: VIEW
};


/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export BUFFER_OVERFLOW */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return buffers; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(34);


var BUFFER_OVERFLOW = "Channel's Buffer overflow!";

var ON_OVERFLOW_THROW = 1;
var ON_OVERFLOW_DROP = 2;
var ON_OVERFLOW_SLIDE = 3;
var ON_OVERFLOW_EXPAND = 4;

var zeroBuffer = { isEmpty: __WEBPACK_IMPORTED_MODULE_0__utils__["o" /* kTrue */], put: __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */], take: __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */] };

function ringBuffer() {
  var limit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;
  var overflowAction = arguments[1];

  var arr = new Array(limit);
  var length = 0;
  var pushIndex = 0;
  var popIndex = 0;

  var push = function push(it) {
    arr[pushIndex] = it;
    pushIndex = (pushIndex + 1) % limit;
    length++;
  };

  var take = function take() {
    if (length != 0) {
      var it = arr[popIndex];
      arr[popIndex] = null;
      length--;
      popIndex = (popIndex + 1) % limit;
      return it;
    }
  };

  var flush = function flush() {
    var items = [];
    while (length) {
      items.push(take());
    }
    return items;
  };

  return {
    isEmpty: function isEmpty() {
      return length == 0;
    },
    put: function put(it) {
      if (length < limit) {
        push(it);
      } else {
        var doubledLimit = void 0;
        switch (overflowAction) {
          case ON_OVERFLOW_THROW:
            throw new Error(BUFFER_OVERFLOW);
          case ON_OVERFLOW_SLIDE:
            arr[pushIndex] = it;
            pushIndex = (pushIndex + 1) % limit;
            popIndex = pushIndex;
            break;
          case ON_OVERFLOW_EXPAND:
            doubledLimit = 2 * limit;

            arr = flush();

            length = arr.length;
            pushIndex = arr.length;
            popIndex = 0;

            arr.length = doubledLimit;
            limit = doubledLimit;

            push(it);
            break;
          default:
          // DROP
        }
      }
    },
    take: take,
    flush: flush
  };
}

var buffers = {
  none: function none() {
    return zeroBuffer;
  },
  fixed: function fixed(limit) {
    return ringBuffer(limit, ON_OVERFLOW_THROW);
  },
  dropping: function dropping(limit) {
    return ringBuffer(limit, ON_OVERFLOW_DROP);
  },
  sliding: function sliding(limit) {
    return ringBuffer(limit, ON_OVERFLOW_SLIDE);
  },
  expanding: function expanding(initialSize) {
    return ringBuffer(initialSize, ON_OVERFLOW_EXPAND);
  }
};

/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return MATERIAL_IMAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BARE_IMAGE; });
var MATERIAL_IMAGE='MaterialImage';var BARE_IMAGE='BareImage';

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var stringify = __webpack_require__(567);
var parse = __webpack_require__(586);
var formats = __webpack_require__(157);

module.exports = {
    formats: formats,
    parse: parse,
    stringify: stringify
};


/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Button; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_variables__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_mixins__ = __webpack_require__(6);
var _templateObject=_taggedTemplateLiteral(['\n  ',';\n  width: 100%;\n  padding: 1rem 2rem;\n  margin: 7px 0 20px;\n  position: relative;\n\n  color: ',';\n  background-color: ',';\n  border: 1px solid ',';\n\n  ',';\n  font-size: 13px;\n  text-align: center;\n  font-weight: 600;\n  letter-spacing: 1.5px;\n  text-transform: uppercase;\n  overflow: hidden;\n\n  cursor: pointer;\n  transition: opacity 0.25s ease, background-color 150ms ease-out, border-color 150ms ease-out, color 150ms ease-out;\n\n  &:hover {\n    opacity: 0.8;\n  }\n\n  &:focus {\n    outline: 0;\n    border-color: ',';\n  }\n\n  ','\n  ','\n  ','\n    ',';\n\n  ',';\n'],['\n  ',';\n  width: 100%;\n  padding: 1rem 2rem;\n  margin: 7px 0 20px;\n  position: relative;\n\n  color: ',';\n  background-color: ',';\n  border: 1px solid ',';\n\n  ',';\n  font-size: 13px;\n  text-align: center;\n  font-weight: 600;\n  letter-spacing: 1.5px;\n  text-transform: uppercase;\n  overflow: hidden;\n\n  cursor: pointer;\n  transition: opacity 0.25s ease, background-color 150ms ease-out, border-color 150ms ease-out, color 150ms ease-out;\n\n  &:hover {\n    opacity: 0.8;\n  }\n\n  &:focus {\n    outline: 0;\n    border-color: ',';\n  }\n\n  ','\n  ','\n  ','\n    ',';\n\n  ',';\n']),_templateObject2=_taggedTemplateLiteral(['\n      background-color: ',';\n      border-color: ',';\n\n      &:after {\n        content: \'\';\n        position: absolute;\n        top: 0;\n        right: 0;\n        bottom: 0;\n        left: 0;\n        background-color: ',';\n        background-image: url(\'/images/icons/checkmark.svg\');\n        background-repeat: no-repeat;\n        background-size: 25px;\n        background-position: center;\n        transform: translateY(-100%);\n        opacity: 0;\n        transition: opacity 450ms ease-in-out, transform 250ms ease-in-out;\n      }\n    '],['\n      background-color: ',';\n      border-color: ',';\n\n      &:after {\n        content: \'\';\n        position: absolute;\n        top: 0;\n        right: 0;\n        bottom: 0;\n        left: 0;\n        background-color: ',';\n        background-image: url(\'/images/icons/checkmark.svg\');\n        background-repeat: no-repeat;\n        background-size: 25px;\n        background-position: center;\n        transform: translateY(-100%);\n        opacity: 0;\n        transition: opacity 450ms ease-in-out, transform 250ms ease-in-out;\n      }\n    ']),_templateObject3=_taggedTemplateLiteral(['\n      margin: 0 0 15px;\n      font-size: 15px;\n      letter-spacing: 0.07em;\n    '],['\n      margin: 0 0 15px;\n      font-size: 15px;\n      letter-spacing: 0.07em;\n    ']),_templateObject4=_taggedTemplateLiteral(['\n      width: auto;\n      padding: 0.5rem 1rem;\n      font-size: 10px;\n      letter-spacing: 0.07em;\n      &:after {\n        background-size: 15px;\n      }\n    '],['\n      width: auto;\n      padding: 0.5rem 1rem;\n      font-size: 10px;\n      letter-spacing: 0.07em;\n      &:after {\n        background-size: 15px;\n      }\n    ']),_templateObject5=_taggedTemplateLiteral(['\n      position: sticky;\n      bottom: -1px;\n      padding: 0.5rem 2rem;\n    '],['\n      position: sticky;\n      bottom: -1px;\n      padding: 0.5rem 2rem;\n    ']),_templateObject6=_taggedTemplateLiteral(['\n      cursor: default;\n      opacity: 1 !important;\n      border-color: ',';\n\n      &:after {\n        transform: translateY(0);\n        opacity: 1;\n      }\n    '],['\n      cursor: default;\n      opacity: 1 !important;\n      border-color: ',';\n\n      &:after {\n        transform: translateY(0);\n        opacity: 1;\n      }\n    ']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Button=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].button(_templateObject,__WEBPACK_IMPORTED_MODULE_4__helpers_mixins__["f" /* hideOnPrint */],__WEBPACK_IMPORTED_MODULE_3__helpers_variables__["c" /* color */].white,__WEBPACK_IMPORTED_MODULE_3__helpers_variables__["c" /* color */].black,__WEBPACK_IMPORTED_MODULE_3__helpers_variables__["c" /* color */].black,__WEBPACK_IMPORTED_MODULE_4__helpers_mixins__["d" /* fontFamilyBody */],__WEBPACK_IMPORTED_MODULE_3__helpers_variables__["c" /* color */].black,function(props){return props.success&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(_templateObject2,__WEBPACK_IMPORTED_MODULE_3__helpers_variables__["c" /* color */].success,__WEBPACK_IMPORTED_MODULE_3__helpers_variables__["c" /* color */].success,__WEBPACK_IMPORTED_MODULE_3__helpers_variables__["c" /* color */].success);},function(props){return props.buy&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(_templateObject3);},function(props){return props.smallBuy&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(_templateObject4);},function(props){return props.sticky&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(_templateObject5);},function(props){return props.active&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(_templateObject6,__WEBPACK_IMPORTED_MODULE_3__helpers_variables__["c" /* color */].success);});Button.button=Button;Button.a=Button.withComponent('a');Button.link=Button.withComponent(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* Link */]);Button.propTypes={success:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,sticky:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,onClick:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};Button.link.propTypes={success:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,sticky:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,onClick:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,to:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};

/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return COMPLETE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return LOADING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return INITIAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return PENDING; });
var SUCCESS='SUCCESS';var COMPLETE='COMPLETE';var LOADING='LOADING';var FAILURE='FAILURE';var INITIAL='INITIAL';var PENDING='PENDING';

/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Section; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _templateObject=_taggedTemplateLiteral(['\n  width: 100%;\n  background-color: ',';\n\n  ','\n\n  ','\n\n  ','\n\n  ','\n\n  ','\n'],['\n  width: 100%;\n  background-color: ',';\n\n  ','\n\n  ','\n\n  ','\n\n  ','\n\n  ','\n']),_templateObject2=_taggedTemplateLiteral(['\n      padding-top: ','px;\n      padding-bottom: ','px;\n    '],['\n      padding-top: ','px;\n      padding-bottom: ','px;\n    ']),_templateObject3=_taggedTemplateLiteral(['\n      padding-top: ','px;\n    '],['\n      padding-top: ','px;\n    ']),_templateObject4=_taggedTemplateLiteral(['\n      padding-bottom: ','px;\n    '],['\n      padding-bottom: ','px;\n    ']),_templateObject5=_taggedTemplateLiteral(['\n      margin-top: ','px;\n    '],['\n      margin-top: ','px;\n    ']),_templateObject6=_taggedTemplateLiteral(['\n      margin-bottom: ','px;\n    '],['\n      margin-bottom: ','px;\n    ']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Section=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].section(_templateObject,function(props){return props.backgroundColor?props.backgroundColor:'transparent';},function(props){return props.py&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(_templateObject2,props.py,props.py);},function(props){return props.pt&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(_templateObject3,props.pt);},function(props){return props.pb&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(_templateObject4,props.pb);},function(props){return props.mt&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(_templateObject5,props.mt);},function(props){return props.mb&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(_templateObject6,props.mb);});Section.defaultProps={py:null,pt:null,pb:null,mt:null,mb:null};Section.propTypes={py:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,pt:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,pb:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,mt:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,mb:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number};

/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProductTag; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_variables__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_mixins__ = __webpack_require__(6);
var _templateObject=_taggedTemplateLiteral(['\n  ',';\n  top: ',';\n  left: ',';\n  color: #fff;\n  background-color: ',';\n  text-transform: uppercase;\n  font-weight: 600;\n  letter-spacing: 1px;\n  padding: 2px 5px;\n  margin: 0 5px 5px 0;\n  position: ',';\n\n  @media (min-width: 640px) {\n    padding: 3px 12px;\n  }\n\n  ',' ',';\n'],['\n  ',';\n  top: ',';\n  left: ',';\n  color: #fff;\n  background-color: ',';\n  text-transform: uppercase;\n  font-weight: 600;\n  letter-spacing: 1px;\n  padding: 2px 5px;\n  margin: 0 5px 5px 0;\n  position: ',';\n\n  @media (min-width: 640px) {\n    padding: 3px 12px;\n  }\n\n  ',' ',';\n']),_templateObject2=_taggedTemplateLiteral(['\n      background-color: ',';\n    '],['\n      background-color: ',';\n    ']),_templateObject3=_taggedTemplateLiteral(['\n      padding: 3px 8px;\n    '],['\n      padding: 3px 8px;\n    ']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var ProductTag=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].div(_templateObject,function(props){return Object(__WEBPACK_IMPORTED_MODULE_2__helpers_mixins__["b" /* dynamicFontSize */])(props.minFontSize?props.minFontSize:8,props.maxFontSize?props.maxFontSize:12);},function(props){return props.spacing?props.spacing:'8px';},function(props){return props.spacing?props.spacing:'8px';},function(props){return props.color?props.color:'#333';},function(props){return props.absolute?'absolute':'initial';},function(props){return props.sale&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(_templateObject2,__WEBPACK_IMPORTED_MODULE_1__helpers_variables__["c" /* color */].sale);},function(props){return props.big&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(_templateObject3);});

/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SubHeading; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_variables__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_mixins__ = __webpack_require__(6);
var _templateObject=_taggedTemplateLiteral(['\n  font-size: 12px;\n  font-weight: 600;\n  letter-spacing: 2px;\n  color: ',';\n  margin: ',';\n\n  ','\n  ',';\n  ','\n  ','\n'],['\n  font-size: 12px;\n  font-weight: 600;\n  letter-spacing: 2px;\n  color: ',';\n  margin: ',';\n\n  ','\n  ',';\n  ','\n  ','\n']),_templateObject2=_taggedTemplateLiteral(['\n      text-transform: uppercase;\n    '],['\n      text-transform: uppercase;\n    ']),_templateObject3=_taggedTemplateLiteral(['\n      ',';\n      ',';\n    '],['\n      ',';\n      ',';\n    ']),_templateObject4=_taggedTemplateLiteral(['\n      display: inline-block;\n      margin: 0 0 10px;\n      font-size: 13px;\n    '],['\n      display: inline-block;\n      margin: 0 0 10px;\n      font-size: 13px;\n    ']),_templateObject5=_taggedTemplateLiteral(['\n      display: inline-block;\n      margin: 0 0 5px;\n      font-size: 11px;\n    '],['\n      display: inline-block;\n      margin: 0 0 5px;\n      font-size: 11px;\n    ']),_templateObject6=_taggedTemplateLiteral(['\n  text-decoration: none;\n  &:hover {\n    text-decoration: underline;\n  }\n'],['\n  text-decoration: none;\n  &:hover {\n    text-decoration: underline;\n  }\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var SubHeading=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].p(_templateObject,function(props){return props.color?props.color:__WEBPACK_IMPORTED_MODULE_2__helpers_variables__["c" /* color */].grey;},function(props){return props.margin?props.margin:'0 0 .5em';},function(props){return props.uppercase&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(_templateObject2);},function(props){return props.small&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(_templateObject3,Object(__WEBPACK_IMPORTED_MODULE_3__helpers_mixins__["b" /* dynamicFontSize */])(10,13),__WEBPACK_IMPORTED_MODULE_3__helpers_mixins__["c" /* ellipsis */]);},function(props){return props.productPage&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(_templateObject4);},function(props){return props.productPageMoble&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(_templateObject5);});SubHeading.p=SubHeading;SubHeading.link=SubHeading.withComponent(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* Link */]).extend(_templateObject6);SubHeading.h1=SubHeading.withComponent('h1');SubHeading.h2=SubHeading.withComponent('h2');SubHeading.h3=SubHeading.withComponent('h3');SubHeading.h4=SubHeading.withComponent('h4');SubHeading.h5=SubHeading.withComponent('h5');SubHeading.h6=SubHeading.withComponent('h6');

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(14);
var document = __webpack_require__(11).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(16);


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(97)('keys');
var uid = __webpack_require__(57);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 120 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(11).document;
module.exports = document && document.documentElement;


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(14);
var anObject = __webpack_require__(13);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(40)(Function.call, __webpack_require__(43).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 123 */
/***/ (function(module, exports) {

module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(14);
var setPrototypeOf = __webpack_require__(122).set;
module.exports = function (that, target, C) {
  var S = target.constructor;
  var P;
  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
    setPrototypeOf(that, P);
  } return that;
};


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toInteger = __webpack_require__(42);
var defined = __webpack_require__(47);

module.exports = function repeat(count) {
  var str = String(defined(this));
  var res = '';
  var n = toInteger(count);
  if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) res += str;
  return res;
};


/***/ }),
/* 126 */
/***/ (function(module, exports) {

// 20.2.2.28 Math.sign(x)
module.exports = Math.sign || function sign(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
};


/***/ }),
/* 127 */
/***/ (function(module, exports) {

// 20.2.2.14 Math.expm1(x)
var $expm1 = Math.expm1;
module.exports = (!$expm1
  // Old FF bug
  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
  // Tor Browser bug
  || $expm1(-2e-17) != -2e-17
) ? function expm1(x) {
  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
} : $expm1;


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(42);
var defined = __webpack_require__(47);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(58);
var $export = __webpack_require__(3);
var redefine = __webpack_require__(27);
var hide = __webpack_require__(32);
var Iterators = __webpack_require__(75);
var $iterCreate = __webpack_require__(185);
var setToStringTag = __webpack_require__(73);
var getPrototypeOf = __webpack_require__(63);
var ITERATOR = __webpack_require__(16)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

// helper for String#{startsWith, endsWith, includes}
var isRegExp = __webpack_require__(131);
var defined = __webpack_require__(47);

module.exports = function (that, searchString, NAME) {
  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
  return String(defined(that));
};


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.8 IsRegExp(argument)
var isObject = __webpack_require__(14);
var cof = __webpack_require__(46);
var MATCH = __webpack_require__(16)('match');
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
};


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

var MATCH = __webpack_require__(16)('match');
module.exports = function (KEY) {
  var re = /./;
  try {
    '/./'[KEY](re);
  } catch (e) {
    try {
      re[MATCH] = false;
      return !'/./'[KEY](re);
    } catch (f) { /* empty */ }
  } return true;
};


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(75);
var ITERATOR = __webpack_require__(16)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(22);
var createDesc = __webpack_require__(56);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(90);
var ITERATOR = __webpack_require__(16)('iterator');
var Iterators = __webpack_require__(75);
module.exports = __webpack_require__(20).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)

var toObject = __webpack_require__(24);
var toAbsoluteIndex = __webpack_require__(60);
var toLength = __webpack_require__(17);
module.exports = function fill(value /* , start = 0, end = @length */) {
  var O = toObject(this);
  var length = toLength(O.length);
  var aLen = arguments.length;
  var index = toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
  var end = aLen > 2 ? arguments[2] : undefined;
  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
  while (endPos > index) O[index++] = value;
  return O;
};


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(64);
var step = __webpack_require__(190);
var Iterators = __webpack_require__(75);
var toIObject = __webpack_require__(33);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(129)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var regexpFlags = __webpack_require__(102);

var nativeExec = RegExp.prototype.exec;
// This always refers to the native implementation, because the
// String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
// which loads this file before patching the method.
var nativeReplace = String.prototype.replace;

var patchedExec = nativeExec;

var LAST_INDEX = 'lastIndex';

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/,
      re2 = /b*/g;
  nativeExec.call(re1, 'a');
  nativeExec.call(re2, 'a');
  return re1[LAST_INDEX] !== 0 || re2[LAST_INDEX] !== 0;
})();

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED;

if (PATCH) {
  patchedExec = function exec(str) {
    var re = this;
    var lastIndex, reCopy, match, i;

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + re.source + '$(?!\\s)', regexpFlags.call(re));
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re[LAST_INDEX];

    match = nativeExec.call(re, str);

    if (UPDATES_LAST_INDEX_WRONG && match) {
      re[LAST_INDEX] = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
      // eslint-disable-next-line no-loop-func
      nativeReplace.call(match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    return match;
  };
}

module.exports = patchedExec;


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var at = __webpack_require__(128)(true);

 // `AdvanceStringIndex` abstract operation
// https://tc39.github.io/ecma262/#sec-advancestringindex
module.exports = function (S, index, unicode) {
  return index + (unicode ? at(S, index).length : 1);
};


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(40);
var invoke = __webpack_require__(179);
var html = __webpack_require__(121);
var cel = __webpack_require__(117);
var global = __webpack_require__(11);
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__(46)(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(11);
var DESCRIPTORS = __webpack_require__(21);
var LIBRARY = __webpack_require__(58);
var $typed = __webpack_require__(108);
var hide = __webpack_require__(32);
var redefineAll = __webpack_require__(78);
var fails = __webpack_require__(12);
var anInstance = __webpack_require__(77);
var toInteger = __webpack_require__(42);
var toLength = __webpack_require__(17);
var toIndex = __webpack_require__(198);
var gOPN = __webpack_require__(62).f;
var dP = __webpack_require__(22).f;
var arrayFill = __webpack_require__(136);
var setToStringTag = __webpack_require__(73);
var ARRAY_BUFFER = 'ArrayBuffer';
var DATA_VIEW = 'DataView';
var PROTOTYPE = 'prototype';
var WRONG_LENGTH = 'Wrong length!';
var WRONG_INDEX = 'Wrong index!';
var $ArrayBuffer = global[ARRAY_BUFFER];
var $DataView = global[DATA_VIEW];
var Math = global.Math;
var RangeError = global.RangeError;
// eslint-disable-next-line no-shadow-restricted-names
var Infinity = global.Infinity;
var BaseBuffer = $ArrayBuffer;
var abs = Math.abs;
var pow = Math.pow;
var floor = Math.floor;
var log = Math.log;
var LN2 = Math.LN2;
var BUFFER = 'buffer';
var BYTE_LENGTH = 'byteLength';
var BYTE_OFFSET = 'byteOffset';
var $BUFFER = DESCRIPTORS ? '_b' : BUFFER;
var $LENGTH = DESCRIPTORS ? '_l' : BYTE_LENGTH;
var $OFFSET = DESCRIPTORS ? '_o' : BYTE_OFFSET;

// IEEE754 conversions based on https://github.com/feross/ieee754
function packIEEE754(value, mLen, nBytes) {
  var buffer = new Array(nBytes);
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var rt = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0;
  var i = 0;
  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
  var e, m, c;
  value = abs(value);
  // eslint-disable-next-line no-self-compare
  if (value != value || value === Infinity) {
    // eslint-disable-next-line no-self-compare
    m = value != value ? 1 : 0;
    e = eMax;
  } else {
    e = floor(log(value) / LN2);
    if (value * (c = pow(2, -e)) < 1) {
      e--;
      c *= 2;
    }
    if (e + eBias >= 1) {
      value += rt / c;
    } else {
      value += rt * pow(2, 1 - eBias);
    }
    if (value * c >= 2) {
      e++;
      c /= 2;
    }
    if (e + eBias >= eMax) {
      m = 0;
      e = eMax;
    } else if (e + eBias >= 1) {
      m = (value * c - 1) * pow(2, mLen);
      e = e + eBias;
    } else {
      m = value * pow(2, eBias - 1) * pow(2, mLen);
      e = 0;
    }
  }
  for (; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
  e = e << mLen | m;
  eLen += mLen;
  for (; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
  buffer[--i] |= s * 128;
  return buffer;
}
function unpackIEEE754(buffer, mLen, nBytes) {
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var nBits = eLen - 7;
  var i = nBytes - 1;
  var s = buffer[i--];
  var e = s & 127;
  var m;
  s >>= 7;
  for (; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
  m = e & (1 << -nBits) - 1;
  e >>= -nBits;
  nBits += mLen;
  for (; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
  if (e === 0) {
    e = 1 - eBias;
  } else if (e === eMax) {
    return m ? NaN : s ? -Infinity : Infinity;
  } else {
    m = m + pow(2, mLen);
    e = e - eBias;
  } return (s ? -1 : 1) * m * pow(2, e - mLen);
}

function unpackI32(bytes) {
  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
}
function packI8(it) {
  return [it & 0xff];
}
function packI16(it) {
  return [it & 0xff, it >> 8 & 0xff];
}
function packI32(it) {
  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
}
function packF64(it) {
  return packIEEE754(it, 52, 8);
}
function packF32(it) {
  return packIEEE754(it, 23, 4);
}

function addGetter(C, key, internal) {
  dP(C[PROTOTYPE], key, { get: function () { return this[internal]; } });
}

function get(view, bytes, index, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = store.slice(start, start + bytes);
  return isLittleEndian ? pack : pack.reverse();
}
function set(view, bytes, index, conversion, value, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = conversion(+value);
  for (var i = 0; i < bytes; i++) store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
}

if (!$typed.ABV) {
  $ArrayBuffer = function ArrayBuffer(length) {
    anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
    var byteLength = toIndex(length);
    this._b = arrayFill.call(new Array(byteLength), 0);
    this[$LENGTH] = byteLength;
  };

  $DataView = function DataView(buffer, byteOffset, byteLength) {
    anInstance(this, $DataView, DATA_VIEW);
    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
    var bufferLength = buffer[$LENGTH];
    var offset = toInteger(byteOffset);
    if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset!');
    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
    if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
    this[$BUFFER] = buffer;
    this[$OFFSET] = offset;
    this[$LENGTH] = byteLength;
  };

  if (DESCRIPTORS) {
    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
    addGetter($DataView, BUFFER, '_b');
    addGetter($DataView, BYTE_LENGTH, '_l');
    addGetter($DataView, BYTE_OFFSET, '_o');
  }

  redefineAll($DataView[PROTOTYPE], {
    getInt8: function getInt8(byteOffset) {
      return get(this, 1, byteOffset)[0] << 24 >> 24;
    },
    getUint8: function getUint8(byteOffset) {
      return get(this, 1, byteOffset)[0];
    },
    getInt16: function getInt16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
    },
    getUint16: function getUint16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return bytes[1] << 8 | bytes[0];
    },
    getInt32: function getInt32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1]));
    },
    getUint32: function getUint32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
    },
    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
    },
    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
    },
    setInt8: function setInt8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setUint8: function setUint8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packF32, value, arguments[2]);
    },
    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
      set(this, 8, byteOffset, packF64, value, arguments[2]);
    }
  });
} else {
  if (!fails(function () {
    $ArrayBuffer(1);
  }) || !fails(function () {
    new $ArrayBuffer(-1); // eslint-disable-line no-new
  }) || fails(function () {
    new $ArrayBuffer(); // eslint-disable-line no-new
    new $ArrayBuffer(1.5); // eslint-disable-line no-new
    new $ArrayBuffer(NaN); // eslint-disable-line no-new
    return $ArrayBuffer.name != ARRAY_BUFFER;
  })) {
    $ArrayBuffer = function ArrayBuffer(length) {
      anInstance(this, $ArrayBuffer);
      return new BaseBuffer(toIndex(length));
    };
    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
    for (var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j;) {
      if (!((key = keys[j++]) in $ArrayBuffer)) hide($ArrayBuffer, key, BaseBuffer[key]);
    }
    if (!LIBRARY) ArrayBufferProto.constructor = $ArrayBuffer;
  }
  // iOS Safari 7.x bug
  var view = new $DataView(new $ArrayBuffer(2));
  var $setInt8 = $DataView[PROTOTYPE].setInt8;
  view.setInt8(0, 2147483648);
  view.setInt8(1, 2147483649);
  if (view.getInt8(0) || !view.getInt8(1)) redefineAll($DataView[PROTOTYPE], {
    setInt8: function setInt8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    },
    setUint8: function setUint8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    }
  }, true);
}
setToStringTag($ArrayBuffer, ARRAY_BUFFER);
setToStringTag($DataView, DATA_VIEW);
hide($DataView[PROTOTYPE], $typed.VIEW, true);
exports[ARRAY_BUFFER] = $ArrayBuffer;
exports[DATA_VIEW] = $DataView;


/***/ }),
/* 142 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 143 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(203)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
  ) {
    return;
  }
  if (false) {
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (true) {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = __webpack_require__(464);
} else {
  module.exports = require('./cjs/react-dom.development.js');
}


/***/ }),
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = warning;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */


  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */

}

/***/ }),
/* 147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _objectWithoutPropertiesLoose; });
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(472);
} else {
  module.exports = require('./cjs/react-is.development.js');
}


/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__ = __webpack_require__(150);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__["a" /* default */]);

/***/ }),
/* 150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/**
 * The public API for putting history on context.
 */

var Router = function (_React$Component) {
  _inherits(Router, _React$Component);

  function Router() {
    var _temp, _this, _ret;

    _classCallCheck(this, Router);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props.history.location.pathname)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Router.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        history: this.props.history,
        route: {
          location: this.props.history.location,
          match: this.state.match
        }
      })
    };
  };

  Router.prototype.computeMatch = function computeMatch(pathname) {
    return {
      path: "/",
      url: "/",
      params: {},
      isExact: pathname === "/"
    };
  };

  Router.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    var _props = this.props,
        children = _props.children,
        history = _props.history;


    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(children == null || __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 1, "A <Router> may have only one child element");

    // Do this here so we can setState when a <Redirect> changes the
    // location in componentWillMount. This happens e.g. when doing
    // server rendering using a <StaticRouter>.
    this.unlisten = history.listen(function () {
      _this2.setState({
        match: _this2.computeMatch(history.location.pathname)
      });
    });
  };

  Router.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(this.props.history === nextProps.history, "You cannot change <Router history>");
  };

  Router.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unlisten();
  };

  Router.prototype.render = function render() {
    var children = this.props.children;

    return children ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children) : null;
  };

  return Router;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Router.propTypes = {
  history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node
};
Router.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Router.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Router);

/***/ }),
/* 151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path_to_regexp__);


var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compilePath = function compilePath(pattern, options) {
  var cacheKey = "" + options.end + options.strict + options.sensitive;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var keys = [];
  var re = __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default()(pattern, keys, options);
  var compiledPattern = { re: re, keys: keys };

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledPattern;
    cacheCount++;
  }

  return compiledPattern;
};

/**
 * Public API for matching a URL pathname to a path pattern.
 */
var matchPath = function matchPath(pathname) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var parent = arguments[2];

  if (typeof options === "string") options = { path: options };

  var _options = options,
      path = _options.path,
      _options$exact = _options.exact,
      exact = _options$exact === undefined ? false : _options$exact,
      _options$strict = _options.strict,
      strict = _options$strict === undefined ? false : _options$strict,
      _options$sensitive = _options.sensitive,
      sensitive = _options$sensitive === undefined ? false : _options$sensitive;


  if (path == null) return parent;

  var _compilePath = compilePath(path, { end: exact, strict: strict, sensitive: sensitive }),
      re = _compilePath.re,
      keys = _compilePath.keys;

  var match = re.exec(pathname);

  if (!match) return null;

  var url = match[0],
      values = match.slice(1);

  var isExact = pathname === url;

  if (exact && !isExact) return null;

  return {
    path: path, // the path pattern used to match
    url: path === "/" && url === "" ? "/" : url, // the matched portion of the URL
    isExact: isExact, // whether or not we matched exactly
    params: keys.reduce(function (memo, key, index) {
      memo[key.name] = values[index];
      return memo;
    }, {})
  };
};

/* harmony default export */ __webpack_exports__["a"] = (matchPath);

/***/ }),
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return qEnd; });
/* harmony export (immutable) */ __webpack_exports__["c"] = safeName;
/* harmony export (immutable) */ __webpack_exports__["a"] = fsmIterator;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(34);


var done = { done: true, value: undefined };
var qEnd = {};

function safeName(patternOrChannel) {
  if (__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].channel(patternOrChannel)) {
    return 'channel';
  } else if (Array.isArray(patternOrChannel)) {
    return String(patternOrChannel.map(function (entry) {
      return String(entry);
    }));
  } else {
    return String(patternOrChannel);
  }
}

function fsmIterator(fsm, q0) {
  var name = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'iterator';

  var updateState = void 0,
      qNext = q0;

  function next(arg, error) {
    if (qNext === qEnd) {
      return done;
    }

    if (error) {
      qNext = qEnd;
      throw error;
    } else {
      updateState && updateState(arg);

      var _fsm$qNext = fsm[qNext](),
          q = _fsm$qNext[0],
          output = _fsm$qNext[1],
          _updateState = _fsm$qNext[2];

      qNext = q;
      updateState = _updateState;
      return qNext === qEnd ? done : output;
    }
  }

  return Object(__WEBPACK_IMPORTED_MODULE_0__utils__["q" /* makeIterator */])(next, function (error) {
    return next(null, error);
  }, name, true);
}

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _CSSTransition = _interopRequireDefault(__webpack_require__(232));

var _ReplaceTransition = _interopRequireDefault(__webpack_require__(549));

var _TransitionGroup = _interopRequireDefault(__webpack_require__(236));

var _Transition = _interopRequireDefault(__webpack_require__(233));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = {
  Transition: _Transition.default,
  TransitionGroup: _TransitionGroup.default,
  ReplaceTransition: _ReplaceTransition.default,
  CSSTransition: _CSSTransition.default
};

/***/ }),
/* 154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_transition_group__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_transition_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_transition_group__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_immutable__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_dom__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_connect__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_Heading__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__CartItem__ = __webpack_require__(566);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_helpers_variables__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_toCurrency__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__styles_Button__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__actions_actionCreators__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__styles_helpers_animations__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__constants_endpoints__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__util_analyticEvents__ = __webpack_require__(68);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  background-color: ',';\n  height: 100%;\n  padding: 20px 15px 26px 22px;\n  display: flex;\n  flex-direction: column;\n\n  @media screen and (min-width: ','px) {\n    padding: 42px 37px 26px 45px;\n  }\n'],['\n  background-color: ',';\n  height: 100%;\n  padding: 20px 15px 26px 22px;\n  display: flex;\n  flex-direction: column;\n\n  @media screen and (min-width: ','px) {\n    padding: 42px 37px 26px 45px;\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  display: flex;\n  justify-content: space-between;\n\n  span {\n    display: inline-block;\n    margin-right: 24px;\n    margin-bottom: 7px;\n    font-size: 12px;\n    text-transform: uppercase;\n    font-weight: 600;\n    font-style: normal;\n    font-stretch: normal;\n    line-height: normal;\n    letter-spacing: 1.5px;\n    text-align: left;\n    color: #a7a7a7;\n  }\n'],['\n  display: flex;\n  justify-content: space-between;\n\n  span {\n    display: inline-block;\n    margin-right: 24px;\n    margin-bottom: 7px;\n    font-size: 12px;\n    text-transform: uppercase;\n    font-weight: 600;\n    font-style: normal;\n    font-stretch: normal;\n    line-height: normal;\n    letter-spacing: 1.5px;\n    text-align: left;\n    color: #a7a7a7;\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  background-color: ',';\n  border-color: ',';\n  width: auto;\n  text-decoration: none;\n  display: block;\n  margin: 0;\n  padding: 10px 20px;\n\n  @media screen and (min-width: ','px) {\n    padding: 16px 20px;\n    margin-top: 20px;\n    width: 100%;\n  }\n'],['\n  background-color: ',';\n  border-color: ',';\n  width: auto;\n  text-decoration: none;\n  display: block;\n  margin: 0;\n  padding: 10px 20px;\n\n  @media screen and (min-width: ','px) {\n    padding: 16px 20px;\n    margin-top: 20px;\n    width: 100%;\n  }\n']),_templateObject4=_taggedTemplateLiteral(['\n  margin: 0;\n\n  @media screen and (min-width: ','px) {\n    margin: 20px 0 60px;\n    min-height: 116px;\n  }\n'],['\n  margin: 0;\n\n  @media screen and (min-width: ','px) {\n    margin: 20px 0 60px;\n    min-height: 116px;\n  }\n']),_templateObject5=_taggedTemplateLiteral(['\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n\n  @media screen and (min-width: ','px) {\n    justify-content: space-between;\n    display: block;\n    flex: 0;\n  }\n'],['\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n\n  @media screen and (min-width: ','px) {\n    justify-content: space-between;\n    display: block;\n    flex: 0;\n  }\n']),_templateObject6=_taggedTemplateLiteral(['\n  margin: 20px 0 0;\n  min-height: 280px;\n\n  @media screen and (min-width: ','px) {\n    margin: 20px 0;\n  }\n\n  ',';\n'],['\n  margin: 20px 0 0;\n  min-height: 280px;\n\n  @media screen and (min-width: ','px) {\n    margin: 20px 0;\n  }\n\n  ',';\n']),_templateObject7=_taggedTemplateLiteral(['\n      min-height: unset;\n    '],['\n      min-height: unset;\n    ']),_templateObject8=_taggedTemplateLiteral(['\n  margin: 0;\n  display: block;\n  text-align: right;\n  color: ',';\n  font-size: 12px;\n  font-weight: normal;\n  font-style: italic;\n  font-stretch: normal;\n  line-height: 1.8;\n  letter-spacing: normal;\n'],['\n  margin: 0;\n  display: block;\n  text-align: right;\n  color: ',';\n  font-size: 12px;\n  font-weight: normal;\n  font-style: italic;\n  font-stretch: normal;\n  line-height: 1.8;\n  letter-spacing: normal;\n']),_templateObject9=_taggedTemplateLiteral(['\n  display: inline-block;\n  width: 50%;\n  font-size: 10px;\n  font-weight: 600;\n  font-style: normal;\n  font-stretch: normal;\n  line-height: normal;\n  letter-spacing: 0.9px;\n  text-transform: uppercase;\n  text-align: left;\n  color: #000000;\n\n  @media screen and (min-width: ','px) {\n    font-size: 12px;\n  }\n'],['\n  display: inline-block;\n  width: 50%;\n  font-size: 10px;\n  font-weight: 600;\n  font-style: normal;\n  font-stretch: normal;\n  line-height: normal;\n  letter-spacing: 0.9px;\n  text-transform: uppercase;\n  text-align: left;\n  color: #000000;\n\n  @media screen and (min-width: ','px) {\n    font-size: 12px;\n  }\n']),_templateObject10=_taggedTemplateLiteral(['\n  display: inline-block;\n  width: 50%;\n  font-size: 16px;\n  font-weight: bold;\n  font-style: normal;\n  font-stretch: normal;\n  line-height: normal;\n  letter-spacing: normal;\n  text-align: right;\n  color: #779182;\n\n  @media screen and (min-width: ','px) {\n    font-size: 18px;\n  }\n'],['\n  display: inline-block;\n  width: 50%;\n  font-size: 16px;\n  font-weight: bold;\n  font-style: normal;\n  font-stretch: normal;\n  line-height: normal;\n  letter-spacing: normal;\n  text-align: right;\n  color: #779182;\n\n  @media screen and (min-width: ','px) {\n    font-size: 18px;\n  }\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Cart=function(_Component){_inherits(Cart,_Component);function Cart(props){_classCallCheck(this,Cart);var _this=_possibleConstructorReturn(this,(Cart.__proto__||Object.getPrototypeOf(Cart)).call(this,props));_this.addCartItem=_this.addCartItem.bind(_this);_this.removeCartItem=_this.removeCartItem.bind(_this);_this.deleteCartRow=_this.deleteCartRow.bind(_this);return _this;}_createClass(Cart,[{key:'componentDidMount',value:function componentDidMount(){if(this.props.location.pathname!=='/kassa'){Object(__WEBPACK_IMPORTED_MODULE_15__util_analyticEvents__["a" /* analyticsCheckoutEvent */])('checkoutStep1',1,this.props.cart.get('cart',Object(__WEBPACK_IMPORTED_MODULE_4_immutable__["List"])()));}}},{key:'addCartItem',value:function addCartItem(productId,productOptions){var quantity=arguments.length>2&&arguments[2]!==undefined?arguments[2]:1;var productOptionsArray=productOptions.reduce(function(memory,option){return[].concat(_toConsumableArray(memory),[option.get('id')]);},[]);this.props.addCartItem({endpointUrl:__WEBPACK_IMPORTED_MODULE_14__constants_endpoints__["c" /* CART_ADD_URL */],body:{id:productId,Quantity:quantity,Options:productOptionsArray}});}},{key:'removeCartItem',value:function removeCartItem(cartRow){var quantity=arguments.length>1&&arguments[1]!==undefined?arguments[1]:1;var rowId=cartRow.get('orderRowId');this.props.removeCartItem({endpointUrl:__WEBPACK_IMPORTED_MODULE_14__constants_endpoints__["f" /* CART_REMOVE_URL */],body:{RowSystemId:rowId,Quantity:quantity}},cartRow);}},{key:'deleteCartRow',value:function deleteCartRow(cartRow){var rowId=cartRow.get('orderRowId');this.props.deleteCartRow({endpointUrl:__WEBPACK_IMPORTED_MODULE_14__constants_endpoints__["e" /* CART_DELETE_URL */],body:{RowSystemId:rowId}},cartRow);}},{key:'render',value:function render(){var _this2=this;var _props=this.props,cart=_props.cart,onCheckoutPage=_props.onCheckoutPage;// map through cart items
var cartItems=cart.get('cart',Object(__WEBPACK_IMPORTED_MODULE_4_immutable__["Map"])()).sortBy(function(item){return item.getIn(['product','id']);}).map(function(item,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__styles_helpers_animations__["f" /* MagicGetaway */],{numberOfOptions:item.get('options').size,key:item.get('orderRowId')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__CartItem__["a" /* default */],{index:index,cartRow:item,modifyDisabled:_this2.props.onCheckoutPage,addCartItem:_this2.addCartItem,removeCartItem:_this2.removeCartItem,deleteCartRow:_this2.deleteCartRow}));}).toArray();return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CartWrapper,{onCheckoutPage:this.props.onCheckoutPage,onMobile:this.props.onMobile},!this.props.onCheckoutPage&&!this.props.onMobile?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__styles_Heading__["a" /* Heading */].p,null,'Varukorg'):false,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CartContainer,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CartItemsContainer,null,this.props.viewstate.get('pageWidth')<__WEBPACK_IMPORTED_MODULE_9__styles_helpers_variables__["f" /* size */].xLarge?false:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CartItemsHead,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Produkt'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Summa')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_transition_group__["TransitionGroup"],null,cartItems)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CartMetaData,{onCheckoutPage:onCheckoutPage},cart.get('totalCampaignPrice')?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CartItemBigText,{color:__WEBPACK_IMPORTED_MODULE_9__styles_helpers_variables__["c" /* color */].sale},'Rabatt - ',Object(__WEBPACK_IMPORTED_MODULE_10__util_toCurrency__["a" /* toCurrency */])(cart.get('totalCampaignPrice'))):false,!Number.isNaN(parseInt(cart.get('deliveryCost'),10))?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CartItemBigText,null,'Frakt ',Object(__WEBPACK_IMPORTED_MODULE_10__util_toCurrency__["a" /* toCurrency */])(parseInt(cart.get('deliveryCost'),10))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CartItemBigText,null,cart.get('deliveryCost')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CartItemBigText,null,'Moms ',Object(__WEBPACK_IMPORTED_MODULE_10__util_toCurrency__["a" /* toCurrency */])(cart.get('vat'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CartItemTotalKey,null,'Total summa'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CartItemTotalValue,null,Object(__WEBPACK_IMPORTED_MODULE_10__util_toCurrency__["a" /* toCurrency */])(cart.get('grandTotalPrice'))),this.props.onCheckoutPage?false:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CartButton,{to:'/kassa'},'G\xE5 till kassa'))));}}]);return Cart;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var CartWrapper=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject,__WEBPACK_IMPORTED_MODULE_9__styles_helpers_variables__["c" /* color */].lightGrey,__WEBPACK_IMPORTED_MODULE_9__styles_helpers_variables__["f" /* size */].xLarge);var CartItemsHead=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject2);var CartButton=__WEBPACK_IMPORTED_MODULE_11__styles_Button__["a" /* Button */].withComponent(__WEBPACK_IMPORTED_MODULE_5_react_router_dom__["a" /* Link */]).extend(_templateObject3,__WEBPACK_IMPORTED_MODULE_9__styles_helpers_variables__["c" /* color */].success,__WEBPACK_IMPORTED_MODULE_9__styles_helpers_variables__["c" /* color */].success,__WEBPACK_IMPORTED_MODULE_9__styles_helpers_variables__["f" /* size */].xLarge);var CartItemsContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject4,__WEBPACK_IMPORTED_MODULE_9__styles_helpers_variables__["f" /* size */].xLarge);var CartContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject5,__WEBPACK_IMPORTED_MODULE_9__styles_helpers_variables__["f" /* size */].xLarge);var CartMetaData=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject6,__WEBPACK_IMPORTED_MODULE_9__styles_helpers_variables__["f" /* size */].xLarge,function(props){return props.onCheckoutPage&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject7);});var CartItemBigText=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].p(_templateObject8,function(props){return props.color?props.color:__WEBPACK_IMPORTED_MODULE_9__styles_helpers_variables__["c" /* color */].black;});var CartItemTotalKey=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].p(_templateObject9,__WEBPACK_IMPORTED_MODULE_9__styles_helpers_variables__["f" /* size */].xLarge);var CartItemTotalValue=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].p(_templateObject10,__WEBPACK_IMPORTED_MODULE_9__styles_helpers_variables__["f" /* size */].xLarge);Cart.defaultProps={cart:Object(__WEBPACK_IMPORTED_MODULE_4_immutable__["Map"])(),viewstate:Object(__WEBPACK_IMPORTED_MODULE_4_immutable__["Map"])(),onCheckoutPage:false,onMobile:false,location:{}};Cart.propTypes={addCartItem:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,removeCartItem:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,deleteCartRow:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,location:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,cart:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_4_immutable__["Map"]),viewstate:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_4_immutable__["Map"]),onMobile:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,onCheckoutPage:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6__store_connect__["a" /* default */])(Cart,{addCartItem:__WEBPACK_IMPORTED_MODULE_12__actions_actionCreators__["a" /* addCartItem */],removeCartItem:__WEBPACK_IMPORTED_MODULE_12__actions_actionCreators__["Q" /* removeCartItem */],deleteCartRow:__WEBPACK_IMPORTED_MODULE_12__actions_actionCreators__["d" /* deleteCartRow */]},function(store){return{cart:store.cart,viewstate:store.viewstate};}));

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__(577);

module.exports = Function.prototype.bind || implementation;


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(84);

/** @type {import('.')} */
var $defineProperty = GetIntrinsic('%Object.defineProperty%', true) || false;
if ($defineProperty) {
	try {
		$defineProperty({}, 'a', { value: 1 });
	} catch (e) {
		// IE 8 has a broken defineProperty
		$defineProperty = false;
	}
}

module.exports = $defineProperty;


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var replace = String.prototype.replace;
var percentTwenties = /%20/g;

var Format = {
    RFC1738: 'RFC1738',
    RFC3986: 'RFC3986'
};

module.exports = {
    'default': Format.RFC3986,
    formatters: {
        RFC1738: function (value) {
            return replace.call(value, percentTwenties, '+');
        },
        RFC3986: function (value) {
            return String(value);
        }
    },
    RFC1738: Format.RFC1738,
    RFC3986: Format.RFC3986
};


/***/ }),
/* 158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Provider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Consumer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Cookies__ = __webpack_require__(245);


var CookiesContext = __WEBPACK_IMPORTED_MODULE_0_react__["createContext"](new __WEBPACK_IMPORTED_MODULE_1__Cookies__["a" /* default */]());
var Provider = CookiesContext.Provider, Consumer = CookiesContext.Consumer;
/* harmony default export */ __webpack_exports__["c"] = (CookiesContext);


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(35);
var normalizeHeaderName = __webpack_require__(606);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(250);
  } else if (typeof process !== 'undefined') {
    // For node use HTTP adapter
    adapter = __webpack_require__(250);
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(230)))

/***/ }),
/* 160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Paragraph; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_variables__ = __webpack_require__(4);
var _templateObject=_taggedTemplateLiteral(['\n  font-size: 14px;\n  font-weight: normal;\n\tline-height: 1.57;\n  text-align: left;\n  margin: ',';\n  color: ',';\n  \n  ','\n  \n  ','\n'],['\n  font-size: 14px;\n  font-weight: normal;\n\tline-height: 1.57;\n  text-align: left;\n  margin: ',';\n  color: ',';\n  \n  ','\n  \n  ','\n']),_templateObject2=_taggedTemplateLiteral(['\n    text-transform: uppercase;\n  '],['\n    text-transform: uppercase;\n  ']),_templateObject3=_taggedTemplateLiteral(['\n    margin: 0;\n  '],['\n    margin: 0;\n  ']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Paragraph=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].p(_templateObject,function(props){return props.mobileMargin?'.5em 0 2em':'1.5em 0';},__WEBPACK_IMPORTED_MODULE_2__helpers_variables__["c" /* color */].black,function(props){return props.uppercase&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(_templateObject2);},function(props){return props.noMargin&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(_templateObject3);});Paragraph.propTypes={uppercase:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};

/***/ }),
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_grid_styled__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_grid_styled___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_grid_styled__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_connect__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ProductCard__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ProductSplashCard__ = __webpack_require__(638);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_analyticEvents__ = __webpack_require__(68);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProductList=function(_Component){_inherits(ProductList,_Component);function ProductList(props){_classCallCheck(this,ProductList);var _this=_possibleConstructorReturn(this,(ProductList.__proto__||Object.getPrototypeOf(ProductList)).call(this,props));_this.renderProductCards=_this.renderProductCards.bind(_this);return _this;}_createClass(ProductList,[{key:'componentDidMount',value:function componentDidMount(){Object(__WEBPACK_IMPORTED_MODULE_8__util_analyticEvents__["c" /* analyticsImpressionEvent */])('productList',false,this.props.data);}},{key:'renderProductCards',value:function renderProductCards(){var _this2=this;var _props=this.props,informationCard=_props.informationCard,modified=_props.modified,viewstate=_props.viewstate;var responsiveGridArrayFour=[1/2,1/2,1/3,1/4];var responsiveGridArraySix=[1/3,1/4,1/5,1/6];var hasFourInGrid=this.props.columns===4;var hasSixInGrid=this.props.columns===6;var gridPadding=['5px','7px','10px'];var currentPosition=0;return this.props.data.map(function(item,index){currentPosition+=1;if(currentPosition===7&&!informationCard.isEmpty()&&!modified&&!viewstate.get('pagination')){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],{key:'productCard-'+item.get('id')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grid_styled__["Box"],{key:index,width:[1,1,2/3,2/4],px:gridPadding,my:gridPadding},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__ProductSplashCard__["a" /* default */],{title:informationCard.get('title'),body:informationCard.get('introduction'),link:informationCard.get('readMoreLink'),images:informationCard.get('image')})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grid_styled__["Box"],{key:'productCard-'+item.get('id'),width:hasFourInGrid?responsiveGridArrayFour:1/2,px:gridPadding,my:gridPadding},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__ProductCard__["e" /* default */],{item:item,showVariantImage:_this2.props.includeRelevance,onProductCardHover:_this2.props.onProductCardHover})));}var width=void 0;if(hasFourInGrid){width=responsiveGridArrayFour;}else if(hasSixInGrid){width=responsiveGridArraySix;}else{width=1/2;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grid_styled__["Box"],{key:'productCard-'+item.get('id'),width:width,px:gridPadding,my:gridPadding},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__ProductCard__["e" /* default */],{item:item,showVariantImage:_this2.props.includeRelevance,activeFilterColor:_this2.props.activeFilterColor,onProductCardHover:_this2.props.onProductCardHover,simpleProductCard:hasSixInGrid}));}).toArray();}},{key:'render',value:function render(){var negativeGridPadding=['-5px','-7px','-10px'];var productData=this.renderProductCards();return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_styled_components__["ThemeProvider"],{theme:{breakpoints:['40em','53.125em','68.75em']}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grid_styled__["Flex"],{flexWrap:'wrap',mx:negativeGridPadding,justifyContent:this.props.center&&'center'},productData));}}]);return ProductList;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ProductList.defaultProps={columns:4,center:false,modified:false,onProductCardHover:null,includeRelevance:false,informationCard:Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])(),activeFilterColor:null};ProductList.propTypes={columns:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,center:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,viewstate:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"]).isRequired,modified:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,onProductCardHover:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,data:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"]),__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_2_immutable__["List"])]).isRequired,includeRelevance:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,informationCard:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"]),activeFilterColor:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5__store_connect__["a" /* default */])(ProductList,{},function(store){return{viewstate:store.viewstate};}));

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(644);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ANIMATION_STATE_CLASSES = {
  animating: 'rah-animating',
  animatingUp: 'rah-animating--up',
  animatingDown: 'rah-animating--down',
  animatingToHeightZero: 'rah-animating--to-height-zero',
  animatingToHeightAuto: 'rah-animating--to-height-auto',
  animatingToHeightSpecific: 'rah-animating--to-height-specific',
  static: 'rah-static',
  staticHeightZero: 'rah-static--height-zero',
  staticHeightAuto: 'rah-static--height-auto',
  staticHeightSpecific: 'rah-static--height-specific'
};

function omit(obj) {
  for (var _len = arguments.length, keys = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    keys[_key - 1] = arguments[_key];
  }

  if (!keys.length) {
    return obj;
  }

  var res = {};
  var objectKeys = Object.keys(obj);

  for (var i = 0; i < objectKeys.length; i++) {
    var key = objectKeys[i];

    if (keys.indexOf(key) === -1) {
      res[key] = obj[key];
    }
  }

  return res;
}

// Start animation helper using nested requestAnimationFrames
function startAnimationHelper(callback) {
  requestAnimationFrame(function () {
    requestAnimationFrame(function () {
      callback();
    });
  });
}

function isNumber(n) {
  return !isNaN(parseFloat(n)) && isFinite(n);
}

function runCallback(callback) {
  if (callback && typeof callback === 'function') {
    callback();
  }
}

var AnimateHeight = function (_React$Component) {
  _inherits(AnimateHeight, _React$Component);

  function AnimateHeight(props) {
    _classCallCheck(this, AnimateHeight);

    var _this = _possibleConstructorReturn(this, (AnimateHeight.__proto__ || Object.getPrototypeOf(AnimateHeight)).call(this, props));

    var height = 'auto';
    var overflow = 'visible';

    if (isNumber(props.height)) {
      height = props.height < 0 ? 0 : props.height;
      overflow = 'hidden';
    } else if (
    // Percentage height
    typeof props.height === 'string' && props.height.search('%') === props.height.length - 1 && isNumber(props.height.substr(0, props.height.length - 1))) {
      height = props.height;
      overflow = 'hidden';
    }

    _this.animationStateClasses = _extends({}, ANIMATION_STATE_CLASSES, props.animationStateClasses);

    var animationStateClasses = _this.getStaticStateClasses(height);

    _this.state = {
      animationStateClasses: animationStateClasses,
      height: height,
      overflow: overflow,
      shouldUseTransitions: false
    };
    return _this;
  }

  _createClass(AnimateHeight, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var height = this.state.height;

      // Hide content if height is 0 (to prevent tabbing into it)
      // Check for contentElement is added cause this would fail in tests (react-test-renderer)
      // Read more here: https://github.com/Stanko/react-animate-height/issues/17

      if (this.contentElement && this.contentElement.style) {
        this.hideContent(height);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      var height = this.props.height;

      // Check if 'height' prop has changed

      if (this.contentElement && nextProps.height !== height) {
        var _cx;

        // Remove display: none from the content div
        // if it was hidden to prevent tabbing into it
        this.showContent();

        // Cache content height
        this.contentElement.style.overflow = 'hidden';
        var contentHeight = this.contentElement.offsetHeight;
        this.contentElement.style.overflow = '';

        // set total animation time
        var totalDuration = nextProps.duration + nextProps.delay;

        var newHeight = null;
        var timeoutState = {
          height: null, // it will be always set to either 'auto' or specific number
          overflow: 'hidden'
        };
        var isCurrentHeightAuto = this.state.height === 'auto';

        if (isNumber(nextProps.height)) {
          // If new height is a number
          newHeight = nextProps.height < 0 ? 0 : nextProps.height;
          timeoutState.height = newHeight;
        } else if (
        // Percentage height
        typeof nextProps.height === 'string' && nextProps.height.search('%') === nextProps.height.length - 1 && isNumber(nextProps.height.substr(0, nextProps.height.length - 1))) {
          newHeight = nextProps.height;
          timeoutState.height = newHeight;
        } else {
          // If not, animate to content height
          // and then reset to auto
          newHeight = contentHeight;
          timeoutState.height = 'auto';
          timeoutState.overflow = null;
        }

        if (isCurrentHeightAuto) {
          // This is the height to be animated to
          timeoutState.height = newHeight;

          // If previous height was 'auto'
          // set starting height explicitly to be able to use transition
          newHeight = contentHeight;
        }

        // Animation classes
        var animationStateClasses = (0, _classnames2.default)((_cx = {}, _defineProperty(_cx, this.animationStateClasses.animating, true), _defineProperty(_cx, this.animationStateClasses.animatingUp, height === 'auto' || nextProps.height < height), _defineProperty(_cx, this.animationStateClasses.animatingDown, nextProps.height === 'auto' || nextProps.height > height), _defineProperty(_cx, this.animationStateClasses.animatingToHeightZero, timeoutState.height === 0), _defineProperty(_cx, this.animationStateClasses.animatingToHeightAuto, timeoutState.height === 'auto'), _defineProperty(_cx, this.animationStateClasses.animatingToHeightSpecific, timeoutState.height > 0), _cx));

        // Animation classes to be put after animation is complete
        var timeoutAnimationStateClasses = this.getStaticStateClasses(timeoutState.height);

        // Set starting height and animating classes
        this.setState({
          animationStateClasses: animationStateClasses,
          height: newHeight,
          overflow: 'hidden',
          // When animating from 'auto' we first need to set fixed height
          // that change should be animated
          shouldUseTransitions: !isCurrentHeightAuto
        });

        // Clear timeouts
        clearTimeout(this.timeoutID);
        clearTimeout(this.animationClassesTimeoutID);

        if (isCurrentHeightAuto) {
          // When animating from 'auto' we use a short timeout to start animation
          // after setting fixed height above
          timeoutState.shouldUseTransitions = true;

          startAnimationHelper(function () {
            _this2.setState(timeoutState);

            // ANIMATION STARTS, run a callback if it exists
            runCallback(nextProps.onAnimationStart);
          });

          // Set static classes and remove transitions when animation ends
          this.animationClassesTimeoutID = setTimeout(function () {
            _this2.setState({
              animationStateClasses: timeoutAnimationStateClasses,
              shouldUseTransitions: false
            });

            // ANIMATION ENDS
            // Hide content if height is 0 (to prevent tabbing into it)
            _this2.hideContent(timeoutState.height);
            // Run a callback if it exists
            runCallback(nextProps.onAnimationEnd);
          }, totalDuration);
        } else {
          // ANIMATION STARTS, run a callback if it exists
          runCallback(nextProps.onAnimationStart);

          // Set end height, classes and remove transitions when animation is complete
          this.timeoutID = setTimeout(function () {
            timeoutState.animationStateClasses = timeoutAnimationStateClasses;
            timeoutState.shouldUseTransitions = false;

            _this2.setState(timeoutState);

            // ANIMATION ENDS
            // Hide content if height is 0 (to prevent tabbing into it)
            _this2.hideContent(newHeight);
            // Run a callback if it exists
            runCallback(nextProps.onAnimationEnd);
          }, totalDuration);
        }
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this.timeoutID);
      clearTimeout(this.animationClassesTimeoutID);
      this.timeoutID = null;
      this.animationClassesTimeoutID = null;
      this.animationStateClasses = null;
    }
  }, {
    key: 'showContent',
    value: function showContent() {
      if (this.state.height === 0) {
        this.contentElement.style.display = '';
      }
    }
  }, {
    key: 'hideContent',
    value: function hideContent(newHeight) {
      if (newHeight === 0) {
        this.contentElement.style.display = 'none';
      }
    }
  }, {
    key: 'getStaticStateClasses',
    value: function getStaticStateClasses(height) {
      var _cx2;

      return (0, _classnames2.default)((_cx2 = {}, _defineProperty(_cx2, this.animationStateClasses.static, true), _defineProperty(_cx2, this.animationStateClasses.staticHeightZero, height === 0), _defineProperty(_cx2, this.animationStateClasses.staticHeightSpecific, height > 0), _defineProperty(_cx2, this.animationStateClasses.staticHeightAuto, height === 'auto'), _cx2));
    }
  }, {
    key: 'render',
    value: function render() {
      var _cx3,
          _this3 = this;

      var _props = this.props,
          animateOpacity = _props.animateOpacity,
          applyInlineTransitions = _props.applyInlineTransitions,
          children = _props.children,
          className = _props.className,
          contentClassName = _props.contentClassName,
          duration = _props.duration,
          easing = _props.easing,
          delay = _props.delay,
          style = _props.style;
      var _state = this.state,
          height = _state.height,
          overflow = _state.overflow,
          animationStateClasses = _state.animationStateClasses,
          shouldUseTransitions = _state.shouldUseTransitions;


      var componentStyle = _extends({}, style, {
        height: height,
        overflow: overflow || style.overflow
      });

      if (shouldUseTransitions && applyInlineTransitions) {
        componentStyle.transition = 'height ' + duration + 'ms ' + easing + ' ' + delay + 'ms';

        // Include transition passed through styles
        if (style.transition) {
          componentStyle.transition = style.transition + ', ' + componentStyle.transition;
        }

        // Add webkit vendor prefix still used by opera, blackberry...
        componentStyle.WebkitTransition = componentStyle.transition;
      }

      var contentStyle = {};

      if (animateOpacity) {
        contentStyle.transition = 'opacity ' + duration + 'ms ' + easing + ' ' + delay + 'ms';
        // Add webkit vendor prefix still used by opera, blackberry...
        contentStyle.WebkitTransition = contentStyle.transition;

        if (height === 0) {
          contentStyle.opacity = 0;
        }
      }

      var componentClasses = (0, _classnames2.default)((_cx3 = {}, _defineProperty(_cx3, animationStateClasses, true), _defineProperty(_cx3, className, className), _cx3));

      var propsToOmit = ['animateOpacity', 'animationStateClasses', 'applyInlineTransitions', 'contentClassName', 'duration', 'easing', 'height', 'delay'];

      return _react2.default.createElement(
        'div',
        _extends({}, omit.apply(undefined, [this.props].concat(propsToOmit)), {
          'aria-hidden': height === 0,
          className: componentClasses,
          style: componentStyle
        }),
        _react2.default.createElement(
          'div',
          {
            className: contentClassName,
            style: contentStyle,
            ref: function ref(el) {
              return _this3.contentElement = el;
            }
          },
          children
        )
      );
    }
  }]);

  return AnimateHeight;
}(_react2.default.Component);

AnimateHeight.propTypes = {
  animateOpacity: _propTypes2.default.bool,
  animationStateClasses: _propTypes2.default.object,
  applyInlineTransitions: _propTypes2.default.bool,
  children: _propTypes2.default.any.isRequired,
  className: _propTypes2.default.string,
  contentClassName: _propTypes2.default.string,
  duration: _propTypes2.default.number.isRequired,
  delay: _propTypes2.default.number.isRequired,
  easing: _propTypes2.default.string.isRequired,
  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  onAnimationEnd: _propTypes2.default.func, // eslint-disable-line react/no-unused-prop-types
  onAnimationStart: _propTypes2.default.func, // eslint-disable-line react/no-unused-prop-types
  style: _propTypes2.default.object
};

AnimateHeight.defaultProps = {
  animateOpacity: false,
  animationStateClasses: ANIMATION_STATE_CLASSES,
  applyInlineTransitions: true,
  duration: 250,
  delay: 0,
  easing: 'ease',
  style: {}
};

exports.default = AnimateHeight;

/***/ }),
/* 163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return LoadingHeading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return LoadingPreamble; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LoadingBody; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
var _templateObject=_taggedTemplateLiteral(['\n  from {\n    opacity: .5;\n  }\n\n  to {\n    opacity: 1;\n  }\n'],['\n  from {\n    opacity: .5;\n  }\n\n  to {\n    opacity: 1;\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  margin-bottom: 60px;\n  height: 70px;\n  width: 400px;\n  max-width: 100%;\n  background-color: rgba(0, 0, 0, 0.03);\n  animation: ',' 1s linear alternate infinite;\n'],['\n  margin-bottom: 60px;\n  height: 70px;\n  width: 400px;\n  max-width: 100%;\n  background-color: rgba(0, 0, 0, 0.03);\n  animation: ',' 1s linear alternate infinite;\n']),_templateObject3=_taggedTemplateLiteral(['\n  margin: 47px 0 30px;\n  height: 31px;\n  width: 95%;\n  background-color: rgba(0, 0, 0, 0.03);\n  animation: ',' 1s linear alternate infinite;\n\n  &:before {\n    content: \'\';\n    height: 31px;\n    width: 98%;\n    background-color: rgba(0, 0, 0, 0.03);\n    display: block;\n    top: -125%;\n    position: relative;\n  }\n\n  &:after {\n    content: \'\';\n    height: 31px;\n    width: 300px;\n    max-width: 100%;\n    background-color: rgba(0, 0, 0, 0.03);\n    display: block;\n    top: 25%;\n    position: relative;\n  }\n'],['\n  margin: 47px 0 30px;\n  height: 31px;\n  width: 95%;\n  background-color: rgba(0, 0, 0, 0.03);\n  animation: ',' 1s linear alternate infinite;\n\n  &:before {\n    content: \'\';\n    height: 31px;\n    width: 98%;\n    background-color: rgba(0, 0, 0, 0.03);\n    display: block;\n    top: -125%;\n    position: relative;\n  }\n\n  &:after {\n    content: \'\';\n    height: 31px;\n    width: 300px;\n    max-width: 100%;\n    background-color: rgba(0, 0, 0, 0.03);\n    display: block;\n    top: 25%;\n    position: relative;\n  }\n']),_templateObject4=_taggedTemplateLiteral(['\n  margin: 80px 0 60px;\n  height: 600px;\n  width: 97%;\n  background-color: rgba(0, 0, 0, 0.03);\n  animation: ',' 1s linear alternate infinite;\n'],['\n  margin: 80px 0 60px;\n  height: 600px;\n  width: 97%;\n  background-color: rgba(0, 0, 0, 0.03);\n  animation: ',' 1s linear alternate infinite;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var fadeIn=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["keyframes"])(_templateObject);var LoadingHeading=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].div(_templateObject2,fadeIn);var LoadingPreamble=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].div(_templateObject3,fadeIn);var LoadingBody=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].div(_templateObject4,fadeIn);

/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FilterOption; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_variables__ = __webpack_require__(4);
var _templateObject=_taggedTemplateLiteral(['\n  cursor: pointer;\n  transition: opacity ',' ',';\n  display: flex;\n  font-weight: normal;\n  align-items: center;\n  position: relative;\n  margin: 2px 0;\n  padding: 10px 0;\n  font-size: 13px;\n\n  &:before {\n    content: \'\';\n    display: inline-block;\n    min-width: 13px;\n    width: 13px;\n    height: 13px;\n    margin-right: 10px;\n    background-color: ',';\n    border: solid 1px ',';\n  }\n\n  &:after {\n    display: none;\n  }\n\n  &:hover {\n    opacity: 0.8;\n  }\n\n  ',';\n\n  ',';\n\n  ',';\n  \n  ','\n  \n  ','\n\n  @media screen and (min-width: ','px) {\n    font-size: 14px;\n\n    &:before {\n      min-width: 18px;\n      width: 18px;\n      height: 18px;\n      margin-right: 17px;\n    }\n\n    &:after {\n      left: 5px;\n      top: calc(50% - 5px);\n      width: 10px;\n      height: 10px;\n    }\n\n    ',';\n  }\n'],['\n  cursor: pointer;\n  transition: opacity ',' ',';\n  display: flex;\n  font-weight: normal;\n  align-items: center;\n  position: relative;\n  margin: 2px 0;\n  padding: 10px 0;\n  font-size: 13px;\n\n  &:before {\n    content: \'\';\n    display: inline-block;\n    min-width: 13px;\n    width: 13px;\n    height: 13px;\n    margin-right: 10px;\n    background-color: ',';\n    border: solid 1px ',';\n  }\n\n  &:after {\n    display: none;\n  }\n\n  &:hover {\n    opacity: 0.8;\n  }\n\n  ',';\n\n  ',';\n\n  ',';\n  \n  ','\n  \n  ','\n\n  @media screen and (min-width: ','px) {\n    font-size: 14px;\n\n    &:before {\n      min-width: 18px;\n      width: 18px;\n      height: 18px;\n      margin-right: 17px;\n    }\n\n    &:after {\n      left: 5px;\n      top: calc(50% - 5px);\n      width: 10px;\n      height: 10px;\n    }\n\n    ',';\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n      font-weight: 600;\n\n      &:after {\n        content: \'\';\n        position: absolute;\n        left: 4px;\n        top: calc(50% - 3.5px);\n        width: 7px;\n        height: 7px;\n        display: inline-block;\n        background-color: ',';\n      }\n    '],['\n      font-weight: 600;\n\n      &:after {\n        content: \'\';\n        position: absolute;\n        left: 4px;\n        top: calc(50% - 3.5px);\n        width: 7px;\n        height: 7px;\n        display: inline-block;\n        background-color: ',';\n      }\n    ']),_templateObject3=_taggedTemplateLiteral(['\n      &:before {\n        border-radius: 100%;\n      }\n\n      &:after {\n        border-radius: 100%;\n      }\n    '],['\n      &:before {\n        border-radius: 100%;\n      }\n\n      &:after {\n        border-radius: 100%;\n      }\n    ']),_templateObject4=_taggedTemplateLiteral(['\n      &:before {\n        background-color: ',';\n      }\n\n      &:after {\n        background-color: ',';\n        width: 5px;\n        height: 5px;\n        border: solid 1px ',';\n      }\n    '],['\n      &:before {\n        background-color: ',';\n      }\n\n      &:after {\n        background-color: ',';\n        width: 5px;\n        height: 5px;\n        border: solid 1px ',';\n      }\n    ']),_templateObject5=_taggedTemplateLiteral(['\n      &:before {\n        background: linear-gradient(\n          135deg,\n          ',' 0%,\n          ',' 100%\n        );\n      }\n    '],['\n      &:before {\n        background: linear-gradient(\n          135deg,\n          ',' 0%,\n          ',' 100%\n        );\n      }\n    ']),_templateObject6=_taggedTemplateLiteral(['\n      &:before {\n        background: linear-gradient(\n          135deg,\n          ',' 0%,\n          ',' 50%,\n          ',' 100%\n        );\n      }\n    '],['\n      &:before {\n        background: linear-gradient(\n          135deg,\n          ',' 0%,\n          ',' 50%,\n          ',' 100%\n        );\n      }\n    ']),_templateObject7=_taggedTemplateLiteral(['\n        &:after {\n          background-color: ',';\n          width: 8px;\n          height: 8px;\n          border: solid 1px ',';\n        }\n      '],['\n        &:after {\n          background-color: ',';\n          width: 8px;\n          height: 8px;\n          border: solid 1px ',';\n        }\n      ']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var FilterOption=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].p(_templateObject,__WEBPACK_IMPORTED_MODULE_1__helpers_variables__["a" /* animation */].transitionTime,__WEBPACK_IMPORTED_MODULE_1__helpers_variables__["a" /* animation */].easing,__WEBPACK_IMPORTED_MODULE_1__helpers_variables__["c" /* color */].lightGrey,__WEBPACK_IMPORTED_MODULE_1__helpers_variables__["c" /* color */].grey,function(props){return props.active&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(_templateObject2,__WEBPACK_IMPORTED_MODULE_1__helpers_variables__["c" /* color */].primary);},function(props){return props.radioButton&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(_templateObject3);},function(props){return props.backgroundColor&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(_templateObject4,props.backgroundColor,__WEBPACK_IMPORTED_MODULE_1__helpers_variables__["c" /* color */].white,__WEBPACK_IMPORTED_MODULE_1__helpers_variables__["c" /* color */].grey);},function(props){return Array.isArray(props.backgroundColor)&&props.backgroundColor.length===2&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(_templateObject5,props.backgroundColor[0]+'55',props.backgroundColor[1]+'55');},function(props){return Array.isArray(props.backgroundColor)&&props.backgroundColor.length>=3&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(_templateObject6,props.backgroundColor[0]+'55',props.backgroundColor[1]+'55',props.backgroundColor[2]+'55');},__WEBPACK_IMPORTED_MODULE_1__helpers_variables__["f" /* size */].large,function(props){return props.backgroundColor&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(_templateObject7,__WEBPACK_IMPORTED_MODULE_1__helpers_variables__["c" /* color */].white,__WEBPACK_IMPORTED_MODULE_1__helpers_variables__["c" /* color */].grey);});

/***/ }),
/* 165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NoProductsFound; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_variables__ = __webpack_require__(4);
var _templateObject=_taggedTemplateLiteral(['\n  max-width: 460px;\n  margin: 200px auto 300px;\n  font-size: 18px;\n  font-weight: 300;\n  font-style: italic;\n  font-stretch: normal;\n  line-height: 1.56;\n  letter-spacing: normal;\n  text-align: center;\n  color: ',';\n'],['\n  max-width: 460px;\n  margin: 200px auto 300px;\n  font-size: 18px;\n  font-weight: 300;\n  font-style: italic;\n  font-stretch: normal;\n  line-height: 1.56;\n  letter-spacing: normal;\n  text-align: center;\n  color: ',';\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var NoProductsFound=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].p(_templateObject,__WEBPACK_IMPORTED_MODULE_1__helpers_variables__["c" /* color */].black);

/***/ }),
/* 166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addPriceToBaseProduct; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return mapToObject; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var addPriceToBaseProduct=function addPriceToBaseProduct(product){if(!product.get('variants',__WEBPACK_IMPORTED_MODULE_0_immutable__["List"]).size){return product;}var cheapestVariant=product.get('variants').sortBy(function(variant){return variant.get('price');}).take(1).get(0);var productPrice=cheapestVariant.get('price');var productOriginalPrice=productPrice<cheapestVariant.get('originalPrice')?cheapestVariant.get('originalPrice'):null;return product.merge({price:productPrice,originalPrice:productOriginalPrice});};var mapToObject=function mapToObject(data){// If result is an array
if(Array.isArray(data)){var newList=data.reduce(function(memo,item){return Object.assign(_defineProperty({},item.id,addPriceToBaseProduct(Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(item))),memo);},{});return Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(newList);}// If result is a single product
if(Array.isArray(data.variants)){return _defineProperty({},data.id,data);}// If result is a editorial page
if(data.url){return _defineProperty({},data.url,data);}// If result is a category
return _defineProperty({},data.systemId,data);};

/***/ }),
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getProductVariantName; });
var getProductVariantName=function getProductVariantName(fullVariantName){var addWordBreakOpportunities=arguments.length>1&&arguments[1]!==undefined?arguments[1]:false;if(Object.prototype.toString.call(fullVariantName)!=='[object String]'){// the param is not a string, return it
return fullVariantName;}var newName=fullVariantName.match(/^(.*)( - )(.*)$/);// check if we got a valid variant name
if(newName&&newName.length===4&&''+newName[1]+newName[2]+newName[3]===fullVariantName){// looks like we got a valid variant name, returning it!
if(addWordBreakOpportunities){// add WBO character after every forward slash
return newName[3].replace(/\//g,'/\u200B');}return newName[3];}// something went wrong in our validation, returning original name...
return fullVariantName;};

/***/ }),
/* 168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export OrderHeading */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return InnerContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return WhiteContainer; });
/* unused harmony export OrderText */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_endpoints__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Page__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_Container__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_Heading__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_helpers_variables__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_helpers_mixins__ = __webpack_require__(6);
var _templateObject=_taggedTemplateLiteral(['\n  margin: 0 0 0.5rem;\n  @media screen and (min-width: ','px) {\n    margin: 0 0 2rem;\n  }\n'],['\n  margin: 0 0 0.5rem;\n  @media screen and (min-width: ','px) {\n    margin: 0 0 2rem;\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  padding: 55px 0;\n  width: 100%;\n  height: 100%;\n  @media screen and (min-width: ','px) {\n    padding: 85px 0 110px;\n  }\n'],['\n  padding: 55px 0;\n  width: 100%;\n  height: 100%;\n  @media screen and (min-width: ','px) {\n    padding: 85px 0 110px;\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  padding-left: 0;\n  margin: 0;\n  list-style: none;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  width: 100%;\n'],['\n  padding-left: 0;\n  margin: 0;\n  list-style: none;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  width: 100%;\n']),_templateObject4=_taggedTemplateLiteral(['\n  height: 100%;\n  width: 100%;\n  object-fit: contain;\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n'],['\n  height: 100%;\n  width: 100%;\n  object-fit: contain;\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n']),_templateObject5=_taggedTemplateLiteral(['\n  width: calc(100% / 3 - 32px);\n  padding-top: calc(100% / 3 - 32px);\n  margin: 0 16px 24px;\n  position: relative;\n  @media screen and (min-width: ','px) {\n    width: calc(100% / 3 - 48px);\n    padding-top: calc(100% / 3 - 48px);\n    margin: 0 24px 36px;\n  }\n  @media screen and (min-width: ','px) {\n    width: calc(100% / 4 - 48px);\n    padding-top: calc(100% / 4 - 48px);\n    margin: 0 24px 36px;\n  }\n  ',';\n'],['\n  width: calc(100% / 3 - 32px);\n  padding-top: calc(100% / 3 - 32px);\n  margin: 0 16px 24px;\n  position: relative;\n  @media screen and (min-width: ','px) {\n    width: calc(100% / 3 - 48px);\n    padding-top: calc(100% / 3 - 48px);\n    margin: 0 24px 36px;\n  }\n  @media screen and (min-width: ','px) {\n    width: calc(100% / 4 - 48px);\n    padding-top: calc(100% / 4 - 48px);\n    margin: 0 24px 36px;\n  }\n  ',';\n']),_templateObject6=_taggedTemplateLiteral(['\n      width: 70%;\n      padding-top: 70%;\n      @media screen and (min-width: ','px) {\n        padding-top: calc(100% / 2 - 32px);\n        width: calc(100% / 2 - 32px);\n      }\n    '],['\n      width: 70%;\n      padding-top: 70%;\n      @media screen and (min-width: ','px) {\n        padding-top: calc(100% / 2 - 32px);\n        width: calc(100% / 2 - 32px);\n      }\n    ']),_templateObject7=_taggedTemplateLiteral(['\n  width: 100%;\n  margin: 0 auto 20px;\n  max-width: 950px;\n  background-color: white !important;\n  display: flex;\n\n  justify-content: flex-start;\n  align-items: center;\n  flex-direction: column;\n  padding: 27px 17px;\n\n  @media screen and (min-width: ','px) {\n    margin: 0 auto 28px;\n    padding: 57px 100px;\n  }\n'],['\n  width: 100%;\n  margin: 0 auto 20px;\n  max-width: 950px;\n  background-color: white !important;\n  display: flex;\n\n  justify-content: flex-start;\n  align-items: center;\n  flex-direction: column;\n  padding: 27px 17px;\n\n  @media screen and (min-width: ','px) {\n    margin: 0 auto 28px;\n    padding: 57px 100px;\n  }\n']),_templateObject8=_taggedTemplateLiteral(['\n  margin: 0;\n  ',';\n  font-weight: 300;\n  line-height: 1.55;\n  text-align: center;\n  margin-bottom: 33px;\n  a{ \n    text-decoration: none;\n    color: inherit;\n    cursor: pointer;\n  }\n  span {\n    font-weight: 600;\n  }\n  ','\n  @media screen and (min-width: ','px) {\n    margin-bottom: 73px;\n  }\n  ','\n'],['\n  margin: 0;\n  ',';\n  font-weight: 300;\n  line-height: 1.55;\n  text-align: center;\n  margin-bottom: 33px;\n  a{ \n    text-decoration: none;\n    color: inherit;\n    cursor: pointer;\n  }\n  span {\n    font-weight: 600;\n  }\n  ','\n  @media screen and (min-width: ','px) {\n    margin-bottom: 73px;\n  }\n  ','\n']),_templateObject9=_taggedTemplateLiteral(['\n      color: ',';\n    '],['\n      color: ',';\n    ']),_templateObject10=_taggedTemplateLiteral(['\n      margin-bottom: 0;\n      @media screen and (min-width: ','px) {\n        margin-bottom: 0;\n      }\n    '],['\n      margin-bottom: 0;\n      @media screen and (min-width: ','px) {\n        margin-bottom: 0;\n      }\n    ']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var OrderConfirmationPage=function OrderConfirmationPage(props){var location=props.location;var state=location.state;var order=state.order;var cart=order.cart,purchasePage=order.purchasePage;var imageUrl=purchasePage.imageUrl,orderNumber=purchasePage.orderNumber,email=purchasePage.email,firstName=purchasePage.firstName;var items=cart.cart.length?cart.cart:[];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Page__["a" /* default */],{title:'Tack f\xF6r din order!',bgImg:''+__WEBPACK_IMPORTED_MODULE_3__constants_endpoints__["n" /* SITE_ROOT_URL */]+imageUrl,noBreadcrumbs:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__styles_Container__["a" /* Container */],{bgColor:'transparent',style:{paddingTop:'0',paddingBottom:'0',minHeight:'60vh'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(InnerContainer,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WhiteContainer,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(OrderHeading,{big:true,margin:'0 0 1rem'},'Tack',firstName?', '+firstName:'','!'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(OrderText,null,'Vi har skickat en orderbekr\xE4ftelse till ',email?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,email):'din mail','.',orderNumber?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Ordernummer: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,orderNumber)):''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(List,null,items.map(function(_ref){var baseProductId=_ref.baseProductId,product=_ref.product;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ListItem,{key:baseProductId,oneItem:items.length===1},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ProductImage,{src:''+__WEBPACK_IMPORTED_MODULE_3__constants_endpoints__["n" /* SITE_ROOT_URL */]+product.mainImage.url,alt:product.name}));}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(OrderText,{color:'white',noMb:true},'Beh\xF6ver du hj\xE4lp, kontakta kundservice',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'tel:018650370'},'Telefon: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'018-65 03 70')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'mailto:kundservice@valamagasinet.se'},'Mail: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'kundservice@valamagasinet.se'))))));};OrderConfirmationPage.defaultProps={location:{}};OrderConfirmationPage.propTypes={location:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object};var OrderHeading=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_6__styles_Heading__["a" /* Heading */])(_templateObject,__WEBPACK_IMPORTED_MODULE_7__styles_helpers_variables__["f" /* size */].large);var InnerContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject2,__WEBPACK_IMPORTED_MODULE_7__styles_helpers_variables__["f" /* size */].large);var List=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].ul(_templateObject3);var ProductImage=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].img(_templateObject4);var ListItem=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].li(_templateObject5,__WEBPACK_IMPORTED_MODULE_7__styles_helpers_variables__["f" /* size */].medium,__WEBPACK_IMPORTED_MODULE_7__styles_helpers_variables__["f" /* size */].xLarge,function(props){return props.oneItem&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject6,__WEBPACK_IMPORTED_MODULE_7__styles_helpers_variables__["f" /* size */].medium);});var WhiteContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject7,__WEBPACK_IMPORTED_MODULE_7__styles_helpers_variables__["f" /* size */].large);var OrderText=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].p(_templateObject8,Object(__WEBPACK_IMPORTED_MODULE_8__styles_helpers_mixins__["b" /* dynamicFontSize */])(16,20),function(props){return props.color&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject9,props.color);},__WEBPACK_IMPORTED_MODULE_7__styles_helpers_variables__["f" /* size */].large,function(props){return props.noMb&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject10,__WEBPACK_IMPORTED_MODULE_7__styles_helpers_variables__["f" /* size */].large);});/* harmony default export */ __webpack_exports__["c"] = (OrderConfirmationPage);

/***/ }),
/* 169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return fetchProductsData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return fetchProductsDataList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fetchCategoryMetaData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchProductData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__generalApi__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_mapToObject__ = __webpack_require__(166);
var fetchProductsData=function fetchProductsData(id){return __WEBPACK_IMPORTED_MODULE_0__generalApi__["a" /* axiosSingleton */].get('/products',{params:{categorySystemId:id}}).then(function(_ref){var data=_ref.data;return Object(__WEBPACK_IMPORTED_MODULE_1__util_mapToObject__["b" /* mapToObject */])(data);}).catch(function(error){throw error;});};var fetchProductsDataList=function fetchProductsDataList(id){return __WEBPACK_IMPORTED_MODULE_0__generalApi__["a" /* axiosSingleton */].get('/products',{params:{productListId:id}}).then(function(_ref2){var data=_ref2.data;return Object(__WEBPACK_IMPORTED_MODULE_1__util_mapToObject__["b" /* mapToObject */])(data);}).catch(function(error){throw error;});};var fetchCategoryMetaData=function fetchCategoryMetaData(url){return __WEBPACK_IMPORTED_MODULE_0__generalApi__["a" /* axiosSingleton */].get('/category/categoryByUrl',{params:{url:url}}).then(function(_ref3){var data=_ref3.data;return Object(__WEBPACK_IMPORTED_MODULE_1__util_mapToObject__["b" /* mapToObject */])(data);}).catch(function(error){throw error;});};var fetchProductData=function fetchProductData(id){return __WEBPACK_IMPORTED_MODULE_0__generalApi__["a" /* axiosSingleton */].get('/products',{params:{productUrlPath:id}}).then(function(_ref4){var data=_ref4.data;return Object(__WEBPACK_IMPORTED_MODULE_1__util_mapToObject__["b" /* mapToObject */])(data);}).catch(function(error){throw error;});};

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var asap = __webpack_require__(273);

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('Promise constructor\'s argument is not a function');
  }
  this._75 = 0;
  this._83 = 0;
  this._18 = null;
  this._38 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._47 = null;
Promise._71 = null;
Promise._44 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
}
function handle(self, deferred) {
  while (self._83 === 3) {
    self = self._18;
  }
  if (Promise._47) {
    Promise._47(self);
  }
  if (self._83 === 0) {
    if (self._75 === 0) {
      self._75 = 1;
      self._38 = deferred;
      return;
    }
    if (self._75 === 1) {
      self._75 = 2;
      self._38 = [self._38, deferred];
      return;
    }
    self._38.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._83 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._83 === 1) {
        resolve(deferred.promise, self._18);
      } else {
        reject(deferred.promise, self._18);
      }
      return;
    }
    var ret = tryCallOne(cb, self._18);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._83 = 3;
      self._18 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._83 = 1;
  self._18 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._83 = 2;
  self._18 = newValue;
  if (Promise._71) {
    Promise._71(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._75 === 1) {
    handle(self, self._38);
    self._38 = null;
  }
  if (self._75 === 2) {
    for (var i = 0; i < self._38.length; i++) {
      handle(self, self._38[i]);
    }
    self._38 = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  });
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(21) && !__webpack_require__(12)(function () {
  return Object.defineProperty(__webpack_require__(117)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(11);
var core = __webpack_require__(20);
var LIBRARY = __webpack_require__(58);
var wksExt = __webpack_require__(118);
var defineProperty = __webpack_require__(22).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(31);
var toIObject = __webpack_require__(33);
var arrayIndexOf = __webpack_require__(98)(false);
var IE_PROTO = __webpack_require__(119)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(22);
var anObject = __webpack_require__(13);
var getKeys = __webpack_require__(59);

module.exports = __webpack_require__(21) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(33);
var gOPN = __webpack_require__(62).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var DESCRIPTORS = __webpack_require__(21);
var getKeys = __webpack_require__(59);
var gOPS = __webpack_require__(99);
var pIE = __webpack_require__(89);
var toObject = __webpack_require__(24);
var IObject = __webpack_require__(88);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(12)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;


/***/ }),
/* 177 */
/***/ (function(module, exports) {

// 7.2.9 SameValue(x, y)
module.exports = Object.is || function is(x, y) {
  // eslint-disable-next-line no-self-compare
  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
};


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var aFunction = __webpack_require__(41);
var isObject = __webpack_require__(14);
var invoke = __webpack_require__(179);
var arraySlice = [].slice;
var factories = {};

var construct = function (F, len, args) {
  if (!(len in factories)) {
    for (var n = [], i = 0; i < len; i++) n[i] = 'a[' + i + ']';
    // eslint-disable-next-line no-new-func
    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
  } return factories[len](F, args);
};

module.exports = Function.bind || function bind(that /* , ...args */) {
  var fn = aFunction(this);
  var partArgs = arraySlice.call(arguments, 1);
  var bound = function (/* args... */) {
    var args = partArgs.concat(arraySlice.call(arguments));
    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
  };
  if (isObject(fn.prototype)) bound.prototype = fn.prototype;
  return bound;
};


/***/ }),
/* 179 */
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

var $parseInt = __webpack_require__(11).parseInt;
var $trim = __webpack_require__(74).trim;
var ws = __webpack_require__(123);
var hex = /^[-+]?0[xX]/;

module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix) {
  var string = $trim(String(str), 3);
  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
} : $parseInt;


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

var $parseFloat = __webpack_require__(11).parseFloat;
var $trim = __webpack_require__(74).trim;

module.exports = 1 / $parseFloat(__webpack_require__(123) + '-0') !== -Infinity ? function parseFloat(str) {
  var string = $trim(String(str), 3);
  var result = $parseFloat(string);
  return result === 0 && string.charAt(0) == '-' ? -0 : result;
} : $parseFloat;


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

var cof = __webpack_require__(46);
module.exports = function (it, msg) {
  if (typeof it != 'number' && cof(it) != 'Number') throw TypeError(msg);
  return +it;
};


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var isObject = __webpack_require__(14);
var floor = Math.floor;
module.exports = function isInteger(it) {
  return !isObject(it) && isFinite(it) && floor(it) === it;
};


/***/ }),
/* 184 */
/***/ (function(module, exports) {

// 20.2.2.20 Math.log1p(x)
module.exports = Math.log1p || function log1p(x) {
  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
};


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(61);
var descriptor = __webpack_require__(56);
var setToStringTag = __webpack_require__(73);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(32)(IteratorPrototype, __webpack_require__(16)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(13);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__(371);

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};


/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

var aFunction = __webpack_require__(41);
var toObject = __webpack_require__(24);
var IObject = __webpack_require__(88);
var toLength = __webpack_require__(17);

module.exports = function (that, callbackfn, aLen, memo, isRight) {
  aFunction(callbackfn);
  var O = toObject(that);
  var self = IObject(O);
  var length = toLength(O.length);
  var index = isRight ? length - 1 : 0;
  var i = isRight ? -1 : 1;
  if (aLen < 2) for (;;) {
    if (index in self) {
      memo = self[index];
      index += i;
      break;
    }
    index += i;
    if (isRight ? index < 0 : length <= index) {
      throw TypeError('Reduce of empty array with no initial value');
    }
  }
  for (;isRight ? index >= 0 : length > index; index += i) if (index in self) {
    memo = callbackfn(memo, self[index], index, O);
  }
  return memo;
};


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)

var toObject = __webpack_require__(24);
var toAbsoluteIndex = __webpack_require__(60);
var toLength = __webpack_require__(17);

module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
  var O = toObject(this);
  var len = toLength(O.length);
  var to = toAbsoluteIndex(target, len);
  var from = toAbsoluteIndex(start, len);
  var end = arguments.length > 2 ? arguments[2] : undefined;
  var count = Math.min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
  var inc = 1;
  if (from < to && to < from + count) {
    inc = -1;
    from += count - 1;
    to += count - 1;
  }
  while (count-- > 0) {
    if (from in O) O[to] = O[from];
    else delete O[to];
    to += inc;
    from += inc;
  } return O;
};


/***/ }),
/* 190 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var regexpExec = __webpack_require__(138);
__webpack_require__(3)({
  target: 'RegExp',
  proto: true,
  forced: regexpExec !== /./.exec
}, {
  exec: regexpExec
});


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

// 21.2.5.3 get RegExp.prototype.flags()
if (__webpack_require__(21) && /./g.flags != 'g') __webpack_require__(22).f(RegExp.prototype, 'flags', {
  configurable: true,
  get: __webpack_require__(102)
});


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(58);
var global = __webpack_require__(11);
var ctx = __webpack_require__(40);
var classof = __webpack_require__(90);
var $export = __webpack_require__(3);
var isObject = __webpack_require__(14);
var aFunction = __webpack_require__(41);
var anInstance = __webpack_require__(77);
var forOf = __webpack_require__(105);
var speciesConstructor = __webpack_require__(91);
var task = __webpack_require__(140).set;
var microtask = __webpack_require__(391)();
var newPromiseCapabilityModule = __webpack_require__(194);
var perform = __webpack_require__(392);
var userAgent = __webpack_require__(106);
var promiseResolve = __webpack_require__(195);
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8 || '';
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__(16)('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function')
      && promise.then(empty) instanceof FakePromise
      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
      // we can't detect it synchronously, so just check versions
      && v8.indexOf('6.6') !== 0
      && userAgent.indexOf('Chrome/66') === -1;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // may throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        if (domain && !exited) domain.exit();
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__(78)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__(73)($Promise, PROMISE);
__webpack_require__(76)(PROMISE);
Wrapper = __webpack_require__(20)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(101)(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__(41);

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(13);
var isObject = __webpack_require__(14);
var newPromiseCapability = __webpack_require__(194);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var dP = __webpack_require__(22).f;
var create = __webpack_require__(61);
var redefineAll = __webpack_require__(78);
var ctx = __webpack_require__(40);
var anInstance = __webpack_require__(77);
var forOf = __webpack_require__(105);
var $iterDefine = __webpack_require__(129);
var step = __webpack_require__(190);
var setSpecies = __webpack_require__(76);
var DESCRIPTORS = __webpack_require__(21);
var fastKey = __webpack_require__(51).fastKey;
var validate = __webpack_require__(65);
var SIZE = DESCRIPTORS ? '_s' : 'size';

var getEntry = function (that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;         // collection type
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = validate(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        validate(this, NAME);
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(validate(this, NAME), key);
      }
    });
    if (DESCRIPTORS) dP(C.prototype, 'size', {
      get: function () {
        return validate(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function (C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function (iterated, kind) {
      this._t = validate(iterated, NAME); // target
      this._k = kind;                     // kind
      this._l = undefined;                // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) entry = entry.p;
      // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if (kind == 'keys') return step(0, entry.k);
      if (kind == 'values') return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var redefineAll = __webpack_require__(78);
var getWeak = __webpack_require__(51).getWeak;
var anObject = __webpack_require__(13);
var isObject = __webpack_require__(14);
var anInstance = __webpack_require__(77);
var forOf = __webpack_require__(105);
var createArrayMethod = __webpack_require__(45);
var $has = __webpack_require__(31);
var validate = __webpack_require__(65);
var arrayFind = createArrayMethod(5);
var arrayFindIndex = createArrayMethod(6);
var id = 0;

// fallback for uncaught frozen keys
var uncaughtFrozenStore = function (that) {
  return that._l || (that._l = new UncaughtFrozenStore());
};
var UncaughtFrozenStore = function () {
  this.a = [];
};
var findUncaughtFrozen = function (store, key) {
  return arrayFind(store.a, function (it) {
    return it[0] === key;
  });
};
UncaughtFrozenStore.prototype = {
  get: function (key) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) return entry[1];
  },
  has: function (key) {
    return !!findUncaughtFrozen(this, key);
  },
  set: function (key, value) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) entry[1] = value;
    else this.a.push([key, value]);
  },
  'delete': function (key) {
    var index = arrayFindIndex(this.a, function (it) {
      return it[0] === key;
    });
    if (~index) this.a.splice(index, 1);
    return !!~index;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;      // collection type
      that._i = id++;      // collection id
      that._l = undefined; // leak store for uncaught frozen objects
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.3.3.2 WeakMap.prototype.delete(key)
      // 23.4.3.3 WeakSet.prototype.delete(value)
      'delete': function (key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
        return data && $has(data, this._i) && delete data[this._i];
      },
      // 23.3.3.4 WeakMap.prototype.has(key)
      // 23.4.3.4 WeakSet.prototype.has(value)
      has: function has(key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
        return data && $has(data, this._i);
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var data = getWeak(anObject(key), true);
    if (data === true) uncaughtFrozenStore(that).set(key, value);
    else data[that._i] = value;
    return that;
  },
  ufstore: uncaughtFrozenStore
};


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/ecma262/#sec-toindex
var toInteger = __webpack_require__(42);
var toLength = __webpack_require__(17);
module.exports = function (it) {
  if (it === undefined) return 0;
  var number = toInteger(it);
  var length = toLength(number);
  if (number !== length) throw RangeError('Wrong length!');
  return length;
};


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

// all object keys, includes non-enumerable and symbols
var gOPN = __webpack_require__(62);
var gOPS = __webpack_require__(99);
var anObject = __webpack_require__(13);
var Reflect = __webpack_require__(11).Reflect;
module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
  var keys = gOPN.f(anObject(it));
  var getSymbols = gOPS.f;
  return getSymbols ? keys.concat(getSymbols(it)) : keys;
};


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-string-pad-start-end
var toLength = __webpack_require__(17);
var repeat = __webpack_require__(125);
var defined = __webpack_require__(47);

module.exports = function (that, maxLength, fillString, left) {
  var S = String(defined(that));
  var stringLength = S.length;
  var fillStr = fillString === undefined ? ' ' : String(fillString);
  var intMaxLength = toLength(maxLength);
  if (intMaxLength <= stringLength || fillStr == '') return S;
  var fillLen = intMaxLength - stringLength;
  var stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
  if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
  return left ? stringFiller + S : S + stringFiller;
};


/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(21);
var getKeys = __webpack_require__(59);
var toIObject = __webpack_require__(33);
var isEnum = __webpack_require__(89).f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) {
      key = keys[i++];
      if (!DESCRIPTORS || isEnum.call(O, key)) {
        result.push(isEntries ? [key, O[key]] : O[key]);
      }
    }
    return result;
  };
};


/***/ }),
/* 202 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.12' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 203 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Provider__ = __webpack_require__(467);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_connectAdvanced__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__connect_connect__ = __webpack_require__(474);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Provider__["a"]; });
/* unused harmony reexport createProvider */
/* unused harmony reexport connectAdvanced */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__connect_connect__["a"]; });





/***/ }),
/* 205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _inheritsLoose; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__setPrototypeOf_js__ = __webpack_require__(468);

function _inheritsLoose(t, o) {
  t.prototype = Object.create(o.prototype), t.prototype.constructor = t, Object(__WEBPACK_IMPORTED_MODULE_0__setPrototypeOf_js__["a" /* default */])(t, o);
}


/***/ }),
/* 206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return subscriptionShape; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return storeShape; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);

var subscriptionShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  trySubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  tryUnsubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  notifyNestedSubs: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  isSubscribed: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});
var storeShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  subscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  dispatch: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  getState: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});

/***/ }),
/* 207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = connectAdvanced;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_invariant__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_is__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_is__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_Subscription__ = __webpack_require__(473);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__ = __webpack_require__(206);










var prefixUnsafeLifecycleMethods = typeof __WEBPACK_IMPORTED_MODULE_6_react___default.a.forwardRef !== "undefined";
var hotReloadingVersion = 0;
var dummyState = {};

function noop() {}

function makeSelectorStateful(sourceSelector, store) {
  // wrap the selector in an object that tracks its results between runs.
  var selector = {
    run: function runComponentSelector(props) {
      try {
        var nextProps = sourceSelector(store.getState(), props);

        if (nextProps !== selector.props || selector.error) {
          selector.shouldComponentUpdate = true;
          selector.props = nextProps;
          selector.error = null;
        }
      } catch (error) {
        selector.shouldComponentUpdate = true;
        selector.error = error;
      }
    }
  };
  return selector;
}

function connectAdvanced(
/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
     export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/
selectorFactory, // options object:
_ref) {
  var _contextTypes, _childContextTypes;

  if (_ref === void 0) {
    _ref = {};
  }

  var _ref2 = _ref,
      _ref2$getDisplayName = _ref2.getDisplayName,
      getDisplayName = _ref2$getDisplayName === void 0 ? function (name) {
    return "ConnectAdvanced(" + name + ")";
  } : _ref2$getDisplayName,
      _ref2$methodName = _ref2.methodName,
      methodName = _ref2$methodName === void 0 ? 'connectAdvanced' : _ref2$methodName,
      _ref2$renderCountProp = _ref2.renderCountProp,
      renderCountProp = _ref2$renderCountProp === void 0 ? undefined : _ref2$renderCountProp,
      _ref2$shouldHandleSta = _ref2.shouldHandleStateChanges,
      shouldHandleStateChanges = _ref2$shouldHandleSta === void 0 ? true : _ref2$shouldHandleSta,
      _ref2$storeKey = _ref2.storeKey,
      storeKey = _ref2$storeKey === void 0 ? 'store' : _ref2$storeKey,
      _ref2$withRef = _ref2.withRef,
      withRef = _ref2$withRef === void 0 ? false : _ref2$withRef,
      connectOptions = Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref2, ["getDisplayName", "methodName", "renderCountProp", "shouldHandleStateChanges", "storeKey", "withRef"]);

  var subscriptionKey = storeKey + 'Subscription';
  var version = hotReloadingVersion++;
  var contextTypes = (_contextTypes = {}, _contextTypes[storeKey] = __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__["a" /* storeShape */], _contextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__["b" /* subscriptionShape */], _contextTypes);
  var childContextTypes = (_childContextTypes = {}, _childContextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__["b" /* subscriptionShape */], _childContextTypes);
  return function wrapWithConnect(WrappedComponent) {
    __WEBPACK_IMPORTED_MODULE_5_invariant___default()(Object(__WEBPACK_IMPORTED_MODULE_7_react_is__["isValidElementType"])(WrappedComponent), "You must pass a component to the function returned by " + (methodName + ". Instead received " + JSON.stringify(WrappedComponent)));
    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
    var displayName = getDisplayName(wrappedComponentName);

    var selectorFactoryOptions = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({}, connectOptions, {
      getDisplayName: getDisplayName,
      methodName: methodName,
      renderCountProp: renderCountProp,
      shouldHandleStateChanges: shouldHandleStateChanges,
      storeKey: storeKey,
      withRef: withRef,
      displayName: displayName,
      wrappedComponentName: wrappedComponentName,
      WrappedComponent: WrappedComponent // TODO Actually fix our use of componentWillReceiveProps

      /* eslint-disable react/no-deprecated */

    });

    var Connect =
    /*#__PURE__*/
    function (_Component) {
      Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Connect, _Component);

      function Connect(props, context) {
        var _this;

        _this = _Component.call(this, props, context) || this;
        _this.version = version;
        _this.state = {};
        _this.renderCount = 0;
        _this.store = props[storeKey] || context[storeKey];
        _this.propsMode = Boolean(props[storeKey]);
        _this.setWrappedInstance = _this.setWrappedInstance.bind(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
        __WEBPACK_IMPORTED_MODULE_5_invariant___default()(_this.store, "Could not find \"" + storeKey + "\" in either the context or props of " + ("\"" + displayName + "\". Either wrap the root component in a <Provider>, ") + ("or explicitly pass \"" + storeKey + "\" as a prop to \"" + displayName + "\"."));

        _this.initSelector();

        _this.initSubscription();

        return _this;
      }

      var _proto = Connect.prototype;

      _proto.getChildContext = function getChildContext() {
        var _ref3;

        // If this component received store from props, its subscription should be transparent
        // to any descendants receiving store+subscription from context; it passes along
        // subscription passed to it. Otherwise, it shadows the parent subscription, which allows
        // Connect to control ordering of notifications to flow top-down.
        var subscription = this.propsMode ? null : this.subscription;
        return _ref3 = {}, _ref3[subscriptionKey] = subscription || this.context[subscriptionKey], _ref3;
      };

      _proto.componentDidMount = function componentDidMount() {
        if (!shouldHandleStateChanges) return; // componentWillMount fires during server side rendering, but componentDidMount and
        // componentWillUnmount do not. Because of this, trySubscribe happens during ...didMount.
        // Otherwise, unsubscription would never take place during SSR, causing a memory leak.
        // To handle the case where a child component may have triggered a state change by
        // dispatching an action in its componentWillMount, we have to re-run the select and maybe
        // re-render.

        this.subscription.trySubscribe();
        this.selector.run(this.props);
        if (this.selector.shouldComponentUpdate) this.forceUpdate();
      }; // Note: this is renamed below to the UNSAFE_ version in React >=16.3.0


      _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        this.selector.run(nextProps);
      };

      _proto.shouldComponentUpdate = function shouldComponentUpdate() {
        return this.selector.shouldComponentUpdate;
      };

      _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.subscription) this.subscription.tryUnsubscribe();
        this.subscription = null;
        this.notifyNestedSubs = noop;
        this.store = null;
        this.selector.run = noop;
        this.selector.shouldComponentUpdate = false;
      };

      _proto.getWrappedInstance = function getWrappedInstance() {
        __WEBPACK_IMPORTED_MODULE_5_invariant___default()(withRef, "To access the wrapped instance, you need to specify " + ("{ withRef: true } in the options argument of the " + methodName + "() call."));
        return this.wrappedInstance;
      };

      _proto.setWrappedInstance = function setWrappedInstance(ref) {
        this.wrappedInstance = ref;
      };

      _proto.initSelector = function initSelector() {
        var sourceSelector = selectorFactory(this.store.dispatch, selectorFactoryOptions);
        this.selector = makeSelectorStateful(sourceSelector, this.store);
        this.selector.run(this.props);
      };

      _proto.initSubscription = function initSubscription() {
        if (!shouldHandleStateChanges) return; // parentSub's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.

        var parentSub = (this.propsMode ? this.props : this.context)[subscriptionKey];
        this.subscription = new __WEBPACK_IMPORTED_MODULE_8__utils_Subscription__["a" /* default */](this.store, parentSub, this.onStateChange.bind(this)); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
        // the middle of the notification loop, where `this.subscription` will then be null. An
        // extra null check every change can be avoided by copying the method onto `this` and then
        // replacing it with a no-op on unmount. This can probably be avoided if Subscription's
        // listeners logic is changed to not call listeners that have been unsubscribed in the
        // middle of the notification loop.

        this.notifyNestedSubs = this.subscription.notifyNestedSubs.bind(this.subscription);
      };

      _proto.onStateChange = function onStateChange() {
        this.selector.run(this.props);

        if (!this.selector.shouldComponentUpdate) {
          this.notifyNestedSubs();
        } else {
          this.componentDidUpdate = this.notifyNestedSubsOnComponentDidUpdate;
          this.setState(dummyState);
        }
      };

      _proto.notifyNestedSubsOnComponentDidUpdate = function notifyNestedSubsOnComponentDidUpdate() {
        // `componentDidUpdate` is conditionally implemented when `onStateChange` determines it
        // needs to notify nested subs. Once called, it unimplements itself until further state
        // changes occur. Doing it this way vs having a permanent `componentDidUpdate` that does
        // a boolean check every time avoids an extra method call most of the time, resulting
        // in some perf boost.
        this.componentDidUpdate = undefined;
        this.notifyNestedSubs();
      };

      _proto.isSubscribed = function isSubscribed() {
        return Boolean(this.subscription) && this.subscription.isSubscribed();
      };

      _proto.addExtraProps = function addExtraProps(props) {
        if (!withRef && !renderCountProp && !(this.propsMode && this.subscription)) return props; // make a shallow copy so that fields added don't leak to the original selector.
        // this is especially important for 'ref' since that's a reference back to the component
        // instance. a singleton memoized selector would then be holding a reference to the
        // instance, preventing the instance from being garbage collected, and that would be bad

        var withExtras = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props);

        if (withRef) withExtras.ref = this.setWrappedInstance;
        if (renderCountProp) withExtras[renderCountProp] = this.renderCount++;
        if (this.propsMode && this.subscription) withExtras[subscriptionKey] = this.subscription;
        return withExtras;
      };

      _proto.render = function render() {
        var selector = this.selector;
        selector.shouldComponentUpdate = false;

        if (selector.error) {
          throw selector.error;
        } else {
          return Object(__WEBPACK_IMPORTED_MODULE_6_react__["createElement"])(WrappedComponent, this.addExtraProps(selector.props));
        }
      };

      return Connect;
    }(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

    if (prefixUnsafeLifecycleMethods) {
      // Use UNSAFE_ event name where supported
      Connect.prototype.UNSAFE_componentWillReceiveProps = Connect.prototype.componentWillReceiveProps;
      delete Connect.prototype.componentWillReceiveProps;
    }
    /* eslint-enable react/no-deprecated */


    Connect.WrappedComponent = WrappedComponent;
    Connect.displayName = displayName;
    Connect.childContextTypes = childContextTypes;
    Connect.contextTypes = contextTypes;
    Connect.propTypes = contextTypes;

    if (false) {
      // Use UNSAFE_ event name where supported
      var eventName = prefixUnsafeLifecycleMethods ? 'UNSAFE_componentWillUpdate' : 'componentWillUpdate';

      Connect.prototype[eventName] = function componentWillUpdate() {
        var _this2 = this;

        // We are hot reloading!
        if (this.version !== version) {
          this.version = version;
          this.initSelector(); // If any connected descendants don't hot reload (and resubscribe in the process), their
          // listeners will be lost when we unsubscribe. Unfortunately, by copying over all
          // listeners, this does mean that the old versions of connected descendants will still be
          // notified of state changes; however, their onStateChange function is a no-op so this
          // isn't a huge deal.

          var oldListeners = [];

          if (this.subscription) {
            oldListeners = this.subscription.listeners.get();
            this.subscription.tryUnsubscribe();
          }

          this.initSubscription();

          if (shouldHandleStateChanges) {
            this.subscription.trySubscribe();
            oldListeners.forEach(function (listener) {
              return _this2.subscription.listeners.subscribe(listener);
            });
          }
        }
      };
    }

    return __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics___default()(Connect, WrappedComponent);
  };
}

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var reactIs = __webpack_require__(148);

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ActionTypes; });
/* harmony export (immutable) */ __webpack_exports__["b"] = createStore;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_symbol_observable__ = __webpack_require__(485);



/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var ActionTypes = {
  INIT: '@@redux/INIT'

  /**
   * Creates a Redux store that holds the state tree.
   * The only way to change the data in the store is to call `dispatch()` on it.
   *
   * There should only be a single store in your app. To specify how different
   * parts of the state tree respond to actions, you may combine several reducers
   * into a single reducer function by using `combineReducers`.
   *
   * @param {Function} reducer A function that returns the next state tree, given
   * the current state tree and the action to handle.
   *
   * @param {any} [preloadedState] The initial state. You may optionally specify it
   * to hydrate the state from the server in universal apps, or to restore a
   * previously serialized user session.
   * If you use `combineReducers` to produce the root reducer function, this must be
   * an object with the same shape as `combineReducers` keys.
   *
   * @param {Function} [enhancer] The store enhancer. You may optionally specify it
   * to enhance the store with third-party capabilities such as middleware,
   * time travel, persistence, etc. The only store enhancer that ships with Redux
   * is `applyMiddleware()`.
   *
   * @returns {Store} A Redux store that lets you read the state, dispatch actions
   * and subscribe to changes.
   */
};function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error('Expected the enhancer to be a function.');
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error('Expected the reducer to be a function.');
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }

  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */
  function getState() {
    return currentState;
  }

  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */
  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected listener to be a function.');
    }

    var isSubscribed = true;

    ensureCanMutateNextListeners();
    nextListeners.push(listener);

    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      isSubscribed = false;

      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
    };
  }

  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */
  function dispatch(action) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__["a" /* default */])(action)) {
      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
    }

    if (typeof action.type === 'undefined') {
      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
    }

    if (isDispatching) {
      throw new Error('Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;
    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }

  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */
  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error('Expected the nextReducer to be a function.');
    }

    currentReducer = nextReducer;
    dispatch({ type: ActionTypes.INIT });
  }

  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */
  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object') {
          throw new TypeError('Expected the observer to be an object.');
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return { unsubscribe: unsubscribe };
      }
    }, _ref[__WEBPACK_IMPORTED_MODULE_1_symbol_observable__["a" /* default */]] = function () {
      return this;
    }, _ref;
  }

  // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.
  dispatch({ type: ActionTypes.INIT });

  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[__WEBPACK_IMPORTED_MODULE_1_symbol_observable__["a" /* default */]] = observable, _ref2;
}

/***/ }),
/* 210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(477);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getPrototype_js__ = __webpack_require__(482);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__ = __webpack_require__(484);




/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__["a" /* default */])(value) || Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) != objectTag) {
    return false;
  }
  var proto = Object(__WEBPACK_IMPORTED_MODULE_1__getPrototype_js__["a" /* default */])(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

/* harmony default export */ __webpack_exports__["a"] = (isPlainObject);


/***/ }),
/* 211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(478);


/** Built-in value references. */
var Symbol = __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Symbol;

/* harmony default export */ __webpack_exports__["a"] = (Symbol);


/***/ }),
/* 212 */
/***/ (function(module, exports) {

module.exports = function(originalModule) {
	if(!originalModule.webpackPolyfill) {
		var module = Object.create(originalModule);
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		Object.defineProperty(module, "exports", {
			enumerable: true,
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}

/***/ }),
/* 214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = compose;
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */

function compose() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(undefined, arguments));
    };
  });
}

/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = wrapMapToPropsConstant;
/* unused harmony export getDependsOnOwnProps */
/* harmony export (immutable) */ __webpack_exports__["b"] = wrapMapToPropsFunc;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(216);

function wrapMapToPropsConstant(getConstant) {
  return function initConstantSelector(dispatch, options) {
    var constant = getConstant(dispatch, options);

    function constantSelector() {
      return constant;
    }

    constantSelector.dependsOnOwnProps = false;
    return constantSelector;
  };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
// whether mapToProps needs to be invoked when props have changed.
// 
// A length of one signals that mapToProps does not depend on props from the parent component.
// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
// therefore not reporting its length accurately..

function getDependsOnOwnProps(mapToProps) {
  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
// this function wraps mapToProps in a proxy function which does several things:
// 
//  * Detects whether the mapToProps function being called depends on props, which
//    is used by selectorFactory to decide if it should reinvoke on props changes.
//    
//  * On first call, handles mapToProps if returns another function, and treats that
//    new function as the true mapToProps for subsequent calls.
//    
//  * On first call, verifies the first result is a plain object, in order to warn
//    the developer that their mapToProps function is not returning a valid result.
//    

function wrapMapToPropsFunc(mapToProps, methodName) {
  return function initProxySelector(dispatch, _ref) {
    var displayName = _ref.displayName;

    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
    }; // allow detectFactoryAndVerify to get ownProps


    proxy.dependsOnOwnProps = true;

    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
      proxy.mapToProps = mapToProps;
      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
      var props = proxy(stateOrDispatch, ownProps);

      if (typeof props === 'function') {
        proxy.mapToProps = props;
        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
        props = proxy(stateOrDispatch, ownProps);
      }

      if (false) verifyPlainObject(props, displayName, methodName);
      return props;
    };

    return proxy;
  };
}

/***/ }),
/* 216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isPlainObject__ = __webpack_require__(490);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__warning__ = __webpack_require__(146);


function verifyPlainObject(value, displayName, methodName) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_0__isPlainObject__["a" /* default */])(value)) {
    Object(__WEBPACK_IMPORTED_MODULE_1__warning__["a" /* default */])(methodName + "() in " + displayName + " must return a plain object. Instead received " + value + ".");
  }
}

/***/ }),
/* 217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
function isAbsolute(pathname) {
  return pathname.charAt(0) === '/';
}

// About 1.5x faster than the two-arg version of Array#splice()
function spliceOne(list, index) {
  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
    list[i] = list[k];
  }

  list.pop();
}

// This implementation is based heavily on node's url.parse
function resolvePathname(to, from) {
  if (from === undefined) from = '';

  var toParts = (to && to.split('/')) || [];
  var fromParts = (from && from.split('/')) || [];

  var isToAbs = to && isAbsolute(to);
  var isFromAbs = from && isAbsolute(from);
  var mustEndAbs = isToAbs || isFromAbs;

  if (to && isAbsolute(to)) {
    // to is absolute
    fromParts = toParts;
  } else if (toParts.length) {
    // to is relative, drop the filename
    fromParts.pop();
    fromParts = fromParts.concat(toParts);
  }

  if (!fromParts.length) return '/';

  var hasTrailingSlash;
  if (fromParts.length) {
    var last = fromParts[fromParts.length - 1];
    hasTrailingSlash = last === '.' || last === '..' || last === '';
  } else {
    hasTrailingSlash = false;
  }

  var up = 0;
  for (var i = fromParts.length; i >= 0; i--) {
    var part = fromParts[i];

    if (part === '.') {
      spliceOne(fromParts, i);
    } else if (part === '..') {
      spliceOne(fromParts, i);
      up++;
    } else if (up) {
      spliceOne(fromParts, i);
      up--;
    }
  }

  if (!mustEndAbs) for (; up--; up) fromParts.unshift('..');

  if (
    mustEndAbs &&
    fromParts[0] !== '' &&
    (!fromParts[0] || !isAbsolute(fromParts[0]))
  )
    fromParts.unshift('');

  var result = fromParts.join('/');

  if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';

  return result;
}

/* harmony default export */ __webpack_exports__["default"] = (resolvePathname);


/***/ }),
/* 218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
function valueOf(obj) {
  return obj.valueOf ? obj.valueOf() : Object.prototype.valueOf.call(obj);
}

function valueEqual(a, b) {
  // Test for strict equality first.
  if (a === b) return true;

  // Otherwise, if either of them == null they are not equal.
  if (a == null || b == null) return false;

  if (Array.isArray(a)) {
    return (
      Array.isArray(b) &&
      a.length === b.length &&
      a.every(function(item, index) {
        return valueEqual(item, b[index]);
      })
    );
  }

  if (typeof a === 'object' || typeof b === 'object') {
    var aValue = valueOf(a);
    var bValue = valueOf(b);

    if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);

    return Object.keys(Object.assign({}, a, b)).every(function(key) {
      return valueEqual(a[key], b[key]);
    });
  }

  return false;
}

/* harmony default export */ __webpack_exports__["default"] = (valueEqual);


/***/ }),
/* 219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var isProduction = "production" === 'production';
function warning(condition, message) {
  if (!isProduction) {
    if (condition) {
      return;
    }

    var text = "Warning: " + message;

    if (typeof console !== 'undefined') {
      console.warn(text);
    }

    try {
      throw Error(text);
    } catch (x) {}
  }
}

/* harmony default export */ __webpack_exports__["default"] = (warning);


/***/ }),
/* 220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return invariant; });
var isProduction = "production" === 'production';
var prefix = 'Invariant failed';
function invariant(condition, message) {
    if (condition) {
        return;
    }
    if (isProduction) {
        throw new Error(prefix);
    }
    var provided = typeof message === 'function' ? message() : message;
    var value = provided ? "".concat(prefix, ": ").concat(provided) : prefix;
    throw new Error(value);
}




/***/ }),
/* 221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(79);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var isModifiedEvent = function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
};

/**
 * The public API for rendering a history-aware <a>.
 */

var Link = function (_React$Component) {
  _inherits(Link, _React$Component);

  function Link() {
    var _temp, _this, _ret;

    _classCallCheck(this, Link);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
      if (_this.props.onClick) _this.props.onClick(event);

      if (!event.defaultPrevented && // onClick prevented default
      event.button === 0 && // ignore everything but left clicks
      !_this.props.target && // let browser handle "target=_blank" etc.
      !isModifiedEvent(event) // ignore clicks with modifier keys
      ) {
          event.preventDefault();

          var history = _this.context.router.history;
          var _this$props = _this.props,
              replace = _this$props.replace,
              to = _this$props.to;


          if (replace) {
            history.replace(to);
          } else {
            history.push(to);
          }
        }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Link.prototype.render = function render() {
    var _props = this.props,
        replace = _props.replace,
        to = _props.to,
        innerRef = _props.innerRef,
        props = _objectWithoutProperties(_props, ["replace", "to", "innerRef"]); // eslint-disable-line no-unused-vars

    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, "You should not use <Link> outside a <Router>");

    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(to !== undefined, 'You must specify the "to" property');

    var history = this.context.router.history;

    var location = typeof to === "string" ? Object(__WEBPACK_IMPORTED_MODULE_3_history__["c" /* createLocation */])(to, null, null, history.location) : to;

    var href = history.createHref(location);
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", _extends({}, props, { onClick: this.handleClick, href: href, ref: innerRef }));
  };

  return Link;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Link.propTypes = {
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  target: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired,
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func])
};
Link.defaultProps = {
  replace: false
};
Link.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      createHref: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Link);

/***/ }),
/* 222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__ = __webpack_require__(223);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__["a" /* default */]);

/***/ }),
/* 223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(151);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var isEmptyChildren = function isEmptyChildren(children) {
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 0;
};

/**
 * The public API for matching a single path and rendering.
 */

var Route = function (_React$Component) {
  _inherits(Route, _React$Component);

  function Route() {
    var _temp, _this, _ret;

    _classCallCheck(this, Route);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props, _this.context.router)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Route.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        route: {
          location: this.props.location || this.context.router.route.location,
          match: this.state.match
        }
      })
    };
  };

  Route.prototype.computeMatch = function computeMatch(_ref, router) {
    var computedMatch = _ref.computedMatch,
        location = _ref.location,
        path = _ref.path,
        strict = _ref.strict,
        exact = _ref.exact,
        sensitive = _ref.sensitive;

    if (computedMatch) return computedMatch; // <Switch> already computed the match for us

    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(router, "You should not use <Route> or withRouter() outside a <Router>");

    var route = router.route;

    var pathname = (location || route.location).pathname;

    return Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(pathname, { path: path, strict: strict, exact: exact, sensitive: sensitive }, route.match);
  };

  Route.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.render), "You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored");

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route component> and <Route children> in the same route; <Route children> will be ignored");

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.render && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route render> and <Route children> in the same route; <Route children> will be ignored");
  };

  Route.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(nextProps.location && !this.props.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(!nextProps.location && this.props.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');

    this.setState({
      match: this.computeMatch(nextProps, nextContext.router)
    });
  };

  Route.prototype.render = function render() {
    var match = this.state.match;
    var _props = this.props,
        children = _props.children,
        component = _props.component,
        render = _props.render;
    var _context$router = this.context.router,
        history = _context$router.history,
        route = _context$router.route,
        staticContext = _context$router.staticContext;

    var location = this.props.location || route.location;
    var props = { match: match, location: location, history: history, staticContext: staticContext };

    if (component) return match ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(component, props) : null;

    if (render) return match ? render(props) : null;

    if (typeof children === "function") return children(props);

    if (children && !isEmptyChildren(children)) return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children);

    return null;
  };

  return Route;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Route.propTypes = {
  computedMatch: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object, // private, from <Switch>
  path: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  exact: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  sensitive: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  component: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  render: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node]),
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Route.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    route: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
  })
};
Route.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Route);

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

var isarray = __webpack_require__(500)

/**
 * Expose `pathToRegexp`.
 */
module.exports = pathToRegexp
module.exports.parse = parse
module.exports.compile = compile
module.exports.tokensToFunction = tokensToFunction
module.exports.tokensToRegExp = tokensToRegExp

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g')

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = []
  var key = 0
  var index = 0
  var path = ''
  var defaultDelimiter = options && options.delimiter || '/'
  var res

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0]
    var escaped = res[1]
    var offset = res.index
    path += str.slice(index, offset)
    index = offset + m.length

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1]
      continue
    }

    var next = str[index]
    var prefix = res[2]
    var name = res[3]
    var capture = res[4]
    var group = res[5]
    var modifier = res[6]
    var asterisk = res[7]

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path)
      path = ''
    }

    var partial = prefix != null && next != null && next !== prefix
    var repeat = modifier === '+' || modifier === '*'
    var optional = modifier === '?' || modifier === '*'
    var delimiter = prefix || defaultDelimiter
    var pattern = capture || group
    var prevText = prefix || (typeof tokens[tokens.length - 1] === 'string' ? tokens[tokens.length - 1] : '')

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : restrictBacktrack(delimiter, prevText))
    })
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index)
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path)
  }

  return tokens
}

function restrictBacktrack(delimiter, prevText) {
  if (!prevText || prevText.indexOf(delimiter) > -1) {
    return '[^' + escapeString(delimiter) + ']+?'
  }

  return escapeString(prevText) + '|(?:(?!' + escapeString(prevText) + ')[^' + escapeString(delimiter) + '])+?'
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options), options)
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens, options) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length)

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$', flags(options))
    }
  }

  return function (obj, opts) {
    var path = ''
    var data = obj || {}
    var options = opts || {}
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i]

      if (typeof token === 'string') {
        path += token

        continue
      }

      var value = data[token.name]
      var segment

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j])

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value)

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options && options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g)

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      })
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = []

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source)
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options))

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  var strict = options.strict
  var end = options.end !== false
  var route = ''

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i]

    if (typeof token === 'string') {
      route += escapeString(token)
    } else {
      var prefix = escapeString(token.prefix)
      var capture = '(?:' + token.pattern + ')'

      keys.push(token)

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*'
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?'
        } else {
          capture = prefix + '(' + capture + ')?'
        }
      } else {
        capture = prefix + '(' + capture + ')'
      }

      route += capture
    }
  }

  var delimiter = escapeString(options.delimiter || '/')
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?'
  }

  if (end) {
    route += '$'
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)'
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}


/***/ }),
/* 225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path_to_regexp__);


var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compileGenerator = function compileGenerator(pattern) {
  var cacheKey = pattern;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var compiledGenerator = __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default.a.compile(pattern);

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledGenerator;
    cacheCount++;
  }

  return compiledGenerator;
};

/**
 * Public API for generating a URL pathname from a pattern and parameters.
 */
var generatePath = function generatePath() {
  var pattern = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "/";
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (pattern === "/") {
    return pattern;
  }
  var generator = compileGenerator(pattern);
  return generator(params, { pretty: true });
};

/* harmony default export */ __webpack_exports__["a"] = (generatePath);

/***/ }),
/* 226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = asap;
/* harmony export (immutable) */ __webpack_exports__["c"] = suspend;
/* harmony export (immutable) */ __webpack_exports__["b"] = flush;
var queue = [];
/**
  Variable to hold a counting semaphore
  - Incrementing adds a lock and puts the scheduler in a `suspended` state (if it's not
    already suspended)
  - Decrementing releases a lock. Zero locks puts the scheduler in a `released` state. This
    triggers flushing the queued tasks.
**/
var semaphore = 0;

/**
  Executes a task 'atomically'. Tasks scheduled during this execution will be queued
  and flushed after this task has finished (assuming the scheduler endup in a released
  state).
**/
function exec(task) {
  try {
    suspend();
    task();
  } finally {
    release();
  }
}

/**
  Executes or queues a task depending on the state of the scheduler (`suspended` or `released`)
**/
function asap(task) {
  queue.push(task);

  if (!semaphore) {
    suspend();
    flush();
  }
}

/**
  Puts the scheduler in a `suspended` state. Scheduled tasks will be queued until the
  scheduler is released.
**/
function suspend() {
  semaphore++;
}

/**
  Puts the scheduler in a `released` state.
**/
function release() {
  semaphore--;
}

/**
  Releases the current lock. Executes all queued tasks if the scheduler is in the released state.
**/
function flush() {
  release();

  var task = void 0;
  while (!semaphore && (task = queue.shift()) !== undefined) {
    exec(task);
  }
}

/***/ }),
/* 227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = runSaga;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__proc__ = __webpack_require__(228);



var RUN_SAGA_SIGNATURE = 'runSaga(storeInterface, saga, ...args)';
var NON_GENERATOR_ERR = RUN_SAGA_SIGNATURE + ': saga argument must be a Generator function!';

function runSaga(storeInterface, saga) {
  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  var iterator = void 0;

  if (__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].iterator(storeInterface)) {
    if (false) {
      log('warn', 'runSaga(iterator, storeInterface) has been deprecated in favor of ' + RUN_SAGA_SIGNATURE);
    }
    iterator = storeInterface;
    storeInterface = saga;
  } else {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(saga, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func, NON_GENERATOR_ERR);
    iterator = saga.apply(undefined, args);
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(iterator, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].iterator, NON_GENERATOR_ERR);
  }

  var _storeInterface = storeInterface,
      subscribe = _storeInterface.subscribe,
      dispatch = _storeInterface.dispatch,
      getState = _storeInterface.getState,
      context = _storeInterface.context,
      sagaMonitor = _storeInterface.sagaMonitor,
      logger = _storeInterface.logger,
      onError = _storeInterface.onError;


  var effectId = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["v" /* uid */])();

  if (sagaMonitor) {
    // monitors are expected to have a certain interface, let's fill-in any missing ones
    sagaMonitor.effectTriggered = sagaMonitor.effectTriggered || __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */];
    sagaMonitor.effectResolved = sagaMonitor.effectResolved || __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */];
    sagaMonitor.effectRejected = sagaMonitor.effectRejected || __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */];
    sagaMonitor.effectCancelled = sagaMonitor.effectCancelled || __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */];
    sagaMonitor.actionDispatched = sagaMonitor.actionDispatched || __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */];

    sagaMonitor.effectTriggered({ effectId: effectId, root: true, parentEffectId: 0, effect: { root: true, saga: saga, args: args } });
  }

  var task = Object(__WEBPACK_IMPORTED_MODULE_1__proc__["a" /* default */])(iterator, subscribe, Object(__WEBPACK_IMPORTED_MODULE_0__utils__["x" /* wrapSagaDispatch */])(dispatch), getState, context, { sagaMonitor: sagaMonitor, logger: logger, onError: onError }, effectId, saga.name);

  if (sagaMonitor) {
    sagaMonitor.effectResolved(effectId, task);
  }

  return task;
}

/***/ }),
/* 228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export NOT_ITERATOR_ERROR */
/* unused harmony export CHANNEL_END */
/* unused harmony export TASK_CANCEL */
/* harmony export (immutable) */ __webpack_exports__["a"] = proc;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__scheduler__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__io__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__channel__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__buffers__ = __webpack_require__(109);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _defineEnumerableProperties(obj, descs) { for (var key in descs) { var desc = descs[key]; desc.configurable = desc.enumerable = true; if ("value" in desc) desc.writable = true; Object.defineProperty(obj, key, desc); } return obj; }







var NOT_ITERATOR_ERROR = 'proc first argument (Saga function result) must be an iterator';

var CHANNEL_END = {
  toString: function toString() {
    return '@@redux-saga/CHANNEL_END';
  }
};
var TASK_CANCEL = {
  toString: function toString() {
    return '@@redux-saga/TASK_CANCEL';
  }
};

var matchers = {
  wildcard: function wildcard() {
    return __WEBPACK_IMPORTED_MODULE_0__utils__["o" /* kTrue */];
  },
  default: function _default(pattern) {
    return (typeof pattern === 'undefined' ? 'undefined' : _typeof(pattern)) === 'symbol' ? function (input) {
      return input.type === pattern;
    } : function (input) {
      return input.type === String(pattern);
    };
  },
  array: function array(patterns) {
    return function (input) {
      return patterns.some(function (p) {
        return matcher(p)(input);
      });
    };
  },
  predicate: function predicate(_predicate) {
    return function (input) {
      return _predicate(input);
    };
  }
};

function matcher(pattern) {
  // prettier-ignore
  return (pattern === '*' ? matchers.wildcard : __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].array(pattern) ? matchers.array : __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].stringableFunc(pattern) ? matchers.default : __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func(pattern) ? matchers.predicate : matchers.default)(pattern);
}

/**
  Used to track a parent task and its forks
  In the new fork model, forked tasks are attached by default to their parent
  We model this using the concept of Parent task && main Task
  main task is the main flow of the current Generator, the parent tasks is the
  aggregation of the main tasks + all its forked tasks.
  Thus the whole model represents an execution tree with multiple branches (vs the
  linear execution tree in sequential (non parallel) programming)

  A parent tasks has the following semantics
  - It completes if all its forks either complete or all cancelled
  - If it's cancelled, all forks are cancelled as well
  - It aborts if any uncaught error bubbles up from forks
  - If it completes, the return value is the one returned by the main task
**/
function forkQueue(name, mainTask, cb) {
  var tasks = [],
      result = void 0,
      completed = false;
  addTask(mainTask);

  function abort(err) {
    cancelAll();
    cb(err, true);
  }

  function addTask(task) {
    tasks.push(task);
    task.cont = function (res, isErr) {
      if (completed) {
        return;
      }

      Object(__WEBPACK_IMPORTED_MODULE_0__utils__["t" /* remove */])(tasks, task);
      task.cont = __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */];
      if (isErr) {
        abort(res);
      } else {
        if (task === mainTask) {
          result = res;
        }
        if (!tasks.length) {
          completed = true;
          cb(result);
        }
      }
    };
    // task.cont.cancel = task.cancel
  }

  function cancelAll() {
    if (completed) {
      return;
    }
    completed = true;
    tasks.forEach(function (t) {
      t.cont = __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */];
      t.cancel();
    });
    tasks = [];
  }

  return {
    addTask: addTask,
    cancelAll: cancelAll,
    abort: abort,
    getTasks: function getTasks() {
      return tasks;
    },
    taskNames: function taskNames() {
      return tasks.map(function (t) {
        return t.name;
      });
    }
  };
}

function createTaskIterator(_ref) {
  var context = _ref.context,
      fn = _ref.fn,
      args = _ref.args;

  if (__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].iterator(fn)) {
    return fn;
  }

  // catch synchronous failures; see #152 and #441
  var result = void 0,
      error = void 0;
  try {
    result = fn.apply(context, args);
  } catch (err) {
    error = err;
  }

  // i.e. a generator function returns an iterator
  if (__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].iterator(result)) {
    return result;
  }

  // do not bubble up synchronous failures for detached forks
  // instead create a failed task. See #152 and #441
  return error ? Object(__WEBPACK_IMPORTED_MODULE_0__utils__["q" /* makeIterator */])(function () {
    throw error;
  }) : Object(__WEBPACK_IMPORTED_MODULE_0__utils__["q" /* makeIterator */])(function () {
    var pc = void 0;
    var eff = { done: false, value: result };
    var ret = function ret(value) {
      return { done: true, value: value };
    };
    return function (arg) {
      if (!pc) {
        pc = true;
        return eff;
      } else {
        return ret(arg);
      }
    };
  }());
}

var wrapHelper = function wrapHelper(helper) {
  return { fn: helper };
};

function proc(iterator) {
  var subscribe = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {
    return __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */];
  };
  var dispatch = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */];
  var getState = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */];
  var parentContext = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
  var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
  var parentEffectId = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 0;
  var name = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : 'anonymous';
  var cont = arguments[8];

  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(iterator, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].iterator, NOT_ITERATOR_ERROR);

  var effectsString = '[...effects]';
  var runParallelEffect = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["k" /* deprecate */])(runAllEffect, Object(__WEBPACK_IMPORTED_MODULE_0__utils__["w" /* updateIncentive */])(effectsString, 'all(' + effectsString + ')'));

  var sagaMonitor = options.sagaMonitor,
      logger = options.logger,
      onError = options.onError;

  var log = logger || __WEBPACK_IMPORTED_MODULE_0__utils__["p" /* log */];
  var logError = function logError(err) {
    var message = err.sagaStack;

    if (!message && err.stack) {
      message = err.stack.split('\n')[0].indexOf(err.message) !== -1 ? err.stack : 'Error: ' + err.message + '\n' + err.stack;
    }

    log('error', 'uncaught at ' + name, message || err.message || err);
  };
  var stdChannel = Object(__WEBPACK_IMPORTED_MODULE_3__channel__["e" /* stdChannel */])(subscribe);
  var taskContext = Object.create(parentContext);
  /**
    Tracks the current effect cancellation
    Each time the generator progresses. calling runEffect will set a new value
    on it. It allows propagating cancellation to child effects
  **/
  next.cancel = __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */];

  /**
    Creates a new task descriptor for this generator, We'll also create a main task
    to track the main flow (besides other forked tasks)
  **/
  var task = newTask(parentEffectId, name, iterator, cont);
  var mainTask = { name: name, cancel: cancelMain, isRunning: true };
  var taskQueue = forkQueue(name, mainTask, end);

  /**
    cancellation of the main task. We'll simply resume the Generator with a Cancel
  **/
  function cancelMain() {
    if (mainTask.isRunning && !mainTask.isCancelled) {
      mainTask.isCancelled = true;
      next(TASK_CANCEL);
    }
  }

  /**
    This may be called by a parent generator to trigger/propagate cancellation
    cancel all pending tasks (including the main task), then end the current task.
     Cancellation propagates down to the whole execution tree holded by this Parent task
    It's also propagated to all joiners of this task and their execution tree/joiners
     Cancellation is noop for terminated/Cancelled tasks tasks
  **/
  function cancel() {
    /**
      We need to check both Running and Cancelled status
      Tasks can be Cancelled but still Running
    **/
    if (iterator._isRunning && !iterator._isCancelled) {
      iterator._isCancelled = true;
      taskQueue.cancelAll();
      /**
        Ending with a Never result will propagate the Cancellation to all joiners
      **/
      end(TASK_CANCEL);
    }
  }
  /**
    attaches cancellation logic to this task's continuation
    this will permit cancellation to propagate down the call chain
  **/
  cont && (cont.cancel = cancel);

  // tracks the running status
  iterator._isRunning = true;

  // kicks up the generator
  next();

  // then return the task descriptor to the caller
  return task;

  /**
    This is the generator driver
    It's a recursive async/continuation function which calls itself
    until the generator terminates or throws
  **/
  function next(arg, isErr) {
    // Preventive measure. If we end up here, then there is really something wrong
    if (!mainTask.isRunning) {
      throw new Error('Trying to resume an already finished generator');
    }

    try {
      var result = void 0;
      if (isErr) {
        result = iterator.throw(arg);
      } else if (arg === TASK_CANCEL) {
        /**
          getting TASK_CANCEL automatically cancels the main task
          We can get this value here
           - By cancelling the parent task manually
          - By joining a Cancelled task
        **/
        mainTask.isCancelled = true;
        /**
          Cancels the current effect; this will propagate the cancellation down to any called tasks
        **/
        next.cancel();
        /**
          If this Generator has a `return` method then invokes it
          This will jump to the finally block
        **/
        result = __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func(iterator.return) ? iterator.return(TASK_CANCEL) : { done: true, value: TASK_CANCEL };
      } else if (arg === CHANNEL_END) {
        // We get CHANNEL_END by taking from a channel that ended using `take` (and not `takem` used to trap End of channels)
        result = __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func(iterator.return) ? iterator.return() : { done: true };
      } else {
        result = iterator.next(arg);
      }

      if (!result.done) {
        runEffect(result.value, parentEffectId, '', next);
      } else {
        /**
          This Generator has ended, terminate the main task and notify the fork queue
        **/
        mainTask.isMainRunning = false;
        mainTask.cont && mainTask.cont(result.value);
      }
    } catch (error) {
      if (mainTask.isCancelled) {
        logError(error);
      }
      mainTask.isMainRunning = false;
      mainTask.cont(error, true);
    }
  }

  function end(result, isErr) {
    iterator._isRunning = false;
    stdChannel.close();
    if (!isErr) {
      iterator._result = result;
      iterator._deferredEnd && iterator._deferredEnd.resolve(result);
    } else {
      if (result instanceof Error) {
        Object.defineProperty(result, 'sagaStack', {
          value: 'at ' + name + ' \n ' + (result.sagaStack || result.stack),
          configurable: true
        });
      }
      if (!task.cont) {
        if (result instanceof Error && onError) {
          onError(result);
        } else {
          logError(result);
        }
      }
      iterator._error = result;
      iterator._isAborted = true;
      iterator._deferredEnd && iterator._deferredEnd.reject(result);
    }
    task.cont && task.cont(result, isErr);
    task.joiners.forEach(function (j) {
      return j.cb(result, isErr);
    });
    task.joiners = null;
  }

  function runEffect(effect, parentEffectId) {
    var label = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    var cb = arguments[3];

    var effectId = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["v" /* uid */])();
    sagaMonitor && sagaMonitor.effectTriggered({ effectId: effectId, parentEffectId: parentEffectId, label: label, effect: effect });

    /**
      completion callback and cancel callback are mutually exclusive
      We can't cancel an already completed effect
      And We can't complete an already cancelled effectId
    **/
    var effectSettled = void 0;

    // Completion callback passed to the appropriate effect runner
    function currCb(res, isErr) {
      if (effectSettled) {
        return;
      }

      effectSettled = true;
      cb.cancel = __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */]; // defensive measure
      if (sagaMonitor) {
        isErr ? sagaMonitor.effectRejected(effectId, res) : sagaMonitor.effectResolved(effectId, res);
      }
      cb(res, isErr);
    }
    // tracks down the current cancel
    currCb.cancel = __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */];

    // setup cancellation logic on the parent cb
    cb.cancel = function () {
      // prevents cancelling an already completed effect
      if (effectSettled) {
        return;
      }

      effectSettled = true;
      /**
        propagates cancel downward
        catch uncaught cancellations errors; since we can no longer call the completion
        callback, log errors raised during cancellations into the console
      **/
      try {
        currCb.cancel();
      } catch (err) {
        logError(err);
      }
      currCb.cancel = __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */]; // defensive measure

      sagaMonitor && sagaMonitor.effectCancelled(effectId);
    };

    /**
      each effect runner must attach its own logic of cancellation to the provided callback
      it allows this generator to propagate cancellation downward.
       ATTENTION! effect runners must setup the cancel logic by setting cb.cancel = [cancelMethod]
      And the setup must occur before calling the callback
       This is a sort of inversion of control: called async functions are responsible
      for completing the flow by calling the provided continuation; while caller functions
      are responsible for aborting the current flow by calling the attached cancel function
       Library users can attach their own cancellation logic to promises by defining a
      promise[CANCEL] method in their returned promises
      ATTENTION! calling cancel must have no effect on an already completed or cancelled effect
    **/
    var data = void 0;
    // prettier-ignore
    return (
      // Non declarative effect
      __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].promise(effect) ? resolvePromise(effect, currCb) : __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].helper(effect) ? runForkEffect(wrapHelper(effect), effectId, currCb) : __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].iterator(effect) ? resolveIterator(effect, effectId, name, currCb)

      // declarative effects
      : __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].array(effect) ? runParallelEffect(effect, effectId, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["b" /* asEffect */].take(effect)) ? runTakeEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["b" /* asEffect */].put(effect)) ? runPutEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["b" /* asEffect */].all(effect)) ? runAllEffect(data, effectId, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["b" /* asEffect */].race(effect)) ? runRaceEffect(data, effectId, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["b" /* asEffect */].call(effect)) ? runCallEffect(data, effectId, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["b" /* asEffect */].cps(effect)) ? runCPSEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["b" /* asEffect */].fork(effect)) ? runForkEffect(data, effectId, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["b" /* asEffect */].join(effect)) ? runJoinEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["b" /* asEffect */].cancel(effect)) ? runCancelEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["b" /* asEffect */].select(effect)) ? runSelectEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["b" /* asEffect */].actionChannel(effect)) ? runChannelEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["b" /* asEffect */].flush(effect)) ? runFlushEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["b" /* asEffect */].cancelled(effect)) ? runCancelledEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["b" /* asEffect */].getContext(effect)) ? runGetContextEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["b" /* asEffect */].setContext(effect)) ? runSetContextEffect(data, currCb) : /* anything else returned as is */currCb(effect)
    );
  }

  function resolvePromise(promise, cb) {
    var cancelPromise = promise[__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* CANCEL */]];
    if (__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func(cancelPromise)) {
      cb.cancel = cancelPromise;
    } else if (__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func(promise.abort)) {
      cb.cancel = function () {
        return promise.abort();
      };
      // TODO: add support for the fetch API, whenever they get around to
      // adding cancel support
    }
    promise.then(cb, function (error) {
      return cb(error, true);
    });
  }

  function resolveIterator(iterator, effectId, name, cb) {
    proc(iterator, subscribe, dispatch, getState, taskContext, options, effectId, name, cb);
  }

  function runTakeEffect(_ref2, cb) {
    var channel = _ref2.channel,
        pattern = _ref2.pattern,
        maybe = _ref2.maybe;

    channel = channel || stdChannel;
    var takeCb = function takeCb(inp) {
      return inp instanceof Error ? cb(inp, true) : Object(__WEBPACK_IMPORTED_MODULE_3__channel__["d" /* isEnd */])(inp) && !maybe ? cb(CHANNEL_END) : cb(inp);
    };
    try {
      channel.take(takeCb, matcher(pattern));
    } catch (err) {
      return cb(err, true);
    }
    cb.cancel = takeCb.cancel;
  }

  function runPutEffect(_ref3, cb) {
    var channel = _ref3.channel,
        action = _ref3.action,
        resolve = _ref3.resolve;

    /**
      Schedule the put in case another saga is holding a lock.
      The put will be executed atomically. ie nested puts will execute after
      this put has terminated.
    **/
    Object(__WEBPACK_IMPORTED_MODULE_1__scheduler__["a" /* asap */])(function () {
      var result = void 0;
      try {
        result = (channel ? channel.put : dispatch)(action);
      } catch (error) {
        // If we have a channel or `put.resolve` was used then bubble up the error.
        if (channel || resolve) return cb(error, true);
        logError(error);
      }

      if (resolve && __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].promise(result)) {
        resolvePromise(result, cb);
      } else {
        return cb(result);
      }
    });
    // Put effects are non cancellables
  }

  function runCallEffect(_ref4, effectId, cb) {
    var context = _ref4.context,
        fn = _ref4.fn,
        args = _ref4.args;

    var result = void 0;
    // catch synchronous failures; see #152
    try {
      result = fn.apply(context, args);
    } catch (error) {
      return cb(error, true);
    }
    return __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].promise(result) ? resolvePromise(result, cb) : __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].iterator(result) ? resolveIterator(result, effectId, fn.name, cb) : cb(result);
  }

  function runCPSEffect(_ref5, cb) {
    var context = _ref5.context,
        fn = _ref5.fn,
        args = _ref5.args;

    // CPS (ie node style functions) can define their own cancellation logic
    // by setting cancel field on the cb

    // catch synchronous failures; see #152
    try {
      var cpsCb = function cpsCb(err, res) {
        return __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].undef(err) ? cb(res) : cb(err, true);
      };
      fn.apply(context, args.concat(cpsCb));
      if (cpsCb.cancel) {
        cb.cancel = function () {
          return cpsCb.cancel();
        };
      }
    } catch (error) {
      return cb(error, true);
    }
  }

  function runForkEffect(_ref6, effectId, cb) {
    var context = _ref6.context,
        fn = _ref6.fn,
        args = _ref6.args,
        detached = _ref6.detached;

    var taskIterator = createTaskIterator({ context: context, fn: fn, args: args });

    try {
      Object(__WEBPACK_IMPORTED_MODULE_1__scheduler__["c" /* suspend */])();
      var _task = proc(taskIterator, subscribe, dispatch, getState, taskContext, options, effectId, fn.name, detached ? null : __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */]);

      if (detached) {
        cb(_task);
      } else {
        if (taskIterator._isRunning) {
          taskQueue.addTask(_task);
          cb(_task);
        } else if (taskIterator._error) {
          taskQueue.abort(taskIterator._error);
        } else {
          cb(_task);
        }
      }
    } finally {
      Object(__WEBPACK_IMPORTED_MODULE_1__scheduler__["b" /* flush */])();
    }
    // Fork effects are non cancellables
  }

  function runJoinEffect(t, cb) {
    if (t.isRunning()) {
      var joiner = { task: task, cb: cb };
      cb.cancel = function () {
        return Object(__WEBPACK_IMPORTED_MODULE_0__utils__["t" /* remove */])(t.joiners, joiner);
      };
      t.joiners.push(joiner);
    } else {
      t.isAborted() ? cb(t.error(), true) : cb(t.result());
    }
  }

  function runCancelEffect(taskToCancel, cb) {
    if (taskToCancel === __WEBPACK_IMPORTED_MODULE_0__utils__["d" /* SELF_CANCELLATION */]) {
      taskToCancel = task;
    }
    if (taskToCancel.isRunning()) {
      taskToCancel.cancel();
    }
    cb();
    // cancel effects are non cancellables
  }

  function runAllEffect(effects, effectId, cb) {
    var keys = Object.keys(effects);

    if (!keys.length) {
      return cb(__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].array(effects) ? [] : {});
    }

    var completedCount = 0;
    var completed = void 0;
    var results = {};
    var childCbs = {};

    function checkEffectEnd() {
      if (completedCount === keys.length) {
        completed = true;
        cb(__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].array(effects) ? __WEBPACK_IMPORTED_MODULE_0__utils__["f" /* array */].from(_extends({}, results, { length: keys.length })) : results);
      }
    }

    keys.forEach(function (key) {
      var chCbAtKey = function chCbAtKey(res, isErr) {
        if (completed) {
          return;
        }
        if (isErr || Object(__WEBPACK_IMPORTED_MODULE_3__channel__["d" /* isEnd */])(res) || res === CHANNEL_END || res === TASK_CANCEL) {
          cb.cancel();
          cb(res, isErr);
        } else {
          results[key] = res;
          completedCount++;
          checkEffectEnd();
        }
      };
      chCbAtKey.cancel = __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */];
      childCbs[key] = chCbAtKey;
    });

    cb.cancel = function () {
      if (!completed) {
        completed = true;
        keys.forEach(function (key) {
          return childCbs[key].cancel();
        });
      }
    };

    keys.forEach(function (key) {
      return runEffect(effects[key], effectId, key, childCbs[key]);
    });
  }

  function runRaceEffect(effects, effectId, cb) {
    var completed = void 0;
    var keys = Object.keys(effects);
    var childCbs = {};

    keys.forEach(function (key) {
      var chCbAtKey = function chCbAtKey(res, isErr) {
        if (completed) {
          return;
        }

        if (isErr) {
          // Race Auto cancellation
          cb.cancel();
          cb(res, true);
        } else if (!Object(__WEBPACK_IMPORTED_MODULE_3__channel__["d" /* isEnd */])(res) && res !== CHANNEL_END && res !== TASK_CANCEL) {
          var _response;

          cb.cancel();
          completed = true;
          var response = (_response = {}, _response[key] = res, _response);
          cb(__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].array(effects) ? [].slice.call(_extends({}, response, { length: keys.length })) : response);
        }
      };
      chCbAtKey.cancel = __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */];
      childCbs[key] = chCbAtKey;
    });

    cb.cancel = function () {
      // prevents unnecessary cancellation
      if (!completed) {
        completed = true;
        keys.forEach(function (key) {
          return childCbs[key].cancel();
        });
      }
    };
    keys.forEach(function (key) {
      if (completed) {
        return;
      }
      runEffect(effects[key], effectId, key, childCbs[key]);
    });
  }

  function runSelectEffect(_ref7, cb) {
    var selector = _ref7.selector,
        args = _ref7.args;

    try {
      var state = selector.apply(undefined, [getState()].concat(args));
      cb(state);
    } catch (error) {
      cb(error, true);
    }
  }

  function runChannelEffect(_ref8, cb) {
    var pattern = _ref8.pattern,
        buffer = _ref8.buffer;

    var match = matcher(pattern);
    match.pattern = pattern;
    cb(Object(__WEBPACK_IMPORTED_MODULE_3__channel__["c" /* eventChannel */])(subscribe, buffer || __WEBPACK_IMPORTED_MODULE_4__buffers__["a" /* buffers */].fixed(), match));
  }

  function runCancelledEffect(data, cb) {
    cb(!!mainTask.isCancelled);
  }

  function runFlushEffect(channel, cb) {
    channel.flush(cb);
  }

  function runGetContextEffect(prop, cb) {
    cb(taskContext[prop]);
  }

  function runSetContextEffect(props, cb) {
    __WEBPACK_IMPORTED_MODULE_0__utils__["s" /* object */].assign(taskContext, props);
    cb();
  }

  function newTask(id, name, iterator, cont) {
    var _done, _ref9, _mutatorMap;

    iterator._deferredEnd = null;
    return _ref9 = {}, _ref9[__WEBPACK_IMPORTED_MODULE_0__utils__["e" /* TASK */]] = true, _ref9.id = id, _ref9.name = name, _done = 'done', _mutatorMap = {}, _mutatorMap[_done] = _mutatorMap[_done] || {}, _mutatorMap[_done].get = function () {
      if (iterator._deferredEnd) {
        return iterator._deferredEnd.promise;
      } else {
        var def = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["i" /* deferred */])();
        iterator._deferredEnd = def;
        if (!iterator._isRunning) {
          iterator._error ? def.reject(iterator._error) : def.resolve(iterator._result);
        }
        return def.promise;
      }
    }, _ref9.cont = cont, _ref9.joiners = [], _ref9.cancel = cancel, _ref9.isRunning = function isRunning() {
      return iterator._isRunning;
    }, _ref9.isCancelled = function isCancelled() {
      return iterator._isCancelled;
    }, _ref9.isAborted = function isAborted() {
      return iterator._isAborted;
    }, _ref9.result = function result() {
      return iterator._result;
    }, _ref9.error = function error() {
      return iterator._error;
    }, _ref9.setContext = function setContext(props) {
      Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(props, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].object, Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* createSetContextWarning */])('task', props));
      __WEBPACK_IMPORTED_MODULE_0__utils__["s" /* object */].assign(taskContext, props);
    }, _defineEnumerableProperties(_ref9, _mutatorMap), _ref9;
  }
}

/***/ }),
/* 229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export takeEvery */
/* unused harmony export takeLatest */
/* unused harmony export throttle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__takeEvery__ = __webpack_require__(517);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__takeLatest__ = __webpack_require__(518);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__throttle__ = __webpack_require__(519);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(34);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__takeEvery__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__takeLatest__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__throttle__["a"]; });






var deprecationWarning = function deprecationWarning(helperName) {
  return 'import { ' + helperName + ' } from \'redux-saga\' has been deprecated in favor of import { ' + helperName + ' } from \'redux-saga/effects\'.\nThe latter will not work with yield*, as helper effects are wrapped automatically for you in fork effect.\nTherefore yield ' + helperName + ' will return task descriptor to your saga and execute next lines of code.';
};

var takeEvery = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_3__utils__["k" /* deprecate */])(__WEBPACK_IMPORTED_MODULE_0__takeEvery__["a" /* default */], /*#__PURE__*/deprecationWarning('takeEvery'));
var takeLatest = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_3__utils__["k" /* deprecate */])(__WEBPACK_IMPORTED_MODULE_1__takeLatest__["a" /* default */], /*#__PURE__*/deprecationWarning('takeLatest'));
var throttle = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_3__utils__["k" /* deprecate */])(__WEBPACK_IMPORTED_MODULE_2__throttle__["a" /* default */], /*#__PURE__*/deprecationWarning('throttle'));



/***/ }),
/* 230 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_helpers_variables__ = __webpack_require__(4);
var _templateObject=_taggedTemplateLiteral(['\n  position: absolute;\n  top: 0;\n  right: 0;\n  left: 0;\n  bottom: 0;\n  background-color: ',';\n  opacity: ',';\n  z-index: ',';\n'],['\n  position: absolute;\n  top: 0;\n  right: 0;\n  left: 0;\n  bottom: 0;\n  background-color: ',';\n  opacity: ',';\n  z-index: ',';\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Overlay=function Overlay(props){if(!props.active){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(OverlayElement,{onClick:props.onClick,opaque:props.opaque,header:props.header});};var OverlayElement=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject,__WEBPACK_IMPORTED_MODULE_3__styles_helpers_variables__["c" /* color */].black,function(props){return props.opaque?1:0.2;},function(props){return props.header?148:1;});Overlay.defaultProps={active:false,opaque:false,header:false,onClick:null};Overlay.propTypes={onClick:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,active:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,opaque:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,header:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (Overlay);

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var PropTypes = _interopRequireWildcard(__webpack_require__(1));

var _addClass = _interopRequireDefault(__webpack_require__(545));

var _removeClass = _interopRequireDefault(__webpack_require__(548));

var _react = _interopRequireDefault(__webpack_require__(0));

var _Transition = _interopRequireDefault(__webpack_require__(233));

var _PropTypes = __webpack_require__(235);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var addClass = function addClass(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return (0, _addClass.default)(node, c);
  });
};

var removeClass = function removeClass(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return (0, _removeClass.default)(node, c);
  });
};
/**
 * A transition component inspired by the excellent
 * [ng-animate](http://www.nganimate.org/) library, you should use it if you're
 * using CSS transitions or animations. It's built upon the
 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
 * component, so it inherits all of its props.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` states of the transition. The first class is applied and then a
 * second `*-active` class in order to activate the CSSS transition. After the
 * transition, matching `*-done` class names are applied to persist the
 * transition state.
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
 *         <div>
 *           {"I'll receive my-node-* classes"}
 *         </div>
 *       </CSSTransition>
 *       <button type="button" onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the `in` prop is set to `true`, the child component will first receive
 * the class `example-enter`, then the `example-enter-active` will be added in
 * the next tick. `CSSTransition` [forces a
 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * between before adding the `example-enter-active`. This is an important trick
 * because it allows us to transition between `example-enter` and
 * `example-enter-active` even though they were added immediately one after
 * another. Most notably, this is what makes it possible for us to animate
 * _appearance_.
 *
 * ```css
 * .my-node-enter {
 *   opacity: 0;
 * }
 * .my-node-enter-active {
 *   opacity: 1;
 *   transition: opacity 200ms;
 * }
 * .my-node-exit {
 *   opacity: 1;
 * }
 * .my-node-exit-active {
 *   opacity: 0;
 *   transition: opacity: 200ms;
 * }
 * ```
 *
 * `*-active` classes represent which styles you want to animate **to**.
 */


var CSSTransition =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(CSSTransition, _React$Component);

  function CSSTransition() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _this.onEnter = function (node, appearing) {
      var _this$getClassNames = _this.getClassNames(appearing ? 'appear' : 'enter'),
          className = _this$getClassNames.className;

      _this.removeClasses(node, 'exit');

      addClass(node, className);

      if (_this.props.onEnter) {
        _this.props.onEnter(node, appearing);
      }
    };

    _this.onEntering = function (node, appearing) {
      var _this$getClassNames2 = _this.getClassNames(appearing ? 'appear' : 'enter'),
          activeClassName = _this$getClassNames2.activeClassName;

      _this.reflowAndAddClass(node, activeClassName);

      if (_this.props.onEntering) {
        _this.props.onEntering(node, appearing);
      }
    };

    _this.onEntered = function (node, appearing) {
      var appearClassName = _this.getClassNames('appear').doneClassName;

      var enterClassName = _this.getClassNames('enter').doneClassName;

      var doneClassName = appearing ? appearClassName + " " + enterClassName : enterClassName;

      _this.removeClasses(node, appearing ? 'appear' : 'enter');

      addClass(node, doneClassName);

      if (_this.props.onEntered) {
        _this.props.onEntered(node, appearing);
      }
    };

    _this.onExit = function (node) {
      var _this$getClassNames3 = _this.getClassNames('exit'),
          className = _this$getClassNames3.className;

      _this.removeClasses(node, 'appear');

      _this.removeClasses(node, 'enter');

      addClass(node, className);

      if (_this.props.onExit) {
        _this.props.onExit(node);
      }
    };

    _this.onExiting = function (node) {
      var _this$getClassNames4 = _this.getClassNames('exit'),
          activeClassName = _this$getClassNames4.activeClassName;

      _this.reflowAndAddClass(node, activeClassName);

      if (_this.props.onExiting) {
        _this.props.onExiting(node);
      }
    };

    _this.onExited = function (node) {
      var _this$getClassNames5 = _this.getClassNames('exit'),
          doneClassName = _this$getClassNames5.doneClassName;

      _this.removeClasses(node, 'exit');

      addClass(node, doneClassName);

      if (_this.props.onExited) {
        _this.props.onExited(node);
      }
    };

    _this.getClassNames = function (type) {
      var classNames = _this.props.classNames;
      var isStringClassNames = typeof classNames === 'string';
      var prefix = isStringClassNames && classNames ? classNames + '-' : '';
      var className = isStringClassNames ? prefix + type : classNames[type];
      var activeClassName = isStringClassNames ? className + '-active' : classNames[type + 'Active'];
      var doneClassName = isStringClassNames ? className + '-done' : classNames[type + 'Done'];
      return {
        className: className,
        activeClassName: activeClassName,
        doneClassName: doneClassName
      };
    };

    return _this;
  }

  var _proto = CSSTransition.prototype;

  _proto.removeClasses = function removeClasses(node, type) {
    var _this$getClassNames6 = this.getClassNames(type),
        className = _this$getClassNames6.className,
        activeClassName = _this$getClassNames6.activeClassName,
        doneClassName = _this$getClassNames6.doneClassName;

    className && removeClass(node, className);
    activeClassName && removeClass(node, activeClassName);
    doneClassName && removeClass(node, doneClassName);
  };

  _proto.reflowAndAddClass = function reflowAndAddClass(node, className) {
    // This is for to force a repaint,
    // which is necessary in order to transition styles when adding a class name.
    if (className) {
      /* eslint-disable no-unused-expressions */
      node && node.scrollTop;
      /* eslint-enable no-unused-expressions */

      addClass(node, className);
    }
  };

  _proto.render = function render() {
    var props = _extends({}, this.props);

    delete props.classNames;
    return _react.default.createElement(_Transition.default, _extends({}, props, {
      onEnter: this.onEnter,
      onEntered: this.onEntered,
      onEntering: this.onEntering,
      onExit: this.onExit,
      onExiting: this.onExiting,
      onExited: this.onExited
    }));
  };

  return CSSTransition;
}(_react.default.Component);

CSSTransition.defaultProps = {
  classNames: ''
};
CSSTransition.propTypes =  false ? _extends({}, _Transition.default.propTypes, {
  /**
   * The animation classNames applied to the component as it enters, exits or
   * has finished the transition. A single name can be provided and it will be
   * suffixed for each stage: e.g.
   *
   * `classNames="fade"` applies `fade-enter`, `fade-enter-active`,
   * `fade-enter-done`, `fade-exit`, `fade-exit-active`, `fade-exit-done`,
   * `fade-appear`, `fade-appear-active`, and `fade-appear-done`.
   *
   * **Note**: `fade-appear-done` and `fade-enter-done` will _both_ be applied.
   * This allows you to define different behavior for when appearing is done and
   * when regular entering is done, using selectors like
   * `.fade-enter-done:not(.fade-appear-done)`. For example, you could apply an
   * epic entrance animation when element first appears in the DOM using
   * [Animate.css](https://daneden.github.io/animate.css/). Otherwise you can
   * simply use `fade-enter-done` for defining both cases.
   *
   * Each individual classNames can also be specified independently like:
   *
   * ```js
   * classNames={{
   *  appear: 'my-appear',
   *  appearActive: 'my-active-appear',
   *  appearDone: 'my-done-appear',
   *  enter: 'my-enter',
   *  enterActive: 'my-active-enter',
   *  enterDone: 'my-done-enter',
   *  exit: 'my-exit',
   *  exitActive: 'my-active-exit',
   *  exitDone: 'my-done-exit',
   * }}
   * ```
   *
   * If you want to set these classes using CSS Modules:
   *
   * ```js
   * import styles from './styles.css';
   * ```
   *
   * you might want to use camelCase in your CSS file, that way could simply
   * spread them instead of listing them one by one:
   *
   * ```js
   * classNames={{ ...styles }}
   * ```
   *
   * @type {string | {
   *  appear?: string,
   *  appearActive?: string,
   *  appearDone?: string,
   *  enter?: string,
   *  enterActive?: string,
   *  enterDone?: string,
   *  exit?: string,
   *  exitActive?: string,
   *  exitDone?: string,
   * }}
   */
  classNames: _PropTypes.classNamesShape,

  /**
   * A `<Transition>` callback fired immediately after the 'enter' or 'appear' class is
   * applied.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEnter: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'enter-active' or
   * 'appear-active' class is applied.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'enter' or
   * 'appear' classes are **removed** and the `done` class is added to the DOM node.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntered: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit' class is
   * applied.
   *
   * @type Function(node: HtmlElement)
   */
  onExit: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit-active' is applied.
   *
   * @type Function(node: HtmlElement)
   */
  onExiting: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit' classes
   * are **removed** and the `exit-done` class is added to the DOM node.
   *
   * @type Function(node: HtmlElement)
   */
  onExited: PropTypes.func
}) : {};
var _default = CSSTransition;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = void 0;

var PropTypes = _interopRequireWildcard(__webpack_require__(1));

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactDom = _interopRequireDefault(__webpack_require__(145));

var _reactLifecyclesCompat = __webpack_require__(234);

var _PropTypes = __webpack_require__(235);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var UNMOUNTED = 'unmounted';
exports.UNMOUNTED = UNMOUNTED;
var EXITED = 'exited';
exports.EXITED = EXITED;
var ENTERING = 'entering';
exports.ENTERING = ENTERING;
var ENTERED = 'entered';
exports.ENTERED = ENTERED;
var EXITING = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 0 },
 *   entered:  { opacity: 1 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */

exports.EXITING = EXITING;

var Transition =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Transition, _React$Component);

  function Transition(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    var parentGroup = context.transitionGroup; // In the context of a TransitionGroup all enters are really appears

    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
    var initialStatus;
    _this.appearStatus = null;

    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.appearStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }

    _this.state = {
      status: initialStatus
    };
    _this.nextCallback = null;
    return _this;
  }

  var _proto = Transition.prototype;

  _proto.getChildContext = function getChildContext() {
    return {
      transitionGroup: null // allows for nested Transitions

    };
  };

  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref.in;

    if (nextIn && prevState.status === UNMOUNTED) {
      return {
        status: EXITED
      };
    }

    return null;
  }; // getSnapshotBeforeUpdate(prevProps) {
  //   let nextStatus = null
  //   if (prevProps !== this.props) {
  //     const { status } = this.state
  //     if (this.props.in) {
  //       if (status !== ENTERING && status !== ENTERED) {
  //         nextStatus = ENTERING
  //       }
  //     } else {
  //       if (status === ENTERING || status === ENTERED) {
  //         nextStatus = EXITING
  //       }
  //     }
  //   }
  //   return { nextStatus }
  // }


  _proto.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;

    if (prevProps !== this.props) {
      var status = this.state.status;

      if (this.props.in) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          nextStatus = EXITING;
        }
      }
    }

    this.updateStatus(false, nextStatus);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };

  _proto.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;
    var exit, enter, appear;
    exit = enter = appear = timeout;

    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter; // TODO: remove fallback for next major

      appear = timeout.appear !== undefined ? timeout.appear : enter;
    }

    return {
      exit: exit,
      enter: enter,
      appear: appear
    };
  };

  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
    if (mounting === void 0) {
      mounting = false;
    }

    if (nextStatus !== null) {
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();

      var node = _reactDom.default.findDOMNode(this);

      if (nextStatus === ENTERING) {
        this.performEnter(node, mounting);
      } else {
        this.performExit(node);
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({
        status: UNMOUNTED
      });
    }
  };

  _proto.performEnter = function performEnter(node, mounting) {
    var _this2 = this;

    var enter = this.props.enter;
    var appearing = this.context.transitionGroup ? this.context.transitionGroup.isMounting : mounting;
    var timeouts = this.getTimeouts();
    var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set

    if (!mounting && !enter) {
      this.safeSetState({
        status: ENTERED
      }, function () {
        _this2.props.onEntered(node);
      });
      return;
    }

    this.props.onEnter(node, appearing);
    this.safeSetState({
      status: ENTERING
    }, function () {
      _this2.props.onEntering(node, appearing);

      _this2.onTransitionEnd(node, enterTimeout, function () {
        _this2.safeSetState({
          status: ENTERED
        }, function () {
          _this2.props.onEntered(node, appearing);
        });
      });
    });
  };

  _proto.performExit = function performExit(node) {
    var _this3 = this;

    var exit = this.props.exit;
    var timeouts = this.getTimeouts(); // no exit animation skip right to EXITED

    if (!exit) {
      this.safeSetState({
        status: EXITED
      }, function () {
        _this3.props.onExited(node);
      });
      return;
    }

    this.props.onExit(node);
    this.safeSetState({
      status: EXITING
    }, function () {
      _this3.props.onExiting(node);

      _this3.onTransitionEnd(node, timeouts.exit, function () {
        _this3.safeSetState({
          status: EXITED
        }, function () {
          _this3.props.onExited(node);
        });
      });
    });
  };

  _proto.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };

  _proto.safeSetState = function safeSetState(nextState, callback) {
    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };

  _proto.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;

    var active = true;

    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this4.nextCallback = null;
        callback(event);
      }
    };

    this.nextCallback.cancel = function () {
      active = false;
    };

    return this.nextCallback;
  };

  _proto.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
    this.setNextCallback(handler);
    var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;

    if (!node || doesNotHaveTimeoutOrListener) {
      setTimeout(this.nextCallback, 0);
      return;
    }

    if (this.props.addEndListener) {
      this.props.addEndListener(node, this.nextCallback);
    }

    if (timeout != null) {
      setTimeout(this.nextCallback, timeout);
    }
  };

  _proto.render = function render() {
    var status = this.state.status;

    if (status === UNMOUNTED) {
      return null;
    }

    var _this$props = this.props,
        children = _this$props.children,
        childProps = _objectWithoutPropertiesLoose(_this$props, ["children"]); // filter props for Transtition


    delete childProps.in;
    delete childProps.mountOnEnter;
    delete childProps.unmountOnExit;
    delete childProps.appear;
    delete childProps.enter;
    delete childProps.exit;
    delete childProps.timeout;
    delete childProps.addEndListener;
    delete childProps.onEnter;
    delete childProps.onEntering;
    delete childProps.onEntered;
    delete childProps.onExit;
    delete childProps.onExiting;
    delete childProps.onExited;

    if (typeof children === 'function') {
      return children(status, childProps);
    }

    var child = _react.default.Children.only(children);

    return _react.default.cloneElement(child, childProps);
  };

  return Transition;
}(_react.default.Component);

Transition.contextTypes = {
  transitionGroup: PropTypes.object
};
Transition.childContextTypes = {
  transitionGroup: function transitionGroup() {}
};
Transition.propTypes =  false ? {
  /**
   * A `function` child can be used instead of a React element. This function is
   * called with the current transition status (`'entering'`, `'entered'`,
   * `'exiting'`, `'exited'`, `'unmounted'`), which can be used to apply context
   * specific props to a component.
   *
   * ```jsx
   * <Transition in={this.state.in} timeout={150}>
   *   {state => (
   *     <MyComponent className={`fade fade-${state}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,

  /**
   * Show the component; triggers the enter or exit states
   */
  in: PropTypes.bool,

  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: PropTypes.bool,

  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: PropTypes.bool,

  /**
   * Normally a component is not transitioned if it is shown when the `<Transition>` component mounts.
   * If you want to transition on the first mount set `appear` to `true`, and the
   * component will transition in as soon as the `<Transition>` mounts.
   *
   * > Note: there are no specific "appear" states. `appear` only adds an additional `enter` transition.
   */
  appear: PropTypes.bool,

  /**
   * Enable or disable enter transitions.
   */
  enter: PropTypes.bool,

  /**
   * Enable or disable exit transitions.
   */
  exit: PropTypes.bool,

  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided.
   *
   * You may specify a single timeout for all transitions:
   *
   * ```jsx
   * timeout={500}
   * ```
   *
   * or individually:
   *
   * ```jsx
   * timeout={{
   *  appear: 500,
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * - `appear` defaults to the value of `enter`
   * - `enter` defaults to `0`
   * - `exit` defaults to `0`
   *
   * @type {number | { enter?: number, exit?: number, appear?: number }}
   */
  timeout: function timeout(props) {
    var pt = _PropTypes.timeoutsShape;
    if (!props.addEndListener) pt = pt.isRequired;

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return pt.apply(void 0, [props].concat(args));
  },

  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. **Note:** Timeouts are still used as a fallback if provided.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: PropTypes.func,

  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: PropTypes.func,

  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: PropTypes.func,

  /**
   * Callback fired before the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: PropTypes.func,

  /**
   * Callback fired after the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: PropTypes.func,

  /**
   * Callback fired after the "exited" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: PropTypes.func // Name the function so it is clearer in the documentation

} : {};

function noop() {}

Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,
  onEnter: noop,
  onEntering: noop,
  onEntered: noop,
  onExit: noop,
  onExiting: noop,
  onExited: noop
};
Transition.UNMOUNTED = 0;
Transition.EXITED = 1;
Transition.ENTERING = 2;
Transition.ENTERED = 3;
Transition.EXITING = 4;

var _default = (0, _reactLifecyclesCompat.polyfill)(Transition);

exports.default = _default;

/***/ }),
/* 234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "polyfill", function() { return polyfill; });
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function componentWillMount() {
  // Call this.constructor.gDSFP to support sub-classes.
  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
  if (state !== null && state !== undefined) {
    this.setState(state);
  }
}

function componentWillReceiveProps(nextProps) {
  // Call this.constructor.gDSFP to support sub-classes.
  // Use the setState() updater to ensure state isn't stale in certain edge cases.
  function updater(prevState) {
    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
    return state !== null && state !== undefined ? state : null;
  }
  // Binding "this" is important for shallow renderer support.
  this.setState(updater.bind(this));
}

function componentWillUpdate(nextProps, nextState) {
  try {
    var prevProps = this.props;
    var prevState = this.state;
    this.props = nextProps;
    this.state = nextState;
    this.__reactInternalSnapshotFlag = true;
    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      prevProps,
      prevState
    );
  } finally {
    this.props = prevProps;
    this.state = prevState;
  }
}

// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;

function polyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  }

  if (
    typeof Component.getDerivedStateFromProps !== 'function' &&
    typeof prototype.getSnapshotBeforeUpdate !== 'function'
  ) {
    return Component;
  }

  // If new component APIs are defined, "unsafe" lifecycles won't be called.
  // Error if any of these lifecycles are present,
  // Because they would work differently between older and newer (16.3+) versions of React.
  var foundWillMountName = null;
  var foundWillReceivePropsName = null;
  var foundWillUpdateName = null;
  if (typeof prototype.componentWillMount === 'function') {
    foundWillMountName = 'componentWillMount';
  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
    foundWillMountName = 'UNSAFE_componentWillMount';
  }
  if (typeof prototype.componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'componentWillReceiveProps';
  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
  }
  if (typeof prototype.componentWillUpdate === 'function') {
    foundWillUpdateName = 'componentWillUpdate';
  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
  }
  if (
    foundWillMountName !== null ||
    foundWillReceivePropsName !== null ||
    foundWillUpdateName !== null
  ) {
    var componentName = Component.displayName || Component.name;
    var newApiName =
      typeof Component.getDerivedStateFromProps === 'function'
        ? 'getDerivedStateFromProps()'
        : 'getSnapshotBeforeUpdate()';

    throw Error(
      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
        componentName +
        ' uses ' +
        newApiName +
        ' but also contains the following legacy lifecycles:' +
        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
        (foundWillReceivePropsName !== null
          ? '\n  ' + foundWillReceivePropsName
          : '') +
        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
        'https://fb.me/react-async-component-lifecycle-hooks'
    );
  }

  // React <= 16.2 does not support static getDerivedStateFromProps.
  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
  // Newer versions of React will ignore these lifecycles if gDSFP exists.
  if (typeof Component.getDerivedStateFromProps === 'function') {
    prototype.componentWillMount = componentWillMount;
    prototype.componentWillReceiveProps = componentWillReceiveProps;
  }

  // React <= 16.2 does not support getSnapshotBeforeUpdate.
  // As a workaround, use cWU to invoke the new lifecycle.
  // Newer versions of React will ignore that lifecycle if gSBU exists.
  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
    if (typeof prototype.componentDidUpdate !== 'function') {
      throw new Error(
        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
      );
    }

    prototype.componentWillUpdate = componentWillUpdate;

    var componentDidUpdate = prototype.componentDidUpdate;

    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
      prevProps,
      prevState,
      maybeSnapshot
    ) {
      // 16.3+ will not execute our will-update method;
      // It will pass a snapshot value to did-update though.
      // Older versions will require our polyfilled will-update value.
      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
      // Because for <= 15.x versions this might be a "prevContext" object.
      // We also can't just check "__reactInternalSnapshot",
      // Because get-snapshot might return a falsy value.
      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
      var snapshot = this.__reactInternalSnapshotFlag
        ? this.__reactInternalSnapshot
        : maybeSnapshot;

      componentDidUpdate.call(this, prevProps, prevState, snapshot);
    };
  }

  return Component;
}




/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.classNamesShape = exports.timeoutsShape = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(1));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var timeoutsShape =  false ? _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
  enter: _propTypes.default.number,
  exit: _propTypes.default.number,
  appear: _propTypes.default.number
}).isRequired]) : null;
exports.timeoutsShape = timeoutsShape;
var classNamesShape =  false ? _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.shape({
  enter: _propTypes.default.string,
  exit: _propTypes.default.string,
  active: _propTypes.default.string
}), _propTypes.default.shape({
  enter: _propTypes.default.string,
  enterDone: _propTypes.default.string,
  enterActive: _propTypes.default.string,
  exit: _propTypes.default.string,
  exitDone: _propTypes.default.string,
  exitActive: _propTypes.default.string
})]) : null;
exports.classNamesShape = classNamesShape;

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactLifecyclesCompat = __webpack_require__(234);

var _ChildMapping = __webpack_require__(550);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var values = Object.values || function (obj) {
  return Object.keys(obj).map(function (k) {
    return obj[k];
  });
};

var defaultProps = {
  component: 'div',
  childFactory: function childFactory(child) {
    return child;
  }
  /**
   * The `<TransitionGroup>` component manages a set of transition components
   * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
   * components, `<TransitionGroup>` is a state machine for managing the mounting
   * and unmounting of components over time.
   *
   * Consider the example below. As items are removed or added to the TodoList the
   * `in` prop is toggled automatically by the `<TransitionGroup>`.
   *
   * Note that `<TransitionGroup>`  does not define any animation behavior!
   * Exactly _how_ a list item animates is up to the individual transition
   * component. This means you can mix and match animations across different list
   * items.
   */

};

var TransitionGroup =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(TransitionGroup, _React$Component);

  function TransitionGroup(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;

    var handleExited = _this.handleExited.bind(_assertThisInitialized(_assertThisInitialized(_this))); // Initial children should all be entering, dependent on appear


    _this.state = {
      handleExited: handleExited,
      firstRender: true
    };
    return _this;
  }

  var _proto = TransitionGroup.prototype;

  _proto.getChildContext = function getChildContext() {
    return {
      transitionGroup: {
        isMounting: !this.appeared
      }
    };
  };

  _proto.componentDidMount = function componentDidMount() {
    this.appeared = true;
    this.mounted = true;
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.mounted = false;
  };

  TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
    var prevChildMapping = _ref.children,
        handleExited = _ref.handleExited,
        firstRender = _ref.firstRender;
    return {
      children: firstRender ? (0, _ChildMapping.getInitialChildMapping)(nextProps, handleExited) : (0, _ChildMapping.getNextChildMapping)(nextProps, prevChildMapping, handleExited),
      firstRender: false
    };
  };

  _proto.handleExited = function handleExited(child, node) {
    var currentChildMapping = (0, _ChildMapping.getChildMapping)(this.props.children);
    if (child.key in currentChildMapping) return;

    if (child.props.onExited) {
      child.props.onExited(node);
    }

    if (this.mounted) {
      this.setState(function (state) {
        var children = _extends({}, state.children);

        delete children[child.key];
        return {
          children: children
        };
      });
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        Component = _this$props.component,
        childFactory = _this$props.childFactory,
        props = _objectWithoutPropertiesLoose(_this$props, ["component", "childFactory"]);

    var children = values(this.state.children).map(childFactory);
    delete props.appear;
    delete props.enter;
    delete props.exit;

    if (Component === null) {
      return children;
    }

    return _react.default.createElement(Component, props, children);
  };

  return TransitionGroup;
}(_react.default.Component);

TransitionGroup.childContextTypes = {
  transitionGroup: _propTypes.default.object.isRequired
};
TransitionGroup.propTypes =  false ? {
  /**
   * `<TransitionGroup>` renders a `<div>` by default. You can change this
   * behavior by providing a `component` prop.
   * If you use React v16+ and would like to avoid a wrapping `<div>` element
   * you can pass in `component={null}`. This is useful if the wrapping div
   * borks your css styles.
   */
  component: _propTypes.default.any,

  /**
   * A set of `<Transition>` components, that are toggled `in` and out as they
   * leave. the `<TransitionGroup>` will inject specific transition props, so
   * remember to spread them through if you are wrapping the `<Transition>` as
   * with our `<Fade>` example.
   *
   * While this component is meant for multiple `Transition` or `CSSTransition`
   * children, sometimes you may want to have a single transition child with
   * content that you want to be transitioned out and in when you change it
   * (e.g. routes, images etc.) In that case you can change the `key` prop of
   * the transition child as you change its content, this will cause
   * `TransitionGroup` to transition the child out and back in.
   */
  children: _propTypes.default.node,

  /**
   * A convenience prop that enables or disables appear animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  appear: _propTypes.default.bool,

  /**
   * A convenience prop that enables or disables enter animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  enter: _propTypes.default.bool,

  /**
   * A convenience prop that enables or disables exit animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  exit: _propTypes.default.bool,

  /**
   * You may need to apply reactive updates to a child as it is exiting.
   * This is generally done by using `cloneElement` however in the case of an exiting
   * child the element has already been removed and not accessible to the consumer.
   *
   * If you do need to update a child as it leaves you can provide a `childFactory`
   * to wrap every child, even the ones that are leaving.
   *
   * @type Function(child: ReactElement) -> ReactElement
   */
  childFactory: _propTypes.default.func
} : {};
TransitionGroup.defaultProps = defaultProps;

var _default = (0, _reactLifecyclesCompat.polyfill)(TransitionGroup);

exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NoStyleLink; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(15);
var _templateObject=_taggedTemplateLiteral(['\n  color: inherit;\n  text-transform: inherit;\n  text-decoration: inherit;\n  font-weight: inherit;\n  font-size: inherit;\n  transition: opacity 250ms ease-out;\n\n  &:hover {\n    opacity: 0.7;\n  }\n'],['\n  color: inherit;\n  text-transform: inherit;\n  text-decoration: inherit;\n  font-weight: inherit;\n  font-size: inherit;\n  transition: opacity 250ms ease-out;\n\n  &:hover {\n    opacity: 0.7;\n  }\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var NoStyleLink=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* Link */])(_templateObject);

/***/ }),
/* 238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CHECKOUT_PAGE_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CAMPAIGN_LIST_PAGE_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return PRODUCT_LIST_PAGE_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CAMPAIGN_PAGE_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return NEWSLETTER_PAGE_TYPE; });
var CHECKOUT_PAGE_TYPE='CheckOut';var CAMPAIGN_LIST_PAGE_TYPE='CampaignListPage';var PRODUCT_LIST_PAGE_TYPE='ProductListPage';var CAMPAIGN_PAGE_TYPE='CampaignPage';var NEWSLETTER_PAGE_TYPE='NewsletterSignupPage';

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('./syntax')} */
module.exports = SyntaxError;


/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(84);

var $gOPD = GetIntrinsic('%Object.getOwnPropertyDescriptor%', true);

if ($gOPD) {
	try {
		$gOPD([], 'length');
	} catch (e) {
		// IE 8 has a broken gOPD
		$gOPD = null;
	}
}

module.exports = $gOPD;


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var formats = __webpack_require__(157);

var has = Object.prototype.hasOwnProperty;
var isArray = Array.isArray;

var hexTable = (function () {
    var array = [];
    for (var i = 0; i < 256; ++i) {
        array.push('%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase());
    }

    return array;
}());

var compactQueue = function compactQueue(queue) {
    while (queue.length > 1) {
        var item = queue.pop();
        var obj = item.obj[item.prop];

        if (isArray(obj)) {
            var compacted = [];

            for (var j = 0; j < obj.length; ++j) {
                if (typeof obj[j] !== 'undefined') {
                    compacted.push(obj[j]);
                }
            }

            item.obj[item.prop] = compacted;
        }
    }
};

var arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? Object.create(null) : {};
    for (var i = 0; i < source.length; ++i) {
        if (typeof source[i] !== 'undefined') {
            obj[i] = source[i];
        }
    }

    return obj;
};

var merge = function merge(target, source, options) {
    /* eslint no-param-reassign: 0 */
    if (!source) {
        return target;
    }

    if (typeof source !== 'object') {
        if (isArray(target)) {
            target.push(source);
        } else if (target && typeof target === 'object') {
            if ((options && (options.plainObjects || options.allowPrototypes)) || !has.call(Object.prototype, source)) {
                target[source] = true;
            }
        } else {
            return [target, source];
        }

        return target;
    }

    if (!target || typeof target !== 'object') {
        return [target].concat(source);
    }

    var mergeTarget = target;
    if (isArray(target) && !isArray(source)) {
        mergeTarget = arrayToObject(target, options);
    }

    if (isArray(target) && isArray(source)) {
        source.forEach(function (item, i) {
            if (has.call(target, i)) {
                var targetItem = target[i];
                if (targetItem && typeof targetItem === 'object' && item && typeof item === 'object') {
                    target[i] = merge(targetItem, item, options);
                } else {
                    target.push(item);
                }
            } else {
                target[i] = item;
            }
        });
        return target;
    }

    return Object.keys(source).reduce(function (acc, key) {
        var value = source[key];

        if (has.call(acc, key)) {
            acc[key] = merge(acc[key], value, options);
        } else {
            acc[key] = value;
        }
        return acc;
    }, mergeTarget);
};

var assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function (acc, key) {
        acc[key] = source[key];
        return acc;
    }, target);
};

var decode = function (str, decoder, charset) {
    var strWithoutPlus = str.replace(/\+/g, ' ');
    if (charset === 'iso-8859-1') {
        // unescape never throws, no try...catch needed:
        return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
    }
    // utf-8
    try {
        return decodeURIComponent(strWithoutPlus);
    } catch (e) {
        return strWithoutPlus;
    }
};

var limit = 1024;

/* eslint operator-linebreak: [2, "before"] */

var encode = function encode(str, defaultEncoder, charset, kind, format) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) {
        return str;
    }

    var string = str;
    if (typeof str === 'symbol') {
        string = Symbol.prototype.toString.call(str);
    } else if (typeof str !== 'string') {
        string = String(str);
    }

    if (charset === 'iso-8859-1') {
        return escape(string).replace(/%u[0-9a-f]{4}/gi, function ($0) {
            return '%26%23' + parseInt($0.slice(2), 16) + '%3B';
        });
    }

    var out = '';
    for (var j = 0; j < string.length; j += limit) {
        var segment = string.length >= limit ? string.slice(j, j + limit) : string;
        var arr = [];

        for (var i = 0; i < segment.length; ++i) {
            var c = segment.charCodeAt(i);
            if (
                c === 0x2D // -
                || c === 0x2E // .
                || c === 0x5F // _
                || c === 0x7E // ~
                || (c >= 0x30 && c <= 0x39) // 0-9
                || (c >= 0x41 && c <= 0x5A) // a-z
                || (c >= 0x61 && c <= 0x7A) // A-Z
                || (format === formats.RFC1738 && (c === 0x28 || c === 0x29)) // ( )
            ) {
                arr[arr.length] = segment.charAt(i);
                continue;
            }

            if (c < 0x80) {
                arr[arr.length] = hexTable[c];
                continue;
            }

            if (c < 0x800) {
                arr[arr.length] = hexTable[0xC0 | (c >> 6)]
                    + hexTable[0x80 | (c & 0x3F)];
                continue;
            }

            if (c < 0xD800 || c >= 0xE000) {
                arr[arr.length] = hexTable[0xE0 | (c >> 12)]
                    + hexTable[0x80 | ((c >> 6) & 0x3F)]
                    + hexTable[0x80 | (c & 0x3F)];
                continue;
            }

            i += 1;
            c = 0x10000 + (((c & 0x3FF) << 10) | (segment.charCodeAt(i) & 0x3FF));

            arr[arr.length] = hexTable[0xF0 | (c >> 18)]
                + hexTable[0x80 | ((c >> 12) & 0x3F)]
                + hexTable[0x80 | ((c >> 6) & 0x3F)]
                + hexTable[0x80 | (c & 0x3F)];
        }

        out += arr.join('');
    }

    return out;
};

var compact = function compact(value) {
    var queue = [{ obj: { o: value }, prop: 'o' }];
    var refs = [];

    for (var i = 0; i < queue.length; ++i) {
        var item = queue[i];
        var obj = item.obj[item.prop];

        var keys = Object.keys(obj);
        for (var j = 0; j < keys.length; ++j) {
            var key = keys[j];
            var val = obj[key];
            if (typeof val === 'object' && val !== null && refs.indexOf(val) === -1) {
                queue.push({ obj: obj, prop: key });
                refs.push(val);
            }
        }
    }

    compactQueue(queue);

    return value;
};

var isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === '[object RegExp]';
};

var isBuffer = function isBuffer(obj) {
    if (!obj || typeof obj !== 'object') {
        return false;
    }

    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};

var combine = function combine(a, b) {
    return [].concat(a, b);
};

var maybeMap = function maybeMap(val, fn) {
    if (isArray(val)) {
        var mapped = [];
        for (var i = 0; i < val.length; i += 1) {
            mapped.push(fn(val[i]));
        }
        return mapped;
    }
    return fn(val);
};

module.exports = {
    arrayToObject: arrayToObject,
    assign: assign,
    combine: combine,
    compact: compact,
    decode: decode,
    encode: encode,
    isBuffer: isBuffer,
    isRegExp: isRegExp,
    maybeMap: maybeMap,
    merge: merge
};


/***/ }),
/* 242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_helpers_variables__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_helpers_animations__ = __webpack_require__(81);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  position: fixed;\n  top: ',';\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 200;\n  pointer-events: ',';\n\n  ','\n'],['\n  position: fixed;\n  top: ',';\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 200;\n  pointer-events: ',';\n\n  ','\n']),_templateObject2=_taggedTemplateLiteral(['\n  height: 44px;\n  width: 44px;\n  position: absolute;\n  top: 0;\n  right: 0;\n  border: none;\n  background-color: transparent;\n  background-image: url(\'/images/icons/close.svg\');\n  background-position: center;\n  background-repeat: no-repeat;\n  cursor: pointer;\n  background-size: 14px;\n  font-size: 20px;\n'],['\n  height: 44px;\n  width: 44px;\n  position: absolute;\n  top: 0;\n  right: 0;\n  border: none;\n  background-color: transparent;\n  background-image: url(\'/images/icons/close.svg\');\n  background-position: center;\n  background-repeat: no-repeat;\n  cursor: pointer;\n  background-size: 14px;\n  font-size: 20px;\n']),_templateObject3=_taggedTemplateLiteral(['\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background-color: ',';\n  transition: opacity 0.8s linear;\n  opacity: 0.2;\n  cursor: inherit;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n'],['\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background-color: ',';\n  transition: opacity 0.8s linear;\n  opacity: 0.2;\n  cursor: inherit;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n']),_templateObject4=_taggedTemplateLiteral(['\n  height: 100vh;\n  width: 85vw;\n  max-width: 400px;\n  position: absolute;\n  top: 0;\n  right: 0;\n  background-color: ',';\n  padding: ',';\n  overflow-y: auto;\n  -webkit-overflow-scrolling: touch;\n  box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0);\n\n  @media screen and (min-width: ','px) {\n    max-width: 560px;\n    padding: 42px 37px 26px 45px;\n  }\n\n  ','\n\n  ',';\n\n  ',';\n\n  ',';\n\n  ',';\n'],['\n  height: 100vh;\n  width: 85vw;\n  max-width: 400px;\n  position: absolute;\n  top: 0;\n  right: 0;\n  background-color: ',';\n  padding: ',';\n  overflow-y: auto;\n  -webkit-overflow-scrolling: touch;\n  box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0);\n\n  @media screen and (min-width: ','px) {\n    max-width: 560px;\n    padding: 42px 37px 26px 45px;\n  }\n\n  ','\n\n  ',';\n\n  ',';\n\n  ',';\n\n  ',';\n']),_templateObject5=_taggedTemplateLiteral(['\n      right: initial;\n      left: 0;\n    '],['\n      right: initial;\n      left: 0;\n    ']),_templateObject6=_taggedTemplateLiteral(['\n      box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.15);\n    '],['\n      box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.15);\n    ']),_templateObject7=_taggedTemplateLiteral(['\n      display: flex;\n      flex-direction: column;\n      justify-content: flex-start;\n    '],['\n      display: flex;\n      flex-direction: column;\n      justify-content: flex-start;\n    ']),_templateObject8=_taggedTemplateLiteral(['\n      padding: 0 !important;\n    '],['\n      padding: 0 !important;\n    ']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SlideOutContainer=function(_PureComponent){_inherits(SlideOutContainer,_PureComponent);function SlideOutContainer(props){_classCallCheck(this,SlideOutContainer);var _this=_possibleConstructorReturn(this,(SlideOutContainer.__proto__||Object.getPrototypeOf(SlideOutContainer)).call(this,props));_this.state={isOpen:false,scrollPosition:false};return _this;}_createClass(SlideOutContainer,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(this.props.active===false&&nextProps.active===true){this.setState({scrollPosition:window.pageYOffset});this.activate(window.pageYOffset);}else if(this.props.active===true&&nextProps.active===false){this.deactivate(this.state.scrollPosition);}}},{key:'activate',value:function activate(scrollPosition){document.body.style.position='fixed';document.body.style.left=0;document.body.style.right=0;document.body.style.top='-'+scrollPosition+'px';document.body.style.overflowY='scroll';this.setState({isOpen:true});}},{key:'deactivate',value:function deactivate(scrollPosition){this.setState({isOpen:false});document.body.removeAttribute('style');window.scrollTo(0,scrollPosition);}},{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Container,{active:this.props.active,top:this.props.top,small:this.props.small&&!this.state.scrollPosition},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles_helpers_animations__["b" /* FadeIn */],{'in':this.state.isOpen},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Overlay,{onClick:function onClick(){return _this2.props.toggleModal(false);},active:this.props.active})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles_helpers_animations__["g" /* SlideIn */],{'in':this.state.isOpen,translateX:this.props.fromLeft?'-100%':'100%',small:this.props.small&&!this.state.scrollPosition},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SlideOut,{fromLeft:this.props.fromLeft,bgColor:this.props.bgColor,small:this.props.small,notScrolled:!this.state.scrollPosition,noPadding:this.props.noPadding},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CloseButton,{onClick:function onClick(){return _this2.props.toggleModal(false);}}),this.props.children)));}}]);return SlideOutContainer;}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);var Container=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject,function(props){return props.top?props.top+'px':0;},function(props){return props.active?'auto':'none';},''/* ${props =>
    props.small &&
    css`
      top: ${header.logoAreaMobileHeight - 1}px;

      @media screen and (min-width: ${size.xLarge}px) {
        top: ${header.logoAreaDesktopHeight - 1}px;
      }
    `}; */);var CloseButton=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].button(_templateObject2);var Overlay=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject3,__WEBPACK_IMPORTED_MODULE_3__styles_helpers_variables__["c" /* color */].black);var SlideOut=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject4,function(props){return props.bgColor?props.bgColor:__WEBPACK_IMPORTED_MODULE_3__styles_helpers_variables__["c" /* color */].white;},function(props){return props.small?'20px 15px 126px 22px':'26px 30px 126px 22px';},__WEBPACK_IMPORTED_MODULE_3__styles_helpers_variables__["f" /* size */].xLarge,''/* ${props =>
    props.notScrolled &&
    props.small &&
    css`
      height: calc(100vh - ${header.logoAreaMobileHeight - 1}px);

      @media screen and (min-width: ${size.xLarge}px) {
        height: calc(100vh - ${header.logoAreaDesktopHeight - 1}px);
      }
    `}; */,function(props){return props.fromLeft&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject5);},function(props){return props.active&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject6);},function(props){return props.small&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject7);},function(props){return props.noPadding&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject8);});SlideOutContainer.defaultProps={active:false,fromLeft:false,top:null,small:false,bgColor:null,noPadding:false,toggleModal:function toggleModal(){}};SlideOutContainer.propTypes={top:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,small:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,bgColor:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,noPadding:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,active:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,toggleModal:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,fromLeft:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,children:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node),__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node]).isRequired};/* harmony default export */ __webpack_exports__["a"] = (SlideOutContainer);

/***/ }),
/* 243 */
/***/ (function(module, exports) {

exports.__esModule = true;
var ATTRIBUTE_NAMES = exports.ATTRIBUTE_NAMES = {
    BODY: "bodyAttributes",
    HTML: "htmlAttributes",
    TITLE: "titleAttributes"
};

var TAG_NAMES = exports.TAG_NAMES = {
    BASE: "base",
    BODY: "body",
    HEAD: "head",
    HTML: "html",
    LINK: "link",
    META: "meta",
    NOSCRIPT: "noscript",
    SCRIPT: "script",
    STYLE: "style",
    TITLE: "title"
};

var VALID_TAG_NAMES = exports.VALID_TAG_NAMES = Object.keys(TAG_NAMES).map(function (name) {
    return TAG_NAMES[name];
});

var TAG_PROPERTIES = exports.TAG_PROPERTIES = {
    CHARSET: "charset",
    CSS_TEXT: "cssText",
    HREF: "href",
    HTTPEQUIV: "http-equiv",
    INNER_HTML: "innerHTML",
    ITEM_PROP: "itemprop",
    NAME: "name",
    PROPERTY: "property",
    REL: "rel",
    SRC: "src"
};

var REACT_TAG_MAP = exports.REACT_TAG_MAP = {
    accesskey: "accessKey",
    charset: "charSet",
    class: "className",
    contenteditable: "contentEditable",
    contextmenu: "contextMenu",
    "http-equiv": "httpEquiv",
    itemprop: "itemProp",
    tabindex: "tabIndex"
};

var HELMET_PROPS = exports.HELMET_PROPS = {
    DEFAULT_TITLE: "defaultTitle",
    DEFER: "defer",
    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
    TITLE_TEMPLATE: "titleTemplate"
};

var HTML_TAG_MAP = exports.HTML_TAG_MAP = Object.keys(REACT_TAG_MAP).reduce(function (obj, key) {
    obj[REACT_TAG_MAP[key]] = key;
    return obj;
}, {});

var SELF_CLOSING_TAGS = exports.SELF_CLOSING_TAGS = [TAG_NAMES.NOSCRIPT, TAG_NAMES.SCRIPT, TAG_NAMES.STYLE];

var HELMET_ATTRIBUTE = exports.HELMET_ATTRIBUTE = "data-react-helmet";

/***/ }),
/* 244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Cookies__ = __webpack_require__(245);
/* unused harmony reexport Cookies */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CookiesProvider__ = __webpack_require__(598);
/* unused harmony reexport CookiesProvider */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__withCookies__ = __webpack_require__(599);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__withCookies__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__useCookies__ = __webpack_require__(600);
/* unused harmony reexport useCookies */






/***/ }),
/* 245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_universal_cookie__ = __webpack_require__(246);

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_universal_cookie__["a" /* default */]);


/***/ }),
/* 246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Cookies__ = __webpack_require__(596);

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__Cookies__["a" /* default */]);


/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*!
 * cookie
 * Copyright(c) 2012-2014 Roman Shtylman
 * Copyright(c) 2015 Douglas Christopher Wilson
 * MIT Licensed
 */



/**
 * Module exports.
 * @public
 */

exports.parse = parse;
exports.serialize = serialize;

/**
 * Module variables.
 * @private
 */

var decode = decodeURIComponent;
var encode = encodeURIComponent;
var pairSplitRegExp = /; */;

/**
 * RegExp to match field-content in RFC 7230 sec 3.2
 *
 * field-content = field-vchar [ 1*( SP / HTAB ) field-vchar ]
 * field-vchar   = VCHAR / obs-text
 * obs-text      = %x80-FF
 */

var fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;

/**
 * Parse a cookie header.
 *
 * Parse the given cookie header string into an object
 * The object has the various cookies as keys(names) => values
 *
 * @param {string} str
 * @param {object} [options]
 * @return {object}
 * @public
 */

function parse(str, options) {
  if (typeof str !== 'string') {
    throw new TypeError('argument str must be a string');
  }

  var obj = {}
  var opt = options || {};
  var pairs = str.split(pairSplitRegExp);
  var dec = opt.decode || decode;

  for (var i = 0; i < pairs.length; i++) {
    var pair = pairs[i];
    var eq_idx = pair.indexOf('=');

    // skip things that don't look like key=value
    if (eq_idx < 0) {
      continue;
    }

    var key = pair.substr(0, eq_idx).trim()
    var val = pair.substr(++eq_idx, pair.length).trim();

    // quoted values
    if ('"' == val[0]) {
      val = val.slice(1, -1);
    }

    // only assign once
    if (undefined == obj[key]) {
      obj[key] = tryDecode(val, dec);
    }
  }

  return obj;
}

/**
 * Serialize data into a cookie header.
 *
 * Serialize the a name value pair into a cookie string suitable for
 * http headers. An optional options object specified cookie parameters.
 *
 * serialize('foo', 'bar', { httpOnly: true })
 *   => "foo=bar; httpOnly"
 *
 * @param {string} name
 * @param {string} val
 * @param {object} [options]
 * @return {string}
 * @public
 */

function serialize(name, val, options) {
  var opt = options || {};
  var enc = opt.encode || encode;

  if (typeof enc !== 'function') {
    throw new TypeError('option encode is invalid');
  }

  if (!fieldContentRegExp.test(name)) {
    throw new TypeError('argument name is invalid');
  }

  var value = enc(val);

  if (value && !fieldContentRegExp.test(value)) {
    throw new TypeError('argument val is invalid');
  }

  var str = name + '=' + value;

  if (null != opt.maxAge) {
    var maxAge = opt.maxAge - 0;
    if (isNaN(maxAge)) throw new Error('maxAge should be a Number');
    str += '; Max-Age=' + Math.floor(maxAge);
  }

  if (opt.domain) {
    if (!fieldContentRegExp.test(opt.domain)) {
      throw new TypeError('option domain is invalid');
    }

    str += '; Domain=' + opt.domain;
  }

  if (opt.path) {
    if (!fieldContentRegExp.test(opt.path)) {
      throw new TypeError('option path is invalid');
    }

    str += '; Path=' + opt.path;
  }

  if (opt.expires) {
    if (typeof opt.expires.toUTCString !== 'function') {
      throw new TypeError('option expires is invalid');
    }

    str += '; Expires=' + opt.expires.toUTCString();
  }

  if (opt.httpOnly) {
    str += '; HttpOnly';
  }

  if (opt.secure) {
    str += '; Secure';
  }

  if (opt.sameSite) {
    var sameSite = typeof opt.sameSite === 'string'
      ? opt.sameSite.toLowerCase() : opt.sameSite;

    switch (sameSite) {
      case true:
        str += '; SameSite=Strict';
        break;
      case 'lax':
        str += '; SameSite=Lax';
        break;
      case 'strict':
        str += '; SameSite=Strict';
        break;
      default:
        throw new TypeError('option sameSite is invalid');
    }
  }

  return str;
}

/**
 * Try decoding a string using a decoding function.
 *
 * @param {string} str
 * @param {function} decode
 * @private
 */

function tryDecode(str, decode) {
  try {
    return decode(str);
  } catch (e) {
    return str;
  }
}


/***/ }),
/* 248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_helpers_mixins__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants_status__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_generalApi__ = __webpack_require__(85);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  width: 100%;\n'],['\n  width: 100%;\n']),_templateObject2=_taggedTemplateLiteral(['\n  width: 100%;\n  display: flex;\n'],['\n  width: 100%;\n  display: flex;\n']),_templateObject3=_taggedTemplateLiteral(['\n  ',';\n  width: 100%;\n  height: 40px;\n  background-color: #343434;\n  border: solid 1px #343434;\n  font-size: 16px;\n  font-weight: normal;\n  font-stretch: normal;\n  font-style: italic;\n  line-height: 1.57;\n  letter-spacing: normal;\n  color: #fff;\n  padding-left: 14px;\n  border-radius: 0;\n  box-shadow: none;\n  -webkit-appearance: none;\n\n  &:focus {\n    outline: 0;\n    border-color: #9e9e9e;\n  }\n\n  &::placeholder {\n    color: #b8b8b8;\n  }\n\n  @media screen and (min-width: 680px) {\n    font-size: 14px;\n  }\n'],['\n  ',';\n  width: 100%;\n  height: 40px;\n  background-color: #343434;\n  border: solid 1px #343434;\n  font-size: 16px;\n  font-weight: normal;\n  font-stretch: normal;\n  font-style: italic;\n  line-height: 1.57;\n  letter-spacing: normal;\n  color: #fff;\n  padding-left: 14px;\n  border-radius: 0;\n  box-shadow: none;\n  -webkit-appearance: none;\n\n  &:focus {\n    outline: 0;\n    border-color: #9e9e9e;\n  }\n\n  &::placeholder {\n    color: #b8b8b8;\n  }\n\n  @media screen and (min-width: 680px) {\n    font-size: 14px;\n  }\n']),_templateObject4=_taggedTemplateLiteral(['\n  display: block;\n  position: relative;\n  padding-left: 24px;\n  cursor: pointer;\n  user-select: none;\n  margin: 14px 0 0;\n\n  p {\n    margin: 0;\n    ',';\n    font-size: 12px;\n    font-weight: normal;\n    font-stretch: normal;\n    font-style: italic;\n    line-height: 1.25;\n    letter-spacing: normal;\n    color: ',';\n\n    a {\n      color: ',';\n\n      &:hover {\n        color: ',';\n      }\n    }\n  }\n\n  /* Hide the browser\'s default checkbox */\n  input {\n    position: absolute;\n    opacity: 0;\n    cursor: pointer;\n    height: 0;\n    width: 0;\n  }\n\n  /* Create a custom checkbox */\n  .checkmark {\n    position: absolute;\n    top: 0;\n    left: 0;\n    height: 16px;\n    width: 16px;\n    border: solid 1px ',';\n    background-color: ',';\n\n    /* Create the checkmark/indicator (hidden when not checked) */\n    &:after {\n      content: \'\';\n      position: absolute;\n      display: none;\n      left: 3px;\n      top: 3px;\n      width: 8px;\n      height: 8px;\n      background-color: ',';\n    }\n  }\n\n  /* Show the checkmark when checked */\n  input:checked ~ .checkmark:after {\n    display: block;\n  }\n'],['\n  display: block;\n  position: relative;\n  padding-left: 24px;\n  cursor: pointer;\n  user-select: none;\n  margin: 14px 0 0;\n\n  p {\n    margin: 0;\n    ',';\n    font-size: 12px;\n    font-weight: normal;\n    font-stretch: normal;\n    font-style: italic;\n    line-height: 1.25;\n    letter-spacing: normal;\n    color: ',';\n\n    a {\n      color: ',';\n\n      &:hover {\n        color: ',';\n      }\n    }\n  }\n\n  /* Hide the browser\'s default checkbox */\n  input {\n    position: absolute;\n    opacity: 0;\n    cursor: pointer;\n    height: 0;\n    width: 0;\n  }\n\n  /* Create a custom checkbox */\n  .checkmark {\n    position: absolute;\n    top: 0;\n    left: 0;\n    height: 16px;\n    width: 16px;\n    border: solid 1px ',';\n    background-color: ',';\n\n    /* Create the checkmark/indicator (hidden when not checked) */\n    &:after {\n      content: \'\';\n      position: absolute;\n      display: none;\n      left: 3px;\n      top: 3px;\n      width: 8px;\n      height: 8px;\n      background-color: ',';\n    }\n  }\n\n  /* Show the checkmark when checked */\n  input:checked ~ .checkmark:after {\n    display: block;\n  }\n']),_templateObject5=_taggedTemplateLiteral(['\n  min-width: 40px;\n  height: 40px;\n  border: solid 1px #ffffff;\n  background-color: #343434;\n  color: white;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0;\n\n  &:focus {\n    outline: 0;\n  }\n\n  &:disabled {\n    cursor: default;\n    opacity: 0.25;\n  }\n'],['\n  min-width: 40px;\n  height: 40px;\n  border: solid 1px #ffffff;\n  background-color: #343434;\n  color: white;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0;\n\n  &:focus {\n    outline: 0;\n  }\n\n  &:disabled {\n    cursor: default;\n    opacity: 0.25;\n  }\n']),_templateObject6=_taggedTemplateLiteral(['\n  height: 12px;\n  width: 12px;\n  transform: rotateZ(-90deg);\n'],['\n  height: 12px;\n  width: 12px;\n  transform: rotateZ(-90deg);\n']),_templateObject7=_taggedTemplateLiteral(['\n  border: solid 1px #c5c5c5;\n  background-color: #f2f2f2;\n  font-size: 16px;\n  padding: 15px;\n  width: 100%;\n  margin: 0 0 10px;\n'],['\n  border: solid 1px #c5c5c5;\n  background-color: #f2f2f2;\n  font-size: 16px;\n  padding: 15px;\n  width: 100%;\n  margin: 0 0 10px;\n']),_templateObject8=_taggedTemplateLiteral(['\n  ',';\n  font-size: 12px;\n  font-weight: 600;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: normal;\n  letter-spacing: 1.5px;\n  text-align: center;\n  color: #ffffff;\n  text-transform: uppercase;\n  width: 100%;\n  background-color: #779182;\n  border: none;\n  padding: 17px;\n  margin: 0;\n  transition: opacity 0.25s ease;\n  cursor: pointer;\n\n  ',';\n\n  &:disabled {\n    opacity: 1;\n    cursor: default;\n  }\n'],['\n  ',';\n  font-size: 12px;\n  font-weight: 600;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: normal;\n  letter-spacing: 1.5px;\n  text-align: center;\n  color: #ffffff;\n  text-transform: uppercase;\n  width: 100%;\n  background-color: #779182;\n  border: none;\n  padding: 17px;\n  margin: 0;\n  transition: opacity 0.25s ease;\n  cursor: pointer;\n\n  ',';\n\n  &:disabled {\n    opacity: 1;\n    cursor: default;\n  }\n']),_templateObject9=_taggedTemplateLiteral(['\n    opacity: .8;\n  '],['\n    opacity: .8;\n  ']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var NewsletterSignUpForm=function(_Component){_inherits(NewsletterSignUpForm,_Component);function NewsletterSignUpForm(props){_classCallCheck(this,NewsletterSignUpForm);var _this=_possibleConstructorReturn(this,(NewsletterSignUpForm.__proto__||Object.getPrototypeOf(NewsletterSignUpForm)).call(this,props));_this.state={email:'',consent:false};_this.timeoutLength=8000;_this.inputHandlerEmail=_this.inputHandlerEmail.bind(_this);_this.inputHandlerConsent=_this.inputHandlerConsent.bind(_this);_this.formHandler=_this.formHandler.bind(_this);return _this;}_createClass(NewsletterSignUpForm,[{key:'inputHandlerEmail',value:function inputHandlerEmail(event){this.setState({email:event.target.value});}},{key:'inputHandlerConsent',value:function inputHandlerConsent(event){this.setState({consent:event.target.checked});}},{key:'formHandler',value:function formHandler(event){var _this2=this;var _props=this.props,onUpdateStatus=_props.onUpdateStatus,onClose=_props.onClose;var _state=this.state,email=_state.email,consent=_state.consent;event.preventDefault();if(email&&consent){onUpdateStatus(__WEBPACK_IMPORTED_MODULE_4__constants_status__["d" /* LOADING */]);__WEBPACK_IMPORTED_MODULE_5__api_generalApi__["a" /* axiosSingleton */].post('/newsletter',{email:email,source:'modal'}).then(function(){onUpdateStatus(__WEBPACK_IMPORTED_MODULE_4__constants_status__["f" /* SUCCESS */]);setTimeout(function(){onClose();},_this2.timeoutLength);}).catch(function(error){onUpdateStatus(__WEBPACK_IMPORTED_MODULE_4__constants_status__["b" /* FAILURE */]);setTimeout(function(){onUpdateStatus(__WEBPACK_IMPORTED_MODULE_4__constants_status__["c" /* INITIAL */]);_this2.setState({email:'',consent:false});},_this2.timeoutLength);throw error;});}}},{key:'render',value:function render(){var _state2=this.state,email=_state2.email,consent=_state2.consent;var _props2=this.props,buttonText=_props2.buttonText,placeholder=_props2.placeholder,privacyPolicy=_props2.privacyPolicy;// if any required data is missing, don't render the widget
if(!privacyPolicy)return null;if(buttonText){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Form,{onSubmit:this.formHandler},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(EmailInput,{name:'email',type:'email',autoComplete:'off',required:true,placeholder:placeholder,onChange:this.inputHandlerEmail}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SubmitButton,{disabled:!email||!consent},buttonText),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Checkbox,{lightTheme:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{dangerouslySetInnerHTML:{__html:privacyPolicy}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',name:'consent',required:true,onChange:this.inputHandlerConsent}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'checkmark'})));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Form,{onSubmit:this.formHandler},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(InputContainer,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Input,{name:'email',type:'email',autoComplete:'off',required:true,placeholder:placeholder,onChange:this.inputHandlerEmail}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FormSubmit,{disabled:!email||!consent},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SubmitIcon,{src:'/images/icons/arrow-white.svg'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(InputContainer,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Checkbox,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{dangerouslySetInnerHTML:{__html:privacyPolicy}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',name:'consent',required:true,onChange:this.inputHandlerConsent}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'checkmark'}))));}}]);return NewsletterSignUpForm;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);NewsletterSignUpForm.defaultProps={onClose:function onClose(){},onUpdateStatus:function onUpdateStatus(){},placeholder:'',privacyPolicy:undefined,buttonText:undefined};NewsletterSignUpForm.propTypes={onClose:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onUpdateStatus:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,placeholder:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,privacyPolicy:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,buttonText:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (NewsletterSignUpForm);/*
  STYLES
*/var Form=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].form(_templateObject);var InputContainer=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].div(_templateObject2);var Input=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].input(_templateObject3,__WEBPACK_IMPORTED_MODULE_3__styles_helpers_mixins__["d" /* fontFamilyBody */]);var Checkbox=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].label(_templateObject4,__WEBPACK_IMPORTED_MODULE_3__styles_helpers_mixins__["d" /* fontFamilyBody */],function(props){return props.lightTheme?'#6a6a6a':'#9e9e9e';},function(props){return props.lightTheme?'#6a6a6a':'#9e9e9e';},function(props){return props.lightTheme?'#000':'#fff';},function(props){return props.lightTheme?'#9e9e9e':'#9e9e9e';},function(props){return props.lightTheme?'#f2f2f2':'#1f1f1f';},function(props){return props.lightTheme?'#779182':'#fff';});var FormSubmit=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].button(_templateObject5);var SubmitIcon=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].img(_templateObject6);var EmailInput=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].input(_templateObject7);var SubmitButton=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].button(_templateObject8,__WEBPACK_IMPORTED_MODULE_3__styles_helpers_mixins__["d" /* fontFamilyBody */],Object(__WEBPACK_IMPORTED_MODULE_3__styles_helpers_mixins__["g" /* hover */])(_templateObject9));

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(35);
var settle = __webpack_require__(607);
var buildURL = __webpack_require__(609);
var parseHeaders = __webpack_require__(610);
var isURLSameOrigin = __webpack_require__(611);
var createError = __webpack_require__(251);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request.onreadystatechange = function handleLoad() {
      if (!request || request.readyState !== 4) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__(612);

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ?
          cookies.read(config.xsrfCookieName) :
          undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (config.withCredentials) {
      request.withCredentials = true;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(608);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),
/* 254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var Truncate = function (_Component) {
    _inherits(Truncate, _Component);

    function Truncate() {
        var _ref;

        _classCallCheck(this, Truncate);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        var _this = _possibleConstructorReturn(this, (_ref = Truncate.__proto__ || Object.getPrototypeOf(Truncate)).call.apply(_ref, [this].concat(args)));

        _this.state = {};
        _this.styles = {
            ellipsis: {
                position: 'fixed',
                visibility: 'hidden',
                top: 0,
                left: 0
            }
        };


        _this.elements = {};

        _this.onResize = _this.onResize.bind(_this);
        _this.onTruncate = _this.onTruncate.bind(_this);
        _this.calcTargetWidth = _this.calcTargetWidth.bind(_this);
        _this.measureWidth = _this.measureWidth.bind(_this);
        _this.getLines = _this.getLines.bind(_this);
        _this.renderLine = _this.renderLine.bind(_this);
        return _this;
    }

    _createClass(Truncate, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var text = this.elements.text,
                calcTargetWidth = this.calcTargetWidth,
                onResize = this.onResize;


            var canvas = document.createElement('canvas');
            this.canvasContext = canvas.getContext('2d');

            calcTargetWidth(function () {
                // Node not needed in document tree to read its content
                if (text) {
                    text.parentNode.removeChild(text);
                }
            });

            window.addEventListener('resize', onResize);
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps) {
            // Render was based on outdated refs and needs to be rerun
            if (this.props.children !== prevProps.children) {
                this.forceUpdate();
            }

            // If the width prop has changed, recalculate size of contents
            if (this.props.width !== prevProps.width) {
                this.calcTargetWidth();
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            var ellipsis = this.elements.ellipsis,
                onResize = this.onResize,
                timeout = this.timeout;


            ellipsis.parentNode.removeChild(ellipsis);

            window.removeEventListener('resize', onResize);

            window.cancelAnimationFrame(timeout);
        }

        // Shim innerText to consistently break lines at <br/> but not at \n

    }, {
        key: 'innerText',
        value: function innerText(node) {
            var div = document.createElement('div');
            var contentKey = 'innerText' in window.HTMLElement.prototype ? 'innerText' : 'textContent';

            div.innerHTML = node.innerHTML.replace(/\r\n|\r|\n/g, ' ');

            var text = div[contentKey];

            var test = document.createElement('div');
            test.innerHTML = 'foo<br/>bar';

            if (test[contentKey].replace(/\r\n|\r/g, '\n') !== 'foo\nbar') {
                div.innerHTML = div.innerHTML.replace(/<br.*?[\/]?>/gi, '\n');
                text = div[contentKey];
            }

            return text;
        }
    }, {
        key: 'onResize',
        value: function onResize() {
            this.calcTargetWidth();
        }
    }, {
        key: 'onTruncate',
        value: function onTruncate(didTruncate) {
            var onTruncate = this.props.onTruncate;


            if (typeof onTruncate === 'function') {
                this.timeout = window.requestAnimationFrame(function () {
                    onTruncate(didTruncate);
                });
            }
        }
    }, {
        key: 'calcTargetWidth',
        value: function calcTargetWidth(callback) {
            var target = this.elements.target,
                calcTargetWidth = this.calcTargetWidth,
                canvasContext = this.canvasContext,
                width = this.props.width;

            // Calculation is no longer relevant, since node has been removed

            if (!target) {
                return;
            }

            var targetWidth = width ||
            // Floor the result to deal with browser subpixel precision
            Math.floor(target.parentNode.getBoundingClientRect().width);

            // Delay calculation until parent node is inserted to the document
            // Mounting order in React is ChildComponent, ParentComponent
            if (!targetWidth) {
                return window.requestAnimationFrame(function () {
                    return calcTargetWidth(callback);
                });
            }

            var style = window.getComputedStyle(target);

            var font = [style['font-weight'], style['font-style'], style['font-size'], style['font-family']].join(' ');

            canvasContext.font = font;

            this.setState({
                targetWidth: targetWidth
            }, callback);
        }
    }, {
        key: 'measureWidth',
        value: function measureWidth(text) {
            return this.canvasContext.measureText(text).width;
        }
    }, {
        key: 'ellipsisWidth',
        value: function ellipsisWidth(node) {
            return node.offsetWidth;
        }
    }, {
        key: 'trimRight',
        value: function trimRight(text) {
            return text.replace(/\s+$/, '');
        }
    }, {
        key: 'getLines',
        value: function getLines() {
            var elements = this.elements,
                _props = this.props,
                numLines = _props.lines,
                ellipsis = _props.ellipsis,
                trimWhitespace = _props.trimWhitespace,
                targetWidth = this.state.targetWidth,
                innerText = this.innerText,
                measureWidth = this.measureWidth,
                onTruncate = this.onTruncate,
                trimRight = this.trimRight;


            var lines = [];
            var text = innerText(elements.text);
            var textLines = text.split('\n').map(function (line) {
                return line.split(' ');
            });
            var didTruncate = true;
            var ellipsisWidth = this.ellipsisWidth(this.elements.ellipsis);

            for (var line = 1; line <= numLines; line++) {
                var textWords = textLines[0];

                // Handle newline
                if (textWords.length === 0) {
                    lines.push();
                    textLines.shift();
                    line--;
                    continue;
                }

                var resultLine = textWords.join(' ');

                if (measureWidth(resultLine) <= targetWidth) {
                    if (textLines.length === 1) {
                        // Line is end of text and fits without truncating
                        didTruncate = false;

                        lines.push(resultLine);
                        break;
                    }
                }

                if (line === numLines) {
                    // Binary search determining the longest possible line inluding truncate string
                    var textRest = textWords.join(' ');

                    var lower = 0;
                    var upper = textRest.length - 1;

                    while (lower <= upper) {
                        var middle = Math.floor((lower + upper) / 2);

                        var testLine = textRest.slice(0, middle + 1);

                        if (measureWidth(testLine) + ellipsisWidth <= targetWidth) {
                            lower = middle + 1;
                        } else {
                            upper = middle - 1;
                        }
                    }

                    var lastLineText = textRest.slice(0, lower);

                    if (trimWhitespace) {
                        lastLineText = trimRight(lastLineText);

                        // Remove blank lines from the end of text
                        while (!lastLineText.length && lines.length) {
                            var prevLine = lines.pop();

                            lastLineText = trimRight(prevLine);
                        }
                    }

                    resultLine = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'span',
                        null,
                        lastLineText,
                        ellipsis
                    );
                } else {
                    // Binary search determining when the line breaks
                    var _lower = 0;
                    var _upper = textWords.length - 1;

                    while (_lower <= _upper) {
                        var _middle = Math.floor((_lower + _upper) / 2);

                        var _testLine = textWords.slice(0, _middle + 1).join(' ');

                        if (measureWidth(_testLine) <= targetWidth) {
                            _lower = _middle + 1;
                        } else {
                            _upper = _middle - 1;
                        }
                    }

                    // The first word of this line is too long to fit it
                    if (_lower === 0) {
                        // Jump to processing of last line
                        line = numLines - 1;
                        continue;
                    }

                    resultLine = textWords.slice(0, _lower).join(' ');
                    textLines[0].splice(0, _lower);
                }

                lines.push(resultLine);
            }

            onTruncate(didTruncate);

            return lines;
        }
    }, {
        key: 'renderLine',
        value: function renderLine(line, i, arr) {
            if (i === arr.length - 1) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    { key: i },
                    line
                );
            } else {
                var br = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', { key: i + 'br' });

                if (line) {
                    return [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'span',
                        { key: i },
                        line
                    ), br];
                } else {
                    return br;
                }
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var target = this.elements.target,
                _props2 = this.props,
                children = _props2.children,
                ellipsis = _props2.ellipsis,
                lines = _props2.lines,
                spanProps = _objectWithoutProperties(_props2, ['children', 'ellipsis', 'lines']),
                targetWidth = this.state.targetWidth,
                getLines = this.getLines,
                renderLine = this.renderLine,
                onTruncate = this.onTruncate;

            var text = void 0;

            var mounted = !!(target && targetWidth);

            if (typeof window !== 'undefined' && mounted) {
                if (lines > 0) {
                    text = getLines().map(renderLine);
                } else {
                    text = children;

                    onTruncate(false);
                }
            }

            delete spanProps.onTruncate;
            delete spanProps.trimWhitespace;

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                _extends({}, spanProps, { ref: function ref(targetEl) {
                        _this2.elements.target = targetEl;
                    } }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    null,
                    text
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    { ref: function ref(textEl) {
                            _this2.elements.text = textEl;
                        } },
                    children
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    { ref: function ref(ellipsisEl) {
                            _this2.elements.ellipsis = ellipsisEl;
                        }, style: this.styles.ellipsis },
                    ellipsis
                )
            );
        }
    }]);

    return Truncate;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Truncate.propTypes = {
    children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
    ellipsis: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
    lines: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf([false]), __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
    trimWhitespace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
    width: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
    onTruncate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};
Truncate.defaultProps = {
    children: '',
    ellipsis: '…',
    lines: 1,
    trimWhitespace: false,
    width: 0
};
/* harmony default export */ __webpack_exports__["a"] = (Truncate);
;


/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var colorString = __webpack_require__(627);
var convert = __webpack_require__(630);

var _slice = [].slice;

var skippedModels = [
	// to be honest, I don't really feel like keyword belongs in color convert, but eh.
	'keyword',

	// gray conflicts with some method names, and has its own method defined.
	'gray',

	// shouldn't really be in color-convert either...
	'hex'
];

var hashedModelKeys = {};
Object.keys(convert).forEach(function (model) {
	hashedModelKeys[_slice.call(convert[model].labels).sort().join('')] = model;
});

var limiters = {};

function Color(obj, model) {
	if (!(this instanceof Color)) {
		return new Color(obj, model);
	}

	if (model && model in skippedModels) {
		model = null;
	}

	if (model && !(model in convert)) {
		throw new Error('Unknown model: ' + model);
	}

	var i;
	var channels;

	if (obj == null) { // eslint-disable-line no-eq-null,eqeqeq
		this.model = 'rgb';
		this.color = [0, 0, 0];
		this.valpha = 1;
	} else if (obj instanceof Color) {
		this.model = obj.model;
		this.color = obj.color.slice();
		this.valpha = obj.valpha;
	} else if (typeof obj === 'string') {
		var result = colorString.get(obj);
		if (result === null) {
			throw new Error('Unable to parse color from string: ' + obj);
		}

		this.model = result.model;
		channels = convert[this.model].channels;
		this.color = result.value.slice(0, channels);
		this.valpha = typeof result.value[channels] === 'number' ? result.value[channels] : 1;
	} else if (obj.length) {
		this.model = model || 'rgb';
		channels = convert[this.model].channels;
		var newArr = _slice.call(obj, 0, channels);
		this.color = zeroArray(newArr, channels);
		this.valpha = typeof obj[channels] === 'number' ? obj[channels] : 1;
	} else if (typeof obj === 'number') {
		// this is always RGB - can be converted later on.
		obj &= 0xFFFFFF;
		this.model = 'rgb';
		this.color = [
			(obj >> 16) & 0xFF,
			(obj >> 8) & 0xFF,
			obj & 0xFF
		];
		this.valpha = 1;
	} else {
		this.valpha = 1;

		var keys = Object.keys(obj);
		if ('alpha' in obj) {
			keys.splice(keys.indexOf('alpha'), 1);
			this.valpha = typeof obj.alpha === 'number' ? obj.alpha : 0;
		}

		var hashedKeys = keys.sort().join('');
		if (!(hashedKeys in hashedModelKeys)) {
			throw new Error('Unable to parse color from object: ' + JSON.stringify(obj));
		}

		this.model = hashedModelKeys[hashedKeys];

		var labels = convert[this.model].labels;
		var color = [];
		for (i = 0; i < labels.length; i++) {
			color.push(obj[labels[i]]);
		}

		this.color = zeroArray(color);
	}

	// perform limitations (clamping, etc.)
	if (limiters[this.model]) {
		channels = convert[this.model].channels;
		for (i = 0; i < channels; i++) {
			var limit = limiters[this.model][i];
			if (limit) {
				this.color[i] = limit(this.color[i]);
			}
		}
	}

	this.valpha = Math.max(0, Math.min(1, this.valpha));

	if (Object.freeze) {
		Object.freeze(this);
	}
}

Color.prototype = {
	toString: function () {
		return this.string();
	},

	toJSON: function () {
		return this[this.model]();
	},

	string: function (places) {
		var self = this.model in colorString.to ? this : this.rgb();
		self = self.round(typeof places === 'number' ? places : 1);
		var args = self.valpha === 1 ? self.color : self.color.concat(this.valpha);
		return colorString.to[self.model](args);
	},

	percentString: function (places) {
		var self = this.rgb().round(typeof places === 'number' ? places : 1);
		var args = self.valpha === 1 ? self.color : self.color.concat(this.valpha);
		return colorString.to.rgb.percent(args);
	},

	array: function () {
		return this.valpha === 1 ? this.color.slice() : this.color.concat(this.valpha);
	},

	object: function () {
		var result = {};
		var channels = convert[this.model].channels;
		var labels = convert[this.model].labels;

		for (var i = 0; i < channels; i++) {
			result[labels[i]] = this.color[i];
		}

		if (this.valpha !== 1) {
			result.alpha = this.valpha;
		}

		return result;
	},

	unitArray: function () {
		var rgb = this.rgb().color;
		rgb[0] /= 255;
		rgb[1] /= 255;
		rgb[2] /= 255;

		if (this.valpha !== 1) {
			rgb.push(this.valpha);
		}

		return rgb;
	},

	unitObject: function () {
		var rgb = this.rgb().object();
		rgb.r /= 255;
		rgb.g /= 255;
		rgb.b /= 255;

		if (this.valpha !== 1) {
			rgb.alpha = this.valpha;
		}

		return rgb;
	},

	round: function (places) {
		places = Math.max(places || 0, 0);
		return new Color(this.color.map(roundToPlace(places)).concat(this.valpha), this.model);
	},

	alpha: function (val) {
		if (arguments.length) {
			return new Color(this.color.concat(Math.max(0, Math.min(1, val))), this.model);
		}

		return this.valpha;
	},

	// rgb
	red: getset('rgb', 0, maxfn(255)),
	green: getset('rgb', 1, maxfn(255)),
	blue: getset('rgb', 2, maxfn(255)),

	hue: getset(['hsl', 'hsv', 'hsl', 'hwb', 'hcg'], 0, function (val) { return ((val % 360) + 360) % 360; }), // eslint-disable-line brace-style

	saturationl: getset('hsl', 1, maxfn(100)),
	lightness: getset('hsl', 2, maxfn(100)),

	saturationv: getset('hsv', 1, maxfn(100)),
	value: getset('hsv', 2, maxfn(100)),

	chroma: getset('hcg', 1, maxfn(100)),
	gray: getset('hcg', 2, maxfn(100)),

	white: getset('hwb', 1, maxfn(100)),
	wblack: getset('hwb', 2, maxfn(100)),

	cyan: getset('cmyk', 0, maxfn(100)),
	magenta: getset('cmyk', 1, maxfn(100)),
	yellow: getset('cmyk', 2, maxfn(100)),
	black: getset('cmyk', 3, maxfn(100)),

	x: getset('xyz', 0, maxfn(100)),
	y: getset('xyz', 1, maxfn(100)),
	z: getset('xyz', 2, maxfn(100)),

	l: getset('lab', 0, maxfn(100)),
	a: getset('lab', 1),
	b: getset('lab', 2),

	keyword: function (val) {
		if (arguments.length) {
			return new Color(val);
		}

		return convert[this.model].keyword(this.color);
	},

	hex: function (val) {
		if (arguments.length) {
			return new Color(val);
		}

		return colorString.to.hex(this.rgb().round().color);
	},

	rgbNumber: function () {
		var rgb = this.rgb().color;
		return ((rgb[0] & 0xFF) << 16) | ((rgb[1] & 0xFF) << 8) | (rgb[2] & 0xFF);
	},

	luminosity: function () {
		// http://www.w3.org/TR/WCAG20/#relativeluminancedef
		var rgb = this.rgb().color;

		var lum = [];
		for (var i = 0; i < rgb.length; i++) {
			var chan = rgb[i] / 255;
			lum[i] = (chan <= 0.03928) ? chan / 12.92 : Math.pow(((chan + 0.055) / 1.055), 2.4);
		}

		return 0.2126 * lum[0] + 0.7152 * lum[1] + 0.0722 * lum[2];
	},

	contrast: function (color2) {
		// http://www.w3.org/TR/WCAG20/#contrast-ratiodef
		var lum1 = this.luminosity();
		var lum2 = color2.luminosity();

		if (lum1 > lum2) {
			return (lum1 + 0.05) / (lum2 + 0.05);
		}

		return (lum2 + 0.05) / (lum1 + 0.05);
	},

	level: function (color2) {
		var contrastRatio = this.contrast(color2);
		if (contrastRatio >= 7.1) {
			return 'AAA';
		}

		return (contrastRatio >= 4.5) ? 'AA' : '';
	},

	isDark: function () {
		// YIQ equation from http://24ways.org/2010/calculating-color-contrast
		var rgb = this.rgb().color;
		var yiq = (rgb[0] * 299 + rgb[1] * 587 + rgb[2] * 114) / 1000;
		return yiq < 128;
	},

	isLight: function () {
		return !this.isDark();
	},

	negate: function () {
		var rgb = this.rgb();
		for (var i = 0; i < 3; i++) {
			rgb.color[i] = 255 - rgb.color[i];
		}
		return rgb;
	},

	lighten: function (ratio) {
		var hsl = this.hsl();
		hsl.color[2] += hsl.color[2] * ratio;
		return hsl;
	},

	darken: function (ratio) {
		var hsl = this.hsl();
		hsl.color[2] -= hsl.color[2] * ratio;
		return hsl;
	},

	saturate: function (ratio) {
		var hsl = this.hsl();
		hsl.color[1] += hsl.color[1] * ratio;
		return hsl;
	},

	desaturate: function (ratio) {
		var hsl = this.hsl();
		hsl.color[1] -= hsl.color[1] * ratio;
		return hsl;
	},

	whiten: function (ratio) {
		var hwb = this.hwb();
		hwb.color[1] += hwb.color[1] * ratio;
		return hwb;
	},

	blacken: function (ratio) {
		var hwb = this.hwb();
		hwb.color[2] += hwb.color[2] * ratio;
		return hwb;
	},

	grayscale: function () {
		// http://en.wikipedia.org/wiki/Grayscale#Converting_color_to_grayscale
		var rgb = this.rgb().color;
		var val = rgb[0] * 0.3 + rgb[1] * 0.59 + rgb[2] * 0.11;
		return Color.rgb(val, val, val);
	},

	fade: function (ratio) {
		return this.alpha(this.valpha - (this.valpha * ratio));
	},

	opaquer: function (ratio) {
		return this.alpha(this.valpha + (this.valpha * ratio));
	},

	rotate: function (degrees) {
		var hsl = this.hsl();
		var hue = hsl.color[0];
		hue = (hue + degrees) % 360;
		hue = hue < 0 ? 360 + hue : hue;
		hsl.color[0] = hue;
		return hsl;
	},

	mix: function (mixinColor, weight) {
		// ported from sass implementation in C
		// https://github.com/sass/libsass/blob/0e6b4a2850092356aa3ece07c6b249f0221caced/functions.cpp#L209
		if (!mixinColor || !mixinColor.rgb) {
			throw new Error('Argument to "mix" was not a Color instance, but rather an instance of ' + typeof mixinColor);
		}
		var color1 = mixinColor.rgb();
		var color2 = this.rgb();
		var p = weight === undefined ? 0.5 : weight;

		var w = 2 * p - 1;
		var a = color1.alpha() - color2.alpha();

		var w1 = (((w * a === -1) ? w : (w + a) / (1 + w * a)) + 1) / 2.0;
		var w2 = 1 - w1;

		return Color.rgb(
				w1 * color1.red() + w2 * color2.red(),
				w1 * color1.green() + w2 * color2.green(),
				w1 * color1.blue() + w2 * color2.blue(),
				color1.alpha() * p + color2.alpha() * (1 - p));
	}
};

// model conversion methods and static constructors
Object.keys(convert).forEach(function (model) {
	if (skippedModels.indexOf(model) !== -1) {
		return;
	}

	var channels = convert[model].channels;

	// conversion methods
	Color.prototype[model] = function () {
		if (this.model === model) {
			return new Color(this);
		}

		if (arguments.length) {
			return new Color(arguments, model);
		}

		var newAlpha = typeof arguments[channels] === 'number' ? channels : this.valpha;
		return new Color(assertArray(convert[this.model][model].raw(this.color)).concat(newAlpha), model);
	};

	// 'static' construction methods
	Color[model] = function (color) {
		if (typeof color === 'number') {
			color = zeroArray(_slice.call(arguments), channels);
		}
		return new Color(color, model);
	};
});

function roundTo(num, places) {
	return Number(num.toFixed(places));
}

function roundToPlace(places) {
	return function (num) {
		return roundTo(num, places);
	};
}

function getset(model, channel, modifier) {
	model = Array.isArray(model) ? model : [model];

	model.forEach(function (m) {
		(limiters[m] || (limiters[m] = []))[channel] = modifier;
	});

	model = model[0];

	return function (val) {
		var result;

		if (arguments.length) {
			if (modifier) {
				val = modifier(val);
			}

			result = this[model]();
			result.color[channel] = val;
			return result;
		}

		result = this[model]().color[channel];
		if (modifier) {
			result = modifier(result);
		}

		return result;
	};
}

function maxfn(max) {
	return function (v) {
		return Math.max(0, Math.min(max, v));
	};
}

function assertArray(val) {
	return Array.isArray(val) ? val : [val];
}

function zeroArray(arr, length) {
	for (var i = 0; i < length; i++) {
		if (typeof arr[i] !== 'number') {
			arr[i] = 0;
		}
	}

	return arr;
}

module.exports = Color;


/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
	"aliceblue": [240, 248, 255],
	"antiquewhite": [250, 235, 215],
	"aqua": [0, 255, 255],
	"aquamarine": [127, 255, 212],
	"azure": [240, 255, 255],
	"beige": [245, 245, 220],
	"bisque": [255, 228, 196],
	"black": [0, 0, 0],
	"blanchedalmond": [255, 235, 205],
	"blue": [0, 0, 255],
	"blueviolet": [138, 43, 226],
	"brown": [165, 42, 42],
	"burlywood": [222, 184, 135],
	"cadetblue": [95, 158, 160],
	"chartreuse": [127, 255, 0],
	"chocolate": [210, 105, 30],
	"coral": [255, 127, 80],
	"cornflowerblue": [100, 149, 237],
	"cornsilk": [255, 248, 220],
	"crimson": [220, 20, 60],
	"cyan": [0, 255, 255],
	"darkblue": [0, 0, 139],
	"darkcyan": [0, 139, 139],
	"darkgoldenrod": [184, 134, 11],
	"darkgray": [169, 169, 169],
	"darkgreen": [0, 100, 0],
	"darkgrey": [169, 169, 169],
	"darkkhaki": [189, 183, 107],
	"darkmagenta": [139, 0, 139],
	"darkolivegreen": [85, 107, 47],
	"darkorange": [255, 140, 0],
	"darkorchid": [153, 50, 204],
	"darkred": [139, 0, 0],
	"darksalmon": [233, 150, 122],
	"darkseagreen": [143, 188, 143],
	"darkslateblue": [72, 61, 139],
	"darkslategray": [47, 79, 79],
	"darkslategrey": [47, 79, 79],
	"darkturquoise": [0, 206, 209],
	"darkviolet": [148, 0, 211],
	"deeppink": [255, 20, 147],
	"deepskyblue": [0, 191, 255],
	"dimgray": [105, 105, 105],
	"dimgrey": [105, 105, 105],
	"dodgerblue": [30, 144, 255],
	"firebrick": [178, 34, 34],
	"floralwhite": [255, 250, 240],
	"forestgreen": [34, 139, 34],
	"fuchsia": [255, 0, 255],
	"gainsboro": [220, 220, 220],
	"ghostwhite": [248, 248, 255],
	"gold": [255, 215, 0],
	"goldenrod": [218, 165, 32],
	"gray": [128, 128, 128],
	"green": [0, 128, 0],
	"greenyellow": [173, 255, 47],
	"grey": [128, 128, 128],
	"honeydew": [240, 255, 240],
	"hotpink": [255, 105, 180],
	"indianred": [205, 92, 92],
	"indigo": [75, 0, 130],
	"ivory": [255, 255, 240],
	"khaki": [240, 230, 140],
	"lavender": [230, 230, 250],
	"lavenderblush": [255, 240, 245],
	"lawngreen": [124, 252, 0],
	"lemonchiffon": [255, 250, 205],
	"lightblue": [173, 216, 230],
	"lightcoral": [240, 128, 128],
	"lightcyan": [224, 255, 255],
	"lightgoldenrodyellow": [250, 250, 210],
	"lightgray": [211, 211, 211],
	"lightgreen": [144, 238, 144],
	"lightgrey": [211, 211, 211],
	"lightpink": [255, 182, 193],
	"lightsalmon": [255, 160, 122],
	"lightseagreen": [32, 178, 170],
	"lightskyblue": [135, 206, 250],
	"lightslategray": [119, 136, 153],
	"lightslategrey": [119, 136, 153],
	"lightsteelblue": [176, 196, 222],
	"lightyellow": [255, 255, 224],
	"lime": [0, 255, 0],
	"limegreen": [50, 205, 50],
	"linen": [250, 240, 230],
	"magenta": [255, 0, 255],
	"maroon": [128, 0, 0],
	"mediumaquamarine": [102, 205, 170],
	"mediumblue": [0, 0, 205],
	"mediumorchid": [186, 85, 211],
	"mediumpurple": [147, 112, 219],
	"mediumseagreen": [60, 179, 113],
	"mediumslateblue": [123, 104, 238],
	"mediumspringgreen": [0, 250, 154],
	"mediumturquoise": [72, 209, 204],
	"mediumvioletred": [199, 21, 133],
	"midnightblue": [25, 25, 112],
	"mintcream": [245, 255, 250],
	"mistyrose": [255, 228, 225],
	"moccasin": [255, 228, 181],
	"navajowhite": [255, 222, 173],
	"navy": [0, 0, 128],
	"oldlace": [253, 245, 230],
	"olive": [128, 128, 0],
	"olivedrab": [107, 142, 35],
	"orange": [255, 165, 0],
	"orangered": [255, 69, 0],
	"orchid": [218, 112, 214],
	"palegoldenrod": [238, 232, 170],
	"palegreen": [152, 251, 152],
	"paleturquoise": [175, 238, 238],
	"palevioletred": [219, 112, 147],
	"papayawhip": [255, 239, 213],
	"peachpuff": [255, 218, 185],
	"peru": [205, 133, 63],
	"pink": [255, 192, 203],
	"plum": [221, 160, 221],
	"powderblue": [176, 224, 230],
	"purple": [128, 0, 128],
	"rebeccapurple": [102, 51, 153],
	"red": [255, 0, 0],
	"rosybrown": [188, 143, 143],
	"royalblue": [65, 105, 225],
	"saddlebrown": [139, 69, 19],
	"salmon": [250, 128, 114],
	"sandybrown": [244, 164, 96],
	"seagreen": [46, 139, 87],
	"seashell": [255, 245, 238],
	"sienna": [160, 82, 45],
	"silver": [192, 192, 192],
	"skyblue": [135, 206, 235],
	"slateblue": [106, 90, 205],
	"slategray": [112, 128, 144],
	"slategrey": [112, 128, 144],
	"snow": [255, 250, 250],
	"springgreen": [0, 255, 127],
	"steelblue": [70, 130, 180],
	"tan": [210, 180, 140],
	"teal": [0, 128, 128],
	"thistle": [216, 191, 216],
	"tomato": [255, 99, 71],
	"turquoise": [64, 224, 208],
	"violet": [238, 130, 238],
	"wheat": [245, 222, 179],
	"white": [255, 255, 255],
	"whitesmoke": [245, 245, 245],
	"yellow": [255, 255, 0],
	"yellowgreen": [154, 205, 50]
};


/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

/* MIT license */
var cssKeywords = __webpack_require__(256);

// NOTE: conversions should only return primitive values (i.e. arrays, or
//       values that give correct `typeof` results).
//       do not use box values types (i.e. Number(), String(), etc.)

var reverseKeywords = {};
for (var key in cssKeywords) {
	if (cssKeywords.hasOwnProperty(key)) {
		reverseKeywords[cssKeywords[key]] = key;
	}
}

var convert = module.exports = {
	rgb: {channels: 3, labels: 'rgb'},
	hsl: {channels: 3, labels: 'hsl'},
	hsv: {channels: 3, labels: 'hsv'},
	hwb: {channels: 3, labels: 'hwb'},
	cmyk: {channels: 4, labels: 'cmyk'},
	xyz: {channels: 3, labels: 'xyz'},
	lab: {channels: 3, labels: 'lab'},
	lch: {channels: 3, labels: 'lch'},
	hex: {channels: 1, labels: ['hex']},
	keyword: {channels: 1, labels: ['keyword']},
	ansi16: {channels: 1, labels: ['ansi16']},
	ansi256: {channels: 1, labels: ['ansi256']},
	hcg: {channels: 3, labels: ['h', 'c', 'g']},
	apple: {channels: 3, labels: ['r16', 'g16', 'b16']},
	gray: {channels: 1, labels: ['gray']}
};

// hide .channels and .labels properties
for (var model in convert) {
	if (convert.hasOwnProperty(model)) {
		if (!('channels' in convert[model])) {
			throw new Error('missing channels property: ' + model);
		}

		if (!('labels' in convert[model])) {
			throw new Error('missing channel labels property: ' + model);
		}

		if (convert[model].labels.length !== convert[model].channels) {
			throw new Error('channel and label counts mismatch: ' + model);
		}

		var channels = convert[model].channels;
		var labels = convert[model].labels;
		delete convert[model].channels;
		delete convert[model].labels;
		Object.defineProperty(convert[model], 'channels', {value: channels});
		Object.defineProperty(convert[model], 'labels', {value: labels});
	}
}

convert.rgb.hsl = function (rgb) {
	var r = rgb[0] / 255;
	var g = rgb[1] / 255;
	var b = rgb[2] / 255;
	var min = Math.min(r, g, b);
	var max = Math.max(r, g, b);
	var delta = max - min;
	var h;
	var s;
	var l;

	if (max === min) {
		h = 0;
	} else if (r === max) {
		h = (g - b) / delta;
	} else if (g === max) {
		h = 2 + (b - r) / delta;
	} else if (b === max) {
		h = 4 + (r - g) / delta;
	}

	h = Math.min(h * 60, 360);

	if (h < 0) {
		h += 360;
	}

	l = (min + max) / 2;

	if (max === min) {
		s = 0;
	} else if (l <= 0.5) {
		s = delta / (max + min);
	} else {
		s = delta / (2 - max - min);
	}

	return [h, s * 100, l * 100];
};

convert.rgb.hsv = function (rgb) {
	var rdif;
	var gdif;
	var bdif;
	var h;
	var s;

	var r = rgb[0] / 255;
	var g = rgb[1] / 255;
	var b = rgb[2] / 255;
	var v = Math.max(r, g, b);
	var diff = v - Math.min(r, g, b);
	var diffc = function (c) {
		return (v - c) / 6 / diff + 1 / 2;
	};

	if (diff === 0) {
		h = s = 0;
	} else {
		s = diff / v;
		rdif = diffc(r);
		gdif = diffc(g);
		bdif = diffc(b);

		if (r === v) {
			h = bdif - gdif;
		} else if (g === v) {
			h = (1 / 3) + rdif - bdif;
		} else if (b === v) {
			h = (2 / 3) + gdif - rdif;
		}
		if (h < 0) {
			h += 1;
		} else if (h > 1) {
			h -= 1;
		}
	}

	return [
		h * 360,
		s * 100,
		v * 100
	];
};

convert.rgb.hwb = function (rgb) {
	var r = rgb[0];
	var g = rgb[1];
	var b = rgb[2];
	var h = convert.rgb.hsl(rgb)[0];
	var w = 1 / 255 * Math.min(r, Math.min(g, b));

	b = 1 - 1 / 255 * Math.max(r, Math.max(g, b));

	return [h, w * 100, b * 100];
};

convert.rgb.cmyk = function (rgb) {
	var r = rgb[0] / 255;
	var g = rgb[1] / 255;
	var b = rgb[2] / 255;
	var c;
	var m;
	var y;
	var k;

	k = Math.min(1 - r, 1 - g, 1 - b);
	c = (1 - r - k) / (1 - k) || 0;
	m = (1 - g - k) / (1 - k) || 0;
	y = (1 - b - k) / (1 - k) || 0;

	return [c * 100, m * 100, y * 100, k * 100];
};

/**
 * See https://en.m.wikipedia.org/wiki/Euclidean_distance#Squared_Euclidean_distance
 * */
function comparativeDistance(x, y) {
	return (
		Math.pow(x[0] - y[0], 2) +
		Math.pow(x[1] - y[1], 2) +
		Math.pow(x[2] - y[2], 2)
	);
}

convert.rgb.keyword = function (rgb) {
	var reversed = reverseKeywords[rgb];
	if (reversed) {
		return reversed;
	}

	var currentClosestDistance = Infinity;
	var currentClosestKeyword;

	for (var keyword in cssKeywords) {
		if (cssKeywords.hasOwnProperty(keyword)) {
			var value = cssKeywords[keyword];

			// Compute comparative distance
			var distance = comparativeDistance(rgb, value);

			// Check if its less, if so set as closest
			if (distance < currentClosestDistance) {
				currentClosestDistance = distance;
				currentClosestKeyword = keyword;
			}
		}
	}

	return currentClosestKeyword;
};

convert.keyword.rgb = function (keyword) {
	return cssKeywords[keyword];
};

convert.rgb.xyz = function (rgb) {
	var r = rgb[0] / 255;
	var g = rgb[1] / 255;
	var b = rgb[2] / 255;

	// assume sRGB
	r = r > 0.04045 ? Math.pow(((r + 0.055) / 1.055), 2.4) : (r / 12.92);
	g = g > 0.04045 ? Math.pow(((g + 0.055) / 1.055), 2.4) : (g / 12.92);
	b = b > 0.04045 ? Math.pow(((b + 0.055) / 1.055), 2.4) : (b / 12.92);

	var x = (r * 0.4124) + (g * 0.3576) + (b * 0.1805);
	var y = (r * 0.2126) + (g * 0.7152) + (b * 0.0722);
	var z = (r * 0.0193) + (g * 0.1192) + (b * 0.9505);

	return [x * 100, y * 100, z * 100];
};

convert.rgb.lab = function (rgb) {
	var xyz = convert.rgb.xyz(rgb);
	var x = xyz[0];
	var y = xyz[1];
	var z = xyz[2];
	var l;
	var a;
	var b;

	x /= 95.047;
	y /= 100;
	z /= 108.883;

	x = x > 0.008856 ? Math.pow(x, 1 / 3) : (7.787 * x) + (16 / 116);
	y = y > 0.008856 ? Math.pow(y, 1 / 3) : (7.787 * y) + (16 / 116);
	z = z > 0.008856 ? Math.pow(z, 1 / 3) : (7.787 * z) + (16 / 116);

	l = (116 * y) - 16;
	a = 500 * (x - y);
	b = 200 * (y - z);

	return [l, a, b];
};

convert.hsl.rgb = function (hsl) {
	var h = hsl[0] / 360;
	var s = hsl[1] / 100;
	var l = hsl[2] / 100;
	var t1;
	var t2;
	var t3;
	var rgb;
	var val;

	if (s === 0) {
		val = l * 255;
		return [val, val, val];
	}

	if (l < 0.5) {
		t2 = l * (1 + s);
	} else {
		t2 = l + s - l * s;
	}

	t1 = 2 * l - t2;

	rgb = [0, 0, 0];
	for (var i = 0; i < 3; i++) {
		t3 = h + 1 / 3 * -(i - 1);
		if (t3 < 0) {
			t3++;
		}
		if (t3 > 1) {
			t3--;
		}

		if (6 * t3 < 1) {
			val = t1 + (t2 - t1) * 6 * t3;
		} else if (2 * t3 < 1) {
			val = t2;
		} else if (3 * t3 < 2) {
			val = t1 + (t2 - t1) * (2 / 3 - t3) * 6;
		} else {
			val = t1;
		}

		rgb[i] = val * 255;
	}

	return rgb;
};

convert.hsl.hsv = function (hsl) {
	var h = hsl[0];
	var s = hsl[1] / 100;
	var l = hsl[2] / 100;
	var smin = s;
	var lmin = Math.max(l, 0.01);
	var sv;
	var v;

	l *= 2;
	s *= (l <= 1) ? l : 2 - l;
	smin *= lmin <= 1 ? lmin : 2 - lmin;
	v = (l + s) / 2;
	sv = l === 0 ? (2 * smin) / (lmin + smin) : (2 * s) / (l + s);

	return [h, sv * 100, v * 100];
};

convert.hsv.rgb = function (hsv) {
	var h = hsv[0] / 60;
	var s = hsv[1] / 100;
	var v = hsv[2] / 100;
	var hi = Math.floor(h) % 6;

	var f = h - Math.floor(h);
	var p = 255 * v * (1 - s);
	var q = 255 * v * (1 - (s * f));
	var t = 255 * v * (1 - (s * (1 - f)));
	v *= 255;

	switch (hi) {
		case 0:
			return [v, t, p];
		case 1:
			return [q, v, p];
		case 2:
			return [p, v, t];
		case 3:
			return [p, q, v];
		case 4:
			return [t, p, v];
		case 5:
			return [v, p, q];
	}
};

convert.hsv.hsl = function (hsv) {
	var h = hsv[0];
	var s = hsv[1] / 100;
	var v = hsv[2] / 100;
	var vmin = Math.max(v, 0.01);
	var lmin;
	var sl;
	var l;

	l = (2 - s) * v;
	lmin = (2 - s) * vmin;
	sl = s * vmin;
	sl /= (lmin <= 1) ? lmin : 2 - lmin;
	sl = sl || 0;
	l /= 2;

	return [h, sl * 100, l * 100];
};

// http://dev.w3.org/csswg/css-color/#hwb-to-rgb
convert.hwb.rgb = function (hwb) {
	var h = hwb[0] / 360;
	var wh = hwb[1] / 100;
	var bl = hwb[2] / 100;
	var ratio = wh + bl;
	var i;
	var v;
	var f;
	var n;

	// wh + bl cant be > 1
	if (ratio > 1) {
		wh /= ratio;
		bl /= ratio;
	}

	i = Math.floor(6 * h);
	v = 1 - bl;
	f = 6 * h - i;

	if ((i & 0x01) !== 0) {
		f = 1 - f;
	}

	n = wh + f * (v - wh); // linear interpolation

	var r;
	var g;
	var b;
	switch (i) {
		default:
		case 6:
		case 0: r = v; g = n; b = wh; break;
		case 1: r = n; g = v; b = wh; break;
		case 2: r = wh; g = v; b = n; break;
		case 3: r = wh; g = n; b = v; break;
		case 4: r = n; g = wh; b = v; break;
		case 5: r = v; g = wh; b = n; break;
	}

	return [r * 255, g * 255, b * 255];
};

convert.cmyk.rgb = function (cmyk) {
	var c = cmyk[0] / 100;
	var m = cmyk[1] / 100;
	var y = cmyk[2] / 100;
	var k = cmyk[3] / 100;
	var r;
	var g;
	var b;

	r = 1 - Math.min(1, c * (1 - k) + k);
	g = 1 - Math.min(1, m * (1 - k) + k);
	b = 1 - Math.min(1, y * (1 - k) + k);

	return [r * 255, g * 255, b * 255];
};

convert.xyz.rgb = function (xyz) {
	var x = xyz[0] / 100;
	var y = xyz[1] / 100;
	var z = xyz[2] / 100;
	var r;
	var g;
	var b;

	r = (x * 3.2406) + (y * -1.5372) + (z * -0.4986);
	g = (x * -0.9689) + (y * 1.8758) + (z * 0.0415);
	b = (x * 0.0557) + (y * -0.2040) + (z * 1.0570);

	// assume sRGB
	r = r > 0.0031308
		? ((1.055 * Math.pow(r, 1.0 / 2.4)) - 0.055)
		: r * 12.92;

	g = g > 0.0031308
		? ((1.055 * Math.pow(g, 1.0 / 2.4)) - 0.055)
		: g * 12.92;

	b = b > 0.0031308
		? ((1.055 * Math.pow(b, 1.0 / 2.4)) - 0.055)
		: b * 12.92;

	r = Math.min(Math.max(0, r), 1);
	g = Math.min(Math.max(0, g), 1);
	b = Math.min(Math.max(0, b), 1);

	return [r * 255, g * 255, b * 255];
};

convert.xyz.lab = function (xyz) {
	var x = xyz[0];
	var y = xyz[1];
	var z = xyz[2];
	var l;
	var a;
	var b;

	x /= 95.047;
	y /= 100;
	z /= 108.883;

	x = x > 0.008856 ? Math.pow(x, 1 / 3) : (7.787 * x) + (16 / 116);
	y = y > 0.008856 ? Math.pow(y, 1 / 3) : (7.787 * y) + (16 / 116);
	z = z > 0.008856 ? Math.pow(z, 1 / 3) : (7.787 * z) + (16 / 116);

	l = (116 * y) - 16;
	a = 500 * (x - y);
	b = 200 * (y - z);

	return [l, a, b];
};

convert.lab.xyz = function (lab) {
	var l = lab[0];
	var a = lab[1];
	var b = lab[2];
	var x;
	var y;
	var z;

	y = (l + 16) / 116;
	x = a / 500 + y;
	z = y - b / 200;

	var y2 = Math.pow(y, 3);
	var x2 = Math.pow(x, 3);
	var z2 = Math.pow(z, 3);
	y = y2 > 0.008856 ? y2 : (y - 16 / 116) / 7.787;
	x = x2 > 0.008856 ? x2 : (x - 16 / 116) / 7.787;
	z = z2 > 0.008856 ? z2 : (z - 16 / 116) / 7.787;

	x *= 95.047;
	y *= 100;
	z *= 108.883;

	return [x, y, z];
};

convert.lab.lch = function (lab) {
	var l = lab[0];
	var a = lab[1];
	var b = lab[2];
	var hr;
	var h;
	var c;

	hr = Math.atan2(b, a);
	h = hr * 360 / 2 / Math.PI;

	if (h < 0) {
		h += 360;
	}

	c = Math.sqrt(a * a + b * b);

	return [l, c, h];
};

convert.lch.lab = function (lch) {
	var l = lch[0];
	var c = lch[1];
	var h = lch[2];
	var a;
	var b;
	var hr;

	hr = h / 360 * 2 * Math.PI;
	a = c * Math.cos(hr);
	b = c * Math.sin(hr);

	return [l, a, b];
};

convert.rgb.ansi16 = function (args) {
	var r = args[0];
	var g = args[1];
	var b = args[2];
	var value = 1 in arguments ? arguments[1] : convert.rgb.hsv(args)[2]; // hsv -> ansi16 optimization

	value = Math.round(value / 50);

	if (value === 0) {
		return 30;
	}

	var ansi = 30
		+ ((Math.round(b / 255) << 2)
		| (Math.round(g / 255) << 1)
		| Math.round(r / 255));

	if (value === 2) {
		ansi += 60;
	}

	return ansi;
};

convert.hsv.ansi16 = function (args) {
	// optimization here; we already know the value and don't need to get
	// it converted for us.
	return convert.rgb.ansi16(convert.hsv.rgb(args), args[2]);
};

convert.rgb.ansi256 = function (args) {
	var r = args[0];
	var g = args[1];
	var b = args[2];

	// we use the extended greyscale palette here, with the exception of
	// black and white. normal palette only has 4 greyscale shades.
	if (r === g && g === b) {
		if (r < 8) {
			return 16;
		}

		if (r > 248) {
			return 231;
		}

		return Math.round(((r - 8) / 247) * 24) + 232;
	}

	var ansi = 16
		+ (36 * Math.round(r / 255 * 5))
		+ (6 * Math.round(g / 255 * 5))
		+ Math.round(b / 255 * 5);

	return ansi;
};

convert.ansi16.rgb = function (args) {
	var color = args % 10;

	// handle greyscale
	if (color === 0 || color === 7) {
		if (args > 50) {
			color += 3.5;
		}

		color = color / 10.5 * 255;

		return [color, color, color];
	}

	var mult = (~~(args > 50) + 1) * 0.5;
	var r = ((color & 1) * mult) * 255;
	var g = (((color >> 1) & 1) * mult) * 255;
	var b = (((color >> 2) & 1) * mult) * 255;

	return [r, g, b];
};

convert.ansi256.rgb = function (args) {
	// handle greyscale
	if (args >= 232) {
		var c = (args - 232) * 10 + 8;
		return [c, c, c];
	}

	args -= 16;

	var rem;
	var r = Math.floor(args / 36) / 5 * 255;
	var g = Math.floor((rem = args % 36) / 6) / 5 * 255;
	var b = (rem % 6) / 5 * 255;

	return [r, g, b];
};

convert.rgb.hex = function (args) {
	var integer = ((Math.round(args[0]) & 0xFF) << 16)
		+ ((Math.round(args[1]) & 0xFF) << 8)
		+ (Math.round(args[2]) & 0xFF);

	var string = integer.toString(16).toUpperCase();
	return '000000'.substring(string.length) + string;
};

convert.hex.rgb = function (args) {
	var match = args.toString(16).match(/[a-f0-9]{6}|[a-f0-9]{3}/i);
	if (!match) {
		return [0, 0, 0];
	}

	var colorString = match[0];

	if (match[0].length === 3) {
		colorString = colorString.split('').map(function (char) {
			return char + char;
		}).join('');
	}

	var integer = parseInt(colorString, 16);
	var r = (integer >> 16) & 0xFF;
	var g = (integer >> 8) & 0xFF;
	var b = integer & 0xFF;

	return [r, g, b];
};

convert.rgb.hcg = function (rgb) {
	var r = rgb[0] / 255;
	var g = rgb[1] / 255;
	var b = rgb[2] / 255;
	var max = Math.max(Math.max(r, g), b);
	var min = Math.min(Math.min(r, g), b);
	var chroma = (max - min);
	var grayscale;
	var hue;

	if (chroma < 1) {
		grayscale = min / (1 - chroma);
	} else {
		grayscale = 0;
	}

	if (chroma <= 0) {
		hue = 0;
	} else
	if (max === r) {
		hue = ((g - b) / chroma) % 6;
	} else
	if (max === g) {
		hue = 2 + (b - r) / chroma;
	} else {
		hue = 4 + (r - g) / chroma + 4;
	}

	hue /= 6;
	hue %= 1;

	return [hue * 360, chroma * 100, grayscale * 100];
};

convert.hsl.hcg = function (hsl) {
	var s = hsl[1] / 100;
	var l = hsl[2] / 100;
	var c = 1;
	var f = 0;

	if (l < 0.5) {
		c = 2.0 * s * l;
	} else {
		c = 2.0 * s * (1.0 - l);
	}

	if (c < 1.0) {
		f = (l - 0.5 * c) / (1.0 - c);
	}

	return [hsl[0], c * 100, f * 100];
};

convert.hsv.hcg = function (hsv) {
	var s = hsv[1] / 100;
	var v = hsv[2] / 100;

	var c = s * v;
	var f = 0;

	if (c < 1.0) {
		f = (v - c) / (1 - c);
	}

	return [hsv[0], c * 100, f * 100];
};

convert.hcg.rgb = function (hcg) {
	var h = hcg[0] / 360;
	var c = hcg[1] / 100;
	var g = hcg[2] / 100;

	if (c === 0.0) {
		return [g * 255, g * 255, g * 255];
	}

	var pure = [0, 0, 0];
	var hi = (h % 1) * 6;
	var v = hi % 1;
	var w = 1 - v;
	var mg = 0;

	switch (Math.floor(hi)) {
		case 0:
			pure[0] = 1; pure[1] = v; pure[2] = 0; break;
		case 1:
			pure[0] = w; pure[1] = 1; pure[2] = 0; break;
		case 2:
			pure[0] = 0; pure[1] = 1; pure[2] = v; break;
		case 3:
			pure[0] = 0; pure[1] = w; pure[2] = 1; break;
		case 4:
			pure[0] = v; pure[1] = 0; pure[2] = 1; break;
		default:
			pure[0] = 1; pure[1] = 0; pure[2] = w;
	}

	mg = (1.0 - c) * g;

	return [
		(c * pure[0] + mg) * 255,
		(c * pure[1] + mg) * 255,
		(c * pure[2] + mg) * 255
	];
};

convert.hcg.hsv = function (hcg) {
	var c = hcg[1] / 100;
	var g = hcg[2] / 100;

	var v = c + g * (1.0 - c);
	var f = 0;

	if (v > 0.0) {
		f = c / v;
	}

	return [hcg[0], f * 100, v * 100];
};

convert.hcg.hsl = function (hcg) {
	var c = hcg[1] / 100;
	var g = hcg[2] / 100;

	var l = g * (1.0 - c) + 0.5 * c;
	var s = 0;

	if (l > 0.0 && l < 0.5) {
		s = c / (2 * l);
	} else
	if (l >= 0.5 && l < 1.0) {
		s = c / (2 * (1 - l));
	}

	return [hcg[0], s * 100, l * 100];
};

convert.hcg.hwb = function (hcg) {
	var c = hcg[1] / 100;
	var g = hcg[2] / 100;
	var v = c + g * (1.0 - c);
	return [hcg[0], (v - c) * 100, (1 - v) * 100];
};

convert.hwb.hcg = function (hwb) {
	var w = hwb[1] / 100;
	var b = hwb[2] / 100;
	var v = 1 - b;
	var c = v - w;
	var g = 0;

	if (c < 1) {
		g = (v - c) / (1 - c);
	}

	return [hwb[0], c * 100, g * 100];
};

convert.apple.rgb = function (apple) {
	return [(apple[0] / 65535) * 255, (apple[1] / 65535) * 255, (apple[2] / 65535) * 255];
};

convert.rgb.apple = function (rgb) {
	return [(rgb[0] / 255) * 65535, (rgb[1] / 255) * 65535, (rgb[2] / 255) * 65535];
};

convert.gray.rgb = function (args) {
	return [args[0] / 100 * 255, args[0] / 100 * 255, args[0] / 100 * 255];
};

convert.gray.hsl = convert.gray.hsv = function (args) {
	return [0, 0, args[0]];
};

convert.gray.hwb = function (gray) {
	return [0, 100, gray[0]];
};

convert.gray.cmyk = function (gray) {
	return [0, 0, 0, gray[0]];
};

convert.gray.lab = function (gray) {
	return [gray[0], 0, 0];
};

convert.gray.hex = function (gray) {
	var val = Math.round(gray[0] / 100 * 255) & 0xFF;
	var integer = (val << 16) + (val << 8) + val;

	var string = integer.toString(16).toUpperCase();
	return '000000'.substring(string.length) + string;
};

convert.rgb.gray = function (rgb) {
	var val = (rgb[0] + rgb[1] + rgb[2]) / 3;
	return [val / 255 * 100];
};


/***/ }),
/* 258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isValidHexColor; });
var isValidHexColor=function isValidHexColor(color){return /(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i.test(color);};

/***/ }),
/* 259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_grid_styled__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_grid_styled___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_grid_styled__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_connect__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_helpers_variables__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_blocks_StartPageBlock__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__actions_actionCreators__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_LinedHeading__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_InstagramPost__ = __webpack_require__(632);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__constants_endpoints__ = __webpack_require__(9);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var InstagramSection=function(_PureComponent){_inherits(InstagramSection,_PureComponent);function InstagramSection(){_classCallCheck(this,InstagramSection);return _possibleConstructorReturn(this,(InstagramSection.__proto__||Object.getPrototypeOf(InstagramSection)).apply(this,arguments));}_createClass(InstagramSection,[{key:'componentDidMount',value:function componentDidMount(){this.props.fetchInstagramPosts({endpointUrl:__WEBPACK_IMPORTED_MODULE_11__constants_endpoints__["l" /* INSTAGRAM_API_URL */]});}},{key:'renderInstagramPosts',value:function renderInstagramPosts(){return this.props.instagram.map(function(post){var imageUrl=post.getIn(['images','standard_resolution','url']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grid_styled__["Box"],{key:post.get('id'),width:[1/2,1/2,1/4],p:['5px','8px','11px']},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_InstagramPost__["a" /* default */],{url:post.get('link'),imageUrl:imageUrl}));}).toArray();}},{key:'render',value:function render(){var viewstate=this.props.viewstate;var instagramPosts=this.renderInstagramPosts();return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__styles_blocks_StartPageBlock__["a" /* StartPageBlock */].Section,{backgroundColor:__WEBPACK_IMPORTED_MODULE_6__styles_helpers_variables__["c" /* color */].lightBlack,pt:viewstate.get('pageWidth')<=__WEBPACK_IMPORTED_MODULE_6__styles_helpers_variables__["f" /* size */].large?30:35,pb:viewstate.get('pageWidth')<=__WEBPACK_IMPORTED_MODULE_6__styles_helpers_variables__["f" /* size */].large?60:100},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__styles_blocks_StartPageBlock__["a" /* StartPageBlock */].Container,{bgColor:__WEBPACK_IMPORTED_MODULE_6__styles_helpers_variables__["c" /* color */].lightBlack},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_LinedHeading__["a" /* default */],{color:__WEBPACK_IMPORTED_MODULE_6__styles_helpers_variables__["c" /* color */].white,noBottomMargin:true},'F\xF6lj oss p\xE5 Instagram'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__styles_blocks_StartPageBlock__["a" /* StartPageBlock */].InstagramHashTag,{href:'https://www.instagram.com/valamagasinet/',target:'_blank'},'@valamagasinet'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_styled_components__["ThemeProvider"],{theme:{breakpoints:['500px','730px','800px','1200px']}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grid_styled__["Flex"],{flexWrap:'wrap',mx:['-5px','-8px','-11px']},instagramPosts))));}}]);return InstagramSection;}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);InstagramSection.defaultProps={viewstate:Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])(),instagram:Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])()};InstagramSection.propTypes={viewstate:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"]),instagram:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"]),fetchInstagramPosts:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5__store_connect__["a" /* default */])(InstagramSection,{fetchInstagramPosts:__WEBPACK_IMPORTED_MODULE_8__actions_actionCreators__["E" /* fetchInstagramPosts */]},function(store){return{viewstate:store.viewstate,instagram:store.instagram};}));

/***/ }),
/* 260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Container */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ProductCardTitle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ProductTagContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProductCardContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ProductCardLink; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_grid_styled__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_grid_styled___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_grid_styled__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_immutable__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_RenderPrice__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_analyticEvents__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_helpers_mixins__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_MainProductImage__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__styles_helpers_variables__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__styles_ProductVariant__ = __webpack_require__(637);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__styles_ProductTag__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__styles_ProductImage__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__styles_SubHeading__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__constants_endpoints__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__constants_imageTypes__ = __webpack_require__(110);
var _templateObject=_taggedTemplateLiteral(['\n  text-align: center;\n'],['\n  text-align: center;\n']),_templateObject2=_taggedTemplateLiteral(['\n  ',';\n  ',';\n  margin: 0.25em 0;\n  line-height: 1.3;\n  ',';\n'],['\n  ',';\n  ',';\n  margin: 0.25em 0;\n  line-height: 1.3;\n  ',';\n']),_templateObject3=_taggedTemplateLiteral(['\n  position: absolute;\n  display: flex;\n  flex-wrap: wrap;\n  width: 60%;\n  top: 10px;\n  left: 8px;\n  z-index: 1;\n  @media screen and (min-width: ','px) {\n    top: 11px;\n    left: 11px;\n  }\n'],['\n  position: absolute;\n  display: flex;\n  flex-wrap: wrap;\n  width: 60%;\n  top: 10px;\n  left: 8px;\n  z-index: 1;\n  @media screen and (min-width: ','px) {\n    top: 11px;\n    left: 11px;\n  }\n']),_templateObject4=_taggedTemplateLiteral(['\n  background-color: #fff;\n  margin: 0;\n  padding: 0 0 10px;\n  position: relative;\n  height: 100%;\n\n  &:after {\n    content: \'\';\n    transition: opacity 0.4s ',';\n    box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.2);\n    opacity: 0;\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n  }\n\n  ',';\n'],['\n  background-color: #fff;\n  margin: 0;\n  padding: 0 0 10px;\n  position: relative;\n  height: 100%;\n\n  &:after {\n    content: \'\';\n    transition: opacity 0.4s ',';\n    box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.2);\n    opacity: 0;\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n  }\n\n  ',';\n']),_templateObject5=_taggedTemplateLiteral(['\n      padding: 0;\n      > div {\n        &:first-child {\n          > div {\n            padding: 10px;\n            > img {\n              margin: 0;\n            }\n          }\n        }\n        &:last-child {\n          padding: 0 10px 20px;\n          > p {\n            margin: 0 0 5px;\n            padding: 0;\n            font-family: \'Open Sans\';\n            font-size: 12px;\n            line-height: 1.25;\n            @media screen and (min-width: 1180px) {\n              font-size: 14px;\n            }\n          }\n          > div {\n            margin: 0;\n            > p {\n              margin: 0;\n              font-size: 12px;\n              line-height: 1.25;\n              @media screen and (min-width: 1180px) {\n                font-size: 14px;\n              }\n              > span {\n                font-size: 10px;\n              }\n            }\n          }\n        }\n      }\n    '],['\n      padding: 0;\n      > div {\n        &:first-child {\n          > div {\n            padding: 10px;\n            > img {\n              margin: 0;\n            }\n          }\n        }\n        &:last-child {\n          padding: 0 10px 20px;\n          > p {\n            margin: 0 0 5px;\n            padding: 0;\n            font-family: \'Open Sans\';\n            font-size: 12px;\n            line-height: 1.25;\n            @media screen and (min-width: 1180px) {\n              font-size: 14px;\n            }\n          }\n          > div {\n            margin: 0;\n            > p {\n              margin: 0;\n              font-size: 12px;\n              line-height: 1.25;\n              @media screen and (min-width: 1180px) {\n                font-size: 14px;\n              }\n              > span {\n                font-size: 10px;\n              }\n            }\n          }\n        }\n      }\n    ']),_templateObject6=_taggedTemplateLiteral(['\n  color: inherit;\n  text-decoration: none;\n  transition: opacity ',' ',';\n\n  &:hover {\n    opacity: 0.8;\n    ',':after {\n      opacity: 1;\n    }\n  }\n'],['\n  color: inherit;\n  text-decoration: none;\n  transition: opacity ',' ',';\n\n  &:hover {\n    opacity: 0.8;\n    ',':after {\n      opacity: 1;\n    }\n  }\n']),_templateObject7=_taggedTemplateLiteral(['\n  background-color: #fff;\n  margin: 0;\n  padding: 0;\n\n  width: calc(50% - ',');\n  @media (min-width: 640px) {\n    width: calc(50% - ',');\n  }\n  @media (min-width: 832px) {\n    width: calc(50% - ',');\n  }\n  @media (min-width: 1024px) {\n    width: calc(50% - ',');\n  }\n'],['\n  background-color: #fff;\n  margin: 0;\n  padding: 0;\n\n  width: calc(50% - ',');\n  @media (min-width: 640px) {\n    width: calc(50% - ',');\n  }\n  @media (min-width: 832px) {\n    width: calc(50% - ',');\n  }\n  @media (min-width: 1024px) {\n    width: calc(50% - ',');\n  }\n']),_templateObject8=_taggedTemplateLiteral(['\n  background-size: cover;\n  background-image: url(/images/sofa-in-room.png);\n  background-repeat: no-repeat;\n  background-position: center;\n\n  width: calc(50% + ',');\n  @media (min-width: 640px) {\n    width: calc(50% + ',');\n  }\n  @media (min-width: 832px) {\n    width: calc(50% + ',');\n  }\n  @media (min-width: 1024px) {\n    width: calc(50% + ',');\n  }\n'],['\n  background-size: cover;\n  background-image: url(/images/sofa-in-room.png);\n  background-repeat: no-repeat;\n  background-position: center;\n\n  width: calc(50% + ',');\n  @media (min-width: 640px) {\n    width: calc(50% + ',');\n  }\n  @media (min-width: 832px) {\n    width: calc(50% + ',');\n  }\n  @media (min-width: 1024px) {\n    width: calc(50% + ',');\n  }\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var GetItemTag=function GetItemTag(item){var defaultVariant=item.get('variants').find(function(variant){return variant.get('id')===item.get('defaultVariantId');});var tags=defaultVariant.get('tags',Object(__WEBPACK_IMPORTED_MODULE_5_immutable__["List"])());if(!tags.isEmpty()){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ProductTagContainer,null,tags.map(function(tag){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__styles_ProductTag__["a" /* ProductTag */],{key:tag.get('key'),color:tag.get('key')},tag.get('value'));}));}return false;};var ProductCard=function ProductCard(props){var item=props.item,isHighlightCard=props.isHighlightCard,showVariantImage=props.showVariantImage,activeFilterColor=props.activeFilterColor;if(!item.get('url'))return false;var itemTag=GetItemTag(item);// If the product has no variants, assume it's a product variant and render the card for a variant
if(!props.item.get('variants',__WEBPACK_IMPORTED_MODULE_5_immutable__["List"]).size){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ProductCardLink,{key:item.get('id'),to:item.get('url'),onClick:function onClick(){Object(__WEBPACK_IMPORTED_MODULE_7__util_analyticEvents__["e" /* analyticsProductClickEvent */])('productClick','Category Page',item);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ProductCardContainer,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_MainProductImage__["a" /* default */],{insideList:true},itemTag,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__styles_ProductImage__["a" /* ProductImage */],{src:__WEBPACK_IMPORTED_MODULE_15__constants_endpoints__["n" /* SITE_ROOT_URL */]+item.getIn(['images',0,'url']),alt:item.getIn(['images',0,'alt'])})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Container,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__styles_SubHeading__["a" /* SubHeading */],{small:true,uppercase:true,title:item.get('manufacturer')},item.getIn(['brand','name'])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ProductCardTitle,{title:item.get('name')},item.get('name')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_RenderPrice__["a" /* default */],{small:true,fontWeight:'600',price:item.get('price'),originalPrice:item.get('originalPrice')}))));}var cheapestVariant=item.get('variants').sortBy(function(variant){return variant.get('price');}).take(1).get(0);// check if product variants all the same price, or if they are different
var usePriceFrom=props.item.get('variants').filter(function(variant){return variant.get('price')===cheapestVariant.get('price');}).size!==props.item.get('variants').size;if(isHighlightCard){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grid_styled__["Flex"],{flexDirection:'row-reverse'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ProductListHighlightContainer,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_MainProductImage__["a" /* default */],{insideList:true},itemTag,item.get('variants')&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__styles_ProductVariant__["a" /* ProductVariant */],null,item.get('variants')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__styles_ProductImage__["a" /* ProductImage */],{src:__WEBPACK_IMPORTED_MODULE_15__constants_endpoints__["n" /* SITE_ROOT_URL */]+item.getIn(['mainImage','url']),alt:item.getIn(['mainImage','alt'])})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Container,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__styles_SubHeading__["a" /* SubHeading */],{small:true,uppercase:true,title:item.get('manufacturer')},item.get('manufacturer')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ProductCardTitle,{title:item.get('name')},item.get('name')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_RenderPrice__["a" /* default */],{small:true,fontWeight:'600',price:item.get('price'),originalPrice:item.get('originalPrice')}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(HighlightImage,null));}var productImage=__WEBPACK_IMPORTED_MODULE_15__constants_endpoints__["n" /* SITE_ROOT_URL */]+item.getIn(['mainImage','url']);var productImageAlt=item.getIn(['mainImage','alt']);var mainImageIsMaterialImage=item.get('variants').find(function(variant){return variant.get('id')===item.get('defaultVariantId');}).getIn(['mainImage','type'])===__WEBPACK_IMPORTED_MODULE_16__constants_imageTypes__["b" /* MATERIAL_IMAGE */];var activeUrl=activeFilterColor?item.get('variants').find(function(variant){return variant.get('filterColor')===activeFilterColor;}).get('url'):item.get('url');if(showVariantImage&&!mainImageIsMaterialImage&&!item.get('allVariantsHaveSameRelevance')){var variantImage=item.get('variants').find(function(variant){return variant.get('id')===item.get('defaultVariantId');});productImage=__WEBPACK_IMPORTED_MODULE_15__constants_endpoints__["n" /* SITE_ROOT_URL */]+variantImage.getIn(['mainImage','url']);productImageAlt=variantImage.getIn(['mainImage','alt']);}if(activeFilterColor&&!mainImageIsMaterialImage){var activeFilterColorVariant=item.get('variants').find(function(variant){return variant.get('filterColor')===activeFilterColor;});productImage=__WEBPACK_IMPORTED_MODULE_15__constants_endpoints__["n" /* SITE_ROOT_URL */]+activeFilterColorVariant.getIn(['mainImage','url']);productImageAlt=activeFilterColorVariant.getIn(['mainImage','alt']);}if(props.simpleProductCard){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ProductCardLink,{to:activeUrl,onClick:function onClick(){Object(__WEBPACK_IMPORTED_MODULE_7__util_analyticEvents__["e" /* analyticsProductClickEvent */])('productClick','Recently Viewed',item);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ProductCardContainer,{simpleProductCard:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_MainProductImage__["a" /* default */],{insideList:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__styles_ProductImage__["a" /* ProductImage */],{src:productImage,alt:productImageAlt})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Container,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ProductCardTitle,{title:item.get('name')},item.get('name')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_RenderPrice__["a" /* default */],{small:true,fontWeight:'600',priceFrom:usePriceFrom,price:cheapestVariant.get('price'),originalPrice:cheapestVariant.get('originalPrice')}))));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ProductCardLink,{to:activeUrl,onClick:function onClick(){Object(__WEBPACK_IMPORTED_MODULE_7__util_analyticEvents__["e" /* analyticsProductClickEvent */])('productClick','Category Page',item);},onMouseEnter:props.onProductCardHover?function(){return props.onProductCardHover(true,item.get('variants').find(function(variant){return variant.get('id')===item.get('defaultVariantId');}).get('filterColor'));}:undefined,onMouseLeave:props.onProductCardHover?function(){return props.onProductCardHover(false);}:undefined},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ProductCardContainer,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_MainProductImage__["a" /* default */],{insideList:true},itemTag,item.get('variants').size>1&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__styles_ProductVariant__["a" /* ProductVariant */],null,item.get('variants').size,' varianter'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__styles_ProductImage__["a" /* ProductImage */],{src:productImage,alt:productImageAlt})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Container,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__styles_SubHeading__["a" /* SubHeading */],{uppercase:true,title:item.get('manufacturer')},item.getIn(['brand','name'])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ProductCardTitle,{title:item.get('name')},item.get('name')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_RenderPrice__["a" /* default */],{small:true,fontWeight:'600',priceFrom:usePriceFrom,price:cheapestVariant.get('price'),originalPrice:cheapestVariant.get('originalPrice')}))));};var Container=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].div(_templateObject);var ProductCardTitle=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].p(_templateObject2,__WEBPACK_IMPORTED_MODULE_8__styles_helpers_mixins__["e" /* fontFamilyHeading */],Object(__WEBPACK_IMPORTED_MODULE_8__styles_helpers_mixins__["b" /* dynamicFontSize */])(14,22),__WEBPACK_IMPORTED_MODULE_8__styles_helpers_mixins__["c" /* ellipsis */]);var ProductTagContainer=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].div(_templateObject3,__WEBPACK_IMPORTED_MODULE_10__styles_helpers_variables__["f" /* size */].medium);var ProductCardContainer=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].div(_templateObject4,__WEBPACK_IMPORTED_MODULE_10__styles_helpers_variables__["a" /* animation */].easing,function(props){return props.simpleProductCard&&Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["css"])(_templateObject5);});var ProductCardLink=Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* Link */])(_templateObject6,__WEBPACK_IMPORTED_MODULE_10__styles_helpers_variables__["a" /* animation */].transitionTime,__WEBPACK_IMPORTED_MODULE_10__styles_helpers_variables__["a" /* animation */].easing,ProductCardContainer);var ProductListHighlightContainer=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].div(_templateObject7,__WEBPACK_IMPORTED_MODULE_10__styles_helpers_variables__["e" /* responsiveListPadding */].rlpSmall,__WEBPACK_IMPORTED_MODULE_10__styles_helpers_variables__["e" /* responsiveListPadding */].rlpMedium,__WEBPACK_IMPORTED_MODULE_10__styles_helpers_variables__["e" /* responsiveListPadding */].rlpLarge,__WEBPACK_IMPORTED_MODULE_10__styles_helpers_variables__["e" /* responsiveListPadding */].rlpXLarge);var HighlightImage=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].div(_templateObject8,__WEBPACK_IMPORTED_MODULE_10__styles_helpers_variables__["e" /* responsiveListPadding */].rlpSmall,__WEBPACK_IMPORTED_MODULE_10__styles_helpers_variables__["e" /* responsiveListPadding */].rlpMedium,__WEBPACK_IMPORTED_MODULE_10__styles_helpers_variables__["e" /* responsiveListPadding */].rlpLarge,__WEBPACK_IMPORTED_MODULE_10__styles_helpers_variables__["e" /* responsiveListPadding */].rlpXLarge);ProductCard.defaultProps={isHighlightCard:false,onProductCardHover:null,showVariantImage:false,activeFilterColor:null,simpleProductCard:false};ProductCard.propTypes={item:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_5_immutable__["Map"]).isRequired,onProductCardHover:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,isHighlightCard:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,showVariantImage:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,activeFilterColor:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,simpleProductCard:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["e"] = (ProductCard);

/***/ }),
/* 261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HtmlWrapper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_mixins__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_variables__ = __webpack_require__(4);
var _templateObject=_taggedTemplateLiteral(['\n  h2,\n  h3,\n  h4,\n  h5,\n  h6,\n  p,\n  li {\n    font-weight: normal;\n    line-height: 1.714;\n    text-align: left;\n    margin: ',';\n    color: ',';\n  }\n\n  h2,\n  h3,\n  h4,\n  h5,\n  h6 {\n    font-weight: 600;\n    margin-bottom: 0;\n  }\n\n  h1 {\n    ',';\n    ',';\n    font-weight: normal;\n  }\n\n  h2 {\n    ',';\n    margin-bottom: 0.277em;\n    font-weight: 600;\n  }\n\n  h3 {\n    ',';\n    font-size: 1em;\n  }\n\n  h4 {\n    ',';\n    font-size: 16px;\n  }\n\n  h5 {\n    ',';\n    font-size: 14px;\n  }\n\n  h6 {\n    font-size: 12px;\n  }\n\n  p,\n  li {\n    ',';\n    margin-top: 0;\n  }\n\n  ul,\n  ol {\n    margin: 1.5em 0;\n  }\n\n  li {\n    margin-bottom: 0.5em;\n  }\n\n  a {\n    color: ',';\n  }\n\n  img {\n    max-width: 100%;\n    height: auto;\n  }\n\n  blockquote,\n  .blockquote {\n    ',';\n    ',';\n    margin: 2em 0;\n    font-weight: normal;\n    font-style: normal;\n    font-stretch: normal;\n    line-height: 1.44;\n    letter-spacing: normal;\n    text-align: left;\n    color: #000000;\n\n    &:after {\n      content: \'\';\n      display: block;\n      margin-top: 40px;\n      height: 1px;\n      width: 150px;\n      background-color: #979797;\n    }\n  }\n\n  iframe {\n    max-width: 100%;\n    height: auto;\n  }\n\n  .video-wrapper,\n  .youtube-container {\n    width: 100%;\n    height: 0;\n    padding-bottom: 56.25%; //value from (9 / 16) for standard youtube aspect ratio\n    position: relative;\n    margin: 34px 0;\n    cursor: pointer;\n\n    iframe {\n      position: absolute;\n      top: 0;\n      right: 0;\n      bottom: 0;\n      left: 0;\n      height: 100%;\n      width: 100%;\n    }\n  }\n'],['\n  h2,\n  h3,\n  h4,\n  h5,\n  h6,\n  p,\n  li {\n    font-weight: normal;\n    line-height: 1.714;\n    text-align: left;\n    margin: ',';\n    color: ',';\n  }\n\n  h2,\n  h3,\n  h4,\n  h5,\n  h6 {\n    font-weight: 600;\n    margin-bottom: 0;\n  }\n\n  h1 {\n    ',';\n    ',';\n    font-weight: normal;\n  }\n\n  h2 {\n    ',';\n    margin-bottom: 0.277em;\n    font-weight: 600;\n  }\n\n  h3 {\n    ',';\n    font-size: 1em;\n  }\n\n  h4 {\n    ',';\n    font-size: 16px;\n  }\n\n  h5 {\n    ',';\n    font-size: 14px;\n  }\n\n  h6 {\n    font-size: 12px;\n  }\n\n  p,\n  li {\n    ',';\n    margin-top: 0;\n  }\n\n  ul,\n  ol {\n    margin: 1.5em 0;\n  }\n\n  li {\n    margin-bottom: 0.5em;\n  }\n\n  a {\n    color: ',';\n  }\n\n  img {\n    max-width: 100%;\n    height: auto;\n  }\n\n  blockquote,\n  .blockquote {\n    ',';\n    ',';\n    margin: 2em 0;\n    font-weight: normal;\n    font-style: normal;\n    font-stretch: normal;\n    line-height: 1.44;\n    letter-spacing: normal;\n    text-align: left;\n    color: #000000;\n\n    &:after {\n      content: \'\';\n      display: block;\n      margin-top: 40px;\n      height: 1px;\n      width: 150px;\n      background-color: #979797;\n    }\n  }\n\n  iframe {\n    max-width: 100%;\n    height: auto;\n  }\n\n  .video-wrapper,\n  .youtube-container {\n    width: 100%;\n    height: 0;\n    padding-bottom: 56.25%; //value from (9 / 16) for standard youtube aspect ratio\n    position: relative;\n    margin: 34px 0;\n    cursor: pointer;\n\n    iframe {\n      position: absolute;\n      top: 0;\n      right: 0;\n      bottom: 0;\n      left: 0;\n      height: 100%;\n      width: 100%;\n    }\n  }\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var HtmlWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].div(_templateObject,function(props){return props.mobileMargin?'.5em 0 2em':'1.5em 0';},__WEBPACK_IMPORTED_MODULE_2__helpers_variables__["c" /* color */].black,__WEBPACK_IMPORTED_MODULE_1__helpers_mixins__["e" /* fontFamilyHeading */],Object(__WEBPACK_IMPORTED_MODULE_1__helpers_mixins__["b" /* dynamicFontSize */])(24,32,__WEBPACK_IMPORTED_MODULE_2__helpers_variables__["f" /* size */].small,__WEBPACK_IMPORTED_MODULE_2__helpers_variables__["f" /* size */].medium),Object(__WEBPACK_IMPORTED_MODULE_1__helpers_mixins__["b" /* dynamicFontSize */])(16,18,__WEBPACK_IMPORTED_MODULE_2__helpers_variables__["f" /* size */].small,__WEBPACK_IMPORTED_MODULE_2__helpers_variables__["f" /* size */].medium),Object(__WEBPACK_IMPORTED_MODULE_1__helpers_mixins__["b" /* dynamicFontSize */])(16,18,__WEBPACK_IMPORTED_MODULE_2__helpers_variables__["f" /* size */].small,__WEBPACK_IMPORTED_MODULE_2__helpers_variables__["f" /* size */].medium),Object(__WEBPACK_IMPORTED_MODULE_1__helpers_mixins__["b" /* dynamicFontSize */])(14,16,__WEBPACK_IMPORTED_MODULE_2__helpers_variables__["f" /* size */].small,__WEBPACK_IMPORTED_MODULE_2__helpers_variables__["f" /* size */].medium),Object(__WEBPACK_IMPORTED_MODULE_1__helpers_mixins__["b" /* dynamicFontSize */])(12,14,__WEBPACK_IMPORTED_MODULE_2__helpers_variables__["f" /* size */].small,__WEBPACK_IMPORTED_MODULE_2__helpers_variables__["f" /* size */].medium),Object(__WEBPACK_IMPORTED_MODULE_1__helpers_mixins__["b" /* dynamicFontSize */])(14,16,__WEBPACK_IMPORTED_MODULE_2__helpers_variables__["f" /* size */].small,__WEBPACK_IMPORTED_MODULE_2__helpers_variables__["f" /* size */].medium),__WEBPACK_IMPORTED_MODULE_2__helpers_variables__["c" /* color */].primaryDark,__WEBPACK_IMPORTED_MODULE_1__helpers_mixins__["e" /* fontFamilyHeading */],Object(__WEBPACK_IMPORTED_MODULE_1__helpers_mixins__["b" /* dynamicFontSize */])(22,32));

/***/ }),
/* 262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_grid_styled__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_grid_styled___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_grid_styled__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions_actionCreators__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_connect__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_FilterOption__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants_filterColors__ = __webpack_require__(654);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  width: 100%;\n'],['\n  width: 100%;\n']),_templateObject2=_taggedTemplateLiteral(['\n  width: 100%;\n  font-size: 14px;\n  font-weight: 300;\n  line-height: 1.25;\n'],['\n  width: 100%;\n  font-size: 14px;\n  font-weight: 300;\n  line-height: 1.25;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var FiltersList=function(_Component){_inherits(FiltersList,_Component);function FiltersList(){_classCallCheck(this,FiltersList);return _possibleConstructorReturn(this,(FiltersList.__proto__||Object.getPrototypeOf(FiltersList)).apply(this,arguments));}_createClass(FiltersList,[{key:'getFilterOptions',value:function getFilterOptions(type,filterArray){var _this2=this;return this.props.products.map(function(item){return item.getIn(filterArray);}).filter(function(item){return typeof item!=='undefined';}).toSet().sort(function(a,b){if(a.toLowerCase()<b.toLowerCase())return-1;if(a.toLowerCase()>b.toLowerCase())return 1;return 0;}).map(function(item){if(!item)return false;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grid_styled__["Box"],{key:'key-'+item,width:_this2.props.width,px:_this2.props.margin},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__styles_FilterOption__["a" /* FilterOption */],{active:_this2.props.viewstate.getIn(['filter',type,item],false),onClick:function onClick(){return _this2.toggleFilter(type,item);}},item));}).toArray();}},{key:'getFilterOptionsForColor',value:function getFilterOptionsForColor(type){var _this3=this;return this.props.products.map(function(item){return item.getIn(['variants']);}).map(function(item){return item.reduce(function(memory,x){return memory.push(x.getIn(['filterColor']));},Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["List"])());}).reduce(function(memory,item){return memory.push.apply(memory,_toConsumableArray(item));},Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["List"])()).toSet().filter(function(item){return __WEBPACK_IMPORTED_MODULE_8__constants_filterColors__["a" /* filterColors */][item];}).sort(function(a,b){if(__WEBPACK_IMPORTED_MODULE_8__constants_filterColors__["a" /* filterColors */][a].name.toLowerCase()<__WEBPACK_IMPORTED_MODULE_8__constants_filterColors__["a" /* filterColors */][b].name.toLowerCase())return-1;if(__WEBPACK_IMPORTED_MODULE_8__constants_filterColors__["a" /* filterColors */][a].name.toLowerCase()>__WEBPACK_IMPORTED_MODULE_8__constants_filterColors__["a" /* filterColors */][b].name.toLowerCase())return 1;return 0;}).map(function(item){if(!__WEBPACK_IMPORTED_MODULE_8__constants_filterColors__["a" /* filterColors */][item])return false;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grid_styled__["Box"],{key:item,width:_this3.props.width,px:_this3.props.margin},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__styles_FilterOption__["a" /* FilterOption */],{radioButton:true,backgroundColor:__WEBPACK_IMPORTED_MODULE_8__constants_filterColors__["a" /* filterColors */][item].value,active:_this3.props.viewstate.getIn(['filter',type,item],false),onClick:function onClick(){return _this3.toggleFilter(type,item);}},__WEBPACK_IMPORTED_MODULE_8__constants_filterColors__["a" /* filterColors */][item].name));}).toArray();}},{key:'toggleFilter',value:function toggleFilter(type,id){var filterExists=this.props.viewstate.hasIn(['filter',type,id]);if(type==='color'&&!filterExists&&this.props.viewstate.hasIn(['filter',type])){this.props.removeViewstate(['filter',type]);this.props.setViewstate(['filter',type,id],true);}else if(!filterExists){this.props.setViewstate(['filter',type,id],true);}else{this.props.removeViewstate(['filter',type,id]);}}},{key:'render',value:function render(){var _props=this.props,type=_props.type,selector=_props.selector,marginBottom=_props.marginBottom,forColor=_props.forColor;var filters=forColor?this.getFilterOptionsForColor(type,selector):this.getFilterOptions(type,selector);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FullWidthFlex,{flexWrap:'wrap',mb:marginBottom},filters.length>0?filters:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(NoFilterOptions,null,'Inga tillg\xE4ngliga filtreringsval'));}}]);return FiltersList;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var FullWidthFlex=Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_4_grid_styled__["Flex"])(_templateObject);var NoFilterOptions=__WEBPACK_IMPORTED_MODULE_3_styled_components__["default"].p(_templateObject2);FiltersList.defaultProps={margin:40,marginBottom:0,width:[1,1/2,1/3,1/4],forColor:false};FiltersList.propTypes={margin:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,marginBottom:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,width:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,products:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"]).isRequired,viewstate:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"]).isRequired,setViewstate:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,removeViewstate:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,type:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,selector:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array.isRequired,forColor:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6__store_connect__["a" /* default */])(FiltersList,{setViewstate:__WEBPACK_IMPORTED_MODULE_5__actions_actionCreators__["W" /* setViewstate */],removeViewstate:__WEBPACK_IMPORTED_MODULE_5__actions_actionCreators__["V" /* removeViewstate */]},function(store){return{viewstate:store.viewstate};}));

/***/ }),
/* 263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_grid_styled__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_grid_styled___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_grid_styled__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions_actionCreators__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_connect__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_FilterOption__ = __webpack_require__(164);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  width: 100%;\n'],['\n  width: 100%;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SortingList=function(_Component){_inherits(SortingList,_Component);function SortingList(){_classCallCheck(this,SortingList);return _possibleConstructorReturn(this,(SortingList.__proto__||Object.getPrototypeOf(SortingList)).apply(this,arguments));}_createClass(SortingList,[{key:'setSortBy',value:function setSortBy(key,ascending){this.props.setViewstate('sortBy',key);this.props.setViewstate('sortAscending',ascending);}},{key:'render',value:function render(){var _this2=this;var _props=this.props,width=_props.width,margin=_props.margin,marginBottom=_props.marginBottom,includeRelevance=_props.includeRelevance;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FullWidthFlex,{flexWrap:'wrap',mb:marginBottom},includeRelevance?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grid_styled__["Box"],{width:width,px:margin},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__styles_FilterOption__["a" /* FilterOption */],{radioButton:true,active:this.props.viewstate.get('sortBy')==='relevance'&&this.props.viewstate.get('sortAscending'),onClick:function onClick(){return _this2.setSortBy('relevance',true);}},'S\xF6krelevans')):false,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grid_styled__["Box"],{width:width,px:margin},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__styles_FilterOption__["a" /* FilterOption */],{radioButton:true,active:this.props.viewstate.get('sortBy')==='name'&&!this.props.viewstate.get('sortAscending'),onClick:function onClick(){return _this2.setSortBy('name',false);}},'Namn (A-\xD6)')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grid_styled__["Box"],{width:width,px:margin},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__styles_FilterOption__["a" /* FilterOption */],{radioButton:true,active:this.props.viewstate.get('sortBy')==='name'&&this.props.viewstate.get('sortAscending'),onClick:function onClick(){return _this2.setSortBy('name',true);}},'Namn (\xD6-A)')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grid_styled__["Box"],{width:width,px:margin},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__styles_FilterOption__["a" /* FilterOption */],{radioButton:true,active:this.props.viewstate.get('sortBy')==='price'&&!this.props.viewstate.get('sortAscending'),onClick:function onClick(){return _this2.setSortBy('price',false);}},'Pris l\xE5gt till h\xF6gt')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grid_styled__["Box"],{width:width,px:margin},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__styles_FilterOption__["a" /* FilterOption */],{radioButton:true,active:this.props.viewstate.get('sortBy')==='price'&&this.props.viewstate.get('sortAscending'),onClick:function onClick(){return _this2.setSortBy('price',true);}},'Pris h\xF6gt till l\xE5gt')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grid_styled__["Box"],{width:width,px:margin},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__styles_FilterOption__["a" /* FilterOption */],{radioButton:true,active:this.props.viewstate.get('sortBy')==='addedDate'&&this.props.viewstate.get('sortAscending'),onClick:function onClick(){return _this2.setSortBy('addedDate',true);}},'Senast inkommet')));}}]);return SortingList;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var FullWidthFlex=Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_4_grid_styled__["Flex"])(_templateObject);SortingList.defaultProps={viewstate:Object(__WEBPACK_IMPORTED_MODULE_3_immutable__["Map"])(),margin:40,marginBottom:0,width:[1,1/2,1/3,1/4],includeRelevance:false};SortingList.propTypes={setViewstate:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,viewstate:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_3_immutable__["Map"]),margin:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,marginBottom:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,width:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),includeRelevance:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6__store_connect__["a" /* default */])(SortingList,{setViewstate:__WEBPACK_IMPORTED_MODULE_5__actions_actionCreators__["W" /* setViewstate */]},function(store){return{viewstate:store.viewstate};}));

/***/ }),
/* 264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_animate_height__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_animate_height___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_animate_height__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_helpers_mixins__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_helpers_variables__ = __webpack_require__(4);
var _templateObject=_taggedTemplateLiteral(['\n  width: 100%;\n  font-weight: 600;\n'],['\n  width: 100%;\n  font-weight: 600;\n']),_templateObject2=_taggedTemplateLiteral(['\n  color: ',';\n\n  &:before {\n    content: \' (\';\n    color: ',';\n  }\n\n  &:after {\n    content: \')\';\n    color: ',';\n  }\n'],['\n  color: ',';\n\n  &:before {\n    content: \' (\';\n    color: ',';\n  }\n\n  &:after {\n    content: \')\';\n    color: ',';\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  flex: 1;\n  padding: 0 14px 0 0;\n  margin: 18px 0;\n  font-size: 12px;\n  font-weight: 600 !important;\n'],['\n  flex: 1;\n  padding: 0 14px 0 0;\n  margin: 18px 0;\n  font-size: 12px;\n  font-weight: 600 !important;\n']),_templateObject4=_taggedTemplateLiteral(['\n  ',';\n  width: 100%;\n  padding: 0 1rem 0 0;\n  outline: 0;\n  cursor: pointer;\n  border: ',';\n  border-left: 0;\n  border-right: 0;\n  background-color: transparent;\n  border-bottom: none;\n\n  font-size: 12px;\n  font-weight: 600;\n  font-style: normal;\n  font-stretch: normal;\n  line-height: normal;\n  letter-spacing: 2px;\n  text-align: left;\n  color: ',';\n  text-transform: uppercase;\n\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n\n  &:after {\n    content: \'\';\n    background-image: ',';\n    background-size: contain;\n    background-repeat: no-repeat;\n    min-width: 12px;\n    height: 12px;\n    justify-self: flex-end;\n    display: block;\n    margin-left: 10px;\n    transition: transform ',' ',';\n    ',';\n  }\n\n  ',';\n\n  @media screen and (min-width: ','px) {\n    font-size: 13px;\n  }\n'],['\n  ',';\n  width: 100%;\n  padding: 0 1rem 0 0;\n  outline: 0;\n  cursor: pointer;\n  border: ',';\n  border-left: 0;\n  border-right: 0;\n  background-color: transparent;\n  border-bottom: none;\n\n  font-size: 12px;\n  font-weight: 600;\n  font-style: normal;\n  font-stretch: normal;\n  line-height: normal;\n  letter-spacing: 2px;\n  text-align: left;\n  color: ',';\n  text-transform: uppercase;\n\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n\n  &:after {\n    content: \'\';\n    background-image: ',';\n    background-size: contain;\n    background-repeat: no-repeat;\n    min-width: 12px;\n    height: 12px;\n    justify-self: flex-end;\n    display: block;\n    margin-left: 10px;\n    transition: transform ',' ',';\n    ',';\n  }\n\n  ',';\n\n  @media screen and (min-width: ','px) {\n    font-size: 13px;\n  }\n']),_templateObject5=_taggedTemplateLiteral(['\n        transform: rotateX(180deg);\n      '],['\n        transform: rotateX(180deg);\n      ']),_templateObject6=_taggedTemplateLiteral(['\n      border-bottom: none;\n    '],['\n      border-bottom: none;\n    ']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var AccordionItemWithText=function AccordionItemWithText(props){var index=props.index,isActive=props.isActive,isLastItem=props.isLastItem,children=props.children,title=props.title,setActive=props.setActive,number=props.number,darkTheme=props.darkTheme;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(AccordionItemContainer,{darkTheme:darkTheme,active:isActive,lastItem:isLastItem},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(AccordionItemButton,{darkTheme:darkTheme,active:isActive,lastItem:isLastItem,onClick:function onClick(){return setActive(index);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(AccordionItemTitle,null,title,number>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Number,null,number))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_animate_height___default.a,{className:'animation',duration:250,easing:'ease-out',height:isActive?'auto':0},children));};var AccordionItemContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject);var Number=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].span(_templateObject2,__WEBPACK_IMPORTED_MODULE_5__styles_helpers_variables__["c" /* color */].primary,__WEBPACK_IMPORTED_MODULE_5__styles_helpers_variables__["c" /* color */].black,__WEBPACK_IMPORTED_MODULE_5__styles_helpers_variables__["c" /* color */].black);var AccordionItemTitle=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].p(_templateObject3);var AccordionItemButton=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].button(_templateObject4,__WEBPACK_IMPORTED_MODULE_4__styles_helpers_mixins__["d" /* fontFamilyBody */],function(props){return props.theme.border;},function(props){return props.theme.fg;},function(props){return props.theme.arrow;},__WEBPACK_IMPORTED_MODULE_5__styles_helpers_variables__["a" /* animation */].transitionTime,__WEBPACK_IMPORTED_MODULE_5__styles_helpers_variables__["a" /* animation */].easing,function(props){return props.active&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject5);},function(props){return props.active&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject6);},__WEBPACK_IMPORTED_MODULE_5__styles_helpers_variables__["f" /* size */].large);AccordionItemWithText.defaultProps={number:0,isActive:false,isLastItem:false,darkTheme:false,title:'',index:null,setActive:function setActive(){}};AccordionItemWithText.propTypes={number:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,index:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,isActive:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,isLastItem:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,darkTheme:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,title:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,setActive:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,children:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node),__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node]).isRequired};/* harmony default export */ __webpack_exports__["a"] = (AccordionItemWithText);

/***/ }),
/* 265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export InputLabel */
/* unused harmony export InputRadioButton */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_helpers_variables__ = __webpack_require__(4);
var _templateObject=_taggedTemplateLiteral(['\n  margin: 10px 0;\n'],['\n  margin: 10px 0;\n']),_templateObject2=_taggedTemplateLiteral(['\n  width: 100%;\n  display: flex;\n  cursor: pointer;\n  position: relative;\n'],['\n  width: 100%;\n  display: flex;\n  cursor: pointer;\n  position: relative;\n']),_templateObject3=_taggedTemplateLiteral(['\n  &:checked,\n  &:not(:checked) {\n    position: absolute;\n    left: -9999px;\n  }\n  &:checked + label,\n  &:not(:checked) + label {\n    position: relative;\n    padding-left: 16px;\n    cursor: pointer;\n  }\n  &:checked + label:before,\n  &:not(:checked) + label:before {\n    content: \'\';\n    position: absolute;\n    left: 0;\n    top: 0;\n    width: 18px;\n    height: 18px;\n    border: 1px solid ',';\n    border-radius: 100%;\n    background-color: ',';\n  }\n  &:checked + label:after,\n  &:not(:checked) + label:after {\n    content: \'\';\n    width: 10px;\n    height: 10px;\n    background-color: ',';\n    position: absolute;\n    top: 5px;\n    left: 5px;\n    border-radius: 100%;\n    transition: transform 250ms ease-out, opacity 500ms ease-out;\n  }\n  &:not(:checked) + label:after {\n    opacity: 0;\n    transform: scale(0);\n  }\n  &:checked + label:after {\n    opacity: 1;\n    transform: scale(1);\n  }\n'],['\n  &:checked,\n  &:not(:checked) {\n    position: absolute;\n    left: -9999px;\n  }\n  &:checked + label,\n  &:not(:checked) + label {\n    position: relative;\n    padding-left: 16px;\n    cursor: pointer;\n  }\n  &:checked + label:before,\n  &:not(:checked) + label:before {\n    content: \'\';\n    position: absolute;\n    left: 0;\n    top: 0;\n    width: 18px;\n    height: 18px;\n    border: 1px solid ',';\n    border-radius: 100%;\n    background-color: ',';\n  }\n  &:checked + label:after,\n  &:not(:checked) + label:after {\n    content: \'\';\n    width: 10px;\n    height: 10px;\n    background-color: ',';\n    position: absolute;\n    top: 5px;\n    left: 5px;\n    border-radius: 100%;\n    transition: transform 250ms ease-out, opacity 500ms ease-out;\n  }\n  &:not(:checked) + label:after {\n    opacity: 0;\n    transform: scale(0);\n  }\n  &:checked + label:after {\n    opacity: 1;\n    transform: scale(1);\n  }\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var RadioButton=function RadioButton(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(RadioButtonContainer,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(InputRadioButton,{id:props.id,theme:props.theme,name:props.name,defaultChecked:props.defaultChecked,value:props.value,onChange:props.onChange,checked:props.checked}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(InputLabel,{htmlFor:props.id},props.children));};RadioButton.defaultProps={defaultChecked:false,onChange:function onChange(){},value:null,theme:null,checked:false};RadioButton.propTypes={id:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,name:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,defaultChecked:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,onChange:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,value:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,theme:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,children:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node),__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node]).isRequired,checked:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (RadioButton);var RadioButtonContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject);var InputLabel=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].label(_templateObject2);var InputRadioButton=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].input.attrs({type:'radio'})(_templateObject3,__WEBPACK_IMPORTED_MODULE_3__styles_helpers_variables__["c" /* color */].grey,function(props){return props.theme==='white'?__WEBPACK_IMPORTED_MODULE_3__styles_helpers_variables__["c" /* color */].white:__WEBPACK_IMPORTED_MODULE_3__styles_helpers_variables__["c" /* color */].lightGrey;},__WEBPACK_IMPORTED_MODULE_3__styles_helpers_variables__["c" /* color */].primary);

/***/ }),
/* 266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return initializePayment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getDeliveryMethods; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return setDeliveryMethod; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return finalizePayment; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_endpoints__ = __webpack_require__(9);
var initializePayment=function initializePayment(){var method='POST';var headers=new window.Headers();var credentials='include';var mode='cors';var url=__WEBPACK_IMPORTED_MODULE_0__constants_endpoints__["g" /* CHECKOUT_API_URL */];headers.append('Accept','application/json');var options={headers:headers,method:method,credentials:credentials,mode:mode};return window.fetch(url,options).then(function(response){if(response.ok){return response.json();}return response.error;}).then(function(json){return json;}).catch(function(error){throw error;});};var getDeliveryMethods=function getDeliveryMethods(){var method='GET';var headers=new window.Headers();var credentials='include';var mode='cors';var url=__WEBPACK_IMPORTED_MODULE_0__constants_endpoints__["j" /* GET_DELIVERY_METHODS_URL */];headers.append('Accept','application/json');var options={headers:headers,method:method,credentials:credentials,mode:mode};return window.fetch(url,options).then(function(response){if(response.ok){return response.json();}return response.error;}).then(function(json){return json;}).catch(function(error){throw error;});};var setDeliveryMethod=function setDeliveryMethod(deliveryMethodId,avardaSessionId){var method='POST';var headers=new window.Headers();var credentials='include';var mode='cors';var url=__WEBPACK_IMPORTED_MODULE_0__constants_endpoints__["m" /* SET_DELIVERY_METHOD_URL */]+'?deliveryMethod='+deliveryMethodId+(avardaSessionId?'&purchaseId='+avardaSessionId:'');headers.append('Accept','application/json');var options={headers:headers,method:method,credentials:credentials,mode:mode};return window.fetch(url,options).then(function(response){if(response.ok){return response.status;}return response.error;}).then(function(json){return json;}).catch(function(error){throw error;});};var finalizePayment=function finalizePayment(avardaId){var method='POST';var headers=new window.Headers();var credentials='include';var mode='cors';var url=__WEBPACK_IMPORTED_MODULE_0__constants_endpoints__["i" /* FINALIZE_PAYMENT_URL */]+'?purchaseId='+avardaId;headers.append('Accept','application/json');var options={headers:headers,method:method,credentials:credentials,mode:mode};return window.fetch(url,options).then(function(response){if(response.ok){return response.json();}return response.error;}).then(function(json){return json;}).catch(function(error){throw error;});};

/***/ }),
/* 267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_helpers_variables__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_helpers_mixins__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_Heading__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_Preamble__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_ProductTag__ = __webpack_require__(115);
var _templateObject=_taggedTemplateLiteral(['\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  margin-bottom: 27px;\n  text-decoration: none;\n  color: ',';\n\n  @media screen and (min-width: 1000px) {\n    margin-bottom: 25px;\n    flex-direction: row;\n    align-items: stretch;\n  }\n'],['\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  margin-bottom: 27px;\n  text-decoration: none;\n  color: ',';\n\n  @media screen and (min-width: 1000px) {\n    margin-bottom: 25px;\n    flex-direction: row;\n    align-items: stretch;\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  ',';\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  margin-bottom: 27px;\n  text-decoration: none;\n  color: ',';\n\n  @media screen and (min-width: 1000px) {\n    margin-bottom: 25px;\n    flex-direction: row;\n    align-items: stretch;\n  }\n'],['\n  ',';\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  margin-bottom: 27px;\n  text-decoration: none;\n  color: ',';\n\n  @media screen and (min-width: 1000px) {\n    margin-bottom: 25px;\n    flex-direction: row;\n    align-items: stretch;\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  width: 100%;\n  height: 0;\n  padding-bottom: 100%;\n  position: relative;\n\n  @media screen and (min-width: 1000px) {\n    width: 365px;\n    height: auto;\n    padding-bottom: 0;\n  }\n'],['\n  width: 100%;\n  height: 0;\n  padding-bottom: 100%;\n  position: relative;\n\n  @media screen and (min-width: 1000px) {\n    width: 365px;\n    height: auto;\n    padding-bottom: 0;\n  }\n']),_templateObject4=_taggedTemplateLiteral(['\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background-image: url("','");\n  background-position: center;\n  background-size: cover;\n'],['\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background-image: url("','");\n  background-position: center;\n  background-size: cover;\n']),_templateObject5=_taggedTemplateLiteral(['\n  flex: 1;\n  background-color: ',';\n  padding: 28px 25px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  align-items: flex-start;\n\n  @media screen and (min-width: 1000px) {\n    padding: 60px 72px 50px 72px;\n    min-height: 365px;\n  }\n'],['\n  flex: 1;\n  background-color: ',';\n  padding: 28px 25px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  align-items: flex-start;\n\n  @media screen and (min-width: 1000px) {\n    padding: 60px 72px 50px 72px;\n    min-height: 365px;\n  }\n']),_templateObject6=_taggedTemplateLiteral(['\n  font-size: 18px !important;\n  \n  @media screen and (min-width: 1000px) {\n    font-size: 26px !important;\n  }\n'],['\n  font-size: 18px !important;\n  \n  @media screen and (min-width: 1000px) {\n    font-size: 26px !important;\n  }\n']),_templateObject7=_taggedTemplateLiteral(['\n  font-size: 15px !important;\n\n  @media screen and (min-width: 1000px) {\n    font-size: 20px !important;\n  }\n'],['\n  font-size: 15px !important;\n\n  @media screen and (min-width: 1000px) {\n    font-size: 20px !important;\n  }\n']),_templateObject8=_taggedTemplateLiteral(['\n  font-size: 12px;\n  font-weight: normal;\n  font-style: italic;\n  font-stretch: normal;\n  line-height: 1.83;\n  letter-spacing: normal;\n  color: ',';\n  margin: 20px 0 8px;\n\n  @media screen and (min-width: 1000px) {\n    margin: initial;\n  }\n'],['\n  font-size: 12px;\n  font-weight: normal;\n  font-style: italic;\n  font-stretch: normal;\n  line-height: 1.83;\n  letter-spacing: normal;\n  color: ',';\n  margin: 20px 0 8px;\n\n  @media screen and (min-width: 1000px) {\n    margin: initial;\n  }\n']),_templateObject9=_taggedTemplateLiteral(['\n  display: inline-block;\n  font-size: 12px;\n  font-weight: 600;\n  font-style: normal;\n  font-stretch: normal;\n  line-height: normal;\n  letter-spacing: 3px;\n  text-transform: uppercase;\n  color: ',';\n\n  @media not all and (hover: none) {\n    margin: 2em 0 1em;\n    padding: 10px 0;\n    position: relative;\n\n    &:before,\n    &:after {\n      content: \'\';\n      position: absolute;\n      right: 0;\n      left: 0;\n      height: 1px;\n      display: block;\n      opacity: 0;\n      transition: opacity 250ms ease-out, transform 250ms ease-out;\n      background-color: ',';\n    }\n\n    &:before {\n      bottom: -5px;\n      transform: translateY(10px);\n    }\n\n    &:after {\n      top: -5px;\n      transform: translateY(-10px);\n    }\n\n    ',':hover & {\n      &:before,\n      &:after {\n        opacity: 1;\n        transform: translateY(0);\n      }\n    }\n  }\n'],['\n  display: inline-block;\n  font-size: 12px;\n  font-weight: 600;\n  font-style: normal;\n  font-stretch: normal;\n  line-height: normal;\n  letter-spacing: 3px;\n  text-transform: uppercase;\n  color: ',';\n\n  @media not all and (hover: none) {\n    margin: 2em 0 1em;\n    padding: 10px 0;\n    position: relative;\n\n    &:before,\n    &:after {\n      content: \'\';\n      position: absolute;\n      right: 0;\n      left: 0;\n      height: 1px;\n      display: block;\n      opacity: 0;\n      transition: opacity 250ms ease-out, transform 250ms ease-out;\n      background-color: ',';\n    }\n\n    &:before {\n      bottom: -5px;\n      transform: translateY(10px);\n    }\n\n    &:after {\n      top: -5px;\n      transform: translateY(-10px);\n    }\n\n    ',':hover & {\n      &:before,\n      &:after {\n        opacity: 1;\n        transform: translateY(0);\n      }\n    }\n  }\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var CampaignListItem=function CampaignListItem(props){if(!props.title||!props.image){return false;}if(!props.to){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CampaignListItemContainerBase,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CampaignListItemImageContainer,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CampaignListItemImage,{image:props.image},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__styles_ProductTag__["a" /* ProductTag */],{absolute:true,color:__WEBPACK_IMPORTED_MODULE_4__styles_helpers_variables__["c" /* color */].primary,spacing:'12px',minFontSize:12},'Kampanj'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CampaignListItemContent,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CampaignListItemHeading,null,props.title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CampaignListItemHPreamble,{textAlign:'left'},props.preamble),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CampaignListItemSmallPrint,null,'Erbjudandet g\xE4ller under en begr\xE4nsad period och kan inte kombineras med andra erbjudanden.'))));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CampaignListItemContainer,{to:props.to},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CampaignListItemImageContainer,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CampaignListItemImage,{image:props.image},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__styles_ProductTag__["a" /* ProductTag */],{absolute:true,color:__WEBPACK_IMPORTED_MODULE_4__styles_helpers_variables__["c" /* color */].primary,spacing:'12px',minFontSize:12},'Kampanj'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CampaignListItemContent,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CampaignListItemHeading,null,props.title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CampaignListItemHPreamble,{textAlign:'left'},props.preamble),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CampaignListItemSmallPrint,null,'Erbjudandet g\xE4ller under en begr\xE4nsad period och kan inte kombineras med andra erbjudanden.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CampaignListItemLinkText,null,props.linkTitle)));};var CampaignListItemContainerBase=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject,__WEBPACK_IMPORTED_MODULE_4__styles_helpers_variables__["c" /* color */].black);var CampaignListItemContainer=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["a" /* Link */])(_templateObject2,__WEBPACK_IMPORTED_MODULE_5__styles_helpers_mixins__["i" /* shadowOnHover */],__WEBPACK_IMPORTED_MODULE_4__styles_helpers_variables__["c" /* color */].black);var CampaignListItemImageContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject3);var CampaignListItemImage=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject4,function(props){return props.image;});var CampaignListItemContent=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject5,__WEBPACK_IMPORTED_MODULE_4__styles_helpers_variables__["c" /* color */].white);var CampaignListItemHeading=__WEBPACK_IMPORTED_MODULE_6__styles_Heading__["a" /* Heading */].p.extend(_templateObject6);var CampaignListItemHPreamble=__WEBPACK_IMPORTED_MODULE_7__styles_Preamble__["a" /* Preamble */].extend(_templateObject7);var CampaignListItemSmallPrint=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].p(_templateObject8,__WEBPACK_IMPORTED_MODULE_4__styles_helpers_variables__["c" /* color */].black);var CampaignListItemLinkText=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].p(_templateObject9,__WEBPACK_IMPORTED_MODULE_4__styles_helpers_variables__["c" /* color */].black,__WEBPACK_IMPORTED_MODULE_4__styles_helpers_variables__["c" /* color */].black,CampaignListItemContainer);CampaignListItem.defaultProps={to:null,title:null,preamble:null,image:null,linkTitle:null};CampaignListItem.propTypes={to:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,title:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,preamble:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,image:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,linkTitle:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (CampaignListItem);

/***/ }),
/* 268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants_endpoints__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_SubHeading__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ProductCard__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_ProductTag__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__RenderPrice__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Conditional__ = __webpack_require__(26);
var _templateObject=_taggedTemplateLiteral(['\n  width: 100%;\n  height: 0;\n  padding-bottom: 93%;\n  position: relative;\n  overflow: hidden;\n'],['\n  width: 100%;\n  height: 0;\n  padding-bottom: 93%;\n  position: relative;\n  overflow: hidden;\n']),_templateObject2=_taggedTemplateLiteral(['\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  object-fit: cover;\n  width: 100%;\n'],['\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  object-fit: cover;\n  width: 100%;\n']),_templateObject3=_taggedTemplateLiteral(['\n  padding-top: 20px;\n  width: 100%;\n  height: auto;\n  text-align: center;\n  background-color: white;\n'],['\n  padding-top: 20px;\n  width: 100%;\n  height: auto;\n  text-align: center;\n  background-color: white;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var StoreItemCard=function StoreItemCard(props){var url=props.url,productName=props.productName,image=props.image,tag=props.tag,price=props.price,originalPrice=props.originalPrice;var brand=props.brand;if(brand===null){brand=Object(__WEBPACK_IMPORTED_MODULE_3_immutable__["Map"])();}var imageProps='?width=600&heightRatio=0.93&mode=crop';if(!url||!productName||!image.get('url')||!price)return false;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__ProductCard__["b" /* ProductCardLink */],{to:url},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__ProductCard__["a" /* ProductCardContainer */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ImageContainer,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Conditional__["a" /* Conditional */],{show:!tag.isEmpty()},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__ProductCard__["d" /* ProductTagContainer */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__styles_ProductTag__["a" /* ProductTag */],{color:tag.get('key')},tag.get('value')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Conditional__["a" /* Conditional */],{show:!!image.get('url')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Image,{src:__WEBPACK_IMPORTED_MODULE_4__constants_endpoints__["n" /* SITE_ROOT_URL */]+image.get('url')+imageProps,alt:image.get('alt')}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ContentContainer,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Conditional__["a" /* Conditional */],{show:!!brand.get('name')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__styles_SubHeading__["a" /* SubHeading */],{uppercase:true,title:brand.get('name')},brand.get('name'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__ProductCard__["c" /* ProductCardTitle */],{title:productName},productName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__RenderPrice__["a" /* default */],{small:true,fontWeight:'600',price:price,originalPrice:originalPrice}))));};StoreItemCard.defaultProps={brand:Object(__WEBPACK_IMPORTED_MODULE_3_immutable__["Map"])(),tag:Object(__WEBPACK_IMPORTED_MODULE_3_immutable__["Map"])(),originalPrice:null};StoreItemCard.propTypes={url:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,productName:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,image:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_3_immutable__["Map"]).isRequired,price:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,originalPrice:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,tag:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_3_immutable__["Map"]),brand:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_3_immutable__["Map"])};/* harmony default export */ __webpack_exports__["a"] = (StoreItemCard);var ImageContainer=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].div(_templateObject);var Image=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].img(_templateObject2);var ContentContainer=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].div(_templateObject3);

/***/ }),
/* 269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fetchBrandData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchDesignerData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_endpoints__ = __webpack_require__(9);
var fetchBrandData=function fetchBrandData(){var method='GET';var headers=new window.Headers();var url=__WEBPACK_IMPORTED_MODULE_0__constants_endpoints__["b" /* BRANDS_API_URL */];headers.append('Accept','application/json');var options={headers:headers,method:method};return window.fetch(url,options).then(function(response){if(response.ok){return response.json();}return response.error();}).then(function(json){return json;}).catch(function(error){throw error;});};var fetchDesignerData=function fetchDesignerData(){var method='GET';var headers=new window.Headers();var url=__WEBPACK_IMPORTED_MODULE_0__constants_endpoints__["h" /* DESIGNERS_API_URL */];headers.append('Accept','application/json');var options={headers:headers,method:method};return window.fetch(url,options).then(function(response){if(response.ok){return response.json();}return response.error();}).then(function(json){return json;}).catch(function(error){throw error;});};

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(271);
module.exports = __webpack_require__(276);


/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// @remove-on-eject-begin
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
// @remove-on-eject-end


if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  __webpack_require__(272).enable();
  window.Promise = __webpack_require__(274);
}

// fetch() polyfill for making API calls.
__webpack_require__(275);

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = __webpack_require__(72);

// In tests, polyfill requestAnimationFrame since jsdom doesn't provide it yet.
// We don't polyfill it in the browser--this is user's responsibility.
if (false) {
  require('raf').polyfill(global);
}


/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__(170);

var DEFAULT_WHITELIST = [
  ReferenceError,
  TypeError,
  RangeError
];

var enabled = false;
exports.disable = disable;
function disable() {
  enabled = false;
  Promise._47 = null;
  Promise._71 = null;
}

exports.enable = enable;
function enable(options) {
  options = options || {};
  if (enabled) disable();
  enabled = true;
  var id = 0;
  var displayId = 0;
  var rejections = {};
  Promise._47 = function (promise) {
    if (
      promise._83 === 2 && // IS REJECTED
      rejections[promise._56]
    ) {
      if (rejections[promise._56].logged) {
        onHandled(promise._56);
      } else {
        clearTimeout(rejections[promise._56].timeout);
      }
      delete rejections[promise._56];
    }
  };
  Promise._71 = function (promise, err) {
    if (promise._75 === 0) { // not yet handled
      promise._56 = id++;
      rejections[promise._56] = {
        displayId: null,
        error: err,
        timeout: setTimeout(
          onUnhandled.bind(null, promise._56),
          // For reference errors and type errors, this almost always
          // means the programmer made a mistake, so log them after just
          // 100ms
          // otherwise, wait 2 seconds to see if they get handled
          matchWhitelist(err, DEFAULT_WHITELIST)
            ? 100
            : 2000
        ),
        logged: false
      };
    }
  };
  function onUnhandled(id) {
    if (
      options.allRejections ||
      matchWhitelist(
        rejections[id].error,
        options.whitelist || DEFAULT_WHITELIST
      )
    ) {
      rejections[id].displayId = displayId++;
      if (options.onUnhandled) {
        rejections[id].logged = true;
        options.onUnhandled(
          rejections[id].displayId,
          rejections[id].error
        );
      } else {
        rejections[id].logged = true;
        logError(
          rejections[id].displayId,
          rejections[id].error
        );
      }
    }
  }
  function onHandled(id) {
    if (rejections[id].logged) {
      if (options.onHandled) {
        options.onHandled(rejections[id].displayId, rejections[id].error);
      } else if (!rejections[id].onUnhandled) {
        console.warn(
          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
        );
        console.warn(
          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
          rejections[id].displayId + '.'
        );
      }
    }
  }
}

function logError(id, error) {
  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
  var errStr = (error && (error.stack || error)) + '';
  errStr.split('\n').forEach(function (line) {
    console.warn('  ' + line);
  });
}

function matchWhitelist(error, list) {
  return list.some(function (cls) {
    return error instanceof cls;
  });
}

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(71)))

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = __webpack_require__(170);

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._44);
  p._83 = 1;
  p._18 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._83 === 3) {
            val = val._18;
          }
          if (val._83 === 1) return res(i, val._18);
          if (val._83 === 2) reject(val._18);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};


/***/ }),
/* 275 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_polyfill__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_dom__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_configureStore__ = __webpack_require__(514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__router_Routes__ = __webpack_require__(536);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__history__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_helpers_global_styles__ = __webpack_require__(712);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__sagas__ = __webpack_require__(728);
var store=Object(__WEBPACK_IMPORTED_MODULE_5__store_configureStore__["a" /* default */])();store.runSaga(__WEBPACK_IMPORTED_MODULE_9__sagas__["a" /* default */]);function main(){__WEBPACK_IMPORTED_MODULE_2_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_redux__["a" /* Provider */],{store:store},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["e" /* Router */],{history:__WEBPACK_IMPORTED_MODULE_7__history__["a" /* default */]},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__router_Routes__["a" /* default */],null))),document.getElementById('react_root'));}main();

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(278);

var _global = _interopRequireDefault(__webpack_require__(450));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

if (_global["default"]._babelPolyfill && typeof console !== "undefined" && console.warn) {
  console.warn("@babel/polyfill is loaded more than once on this page. This is probably not desirable/intended " + "and may have consequences if different versions of the polyfills are applied sequentially. " + "If you do need to load the polyfill more than once, use @babel/polyfill/noConflict " + "instead to bypass the warning.");
}

_global["default"]._babelPolyfill = true;

/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(279);

__webpack_require__(422);

__webpack_require__(424);

__webpack_require__(427);

__webpack_require__(429);

__webpack_require__(431);

__webpack_require__(433);

__webpack_require__(435);

__webpack_require__(437);

__webpack_require__(439);

__webpack_require__(441);

__webpack_require__(443);

__webpack_require__(445);

__webpack_require__(449);

/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(280);
__webpack_require__(283);
__webpack_require__(284);
__webpack_require__(285);
__webpack_require__(286);
__webpack_require__(287);
__webpack_require__(288);
__webpack_require__(289);
__webpack_require__(290);
__webpack_require__(291);
__webpack_require__(292);
__webpack_require__(293);
__webpack_require__(294);
__webpack_require__(295);
__webpack_require__(296);
__webpack_require__(297);
__webpack_require__(298);
__webpack_require__(299);
__webpack_require__(300);
__webpack_require__(301);
__webpack_require__(302);
__webpack_require__(303);
__webpack_require__(304);
__webpack_require__(305);
__webpack_require__(306);
__webpack_require__(307);
__webpack_require__(308);
__webpack_require__(309);
__webpack_require__(310);
__webpack_require__(311);
__webpack_require__(312);
__webpack_require__(313);
__webpack_require__(314);
__webpack_require__(315);
__webpack_require__(316);
__webpack_require__(317);
__webpack_require__(318);
__webpack_require__(319);
__webpack_require__(320);
__webpack_require__(321);
__webpack_require__(322);
__webpack_require__(323);
__webpack_require__(324);
__webpack_require__(326);
__webpack_require__(327);
__webpack_require__(328);
__webpack_require__(329);
__webpack_require__(330);
__webpack_require__(331);
__webpack_require__(332);
__webpack_require__(333);
__webpack_require__(334);
__webpack_require__(335);
__webpack_require__(336);
__webpack_require__(337);
__webpack_require__(338);
__webpack_require__(339);
__webpack_require__(340);
__webpack_require__(341);
__webpack_require__(342);
__webpack_require__(343);
__webpack_require__(344);
__webpack_require__(345);
__webpack_require__(346);
__webpack_require__(347);
__webpack_require__(348);
__webpack_require__(349);
__webpack_require__(350);
__webpack_require__(351);
__webpack_require__(352);
__webpack_require__(353);
__webpack_require__(354);
__webpack_require__(355);
__webpack_require__(356);
__webpack_require__(357);
__webpack_require__(358);
__webpack_require__(359);
__webpack_require__(361);
__webpack_require__(362);
__webpack_require__(364);
__webpack_require__(365);
__webpack_require__(366);
__webpack_require__(367);
__webpack_require__(368);
__webpack_require__(369);
__webpack_require__(370);
__webpack_require__(372);
__webpack_require__(373);
__webpack_require__(374);
__webpack_require__(375);
__webpack_require__(376);
__webpack_require__(377);
__webpack_require__(378);
__webpack_require__(379);
__webpack_require__(380);
__webpack_require__(381);
__webpack_require__(382);
__webpack_require__(383);
__webpack_require__(384);
__webpack_require__(137);
__webpack_require__(385);
__webpack_require__(191);
__webpack_require__(386);
__webpack_require__(192);
__webpack_require__(387);
__webpack_require__(388);
__webpack_require__(389);
__webpack_require__(390);
__webpack_require__(193);
__webpack_require__(393);
__webpack_require__(394);
__webpack_require__(395);
__webpack_require__(396);
__webpack_require__(397);
__webpack_require__(398);
__webpack_require__(399);
__webpack_require__(400);
__webpack_require__(401);
__webpack_require__(402);
__webpack_require__(403);
__webpack_require__(404);
__webpack_require__(405);
__webpack_require__(406);
__webpack_require__(407);
__webpack_require__(408);
__webpack_require__(409);
__webpack_require__(410);
__webpack_require__(411);
__webpack_require__(412);
__webpack_require__(413);
__webpack_require__(414);
__webpack_require__(415);
__webpack_require__(416);
__webpack_require__(417);
__webpack_require__(418);
__webpack_require__(419);
__webpack_require__(420);
__webpack_require__(421);
module.exports = __webpack_require__(20);


/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(11);
var has = __webpack_require__(31);
var DESCRIPTORS = __webpack_require__(21);
var $export = __webpack_require__(3);
var redefine = __webpack_require__(27);
var META = __webpack_require__(51).KEY;
var $fails = __webpack_require__(12);
var shared = __webpack_require__(97);
var setToStringTag = __webpack_require__(73);
var uid = __webpack_require__(57);
var wks = __webpack_require__(16);
var wksExt = __webpack_require__(118);
var wksDefine = __webpack_require__(172);
var enumKeys = __webpack_require__(282);
var isArray = __webpack_require__(100);
var anObject = __webpack_require__(13);
var isObject = __webpack_require__(14);
var toObject = __webpack_require__(24);
var toIObject = __webpack_require__(33);
var toPrimitive = __webpack_require__(50);
var createDesc = __webpack_require__(56);
var _create = __webpack_require__(61);
var gOPNExt = __webpack_require__(175);
var $GOPD = __webpack_require__(43);
var $GOPS = __webpack_require__(99);
var $DP = __webpack_require__(22);
var $keys = __webpack_require__(59);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(62).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(89).f = $propertyIsEnumerable;
  $GOPS.f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(58)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });

$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return $GOPS.f(toObject(it));
  }
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(32)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(97)('native-function-to-string', Function.toString);


/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(59);
var gOPS = __webpack_require__(99);
var pIE = __webpack_require__(89);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(3);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(61) });


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(3);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(21), 'Object', { defineProperty: __webpack_require__(22).f });


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(3);
// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
$export($export.S + $export.F * !__webpack_require__(21), 'Object', { defineProperties: __webpack_require__(174) });


/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject = __webpack_require__(33);
var $getOwnPropertyDescriptor = __webpack_require__(43).f;

__webpack_require__(44)('getOwnPropertyDescriptor', function () {
  return function getOwnPropertyDescriptor(it, key) {
    return $getOwnPropertyDescriptor(toIObject(it), key);
  };
});


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(24);
var $getPrototypeOf = __webpack_require__(63);

__webpack_require__(44)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(24);
var $keys = __webpack_require__(59);

__webpack_require__(44)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 Object.getOwnPropertyNames(O)
__webpack_require__(44)('getOwnPropertyNames', function () {
  return __webpack_require__(175).f;
});


/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.5 Object.freeze(O)
var isObject = __webpack_require__(14);
var meta = __webpack_require__(51).onFreeze;

__webpack_require__(44)('freeze', function ($freeze) {
  return function freeze(it) {
    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
  };
});


/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.17 Object.seal(O)
var isObject = __webpack_require__(14);
var meta = __webpack_require__(51).onFreeze;

__webpack_require__(44)('seal', function ($seal) {
  return function seal(it) {
    return $seal && isObject(it) ? $seal(meta(it)) : it;
  };
});


/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.15 Object.preventExtensions(O)
var isObject = __webpack_require__(14);
var meta = __webpack_require__(51).onFreeze;

__webpack_require__(44)('preventExtensions', function ($preventExtensions) {
  return function preventExtensions(it) {
    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
  };
});


/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.12 Object.isFrozen(O)
var isObject = __webpack_require__(14);

__webpack_require__(44)('isFrozen', function ($isFrozen) {
  return function isFrozen(it) {
    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
  };
});


/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.13 Object.isSealed(O)
var isObject = __webpack_require__(14);

__webpack_require__(44)('isSealed', function ($isSealed) {
  return function isSealed(it) {
    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
  };
});


/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.11 Object.isExtensible(O)
var isObject = __webpack_require__(14);

__webpack_require__(44)('isExtensible', function ($isExtensible) {
  return function isExtensible(it) {
    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
  };
});


/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(3);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(176) });


/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.10 Object.is(value1, value2)
var $export = __webpack_require__(3);
$export($export.S, 'Object', { is: __webpack_require__(177) });


/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(3);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(122).set });


/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.3.6 Object.prototype.toString()
var classof = __webpack_require__(90);
var test = {};
test[__webpack_require__(16)('toStringTag')] = 'z';
if (test + '' != '[object z]') {
  __webpack_require__(27)(Object.prototype, 'toString', function toString() {
    return '[object ' + classof(this) + ']';
  }, true);
}


/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
var $export = __webpack_require__(3);

$export($export.P, 'Function', { bind: __webpack_require__(178) });


/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(22).f;
var FProto = Function.prototype;
var nameRE = /^\s*function ([^ (]*)/;
var NAME = 'name';

// 19.2.4.2 name
NAME in FProto || __webpack_require__(21) && dP(FProto, NAME, {
  configurable: true,
  get: function () {
    try {
      return ('' + this).match(nameRE)[1];
    } catch (e) {
      return '';
    }
  }
});


/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isObject = __webpack_require__(14);
var getPrototypeOf = __webpack_require__(63);
var HAS_INSTANCE = __webpack_require__(16)('hasInstance');
var FunctionProto = Function.prototype;
// 19.2.3.6 Function.prototype[@@hasInstance](V)
if (!(HAS_INSTANCE in FunctionProto)) __webpack_require__(22).f(FunctionProto, HAS_INSTANCE, { value: function (O) {
  if (typeof this != 'function' || !isObject(O)) return false;
  if (!isObject(this.prototype)) return O instanceof this;
  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
  while (O = getPrototypeOf(O)) if (this.prototype === O) return true;
  return false;
} });


/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(3);
var $parseInt = __webpack_require__(180);
// 18.2.5 parseInt(string, radix)
$export($export.G + $export.F * (parseInt != $parseInt), { parseInt: $parseInt });


/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(3);
var $parseFloat = __webpack_require__(181);
// 18.2.4 parseFloat(string)
$export($export.G + $export.F * (parseFloat != $parseFloat), { parseFloat: $parseFloat });


/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(11);
var has = __webpack_require__(31);
var cof = __webpack_require__(46);
var inheritIfRequired = __webpack_require__(124);
var toPrimitive = __webpack_require__(50);
var fails = __webpack_require__(12);
var gOPN = __webpack_require__(62).f;
var gOPD = __webpack_require__(43).f;
var dP = __webpack_require__(22).f;
var $trim = __webpack_require__(74).trim;
var NUMBER = 'Number';
var $Number = global[NUMBER];
var Base = $Number;
var proto = $Number.prototype;
// Opera ~12 has broken Object#toString
var BROKEN_COF = cof(__webpack_require__(61)(proto)) == NUMBER;
var TRIM = 'trim' in String.prototype;

// 7.1.3 ToNumber(argument)
var toNumber = function (argument) {
  var it = toPrimitive(argument, false);
  if (typeof it == 'string' && it.length > 2) {
    it = TRIM ? it.trim() : $trim(it, 3);
    var first = it.charCodeAt(0);
    var third, radix, maxCode;
    if (first === 43 || first === 45) {
      third = it.charCodeAt(2);
      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if (first === 48) {
      switch (it.charCodeAt(1)) {
        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
        default: return +it;
      }
      for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
        code = digits.charCodeAt(i);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if (code < 48 || code > maxCode) return NaN;
      } return parseInt(digits, radix);
    }
  } return +it;
};

if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
  $Number = function Number(value) {
    var it = arguments.length < 1 ? 0 : value;
    var that = this;
    return that instanceof $Number
      // check on 1..constructor(foo) case
      && (BROKEN_COF ? fails(function () { proto.valueOf.call(that); }) : cof(that) != NUMBER)
        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
  };
  for (var keys = __webpack_require__(21) ? gOPN(Base) : (
    // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
    // ES6 (in case, if modules with ES6 Number statics required before):
    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
  ).split(','), j = 0, key; keys.length > j; j++) {
    if (has(Base, key = keys[j]) && !has($Number, key)) {
      dP($Number, key, gOPD(Base, key));
    }
  }
  $Number.prototype = proto;
  proto.constructor = $Number;
  __webpack_require__(27)(global, NUMBER, $Number);
}


/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(3);
var toInteger = __webpack_require__(42);
var aNumberValue = __webpack_require__(182);
var repeat = __webpack_require__(125);
var $toFixed = 1.0.toFixed;
var floor = Math.floor;
var data = [0, 0, 0, 0, 0, 0];
var ERROR = 'Number.toFixed: incorrect invocation!';
var ZERO = '0';

var multiply = function (n, c) {
  var i = -1;
  var c2 = c;
  while (++i < 6) {
    c2 += n * data[i];
    data[i] = c2 % 1e7;
    c2 = floor(c2 / 1e7);
  }
};
var divide = function (n) {
  var i = 6;
  var c = 0;
  while (--i >= 0) {
    c += data[i];
    data[i] = floor(c / n);
    c = (c % n) * 1e7;
  }
};
var numToString = function () {
  var i = 6;
  var s = '';
  while (--i >= 0) {
    if (s !== '' || i === 0 || data[i] !== 0) {
      var t = String(data[i]);
      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
    }
  } return s;
};
var pow = function (x, n, acc) {
  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
};
var log = function (x) {
  var n = 0;
  var x2 = x;
  while (x2 >= 4096) {
    n += 12;
    x2 /= 4096;
  }
  while (x2 >= 2) {
    n += 1;
    x2 /= 2;
  } return n;
};

$export($export.P + $export.F * (!!$toFixed && (
  0.00008.toFixed(3) !== '0.000' ||
  0.9.toFixed(0) !== '1' ||
  1.255.toFixed(2) !== '1.25' ||
  1000000000000000128.0.toFixed(0) !== '1000000000000000128'
) || !__webpack_require__(12)(function () {
  // V8 ~ Android 4.3-
  $toFixed.call({});
})), 'Number', {
  toFixed: function toFixed(fractionDigits) {
    var x = aNumberValue(this, ERROR);
    var f = toInteger(fractionDigits);
    var s = '';
    var m = ZERO;
    var e, z, j, k;
    if (f < 0 || f > 20) throw RangeError(ERROR);
    // eslint-disable-next-line no-self-compare
    if (x != x) return 'NaN';
    if (x <= -1e21 || x >= 1e21) return String(x);
    if (x < 0) {
      s = '-';
      x = -x;
    }
    if (x > 1e-21) {
      e = log(x * pow(2, 69, 1)) - 69;
      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
      z *= 0x10000000000000;
      e = 52 - e;
      if (e > 0) {
        multiply(0, z);
        j = f;
        while (j >= 7) {
          multiply(1e7, 0);
          j -= 7;
        }
        multiply(pow(10, j, 1), 0);
        j = e - 1;
        while (j >= 23) {
          divide(1 << 23);
          j -= 23;
        }
        divide(1 << j);
        multiply(1, 1);
        divide(2);
        m = numToString();
      } else {
        multiply(0, z);
        multiply(1 << -e, 0);
        m = numToString() + repeat.call(ZERO, f);
      }
    }
    if (f > 0) {
      k = m.length;
      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
    } else {
      m = s + m;
    } return m;
  }
});


/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(3);
var $fails = __webpack_require__(12);
var aNumberValue = __webpack_require__(182);
var $toPrecision = 1.0.toPrecision;

$export($export.P + $export.F * ($fails(function () {
  // IE7-
  return $toPrecision.call(1, undefined) !== '1';
}) || !$fails(function () {
  // V8 ~ Android 4.3-
  $toPrecision.call({});
})), 'Number', {
  toPrecision: function toPrecision(precision) {
    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision);
  }
});


/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.1 Number.EPSILON
var $export = __webpack_require__(3);

$export($export.S, 'Number', { EPSILON: Math.pow(2, -52) });


/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.2 Number.isFinite(number)
var $export = __webpack_require__(3);
var _isFinite = __webpack_require__(11).isFinite;

$export($export.S, 'Number', {
  isFinite: function isFinite(it) {
    return typeof it == 'number' && _isFinite(it);
  }
});


/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var $export = __webpack_require__(3);

$export($export.S, 'Number', { isInteger: __webpack_require__(183) });


/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.4 Number.isNaN(number)
var $export = __webpack_require__(3);

$export($export.S, 'Number', {
  isNaN: function isNaN(number) {
    // eslint-disable-next-line no-self-compare
    return number != number;
  }
});


/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.5 Number.isSafeInteger(number)
var $export = __webpack_require__(3);
var isInteger = __webpack_require__(183);
var abs = Math.abs;

$export($export.S, 'Number', {
  isSafeInteger: function isSafeInteger(number) {
    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
  }
});


/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.6 Number.MAX_SAFE_INTEGER
var $export = __webpack_require__(3);

$export($export.S, 'Number', { MAX_SAFE_INTEGER: 0x1fffffffffffff });


/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.10 Number.MIN_SAFE_INTEGER
var $export = __webpack_require__(3);

$export($export.S, 'Number', { MIN_SAFE_INTEGER: -0x1fffffffffffff });


/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(3);
var $parseFloat = __webpack_require__(181);
// 20.1.2.12 Number.parseFloat(string)
$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', { parseFloat: $parseFloat });


/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(3);
var $parseInt = __webpack_require__(180);
// 20.1.2.13 Number.parseInt(string, radix)
$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', { parseInt: $parseInt });


/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.3 Math.acosh(x)
var $export = __webpack_require__(3);
var log1p = __webpack_require__(184);
var sqrt = Math.sqrt;
var $acosh = Math.acosh;

$export($export.S + $export.F * !($acosh
  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
  && Math.floor($acosh(Number.MAX_VALUE)) == 710
  // Tor Browser bug: Math.acosh(Infinity) -> NaN
  && $acosh(Infinity) == Infinity
), 'Math', {
  acosh: function acosh(x) {
    return (x = +x) < 1 ? NaN : x > 94906265.62425156
      ? Math.log(x) + Math.LN2
      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
  }
});


/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.5 Math.asinh(x)
var $export = __webpack_require__(3);
var $asinh = Math.asinh;

function asinh(x) {
  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
}

// Tor Browser bug: Math.asinh(0) -> -0
$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', { asinh: asinh });


/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.7 Math.atanh(x)
var $export = __webpack_require__(3);
var $atanh = Math.atanh;

// Tor Browser bug: Math.atanh(-0) -> 0
$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
  atanh: function atanh(x) {
    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
  }
});


/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.9 Math.cbrt(x)
var $export = __webpack_require__(3);
var sign = __webpack_require__(126);

$export($export.S, 'Math', {
  cbrt: function cbrt(x) {
    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
  }
});


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.11 Math.clz32(x)
var $export = __webpack_require__(3);

$export($export.S, 'Math', {
  clz32: function clz32(x) {
    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
  }
});


/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.12 Math.cosh(x)
var $export = __webpack_require__(3);
var exp = Math.exp;

$export($export.S, 'Math', {
  cosh: function cosh(x) {
    return (exp(x = +x) + exp(-x)) / 2;
  }
});


/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.14 Math.expm1(x)
var $export = __webpack_require__(3);
var $expm1 = __webpack_require__(127);

$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', { expm1: $expm1 });


/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var $export = __webpack_require__(3);

$export($export.S, 'Math', { fround: __webpack_require__(325) });


/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var sign = __webpack_require__(126);
var pow = Math.pow;
var EPSILON = pow(2, -52);
var EPSILON32 = pow(2, -23);
var MAX32 = pow(2, 127) * (2 - EPSILON32);
var MIN32 = pow(2, -126);

var roundTiesToEven = function (n) {
  return n + 1 / EPSILON - 1 / EPSILON;
};

module.exports = Math.fround || function fround(x) {
  var $abs = Math.abs(x);
  var $sign = sign(x);
  var a, result;
  if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
  a = (1 + EPSILON32 / EPSILON) * $abs;
  result = a - (a - $abs);
  // eslint-disable-next-line no-self-compare
  if (result > MAX32 || result != result) return $sign * Infinity;
  return $sign * result;
};


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
var $export = __webpack_require__(3);
var abs = Math.abs;

$export($export.S, 'Math', {
  hypot: function hypot(value1, value2) { // eslint-disable-line no-unused-vars
    var sum = 0;
    var i = 0;
    var aLen = arguments.length;
    var larg = 0;
    var arg, div;
    while (i < aLen) {
      arg = abs(arguments[i++]);
      if (larg < arg) {
        div = larg / arg;
        sum = sum * div * div + 1;
        larg = arg;
      } else if (arg > 0) {
        div = arg / larg;
        sum += div * div;
      } else sum += arg;
    }
    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
  }
});


/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.18 Math.imul(x, y)
var $export = __webpack_require__(3);
var $imul = Math.imul;

// some WebKit versions fails with big numbers, some has wrong arity
$export($export.S + $export.F * __webpack_require__(12)(function () {
  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
}), 'Math', {
  imul: function imul(x, y) {
    var UINT16 = 0xffff;
    var xn = +x;
    var yn = +y;
    var xl = UINT16 & xn;
    var yl = UINT16 & yn;
    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
  }
});


/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.21 Math.log10(x)
var $export = __webpack_require__(3);

$export($export.S, 'Math', {
  log10: function log10(x) {
    return Math.log(x) * Math.LOG10E;
  }
});


/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.20 Math.log1p(x)
var $export = __webpack_require__(3);

$export($export.S, 'Math', { log1p: __webpack_require__(184) });


/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.22 Math.log2(x)
var $export = __webpack_require__(3);

$export($export.S, 'Math', {
  log2: function log2(x) {
    return Math.log(x) / Math.LN2;
  }
});


/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.28 Math.sign(x)
var $export = __webpack_require__(3);

$export($export.S, 'Math', { sign: __webpack_require__(126) });


/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.30 Math.sinh(x)
var $export = __webpack_require__(3);
var expm1 = __webpack_require__(127);
var exp = Math.exp;

// V8 near Chromium 38 has a problem with very small numbers
$export($export.S + $export.F * __webpack_require__(12)(function () {
  return !Math.sinh(-2e-17) != -2e-17;
}), 'Math', {
  sinh: function sinh(x) {
    return Math.abs(x = +x) < 1
      ? (expm1(x) - expm1(-x)) / 2
      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
  }
});


/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.33 Math.tanh(x)
var $export = __webpack_require__(3);
var expm1 = __webpack_require__(127);
var exp = Math.exp;

$export($export.S, 'Math', {
  tanh: function tanh(x) {
    var a = expm1(x = +x);
    var b = expm1(-x);
    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
  }
});


/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.34 Math.trunc(x)
var $export = __webpack_require__(3);

$export($export.S, 'Math', {
  trunc: function trunc(it) {
    return (it > 0 ? Math.floor : Math.ceil)(it);
  }
});


/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(3);
var toAbsoluteIndex = __webpack_require__(60);
var fromCharCode = String.fromCharCode;
var $fromCodePoint = String.fromCodePoint;

// length should be 1, old FF problem
$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
  // 21.1.2.2 String.fromCodePoint(...codePoints)
  fromCodePoint: function fromCodePoint(x) { // eslint-disable-line no-unused-vars
    var res = [];
    var aLen = arguments.length;
    var i = 0;
    var code;
    while (aLen > i) {
      code = +arguments[i++];
      if (toAbsoluteIndex(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
      res.push(code < 0x10000
        ? fromCharCode(code)
        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
      );
    } return res.join('');
  }
});


/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(3);
var toIObject = __webpack_require__(33);
var toLength = __webpack_require__(17);

$export($export.S, 'String', {
  // 21.1.2.4 String.raw(callSite, ...substitutions)
  raw: function raw(callSite) {
    var tpl = toIObject(callSite.raw);
    var len = toLength(tpl.length);
    var aLen = arguments.length;
    var res = [];
    var i = 0;
    while (len > i) {
      res.push(String(tpl[i++]));
      if (i < aLen) res.push(String(arguments[i]));
    } return res.join('');
  }
});


/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.1.3.25 String.prototype.trim()
__webpack_require__(74)('trim', function ($trim) {
  return function trim() {
    return $trim(this, 3);
  };
});


/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(128)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(129)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(3);
var $at = __webpack_require__(128)(false);
$export($export.P, 'String', {
  // 21.1.3.3 String.prototype.codePointAt(pos)
  codePointAt: function codePointAt(pos) {
    return $at(this, pos);
  }
});


/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])

var $export = __webpack_require__(3);
var toLength = __webpack_require__(17);
var context = __webpack_require__(130);
var ENDS_WITH = 'endsWith';
var $endsWith = ''[ENDS_WITH];

$export($export.P + $export.F * __webpack_require__(132)(ENDS_WITH), 'String', {
  endsWith: function endsWith(searchString /* , endPosition = @length */) {
    var that = context(this, searchString, ENDS_WITH);
    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
    var len = toLength(that.length);
    var end = endPosition === undefined ? len : Math.min(toLength(endPosition), len);
    var search = String(searchString);
    return $endsWith
      ? $endsWith.call(that, search, end)
      : that.slice(end - search.length, end) === search;
  }
});


/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.7 String.prototype.includes(searchString, position = 0)

var $export = __webpack_require__(3);
var context = __webpack_require__(130);
var INCLUDES = 'includes';

$export($export.P + $export.F * __webpack_require__(132)(INCLUDES), 'String', {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~context(this, searchString, INCLUDES)
      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(3);

$export($export.P, 'String', {
  // 21.1.3.13 String.prototype.repeat(count)
  repeat: __webpack_require__(125)
});


/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.18 String.prototype.startsWith(searchString [, position ])

var $export = __webpack_require__(3);
var toLength = __webpack_require__(17);
var context = __webpack_require__(130);
var STARTS_WITH = 'startsWith';
var $startsWith = ''[STARTS_WITH];

$export($export.P + $export.F * __webpack_require__(132)(STARTS_WITH), 'String', {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = context(this, searchString, STARTS_WITH);
    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = String(searchString);
    return $startsWith
      ? $startsWith.call(that, search, index)
      : that.slice(index, index + search.length) === search;
  }
});


/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.2 String.prototype.anchor(name)
__webpack_require__(28)('anchor', function (createHTML) {
  return function anchor(name) {
    return createHTML(this, 'a', 'name', name);
  };
});


/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.3 String.prototype.big()
__webpack_require__(28)('big', function (createHTML) {
  return function big() {
    return createHTML(this, 'big', '', '');
  };
});


/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.4 String.prototype.blink()
__webpack_require__(28)('blink', function (createHTML) {
  return function blink() {
    return createHTML(this, 'blink', '', '');
  };
});


/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.5 String.prototype.bold()
__webpack_require__(28)('bold', function (createHTML) {
  return function bold() {
    return createHTML(this, 'b', '', '');
  };
});


/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.6 String.prototype.fixed()
__webpack_require__(28)('fixed', function (createHTML) {
  return function fixed() {
    return createHTML(this, 'tt', '', '');
  };
});


/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.7 String.prototype.fontcolor(color)
__webpack_require__(28)('fontcolor', function (createHTML) {
  return function fontcolor(color) {
    return createHTML(this, 'font', 'color', color);
  };
});


/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.8 String.prototype.fontsize(size)
__webpack_require__(28)('fontsize', function (createHTML) {
  return function fontsize(size) {
    return createHTML(this, 'font', 'size', size);
  };
});


/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.9 String.prototype.italics()
__webpack_require__(28)('italics', function (createHTML) {
  return function italics() {
    return createHTML(this, 'i', '', '');
  };
});


/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.10 String.prototype.link(url)
__webpack_require__(28)('link', function (createHTML) {
  return function link(url) {
    return createHTML(this, 'a', 'href', url);
  };
});


/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.11 String.prototype.small()
__webpack_require__(28)('small', function (createHTML) {
  return function small() {
    return createHTML(this, 'small', '', '');
  };
});


/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.12 String.prototype.strike()
__webpack_require__(28)('strike', function (createHTML) {
  return function strike() {
    return createHTML(this, 'strike', '', '');
  };
});


/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.13 String.prototype.sub()
__webpack_require__(28)('sub', function (createHTML) {
  return function sub() {
    return createHTML(this, 'sub', '', '');
  };
});


/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.14 String.prototype.sup()
__webpack_require__(28)('sup', function (createHTML) {
  return function sup() {
    return createHTML(this, 'sup', '', '');
  };
});


/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

// 20.3.3.1 / 15.9.4.4 Date.now()
var $export = __webpack_require__(3);

$export($export.S, 'Date', { now: function () { return new Date().getTime(); } });


/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(3);
var toObject = __webpack_require__(24);
var toPrimitive = __webpack_require__(50);

$export($export.P + $export.F * __webpack_require__(12)(function () {
  return new Date(NaN).toJSON() !== null
    || Date.prototype.toJSON.call({ toISOString: function () { return 1; } }) !== 1;
}), 'Date', {
  // eslint-disable-next-line no-unused-vars
  toJSON: function toJSON(key) {
    var O = toObject(this);
    var pv = toPrimitive(O);
    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
  }
});


/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var $export = __webpack_require__(3);
var toISOString = __webpack_require__(360);

// PhantomJS / old WebKit has a broken implementations
$export($export.P + $export.F * (Date.prototype.toISOString !== toISOString), 'Date', {
  toISOString: toISOString
});


/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var fails = __webpack_require__(12);
var getTime = Date.prototype.getTime;
var $toISOString = Date.prototype.toISOString;

var lz = function (num) {
  return num > 9 ? num : '0' + num;
};

// PhantomJS / old WebKit has a broken implementations
module.exports = (fails(function () {
  return $toISOString.call(new Date(-5e13 - 1)) != '0385-07-25T07:06:39.999Z';
}) || !fails(function () {
  $toISOString.call(new Date(NaN));
})) ? function toISOString() {
  if (!isFinite(getTime.call(this))) throw RangeError('Invalid time value');
  var d = this;
  var y = d.getUTCFullYear();
  var m = d.getUTCMilliseconds();
  var s = y < 0 ? '-' : y > 9999 ? '+' : '';
  return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
    '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
    'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
    ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
} : $toISOString;


/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

var DateProto = Date.prototype;
var INVALID_DATE = 'Invalid Date';
var TO_STRING = 'toString';
var $toString = DateProto[TO_STRING];
var getTime = DateProto.getTime;
if (new Date(NaN) + '' != INVALID_DATE) {
  __webpack_require__(27)(DateProto, TO_STRING, function toString() {
    var value = getTime.call(this);
    // eslint-disable-next-line no-self-compare
    return value === value ? $toString.call(this) : INVALID_DATE;
  });
}


/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

var TO_PRIMITIVE = __webpack_require__(16)('toPrimitive');
var proto = Date.prototype;

if (!(TO_PRIMITIVE in proto)) __webpack_require__(32)(proto, TO_PRIMITIVE, __webpack_require__(363));


/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__(13);
var toPrimitive = __webpack_require__(50);
var NUMBER = 'number';

module.exports = function (hint) {
  if (hint !== 'string' && hint !== NUMBER && hint !== 'default') throw TypeError('Incorrect hint');
  return toPrimitive(anObject(this), hint != NUMBER);
};


/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
var $export = __webpack_require__(3);

$export($export.S, 'Array', { isArray: __webpack_require__(100) });


/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(40);
var $export = __webpack_require__(3);
var toObject = __webpack_require__(24);
var call = __webpack_require__(186);
var isArrayIter = __webpack_require__(133);
var toLength = __webpack_require__(17);
var createProperty = __webpack_require__(134);
var getIterFn = __webpack_require__(135);

$export($export.S + $export.F * !__webpack_require__(101)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(3);
var createProperty = __webpack_require__(134);

// WebKit Array.of isn't generic
$export($export.S + $export.F * __webpack_require__(12)(function () {
  function F() { /* empty */ }
  return !(Array.of.call(F) instanceof F);
}), 'Array', {
  // 22.1.2.3 Array.of( ...items)
  of: function of(/* ...args */) {
    var index = 0;
    var aLen = arguments.length;
    var result = new (typeof this == 'function' ? this : Array)(aLen);
    while (aLen > index) createProperty(result, index, arguments[index++]);
    result.length = aLen;
    return result;
  }
});


/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.13 Array.prototype.join(separator)
var $export = __webpack_require__(3);
var toIObject = __webpack_require__(33);
var arrayJoin = [].join;

// fallback for not array-like strings
$export($export.P + $export.F * (__webpack_require__(88) != Object || !__webpack_require__(38)(arrayJoin)), 'Array', {
  join: function join(separator) {
    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
  }
});


/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(3);
var html = __webpack_require__(121);
var cof = __webpack_require__(46);
var toAbsoluteIndex = __webpack_require__(60);
var toLength = __webpack_require__(17);
var arraySlice = [].slice;

// fallback for not array-like ES3 strings and DOM objects
$export($export.P + $export.F * __webpack_require__(12)(function () {
  if (html) arraySlice.call(html);
}), 'Array', {
  slice: function slice(begin, end) {
    var len = toLength(this.length);
    var klass = cof(this);
    end = end === undefined ? len : end;
    if (klass == 'Array') return arraySlice.call(this, begin, end);
    var start = toAbsoluteIndex(begin, len);
    var upTo = toAbsoluteIndex(end, len);
    var size = toLength(upTo - start);
    var cloned = new Array(size);
    var i = 0;
    for (; i < size; i++) cloned[i] = klass == 'String'
      ? this.charAt(start + i)
      : this[start + i];
    return cloned;
  }
});


/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(3);
var aFunction = __webpack_require__(41);
var toObject = __webpack_require__(24);
var fails = __webpack_require__(12);
var $sort = [].sort;
var test = [1, 2, 3];

$export($export.P + $export.F * (fails(function () {
  // IE8-
  test.sort(undefined);
}) || !fails(function () {
  // V8 bug
  test.sort(null);
  // Old WebKit
}) || !__webpack_require__(38)($sort)), 'Array', {
  // 22.1.3.25 Array.prototype.sort(comparefn)
  sort: function sort(comparefn) {
    return comparefn === undefined
      ? $sort.call(toObject(this))
      : $sort.call(toObject(this), aFunction(comparefn));
  }
});


/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(3);
var $forEach = __webpack_require__(45)(0);
var STRICT = __webpack_require__(38)([].forEach, true);

$export($export.P + $export.F * !STRICT, 'Array', {
  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
  forEach: function forEach(callbackfn /* , thisArg */) {
    return $forEach(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(14);
var isArray = __webpack_require__(100);
var SPECIES = __webpack_require__(16)('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(3);
var $map = __webpack_require__(45)(1);

$export($export.P + $export.F * !__webpack_require__(38)([].map, true), 'Array', {
  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(3);
var $filter = __webpack_require__(45)(2);

$export($export.P + $export.F * !__webpack_require__(38)([].filter, true), 'Array', {
  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(3);
var $some = __webpack_require__(45)(3);

$export($export.P + $export.F * !__webpack_require__(38)([].some, true), 'Array', {
  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
  some: function some(callbackfn /* , thisArg */) {
    return $some(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(3);
var $every = __webpack_require__(45)(4);

$export($export.P + $export.F * !__webpack_require__(38)([].every, true), 'Array', {
  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
  every: function every(callbackfn /* , thisArg */) {
    return $every(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(3);
var $reduce = __webpack_require__(188);

$export($export.P + $export.F * !__webpack_require__(38)([].reduce, true), 'Array', {
  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
  reduce: function reduce(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
  }
});


/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(3);
var $reduce = __webpack_require__(188);

$export($export.P + $export.F * !__webpack_require__(38)([].reduceRight, true), 'Array', {
  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
  reduceRight: function reduceRight(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
  }
});


/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(3);
var $indexOf = __webpack_require__(98)(false);
var $native = [].indexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(38)($native)), 'Array', {
  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
    return NEGATIVE_ZERO
      // convert -0 to +0
      ? $native.apply(this, arguments) || 0
      : $indexOf(this, searchElement, arguments[1]);
  }
});


/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(3);
var toIObject = __webpack_require__(33);
var toInteger = __webpack_require__(42);
var toLength = __webpack_require__(17);
var $native = [].lastIndexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(38)($native)), 'Array', {
  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
  lastIndexOf: function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
    // convert -0 to +0
    if (NEGATIVE_ZERO) return $native.apply(this, arguments) || 0;
    var O = toIObject(this);
    var length = toLength(O.length);
    var index = length - 1;
    if (arguments.length > 1) index = Math.min(index, toInteger(arguments[1]));
    if (index < 0) index = length + index;
    for (;index >= 0; index--) if (index in O) if (O[index] === searchElement) return index || 0;
    return -1;
  }
});


/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
var $export = __webpack_require__(3);

$export($export.P, 'Array', { copyWithin: __webpack_require__(189) });

__webpack_require__(64)('copyWithin');


/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
var $export = __webpack_require__(3);

$export($export.P, 'Array', { fill: __webpack_require__(136) });

__webpack_require__(64)('fill');


/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
var $export = __webpack_require__(3);
var $find = __webpack_require__(45)(5);
var KEY = 'find';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(64)(KEY);


/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
var $export = __webpack_require__(3);
var $find = __webpack_require__(45)(6);
var KEY = 'findIndex';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  findIndex: function findIndex(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(64)(KEY);


/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(76)('Array');


/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(11);
var inheritIfRequired = __webpack_require__(124);
var dP = __webpack_require__(22).f;
var gOPN = __webpack_require__(62).f;
var isRegExp = __webpack_require__(131);
var $flags = __webpack_require__(102);
var $RegExp = global.RegExp;
var Base = $RegExp;
var proto = $RegExp.prototype;
var re1 = /a/g;
var re2 = /a/g;
// "new" creates a new object, old webkit buggy here
var CORRECT_NEW = new $RegExp(re1) !== re1;

if (__webpack_require__(21) && (!CORRECT_NEW || __webpack_require__(12)(function () {
  re2[__webpack_require__(16)('match')] = false;
  // RegExp constructor can alter flags and IsRegExp works correct with @@match
  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
}))) {
  $RegExp = function RegExp(p, f) {
    var tiRE = this instanceof $RegExp;
    var piRE = isRegExp(p);
    var fiU = f === undefined;
    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
      : inheritIfRequired(CORRECT_NEW
        ? new Base(piRE && !fiU ? p.source : p, f)
        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
      , tiRE ? this : proto, $RegExp);
  };
  var proxy = function (key) {
    key in $RegExp || dP($RegExp, key, {
      configurable: true,
      get: function () { return Base[key]; },
      set: function (it) { Base[key] = it; }
    });
  };
  for (var keys = gOPN(Base), i = 0; keys.length > i;) proxy(keys[i++]);
  proto.constructor = $RegExp;
  $RegExp.prototype = proto;
  __webpack_require__(27)(global, 'RegExp', $RegExp);
}

__webpack_require__(76)('RegExp');


/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(192);
var anObject = __webpack_require__(13);
var $flags = __webpack_require__(102);
var DESCRIPTORS = __webpack_require__(21);
var TO_STRING = 'toString';
var $toString = /./[TO_STRING];

var define = function (fn) {
  __webpack_require__(27)(RegExp.prototype, TO_STRING, fn, true);
};

// 21.2.5.14 RegExp.prototype.toString()
if (__webpack_require__(12)(function () { return $toString.call({ source: 'a', flags: 'b' }) != '/a/b'; })) {
  define(function toString() {
    var R = anObject(this);
    return '/'.concat(R.source, '/',
      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
  });
// FF44- RegExp#toString has a wrong name
} else if ($toString.name != TO_STRING) {
  define(function toString() {
    return $toString.call(this);
  });
}


/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(13);
var toLength = __webpack_require__(17);
var advanceStringIndex = __webpack_require__(139);
var regExpExec = __webpack_require__(103);

// @@match logic
__webpack_require__(104)('match', 1, function (defined, MATCH, $match, maybeCallNative) {
  return [
    // `String.prototype.match` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.match
    function match(regexp) {
      var O = defined(this);
      var fn = regexp == undefined ? undefined : regexp[MATCH];
      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
    },
    // `RegExp.prototype[@@match]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@match
    function (regexp) {
      var res = maybeCallNative($match, regexp, this);
      if (res.done) return res.value;
      var rx = anObject(regexp);
      var S = String(this);
      if (!rx.global) return regExpExec(rx, S);
      var fullUnicode = rx.unicode;
      rx.lastIndex = 0;
      var A = [];
      var n = 0;
      var result;
      while ((result = regExpExec(rx, S)) !== null) {
        var matchStr = String(result[0]);
        A[n] = matchStr;
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
        n++;
      }
      return n === 0 ? null : A;
    }
  ];
});


/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(13);
var toObject = __webpack_require__(24);
var toLength = __webpack_require__(17);
var toInteger = __webpack_require__(42);
var advanceStringIndex = __webpack_require__(139);
var regExpExec = __webpack_require__(103);
var max = Math.max;
var min = Math.min;
var floor = Math.floor;
var SUBSTITUTION_SYMBOLS = /\$([$&`']|\d\d?|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&`']|\d\d?)/g;

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// @@replace logic
__webpack_require__(104)('replace', 2, function (defined, REPLACE, $replace, maybeCallNative) {
  return [
    // `String.prototype.replace` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = defined(this);
      var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
      return fn !== undefined
        ? fn.call(searchValue, O, replaceValue)
        : $replace.call(String(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
    function (regexp, replaceValue) {
      var res = maybeCallNative($replace, regexp, this, replaceValue);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var functionalReplace = typeof replaceValue === 'function';
      if (!functionalReplace) replaceValue = String(replaceValue);
      var global = rx.global;
      if (global) {
        var fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }
      var results = [];
      while (true) {
        var result = regExpExec(rx, S);
        if (result === null) break;
        results.push(result);
        if (!global) break;
        var matchStr = String(result[0]);
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
      }
      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];
        var matched = String(result[0]);
        var position = max(min(toInteger(result.index), S.length), 0);
        var captures = [];
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = [matched].concat(captures, position, S);
          if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
          var replacement = String(replaceValue.apply(undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }
      return accumulatedResult + S.slice(nextSourcePosition);
    }
  ];

    // https://tc39.github.io/ecma262/#sec-getsubstitution
  function getSubstitution(matched, str, position, captures, namedCaptures, replacement) {
    var tailPos = position + matched.length;
    var m = captures.length;
    var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
    if (namedCaptures !== undefined) {
      namedCaptures = toObject(namedCaptures);
      symbols = SUBSTITUTION_SYMBOLS;
    }
    return $replace.call(replacement, symbols, function (match, ch) {
      var capture;
      switch (ch.charAt(0)) {
        case '$': return '$';
        case '&': return matched;
        case '`': return str.slice(0, position);
        case "'": return str.slice(tailPos);
        case '<':
          capture = namedCaptures[ch.slice(1, -1)];
          break;
        default: // \d\d?
          var n = +ch;
          if (n === 0) return match;
          if (n > m) {
            var f = floor(n / 10);
            if (f === 0) return match;
            if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
            return match;
          }
          capture = captures[n - 1];
      }
      return capture === undefined ? '' : capture;
    });
  }
});


/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(13);
var sameValue = __webpack_require__(177);
var regExpExec = __webpack_require__(103);

// @@search logic
__webpack_require__(104)('search', 1, function (defined, SEARCH, $search, maybeCallNative) {
  return [
    // `String.prototype.search` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.search
    function search(regexp) {
      var O = defined(this);
      var fn = regexp == undefined ? undefined : regexp[SEARCH];
      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
    },
    // `RegExp.prototype[@@search]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@search
    function (regexp) {
      var res = maybeCallNative($search, regexp, this);
      if (res.done) return res.value;
      var rx = anObject(regexp);
      var S = String(this);
      var previousLastIndex = rx.lastIndex;
      if (!sameValue(previousLastIndex, 0)) rx.lastIndex = 0;
      var result = regExpExec(rx, S);
      if (!sameValue(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
      return result === null ? -1 : result.index;
    }
  ];
});


/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isRegExp = __webpack_require__(131);
var anObject = __webpack_require__(13);
var speciesConstructor = __webpack_require__(91);
var advanceStringIndex = __webpack_require__(139);
var toLength = __webpack_require__(17);
var callRegExpExec = __webpack_require__(103);
var regexpExec = __webpack_require__(138);
var fails = __webpack_require__(12);
var $min = Math.min;
var $push = [].push;
var $SPLIT = 'split';
var LENGTH = 'length';
var LAST_INDEX = 'lastIndex';
var MAX_UINT32 = 0xffffffff;

// babel-minify transpiles RegExp('x', 'y') -> /x/y and it causes SyntaxError
var SUPPORTS_Y = !fails(function () { RegExp(MAX_UINT32, 'y'); });

// @@split logic
__webpack_require__(104)('split', 2, function (defined, SPLIT, $split, maybeCallNative) {
  var internalSplit;
  if (
    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
    ''[$SPLIT](/.?/)[LENGTH]
  ) {
    // based on es5-shim implementation, need to rework it
    internalSplit = function (separator, limit) {
      var string = String(this);
      if (separator === undefined && limit === 0) return [];
      // If `separator` is not a regex, use native split
      if (!isRegExp(separator)) return $split.call(string, separator, limit);
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      var splitLimit = limit === undefined ? MAX_UINT32 : limit >>> 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var match, lastIndex, lastLength;
      while (match = regexpExec.call(separatorCopy, string)) {
        lastIndex = separatorCopy[LAST_INDEX];
        if (lastIndex > lastLastIndex) {
          output.push(string.slice(lastLastIndex, match.index));
          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
          lastLength = match[0][LENGTH];
          lastLastIndex = lastIndex;
          if (output[LENGTH] >= splitLimit) break;
        }
        if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
      }
      if (lastLastIndex === string[LENGTH]) {
        if (lastLength || !separatorCopy.test('')) output.push('');
      } else output.push(string.slice(lastLastIndex));
      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
    };
  // Chakra, V8
  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
    internalSplit = function (separator, limit) {
      return separator === undefined && limit === 0 ? [] : $split.call(this, separator, limit);
    };
  } else {
    internalSplit = $split;
  }

  return [
    // `String.prototype.split` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.split
    function split(separator, limit) {
      var O = defined(this);
      var splitter = separator == undefined ? undefined : separator[SPLIT];
      return splitter !== undefined
        ? splitter.call(separator, O, limit)
        : internalSplit.call(String(O), separator, limit);
    },
    // `RegExp.prototype[@@split]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@split
    //
    // NOTE: This cannot be properly polyfilled in engines that don't support
    // the 'y' flag.
    function (regexp, limit) {
      var res = maybeCallNative(internalSplit, regexp, this, limit, internalSplit !== $split);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var C = speciesConstructor(rx, RegExp);

      var unicodeMatching = rx.unicode;
      var flags = (rx.ignoreCase ? 'i' : '') +
                  (rx.multiline ? 'm' : '') +
                  (rx.unicode ? 'u' : '') +
                  (SUPPORTS_Y ? 'y' : 'g');

      // ^(? + rx + ) is needed, in combination with some S slicing, to
      // simulate the 'y' flag.
      var splitter = new C(SUPPORTS_Y ? rx : '^(?:' + rx.source + ')', flags);
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : [];
      var p = 0;
      var q = 0;
      var A = [];
      while (q < S.length) {
        splitter.lastIndex = SUPPORTS_Y ? q : 0;
        var z = callRegExpExec(splitter, SUPPORTS_Y ? S : S.slice(q));
        var e;
        if (
          z === null ||
          (e = $min(toLength(splitter.lastIndex + (SUPPORTS_Y ? 0 : q)), S.length)) === p
        ) {
          q = advanceStringIndex(S, q, unicodeMatching);
        } else {
          A.push(S.slice(p, q));
          if (A.length === lim) return A;
          for (var i = 1; i <= z.length - 1; i++) {
            A.push(z[i]);
            if (A.length === lim) return A;
          }
          q = p = e;
        }
      }
      A.push(S.slice(p));
      return A;
    }
  ];
});


/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(11);
var macrotask = __webpack_require__(140).set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__(46)(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    var promise = Promise.resolve(undefined);
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),
/* 392 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(196);
var validate = __webpack_require__(65);
var MAP = 'Map';

// 23.1 Map Objects
module.exports = __webpack_require__(107)(MAP, function (get) {
  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.1.3.6 Map.prototype.get(key)
  get: function get(key) {
    var entry = strong.getEntry(validate(this, MAP), key);
    return entry && entry.v;
  },
  // 23.1.3.9 Map.prototype.set(key, value)
  set: function set(key, value) {
    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
  }
}, strong, true);


/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(196);
var validate = __webpack_require__(65);
var SET = 'Set';

// 23.2 Set Objects
module.exports = __webpack_require__(107)(SET, function (get) {
  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.2.3.1 Set.prototype.add(value)
  add: function add(value) {
    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
  }
}, strong);


/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(11);
var each = __webpack_require__(45)(0);
var redefine = __webpack_require__(27);
var meta = __webpack_require__(51);
var assign = __webpack_require__(176);
var weak = __webpack_require__(197);
var isObject = __webpack_require__(14);
var validate = __webpack_require__(65);
var NATIVE_WEAK_MAP = __webpack_require__(65);
var IS_IE11 = !global.ActiveXObject && 'ActiveXObject' in global;
var WEAK_MAP = 'WeakMap';
var getWeak = meta.getWeak;
var isExtensible = Object.isExtensible;
var uncaughtFrozenStore = weak.ufstore;
var InternalMap;

var wrapper = function (get) {
  return function WeakMap() {
    return get(this, arguments.length > 0 ? arguments[0] : undefined);
  };
};

var methods = {
  // 23.3.3.3 WeakMap.prototype.get(key)
  get: function get(key) {
    if (isObject(key)) {
      var data = getWeak(key);
      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
      return data ? data[this._i] : undefined;
    }
  },
  // 23.3.3.5 WeakMap.prototype.set(key, value)
  set: function set(key, value) {
    return weak.def(validate(this, WEAK_MAP), key, value);
  }
};

// 23.3 WeakMap Objects
var $WeakMap = module.exports = __webpack_require__(107)(WEAK_MAP, wrapper, methods, weak, true, true);

// IE11 WeakMap frozen keys fix
if (NATIVE_WEAK_MAP && IS_IE11) {
  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
  assign(InternalMap.prototype, methods);
  meta.NEED = true;
  each(['delete', 'has', 'get', 'set'], function (key) {
    var proto = $WeakMap.prototype;
    var method = proto[key];
    redefine(proto, key, function (a, b) {
      // store frozen objects on internal weakmap shim
      if (isObject(a) && !isExtensible(a)) {
        if (!this._f) this._f = new InternalMap();
        var result = this._f[key](a, b);
        return key == 'set' ? this : result;
      // store all the rest on native weakmap
      } return method.call(this, a, b);
    });
  });
}


/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var weak = __webpack_require__(197);
var validate = __webpack_require__(65);
var WEAK_SET = 'WeakSet';

// 23.4 WeakSet Objects
__webpack_require__(107)(WEAK_SET, function (get) {
  return function WeakSet() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.4.3.1 WeakSet.prototype.add(value)
  add: function add(value) {
    return weak.def(validate(this, WEAK_SET), value, true);
  }
}, weak, false, true);


/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(3);
var $typed = __webpack_require__(108);
var buffer = __webpack_require__(141);
var anObject = __webpack_require__(13);
var toAbsoluteIndex = __webpack_require__(60);
var toLength = __webpack_require__(17);
var isObject = __webpack_require__(14);
var ArrayBuffer = __webpack_require__(11).ArrayBuffer;
var speciesConstructor = __webpack_require__(91);
var $ArrayBuffer = buffer.ArrayBuffer;
var $DataView = buffer.DataView;
var $isView = $typed.ABV && ArrayBuffer.isView;
var $slice = $ArrayBuffer.prototype.slice;
var VIEW = $typed.VIEW;
var ARRAY_BUFFER = 'ArrayBuffer';

$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), { ArrayBuffer: $ArrayBuffer });

$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
  // 24.1.3.1 ArrayBuffer.isView(arg)
  isView: function isView(it) {
    return $isView && $isView(it) || isObject(it) && VIEW in it;
  }
});

$export($export.P + $export.U + $export.F * __webpack_require__(12)(function () {
  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
}), ARRAY_BUFFER, {
  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
  slice: function slice(start, end) {
    if ($slice !== undefined && end === undefined) return $slice.call(anObject(this), start); // FF fix
    var len = anObject(this).byteLength;
    var first = toAbsoluteIndex(start, len);
    var fin = toAbsoluteIndex(end === undefined ? len : end, len);
    var result = new (speciesConstructor(this, $ArrayBuffer))(toLength(fin - first));
    var viewS = new $DataView(this);
    var viewT = new $DataView(result);
    var index = 0;
    while (first < fin) {
      viewT.setUint8(index++, viewS.getUint8(first++));
    } return result;
  }
});

__webpack_require__(76)(ARRAY_BUFFER);


/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(3);
$export($export.G + $export.W + $export.F * !__webpack_require__(108).ABV, {
  DataView: __webpack_require__(141).DataView
});


/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(48)('Int8', 1, function (init) {
  return function Int8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(48)('Uint8', 1, function (init) {
  return function Uint8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(48)('Uint8', 1, function (init) {
  return function Uint8ClampedArray(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
}, true);


/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(48)('Int16', 2, function (init) {
  return function Int16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(48)('Uint16', 2, function (init) {
  return function Uint16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(48)('Int32', 4, function (init) {
  return function Int32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(48)('Uint32', 4, function (init) {
  return function Uint32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(48)('Float32', 4, function (init) {
  return function Float32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(48)('Float64', 8, function (init) {
  return function Float64Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
var $export = __webpack_require__(3);
var aFunction = __webpack_require__(41);
var anObject = __webpack_require__(13);
var rApply = (__webpack_require__(11).Reflect || {}).apply;
var fApply = Function.apply;
// MS Edge argumentsList argument is optional
$export($export.S + $export.F * !__webpack_require__(12)(function () {
  rApply(function () { /* empty */ });
}), 'Reflect', {
  apply: function apply(target, thisArgument, argumentsList) {
    var T = aFunction(target);
    var L = anObject(argumentsList);
    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
  }
});


/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
var $export = __webpack_require__(3);
var create = __webpack_require__(61);
var aFunction = __webpack_require__(41);
var anObject = __webpack_require__(13);
var isObject = __webpack_require__(14);
var fails = __webpack_require__(12);
var bind = __webpack_require__(178);
var rConstruct = (__webpack_require__(11).Reflect || {}).construct;

// MS Edge supports only 2 arguments and argumentsList argument is optional
// FF Nightly sets third argument as `new.target`, but does not create `this` from it
var NEW_TARGET_BUG = fails(function () {
  function F() { /* empty */ }
  return !(rConstruct(function () { /* empty */ }, [], F) instanceof F);
});
var ARGS_BUG = !fails(function () {
  rConstruct(function () { /* empty */ });
});

$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
  construct: function construct(Target, args /* , newTarget */) {
    aFunction(Target);
    anObject(args);
    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
    if (ARGS_BUG && !NEW_TARGET_BUG) return rConstruct(Target, args, newTarget);
    if (Target == newTarget) {
      // w/o altered newTarget, optimization for 0-4 arguments
      switch (args.length) {
        case 0: return new Target();
        case 1: return new Target(args[0]);
        case 2: return new Target(args[0], args[1]);
        case 3: return new Target(args[0], args[1], args[2]);
        case 4: return new Target(args[0], args[1], args[2], args[3]);
      }
      // w/o altered newTarget, lot of arguments case
      var $args = [null];
      $args.push.apply($args, args);
      return new (bind.apply(Target, $args))();
    }
    // with altered newTarget, not support built-in constructors
    var proto = newTarget.prototype;
    var instance = create(isObject(proto) ? proto : Object.prototype);
    var result = Function.apply.call(Target, instance, args);
    return isObject(result) ? result : instance;
  }
});


/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
var dP = __webpack_require__(22);
var $export = __webpack_require__(3);
var anObject = __webpack_require__(13);
var toPrimitive = __webpack_require__(50);

// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
$export($export.S + $export.F * __webpack_require__(12)(function () {
  // eslint-disable-next-line no-undef
  Reflect.defineProperty(dP.f({}, 1, { value: 1 }), 1, { value: 2 });
}), 'Reflect', {
  defineProperty: function defineProperty(target, propertyKey, attributes) {
    anObject(target);
    propertyKey = toPrimitive(propertyKey, true);
    anObject(attributes);
    try {
      dP.f(target, propertyKey, attributes);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.4 Reflect.deleteProperty(target, propertyKey)
var $export = __webpack_require__(3);
var gOPD = __webpack_require__(43).f;
var anObject = __webpack_require__(13);

$export($export.S, 'Reflect', {
  deleteProperty: function deleteProperty(target, propertyKey) {
    var desc = gOPD(anObject(target), propertyKey);
    return desc && !desc.configurable ? false : delete target[propertyKey];
  }
});


/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 26.1.5 Reflect.enumerate(target)
var $export = __webpack_require__(3);
var anObject = __webpack_require__(13);
var Enumerate = function (iterated) {
  this._t = anObject(iterated); // target
  this._i = 0;                  // next index
  var keys = this._k = [];      // keys
  var key;
  for (key in iterated) keys.push(key);
};
__webpack_require__(185)(Enumerate, 'Object', function () {
  var that = this;
  var keys = that._k;
  var key;
  do {
    if (that._i >= keys.length) return { value: undefined, done: true };
  } while (!((key = keys[that._i++]) in that._t));
  return { value: key, done: false };
});

$export($export.S, 'Reflect', {
  enumerate: function enumerate(target) {
    return new Enumerate(target);
  }
});


/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.6 Reflect.get(target, propertyKey [, receiver])
var gOPD = __webpack_require__(43);
var getPrototypeOf = __webpack_require__(63);
var has = __webpack_require__(31);
var $export = __webpack_require__(3);
var isObject = __webpack_require__(14);
var anObject = __webpack_require__(13);

function get(target, propertyKey /* , receiver */) {
  var receiver = arguments.length < 3 ? target : arguments[2];
  var desc, proto;
  if (anObject(target) === receiver) return target[propertyKey];
  if (desc = gOPD.f(target, propertyKey)) return has(desc, 'value')
    ? desc.value
    : desc.get !== undefined
      ? desc.get.call(receiver)
      : undefined;
  if (isObject(proto = getPrototypeOf(target))) return get(proto, propertyKey, receiver);
}

$export($export.S, 'Reflect', { get: get });


/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
var gOPD = __webpack_require__(43);
var $export = __webpack_require__(3);
var anObject = __webpack_require__(13);

$export($export.S, 'Reflect', {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
    return gOPD.f(anObject(target), propertyKey);
  }
});


/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.8 Reflect.getPrototypeOf(target)
var $export = __webpack_require__(3);
var getProto = __webpack_require__(63);
var anObject = __webpack_require__(13);

$export($export.S, 'Reflect', {
  getPrototypeOf: function getPrototypeOf(target) {
    return getProto(anObject(target));
  }
});


/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.9 Reflect.has(target, propertyKey)
var $export = __webpack_require__(3);

$export($export.S, 'Reflect', {
  has: function has(target, propertyKey) {
    return propertyKey in target;
  }
});


/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.10 Reflect.isExtensible(target)
var $export = __webpack_require__(3);
var anObject = __webpack_require__(13);
var $isExtensible = Object.isExtensible;

$export($export.S, 'Reflect', {
  isExtensible: function isExtensible(target) {
    anObject(target);
    return $isExtensible ? $isExtensible(target) : true;
  }
});


/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.11 Reflect.ownKeys(target)
var $export = __webpack_require__(3);

$export($export.S, 'Reflect', { ownKeys: __webpack_require__(199) });


/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.12 Reflect.preventExtensions(target)
var $export = __webpack_require__(3);
var anObject = __webpack_require__(13);
var $preventExtensions = Object.preventExtensions;

$export($export.S, 'Reflect', {
  preventExtensions: function preventExtensions(target) {
    anObject(target);
    try {
      if ($preventExtensions) $preventExtensions(target);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
var dP = __webpack_require__(22);
var gOPD = __webpack_require__(43);
var getPrototypeOf = __webpack_require__(63);
var has = __webpack_require__(31);
var $export = __webpack_require__(3);
var createDesc = __webpack_require__(56);
var anObject = __webpack_require__(13);
var isObject = __webpack_require__(14);

function set(target, propertyKey, V /* , receiver */) {
  var receiver = arguments.length < 4 ? target : arguments[3];
  var ownDesc = gOPD.f(anObject(target), propertyKey);
  var existingDescriptor, proto;
  if (!ownDesc) {
    if (isObject(proto = getPrototypeOf(target))) {
      return set(proto, propertyKey, V, receiver);
    }
    ownDesc = createDesc(0);
  }
  if (has(ownDesc, 'value')) {
    if (ownDesc.writable === false || !isObject(receiver)) return false;
    if (existingDescriptor = gOPD.f(receiver, propertyKey)) {
      if (existingDescriptor.get || existingDescriptor.set || existingDescriptor.writable === false) return false;
      existingDescriptor.value = V;
      dP.f(receiver, propertyKey, existingDescriptor);
    } else dP.f(receiver, propertyKey, createDesc(0, V));
    return true;
  }
  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
}

$export($export.S, 'Reflect', { set: set });


/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.14 Reflect.setPrototypeOf(target, proto)
var $export = __webpack_require__(3);
var setProto = __webpack_require__(122);

if (setProto) $export($export.S, 'Reflect', {
  setPrototypeOf: function setPrototypeOf(target, proto) {
    setProto.check(target, proto);
    try {
      setProto.set(target, proto);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(423);
module.exports = __webpack_require__(20).Array.includes;


/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/Array.prototype.includes
var $export = __webpack_require__(3);
var $includes = __webpack_require__(98)(true);

$export($export.P, 'Array', {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

__webpack_require__(64)('includes');


/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(425);
module.exports = __webpack_require__(20).Array.flatMap;


/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatMap
var $export = __webpack_require__(3);
var flattenIntoArray = __webpack_require__(426);
var toObject = __webpack_require__(24);
var toLength = __webpack_require__(17);
var aFunction = __webpack_require__(41);
var arraySpeciesCreate = __webpack_require__(187);

$export($export.P, 'Array', {
  flatMap: function flatMap(callbackfn /* , thisArg */) {
    var O = toObject(this);
    var sourceLen, A;
    aFunction(callbackfn);
    sourceLen = toLength(O.length);
    A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments[1]);
    return A;
  }
});

__webpack_require__(64)('flatMap');


/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
var isArray = __webpack_require__(100);
var isObject = __webpack_require__(14);
var toLength = __webpack_require__(17);
var ctx = __webpack_require__(40);
var IS_CONCAT_SPREADABLE = __webpack_require__(16)('isConcatSpreadable');

function flattenIntoArray(target, original, source, sourceLen, start, depth, mapper, thisArg) {
  var targetIndex = start;
  var sourceIndex = 0;
  var mapFn = mapper ? ctx(mapper, thisArg, 3) : false;
  var element, spreadable;

  while (sourceIndex < sourceLen) {
    if (sourceIndex in source) {
      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];

      spreadable = false;
      if (isObject(element)) {
        spreadable = element[IS_CONCAT_SPREADABLE];
        spreadable = spreadable !== undefined ? !!spreadable : isArray(element);
      }

      if (spreadable && depth > 0) {
        targetIndex = flattenIntoArray(target, original, element, toLength(element.length), targetIndex, depth - 1) - 1;
      } else {
        if (targetIndex >= 0x1fffffffffffff) throw TypeError();
        target[targetIndex] = element;
      }

      targetIndex++;
    }
    sourceIndex++;
  }
  return targetIndex;
}

module.exports = flattenIntoArray;


/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(428);
module.exports = __webpack_require__(20).String.padStart;


/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__(3);
var $pad = __webpack_require__(200);
var userAgent = __webpack_require__(106);

// https://github.com/zloirock/core-js/issues/280
var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);

$export($export.P + $export.F * WEBKIT_BUG, 'String', {
  padStart: function padStart(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
  }
});


/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(430);
module.exports = __webpack_require__(20).String.padEnd;


/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__(3);
var $pad = __webpack_require__(200);
var userAgent = __webpack_require__(106);

// https://github.com/zloirock/core-js/issues/280
var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);

$export($export.P + $export.F * WEBKIT_BUG, 'String', {
  padEnd: function padEnd(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
  }
});


/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(432);
module.exports = __webpack_require__(20).String.trimLeft;


/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
__webpack_require__(74)('trimLeft', function ($trim) {
  return function trimLeft() {
    return $trim(this, 1);
  };
}, 'trimStart');


/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(434);
module.exports = __webpack_require__(20).String.trimRight;


/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
__webpack_require__(74)('trimRight', function ($trim) {
  return function trimRight() {
    return $trim(this, 2);
  };
}, 'trimEnd');


/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(436);
module.exports = __webpack_require__(118).f('asyncIterator');


/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(172)('asyncIterator');


/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(438);
module.exports = __webpack_require__(20).Object.getOwnPropertyDescriptors;


/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-getownpropertydescriptors
var $export = __webpack_require__(3);
var ownKeys = __webpack_require__(199);
var toIObject = __webpack_require__(33);
var gOPD = __webpack_require__(43);
var createProperty = __webpack_require__(134);

$export($export.S, 'Object', {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
    var O = toIObject(object);
    var getDesc = gOPD.f;
    var keys = ownKeys(O);
    var result = {};
    var i = 0;
    var key, desc;
    while (keys.length > i) {
      desc = getDesc(O, key = keys[i++]);
      if (desc !== undefined) createProperty(result, key, desc);
    }
    return result;
  }
});


/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(440);
module.exports = __webpack_require__(20).Object.values;


/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(3);
var $values = __webpack_require__(201)(false);

$export($export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});


/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(442);
module.exports = __webpack_require__(20).Object.entries;


/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(3);
var $entries = __webpack_require__(201)(true);

$export($export.S, 'Object', {
  entries: function entries(it) {
    return $entries(it);
  }
});


/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(193);
__webpack_require__(444);
module.exports = __webpack_require__(20).Promise['finally'];


/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// https://github.com/tc39/proposal-promise-finally

var $export = __webpack_require__(3);
var core = __webpack_require__(20);
var global = __webpack_require__(11);
var speciesConstructor = __webpack_require__(91);
var promiseResolve = __webpack_require__(195);

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });


/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(446);
__webpack_require__(447);
__webpack_require__(448);
module.exports = __webpack_require__(20);


/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

// ie9- setTimeout & setInterval additional parameters fix
var global = __webpack_require__(11);
var $export = __webpack_require__(3);
var userAgent = __webpack_require__(106);
var slice = [].slice;
var MSIE = /MSIE .\./.test(userAgent); // <- dirty ie9- check
var wrap = function (set) {
  return function (fn, time /* , ...args */) {
    var boundArgs = arguments.length > 2;
    var args = boundArgs ? slice.call(arguments, 2) : false;
    return set(boundArgs ? function () {
      // eslint-disable-next-line no-new-func
      (typeof fn == 'function' ? fn : Function(fn)).apply(this, args);
    } : fn, time);
  };
};
$export($export.G + $export.B + $export.F * MSIE, {
  setTimeout: wrap(global.setTimeout),
  setInterval: wrap(global.setInterval)
});


/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(3);
var $task = __webpack_require__(140);
$export($export.G + $export.B, {
  setImmediate: $task.set,
  clearImmediate: $task.clear
});


/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

var $iterators = __webpack_require__(137);
var getKeys = __webpack_require__(59);
var redefine = __webpack_require__(27);
var global = __webpack_require__(11);
var hide = __webpack_require__(32);
var Iterators = __webpack_require__(75);
var wks = __webpack_require__(16);
var ITERATOR = wks('iterator');
var TO_STRING_TAG = wks('toStringTag');
var ArrayValues = Iterators.Array;

var DOMIterables = {
  CSSRuleList: true, // TODO: Not spec compliant, should be false.
  CSSStyleDeclaration: false,
  CSSValueList: false,
  ClientRectList: false,
  DOMRectList: false,
  DOMStringList: false,
  DOMTokenList: true,
  DataTransferItemList: false,
  FileList: false,
  HTMLAllCollection: false,
  HTMLCollection: false,
  HTMLFormElement: false,
  HTMLSelectElement: false,
  MediaList: true, // TODO: Not spec compliant, should be false.
  MimeTypeArray: false,
  NamedNodeMap: false,
  NodeList: true,
  PaintRequestList: false,
  Plugin: false,
  PluginArray: false,
  SVGLengthList: false,
  SVGNumberList: false,
  SVGPathSegList: false,
  SVGPointList: false,
  SVGStringList: false,
  SVGTransformList: false,
  SourceBufferList: false,
  StyleSheetList: true, // TODO: Not spec compliant, should be false.
  TextTrackCueList: false,
  TextTrackList: false,
  TouchList: false
};

for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
  var NAME = collections[i];
  var explicit = DOMIterables[NAME];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  var key;
  if (proto) {
    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
    Iterators[NAME] = ArrayValues;
    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
  }
}


/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var runtime = (function (exports) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; };
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function define(obj, key, value) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
    return obj[key];
  }
  try {
    // IE 8 has a broken Object.defineProperty that only works on DOM objects.
    define({}, "");
  } catch (err) {
    define = function(obj, key, value) {
      return obj[key] = value;
    };
  }

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) });

    return generator;
  }
  exports.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = GeneratorFunctionPrototype;
  defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: true });
  defineProperty(
    GeneratorFunctionPrototype,
    "constructor",
    { value: GeneratorFunction, configurable: true }
  );
  GeneratorFunction.displayName = define(
    GeneratorFunctionPrototype,
    toStringTagSymbol,
    "GeneratorFunction"
  );

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      define(prototype, method, function(arg) {
        return this._invoke(method, arg);
      });
    });
  }

  exports.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  exports.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      define(genFun, toStringTagSymbol, "GeneratorFunction");
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  exports.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return PromiseImpl.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return PromiseImpl.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration.
          result.value = unwrapped;
          resolve(result);
        }, function(error) {
          // If a rejected Promise was yielded, throw the rejection back
          // into the async generator function so it can be handled there.
          return invoke("throw", error, resolve, reject);
        });
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    defineProperty(this, "_invoke", { value: enqueue });
  }

  defineIteratorMethods(AsyncIterator.prototype);
  define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  });
  exports.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    if (PromiseImpl === void 0) PromiseImpl = Promise;

    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList),
      PromiseImpl
    );

    return exports.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var methodName = context.method;
    var method = delegate.iterator[methodName];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method, or a missing .next mehtod, always terminate the
      // yield* loop.
      context.delegate = null;

      // Note: ["return"] must be used for ES3 parsing compatibility.
      if (methodName === "throw" && delegate.iterator["return"]) {
        // If the delegate iterator has a return method, give it a
        // chance to clean up.
        context.method = "return";
        context.arg = undefined;
        maybeInvokeDelegate(delegate, context);

        if (context.method === "throw") {
          // If maybeInvokeDelegate(context) changed context.method from
          // "return" to "throw", let that override the TypeError below.
          return ContinueSentinel;
        }
      }
      if (methodName !== "return") {
        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a '" + methodName + "' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  define(Gp, toStringTagSymbol, "Generator");

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  define(Gp, iteratorSymbol, function() {
    return this;
  });

  define(Gp, "toString", function() {
    return "[object Generator]";
  });

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  exports.keys = function(val) {
    var object = Object(val);
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  exports.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };

  // Regardless of whether this script is executing as a CommonJS module
  // or not, return the runtime object so that we can declare the variable
  // regeneratorRuntime in the outer scope, which allows this module to be
  // injected easily by `bin/regenerator --include-runtime script.js`.
  return exports;

}(
  // If this script is executing as a CommonJS module, use module.exports
  // as the regeneratorRuntime namespace. Otherwise create a new empty
  // object. Either way, the resulting object will be used to initialize
  // the regeneratorRuntime variable at the top of this file.
   true ? module.exports : {}
));

try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  // This module should not be running in strict mode, so the above
  // assignment should always work unless something is misconfigured. Just
  // in case runtime.js accidentally runs in strict mode, in modern engines
  // we can explicitly access globalThis. In older engines we can escape
  // strict mode using a global Function call. This could conceivably fail
  // if a Content Security Policy forbids using Function, but in that case
  // the proper solution is to fix the accidental strict mode problem. If
  // you've misconfigured your bundler to force strict mode and applied a
  // CSP to forbid Function, and you're not willing to fix either of those
  // problems, please detail your unique predicament in a GitHub issue.
  if (typeof globalThis === "object") {
    globalThis.regeneratorRuntime = runtime;
  } else {
    Function("r", "regeneratorRuntime = r")(runtime);
  }
}


/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(451);
module.exports = __webpack_require__(202).global;


/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-global
var $export = __webpack_require__(452);

$export($export.G, { global: __webpack_require__(142) });


/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(142);
var core = __webpack_require__(202);
var ctx = __webpack_require__(453);
var hide = __webpack_require__(455);
var has = __webpack_require__(462);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(454);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 454 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(456);
var createDesc = __webpack_require__(461);
module.exports = __webpack_require__(144) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(457);
var IE8_DOM_DEFINE = __webpack_require__(458);
var toPrimitive = __webpack_require__(460);
var dP = Object.defineProperty;

exports.f = __webpack_require__(144) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(143);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(144) && !__webpack_require__(203)(function () {
  return Object.defineProperty(__webpack_require__(459)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(143);
var document = __webpack_require__(142).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(143);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 461 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 462 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.14.0
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var l=__webpack_require__(72),n="function"===typeof Symbol&&Symbol.for,p=n?Symbol.for("react.element"):60103,q=n?Symbol.for("react.portal"):60106,r=n?Symbol.for("react.fragment"):60107,t=n?Symbol.for("react.strict_mode"):60108,u=n?Symbol.for("react.profiler"):60114,v=n?Symbol.for("react.provider"):60109,w=n?Symbol.for("react.context"):60110,x=n?Symbol.for("react.forward_ref"):60112,y=n?Symbol.for("react.suspense"):60113,z=n?Symbol.for("react.memo"):60115,A=n?Symbol.for("react.lazy"):
60116,B="function"===typeof Symbol&&Symbol.iterator;function C(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}
var D={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},E={};function F(a,b,c){this.props=a;this.context=b;this.refs=E;this.updater=c||D}F.prototype.isReactComponent={};F.prototype.setState=function(a,b){if("object"!==typeof a&&"function"!==typeof a&&null!=a)throw Error(C(85));this.updater.enqueueSetState(this,a,b,"setState")};F.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};
function G(){}G.prototype=F.prototype;function H(a,b,c){this.props=a;this.context=b;this.refs=E;this.updater=c||D}var I=H.prototype=new G;I.constructor=H;l(I,F.prototype);I.isPureReactComponent=!0;var J={current:null},K=Object.prototype.hasOwnProperty,L={key:!0,ref:!0,__self:!0,__source:!0};
function M(a,b,c){var e,d={},g=null,k=null;if(null!=b)for(e in void 0!==b.ref&&(k=b.ref),void 0!==b.key&&(g=""+b.key),b)K.call(b,e)&&!L.hasOwnProperty(e)&&(d[e]=b[e]);var f=arguments.length-2;if(1===f)d.children=c;else if(1<f){for(var h=Array(f),m=0;m<f;m++)h[m]=arguments[m+2];d.children=h}if(a&&a.defaultProps)for(e in f=a.defaultProps,f)void 0===d[e]&&(d[e]=f[e]);return{$$typeof:p,type:a,key:g,ref:k,props:d,_owner:J.current}}
function N(a,b){return{$$typeof:p,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}}function O(a){return"object"===typeof a&&null!==a&&a.$$typeof===p}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var P=/\/+/g,Q=[];function R(a,b,c,e){if(Q.length){var d=Q.pop();d.result=a;d.keyPrefix=b;d.func=c;d.context=e;d.count=0;return d}return{result:a,keyPrefix:b,func:c,context:e,count:0}}
function S(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>Q.length&&Q.push(a)}
function T(a,b,c,e){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case p:case q:g=!0}}if(g)return c(e,a,""===b?"."+U(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var k=0;k<a.length;k++){d=a[k];var f=b+U(d,k);g+=T(d,f,c,e)}else if(null===a||"object"!==typeof a?f=null:(f=B&&a[B]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),k=
0;!(d=a.next()).done;)d=d.value,f=b+U(d,k++),g+=T(d,f,c,e);else if("object"===d)throw c=""+a,Error(C(31,"[object Object]"===c?"object with keys {"+Object.keys(a).join(", ")+"}":c,""));return g}function V(a,b,c){return null==a?0:T(a,"",b,c)}function U(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function W(a,b){a.func.call(a.context,b,a.count++)}
function aa(a,b,c){var e=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?X(a,e,c,function(a){return a}):null!=a&&(O(a)&&(a=N(a,d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(P,"$&/")+"/")+c)),e.push(a))}function X(a,b,c,e,d){var g="";null!=c&&(g=(""+c).replace(P,"$&/")+"/");b=R(b,g,e,d);V(a,aa,b);S(b)}var Y={current:null};function Z(){var a=Y.current;if(null===a)throw Error(C(321));return a}
var ba={ReactCurrentDispatcher:Y,ReactCurrentBatchConfig:{suspense:null},ReactCurrentOwner:J,IsSomeRendererActing:{current:!1},assign:l};exports.Children={map:function(a,b,c){if(null==a)return a;var e=[];X(a,e,null,b,c);return e},forEach:function(a,b,c){if(null==a)return a;b=R(null,null,b,c);V(a,W,b);S(b)},count:function(a){return V(a,function(){return null},null)},toArray:function(a){var b=[];X(a,b,null,function(a){return a});return b},only:function(a){if(!O(a))throw Error(C(143));return a}};
exports.Component=F;exports.Fragment=r;exports.Profiler=u;exports.PureComponent=H;exports.StrictMode=t;exports.Suspense=y;exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=ba;
exports.cloneElement=function(a,b,c){if(null===a||void 0===a)throw Error(C(267,a));var e=l({},a.props),d=a.key,g=a.ref,k=a._owner;if(null!=b){void 0!==b.ref&&(g=b.ref,k=J.current);void 0!==b.key&&(d=""+b.key);if(a.type&&a.type.defaultProps)var f=a.type.defaultProps;for(h in b)K.call(b,h)&&!L.hasOwnProperty(h)&&(e[h]=void 0===b[h]&&void 0!==f?f[h]:b[h])}var h=arguments.length-2;if(1===h)e.children=c;else if(1<h){f=Array(h);for(var m=0;m<h;m++)f[m]=arguments[m+2];e.children=f}return{$$typeof:p,type:a.type,
key:d,ref:g,props:e,_owner:k}};exports.createContext=function(a,b){void 0===b&&(b=null);a={$$typeof:w,_calculateChangedBits:b,_currentValue:a,_currentValue2:a,_threadCount:0,Provider:null,Consumer:null};a.Provider={$$typeof:v,_context:a};return a.Consumer=a};exports.createElement=M;exports.createFactory=function(a){var b=M.bind(null,a);b.type=a;return b};exports.createRef=function(){return{current:null}};exports.forwardRef=function(a){return{$$typeof:x,render:a}};exports.isValidElement=O;
exports.lazy=function(a){return{$$typeof:A,_ctor:a,_status:-1,_result:null}};exports.memo=function(a,b){return{$$typeof:z,type:a,compare:void 0===b?null:b}};exports.useCallback=function(a,b){return Z().useCallback(a,b)};exports.useContext=function(a,b){return Z().useContext(a,b)};exports.useDebugValue=function(){};exports.useEffect=function(a,b){return Z().useEffect(a,b)};exports.useImperativeHandle=function(a,b,c){return Z().useImperativeHandle(a,b,c)};
exports.useLayoutEffect=function(a,b){return Z().useLayoutEffect(a,b)};exports.useMemo=function(a,b){return Z().useMemo(a,b)};exports.useReducer=function(a,b,c){return Z().useReducer(a,b,c)};exports.useRef=function(a){return Z().useRef(a)};exports.useState=function(a){return Z().useState(a)};exports.version="16.14.0";


/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.14.0
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/
var aa=__webpack_require__(0),n=__webpack_require__(72),r=__webpack_require__(465);function u(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}if(!aa)throw Error(u(227));
function ba(a,b,c,d,e,f,g,h,k){var l=Array.prototype.slice.call(arguments,3);try{b.apply(c,l)}catch(m){this.onError(m)}}var da=!1,ea=null,fa=!1,ha=null,ia={onError:function(a){da=!0;ea=a}};function ja(a,b,c,d,e,f,g,h,k){da=!1;ea=null;ba.apply(ia,arguments)}function ka(a,b,c,d,e,f,g,h,k){ja.apply(this,arguments);if(da){if(da){var l=ea;da=!1;ea=null}else throw Error(u(198));fa||(fa=!0,ha=l)}}var la=null,ma=null,na=null;
function oa(a,b,c){var d=a.type||"unknown-event";a.currentTarget=na(c);ka(d,b,void 0,a);a.currentTarget=null}var pa=null,qa={};
function ra(){if(pa)for(var a in qa){var b=qa[a],c=pa.indexOf(a);if(!(-1<c))throw Error(u(96,a));if(!sa[c]){if(!b.extractEvents)throw Error(u(97,a));sa[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;if(ta.hasOwnProperty(h))throw Error(u(99,h));ta[h]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&ua(k[e],g,h);e=!0}else f.registrationName?(ua(f.registrationName,g,h),e=!0):e=!1;if(!e)throw Error(u(98,d,a));}}}}
function ua(a,b,c){if(va[a])throw Error(u(100,a));va[a]=b;wa[a]=b.eventTypes[c].dependencies}var sa=[],ta={},va={},wa={};function xa(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];if(!qa.hasOwnProperty(c)||qa[c]!==d){if(qa[c])throw Error(u(102,c));qa[c]=d;b=!0}}b&&ra()}var ya=!("undefined"===typeof window||"undefined"===typeof window.document||"undefined"===typeof window.document.createElement),za=null,Aa=null,Ba=null;
function Ca(a){if(a=ma(a)){if("function"!==typeof za)throw Error(u(280));var b=a.stateNode;b&&(b=la(b),za(a.stateNode,a.type,b))}}function Da(a){Aa?Ba?Ba.push(a):Ba=[a]:Aa=a}function Ea(){if(Aa){var a=Aa,b=Ba;Ba=Aa=null;Ca(a);if(b)for(a=0;a<b.length;a++)Ca(b[a])}}function Fa(a,b){return a(b)}function Ga(a,b,c,d,e){return a(b,c,d,e)}function Ha(){}var Ia=Fa,Ja=!1,Ka=!1;function La(){if(null!==Aa||null!==Ba)Ha(),Ea()}
function Ma(a,b,c){if(Ka)return a(b,c);Ka=!0;try{return Ia(a,b,c)}finally{Ka=!1,La()}}var Na=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,Oa=Object.prototype.hasOwnProperty,Pa={},Qa={};
function Ra(a){if(Oa.call(Qa,a))return!0;if(Oa.call(Pa,a))return!1;if(Na.test(a))return Qa[a]=!0;Pa[a]=!0;return!1}function Sa(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
function Ta(a,b,c,d){if(null===b||"undefined"===typeof b||Sa(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function v(a,b,c,d,e,f){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b;this.sanitizeURL=f}var C={};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){C[a]=new v(a,0,!1,a,null,!1)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];C[b]=new v(b,1,!1,a[1],null,!1)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){C[a]=new v(a,2,!1,a.toLowerCase(),null,!1)});
["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){C[a]=new v(a,2,!1,a,null,!1)});"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){C[a]=new v(a,3,!1,a.toLowerCase(),null,!1)});
["checked","multiple","muted","selected"].forEach(function(a){C[a]=new v(a,3,!0,a,null,!1)});["capture","download"].forEach(function(a){C[a]=new v(a,4,!1,a,null,!1)});["cols","rows","size","span"].forEach(function(a){C[a]=new v(a,6,!1,a,null,!1)});["rowSpan","start"].forEach(function(a){C[a]=new v(a,5,!1,a.toLowerCase(),null,!1)});var Ua=/[\-:]([a-z])/g;function Va(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(Ua,
Va);C[b]=new v(b,1,!1,a,null,!1)});"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(Ua,Va);C[b]=new v(b,1,!1,a,"http://www.w3.org/1999/xlink",!1)});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(Ua,Va);C[b]=new v(b,1,!1,a,"http://www.w3.org/XML/1998/namespace",!1)});["tabIndex","crossOrigin"].forEach(function(a){C[a]=new v(a,1,!1,a.toLowerCase(),null,!1)});
C.xlinkHref=new v("xlinkHref",1,!1,"xlink:href","http://www.w3.org/1999/xlink",!0);["src","href","action","formAction"].forEach(function(a){C[a]=new v(a,1,!1,a.toLowerCase(),null,!0)});var Wa=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;Wa.hasOwnProperty("ReactCurrentDispatcher")||(Wa.ReactCurrentDispatcher={current:null});Wa.hasOwnProperty("ReactCurrentBatchConfig")||(Wa.ReactCurrentBatchConfig={suspense:null});
function Xa(a,b,c,d){var e=C.hasOwnProperty(b)?C[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(Ta(b,c,e,d)&&(c=null),d||null===e?Ra(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
var Ya=/^(.*)[\\\/]/,E="function"===typeof Symbol&&Symbol.for,Za=E?Symbol.for("react.element"):60103,$a=E?Symbol.for("react.portal"):60106,ab=E?Symbol.for("react.fragment"):60107,bb=E?Symbol.for("react.strict_mode"):60108,cb=E?Symbol.for("react.profiler"):60114,db=E?Symbol.for("react.provider"):60109,eb=E?Symbol.for("react.context"):60110,fb=E?Symbol.for("react.concurrent_mode"):60111,gb=E?Symbol.for("react.forward_ref"):60112,hb=E?Symbol.for("react.suspense"):60113,ib=E?Symbol.for("react.suspense_list"):
60120,jb=E?Symbol.for("react.memo"):60115,kb=E?Symbol.for("react.lazy"):60116,lb=E?Symbol.for("react.block"):60121,mb="function"===typeof Symbol&&Symbol.iterator;function nb(a){if(null===a||"object"!==typeof a)return null;a=mb&&a[mb]||a["@@iterator"];return"function"===typeof a?a:null}function ob(a){if(-1===a._status){a._status=0;var b=a._ctor;b=b();a._result=b;b.then(function(b){0===a._status&&(b=b.default,a._status=1,a._result=b)},function(b){0===a._status&&(a._status=2,a._result=b)})}}
function pb(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case ab:return"Fragment";case $a:return"Portal";case cb:return"Profiler";case bb:return"StrictMode";case hb:return"Suspense";case ib:return"SuspenseList"}if("object"===typeof a)switch(a.$$typeof){case eb:return"Context.Consumer";case db:return"Context.Provider";case gb:var b=a.render;b=b.displayName||b.name||"";return a.displayName||(""!==b?"ForwardRef("+b+")":
"ForwardRef");case jb:return pb(a.type);case lb:return pb(a.render);case kb:if(a=1===a._status?a._result:null)return pb(a)}return null}function qb(a){var b="";do{a:switch(a.tag){case 3:case 4:case 6:case 7:case 10:case 9:var c="";break a;default:var d=a._debugOwner,e=a._debugSource,f=pb(a.type);c=null;d&&(c=pb(d.type));d=f;f="";e?f=" (at "+e.fileName.replace(Ya,"")+":"+e.lineNumber+")":c&&(f=" (created by "+c+")");c="\n    in "+(d||"Unknown")+f}b+=c;a=a.return}while(a);return b}
function rb(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}function sb(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
function tb(a){var b=sb(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"undefined"!==typeof c&&"function"===typeof c.get&&"function"===typeof c.set){var e=c.get,f=c.set;Object.defineProperty(a,b,{configurable:!0,get:function(){return e.call(this)},set:function(a){d=""+a;f.call(this,a)}});Object.defineProperty(a,b,{enumerable:c.enumerable});return{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=
null;delete a[b]}}}}function xb(a){a._valueTracker||(a._valueTracker=tb(a))}function yb(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=sb(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}function zb(a,b){var c=b.checked;return n({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}
function Ab(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=rb(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function Bb(a,b){b=b.checked;null!=b&&Xa(a,"checked",b,!1)}
function Cb(a,b){Bb(a,b);var c=rb(b.value),d=b.type;if(null!=c)if("number"===d){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else if("submit"===d||"reset"===d){a.removeAttribute("value");return}b.hasOwnProperty("value")?Db(a,b.type,c):b.hasOwnProperty("defaultValue")&&Db(a,b.type,rb(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
function Eb(a,b,c){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue")){var d=b.type;if(!("submit"!==d&&"reset"!==d||void 0!==b.value&&null!==b.value))return;b=""+a._wrapperState.initialValue;c||b===a.value||(a.value=b);a.defaultValue=b}c=a.name;""!==c&&(a.name="");a.defaultChecked=!!a._wrapperState.initialChecked;""!==c&&(a.name=c)}
function Db(a,b,c){if("number"!==b||a.ownerDocument.activeElement!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}function Fb(a){var b="";aa.Children.forEach(a,function(a){null!=a&&(b+=a)});return b}function Gb(a,b){a=n({children:void 0},b);if(b=Fb(b.children))a.children=b;return a}
function Hb(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+rb(c);b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
function Ib(a,b){if(null!=b.dangerouslySetInnerHTML)throw Error(u(91));return n({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function Jb(a,b){var c=b.value;if(null==c){c=b.children;b=b.defaultValue;if(null!=c){if(null!=b)throw Error(u(92));if(Array.isArray(c)){if(!(1>=c.length))throw Error(u(93));c=c[0]}b=c}null==b&&(b="");c=b}a._wrapperState={initialValue:rb(c)}}
function Kb(a,b){var c=rb(b.value),d=rb(b.defaultValue);null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&a.defaultValue!==c&&(a.defaultValue=c));null!=d&&(a.defaultValue=""+d)}function Lb(a){var b=a.textContent;b===a._wrapperState.initialValue&&""!==b&&null!==b&&(a.value=b)}var Mb={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function Nb(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function Ob(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?Nb(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
var Pb,Qb=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==Mb.svg||"innerHTML"in a)a.innerHTML=b;else{Pb=Pb||document.createElement("div");Pb.innerHTML="<svg>"+b.valueOf().toString()+"</svg>";for(b=Pb.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
function Rb(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}function Sb(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;return c}var Tb={animationend:Sb("Animation","AnimationEnd"),animationiteration:Sb("Animation","AnimationIteration"),animationstart:Sb("Animation","AnimationStart"),transitionend:Sb("Transition","TransitionEnd")},Ub={},Vb={};
ya&&(Vb=document.createElement("div").style,"AnimationEvent"in window||(delete Tb.animationend.animation,delete Tb.animationiteration.animation,delete Tb.animationstart.animation),"TransitionEvent"in window||delete Tb.transitionend.transition);function Wb(a){if(Ub[a])return Ub[a];if(!Tb[a])return a;var b=Tb[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in Vb)return Ub[a]=b[c];return a}
var Xb=Wb("animationend"),Yb=Wb("animationiteration"),Zb=Wb("animationstart"),$b=Wb("transitionend"),ac="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),bc=new ("function"===typeof WeakMap?WeakMap:Map);function cc(a){var b=bc.get(a);void 0===b&&(b=new Map,bc.set(a,b));return b}
function dc(a){var b=a,c=a;if(a.alternate)for(;b.return;)b=b.return;else{a=b;do b=a,0!==(b.effectTag&1026)&&(c=b.return),a=b.return;while(a)}return 3===b.tag?c:null}function ec(a){if(13===a.tag){var b=a.memoizedState;null===b&&(a=a.alternate,null!==a&&(b=a.memoizedState));if(null!==b)return b.dehydrated}return null}function fc(a){if(dc(a)!==a)throw Error(u(188));}
function gc(a){var b=a.alternate;if(!b){b=dc(a);if(null===b)throw Error(u(188));return b!==a?null:a}for(var c=a,d=b;;){var e=c.return;if(null===e)break;var f=e.alternate;if(null===f){d=e.return;if(null!==d){c=d;continue}break}if(e.child===f.child){for(f=e.child;f;){if(f===c)return fc(e),a;if(f===d)return fc(e),b;f=f.sibling}throw Error(u(188));}if(c.return!==d.return)c=e,d=f;else{for(var g=!1,h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===
c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}if(!g)throw Error(u(189));}}if(c.alternate!==d)throw Error(u(190));}if(3!==c.tag)throw Error(u(188));return c.stateNode.current===c?a:b}function hc(a){a=gc(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}
function ic(a,b){if(null==b)throw Error(u(30));if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}function jc(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var kc=null;
function lc(a){if(a){var b=a._dispatchListeners,c=a._dispatchInstances;if(Array.isArray(b))for(var d=0;d<b.length&&!a.isPropagationStopped();d++)oa(a,b[d],c[d]);else b&&oa(a,b,c);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}function mc(a){null!==a&&(kc=ic(kc,a));a=kc;kc=null;if(a){jc(a,lc);if(kc)throw Error(u(95));if(fa)throw a=ha,fa=!1,ha=null,a;}}
function nc(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}function oc(a){if(!ya)return!1;a="on"+a;var b=a in document;b||(b=document.createElement("div"),b.setAttribute(a,"return;"),b="function"===typeof b[a]);return b}var pc=[];function qc(a){a.topLevelType=null;a.nativeEvent=null;a.targetInst=null;a.ancestors.length=0;10>pc.length&&pc.push(a)}
function rc(a,b,c,d){if(pc.length){var e=pc.pop();e.topLevelType=a;e.eventSystemFlags=d;e.nativeEvent=b;e.targetInst=c;return e}return{topLevelType:a,eventSystemFlags:d,nativeEvent:b,targetInst:c,ancestors:[]}}
function sc(a){var b=a.targetInst,c=b;do{if(!c){a.ancestors.push(c);break}var d=c;if(3===d.tag)d=d.stateNode.containerInfo;else{for(;d.return;)d=d.return;d=3!==d.tag?null:d.stateNode.containerInfo}if(!d)break;b=c.tag;5!==b&&6!==b||a.ancestors.push(c);c=tc(d)}while(c);for(c=0;c<a.ancestors.length;c++){b=a.ancestors[c];var e=nc(a.nativeEvent);d=a.topLevelType;var f=a.nativeEvent,g=a.eventSystemFlags;0===c&&(g|=64);for(var h=null,k=0;k<sa.length;k++){var l=sa[k];l&&(l=l.extractEvents(d,b,f,e,g))&&(h=
ic(h,l))}mc(h)}}function uc(a,b,c){if(!c.has(a)){switch(a){case "scroll":vc(b,"scroll",!0);break;case "focus":case "blur":vc(b,"focus",!0);vc(b,"blur",!0);c.set("blur",null);c.set("focus",null);break;case "cancel":case "close":oc(a)&&vc(b,a,!0);break;case "invalid":case "submit":case "reset":break;default:-1===ac.indexOf(a)&&F(a,b)}c.set(a,null)}}
var wc,xc,yc,zc=!1,Ac=[],Bc=null,Cc=null,Dc=null,Ec=new Map,Fc=new Map,Gc=[],Hc="mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput close cancel copy cut paste click change contextmenu reset submit".split(" "),Ic="focus blur dragenter dragleave mouseover mouseout pointerover pointerout gotpointercapture lostpointercapture".split(" ");
function Jc(a,b){var c=cc(b);Hc.forEach(function(a){uc(a,b,c)});Ic.forEach(function(a){uc(a,b,c)})}function Kc(a,b,c,d,e){return{blockedOn:a,topLevelType:b,eventSystemFlags:c|32,nativeEvent:e,container:d}}
function Lc(a,b){switch(a){case "focus":case "blur":Bc=null;break;case "dragenter":case "dragleave":Cc=null;break;case "mouseover":case "mouseout":Dc=null;break;case "pointerover":case "pointerout":Ec.delete(b.pointerId);break;case "gotpointercapture":case "lostpointercapture":Fc.delete(b.pointerId)}}function Mc(a,b,c,d,e,f){if(null===a||a.nativeEvent!==f)return a=Kc(b,c,d,e,f),null!==b&&(b=Nc(b),null!==b&&xc(b)),a;a.eventSystemFlags|=d;return a}
function Oc(a,b,c,d,e){switch(b){case "focus":return Bc=Mc(Bc,a,b,c,d,e),!0;case "dragenter":return Cc=Mc(Cc,a,b,c,d,e),!0;case "mouseover":return Dc=Mc(Dc,a,b,c,d,e),!0;case "pointerover":var f=e.pointerId;Ec.set(f,Mc(Ec.get(f)||null,a,b,c,d,e));return!0;case "gotpointercapture":return f=e.pointerId,Fc.set(f,Mc(Fc.get(f)||null,a,b,c,d,e)),!0}return!1}
function Pc(a){var b=tc(a.target);if(null!==b){var c=dc(b);if(null!==c)if(b=c.tag,13===b){if(b=ec(c),null!==b){a.blockedOn=b;r.unstable_runWithPriority(a.priority,function(){yc(c)});return}}else if(3===b&&c.stateNode.hydrate){a.blockedOn=3===c.tag?c.stateNode.containerInfo:null;return}}a.blockedOn=null}function Qc(a){if(null!==a.blockedOn)return!1;var b=Rc(a.topLevelType,a.eventSystemFlags,a.container,a.nativeEvent);if(null!==b){var c=Nc(b);null!==c&&xc(c);a.blockedOn=b;return!1}return!0}
function Sc(a,b,c){Qc(a)&&c.delete(b)}function Tc(){for(zc=!1;0<Ac.length;){var a=Ac[0];if(null!==a.blockedOn){a=Nc(a.blockedOn);null!==a&&wc(a);break}var b=Rc(a.topLevelType,a.eventSystemFlags,a.container,a.nativeEvent);null!==b?a.blockedOn=b:Ac.shift()}null!==Bc&&Qc(Bc)&&(Bc=null);null!==Cc&&Qc(Cc)&&(Cc=null);null!==Dc&&Qc(Dc)&&(Dc=null);Ec.forEach(Sc);Fc.forEach(Sc)}function Uc(a,b){a.blockedOn===b&&(a.blockedOn=null,zc||(zc=!0,r.unstable_scheduleCallback(r.unstable_NormalPriority,Tc)))}
function Vc(a){function b(b){return Uc(b,a)}if(0<Ac.length){Uc(Ac[0],a);for(var c=1;c<Ac.length;c++){var d=Ac[c];d.blockedOn===a&&(d.blockedOn=null)}}null!==Bc&&Uc(Bc,a);null!==Cc&&Uc(Cc,a);null!==Dc&&Uc(Dc,a);Ec.forEach(b);Fc.forEach(b);for(c=0;c<Gc.length;c++)d=Gc[c],d.blockedOn===a&&(d.blockedOn=null);for(;0<Gc.length&&(c=Gc[0],null===c.blockedOn);)Pc(c),null===c.blockedOn&&Gc.shift()}
var Wc={},Yc=new Map,Zc=new Map,$c=["abort","abort",Xb,"animationEnd",Yb,"animationIteration",Zb,"animationStart","canplay","canPlay","canplaythrough","canPlayThrough","durationchange","durationChange","emptied","emptied","encrypted","encrypted","ended","ended","error","error","gotpointercapture","gotPointerCapture","load","load","loadeddata","loadedData","loadedmetadata","loadedMetadata","loadstart","loadStart","lostpointercapture","lostPointerCapture","playing","playing","progress","progress","seeking",
"seeking","stalled","stalled","suspend","suspend","timeupdate","timeUpdate",$b,"transitionEnd","waiting","waiting"];function ad(a,b){for(var c=0;c<a.length;c+=2){var d=a[c],e=a[c+1],f="on"+(e[0].toUpperCase()+e.slice(1));f={phasedRegistrationNames:{bubbled:f,captured:f+"Capture"},dependencies:[d],eventPriority:b};Zc.set(d,b);Yc.set(d,f);Wc[e]=f}}
ad("blur blur cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focus focus input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "),0);
ad("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "),1);ad($c,2);for(var bd="change selectionchange textInput compositionstart compositionend compositionupdate".split(" "),cd=0;cd<bd.length;cd++)Zc.set(bd[cd],0);
var dd=r.unstable_UserBlockingPriority,ed=r.unstable_runWithPriority,fd=!0;function F(a,b){vc(b,a,!1)}function vc(a,b,c){var d=Zc.get(b);switch(void 0===d?2:d){case 0:d=gd.bind(null,b,1,a);break;case 1:d=hd.bind(null,b,1,a);break;default:d=id.bind(null,b,1,a)}c?a.addEventListener(b,d,!0):a.addEventListener(b,d,!1)}function gd(a,b,c,d){Ja||Ha();var e=id,f=Ja;Ja=!0;try{Ga(e,a,b,c,d)}finally{(Ja=f)||La()}}function hd(a,b,c,d){ed(dd,id.bind(null,a,b,c,d))}
function id(a,b,c,d){if(fd)if(0<Ac.length&&-1<Hc.indexOf(a))a=Kc(null,a,b,c,d),Ac.push(a);else{var e=Rc(a,b,c,d);if(null===e)Lc(a,d);else if(-1<Hc.indexOf(a))a=Kc(e,a,b,c,d),Ac.push(a);else if(!Oc(e,a,b,c,d)){Lc(a,d);a=rc(a,d,null,b);try{Ma(sc,a)}finally{qc(a)}}}}
function Rc(a,b,c,d){c=nc(d);c=tc(c);if(null!==c){var e=dc(c);if(null===e)c=null;else{var f=e.tag;if(13===f){c=ec(e);if(null!==c)return c;c=null}else if(3===f){if(e.stateNode.hydrate)return 3===e.tag?e.stateNode.containerInfo:null;c=null}else e!==c&&(c=null)}}a=rc(a,d,c,b);try{Ma(sc,a)}finally{qc(a)}return null}
var jd={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,
floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},kd=["Webkit","ms","Moz","O"];Object.keys(jd).forEach(function(a){kd.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);jd[b]=jd[a]})});function ld(a,b,c){return null==b||"boolean"===typeof b||""===b?"":c||"number"!==typeof b||0===b||jd.hasOwnProperty(a)&&jd[a]?(""+b).trim():b+"px"}
function md(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--"),e=ld(c,b[c],d);"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var nd=n({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
function od(a,b){if(b){if(nd[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML))throw Error(u(137,a,""));if(null!=b.dangerouslySetInnerHTML){if(null!=b.children)throw Error(u(60));if(!("object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML))throw Error(u(61));}if(null!=b.style&&"object"!==typeof b.style)throw Error(u(62,""));}}
function pd(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}var qd=Mb.html;function rd(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=cc(a);b=wa[b];for(var d=0;d<b.length;d++)uc(b[d],a,c)}function sd(){}
function td(a){a=a||("undefined"!==typeof document?document:void 0);if("undefined"===typeof a)return null;try{return a.activeElement||a.body}catch(b){return a.body}}function ud(a){for(;a&&a.firstChild;)a=a.firstChild;return a}function vd(a,b){var c=ud(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=ud(c)}}
function wd(a,b){return a&&b?a===b?!0:a&&3===a.nodeType?!1:b&&3===b.nodeType?wd(a,b.parentNode):"contains"in a?a.contains(b):a.compareDocumentPosition?!!(a.compareDocumentPosition(b)&16):!1:!1}function xd(){for(var a=window,b=td();b instanceof a.HTMLIFrameElement;){try{var c="string"===typeof b.contentWindow.location.href}catch(d){c=!1}if(c)a=b.contentWindow;else break;b=td(a.document)}return b}
function yd(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&("text"===a.type||"search"===a.type||"tel"===a.type||"url"===a.type||"password"===a.type)||"textarea"===b||"true"===a.contentEditable)}var zd="$",Ad="/$",Bd="$?",Cd="$!",Dd=null,Ed=null;function Fd(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}
function Gd(a,b){return"textarea"===a||"option"===a||"noscript"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&null!=b.dangerouslySetInnerHTML.__html}var Hd="function"===typeof setTimeout?setTimeout:void 0,Id="function"===typeof clearTimeout?clearTimeout:void 0;function Jd(a){for(;null!=a;a=a.nextSibling){var b=a.nodeType;if(1===b||3===b)break}return a}
function Kd(a){a=a.previousSibling;for(var b=0;a;){if(8===a.nodeType){var c=a.data;if(c===zd||c===Cd||c===Bd){if(0===b)return a;b--}else c===Ad&&b++}a=a.previousSibling}return null}var Ld=Math.random().toString(36).slice(2),Md="__reactInternalInstance$"+Ld,Nd="__reactEventHandlers$"+Ld,Od="__reactContainere$"+Ld;
function tc(a){var b=a[Md];if(b)return b;for(var c=a.parentNode;c;){if(b=c[Od]||c[Md]){c=b.alternate;if(null!==b.child||null!==c&&null!==c.child)for(a=Kd(a);null!==a;){if(c=a[Md])return c;a=Kd(a)}return b}a=c;c=a.parentNode}return null}function Nc(a){a=a[Md]||a[Od];return!a||5!==a.tag&&6!==a.tag&&13!==a.tag&&3!==a.tag?null:a}function Pd(a){if(5===a.tag||6===a.tag)return a.stateNode;throw Error(u(33));}function Qd(a){return a[Nd]||null}
function Rd(a){do a=a.return;while(a&&5!==a.tag);return a?a:null}
function Sd(a,b){var c=a.stateNode;if(!c)return null;var d=la(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":case "onMouseEnter":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;if(c&&"function"!==typeof c)throw Error(u(231,
b,typeof c));return c}function Td(a,b,c){if(b=Sd(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=ic(c._dispatchListeners,b),c._dispatchInstances=ic(c._dispatchInstances,a)}function Ud(a){if(a&&a.dispatchConfig.phasedRegistrationNames){for(var b=a._targetInst,c=[];b;)c.push(b),b=Rd(b);for(b=c.length;0<b--;)Td(c[b],"captured",a);for(b=0;b<c.length;b++)Td(c[b],"bubbled",a)}}
function Vd(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Sd(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=ic(c._dispatchListeners,b),c._dispatchInstances=ic(c._dispatchInstances,a))}function Wd(a){a&&a.dispatchConfig.registrationName&&Vd(a._targetInst,null,a)}function Xd(a){jc(a,Ud)}var Yd=null,Zd=null,$d=null;
function ae(){if($d)return $d;var a,b=Zd,c=b.length,d,e="value"in Yd?Yd.value:Yd.textContent,f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);return $d=e.slice(a,1<d?1-d:void 0)}function be(){return!0}function ce(){return!1}
function G(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?be:ce;this.isPropagationStopped=ce;return this}
n(G.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=be)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=be)},persist:function(){this.isPersistent=be},isPersistent:ce,destructor:function(){var a=this.constructor.Interface,
b;for(b in a)this[b]=null;this.nativeEvent=this._targetInst=this.dispatchConfig=null;this.isPropagationStopped=this.isDefaultPrevented=ce;this._dispatchInstances=this._dispatchListeners=null}});G.Interface={type:null,target:null,currentTarget:function(){return null},eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
G.extend=function(a){function b(){}function c(){return d.apply(this,arguments)}var d=this;b.prototype=d.prototype;var e=new b;n(e,c.prototype);c.prototype=e;c.prototype.constructor=c;c.Interface=n({},d.Interface,a);c.extend=d.extend;de(c);return c};de(G);function ee(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}
function fe(a){if(!(a instanceof this))throw Error(u(279));a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function de(a){a.eventPool=[];a.getPooled=ee;a.release=fe}var ge=G.extend({data:null}),he=G.extend({data:null}),ie=[9,13,27,32],je=ya&&"CompositionEvent"in window,ke=null;ya&&"documentMode"in document&&(ke=document.documentMode);
var le=ya&&"TextEvent"in window&&!ke,me=ya&&(!je||ke&&8<ke&&11>=ke),ne=String.fromCharCode(32),oe={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["compositionend","keypress","textInput","paste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"blur compositionend keydown keypress keyup mousedown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
captured:"onCompositionStartCapture"},dependencies:"blur compositionstart keydown keypress keyup mousedown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"blur compositionupdate keydown keypress keyup mousedown".split(" ")}},pe=!1;
function qe(a,b){switch(a){case "keyup":return-1!==ie.indexOf(b.keyCode);case "keydown":return 229!==b.keyCode;case "keypress":case "mousedown":case "blur":return!0;default:return!1}}function re(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var se=!1;function te(a,b){switch(a){case "compositionend":return re(b);case "keypress":if(32!==b.which)return null;pe=!0;return ne;case "textInput":return a=b.data,a===ne&&pe?null:a;default:return null}}
function ue(a,b){if(se)return"compositionend"===a||!je&&qe(a,b)?(a=ae(),$d=Zd=Yd=null,se=!1,a):null;switch(a){case "paste":return null;case "keypress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "compositionend":return me&&"ko"!==b.locale?null:b.data;default:return null}}
var ve={eventTypes:oe,extractEvents:function(a,b,c,d){var e;if(je)b:{switch(a){case "compositionstart":var f=oe.compositionStart;break b;case "compositionend":f=oe.compositionEnd;break b;case "compositionupdate":f=oe.compositionUpdate;break b}f=void 0}else se?qe(a,c)&&(f=oe.compositionEnd):"keydown"===a&&229===c.keyCode&&(f=oe.compositionStart);f?(me&&"ko"!==c.locale&&(se||f!==oe.compositionStart?f===oe.compositionEnd&&se&&(e=ae()):(Yd=d,Zd="value"in Yd?Yd.value:Yd.textContent,se=!0)),f=ge.getPooled(f,
b,c,d),e?f.data=e:(e=re(c),null!==e&&(f.data=e)),Xd(f),e=f):e=null;(a=le?te(a,c):ue(a,c))?(b=he.getPooled(oe.beforeInput,b,c,d),b.data=a,Xd(b)):b=null;return null===e?b:null===b?e:[e,b]}},we={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function xe(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!we[a.type]:"textarea"===b?!0:!1}
var ye={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"blur change click focus input keydown keyup selectionchange".split(" ")}};function ze(a,b,c){a=G.getPooled(ye.change,a,b,c);a.type="change";Da(c);Xd(a);return a}var Ae=null,Be=null;function Ce(a){mc(a)}function De(a){var b=Pd(a);if(yb(b))return a}function Ee(a,b){if("change"===a)return b}var Fe=!1;ya&&(Fe=oc("input")&&(!document.documentMode||9<document.documentMode));
function Ge(){Ae&&(Ae.detachEvent("onpropertychange",He),Be=Ae=null)}function He(a){if("value"===a.propertyName&&De(Be))if(a=ze(Be,a,nc(a)),Ja)mc(a);else{Ja=!0;try{Fa(Ce,a)}finally{Ja=!1,La()}}}function Ie(a,b,c){"focus"===a?(Ge(),Ae=b,Be=c,Ae.attachEvent("onpropertychange",He)):"blur"===a&&Ge()}function Je(a){if("selectionchange"===a||"keyup"===a||"keydown"===a)return De(Be)}function Ke(a,b){if("click"===a)return De(b)}function Le(a,b){if("input"===a||"change"===a)return De(b)}
var Me={eventTypes:ye,_isInputEventSupported:Fe,extractEvents:function(a,b,c,d){var e=b?Pd(b):window,f=e.nodeName&&e.nodeName.toLowerCase();if("select"===f||"input"===f&&"file"===e.type)var g=Ee;else if(xe(e))if(Fe)g=Le;else{g=Je;var h=Ie}else(f=e.nodeName)&&"input"===f.toLowerCase()&&("checkbox"===e.type||"radio"===e.type)&&(g=Ke);if(g&&(g=g(a,b)))return ze(g,c,d);h&&h(a,e,b);"blur"===a&&(a=e._wrapperState)&&a.controlled&&"number"===e.type&&Db(e,"number",e.value)}},Ne=G.extend({view:null,detail:null}),
Oe={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function Pe(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=Oe[a])?!!b[a]:!1}function Qe(){return Pe}
var Re=0,Se=0,Te=!1,Ue=!1,Ve=Ne.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:Qe,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)},movementX:function(a){if("movementX"in a)return a.movementX;var b=Re;Re=a.screenX;return Te?"mousemove"===a.type?a.screenX-b:0:(Te=!0,0)},movementY:function(a){if("movementY"in a)return a.movementY;
var b=Se;Se=a.screenY;return Ue?"mousemove"===a.type?a.screenY-b:0:(Ue=!0,0)}}),We=Ve.extend({pointerId:null,width:null,height:null,pressure:null,tangentialPressure:null,tiltX:null,tiltY:null,twist:null,pointerType:null,isPrimary:null}),Xe={mouseEnter:{registrationName:"onMouseEnter",dependencies:["mouseout","mouseover"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["mouseout","mouseover"]},pointerEnter:{registrationName:"onPointerEnter",dependencies:["pointerout","pointerover"]},pointerLeave:{registrationName:"onPointerLeave",
dependencies:["pointerout","pointerover"]}},Ye={eventTypes:Xe,extractEvents:function(a,b,c,d,e){var f="mouseover"===a||"pointerover"===a,g="mouseout"===a||"pointerout"===a;if(f&&0===(e&32)&&(c.relatedTarget||c.fromElement)||!g&&!f)return null;f=d.window===d?d:(f=d.ownerDocument)?f.defaultView||f.parentWindow:window;if(g){if(g=b,b=(b=c.relatedTarget||c.toElement)?tc(b):null,null!==b){var h=dc(b);if(b!==h||5!==b.tag&&6!==b.tag)b=null}}else g=null;if(g===b)return null;if("mouseout"===a||"mouseover"===
a){var k=Ve;var l=Xe.mouseLeave;var m=Xe.mouseEnter;var p="mouse"}else if("pointerout"===a||"pointerover"===a)k=We,l=Xe.pointerLeave,m=Xe.pointerEnter,p="pointer";a=null==g?f:Pd(g);f=null==b?f:Pd(b);l=k.getPooled(l,g,c,d);l.type=p+"leave";l.target=a;l.relatedTarget=f;c=k.getPooled(m,b,c,d);c.type=p+"enter";c.target=f;c.relatedTarget=a;d=g;p=b;if(d&&p)a:{k=d;m=p;g=0;for(a=k;a;a=Rd(a))g++;a=0;for(b=m;b;b=Rd(b))a++;for(;0<g-a;)k=Rd(k),g--;for(;0<a-g;)m=Rd(m),a--;for(;g--;){if(k===m||k===m.alternate)break a;
k=Rd(k);m=Rd(m)}k=null}else k=null;m=k;for(k=[];d&&d!==m;){g=d.alternate;if(null!==g&&g===m)break;k.push(d);d=Rd(d)}for(d=[];p&&p!==m;){g=p.alternate;if(null!==g&&g===m)break;d.push(p);p=Rd(p)}for(p=0;p<k.length;p++)Vd(k[p],"bubbled",l);for(p=d.length;0<p--;)Vd(d[p],"captured",c);return 0===(e&64)?[l]:[l,c]}};function Ze(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var $e="function"===typeof Object.is?Object.is:Ze,af=Object.prototype.hasOwnProperty;
function bf(a,b){if($e(a,b))return!0;if("object"!==typeof a||null===a||"object"!==typeof b||null===b)return!1;var c=Object.keys(a),d=Object.keys(b);if(c.length!==d.length)return!1;for(d=0;d<c.length;d++)if(!af.call(b,c[d])||!$e(a[c[d]],b[c[d]]))return!1;return!0}
var cf=ya&&"documentMode"in document&&11>=document.documentMode,df={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")}},ef=null,ff=null,gf=null,hf=!1;
function jf(a,b){var c=b.window===b?b.document:9===b.nodeType?b:b.ownerDocument;if(hf||null==ef||ef!==td(c))return null;c=ef;"selectionStart"in c&&yd(c)?c={start:c.selectionStart,end:c.selectionEnd}:(c=(c.ownerDocument&&c.ownerDocument.defaultView||window).getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset});return gf&&bf(gf,c)?null:(gf=c,a=G.getPooled(df.select,ff,a,b),a.type="select",a.target=ef,Xd(a),a)}
var kf={eventTypes:df,extractEvents:function(a,b,c,d,e,f){e=f||(d.window===d?d.document:9===d.nodeType?d:d.ownerDocument);if(!(f=!e)){a:{e=cc(e);f=wa.onSelect;for(var g=0;g<f.length;g++)if(!e.has(f[g])){e=!1;break a}e=!0}f=!e}if(f)return null;e=b?Pd(b):window;switch(a){case "focus":if(xe(e)||"true"===e.contentEditable)ef=e,ff=b,gf=null;break;case "blur":gf=ff=ef=null;break;case "mousedown":hf=!0;break;case "contextmenu":case "mouseup":case "dragend":return hf=!1,jf(c,d);case "selectionchange":if(cf)break;
case "keydown":case "keyup":return jf(c,d)}return null}},lf=G.extend({animationName:null,elapsedTime:null,pseudoElement:null}),mf=G.extend({clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),nf=Ne.extend({relatedTarget:null});function of(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}
var pf={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},qf={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},rf=Ne.extend({key:function(a){if(a.key){var b=pf[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=of(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?qf[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:Qe,charCode:function(a){return"keypress"===
a.type?of(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===a.type?of(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),sf=Ve.extend({dataTransfer:null}),tf=Ne.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:Qe}),uf=G.extend({propertyName:null,elapsedTime:null,pseudoElement:null}),vf=Ve.extend({deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in
a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null}),wf={eventTypes:Wc,extractEvents:function(a,b,c,d){var e=Yc.get(a);if(!e)return null;switch(a){case "keypress":if(0===of(c))return null;case "keydown":case "keyup":a=rf;break;case "blur":case "focus":a=nf;break;case "click":if(2===c.button)return null;case "auxclick":case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":a=
Ve;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":a=sf;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":a=tf;break;case Xb:case Yb:case Zb:a=lf;break;case $b:a=uf;break;case "scroll":a=Ne;break;case "wheel":a=vf;break;case "copy":case "cut":case "paste":a=mf;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":a=
We;break;default:a=G}b=a.getPooled(e,b,c,d);Xd(b);return b}};if(pa)throw Error(u(101));pa=Array.prototype.slice.call("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));ra();var xf=Nc;la=Qd;ma=xf;na=Pd;xa({SimpleEventPlugin:wf,EnterLeaveEventPlugin:Ye,ChangeEventPlugin:Me,SelectEventPlugin:kf,BeforeInputEventPlugin:ve});var yf=[],zf=-1;function H(a){0>zf||(a.current=yf[zf],yf[zf]=null,zf--)}
function I(a,b){zf++;yf[zf]=a.current;a.current=b}var Af={},J={current:Af},K={current:!1},Bf=Af;function Cf(a,b){var c=a.type.contextTypes;if(!c)return Af;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function L(a){a=a.childContextTypes;return null!==a&&void 0!==a}
function Df(){H(K);H(J)}function Ef(a,b,c){if(J.current!==Af)throw Error(u(168));I(J,b);I(K,c)}function Ff(a,b,c){var d=a.stateNode;a=b.childContextTypes;if("function"!==typeof d.getChildContext)return c;d=d.getChildContext();for(var e in d)if(!(e in a))throw Error(u(108,pb(b)||"Unknown",e));return n({},c,{},d)}function Gf(a){a=(a=a.stateNode)&&a.__reactInternalMemoizedMergedChildContext||Af;Bf=J.current;I(J,a);I(K,K.current);return!0}
function Hf(a,b,c){var d=a.stateNode;if(!d)throw Error(u(169));c?(a=Ff(a,b,Bf),d.__reactInternalMemoizedMergedChildContext=a,H(K),H(J),I(J,a)):H(K);I(K,c)}
var If=r.unstable_runWithPriority,Jf=r.unstable_scheduleCallback,Kf=r.unstable_cancelCallback,Lf=r.unstable_requestPaint,Mf=r.unstable_now,Nf=r.unstable_getCurrentPriorityLevel,Of=r.unstable_ImmediatePriority,Pf=r.unstable_UserBlockingPriority,Qf=r.unstable_NormalPriority,Rf=r.unstable_LowPriority,Sf=r.unstable_IdlePriority,Tf={},Uf=r.unstable_shouldYield,Vf=void 0!==Lf?Lf:function(){},Wf=null,Xf=null,Yf=!1,Zf=Mf(),$f=1E4>Zf?Mf:function(){return Mf()-Zf};
function ag(){switch(Nf()){case Of:return 99;case Pf:return 98;case Qf:return 97;case Rf:return 96;case Sf:return 95;default:throw Error(u(332));}}function bg(a){switch(a){case 99:return Of;case 98:return Pf;case 97:return Qf;case 96:return Rf;case 95:return Sf;default:throw Error(u(332));}}function cg(a,b){a=bg(a);return If(a,b)}function dg(a,b,c){a=bg(a);return Jf(a,b,c)}function eg(a){null===Wf?(Wf=[a],Xf=Jf(Of,fg)):Wf.push(a);return Tf}function gg(){if(null!==Xf){var a=Xf;Xf=null;Kf(a)}fg()}
function fg(){if(!Yf&&null!==Wf){Yf=!0;var a=0;try{var b=Wf;cg(99,function(){for(;a<b.length;a++){var c=b[a];do c=c(!0);while(null!==c)}});Wf=null}catch(c){throw null!==Wf&&(Wf=Wf.slice(a+1)),Jf(Of,gg),c;}finally{Yf=!1}}}function hg(a,b,c){c/=10;return 1073741821-(((1073741821-a+b/10)/c|0)+1)*c}function ig(a,b){if(a&&a.defaultProps){b=n({},b);a=a.defaultProps;for(var c in a)void 0===b[c]&&(b[c]=a[c])}return b}var jg={current:null},kg=null,lg=null,mg=null;function ng(){mg=lg=kg=null}
function og(a){var b=jg.current;H(jg);a.type._context._currentValue=b}function pg(a,b){for(;null!==a;){var c=a.alternate;if(a.childExpirationTime<b)a.childExpirationTime=b,null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);else if(null!==c&&c.childExpirationTime<b)c.childExpirationTime=b;else break;a=a.return}}function qg(a,b){kg=a;mg=lg=null;a=a.dependencies;null!==a&&null!==a.firstContext&&(a.expirationTime>=b&&(rg=!0),a.firstContext=null)}
function sg(a,b){if(mg!==a&&!1!==b&&0!==b){if("number"!==typeof b||1073741823===b)mg=a,b=1073741823;b={context:a,observedBits:b,next:null};if(null===lg){if(null===kg)throw Error(u(308));lg=b;kg.dependencies={expirationTime:0,firstContext:b,responders:null}}else lg=lg.next=b}return a._currentValue}var tg=!1;function ug(a){a.updateQueue={baseState:a.memoizedState,baseQueue:null,shared:{pending:null},effects:null}}
function vg(a,b){a=a.updateQueue;b.updateQueue===a&&(b.updateQueue={baseState:a.baseState,baseQueue:a.baseQueue,shared:a.shared,effects:a.effects})}function wg(a,b){a={expirationTime:a,suspenseConfig:b,tag:0,payload:null,callback:null,next:null};return a.next=a}function xg(a,b){a=a.updateQueue;if(null!==a){a=a.shared;var c=a.pending;null===c?b.next=b:(b.next=c.next,c.next=b);a.pending=b}}
function yg(a,b){var c=a.alternate;null!==c&&vg(c,a);a=a.updateQueue;c=a.baseQueue;null===c?(a.baseQueue=b.next=b,b.next=b):(b.next=c.next,c.next=b)}
function zg(a,b,c,d){var e=a.updateQueue;tg=!1;var f=e.baseQueue,g=e.shared.pending;if(null!==g){if(null!==f){var h=f.next;f.next=g.next;g.next=h}f=g;e.shared.pending=null;h=a.alternate;null!==h&&(h=h.updateQueue,null!==h&&(h.baseQueue=g))}if(null!==f){h=f.next;var k=e.baseState,l=0,m=null,p=null,x=null;if(null!==h){var z=h;do{g=z.expirationTime;if(g<d){var ca={expirationTime:z.expirationTime,suspenseConfig:z.suspenseConfig,tag:z.tag,payload:z.payload,callback:z.callback,next:null};null===x?(p=x=
ca,m=k):x=x.next=ca;g>l&&(l=g)}else{null!==x&&(x=x.next={expirationTime:1073741823,suspenseConfig:z.suspenseConfig,tag:z.tag,payload:z.payload,callback:z.callback,next:null});Ag(g,z.suspenseConfig);a:{var D=a,t=z;g=b;ca=c;switch(t.tag){case 1:D=t.payload;if("function"===typeof D){k=D.call(ca,k,g);break a}k=D;break a;case 3:D.effectTag=D.effectTag&-4097|64;case 0:D=t.payload;g="function"===typeof D?D.call(ca,k,g):D;if(null===g||void 0===g)break a;k=n({},k,g);break a;case 2:tg=!0}}null!==z.callback&&
(a.effectTag|=32,g=e.effects,null===g?e.effects=[z]:g.push(z))}z=z.next;if(null===z||z===h)if(g=e.shared.pending,null===g)break;else z=f.next=g.next,g.next=h,e.baseQueue=f=g,e.shared.pending=null}while(1)}null===x?m=k:x.next=p;e.baseState=m;e.baseQueue=x;Bg(l);a.expirationTime=l;a.memoizedState=k}}
function Cg(a,b,c){a=b.effects;b.effects=null;if(null!==a)for(b=0;b<a.length;b++){var d=a[b],e=d.callback;if(null!==e){d.callback=null;d=e;e=c;if("function"!==typeof d)throw Error(u(191,d));d.call(e)}}}var Dg=Wa.ReactCurrentBatchConfig,Eg=(new aa.Component).refs;function Fg(a,b,c,d){b=a.memoizedState;c=c(d,b);c=null===c||void 0===c?b:n({},b,c);a.memoizedState=c;0===a.expirationTime&&(a.updateQueue.baseState=c)}
var Jg={isMounted:function(a){return(a=a._reactInternalFiber)?dc(a)===a:!1},enqueueSetState:function(a,b,c){a=a._reactInternalFiber;var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e=wg(d,e);e.payload=b;void 0!==c&&null!==c&&(e.callback=c);xg(a,e);Ig(a,d)},enqueueReplaceState:function(a,b,c){a=a._reactInternalFiber;var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e=wg(d,e);e.tag=1;e.payload=b;void 0!==c&&null!==c&&(e.callback=c);xg(a,e);Ig(a,d)},enqueueForceUpdate:function(a,b){a=a._reactInternalFiber;var c=Gg(),d=Dg.suspense;
c=Hg(c,a,d);d=wg(c,d);d.tag=2;void 0!==b&&null!==b&&(d.callback=b);xg(a,d);Ig(a,c)}};function Kg(a,b,c,d,e,f,g){a=a.stateNode;return"function"===typeof a.shouldComponentUpdate?a.shouldComponentUpdate(d,f,g):b.prototype&&b.prototype.isPureReactComponent?!bf(c,d)||!bf(e,f):!0}
function Lg(a,b,c){var d=!1,e=Af;var f=b.contextType;"object"===typeof f&&null!==f?f=sg(f):(e=L(b)?Bf:J.current,d=b.contextTypes,f=(d=null!==d&&void 0!==d)?Cf(a,e):Af);b=new b(c,f);a.memoizedState=null!==b.state&&void 0!==b.state?b.state:null;b.updater=Jg;a.stateNode=b;b._reactInternalFiber=a;d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=e,a.__reactInternalMemoizedMaskedChildContext=f);return b}
function Mg(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&Jg.enqueueReplaceState(b,b.state,null)}
function Ng(a,b,c,d){var e=a.stateNode;e.props=c;e.state=a.memoizedState;e.refs=Eg;ug(a);var f=b.contextType;"object"===typeof f&&null!==f?e.context=sg(f):(f=L(b)?Bf:J.current,e.context=Cf(a,f));zg(a,c,e,d);e.state=a.memoizedState;f=b.getDerivedStateFromProps;"function"===typeof f&&(Fg(a,b,f,c),e.state=a.memoizedState);"function"===typeof b.getDerivedStateFromProps||"function"===typeof e.getSnapshotBeforeUpdate||"function"!==typeof e.UNSAFE_componentWillMount&&"function"!==typeof e.componentWillMount||
(b=e.state,"function"===typeof e.componentWillMount&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&e.UNSAFE_componentWillMount(),b!==e.state&&Jg.enqueueReplaceState(e,e.state,null),zg(a,c,e,d),e.state=a.memoizedState);"function"===typeof e.componentDidMount&&(a.effectTag|=4)}var Og=Array.isArray;
function Pg(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;if(c){if(1!==c.tag)throw Error(u(309));var d=c.stateNode}if(!d)throw Error(u(147,a));var e=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs;b===Eg&&(b=d.refs={});null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}if("string"!==typeof a)throw Error(u(284));if(!c._owner)throw Error(u(290,a));}return a}
function Qg(a,b){if("textarea"!==a.type)throw Error(u(31,"[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,""));}
function Rg(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b){a=Sg(a,b);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=Tg(c,a.mode,d),b.return=a,b;b=e(b,c);b.return=a;return b}function k(a,b,c,d){if(null!==b&&b.elementType===c.type)return d=e(b,c.props),d.ref=Pg(a,b,c),d.return=a,d;d=Ug(c.type,c.key,c.props,null,a.mode,d);d.ref=Pg(a,b,c);d.return=a;return d}function l(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==
c.implementation)return b=Vg(c,a.mode,d),b.return=a,b;b=e(b,c.children||[]);b.return=a;return b}function m(a,b,c,d,f){if(null===b||7!==b.tag)return b=Wg(c,a.mode,d,f),b.return=a,b;b=e(b,c);b.return=a;return b}function p(a,b,c){if("string"===typeof b||"number"===typeof b)return b=Tg(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case Za:return c=Ug(b.type,b.key,b.props,null,a.mode,c),c.ref=Pg(a,null,b),c.return=a,c;case $a:return b=Vg(b,a.mode,c),b.return=a,b}if(Og(b)||
nb(b))return b=Wg(b,a.mode,c,null),b.return=a,b;Qg(a,b)}return null}function x(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case Za:return c.key===e?c.type===ab?m(a,b,c.props.children,d,e):k(a,b,c,d):null;case $a:return c.key===e?l(a,b,c,d):null}if(Og(c)||nb(c))return null!==e?null:m(a,b,c,d,null);Qg(a,c)}return null}function z(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=
a.get(c)||null,h(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case Za:return a=a.get(null===d.key?c:d.key)||null,d.type===ab?m(b,a,d.props.children,e,d.key):k(b,a,d,e);case $a:return a=a.get(null===d.key?c:d.key)||null,l(b,a,d,e)}if(Og(d)||nb(d))return a=a.get(c)||null,m(b,a,d,e,null);Qg(b,d)}return null}function ca(e,g,h,k){for(var l=null,t=null,m=g,y=g=0,A=null;null!==m&&y<h.length;y++){m.index>y?(A=m,m=null):A=m.sibling;var q=x(e,m,h[y],k);if(null===q){null===m&&(m=A);break}a&&
m&&null===q.alternate&&b(e,m);g=f(q,g,y);null===t?l=q:t.sibling=q;t=q;m=A}if(y===h.length)return c(e,m),l;if(null===m){for(;y<h.length;y++)m=p(e,h[y],k),null!==m&&(g=f(m,g,y),null===t?l=m:t.sibling=m,t=m);return l}for(m=d(e,m);y<h.length;y++)A=z(m,e,y,h[y],k),null!==A&&(a&&null!==A.alternate&&m.delete(null===A.key?y:A.key),g=f(A,g,y),null===t?l=A:t.sibling=A,t=A);a&&m.forEach(function(a){return b(e,a)});return l}function D(e,g,h,l){var k=nb(h);if("function"!==typeof k)throw Error(u(150));h=k.call(h);
if(null==h)throw Error(u(151));for(var m=k=null,t=g,y=g=0,A=null,q=h.next();null!==t&&!q.done;y++,q=h.next()){t.index>y?(A=t,t=null):A=t.sibling;var D=x(e,t,q.value,l);if(null===D){null===t&&(t=A);break}a&&t&&null===D.alternate&&b(e,t);g=f(D,g,y);null===m?k=D:m.sibling=D;m=D;t=A}if(q.done)return c(e,t),k;if(null===t){for(;!q.done;y++,q=h.next())q=p(e,q.value,l),null!==q&&(g=f(q,g,y),null===m?k=q:m.sibling=q,m=q);return k}for(t=d(e,t);!q.done;y++,q=h.next())q=z(t,e,y,q.value,l),null!==q&&(a&&null!==
q.alternate&&t.delete(null===q.key?y:q.key),g=f(q,g,y),null===m?k=q:m.sibling=q,m=q);a&&t.forEach(function(a){return b(e,a)});return k}return function(a,d,f,h){var k="object"===typeof f&&null!==f&&f.type===ab&&null===f.key;k&&(f=f.props.children);var l="object"===typeof f&&null!==f;if(l)switch(f.$$typeof){case Za:a:{l=f.key;for(k=d;null!==k;){if(k.key===l){switch(k.tag){case 7:if(f.type===ab){c(a,k.sibling);d=e(k,f.props.children);d.return=a;a=d;break a}break;default:if(k.elementType===f.type){c(a,
k.sibling);d=e(k,f.props);d.ref=Pg(a,k,f);d.return=a;a=d;break a}}c(a,k);break}else b(a,k);k=k.sibling}f.type===ab?(d=Wg(f.props.children,a.mode,h,f.key),d.return=a,a=d):(h=Ug(f.type,f.key,f.props,null,a.mode,h),h.ref=Pg(a,d,f),h.return=a,a=h)}return g(a);case $a:a:{for(k=f.key;null!==d;){if(d.key===k)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[]);d.return=a;a=d;break a}else{c(a,d);break}else b(a,d);d=
d.sibling}d=Vg(f,a.mode,h);d.return=a;a=d}return g(a)}if("string"===typeof f||"number"===typeof f)return f=""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f),d.return=a,a=d):(c(a,d),d=Tg(f,a.mode,h),d.return=a,a=d),g(a);if(Og(f))return ca(a,d,f,h);if(nb(f))return D(a,d,f,h);l&&Qg(a,f);if("undefined"===typeof f&&!k)switch(a.tag){case 1:case 0:throw a=a.type,Error(u(152,a.displayName||a.name||"Component"));}return c(a,d)}}var Xg=Rg(!0),Yg=Rg(!1),Zg={},$g={current:Zg},ah={current:Zg},bh={current:Zg};
function ch(a){if(a===Zg)throw Error(u(174));return a}function dh(a,b){I(bh,b);I(ah,a);I($g,Zg);a=b.nodeType;switch(a){case 9:case 11:b=(b=b.documentElement)?b.namespaceURI:Ob(null,"");break;default:a=8===a?b.parentNode:b,b=a.namespaceURI||null,a=a.tagName,b=Ob(b,a)}H($g);I($g,b)}function eh(){H($g);H(ah);H(bh)}function fh(a){ch(bh.current);var b=ch($g.current);var c=Ob(b,a.type);b!==c&&(I(ah,a),I($g,c))}function gh(a){ah.current===a&&(H($g),H(ah))}var M={current:0};
function hh(a){for(var b=a;null!==b;){if(13===b.tag){var c=b.memoizedState;if(null!==c&&(c=c.dehydrated,null===c||c.data===Bd||c.data===Cd))return b}else if(19===b.tag&&void 0!==b.memoizedProps.revealOrder){if(0!==(b.effectTag&64))return b}else if(null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}return null}function ih(a,b){return{responder:a,props:b}}
var jh=Wa.ReactCurrentDispatcher,kh=Wa.ReactCurrentBatchConfig,lh=0,N=null,O=null,P=null,mh=!1;function Q(){throw Error(u(321));}function nh(a,b){if(null===b)return!1;for(var c=0;c<b.length&&c<a.length;c++)if(!$e(a[c],b[c]))return!1;return!0}
function oh(a,b,c,d,e,f){lh=f;N=b;b.memoizedState=null;b.updateQueue=null;b.expirationTime=0;jh.current=null===a||null===a.memoizedState?ph:qh;a=c(d,e);if(b.expirationTime===lh){f=0;do{b.expirationTime=0;if(!(25>f))throw Error(u(301));f+=1;P=O=null;b.updateQueue=null;jh.current=rh;a=c(d,e)}while(b.expirationTime===lh)}jh.current=sh;b=null!==O&&null!==O.next;lh=0;P=O=N=null;mh=!1;if(b)throw Error(u(300));return a}
function th(){var a={memoizedState:null,baseState:null,baseQueue:null,queue:null,next:null};null===P?N.memoizedState=P=a:P=P.next=a;return P}function uh(){if(null===O){var a=N.alternate;a=null!==a?a.memoizedState:null}else a=O.next;var b=null===P?N.memoizedState:P.next;if(null!==b)P=b,O=a;else{if(null===a)throw Error(u(310));O=a;a={memoizedState:O.memoizedState,baseState:O.baseState,baseQueue:O.baseQueue,queue:O.queue,next:null};null===P?N.memoizedState=P=a:P=P.next=a}return P}
function vh(a,b){return"function"===typeof b?b(a):b}
function wh(a){var b=uh(),c=b.queue;if(null===c)throw Error(u(311));c.lastRenderedReducer=a;var d=O,e=d.baseQueue,f=c.pending;if(null!==f){if(null!==e){var g=e.next;e.next=f.next;f.next=g}d.baseQueue=e=f;c.pending=null}if(null!==e){e=e.next;d=d.baseState;var h=g=f=null,k=e;do{var l=k.expirationTime;if(l<lh){var m={expirationTime:k.expirationTime,suspenseConfig:k.suspenseConfig,action:k.action,eagerReducer:k.eagerReducer,eagerState:k.eagerState,next:null};null===h?(g=h=m,f=d):h=h.next=m;l>N.expirationTime&&
(N.expirationTime=l,Bg(l))}else null!==h&&(h=h.next={expirationTime:1073741823,suspenseConfig:k.suspenseConfig,action:k.action,eagerReducer:k.eagerReducer,eagerState:k.eagerState,next:null}),Ag(l,k.suspenseConfig),d=k.eagerReducer===a?k.eagerState:a(d,k.action);k=k.next}while(null!==k&&k!==e);null===h?f=d:h.next=g;$e(d,b.memoizedState)||(rg=!0);b.memoizedState=d;b.baseState=f;b.baseQueue=h;c.lastRenderedState=d}return[b.memoizedState,c.dispatch]}
function xh(a){var b=uh(),c=b.queue;if(null===c)throw Error(u(311));c.lastRenderedReducer=a;var d=c.dispatch,e=c.pending,f=b.memoizedState;if(null!==e){c.pending=null;var g=e=e.next;do f=a(f,g.action),g=g.next;while(g!==e);$e(f,b.memoizedState)||(rg=!0);b.memoizedState=f;null===b.baseQueue&&(b.baseState=f);c.lastRenderedState=f}return[f,d]}
function yh(a){var b=th();"function"===typeof a&&(a=a());b.memoizedState=b.baseState=a;a=b.queue={pending:null,dispatch:null,lastRenderedReducer:vh,lastRenderedState:a};a=a.dispatch=zh.bind(null,N,a);return[b.memoizedState,a]}function Ah(a,b,c,d){a={tag:a,create:b,destroy:c,deps:d,next:null};b=N.updateQueue;null===b?(b={lastEffect:null},N.updateQueue=b,b.lastEffect=a.next=a):(c=b.lastEffect,null===c?b.lastEffect=a.next=a:(d=c.next,c.next=a,a.next=d,b.lastEffect=a));return a}
function Bh(){return uh().memoizedState}function Ch(a,b,c,d){var e=th();N.effectTag|=a;e.memoizedState=Ah(1|b,c,void 0,void 0===d?null:d)}function Dh(a,b,c,d){var e=uh();d=void 0===d?null:d;var f=void 0;if(null!==O){var g=O.memoizedState;f=g.destroy;if(null!==d&&nh(d,g.deps)){Ah(b,c,f,d);return}}N.effectTag|=a;e.memoizedState=Ah(1|b,c,f,d)}function Eh(a,b){return Ch(516,4,a,b)}function Fh(a,b){return Dh(516,4,a,b)}function Gh(a,b){return Dh(4,2,a,b)}
function Hh(a,b){if("function"===typeof b)return a=a(),b(a),function(){b(null)};if(null!==b&&void 0!==b)return a=a(),b.current=a,function(){b.current=null}}function Ih(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Dh(4,2,Hh.bind(null,b,a),c)}function Jh(){}function Kh(a,b){th().memoizedState=[a,void 0===b?null:b];return a}function Lh(a,b){var c=uh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&nh(b,d[1]))return d[0];c.memoizedState=[a,b];return a}
function Mh(a,b){var c=uh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&nh(b,d[1]))return d[0];a=a();c.memoizedState=[a,b];return a}function Nh(a,b,c){var d=ag();cg(98>d?98:d,function(){a(!0)});cg(97<d?97:d,function(){var d=kh.suspense;kh.suspense=void 0===b?null:b;try{a(!1),c()}finally{kh.suspense=d}})}
function zh(a,b,c){var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e={expirationTime:d,suspenseConfig:e,action:c,eagerReducer:null,eagerState:null,next:null};var f=b.pending;null===f?e.next=e:(e.next=f.next,f.next=e);b.pending=e;f=a.alternate;if(a===N||null!==f&&f===N)mh=!0,e.expirationTime=lh,N.expirationTime=lh;else{if(0===a.expirationTime&&(null===f||0===f.expirationTime)&&(f=b.lastRenderedReducer,null!==f))try{var g=b.lastRenderedState,h=f(g,c);e.eagerReducer=f;e.eagerState=h;if($e(h,g))return}catch(k){}finally{}Ig(a,
d)}}
var sh={readContext:sg,useCallback:Q,useContext:Q,useEffect:Q,useImperativeHandle:Q,useLayoutEffect:Q,useMemo:Q,useReducer:Q,useRef:Q,useState:Q,useDebugValue:Q,useResponder:Q,useDeferredValue:Q,useTransition:Q},ph={readContext:sg,useCallback:Kh,useContext:sg,useEffect:Eh,useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Ch(4,2,Hh.bind(null,b,a),c)},useLayoutEffect:function(a,b){return Ch(4,2,a,b)},useMemo:function(a,b){var c=th();b=void 0===b?null:b;a=a();c.memoizedState=[a,
b];return a},useReducer:function(a,b,c){var d=th();b=void 0!==c?c(b):b;d.memoizedState=d.baseState=b;a=d.queue={pending:null,dispatch:null,lastRenderedReducer:a,lastRenderedState:b};a=a.dispatch=zh.bind(null,N,a);return[d.memoizedState,a]},useRef:function(a){var b=th();a={current:a};return b.memoizedState=a},useState:yh,useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=yh(a),d=c[0],e=c[1];Eh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=
c}},[a,b]);return d},useTransition:function(a){var b=yh(!1),c=b[0];b=b[1];return[Kh(Nh.bind(null,b,a),[b,a]),c]}},qh={readContext:sg,useCallback:Lh,useContext:sg,useEffect:Fh,useImperativeHandle:Ih,useLayoutEffect:Gh,useMemo:Mh,useReducer:wh,useRef:Bh,useState:function(){return wh(vh)},useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=wh(vh),d=c[0],e=c[1];Fh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=c}},[a,b]);return d},useTransition:function(a){var b=
wh(vh),c=b[0];b=b[1];return[Lh(Nh.bind(null,b,a),[b,a]),c]}},rh={readContext:sg,useCallback:Lh,useContext:sg,useEffect:Fh,useImperativeHandle:Ih,useLayoutEffect:Gh,useMemo:Mh,useReducer:xh,useRef:Bh,useState:function(){return xh(vh)},useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=xh(vh),d=c[0],e=c[1];Fh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=c}},[a,b]);return d},useTransition:function(a){var b=xh(vh),c=b[0];b=b[1];return[Lh(Nh.bind(null,
b,a),[b,a]),c]}},Oh=null,Ph=null,Qh=!1;function Rh(a,b){var c=Sh(5,null,null,0);c.elementType="DELETED";c.type="DELETED";c.stateNode=b;c.return=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}
function Th(a,b){switch(a.tag){case 5:var c=a.type;b=1!==b.nodeType||c.toLowerCase()!==b.nodeName.toLowerCase()?null:b;return null!==b?(a.stateNode=b,!0):!1;case 6:return b=""===a.pendingProps||3!==b.nodeType?null:b,null!==b?(a.stateNode=b,!0):!1;case 13:return!1;default:return!1}}
function Uh(a){if(Qh){var b=Ph;if(b){var c=b;if(!Th(a,b)){b=Jd(c.nextSibling);if(!b||!Th(a,b)){a.effectTag=a.effectTag&-1025|2;Qh=!1;Oh=a;return}Rh(Oh,c)}Oh=a;Ph=Jd(b.firstChild)}else a.effectTag=a.effectTag&-1025|2,Qh=!1,Oh=a}}function Vh(a){for(a=a.return;null!==a&&5!==a.tag&&3!==a.tag&&13!==a.tag;)a=a.return;Oh=a}
function Wh(a){if(a!==Oh)return!1;if(!Qh)return Vh(a),Qh=!0,!1;var b=a.type;if(5!==a.tag||"head"!==b&&"body"!==b&&!Gd(b,a.memoizedProps))for(b=Ph;b;)Rh(a,b),b=Jd(b.nextSibling);Vh(a);if(13===a.tag){a=a.memoizedState;a=null!==a?a.dehydrated:null;if(!a)throw Error(u(317));a:{a=a.nextSibling;for(b=0;a;){if(8===a.nodeType){var c=a.data;if(c===Ad){if(0===b){Ph=Jd(a.nextSibling);break a}b--}else c!==zd&&c!==Cd&&c!==Bd||b++}a=a.nextSibling}Ph=null}}else Ph=Oh?Jd(a.stateNode.nextSibling):null;return!0}
function Xh(){Ph=Oh=null;Qh=!1}var Yh=Wa.ReactCurrentOwner,rg=!1;function R(a,b,c,d){b.child=null===a?Yg(b,null,c,d):Xg(b,a.child,c,d)}function Zh(a,b,c,d,e){c=c.render;var f=b.ref;qg(b,e);d=oh(a,b,c,d,f,e);if(null!==a&&!rg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),$h(a,b,e);b.effectTag|=1;R(a,b,d,e);return b.child}
function ai(a,b,c,d,e,f){if(null===a){var g=c.type;if("function"===typeof g&&!bi(g)&&void 0===g.defaultProps&&null===c.compare&&void 0===c.defaultProps)return b.tag=15,b.type=g,ci(a,b,g,d,e,f);a=Ug(c.type,null,d,null,b.mode,f);a.ref=b.ref;a.return=b;return b.child=a}g=a.child;if(e<f&&(e=g.memoizedProps,c=c.compare,c=null!==c?c:bf,c(e,d)&&a.ref===b.ref))return $h(a,b,f);b.effectTag|=1;a=Sg(g,d);a.ref=b.ref;a.return=b;return b.child=a}
function ci(a,b,c,d,e,f){return null!==a&&bf(a.memoizedProps,d)&&a.ref===b.ref&&(rg=!1,e<f)?(b.expirationTime=a.expirationTime,$h(a,b,f)):di(a,b,c,d,f)}function ei(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function di(a,b,c,d,e){var f=L(c)?Bf:J.current;f=Cf(b,f);qg(b,e);c=oh(a,b,c,d,f,e);if(null!==a&&!rg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),$h(a,b,e);b.effectTag|=1;R(a,b,c,e);return b.child}
function fi(a,b,c,d,e){if(L(c)){var f=!0;Gf(b)}else f=!1;qg(b,e);if(null===b.stateNode)null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),Lg(b,c,d),Ng(b,c,d,e),d=!0;else if(null===a){var g=b.stateNode,h=b.memoizedProps;g.props=h;var k=g.context,l=c.contextType;"object"===typeof l&&null!==l?l=sg(l):(l=L(c)?Bf:J.current,l=Cf(b,l));var m=c.getDerivedStateFromProps,p="function"===typeof m||"function"===typeof g.getSnapshotBeforeUpdate;p||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&
"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Mg(b,g,d,l);tg=!1;var x=b.memoizedState;g.state=x;zg(b,d,g,e);k=b.memoizedState;h!==d||x!==k||K.current||tg?("function"===typeof m&&(Fg(b,c,m,d),k=b.memoizedState),(h=tg||Kg(b,c,h,d,x,k,l))?(p||"function"!==typeof g.UNSAFE_componentWillMount&&"function"!==typeof g.componentWillMount||("function"===typeof g.componentWillMount&&g.componentWillMount(),"function"===typeof g.UNSAFE_componentWillMount&&g.UNSAFE_componentWillMount()),"function"===
typeof g.componentDidMount&&(b.effectTag|=4)):("function"===typeof g.componentDidMount&&(b.effectTag|=4),b.memoizedProps=d,b.memoizedState=k),g.props=d,g.state=k,g.context=l,d=h):("function"===typeof g.componentDidMount&&(b.effectTag|=4),d=!1)}else g=b.stateNode,vg(a,b),h=b.memoizedProps,g.props=b.type===b.elementType?h:ig(b.type,h),k=g.context,l=c.contextType,"object"===typeof l&&null!==l?l=sg(l):(l=L(c)?Bf:J.current,l=Cf(b,l)),m=c.getDerivedStateFromProps,(p="function"===typeof m||"function"===
typeof g.getSnapshotBeforeUpdate)||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Mg(b,g,d,l),tg=!1,k=b.memoizedState,g.state=k,zg(b,d,g,e),x=b.memoizedState,h!==d||k!==x||K.current||tg?("function"===typeof m&&(Fg(b,c,m,d),x=b.memoizedState),(m=tg||Kg(b,c,h,d,k,x,l))?(p||"function"!==typeof g.UNSAFE_componentWillUpdate&&"function"!==typeof g.componentWillUpdate||("function"===typeof g.componentWillUpdate&&g.componentWillUpdate(d,
x,l),"function"===typeof g.UNSAFE_componentWillUpdate&&g.UNSAFE_componentWillUpdate(d,x,l)),"function"===typeof g.componentDidUpdate&&(b.effectTag|=4),"function"===typeof g.getSnapshotBeforeUpdate&&(b.effectTag|=256)):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),b.memoizedProps=d,b.memoizedState=x),g.props=d,g.state=x,g.context=l,d=m):
("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),d=!1);return gi(a,b,c,d,f,e)}
function gi(a,b,c,d,e,f){ei(a,b);var g=0!==(b.effectTag&64);if(!d&&!g)return e&&Hf(b,c,!1),$h(a,b,f);d=b.stateNode;Yh.current=b;var h=g&&"function"!==typeof c.getDerivedStateFromError?null:d.render();b.effectTag|=1;null!==a&&g?(b.child=Xg(b,a.child,null,f),b.child=Xg(b,null,h,f)):R(a,b,h,f);b.memoizedState=d.state;e&&Hf(b,c,!0);return b.child}function hi(a){var b=a.stateNode;b.pendingContext?Ef(a,b.pendingContext,b.pendingContext!==b.context):b.context&&Ef(a,b.context,!1);dh(a,b.containerInfo)}
var ii={dehydrated:null,retryTime:0};
function ji(a,b,c){var d=b.mode,e=b.pendingProps,f=M.current,g=!1,h;(h=0!==(b.effectTag&64))||(h=0!==(f&2)&&(null===a||null!==a.memoizedState));h?(g=!0,b.effectTag&=-65):null!==a&&null===a.memoizedState||void 0===e.fallback||!0===e.unstable_avoidThisFallback||(f|=1);I(M,f&1);if(null===a){void 0!==e.fallback&&Uh(b);if(g){g=e.fallback;e=Wg(null,d,0,null);e.return=b;if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=Wg(g,d,c,null);c.return=
b;e.sibling=c;b.memoizedState=ii;b.child=e;return c}d=e.children;b.memoizedState=null;return b.child=Yg(b,null,d,c)}if(null!==a.memoizedState){a=a.child;d=a.sibling;if(g){e=e.fallback;c=Sg(a,a.pendingProps);c.return=b;if(0===(b.mode&2)&&(g=null!==b.memoizedState?b.child.child:b.child,g!==a.child))for(c.child=g;null!==g;)g.return=c,g=g.sibling;d=Sg(d,e);d.return=b;c.sibling=d;c.childExpirationTime=0;b.memoizedState=ii;b.child=c;return d}c=Xg(b,a.child,e.children,c);b.memoizedState=null;return b.child=
c}a=a.child;if(g){g=e.fallback;e=Wg(null,d,0,null);e.return=b;e.child=a;null!==a&&(a.return=e);if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=Wg(g,d,c,null);c.return=b;e.sibling=c;c.effectTag|=2;e.childExpirationTime=0;b.memoizedState=ii;b.child=e;return c}b.memoizedState=null;return b.child=Xg(b,a,e.children,c)}
function ki(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);pg(a.return,b)}function li(a,b,c,d,e,f){var g=a.memoizedState;null===g?a.memoizedState={isBackwards:b,rendering:null,renderingStartTime:0,last:d,tail:c,tailExpiration:0,tailMode:e,lastEffect:f}:(g.isBackwards=b,g.rendering=null,g.renderingStartTime=0,g.last=d,g.tail=c,g.tailExpiration=0,g.tailMode=e,g.lastEffect=f)}
function mi(a,b,c){var d=b.pendingProps,e=d.revealOrder,f=d.tail;R(a,b,d.children,c);d=M.current;if(0!==(d&2))d=d&1|2,b.effectTag|=64;else{if(null!==a&&0!==(a.effectTag&64))a:for(a=b.child;null!==a;){if(13===a.tag)null!==a.memoizedState&&ki(a,c);else if(19===a.tag)ki(a,c);else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===b)break a;for(;null===a.sibling;){if(null===a.return||a.return===b)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}d&=1}I(M,d);if(0===(b.mode&2))b.memoizedState=
null;else switch(e){case "forwards":c=b.child;for(e=null;null!==c;)a=c.alternate,null!==a&&null===hh(a)&&(e=c),c=c.sibling;c=e;null===c?(e=b.child,b.child=null):(e=c.sibling,c.sibling=null);li(b,!1,e,c,f,b.lastEffect);break;case "backwards":c=null;e=b.child;for(b.child=null;null!==e;){a=e.alternate;if(null!==a&&null===hh(a)){b.child=e;break}a=e.sibling;e.sibling=c;c=e;e=a}li(b,!0,c,null,f,b.lastEffect);break;case "together":li(b,!1,null,null,void 0,b.lastEffect);break;default:b.memoizedState=null}return b.child}
function $h(a,b,c){null!==a&&(b.dependencies=a.dependencies);var d=b.expirationTime;0!==d&&Bg(d);if(b.childExpirationTime<c)return null;if(null!==a&&b.child!==a.child)throw Error(u(153));if(null!==b.child){a=b.child;c=Sg(a,a.pendingProps);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=Sg(a,a.pendingProps),c.return=b;c.sibling=null}return b.child}var ni,oi,pi,qi;
ni=function(a,b){for(var c=b.child;null!==c;){if(5===c.tag||6===c.tag)a.appendChild(c.stateNode);else if(4!==c.tag&&null!==c.child){c.child.return=c;c=c.child;continue}if(c===b)break;for(;null===c.sibling;){if(null===c.return||c.return===b)return;c=c.return}c.sibling.return=c.return;c=c.sibling}};oi=function(){};
pi=function(a,b,c,d,e){var f=a.memoizedProps;if(f!==d){var g=b.stateNode;ch($g.current);a=null;switch(c){case "input":f=zb(g,f);d=zb(g,d);a=[];break;case "option":f=Gb(g,f);d=Gb(g,d);a=[];break;case "select":f=n({},f,{value:void 0});d=n({},d,{value:void 0});a=[];break;case "textarea":f=Ib(g,f);d=Ib(g,d);a=[];break;default:"function"!==typeof f.onClick&&"function"===typeof d.onClick&&(g.onclick=sd)}od(c,d);var h,k;c=null;for(h in f)if(!d.hasOwnProperty(h)&&f.hasOwnProperty(h)&&null!=f[h])if("style"===
h)for(k in g=f[h],g)g.hasOwnProperty(k)&&(c||(c={}),c[k]="");else"dangerouslySetInnerHTML"!==h&&"children"!==h&&"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&"autoFocus"!==h&&(va.hasOwnProperty(h)?a||(a=[]):(a=a||[]).push(h,null));for(h in d){var l=d[h];g=null!=f?f[h]:void 0;if(d.hasOwnProperty(h)&&l!==g&&(null!=l||null!=g))if("style"===h)if(g){for(k in g)!g.hasOwnProperty(k)||l&&l.hasOwnProperty(k)||(c||(c={}),c[k]="");for(k in l)l.hasOwnProperty(k)&&g[k]!==l[k]&&(c||(c={}),
c[k]=l[k])}else c||(a||(a=[]),a.push(h,c)),c=l;else"dangerouslySetInnerHTML"===h?(l=l?l.__html:void 0,g=g?g.__html:void 0,null!=l&&g!==l&&(a=a||[]).push(h,l)):"children"===h?g===l||"string"!==typeof l&&"number"!==typeof l||(a=a||[]).push(h,""+l):"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&(va.hasOwnProperty(h)?(null!=l&&rd(e,h),a||g===l||(a=[])):(a=a||[]).push(h,l))}c&&(a=a||[]).push("style",c);e=a;if(b.updateQueue=e)b.effectTag|=4}};
qi=function(a,b,c,d){c!==d&&(b.effectTag|=4)};function ri(a,b){switch(a.tailMode){case "hidden":b=a.tail;for(var c=null;null!==b;)null!==b.alternate&&(c=b),b=b.sibling;null===c?a.tail=null:c.sibling=null;break;case "collapsed":c=a.tail;for(var d=null;null!==c;)null!==c.alternate&&(d=c),c=c.sibling;null===d?b||null===a.tail?a.tail=null:a.tail.sibling=null:d.sibling=null}}
function si(a,b,c){var d=b.pendingProps;switch(b.tag){case 2:case 16:case 15:case 0:case 11:case 7:case 8:case 12:case 9:case 14:return null;case 1:return L(b.type)&&Df(),null;case 3:return eh(),H(K),H(J),c=b.stateNode,c.pendingContext&&(c.context=c.pendingContext,c.pendingContext=null),null!==a&&null!==a.child||!Wh(b)||(b.effectTag|=4),oi(b),null;case 5:gh(b);c=ch(bh.current);var e=b.type;if(null!==a&&null!=b.stateNode)pi(a,b,e,d,c),a.ref!==b.ref&&(b.effectTag|=128);else{if(!d){if(null===b.stateNode)throw Error(u(166));
return null}a=ch($g.current);if(Wh(b)){d=b.stateNode;e=b.type;var f=b.memoizedProps;d[Md]=b;d[Nd]=f;switch(e){case "iframe":case "object":case "embed":F("load",d);break;case "video":case "audio":for(a=0;a<ac.length;a++)F(ac[a],d);break;case "source":F("error",d);break;case "img":case "image":case "link":F("error",d);F("load",d);break;case "form":F("reset",d);F("submit",d);break;case "details":F("toggle",d);break;case "input":Ab(d,f);F("invalid",d);rd(c,"onChange");break;case "select":d._wrapperState=
{wasMultiple:!!f.multiple};F("invalid",d);rd(c,"onChange");break;case "textarea":Jb(d,f),F("invalid",d),rd(c,"onChange")}od(e,f);a=null;for(var g in f)if(f.hasOwnProperty(g)){var h=f[g];"children"===g?"string"===typeof h?d.textContent!==h&&(a=["children",h]):"number"===typeof h&&d.textContent!==""+h&&(a=["children",""+h]):va.hasOwnProperty(g)&&null!=h&&rd(c,g)}switch(e){case "input":xb(d);Eb(d,f,!0);break;case "textarea":xb(d);Lb(d);break;case "select":case "option":break;default:"function"===typeof f.onClick&&
(d.onclick=sd)}c=a;b.updateQueue=c;null!==c&&(b.effectTag|=4)}else{g=9===c.nodeType?c:c.ownerDocument;a===qd&&(a=Nb(e));a===qd?"script"===e?(a=g.createElement("div"),a.innerHTML="<script>\x3c/script>",a=a.removeChild(a.firstChild)):"string"===typeof d.is?a=g.createElement(e,{is:d.is}):(a=g.createElement(e),"select"===e&&(g=a,d.multiple?g.multiple=!0:d.size&&(g.size=d.size))):a=g.createElementNS(a,e);a[Md]=b;a[Nd]=d;ni(a,b,!1,!1);b.stateNode=a;g=pd(e,d);switch(e){case "iframe":case "object":case "embed":F("load",
a);h=d;break;case "video":case "audio":for(h=0;h<ac.length;h++)F(ac[h],a);h=d;break;case "source":F("error",a);h=d;break;case "img":case "image":case "link":F("error",a);F("load",a);h=d;break;case "form":F("reset",a);F("submit",a);h=d;break;case "details":F("toggle",a);h=d;break;case "input":Ab(a,d);h=zb(a,d);F("invalid",a);rd(c,"onChange");break;case "option":h=Gb(a,d);break;case "select":a._wrapperState={wasMultiple:!!d.multiple};h=n({},d,{value:void 0});F("invalid",a);rd(c,"onChange");break;case "textarea":Jb(a,
d);h=Ib(a,d);F("invalid",a);rd(c,"onChange");break;default:h=d}od(e,h);var k=h;for(f in k)if(k.hasOwnProperty(f)){var l=k[f];"style"===f?md(a,l):"dangerouslySetInnerHTML"===f?(l=l?l.__html:void 0,null!=l&&Qb(a,l)):"children"===f?"string"===typeof l?("textarea"!==e||""!==l)&&Rb(a,l):"number"===typeof l&&Rb(a,""+l):"suppressContentEditableWarning"!==f&&"suppressHydrationWarning"!==f&&"autoFocus"!==f&&(va.hasOwnProperty(f)?null!=l&&rd(c,f):null!=l&&Xa(a,f,l,g))}switch(e){case "input":xb(a);Eb(a,d,!1);
break;case "textarea":xb(a);Lb(a);break;case "option":null!=d.value&&a.setAttribute("value",""+rb(d.value));break;case "select":a.multiple=!!d.multiple;c=d.value;null!=c?Hb(a,!!d.multiple,c,!1):null!=d.defaultValue&&Hb(a,!!d.multiple,d.defaultValue,!0);break;default:"function"===typeof h.onClick&&(a.onclick=sd)}Fd(e,d)&&(b.effectTag|=4)}null!==b.ref&&(b.effectTag|=128)}return null;case 6:if(a&&null!=b.stateNode)qi(a,b,a.memoizedProps,d);else{if("string"!==typeof d&&null===b.stateNode)throw Error(u(166));
c=ch(bh.current);ch($g.current);Wh(b)?(c=b.stateNode,d=b.memoizedProps,c[Md]=b,c.nodeValue!==d&&(b.effectTag|=4)):(c=(9===c.nodeType?c:c.ownerDocument).createTextNode(d),c[Md]=b,b.stateNode=c)}return null;case 13:H(M);d=b.memoizedState;if(0!==(b.effectTag&64))return b.expirationTime=c,b;c=null!==d;d=!1;null===a?void 0!==b.memoizedProps.fallback&&Wh(b):(e=a.memoizedState,d=null!==e,c||null===e||(e=a.child.sibling,null!==e&&(f=b.firstEffect,null!==f?(b.firstEffect=e,e.nextEffect=f):(b.firstEffect=b.lastEffect=
e,e.nextEffect=null),e.effectTag=8)));if(c&&!d&&0!==(b.mode&2))if(null===a&&!0!==b.memoizedProps.unstable_avoidThisFallback||0!==(M.current&1))S===ti&&(S=ui);else{if(S===ti||S===ui)S=vi;0!==wi&&null!==T&&(xi(T,U),yi(T,wi))}if(c||d)b.effectTag|=4;return null;case 4:return eh(),oi(b),null;case 10:return og(b),null;case 17:return L(b.type)&&Df(),null;case 19:H(M);d=b.memoizedState;if(null===d)return null;e=0!==(b.effectTag&64);f=d.rendering;if(null===f)if(e)ri(d,!1);else{if(S!==ti||null!==a&&0!==(a.effectTag&
64))for(f=b.child;null!==f;){a=hh(f);if(null!==a){b.effectTag|=64;ri(d,!1);e=a.updateQueue;null!==e&&(b.updateQueue=e,b.effectTag|=4);null===d.lastEffect&&(b.firstEffect=null);b.lastEffect=d.lastEffect;for(d=b.child;null!==d;)e=d,f=c,e.effectTag&=2,e.nextEffect=null,e.firstEffect=null,e.lastEffect=null,a=e.alternate,null===a?(e.childExpirationTime=0,e.expirationTime=f,e.child=null,e.memoizedProps=null,e.memoizedState=null,e.updateQueue=null,e.dependencies=null):(e.childExpirationTime=a.childExpirationTime,
e.expirationTime=a.expirationTime,e.child=a.child,e.memoizedProps=a.memoizedProps,e.memoizedState=a.memoizedState,e.updateQueue=a.updateQueue,f=a.dependencies,e.dependencies=null===f?null:{expirationTime:f.expirationTime,firstContext:f.firstContext,responders:f.responders}),d=d.sibling;I(M,M.current&1|2);return b.child}f=f.sibling}}else{if(!e)if(a=hh(f),null!==a){if(b.effectTag|=64,e=!0,c=a.updateQueue,null!==c&&(b.updateQueue=c,b.effectTag|=4),ri(d,!0),null===d.tail&&"hidden"===d.tailMode&&!f.alternate)return b=
b.lastEffect=d.lastEffect,null!==b&&(b.nextEffect=null),null}else 2*$f()-d.renderingStartTime>d.tailExpiration&&1<c&&(b.effectTag|=64,e=!0,ri(d,!1),b.expirationTime=b.childExpirationTime=c-1);d.isBackwards?(f.sibling=b.child,b.child=f):(c=d.last,null!==c?c.sibling=f:b.child=f,d.last=f)}return null!==d.tail?(0===d.tailExpiration&&(d.tailExpiration=$f()+500),c=d.tail,d.rendering=c,d.tail=c.sibling,d.lastEffect=b.lastEffect,d.renderingStartTime=$f(),c.sibling=null,b=M.current,I(M,e?b&1|2:b&1),c):null}throw Error(u(156,
b.tag));}function zi(a){switch(a.tag){case 1:L(a.type)&&Df();var b=a.effectTag;return b&4096?(a.effectTag=b&-4097|64,a):null;case 3:eh();H(K);H(J);b=a.effectTag;if(0!==(b&64))throw Error(u(285));a.effectTag=b&-4097|64;return a;case 5:return gh(a),null;case 13:return H(M),b=a.effectTag,b&4096?(a.effectTag=b&-4097|64,a):null;case 19:return H(M),null;case 4:return eh(),null;case 10:return og(a),null;default:return null}}function Ai(a,b){return{value:a,source:b,stack:qb(b)}}
var Bi="function"===typeof WeakSet?WeakSet:Set;function Ci(a,b){var c=b.source,d=b.stack;null===d&&null!==c&&(d=qb(c));null!==c&&pb(c.type);b=b.value;null!==a&&1===a.tag&&pb(a.type);try{console.error(b)}catch(e){setTimeout(function(){throw e;})}}function Di(a,b){try{b.props=a.memoizedProps,b.state=a.memoizedState,b.componentWillUnmount()}catch(c){Ei(a,c)}}function Fi(a){var b=a.ref;if(null!==b)if("function"===typeof b)try{b(null)}catch(c){Ei(a,c)}else b.current=null}
function Gi(a,b){switch(b.tag){case 0:case 11:case 15:case 22:return;case 1:if(b.effectTag&256&&null!==a){var c=a.memoizedProps,d=a.memoizedState;a=b.stateNode;b=a.getSnapshotBeforeUpdate(b.elementType===b.type?c:ig(b.type,c),d);a.__reactInternalSnapshotBeforeUpdate=b}return;case 3:case 5:case 6:case 4:case 17:return}throw Error(u(163));}
function Hi(a,b){b=b.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){var c=b=b.next;do{if((c.tag&a)===a){var d=c.destroy;c.destroy=void 0;void 0!==d&&d()}c=c.next}while(c!==b)}}function Ii(a,b){b=b.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){var c=b=b.next;do{if((c.tag&a)===a){var d=c.create;c.destroy=d()}c=c.next}while(c!==b)}}
function Ji(a,b,c){switch(c.tag){case 0:case 11:case 15:case 22:Ii(3,c);return;case 1:a=c.stateNode;if(c.effectTag&4)if(null===b)a.componentDidMount();else{var d=c.elementType===c.type?b.memoizedProps:ig(c.type,b.memoizedProps);a.componentDidUpdate(d,b.memoizedState,a.__reactInternalSnapshotBeforeUpdate)}b=c.updateQueue;null!==b&&Cg(c,b,a);return;case 3:b=c.updateQueue;if(null!==b){a=null;if(null!==c.child)switch(c.child.tag){case 5:a=c.child.stateNode;break;case 1:a=c.child.stateNode}Cg(c,b,a)}return;
case 5:a=c.stateNode;null===b&&c.effectTag&4&&Fd(c.type,c.memoizedProps)&&a.focus();return;case 6:return;case 4:return;case 12:return;case 13:null===c.memoizedState&&(c=c.alternate,null!==c&&(c=c.memoizedState,null!==c&&(c=c.dehydrated,null!==c&&Vc(c))));return;case 19:case 17:case 20:case 21:return}throw Error(u(163));}
function Ki(a,b,c){"function"===typeof Li&&Li(b);switch(b.tag){case 0:case 11:case 14:case 15:case 22:a=b.updateQueue;if(null!==a&&(a=a.lastEffect,null!==a)){var d=a.next;cg(97<c?97:c,function(){var a=d;do{var c=a.destroy;if(void 0!==c){var g=b;try{c()}catch(h){Ei(g,h)}}a=a.next}while(a!==d)})}break;case 1:Fi(b);c=b.stateNode;"function"===typeof c.componentWillUnmount&&Di(b,c);break;case 5:Fi(b);break;case 4:Mi(a,b,c)}}
function Ni(a){var b=a.alternate;a.return=null;a.child=null;a.memoizedState=null;a.updateQueue=null;a.dependencies=null;a.alternate=null;a.firstEffect=null;a.lastEffect=null;a.pendingProps=null;a.memoizedProps=null;a.stateNode=null;null!==b&&Ni(b)}function Oi(a){return 5===a.tag||3===a.tag||4===a.tag}
function Pi(a){a:{for(var b=a.return;null!==b;){if(Oi(b)){var c=b;break a}b=b.return}throw Error(u(160));}b=c.stateNode;switch(c.tag){case 5:var d=!1;break;case 3:b=b.containerInfo;d=!0;break;case 4:b=b.containerInfo;d=!0;break;default:throw Error(u(161));}c.effectTag&16&&(Rb(b,""),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||Oi(c.return)){c=null;break a}c=c.return}c.sibling.return=c.return;for(c=c.sibling;5!==c.tag&&6!==c.tag&&18!==c.tag;){if(c.effectTag&2)continue b;
if(null===c.child||4===c.tag)continue b;else c.child.return=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}d?Qi(a,c,b):Ri(a,c,b)}
function Qi(a,b,c){var d=a.tag,e=5===d||6===d;if(e)a=e?a.stateNode:a.stateNode.instance,b?8===c.nodeType?c.parentNode.insertBefore(a,b):c.insertBefore(a,b):(8===c.nodeType?(b=c.parentNode,b.insertBefore(a,c)):(b=c,b.appendChild(a)),c=c._reactRootContainer,null!==c&&void 0!==c||null!==b.onclick||(b.onclick=sd));else if(4!==d&&(a=a.child,null!==a))for(Qi(a,b,c),a=a.sibling;null!==a;)Qi(a,b,c),a=a.sibling}
function Ri(a,b,c){var d=a.tag,e=5===d||6===d;if(e)a=e?a.stateNode:a.stateNode.instance,b?c.insertBefore(a,b):c.appendChild(a);else if(4!==d&&(a=a.child,null!==a))for(Ri(a,b,c),a=a.sibling;null!==a;)Ri(a,b,c),a=a.sibling}
function Mi(a,b,c){for(var d=b,e=!1,f,g;;){if(!e){e=d.return;a:for(;;){if(null===e)throw Error(u(160));f=e.stateNode;switch(e.tag){case 5:g=!1;break a;case 3:f=f.containerInfo;g=!0;break a;case 4:f=f.containerInfo;g=!0;break a}e=e.return}e=!0}if(5===d.tag||6===d.tag){a:for(var h=a,k=d,l=c,m=k;;)if(Ki(h,m,l),null!==m.child&&4!==m.tag)m.child.return=m,m=m.child;else{if(m===k)break a;for(;null===m.sibling;){if(null===m.return||m.return===k)break a;m=m.return}m.sibling.return=m.return;m=m.sibling}g?(h=
f,k=d.stateNode,8===h.nodeType?h.parentNode.removeChild(k):h.removeChild(k)):f.removeChild(d.stateNode)}else if(4===d.tag){if(null!==d.child){f=d.stateNode.containerInfo;g=!0;d.child.return=d;d=d.child;continue}}else if(Ki(a,d,c),null!==d.child){d.child.return=d;d=d.child;continue}if(d===b)break;for(;null===d.sibling;){if(null===d.return||d.return===b)return;d=d.return;4===d.tag&&(e=!1)}d.sibling.return=d.return;d=d.sibling}}
function Si(a,b){switch(b.tag){case 0:case 11:case 14:case 15:case 22:Hi(3,b);return;case 1:return;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps,e=null!==a?a.memoizedProps:d;a=b.type;var f=b.updateQueue;b.updateQueue=null;if(null!==f){c[Nd]=d;"input"===a&&"radio"===d.type&&null!=d.name&&Bb(c,d);pd(a,e);b=pd(a,d);for(e=0;e<f.length;e+=2){var g=f[e],h=f[e+1];"style"===g?md(c,h):"dangerouslySetInnerHTML"===g?Qb(c,h):"children"===g?Rb(c,h):Xa(c,g,h,b)}switch(a){case "input":Cb(c,d);break;
case "textarea":Kb(c,d);break;case "select":b=c._wrapperState.wasMultiple,c._wrapperState.wasMultiple=!!d.multiple,a=d.value,null!=a?Hb(c,!!d.multiple,a,!1):b!==!!d.multiple&&(null!=d.defaultValue?Hb(c,!!d.multiple,d.defaultValue,!0):Hb(c,!!d.multiple,d.multiple?[]:"",!1))}}}return;case 6:if(null===b.stateNode)throw Error(u(162));b.stateNode.nodeValue=b.memoizedProps;return;case 3:b=b.stateNode;b.hydrate&&(b.hydrate=!1,Vc(b.containerInfo));return;case 12:return;case 13:c=b;null===b.memoizedState?
d=!1:(d=!0,c=b.child,Ti=$f());if(null!==c)a:for(a=c;;){if(5===a.tag)f=a.stateNode,d?(f=f.style,"function"===typeof f.setProperty?f.setProperty("display","none","important"):f.display="none"):(f=a.stateNode,e=a.memoizedProps.style,e=void 0!==e&&null!==e&&e.hasOwnProperty("display")?e.display:null,f.style.display=ld("display",e));else if(6===a.tag)a.stateNode.nodeValue=d?"":a.memoizedProps;else if(13===a.tag&&null!==a.memoizedState&&null===a.memoizedState.dehydrated){f=a.child.sibling;f.return=a;a=
f;continue}else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===c)break;for(;null===a.sibling;){if(null===a.return||a.return===c)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}Ui(b);return;case 19:Ui(b);return;case 17:return}throw Error(u(163));}function Ui(a){var b=a.updateQueue;if(null!==b){a.updateQueue=null;var c=a.stateNode;null===c&&(c=a.stateNode=new Bi);b.forEach(function(b){var d=Vi.bind(null,a,b);c.has(b)||(c.add(b),b.then(d,d))})}}
var Wi="function"===typeof WeakMap?WeakMap:Map;function Xi(a,b,c){c=wg(c,null);c.tag=3;c.payload={element:null};var d=b.value;c.callback=function(){Yi||(Yi=!0,Zi=d);Ci(a,b)};return c}
function $i(a,b,c){c=wg(c,null);c.tag=3;var d=a.type.getDerivedStateFromError;if("function"===typeof d){var e=b.value;c.payload=function(){Ci(a,b);return d(e)}}var f=a.stateNode;null!==f&&"function"===typeof f.componentDidCatch&&(c.callback=function(){"function"!==typeof d&&(null===aj?aj=new Set([this]):aj.add(this),Ci(a,b));var c=b.stack;this.componentDidCatch(b.value,{componentStack:null!==c?c:""})});return c}
var bj=Math.ceil,cj=Wa.ReactCurrentDispatcher,dj=Wa.ReactCurrentOwner,V=0,ej=8,fj=16,gj=32,ti=0,hj=1,ij=2,ui=3,vi=4,jj=5,W=V,T=null,X=null,U=0,S=ti,kj=null,lj=1073741823,mj=1073741823,nj=null,wi=0,oj=!1,Ti=0,pj=500,Y=null,Yi=!1,Zi=null,aj=null,qj=!1,rj=null,sj=90,tj=null,uj=0,vj=null,wj=0;function Gg(){return(W&(fj|gj))!==V?1073741821-($f()/10|0):0!==wj?wj:wj=1073741821-($f()/10|0)}
function Hg(a,b,c){b=b.mode;if(0===(b&2))return 1073741823;var d=ag();if(0===(b&4))return 99===d?1073741823:1073741822;if((W&fj)!==V)return U;if(null!==c)a=hg(a,c.timeoutMs|0||5E3,250);else switch(d){case 99:a=1073741823;break;case 98:a=hg(a,150,100);break;case 97:case 96:a=hg(a,5E3,250);break;case 95:a=2;break;default:throw Error(u(326));}null!==T&&a===U&&--a;return a}
function Ig(a,b){if(50<uj)throw uj=0,vj=null,Error(u(185));a=xj(a,b);if(null!==a){var c=ag();1073741823===b?(W&ej)!==V&&(W&(fj|gj))===V?yj(a):(Z(a),W===V&&gg()):Z(a);(W&4)===V||98!==c&&99!==c||(null===tj?tj=new Map([[a,b]]):(c=tj.get(a),(void 0===c||c>b)&&tj.set(a,b)))}}
function xj(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);var d=a.return,e=null;if(null===d&&3===a.tag)e=a.stateNode;else for(;null!==d;){c=d.alternate;d.childExpirationTime<b&&(d.childExpirationTime=b);null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);if(null===d.return&&3===d.tag){e=d.stateNode;break}d=d.return}null!==e&&(T===e&&(Bg(b),S===vi&&xi(e,U)),yi(e,b));return e}
function zj(a){var b=a.lastExpiredTime;if(0!==b)return b;b=a.firstPendingTime;if(!Aj(a,b))return b;var c=a.lastPingedTime;a=a.nextKnownPendingLevel;a=c>a?c:a;return 2>=a&&b!==a?0:a}
function Z(a){if(0!==a.lastExpiredTime)a.callbackExpirationTime=1073741823,a.callbackPriority=99,a.callbackNode=eg(yj.bind(null,a));else{var b=zj(a),c=a.callbackNode;if(0===b)null!==c&&(a.callbackNode=null,a.callbackExpirationTime=0,a.callbackPriority=90);else{var d=Gg();1073741823===b?d=99:1===b||2===b?d=95:(d=10*(1073741821-b)-10*(1073741821-d),d=0>=d?99:250>=d?98:5250>=d?97:95);if(null!==c){var e=a.callbackPriority;if(a.callbackExpirationTime===b&&e>=d)return;c!==Tf&&Kf(c)}a.callbackExpirationTime=
b;a.callbackPriority=d;b=1073741823===b?eg(yj.bind(null,a)):dg(d,Bj.bind(null,a),{timeout:10*(1073741821-b)-$f()});a.callbackNode=b}}}
function Bj(a,b){wj=0;if(b)return b=Gg(),Cj(a,b),Z(a),null;var c=zj(a);if(0!==c){b=a.callbackNode;if((W&(fj|gj))!==V)throw Error(u(327));Dj();a===T&&c===U||Ej(a,c);if(null!==X){var d=W;W|=fj;var e=Fj();do try{Gj();break}catch(h){Hj(a,h)}while(1);ng();W=d;cj.current=e;if(S===hj)throw b=kj,Ej(a,c),xi(a,c),Z(a),b;if(null===X)switch(e=a.finishedWork=a.current.alternate,a.finishedExpirationTime=c,d=S,T=null,d){case ti:case hj:throw Error(u(345));case ij:Cj(a,2<c?2:c);break;case ui:xi(a,c);d=a.lastSuspendedTime;
c===d&&(a.nextKnownPendingLevel=Ij(e));if(1073741823===lj&&(e=Ti+pj-$f(),10<e)){if(oj){var f=a.lastPingedTime;if(0===f||f>=c){a.lastPingedTime=c;Ej(a,c);break}}f=zj(a);if(0!==f&&f!==c)break;if(0!==d&&d!==c){a.lastPingedTime=d;break}a.timeoutHandle=Hd(Jj.bind(null,a),e);break}Jj(a);break;case vi:xi(a,c);d=a.lastSuspendedTime;c===d&&(a.nextKnownPendingLevel=Ij(e));if(oj&&(e=a.lastPingedTime,0===e||e>=c)){a.lastPingedTime=c;Ej(a,c);break}e=zj(a);if(0!==e&&e!==c)break;if(0!==d&&d!==c){a.lastPingedTime=
d;break}1073741823!==mj?d=10*(1073741821-mj)-$f():1073741823===lj?d=0:(d=10*(1073741821-lj)-5E3,e=$f(),c=10*(1073741821-c)-e,d=e-d,0>d&&(d=0),d=(120>d?120:480>d?480:1080>d?1080:1920>d?1920:3E3>d?3E3:4320>d?4320:1960*bj(d/1960))-d,c<d&&(d=c));if(10<d){a.timeoutHandle=Hd(Jj.bind(null,a),d);break}Jj(a);break;case jj:if(1073741823!==lj&&null!==nj){f=lj;var g=nj;d=g.busyMinDurationMs|0;0>=d?d=0:(e=g.busyDelayMs|0,f=$f()-(10*(1073741821-f)-(g.timeoutMs|0||5E3)),d=f<=e?0:e+d-f);if(10<d){xi(a,c);a.timeoutHandle=
Hd(Jj.bind(null,a),d);break}}Jj(a);break;default:throw Error(u(329));}Z(a);if(a.callbackNode===b)return Bj.bind(null,a)}}return null}
function yj(a){var b=a.lastExpiredTime;b=0!==b?b:1073741823;if((W&(fj|gj))!==V)throw Error(u(327));Dj();a===T&&b===U||Ej(a,b);if(null!==X){var c=W;W|=fj;var d=Fj();do try{Kj();break}catch(e){Hj(a,e)}while(1);ng();W=c;cj.current=d;if(S===hj)throw c=kj,Ej(a,b),xi(a,b),Z(a),c;if(null!==X)throw Error(u(261));a.finishedWork=a.current.alternate;a.finishedExpirationTime=b;T=null;Jj(a);Z(a)}return null}function Lj(){if(null!==tj){var a=tj;tj=null;a.forEach(function(a,c){Cj(c,a);Z(c)});gg()}}
function Mj(a,b){var c=W;W|=1;try{return a(b)}finally{W=c,W===V&&gg()}}function Nj(a,b){var c=W;W&=-2;W|=ej;try{return a(b)}finally{W=c,W===V&&gg()}}
function Ej(a,b){a.finishedWork=null;a.finishedExpirationTime=0;var c=a.timeoutHandle;-1!==c&&(a.timeoutHandle=-1,Id(c));if(null!==X)for(c=X.return;null!==c;){var d=c;switch(d.tag){case 1:d=d.type.childContextTypes;null!==d&&void 0!==d&&Df();break;case 3:eh();H(K);H(J);break;case 5:gh(d);break;case 4:eh();break;case 13:H(M);break;case 19:H(M);break;case 10:og(d)}c=c.return}T=a;X=Sg(a.current,null);U=b;S=ti;kj=null;mj=lj=1073741823;nj=null;wi=0;oj=!1}
function Hj(a,b){do{try{ng();jh.current=sh;if(mh)for(var c=N.memoizedState;null!==c;){var d=c.queue;null!==d&&(d.pending=null);c=c.next}lh=0;P=O=N=null;mh=!1;if(null===X||null===X.return)return S=hj,kj=b,X=null;a:{var e=a,f=X.return,g=X,h=b;b=U;g.effectTag|=2048;g.firstEffect=g.lastEffect=null;if(null!==h&&"object"===typeof h&&"function"===typeof h.then){var k=h;if(0===(g.mode&2)){var l=g.alternate;l?(g.updateQueue=l.updateQueue,g.memoizedState=l.memoizedState,g.expirationTime=l.expirationTime):(g.updateQueue=
null,g.memoizedState=null)}var m=0!==(M.current&1),p=f;do{var x;if(x=13===p.tag){var z=p.memoizedState;if(null!==z)x=null!==z.dehydrated?!0:!1;else{var ca=p.memoizedProps;x=void 0===ca.fallback?!1:!0!==ca.unstable_avoidThisFallback?!0:m?!1:!0}}if(x){var D=p.updateQueue;if(null===D){var t=new Set;t.add(k);p.updateQueue=t}else D.add(k);if(0===(p.mode&2)){p.effectTag|=64;g.effectTag&=-2981;if(1===g.tag)if(null===g.alternate)g.tag=17;else{var y=wg(1073741823,null);y.tag=2;xg(g,y)}g.expirationTime=1073741823;
break a}h=void 0;g=b;var A=e.pingCache;null===A?(A=e.pingCache=new Wi,h=new Set,A.set(k,h)):(h=A.get(k),void 0===h&&(h=new Set,A.set(k,h)));if(!h.has(g)){h.add(g);var q=Oj.bind(null,e,k,g);k.then(q,q)}p.effectTag|=4096;p.expirationTime=b;break a}p=p.return}while(null!==p);h=Error((pb(g.type)||"A React component")+" suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display."+qb(g))}S!==
jj&&(S=ij);h=Ai(h,g);p=f;do{switch(p.tag){case 3:k=h;p.effectTag|=4096;p.expirationTime=b;var B=Xi(p,k,b);yg(p,B);break a;case 1:k=h;var w=p.type,ub=p.stateNode;if(0===(p.effectTag&64)&&("function"===typeof w.getDerivedStateFromError||null!==ub&&"function"===typeof ub.componentDidCatch&&(null===aj||!aj.has(ub)))){p.effectTag|=4096;p.expirationTime=b;var vb=$i(p,k,b);yg(p,vb);break a}}p=p.return}while(null!==p)}X=Pj(X)}catch(Xc){b=Xc;continue}break}while(1)}
function Fj(){var a=cj.current;cj.current=sh;return null===a?sh:a}function Ag(a,b){a<lj&&2<a&&(lj=a);null!==b&&a<mj&&2<a&&(mj=a,nj=b)}function Bg(a){a>wi&&(wi=a)}function Kj(){for(;null!==X;)X=Qj(X)}function Gj(){for(;null!==X&&!Uf();)X=Qj(X)}function Qj(a){var b=Rj(a.alternate,a,U);a.memoizedProps=a.pendingProps;null===b&&(b=Pj(a));dj.current=null;return b}
function Pj(a){X=a;do{var b=X.alternate;a=X.return;if(0===(X.effectTag&2048)){b=si(b,X,U);if(1===U||1!==X.childExpirationTime){for(var c=0,d=X.child;null!==d;){var e=d.expirationTime,f=d.childExpirationTime;e>c&&(c=e);f>c&&(c=f);d=d.sibling}X.childExpirationTime=c}if(null!==b)return b;null!==a&&0===(a.effectTag&2048)&&(null===a.firstEffect&&(a.firstEffect=X.firstEffect),null!==X.lastEffect&&(null!==a.lastEffect&&(a.lastEffect.nextEffect=X.firstEffect),a.lastEffect=X.lastEffect),1<X.effectTag&&(null!==
a.lastEffect?a.lastEffect.nextEffect=X:a.firstEffect=X,a.lastEffect=X))}else{b=zi(X);if(null!==b)return b.effectTag&=2047,b;null!==a&&(a.firstEffect=a.lastEffect=null,a.effectTag|=2048)}b=X.sibling;if(null!==b)return b;X=a}while(null!==X);S===ti&&(S=jj);return null}function Ij(a){var b=a.expirationTime;a=a.childExpirationTime;return b>a?b:a}function Jj(a){var b=ag();cg(99,Sj.bind(null,a,b));return null}
function Sj(a,b){do Dj();while(null!==rj);if((W&(fj|gj))!==V)throw Error(u(327));var c=a.finishedWork,d=a.finishedExpirationTime;if(null===c)return null;a.finishedWork=null;a.finishedExpirationTime=0;if(c===a.current)throw Error(u(177));a.callbackNode=null;a.callbackExpirationTime=0;a.callbackPriority=90;a.nextKnownPendingLevel=0;var e=Ij(c);a.firstPendingTime=e;d<=a.lastSuspendedTime?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:d<=a.firstSuspendedTime&&(a.firstSuspendedTime=
d-1);d<=a.lastPingedTime&&(a.lastPingedTime=0);d<=a.lastExpiredTime&&(a.lastExpiredTime=0);a===T&&(X=T=null,U=0);1<c.effectTag?null!==c.lastEffect?(c.lastEffect.nextEffect=c,e=c.firstEffect):e=c:e=c.firstEffect;if(null!==e){var f=W;W|=gj;dj.current=null;Dd=fd;var g=xd();if(yd(g)){if("selectionStart"in g)var h={start:g.selectionStart,end:g.selectionEnd};else a:{h=(h=g.ownerDocument)&&h.defaultView||window;var k=h.getSelection&&h.getSelection();if(k&&0!==k.rangeCount){h=k.anchorNode;var l=k.anchorOffset,
m=k.focusNode;k=k.focusOffset;try{h.nodeType,m.nodeType}catch(wb){h=null;break a}var p=0,x=-1,z=-1,ca=0,D=0,t=g,y=null;b:for(;;){for(var A;;){t!==h||0!==l&&3!==t.nodeType||(x=p+l);t!==m||0!==k&&3!==t.nodeType||(z=p+k);3===t.nodeType&&(p+=t.nodeValue.length);if(null===(A=t.firstChild))break;y=t;t=A}for(;;){if(t===g)break b;y===h&&++ca===l&&(x=p);y===m&&++D===k&&(z=p);if(null!==(A=t.nextSibling))break;t=y;y=t.parentNode}t=A}h=-1===x||-1===z?null:{start:x,end:z}}else h=null}h=h||{start:0,end:0}}else h=
null;Ed={activeElementDetached:null,focusedElem:g,selectionRange:h};fd=!1;Y=e;do try{Tj()}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);Y=e;do try{for(g=a,h=b;null!==Y;){var q=Y.effectTag;q&16&&Rb(Y.stateNode,"");if(q&128){var B=Y.alternate;if(null!==B){var w=B.ref;null!==w&&("function"===typeof w?w(null):w.current=null)}}switch(q&1038){case 2:Pi(Y);Y.effectTag&=-3;break;case 6:Pi(Y);Y.effectTag&=-3;Si(Y.alternate,Y);break;case 1024:Y.effectTag&=-1025;break;case 1028:Y.effectTag&=
-1025;Si(Y.alternate,Y);break;case 4:Si(Y.alternate,Y);break;case 8:l=Y,Mi(g,l,h),Ni(l)}Y=Y.nextEffect}}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);w=Ed;B=xd();q=w.focusedElem;h=w.selectionRange;if(B!==q&&q&&q.ownerDocument&&wd(q.ownerDocument.documentElement,q)){null!==h&&yd(q)&&(B=h.start,w=h.end,void 0===w&&(w=B),"selectionStart"in q?(q.selectionStart=B,q.selectionEnd=Math.min(w,q.value.length)):(w=(B=q.ownerDocument||document)&&B.defaultView||window,w.getSelection&&
(w=w.getSelection(),l=q.textContent.length,g=Math.min(h.start,l),h=void 0===h.end?g:Math.min(h.end,l),!w.extend&&g>h&&(l=h,h=g,g=l),l=vd(q,g),m=vd(q,h),l&&m&&(1!==w.rangeCount||w.anchorNode!==l.node||w.anchorOffset!==l.offset||w.focusNode!==m.node||w.focusOffset!==m.offset)&&(B=B.createRange(),B.setStart(l.node,l.offset),w.removeAllRanges(),g>h?(w.addRange(B),w.extend(m.node,m.offset)):(B.setEnd(m.node,m.offset),w.addRange(B))))));B=[];for(w=q;w=w.parentNode;)1===w.nodeType&&B.push({element:w,left:w.scrollLeft,
top:w.scrollTop});"function"===typeof q.focus&&q.focus();for(q=0;q<B.length;q++)w=B[q],w.element.scrollLeft=w.left,w.element.scrollTop=w.top}fd=!!Dd;Ed=Dd=null;a.current=c;Y=e;do try{for(q=a;null!==Y;){var ub=Y.effectTag;ub&36&&Ji(q,Y.alternate,Y);if(ub&128){B=void 0;var vb=Y.ref;if(null!==vb){var Xc=Y.stateNode;switch(Y.tag){case 5:B=Xc;break;default:B=Xc}"function"===typeof vb?vb(B):vb.current=B}}Y=Y.nextEffect}}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);Y=
null;Vf();W=f}else a.current=c;if(qj)qj=!1,rj=a,sj=b;else for(Y=e;null!==Y;)b=Y.nextEffect,Y.nextEffect=null,Y=b;b=a.firstPendingTime;0===b&&(aj=null);1073741823===b?a===vj?uj++:(uj=0,vj=a):uj=0;"function"===typeof Uj&&Uj(c.stateNode,d);Z(a);if(Yi)throw Yi=!1,a=Zi,Zi=null,a;if((W&ej)!==V)return null;gg();return null}function Tj(){for(;null!==Y;){var a=Y.effectTag;0!==(a&256)&&Gi(Y.alternate,Y);0===(a&512)||qj||(qj=!0,dg(97,function(){Dj();return null}));Y=Y.nextEffect}}
function Dj(){if(90!==sj){var a=97<sj?97:sj;sj=90;return cg(a,Vj)}}function Vj(){if(null===rj)return!1;var a=rj;rj=null;if((W&(fj|gj))!==V)throw Error(u(331));var b=W;W|=gj;for(a=a.current.firstEffect;null!==a;){try{var c=a;if(0!==(c.effectTag&512))switch(c.tag){case 0:case 11:case 15:case 22:Hi(5,c),Ii(5,c)}}catch(d){if(null===a)throw Error(u(330));Ei(a,d)}c=a.nextEffect;a.nextEffect=null;a=c}W=b;gg();return!0}
function Wj(a,b,c){b=Ai(c,b);b=Xi(a,b,1073741823);xg(a,b);a=xj(a,1073741823);null!==a&&Z(a)}function Ei(a,b){if(3===a.tag)Wj(a,a,b);else for(var c=a.return;null!==c;){if(3===c.tag){Wj(c,a,b);break}else if(1===c.tag){var d=c.stateNode;if("function"===typeof c.type.getDerivedStateFromError||"function"===typeof d.componentDidCatch&&(null===aj||!aj.has(d))){a=Ai(b,a);a=$i(c,a,1073741823);xg(c,a);c=xj(c,1073741823);null!==c&&Z(c);break}}c=c.return}}
function Oj(a,b,c){var d=a.pingCache;null!==d&&d.delete(b);T===a&&U===c?S===vi||S===ui&&1073741823===lj&&$f()-Ti<pj?Ej(a,U):oj=!0:Aj(a,c)&&(b=a.lastPingedTime,0!==b&&b<c||(a.lastPingedTime=c,Z(a)))}function Vi(a,b){var c=a.stateNode;null!==c&&c.delete(b);b=0;0===b&&(b=Gg(),b=Hg(b,a,null));a=xj(a,b);null!==a&&Z(a)}var Rj;
Rj=function(a,b,c){var d=b.expirationTime;if(null!==a){var e=b.pendingProps;if(a.memoizedProps!==e||K.current)rg=!0;else{if(d<c){rg=!1;switch(b.tag){case 3:hi(b);Xh();break;case 5:fh(b);if(b.mode&4&&1!==c&&e.hidden)return b.expirationTime=b.childExpirationTime=1,null;break;case 1:L(b.type)&&Gf(b);break;case 4:dh(b,b.stateNode.containerInfo);break;case 10:d=b.memoizedProps.value;e=b.type._context;I(jg,e._currentValue);e._currentValue=d;break;case 13:if(null!==b.memoizedState){d=b.child.childExpirationTime;
if(0!==d&&d>=c)return ji(a,b,c);I(M,M.current&1);b=$h(a,b,c);return null!==b?b.sibling:null}I(M,M.current&1);break;case 19:d=b.childExpirationTime>=c;if(0!==(a.effectTag&64)){if(d)return mi(a,b,c);b.effectTag|=64}e=b.memoizedState;null!==e&&(e.rendering=null,e.tail=null);I(M,M.current);if(!d)return null}return $h(a,b,c)}rg=!1}}else rg=!1;b.expirationTime=0;switch(b.tag){case 2:d=b.type;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;e=Cf(b,J.current);qg(b,c);e=oh(null,
b,d,a,e,c);b.effectTag|=1;if("object"===typeof e&&null!==e&&"function"===typeof e.render&&void 0===e.$$typeof){b.tag=1;b.memoizedState=null;b.updateQueue=null;if(L(d)){var f=!0;Gf(b)}else f=!1;b.memoizedState=null!==e.state&&void 0!==e.state?e.state:null;ug(b);var g=d.getDerivedStateFromProps;"function"===typeof g&&Fg(b,d,g,a);e.updater=Jg;b.stateNode=e;e._reactInternalFiber=b;Ng(b,d,a,c);b=gi(null,b,d,!0,f,c)}else b.tag=0,R(null,b,e,c),b=b.child;return b;case 16:a:{e=b.elementType;null!==a&&(a.alternate=
null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;ob(e);if(1!==e._status)throw e._result;e=e._result;b.type=e;f=b.tag=Xj(e);a=ig(e,a);switch(f){case 0:b=di(null,b,e,a,c);break a;case 1:b=fi(null,b,e,a,c);break a;case 11:b=Zh(null,b,e,a,c);break a;case 14:b=ai(null,b,e,ig(e.type,a),d,c);break a}throw Error(u(306,e,""));}return b;case 0:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),di(a,b,d,e,c);case 1:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),fi(a,b,d,e,c);
case 3:hi(b);d=b.updateQueue;if(null===a||null===d)throw Error(u(282));d=b.pendingProps;e=b.memoizedState;e=null!==e?e.element:null;vg(a,b);zg(b,d,null,c);d=b.memoizedState.element;if(d===e)Xh(),b=$h(a,b,c);else{if(e=b.stateNode.hydrate)Ph=Jd(b.stateNode.containerInfo.firstChild),Oh=b,e=Qh=!0;if(e)for(c=Yg(b,null,d,c),b.child=c;c;)c.effectTag=c.effectTag&-3|1024,c=c.sibling;else R(a,b,d,c),Xh();b=b.child}return b;case 5:return fh(b),null===a&&Uh(b),d=b.type,e=b.pendingProps,f=null!==a?a.memoizedProps:
null,g=e.children,Gd(d,e)?g=null:null!==f&&Gd(d,f)&&(b.effectTag|=16),ei(a,b),b.mode&4&&1!==c&&e.hidden?(b.expirationTime=b.childExpirationTime=1,b=null):(R(a,b,g,c),b=b.child),b;case 6:return null===a&&Uh(b),null;case 13:return ji(a,b,c);case 4:return dh(b,b.stateNode.containerInfo),d=b.pendingProps,null===a?b.child=Xg(b,null,d,c):R(a,b,d,c),b.child;case 11:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),Zh(a,b,d,e,c);case 7:return R(a,b,b.pendingProps,c),b.child;case 8:return R(a,
b,b.pendingProps.children,c),b.child;case 12:return R(a,b,b.pendingProps.children,c),b.child;case 10:a:{d=b.type._context;e=b.pendingProps;g=b.memoizedProps;f=e.value;var h=b.type._context;I(jg,h._currentValue);h._currentValue=f;if(null!==g)if(h=g.value,f=$e(h,f)?0:("function"===typeof d._calculateChangedBits?d._calculateChangedBits(h,f):1073741823)|0,0===f){if(g.children===e.children&&!K.current){b=$h(a,b,c);break a}}else for(h=b.child,null!==h&&(h.return=b);null!==h;){var k=h.dependencies;if(null!==
k){g=h.child;for(var l=k.firstContext;null!==l;){if(l.context===d&&0!==(l.observedBits&f)){1===h.tag&&(l=wg(c,null),l.tag=2,xg(h,l));h.expirationTime<c&&(h.expirationTime=c);l=h.alternate;null!==l&&l.expirationTime<c&&(l.expirationTime=c);pg(h.return,c);k.expirationTime<c&&(k.expirationTime=c);break}l=l.next}}else g=10===h.tag?h.type===b.type?null:h.child:h.child;if(null!==g)g.return=h;else for(g=h;null!==g;){if(g===b){g=null;break}h=g.sibling;if(null!==h){h.return=g.return;g=h;break}g=g.return}h=
g}R(a,b,e.children,c);b=b.child}return b;case 9:return e=b.type,f=b.pendingProps,d=f.children,qg(b,c),e=sg(e,f.unstable_observedBits),d=d(e),b.effectTag|=1,R(a,b,d,c),b.child;case 14:return e=b.type,f=ig(e,b.pendingProps),f=ig(e.type,f),ai(a,b,e,f,d,c);case 15:return ci(a,b,b.type,b.pendingProps,d,c);case 17:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),b.tag=1,L(d)?(a=!0,Gf(b)):a=!1,qg(b,c),Lg(b,d,e),Ng(b,d,e,c),gi(null,
b,d,!0,a,c);case 19:return mi(a,b,c)}throw Error(u(156,b.tag));};var Uj=null,Li=null;function Yj(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);Uj=function(a){try{b.onCommitFiberRoot(c,a,void 0,64===(a.current.effectTag&64))}catch(e){}};Li=function(a){try{b.onCommitFiberUnmount(c,a)}catch(e){}}}catch(d){}return!0}
function Zj(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=this.elementType=null;this.index=0;this.ref=null;this.pendingProps=b;this.dependencies=this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.childExpirationTime=this.expirationTime=0;this.alternate=null}function Sh(a,b,c,d){return new Zj(a,b,c,d)}
function bi(a){a=a.prototype;return!(!a||!a.isReactComponent)}function Xj(a){if("function"===typeof a)return bi(a)?1:0;if(void 0!==a&&null!==a){a=a.$$typeof;if(a===gb)return 11;if(a===jb)return 14}return 2}
function Sg(a,b){var c=a.alternate;null===c?(c=Sh(a.tag,b,a.key,a.mode),c.elementType=a.elementType,c.type=a.type,c.stateNode=a.stateNode,c.alternate=a,a.alternate=c):(c.pendingProps=b,c.effectTag=0,c.nextEffect=null,c.firstEffect=null,c.lastEffect=null);c.childExpirationTime=a.childExpirationTime;c.expirationTime=a.expirationTime;c.child=a.child;c.memoizedProps=a.memoizedProps;c.memoizedState=a.memoizedState;c.updateQueue=a.updateQueue;b=a.dependencies;c.dependencies=null===b?null:{expirationTime:b.expirationTime,
firstContext:b.firstContext,responders:b.responders};c.sibling=a.sibling;c.index=a.index;c.ref=a.ref;return c}
function Ug(a,b,c,d,e,f){var g=2;d=a;if("function"===typeof a)bi(a)&&(g=1);else if("string"===typeof a)g=5;else a:switch(a){case ab:return Wg(c.children,e,f,b);case fb:g=8;e|=7;break;case bb:g=8;e|=1;break;case cb:return a=Sh(12,c,b,e|8),a.elementType=cb,a.type=cb,a.expirationTime=f,a;case hb:return a=Sh(13,c,b,e),a.type=hb,a.elementType=hb,a.expirationTime=f,a;case ib:return a=Sh(19,c,b,e),a.elementType=ib,a.expirationTime=f,a;default:if("object"===typeof a&&null!==a)switch(a.$$typeof){case db:g=
10;break a;case eb:g=9;break a;case gb:g=11;break a;case jb:g=14;break a;case kb:g=16;d=null;break a;case lb:g=22;break a}throw Error(u(130,null==a?a:typeof a,""));}b=Sh(g,c,b,e);b.elementType=a;b.type=d;b.expirationTime=f;return b}function Wg(a,b,c,d){a=Sh(7,a,d,b);a.expirationTime=c;return a}function Tg(a,b,c){a=Sh(6,a,null,b);a.expirationTime=c;return a}
function Vg(a,b,c){b=Sh(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}
function ak(a,b,c){this.tag=b;this.current=null;this.containerInfo=a;this.pingCache=this.pendingChildren=null;this.finishedExpirationTime=0;this.finishedWork=null;this.timeoutHandle=-1;this.pendingContext=this.context=null;this.hydrate=c;this.callbackNode=null;this.callbackPriority=90;this.lastExpiredTime=this.lastPingedTime=this.nextKnownPendingLevel=this.lastSuspendedTime=this.firstSuspendedTime=this.firstPendingTime=0}
function Aj(a,b){var c=a.firstSuspendedTime;a=a.lastSuspendedTime;return 0!==c&&c>=b&&a<=b}function xi(a,b){var c=a.firstSuspendedTime,d=a.lastSuspendedTime;c<b&&(a.firstSuspendedTime=b);if(d>b||0===c)a.lastSuspendedTime=b;b<=a.lastPingedTime&&(a.lastPingedTime=0);b<=a.lastExpiredTime&&(a.lastExpiredTime=0)}
function yi(a,b){b>a.firstPendingTime&&(a.firstPendingTime=b);var c=a.firstSuspendedTime;0!==c&&(b>=c?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:b>=a.lastSuspendedTime&&(a.lastSuspendedTime=b+1),b>a.nextKnownPendingLevel&&(a.nextKnownPendingLevel=b))}function Cj(a,b){var c=a.lastExpiredTime;if(0===c||c>b)a.lastExpiredTime=b}
function bk(a,b,c,d){var e=b.current,f=Gg(),g=Dg.suspense;f=Hg(f,e,g);a:if(c){c=c._reactInternalFiber;b:{if(dc(c)!==c||1!==c.tag)throw Error(u(170));var h=c;do{switch(h.tag){case 3:h=h.stateNode.context;break b;case 1:if(L(h.type)){h=h.stateNode.__reactInternalMemoizedMergedChildContext;break b}}h=h.return}while(null!==h);throw Error(u(171));}if(1===c.tag){var k=c.type;if(L(k)){c=Ff(c,k,h);break a}}c=h}else c=Af;null===b.context?b.context=c:b.pendingContext=c;b=wg(f,g);b.payload={element:a};d=void 0===
d?null:d;null!==d&&(b.callback=d);xg(e,b);Ig(e,f);return f}function ck(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return a.child.stateNode;default:return a.child.stateNode}}function dk(a,b){a=a.memoizedState;null!==a&&null!==a.dehydrated&&a.retryTime<b&&(a.retryTime=b)}function ek(a,b){dk(a,b);(a=a.alternate)&&dk(a,b)}
function fk(a,b,c){c=null!=c&&!0===c.hydrate;var d=new ak(a,b,c),e=Sh(3,null,null,2===b?7:1===b?3:0);d.current=e;e.stateNode=d;ug(e);a[Od]=d.current;c&&0!==b&&Jc(a,9===a.nodeType?a:a.ownerDocument);this._internalRoot=d}fk.prototype.render=function(a){bk(a,this._internalRoot,null,null)};fk.prototype.unmount=function(){var a=this._internalRoot,b=a.containerInfo;bk(null,a,null,function(){b[Od]=null})};
function gk(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}function hk(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new fk(a,0,b?{hydrate:!0}:void 0)}
function ik(a,b,c,d,e){var f=c._reactRootContainer;if(f){var g=f._internalRoot;if("function"===typeof e){var h=e;e=function(){var a=ck(g);h.call(a)}}bk(b,g,a,e)}else{f=c._reactRootContainer=hk(c,d);g=f._internalRoot;if("function"===typeof e){var k=e;e=function(){var a=ck(g);k.call(a)}}Nj(function(){bk(b,g,a,e)})}return ck(g)}function jk(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:$a,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}
wc=function(a){if(13===a.tag){var b=hg(Gg(),150,100);Ig(a,b);ek(a,b)}};xc=function(a){13===a.tag&&(Ig(a,3),ek(a,3))};yc=function(a){if(13===a.tag){var b=Gg();b=Hg(b,a,null);Ig(a,b);ek(a,b)}};
za=function(a,b,c){switch(b){case "input":Cb(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=c.parentNode;c=c.querySelectorAll("input[name="+JSON.stringify(""+b)+'][type="radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=Qd(d);if(!e)throw Error(u(90));yb(d);Cb(d,e)}}}break;case "textarea":Kb(a,c);break;case "select":b=c.value,null!=b&&Hb(a,!!c.multiple,b,!1)}};Fa=Mj;
Ga=function(a,b,c,d,e){var f=W;W|=4;try{return cg(98,a.bind(null,b,c,d,e))}finally{W=f,W===V&&gg()}};Ha=function(){(W&(1|fj|gj))===V&&(Lj(),Dj())};Ia=function(a,b){var c=W;W|=2;try{return a(b)}finally{W=c,W===V&&gg()}};function kk(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;if(!gk(b))throw Error(u(200));return jk(a,b,null,c)}var lk={Events:[Nc,Pd,Qd,xa,ta,Xd,function(a){jc(a,Wd)},Da,Ea,id,mc,Dj,{current:!1}]};
(function(a){var b=a.findFiberByHostInstance;return Yj(n({},a,{overrideHookState:null,overrideProps:null,setSuspenseHandler:null,scheduleUpdate:null,currentDispatcherRef:Wa.ReactCurrentDispatcher,findHostInstanceByFiber:function(a){a=hc(a);return null===a?null:a.stateNode},findFiberByHostInstance:function(a){return b?b(a):null},findHostInstancesForRefresh:null,scheduleRefresh:null,scheduleRoot:null,setRefreshHandler:null,getCurrentFiber:null}))})({findFiberByHostInstance:tc,bundleType:0,version:"16.14.0",
rendererPackageName:"react-dom"});exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=lk;exports.createPortal=kk;exports.findDOMNode=function(a){if(null==a)return null;if(1===a.nodeType)return a;var b=a._reactInternalFiber;if(void 0===b){if("function"===typeof a.render)throw Error(u(188));throw Error(u(268,Object.keys(a)));}a=hc(b);a=null===a?null:a.stateNode;return a};
exports.flushSync=function(a,b){if((W&(fj|gj))!==V)throw Error(u(187));var c=W;W|=1;try{return cg(99,a.bind(null,b))}finally{W=c,gg()}};exports.hydrate=function(a,b,c){if(!gk(b))throw Error(u(200));return ik(null,a,b,!0,c)};exports.render=function(a,b,c){if(!gk(b))throw Error(u(200));return ik(null,a,b,!1,c)};
exports.unmountComponentAtNode=function(a){if(!gk(a))throw Error(u(40));return a._reactRootContainer?(Nj(function(){ik(null,null,a,!1,function(){a._reactRootContainer=null;a[Od]=null})}),!0):!1};exports.unstable_batchedUpdates=Mj;exports.unstable_createPortal=function(a,b){return kk(a,b,2<arguments.length&&void 0!==arguments[2]?arguments[2]:null)};
exports.unstable_renderSubtreeIntoContainer=function(a,b,c,d){if(!gk(c))throw Error(u(200));if(null==a||void 0===a._reactInternalFiber)throw Error(u(38));return ik(a,b,c,!1,d)};exports.version="16.14.0";


/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(466);
} else {
  module.exports = require('./cjs/scheduler.development.js');
}


/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v0.19.1
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var f,g,h,k,l;
if("undefined"===typeof window||"function"!==typeof MessageChannel){var p=null,q=null,t=function(){if(null!==p)try{var a=exports.unstable_now();p(!0,a);p=null}catch(b){throw setTimeout(t,0),b;}},u=Date.now();exports.unstable_now=function(){return Date.now()-u};f=function(a){null!==p?setTimeout(f,0,a):(p=a,setTimeout(t,0))};g=function(a,b){q=setTimeout(a,b)};h=function(){clearTimeout(q)};k=function(){return!1};l=exports.unstable_forceFrameRate=function(){}}else{var w=window.performance,x=window.Date,
y=window.setTimeout,z=window.clearTimeout;if("undefined"!==typeof console){var A=window.cancelAnimationFrame;"function"!==typeof window.requestAnimationFrame&&console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");"function"!==typeof A&&console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills")}if("object"===
typeof w&&"function"===typeof w.now)exports.unstable_now=function(){return w.now()};else{var B=x.now();exports.unstable_now=function(){return x.now()-B}}var C=!1,D=null,E=-1,F=5,G=0;k=function(){return exports.unstable_now()>=G};l=function(){};exports.unstable_forceFrameRate=function(a){0>a||125<a?console.error("forceFrameRate takes a positive int between 0 and 125, forcing framerates higher than 125 fps is not unsupported"):F=0<a?Math.floor(1E3/a):5};var H=new MessageChannel,I=H.port2;H.port1.onmessage=
function(){if(null!==D){var a=exports.unstable_now();G=a+F;try{D(!0,a)?I.postMessage(null):(C=!1,D=null)}catch(b){throw I.postMessage(null),b;}}else C=!1};f=function(a){D=a;C||(C=!0,I.postMessage(null))};g=function(a,b){E=y(function(){a(exports.unstable_now())},b)};h=function(){z(E);E=-1}}function J(a,b){var c=a.length;a.push(b);a:for(;;){var d=c-1>>>1,e=a[d];if(void 0!==e&&0<K(e,b))a[d]=b,a[c]=e,c=d;else break a}}function L(a){a=a[0];return void 0===a?null:a}
function M(a){var b=a[0];if(void 0!==b){var c=a.pop();if(c!==b){a[0]=c;a:for(var d=0,e=a.length;d<e;){var m=2*(d+1)-1,n=a[m],v=m+1,r=a[v];if(void 0!==n&&0>K(n,c))void 0!==r&&0>K(r,n)?(a[d]=r,a[v]=c,d=v):(a[d]=n,a[m]=c,d=m);else if(void 0!==r&&0>K(r,c))a[d]=r,a[v]=c,d=v;else break a}}return b}return null}function K(a,b){var c=a.sortIndex-b.sortIndex;return 0!==c?c:a.id-b.id}var N=[],O=[],P=1,Q=null,R=3,S=!1,T=!1,U=!1;
function V(a){for(var b=L(O);null!==b;){if(null===b.callback)M(O);else if(b.startTime<=a)M(O),b.sortIndex=b.expirationTime,J(N,b);else break;b=L(O)}}function W(a){U=!1;V(a);if(!T)if(null!==L(N))T=!0,f(X);else{var b=L(O);null!==b&&g(W,b.startTime-a)}}
function X(a,b){T=!1;U&&(U=!1,h());S=!0;var c=R;try{V(b);for(Q=L(N);null!==Q&&(!(Q.expirationTime>b)||a&&!k());){var d=Q.callback;if(null!==d){Q.callback=null;R=Q.priorityLevel;var e=d(Q.expirationTime<=b);b=exports.unstable_now();"function"===typeof e?Q.callback=e:Q===L(N)&&M(N);V(b)}else M(N);Q=L(N)}if(null!==Q)var m=!0;else{var n=L(O);null!==n&&g(W,n.startTime-b);m=!1}return m}finally{Q=null,R=c,S=!1}}
function Y(a){switch(a){case 1:return-1;case 2:return 250;case 5:return 1073741823;case 4:return 1E4;default:return 5E3}}var Z=l;exports.unstable_IdlePriority=5;exports.unstable_ImmediatePriority=1;exports.unstable_LowPriority=4;exports.unstable_NormalPriority=3;exports.unstable_Profiling=null;exports.unstable_UserBlockingPriority=2;exports.unstable_cancelCallback=function(a){a.callback=null};exports.unstable_continueExecution=function(){T||S||(T=!0,f(X))};
exports.unstable_getCurrentPriorityLevel=function(){return R};exports.unstable_getFirstCallbackNode=function(){return L(N)};exports.unstable_next=function(a){switch(R){case 1:case 2:case 3:var b=3;break;default:b=R}var c=R;R=b;try{return a()}finally{R=c}};exports.unstable_pauseExecution=function(){};exports.unstable_requestPaint=Z;exports.unstable_runWithPriority=function(a,b){switch(a){case 1:case 2:case 3:case 4:case 5:break;default:a=3}var c=R;R=a;try{return b()}finally{R=c}};
exports.unstable_scheduleCallback=function(a,b,c){var d=exports.unstable_now();if("object"===typeof c&&null!==c){var e=c.delay;e="number"===typeof e&&0<e?d+e:d;c="number"===typeof c.timeout?c.timeout:Y(a)}else c=Y(a),e=d;c=e+c;a={id:P++,callback:b,priorityLevel:a,startTime:e,expirationTime:c,sortIndex:-1};e>d?(a.sortIndex=e,J(O,a),null===L(N)&&a===L(O)&&(U?h():U=!0,g(W,e-d))):(a.sortIndex=c,J(N,a),T||S||(T=!0,f(X)));return a};
exports.unstable_shouldYield=function(){var a=exports.unstable_now();V(a);var b=L(N);return b!==Q&&null!==Q&&null!==b&&null!==b.callback&&b.startTime<=a&&b.expirationTime<Q.expirationTime||k()};exports.unstable_wrapCallback=function(a){var b=R;return function(){var c=R;R=b;try{return a.apply(this,arguments)}finally{R=c}}};


/***/ }),
/* 467 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createProvider */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_warning__ = __webpack_require__(146);





var prefixUnsafeLifecycleMethods = typeof __WEBPACK_IMPORTED_MODULE_1_react___default.a.forwardRef !== "undefined";
var didWarnAboutReceivingStore = false;

function warnAboutReceivingStore() {
  if (didWarnAboutReceivingStore) {
    return;
  }

  didWarnAboutReceivingStore = true;
  Object(__WEBPACK_IMPORTED_MODULE_4__utils_warning__["a" /* default */])('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reduxjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
}

function createProvider(storeKey) {
  var _Provider$childContex;

  if (storeKey === void 0) {
    storeKey = 'store';
  }

  var subscriptionKey = storeKey + "Subscription";

  var Provider =
  /*#__PURE__*/
  function (_Component) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Provider, _Component);

    var _proto = Provider.prototype;

    _proto.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[storeKey] = this[storeKey], _ref[subscriptionKey] = null, _ref;
    };

    function Provider(props, context) {
      var _this;

      _this = _Component.call(this, props, context) || this;
      _this[storeKey] = props.store;
      return _this;
    }

    _proto.render = function render() {
      return __WEBPACK_IMPORTED_MODULE_1_react__["Children"].only(this.props.children);
    };

    return Provider;
  }(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

  if (false) {
    // Use UNSAFE_ event name where supported
    var eventName = prefixUnsafeLifecycleMethods ? 'UNSAFE_componentWillReceiveProps' : 'componentWillReceiveProps';

    Provider.prototype[eventName] = function (nextProps) {
      if (this[storeKey] !== nextProps.store) {
        warnAboutReceivingStore();
      }
    };
  }

  Provider.propTypes = {
    store: __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__["a" /* storeShape */].isRequired,
    children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.element.isRequired
  };
  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[storeKey] = __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__["a" /* storeShape */].isRequired, _Provider$childContex[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__["b" /* subscriptionShape */], _Provider$childContex);
  return Provider;
}
/* harmony default export */ __webpack_exports__["a"] = (createProvider());

/***/ }),
/* 468 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _setPrototypeOf; });
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}


/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(470);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 471 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _assertThisInitialized; });
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}


/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ }),
/* 473 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Subscription; });
// encapsulates the subscription logic for connecting a component to the redux store, as
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants
var CLEARED = null;
var nullListeners = {
  notify: function notify() {}
};

function createListenerCollection() {
  // the current/next pattern is copied from redux's createStore code.
  // TODO: refactor+expose that code to be reusable here?
  var current = [];
  var next = [];
  return {
    clear: function clear() {
      next = CLEARED;
      current = CLEARED;
    },
    notify: function notify() {
      var listeners = current = next;

      for (var i = 0; i < listeners.length; i++) {
        listeners[i]();
      }
    },
    get: function get() {
      return next;
    },
    subscribe: function subscribe(listener) {
      var isSubscribed = true;
      if (next === current) next = current.slice();
      next.push(listener);
      return function unsubscribe() {
        if (!isSubscribed || current === CLEARED) return;
        isSubscribed = false;
        if (next === current) next = current.slice();
        next.splice(next.indexOf(listener), 1);
      };
    }
  };
}

var Subscription =
/*#__PURE__*/
function () {
  function Subscription(store, parentSub, onStateChange) {
    this.store = store;
    this.parentSub = parentSub;
    this.onStateChange = onStateChange;
    this.unsubscribe = null;
    this.listeners = nullListeners;
  }

  var _proto = Subscription.prototype;

  _proto.addNestedSub = function addNestedSub(listener) {
    this.trySubscribe();
    return this.listeners.subscribe(listener);
  };

  _proto.notifyNestedSubs = function notifyNestedSubs() {
    this.listeners.notify();
  };

  _proto.isSubscribed = function isSubscribed() {
    return Boolean(this.unsubscribe);
  };

  _proto.trySubscribe = function trySubscribe() {
    if (!this.unsubscribe) {
      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.onStateChange) : this.store.subscribe(this.onStateChange);
      this.listeners = createListenerCollection();
    }
  };

  _proto.tryUnsubscribe = function tryUnsubscribe() {
    if (this.unsubscribe) {
      this.unsubscribe();
      this.unsubscribe = null;
      this.listeners.clear();
      this.listeners = nullListeners;
    }
  };

  return Subscription;
}();



/***/ }),
/* 474 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createConnect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_connectAdvanced__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__ = __webpack_require__(475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mapDispatchToProps__ = __webpack_require__(476);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mapStateToProps__ = __webpack_require__(491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mergeProps__ = __webpack_require__(492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__selectorFactory__ = __webpack_require__(493);








/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */

function match(arg, factories, name) {
  for (var i = factories.length - 1; i >= 0; i--) {
    var result = factories[i](arg);
    if (result) return result;
  }

  return function (dispatch, options) {
    throw new Error("Invalid value of type " + typeof arg + " for " + name + " argument when connecting component " + options.wrappedComponentName + ".");
  };
}

function strictEqual(a, b) {
  return a === b;
} // createConnect with default args builds the 'official' connect behavior. Calling it with
// different options opens up some testing and extensibility scenarios


function createConnect(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      _ref$connectHOC = _ref.connectHOC,
      connectHOC = _ref$connectHOC === void 0 ? __WEBPACK_IMPORTED_MODULE_2__components_connectAdvanced__["a" /* default */] : _ref$connectHOC,
      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
      mapStateToPropsFactories = _ref$mapStateToPropsF === void 0 ? __WEBPACK_IMPORTED_MODULE_5__mapStateToProps__["a" /* default */] : _ref$mapStateToPropsF,
      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
      mapDispatchToPropsFactories = _ref$mapDispatchToPro === void 0 ? __WEBPACK_IMPORTED_MODULE_4__mapDispatchToProps__["a" /* default */] : _ref$mapDispatchToPro,
      _ref$mergePropsFactor = _ref.mergePropsFactories,
      mergePropsFactories = _ref$mergePropsFactor === void 0 ? __WEBPACK_IMPORTED_MODULE_6__mergeProps__["a" /* default */] : _ref$mergePropsFactor,
      _ref$selectorFactory = _ref.selectorFactory,
      selectorFactory = _ref$selectorFactory === void 0 ? __WEBPACK_IMPORTED_MODULE_7__selectorFactory__["a" /* default */] : _ref$selectorFactory;

  return function connect(mapStateToProps, mapDispatchToProps, mergeProps, _ref2) {
    if (_ref2 === void 0) {
      _ref2 = {};
    }

    var _ref3 = _ref2,
        _ref3$pure = _ref3.pure,
        pure = _ref3$pure === void 0 ? true : _ref3$pure,
        _ref3$areStatesEqual = _ref3.areStatesEqual,
        areStatesEqual = _ref3$areStatesEqual === void 0 ? strictEqual : _ref3$areStatesEqual,
        _ref3$areOwnPropsEqua = _ref3.areOwnPropsEqual,
        areOwnPropsEqual = _ref3$areOwnPropsEqua === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areOwnPropsEqua,
        _ref3$areStatePropsEq = _ref3.areStatePropsEqual,
        areStatePropsEqual = _ref3$areStatePropsEq === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areStatePropsEq,
        _ref3$areMergedPropsE = _ref3.areMergedPropsEqual,
        areMergedPropsEqual = _ref3$areMergedPropsE === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areMergedPropsE,
        extraOptions = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref3, ["pure", "areStatesEqual", "areOwnPropsEqual", "areStatePropsEqual", "areMergedPropsEqual"]);

    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');
    return connectHOC(selectorFactory, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      // used in error messages
      methodName: 'connect',
      // used to compute Connect's displayName from the wrapped component's displayName.
      getDisplayName: function getDisplayName(name) {
        return "Connect(" + name + ")";
      },
      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
      shouldHandleStateChanges: Boolean(mapStateToProps),
      // passed through to selectorFactory
      initMapStateToProps: initMapStateToProps,
      initMapDispatchToProps: initMapDispatchToProps,
      initMergeProps: initMergeProps,
      pure: pure,
      areStatesEqual: areStatesEqual,
      areOwnPropsEqual: areOwnPropsEqual,
      areStatePropsEqual: areStatePropsEqual,
      areMergedPropsEqual: areMergedPropsEqual
    }, extraOptions));
  };
}
/* harmony default export */ __webpack_exports__["a"] = (createConnect());

/***/ }),
/* 475 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = shallowEqual;
var hasOwn = Object.prototype.hasOwnProperty;

function is(x, y) {
  if (x === y) {
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function shallowEqual(objA, objB) {
  if (is(objA, objB)) return true;

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);
  if (keysA.length !== keysB.length) return false;

  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

/***/ }),
/* 476 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapDispatchToPropsIsFunction */
/* unused harmony export whenMapDispatchToPropsIsMissing */
/* unused harmony export whenMapDispatchToPropsIsObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__ = __webpack_require__(215);


function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
  return typeof mapDispatchToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}
function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
  return !mapDispatchToProps ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return {
      dispatch: dispatch
    };
  }) : undefined;
}
function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_redux__["b" /* bindActionCreators */])(mapDispatchToProps, dispatch);
  }) : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject]);

/***/ }),
/* 477 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getRawTag_js__ = __webpack_require__(480);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__objectToString_js__ = __webpack_require__(481);




/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? Object(__WEBPACK_IMPORTED_MODULE_1__getRawTag_js__["a" /* default */])(value)
    : Object(__WEBPACK_IMPORTED_MODULE_2__objectToString_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (baseGetTag);


/***/ }),
/* 478 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__ = __webpack_require__(479);


/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__["a" /* default */] || freeSelf || Function('return this')();

/* harmony default export */ __webpack_exports__["a"] = (root);


/***/ }),
/* 479 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/* harmony default export */ __webpack_exports__["a"] = (freeGlobal);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(71)))

/***/ }),
/* 480 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(211);


/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (getRawTag);


/***/ }),
/* 481 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/* harmony default export */ __webpack_exports__["a"] = (objectToString);


/***/ }),
/* 482 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__overArg_js__ = __webpack_require__(483);


/** Built-in value references. */
var getPrototype = Object(__WEBPACK_IMPORTED_MODULE_0__overArg_js__["a" /* default */])(Object.getPrototypeOf, Object);

/* harmony default export */ __webpack_exports__["a"] = (getPrototype);


/***/ }),
/* 483 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (overArg);


/***/ }),
/* 484 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/* harmony default export */ __webpack_exports__["a"] = (isObjectLike);


/***/ }),
/* 485 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ponyfill_js__ = __webpack_require__(486);
/* global window */


var root;

if (typeof self !== 'undefined') {
  root = self;
} else if (typeof window !== 'undefined') {
  root = window;
} else if (typeof global !== 'undefined') {
  root = global;
} else if (true) {
  root = module;
} else {
  root = Function('return this')();
}

var result = Object(__WEBPACK_IMPORTED_MODULE_0__ponyfill_js__["a" /* default */])(root);
/* harmony default export */ __webpack_exports__["a"] = (result);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(71), __webpack_require__(212)(module)))

/***/ }),
/* 486 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = symbolObservablePonyfill;
function symbolObservablePonyfill(root) {
	var result;
	var Symbol = root.Symbol;

	if (typeof Symbol === 'function') {
		if (Symbol.observable) {
			result = Symbol.observable;
		} else {
			result = Symbol('observable');
			Symbol.observable = result;
		}
	} else {
		result = '@@observable';
	}

	return result;
};


/***/ }),
/* 487 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = combineReducers;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_warning__ = __webpack_require__(213);




function getUndefinedStateErrorMessage(key, action) {
  var actionType = action && action.type;
  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';

  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!Object(__WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__["a" /* default */])(inputState)) {
    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });

  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });

  if (unexpectedKeys.length > 0) {
    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
  }
}

function assertReducerShape(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, { type: __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT });

    if (typeof initialState === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
    }

    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
    if (typeof reducer(undefined, { type: type }) === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
    }
  });
}

/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */
function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};
  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (false) {
      if (typeof reducers[key] === 'undefined') {
        warning('No reducer provided for key "' + key + '"');
      }
    }

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }
  var finalReducerKeys = Object.keys(finalReducers);

  var unexpectedKeyCache = void 0;
  if (false) {
    unexpectedKeyCache = {};
  }

  var shapeAssertionError = void 0;
  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }

  return function combination() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    if (shapeAssertionError) {
      throw shapeAssertionError;
    }

    if (false) {
      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
      if (warningMessage) {
        warning(warningMessage);
      }
    }

    var hasChanged = false;
    var nextState = {};
    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
      var _key = finalReducerKeys[_i];
      var reducer = finalReducers[_key];
      var previousStateForKey = state[_key];
      var nextStateForKey = reducer(previousStateForKey, action);
      if (typeof nextStateForKey === 'undefined') {
        var errorMessage = getUndefinedStateErrorMessage(_key, action);
        throw new Error(errorMessage);
      }
      nextState[_key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }
    return hasChanged ? nextState : state;
  };
}

/***/ }),
/* 488 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = bindActionCreators;
function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(undefined, arguments));
  };
}

/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass a single function as the first argument,
 * and get a function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */
function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if (typeof actionCreators !== 'object' || actionCreators === null) {
    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
  }

  var keys = Object.keys(actionCreators);
  var boundActionCreators = {};
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    var actionCreator = actionCreators[key];
    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }
  return boundActionCreators;
}

/***/ }),
/* 489 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = applyMiddleware;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__compose__ = __webpack_require__(214);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */
function applyMiddleware() {
  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function (reducer, preloadedState, enhancer) {
      var store = createStore(reducer, preloadedState, enhancer);
      var _dispatch = store.dispatch;
      var chain = [];

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch(action) {
          return _dispatch(action);
        }
      };
      chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = __WEBPACK_IMPORTED_MODULE_0__compose__["a" /* default */].apply(undefined, chain)(store.dispatch);

      return _extends({}, store, {
        dispatch: _dispatch
      });
    };
  };
}

/***/ }),
/* 490 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isPlainObject;
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */
function isPlainObject(obj) {
  if (typeof obj !== 'object' || obj === null) return false;
  var proto = Object.getPrototypeOf(obj);
  if (proto === null) return true;
  var baseProto = proto;

  while (Object.getPrototypeOf(baseProto) !== null) {
    baseProto = Object.getPrototypeOf(baseProto);
  }

  return proto === baseProto;
}

/***/ }),
/* 491 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapStateToPropsIsFunction */
/* unused harmony export whenMapStateToPropsIsMissing */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__ = __webpack_require__(215);

function whenMapStateToPropsIsFunction(mapStateToProps) {
  return typeof mapStateToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapStateToProps, 'mapStateToProps') : undefined;
}
function whenMapStateToPropsIsMissing(mapStateToProps) {
  return !mapStateToProps ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function () {
    return {};
  }) : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing]);

/***/ }),
/* 492 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export defaultMergeProps */
/* unused harmony export wrapMergePropsFunc */
/* unused harmony export whenMergePropsIsFunction */
/* unused harmony export whenMergePropsIsOmitted */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_verifyPlainObject__ = __webpack_require__(216);


function defaultMergeProps(stateProps, dispatchProps, ownProps) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, ownProps, stateProps, dispatchProps);
}
function wrapMergePropsFunc(mergeProps) {
  return function initMergePropsProxy(dispatch, _ref) {
    var displayName = _ref.displayName,
        pure = _ref.pure,
        areMergedPropsEqual = _ref.areMergedPropsEqual;
    var hasRunOnce = false;
    var mergedProps;
    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);

      if (hasRunOnce) {
        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
      } else {
        hasRunOnce = true;
        mergedProps = nextMergedProps;
        if (false) verifyPlainObject(mergedProps, displayName, 'mergeProps');
      }

      return mergedProps;
    };
  };
}
function whenMergePropsIsFunction(mergeProps) {
  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
}
function whenMergePropsIsOmitted(mergeProps) {
  return !mergeProps ? function () {
    return defaultMergeProps;
  } : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMergePropsIsFunction, whenMergePropsIsOmitted]);

/***/ }),
/* 493 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export impureFinalPropsSelectorFactory */
/* unused harmony export pureFinalPropsSelectorFactory */
/* harmony export (immutable) */ __webpack_exports__["a"] = finalPropsSelectorFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__verifySubselectors__ = __webpack_require__(494);


function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
  return function impureFinalPropsSelector(state, ownProps) {
    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
  };
}
function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
  var areStatesEqual = _ref.areStatesEqual,
      areOwnPropsEqual = _ref.areOwnPropsEqual,
      areStatePropsEqual = _ref.areStatePropsEqual;
  var hasRunAtLeastOnce = false;
  var state;
  var ownProps;
  var stateProps;
  var dispatchProps;
  var mergedProps;

  function handleFirstCall(firstState, firstOwnProps) {
    state = firstState;
    ownProps = firstOwnProps;
    stateProps = mapStateToProps(state, ownProps);
    dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    hasRunAtLeastOnce = true;
    return mergedProps;
  }

  function handleNewPropsAndNewState() {
    stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewProps() {
    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewState() {
    var nextStateProps = mapStateToProps(state, ownProps);
    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
    stateProps = nextStateProps;
    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleSubsequentCalls(nextState, nextOwnProps) {
    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
    var stateChanged = !areStatesEqual(nextState, state);
    state = nextState;
    ownProps = nextOwnProps;
    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
    if (propsChanged) return handleNewProps();
    if (stateChanged) return handleNewState();
    return mergedProps;
  }

  return function pureFinalPropsSelector(nextState, nextOwnProps) {
    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
  };
} // TODO: Add more comments
// If pure is true, the selector returned by selectorFactory will memoize its results,
// allowing connectAdvanced's shouldComponentUpdate to return false if final
// props have not changed. If false, the selector will always return a new
// object and shouldComponentUpdate will always return true.

function finalPropsSelectorFactory(dispatch, _ref2) {
  var initMapStateToProps = _ref2.initMapStateToProps,
      initMapDispatchToProps = _ref2.initMapDispatchToProps,
      initMergeProps = _ref2.initMergeProps,
      options = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref2, ["initMapStateToProps", "initMapDispatchToProps", "initMergeProps"]);

  var mapStateToProps = initMapStateToProps(dispatch, options);
  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
  var mergeProps = initMergeProps(dispatch, options);

  if (false) {
    verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
  }

  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;
  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

/***/ }),
/* 494 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_warning__ = __webpack_require__(146);


function verify(selector, methodName, displayName) {
  if (!selector) {
    throw new Error("Unexpected value for " + methodName + " in " + displayName + ".");
  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
    if (!selector.hasOwnProperty('dependsOnOwnProps')) {
      Object(__WEBPACK_IMPORTED_MODULE_0__utils_warning__["a" /* default */])("The selector for " + methodName + " of " + displayName + " did not specify a value for dependsOnOwnProps.");
    }
  }
}

function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
  verify(mapStateToProps, 'mapStateToProps', displayName);
  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
  verify(mergeProps, 'mergeProps', displayName);
}

/***/ }),
/* 495 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(149);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses HTML5 history.
 */

var BrowserRouter = function (_React$Component) {
  _inherits(BrowserRouter, _React$Component);

  function BrowserRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, BrowserRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["a" /* createBrowserHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  BrowserRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<BrowserRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { BrowserRouter as Router }`.");
  };

  BrowserRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return BrowserRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

BrowserRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  forceRefresh: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* unused harmony default export */ var _unused_webpack_default_export = (BrowserRouter);

/***/ }),
/* 496 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(149);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses window.location.hash.
 */

var HashRouter = function (_React$Component) {
  _inherits(HashRouter, _React$Component);

  function HashRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, HashRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["b" /* createHashHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  HashRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<HashRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { HashRouter as Router }`.");
  };

  HashRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return HashRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

HashRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  hashType: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(["hashbang", "noslash", "slash"]),
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* unused harmony default export */ var _unused_webpack_default_export = (HashRouter);

/***/ }),
/* 497 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__ = __webpack_require__(498);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__["a" /* default */]);

/***/ }),
/* 498 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(150);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that stores location in memory.
 */

var MemoryRouter = function (_React$Component) {
  _inherits(MemoryRouter, _React$Component);

  function MemoryRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, MemoryRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["d" /* createMemoryHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  MemoryRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<MemoryRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { MemoryRouter as Router }`.");
  };

  MemoryRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return MemoryRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

MemoryRouter.propTypes = {
  initialEntries: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,
  initialIndex: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (MemoryRouter);

/***/ }),
/* 499 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Route__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Link__ = __webpack_require__(221);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A <Link> wrapper that knows if it's "active" or not.
 */
var NavLink = function NavLink(_ref) {
  var to = _ref.to,
      exact = _ref.exact,
      strict = _ref.strict,
      location = _ref.location,
      activeClassName = _ref.activeClassName,
      className = _ref.className,
      activeStyle = _ref.activeStyle,
      style = _ref.style,
      getIsActive = _ref.isActive,
      ariaCurrent = _ref["aria-current"],
      rest = _objectWithoutProperties(_ref, ["to", "exact", "strict", "location", "activeClassName", "className", "activeStyle", "style", "isActive", "aria-current"]);

  var path = (typeof to === "undefined" ? "undefined" : _typeof(to)) === "object" ? to.pathname : to;

  // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202
  var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Route__["a" /* default */], {
    path: escapedPath,
    exact: exact,
    strict: strict,
    location: location,
    children: function children(_ref2) {
      var location = _ref2.location,
          match = _ref2.match;

      var isActive = !!(getIsActive ? getIsActive(match, location) : match);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */], _extends({
        to: to,
        className: isActive ? [className, activeClassName].filter(function (i) {
          return i;
        }).join(" ") : className,
        style: isActive ? _extends({}, style, activeStyle) : style,
        "aria-current": isActive && ariaCurrent || null
      }, rest));
    }
  });
};

NavLink.propTypes = {
  to: __WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */].propTypes.to,
  exact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  activeClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  activeStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  isActive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  "aria-current": __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["page", "step", "location", "date", "time", "true"])
};

NavLink.defaultProps = {
  activeClassName: "active",
  "aria-current": "page"
};

/* harmony default export */ __webpack_exports__["a"] = (NavLink);

/***/ }),
/* 500 */
/***/ (function(module, exports) {

module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};


/***/ }),
/* 501 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__ = __webpack_require__(502);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__["a" /* default */]);

/***/ }),
/* 502 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





/**
 * The public API for prompting the user before navigating away
 * from a screen with a component.
 */

var Prompt = function (_React$Component) {
  _inherits(Prompt, _React$Component);

  function Prompt() {
    _classCallCheck(this, Prompt);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Prompt.prototype.enable = function enable(message) {
    if (this.unblock) this.unblock();

    this.unblock = this.context.router.history.block(message);
  };

  Prompt.prototype.disable = function disable() {
    if (this.unblock) {
      this.unblock();
      this.unblock = null;
    }
  };

  Prompt.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, "You should not use <Prompt> outside a <Router>");

    if (this.props.when) this.enable(this.props.message);
  };

  Prompt.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.when) {
      if (!this.props.when || this.props.message !== nextProps.message) this.enable(nextProps.message);
    } else {
      this.disable();
    }
  };

  Prompt.prototype.componentWillUnmount = function componentWillUnmount() {
    this.disable();
  };

  Prompt.prototype.render = function render() {
    return null;
  };

  return Prompt;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Prompt.propTypes = {
  when: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  message: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]).isRequired
};
Prompt.defaultProps = {
  when: true
};
Prompt.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      block: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Prompt);

/***/ }),
/* 503 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__ = __webpack_require__(504);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__["a" /* default */]);

/***/ }),
/* 504 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__generatePath__ = __webpack_require__(225);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








/**
 * The public API for updating the location programmatically
 * with a component.
 */

var Redirect = function (_React$Component) {
  _inherits(Redirect, _React$Component);

  function Redirect() {
    _classCallCheck(this, Redirect);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Redirect.prototype.isStatic = function isStatic() {
    return this.context.router && this.context.router.staticContext;
  };

  Redirect.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, "You should not use <Redirect> outside a <Router>");

    if (this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidMount = function componentDidMount() {
    if (!this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var prevTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(prevProps.to);
    var nextTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(this.props.to);

    if (Object(__WEBPACK_IMPORTED_MODULE_4_history__["f" /* locationsAreEqual */])(prevTo, nextTo)) {
      __WEBPACK_IMPORTED_MODULE_2_warning___default()(false, "You tried to redirect to the same route you're currently on: " + ("\"" + nextTo.pathname + nextTo.search + "\""));
      return;
    }

    this.perform();
  };

  Redirect.prototype.computeTo = function computeTo(_ref) {
    var computedMatch = _ref.computedMatch,
        to = _ref.to;

    if (computedMatch) {
      if (typeof to === "string") {
        return Object(__WEBPACK_IMPORTED_MODULE_5__generatePath__["a" /* default */])(to, computedMatch.params);
      } else {
        return _extends({}, to, {
          pathname: Object(__WEBPACK_IMPORTED_MODULE_5__generatePath__["a" /* default */])(to.pathname, computedMatch.params)
        });
      }
    }

    return to;
  };

  Redirect.prototype.perform = function perform() {
    var history = this.context.router.history;
    var push = this.props.push;

    var to = this.computeTo(this.props);

    if (push) {
      history.push(to);
    } else {
      history.replace(to);
    }
  };

  Redirect.prototype.render = function render() {
    return null;
  };

  return Redirect;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Redirect.propTypes = {
  computedMatch: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, // private, from <Switch>
  push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  from: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired
};
Redirect.defaultProps = {
  push: false
};
Redirect.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Redirect);

/***/ }),
/* 505 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__ = __webpack_require__(506);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__["a" /* default */]);

/***/ }),
/* 506 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Router__ = __webpack_require__(150);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === "/" ? path : "/" + path;
};

var addBasename = function addBasename(basename, location) {
  if (!basename) return location;

  return _extends({}, location, {
    pathname: addLeadingSlash(basename) + location.pathname
  });
};

var stripBasename = function stripBasename(basename, location) {
  if (!basename) return location;

  var base = addLeadingSlash(basename);

  if (location.pathname.indexOf(base) !== 0) return location;

  return _extends({}, location, {
    pathname: location.pathname.substr(base.length)
  });
};

var createURL = function createURL(location) {
  return typeof location === "string" ? location : Object(__WEBPACK_IMPORTED_MODULE_4_history__["e" /* createPath */])(location);
};

var staticHandler = function staticHandler(methodName) {
  return function () {
    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(false, "You cannot %s with <StaticRouter>", methodName);
  };
};

var noop = function noop() {};

/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */

var StaticRouter = function (_React$Component) {
  _inherits(StaticRouter, _React$Component);

  function StaticRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, StaticRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.createHref = function (path) {
      return addLeadingSlash(_this.props.basename + createURL(path));
    }, _this.handlePush = function (location) {
      var _this$props = _this.props,
          basename = _this$props.basename,
          context = _this$props.context;

      context.action = "PUSH";
      context.location = addBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(location));
      context.url = createURL(context.location);
    }, _this.handleReplace = function (location) {
      var _this$props2 = _this.props,
          basename = _this$props2.basename,
          context = _this$props2.context;

      context.action = "REPLACE";
      context.location = addBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(location));
      context.url = createURL(context.location);
    }, _this.handleListen = function () {
      return noop;
    }, _this.handleBlock = function () {
      return noop;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  StaticRouter.prototype.getChildContext = function getChildContext() {
    return {
      router: {
        staticContext: this.props.context
      }
    };
  };

  StaticRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<StaticRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { StaticRouter as Router }`.");
  };

  StaticRouter.prototype.render = function render() {
    var _props = this.props,
        basename = _props.basename,
        context = _props.context,
        location = _props.location,
        props = _objectWithoutProperties(_props, ["basename", "context", "location"]);

    var history = {
      createHref: this.createHref,
      action: "POP",
      location: stripBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(location)),
      push: this.handlePush,
      replace: this.handleReplace,
      go: staticHandler("go"),
      goBack: staticHandler("goBack"),
      goForward: staticHandler("goForward"),
      listen: this.handleListen,
      block: this.handleBlock
    };

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Router__["a" /* default */], _extends({}, props, { history: history }));
  };

  return StaticRouter;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

StaticRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  context: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object])
};
StaticRouter.defaultProps = {
  basename: "",
  location: "/"
};
StaticRouter.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (StaticRouter);

/***/ }),
/* 507 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__ = __webpack_require__(508);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__["a" /* default */]);

/***/ }),
/* 508 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(151);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for rendering the first <Route> that matches.
 */

var Switch = function (_React$Component) {
  _inherits(Switch, _React$Component);

  function Switch() {
    _classCallCheck(this, Switch);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Switch.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, "You should not use <Switch> outside a <Router>");
  };

  Switch.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(nextProps.location && !this.props.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(!nextProps.location && this.props.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
  };

  Switch.prototype.render = function render() {
    var route = this.context.router.route;
    var children = this.props.children;

    var location = this.props.location || route.location;

    var match = void 0,
        child = void 0;
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (element) {
      if (match == null && __WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(element)) {
        var _element$props = element.props,
            pathProp = _element$props.path,
            exact = _element$props.exact,
            strict = _element$props.strict,
            sensitive = _element$props.sensitive,
            from = _element$props.from;

        var path = pathProp || from;

        child = element;
        match = Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(location.pathname, { path: path, exact: exact, strict: strict, sensitive: sensitive }, route.match);
      }
    });

    return match ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(child, { location: location, computedMatch: match }) : null;
  };

  return Switch;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Switch.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    route: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
  }).isRequired
};
Switch.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};


/* harmony default export */ __webpack_exports__["a"] = (Switch);

/***/ }),
/* 509 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_generatePath__ = __webpack_require__(225);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_generatePath__["a" /* default */]);

/***/ }),
/* 510 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__ = __webpack_require__(151);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__["a" /* default */]);

/***/ }),
/* 511 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__ = __webpack_require__(512);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__["a" /* default */]);

/***/ }),
/* 512 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__ = __webpack_require__(513);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Route__ = __webpack_require__(223);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A public higher-order component to access the imperative API
 */
var withRouter = function withRouter(Component) {
  var C = function C(props) {
    var wrappedComponentRef = props.wrappedComponentRef,
        remainingProps = _objectWithoutProperties(props, ["wrappedComponentRef"]);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Route__["a" /* default */], {
      children: function children(routeComponentProps) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, _extends({}, remainingProps, routeComponentProps, {
          ref: wrappedComponentRef
        }));
      }
    });
  };

  C.displayName = "withRouter(" + (Component.displayName || Component.name) + ")";
  C.WrappedComponent = Component;
  C.propTypes = {
    wrappedComponentRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
  };

  return __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(C, Component);
};

/* harmony default export */ __webpack_exports__["a"] = (withRouter);

/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try { // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 514 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_saga__ = __webpack_require__(515);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers__ = __webpack_require__(522);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__analyticsMiddleware__ = __webpack_require__(535);
var configureStore=function configureStore(){var sagaMiddleware=Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga__["a" /* default */])();// eslint-disable-next-line
var composeEnhancers=window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__||__WEBPACK_IMPORTED_MODULE_0_redux__["d" /* compose */];var middleware=[sagaMiddleware,__WEBPACK_IMPORTED_MODULE_3__analyticsMiddleware__["a" /* analytics */]];var middlewares= true?__WEBPACK_IMPORTED_MODULE_0_redux__["a" /* applyMiddleware */].apply(undefined,middleware):composeEnhancers(applyMiddleware.apply(undefined,middleware));return Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_0_redux__["e" /* createStore */])(__WEBPACK_IMPORTED_MODULE_2__reducers__["a" /* default */],middlewares),{runSaga:sagaMiddleware.run});};/* harmony default export */ __webpack_exports__["a"] = (configureStore);

/***/ }),
/* 515 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_middleware__ = __webpack_require__(516);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_runSaga__ = __webpack_require__(227);
/* unused harmony reexport runSaga */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__internal_channel__ = __webpack_require__(80);
/* unused harmony reexport END */
/* unused harmony reexport eventChannel */
/* unused harmony reexport channel */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__internal_buffers__ = __webpack_require__(109);
/* unused harmony reexport buffers */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__internal_sagaHelpers__ = __webpack_require__(229);
/* unused harmony reexport takeEvery */
/* unused harmony reexport takeLatest */
/* unused harmony reexport throttle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__internal_utils__ = __webpack_require__(34);
/* unused harmony reexport delay */
/* unused harmony reexport CANCEL */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__internal_io__ = __webpack_require__(54);
/* unused harmony reexport detach */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__effects__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils__ = __webpack_require__(521);
/* unused harmony reexport effects */
/* unused harmony reexport utils */

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__internal_middleware__["a" /* default */]);













/***/ }),
/* 516 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = sagaMiddlewareFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__channel__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__runSaga__ = __webpack_require__(227);
function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






function sagaMiddlewareFactory() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _ref$context = _ref.context,
      context = _ref$context === undefined ? {} : _ref$context,
      options = _objectWithoutProperties(_ref, ['context']);

  var sagaMonitor = options.sagaMonitor,
      logger = options.logger,
      onError = options.onError;


  if (__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func(options)) {
    if (true) {
      throw new Error('Saga middleware no longer accept Generator functions. Use sagaMiddleware.run instead');
    } else {
      throw new Error('You passed a function to the Saga middleware. You are likely trying to start a        Saga by directly passing it to the middleware. This is no longer possible starting from 0.10.0.        To run a Saga, you must do it dynamically AFTER mounting the middleware into the store.\n        Example:\n          import createSagaMiddleware from \'redux-saga\'\n          ... other imports\n\n          const sagaMiddleware = createSagaMiddleware()\n          const store = createStore(reducer, applyMiddleware(sagaMiddleware))\n          sagaMiddleware.run(saga, ...args)\n      ');
    }
  }

  if (logger && !__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func(logger)) {
    throw new Error('`options.logger` passed to the Saga middleware is not a function!');
  }

  if (false) {
    throw new Error('`options.onerror` was removed. Use `options.onError` instead.');
  }

  if (onError && !__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func(onError)) {
    throw new Error('`options.onError` passed to the Saga middleware is not a function!');
  }

  if (options.emitter && !__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func(options.emitter)) {
    throw new Error('`options.emitter` passed to the Saga middleware is not a function!');
  }

  function sagaMiddleware(_ref2) {
    var getState = _ref2.getState,
        dispatch = _ref2.dispatch;

    var sagaEmitter = Object(__WEBPACK_IMPORTED_MODULE_1__channel__["b" /* emitter */])();
    sagaEmitter.emit = (options.emitter || __WEBPACK_IMPORTED_MODULE_0__utils__["l" /* ident */])(sagaEmitter.emit);

    sagaMiddleware.run = __WEBPACK_IMPORTED_MODULE_2__runSaga__["a" /* runSaga */].bind(null, {
      context: context,
      subscribe: sagaEmitter.subscribe,
      dispatch: dispatch,
      getState: getState,
      sagaMonitor: sagaMonitor,
      logger: logger,
      onError: onError
    });

    return function (next) {
      return function (action) {
        if (sagaMonitor && sagaMonitor.actionDispatched) {
          sagaMonitor.actionDispatched(action);
        }
        var result = next(action); // hit reducers
        sagaEmitter.emit(action);
        return result;
      };
    };
  }

  sagaMiddleware.run = function () {
    throw new Error('Before running a Saga, you must mount the Saga middleware on the Store using applyMiddleware');
  };

  sagaMiddleware.setContext = function (props) {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(props, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].object, Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* createSetContextWarning */])('sagaMiddleware', props));
    __WEBPACK_IMPORTED_MODULE_0__utils__["s" /* object */].assign(context, props);
  };

  return sagaMiddleware;
}

/***/ }),
/* 517 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = takeEvery;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fsmIterator__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__io__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__channel__ = __webpack_require__(80);




function takeEvery(patternOrChannel, worker) {
  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  var yTake = { done: false, value: Object(__WEBPACK_IMPORTED_MODULE_1__io__["g" /* take */])(patternOrChannel) };
  var yFork = function yFork(ac) {
    return { done: false, value: __WEBPACK_IMPORTED_MODULE_1__io__["e" /* fork */].apply(undefined, [worker].concat(args, [ac])) };
  };

  var action = void 0,
      setAction = function setAction(ac) {
    return action = ac;
  };

  return Object(__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["a" /* default */])({
    q1: function q1() {
      return ['q2', yTake, setAction];
    },
    q2: function q2() {
      return action === __WEBPACK_IMPORTED_MODULE_2__channel__["a" /* END */] ? [__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["b" /* qEnd */]] : ['q1', yFork(action)];
    }
  }, 'q1', 'takeEvery(' + Object(__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["c" /* safeName */])(patternOrChannel) + ', ' + worker.name + ')');
}

/***/ }),
/* 518 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = takeLatest;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fsmIterator__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__io__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__channel__ = __webpack_require__(80);




function takeLatest(patternOrChannel, worker) {
  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  var yTake = { done: false, value: Object(__WEBPACK_IMPORTED_MODULE_1__io__["g" /* take */])(patternOrChannel) };
  var yFork = function yFork(ac) {
    return { done: false, value: __WEBPACK_IMPORTED_MODULE_1__io__["e" /* fork */].apply(undefined, [worker].concat(args, [ac])) };
  };
  var yCancel = function yCancel(task) {
    return { done: false, value: Object(__WEBPACK_IMPORTED_MODULE_1__io__["d" /* cancel */])(task) };
  };

  var task = void 0,
      action = void 0;
  var setTask = function setTask(t) {
    return task = t;
  };
  var setAction = function setAction(ac) {
    return action = ac;
  };

  return Object(__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["a" /* default */])({
    q1: function q1() {
      return ['q2', yTake, setAction];
    },
    q2: function q2() {
      return action === __WEBPACK_IMPORTED_MODULE_2__channel__["a" /* END */] ? [__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["b" /* qEnd */]] : task ? ['q3', yCancel(task)] : ['q1', yFork(action), setTask];
    },
    q3: function q3() {
      return ['q1', yFork(action), setTask];
    }
  }, 'q1', 'takeLatest(' + Object(__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["c" /* safeName */])(patternOrChannel) + ', ' + worker.name + ')');
}

/***/ }),
/* 519 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = throttle;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fsmIterator__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__io__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__channel__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__buffers__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(34);






function throttle(delayLength, pattern, worker) {
  for (var _len = arguments.length, args = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
    args[_key - 3] = arguments[_key];
  }

  var action = void 0,
      channel = void 0;

  var yActionChannel = { done: false, value: Object(__WEBPACK_IMPORTED_MODULE_1__io__["a" /* actionChannel */])(pattern, __WEBPACK_IMPORTED_MODULE_3__buffers__["a" /* buffers */].sliding(1)) };
  var yTake = function yTake() {
    return { done: false, value: Object(__WEBPACK_IMPORTED_MODULE_1__io__["g" /* take */])(channel) };
  };
  var yFork = function yFork(ac) {
    return { done: false, value: __WEBPACK_IMPORTED_MODULE_1__io__["e" /* fork */].apply(undefined, [worker].concat(args, [ac])) };
  };
  var yDelay = { done: false, value: Object(__WEBPACK_IMPORTED_MODULE_1__io__["c" /* call */])(__WEBPACK_IMPORTED_MODULE_4__utils__["j" /* delay */], delayLength) };

  var setAction = function setAction(ac) {
    return action = ac;
  };
  var setChannel = function setChannel(ch) {
    return channel = ch;
  };

  return Object(__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["a" /* default */])({
    q1: function q1() {
      return ['q2', yActionChannel, setChannel];
    },
    q2: function q2() {
      return ['q3', yTake(), setAction];
    },
    q3: function q3() {
      return action === __WEBPACK_IMPORTED_MODULE_2__channel__["a" /* END */] ? [__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["b" /* qEnd */]] : ['q4', yFork(action)];
    },
    q4: function q4() {
      return ['q2', yDelay];
    }
  }, 'q1', 'throttle(' + Object(__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["c" /* safeName */])(pattern) + ', ' + worker.name + ')');
}

/***/ }),
/* 520 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = takeEvery;
/* harmony export (immutable) */ __webpack_exports__["b"] = takeLatest;
/* unused harmony export throttle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__io__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sagaHelpers__ = __webpack_require__(229);



function takeEvery(patternOrChannel, worker) {
  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  return __WEBPACK_IMPORTED_MODULE_0__io__["e" /* fork */].apply(undefined, [__WEBPACK_IMPORTED_MODULE_1__sagaHelpers__["a" /* takeEveryHelper */], patternOrChannel, worker].concat(args));
}

function takeLatest(patternOrChannel, worker) {
  for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
    args[_key2 - 2] = arguments[_key2];
  }

  return __WEBPACK_IMPORTED_MODULE_0__io__["e" /* fork */].apply(undefined, [__WEBPACK_IMPORTED_MODULE_1__sagaHelpers__["b" /* takeLatestHelper */], patternOrChannel, worker].concat(args));
}

function throttle(ms, pattern, worker) {
  for (var _len3 = arguments.length, args = Array(_len3 > 3 ? _len3 - 3 : 0), _key3 = 3; _key3 < _len3; _key3++) {
    args[_key3 - 3] = arguments[_key3];
  }

  return __WEBPACK_IMPORTED_MODULE_0__io__["e" /* fork */].apply(undefined, [__WEBPACK_IMPORTED_MODULE_1__sagaHelpers__["c" /* throttleHelper */], ms, pattern, worker].concat(args));
}

/***/ }),
/* 521 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_utils__ = __webpack_require__(34);
/* unused harmony reexport TASK */
/* unused harmony reexport SAGA_ACTION */
/* unused harmony reexport noop */
/* unused harmony reexport is */
/* unused harmony reexport deferred */
/* unused harmony reexport arrayOfDeffered */
/* unused harmony reexport createMockTask */
/* unused harmony reexport cloneableGenerator */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_io__ = __webpack_require__(54);
/* unused harmony reexport asEffect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__internal_proc__ = __webpack_require__(228);
/* unused harmony reexport CHANNEL_END */




/***/ }),
/* 522 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__products__ = __webpack_require__(523);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__designers__ = __webpack_require__(524);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cart__ = __webpack_require__(525);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__viewstate__ = __webpack_require__(526);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__page__ = __webpack_require__(527);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__globalSearch__ = __webpack_require__(528);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__quickSearch__ = __webpack_require__(529);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__brands__ = __webpack_require__(530);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__instagram__ = __webpack_require__(531);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__deliveryMethods__ = __webpack_require__(532);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__categories__ = __webpack_require__(533);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__campaign__ = __webpack_require__(534);
var rootReducer=Object(__WEBPACK_IMPORTED_MODULE_0_redux__["c" /* combineReducers */])({products:__WEBPACK_IMPORTED_MODULE_1__products__["a" /* products */],designers:__WEBPACK_IMPORTED_MODULE_2__designers__["a" /* designers */],cart:__WEBPACK_IMPORTED_MODULE_3__cart__["a" /* cart */],page:__WEBPACK_IMPORTED_MODULE_5__page__["a" /* default */],campaign:__WEBPACK_IMPORTED_MODULE_12__campaign__["a" /* campaign */],categories:__WEBPACK_IMPORTED_MODULE_11__categories__["a" /* default */],viewstate:__WEBPACK_IMPORTED_MODULE_4__viewstate__["a" /* viewstate */],globalSearch:__WEBPACK_IMPORTED_MODULE_6__globalSearch__["a" /* default */],quickSearch:__WEBPACK_IMPORTED_MODULE_7__quickSearch__["a" /* default */],brands:__WEBPACK_IMPORTED_MODULE_8__brands__["a" /* brands */],instagram:__WEBPACK_IMPORTED_MODULE_9__instagram__["a" /* instagram */],deliveryMethods:__WEBPACK_IMPORTED_MODULE_10__deliveryMethods__["a" /* deliveryMethods */]});/* harmony default export */ __webpack_exports__["a"] = (rootReducer);

/***/ }),
/* 523 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return products; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_actionTypes__ = __webpack_require__(25);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var initialState=Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])();var transformSearchData=function transformSearchData(){var payload=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var productHits=payload.getIn(['products','hits'],[]);if(productHits.length===0){return Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])();}var filteredProductHits=productHits.filter(function(product){return product.get('item')&&product.get('relevance');});return filteredProductHits.map(function(product){return product.get('item').merge({relevance:product.get('relevance'),allVariantsHaveSameRelevance:product.get('allVariantsHaveSameRelevance')});});};var formatData=function formatData(arrayData){var key=arguments.length>1&&arguments[1]!==undefined?arguments[1]:'id';return arrayData.toMap().filter(function(item){return item.get('url')&&item.get('id');})// filter out products that do not have a URL, should be done in backend, but can't wait for them to fix it...
.mapEntries(function(entry){var newEntry=entry;newEntry[0]=entry[1].get(key);return newEntry;});};function data(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var _ref=arguments[1];var type=_ref.type,payload=_ref.payload;switch(type){case __WEBPACK_IMPORTED_MODULE_2__actions_actionTypes__["O" /* FETCH_PRODUCT_SUCCESS */]:return state.mergeDeep(payload);case __WEBPACK_IMPORTED_MODULE_2__actions_actionTypes__["M" /* FETCH_PRODUCTS_SUCCESS */]:return state.mergeDeep(payload);case __WEBPACK_IMPORTED_MODULE_2__actions_actionTypes__["o" /* FETCH_CAMPAIGN_PRODUCTS_SUCCESS */]:return state.mergeDeep(payload);case __WEBPACK_IMPORTED_MODULE_2__actions_actionTypes__["D" /* FETCH_GLOBAL_SEARCH_SUCCESS */]:return state.mergeDeep(formatData(transformSearchData(payload)));case __WEBPACK_IMPORTED_MODULE_2__actions_actionTypes__["R" /* FETCH_QUICK_SEARCH_SUCCESS */]:return state.mergeDeep(formatData(transformSearchData(payload)));default:return state;}}function request(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var _ref2=arguments[1];var type=_ref2.type,error=_ref2.error,meta=_ref2.meta;switch(type){case __WEBPACK_IMPORTED_MODULE_2__actions_actionTypes__["m" /* FETCH_CAMPAIGN_PRODUCTS */]:case __WEBPACK_IMPORTED_MODULE_2__actions_actionTypes__["H" /* FETCH_PRODUCT */]:case __WEBPACK_IMPORTED_MODULE_2__actions_actionTypes__["I" /* FETCH_PRODUCTS */]:{var next=_defineProperty({},meta.url,{status:'LOADING'});return state.merge(next);}case __WEBPACK_IMPORTED_MODULE_2__actions_actionTypes__["o" /* FETCH_CAMPAIGN_PRODUCTS_SUCCESS */]:case __WEBPACK_IMPORTED_MODULE_2__actions_actionTypes__["O" /* FETCH_PRODUCT_SUCCESS */]:case __WEBPACK_IMPORTED_MODULE_2__actions_actionTypes__["M" /* FETCH_PRODUCTS_SUCCESS */]:{var _next2=_defineProperty({},meta.url,{status:'SUCCESS',statusCode:200});return state.merge(_next2);}case __WEBPACK_IMPORTED_MODULE_2__actions_actionTypes__["n" /* FETCH_CAMPAIGN_PRODUCTS_FAIL */]:case __WEBPACK_IMPORTED_MODULE_2__actions_actionTypes__["N" /* FETCH_PRODUCT_FAIL */]:case __WEBPACK_IMPORTED_MODULE_2__actions_actionTypes__["K" /* FETCH_PRODUCTS_FAIL */]:{var _next4=_defineProperty({},meta.url,{status:'ERROR',statusCode:error.response.status});return state.merge(_next4);}default:return state;}}var products=Object(__WEBPACK_IMPORTED_MODULE_1_redux__["c" /* combineReducers */])({data:data,request:request});

/***/ }),
/* 524 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = designers;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions_actionTypes__ = __webpack_require__(25);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var initialState=Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])();var formatData=function formatData(arrayData){var key=arguments.length>1&&arguments[1]!==undefined?arguments[1]:'id';return arrayData.reduce(function(memory,item){return memory.merge(_defineProperty({},item.get(key),item));},Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])());};function designers(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var _ref=arguments[1];var type=_ref.type,payload=_ref.payload;switch(type){case __WEBPACK_IMPORTED_MODULE_1__actions_actionTypes__["A" /* FETCH_DESIGNERS_DATA_SUCCESS */]:return state.mergeDeep(formatData(payload,'url'));case __WEBPACK_IMPORTED_MODULE_1__actions_actionTypes__["z" /* FETCH_DESIGNERS_DATA_FAIL */]:return state;default:return state;}}

/***/ }),
/* 525 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = cart;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions_actionTypes__ = __webpack_require__(25);
var initialState=Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])();function cart(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var _ref=arguments[1];var type=_ref.type,payload=_ref.payload;switch(type){case __WEBPACK_IMPORTED_MODULE_1__actions_actionTypes__["r" /* FETCH_CART_SUCCESS */]:case __WEBPACK_IMPORTED_MODULE_1__actions_actionTypes__["c" /* ADD_PRODUCT_TO_CART_SUCCESS */]:case __WEBPACK_IMPORTED_MODULE_1__actions_actionTypes__["W" /* REMOVE_PRODUCT_FROM_CART_SUCCESS */]:case __WEBPACK_IMPORTED_MODULE_1__actions_actionTypes__["f" /* DELETE_CART_ROW_SUCCESS */]:return payload;case __WEBPACK_IMPORTED_MODULE_1__actions_actionTypes__["q" /* FETCH_CART_FAIL */]:return initialState;case __WEBPACK_IMPORTED_MODULE_1__actions_actionTypes__["b" /* ADD_PRODUCT_TO_CART_FAIL */]:case __WEBPACK_IMPORTED_MODULE_1__actions_actionTypes__["V" /* REMOVE_PRODUCT_FROM_CART_FAIL */]:case __WEBPACK_IMPORTED_MODULE_1__actions_actionTypes__["e" /* DELETE_CART_ROW_FAIL */]:return state;default:return state;}}

/***/ }),
/* 526 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = viewstate;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions_actionTypes__ = __webpack_require__(25);
var initialState=Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])();function viewstate(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var _ref=arguments[1];var type=_ref.type,payload=_ref.payload;switch(type){case __WEBPACK_IMPORTED_MODULE_1__actions_actionTypes__["Z" /* SET_VIEWSTATE */]:{var keyPath=typeof payload.key==="string"?[payload.key]:payload.key;return state.setIn(keyPath,payload.value);}case __WEBPACK_IMPORTED_MODULE_1__actions_actionTypes__["Y" /* REMOVE_VIEWSTATE */]:{var _keyPath=typeof payload.key==="string"?[payload.key]:payload.key;return state.deleteIn(_keyPath);}default:return state;}}

/***/ }),
/* 527 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_actionTypes__ = __webpack_require__(25);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var data=function data(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])();var _ref=arguments[1];var type=_ref.type,payload=_ref.payload,meta=_ref.meta;switch(type){case __WEBPACK_IMPORTED_MODULE_2__actions_actionTypes__["i" /* FETCH_ARTICLE_PAGE_VIEW_SUCCESS */]:return state.merge(_defineProperty({},meta.urlPath,payload));default:return state;}};var request=function request(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])();var _ref2=arguments[1];var type=_ref2.type,meta=_ref2.meta,error=_ref2.error;switch(type){case __WEBPACK_IMPORTED_MODULE_2__actions_actionTypes__["g" /* FETCH_ARTICLE_PAGE_VIEW */]:{var next=_defineProperty({},meta.urlPath,{status:'LOADING'});return state.merge(next);}case __WEBPACK_IMPORTED_MODULE_2__actions_actionTypes__["i" /* FETCH_ARTICLE_PAGE_VIEW_SUCCESS */]:{var _next2=_defineProperty({},meta.urlPath,{status:'SUCCESS',statusCode:200});return state.merge(_next2);}case __WEBPACK_IMPORTED_MODULE_2__actions_actionTypes__["h" /* FETCH_ARTICLE_PAGE_VIEW_FAIL */]:{var _next4=_defineProperty({},meta.urlPath,{status:'ERROR',statusCode:error.response.status});return state.merge(_next4);}default:return state;}};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_redux__["c" /* combineReducers */])({data:data,request:request}));

/***/ }),
/* 528 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_actionTypes__ = __webpack_require__(25);
// const transformProductData = payload => {
//   const productData = payload.getIn(['products', 'hits'], []);
//   const filteredProductData = productData.filter(product => product.get('item') && product.get('relevance'));
//   const transformedProductData = filteredProductData.map(product => ({
//       id: product.getIn(['item', 'id']),
//       relevance: product.get('relevance')
//     }));
//   if (productData.length === 0) {
//     return payload;
//   }
//   return payload.setIn(['products', 'hits'], transformedProductData);
// };
var transformProductData=function transformProductData(payload){var productData=payload.getIn(['products','hits'],[]);var filteredProductData=productData.filter(function(product){return product.get('item')&&product.get('relevance');});var transformedProductData=filteredProductData.map(function(product){var object=Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])({id:product.getIn(['item','id']),relevance:product.get('relevance'),allVariantsHaveSameRelevance:product.get('allVariantsHaveSameRelevance')});return object;});if(productData.length===0){return payload;}return payload.setIn(['products','hits'],transformedProductData);};var initialState=Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])();var results=function results(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var _ref=arguments[1];var type=_ref.type,payload=_ref.payload;switch(type){case __WEBPACK_IMPORTED_MODULE_2__actions_actionTypes__["B" /* FETCH_GLOBAL_SEARCH */]:{return state;}case __WEBPACK_IMPORTED_MODULE_2__actions_actionTypes__["D" /* FETCH_GLOBAL_SEARCH_SUCCESS */]:{return transformProductData(payload);}case __WEBPACK_IMPORTED_MODULE_2__actions_actionTypes__["C" /* FETCH_GLOBAL_SEARCH_FAIL */]:{return state;}case __WEBPACK_IMPORTED_MODULE_2__actions_actionTypes__["T" /* REMOVE_GLOBAL_SEARCH */]:{return initialState;}default:return state;}};var status=function status(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:'';var _ref2=arguments[1];var type=_ref2.type;switch(type){case __WEBPACK_IMPORTED_MODULE_2__actions_actionTypes__["B" /* FETCH_GLOBAL_SEARCH */]:{return'LOADING';}case __WEBPACK_IMPORTED_MODULE_2__actions_actionTypes__["D" /* FETCH_GLOBAL_SEARCH_SUCCESS */]:{return'SUCCESS';}case __WEBPACK_IMPORTED_MODULE_2__actions_actionTypes__["C" /* FETCH_GLOBAL_SEARCH_FAIL */]:{return'FAIL';}default:return state;}};var query=function query(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:'';var _ref3=arguments[1];var type=_ref3.type,payload=_ref3.payload;switch(type){case __WEBPACK_IMPORTED_MODULE_2__actions_actionTypes__["B" /* FETCH_GLOBAL_SEARCH */]:{return payload;}case __WEBPACK_IMPORTED_MODULE_2__actions_actionTypes__["T" /* REMOVE_GLOBAL_SEARCH */]:{return null;}default:return state;}};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_redux__["c" /* combineReducers */])({results:results,status:status,query:query}));

/***/ }),
/* 529 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_actionTypes__ = __webpack_require__(25);
var transformProductData=function transformProductData(payload){var productData=payload.getIn(['products','hits'],[]);var filteredProductData=productData.filter(function(product){return product.get('item')&&product.get('relevance');});var transformedProductData=filteredProductData.map(function(product){var object=Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])({id:product.getIn(['item','id']),relevance:product.get('relevance')});return object;});if(productData.length===0){return payload;}return payload.setIn(['products','hits'],transformedProductData);};var initialState=Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])();var results=function results(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var _ref=arguments[1];var type=_ref.type,payload=_ref.payload;switch(type){case __WEBPACK_IMPORTED_MODULE_2__actions_actionTypes__["P" /* FETCH_QUICK_SEARCH */]:{return state;}case __WEBPACK_IMPORTED_MODULE_2__actions_actionTypes__["R" /* FETCH_QUICK_SEARCH_SUCCESS */]:{return transformProductData(payload);}case __WEBPACK_IMPORTED_MODULE_2__actions_actionTypes__["Q" /* FETCH_QUICK_SEARCH_FAIL */]:{return state;}case __WEBPACK_IMPORTED_MODULE_2__actions_actionTypes__["X" /* REMOVE_QUICK_SEARCH */]:{return initialState;}default:return state;}};var status=function status(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:'';var _ref2=arguments[1];var type=_ref2.type;switch(type){case __WEBPACK_IMPORTED_MODULE_2__actions_actionTypes__["P" /* FETCH_QUICK_SEARCH */]:{return'LOADING';}case __WEBPACK_IMPORTED_MODULE_2__actions_actionTypes__["R" /* FETCH_QUICK_SEARCH_SUCCESS */]:{return'SUCCESS';}case __WEBPACK_IMPORTED_MODULE_2__actions_actionTypes__["Q" /* FETCH_QUICK_SEARCH_FAIL */]:{return'FAIL';}case __WEBPACK_IMPORTED_MODULE_2__actions_actionTypes__["X" /* REMOVE_QUICK_SEARCH */]:{return"";}default:return state;}};var query=function query(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:'';var _ref3=arguments[1];var type=_ref3.type,payload=_ref3.payload;switch(type){case __WEBPACK_IMPORTED_MODULE_2__actions_actionTypes__["P" /* FETCH_QUICK_SEARCH */]:{return payload;}case __WEBPACK_IMPORTED_MODULE_2__actions_actionTypes__["X" /* REMOVE_QUICK_SEARCH */]:{return null;}default:return state;}};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_redux__["c" /* combineReducers */])({results:results,status:status,query:query}));

/***/ }),
/* 530 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = brands;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions_actionTypes__ = __webpack_require__(25);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var initialState=Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])();var formatData=function formatData(arrayData){var key=arguments.length>1&&arguments[1]!==undefined?arguments[1]:'id';return arrayData.reduce(function(memory,item){return memory.merge(_defineProperty({},item.get(key),item));},Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])());};function brands(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var _ref=arguments[1];var type=_ref.type,payload=_ref.payload;switch(type){case __WEBPACK_IMPORTED_MODULE_1__actions_actionTypes__["l" /* FETCH_BRAND_DATA_SUCCESS */]:return state.mergeDeep(formatData(payload,'url'));case __WEBPACK_IMPORTED_MODULE_1__actions_actionTypes__["k" /* FETCH_BRAND_DATA_FAIL */]:return state;default:return state;}}

/***/ }),
/* 531 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = instagram;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions_actionTypes__ = __webpack_require__(25);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var initialState=Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])();var formatData=function formatData(arrayData){var key=arguments.length>1&&arguments[1]!==undefined?arguments[1]:'id';return arrayData.reduce(function(memory,item){return memory.merge(_defineProperty({},item.get(key),item));},Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])());};function instagram(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var _ref=arguments[1];var type=_ref.type,payload=_ref.payload;switch(type){case __WEBPACK_IMPORTED_MODULE_1__actions_actionTypes__["G" /* FETCH_INSTAGRAM_POSTS_SUCCESS */]:return formatData(payload);case __WEBPACK_IMPORTED_MODULE_1__actions_actionTypes__["F" /* FETCH_INSTAGRAM_POSTS_FAIL */]:return state;default:return state;}}

/***/ }),
/* 532 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = deliveryMethods;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions_actionTypes__ = __webpack_require__(25);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var initialState=Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])();var formatData=function formatData(arrayData){var key=arguments.length>1&&arguments[1]!==undefined?arguments[1]:'id';return arrayData.reduce(function(memory,item){return memory.merge(_defineProperty({},item.get(key),item));},Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])());};function deliveryMethods(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var _ref=arguments[1];var type=_ref.type,payload=_ref.payload;switch(type){case __WEBPACK_IMPORTED_MODULE_1__actions_actionTypes__["x" /* FETCH_DELIVERY_METHODS_SUCCESS */]:return formatData(payload);case __WEBPACK_IMPORTED_MODULE_1__actions_actionTypes__["w" /* FETCH_DELIVERY_METHODS_FAIL */]:return state;default:return state;}}

/***/ }),
/* 533 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_actionTypes__ = __webpack_require__(25);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var initialState=Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])();var items=function items(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var _ref=arguments[1];var type=_ref.type,payload=_ref.payload;switch(type){case __WEBPACK_IMPORTED_MODULE_2__actions_actionTypes__["u" /* FETCH_CATEGORY_META_DATA_SUCCESS */]:{return state.mergeDeep(payload);}default:return state;}};function request(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var _ref2=arguments[1];var type=_ref2.type,error=_ref2.error,meta=_ref2.meta;switch(type){case __WEBPACK_IMPORTED_MODULE_2__actions_actionTypes__["s" /* FETCH_CATEGORY_META_DATA */]:{var next=_defineProperty({},meta.url,{status:'LOADING'});return state.merge(next);}case __WEBPACK_IMPORTED_MODULE_2__actions_actionTypes__["u" /* FETCH_CATEGORY_META_DATA_SUCCESS */]:{var _next2=_defineProperty({},meta.url,{status:'SUCCESS',statusCode:200});return state.merge(_next2);}case __WEBPACK_IMPORTED_MODULE_2__actions_actionTypes__["t" /* FETCH_CATEGORY_META_DATA_FAIL */]:{var _next4=_defineProperty({},meta.url,{status:'ERROR',statusCode:error.response.status});return state.merge(_next4);}default:return state;}}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_redux__["c" /* combineReducers */])({items:items,request:request}));

/***/ }),
/* 534 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = campaign;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions_actionTypes__ = __webpack_require__(25);
var initialState=Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])();var mapToArrayOfIds=function mapToArrayOfIds(arr){return arr.reduce(function(memo,item){// TODO: change to id
var id=item.get('id');if(!id){return memo;}return memo.concat(id);},[]);};function campaign(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var _ref=arguments[1];var type=_ref.type,payload=_ref.payload,meta=_ref.meta;switch(type){case __WEBPACK_IMPORTED_MODULE_1__actions_actionTypes__["o" /* FETCH_CAMPAIGN_PRODUCTS_SUCCESS */]:return state.set(meta.id,mapToArrayOfIds(payload));default:return state;}}

/***/ }),
/* 535 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return analytics; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__ = __webpack_require__(25);
var analytics=function analytics(){return function(next){return function(action){var payload=action.payload,type=action.type,cartRow=action.cartRow;window.dataLayer=window.dataLayer||[];switch(type){case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["c" /* ADD_PRODUCT_TO_CART_SUCCESS */]:var productData=payload.getIn(['cart',0,'product']);window.dataLayer.push({event:'addToCart',ecommerce:{currencyCode:'SEK',add:{products:[{id:productData.get('id'),name:productData.get('name'),price:productData.get('price'),brand:productData.getIn(['brand','name']),category:productData.get('category'),quantity:1}]}}});break;case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["W" /* REMOVE_PRODUCT_FROM_CART_SUCCESS */]:case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["f" /* DELETE_CART_ROW_SUCCESS */]:var product=cartRow.get('product');window.dataLayer.push({event:'removeFromCart',ecommerce:{remove:{products:[{name:product.get('name'),id:product.get('id'),price:product.get('price'),brand:product.getIn(['brand','name']),category:product.get('category'),quantity:type===__WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["f" /* DELETE_CART_ROW_SUCCESS */]?cartRow.get('quantity'):1}]}}});break;default:}return next(action);};};};

/***/ }),
/* 536 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions_actionCreators__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants_endpoints__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_connect__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Header_Header__ = __webpack_require__(537);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Footer__ = __webpack_require__(564);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_CartWrapper__ = __webpack_require__(565);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__pages_StartPage__ = __webpack_require__(588);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__pages_ArticlePage__ = __webpack_require__(639);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__pages_CategoryLink__ = __webpack_require__(649);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__pages_CategoryPage__ = __webpack_require__(652);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__pages_ProductPage__ = __webpack_require__(661);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__pages_CheckoutPage__ = __webpack_require__(691);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__pages_SearchResultPage__ = __webpack_require__(698);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__pages_ErrorPage__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__pages_BrandListPage__ = __webpack_require__(701);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__pages_BrandPage__ = __webpack_require__(703);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__pages_CampaignListPage__ = __webpack_require__(705);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__pages_CampaignPage__ = __webpack_require__(706);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__pages_ParentCategoryPage__ = __webpack_require__(707);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__pages_OrderConfirmationPage__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__pages_StoreItemListPage__ = __webpack_require__(708);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__pages_StoreItemPage__ = __webpack_require__(709);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__pages_ProductListPage__ = __webpack_require__(710);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__pages_NewsletterPage__ = __webpack_require__(711);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__util_analyticEvents__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__constants_pageTypes__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__history__ = __webpack_require__(87);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Routes=function(_Component){_inherits(Routes,_Component);function Routes(){_classCallCheck(this,Routes);return _possibleConstructorReturn(this,(Routes.__proto__||Object.getPrototypeOf(Routes)).apply(this,arguments));}_createClass(Routes,[{key:'componentDidMount',value:function componentDidMount(){// PAGE VIEW EVENT TRIGGER
Object(__WEBPACK_IMPORTED_MODULE_28__util_analyticEvents__["d" /* analyticsPageViewEvent */])();this.props.fetchCart({endpointUrl:__WEBPACK_IMPORTED_MODULE_5__constants_endpoints__["d" /* CART_API_BASE_URL */]+'/get',method:'GET'});if(document.getElementById('react_root').dataset.litiumPreview){__WEBPACK_IMPORTED_MODULE_30__history__["a" /* default */].push(document.getElementById('react_root').dataset.litiumPreview);}}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(nextProps.location.pathname!==this.props.location.pathname){this.props.fetchCart({endpointUrl:__WEBPACK_IMPORTED_MODULE_5__constants_endpoints__["d" /* CART_API_BASE_URL */]+'/get',method:'GET'});// PAGE VIEW EVENT TRIGGER
Object(__WEBPACK_IMPORTED_MODULE_28__util_analyticEvents__["d" /* analyticsPageViewEvent */])();}}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){if(prevProps.location.pathname!==this.props.location.pathname){// reset viewstates for overlays on route change
this.props.removeViewstate('mobileMenuActive');this.props.removeViewstate('activeMenuItem');this.props.removeViewstate('globalSearchActive');// this.props.removeGlobalSearch();
if(!this.navigatingBetweenProductVariants(prevProps.location.pathname,this.props.location.pathname)){// scroll page to top on route change (but not on URL replace)
window.scrollTo(0,0);}}}},{key:'getBaseProduct',value:function getBaseProduct(url){// method to return the first part of a product url
var splitUrl=url.split('/');var lastPartOfUrl=splitUrl.pop();var splitLastPartOfUrl=lastPartOfUrl.split('-');return{firstPart:splitUrl.join('/'),lastPart:splitLastPartOfUrl[0]};}},{key:'navigatingBetweenProductVariants',value:function navigatingBetweenProductVariants(prevUrl,nextUrl){var prevUrlObject=this.getBaseProduct(prevUrl);var nextUrlObject=this.getBaseProduct(nextUrl);return prevUrlObject.firstPart===nextUrlObject.firstPart&&prevUrlObject.lastPart===nextUrlObject.lastPart;}},{key:'render',value:function render(){var CategoryLinks=this.props.sitemap.get('children',Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])()).filter(function(item){return item.get('pageType')==='CategoryLink';});// Dynamically create routes to all category link pages
var categoryLinkRoutes=CategoryLinks.map(function(item){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{exact:true,key:item.get('id'),path:item.get('url'),render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__pages_CategoryLink__["a" /* default */],Object.assign({item:item},props));}});}).toArray();var mainCategoryRoutes=CategoryLinks.map(function(item){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{exact:true,key:item.get('id'),path:item.get('url')+'/:categoryId',render:function render(props){if(item.getIn(['children',0,'children']).size===0){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__pages_CategoryPage__["a" /* default */],Object.assign({item:item.get('children',Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["List"])()).find(function(child){return child.get('url')===item.get('url')+'/'+props.match.params.categoryId;})},props));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__pages_ParentCategoryPage__["a" /* default */],Object.assign({item:item.get('children',Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["List"])()).find(function(child){return child.get('url')===item.get('url')+'/'+props.match.params.categoryId;})},props));}});}).toArray();var subCategoryRoutes=CategoryLinks.map(function(item){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{exact:true,key:item.get('id'),path:item.get('url')+'/:categoryId/:subCategoryId',render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__pages_CategoryPage__["a" /* default */],Object.assign({item:item.get('children',Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["List"])()).find(function(child){return child.get('url')===item.get('url')+'/'+props.match.params.categoryId;}).get('children',Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["List"])()).find(function(child){return child.get('url')===item.get('url')+'/'+props.match.params.categoryId+'/'+props.match.params.subCategoryId;})},props));}});}).toArray();var productRoutes=CategoryLinks.map(function(item){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{exact:true,key:item.get('id'),path:item.get('url')+'/:categoryId/:subCategoryId/:productId',render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__pages_ProductPage__["a" /* default */],props);}});}).toArray();var shallowProductRoutes=CategoryLinks.filter(function(mainCategory){return mainCategory.get('children').reduce(function(memory,item){return memory+item.get('children').size;},0)===0;}).map(function(item){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{exact:true,key:item.get('id'),path:item.get('url')+'/:subCategoryId/:productId',render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__pages_ProductPage__["a" /* default */],props);}});}).toArray();// Checkout Page Route
var checkoutRoute=this.props.sitemap.get('children',Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])()).filter(function(item){return item.get('pageType')===__WEBPACK_IMPORTED_MODULE_29__constants_pageTypes__["c" /* CHECKOUT_PAGE_TYPE */];}).map(function(item){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{key:item.get('id'),exact:true,path:item.get('url'),render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__pages_CheckoutPage__["a" /* default */],props);}});}).toArray();// Campaign List Page Route
var campaignListRoute=this.props.sitemap.get('children',Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])()).filter(function(item){return item.get('pageType')===__WEBPACK_IMPORTED_MODULE_29__constants_pageTypes__["a" /* CAMPAIGN_LIST_PAGE_TYPE */];}).map(function(item){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{key:item.get('id'),exact:true,path:item.get('url'),render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__pages_CampaignListPage__["a" /* default */],props);}});}).toArray();// Campaign Page in root Route
var campaignRootRoute=this.props.sitemap.get('children',Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])()).filter(function(item){return item.get('pageType')===__WEBPACK_IMPORTED_MODULE_29__constants_pageTypes__["b" /* CAMPAIGN_PAGE_TYPE */];}).map(function(item){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{key:item.get('id'),exact:true,path:item.get('url'),render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__pages_CampaignPage__["a" /* default */],props);}});}).toArray();// Campaign Page Route
var campaignRoute=this.props.sitemap.get('children',Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])()).filter(function(item){return item.get('pageType')===__WEBPACK_IMPORTED_MODULE_29__constants_pageTypes__["a" /* CAMPAIGN_LIST_PAGE_TYPE */];}).map(function(item){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{key:item.get('id'),exact:true,path:item.get('url')+'/:brandPage',render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__pages_CampaignPage__["a" /* default */],props);}});}).toArray();// Campaign Page Route
var productListRoute=this.props.sitemap.get('children',Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])()).filter(function(item){return item.get('pageType')===__WEBPACK_IMPORTED_MODULE_29__constants_pageTypes__["e" /* PRODUCT_LIST_PAGE_TYPE */];}).map(function(item){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{key:item.get('id'),exact:true,path:item.get('url'),render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__pages_ProductListPage__["a" /* default */],props);}});}).toArray();// Newsletter Page Route
var newsletterRoute=this.props.sitemap.get('children',Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])()).filter(function(item){return item.get('pageType')===__WEBPACK_IMPORTED_MODULE_29__constants_pageTypes__["d" /* NEWSLETTER_PAGE_TYPE */];}).map(function(item){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{key:item.get('id'),exact:true,path:item.get('url'),render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__pages_NewsletterPage__["a" /* default */],props);}});}).toArray();return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Header_Header__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_CartWrapper__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["f" /* Switch */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{exact:true,path:'/',render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__pages_StartPage__["a" /* default */],props);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{exact:true,path:'/404',render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__pages_ErrorPage__["a" /* default */],Object.assign({title:'404'},props));}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{exact:true,path:'/error',render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__pages_ErrorPage__["a" /* default */],Object.assign({title:'Error'},props));}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{exact:true,path:'/varumarken',render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__pages_BrandListPage__["a" /* default */],Object.assign({type:'brands'},props));}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{exact:true,path:'/varumarken/:brandPage',render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__pages_BrandPage__["a" /* default */],Object.assign({type:'brand'},props));}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{exact:true,path:'/formgivare',render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__pages_BrandListPage__["a" /* default */],Object.assign({type:'designers'},props));}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{exact:true,path:'/formgivare/:id',render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__pages_BrandPage__["a" /* default */],Object.assign({type:'designer'},props));}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:'/sok/:searchQuery',render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__pages_SearchResultPage__["a" /* default */],props);}}),shallowProductRoutes,categoryLinkRoutes,mainCategoryRoutes,subCategoryRoutes,productRoutes,checkoutRoute,campaignListRoute,campaignRootRoute,campaignRoute,productListRoute,newsletterRoute,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{exact:true,path:'/butiksexemplar',render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__pages_StoreItemListPage__["a" /* default */],props);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{exact:true,path:'/butiksexemplar/:productUrl',render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__pages_StoreItemPage__["a" /* default */],props);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{exact:true,path:'/tack',render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__pages_OrderConfirmationPage__["c" /* default */],Object.assign({title:'Tack'},props));}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:'/:articleUrl',render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__pages_ArticlePage__["a" /* default */],props);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Redirect */],{to:'/404'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_Footer__["a" /* default */],null));}}]);return Routes;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Routes.defaultProps={sitemap:Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])()};Routes.propTypes={removeViewstate:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,removeGlobalSearch:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,fetchCart:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,sitemap:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"]),location:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,history:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6__store_connect__["a" /* default */])(Routes,{removeViewstate:__WEBPACK_IMPORTED_MODULE_4__actions_actionCreators__["V" /* removeViewstate */],removeGlobalSearch:__WEBPACK_IMPORTED_MODULE_4__actions_actionCreators__["T" /* removeGlobalSearch */],fetchCart:__WEBPACK_IMPORTED_MODULE_4__actions_actionCreators__["p" /* fetchCart */]},function(){return{sitemap:Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["fromJS"])(window.sitemap)};}));

/***/ }),
/* 537 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_immutable__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_connect__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions_actionCreators__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_helpers_variables__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_Container__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__MobileMainMenu__ = __webpack_require__(543);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Overlay__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__styles_helpers_mixins__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__MenuCart__ = __webpack_require__(544);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__SearchResults__ = __webpack_require__(555);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__SearchInput__ = __webpack_require__(559);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__MainMenu__ = __webpack_require__(560);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  ',';\n  > img {\n    display: block;\n    width: 200px;\n    margin: 0 auto;\n  }\n'],['\n  ',';\n  > img {\n    display: block;\n    width: 200px;\n    margin: 0 auto;\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  position: sticky;\n  top: 0;\n  z-index: 150;\n  ',';\n  @media screen and (min-width: ','px) {\n    margin: 0 0 35px;\n  }\n  ',';\n'],['\n  position: sticky;\n  top: 0;\n  z-index: 150;\n  ',';\n  @media screen and (min-width: ','px) {\n    margin: 0 0 35px;\n  }\n  ',';\n']),_templateObject3=_taggedTemplateLiteral(['\n      margin: 0 !important;\n    '],['\n      margin: 0 !important;\n    ']),_templateObject4=_taggedTemplateLiteral(['\n  position: relative;\n  padding: 10px 0;\n  background-color: ',';\n  z-index: 1;\n  @media screen and (min-width: ','px) {\n    padding: 20px 0;\n  }\n'],['\n  position: relative;\n  padding: 10px 0;\n  background-color: ',';\n  z-index: 1;\n  @media screen and (min-width: ','px) {\n    padding: 20px 0;\n  }\n']),_templateObject5=_taggedTemplateLiteral(['\n  display: flex;\n  align-items: center;\n  margin: 0 0 10px;\n  @media screen and (min-width: ','px) {\n    margin: 0;\n  }\n  ',';\n'],['\n  display: flex;\n  align-items: center;\n  margin: 0 0 10px;\n  @media screen and (min-width: ','px) {\n    margin: 0;\n  }\n  ',';\n']),_templateObject6=_taggedTemplateLiteral(['\n  flex: 0 0 25%;\n  max-width: 25%;\n  padding: 0 20px 0 0;\n  @media screen and (min-width: ','px) {\n    display: none;\n  }\n'],['\n  flex: 0 0 25%;\n  max-width: 25%;\n  padding: 0 20px 0 0;\n  @media screen and (min-width: ','px) {\n    display: none;\n  }\n']),_templateObject7=_taggedTemplateLiteral(['\n  display: block;\n  position: relative;\n  height: 17.5px;\n  width: 17.5px;\n  padding: 0;\n  border: none;\n  outline: none;\n  background-color: transparent;\n  color: ',';\n  cursor: pointer;\n'],['\n  display: block;\n  position: relative;\n  height: 17.5px;\n  width: 17.5px;\n  padding: 0;\n  border: none;\n  outline: none;\n  background-color: transparent;\n  color: ',';\n  cursor: pointer;\n']),_templateObject8=_taggedTemplateLiteral(['\n  position: absolute;\n  top: 50%;\n  left: 0;\n  height: 1px;\n  width: 100%;\n  background-color: currentColor;\n  transition: background-color 0s linear 0.125s;\n  &:before,\n  &:after {\n    content: \'\';\n    position: absolute;\n    left: 0;\n    height: 1px;\n    width: 100%;\n    background-color: currentColor;\n    transition: top 0.125s ease 0.125s, transform 0.125s ease;\n  }\n  &:before {\n    top: -6px;\n  }\n  &:after {\n    top: 6px;\n  }\n  ',';\n'],['\n  position: absolute;\n  top: 50%;\n  left: 0;\n  height: 1px;\n  width: 100%;\n  background-color: currentColor;\n  transition: background-color 0s linear 0.125s;\n  &:before,\n  &:after {\n    content: \'\';\n    position: absolute;\n    left: 0;\n    height: 1px;\n    width: 100%;\n    background-color: currentColor;\n    transition: top 0.125s ease 0.125s, transform 0.125s ease;\n  }\n  &:before {\n    top: -6px;\n  }\n  &:after {\n    top: 6px;\n  }\n  ',';\n']),_templateObject9=_taggedTemplateLiteral(['\n      background-color: transparent;\n      &:before,\n      &:after {\n        top: 0;\n        transition: top 0.125s ease, transform 0.125s ease 0.125s;\n      }\n      &:before {\n        transform: rotate(45deg);\n      }\n      &:after {\n        transform: rotate(-45deg);\n      }\n    '],['\n      background-color: transparent;\n      &:before,\n      &:after {\n        top: 0;\n        transition: top 0.125s ease, transform 0.125s ease 0.125s;\n      }\n      &:before {\n        transform: rotate(45deg);\n      }\n      &:after {\n        transform: rotate(-45deg);\n      }\n    ']),_templateObject10=_taggedTemplateLiteral(['\n  flex: 0 0 50%;\n  max-width: 50%;\n  @media screen and (min-width: ','px) {\n    flex: 0 0 25%;\n    max-width: 25%;\n    padding: 0 10px 0 0;\n  }\n  @media screen and (min-width: ','px) {\n    padding: 0 20px 0 0;\n  }\n  ',';\n'],['\n  flex: 0 0 50%;\n  max-width: 50%;\n  @media screen and (min-width: ','px) {\n    flex: 0 0 25%;\n    max-width: 25%;\n    padding: 0 10px 0 0;\n  }\n  @media screen and (min-width: ','px) {\n    padding: 0 20px 0 0;\n  }\n  ',';\n']),_templateObject11=_taggedTemplateLiteral(['\n      flex: 0 0 50% !important;\n      max-width: 50% !important;\n      padding: 0 !important;\n    '],['\n      flex: 0 0 50% !important;\n      max-width: 50% !important;\n      padding: 0 !important;\n    ']),_templateObject12=_taggedTemplateLiteral(['\n  display: block;\n  max-width: 125px;\n  margin: 0 auto;\n  ',';\n  @media screen and (min-width: ','px) {\n    max-width: 162.5px;\n  }\n  @media screen and (min-width: ','px) {\n    max-width: 200px;\n    margin: 0;\n    ',';\n  }\n  > img {\n    display: block;\n    width: 100%;\n    transition: opacity 0.25s ease-out;\n    &:hover {\n      opacity: 0.875;\n    }\n    &:active {\n      opacity: 0.75;\n    }\n  }\n'],['\n  display: block;\n  max-width: 125px;\n  margin: 0 auto;\n  ',';\n  @media screen and (min-width: ','px) {\n    max-width: 162.5px;\n  }\n  @media screen and (min-width: ','px) {\n    max-width: 200px;\n    margin: 0;\n    ',';\n  }\n  > img {\n    display: block;\n    width: 100%;\n    transition: opacity 0.25s ease-out;\n    &:hover {\n      opacity: 0.875;\n    }\n    &:active {\n      opacity: 0.75;\n    }\n  }\n']),_templateObject13=_taggedTemplateLiteral(['\n      margin: 0 0 0 auto;\n    '],['\n      margin: 0 0 0 auto;\n    ']),_templateObject14=_taggedTemplateLiteral(['\n        margin: 0 auto;\n      '],['\n        margin: 0 auto;\n      ']),_templateObject15=_taggedTemplateLiteral(['\n  flex: 0 0 50%;\n  display: none;\n  position: relative;\n  max-width: 50%;\n  padding: 0 20px;\n  @media screen and (min-width: ','px) {\n    display: block;\n  }\n  @media screen and (min-width: ','px) {\n    padding: 0;\n  }\n'],['\n  flex: 0 0 50%;\n  display: none;\n  position: relative;\n  max-width: 50%;\n  padding: 0 20px;\n  @media screen and (min-width: ','px) {\n    display: block;\n  }\n  @media screen and (min-width: ','px) {\n    padding: 0;\n  }\n']),_templateObject16=_taggedTemplateLiteral(['\n  flex: 0 0 25%;\n  display: flex;\n  justify-content: flex-end;\n  position: relative;\n  max-width: 25%;\n  padding: 0 0 0 20px;\n'],['\n  flex: 0 0 25%;\n  display: flex;\n  justify-content: flex-end;\n  position: relative;\n  max-width: 25%;\n  padding: 0 0 0 20px;\n']),_templateObject17=_taggedTemplateLiteral(['\n  position: relative;\n  @media screen and (min-width: ','px) {\n    display: none;\n  }\n'],['\n  position: relative;\n  @media screen and (min-width: ','px) {\n    display: none;\n  }\n']),_templateObject18=_taggedTemplateLiteral(['\n  display: none;\n  position: absolute;\n  top: 100%;\n  left: 0;\n  width: 100%;\n  background-color: ',';\n  transform: translateY(-100%);\n  transition: transform 0.25s ease-out;\n  @media screen and (min-width: ','px) {\n    display: block;\n  }\n  ',';\n  > div {\n    opacity: 0;\n    transition: opacity 0.125s ease-out;\n    ',';\n  }\n'],['\n  display: none;\n  position: absolute;\n  top: 100%;\n  left: 0;\n  width: 100%;\n  background-color: ',';\n  transform: translateY(-100%);\n  transition: transform 0.25s ease-out;\n  @media screen and (min-width: ','px) {\n    display: block;\n  }\n  ',';\n  > div {\n    opacity: 0;\n    transition: opacity 0.125s ease-out;\n    ',';\n  }\n']),_templateObject19=_taggedTemplateLiteral(['\n      transform: translateY(0);\n    '],['\n      transform: translateY(0);\n    ']),_templateObject20=_taggedTemplateLiteral(['\n        opacity: 1;\n        transition: opacity 0.125s ease-out 0.125s;\n      '],['\n        opacity: 1;\n        transition: opacity 0.125s ease-out 0.125s;\n      ']),_templateObject21=_taggedTemplateLiteral(['\n  flex: 0 0 50%;\n  display: flex;\n  max-width: 50%;\n  padding: 0 20px 0 0;\n  @media screen and (min-width: ','px) {\n    flex: 0 0 25%;\n    max-width: 25%;\n  }\n'],['\n  flex: 0 0 50%;\n  display: flex;\n  max-width: 50%;\n  padding: 0 20px 0 0;\n  @media screen and (min-width: ','px) {\n    flex: 0 0 25%;\n    max-width: 25%;\n  }\n']),_templateObject22=_taggedTemplateLiteral(['\n  color: ',';\n  font-size: 10px;\n  font-weight: 600;\n  text-transform: uppercase;\n  text-decoration: none;\n  letter-spacing: 0.125em;\n  line-height: 1.25;\n  transition: opacity 0.25s ease-out;\n  @media screen and (min-width: ','px) {\n    font-size: 12px;\n  }\n  &:hover {\n    opacity: 0.875;\n  }\n  &:active {\n    opacity: 0.75;\n  }\n'],['\n  color: ',';\n  font-size: 10px;\n  font-weight: 600;\n  text-transform: uppercase;\n  text-decoration: none;\n  letter-spacing: 0.125em;\n  line-height: 1.25;\n  transition: opacity 0.25s ease-out;\n  @media screen and (min-width: ','px) {\n    font-size: 12px;\n  }\n  &:hover {\n    opacity: 0.875;\n  }\n  &:active {\n    opacity: 0.75;\n  }\n']),_templateObject23=_taggedTemplateLiteral(['\n  display: flex;\n  align-items: center;\n  position: relative;\n  height: 25px;\n  background-color: #779182;\n  z-index: 149;\n  ',';\n  @media screen and (min-width: ','px) {\n    height: 35px;\n  }\n  ',';\n'],['\n  display: flex;\n  align-items: center;\n  position: relative;\n  height: 25px;\n  background-color: #779182;\n  z-index: 149;\n  ',';\n  @media screen and (min-width: ','px) {\n    height: 35px;\n  }\n  ',';\n']),_templateObject24=_taggedTemplateLiteral(['\n      background-color: #ced5d1;\n      > div {\n        > ul {\n          color: ',';\n          > li {\n            > svg {\n              > path {\n                fill: #779182;\n              }\n            }\n          }\n        }\n      }\n    '],['\n      background-color: #ced5d1;\n      > div {\n        > ul {\n          color: ',';\n          > li {\n            > svg {\n              > path {\n                fill: #779182;\n              }\n            }\n          }\n        }\n      }\n    ']),_templateObject25=_taggedTemplateLiteral(['\n  position: relative;\n  list-style: none;\n  height: ','px;\n  margin: 0;\n  padding: 0;\n  color: ',';\n  font-size: 10px;\n  line-height: 1.25;\n  @media screen and (min-width: ','px) {\n    display: flex;\n    justify-content: center;\n    height: auto;\n  }\n  @media screen and (min-width: ','px) {\n    font-size: 14px;\n  }\n'],['\n  position: relative;\n  list-style: none;\n  height: ','px;\n  margin: 0;\n  padding: 0;\n  color: ',';\n  font-size: 10px;\n  line-height: 1.25;\n  @media screen and (min-width: ','px) {\n    display: flex;\n    justify-content: center;\n    height: auto;\n  }\n  @media screen and (min-width: ','px) {\n    font-size: 14px;\n  }\n']),_templateObject26=_taggedTemplateLiteral(['\n  0% {\n    opacity: 0;\n  }\n  ','% {\n    opacity: 1;\n  }\n\n  ','% {\n    opacity: 1;\n  }\n  ','% {\n    opacity: 0;\n  }\n'],['\n  0% {\n    opacity: 0;\n  }\n  ','% {\n    opacity: 1;\n  }\n\n  ','% {\n    opacity: 1;\n  }\n  ','% {\n    opacity: 0;\n  }\n']),_templateObject27=_taggedTemplateLiteral(['\n  ','% {\n    opacity: 0;\n  }\n  ','% {\n    opacity: 1;\n  }\n\n  ','% {\n    opacity: 1;\n  }\n  100% {\n    opacity: 0;\n  }\n'],['\n  ','% {\n    opacity: 0;\n  }\n  ','% {\n    opacity: 1;\n  }\n\n  ','% {\n    opacity: 1;\n  }\n  100% {\n    opacity: 0;\n  }\n']),_templateObject28=_taggedTemplateLiteral(['\n  ','% {\n    opacity: 0;\n  }\n  ','% {\n    opacity: 1;\n  }\n\n  ','% {\n    opacity: 1;\n  }\n  ','% {\n    opacity: 0;\n  }\n'],['\n  ','% {\n    opacity: 0;\n  }\n  ','% {\n    opacity: 1;\n  }\n\n  ','% {\n    opacity: 1;\n  }\n  ','% {\n    opacity: 0;\n  }\n']),_templateObject29=_taggedTemplateLiteral(['\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  @media screen and (min-width: ','px) {\n    position: static;\n    justify-content: flex-start;\n    top: auto;\n    left: auto;\n    width: auto;\n    max-width: 100%;\n    margin: 0 20px 0 0;\n  }\n  @media screen and (min-width: ','px) {\n    margin: 0 40px 0 0;\n  }\n  @media screen and (min-width: ','px) {\n    margin: 0 80px 0 0;\n  }\n  ',';\n  ',';\n  ',';\n  &:last-child {\n    @media screen and (min-width: ','px) {\n      margin: 0;\n    }\n  }\n  > svg {\n    flex: 0 0 auto;\n    width: 10px;\n    margin: 0 5px 0 0;\n    @media screen and (min-width: ','px) {\n      margin: 1px 5px 0 0;\n    }\n  }\n  > span {\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    overflow: hidden;\n  }\n'],['\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  @media screen and (min-width: ','px) {\n    position: static;\n    justify-content: flex-start;\n    top: auto;\n    left: auto;\n    width: auto;\n    max-width: 100%;\n    margin: 0 20px 0 0;\n  }\n  @media screen and (min-width: ','px) {\n    margin: 0 40px 0 0;\n  }\n  @media screen and (min-width: ','px) {\n    margin: 0 80px 0 0;\n  }\n  ',';\n  ',';\n  ',';\n  &:last-child {\n    @media screen and (min-width: ','px) {\n      margin: 0;\n    }\n  }\n  > svg {\n    flex: 0 0 auto;\n    width: 10px;\n    margin: 0 5px 0 0;\n    @media screen and (min-width: ','px) {\n      margin: 1px 5px 0 0;\n    }\n  }\n  > span {\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    overflow: hidden;\n  }\n']),_templateObject30=_taggedTemplateLiteral(['\n      opacity: 0;\n      animation-delay: -0.25s;\n      animation-iteration-count: infinite;\n      @media screen and (min-width: ','px) {\n        opacity: 1;\n        animation-name: none !important;\n      }\n    '],['\n      opacity: 0;\n      animation-delay: -0.25s;\n      animation-iteration-count: infinite;\n      @media screen and (min-width: ','px) {\n        opacity: 1;\n        animation-name: none !important;\n      }\n    ']),_templateObject31=_taggedTemplateLiteral(['\n      animation-name: ',';\n      animation-duration: 20s;\n      @media screen and (min-width: ','px) {\n        max-width: calc((100% / 2) - ((20px * 1) / 2));\n      }\n      @media screen and (min-width: ','px) {\n        max-width: calc((100% / 2) - ((40px * 1) / 2));\n      }\n      @media screen and (min-width: ','px) {\n        max-width: calc((100% / 2) - ((80px * 1) / 2));\n      }\n      &:nth-child(2) {\n        animation-name: ',';\n      }\n    '],['\n      animation-name: ',';\n      animation-duration: 20s;\n      @media screen and (min-width: ','px) {\n        max-width: calc((100% / 2) - ((20px * 1) / 2));\n      }\n      @media screen and (min-width: ','px) {\n        max-width: calc((100% / 2) - ((40px * 1) / 2));\n      }\n      @media screen and (min-width: ','px) {\n        max-width: calc((100% / 2) - ((80px * 1) / 2));\n      }\n      &:nth-child(2) {\n        animation-name: ',';\n      }\n    ']),_templateObject32=_taggedTemplateLiteral(['\n      animation-name: ',';\n      animation-duration: 30s;\n      @media screen and (min-width: ','px) {\n        max-width: calc((100% / 3) - ((20px * 2) / 3));\n      }\n      @media screen and (min-width: ','px) {\n        max-width: calc((100% / 3) - ((40px * 2) / 3));\n      }\n      @media screen and (min-width: ','px) {\n        max-width: calc((100% / 3) - ((80px * 2) / 3));\n      }\n      &:nth-child(2) {\n        animation-name: ',';\n      }\n      &:nth-child(3) {\n        animation-name: ',';\n      }\n    '],['\n      animation-name: ',';\n      animation-duration: 30s;\n      @media screen and (min-width: ','px) {\n        max-width: calc((100% / 3) - ((20px * 2) / 3));\n      }\n      @media screen and (min-width: ','px) {\n        max-width: calc((100% / 3) - ((40px * 2) / 3));\n      }\n      @media screen and (min-width: ','px) {\n        max-width: calc((100% / 3) - ((80px * 2) / 3));\n      }\n      &:nth-child(2) {\n        animation-name: ',';\n      }\n      &:nth-child(3) {\n        animation-name: ',';\n      }\n    ']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Header=function(_Component){_inherits(Header,_Component);function Header(props){_classCallCheck(this,Header);var _this=_possibleConstructorReturn(this,(Header.__proto__||Object.getPrototypeOf(Header)).call(this,props));_this.state={scrolledToTop:true};_this.onScroll=_this.onScroll.bind(_this);_this.handleOverlayClick=_this.handleOverlayClick.bind(_this);return _this;}_createClass(Header,[{key:'componentDidMount',value:function componentDidMount(){window.addEventListener('scroll',this.onScroll);}},{key:'onScroll',value:function onScroll(){var oldScrolledToTopState=this.state.scrolledToTop;this.setState({scrolledToTop:window.pageYOffset<=25+35&&document.getElementsByTagName('body')[0].style.position!=='fixed'});if(oldScrolledToTopState!==this.state.scrolledToTop&&!this.state.scrolledToTop&&this.props.viewstate.get('activeMenuItem')){this.props.removeViewstate('activeMenuItem');}}},{key:'handleOverlayClick',value:function handleOverlayClick(){this.props.setViewstate('globalSearchActive',false);this.props.removeQuickSearch();}},{key:'render',value:function render(){var _this2=this;var _props=this.props,headerUspList=_props.headerUspList,headerUSPVariantSecondary=_props.headerUSPVariantSecondary,headerUSPShowIcons=_props.headerUSPShowIcons;var isCheckoutPage=this.props.location.pathname==='/kassa';var isOrderConfirmationPage=this.props.location.pathname==='/tack';var printableHeader=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PrintableHeader,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'/images/valamagasinet_logo_black.svg',alt:'V\xE5lamagasinet'}));if(isCheckoutPage||isOrderConfirmationPage){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,printableHeader,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Header123,{simple:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(HeaderMain,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__styles_Container__["a" /* Container */],{noPadding:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(HeaderMainContent,{simple:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(HeaderMainContentReturnToStoreLink,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ReturnToStoreLink,{to:'/'},'Forts\xE4tt handla')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(HeaderMainContentLogo,{simple:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(HeaderLogo,{to:'/',simple:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'/images/valamagasinet_logo_white.svg',alt:'V\xE5lamagasinet'}))))))));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,printableHeader,headerUspList&&headerUspList.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(HeaderUSP,{variant:headerUSPVariantSecondary&&'secondary'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__styles_Container__["a" /* Container */],{noPadding:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(HeaderUSPList,null,headerUspList.map(function(usp){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(HeaderUSPListItem,{numberOfUSPListItems:headerUspList.length},headerUSPShowIcons&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',{viewBox:'0 0 12 9',xmlns:'http://www.w3.org/2000/svg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M11.7212 0.278745C11.3499 -0.093032 10.747 -0.0927976 10.3752 0.278745L4.31744 6.33674L1.62503 3.64435C1.25325 3.27257 0.650609 3.27257 0.278832 3.64435C-0.0929441 4.01613 -0.0929441 4.61877 0.278832 4.99055L3.6442 8.35592C3.82998 8.54169 4.07357 8.63481 4.31719 8.63481C4.5608 8.63481 4.80463 8.54192 4.9904 8.35592L11.7212 1.62492C12.0929 1.2534 12.0929 0.650498 11.7212 0.278745Z',fill:'white'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,usp));})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Header123,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(HeaderMain,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__styles_Container__["a" /* Container */],{noPadding:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(HeaderMainContent,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(HeaderMainContentMobileMenuButton,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MobileMenuButton,{onClick:function onClick(){_this2.props.setViewstate('mobileMenuActive',!_this2.props.viewstate.get('mobileMenuActive'));_this2.props.removeViewstate('activeMenuItem');// this.props.removeQuickSearch();
_this2.props.removeViewstate('globalSearchActive');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MobileMenuButtonIcon,{active:this.props.viewstate.get('mobileMenuActive')}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(HeaderMainContentLogo,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(HeaderLogo,{to:'/',onClick:function onClick(){// this.props.removeQuickSearch();
_this2.props.removeViewstate('globalSearchActive');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'/images/valamagasinet_logo_white.svg',alt:'V\xE5lamagasinet'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(HeaderMainContentSearch,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__SearchInput__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(HeaderMainContentCart,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__MenuCart__["a" /* default */],null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(HeaderLowerContent,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__SearchInput__["a" /* default */],null)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(HeaderLower,{active:this.state.scrolledToTop},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__styles_Container__["a" /* Container */],{noPadding:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__MainMenu__["a" /* default */],null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__SearchResults__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__MobileMainMenu__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Overlay__["a" /* default */],{header:true,onClick:this.handleOverlayClick,active:this.props.viewstate.get('globalSearchActive')}));}}]);return Header;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var PrintableHeader=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].div(_templateObject,__WEBPACK_IMPORTED_MODULE_11__styles_helpers_mixins__["j" /* showOnPrint */]);var Header123=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].header(_templateObject2,__WEBPACK_IMPORTED_MODULE_11__styles_helpers_mixins__["f" /* hideOnPrint */],__WEBPACK_IMPORTED_MODULE_7__styles_helpers_variables__["b" /* breakpoint */].large,function(props){return props.simple&&Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["css"])(_templateObject3);});var HeaderMain=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].div(_templateObject4,__WEBPACK_IMPORTED_MODULE_7__styles_helpers_variables__["c" /* color */].black,__WEBPACK_IMPORTED_MODULE_7__styles_helpers_variables__["b" /* breakpoint */].large);var HeaderMainContent=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].div(_templateObject5,__WEBPACK_IMPORTED_MODULE_7__styles_helpers_variables__["b" /* breakpoint */].large,function(props){return props.simple&&Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["css"])(_templateObject3);});var HeaderMainContentMobileMenuButton=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].div(_templateObject6,__WEBPACK_IMPORTED_MODULE_7__styles_helpers_variables__["b" /* breakpoint */].large);var MobileMenuButton=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].button(_templateObject7,__WEBPACK_IMPORTED_MODULE_7__styles_helpers_variables__["c" /* color */].white);var MobileMenuButtonIcon=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].span(_templateObject8,function(props){return props.active&&Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["css"])(_templateObject9);});var HeaderMainContentLogo=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].div(_templateObject10,__WEBPACK_IMPORTED_MODULE_7__styles_helpers_variables__["b" /* breakpoint */].large,__WEBPACK_IMPORTED_MODULE_7__styles_helpers_variables__["b" /* breakpoint */].extraLarge,function(props){return props.simple&&Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["css"])(_templateObject11);});var HeaderLogo=Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* Link */])(_templateObject12,function(props){return props.simple&&Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["css"])(_templateObject13);},__WEBPACK_IMPORTED_MODULE_7__styles_helpers_variables__["b" /* breakpoint */].medium,__WEBPACK_IMPORTED_MODULE_7__styles_helpers_variables__["b" /* breakpoint */].large,function(props){return props.simple&&Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["css"])(_templateObject14);});var HeaderMainContentSearch=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].div(_templateObject15,__WEBPACK_IMPORTED_MODULE_7__styles_helpers_variables__["b" /* breakpoint */].large,__WEBPACK_IMPORTED_MODULE_7__styles_helpers_variables__["b" /* breakpoint */].extraLarge);var HeaderMainContentCart=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].div(_templateObject16);var HeaderLowerContent=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].div(_templateObject17,__WEBPACK_IMPORTED_MODULE_7__styles_helpers_variables__["b" /* breakpoint */].large);var HeaderLower=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].div(_templateObject18,__WEBPACK_IMPORTED_MODULE_7__styles_helpers_variables__["c" /* color */].black,__WEBPACK_IMPORTED_MODULE_7__styles_helpers_variables__["b" /* breakpoint */].large,function(props){return props.active&&Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["css"])(_templateObject19);},function(props){return props.active&&Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["css"])(_templateObject20);});var HeaderMainContentReturnToStoreLink=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].div(_templateObject21,__WEBPACK_IMPORTED_MODULE_7__styles_helpers_variables__["b" /* breakpoint */].large);var ReturnToStoreLink=Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* Link */])(_templateObject22,__WEBPACK_IMPORTED_MODULE_7__styles_helpers_variables__["c" /* color */].white,__WEBPACK_IMPORTED_MODULE_7__styles_helpers_variables__["b" /* breakpoint */].large);var HeaderUSP=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].div(_templateObject23,__WEBPACK_IMPORTED_MODULE_11__styles_helpers_mixins__["f" /* hideOnPrint */],__WEBPACK_IMPORTED_MODULE_7__styles_helpers_variables__["b" /* breakpoint */].large,function(props){return props.variant==='secondary'&&Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["css"])(_templateObject24,__WEBPACK_IMPORTED_MODULE_7__styles_helpers_variables__["c" /* color */].black);});var HeaderUSPList=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].ul(_templateObject25,10*1.25,__WEBPACK_IMPORTED_MODULE_7__styles_helpers_variables__["c" /* color */].white,__WEBPACK_IMPORTED_MODULE_7__styles_helpers_variables__["b" /* breakpoint */].medium,__WEBPACK_IMPORTED_MODULE_7__styles_helpers_variables__["b" /* breakpoint */].large);var twoUSPListItemsAnimation1=Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["keyframes"])(_templateObject26,100/(20/0.25),100/2-100/(20/0.25),100/2);var twoUSPListItemsAnimation2=Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["keyframes"])(_templateObject27,100/2,100/2+100/(20/0.25),100-100/(20/0.25));var threeUSPListItemsAnimation1=Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["keyframes"])(_templateObject26,100/(30/0.25),100/3-100/(30/0.25),100/3);var threeUSPListItemsAnimation2=Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["keyframes"])(_templateObject28,100/3,100/3+100/(30/0.25),100/3*2-100/(30/0.25),100/3*2);var threeUSPListItemsAnimation3=Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["keyframes"])(_templateObject27,100/3*2,100/3*2+100/(30/0.25),100-100/(30/0.25));var HeaderUSPListItem=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].li(_templateObject29,__WEBPACK_IMPORTED_MODULE_7__styles_helpers_variables__["b" /* breakpoint */].medium,__WEBPACK_IMPORTED_MODULE_7__styles_helpers_variables__["b" /* breakpoint */].extraMedium,__WEBPACK_IMPORTED_MODULE_7__styles_helpers_variables__["b" /* breakpoint */].extraLarge,function(props){return(props.numberOfUSPListItems===2||props.numberOfUSPListItems===3)&&Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["css"])(_templateObject30,__WEBPACK_IMPORTED_MODULE_7__styles_helpers_variables__["b" /* breakpoint */].medium);},function(props){return props.numberOfUSPListItems===2&&Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["css"])(_templateObject31,twoUSPListItemsAnimation1,__WEBPACK_IMPORTED_MODULE_7__styles_helpers_variables__["b" /* breakpoint */].medium,__WEBPACK_IMPORTED_MODULE_7__styles_helpers_variables__["b" /* breakpoint */].extraMedium,__WEBPACK_IMPORTED_MODULE_7__styles_helpers_variables__["b" /* breakpoint */].extraLarge,twoUSPListItemsAnimation2);},function(props){return props.numberOfUSPListItems===3&&Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["css"])(_templateObject32,threeUSPListItemsAnimation1,__WEBPACK_IMPORTED_MODULE_7__styles_helpers_variables__["b" /* breakpoint */].medium,__WEBPACK_IMPORTED_MODULE_7__styles_helpers_variables__["b" /* breakpoint */].extraMedium,__WEBPACK_IMPORTED_MODULE_7__styles_helpers_variables__["b" /* breakpoint */].extraLarge,threeUSPListItemsAnimation2,threeUSPListItemsAnimation3);},__WEBPACK_IMPORTED_MODULE_7__styles_helpers_variables__["b" /* breakpoint */].medium,__WEBPACK_IMPORTED_MODULE_7__styles_helpers_variables__["b" /* breakpoint */].large);Header.defaultProps={viewstate:Object(__WEBPACK_IMPORTED_MODULE_4_immutable__["Map"])(),headerUspList:[],headerUSPVariantSecondary:false,headerUSPShowIcons:true};Header.propTypes={viewstate:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_4_immutable__["Map"]),location:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,removeQuickSearch:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,setViewstate:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,removeViewstate:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,headerUspList:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.array,headerUSPVariantSecondary:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,headerUSPShowIcons:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5__store_connect__["a" /* default */])(Header,{setViewstate:__WEBPACK_IMPORTED_MODULE_6__actions_actionCreators__["W" /* setViewstate */],removeViewstate:__WEBPACK_IMPORTED_MODULE_6__actions_actionCreators__["V" /* removeViewstate */],removeQuickSearch:__WEBPACK_IMPORTED_MODULE_6__actions_actionCreators__["U" /* removeQuickSearch */]},function(store){return{viewstate:store.viewstate,headerUspList:(window.startup||{}).uspTexts,headerUSPVariantSecondary:(window.startup||{}).uspBarUseSecondaryColors,headerUSPShowIcons:!(window.startup||{}).uspBarHideIcons};}));

/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */



var hyphenate = __webpack_require__(539);

var msPattern = /^ms-/;

/**
 * Hyphenates a camelcased CSS property name, for example:
 *
 *   > hyphenateStyleName('backgroundColor')
 *   < "background-color"
 *   > hyphenateStyleName('MozTransition')
 *   < "-moz-transition"
 *   > hyphenateStyleName('msTransition')
 *   < "-ms-transition"
 *
 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
 * is converted to `-ms-`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenateStyleName(string) {
  return hyphenate(string).replace(msPattern, '-ms-');
}

module.exports = hyphenateStyleName;

/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var _uppercasePattern = /([A-Z])/g;

/**
 * Hyphenates a camelcased string, for example:
 *
 *   > hyphenate('backgroundColor')
 *   < "background-color"
 *
 * For CSS style names, use `hyphenateStyleName` instead which works properly
 * with all vendor prefixes, including `ms`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenate(string) {
  return string.replace(_uppercasePattern, '-$1').toLowerCase();
}

module.exports = hyphenate;

/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

/*
 *          __        ___
 *    _____/ /___  __/ (_)____
 *   / ___/ __/ / / / / / ___/
 *  (__  ) /_/ /_/ / / (__  )
 * /____/\__/\__, /_/_/____/
 *          /____/
 *
 * light - weight css preprocessor @licence MIT
 */
(function (factory) {/* eslint-disable */
	 true ? (module['exports'] = factory(null)) :
		typeof define === 'function' && define['amd'] ? define(factory(null)) :
			(window['stylis'] = factory(null))
}(/** @param {*=} options */function factory (options) {/* eslint-disable */

	'use strict'

	/**
	 * Notes
	 *
	 * The ['<method name>'] pattern is used to support closure compiler
	 * the jsdoc signatures are also used to the same effect
	 *
	 * ----
	 *
	 * int + int + int === n4 [faster]
	 *
	 * vs
	 *
	 * int === n1 && int === n2 && int === n3
	 *
	 * ----
	 *
	 * switch (int) { case ints...} [faster]
	 *
	 * vs
	 *
	 * if (int == 1 && int === 2 ...)
	 *
	 * ----
	 *
	 * The (first*n1 + second*n2 + third*n3) format used in the property parser
	 * is a simple way to hash the sequence of characters
	 * taking into account the index they occur in
	 * since any number of 3 character sequences could produce duplicates.
	 *
	 * On the other hand sequences that are directly tied to the index of the character
	 * resolve a far more accurate measure, it's also faster
	 * to evaluate one condition in a switch statement
	 * than three in an if statement regardless of the added math.
	 *
	 * This allows the vendor prefixer to be both small and fast.
	 */

	var nullptn = /^\0+/g /* matches leading null characters */
	var formatptn = /[\0\r\f]/g /* matches new line, null and formfeed characters */
	var colonptn = /: */g /* splits animation rules */
	var cursorptn = /zoo|gra/ /* assert cursor varient */
	var transformptn = /([,: ])(transform)/g /* vendor prefix transform, older webkit */
	var animationptn = /,+\s*(?![^(]*[)])/g /* splits multiple shorthand notation animations */
	var propertiesptn = / +\s*(?![^(]*[)])/g /* animation properties */
	var elementptn = / *[\0] */g /* selector elements */
	var selectorptn = /,\r+?/g /* splits selectors */
	var andptn = /([\t\r\n ])*\f?&/g /* match & */
	var escapeptn = /:global\(((?:[^\(\)\[\]]*|\[.*\]|\([^\(\)]*\))*)\)/g /* matches :global(.*) */
	var invalidptn = /\W+/g /* removes invalid characters from keyframes */
	var keyframeptn = /@(k\w+)\s*(\S*)\s*/ /* matches @keyframes $1 */
	var plcholdrptn = /::(place)/g /* match ::placeholder varient */
	var readonlyptn = /:(read-only)/g /* match :read-only varient */
	var beforeptn = /\s+(?=[{\];=:>])/g /* matches \s before ] ; = : */
	var afterptn = /([[}=:>])\s+/g /* matches \s after characters [ } = : */
	var tailptn = /(\{[^{]+?);(?=\})/g /* matches tail semi-colons ;} */
	var whiteptn = /\s{2,}/g /* matches repeating whitespace */
	var pseudoptn = /([^\(])(:+) */g /* pseudo element */
	var writingptn = /[svh]\w+-[tblr]{2}/ /* match writing mode property values */
	var gradientptn = /([\w-]+t\()/g /* match *gradient property */
	var supportsptn = /\(\s*(.*)\s*\)/g /* match supports (groups) */
	var propertyptn = /([\s\S]*?);/g /* match properties leading semicolon */
	var selfptn = /-self|flex-/g /* match flex- and -self in align-self: flex-*; */
	var pseudofmt = /[^]*?(:[rp][el]a[\w-]+)[^]*/ /* extrats :readonly or :placholder from selector */
	var trimptn = /[ \t]+$/ /* match tail whitspace */
	var dimensionptn = /stretch|:\s*\w+\-(?:conte|avail)/ /* match max/min/fit-content, fill-available */
	var imgsrcptn = /([^-])(image-set\()/

	/* vendors */
	var webkit = '-webkit-'
	var moz = '-moz-'
	var ms = '-ms-'

	/* character codes */
	var SEMICOLON = 59 /* ; */
	var CLOSEBRACES = 125 /* } */
	var OPENBRACES = 123 /* { */
	var OPENPARENTHESES = 40 /* ( */
	var CLOSEPARENTHESES = 41 /* ) */
	var OPENBRACKET = 91 /* [ */
	var CLOSEBRACKET = 93 /* ] */
	var NEWLINE = 10 /* \n */
	var CARRIAGE = 13 /* \r */
	var TAB = 9 /* \t */
	var AT = 64 /* @ */
	var SPACE = 32 /*   */
	var AND = 38 /* & */
	var DASH = 45 /* - */
	var UNDERSCORE = 95 /* _ */
	var STAR = 42 /* * */
	var COMMA = 44 /* , */
	var COLON = 58 /* : */
	var SINGLEQUOTE = 39 /* ' */
	var DOUBLEQUOTE = 34 /* " */
	var FOWARDSLASH = 47 /* / */
	var GREATERTHAN = 62 /* > */
	var PLUS = 43 /* + */
	var TILDE = 126 /* ~ */
	var NULL = 0 /* \0 */
	var FORMFEED = 12 /* \f */
	var VERTICALTAB = 11 /* \v */

	/* special identifiers */
	var KEYFRAME = 107 /* k */
	var MEDIA = 109 /* m */
	var SUPPORTS = 115 /* s */
	var PLACEHOLDER = 112 /* p */
	var READONLY = 111 /* o */
	var IMPORT = 105 /* <at>i */
	var CHARSET = 99 /* <at>c */
	var DOCUMENT = 100 /* <at>d */
	var PAGE = 112 /* <at>p */

	var column = 1 /* current column */
	var line = 1 /* current line numebr */
	var pattern = 0 /* :pattern */

	var cascade = 1 /* #id h1 h2 vs h1#id h2#id  */
	var prefix = 1 /* vendor prefix */
	var escape = 1 /* escape :global() pattern */
	var compress = 0 /* compress output */
	var semicolon = 0 /* no/semicolon option */
	var preserve = 0 /* preserve empty selectors */

	/* empty reference */
	var array = []

	/* plugins */
	var plugins = []
	var plugged = 0
	var should = null

	/* plugin context */
	var POSTS = -2
	var PREPS = -1
	var UNKWN = 0
	var PROPS = 1
	var BLCKS = 2
	var ATRUL = 3

	/* plugin newline context */
	var unkwn = 0

	/* keyframe animation */
	var keyed = 1
	var key = ''

	/* selector namespace */
	var nscopealt = ''
	var nscope = ''

	/**
	 * Compile
	 *
	 * @param {Array<string>} parent
	 * @param {Array<string>} current
	 * @param {string} body
	 * @param {number} id
	 * @param {number} depth
	 * @return {string}
	 */
	function compile (parent, current, body, id, depth) {
		var bracket = 0 /* brackets [] */
		var comment = 0 /* comments /* // or /* */
		var parentheses = 0 /* functions () */
		var quote = 0 /* quotes '', "" */

		var first = 0 /* first character code */
		var second = 0 /* second character code */
		var code = 0 /* current character code */
		var tail = 0 /* previous character code */
		var trail = 0 /* character before previous code */
		var peak = 0 /* previous non-whitespace code */

		var counter = 0 /* count sequence termination */
		var context = 0 /* track current context */
		var atrule = 0 /* track @at-rule context */
		var pseudo = 0 /* track pseudo token index */
		var caret = 0 /* current character index */
		var format = 0 /* control character formating context */
		var insert = 0 /* auto semicolon insertion */
		var invert = 0 /* inverted selector pattern */
		var length = 0 /* generic length address */
		var eof = body.length /* end of file(length) */
		var eol = eof - 1 /* end of file(characters) */

		var char = '' /* current character */
		var chars = '' /* current buffer of characters */
		var child = '' /* next buffer of characters */
		var out = '' /* compiled body */
		var children = '' /* compiled children */
		var flat = '' /* compiled leafs */
		var selector /* generic selector address */
		var result /* generic address */

		// ...build body
		while (caret < eof) {
			code = body.charCodeAt(caret)

			// eof varient
			if (caret === eol) {
				// last character + noop context, add synthetic padding for noop context to terminate
				if (comment + quote + parentheses + bracket !== 0) {
					if (comment !== 0) {
						code = comment === FOWARDSLASH ? NEWLINE : FOWARDSLASH
					}

					quote = parentheses = bracket = 0
					eof++
					eol++
				}
			}

			if (comment + quote + parentheses + bracket === 0) {
				// eof varient
				if (caret === eol) {
					if (format > 0) {
						chars = chars.replace(formatptn, '')
					}

					if (chars.trim().length > 0) {
						switch (code) {
							case SPACE:
							case TAB:
							case SEMICOLON:
							case CARRIAGE:
							case NEWLINE: {
								break
							}
							default: {
								chars += body.charAt(caret)
							}
						}

						code = SEMICOLON
					}
				}

				// auto semicolon insertion
				if (insert === 1) {
					switch (code) {
						// false flags
						case OPENBRACES:
						case CLOSEBRACES:
						case SEMICOLON:
						case DOUBLEQUOTE:
						case SINGLEQUOTE:
						case OPENPARENTHESES:
						case CLOSEPARENTHESES:
						case COMMA: {
							insert = 0
						}
						// ignore
						case TAB:
						case CARRIAGE:
						case NEWLINE:
						case SPACE: {
							break
						}
						// valid
						default: {
							insert = 0
							length = caret
							first = code
							caret--
							code = SEMICOLON

							while (length < eof) {
								switch (body.charCodeAt(length++)) {
									case NEWLINE:
									case CARRIAGE:
									case SEMICOLON: {
										++caret
										code = first
										length = eof
										break
									}
									case COLON: {
										if (format > 0) {
											++caret
											code = first
										}
									}
									case OPENBRACES: {
										length = eof
									}
								}
							}
						}
					}
				}

				// token varient
				switch (code) {
					case OPENBRACES: {
						chars = chars.trim()
						first = chars.charCodeAt(0)
						counter = 1
						length = ++caret

						while (caret < eof) {
							switch (code = body.charCodeAt(caret)) {
								case OPENBRACES: {
									counter++
									break
								}
								case CLOSEBRACES: {
									counter--
									break
								}
								case FOWARDSLASH: {
									switch (second = body.charCodeAt(caret + 1)) {
										// /*, //
										case STAR:
										case FOWARDSLASH: {
											caret = delimited(second, caret, eol, body)
										}
									}
									break
								}
								// given "[" === 91 & "]" === 93 hence forth 91 + 1 + 1 === 93
								case OPENBRACKET: {
									code++
								}
								// given "(" === 40 & ")" === 41 hence forth 40 + 1 === 41
								case OPENPARENTHESES: {
									code++
								}
								// quote tail delimiter is identical to the head delimiter hence noop,
								// fallthrough clauses have been shifted to the correct tail delimiter
								case DOUBLEQUOTE:
								case SINGLEQUOTE: {
									while (caret++ < eol) {
										if (body.charCodeAt(caret) === code) {
											break
										}
									}
								}
							}

							if (counter === 0) {
								break
							}

							caret++
						}

						child = body.substring(length, caret)

						if (first === NULL) {
							first = (chars = chars.replace(nullptn, '').trim()).charCodeAt(0)
						}

						switch (first) {
							// @at-rule
							case AT: {
								if (format > 0) {
									chars = chars.replace(formatptn, '')
								}

								second = chars.charCodeAt(1)

								switch (second) {
									case DOCUMENT:
									case MEDIA:
									case SUPPORTS:
									case DASH: {
										selector = current
										break
									}
									default: {
										selector = array
									}
								}

								child = compile(current, selector, child, second, depth+1)
								length = child.length

								// preserve empty @at-rule
								if (preserve > 0 && length === 0) {
									length = chars.length
								}

								// execute plugins, @at-rule context
								if (plugged > 0) {
									selector = select(array, chars, invert)
									result = proxy(ATRUL, child, selector, current, line, column, length, second, depth, id)
									chars = selector.join('')

									if (result !== void 0) {
										if ((length = (child = result.trim()).length) === 0) {
											second = 0
											child = ''
										}
									}
								}

								if (length > 0) {
									switch (second) {
										case SUPPORTS: {
											chars = chars.replace(supportsptn, supports)
										}
										case DOCUMENT:
										case MEDIA:
										case DASH: {
											child = chars + '{' + child + '}'
											break
										}
										case KEYFRAME: {
											chars = chars.replace(keyframeptn, '$1 $2' + (keyed > 0 ? key : ''))
											child = chars + '{' + child + '}'

											if (prefix === 1 || (prefix === 2 && vendor('@'+child, 3))) {
												child = '@' + webkit + child + '@' + child
											} else {
												child = '@' + child
											}
											break
										}
										default: {
											child = chars + child

											if (id === PAGE) {
												child = (out += child, '')
											}
										}
									}
								} else {
									child = ''
								}

								break
							}
							// selector
							default: {
								child = compile(current, select(current, chars, invert), child, id, depth+1)
							}
						}

						children += child

						// reset
						context = 0
						insert = 0
						pseudo = 0
						format = 0
						invert = 0
						atrule = 0
						chars = ''
						child = ''
						code = body.charCodeAt(++caret)
						break
					}
					case CLOSEBRACES:
					case SEMICOLON: {
						chars = (format > 0 ? chars.replace(formatptn, '') : chars).trim()

						if ((length = chars.length) > 1) {
							// monkey-patch missing colon
							if (pseudo === 0) {
								first = chars.charCodeAt(0)

								// first character is a letter or dash, buffer has a space character
								if ((first === DASH || first > 96 && first < 123)) {
									length = (chars = chars.replace(' ', ':')).length
								}
							}

							// execute plugins, property context
							if (plugged > 0) {
								if ((result = proxy(PROPS, chars, current, parent, line, column, out.length, id, depth, id)) !== void 0) {
									if ((length = (chars = result.trim()).length) === 0) {
										chars = '\0\0'
									}
								}
							}

							first = chars.charCodeAt(0)
							second = chars.charCodeAt(1)

							switch (first) {
								case NULL: {
									break
								}
								case AT: {
									if (second === IMPORT || second === CHARSET) {
										flat += chars + body.charAt(caret)
										break
									}
								}
								default: {
									if (chars.charCodeAt(length-1) === COLON) {
										break
									}

									out += property(chars, first, second, chars.charCodeAt(2))
								}
							}
						}

						// reset
						context = 0
						insert = 0
						pseudo = 0
						format = 0
						invert = 0
						chars = ''
						code = body.charCodeAt(++caret)
						break
					}
				}
			}

			// parse characters
			switch (code) {
				case CARRIAGE:
				case NEWLINE: {
					// auto insert semicolon
					if (comment + quote + parentheses + bracket + semicolon === 0) {
						// valid non-whitespace characters that
						// may precede a newline
						switch (peak) {
							case CLOSEPARENTHESES:
							case SINGLEQUOTE:
							case DOUBLEQUOTE:
							case AT:
							case TILDE:
							case GREATERTHAN:
							case STAR:
							case PLUS:
							case FOWARDSLASH:
							case DASH:
							case COLON:
							case COMMA:
							case SEMICOLON:
							case OPENBRACES:
							case CLOSEBRACES: {
								break
							}
							default: {
								// current buffer has a colon
								if (pseudo > 0) {
									insert = 1
								}
							}
						}
					}

					// terminate line comment
					if (comment === FOWARDSLASH) {
						comment = 0
					} else if (cascade + context === 0 && id !== KEYFRAME && chars.length > 0) {
						format = 1
						chars += '\0'
					}

					// execute plugins, newline context
					if (plugged * unkwn > 0) {
						proxy(UNKWN, chars, current, parent, line, column, out.length, id, depth, id)
					}

					// next line, reset column position
					column = 1
					line++
					break
				}
				case SEMICOLON:
				case CLOSEBRACES: {
					if (comment + quote + parentheses + bracket === 0) {
						column++
						break
					}
				}
				default: {
					// increment column position
					column++

					// current character
					char = body.charAt(caret)

					// remove comments, escape functions, strings, attributes and prepare selectors
					switch (code) {
						case TAB:
						case SPACE: {
							if (quote + bracket + comment === 0) {
								switch (tail) {
									case COMMA:
									case COLON:
									case TAB:
									case SPACE: {
										char = ''
										break
									}
									default: {
										if (code !== SPACE) {
											char = ' '
										}
									}
								}
							}
							break
						}
						// escape breaking control characters
						case NULL: {
							char = '\\0'
							break
						}
						case FORMFEED: {
							char = '\\f'
							break
						}
						case VERTICALTAB: {
							char = '\\v'
							break
						}
						// &
						case AND: {
							// inverted selector pattern i.e html &
							if (quote + comment + bracket === 0 && cascade > 0) {
								invert = 1
								format = 1
								char = '\f' + char
							}
							break
						}
						// ::p<l>aceholder, l
						// :read-on<l>y, l
						case 108: {
							if (quote + comment + bracket + pattern === 0 && pseudo > 0) {
								switch (caret - pseudo) {
									// ::placeholder
									case 2: {
										if (tail === PLACEHOLDER && body.charCodeAt(caret-3) === COLON) {
											pattern = tail
										}
									}
									// :read-only
									case 8: {
										if (trail === READONLY) {
											pattern = trail
										}
									}
								}
							}
							break
						}
						// :<pattern>
						case COLON: {
							if (quote + comment + bracket === 0) {
								pseudo = caret
							}
							break
						}
						// selectors
						case COMMA: {
							if (comment + parentheses + quote + bracket === 0) {
								format = 1
								char += '\r'
							}
							break
						}
						// quotes
						case DOUBLEQUOTE:
						case SINGLEQUOTE: {
							if (comment === 0) {
								quote = quote === code ? 0 : (quote === 0 ? code : quote)
							}
							break
						}
						// attributes
						case OPENBRACKET: {
							if (quote + comment + parentheses === 0) {
								bracket++
							}
							break
						}
						case CLOSEBRACKET: {
							if (quote + comment + parentheses === 0) {
								bracket--
							}
							break
						}
						// functions
						case CLOSEPARENTHESES: {
							if (quote + comment + bracket === 0) {
								parentheses--
							}
							break
						}
						case OPENPARENTHESES: {
							if (quote + comment + bracket === 0) {
								if (context === 0) {
									switch (tail*2 + trail*3) {
										// :matches
										case 533: {
											break
										}
										// :global, :not, :nth-child etc...
										default: {
											counter = 0
											context = 1
										}
									}
								}

								parentheses++
							}
							break
						}
						case AT: {
							if (comment + parentheses + quote + bracket + pseudo + atrule === 0) {
								atrule = 1
							}
							break
						}
						// block/line comments
						case STAR:
						case FOWARDSLASH: {
							if (quote + bracket + parentheses > 0) {
								break
							}

							switch (comment) {
								// initialize line/block comment context
								case 0: {
									switch (code*2 + body.charCodeAt(caret+1)*3) {
										// //
										case 235: {
											comment = FOWARDSLASH
											break
										}
										// /*
										case 220: {
											length = caret
											comment = STAR
											break
										}
									}
									break
								}
								// end block comment context
								case STAR: {
									if (code === FOWARDSLASH && tail === STAR && length + 2 !== caret) {
										// /*<!> ... */, !
										if (body.charCodeAt(length+2) === 33) {
											out += body.substring(length, caret+1)
										}
										char = ''
										comment = 0
									}
								}
							}
						}
					}

					// ignore comment blocks
					if (comment === 0) {
						// aggressive isolation mode, divide each individual selector
						// including selectors in :not function but excluding selectors in :global function
						if (cascade + quote + bracket + atrule === 0 && id !== KEYFRAME && code !== SEMICOLON) {
							switch (code) {
								case COMMA:
								case TILDE:
								case GREATERTHAN:
								case PLUS:
								case CLOSEPARENTHESES:
								case OPENPARENTHESES: {
									if (context === 0) {
										// outside of an isolated context i.e nth-child(<...>)
										switch (tail) {
											case TAB:
											case SPACE:
											case NEWLINE:
											case CARRIAGE: {
												char = char + '\0'
												break
											}
											default: {
												char = '\0' + char + (code === COMMA ? '' : '\0')
											}
										}
										format = 1
									} else {
										// within an isolated context, sleep untill it's terminated
										switch (code) {
											case OPENPARENTHESES: {
												// :globa<l>(
												if (pseudo + 7 === caret && tail === 108) {
													pseudo = 0
												}
												context = ++counter
												break
											}
											case CLOSEPARENTHESES: {
												if ((context = --counter) === 0) {
													format = 1
													char += '\0'
												}
												break
											}
										}
									}
									break
								}
								case TAB:
								case SPACE: {
									switch (tail) {
										case NULL:
										case OPENBRACES:
										case CLOSEBRACES:
										case SEMICOLON:
										case COMMA:
										case FORMFEED:
										case TAB:
										case SPACE:
										case NEWLINE:
										case CARRIAGE: {
											break
										}
										default: {
											// ignore in isolated contexts
											if (context === 0) {
												format = 1
												char += '\0'
											}
										}
									}
								}
							}
						}

						// concat buffer of characters
						chars += char

						// previous non-whitespace character code
						if (code !== SPACE && code !== TAB) {
							peak = code
						}
					}
				}
			}

			// tail character codes
			trail = tail
			tail = code

			// visit every character
			caret++
		}

		length = out.length

		// preserve empty selector
 		if (preserve > 0) {
 			if (length === 0 && children.length === 0 && (current[0].length === 0) === false) {
 				if (id !== MEDIA || (current.length === 1 && (cascade > 0 ? nscopealt : nscope) === current[0])) {
					length = current.join(',').length + 2
 				}
 			}
		}

		if (length > 0) {
			// cascade isolation mode?
			selector = cascade === 0 && id !== KEYFRAME ? isolate(current) : current

			// execute plugins, block context
			if (plugged > 0) {
				result = proxy(BLCKS, out, selector, parent, line, column, length, id, depth, id)

				if (result !== void 0 && (out = result).length === 0) {
					return flat + out + children
				}
			}

			out = selector.join(',') + '{' + out + '}'

			if (prefix*pattern !== 0) {
				if (prefix === 2 && !vendor(out, 2))
					pattern = 0

				switch (pattern) {
					// ::read-only
					case READONLY: {
						out = out.replace(readonlyptn, ':'+moz+'$1')+out
						break
					}
					// ::placeholder
					case PLACEHOLDER: {
						out = (
							out.replace(plcholdrptn, '::' + webkit + 'input-$1') +
							out.replace(plcholdrptn, '::' + moz + '$1') +
							out.replace(plcholdrptn, ':' + ms + 'input-$1') + out
						)
						break
					}
				}

				pattern = 0
			}
		}

		return flat + out + children
	}

	/**
	 * Select
	 *
	 * @param {Array<string>} parent
	 * @param {string} current
	 * @param {number} invert
	 * @return {Array<string>}
	 */
	function select (parent, current, invert) {
		var selectors = current.trim().split(selectorptn)
		var out = selectors

		var length = selectors.length
		var l = parent.length

		switch (l) {
			// 0-1 parent selectors
			case 0:
			case 1: {
				for (var i = 0, selector = l === 0 ? '' : parent[0] + ' '; i < length; ++i) {
					out[i] = scope(selector, out[i], invert, l).trim()
				}
				break
			}
			// >2 parent selectors, nested
			default: {
				for (var i = 0, j = 0, out = []; i < length; ++i) {
					for (var k = 0; k < l; ++k) {
						out[j++] = scope(parent[k] + ' ', selectors[i], invert, l).trim()
					}
				}
			}
		}

		return out
	}

	/**
	 * Scope
	 *
	 * @param {string} parent
	 * @param {string} current
	 * @param {number} invert
	 * @param {number} level
	 * @return {string}
	 */
	function scope (parent, current, invert, level) {
		var selector = current
		var code = selector.charCodeAt(0)

		// trim leading whitespace
		if (code < 33) {
			code = (selector = selector.trim()).charCodeAt(0)
		}

		switch (code) {
			// &
			case AND: {
				switch (cascade + level) {
					case 0:
					case 1: {
						if (parent.trim().length === 0) {
							break
						}
					}
					default: {
						return selector.replace(andptn, '$1'+parent.trim())
					}
				}
				break
			}
			// :
			case COLON: {
				switch (selector.charCodeAt(1)) {
					// g in :global
					case 103: {
						if (escape > 0 && cascade > 0) {
							return selector.replace(escapeptn, '$1').replace(andptn, '$1'+nscope)
						}
						break
					}
					default: {
						// :hover
						return parent.trim() + selector.replace(andptn, '$1'+parent.trim())
					}
				}
			}
			default: {
				// html &
				if (invert*cascade > 0 && selector.indexOf('\f') > 0) {
					return selector.replace(andptn, (parent.charCodeAt(0) === COLON ? '' : '$1')+parent.trim())
				}
			}
		}

		return parent + selector
	}

	/**
	 * Property
	 *
	 * @param {string} input
	 * @param {number} first
	 * @param {number} second
	 * @param {number} third
	 * @return {string}
	 */
	function property (input, first, second, third) {
		var index = 0
		var out = input + ';'
		var hash = (first*2) + (second*3) + (third*4)
		var cache

		// animation: a, n, i characters
		if (hash === 944) {
			return animation(out)
		} else if (prefix === 0 || (prefix === 2 && !vendor(out, 1))) {
			return out
		}

		// vendor prefix
		switch (hash) {
			// text-decoration/text-size-adjust/text-shadow/text-align/text-transform: t, e, x
			case 1015: {
				// text-shadow/text-align/text-transform, a
				return out.charCodeAt(10) === 97 ? webkit + out + out : out
			}
			// filter/fill f, i, l
			case 951: {
				// filter, t
				return out.charCodeAt(3) === 116 ? webkit + out + out : out
			}
			// color/column, c, o, l
			case 963: {
				// column, n
				return out.charCodeAt(5) === 110 ? webkit + out + out : out
			}
			// box-decoration-break, b, o, x
			case 1009: {
				if (out.charCodeAt(4) !== 100) {
					break
				}
			}
			// mask, m, a, s
			// clip-path, c, l, i
			case 969:
			case 942: {
				return webkit + out + out
			}
			// appearance: a, p, p
			case 978: {
				return webkit + out + moz + out + out
			}
			// hyphens: h, y, p
			// user-select: u, s, e
			case 1019:
			case 983: {
				return webkit + out + moz + out + ms + out + out
			}
			// background/backface-visibility, b, a, c
			case 883: {
				// backface-visibility, -
				if (out.charCodeAt(8) === DASH) {
					return webkit + out + out
				}

				// image-set(...)
				if (out.indexOf('image-set(', 11) > 0) {
					return out.replace(imgsrcptn, '$1'+webkit+'$2') + out
				}

				return out
			}
			// flex: f, l, e
			case 932: {
				if (out.charCodeAt(4) === DASH) {
					switch (out.charCodeAt(5)) {
						// flex-grow, g
						case 103: {
							return webkit + 'box-' + out.replace('-grow', '') + webkit + out + ms + out.replace('grow', 'positive') + out
						}
						// flex-shrink, s
						case 115: {
							return webkit + out + ms + out.replace('shrink', 'negative') + out
						}
						// flex-basis, b
						case 98: {
							return webkit + out + ms + out.replace('basis', 'preferred-size') + out
						}
					}
				}

				return webkit + out + ms + out + out
			}
			// order: o, r, d
			case 964: {
				return webkit + out + ms + 'flex' + '-' + out + out
			}
			// justify-items/justify-content, j, u, s
			case 1023: {
				// justify-content, c
				if (out.charCodeAt(8) !== 99) {
					break
				}

				cache = out.substring(out.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify')
				return webkit + 'box-pack' + cache + webkit + out + ms + 'flex-pack' + cache + out
			}
			// cursor, c, u, r
			case 1005: {
				return cursorptn.test(out) ? out.replace(colonptn, ':' + webkit) + out.replace(colonptn, ':' + moz) + out : out
			}
			// writing-mode, w, r, i
			case 1000: {
				cache = out.substring(13).trim()
				index = cache.indexOf('-') + 1

				switch (cache.charCodeAt(0)+cache.charCodeAt(index)) {
					// vertical-lr
					case 226: {
						cache = out.replace(writingptn, 'tb')
						break
					}
					// vertical-rl
					case 232: {
						cache = out.replace(writingptn, 'tb-rl')
						break
					}
					// horizontal-tb
					case 220: {
						cache = out.replace(writingptn, 'lr')
						break
					}
					default: {
						return out
					}
				}

				return webkit + out + ms + cache + out
			}
			// position: sticky
			case 1017: {
				if (out.indexOf('sticky', 9) === -1) {
					return out
				}
			}
			// display(flex/inline-flex/inline-box): d, i, s
			case 975: {
				index = (out = input).length - 10
				cache = (out.charCodeAt(index) === 33 ? out.substring(0, index) : out).substring(input.indexOf(':', 7) + 1).trim()

				switch (hash = cache.charCodeAt(0) + (cache.charCodeAt(7)|0)) {
					// inline-
					case 203: {
						// inline-box
						if (cache.charCodeAt(8) < 111) {
							break
						}
					}
					// inline-box/sticky
					case 115: {
						out = out.replace(cache, webkit+cache)+';'+out
						break
					}
					// inline-flex
					// flex
					case 207:
					case 102: {
						out = (
							out.replace(cache, webkit+(hash > 102 ? 'inline-' : '')+'box')+';'+
							out.replace(cache, webkit+cache)+';'+
							out.replace(cache, ms+cache+'box')+';'+
							out
						)
					}
				}

				return out + ';'
			}
			// align-items, align-center, align-self: a, l, i, -
			case 938: {
				if (out.charCodeAt(5) === DASH) {
					switch (out.charCodeAt(6)) {
						// align-items, i
						case 105: {
							cache = out.replace('-items', '')
							return webkit + out + webkit + 'box-' + cache + ms + 'flex-' + cache + out
						}
						// align-self, s
						case 115: {
							return webkit + out + ms + 'flex-item-' + out.replace(selfptn, '') + out
						}
						// align-content
						default: {
							return webkit + out + ms + 'flex-line-pack' + out.replace('align-content', '').replace(selfptn, '') + out
						}
					}
				}
				break
			}
			// min/max
			case 973:
			case 989: {
				// min-/max- height/width/block-size/inline-size
				if (out.charCodeAt(3) !== DASH || out.charCodeAt(4) === 122) {
					break
				}
			}
			// height/width: min-content / width: max-content
			case 931:
			case 953: {
				if (dimensionptn.test(input) === true) {
					// stretch
					if ((cache = input.substring(input.indexOf(':') + 1)).charCodeAt(0) === 115)
						return property(input.replace('stretch', 'fill-available'), first, second, third).replace(':fill-available', ':stretch')
					else
						return out.replace(cache, webkit + cache) + out.replace(cache, moz + cache.replace('fill-', '')) + out
				}
				break
			}
			// transform, transition: t, r, a
			case 962: {
				out = webkit + out + (out.charCodeAt(5) === 102 ? ms + out : '') + out

				// transitions
				if (second + third === 211 && out.charCodeAt(13) === 105 && out.indexOf('transform', 10) > 0) {
					return out.substring(0, out.indexOf(';', 27) + 1).replace(transformptn, '$1' + webkit + '$2') + out
				}

				break
			}
		}

		return out
	}

	/**
	 * Vendor
	 *
	 * @param {string} content
	 * @param {number} context
	 * @return {boolean}
	 */
	function vendor (content, context) {
		var index = content.indexOf(context === 1 ? ':' : '{')
		var key = content.substring(0, context !== 3 ? index : 10)
		var value = content.substring(index + 1, content.length - 1)

		return should(context !== 2 ? key : key.replace(pseudofmt, '$1'), value, context)
	}

	/**
	 * Supports
	 *
	 * @param {string} match
	 * @param {string} group
	 * @return {string}
	 */
	function supports (match, group) {
		var out = property(group, group.charCodeAt(0), group.charCodeAt(1), group.charCodeAt(2))

		return out !== group+';' ? out.replace(propertyptn, ' or ($1)').substring(4) : '('+group+')'
	}

	/**
	 * Animation
	 *
	 * @param {string} input
	 * @return {string}
	 */
	function animation (input) {
		var length = input.length
		var index = input.indexOf(':', 9) + 1
		var declare = input.substring(0, index).trim()
		var out = input.substring(index, length-1).trim()

		switch (input.charCodeAt(9)*keyed) {
			case 0: {
				break
			}
			// animation-*, -
			case DASH: {
				// animation-name, n
				if (input.charCodeAt(10) !== 110) {
					break
				}
			}
			// animation/animation-name
			default: {
				// split in case of multiple animations
				var list = out.split((out = '', animationptn))

				for (var i = 0, index = 0, length = list.length; i < length; index = 0, ++i) {
					var value = list[i]
					var items = value.split(propertiesptn)

					while (value = items[index]) {
						var peak = value.charCodeAt(0)

						if (keyed === 1 && (
							// letters
							(peak > AT && peak < 90) || (peak > 96 && peak < 123) || peak === UNDERSCORE ||
							// dash but not in sequence i.e --
							(peak === DASH && value.charCodeAt(1) !== DASH)
						)) {
							// not a number/function
							switch (isNaN(parseFloat(value)) + (value.indexOf('(') !== -1)) {
								case 1: {
									switch (value) {
										// not a valid reserved keyword
										case 'infinite': case 'alternate': case 'backwards': case 'running':
										case 'normal': case 'forwards': case 'both': case 'none': case 'linear':
										case 'ease': case 'ease-in': case 'ease-out': case 'ease-in-out':
										case 'paused': case 'reverse': case 'alternate-reverse': case 'inherit':
										case 'initial': case 'unset': case 'step-start': case 'step-end': {
											break
										}
										default: {
											value += key
										}
									}
								}
							}
						}

						items[index++] = value
					}

					out += (i === 0 ? '' : ',') + items.join(' ')
				}
			}
		}

		out = declare + out + ';'

		if (prefix === 1 || (prefix === 2 && vendor(out, 1)))
			return webkit + out + out

		return out
	}

	/**
	 * Isolate
	 *
	 * @param {Array<string>} current
	 */
	function isolate (current) {
		for (var i = 0, length = current.length, selector = Array(length), padding, element; i < length; ++i) {
			// split individual elements in a selector i.e h1 h2 === [h1, h2]
			var elements = current[i].split(elementptn)
			var out = ''

			for (var j = 0, size = 0, tail = 0, code = 0, l = elements.length; j < l; ++j) {
				// empty element
				if ((size = (element = elements[j]).length) === 0 && l > 1) {
					continue
				}

				tail = out.charCodeAt(out.length-1)
				code = element.charCodeAt(0)
				padding = ''

				if (j !== 0) {
					// determine if we need padding
					switch (tail) {
						case STAR:
						case TILDE:
						case GREATERTHAN:
						case PLUS:
						case SPACE:
						case OPENPARENTHESES:  {
							break
						}
						default: {
							padding = ' '
						}
					}
				}

				switch (code) {
					case AND: {
						element = padding + nscopealt
					}
					case TILDE:
					case GREATERTHAN:
					case PLUS:
					case SPACE:
					case CLOSEPARENTHESES:
					case OPENPARENTHESES: {
						break
					}
					case OPENBRACKET: {
						element = padding + element + nscopealt
						break
					}
					case COLON: {
						switch (element.charCodeAt(1)*2 + element.charCodeAt(2)*3) {
							// :global
							case 530: {
								if (escape > 0) {
									element = padding + element.substring(8, size - 1)
									break
								}
							}
							// :hover, :nth-child(), ...
							default: {
								if (j < 1 || elements[j-1].length < 1) {
									element = padding + nscopealt + element
								}
							}
						}
						break
					}
					case COMMA: {
						padding = ''
					}
					default: {
						if (size > 1 && element.indexOf(':') > 0) {
							element = padding + element.replace(pseudoptn, '$1' + nscopealt + '$2')
						} else {
							element = padding + element + nscopealt
						}
					}
				}

				out += element
			}

			selector[i] = out.replace(formatptn, '').trim()
		}

		return selector
	}

	/**
	 * Proxy
	 *
	 * @param {number} context
	 * @param {string} content
	 * @param {Array<string>} selectors
	 * @param {Array<string>} parents
	 * @param {number} line
	 * @param {number} column
	 * @param {number} length
	 * @param {number} id
	 * @param {number} depth
	 * @param {number} at
	 * @return {(string|void|*)}
	 */
	function proxy (context, content, selectors, parents, line, column, length, id, depth, at) {
		for (var i = 0, out = content, next; i < plugged; ++i) {
			switch (next = plugins[i].call(stylis, context, out, selectors, parents, line, column, length, id, depth, at)) {
				case void 0:
				case false:
				case true:
				case null: {
					break
				}
				default: {
					out = next
				}
			}
		}
		if (out !== content) {
		  return out
		}
	}

	/**
	 * @param {number} code
	 * @param {number} index
	 * @param {number} length
	 * @param {string} body
	 * @return {number}
	 */
	function delimited (code, index, length, body) {
		for (var i = index + 1; i < length; ++i) {
			switch (body.charCodeAt(i)) {
				// /*
				case FOWARDSLASH: {
					if (code === STAR) {
						if (body.charCodeAt(i - 1) === STAR &&  index + 2 !== i) {
							return i + 1
						}
					}
					break
				}
				// //
				case NEWLINE: {
					if (code === FOWARDSLASH) {
						return i + 1
					}
				}
			}
		}

		return i
	}

	/**
	 * @param {number} type
	 * @param {number} index
	 * @param {number} length
	 * @param {number} find
	 * @param {string} body
	 * @return {number}
	 */
	function match (type, index, length, body) {
		for (var i = index + 1; i < length; ++i) {
			switch (body.charCodeAt(i)) {
				case type: {
					return i
				}
			}
		}

		return i
	}

	/**
	 * Minify
	 *
	 * @param {(string|*)} output
	 * @return {string}
	 */
	function minify (output) {
		return output
			.replace(formatptn, '')
			.replace(beforeptn, '')
			.replace(afterptn, '$1')
			.replace(tailptn, '$1')
			.replace(whiteptn, ' ')
	}

	/**
	 * Use
	 *
	 * @param {(Array<function(...?)>|function(...?)|number|void)?} plugin
	 */
	function use (plugin) {
		switch (plugin) {
			case void 0:
			case null: {
				plugged = plugins.length = 0
				break
			}
			default: {
				if (typeof plugin === 'function') {
					plugins[plugged++] = plugin
				}	else if (typeof plugin === 'object') {
					for (var i = 0, length = plugin.length; i < length; ++i) {
						use(plugin[i])
					}
				} else {
					unkwn = !!plugin|0
				}
			}
 		}

 		return use
	}

	/**
	 * Set
	 *
	 * @param {*} options
	 */
	function set (options) {
		for (var name in options) {
			var value = options[name]
			switch (name) {
				case 'keyframe': keyed = value|0; break
				case 'global': escape = value|0; break
				case 'cascade': cascade = value|0; break
				case 'compress': compress = value|0; break
				case 'semicolon': semicolon = value|0; break
				case 'preserve': preserve = value|0; break
				case 'prefix':
					should = null

					if (!value) {
						prefix = 0
					} else if (typeof value !== 'function') {
						prefix = 1
					} else {
						prefix = 2
						should = value
					}
			}
		}

		return set
	}

	/**
	 * Stylis
	 *
	 * @param {string} selector
	 * @param {string} input
	 * @return {*}
	 */
	function stylis (selector, input) {
		if (this !== void 0 && this.constructor === stylis) {
			return factory(selector)
		}

		// setup
		var ns = selector
		var code = ns.charCodeAt(0)

		// trim leading whitespace
		if (code < 33) {
			code = (ns = ns.trim()).charCodeAt(0)
		}

		// keyframe/animation namespace
		if (keyed > 0) {
			key = ns.replace(invalidptn, code === OPENBRACKET ? '' : '-')
		}

		// reset, used to assert if a plugin is moneky-patching the return value
		code = 1

		// cascade/isolate
		if (cascade === 1) {
			nscope = ns
		} else {
			nscopealt = ns
		}

		var selectors = [nscope]
		var result

		// execute plugins, pre-process context
		if (plugged > 0) {
			result = proxy(PREPS, input, selectors, selectors, line, column, 0, 0, 0, 0)

			if (result !== void 0 && typeof result === 'string') {
				input = result
			}
		}

		// build
		var output = compile(array, selectors, input, 0, 0)

		// execute plugins, post-process context
		if (plugged > 0) {
			result = proxy(POSTS, output, selectors, selectors, line, column, output.length, 0, 0, 0)

			// bypass minification
			if (result !== void 0 && typeof(output = result) !== 'string') {
				code = 0
			}
		}

		// reset
		key = ''
		nscope = ''
		nscopealt = ''
		pattern = 0
		line = 1
		column = 1

		return compress*code === 0 ? output : minify(output)
	}

	stylis['use'] = use
	stylis['set'] = set

	if (options !== void 0) {
		set(options)
	}

	return stylis
}));


/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

(function (factory) {
	 true ? (module['exports'] = factory()) :
		typeof define === 'function' && define['amd'] ? define(factory()) :
			(window['stylisRuleSheet'] = factory())
}(function () {

	'use strict'

	return function (insertRule) {
		var delimiter = '/*|*/'
		var needle = delimiter+'}'

		function toSheet (block) {
			if (block)
				try {
					insertRule(block + '}')
				} catch (e) {}
		}

		return function ruleSheet (context, content, selectors, parents, line, column, length, ns, depth, at) {
			switch (context) {
				// property
				case 1:
					// @import
					if (depth === 0 && content.charCodeAt(0) === 64)
						return insertRule(content+';'), ''
					break
				// selector
				case 2:
					if (ns === 0)
						return content + delimiter
					break
				// at-rule
				case 3:
					switch (ns) {
						// @font-face, @page
						case 102:
						case 112:
							return insertRule(selectors[0]+content), ''
						default:
							return content + (at === 0 ? delimiter : '')
					}
				case -2:
					content.split(needle).forEach(toSheet)
			}
		}
	}
}))


/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try { // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 543 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_connect__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions_actionCreators__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_helpers_variables__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  margin: 0;\n  padding: 11.5px 20px;\n  border: none;\n  outline: none;\n  border-top: 1px solid #333333;\n  border-bottom: 1px solid #333333;\n  background-color: ',';\n  color: rgba(255, 255, 255, 0.75);\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 1.25;\n  letter-spacing: 0.125em;\n  text-transform: uppercase;\n  text-align: center;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n  transform: translateX(-100%);\n  transition: transform 0.25s ease-out, color 0.25s ease-out;\n  cursor: pointer;\n  ',';\n  &:hover {\n    color: rgba(255, 255, 255, 0.625);\n  }\n  &:active {\n    color: rgba(255, 255, 255, 0.5);\n  }\n'],['\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  margin: 0;\n  padding: 11.5px 20px;\n  border: none;\n  outline: none;\n  border-top: 1px solid #333333;\n  border-bottom: 1px solid #333333;\n  background-color: ',';\n  color: rgba(255, 255, 255, 0.75);\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 1.25;\n  letter-spacing: 0.125em;\n  text-transform: uppercase;\n  text-align: center;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n  transform: translateX(-100%);\n  transition: transform 0.25s ease-out, color 0.25s ease-out;\n  cursor: pointer;\n  ',';\n  &:hover {\n    color: rgba(255, 255, 255, 0.625);\n  }\n  &:active {\n    color: rgba(255, 255, 255, 0.5);\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n      transform: translateX(0);\n    '],['\n      transform: translateX(0);\n    ']),_templateObject3=_taggedTemplateLiteral(['\n  position: absolute;\n  top: 100%;\n  left: 0;\n  height: calc(100vh - 100%);\n  width: 100%;\n  overflow: hidden;\n  visibility: hidden;\n  z-index: 1;\n  transition: visibility 0s linear 0.25s;\n  ',';\n'],['\n  position: absolute;\n  top: 100%;\n  left: 0;\n  height: calc(100vh - 100%);\n  width: 100%;\n  overflow: hidden;\n  visibility: hidden;\n  z-index: 1;\n  transition: visibility 0s linear 0.25s;\n  ',';\n']),_templateObject4=_taggedTemplateLiteral(['\n      visibility: visible;\n      transition: visibility 0s linear 0s;\n    '],['\n      visibility: visible;\n      transition: visibility 0s linear 0s;\n    ']),_templateObject5=_taggedTemplateLiteral(['\n  position: absolute;\n  top: 40px;\n  right: -5px;\n  bottom: 0;\n  left: 0;\n  padding: 0 0 25px;\n  transform: translateX(-100%);\n  background-color: ',';\n  transition: transform 0.25s ease-out;\n  border-right: 5px solid ',';\n  overflow-y: auto;\n  -webkit-overflow-scrolling: touch;\n  ',';\n'],['\n  position: absolute;\n  top: 40px;\n  right: -5px;\n  bottom: 0;\n  left: 0;\n  padding: 0 0 25px;\n  transform: translateX(-100%);\n  background-color: ',';\n  transition: transform 0.25s ease-out;\n  border-right: 5px solid ',';\n  overflow-y: auto;\n  -webkit-overflow-scrolling: touch;\n  ',';\n']),_templateObject6=_taggedTemplateLiteral(['\n  padding-top: 30px;\n  text-align: center;\n'],['\n  padding-top: 30px;\n  text-align: center;\n']),_templateObject7=_taggedTemplateLiteral(['\n  font-size: 19px;\n  font-weight: normal;\n  font-style: normal;\n  font-stretch: normal;\n  line-height: normal;\n  letter-spacing: normal;\n  text-align: center;\n  text-decoration: none;\n  padding: 20px 0;\n  color: #ffffff;\n  transition: opacity 250ms ease-out;\n\n  &:hover {\n    opacity: 0.8;\n  }\n'],['\n  font-size: 19px;\n  font-weight: normal;\n  font-style: normal;\n  font-stretch: normal;\n  line-height: normal;\n  letter-spacing: normal;\n  text-align: center;\n  text-decoration: none;\n  padding: 20px 0;\n  color: #ffffff;\n  transition: opacity 250ms ease-out;\n\n  &:hover {\n    opacity: 0.8;\n  }\n']),_templateObject8=_taggedTemplateLiteral(['\n  position: absolute;\n  top: 100%;\n  right: 0;\n  left: 0;\n  z-index: 100;\n  padding: 20px 0 0;\n  background-color: white;\n  color: ',';\n'],['\n  position: absolute;\n  top: 100%;\n  right: 0;\n  left: 0;\n  z-index: 100;\n  padding: 20px 0 0;\n  background-color: white;\n  color: ',';\n']),_templateObject9=_taggedTemplateLiteral(['\n  margin: 0;\n  padding: 20px 0;\n  list-style: none;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n'],['\n  margin: 0;\n  padding: 20px 0;\n  list-style: none;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n']),_templateObject10=_taggedTemplateLiteral(['\n  font-size: 19px;\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  color: ',';\n  text-decoration: none;\n  padding: 10px;\n  margin: 0;\n  cursor: pointer;\n'],['\n  font-size: 19px;\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  color: ',';\n  text-decoration: none;\n  padding: 10px;\n  margin: 0;\n  cursor: pointer;\n']),_templateObject11=_taggedTemplateLiteral(['\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  color: ',';\n  text-decoration: none;\n  padding: 10px;\n  margin: 0;\n  cursor: pointer;\n  font-size: 13px;\n  font-weight: 600;\n  font-style: normal;\n  font-stretch: normal;\n  line-height: normal;\n  letter-spacing: 2.3px;\n  text-transform: uppercase;\n'],['\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  color: ',';\n  text-decoration: none;\n  padding: 10px;\n  margin: 0;\n  cursor: pointer;\n  font-size: 13px;\n  font-weight: 600;\n  font-style: normal;\n  font-stretch: normal;\n  line-height: normal;\n  letter-spacing: 2.3px;\n  text-transform: uppercase;\n']),_templateObject12=_taggedTemplateLiteral(['\n  color: ',';\n  border-top: 1px solid transparent;\n  transition: opacity 250ms ease-out;\n\n  &:hover {\n    span {\n      opacity: 0.8;\n    }\n\n    ',' {\n      opacity: 1;\n      transform: translateY(0);\n    }\n  }\n\n  ',';\n\n  ',';\n'],['\n  color: ',';\n  border-top: 1px solid transparent;\n  transition: opacity 250ms ease-out;\n\n  &:hover {\n    span {\n      opacity: 0.8;\n    }\n\n    ',' {\n      opacity: 1;\n      transform: translateY(0);\n    }\n  }\n\n  ',';\n\n  ',';\n']),_templateObject13=_taggedTemplateLiteral(['\n      span:after {\n        content: \'\';\n        background-image: url(\'/images/icons/arrow-white.svg\');\n        background-size: contain;\n        background-repeat: no-repeat;\n        min-width: 10px;\n        height: 10px;\n        display: inline-block;\n        margin-left: 6px;\n        transform: rotateZ(-90deg);\n      }\n    '],['\n      span:after {\n        content: \'\';\n        background-image: url(\'/images/icons/arrow-white.svg\');\n        background-size: contain;\n        background-repeat: no-repeat;\n        min-width: 10px;\n        height: 10px;\n        display: inline-block;\n        margin-left: 6px;\n        transform: rotateZ(-90deg);\n      }\n    ']),_templateObject14=_taggedTemplateLiteral(['\n      span:after {\n        min-width: 7px;\n        height: 7px;\n        margin-bottom: 1px;\n      }\n    '],['\n      span:after {\n        min-width: 7px;\n        height: 7px;\n        margin-bottom: 1px;\n      }\n    ']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MobileMainMenu=function(_Component){_inherits(MobileMainMenu,_Component);function MobileMainMenu(props){_classCallCheck(this,MobileMainMenu);var _this=_possibleConstructorReturn(this,(MobileMainMenu.__proto__||Object.getPrototypeOf(MobileMainMenu)).call(this,props));_this.state={scrollPosition:window.pageYOffset};_this.clearActiveMenuItem=_this.clearActiveMenuItem.bind(_this);return _this;}_createClass(MobileMainMenu,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var _this2=this;if(!this.props.viewstate.get('mobileMenuActive')&&nextProps.viewstate.get('mobileMenuActive')){this.setState({scrollPosition:window.pageYOffset,currentPath:this.props.location.pathname});if(window.pageYOffset>0&&window.pageYOffset<__WEBPACK_IMPORTED_MODULE_7__styles_helpers_variables__["d" /* header */].logoAreaMobileHeight){window.scrollTo(0,0);this.activate(0);}else{this.activate(window.pageYOffset);}}else if(this.props.viewstate.get('mobileMenuActive')&&!nextProps.viewstate.get('mobileMenuActive')){if(this.state.scrollPosition>0&&this.state.scrollPosition<__WEBPACK_IMPORTED_MODULE_7__styles_helpers_variables__["d" /* header */].logoAreaMobileHeight){window.scrollTo(0,0);this.setState(function(){return{scrollPosition:0};},function(){_this2.deactivate(_this2.state.scrollPosition);});}else{this.deactivate(this.state.scrollPosition);}}}},{key:'setActiveMenuItem',value:function setActiveMenuItem(arrayOfIds){this.props.setViewstate('activeMenuItem',arrayOfIds);}},{key:'clearActiveMenuItem',value:function clearActiveMenuItem(){this.props.removeViewstate('activeMenuItem');}},{key:'activate',value:function activate(scrollPosition){document.body.style.position='fixed';document.body.style.left=0;document.body.style.right=0;document.body.style.top='-'+scrollPosition+'px';document.body.style.overflowY='scroll';}},{key:'deactivate',value:function deactivate(scrollPosition){document.body.removeAttribute('style');if(this.state.currentPath===this.props.location.pathname){window.scrollTo(0,scrollPosition);}}},{key:'renderFirstLevelMenu',value:function renderFirstLevelMenu(){var _this3=this;// get sitemap object from window.sitemap
var sitemap=this.props.sitemap.get('children',Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])());return sitemap.map(function(item){if(!item.get('visibleInMenu')){return false;}// set a bool if the menu item has children and should open a submenu onClick
var itemHasChildren=!!item.get('children',Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])()).filter(function(itemChild){return itemChild.get('visibleInMenu')===true;}).size;if(itemHasChildren){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ListMenuItem,{key:item.get('url'),hasChildren:true,onClick:function onClick(){return _this3.setActiveMenuItem([item.get('id')]);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MenuItem,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,item.get('title'))));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ListMenuItem,{key:item.get('url')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MenuItemLink,{to:item.get('url')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,item.get('title'))));}).toArray();}},{key:'renderSecondLevelMenu',value:function renderSecondLevelMenu(){var _this4=this;// don't render anything if the firstLevelMenu has not made a selection
if(!this.props.viewstate.get('activeMenuItem')||this.props.viewstate.get('activeMenuItem')&&this.props.viewstate.get('activeMenuItem').length<1){return false;}var parentItem=this.props.sitemap.get('children',Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])()).find(function(item){return item.get('id')===_this4.props.viewstate.get('activeMenuItem')[0];});// TODO: remove this if-statement once backend is formated correctly for CategoryLink items...
var currentItem=parentItem.get('pageType',Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])())==='CategoryLink'?parentItem.getIn(['children']):parentItem.get('children');return currentItem.map(function(item){// set a bool if the menu item has children and should open a submenu onClick
var itemHasChildren=!!item.get('children',Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])()).size;if(itemHasChildren){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ListMenuItem,{key:item.get('url'),isSmall:true,hasChildren:true,onClick:function onClick(){return _this4.setActiveMenuItem([_this4.props.viewstate.get('activeMenuItem')[0],item.get('id')]);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MenuItem,{isSmall:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,item.get('title'))));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ListMenuItem,{key:item.get('url'),isSmall:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MenuItemLinkSmall,{to:item.get('url')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,item.get('title'))));}).toArray();}},{key:'renderThirdLevelMenu',value:function renderThirdLevelMenu(){var _this5=this;// don't render anything if the secondLevelMenu has not made a selection
if(!this.props.viewstate.get('activeMenuItem')||this.props.viewstate.get('activeMenuItem')&&this.props.viewstate.get('activeMenuItem').length<2){return false;}var grandParentItem=this.props.sitemap.get('children',Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])()).find(function(item){return item.get('id')===_this5.props.viewstate.get('activeMenuItem')[0];});var parentItem=grandParentItem.get('pageType')==='CategoryLink'?grandParentItem.getIn(['children'],Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])()).find(function(item){return item.get('id',Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])())===_this5.props.viewstate.get('activeMenuItem')[1];}):grandParentItem.get('children',Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])()).find(function(item){return item.get('id',Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])())===_this5.props.viewstate.get('activeMenuItem')[1];});// get sitemap object from window.sitemap
var currentItem=parentItem.get('children');return currentItem.map(function(item){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ListMenuItem,{key:item.get('url'),isSmall:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MenuItemLinkSmall,{to:item.get('url')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,item.get('title'))));}).toArray();}},{key:'renderActiveMenuItem',value:function renderActiveMenuItem(activeMenuItem){var lastLevel=arguments.length>1&&arguments[1]!==undefined?arguments[1]:false;if(!activeMenuItem){return false;}var activeItem=this.props.sitemap.get('children',Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])()).find(function(obj){return obj.get('id')===activeMenuItem[0];});if(activeItem.get('pageType')==='CategoryLink'&&lastLevel&&activeMenuItem&&activeMenuItem.length>1){activeItem=activeItem.getIn(['children']).find(function(obj){return obj.get('id')===activeMenuItem[1];});}else if(lastLevel&&activeMenuItem&&activeMenuItem.length>1){activeItem=activeItem.get('children').find(function(obj){return obj.get('id')===activeMenuItem[1];});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CenterDiv,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ActiveMenuItem,{to:activeItem.get('url')},activeItem.get('title')));}},{key:'render',value:function render(){var _this6=this;var viewstate=this.props.viewstate;var pageWidth=viewstate.get('pageWidth');if(pageWidth>__WEBPACK_IMPORTED_MODULE_7__styles_helpers_variables__["b" /* breakpoint */].large){return null;}var firstLevelMenu=this.renderFirstLevelMenu();var secondLevelMenu=this.renderSecondLevelMenu();var thirdLevelMenu=this.renderThirdLevelMenu();var secondLevelactiveMenuItem=this.renderActiveMenuItem(viewstate.get('activeMenuItem'));var thirdLevelactiveMenuItem=this.renderActiveMenuItem(viewstate.get('activeMenuItem'),true);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MobileMenuContainer,{active:viewstate.get('mobileMenuActive')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(BackAndClose,{active:viewstate.get('mobileMenuActive'),onClick:function onClick(){if(viewstate.get('activeMenuItem')){if(viewstate.get('activeMenuItem').length>1){_this6.props.setViewstate('activeMenuItem',viewstate.get('activeMenuItem').slice(0,-1));}else{_this6.props.removeViewstate('activeMenuItem');}}else{_this6.props.removeViewstate('mobileMenuActive');}}},viewstate.get('activeMenuItem')?'Tillbaka':'Stäng'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SlideInContainer,{className:'SlideInContainer',active:viewstate.get('mobileMenuActive')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SubMenuList,null,firstLevelMenu)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SlideInContainer,{className:'SlideInContainer',active:viewstate.get('mobileMenuActive')&&viewstate.get('activeMenuItem')&&viewstate.get('activeMenuItem').length>=1},secondLevelactiveMenuItem,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SubMenuList,null,secondLevelMenu)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SlideInContainer,{className:'SlideInContainer',active:viewstate.get('mobileMenuActive')&&viewstate.get('activeMenuItem')&&viewstate.get('activeMenuItem').length>=2},thirdLevelactiveMenuItem,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SubMenuList,null,thirdLevelMenu)));}}]);return MobileMainMenu;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var BackAndClose=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].button(_templateObject,__WEBPACK_IMPORTED_MODULE_7__styles_helpers_variables__["c" /* color */].black,function(props){return props.active&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject2);});var MobileMenuContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject3,function(props){return props.active&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject4);});var SlideInContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject5,__WEBPACK_IMPORTED_MODULE_7__styles_helpers_variables__["c" /* color */].black,__WEBPACK_IMPORTED_MODULE_7__styles_helpers_variables__["c" /* color */].darkerGrey,function(props){return props.active&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject2);});var CenterDiv=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject6);var ActiveMenuItem=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["a" /* Link */])(_templateObject7);var SubMenu=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject8,__WEBPACK_IMPORTED_MODULE_7__styles_helpers_variables__["c" /* color */].black);var SubMenuList=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].ul(_templateObject9);var MenuItem=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].p(_templateObject10,__WEBPACK_IMPORTED_MODULE_7__styles_helpers_variables__["c" /* color */].white);var MenuItemSmall=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].p(_templateObject11,__WEBPACK_IMPORTED_MODULE_7__styles_helpers_variables__["c" /* color */].white);var MenuItemLink=MenuItem.withComponent(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["a" /* Link */]);var MenuItemLinkSmall=MenuItemSmall.withComponent(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["a" /* Link */]);var ListMenuItem=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].li(_templateObject12,__WEBPACK_IMPORTED_MODULE_7__styles_helpers_variables__["c" /* color */].white,SubMenu,function(props){return props.hasChildren&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject13);},function(props){return props.isSmall&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject14);});MobileMainMenu.defaultProps={viewstate:Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])(),sitemap:Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])()};MobileMainMenu.propTypes={setViewstate:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired,removeViewstate:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired,viewstate:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"]),sitemap:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"]),location:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5__store_connect__["a" /* default */])(MobileMainMenu,{setViewstate:__WEBPACK_IMPORTED_MODULE_6__actions_actionCreators__["W" /* setViewstate */],removeViewstate:__WEBPACK_IMPORTED_MODULE_6__actions_actionCreators__["V" /* removeViewstate */]},function(store){return{viewstate:store.viewstate,sitemap:Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["fromJS"])(window.sitemap)};}));

/***/ }),
/* 544 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_transition_group__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_transition_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_transition_group__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_connect__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_helpers_animations__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_helpers_variables__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_helpers_mixins__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__actions_actionCreators__ = __webpack_require__(7);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  ',';\n  position: relative;\n  margin: 0;\n  padding: 0;\n  background-color: transparent;\n  outline: 0;\n  cursor: ',';\n  border: none;\n  font-size: 12px;\n  font-weight: 600;\n  letter-spacing: 1.5px;\n  color: ',';\n  text-decoration: none;\n  text-transform: uppercase;\n  transition: opacity 250ms ease-out;\n'],['\n  ',';\n  position: relative;\n  margin: 0;\n  padding: 0;\n  background-color: transparent;\n  outline: 0;\n  cursor: ',';\n  border: none;\n  font-size: 12px;\n  font-weight: 600;\n  letter-spacing: 1.5px;\n  color: ',';\n  text-decoration: none;\n  text-transform: uppercase;\n  transition: opacity 250ms ease-out;\n']),_templateObject2=_taggedTemplateLiteral(['\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  transition: opacity 0.25s ease-out;\n  &:hover {\n    opacity: ',';\n  }\n  &:active {\n    opacity: ',';\n  }\n  &:after {\n    content: \'\';\n    position: relative;\n    display: inline-block;\n    margin-left: 5px;\n    background-image: ',';\n    background-size: contain;\n    background-repeat: no-repeat;\n    background-position: center;\n    width: 17.5px;\n    height: 17.5px;\n    @media screen and (min-width: ','px) {\n      width: 20px;\n      height: 20px;\n    }\n  }\n'],['\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  transition: opacity 0.25s ease-out;\n  &:hover {\n    opacity: ',';\n  }\n  &:active {\n    opacity: ',';\n  }\n  &:after {\n    content: \'\';\n    position: relative;\n    display: inline-block;\n    margin-left: 5px;\n    background-image: ',';\n    background-size: contain;\n    background-repeat: no-repeat;\n    background-position: center;\n    width: 17.5px;\n    height: 17.5px;\n    @media screen and (min-width: ','px) {\n      width: 20px;\n      height: 20px;\n    }\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  display: none;\n  @media screen and (min-width: ','px) {\n    display: inline;\n  }\n'],['\n  display: none;\n  @media screen and (min-width: ','px) {\n    display: inline;\n  }\n']),_templateObject4=_taggedTemplateLiteral(['\n  display: block;\n  height: 7px;\n  width: 7px;\n  position: absolute;\n  top: calc(50% - 1px);\n  right: 5px;\n  @media screen and (min-width: ','px) {\n    height: 8px;\n    width: 8px;\n    top: calc(50% - 2px);\n    right: 6px;\n  }\n'],['\n  display: block;\n  height: 7px;\n  width: 7px;\n  position: absolute;\n  top: calc(50% - 1px);\n  right: 5px;\n  @media screen and (min-width: ','px) {\n    height: 8px;\n    width: 8px;\n    top: calc(50% - 2px);\n    right: 6px;\n  }\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MenuCart=function(_PureComponent){_inherits(MenuCart,_PureComponent);_createClass(MenuCart,null,[{key:'getTotalCartItems',value:function getTotalCartItems(cart){return cart.get('cart',Object(__WEBPACK_IMPORTED_MODULE_3_immutable__["Map"])()).reduce(function(memory,item){return memory+item.get('quantity');},0);}}]);function MenuCart(props){_classCallCheck(this,MenuCart);var _this=_possibleConstructorReturn(this,(MenuCart.__proto__||Object.getPrototypeOf(MenuCart)).call(this,props));_this.state={totalCartItems:0,displayNumber:0};_this.toggleCart=_this.toggleCart.bind(_this);_this.updateCart=_this.updateCart.bind(_this);return _this;}_createClass(MenuCart,[{key:'componentDidMount',value:function componentDidMount(){this.updateCart(this.props.cart);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(!Object(__WEBPACK_IMPORTED_MODULE_3_immutable__["is"])(this.props.cart,nextProps.cart)){this.updateCart(nextProps.cart);}var propsCartItems=this.constructor.getTotalCartItems(this.props.cart);var nextPropsCartItems=this.constructor.getTotalCartItems(nextProps.cart);if(propsCartItems<nextPropsCartItems&&this.props.viewstate.get('productAddedToCart')){this.handleProductAddedToCart();}}},{key:'handleProductAddedToCart',value:function handleProductAddedToCart(){this.props.setViewstate('cartActive',true);}},{key:'toggleCart',value:function toggleCart(){this.props.removeViewstate('globalSearchActive');if(this.props.cart.get('cart',Object(__WEBPACK_IMPORTED_MODULE_3_immutable__["List"])()).isEmpty()){this.props.setViewstate('cartActive',false);}else{this.props.setViewstate('cartActive',!this.props.viewstate.get('cartActive'));}}},{key:'updateCart',value:function updateCart(cart){var _this2=this;var totalCartItems=this.constructor.getTotalCartItems(cart);this.setState({totalCartItems:totalCartItems,displayNumber:this.state.displayNumber===0?totalCartItems:null});if(this.state.displayNumber!==0){setTimeout(function(){_this2.setState({displayNumber:totalCartItems});},250);}}},{key:'render',value:function render(){var _state=this.state,totalCartItems=_state.totalCartItems,displayNumber=_state.displayNumber;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SideMenuLink,{onClick:this.toggleCart,hasCartItems:totalCartItems>=1},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CartContentWrapper,{hasCartItems:totalCartItems>=1,bg:'/images/icons/shopping.svg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DisplayInlineOnLarge,null,'Varukorg'),totalCartItems>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DisplayInlineOnLarge,null,'\xA0'),totalCartItems>0&&'(',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_transition_group__["TransitionGroup"],null,displayNumber&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__styles_helpers_animations__["c" /* FadeInInline */],null,displayNumber)),totalCartItems>0&&')',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_transition_group__["TransitionGroup"],null,totalCartItems>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__styles_helpers_animations__["d" /* FadeInInline2 */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CheckmarkIcon,{src:'/images/icons/checkmark.svg'})))));}}]);return MenuCart;}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);var SideMenuLink=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].button(_templateObject,__WEBPACK_IMPORTED_MODULE_8__styles_helpers_mixins__["d" /* fontFamilyBody */],function(props){return props.hasCartItems?'pointer':'default';},__WEBPACK_IMPORTED_MODULE_7__styles_helpers_variables__["c" /* color */].white);var CartContentWrapper=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].span(_templateObject2,function(props){return props.hasCartItems?0.875:1;},function(props){return props.hasCartItems?0.75:1;},function(props){return props.bg&&'url('+props.bg+')';},__WEBPACK_IMPORTED_MODULE_7__styles_helpers_variables__["b" /* breakpoint */].large);var DisplayInlineOnLarge=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].span(_templateObject3,__WEBPACK_IMPORTED_MODULE_7__styles_helpers_variables__["b" /* breakpoint */].large);var CheckmarkIcon=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].img(_templateObject4,__WEBPACK_IMPORTED_MODULE_7__styles_helpers_variables__["b" /* breakpoint */].large);MenuCart.defaultProps={viewstate:Object(__WEBPACK_IMPORTED_MODULE_3_immutable__["Map"])(),cart:Object(__WEBPACK_IMPORTED_MODULE_3_immutable__["Map"])()};MenuCart.propTypes={viewstate:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_3_immutable__["Map"]),cart:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_3_immutable__["Map"]),setViewstate:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,removeViewstate:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5__store_connect__["a" /* default */])(MenuCart,{setViewstate:__WEBPACK_IMPORTED_MODULE_9__actions_actionCreators__["W" /* setViewstate */],removeViewstate:__WEBPACK_IMPORTED_MODULE_9__actions_actionCreators__["V" /* removeViewstate */]},function(store){return{viewstate:store.viewstate,cart:store.cart};}));

/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(546);

exports.__esModule = true;
exports.default = addClass;

var _hasClass = _interopRequireDefault(__webpack_require__(547));

function addClass(element, className) {
  if (element.classList) element.classList.add(className);else if (!(0, _hasClass.default)(element, className)) if (typeof element.className === 'string') element.className = element.className + ' ' + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + ' ' + className);
}

module.exports = exports["default"];

/***/ }),
/* 546 */
/***/ (function(module, exports) {

function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = hasClass;

function hasClass(element, className) {
  if (element.classList) return !!className && element.classList.contains(className);else return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}

module.exports = exports["default"];

/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function replaceClassName(origClass, classToRemove) {
  return origClass.replace(new RegExp('(^|\\s)' + classToRemove + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}

module.exports = function removeClass(element, className) {
  if (element.classList) element.classList.remove(className);else if (typeof element.className === 'string') element.className = replaceClassName(element.className, className);else element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
};

/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactDom = __webpack_require__(145);

var _TransitionGroup = _interopRequireDefault(__webpack_require__(236));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

/**
 * The `<ReplaceTransition>` component is a specialized `Transition` component
 * that animates between two children.
 *
 * ```jsx
 * <ReplaceTransition in>
 *   <Fade><div>I appear first</div></Fade>
 *   <Fade><div>I replace the above</div></Fade>
 * </ReplaceTransition>
 * ```
 */
var ReplaceTransition =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(ReplaceTransition, _React$Component);

  function ReplaceTransition() {
    var _this;

    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
      _args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(_args)) || this;

    _this.handleEnter = function () {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return _this.handleLifecycle('onEnter', 0, args);
    };

    _this.handleEntering = function () {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      return _this.handleLifecycle('onEntering', 0, args);
    };

    _this.handleEntered = function () {
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }

      return _this.handleLifecycle('onEntered', 0, args);
    };

    _this.handleExit = function () {
      for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
        args[_key5] = arguments[_key5];
      }

      return _this.handleLifecycle('onExit', 1, args);
    };

    _this.handleExiting = function () {
      for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
        args[_key6] = arguments[_key6];
      }

      return _this.handleLifecycle('onExiting', 1, args);
    };

    _this.handleExited = function () {
      for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
        args[_key7] = arguments[_key7];
      }

      return _this.handleLifecycle('onExited', 1, args);
    };

    return _this;
  }

  var _proto = ReplaceTransition.prototype;

  _proto.handleLifecycle = function handleLifecycle(handler, idx, originalArgs) {
    var _child$props;

    var children = this.props.children;

    var child = _react.default.Children.toArray(children)[idx];

    if (child.props[handler]) (_child$props = child.props)[handler].apply(_child$props, originalArgs);
    if (this.props[handler]) this.props[handler]((0, _reactDom.findDOMNode)(this));
  };

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        inProp = _this$props.in,
        props = _objectWithoutPropertiesLoose(_this$props, ["children", "in"]);

    var _React$Children$toArr = _react.default.Children.toArray(children),
        first = _React$Children$toArr[0],
        second = _React$Children$toArr[1];

    delete props.onEnter;
    delete props.onEntering;
    delete props.onEntered;
    delete props.onExit;
    delete props.onExiting;
    delete props.onExited;
    return _react.default.createElement(_TransitionGroup.default, props, inProp ? _react.default.cloneElement(first, {
      key: 'first',
      onEnter: this.handleEnter,
      onEntering: this.handleEntering,
      onEntered: this.handleEntered
    }) : _react.default.cloneElement(second, {
      key: 'second',
      onEnter: this.handleExit,
      onEntering: this.handleExiting,
      onEntered: this.handleExited
    }));
  };

  return ReplaceTransition;
}(_react.default.Component);

ReplaceTransition.propTypes =  false ? {
  in: _propTypes.default.bool.isRequired,
  children: function children(props, propName) {
    if (_react.default.Children.count(props[propName]) !== 2) return new Error("\"" + propName + "\" must be exactly two transition components.");
    return null;
  }
} : {};
var _default = ReplaceTransition;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.getChildMapping = getChildMapping;
exports.mergeChildMappings = mergeChildMappings;
exports.getInitialChildMapping = getInitialChildMapping;
exports.getNextChildMapping = getNextChildMapping;

var _react = __webpack_require__(0);

/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */
function getChildMapping(children, mapFn) {
  var mapper = function mapper(child) {
    return mapFn && (0, _react.isValidElement)(child) ? mapFn(child) : child;
  };

  var result = Object.create(null);
  if (children) _react.Children.map(children, function (c) {
    return c;
  }).forEach(function (child) {
    // run the map function here instead so that the key is the computed one
    result[child.key] = mapper(child);
  });
  return result;
}
/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */


function mergeChildMappings(prev, next) {
  prev = prev || {};
  next = next || {};

  function getValueForKey(key) {
    return key in next ? next[key] : prev[key];
  } // For each key of `next`, the list of keys to insert before that key in
  // the combined list


  var nextKeysPending = Object.create(null);
  var pendingKeys = [];

  for (var prevKey in prev) {
    if (prevKey in next) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }

  var i;
  var childMapping = {};

  for (var nextKey in next) {
    if (nextKeysPending[nextKey]) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }

    childMapping[nextKey] = getValueForKey(nextKey);
  } // Finally, add the keys which didn't appear before any key in `next`


  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }

  return childMapping;
}

function getProp(child, prop, props) {
  return props[prop] != null ? props[prop] : child.props[prop];
}

function getInitialChildMapping(props, onExited) {
  return getChildMapping(props.children, function (child) {
    return (0, _react.cloneElement)(child, {
      onExited: onExited.bind(null, child),
      in: true,
      appear: getProp(child, 'appear', props),
      enter: getProp(child, 'enter', props),
      exit: getProp(child, 'exit', props)
    });
  });
}

function getNextChildMapping(nextProps, prevChildMapping, onExited) {
  var nextChildMapping = getChildMapping(nextProps.children);
  var children = mergeChildMappings(prevChildMapping, nextChildMapping);
  Object.keys(children).forEach(function (key) {
    var child = children[key];
    if (!(0, _react.isValidElement)(child)) return;
    var hasPrev = key in prevChildMapping;
    var hasNext = key in nextChildMapping;
    var prevChild = prevChildMapping[key];
    var isLeaving = (0, _react.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)

    if (hasNext && (!hasPrev || isLeaving)) {
      // console.log('entering', key)
      children[key] = (0, _react.cloneElement)(child, {
        onExited: onExited.bind(null, child),
        in: true,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    } else if (!hasNext && hasPrev && !isLeaving) {
      // item is old (exiting)
      // console.log('leaving', key)
      children[key] = (0, _react.cloneElement)(child, {
        in: false
      });
    } else if (hasNext && hasPrev && (0, _react.isValidElement)(prevChild)) {
      // item hasn't changed transition states
      // copy over the last transition props;
      // console.log('unchanged', key)
      children[key] = (0, _react.cloneElement)(child, {
        onExited: onExited.bind(null, child),
        in: prevChild.props.in,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    }
  });
  return children;
}

/***/ }),
/* 551 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export css */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return index; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_transition_group_CSSTransition__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_transition_group_CSSTransition___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_transition_group_CSSTransition__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isempty__ = __webpack_require__(552);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isempty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_isempty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_invert__ = __webpack_require__(554);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_invert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_invert__);






// Thanks to ReactDOMFactories for this handy list!

var domElements = ["a", "abbr", "address", "area", "article", "aside", "audio", "b", "base", "bdi", "bdo", "big", "blockquote", "body", "br", "button", "canvas", "caption", "cite", "code", "col", "colgroup", "data", "datalist", "dd", "del", "details", "dfn", "dialog", "div", "dl", "dt", "em", "embed", "fieldset", "figcaption", "figure", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "iframe", "img", "input", "ins", "kbd", "keygen", "label", "legend", "li", "link", "main", "map", "mark", "marquee", "menu", "menuitem", "meta", "meter", "nav", "noscript", "object", "ol", "optgroup", "option", "output", "p", "param", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "script", "section", "select", "small", "source", "span", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "textarea", "tfoot", "th", "thead", "time", "title", "tr", "track", "u", "ul", "var", "video", "wbr",
// SVG
"circle", "clipPath", "defs", "ellipse", "g", "image", "line", "linearGradient", "mask", "path", "pattern", "polygon", "polyline", "radialGradient", "rect", "stop", "svg", "text", "tspan"];

var styled = (function (styledComponent, constructWithOptions) {
  var styled = function styled(tag) {
    return constructWithOptions(styledComponent, tag);
  };

  // Shorthands for all valid HTML Elements
  domElements.forEach(function (domElement) {
    styled[domElement] = styled(domElement);
  });
  return styled;
});

function _iterableToArrayLimit(arr, i) {
  var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
  if (null != _i) {
    var _s,
      _e,
      _x,
      _r,
      _arr = [],
      _n = !0,
      _d = !1;
    try {
      if (_x = (_i = _i.call(arr)).next, 0 === i) {
        if (Object(_i) !== _i) return;
        _n = !1;
      } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
    } catch (err) {
      _d = !0, _e = err;
    } finally {
      try {
        if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized(self);
}
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}

var STATES = {
  appear: "appear",
  appearActive: "appear-active",
  enter: "enter",
  enterActive: "enter-active",
  exit: "exit",
  exitActive: "exit-active"
};
var classNames = function classNames(id) {
  return Object.keys(STATES).reduce(function (result, type) {
    result[type] = "".concat(id, "-").concat(STATES[type]);
    return result;
  }, {});
};

var transitionProps = ["in", "mountOnEnter", "unmountOnExit", "onEnter", "onEntering", "onEntered", "onExit", "onExited", "onExiting", "onExit", "onExited", "onExiting", "onAppear"];
var bothProps = [
// Pass timeout through to use in css templates
"timeout"];

/**
 * Select which props to pass to transition and child component.
 * @param {Object} props               All props
 * @returns {Object} groups
 * @returns {Object} groups.transition Transition props
 * @returns {Object} groups.props      Child component props
 */
function partition(props) {
  var groups = {
    transition: {},
    props: {}
  };
  Object.entries(props).forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      value = _ref2[1];
    if (bothProps.includes(key)) {
      groups.transition[key] = value;
      groups.props[key] = value;
    } else if (transitionProps.includes(key)) {
      groups.transition[key] = value;
    } else {
      groups.props[key] = value;
    }
  });
  return groups;
}

var _excluded$1 = ["forwardedRef"],
  _excluded2 = ["children"];
var animated = function animated(options) {
  return function animatedWithOptions(Target) {
    var attrs = options.attrs;
    var AnimatedComponent = /*#__PURE__*/function (_Component) {
      _inherits(AnimatedComponent, _Component);
      var _super = _createSuper(AnimatedComponent);
      function AnimatedComponent() {
        _classCallCheck(this, AnimatedComponent);
        return _super.apply(this, arguments);
      }
      _createClass(AnimatedComponent, [{
        key: "renderTarget",
        value: function renderTarget(_ref) {
          var forwardedRef = _ref.forwardedRef,
            props = _objectWithoutProperties(_ref, _excluded$1);
          return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Target, _extends({
            transitionClassNames: this.constructor.classNames
          }, props, {
            ref: forwardedRef
          }));
        }
      }, {
        key: "renderChildren",
        value: function renderChildren(_ref2) {
          var _this = this;
          var children = _ref2.children,
            props = _objectWithoutProperties(_ref2, _excluded2);
          if (typeof children === "function") {
            return function (state) {
              return _this.renderTarget(_objectSpread2(_objectSpread2({}, props), {}, {
                children: children(state)
              }));
            };
          }
          return this.renderTarget(_objectSpread2({
            children: children
          }, props));
        }
      }, {
        key: "render",
        value: function render() {
          var _groupProps = partition(this.props),
            transition = _groupProps.transition,
            props = _groupProps.props;
          var transitionClassNames = this.constructor.classNames;
          return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_transition_group_CSSTransition___default.a, _extends({}, transition, props, this.constructor.attrs || {}, Target.attrs || {}, {
            classNames: transitionClassNames
          }), this.renderChildren(_objectSpread2(_objectSpread2({}, props), {}, {
            transitionClassNames: transitionClassNames
          })));
        }
      }], [{
        key: "classNames",
        get: function get() {
          return classNames(this.styledComponentId);
        }
      }, {
        key: "withComponent",
        value: function withComponent() {
          return animatedWithOptions(Target.withComponent.apply(Target, arguments));
        }
      }]);
      return AnimatedComponent;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);
    _defineProperty(AnimatedComponent, "displayName", "Animated(".concat(Target.displayName, ")"));
    _defineProperty(AnimatedComponent, "styledComponentId", Target.styledComponentId);
    _defineProperty(AnimatedComponent, "attrs", attrs);
    var AnimatedComponentWithRef = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(function (props, ref) {
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(AnimatedComponent, _extends({}, props, {
        forwardedRef: ref
      }));
    });
    AnimatedComponentWithRef.Target = Target;
    return AnimatedComponentWithRef;
  };
};
var isAnimatedComponent = function isAnimatedComponent(Klass) {
  return "styledComponentId" in Klass && "classNames" in Klass;
};

var MyStyled = typeof __WEBPACK_IMPORTED_MODULE_3_styled_components__["default"] === "function" ? __WEBPACK_IMPORTED_MODULE_3_styled_components__["default"] : __WEBPACK_IMPORTED_MODULE_3_styled_components__["default"]["default"];

var STATES_BY_NAME = __WEBPACK_IMPORTED_MODULE_4_lodash_invert___default()(STATES);
var PATTERN = new RegExp("([^\\s;}]+|^):(".concat(Object.keys(STATES).map(function (key) {
  return STATES[key];
}).join("|"), ")(?=[\\s\\+~,{])"), "g");
var getClassName = function getClassName(state) {
  return function (props) {
    return "&.".concat(props.transitionClassNames[state]);
  };
};

// Replace &:state with a class name selector
var walkChunk = function walkChunk(_ref) {
  var strings = _ref.strings,
    interpolations = _ref.interpolations;
  return function (_, chunk) {
    var match;
    var lastIndex = 0;
    // eslint-disable-next-line no-cond-assign
    while (match = PATTERN.exec(chunk)) {
      var _match$slice = match.slice(1),
        _match$slice2 = _slicedToArray(_match$slice, 2),
        target = _match$slice2[0],
        element = _match$slice2[1];
      var state = STATES_BY_NAME[element];
      var len = match[0].length;
      if (target === "&") {
        strings.push(chunk.substring(lastIndex, match.index));
        interpolations.splice(strings.length - 1, 0, getClassName(state));
      } else if (target === "") {
        var targetIndex = strings.length - 1;
        var Target = interpolations[targetIndex];
        if (!isAnimatedComponent(Target)) {
          var name = Target && Target.constructor ? Target.constructor.name : Target;
          throw new Error("Invalid transition target \"".concat(name, "\". Target must be an AnimatedComponent."));
        }
        interpolations.splice(targetIndex, 1, ".".concat(Target.classNames[state]));
      } else {
        throw new Error("Invalid transition target \"".concat(target, "\"."));
      }
      lastIndex = match.index + len;
    }
    strings.push(chunk.substring(lastIndex, chunk.length));
  };
};
function parseCss(strings) {
  for (var _len = arguments.length, interpolations = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    interpolations[_key - 1] = arguments[_key];
  }
  var next = {
    strings: [],
    interpolations: [].concat(interpolations)
  };
  strings.reduce(walkChunk(next), null);
  return __WEBPACK_IMPORTED_MODULE_3_styled_components__["css"].apply(void 0, [next.strings].concat(_toConsumableArray(next.interpolations)));
}

var _excluded = ["attrs"];
var _templateObject;
var delegate = function delegate(animated) {
  return function (fun) {
    return function () {
      return animated(fun(_templateObject || (_templateObject = _taggedTemplateLiteral(["", ""])), parseCss.apply(void 0, arguments)));
    };
  };
};
var groupConfig = function groupConfig(_ref) {
  var attrs = _ref.attrs,
    config = _objectWithoutProperties(_ref, _excluded);
  var groups = {
    transition: {},
    styled: _objectSpread2({}, config)
  };
  if (attrs) {
    var _groupProps = partition(attrs),
      transition = _groupProps.transition,
      props = _groupProps.props;
    groups.transition.attrs = transition;
    if (!__WEBPACK_IMPORTED_MODULE_2_lodash_isempty___default()(props)) groups.styled.attrs = props;
  }
  return groups;
};
var extend = function extend(animated, target) {
  var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var _groupConfig = groupConfig(config),
    transition = _groupConfig.transition,
    styledConfig = _groupConfig.styled;
  var delegateThis = function delegateThis(cfg) {
    return delegate(animated(_objectSpread2(_objectSpread2({}, transition), cfg)));
  };
  if (!__WEBPACK_IMPORTED_MODULE_2_lodash_isempty___default()(styledConfig)) {
    return extend(animated, target.withConfig(styledConfig), transition);
  }
  var result = delegateThis({})(target);
  result.withConfig = function (options) {
    var cfg = groupConfig(options);
    return delegateThis(cfg.transition)(target.withConfig(cfg.styled));
  };
  result.attrs = function (attrs) {
    var cfg = groupConfig({
      attrs: attrs
    });
    return delegateThis(cfg.transition)(target.attrs(cfg.styled.attrs));
  };
  return result;
};
var construct = (function (animated, Tag, config) {
  return extend(animated, MyStyled(Tag), config);
});

var index = styled(animated, construct);


//# sourceMappingURL=bundle.es.js.map


/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
    nativeKeys = overArg(Object.keys, Object);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView'),
    Map = getNative(root, 'Map'),
    Promise = getNative(root, 'Promise'),
    Set = getNative(root, 'Set'),
    WeakMap = getNative(root, 'WeakMap');

/** Detect if properties shadowing those on `Object.prototype` are non-enumerable. */
var nonEnumShadows = !propertyIsEnumerable.call({ 'valueOf': 1 }, 'valueOf');

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * The base implementation of `getTag`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  return objectToString.call(value);
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11,
// for data views in Edge < 14, and promises in Node.js.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = objectToString.call(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : undefined;

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */
function isEmpty(value) {
  if (isArrayLike(value) &&
      (isArray(value) || typeof value == 'string' ||
        typeof value.splice == 'function' || isBuffer(value) || isArguments(value))) {
    return !value.length;
  }
  var tag = getTag(value);
  if (tag == mapTag || tag == setTag) {
    return !value.size;
  }
  if (nonEnumShadows || isPrototype(value)) {
    return !nativeKeys(value).length;
  }
  for (var key in value) {
    if (hasOwnProperty.call(value, key)) {
      return false;
    }
  }
  return true;
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = isEmpty;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(71), __webpack_require__(553)(module)))

/***/ }),
/* 553 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 554 */
/***/ (function(module, exports) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]';

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  // Safari 9 makes `arguments.length` enumerable in strict mode.
  var result = (isArray(value) || isArguments(value))
    ? baseTimes(value.length, String)
    : [];

  var length = result.length,
      skipIndexes = !!length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

/**
 * The base implementation of `_.invert` and `_.invertBy` which inverts
 * `object` with values transformed by `iteratee` and set by `setter`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform values.
 * @param {Object} accumulator The initial inverted object.
 * @returns {Function} Returns `accumulator`.
 */
function baseInverter(object, setter, iteratee, accumulator) {
  baseForOwn(object, function(value, key, object) {
    setter(accumulator, iteratee(value), key, object);
  });
  return accumulator;
}

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

/**
 * Creates a function like `_.invertBy`.
 *
 * @private
 * @param {Function} setter The function to set accumulator values.
 * @param {Function} toIteratee The function to resolve iteratees.
 * @returns {Function} Returns the new inverter function.
 */
function createInverter(setter, toIteratee) {
  return function(object, iteratee) {
    return baseInverter(object, setter, toIteratee(iteratee), {});
  };
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Creates an object composed of the inverted keys and values of `object`.
 * If `object` contains duplicate values, subsequent values overwrite
 * property assignments of previous values.
 *
 * @static
 * @memberOf _
 * @since 0.7.0
 * @category Object
 * @param {Object} object The object to invert.
 * @returns {Object} Returns the new inverted object.
 * @example
 *
 * var object = { 'a': 1, 'b': 2, 'c': 1 };
 *
 * _.invert(object);
 * // => { '1': 'c', '2': 'b' }
 */
var invert = createInverter(function(result, value, key) {
  result[value] = key;
}, constant(identity));

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = invert;


/***/ }),
/* 555 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_connect__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_helpers_mixins__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__MainProductImage__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_ProductImage__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_helpers_variables__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__constants_endpoints__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__styles_LoadingSpinner__ = __webpack_require__(557);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__selectors_reselectCategory__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__actions_actionCreators__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__constants_imageTypes__ = __webpack_require__(110);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  position: absolute;\n  top: 100%;\n  left: 0;\n  max-height: calc(100vh - 25px - 100%);\n  width: 100%;\n  background-color: ',';\n  overflow-x: hidden;\n  overflow-y: auto;\n  z-index: 1;\n  @media screen and (min-width: ','px) {\n    top: calc(100% - 20px);\n    left: 50%;\n    max-height: calc(100vh - 35px - 100% + 20px - 20px);\n    width: calc(((100% - (80px * 2)) / 2) - (20px * 2));\n    border: 1px solid ',';\n    ',';\n    transform: translateX(-50%);\n  }\n  @media screen and (min-width: ','px) {\n    width: calc((100% - (80px * 2)) / 2);\n  }\n  @media screen and (min-width: 1580px) {\n    width: ','px;\n  }\n'],['\n  position: absolute;\n  top: 100%;\n  left: 0;\n  max-height: calc(100vh - 25px - 100%);\n  width: 100%;\n  background-color: ',';\n  overflow-x: hidden;\n  overflow-y: auto;\n  z-index: 1;\n  @media screen and (min-width: ','px) {\n    top: calc(100% - 20px);\n    left: 50%;\n    max-height: calc(100vh - 35px - 100% + 20px - 20px);\n    width: calc(((100% - (80px * 2)) / 2) - (20px * 2));\n    border: 1px solid ',';\n    ',';\n    transform: translateX(-50%);\n  }\n  @media screen and (min-width: ','px) {\n    width: calc((100% - (80px * 2)) / 2);\n  }\n  @media screen and (min-width: 1580px) {\n    width: ','px;\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n        border-color: ',';\n      '],['\n        border-color: ',';\n      ']),_templateObject3=_taggedTemplateLiteral(['\n  padding: 20px;\n  background-color: ',';\n  color: ',';\n  font-size: 14px;\n  text-align: center;\n'],['\n  padding: 20px;\n  background-color: ',';\n  color: ',';\n  font-size: 14px;\n  text-align: center;\n']),_templateObject4=_taggedTemplateLiteral(['\n  display: flex;\n  align-items: center;\n  margin-bottom: 10px;\n  text-decoration: none;\n\n  &:last-child {\n    margin-bottom: 0;\n  }\n\n  div:first-child {\n    width: 70px;\n    margin-right: 20px;\n    margin-bottom: 0;\n  }\n\n  p {\n    flex: 1;\n  }\n'],['\n  display: flex;\n  align-items: center;\n  margin-bottom: 10px;\n  text-decoration: none;\n\n  &:last-child {\n    margin-bottom: 0;\n  }\n\n  div:first-child {\n    width: 70px;\n    margin-right: 20px;\n    margin-bottom: 0;\n  }\n\n  p {\n    flex: 1;\n  }\n']),_templateObject5=_taggedTemplateLiteral(['\n  ',';\n  font-size: 20px;\n  font-weight: normal;\n  font-style: normal;\n  font-stretch: normal;\n  line-height: 0.8;\n  letter-spacing: normal;\n  text-align: left;\n  color: #000000 !important;\n  text-decoration: none !important;\n  margin: 0;\n'],['\n  ',';\n  font-size: 20px;\n  font-weight: normal;\n  font-style: normal;\n  font-stretch: normal;\n  line-height: 0.8;\n  letter-spacing: normal;\n  text-align: left;\n  color: #000000 !important;\n  text-decoration: none !important;\n  margin: 0;\n']),_templateObject6=_taggedTemplateLiteral(['\n  display: flex;\n  justify-content: flex-start;\n  padding: 0 15px;\n'],['\n  display: flex;\n  justify-content: flex-start;\n  padding: 0 15px;\n']),_templateObject7=_taggedTemplateLiteral(['\n  margin: 15px 30px 15px 0;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: flex-start;\n  text-align: left;\n'],['\n  margin: 15px 30px 15px 0;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: flex-start;\n  text-align: left;\n']),_templateObject8=_taggedTemplateLiteral(['\n  font-size: 12px;\n  font-weight: 600;\n  font-style: normal;\n  font-stretch: normal;\n  line-height: normal;\n  letter-spacing: 1.8px;\n  text-align: left;\n  color: #000000;\n  text-transform: uppercase;\n  padding: 5px;\n  margin: 0;\n'],['\n  font-size: 12px;\n  font-weight: 600;\n  font-style: normal;\n  font-stretch: normal;\n  line-height: normal;\n  letter-spacing: 1.8px;\n  text-align: left;\n  color: #000000;\n  text-transform: uppercase;\n  padding: 5px;\n  margin: 0;\n']),_templateObject9=_taggedTemplateLiteral(['\n  font-size: 14px;\n  font-weight: normal;\n  font-style: normal;\n  font-stretch: normal;\n  line-height: 1.79;\n  letter-spacing: normal;\n  text-align: left;\n  color: #000000;\n  text-decoration: none;\n  display: inline-block;\n  margin: 0;\n  padding: 4px;\n'],['\n  font-size: 14px;\n  font-weight: normal;\n  font-style: normal;\n  font-stretch: normal;\n  line-height: 1.79;\n  letter-spacing: normal;\n  text-align: left;\n  color: #000000;\n  text-decoration: none;\n  display: inline-block;\n  margin: 0;\n  padding: 4px;\n']),_templateObject10=_taggedTemplateLiteral(['\n  display: block;\n  padding: 12.5px 20px;\n  background-color: ',';\n  color: ',';\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 1.25;\n  letter-spacing: 0.125em;\n  text-decoration: none;\n  text-transform: uppercase;\n  text-align: center;\n  /* @media screen and (min-width: ','px) {\n    margin: 0 -1px -1px -1px;\n  } */\n'],['\n  display: block;\n  padding: 12.5px 20px;\n  background-color: ',';\n  color: ',';\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 1.25;\n  letter-spacing: 0.125em;\n  text-decoration: none;\n  text-transform: uppercase;\n  text-align: center;\n  /* @media screen and (min-width: ','px) {\n    margin: 0 -1px -1px -1px;\n  } */\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SearchResults=function(_Component){_inherits(SearchResults,_Component);function SearchResults(props){_classCallCheck(this,SearchResults);var _this=_possibleConstructorReturn(this,(SearchResults.__proto__||Object.getPrototypeOf(SearchResults)).call(this,props));_this.state={scrollPosition:0,currentPath:undefined};return _this;}_createClass(SearchResults,[{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){if(this.props.viewstate.get('globalSearchActive')!==prevProps.viewstate.get('globalSearchActive')){if(this.props.viewstate.get('globalSearchActive')&&window.innerWidth<__WEBPACK_IMPORTED_MODULE_9__styles_helpers_variables__["b" /* breakpoint */].large){this.enableBodyScrollLock();}else if(document.body.style.position==='fixed'){this.disableBodyScrollLock();}}}},{key:'getSearchResultProducts',value:function getSearchResultProducts(){var _this2=this;var products=this.props.products;return products.sortBy(function(item){return item.get('relevance');}).reverse().take(5).map(function(item){if(!item.get('url')){return false;}var mainImageType=item.get('variants').find(function(variant){return variant.get('id')===item.get('defaultVariantId');}).getIn(['mainImage','type']);var imageUrl=item.getIn(['mainImage','url']);if(mainImageType===__WEBPACK_IMPORTED_MODULE_14__constants_imageTypes__["b" /* MATERIAL_IMAGE */]&&!item.get('allVariantsHaveSameRelevance')){imageUrl=item.get('variants').find(function(variant){return variant.get('id')===item.get('defaultVariantId');}).getIn(['mainImage','url']);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ProductContainer,{key:item.get('id'),to:item.get('url'),onClick:function onClick(){return _this2.props.removeQuickSearch();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__MainProductImage__["a" /* default */],{small:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__styles_ProductImage__["a" /* ProductImage */],{src:__WEBPACK_IMPORTED_MODULE_10__constants_endpoints__["n" /* SITE_ROOT_URL */]+imageUrl}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ProductTitle,null,item.get('name')));}).toArray();}},{key:'getSearchResultPage',value:function getSearchResultPage(pageType){var _this3=this;var globalQuickResults=this.props.globalQuickResults;return globalQuickResults.getIn([pageType,'hits'],Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])()).sortBy(function(item){return item.get('relevance');}).reverse().take(5).map(function(item){var itemData=item.get('item',Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])());if(!itemData.get('url')){return false;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PageLink,{key:itemData.get('id'),to:itemData.get('url'),onClick:function onClick(){return _this3.props.removeQuickSearch();}},pageType==='pages'?itemData.getIn(['fields','title']):itemData.getIn(['name']));}).toArray();}},{key:'getTotalSearchResultHits',value:function getTotalSearchResultHits(){var globalQuickResults=this.props.globalQuickResults;var totalHits=0;globalQuickResults.forEach(function(type){totalHits+=type?type.get('hits',Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["List"])()).size:0;});return totalHits;}},{key:'enableBodyScrollLock',value:function enableBodyScrollLock(){var scrollPosition=window.pageYOffset;this.setState({scrollPosition:scrollPosition,currentPath:this.props.location.pathname});document.body.style.position='fixed';document.body.style.left=0;document.body.style.right=0;document.body.style.top='-'+scrollPosition+'px';document.body.style.overflowY='scroll';}},{key:'disableBodyScrollLock',value:function disableBodyScrollLock(){document.body.removeAttribute('style');if(this.state.currentPath===this.props.location.pathname){window.scrollTo(0,this.state.scrollPosition);}}},{key:'renderPageResult',value:function renderPageResult(title,type){var globalQuickResults=this.props.globalQuickResults;var pages=this.getSearchResultPage(type);if(!globalQuickResults.getIn([type,'hits'],Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])()).size){return false;}// if (!globalQuickResults.getIn([type, 'totalHits'], Map())) {
//   return false;
// }
// if (pages.length === 0) return false;
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CenterText,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PageCategoryTitle,null,title),pages);}},{key:'render',value:function render(){var _props=this.props,globalQuickQuery=_props.globalQuickQuery,globalQuickStatus=_props.globalQuickStatus,viewstate=_props.viewstate;if(!viewstate.get('globalSearchActive')){return null;}var products=this.getSearchResultProducts();var categories=this.renderPageResult('Kategorier','categories');var pages=this.renderPageResult('Sidor','pages');var totalHits=this.getTotalSearchResultHits();return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SearchResultsSearchResults,{loading:globalQuickStatus!=='SUCCESS'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SearchResultProducts,null,products.length?products:'Inga matchande produkter'),(categories||pages)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SearchResultLinks,null,categories,pages),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ShowAllResultsButton,{to:'/sok/'+window.encodeURIComponent(globalQuickQuery)},'Visa alla ',totalHits,' tr\xE4ffar'),globalQuickStatus!=='SUCCESS'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__styles_LoadingSpinner__["a" /* LoadingSpinner */],null));}}]);return SearchResults;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var SearchResultsSearchResults=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject,__WEBPACK_IMPORTED_MODULE_9__styles_helpers_variables__["c" /* color */].white,__WEBPACK_IMPORTED_MODULE_9__styles_helpers_variables__["b" /* breakpoint */].large,__WEBPACK_IMPORTED_MODULE_9__styles_helpers_variables__["c" /* color */].grey,function(props){return props.loading&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject2,__WEBPACK_IMPORTED_MODULE_9__styles_helpers_variables__["c" /* color */].darkerGrey);},__WEBPACK_IMPORTED_MODULE_9__styles_helpers_variables__["b" /* breakpoint */].extraLarge,(1580-80*2)/2);var SearchResultProducts=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject3,__WEBPACK_IMPORTED_MODULE_9__styles_helpers_variables__["c" /* color */].lightGrey,__WEBPACK_IMPORTED_MODULE_9__styles_helpers_variables__["c" /* color */].darkerGrey);var ProductContainer=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["a" /* Link */])(_templateObject4);var ProductTitle=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].p(_templateObject5,__WEBPACK_IMPORTED_MODULE_6__styles_helpers_mixins__["e" /* fontFamilyHeading */]);var SearchResultLinks=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject6);var CenterText=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject7);var PageCategoryTitle=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].p(_templateObject8);var PageLink=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["a" /* Link */])(_templateObject9);var ShowAllResultsButton=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["a" /* Link */])(_templateObject10,__WEBPACK_IMPORTED_MODULE_9__styles_helpers_variables__["c" /* color */].black,__WEBPACK_IMPORTED_MODULE_9__styles_helpers_variables__["c" /* color */].white,__WEBPACK_IMPORTED_MODULE_9__styles_helpers_variables__["b" /* breakpoint */].large);SearchResults.defaultProps={globalQuickResults:Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])(),globalQuickQuery:null,globalQuickStatus:null,viewstate:Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])(),products:Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])()};SearchResults.propTypes={globalQuickResults:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"]),globalQuickQuery:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,globalQuickStatus:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,removeQuickSearch:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired,viewstate:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"]),products:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"]),location:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5__store_connect__["a" /* default */])(SearchResults,{removeQuickSearch:__WEBPACK_IMPORTED_MODULE_13__actions_actionCreators__["U" /* removeQuickSearch */]},function(store){return{globalQuickResults:store.quickSearch.results,globalQuickQuery:store.quickSearch.query,globalQuickStatus:store.quickSearch.status,viewstate:store.viewstate,products:Object(__WEBPACK_IMPORTED_MODULE_12__selectors_reselectCategory__["f" /* getQuickSearchProductsByList */])(store)};}));

/***/ }),
/* 556 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MainProductImageContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return MainProductImageContent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_variables__ = __webpack_require__(4);
var _templateObject=_taggedTemplateLiteral(['\n  position: relative;\n  width: 100%;\n  height: 0;\n  float: ',';\n  padding-bottom: 100%;\n\n  display: block;\n  margin: ',';\n\n  padding-left: ',';\n  padding-right: ',';\n\n  background-color: #fff;\n  border: 1px solid transparent;\n  \n  ','\n  \n  ','\n\n  ','\n'],['\n  position: relative;\n  width: 100%;\n  height: 0;\n  float: ',';\n  padding-bottom: 100%;\n\n  display: block;\n  margin: ',';\n\n  padding-left: ',';\n  padding-right: ',';\n\n  background-color: #fff;\n  border: 1px solid transparent;\n  \n  ','\n  \n  ','\n\n  ','\n']),_templateObject2=_taggedTemplateLiteral(['\n      margin: 0;\n    '],['\n      margin: 0;\n    ']),_templateObject3=_taggedTemplateLiteral(['\n      border: 1px solid ',';\n    '],['\n      border: 1px solid ',';\n    ']),_templateObject4=_taggedTemplateLiteral(['\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  padding: 2rem 0.5rem 0.5rem;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  @media (min-width: ','px) {\n    padding: 2rem 1rem 0.75rem;\n  }\n\n  @media (min-width: ','px) {\n    padding: 3rem 1.75rem;\n  }\n\n  ',';\n'],['\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  padding: 2rem 0.5rem 0.5rem;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  @media (min-width: ','px) {\n    padding: 2rem 1rem 0.75rem;\n  }\n\n  @media (min-width: ','px) {\n    padding: 3rem 1.75rem;\n  }\n\n  ',';\n']),_templateObject5=_taggedTemplateLiteral(['\n      padding: 8px !important;\n    '],['\n      padding: 8px !important;\n    ']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var MainProductImageContainer=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].div(_templateObject,function(props){return props.swipe?'left':'none';},function(props){return props.small?'0 0 .5rem':'0 0 2rem';},function(props){return props.swipe?'calc(8px + ((80 - 8) * ((100vw - '+__WEBPACK_IMPORTED_MODULE_1__helpers_variables__["f" /* size */].small+'px) / ('+__WEBPACK_IMPORTED_MODULE_1__helpers_variables__["f" /* size */].large+' - '+__WEBPACK_IMPORTED_MODULE_1__helpers_variables__["f" /* size */].small+'))))':'0';},function(props){return props.swipe?'calc(8px + ((80 - 8) * ((100vw - '+__WEBPACK_IMPORTED_MODULE_1__helpers_variables__["f" /* size */].small+'px) / ('+__WEBPACK_IMPORTED_MODULE_1__helpers_variables__["f" /* size */].large+' - '+__WEBPACK_IMPORTED_MODULE_1__helpers_variables__["f" /* size */].small+'))))':'0';},function(props){return props.insideList&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(_templateObject2);},function(props){return props.swipe&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(_templateObject2);},function(props){return props.selected&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(_templateObject3,__WEBPACK_IMPORTED_MODULE_1__helpers_variables__["c" /* color */].primary);});var MainProductImageContent=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].div(_templateObject4,__WEBPACK_IMPORTED_MODULE_1__helpers_variables__["f" /* size */].medium,__WEBPACK_IMPORTED_MODULE_1__helpers_variables__["f" /* size */].large,function(props){return props.small&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(_templateObject5);});

/***/ }),
/* 557 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LoadingSpinner; });
/* unused harmony export RelativeLoadingSpinner */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
var _templateObject=_taggedTemplateLiteral(['\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n'],['\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 10;\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  background-color: rgba(0, 0, 0, 0.5);\n\n  &:after {\n    content: \'\';\n    display: block;\n    width: 50px;\n    height: 50px;\n\n    animation: ',' 2s linear infinite;\n\n    background-image: url(\'/images/icons/loading-spinner.svg\');\n    background-position: center;\n    background-size: contain;\n    background-repeat: no-repeat;\n  }\n'],['\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 10;\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  background-color: rgba(0, 0, 0, 0.5);\n\n  &:after {\n    content: \'\';\n    display: block;\n    width: 50px;\n    height: 50px;\n\n    animation: ',' 2s linear infinite;\n\n    background-image: url(\'/images/icons/loading-spinner.svg\');\n    background-position: center;\n    background-size: contain;\n    background-repeat: no-repeat;\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  height: 500px;\n  width: 100%;\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  &:after {\n    content: \'\';\n    display: block;\n    width: 100px;\n    height: 100px;\n\n    animation: ',' 2s linear infinite;\n\n    background-image: url(\'/images/icons/loading-spinner-alt.svg\');\n    background-position: center;\n    background-size: contain;\n    background-repeat: no-repeat;\n  }\n'],['\n  height: 500px;\n  width: 100%;\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  &:after {\n    content: \'\';\n    display: block;\n    width: 100px;\n    height: 100px;\n\n    animation: ',' 2s linear infinite;\n\n    background-image: url(\'/images/icons/loading-spinner-alt.svg\');\n    background-position: center;\n    background-size: contain;\n    background-repeat: no-repeat;\n  }\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var rotate360=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["keyframes"])(_templateObject);var LoadingSpinner=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].div(_templateObject2,rotate360);var RelativeLoadingSpinner=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].div(_templateObject3,rotate360);

/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.defaultMemoize = defaultMemoize;
exports.createSelectorCreator = createSelectorCreator;
exports.createStructuredSelector = createStructuredSelector;
function defaultEqualityCheck(a, b) {
  return a === b;
}

function areArgumentsShallowlyEqual(equalityCheck, prev, next) {
  if (prev === null || next === null || prev.length !== next.length) {
    return false;
  }

  // Do this in a for loop (and not a `forEach` or an `every`) so we can determine equality as fast as possible.
  var length = prev.length;
  for (var i = 0; i < length; i++) {
    if (!equalityCheck(prev[i], next[i])) {
      return false;
    }
  }

  return true;
}

function defaultMemoize(func) {
  var equalityCheck = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultEqualityCheck;

  var lastArgs = null;
  var lastResult = null;
  // we reference arguments instead of spreading them for performance reasons
  return function () {
    if (!areArgumentsShallowlyEqual(equalityCheck, lastArgs, arguments)) {
      // apply arguments instead of spreading for performance.
      lastResult = func.apply(null, arguments);
    }

    lastArgs = arguments;
    return lastResult;
  };
}

function getDependencies(funcs) {
  var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;

  if (!dependencies.every(function (dep) {
    return typeof dep === 'function';
  })) {
    var dependencyTypes = dependencies.map(function (dep) {
      return typeof dep;
    }).join(', ');
    throw new Error('Selector creators expect all input-selectors to be functions, ' + ('instead received the following types: [' + dependencyTypes + ']'));
  }

  return dependencies;
}

function createSelectorCreator(memoize) {
  for (var _len = arguments.length, memoizeOptions = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    memoizeOptions[_key - 1] = arguments[_key];
  }

  return function () {
    for (var _len2 = arguments.length, funcs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      funcs[_key2] = arguments[_key2];
    }

    var recomputations = 0;
    var resultFunc = funcs.pop();
    var dependencies = getDependencies(funcs);

    var memoizedResultFunc = memoize.apply(undefined, [function () {
      recomputations++;
      // apply arguments instead of spreading for performance.
      return resultFunc.apply(null, arguments);
    }].concat(memoizeOptions));

    // If a selector is called with the exact same arguments we don't need to traverse our dependencies again.
    var selector = defaultMemoize(function () {
      var params = [];
      var length = dependencies.length;

      for (var i = 0; i < length; i++) {
        // apply arguments instead of spreading and mutate a local list of params for performance.
        params.push(dependencies[i].apply(null, arguments));
      }

      // apply arguments instead of spreading for performance.
      return memoizedResultFunc.apply(null, params);
    });

    selector.resultFunc = resultFunc;
    selector.recomputations = function () {
      return recomputations;
    };
    selector.resetRecomputations = function () {
      return recomputations = 0;
    };
    return selector;
  };
}

var createSelector = exports.createSelector = createSelectorCreator(defaultMemoize);

function createStructuredSelector(selectors) {
  var selectorCreator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : createSelector;

  if (typeof selectors !== 'object') {
    throw new Error('createStructuredSelector expects first argument to be an object ' + ('where each property is a selector, instead received a ' + typeof selectors));
  }
  var objectKeys = Object.keys(selectors);
  return selectorCreator(objectKeys.map(function (key) {
    return selectors[key];
  }), function () {
    for (var _len3 = arguments.length, values = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      values[_key3] = arguments[_key3];
    }

    return values.reduce(function (composition, value, index) {
      composition[objectKeys[index]] = value;
      return composition;
    }, {});
  });
}

/***/ }),
/* 559 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_connect__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_helpers_variables__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions_actionCreators__ = __webpack_require__(7);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  position: relative;\n  &:before {\n    content: \'\';\n    position: absolute;\n    top: 50%;\n    margin: -7.5px 0 0;\n    left: 12.5px;\n    height: 15px;\n    width: 15px;\n    background-image: url(/images/icons/search.svg);\n    background-position: center;\n    background-repeat: no-repeat;\n    background-size: cover;\n    pointer-events: none;\n  }\n'],['\n  position: relative;\n  &:before {\n    content: \'\';\n    position: absolute;\n    top: 50%;\n    margin: -7.5px 0 0;\n    left: 12.5px;\n    height: 15px;\n    width: 15px;\n    background-image: url(/images/icons/search.svg);\n    background-position: center;\n    background-repeat: no-repeat;\n    background-size: cover;\n    pointer-events: none;\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  display: block;\n  width: 100%;\n  padding: 8.5px 12.5px 8.5px 40px;\n  border: none;\n  border-radius: 0;\n  outline: none;\n  background-color: rgba(255, 255, 255, 0.25);\n  color: ',';\n  font-size: 12px;\n  font-style: italic;\n  line-height: 1.5;\n  ',';\n  @media screen and (min-width: ','px) {\n    padding: 9.5px 12.5px 9.5px 40px;\n    font-size: 14px;\n    ',';\n  }\n  &::placeholder {\n    color: ',';\n  }\n'],['\n  display: block;\n  width: 100%;\n  padding: 8.5px 12.5px 8.5px 40px;\n  border: none;\n  border-radius: 0;\n  outline: none;\n  background-color: rgba(255, 255, 255, 0.25);\n  color: ',';\n  font-size: 12px;\n  font-style: italic;\n  line-height: 1.5;\n  ',';\n  @media screen and (min-width: ','px) {\n    padding: 9.5px 12.5px 9.5px 40px;\n    font-size: 14px;\n    ',';\n  }\n  &::placeholder {\n    color: ',';\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n      padding: 8.5px 40px;\n    '],['\n      padding: 8.5px 40px;\n    ']),_templateObject4=_taggedTemplateLiteral(['\n        padding: 9.5px 40px;\n      '],['\n        padding: 9.5px 40px;\n      ']),_templateObject5=_taggedTemplateLiteral(['\n  display: none;\n  position: absolute;\n  top: 0;\n  right: 0;\n  height: 35px;\n  width: 27.5px;\n  padding: 0;\n  border: none;\n  outline: none;\n  background-color: transparent;\n  color: ',';\n  cursor: pointer;\n  @media screen and (min-width: ','px) {\n    height: 40px;\n  }\n  ',';\n  &:before,\n  &:after {\n    content: \'\';\n    position: absolute;\n    top: 50%;\n    left: 0;\n    height: 1px;\n    width: 15px;\n    background-color: ',';\n  }\n  &:before {\n    transform: rotate(45deg);\n  }\n  &:after {\n    transform: rotate(-45deg);\n  }\n'],['\n  display: none;\n  position: absolute;\n  top: 0;\n  right: 0;\n  height: 35px;\n  width: 27.5px;\n  padding: 0;\n  border: none;\n  outline: none;\n  background-color: transparent;\n  color: ',';\n  cursor: pointer;\n  @media screen and (min-width: ','px) {\n    height: 40px;\n  }\n  ',';\n  &:before,\n  &:after {\n    content: \'\';\n    position: absolute;\n    top: 50%;\n    left: 0;\n    height: 1px;\n    width: 15px;\n    background-color: ',';\n  }\n  &:before {\n    transform: rotate(45deg);\n  }\n  &:after {\n    transform: rotate(-45deg);\n  }\n']),_templateObject6=_taggedTemplateLiteral(['\n      display: block;\n    '],['\n      display: block;\n    ']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SearchInput=function(_Component){_inherits(SearchInput,_Component);function SearchInput(props){_classCallCheck(this,SearchInput);var _this=_possibleConstructorReturn(this,(SearchInput.__proto__||Object.getPrototypeOf(SearchInput)).call(this,props));_this.state={queryLength:0,lastTimestamp:0};_this.inputRef=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();_this.onKeyPress=_this.onKeyPress.bind(_this);_this.clearInput=_this.clearInput.bind(_this);return _this;}_createClass(SearchInput,[{key:'onKeyPress',value:function onKeyPress(event){if(event.key==='Enter'){if(this.props.location.pathname.includes('/sok')){this.props.fetchGlobalSearch(event.target.value);}else{this.props.history.push('/sok/'+window.encodeURIComponent(event.target.value));}}}},{key:'clearInput',value:function clearInput(){this.inputRef.current.value='';this.inputRef.current.focus();this.setState({queryLength:0});this.props.setViewstate('globalSearchActive',false);}},{key:'globalSearchInputHandler',value:function globalSearchInputHandler(event){var _this2=this;var searchTimeout=125;var timeStamp=event.timeStamp;var value=event.target.value;var length=value.length;if(timeStamp-searchTimeout>this.state.lastTimestamp&&value&&length>=2){this.props.fetchQuickSearch(value);}else{setTimeout(function(){if(timeStamp===_this2.state.lastTimestamp&&value){_this2.props.fetchQuickSearch(value);}},searchTimeout);}this.setState({queryLength:length,lastTimestamp:timeStamp});this.props.setViewstate('globalSearchActive',!!length);}},{key:'render',value:function render(){var _this3=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SearchInputContainer,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SearchInputInput,{innerRef:this.inputRef,onChange:function onChange(event){_this3.globalSearchInputHandler(event);},onFocus:function onFocus(event){if(_this3.state.queryLength>0){_this3.globalSearchInputHandler(event);}},onKeyPress:this.onKeyPress,active:this.state.queryLength>=1}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SearchInputClear,{onClick:this.clearInput,active:this.state.queryLength>=1}));}}]);return SearchInput;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var SearchInputContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject);var SearchInputInput=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].input.attrs({type:'text',placeholder:'Sök efter produkter, varumärke eller formgivare…'})(_templateObject2,__WEBPACK_IMPORTED_MODULE_4__styles_helpers_variables__["c" /* color */].white,function(props){return props.active&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject3);},__WEBPACK_IMPORTED_MODULE_4__styles_helpers_variables__["b" /* breakpoint */].large,function(props){return props.active&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject4);},__WEBPACK_IMPORTED_MODULE_4__styles_helpers_variables__["c" /* color */].white);var SearchInputClear=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].button(_templateObject5,__WEBPACK_IMPORTED_MODULE_4__styles_helpers_variables__["c" /* color */].white,__WEBPACK_IMPORTED_MODULE_4__styles_helpers_variables__["b" /* breakpoint */].large,function(props){return props.active&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject6);},__WEBPACK_IMPORTED_MODULE_4__styles_helpers_variables__["c" /* color */].white);SearchInput.defaultProps={};SearchInput.propTypes={setViewstate:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,fetchQuickSearch:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,fetchGlobalSearch:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,location:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,history:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3__store_connect__["a" /* default */])(SearchInput,{setViewstate:__WEBPACK_IMPORTED_MODULE_5__actions_actionCreators__["W" /* setViewstate */],fetchGlobalSearch:__WEBPACK_IMPORTED_MODULE_5__actions_actionCreators__["B" /* fetchGlobalSearch */],removeGlobalSearch:__WEBPACK_IMPORTED_MODULE_5__actions_actionCreators__["T" /* removeGlobalSearch */],fetchQuickSearch:__WEBPACK_IMPORTED_MODULE_5__actions_actionCreators__["N" /* fetchQuickSearch */],removeQuickSearch:__WEBPACK_IMPORTED_MODULE_5__actions_actionCreators__["U" /* removeQuickSearch */]}));

/***/ }),
/* 560 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_grid_styled__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_grid_styled___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_grid_styled__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_connect__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__actions_actionCreators__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_helpers_variables__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_Container__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__styles_NoStyleLink__ = __webpack_require__(237);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  list-style: none;\n  margin: 0;\n  padding: 0;\n'],['\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  list-style: none;\n  margin: 0;\n  padding: 0;\n']),_templateObject2=_taggedTemplateLiteral(['\n  min-width: 0;\n  margin: 0 20px 0 0;\n  &:last-child {\n    margin: 0;\n  }\n'],['\n  min-width: 0;\n  margin: 0 20px 0 0;\n  &:last-child {\n    margin: 0;\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  display: block;\n  padding: 0 0 13px;\n  border-bottom: 2px solid transparent;\n  color: ',';\n  font-size: 16px;\n  line-height: 1.25;\n  text-decoration: none;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n  transition: border-bottom-color 0.25s ease-out, color 0.25s ease-out;\n  ',';\n  &:hover {\n    color: rgba(255, 255, 255, 0.875);\n  }\n  &:active {\n    color: rgba(255, 255, 255, 0.75);\n  }\n'],['\n  display: block;\n  padding: 0 0 13px;\n  border-bottom: 2px solid transparent;\n  color: ',';\n  font-size: 16px;\n  line-height: 1.25;\n  text-decoration: none;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n  transition: border-bottom-color 0.25s ease-out, color 0.25s ease-out;\n  ',';\n  &:hover {\n    color: rgba(255, 255, 255, 0.875);\n  }\n  &:active {\n    color: rgba(255, 255, 255, 0.75);\n  }\n']),_templateObject4=_taggedTemplateLiteral(['\n      border-bottom-color: ',';\n    '],['\n      border-bottom-color: ',';\n    ']),_templateObject5=_taggedTemplateLiteral(['\n  position: absolute;\n  top: 100%;\n  left: 0;\n  width: 100%;\n  padding: 40px 0 80px;\n  background-color: ',';\n  visibility: hidden;\n  z-index: 100;\n  ',';\n'],['\n  position: absolute;\n  top: 100%;\n  left: 0;\n  width: 100%;\n  padding: 40px 0 80px;\n  background-color: ',';\n  visibility: hidden;\n  z-index: 100;\n  ',';\n']),_templateObject6=_taggedTemplateLiteral(['\n      visibility: visible;\n    '],['\n      visibility: visible;\n    ']),_templateObject7=_taggedTemplateLiteral(['\n  list-style: none;\n  padding: 0;\n'],['\n  list-style: none;\n  padding: 0;\n']),_templateObject8=_taggedTemplateLiteral(['\n  font-size: 12px;\n  font-weight: 600;\n  font-style: normal;\n  font-stretch: normal;\n  line-height: normal;\n  letter-spacing: 1.5px;\n  color: ',';\n  text-transform: uppercase;\n  margin-bottom: 40px;\n  &:last-child {\n    margin-bottom: 0;\n  }\n\n  span {\n    display: inline-block;\n    margin-bottom: 8px;\n  }\n\n  ',';\n'],['\n  font-size: 12px;\n  font-weight: 600;\n  font-style: normal;\n  font-stretch: normal;\n  line-height: normal;\n  letter-spacing: 1.5px;\n  color: ',';\n  text-transform: uppercase;\n  margin-bottom: 40px;\n  &:last-child {\n    margin-bottom: 0;\n  }\n\n  span {\n    display: inline-block;\n    margin-bottom: 8px;\n  }\n\n  ',';\n']),_templateObject9=_taggedTemplateLiteral(['\n      span {\n        position: relative;\n\n        &:before {\n          content: \'\';\n          position: absolute;\n          right: -0.1em;\n          bottom: 0;\n          left: -0.1em;\n          height: 90%;\n          opacity: 0.5;\n          background-color: #d3d3d3;\n          z-index: -1;\n        }\n      }\n    '],['\n      span {\n        position: relative;\n\n        &:before {\n          content: \'\';\n          position: absolute;\n          right: -0.1em;\n          bottom: 0;\n          left: -0.1em;\n          height: 90%;\n          opacity: 0.5;\n          background-color: #d3d3d3;\n          z-index: -1;\n        }\n      }\n    ']),_templateObject10=_taggedTemplateLiteral(['\n  padding: 0;\n  list-style: none;\n  width: 100%;\n'],['\n  padding: 0;\n  list-style: none;\n  width: 100%;\n']),_templateObject11=_taggedTemplateLiteral(['\n  font-size: 14px;\n  font-weight: normal;\n  font-style: normal;\n  font-stretch: normal;\n  line-height: 1.79;\n  letter-spacing: normal;\n  color: ',';\n  text-transform: none;\n\n  ',';\n'],['\n  font-size: 14px;\n  font-weight: normal;\n  font-style: normal;\n  font-stretch: normal;\n  line-height: 1.79;\n  letter-spacing: normal;\n  color: ',';\n  text-transform: none;\n\n  ',';\n']),_templateObject12=_taggedTemplateLiteral(['\n      a {\n        position: relative;\n\n        &:before {\n          content: \'\';\n          position: absolute;\n          right: -0.1em;\n          bottom: 0;\n          left: -0.1em;\n          height: 90%;\n          opacity: 0.5;\n          background-color: #d3d3d3;\n          z-index: -1;\n        }\n      }\n    '],['\n      a {\n        position: relative;\n\n        &:before {\n          content: \'\';\n          position: absolute;\n          right: -0.1em;\n          bottom: 0;\n          left: -0.1em;\n          height: 90%;\n          opacity: 0.5;\n          background-color: #d3d3d3;\n          z-index: -1;\n        }\n      }\n    ']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MainMenu=function(_Component){_inherits(MainMenu,_Component);function MainMenu(props){_classCallCheck(this,MainMenu);var _this=_possibleConstructorReturn(this,(MainMenu.__proto__||Object.getPrototypeOf(MainMenu)).call(this,props));_this.hoverTimeout=null;_this.clearActiveMenuItem=_this.clearActiveMenuItem.bind(_this);return _this;}_createClass(MainMenu,[{key:'setActiveMenuItem',value:function setActiveMenuItem(id,itemHasDropdown){if(itemHasDropdown){this.props.removeViewstate('globalSearchActive');clearTimeout(this.hoverTimeout);this.props.setViewstate('activeMenuItem',id);}}},{key:'clearActiveMenuItem',value:function clearActiveMenuItem(){var _this2=this;clearTimeout(this.hoverTimeout);this.hoverTimeout=setTimeout(function(){_this2.props.removeViewstate('activeMenuItem');},250);}},{key:'renderMenuItem',value:function renderMenuItem(){var _this3=this;return this.props.sitemap.get('children',Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])()).filter(function(item){return item.get('visibleInMenu');}).map(function(item){var itemHasDropdown=!!item.getIn(['children'],Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])()).filter(function(itemChild){return itemChild.get('visibleInMenu')===true;}).size;var active=_this3.props.viewstate.get('activeMenuItem')===item.get('id');return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MainMenuListItem,{key:item.get('id'),onMouseEnter:function onMouseEnter(){return _this3.setActiveMenuItem(item.get('id'),itemHasDropdown);},onMouseLeave:function onMouseLeave(){return _this3.clearActiveMenuItem();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MainMenuListItemLink,{to:item.get('url'),active:active},item.get('title')),itemHasDropdown&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Submenu,{active:active},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__styles_Container__["a" /* Container */],{noPadding:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SubmenuList,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grid_styled__["Flex"],{mx:'-10px'},_this3.renderSubMenu(item))))));}).toArray();}},{key:'renderSubMenu',value:function renderSubMenu(item){var _this4=this;// a method with some fancy logic that divides the submenuitems evenly based on how many children they have
var pageWidth=this.props.viewstate.get('pageWidth');var width=void 0;if(pageWidth<1100){width=4;}else if(pageWidth<1300){width=5;}else{width=6;}var allItems=item.getIn(['children'],Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])());// get the smallest value of width or the number of children
var widthOrNumberOfItems=allItems.size<width?allItems.size:width;// define array where result of our logic is placed
var myArray=[];// loop through our children to place the first row of children according to the order set in the CMS
for(var i=0;i<widthOrNumberOfItems;i+=1){myArray.push({counter:allItems.getIn([i,'children'],Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])()).size,items:[i]});}// loop through the rest of out children and place them in the column with the least number of items
allItems.slice(width).sort(function(a,b){if(a.get('children',Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])()).size>b.get('children',Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])()).size){return-1;}if(a.get('children',Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])()).size<b.get('children',Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])()).size){return 1;}// a must be equal to b
return 0;}).forEach(function(childItem,index){var adjustedIndex=index+width;var smallestIndex=0;myArray.forEach(function(arrayItem,arrayItemIndex){if(arrayItem.counter<myArray[smallestIndex].counter+(myArray[smallestIndex].items.length*2-2)){smallestIndex=arrayItemIndex;}});myArray[smallestIndex].counter+=childItem.get('children',Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])()).size;myArray[smallestIndex].items.push(adjustedIndex);return true;});// take the result from our logic and render the DOM according to the order we set
return myArray.map(function(block){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grid_styled__["Box"],{key:block.items,width:1/width,px:'10px'},block.items.map(function(blockItem){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SubMenuListItem,{key:allItems.get(blockItem).get('url'),isCurrentPage:allItems.get(blockItem).get('url')===_this4.props.location.pathname},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__styles_NoStyleLink__["a" /* NoStyleLink */],{to:allItems.get(blockItem).get('url')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,allItems.get(blockItem).get('title'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SubSubMenuList,null,_this4.renderSubMenuItems(allItems.get(blockItem).get('children',Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])()))));}));});}},{key:'renderSubMenuItems',value:function renderSubMenuItems(itemList){var _this5=this;return itemList.map(function(child){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SubSubMenuListItem,{key:child.get('url'),isCurrentPage:child.get('url')===_this5.props.location.pathname},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__styles_NoStyleLink__["a" /* NoStyleLink */],{to:child.get('url')},child.get('title')));});}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MainMenuList,null,this.renderMenuItem());}}]);return MainMenu;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var MainMenuList=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].ul(_templateObject);var MainMenuListItem=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].li(_templateObject2);var MainMenuListItemLink=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["a" /* Link */])(_templateObject3,__WEBPACK_IMPORTED_MODULE_8__styles_helpers_variables__["c" /* color */].white,function(props){return props.active&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject4,__WEBPACK_IMPORTED_MODULE_8__styles_helpers_variables__["c" /* color */].white);});var Submenu=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject5,__WEBPACK_IMPORTED_MODULE_8__styles_helpers_variables__["c" /* color */].white,function(props){return props.active&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject6);});var SubmenuList=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].ul(_templateObject7);var SubMenuListItem=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].li(_templateObject8,__WEBPACK_IMPORTED_MODULE_8__styles_helpers_variables__["c" /* color */].black,function(props){return props.isCurrentPage&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject9);});var SubSubMenuList=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].ul(_templateObject10);var SubSubMenuListItem=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].li(_templateObject11,__WEBPACK_IMPORTED_MODULE_8__styles_helpers_variables__["c" /* color */].black,function(props){return props.isCurrentPage&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject12);});MainMenu.defaultProps={viewstate:Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])(),sitemap:Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])()};MainMenu.propTypes={setViewstate:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func.isRequired,removeViewstate:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func.isRequired,viewstate:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"]),location:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object.isRequired,sitemap:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6__store_connect__["a" /* default */])(MainMenu,{setViewstate:__WEBPACK_IMPORTED_MODULE_7__actions_actionCreators__["W" /* setViewstate */],removeViewstate:__WEBPACK_IMPORTED_MODULE_7__actions_actionCreators__["V" /* removeViewstate */]},function(store){return{viewstate:store.viewstate,sitemap:Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["fromJS"])(window.sitemap)};}));

/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.System = undefined;

var _System = __webpack_require__(562);

Object.defineProperty(exports, 'System', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_System).default;
  }
});

var _styledComponents = __webpack_require__(2);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _System2 = _interopRequireDefault(_System);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var create = new _System2.default({
  createComponent: function createComponent(type) {
    return function () {
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return (0, _styledComponents2.default)(type).apply(undefined, [[]].concat(args));
    };
  }
});

exports.default = create;

/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _styledSystem = __webpack_require__(563);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var funcNames = Object.keys(_styledSystem.styles);
var unique = function unique(arr) {
  var seen = {};
  return arr.concat().filter(function (item) {
    return seen.hasOwnProperty(item) ? false : seen[item] = true;
  });
};
var isPOJO = function isPOJO(n) {
  return (typeof n === 'undefined' ? 'undefined' : _typeof(n)) === 'object' && n !== null && !Array.isArray(n);
};

var dict = Object.keys(_styledSystem.styles).map(function (key) {
  return {
    key: key,
    propNames: Object.keys(_styledSystem.styles[key].propTypes || {})
  };
}).reduce(function (acc, b) {
  var vals = b.propNames.reduce(function (a, name) {
    return _extends({}, a, _defineProperty({}, name, b.key));
  }, {});
  return _extends({}, acc, vals);
}, {});

var getPropKeys = function getPropKeys(defaultProps) {
  return Object.keys(defaultProps || {}).map(function (key) {
    return dict[key];
  }).filter(function (key) {
    return !!key;
  });
};

var getFuncs = function getFuncs(keys) {
  return keys.map(function (f) {
    return _styledSystem.styles[f] || f;
  }).reduce(function (a, f) {
    return Array.isArray(f) ? [].concat(_toConsumableArray(a), _toConsumableArray(f)) : [].concat(_toConsumableArray(a), [f]);
  }, []);
};

var getPropTypes = function getPropTypes(keys) {
  return keys.filter(function (key) {
    return typeof key === 'string';
  }).filter(function (key) {
    return typeof _styledSystem.styles[key] === 'function';
  }).map(function (key) {
    return _styledSystem.styles[key].propTypes || {};
  }).reduce(function (a, propType) {
    return _extends({}, a, propType);
  }, {});
};

var css = function css(props) {
  return props.css;
};

var omit = function omit(obj, blacklist) {
  var next = {};
  for (var key in obj) {
    if (blacklist.indexOf(key) > -1) continue;
    next[key] = obj[key];
  }
  return next;
};

var tag = _react2.default.forwardRef(function (_ref, ref) {
  var _ref$is = _ref.is,
      Tag = _ref$is === undefined ? 'div' : _ref$is,
      _ref$blacklist = _ref.blacklist,
      blacklist = _ref$blacklist === undefined ? [] : _ref$blacklist,
      props = _objectWithoutProperties(_ref, ['is', 'blacklist']);

  return _react2.default.createElement(Tag, _extends({
    ref: ref
  }, omit(props, blacklist)));
});

var System = function System(opts) {
  _classCallCheck(this, System);

  var createComponent = opts.createComponent;


  this.create = function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var first = args[0],
        rest = args.slice(1);


    var defaultProps = isPOJO(first) ? first : null;
    var propKeys = getPropKeys(defaultProps);
    var funcsOrKeys = defaultProps ? rest : args;
    var combined = unique([].concat(_toConsumableArray(propKeys), _toConsumableArray(funcsOrKeys)));
    var funcs = getFuncs(combined);
    var propTypes = getPropTypes(combined);

    var blacklist = ['css'].concat(_toConsumableArray(Object.keys(propTypes)), _toConsumableArray(defaultProps ? defaultProps.blacklist || [] : []));

    var Base = defaultProps && typeof defaultProps.is === 'function' ? defaultProps.is : tag;

    var Component = createComponent(Base).apply(undefined, [css].concat(_toConsumableArray(funcs)));

    var baseProps = _styledSystem.util.get(defaultProps, 'is.defaultProps') || {};
    Component.defaultProps = _extends({}, baseProps, {
      blacklist: [].concat(_toConsumableArray(blacklist), _toConsumableArray(baseProps.blacklist || []))
    }, defaultProps);
    Component.propTypes = propTypes;
    Component.systemComponent = true;

    return Component;
  };

  return this.create;
};

exports.default = System;

/***/ }),
/* 563 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "propTypes", function() { return propTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defaultBreakpoints", function() { return defaultBreakpoints; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "is", function() { return is; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "num", function() { return num; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "px", function() { return px; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isArray", function() { return isArray; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isObject", function() { return isObject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "get", function() { return get; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "themeGet", function() { return themeGet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "cloneFunc", function() { return cloneFunc; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "merge", function() { return merge; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "compose", function() { return compose; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createMediaQuery", function() { return createMediaQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "style", function() { return style; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getWidth", function() { return getWidth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "variant", function() { return variant; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "util", function() { return util; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "space", function() { return space; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "width", function() { return width; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fontSize", function() { return fontSize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "textColor", function() { return textColor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "bgColor", function() { return bgColor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "color", function() { return color; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fontFamily", function() { return fontFamily; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "textAlign", function() { return textAlign; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "lineHeight", function() { return lineHeight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fontWeight", function() { return fontWeight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fontStyle", function() { return fontStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "letterSpacing", function() { return letterSpacing; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "display", function() { return display; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "maxWidth", function() { return maxWidth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "minWidth", function() { return minWidth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "height", function() { return height; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "maxHeight", function() { return maxHeight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "minHeight", function() { return minHeight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "sizeWidth", function() { return sizeWidth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "sizeHeight", function() { return sizeHeight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "size", function() { return size; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ratioPadding", function() { return ratioPadding; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ratio", function() { return ratio; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "verticalAlign", function() { return verticalAlign; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "alignItems", function() { return alignItems; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "alignContent", function() { return alignContent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "justifyItems", function() { return justifyItems; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "justifyContent", function() { return justifyContent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "flexWrap", function() { return flexWrap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "flexBasis", function() { return flexBasis; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "flexDirection", function() { return flexDirection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "flex", function() { return flex; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "justifySelf", function() { return justifySelf; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "alignSelf", function() { return alignSelf; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "order", function() { return order; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "gridGap", function() { return gridGap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "gridColumnGap", function() { return gridColumnGap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "gridRowGap", function() { return gridRowGap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "gridColumn", function() { return gridColumn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "gridRow", function() { return gridRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "gridAutoFlow", function() { return gridAutoFlow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "gridAutoColumns", function() { return gridAutoColumns; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "gridAutoRows", function() { return gridAutoRows; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "gridTemplateColumns", function() { return gridTemplateColumns; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "gridTemplateRows", function() { return gridTemplateRows; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "gridTemplateAreas", function() { return gridTemplateAreas; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "gridArea", function() { return gridArea; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "border", function() { return border; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "borderTop", function() { return borderTop; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "borderRight", function() { return borderRight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "borderBottom", function() { return borderBottom; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "borderLeft", function() { return borderLeft; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "borders", function() { return borders; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "borderColor", function() { return borderColor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "borderRadius", function() { return borderRadius; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "boxShadow", function() { return boxShadow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "opacity", function() { return opacity; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "overflow", function() { return overflow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "background", function() { return background; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "backgroundImage", function() { return backgroundImage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "backgroundSize", function() { return backgroundSize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "backgroundPosition", function() { return backgroundPosition; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "backgroundRepeat", function() { return backgroundRepeat; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "position", function() { return position; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "zIndex", function() { return zIndex; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "top", function() { return top; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "right", function() { return right; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "bottom", function() { return bottom; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "left", function() { return left; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "textStyle", function() { return textStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "colorStyle", function() { return colorStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "buttonStyle", function() { return buttonStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "styles", function() { return styles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mixed", function() { return mixed; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);

 // utils

var noop = function noop(n) {
  return n;
};

var propTypes = {
  numberOrString: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  responsive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object])
};
var defaultBreakpoints = [40, 52, 64].map(function (n) {
  return n + 'em';
});
var is = function is(n) {
  return n !== undefined && n !== null;
};
var num = function num(n) {
  return typeof n === 'number' && !isNaN(n);
};
var px = function px(n) {
  return num(n) ? n + 'px' : n;
};
var isArray = Array.isArray;

var isObject = function isObject(n) {
  return typeof n === 'object' && n !== null;
};
var get = function get(obj) {
  for (var _len = arguments.length, paths = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    paths[_key - 1] = arguments[_key];
  }

  return paths.join('.').split('.').reduce(function (a, b) {
    return a && a[b] ? a[b] : null;
  }, obj);
};
var themeGet = function themeGet(paths, fallback) {
  return function (props) {
    return get(props.theme, paths) || fallback;
  };
};
var cloneFunc = function cloneFunc(fn) {
  return function () {
    return fn.apply(void 0, arguments);
  };
};
var merge = function merge(a, b) {
  return Object.assign({}, a, b, Object.keys(b || {}).reduce(function (obj, key) {
    var _Object$assign;

    return Object.assign(obj, (_Object$assign = {}, _Object$assign[key] = a[key] !== null && typeof a[key] === 'object' ? merge(a[key], b[key]) : b[key], _Object$assign));
  }, {}));
};
var compose = function compose() {
  for (var _len2 = arguments.length, funcs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    funcs[_key2] = arguments[_key2];
  }

  var fn = function fn(props) {
    return funcs.map(function (fn) {
      return fn(props);
    }).filter(Boolean).reduce(merge, {});
  };

  fn.propTypes = funcs.map(function (fn) {
    return fn.propTypes;
  }).reduce(merge, {});
  return fn;
};
var createMediaQuery = function createMediaQuery(n) {
  return "@media screen and (min-width: " + px(n) + ")";
};

var getStyles = function getStyles(_ref) {
  var props = _ref.props,
      style = _ref.style,
      value = _ref.value;

  if (!isObject(value)) {
    return style(value);
  } // how to hoist this up??


  var breakpoints = get(props.theme, 'breakpoints') || defaultBreakpoints;

  if (isArray(value)) {
    var _styles = style(value[0]) || {};

    for (var i = 1; i < value.length; i++) {
      var rule = style(value[i]);

      if (rule) {
        var media = createMediaQuery(breakpoints[i - 1]);
        _styles[media] = rule;
      }
    }

    return _styles;
  }

  var styles = {};

  for (var breakpoint in value) {
    var _minWidth = breakpoints[breakpoint];

    if (!_minWidth) {
      Object.assign(styles, style(value[breakpoint]));
    } else {
      var _rule = style(value[breakpoint]);

      var _media = createMediaQuery(_minWidth);

      styles[_media] = _rule;
    }
  }

  return styles;
};

var style = function style(_ref2) {
  var _fn$propTypes;

  var prop = _ref2.prop,
      cssProperty = _ref2.cssProperty,
      key = _ref2.key,
      getter = _ref2.getter,
      transformValue = _ref2.transformValue,
      _ref2$scale = _ref2.scale,
      defaultScale = _ref2$scale === void 0 ? {} : _ref2$scale;
  var css = cssProperty || prop;
  var transform = transformValue || getter || noop;

  var fn = function fn(props) {
    var value = props[prop];
    if (!is(value)) return null;
    var scale = get(props.theme, key) || defaultScale;

    var style = function style(n) {
      var _ref3;

      return is(n) ? (_ref3 = {}, _ref3[css] = transform(get(scale, n) || n), _ref3) : null;
    };

    return getStyles({
      props: props,
      style: style,
      value: value
    });
  };

  fn.propTypes = (_fn$propTypes = {}, _fn$propTypes[prop] = cloneFunc(propTypes.responsive), _fn$propTypes);
  fn.propTypes[prop].meta = {
    prop: prop,
    themeKey: key,
    styleType: 'responsive'
  };
  return fn;
};
var getWidth = function getWidth(n) {
  return !num(n) || n > 1 ? px(n) : n * 100 + '%';
}; // variant

var variant = function variant(_ref4) {
  var _fn$propTypes2;

  var key = _ref4.key,
      _ref4$prop = _ref4.prop,
      prop = _ref4$prop === void 0 ? 'variant' : _ref4$prop;

  var fn = function fn(props) {
    return get(props.theme, key, props[prop]) || null;
  };

  fn.propTypes = (_fn$propTypes2 = {}, _fn$propTypes2[prop] = propTypes.numberOrString, _fn$propTypes2);
  return fn;
};
var util = {
  propTypes: propTypes,
  defaultBreakpoints: defaultBreakpoints,
  is: is,
  num: num,
  px: px,
  get: get,
  themeGet: themeGet,
  cloneFunc: cloneFunc,
  merge: merge,
  compose: compose,
  createMediaQuery: createMediaQuery,
  style: style // space

};

var isNegative = function isNegative(n) {
  return n < 0;
};

var REG = /^[mp][trblxy]?$/;
var properties = {
  m: 'margin',
  p: 'padding'
};
var directions = {
  t: 'Top',
  r: 'Right',
  b: 'Bottom',
  l: 'Left',
  x: ['Left', 'Right'],
  y: ['Top', 'Bottom']
};

var getProperties = function getProperties(key) {
  var _key$split = key.split(''),
      a = _key$split[0],
      b = _key$split[1];

  var property = properties[a];
  var direction = directions[b] || '';
  return Array.isArray(direction) ? direction.map(function (dir) {
    return property + dir;
  }) : [property + direction];
};

var getValue = function getValue(scale) {
  return function (n) {
    if (!num(n)) {
      return px(get(scale, n) || n);
    }

    var abs = Math.abs(n);
    var neg = isNegative(n);
    var value = scale[abs] || abs;

    if (!num(value)) {
      return neg ? '-' + value : value;
    }

    return px(value * (neg ? -1 : 1));
  };
};

var defaultScale = [0, 4, 8, 16, 32, 64, 128, 256, 512];
var space = function space(props) {
  var keys = Object.keys(props).filter(function (key) {
    return REG.test(key);
  }).sort();
  var scale = get(props.theme, 'space') || defaultScale;
  var getStyle = getValue(scale);
  return keys.map(function (key) {
    var value = props[key];
    var properties = getProperties(key);

    var style = function style(n) {
      return is(n) ? properties.reduce(function (a, prop) {
        var _extends2;

        return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, a, (_extends2 = {}, _extends2[prop] = getStyle(n), _extends2));
      }, {}) : null;
    };

    return getStyles({
      props: props,
      style: style,
      value: value
    });
  }).reduce(merge, {});
};
space.propTypes = {
  m: cloneFunc(propTypes.responsive),
  mt: cloneFunc(propTypes.responsive),
  mr: cloneFunc(propTypes.responsive),
  mb: cloneFunc(propTypes.responsive),
  ml: cloneFunc(propTypes.responsive),
  mx: cloneFunc(propTypes.responsive),
  my: cloneFunc(propTypes.responsive),
  p: cloneFunc(propTypes.responsive),
  pt: cloneFunc(propTypes.responsive),
  pr: cloneFunc(propTypes.responsive),
  pb: cloneFunc(propTypes.responsive),
  pl: cloneFunc(propTypes.responsive),
  px: cloneFunc(propTypes.responsive),
  py: cloneFunc(propTypes.responsive)
};

var meta = function meta(prop) {
  return {
    prop: prop,
    themeKey: 'space',
    styleType: 'responsive'
  };
};

Object.keys(space.propTypes).forEach(function (prop) {
  space.propTypes[prop].meta = meta(prop);
}); // styles

var width = style({
  prop: 'width',
  transformValue: getWidth
});
var fontSize = style({
  prop: 'fontSize',
  key: 'fontSizes',
  transformValue: px,
  scale: [12, 14, 16, 20, 24, 32, 48, 64, 72]
});
var textColor = style({
  prop: 'color',
  key: 'colors'
});
var bgColor = style({
  prop: 'bg',
  cssProperty: 'backgroundColor',
  key: 'colors'
});
var color = compose(textColor, bgColor); // typography

var fontFamily = style({
  prop: 'fontFamily',
  key: 'fonts'
});
var textAlign = style({
  prop: 'textAlign'
});
var lineHeight = style({
  prop: 'lineHeight',
  key: 'lineHeights'
});
var fontWeight = style({
  prop: 'fontWeight',
  key: 'fontWeights'
});
var fontStyle = style({
  prop: 'fontStyle'
});
var letterSpacing = style({
  prop: 'letterSpacing',
  key: 'letterSpacings',
  transformValue: px
}); // layout

var display = style({
  prop: 'display'
});
var maxWidth = style({
  prop: 'maxWidth',
  key: 'maxWidths',
  transformValue: px
});
var minWidth = style({
  prop: 'minWidth',
  key: 'minWidths',
  transformValue: px
});
var height = style({
  prop: 'height',
  key: 'heights',
  transformValue: px
});
var maxHeight = style({
  prop: 'maxHeight',
  key: 'maxHeights',
  transformValue: px
});
var minHeight = style({
  prop: 'minHeight',
  key: 'minHeights',
  transformValue: px
});
var sizeWidth = style({
  prop: 'size',
  cssProperty: 'width',
  transformValue: px
});
var sizeHeight = style({
  prop: 'size',
  cssProperty: 'height',
  transformValue: px
});
var size = compose(sizeHeight, sizeWidth);
var ratioPadding = style({
  prop: 'ratio',
  cssProperty: 'paddingBottom',
  transformValue: function transformValue(n) {
    return n * 100 + '%';
  }
});
var ratio = function ratio(props) {
  return props.ratio ? Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    height: 0
  }, ratioPadding(props)) : null;
};
ratio.propTypes = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, ratioPadding.propTypes);
var verticalAlign = style({
  prop: 'verticalAlign'
}); // flexbox

var alignItems = style({
  prop: 'alignItems'
});
var alignContent = style({
  prop: 'alignContent'
});
var justifyItems = style({
  prop: 'justifyItems'
});
var justifyContent = style({
  prop: 'justifyContent'
});
var flexWrap = style({
  prop: 'flexWrap'
});
var flexBasis = style({
  prop: 'flexBasis',
  transformValue: getWidth
});
var flexDirection = style({
  prop: 'flexDirection'
});
var flex = style({
  prop: 'flex'
});
var justifySelf = style({
  prop: 'justifySelf'
});
var alignSelf = style({
  prop: 'alignSelf'
});
var order = style({
  prop: 'order'
}); // grid

var gridGap = style({
  prop: 'gridGap',
  transformValue: px,
  key: 'space'
});
var gridColumnGap = style({
  prop: 'gridColumnGap',
  transformValue: px,
  key: 'space'
});
var gridRowGap = style({
  prop: 'gridRowGap',
  transformValue: px,
  key: 'space'
});
var gridColumn = style({
  prop: 'gridColumn'
});
var gridRow = style({
  prop: 'gridRow'
});
var gridAutoFlow = style({
  prop: 'gridAutoFlow'
});
var gridAutoColumns = style({
  prop: 'gridAutoColumns'
});
var gridAutoRows = style({
  prop: 'gridAutoRows'
});
var gridTemplateColumns = style({
  prop: 'gridTemplateColumns'
});
var gridTemplateRows = style({
  prop: 'gridTemplateRows'
});
var gridTemplateAreas = style({
  prop: 'gridTemplateAreas'
});
var gridArea = style({
  prop: 'gridArea'
}); // borders

var getBorder = function getBorder(n) {
  return num(n) && n > 0 ? n + 'px solid' : n;
};

var border = style({
  prop: 'border',
  key: 'borders',
  transformValue: getBorder
});
var borderTop = style({
  prop: 'borderTop',
  key: 'borders',
  transformValue: getBorder
});
var borderRight = style({
  prop: 'borderRight',
  key: 'borders',
  transformValue: getBorder
});
var borderBottom = style({
  prop: 'borderBottom',
  key: 'borders',
  transformValue: getBorder
});
var borderLeft = style({
  prop: 'borderLeft',
  key: 'borders',
  transformValue: getBorder
});
var borders = compose(border, borderTop, borderRight, borderBottom, borderLeft);
var borderColor = style({
  prop: 'borderColor',
  key: 'colors'
});
var borderRadius = style({
  prop: 'borderRadius',
  key: 'radii',
  transformValue: px
});
var boxShadow = style({
  prop: 'boxShadow',
  key: 'shadows'
});
var opacity = style({
  prop: 'opacity'
});
var overflow = style({
  prop: 'overflow'
}); // backgrounds

var background = style({
  prop: 'background'
});
var backgroundImage = style({
  prop: 'backgroundImage'
});
var backgroundSize = style({
  prop: 'backgroundSize'
});
var backgroundPosition = style({
  prop: 'backgroundPosition'
});
var backgroundRepeat = style({
  prop: 'backgroundRepeat'
}); // position

var position = style({
  prop: 'position'
});
var zIndex = style({
  prop: 'zIndex'
});
var top = style({
  prop: 'top',
  transformValue: px
});
var right = style({
  prop: 'right',
  transformValue: px
});
var bottom = style({
  prop: 'bottom',
  transformValue: px
});
var left = style({
  prop: 'left',
  transformValue: px
});
var textStyle = variant({
  prop: 'textStyle',
  key: 'textStyles'
});
var colorStyle = variant({
  prop: 'colors',
  key: 'colorStyles'
});
var buttonStyle = variant({
  key: 'buttons'
});
var styles = {
  space: space,
  width: width,
  fontSize: fontSize,
  textColor: textColor,
  bgColor: bgColor,
  color: color,
  fontFamily: fontFamily,
  textAlign: textAlign,
  lineHeight: lineHeight,
  fontWeight: fontWeight,
  fontStyle: fontStyle,
  letterSpacing: letterSpacing,
  display: display,
  maxWidth: maxWidth,
  minWidth: minWidth,
  height: height,
  maxHeight: maxHeight,
  minHeight: minHeight,
  sizeWidth: sizeWidth,
  sizeHeight: sizeHeight,
  size: size,
  ratioPadding: ratioPadding,
  ratio: ratio,
  verticalAlign: verticalAlign,
  alignItems: alignItems,
  alignContent: alignContent,
  justifyItems: justifyItems,
  justifyContent: justifyContent,
  flexWrap: flexWrap,
  flexBasis: flexBasis,
  flexDirection: flexDirection,
  flex: flex,
  justifySelf: justifySelf,
  alignSelf: alignSelf,
  order: order,
  gridGap: gridGap,
  gridColumnGap: gridColumnGap,
  gridRowGap: gridRowGap,
  gridColumn: gridColumn,
  gridRow: gridRow,
  gridAutoFlow: gridAutoFlow,
  gridAutoColumns: gridAutoColumns,
  gridAutoRows: gridAutoRows,
  gridTemplateColumns: gridTemplateColumns,
  gridTemplateRows: gridTemplateRows,
  gridTemplateAreas: gridTemplateAreas,
  gridArea: gridArea,
  // borders
  border: border,
  borderTop: borderTop,
  borderRight: borderRight,
  borderBottom: borderBottom,
  borderLeft: borderLeft,
  borders: borders,
  borderColor: borderColor,
  borderRadius: borderRadius,
  boxShadow: boxShadow,
  opacity: opacity,
  overflow: overflow,
  background: background,
  backgroundImage: backgroundImage,
  backgroundPosition: backgroundPosition,
  backgroundRepeat: backgroundRepeat,
  backgroundSize: backgroundSize,
  position: position,
  zIndex: zIndex,
  top: top,
  right: right,
  bottom: bottom,
  left: left,
  textStyle: textStyle,
  colorStyle: colorStyle,
  buttonStyle: buttonStyle // mixed

};

var omit = function omit(obj, blacklist) {
  var next = {};

  for (var key in obj) {
    if (blacklist.indexOf(key) > -1) continue;
    next[key] = obj[key];
  }

  return next;
};

var funcs = Object.keys(styles).map(function (key) {
  return styles[key];
}).filter(function (fn) {
  return typeof fn === 'function';
});
var blacklist = funcs.reduce(function (a, fn) {
  return a.concat(Object.keys(fn.propTypes || {}));
}, ['theme']);
var mixed = function mixed(props) {
  return funcs.map(function (fn) {
    return fn(props);
  }).reduce(merge, omit(props, blacklist));
};


/***/ }),
/* 564 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_grid_styled__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_grid_styled___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_grid_styled__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_helpers_variables__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_Container__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__store_connect__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Conditional__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__actions_actionCreators__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__styles_helpers_mixins__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__constants_pageTypes__ = __webpack_require__(238);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  ',';\n  list-style: none;\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n  position: fixed;\n  bottom: 0;\n  left: 0;\n\n  li {\n    font-size: 12px;\n    &:first-child {\n      display: none;\n    }\n  }\n'],['\n  ',';\n  list-style: none;\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n  position: fixed;\n  bottom: 0;\n  left: 0;\n\n  li {\n    font-size: 12px;\n    &:first-child {\n      display: none;\n    }\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  display: flex;\n  align-items: center;\n  justify-content: ',';\n'],['\n  display: flex;\n  align-items: center;\n  justify-content: ',';\n']),_templateObject3=_taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin: 0 0 40px;\n  > div {\n    &:first-child {\n      margin: 0 0 20px;\n    }\n  }\n'],['\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin: 0 0 40px;\n  > div {\n    &:first-child {\n      margin: 0 0 20px;\n    }\n  }\n']),_templateObject4=_taggedTemplateLiteral(['\n  display: flex;\n  align-items: center;\n  margin: 0 0 40px;\n'],['\n  display: flex;\n  align-items: center;\n  margin: 0 0 40px;\n']),_templateObject5=_taggedTemplateLiteral(['\n  flex: 1 1 auto;\n  height: 1px;\n  margin: 0 10px;\n  background-color: #363636;\n'],['\n  flex: 1 1 auto;\n  height: 1px;\n  margin: 0 10px;\n  background-color: #363636;\n']),_templateObject6=_taggedTemplateLiteral(['\n  display: flex;\n  align-items: center;\n'],['\n  display: flex;\n  align-items: center;\n']),_templateObject7=_taggedTemplateLiteral(['\n  margin: 0 10px 0 0;\n  color: ',';\n  font-size: 11px;\n  font-weight: 600;\n  font-style: normal;\n  line-height: 1.25;\n  letter-spacing: 0.15em;\n  text-transform: uppercase;\n  @media screen and (min-width: 850px) {\n    font-size: 13px;\n  }\n'],['\n  margin: 0 10px 0 0;\n  color: ',';\n  font-size: 11px;\n  font-weight: 600;\n  font-style: normal;\n  line-height: 1.25;\n  letter-spacing: 0.15em;\n  text-transform: uppercase;\n  @media screen and (min-width: 850px) {\n    font-size: 13px;\n  }\n']),_templateObject8=_taggedTemplateLiteral(['\n  margin: 0 10px 0 0;\n  &:last-child {\n    margin: 0;\n  }\n'],['\n  margin: 0 10px 0 0;\n  &:last-child {\n    margin: 0;\n  }\n']),_templateObject9=_taggedTemplateLiteral(['\n  display: flex;\n  align-items: center;\n  color: ',';\n  font-size: 11px;\n  font-weight: 600;\n  font-style: normal;\n  line-height: 1.25;\n  letter-spacing: 0.15em;\n  text-decoration: none;\n  text-transform: uppercase;\n  @media screen and (min-width: 850px) {\n    font-size: 13px;\n  }\n  > svg {\n    flex: 0 0 auto;\n    margin: 0 0 0 10px;\n  }\n'],['\n  display: flex;\n  align-items: center;\n  color: ',';\n  font-size: 11px;\n  font-weight: 600;\n  font-style: normal;\n  line-height: 1.25;\n  letter-spacing: 0.15em;\n  text-decoration: none;\n  text-transform: uppercase;\n  @media screen and (min-width: 850px) {\n    font-size: 13px;\n  }\n  > svg {\n    flex: 0 0 auto;\n    margin: 0 0 0 10px;\n  }\n']),_templateObject10=_taggedTemplateLiteral(['\n  display: block;\n  height: 30px;\n  width: 30px;\n'],['\n  display: block;\n  height: 30px;\n  width: 30px;\n']),_templateObject11=_taggedTemplateLiteral(['\n  list-style: none;\n  margin: 0 0 40px;\n  padding: 0 0 40px;\n  border-bottom: 1px solid #363636;\n  line-height: 1.25;\n  text-align: center;\n'],['\n  list-style: none;\n  margin: 0 0 40px;\n  padding: 0 0 40px;\n  border-bottom: 1px solid #363636;\n  line-height: 1.25;\n  text-align: center;\n']),_templateObject12=_taggedTemplateLiteral(['\n  margin: 0 0 20px;\n  &:last-child {\n    margin: 0;\n  }\n'],['\n  margin: 0 0 20px;\n  &:last-child {\n    margin: 0;\n  }\n']),_templateObject13=_taggedTemplateLiteral(['\n  color: ',';\n  font-family: PlayfairDisplay;\n  font-size: 14px;\n  text-decoration: none;\n'],['\n  color: ',';\n  font-family: PlayfairDisplay;\n  font-size: 14px;\n  text-decoration: none;\n']),_templateObject14=_taggedTemplateLiteral(['\n  color: ',';\n  text-decoration: none;\n  padding: 2px 0;\n  transition: opacity 250ms ease-out;\n  position: relative;\n\n  &:before,\n  :after {\n    position: absolute;\n    content: \'\';\n    display: block;\n    width: 6px;\n    height: 1px;\n    background: ',';\n    right: -12px;\n  }\n  &:before {\n    top: calc(50% - 1px);\n    transform: rotate(40deg);\n  }\n  &:after {\n    top: calc(50% + 3px);\n    transform: rotate(-40deg);\n  }\n\n  &:hover {\n    opacity: 0.8;\n  }\n'],['\n  color: ',';\n  text-decoration: none;\n  padding: 2px 0;\n  transition: opacity 250ms ease-out;\n  position: relative;\n\n  &:before,\n  :after {\n    position: absolute;\n    content: \'\';\n    display: block;\n    width: 6px;\n    height: 1px;\n    background: ',';\n    right: -12px;\n  }\n  &:before {\n    top: calc(50% - 1px);\n    transform: rotate(40deg);\n  }\n  &:after {\n    top: calc(50% + 3px);\n    transform: rotate(-40deg);\n  }\n\n  &:hover {\n    opacity: 0.8;\n  }\n']),_templateObject15=_taggedTemplateLiteral(['\n  color: ',';\n  text-decoration: none;\n  padding: 2px 0;\n  transition: opacity 250ms ease-out;\n  position: relative;\n  font-family: PlayfairDisplay;\n  font-size: 24px;\n  line-height: 1.25;\n  text-align: left;\n\n  &:hover {\n    opacity: 0.8;\n  }\n'],['\n  color: ',';\n  text-decoration: none;\n  padding: 2px 0;\n  transition: opacity 250ms ease-out;\n  position: relative;\n  font-family: PlayfairDisplay;\n  font-size: 24px;\n  line-height: 1.25;\n  text-align: left;\n\n  &:hover {\n    opacity: 0.8;\n  }\n']),_templateObject16=_taggedTemplateLiteral(['\n  color: ',';\n  display: block;\n  font-size: 12px;\n  line-height: 2.08;\n  text-align: left;\n  font-style: italic;\n  ',';\n'],['\n  color: ',';\n  display: block;\n  font-size: 12px;\n  line-height: 2.08;\n  text-align: left;\n  font-style: italic;\n  ',';\n']),_templateObject17=_taggedTemplateLiteral(['\n      font-size: 10px;\n    '],['\n      font-size: 10px;\n    ']),_templateObject18=_taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: column;\n  list-style: none;\n  padding-left: 0;\n  margin: 0 0 20px;\n  color: ',';\n'],['\n  display: flex;\n  flex-direction: column;\n  list-style: none;\n  padding-left: 0;\n  margin: 0 0 20px;\n  color: ',';\n']),_templateObject19=_taggedTemplateLiteral(['\n  color: ',';\n  font-size: 14px;\n  line-height: 1.5;\n  margin-bottom: 5px;\n  text-align: left;\n  padding: 0;\n  font-weight: normal;\n'],['\n  color: ',';\n  font-size: 14px;\n  line-height: 1.5;\n  margin-bottom: 5px;\n  text-align: left;\n  padding: 0;\n  font-weight: normal;\n']),_templateObject20=_taggedTemplateLiteral(['\n  color: ',';\n  font-size: 14px;\n  line-height: 1.5;\n  margin-bottom: 8px;\n  text-align: left;\n  padding: 0;\n  font-weight: normal;\n\n  ',';\n'],['\n  color: ',';\n  font-size: 14px;\n  line-height: 1.5;\n  margin-bottom: 8px;\n  text-align: left;\n  padding: 0;\n  font-weight: normal;\n\n  ',';\n']),_templateObject21=_taggedTemplateLiteral(['\n      margin-top: 8px;\n      margin-bottom: 0;\n\n      ',' + & {\n        margin-top: 20px;\n      }\n    '],['\n      margin-top: 8px;\n      margin-bottom: 0;\n\n      ',' + & {\n        margin-top: 20px;\n      }\n    ']),_templateObject22=_taggedTemplateLiteral(['\n  color: ',';\n  font-size: 14px;\n  text-decoration: none;\n  line-height: 1.5;\n  margin-bottom: 5px;\n  text-align: left;\n  padding: 0;\n  font-weight: normal;\n\n  ',';\n\n  &.--mb {\n    margin-bottom: 1.5em;\n  }\n'],['\n  color: ',';\n  font-size: 14px;\n  text-decoration: none;\n  line-height: 1.5;\n  margin-bottom: 5px;\n  text-align: left;\n  padding: 0;\n  font-weight: normal;\n\n  ',';\n\n  &.--mb {\n    margin-bottom: 1.5em;\n  }\n']),_templateObject23=_taggedTemplateLiteral(['\n      margin-bottom: 8px;\n      font-family: PlayfairDisplay;\n      font-size: 24px;\n      line-height: 1.25;\n      text-align: left;\n    '],['\n      margin-bottom: 8px;\n      font-family: PlayfairDisplay;\n      font-size: 24px;\n      line-height: 1.25;\n      text-align: left;\n    ']),_templateObject24=_taggedTemplateLiteral(['\n  height: auto;\n  display: flex;\n  padding: 80px 0;\n  justify-content: center;\n  align-items: center;\n  background-color: ',';\n  ul {\n    padding: 0;\n    list-style: none;\n  }\n'],['\n  height: auto;\n  display: flex;\n  padding: 80px 0;\n  justify-content: center;\n  align-items: center;\n  background-color: ',';\n  ul {\n    padding: 0;\n    list-style: none;\n  }\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Footer=function(_Component){_inherits(Footer,_Component);function Footer(){_classCallCheck(this,Footer);return _possibleConstructorReturn(this,(Footer.__proto__||Object.getPrototypeOf(Footer)).apply(this,arguments));}_createClass(Footer,[{key:'componentDidMount',value:function componentDidMount(){this.props.fetchArticlePageView({urlPath:'/footer'});}},{key:'desktopLinkListRender',value:function desktopLinkListRender(){var _this2=this;return this.props.footerLinks.map(function(item,index){var children=item.get('children');var itemsWithoutChildren=[];if(!children.size){return false;}var indexOfNextItemWithChildren=0;_this2.props.footerLinks.forEach(function(subItem,subIndex){if(subIndex>index&&subItem.get('children').size){// update indexOfNextItemWithChildren
indexOfNextItemWithChildren=subIndex;}if(subIndex>index&&index>indexOfNextItemWithChildren&&!subItem.get('children').size){itemsWithoutChildren.push(subItem);}});var CurrentBox=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grid_styled__["Box"],{width:[1/5],px:[0,'14px'],key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FooterLinks,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FooterLinkTitleItem,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FooterDetailTitleLink,{to:item.get('url')},item.get('title'))),item.get('children').map(function(child,childIndex){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FooterLinkItem,{key:childIndex},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FooterDetailLink,{to:child.get('url')},child.get('title')));}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Conditional__["a" /* Conditional */],{show:!!itemsWithoutChildren.length},itemsWithoutChildren.map(function(savedItem){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FooterLinkTitleItem,{marginTop:true,key:savedItem.get('url')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FooterDetailTitleLink,{to:savedItem.get('url')},savedItem.get('title')));}))));itemsWithoutChildren=[];return CurrentBox;}).filter(function(item){return!!item;}).toArray();}},{key:'render',value:function render(){var _props=this.props,viewstate=_props.viewstate,sitemap=_props.sitemap;var isMobile=viewstate.get('pageWidth')<__WEBPACK_IMPORTED_MODULE_6__styles_helpers_variables__["f" /* size */].footerBreakPoint;var mobileTheme={isMobile:true};var desktopTheme={isMobile:false};var newsletterLink=sitemap.get('children',Object(__WEBPACK_IMPORTED_MODULE_3_immutable__["Map"])()).filter(function(item){return item.get('pageType')===__WEBPACK_IMPORTED_MODULE_12__constants_pageTypes__["d" /* NEWSLETTER_PAGE_TYPE */];}).map(function(item){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SocialLinkWithLabelAsLink,{to:item.get('url'),key:item.get('url')},'Premenurera p\xE5 nyhetsbrev',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SocialIcon,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('use',{href:'/images/icons/social_v1.svg#newsletter'})));}).toArray();var socialLinks=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SocialLinks,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SocialLinksLabel,null,'F\xF6lj oss'),[{id:'facebook',href:'https://www.facebook.com/ValaMagasinet/'},{id:'instagram',href:'https://www.instagram.com/valamagasinet/'}].map(function(_ref){var id=_ref.id,href=_ref.href;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SocialLink,{href:href,target:'_blank',rel:'noreferrer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SocialIcon,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('use',{href:'/images/icons/social_v1.svg#'+id})));}));if(isMobile){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_styled_components__["ThemeProvider"],{theme:mobileTheme},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__styles_Container__["a" /* Container */],{hideOnPrint:true,style:{padding:'40px 20px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MobileLinkList,null,this.props.footerLinksMobile.map(function(item){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MobileLinkListItem,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MobileLink,{to:item.get('url')},item.get('title')));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SocialContainer,null,socialLinks,newsletterLink),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FooterDetails,{center:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CopyText,{mobile:true},'\xA9 V\xE5lamagasinet. Alla r\xE4ttigheter f\xF6rbeh\xE5lls.'))));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_styled_components__["ThemeProvider"],{theme:desktopTheme},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FooterContainer,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PrintFooter,null,this.props.contactInformation.map(function(item,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:'print-contact-'+index,dangerouslySetInnerHTML:{__html:item}});})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__styles_Container__["a" /* Container */],{swipe:true,hideOnPrint:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SocialDesktopContainer,null,newsletterLink,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SocialDesktopContainerDivider,null),socialLinks),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grid_styled__["Flex"],{mx:[0,'-14px'],mb:30},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grid_styled__["Box"],{width:[1/5],px:[0,'14px']},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FooterLinks,null,this.props.contactInformation.map(function(item,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FooterItem,{title:index===0?'title':undefined,className:index===3?'--mb':undefined,key:index+1},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{dangerouslySetInnerHTML:{__html:item}}));}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grid_styled__["Box"],{width:[1/5],px:[0,'14px']},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FooterLinks,null,this.props.openingHours.map(function(item,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FooterItem,{title:index===0?'title':undefined,key:index+1},item);}))),this.desktopLinkListRender()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FooterDetails,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CopyText,null,'\xA9 V\xE5lamagasinet. Alla r\xE4ttigheter f\xF6rbeh\xE5lls.')))));}}]);return Footer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var PrintFooter=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].ul(_templateObject,__WEBPACK_IMPORTED_MODULE_11__styles_helpers_mixins__["j" /* showOnPrint */]);var FooterDetails=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject2,function(props){return props.center?'center':'flex-start';});var SocialContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject3);var SocialDesktopContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject4);var SocialDesktopContainerDivider=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject5);var SocialLinks=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject6);var SocialLinksLabel=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject7,__WEBPACK_IMPORTED_MODULE_6__styles_helpers_variables__["c" /* color */].white);var SocialLink=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].a(_templateObject8);var SocialLinkWithLabel=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].a(_templateObject9,__WEBPACK_IMPORTED_MODULE_6__styles_helpers_variables__["c" /* color */].white);var SocialIcon=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].svg(_templateObject10);var SocialLinkWithLabelAsLink=SocialLinkWithLabel.withComponent(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* Link */]);var MobileLinkList=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].ul(_templateObject11);var MobileLinkListItem=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].li(_templateObject12);var MobileLink=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* Link */])(_templateObject13,__WEBPACK_IMPORTED_MODULE_6__styles_helpers_variables__["c" /* color */].white);var FooterDetailLink=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* Link */])(_templateObject14,__WEBPACK_IMPORTED_MODULE_6__styles_helpers_variables__["c" /* color */].white,__WEBPACK_IMPORTED_MODULE_6__styles_helpers_variables__["c" /* color */].white);var FooterDetailTitleLink=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* Link */])(_templateObject15,__WEBPACK_IMPORTED_MODULE_6__styles_helpers_variables__["c" /* color */].white);var CopyText=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].span(_templateObject16,__WEBPACK_IMPORTED_MODULE_6__styles_helpers_variables__["c" /* color */].white,function(props){return props.mobile&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject17);});var FooterLinks=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].ul(_templateObject18,__WEBPACK_IMPORTED_MODULE_6__styles_helpers_variables__["c" /* color */].white);var FooterLinkItem=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].li(_templateObject19,function(props){return props.theme?props.theme.fg:__WEBPACK_IMPORTED_MODULE_6__styles_helpers_variables__["c" /* color */].white;});var FooterLinkTitleItem=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].li(_templateObject20,function(props){return props.theme?props.theme.fg:__WEBPACK_IMPORTED_MODULE_6__styles_helpers_variables__["c" /* color */].white;},function(props){return props.marginTop&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject21,FooterLinkItem);});var FooterItem=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].li(_templateObject22,__WEBPACK_IMPORTED_MODULE_6__styles_helpers_variables__["c" /* color */].white,function(props){return props.title&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject23);});var FooterContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].footer(_templateObject24,__WEBPACK_IMPORTED_MODULE_6__styles_helpers_variables__["c" /* color */].black);Footer.defaultProps={viewstate:Object(__WEBPACK_IMPORTED_MODULE_3_immutable__["Map"])(),footerLinks:Object(__WEBPACK_IMPORTED_MODULE_3_immutable__["List"])(),footerLinksMobile:Object(__WEBPACK_IMPORTED_MODULE_3_immutable__["List"])(),sitemap:Object(__WEBPACK_IMPORTED_MODULE_3_immutable__["Map"])(),openingHours:Object(__WEBPACK_IMPORTED_MODULE_3_immutable__["List"])(),contactInformation:Object(__WEBPACK_IMPORTED_MODULE_3_immutable__["List"])()};Footer.propTypes={viewstate:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_3_immutable__["Map"]),footerLinks:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_3_immutable__["List"]),footerLinksMobile:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_3_immutable__["List"]),sitemap:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_3_immutable__["Map"]),fetchArticlePageView:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired,openingHours:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_3_immutable__["List"]),contactInformation:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_3_immutable__["List"])};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8__store_connect__["a" /* default */])(Footer,{fetchArticlePageView:__WEBPACK_IMPORTED_MODULE_10__actions_actionCreators__["g" /* fetchArticlePageView */]},function(store){return{viewstate:store.viewstate,footerLinks:Object(__WEBPACK_IMPORTED_MODULE_3_immutable__["fromJS"])((window.startup||{}).footerLinks),footerLinksMobile:Object(__WEBPACK_IMPORTED_MODULE_3_immutable__["fromJS"])((window.startup||{}).mobileFooterLinks),sitemap:Object(__WEBPACK_IMPORTED_MODULE_3_immutable__["fromJS"])(window.sitemap),openingHours:store.page.data.getIn(['/footer','fields','openingHoursArray'],Object(__WEBPACK_IMPORTED_MODULE_3_immutable__["List"])()),contactInformation:store.page.data.getIn(['/footer','fields','contactInformationArray'],Object(__WEBPACK_IMPORTED_MODULE_3_immutable__["List"])())};}));

/***/ }),
/* 565 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Cart__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_connect__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SlideOutContainer__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions_actionCreators__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_helpers_variables__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CartWrapper=function(_Component){_inherits(CartWrapper,_Component);function CartWrapper(props){_classCallCheck(this,CartWrapper);var _this=_possibleConstructorReturn(this,(CartWrapper.__proto__||Object.getPrototypeOf(CartWrapper)).call(this,props));_this.toggleCart=_this.toggleCart.bind(_this);return _this;}_createClass(CartWrapper,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(nextProps.cart.get('cart',Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["List"])()).isEmpty()){this.toggleCart(false);}}},{key:'toggleCart',value:function toggleCart(bool){if(this.props.cart.get('cart',Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["List"])()).isEmpty()||!bool){this.props.setViewstate('cartActive',false);}else{this.props.setViewstate('cartActive',!this.props.viewstate.get('cartActive'));}}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__SlideOutContainer__["a" /* default */],{toggleModal:this.toggleCart,active:this.props.viewstate.get('cartActive'),bgColor:__WEBPACK_IMPORTED_MODULE_7__styles_helpers_variables__["c" /* color */].lightGrey,noPadding:true,small:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_Cart__["a" /* default */],null));}}]);return CartWrapper;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);CartWrapper.defaultProps={cart:Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])(),viewstate:Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])()};CartWrapper.propTypes={setViewstate:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,cart:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"]),viewstate:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4__store_connect__["a" /* default */])(CartWrapper,{setViewstate:__WEBPACK_IMPORTED_MODULE_6__actions_actionCreators__["W" /* setViewstate */]},function(store){return{cart:store.cart,viewstate:store.viewstate};}));

/***/ }),
/* 566 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_dom__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_qs__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_connect__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__RenderPrice__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_helpers_variables__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_toCurrency__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__styles_helpers_mixins__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__constants_endpoints__ = __webpack_require__(9);
var _templateObject=_taggedTemplateLiteral(['\n  background-color: ',';\n  padding-bottom: 2px;\n  margin-bottom: 3px;\n'],['\n  background-color: ',';\n  padding-bottom: 2px;\n  margin-bottom: 3px;\n']),_templateObject2=_taggedTemplateLiteral(['\n  position: relative;\n  background-color: ',';\n  padding: 12px 15px 0 10px;\n  display: flex;\n  justify-content: flex-start;\n  align-items: flex-start;\n  margin-bottom: 2px;\n\n  @media screen and (min-width: ','px) {\n    padding: 20px 38px 12px 12px;\n    align-items: center;\n  }\n'],['\n  position: relative;\n  background-color: ',';\n  padding: 12px 15px 0 10px;\n  display: flex;\n  justify-content: flex-start;\n  align-items: flex-start;\n  margin-bottom: 2px;\n\n  @media screen and (min-width: ','px) {\n    padding: 20px 38px 12px 12px;\n    align-items: center;\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  border-left: 1px solid ',';\n  margin: 10px 0 10px 30px;\n'],['\n  border-left: 1px solid ',';\n  margin: 10px 0 10px 30px;\n']),_templateObject4=_taggedTemplateLiteral(['\n  min-height: 40px;\n  padding: 2px 15px 2px 10px;\n  align-items: center;\n\n  @media screen and (min-width: ','px) {\n    padding: 4px 38px 4px 12px;\n    margin-bottom: 3px;\n  }\n'],['\n  min-height: 40px;\n  padding: 2px 15px 2px 10px;\n  align-items: center;\n\n  @media screen and (min-width: ','px) {\n    padding: 4px 38px 4px 12px;\n    margin-bottom: 3px;\n  }\n']),_templateObject5=_taggedTemplateLiteral(['\n  height: 30px;\n  width: 30px;\n  position: absolute;\n  top: 0;\n  right: 0;\n  border: none;\n  background-color: transparent;\n  background-image: url(\'/images/icons/close.svg\');\n  background-position: center;\n  background-repeat: no-repeat;\n  cursor: pointer;\n  background-size: 10px;\n  font-size: 20px;\n'],['\n  height: 30px;\n  width: 30px;\n  position: absolute;\n  top: 0;\n  right: 0;\n  border: none;\n  background-color: transparent;\n  background-image: url(\'/images/icons/close.svg\');\n  background-position: center;\n  background-repeat: no-repeat;\n  cursor: pointer;\n  background-size: 10px;\n  font-size: 20px;\n']),_templateObject6=_taggedTemplateLiteral(['\n  width: 35px;\n  height: auto;\n  max-height: 35px;\n  object-fit: contain;\n  margin-top: 6px;\n\n  @media screen and (min-width: ','px) {\n    width: 50px;\n    max-height: 50px;\n    margin-top: 0;\n  }\n\n  ',';\n'],['\n  width: 35px;\n  height: auto;\n  max-height: 35px;\n  object-fit: contain;\n  margin-top: 6px;\n\n  @media screen and (min-width: ','px) {\n    width: 50px;\n    max-height: 50px;\n    margin-top: 0;\n  }\n\n  ',';\n']),_templateObject7=_taggedTemplateLiteral(['\n      width: 30px;\n      max-height: 30px;\n\n      @media screen and (min-width: ','px) {\n        width: 40px;\n        max-height: 40px;\n      }\n    '],['\n      width: 30px;\n      max-height: 30px;\n\n      @media screen and (min-width: ','px) {\n        width: 40px;\n        max-height: 40px;\n      }\n    ']),_templateObject8=_taggedTemplateLiteral(['\n  flex: 1;\n  padding-left: 16px;\n  display: flex;\n  flex-direction: column;\n\n  @media screen and (min-width: ','px) {\n    flex-direction: row;\n    padding-left: 26px;\n  }\n'],['\n  flex: 1;\n  padding-left: 16px;\n  display: flex;\n  flex-direction: column;\n\n  @media screen and (min-width: ','px) {\n    flex-direction: row;\n    padding-left: 26px;\n  }\n']),_templateObject9=_taggedTemplateLiteral(['\n  margin: 0;\n  font-size: 12px;\n  font-weight: 600;\n  font-style: normal;\n  font-stretch: normal;\n  line-height: normal;\n  letter-spacing: normal;\n  text-align: left;\n  text-decoration: none;\n  color: ',';\n  transition: opacity 250ms ease-out;\n\n  &:hover {\n    opacity: 0.8;\n  }\n\n  @media screen and (min-width: ','px) {\n    font-size: 16px;\n  }\n'],['\n  margin: 0;\n  font-size: 12px;\n  font-weight: 600;\n  font-style: normal;\n  font-stretch: normal;\n  line-height: normal;\n  letter-spacing: normal;\n  text-align: left;\n  text-decoration: none;\n  color: ',';\n  transition: opacity 250ms ease-out;\n\n  &:hover {\n    opacity: 0.8;\n  }\n\n  @media screen and (min-width: ','px) {\n    font-size: 16px;\n  }\n']),_templateObject10=_taggedTemplateLiteral(['\n  font-size: 12px;\n\n  @media screen and (min-width: ','px) {\n    font-size: 14px;\n  }\n'],['\n  font-size: 12px;\n\n  @media screen and (min-width: ','px) {\n    font-size: 14px;\n  }\n']),_templateObject11=_taggedTemplateLiteral(['\n  margin: 0.08725em 0 0.08725em;\n  font-size: 12px;\n  font-weight: normal;\n  font-style: normal;\n  font-stretch: normal;\n  line-height: 1.4;\n  letter-spacing: normal;\n  text-align: left;\n  color: ',';\n  ',';\n  ',';\n'],['\n  margin: 0.08725em 0 0.08725em;\n  font-size: 12px;\n  font-weight: normal;\n  font-style: normal;\n  font-stretch: normal;\n  line-height: 1.4;\n  letter-spacing: normal;\n  text-align: left;\n  color: ',';\n  ',';\n  ',';\n']),_templateObject12=_taggedTemplateLiteral(['\n      font-weight: ',';\n    '],['\n      font-weight: ',';\n    ']),_templateObject13=_taggedTemplateLiteral(['\n      margin-bottom: ',';\n    '],['\n      margin-bottom: ',';\n    ']),_templateObject14=_taggedTemplateLiteral(['\n  ',';\n  @media screen and (min-width: ','px) {\n    flex: 1;\n  }\n'],['\n  ',';\n  @media screen and (min-width: ','px) {\n    flex: 1;\n  }\n']),_templateObject15=_taggedTemplateLiteral(['\n      padding: ',';\n    '],['\n      padding: ',';\n    ']),_templateObject16=_taggedTemplateLiteral(['\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  margin: 10px 0;\n  position: relative;\n  left: -10px;\n\n  @media screen and (min-width: ','px) {\n    position: initial;\n    margin: 0;\n    height: 40px;\n  }\n'],['\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  margin: 10px 0;\n  position: relative;\n  left: -10px;\n\n  @media screen and (min-width: ','px) {\n    position: initial;\n    margin: 0;\n    height: 40px;\n  }\n']),_templateObject17=_taggedTemplateLiteral(['\n  display: flex;\n  justify-content: space-between;\n  align-items: stretch;\n'],['\n  display: flex;\n  justify-content: space-between;\n  align-items: stretch;\n']),_templateObject18=_taggedTemplateLiteral(['\n  min-width: 30px;\n  height: 30px;\n  border-radius: 15px;\n  padding: 0 5px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid ',';\n  font-size: 14px;\n  font-weight: 600;\n  font-style: normal;\n  font-stretch: normal;\n  line-height: 1;\n  letter-spacing: normal;\n  text-align: center;\n  color: ',';\n'],['\n  min-width: 30px;\n  height: 30px;\n  border-radius: 15px;\n  padding: 0 5px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid ',';\n  font-size: 14px;\n  font-weight: 600;\n  font-style: normal;\n  font-stretch: normal;\n  line-height: 1;\n  letter-spacing: normal;\n  text-align: center;\n  color: ',';\n']),_templateObject19=_taggedTemplateLiteral(['\n  ',';\n  outline: 0;\n  width: 30px;\n  height: 30px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: transparent;\n  border: none;\n  font-size: 24px;\n  font-weight: 300;\n  font-style: normal;\n  font-stretch: normal;\n  line-height: 0.92;\n  letter-spacing: normal;\n  text-align: left;\n  cursor: pointer;\n  padding: 2px 8px;\n  top: -2px;\n  position: relative;\n  color: ',';\n  transition: opacity 250ms ease-out;\n\n  &:disabled {\n    color: ',';\n    cursor: default;\n  }\n\n  &:hover {\n    opacity: 0.6;\n  }\n'],['\n  ',';\n  outline: 0;\n  width: 30px;\n  height: 30px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: transparent;\n  border: none;\n  font-size: 24px;\n  font-weight: 300;\n  font-style: normal;\n  font-stretch: normal;\n  line-height: 0.92;\n  letter-spacing: normal;\n  text-align: left;\n  cursor: pointer;\n  padding: 2px 8px;\n  top: -2px;\n  position: relative;\n  color: ',';\n  transition: opacity 250ms ease-out;\n\n  &:disabled {\n    color: ',';\n    cursor: default;\n  }\n\n  &:hover {\n    opacity: 0.6;\n  }\n']),_templateObject20=_taggedTemplateLiteral(['\n  display: inline-block;\n  margin: 0;\n  font-size: 13px;\n  font-weight: 600;\n  font-style: normal;\n  font-stretch: normal;\n  line-height: 1.69;\n  letter-spacing: normal;\n  text-align: left;\n  color: ',';\n  margin-left: 10px;\n  min-width: 70px;\n  text-align: right;\n'],['\n  display: inline-block;\n  margin: 0;\n  font-size: 13px;\n  font-weight: 600;\n  font-style: normal;\n  font-stretch: normal;\n  line-height: 1.69;\n  letter-spacing: normal;\n  text-align: left;\n  color: ',';\n  margin-left: 10px;\n  min-width: 70px;\n  text-align: right;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var getProductUrlWithOptions=function getProductUrlWithOptions(baseUrl,options){if(options.size){var queryObject=options.reduce(function(memory,option){return Object.assign(memory,_defineProperty({},option.get('configurationTypeName'),option.get('id')));},{});return baseUrl+'?'+__WEBPACK_IMPORTED_MODULE_5_qs___default.a.stringify(queryObject);}return baseUrl;};var CartItem=function CartItem(props){var cartRow=props.cartRow;var currentProduct=cartRow.get('product');var currentOptions=cartRow.get('options');var quantity=cartRow.get('quantity');var productOptions=currentOptions.map(function(option){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CartOptionsContainer,{key:option.get('id')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CartItemImage,{small:true,src:__WEBPACK_IMPORTED_MODULE_11__constants_endpoints__["n" /* SITE_ROOT_URL */]+option.getIn(['images',0,'url'])}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CartItemContent,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CartItemTextContainer,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CartItemTitle,null,option.get('configurationTypeName')+': '+option.get('name')),option.get('price')?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CartItemText,null,'Pris:',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__RenderPrice__["a" /* default */],{inline:true,price:option.get('price'),originalPrice:option.get('originalPrice'),fontWeight:'normal',fontSize:'12px'})):false)));}).toArray();var cartRowUrl=getProductUrlWithOptions(currentProduct.get('url'),currentOptions);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CartItemRootContainer,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CartItemContainer,null,!props.modifyDisabled?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CloseButton,{onClick:function onClick(){return props.deleteCartRow(cartRow);}}):false,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CartItemImage,{src:__WEBPACK_IMPORTED_MODULE_11__constants_endpoints__["n" /* SITE_ROOT_URL */]+currentProduct.getIn(['mainImage','url'])}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CartItemContent,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CartItemTextContainer,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CartItemTitleLink,{to:cartRowUrl},currentProduct.get('name')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CartItemText,null,'Pris:',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__RenderPrice__["a" /* default */],{inline:true,price:currentProduct.get('price'),originalPrice:currentProduct.get('originalPrice'),fontWeight:'normal',fontSize:'12px'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CartItemText,null,'Leverans: ',currentProduct.get('deliveryInformation'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CartItemMetaContainer,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CartItemMetaQuantityContainer,null,!props.modifyDisabled?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CartItemButton,{disabled:quantity-1<=0||props.modifyDisabled,onClick:function onClick(){return props.removeCartItem(cartRow);}},'-'):false,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CartItemQuantity,null,quantity),!props.modifyDisabled?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CartItemButton,{disabled:props.modifyDisabled,onClick:function onClick(){return props.addCartItem(currentProduct.get('id'),currentOptions);}},'+'):false),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CartItemPrice,null,Object(__WEBPACK_IMPORTED_MODULE_9__util_toCurrency__["a" /* toCurrency */])(cartRow.get('totalPrice')))))),currentOptions.size?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CartItemOptionsContainer,null,productOptions):false);};var CartItemRootContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject,__WEBPACK_IMPORTED_MODULE_8__styles_helpers_variables__["c" /* color */].white);var CartItemContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject2,__WEBPACK_IMPORTED_MODULE_8__styles_helpers_variables__["c" /* color */].white,__WEBPACK_IMPORTED_MODULE_8__styles_helpers_variables__["f" /* size */].xLarge);var CartItemOptionsContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject3,__WEBPACK_IMPORTED_MODULE_8__styles_helpers_variables__["c" /* color */].grey);var CartOptionsContainer=CartItemContainer.extend(_templateObject4,__WEBPACK_IMPORTED_MODULE_8__styles_helpers_variables__["f" /* size */].xLarge);var CloseButton=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].button(_templateObject5);var CartItemImage=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].img(_templateObject6,__WEBPACK_IMPORTED_MODULE_8__styles_helpers_variables__["f" /* size */].xLarge,function(props){return props.small&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject7,__WEBPACK_IMPORTED_MODULE_8__styles_helpers_variables__["f" /* size */].xLarge);});var CartItemContent=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject8,__WEBPACK_IMPORTED_MODULE_8__styles_helpers_variables__["f" /* size */].xLarge);var CartItemTitleLink=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["a" /* Link */])(_templateObject9,__WEBPACK_IMPORTED_MODULE_8__styles_helpers_variables__["c" /* color */].black,__WEBPACK_IMPORTED_MODULE_8__styles_helpers_variables__["f" /* size */].xLarge);var CartItemTitle=CartItemTitleLink.withComponent('p').extend(_templateObject10,__WEBPACK_IMPORTED_MODULE_8__styles_helpers_variables__["f" /* size */].xLarge);var CartItemText=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject11,__WEBPACK_IMPORTED_MODULE_8__styles_helpers_variables__["c" /* color */].black,function(props){return props.fontWeight&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject12,props.fontWeight);},function(props){return props.marginBottom&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject13,props.marginBottom);});var CartItemTextContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject14,function(props){return props.padding&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject15,props.padding);},__WEBPACK_IMPORTED_MODULE_8__styles_helpers_variables__["f" /* size */].xLarge);var CartItemMetaContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject16,__WEBPACK_IMPORTED_MODULE_8__styles_helpers_variables__["f" /* size */].xLarge);var CartItemMetaQuantityContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject17);var CartItemQuantity=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject18,__WEBPACK_IMPORTED_MODULE_8__styles_helpers_variables__["c" /* color */].grey,__WEBPACK_IMPORTED_MODULE_8__styles_helpers_variables__["c" /* color */].black);var CartItemButton=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].button(_templateObject19,__WEBPACK_IMPORTED_MODULE_10__styles_helpers_mixins__["d" /* fontFamilyBody */],__WEBPACK_IMPORTED_MODULE_8__styles_helpers_variables__["c" /* color */].black,__WEBPACK_IMPORTED_MODULE_8__styles_helpers_variables__["c" /* color */].darkgrey);var CartItemPrice=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].p(_templateObject20,__WEBPACK_IMPORTED_MODULE_8__styles_helpers_variables__["c" /* color */].black);CartItem.defaultProps={cartRow:Object(__WEBPACK_IMPORTED_MODULE_3_immutable__["Map"])(),modifyDisabled:false,addCartItem:function addCartItem(){},removeCartItem:function removeCartItem(){},deleteCartRow:function deleteCartRow(){}};CartItem.propTypes={cartRow:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_3_immutable__["Map"]),addCartItem:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,removeCartItem:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,deleteCartRow:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,modifyDisabled:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6__store_connect__["a" /* default */])(CartItem,{},function(store){return{viewstate:store.viewstate};}));

/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var getSideChannel = __webpack_require__(568);
var utils = __webpack_require__(241);
var formats = __webpack_require__(157);
var has = Object.prototype.hasOwnProperty;

var arrayPrefixGenerators = {
    brackets: function brackets(prefix) {
        return prefix + '[]';
    },
    comma: 'comma',
    indices: function indices(prefix, key) {
        return prefix + '[' + key + ']';
    },
    repeat: function repeat(prefix) {
        return prefix;
    }
};

var isArray = Array.isArray;
var push = Array.prototype.push;
var pushToArray = function (arr, valueOrArray) {
    push.apply(arr, isArray(valueOrArray) ? valueOrArray : [valueOrArray]);
};

var toISO = Date.prototype.toISOString;

var defaultFormat = formats['default'];
var defaults = {
    addQueryPrefix: false,
    allowDots: false,
    allowEmptyArrays: false,
    arrayFormat: 'indices',
    charset: 'utf-8',
    charsetSentinel: false,
    delimiter: '&',
    encode: true,
    encodeDotInKeys: false,
    encoder: utils.encode,
    encodeValuesOnly: false,
    format: defaultFormat,
    formatter: formats.formatters[defaultFormat],
    // deprecated
    indices: false,
    serializeDate: function serializeDate(date) {
        return toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};

var isNonNullishPrimitive = function isNonNullishPrimitive(v) {
    return typeof v === 'string'
        || typeof v === 'number'
        || typeof v === 'boolean'
        || typeof v === 'symbol'
        || typeof v === 'bigint';
};

var sentinel = {};

var stringify = function stringify(
    object,
    prefix,
    generateArrayPrefix,
    commaRoundTrip,
    allowEmptyArrays,
    strictNullHandling,
    skipNulls,
    encodeDotInKeys,
    encoder,
    filter,
    sort,
    allowDots,
    serializeDate,
    format,
    formatter,
    encodeValuesOnly,
    charset,
    sideChannel
) {
    var obj = object;

    var tmpSc = sideChannel;
    var step = 0;
    var findFlag = false;
    while ((tmpSc = tmpSc.get(sentinel)) !== void undefined && !findFlag) {
        // Where object last appeared in the ref tree
        var pos = tmpSc.get(object);
        step += 1;
        if (typeof pos !== 'undefined') {
            if (pos === step) {
                throw new RangeError('Cyclic object value');
            } else {
                findFlag = true; // Break while
            }
        }
        if (typeof tmpSc.get(sentinel) === 'undefined') {
            step = 0;
        }
    }

    if (typeof filter === 'function') {
        obj = filter(prefix, obj);
    } else if (obj instanceof Date) {
        obj = serializeDate(obj);
    } else if (generateArrayPrefix === 'comma' && isArray(obj)) {
        obj = utils.maybeMap(obj, function (value) {
            if (value instanceof Date) {
                return serializeDate(value);
            }
            return value;
        });
    }

    if (obj === null) {
        if (strictNullHandling) {
            return encoder && !encodeValuesOnly ? encoder(prefix, defaults.encoder, charset, 'key', format) : prefix;
        }

        obj = '';
    }

    if (isNonNullishPrimitive(obj) || utils.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, defaults.encoder, charset, 'key', format);
            return [formatter(keyValue) + '=' + formatter(encoder(obj, defaults.encoder, charset, 'value', format))];
        }
        return [formatter(prefix) + '=' + formatter(String(obj))];
    }

    var values = [];

    if (typeof obj === 'undefined') {
        return values;
    }

    var objKeys;
    if (generateArrayPrefix === 'comma' && isArray(obj)) {
        // we need to join elements in
        if (encodeValuesOnly && encoder) {
            obj = utils.maybeMap(obj, encoder);
        }
        objKeys = [{ value: obj.length > 0 ? obj.join(',') || null : void undefined }];
    } else if (isArray(filter)) {
        objKeys = filter;
    } else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }

    var encodedPrefix = encodeDotInKeys ? prefix.replace(/\./g, '%2E') : prefix;

    var adjustedPrefix = commaRoundTrip && isArray(obj) && obj.length === 1 ? encodedPrefix + '[]' : encodedPrefix;

    if (allowEmptyArrays && isArray(obj) && obj.length === 0) {
        return adjustedPrefix + '[]';
    }

    for (var j = 0; j < objKeys.length; ++j) {
        var key = objKeys[j];
        var value = typeof key === 'object' && typeof key.value !== 'undefined' ? key.value : obj[key];

        if (skipNulls && value === null) {
            continue;
        }

        var encodedKey = allowDots && encodeDotInKeys ? key.replace(/\./g, '%2E') : key;
        var keyPrefix = isArray(obj)
            ? typeof generateArrayPrefix === 'function' ? generateArrayPrefix(adjustedPrefix, encodedKey) : adjustedPrefix
            : adjustedPrefix + (allowDots ? '.' + encodedKey : '[' + encodedKey + ']');

        sideChannel.set(object, step);
        var valueSideChannel = getSideChannel();
        valueSideChannel.set(sentinel, sideChannel);
        pushToArray(values, stringify(
            value,
            keyPrefix,
            generateArrayPrefix,
            commaRoundTrip,
            allowEmptyArrays,
            strictNullHandling,
            skipNulls,
            encodeDotInKeys,
            generateArrayPrefix === 'comma' && encodeValuesOnly && isArray(obj) ? null : encoder,
            filter,
            sort,
            allowDots,
            serializeDate,
            format,
            formatter,
            encodeValuesOnly,
            charset,
            valueSideChannel
        ));
    }

    return values;
};

var normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
    if (!opts) {
        return defaults;
    }

    if (typeof opts.allowEmptyArrays !== 'undefined' && typeof opts.allowEmptyArrays !== 'boolean') {
        throw new TypeError('`allowEmptyArrays` option can only be `true` or `false`, when provided');
    }

    if (typeof opts.encodeDotInKeys !== 'undefined' && typeof opts.encodeDotInKeys !== 'boolean') {
        throw new TypeError('`encodeDotInKeys` option can only be `true` or `false`, when provided');
    }

    if (opts.encoder !== null && typeof opts.encoder !== 'undefined' && typeof opts.encoder !== 'function') {
        throw new TypeError('Encoder has to be a function.');
    }

    var charset = opts.charset || defaults.charset;
    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
        throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    }

    var format = formats['default'];
    if (typeof opts.format !== 'undefined') {
        if (!has.call(formats.formatters, opts.format)) {
            throw new TypeError('Unknown format option provided.');
        }
        format = opts.format;
    }
    var formatter = formats.formatters[format];

    var filter = defaults.filter;
    if (typeof opts.filter === 'function' || isArray(opts.filter)) {
        filter = opts.filter;
    }

    var arrayFormat;
    if (opts.arrayFormat in arrayPrefixGenerators) {
        arrayFormat = opts.arrayFormat;
    } else if ('indices' in opts) {
        arrayFormat = opts.indices ? 'indices' : 'repeat';
    } else {
        arrayFormat = defaults.arrayFormat;
    }

    if ('commaRoundTrip' in opts && typeof opts.commaRoundTrip !== 'boolean') {
        throw new TypeError('`commaRoundTrip` must be a boolean, or absent');
    }

    var allowDots = typeof opts.allowDots === 'undefined' ? opts.encodeDotInKeys === true ? true : defaults.allowDots : !!opts.allowDots;

    return {
        addQueryPrefix: typeof opts.addQueryPrefix === 'boolean' ? opts.addQueryPrefix : defaults.addQueryPrefix,
        allowDots: allowDots,
        allowEmptyArrays: typeof opts.allowEmptyArrays === 'boolean' ? !!opts.allowEmptyArrays : defaults.allowEmptyArrays,
        arrayFormat: arrayFormat,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
        commaRoundTrip: opts.commaRoundTrip,
        delimiter: typeof opts.delimiter === 'undefined' ? defaults.delimiter : opts.delimiter,
        encode: typeof opts.encode === 'boolean' ? opts.encode : defaults.encode,
        encodeDotInKeys: typeof opts.encodeDotInKeys === 'boolean' ? opts.encodeDotInKeys : defaults.encodeDotInKeys,
        encoder: typeof opts.encoder === 'function' ? opts.encoder : defaults.encoder,
        encodeValuesOnly: typeof opts.encodeValuesOnly === 'boolean' ? opts.encodeValuesOnly : defaults.encodeValuesOnly,
        filter: filter,
        format: format,
        formatter: formatter,
        serializeDate: typeof opts.serializeDate === 'function' ? opts.serializeDate : defaults.serializeDate,
        skipNulls: typeof opts.skipNulls === 'boolean' ? opts.skipNulls : defaults.skipNulls,
        sort: typeof opts.sort === 'function' ? opts.sort : null,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling
    };
};

module.exports = function (object, opts) {
    var obj = object;
    var options = normalizeStringifyOptions(opts);

    var objKeys;
    var filter;

    if (typeof options.filter === 'function') {
        filter = options.filter;
        obj = filter('', obj);
    } else if (isArray(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }

    var keys = [];

    if (typeof obj !== 'object' || obj === null) {
        return '';
    }

    var generateArrayPrefix = arrayPrefixGenerators[options.arrayFormat];
    var commaRoundTrip = generateArrayPrefix === 'comma' && options.commaRoundTrip;

    if (!objKeys) {
        objKeys = Object.keys(obj);
    }

    if (options.sort) {
        objKeys.sort(options.sort);
    }

    var sideChannel = getSideChannel();
    for (var i = 0; i < objKeys.length; ++i) {
        var key = objKeys[i];

        if (options.skipNulls && obj[key] === null) {
            continue;
        }
        pushToArray(keys, stringify(
            obj[key],
            key,
            generateArrayPrefix,
            commaRoundTrip,
            options.allowEmptyArrays,
            options.strictNullHandling,
            options.skipNulls,
            options.encodeDotInKeys,
            options.encode ? options.encoder : null,
            options.filter,
            options.sort,
            options.allowDots,
            options.serializeDate,
            options.format,
            options.formatter,
            options.encodeValuesOnly,
            options.charset,
            sideChannel
        ));
    }

    var joined = keys.join(options.delimiter);
    var prefix = options.addQueryPrefix === true ? '?' : '';

    if (options.charsetSentinel) {
        if (options.charset === 'iso-8859-1') {
            // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
            prefix += 'utf8=%26%2310003%3B&';
        } else {
            // encodeURIComponent('✓')
            prefix += 'utf8=%E2%9C%93&';
        }
    }

    return joined.length > 0 ? prefix + joined : '';
};


/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(84);
var callBound = __webpack_require__(579);
var inspect = __webpack_require__(584);

var $TypeError = __webpack_require__(93);
var $WeakMap = GetIntrinsic('%WeakMap%', true);
var $Map = GetIntrinsic('%Map%', true);

var $weakMapGet = callBound('WeakMap.prototype.get', true);
var $weakMapSet = callBound('WeakMap.prototype.set', true);
var $weakMapHas = callBound('WeakMap.prototype.has', true);
var $mapGet = callBound('Map.prototype.get', true);
var $mapSet = callBound('Map.prototype.set', true);
var $mapHas = callBound('Map.prototype.has', true);

/*
* This function traverses the list returning the node corresponding to the given key.
*
* That node is also moved to the head of the list, so that if it's accessed again we don't need to traverse the whole list. By doing so, all the recently used nodes can be accessed relatively quickly.
*/
/** @type {import('.').listGetNode} */
var listGetNode = function (list, key) { // eslint-disable-line consistent-return
	/** @type {typeof list | NonNullable<(typeof list)['next']>} */
	var prev = list;
	/** @type {(typeof list)['next']} */
	var curr;
	for (; (curr = prev.next) !== null; prev = curr) {
		if (curr.key === key) {
			prev.next = curr.next;
			// eslint-disable-next-line no-extra-parens
			curr.next = /** @type {NonNullable<typeof list.next>} */ (list.next);
			list.next = curr; // eslint-disable-line no-param-reassign
			return curr;
		}
	}
};

/** @type {import('.').listGet} */
var listGet = function (objects, key) {
	var node = listGetNode(objects, key);
	return node && node.value;
};
/** @type {import('.').listSet} */
var listSet = function (objects, key, value) {
	var node = listGetNode(objects, key);
	if (node) {
		node.value = value;
	} else {
		// Prepend the new node to the beginning of the list
		objects.next = /** @type {import('.').ListNode<typeof value>} */ ({ // eslint-disable-line no-param-reassign, no-extra-parens
			key: key,
			next: objects.next,
			value: value
		});
	}
};
/** @type {import('.').listHas} */
var listHas = function (objects, key) {
	return !!listGetNode(objects, key);
};

/** @type {import('.')} */
module.exports = function getSideChannel() {
	/** @type {WeakMap<object, unknown>} */ var $wm;
	/** @type {Map<object, unknown>} */ var $m;
	/** @type {import('.').RootNode<unknown>} */ var $o;

	/** @type {import('.').Channel} */
	var channel = {
		assert: function (key) {
			if (!channel.has(key)) {
				throw new $TypeError('Side channel does not contain ' + inspect(key));
			}
		},
		get: function (key) { // eslint-disable-line consistent-return
			if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
				if ($wm) {
					return $weakMapGet($wm, key);
				}
			} else if ($Map) {
				if ($m) {
					return $mapGet($m, key);
				}
			} else {
				if ($o) { // eslint-disable-line no-lonely-if
					return listGet($o, key);
				}
			}
		},
		has: function (key) {
			if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
				if ($wm) {
					return $weakMapHas($wm, key);
				}
			} else if ($Map) {
				if ($m) {
					return $mapHas($m, key);
				}
			} else {
				if ($o) { // eslint-disable-line no-lonely-if
					return listHas($o, key);
				}
			}
			return false;
		},
		set: function (key, value) {
			if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
				if (!$wm) {
					$wm = new $WeakMap();
				}
				$weakMapSet($wm, key, value);
			} else if ($Map) {
				if (!$m) {
					$m = new $Map();
				}
				$mapSet($m, key, value);
			} else {
				if (!$o) {
					// Initialize the linked list as an empty node, so that we don't have to special-case handling of the first node: we can always refer to it as (previous node).next, instead of something like (list).head
					$o = { key: {}, next: null };
				}
				listSet($o, key, value);
			}
		}
	};
	return channel;
};


/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('.')} */
module.exports = Error;


/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('./eval')} */
module.exports = EvalError;


/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('./range')} */
module.exports = RangeError;


/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('./ref')} */
module.exports = ReferenceError;


/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('./uri')} */
module.exports = URIError;


/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var origSymbol = typeof Symbol !== 'undefined' && Symbol;
var hasSymbolSham = __webpack_require__(575);

module.exports = function hasNativeSymbols() {
	if (typeof origSymbol !== 'function') { return false; }
	if (typeof Symbol !== 'function') { return false; }
	if (typeof origSymbol('foo') !== 'symbol') { return false; }
	if (typeof Symbol('bar') !== 'symbol') { return false; }

	return hasSymbolSham();
};


/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint complexity: [2, 18], max-statements: [2, 33] */
module.exports = function hasSymbols() {
	if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') { return false; }
	if (typeof Symbol.iterator === 'symbol') { return true; }

	var obj = {};
	var sym = Symbol('test');
	var symObj = Object(sym);
	if (typeof sym === 'string') { return false; }

	if (Object.prototype.toString.call(sym) !== '[object Symbol]') { return false; }
	if (Object.prototype.toString.call(symObj) !== '[object Symbol]') { return false; }

	// temp disabled per https://github.com/ljharb/object.assign/issues/17
	// if (sym instanceof Symbol) { return false; }
	// temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
	// if (!(symObj instanceof Symbol)) { return false; }

	// if (typeof Symbol.prototype.toString !== 'function') { return false; }
	// if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }

	var symVal = 42;
	obj[sym] = symVal;
	for (sym in obj) { return false; } // eslint-disable-line no-restricted-syntax, no-unreachable-loop
	if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) { return false; }

	if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) { return false; }

	var syms = Object.getOwnPropertySymbols(obj);
	if (syms.length !== 1 || syms[0] !== sym) { return false; }

	if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) { return false; }

	if (typeof Object.getOwnPropertyDescriptor === 'function') {
		var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
		if (descriptor.value !== symVal || descriptor.enumerable !== true) { return false; }
	}

	return true;
};


/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var test = {
	__proto__: null,
	foo: {}
};

var $Object = Object;

/** @type {import('.')} */
module.exports = function hasProto() {
	// @ts-expect-error: TS errors on an inherited property for some reason
	return { __proto__: test }.foo === test.foo
		&& !(test instanceof $Object);
};


/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint no-invalid-this: 1 */

var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var toStr = Object.prototype.toString;
var max = Math.max;
var funcType = '[object Function]';

var concatty = function concatty(a, b) {
    var arr = [];

    for (var i = 0; i < a.length; i += 1) {
        arr[i] = a[i];
    }
    for (var j = 0; j < b.length; j += 1) {
        arr[j + a.length] = b[j];
    }

    return arr;
};

var slicy = function slicy(arrLike, offset) {
    var arr = [];
    for (var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1) {
        arr[j] = arrLike[i];
    }
    return arr;
};

var joiny = function (arr, joiner) {
    var str = '';
    for (var i = 0; i < arr.length; i += 1) {
        str += arr[i];
        if (i + 1 < arr.length) {
            str += joiner;
        }
    }
    return str;
};

module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || toStr.apply(target) !== funcType) {
        throw new TypeError(ERROR_MESSAGE + target);
    }
    var args = slicy(arguments, 1);

    var bound;
    var binder = function () {
        if (this instanceof bound) {
            var result = target.apply(
                this,
                concatty(args, arguments)
            );
            if (Object(result) === result) {
                return result;
            }
            return this;
        }
        return target.apply(
            that,
            concatty(args, arguments)
        );

    };

    var boundLength = max(0, target.length - args.length);
    var boundArgs = [];
    for (var i = 0; i < boundLength; i++) {
        boundArgs[i] = '$' + i;
    }

    bound = Function('binder', 'return function (' + joiny(boundArgs, ',') + '){ return binder.apply(this,arguments); }')(binder);

    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }

    return bound;
};


/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var call = Function.prototype.call;
var $hasOwn = Object.prototype.hasOwnProperty;
var bind = __webpack_require__(155);

/** @type {import('.')} */
module.exports = bind.call(call, $hasOwn);


/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(84);

var callBind = __webpack_require__(580);

var $indexOf = callBind(GetIntrinsic('String.prototype.indexOf'));

module.exports = function callBoundIntrinsic(name, allowMissing) {
	var intrinsic = GetIntrinsic(name, !!allowMissing);
	if (typeof intrinsic === 'function' && $indexOf(name, '.prototype.') > -1) {
		return callBind(intrinsic);
	}
	return intrinsic;
};


/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(155);
var GetIntrinsic = __webpack_require__(84);
var setFunctionLength = __webpack_require__(581);

var $TypeError = __webpack_require__(93);
var $apply = GetIntrinsic('%Function.prototype.apply%');
var $call = GetIntrinsic('%Function.prototype.call%');
var $reflectApply = GetIntrinsic('%Reflect.apply%', true) || bind.call($call, $apply);

var $defineProperty = __webpack_require__(156);
var $max = GetIntrinsic('%Math.max%');

module.exports = function callBind(originalFunction) {
	if (typeof originalFunction !== 'function') {
		throw new $TypeError('a function is required');
	}
	var func = $reflectApply(bind, $call, arguments);
	return setFunctionLength(
		func,
		1 + $max(0, originalFunction.length - (arguments.length - 1)),
		true
	);
};

var applyBind = function applyBind() {
	return $reflectApply(bind, $apply, arguments);
};

if ($defineProperty) {
	$defineProperty(module.exports, 'apply', { value: applyBind });
} else {
	module.exports.apply = applyBind;
}


/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(84);
var define = __webpack_require__(582);
var hasDescriptors = __webpack_require__(583)();
var gOPD = __webpack_require__(240);

var $TypeError = __webpack_require__(93);
var $floor = GetIntrinsic('%Math.floor%');

/** @type {import('.')} */
module.exports = function setFunctionLength(fn, length) {
	if (typeof fn !== 'function') {
		throw new $TypeError('`fn` is not a function');
	}
	if (typeof length !== 'number' || length < 0 || length > 0xFFFFFFFF || $floor(length) !== length) {
		throw new $TypeError('`length` must be a positive 32-bit integer');
	}

	var loose = arguments.length > 2 && !!arguments[2];

	var functionLengthIsConfigurable = true;
	var functionLengthIsWritable = true;
	if ('length' in fn && gOPD) {
		var desc = gOPD(fn, 'length');
		if (desc && !desc.configurable) {
			functionLengthIsConfigurable = false;
		}
		if (desc && !desc.writable) {
			functionLengthIsWritable = false;
		}
	}

	if (functionLengthIsConfigurable || functionLengthIsWritable || !loose) {
		if (hasDescriptors) {
			define(/** @type {Parameters<define>[0]} */ (fn), 'length', length, true, true);
		} else {
			define(/** @type {Parameters<define>[0]} */ (fn), 'length', length);
		}
	}
	return fn;
};


/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $defineProperty = __webpack_require__(156);

var $SyntaxError = __webpack_require__(239);
var $TypeError = __webpack_require__(93);

var gopd = __webpack_require__(240);

/** @type {import('.')} */
module.exports = function defineDataProperty(
	obj,
	property,
	value
) {
	if (!obj || (typeof obj !== 'object' && typeof obj !== 'function')) {
		throw new $TypeError('`obj` must be an object or a function`');
	}
	if (typeof property !== 'string' && typeof property !== 'symbol') {
		throw new $TypeError('`property` must be a string or a symbol`');
	}
	if (arguments.length > 3 && typeof arguments[3] !== 'boolean' && arguments[3] !== null) {
		throw new $TypeError('`nonEnumerable`, if provided, must be a boolean or null');
	}
	if (arguments.length > 4 && typeof arguments[4] !== 'boolean' && arguments[4] !== null) {
		throw new $TypeError('`nonWritable`, if provided, must be a boolean or null');
	}
	if (arguments.length > 5 && typeof arguments[5] !== 'boolean' && arguments[5] !== null) {
		throw new $TypeError('`nonConfigurable`, if provided, must be a boolean or null');
	}
	if (arguments.length > 6 && typeof arguments[6] !== 'boolean') {
		throw new $TypeError('`loose`, if provided, must be a boolean');
	}

	var nonEnumerable = arguments.length > 3 ? arguments[3] : null;
	var nonWritable = arguments.length > 4 ? arguments[4] : null;
	var nonConfigurable = arguments.length > 5 ? arguments[5] : null;
	var loose = arguments.length > 6 ? arguments[6] : false;

	/* @type {false | TypedPropertyDescriptor<unknown>} */
	var desc = !!gopd && gopd(obj, property);

	if ($defineProperty) {
		$defineProperty(obj, property, {
			configurable: nonConfigurable === null && desc ? desc.configurable : !nonConfigurable,
			enumerable: nonEnumerable === null && desc ? desc.enumerable : !nonEnumerable,
			value: value,
			writable: nonWritable === null && desc ? desc.writable : !nonWritable
		});
	} else if (loose || (!nonEnumerable && !nonWritable && !nonConfigurable)) {
		// must fall back to [[Set]], and was not explicitly asked to make non-enumerable, non-writable, or non-configurable
		obj[property] = value; // eslint-disable-line no-param-reassign
	} else {
		throw new $SyntaxError('This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.');
	}
};


/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $defineProperty = __webpack_require__(156);

var hasPropertyDescriptors = function hasPropertyDescriptors() {
	return !!$defineProperty;
};

hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
	// node v0.6 has a bug where array lengths can be Set but not Defined
	if (!$defineProperty) {
		return null;
	}
	try {
		return $defineProperty([], 'length', { value: 1 }).length !== 1;
	} catch (e) {
		// In Firefox 4-22, defining length on an array throws an exception.
		return true;
	}
};

module.exports = hasPropertyDescriptors;


/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var hasMap = typeof Map === 'function' && Map.prototype;
var mapSizeDescriptor = Object.getOwnPropertyDescriptor && hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, 'size') : null;
var mapSize = hasMap && mapSizeDescriptor && typeof mapSizeDescriptor.get === 'function' ? mapSizeDescriptor.get : null;
var mapForEach = hasMap && Map.prototype.forEach;
var hasSet = typeof Set === 'function' && Set.prototype;
var setSizeDescriptor = Object.getOwnPropertyDescriptor && hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, 'size') : null;
var setSize = hasSet && setSizeDescriptor && typeof setSizeDescriptor.get === 'function' ? setSizeDescriptor.get : null;
var setForEach = hasSet && Set.prototype.forEach;
var hasWeakMap = typeof WeakMap === 'function' && WeakMap.prototype;
var weakMapHas = hasWeakMap ? WeakMap.prototype.has : null;
var hasWeakSet = typeof WeakSet === 'function' && WeakSet.prototype;
var weakSetHas = hasWeakSet ? WeakSet.prototype.has : null;
var hasWeakRef = typeof WeakRef === 'function' && WeakRef.prototype;
var weakRefDeref = hasWeakRef ? WeakRef.prototype.deref : null;
var booleanValueOf = Boolean.prototype.valueOf;
var objectToString = Object.prototype.toString;
var functionToString = Function.prototype.toString;
var $match = String.prototype.match;
var $slice = String.prototype.slice;
var $replace = String.prototype.replace;
var $toUpperCase = String.prototype.toUpperCase;
var $toLowerCase = String.prototype.toLowerCase;
var $test = RegExp.prototype.test;
var $concat = Array.prototype.concat;
var $join = Array.prototype.join;
var $arrSlice = Array.prototype.slice;
var $floor = Math.floor;
var bigIntValueOf = typeof BigInt === 'function' ? BigInt.prototype.valueOf : null;
var gOPS = Object.getOwnPropertySymbols;
var symToString = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol' ? Symbol.prototype.toString : null;
var hasShammedSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'object';
// ie, `has-tostringtag/shams
var toStringTag = typeof Symbol === 'function' && Symbol.toStringTag && (typeof Symbol.toStringTag === hasShammedSymbols ? 'object' : 'symbol')
    ? Symbol.toStringTag
    : null;
var isEnumerable = Object.prototype.propertyIsEnumerable;

var gPO = (typeof Reflect === 'function' ? Reflect.getPrototypeOf : Object.getPrototypeOf) || (
    [].__proto__ === Array.prototype // eslint-disable-line no-proto
        ? function (O) {
            return O.__proto__; // eslint-disable-line no-proto
        }
        : null
);

function addNumericSeparator(num, str) {
    if (
        num === Infinity
        || num === -Infinity
        || num !== num
        || (num && num > -1000 && num < 1000)
        || $test.call(/e/, str)
    ) {
        return str;
    }
    var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof num === 'number') {
        var int = num < 0 ? -$floor(-num) : $floor(num); // trunc(num)
        if (int !== num) {
            var intStr = String(int);
            var dec = $slice.call(str, intStr.length + 1);
            return $replace.call(intStr, sepRegex, '$&_') + '.' + $replace.call($replace.call(dec, /([0-9]{3})/g, '$&_'), /_$/, '');
        }
    }
    return $replace.call(str, sepRegex, '$&_');
}

var utilInspect = __webpack_require__(585);
var inspectCustom = utilInspect.custom;
var inspectSymbol = isSymbol(inspectCustom) ? inspectCustom : null;

var quotes = {
    __proto__: null,
    'double': '"',
    single: "'"
};
var quoteREs = {
    __proto__: null,
    'double': /(["\\])/g,
    single: /(['\\])/g
};

module.exports = function inspect_(obj, options, depth, seen) {
    var opts = options || {};

    if (has(opts, 'quoteStyle') && !has(quotes, opts.quoteStyle)) {
        throw new TypeError('option "quoteStyle" must be "single" or "double"');
    }
    if (
        has(opts, 'maxStringLength') && (typeof opts.maxStringLength === 'number'
            ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity
            : opts.maxStringLength !== null
        )
    ) {
        throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    }
    var customInspect = has(opts, 'customInspect') ? opts.customInspect : true;
    if (typeof customInspect !== 'boolean' && customInspect !== 'symbol') {
        throw new TypeError('option "customInspect", if provided, must be `true`, `false`, or `\'symbol\'`');
    }

    if (
        has(opts, 'indent')
        && opts.indent !== null
        && opts.indent !== '\t'
        && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)
    ) {
        throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    }
    if (has(opts, 'numericSeparator') && typeof opts.numericSeparator !== 'boolean') {
        throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    }
    var numericSeparator = opts.numericSeparator;

    if (typeof obj === 'undefined') {
        return 'undefined';
    }
    if (obj === null) {
        return 'null';
    }
    if (typeof obj === 'boolean') {
        return obj ? 'true' : 'false';
    }

    if (typeof obj === 'string') {
        return inspectString(obj, opts);
    }
    if (typeof obj === 'number') {
        if (obj === 0) {
            return Infinity / obj > 0 ? '0' : '-0';
        }
        var str = String(obj);
        return numericSeparator ? addNumericSeparator(obj, str) : str;
    }
    if (typeof obj === 'bigint') {
        var bigIntStr = String(obj) + 'n';
        return numericSeparator ? addNumericSeparator(obj, bigIntStr) : bigIntStr;
    }

    var maxDepth = typeof opts.depth === 'undefined' ? 5 : opts.depth;
    if (typeof depth === 'undefined') { depth = 0; }
    if (depth >= maxDepth && maxDepth > 0 && typeof obj === 'object') {
        return isArray(obj) ? '[Array]' : '[Object]';
    }

    var indent = getIndent(opts, depth);

    if (typeof seen === 'undefined') {
        seen = [];
    } else if (indexOf(seen, obj) >= 0) {
        return '[Circular]';
    }

    function inspect(value, from, noIndent) {
        if (from) {
            seen = $arrSlice.call(seen);
            seen.push(from);
        }
        if (noIndent) {
            var newOpts = {
                depth: opts.depth
            };
            if (has(opts, 'quoteStyle')) {
                newOpts.quoteStyle = opts.quoteStyle;
            }
            return inspect_(value, newOpts, depth + 1, seen);
        }
        return inspect_(value, opts, depth + 1, seen);
    }

    if (typeof obj === 'function' && !isRegExp(obj)) { // in older engines, regexes are callable
        var name = nameOf(obj);
        var keys = arrObjKeys(obj, inspect);
        return '[Function' + (name ? ': ' + name : ' (anonymous)') + ']' + (keys.length > 0 ? ' { ' + $join.call(keys, ', ') + ' }' : '');
    }
    if (isSymbol(obj)) {
        var symString = hasShammedSymbols ? $replace.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, '$1') : symToString.call(obj);
        return typeof obj === 'object' && !hasShammedSymbols ? markBoxed(symString) : symString;
    }
    if (isElement(obj)) {
        var s = '<' + $toLowerCase.call(String(obj.nodeName));
        var attrs = obj.attributes || [];
        for (var i = 0; i < attrs.length; i++) {
            s += ' ' + attrs[i].name + '=' + wrapQuotes(quote(attrs[i].value), 'double', opts);
        }
        s += '>';
        if (obj.childNodes && obj.childNodes.length) { s += '...'; }
        s += '</' + $toLowerCase.call(String(obj.nodeName)) + '>';
        return s;
    }
    if (isArray(obj)) {
        if (obj.length === 0) { return '[]'; }
        var xs = arrObjKeys(obj, inspect);
        if (indent && !singleLineValues(xs)) {
            return '[' + indentedJoin(xs, indent) + ']';
        }
        return '[ ' + $join.call(xs, ', ') + ' ]';
    }
    if (isError(obj)) {
        var parts = arrObjKeys(obj, inspect);
        if (!('cause' in Error.prototype) && 'cause' in obj && !isEnumerable.call(obj, 'cause')) {
            return '{ [' + String(obj) + '] ' + $join.call($concat.call('[cause]: ' + inspect(obj.cause), parts), ', ') + ' }';
        }
        if (parts.length === 0) { return '[' + String(obj) + ']'; }
        return '{ [' + String(obj) + '] ' + $join.call(parts, ', ') + ' }';
    }
    if (typeof obj === 'object' && customInspect) {
        if (inspectSymbol && typeof obj[inspectSymbol] === 'function' && utilInspect) {
            return utilInspect(obj, { depth: maxDepth - depth });
        } else if (customInspect !== 'symbol' && typeof obj.inspect === 'function') {
            return obj.inspect();
        }
    }
    if (isMap(obj)) {
        var mapParts = [];
        if (mapForEach) {
            mapForEach.call(obj, function (value, key) {
                mapParts.push(inspect(key, obj, true) + ' => ' + inspect(value, obj));
            });
        }
        return collectionOf('Map', mapSize.call(obj), mapParts, indent);
    }
    if (isSet(obj)) {
        var setParts = [];
        if (setForEach) {
            setForEach.call(obj, function (value) {
                setParts.push(inspect(value, obj));
            });
        }
        return collectionOf('Set', setSize.call(obj), setParts, indent);
    }
    if (isWeakMap(obj)) {
        return weakCollectionOf('WeakMap');
    }
    if (isWeakSet(obj)) {
        return weakCollectionOf('WeakSet');
    }
    if (isWeakRef(obj)) {
        return weakCollectionOf('WeakRef');
    }
    if (isNumber(obj)) {
        return markBoxed(inspect(Number(obj)));
    }
    if (isBigInt(obj)) {
        return markBoxed(inspect(bigIntValueOf.call(obj)));
    }
    if (isBoolean(obj)) {
        return markBoxed(booleanValueOf.call(obj));
    }
    if (isString(obj)) {
        return markBoxed(inspect(String(obj)));
    }
    // note: in IE 8, sometimes `global !== window` but both are the prototypes of each other
    /* eslint-env browser */
    if (typeof window !== 'undefined' && obj === window) {
        return '{ [object Window] }';
    }
    if (
        (typeof globalThis !== 'undefined' && obj === globalThis)
        || (typeof global !== 'undefined' && obj === global)
    ) {
        return '{ [object globalThis] }';
    }
    if (!isDate(obj) && !isRegExp(obj)) {
        var ys = arrObjKeys(obj, inspect);
        var isPlainObject = gPO ? gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
        var protoTag = obj instanceof Object ? '' : 'null prototype';
        var stringTag = !isPlainObject && toStringTag && Object(obj) === obj && toStringTag in obj ? $slice.call(toStr(obj), 8, -1) : protoTag ? 'Object' : '';
        var constructorTag = isPlainObject || typeof obj.constructor !== 'function' ? '' : obj.constructor.name ? obj.constructor.name + ' ' : '';
        var tag = constructorTag + (stringTag || protoTag ? '[' + $join.call($concat.call([], stringTag || [], protoTag || []), ': ') + '] ' : '');
        if (ys.length === 0) { return tag + '{}'; }
        if (indent) {
            return tag + '{' + indentedJoin(ys, indent) + '}';
        }
        return tag + '{ ' + $join.call(ys, ', ') + ' }';
    }
    return String(obj);
};

function wrapQuotes(s, defaultStyle, opts) {
    var style = opts.quoteStyle || defaultStyle;
    var quoteChar = quotes[style];
    return quoteChar + s + quoteChar;
}

function quote(s) {
    return $replace.call(String(s), /"/g, '&quot;');
}

function isArray(obj) { return toStr(obj) === '[object Array]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isDate(obj) { return toStr(obj) === '[object Date]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isRegExp(obj) { return toStr(obj) === '[object RegExp]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isError(obj) { return toStr(obj) === '[object Error]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isString(obj) { return toStr(obj) === '[object String]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isNumber(obj) { return toStr(obj) === '[object Number]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isBoolean(obj) { return toStr(obj) === '[object Boolean]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }

// Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives
function isSymbol(obj) {
    if (hasShammedSymbols) {
        return obj && typeof obj === 'object' && obj instanceof Symbol;
    }
    if (typeof obj === 'symbol') {
        return true;
    }
    if (!obj || typeof obj !== 'object' || !symToString) {
        return false;
    }
    try {
        symToString.call(obj);
        return true;
    } catch (e) {}
    return false;
}

function isBigInt(obj) {
    if (!obj || typeof obj !== 'object' || !bigIntValueOf) {
        return false;
    }
    try {
        bigIntValueOf.call(obj);
        return true;
    } catch (e) {}
    return false;
}

var hasOwn = Object.prototype.hasOwnProperty || function (key) { return key in this; };
function has(obj, key) {
    return hasOwn.call(obj, key);
}

function toStr(obj) {
    return objectToString.call(obj);
}

function nameOf(f) {
    if (f.name) { return f.name; }
    var m = $match.call(functionToString.call(f), /^function\s*([\w$]+)/);
    if (m) { return m[1]; }
    return null;
}

function indexOf(xs, x) {
    if (xs.indexOf) { return xs.indexOf(x); }
    for (var i = 0, l = xs.length; i < l; i++) {
        if (xs[i] === x) { return i; }
    }
    return -1;
}

function isMap(x) {
    if (!mapSize || !x || typeof x !== 'object') {
        return false;
    }
    try {
        mapSize.call(x);
        try {
            setSize.call(x);
        } catch (s) {
            return true;
        }
        return x instanceof Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakMap(x) {
    if (!weakMapHas || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakMapHas.call(x, weakMapHas);
        try {
            weakSetHas.call(x, weakSetHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakRef(x) {
    if (!weakRefDeref || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakRefDeref.call(x);
        return true;
    } catch (e) {}
    return false;
}

function isSet(x) {
    if (!setSize || !x || typeof x !== 'object') {
        return false;
    }
    try {
        setSize.call(x);
        try {
            mapSize.call(x);
        } catch (m) {
            return true;
        }
        return x instanceof Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakSet(x) {
    if (!weakSetHas || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakSetHas.call(x, weakSetHas);
        try {
            weakMapHas.call(x, weakMapHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isElement(x) {
    if (!x || typeof x !== 'object') { return false; }
    if (typeof HTMLElement !== 'undefined' && x instanceof HTMLElement) {
        return true;
    }
    return typeof x.nodeName === 'string' && typeof x.getAttribute === 'function';
}

function inspectString(str, opts) {
    if (str.length > opts.maxStringLength) {
        var remaining = str.length - opts.maxStringLength;
        var trailer = '... ' + remaining + ' more character' + (remaining > 1 ? 's' : '');
        return inspectString($slice.call(str, 0, opts.maxStringLength), opts) + trailer;
    }
    var quoteRE = quoteREs[opts.quoteStyle || 'single'];
    quoteRE.lastIndex = 0;
    // eslint-disable-next-line no-control-regex
    var s = $replace.call($replace.call(str, quoteRE, '\\$1'), /[\x00-\x1f]/g, lowbyte);
    return wrapQuotes(s, 'single', opts);
}

function lowbyte(c) {
    var n = c.charCodeAt(0);
    var x = {
        8: 'b',
        9: 't',
        10: 'n',
        12: 'f',
        13: 'r'
    }[n];
    if (x) { return '\\' + x; }
    return '\\x' + (n < 0x10 ? '0' : '') + $toUpperCase.call(n.toString(16));
}

function markBoxed(str) {
    return 'Object(' + str + ')';
}

function weakCollectionOf(type) {
    return type + ' { ? }';
}

function collectionOf(type, size, entries, indent) {
    var joinedEntries = indent ? indentedJoin(entries, indent) : $join.call(entries, ', ');
    return type + ' (' + size + ') {' + joinedEntries + '}';
}

function singleLineValues(xs) {
    for (var i = 0; i < xs.length; i++) {
        if (indexOf(xs[i], '\n') >= 0) {
            return false;
        }
    }
    return true;
}

function getIndent(opts, depth) {
    var baseIndent;
    if (opts.indent === '\t') {
        baseIndent = '\t';
    } else if (typeof opts.indent === 'number' && opts.indent > 0) {
        baseIndent = $join.call(Array(opts.indent + 1), ' ');
    } else {
        return null;
    }
    return {
        base: baseIndent,
        prev: $join.call(Array(depth + 1), baseIndent)
    };
}

function indentedJoin(xs, indent) {
    if (xs.length === 0) { return ''; }
    var lineJoiner = '\n' + indent.prev + indent.base;
    return lineJoiner + $join.call(xs, ',' + lineJoiner) + '\n' + indent.prev;
}

function arrObjKeys(obj, inspect) {
    var isArr = isArray(obj);
    var xs = [];
    if (isArr) {
        xs.length = obj.length;
        for (var i = 0; i < obj.length; i++) {
            xs[i] = has(obj, i) ? inspect(obj[i], obj) : '';
        }
    }
    var syms = typeof gOPS === 'function' ? gOPS(obj) : [];
    var symMap;
    if (hasShammedSymbols) {
        symMap = {};
        for (var k = 0; k < syms.length; k++) {
            symMap['$' + syms[k]] = syms[k];
        }
    }

    for (var key in obj) { // eslint-disable-line no-restricted-syntax
        if (!has(obj, key)) { continue; } // eslint-disable-line no-restricted-syntax, no-continue
        if (isArr && String(Number(key)) === key && key < obj.length) { continue; } // eslint-disable-line no-restricted-syntax, no-continue
        if (hasShammedSymbols && symMap['$' + key] instanceof Symbol) {
            // this is to prevent shammed Symbols, which are stored as strings, from being included in the string key section
            continue; // eslint-disable-line no-restricted-syntax, no-continue
        } else if ($test.call(/[^\w$]/, key)) {
            xs.push(inspect(key, obj) + ': ' + inspect(obj[key], obj));
        } else {
            xs.push(key + ': ' + inspect(obj[key], obj));
        }
    }
    if (typeof gOPS === 'function') {
        for (var j = 0; j < syms.length; j++) {
            if (isEnumerable.call(obj, syms[j])) {
                xs.push('[' + inspect(syms[j]) + ']: ' + inspect(obj[syms[j]], obj));
            }
        }
    }
    return xs;
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(71)))

/***/ }),
/* 585 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(241);

var has = Object.prototype.hasOwnProperty;
var isArray = Array.isArray;

var defaults = {
    allowDots: false,
    allowEmptyArrays: false,
    allowPrototypes: false,
    allowSparse: false,
    arrayLimit: 20,
    charset: 'utf-8',
    charsetSentinel: false,
    comma: false,
    decodeDotInKeys: false,
    decoder: utils.decode,
    delimiter: '&',
    depth: 5,
    duplicates: 'combine',
    ignoreQueryPrefix: false,
    interpretNumericEntities: false,
    parameterLimit: 1000,
    parseArrays: true,
    plainObjects: false,
    strictDepth: false,
    strictNullHandling: false
};

var interpretNumericEntities = function (str) {
    return str.replace(/&#(\d+);/g, function ($0, numberStr) {
        return String.fromCharCode(parseInt(numberStr, 10));
    });
};

var parseArrayValue = function (val, options) {
    if (val && typeof val === 'string' && options.comma && val.indexOf(',') > -1) {
        return val.split(',');
    }

    return val;
};

// This is what browsers will submit when the ✓ character occurs in an
// application/x-www-form-urlencoded body and the encoding of the page containing
// the form is iso-8859-1, or when the submitted form has an accept-charset
// attribute of iso-8859-1. Presumably also with other charsets that do not contain
// the ✓ character, such as us-ascii.
var isoSentinel = 'utf8=%26%2310003%3B'; // encodeURIComponent('&#10003;')

// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
var charsetSentinel = 'utf8=%E2%9C%93'; // encodeURIComponent('✓')

var parseValues = function parseQueryStringValues(str, options) {
    var obj = { __proto__: null };

    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, '') : str;
    cleanStr = cleanStr.replace(/%5B/gi, '[').replace(/%5D/gi, ']');
    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
    var parts = cleanStr.split(options.delimiter, limit);
    var skipIndex = -1; // Keep track of where the utf8 sentinel was found
    var i;

    var charset = options.charset;
    if (options.charsetSentinel) {
        for (i = 0; i < parts.length; ++i) {
            if (parts[i].indexOf('utf8=') === 0) {
                if (parts[i] === charsetSentinel) {
                    charset = 'utf-8';
                } else if (parts[i] === isoSentinel) {
                    charset = 'iso-8859-1';
                }
                skipIndex = i;
                i = parts.length; // The eslint settings do not allow break;
            }
        }
    }

    for (i = 0; i < parts.length; ++i) {
        if (i === skipIndex) {
            continue;
        }
        var part = parts[i];

        var bracketEqualsPos = part.indexOf(']=');
        var pos = bracketEqualsPos === -1 ? part.indexOf('=') : bracketEqualsPos + 1;

        var key, val;
        if (pos === -1) {
            key = options.decoder(part, defaults.decoder, charset, 'key');
            val = options.strictNullHandling ? null : '';
        } else {
            key = options.decoder(part.slice(0, pos), defaults.decoder, charset, 'key');
            val = utils.maybeMap(
                parseArrayValue(part.slice(pos + 1), options),
                function (encodedVal) {
                    return options.decoder(encodedVal, defaults.decoder, charset, 'value');
                }
            );
        }

        if (val && options.interpretNumericEntities && charset === 'iso-8859-1') {
            val = interpretNumericEntities(val);
        }

        if (part.indexOf('[]=') > -1) {
            val = isArray(val) ? [val] : val;
        }

        var existing = has.call(obj, key);
        if (existing && options.duplicates === 'combine') {
            obj[key] = utils.combine(obj[key], val);
        } else if (!existing || options.duplicates === 'last') {
            obj[key] = val;
        }
    }

    return obj;
};

var parseObject = function (chain, val, options, valuesParsed) {
    var leaf = valuesParsed ? val : parseArrayValue(val, options);

    for (var i = chain.length - 1; i >= 0; --i) {
        var obj;
        var root = chain[i];

        if (root === '[]' && options.parseArrays) {
            obj = options.allowEmptyArrays && (leaf === '' || (options.strictNullHandling && leaf === null))
                ? []
                : [].concat(leaf);
        } else {
            obj = options.plainObjects ? Object.create(null) : {};
            var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
            var decodedRoot = options.decodeDotInKeys ? cleanRoot.replace(/%2E/g, '.') : cleanRoot;
            var index = parseInt(decodedRoot, 10);
            if (!options.parseArrays && decodedRoot === '') {
                obj = { 0: leaf };
            } else if (
                !isNaN(index)
                && root !== decodedRoot
                && String(index) === decodedRoot
                && index >= 0
                && (options.parseArrays && index <= options.arrayLimit)
            ) {
                obj = [];
                obj[index] = leaf;
            } else if (decodedRoot !== '__proto__') {
                obj[decodedRoot] = leaf;
            }
        }

        leaf = obj;
    }

    return leaf;
};

var parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
    if (!givenKey) {
        return;
    }

    // Transform dot notation to bracket notation
    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, '[$1]') : givenKey;

    // The regex chunks

    var brackets = /(\[[^[\]]*])/;
    var child = /(\[[^[\]]*])/g;

    // Get the parent

    var segment = options.depth > 0 && brackets.exec(key);
    var parent = segment ? key.slice(0, segment.index) : key;

    // Stash the parent if it exists

    var keys = [];
    if (parent) {
        // If we aren't using plain objects, optionally prefix keys that would overwrite object prototype properties
        if (!options.plainObjects && has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) {
                return;
            }
        }

        keys.push(parent);
    }

    // Loop through children appending to the array until we hit depth

    var i = 0;
    while (options.depth > 0 && (segment = child.exec(key)) !== null && i < options.depth) {
        i += 1;
        if (!options.plainObjects && has.call(Object.prototype, segment[1].slice(1, -1))) {
            if (!options.allowPrototypes) {
                return;
            }
        }
        keys.push(segment[1]);
    }

    // If there's a remainder, check strictDepth option for throw, else just add whatever is left

    if (segment) {
        if (options.strictDepth === true) {
            throw new RangeError('Input depth exceeded depth option of ' + options.depth + ' and strictDepth is true');
        }
        keys.push('[' + key.slice(segment.index) + ']');
    }

    return parseObject(keys, val, options, valuesParsed);
};

var normalizeParseOptions = function normalizeParseOptions(opts) {
    if (!opts) {
        return defaults;
    }

    if (typeof opts.allowEmptyArrays !== 'undefined' && typeof opts.allowEmptyArrays !== 'boolean') {
        throw new TypeError('`allowEmptyArrays` option can only be `true` or `false`, when provided');
    }

    if (typeof opts.decodeDotInKeys !== 'undefined' && typeof opts.decodeDotInKeys !== 'boolean') {
        throw new TypeError('`decodeDotInKeys` option can only be `true` or `false`, when provided');
    }

    if (opts.decoder !== null && typeof opts.decoder !== 'undefined' && typeof opts.decoder !== 'function') {
        throw new TypeError('Decoder has to be a function.');
    }

    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
        throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    }
    var charset = typeof opts.charset === 'undefined' ? defaults.charset : opts.charset;

    var duplicates = typeof opts.duplicates === 'undefined' ? defaults.duplicates : opts.duplicates;

    if (duplicates !== 'combine' && duplicates !== 'first' && duplicates !== 'last') {
        throw new TypeError('The duplicates option must be either combine, first, or last');
    }

    var allowDots = typeof opts.allowDots === 'undefined' ? opts.decodeDotInKeys === true ? true : defaults.allowDots : !!opts.allowDots;

    return {
        allowDots: allowDots,
        allowEmptyArrays: typeof opts.allowEmptyArrays === 'boolean' ? !!opts.allowEmptyArrays : defaults.allowEmptyArrays,
        allowPrototypes: typeof opts.allowPrototypes === 'boolean' ? opts.allowPrototypes : defaults.allowPrototypes,
        allowSparse: typeof opts.allowSparse === 'boolean' ? opts.allowSparse : defaults.allowSparse,
        arrayLimit: typeof opts.arrayLimit === 'number' ? opts.arrayLimit : defaults.arrayLimit,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
        comma: typeof opts.comma === 'boolean' ? opts.comma : defaults.comma,
        decodeDotInKeys: typeof opts.decodeDotInKeys === 'boolean' ? opts.decodeDotInKeys : defaults.decodeDotInKeys,
        decoder: typeof opts.decoder === 'function' ? opts.decoder : defaults.decoder,
        delimiter: typeof opts.delimiter === 'string' || utils.isRegExp(opts.delimiter) ? opts.delimiter : defaults.delimiter,
        // eslint-disable-next-line no-implicit-coercion, no-extra-parens
        depth: (typeof opts.depth === 'number' || opts.depth === false) ? +opts.depth : defaults.depth,
        duplicates: duplicates,
        ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
        interpretNumericEntities: typeof opts.interpretNumericEntities === 'boolean' ? opts.interpretNumericEntities : defaults.interpretNumericEntities,
        parameterLimit: typeof opts.parameterLimit === 'number' ? opts.parameterLimit : defaults.parameterLimit,
        parseArrays: opts.parseArrays !== false,
        plainObjects: typeof opts.plainObjects === 'boolean' ? opts.plainObjects : defaults.plainObjects,
        strictDepth: typeof opts.strictDepth === 'boolean' ? !!opts.strictDepth : defaults.strictDepth,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling
    };
};

module.exports = function (str, opts) {
    var options = normalizeParseOptions(opts);

    if (str === '' || str === null || typeof str === 'undefined') {
        return options.plainObjects ? Object.create(null) : {};
    }

    var tempObj = typeof str === 'string' ? parseValues(str, options) : str;
    var obj = options.plainObjects ? Object.create(null) : {};

    // Iterate over the keys and setup the new object

    var keys = Object.keys(tempObj);
    for (var i = 0; i < keys.length; ++i) {
        var key = keys[i];
        var newObj = parseKeys(key, tempObj[key], options, typeof str === 'string');
        obj = utils.merge(obj, newObj, options);
    }

    if (options.allowSparse === true) {
        return obj;
    }

    return utils.compact(obj);
};


/***/ }),
/* 587 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Price; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_variables__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_mixins__ = __webpack_require__(6);
var _templateObject=_taggedTemplateLiteral(['\n  font-size: 18px;\n  font-weight: ',';\n  font-style: normal;\n  font-stretch: normal;\n  line-height: 1.57;\n  letter-spacing: normal;\n  margin-top: 0;\n  color: ',';\n  display: ',';\n  text-align: inherit;\n  \n  ','\n  \n  ','\n  \n  ','\n'],['\n  font-size: 18px;\n  font-weight: ',';\n  font-style: normal;\n  font-stretch: normal;\n  line-height: 1.57;\n  letter-spacing: normal;\n  margin-top: 0;\n  color: ',';\n  display: ',';\n  text-align: inherit;\n  \n  ','\n  \n  ','\n  \n  ','\n']),_templateObject2=_taggedTemplateLiteral(['\n      color: ',';\n      font-size: 13px;\n      text-decoration: line-through;\n      margin-left: 0.5em;\n      font-style: italic;\n      font-weight: normal;\n    '],['\n      color: ',';\n      font-size: 13px;\n      text-decoration: line-through;\n      margin-left: 0.5em;\n      font-style: italic;\n      font-weight: normal;\n    ']),_templateObject3=_taggedTemplateLiteral(['\n      ',';\n      margin-top: 0.35em;\n    '],['\n      ',';\n      margin-top: 0.35em;\n    ']),_templateObject4=_taggedTemplateLiteral(['\n      font-size: ',';\n    '],['\n      font-size: ',';\n    ']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Price=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].p(_templateObject,function(props){return props.fontWeight;},function(props){return props.sale?__WEBPACK_IMPORTED_MODULE_1__helpers_variables__["c" /* color */].sale:__WEBPACK_IMPORTED_MODULE_1__helpers_variables__["c" /* color */].black;},function(props){return props.inline?'inline':'block';},function(props){return props.originalPrice&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(_templateObject2,__WEBPACK_IMPORTED_MODULE_1__helpers_variables__["c" /* color */].darkgrey);},function(props){return props.small&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(_templateObject3,Object(__WEBPACK_IMPORTED_MODULE_2__helpers_mixins__["b" /* dynamicFontSize */])(12,15));},function(props){return props.fontSize&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(_templateObject4,props.fontSize);});

/***/ }),
/* 588 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_grid_styled__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_grid_styled___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_grid_styled__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_connect__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Page__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__actions_actionCreators__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_helpers_variables__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_blocks_StartPageBlock__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__constants_endpoints__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_LinedHeading__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_NavigationButton__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_LargeNavigationButton__ = __webpack_require__(622);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_AboutCard__ = __webpack_require__(624);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_StartPage_HeroSection__ = __webpack_require__(626);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_InstagramSection__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_InfoBanner__ = __webpack_require__(633);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_Conditional__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_InformationCards__ = __webpack_require__(634);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_ProductList__ = __webpack_require__(161);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import DesignerCard from '../components/DesignerCard';
var StartPage=function(_Component){_inherits(StartPage,_Component);function StartPage(props){_classCallCheck(this,StartPage);var _this=_possibleConstructorReturn(this,(StartPage.__proto__||Object.getPrototypeOf(StartPage)).call(this,props));_this.state={popularCategoriesNumber:props.viewstate.get('pageWidth')>__WEBPACK_IMPORTED_MODULE_8__styles_helpers_variables__["f" /* size */].xLarge?3:0};return _this;}_createClass(StartPage,[{key:'componentDidMount',value:function componentDidMount(){this.props.fetchArticlePageView({urlPath:this.props.location.pathname});}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){this.setState(function(){return{popularCategoriesNumber:nextProps.viewstate.get('pageWidth')>__WEBPACK_IMPORTED_MODULE_8__styles_helpers_variables__["f" /* size */].xLarge?3:0};});}},{key:'renderLargePopularCategories',value:function renderLargePopularCategories(){return this.props.startPage.getIn(['fields','categoryLinks'],Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["List"])()).take(this.state.popularCategoriesNumber).map(function(category){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grid_styled__["Box"],{key:category.get('systemId'),width:[1,1,1,1/3,1/3],py:['5px','8px','11px'],px:['0px','8px','11px']},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_LargeNavigationButton__["a" /* default */],{image:__WEBPACK_IMPORTED_MODULE_10__constants_endpoints__["n" /* SITE_ROOT_URL */]+category.getIn(['images',0,'url']),title:category.get('name'),url:category.get('url')}));}).toArray();}},{key:'renderSmallPopularCategories',value:function renderSmallPopularCategories(){return this.props.startPage.getIn(['fields','categoryLinks'],Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["List"])()).slice(this.state.popularCategoriesNumber,6+this.state.popularCategoriesNumber).map(function(category){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grid_styled__["Box"],{key:category.get('systemId'),width:[1,1,1/2,1/2,1/3],py:['5px','8px','11px'],px:['0px','8px','11px']},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_NavigationButton__["a" /* NavigationButton */],{image:category.getIn(['images',0,'url']),title:category.get('name'),url:category.get('url')}));}).toArray();}},{key:'render',value:function render(){var _props=this.props,startPage=_props.startPage,viewstate=_props.viewstate;var startPageFields=startPage.get('fields',Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])());var largePopularCategoriesList=this.renderLargePopularCategories();var smallPopularCategoriesList=this.renderSmallPopularCategories();var popularProducts=startPageFields.get('popularProducts');if(popularProducts){if(viewstate.get('pageWidth')>=850&&viewstate.get('pageWidth')<1100&&popularProducts.size===4){popularProducts=popularProducts.slice(0,3);}popularProducts=popularProducts.toMap().mapEntries(function(entry){var newEntry=entry;newEntry[0]=entry[1].get('id');return newEntry;});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Page__["a" /* default */],{meta:startPage.get('metaData'),bgColor:'white',noBreadcrumbs:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_StartPage_HeroSection__["a" /* default */],{backgroundColor:startPageFields.get('heroBackgroundColor',__WEBPACK_IMPORTED_MODULE_8__styles_helpers_variables__["c" /* color */].grey),heroImage:startPageFields.getIn(['heroImage','url'])?__WEBPACK_IMPORTED_MODULE_10__constants_endpoints__["n" /* SITE_ROOT_URL */]+startPageFields.getIn(['heroImage','url']):null,heroBackgroundIsLight:startPageFields.get('heroBackgroundIsLight'),heroTitle:startPageFields.get('heroTitle'),heroLinkUrl:startPageFields.get('heroLinkUrl'),heroLinkLabel:startPageFields.get('heroLinkLabel'),alignRight:startPageFields.get('heroBoxPosition'),isMobile:viewstate.get('pageWidth')<__WEBPACK_IMPORTED_MODULE_8__styles_helpers_variables__["f" /* size */].large}),viewstate.get('pageWidth')>=__WEBPACK_IMPORTED_MODULE_8__styles_helpers_variables__["f" /* size */].large&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__components_InformationCards__["a" /* InformationCards */],{cards:startPageFields.get('informationCardLinks'),py:20,mb:!(!!startPageFields.get('infoBannerBackgroundColor')&&!!startPageFields.get('infoBannerHeadline')&&!!startPageFields.get('infoBannerText'))?-50:0}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__components_Conditional__["a" /* Conditional */],{show:!!startPageFields.get('infoBannerBackgroundColor')&&!!startPageFields.get('infoBannerHeadline')&&!!startPageFields.get('infoBannerText')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__styles_blocks_StartPageBlock__["a" /* StartPageBlock */].Section,{backgroundColor:__WEBPACK_IMPORTED_MODULE_8__styles_helpers_variables__["c" /* color */].lightGrey,py:0},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__styles_blocks_StartPageBlock__["a" /* StartPageBlock */].Container,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__components_InfoBanner__["a" /* InfoBanner */],{backgroundColor:startPageFields.get('infoBannerBackgroundColor'),headline:startPageFields.get('infoBannerHeadline'),text:startPageFields.get('infoBannerText'),linkText:startPageFields.get('infoBannerLinkText'),linkUrl:startPageFields.get('infoBannerLinkUrl')}))))),viewstate.get('pageWidth')>=__WEBPACK_IMPORTED_MODULE_8__styles_helpers_variables__["f" /* size */].large&&popularProducts&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__styles_blocks_StartPageBlock__["a" /* StartPageBlock */].Section,{backgroundColor:__WEBPACK_IMPORTED_MODULE_8__styles_helpers_variables__["c" /* color */].lightGrey,pt:viewstate.get('pageWidth')<=__WEBPACK_IMPORTED_MODULE_8__styles_helpers_variables__["f" /* size */].large?1:35},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__styles_blocks_StartPageBlock__["a" /* StartPageBlock */].Container,{bgColor:__WEBPACK_IMPORTED_MODULE_8__styles_helpers_variables__["c" /* color */].lightGrey},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_LinedHeading__["a" /* default */],null,startPageFields.get('popularProductsSectionHeadline','')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__components_ProductList__["a" /* default */],{data:popularProducts}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__styles_blocks_StartPageBlock__["a" /* StartPageBlock */].Section,{backgroundColor:__WEBPACK_IMPORTED_MODULE_8__styles_helpers_variables__["c" /* color */].lightGrey,pt:viewstate.get('pageWidth')<=__WEBPACK_IMPORTED_MODULE_8__styles_helpers_variables__["f" /* size */].large?10:35},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__styles_blocks_StartPageBlock__["a" /* StartPageBlock */].Container,{bgColor:__WEBPACK_IMPORTED_MODULE_8__styles_helpers_variables__["c" /* color */].lightGrey},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_LinedHeading__["a" /* default */],null,startPageFields.get('categorySectionHeadline','')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_styled_components__["ThemeProvider"],{theme:{breakpoints:['500px','730px','800px','1200px']}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grid_styled__["Flex"],{flexWrap:'wrap',mx:['0px','-8px','-11px']},this.props.viewstate.get('pageWidth')>__WEBPACK_IMPORTED_MODULE_8__styles_helpers_variables__["f" /* size */].xLarge?largePopularCategoriesList:smallPopularCategoriesList)),this.props.viewstate.get('pageWidth')>__WEBPACK_IMPORTED_MODULE_8__styles_helpers_variables__["f" /* size */].xLarge&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_styled_components__["ThemeProvider"],{theme:{breakpoints:['500px','730px','800px','1200px']}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grid_styled__["Flex"],{flexWrap:'wrap',mx:['0px','-8px','-11px']},smallPopularCategoriesList)))),viewstate.get('pageWidth')<__WEBPACK_IMPORTED_MODULE_8__styles_helpers_variables__["f" /* size */].large&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__components_Conditional__["a" /* Conditional */],{show:!!startPageFields.get('infoBannerBackgroundColor')&&!!startPageFields.get('infoBannerHeadline')&&!!startPageFields.get('infoBannerText')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__styles_blocks_StartPageBlock__["a" /* StartPageBlock */].Section,{backgroundColor:__WEBPACK_IMPORTED_MODULE_8__styles_helpers_variables__["c" /* color */].lightGrey},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__styles_blocks_StartPageBlock__["a" /* StartPageBlock */].Container,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__components_InfoBanner__["a" /* InfoBanner */],{backgroundColor:startPageFields.get('infoBannerBackgroundColor'),headline:startPageFields.get('infoBannerHeadline'),text:startPageFields.get('infoBannerText'),linkText:startPageFields.get('infoBannerLinkText'),linkUrl:startPageFields.get('infoBannerLinkUrl')})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__components_InformationCards__["a" /* InformationCards */],{headline:'Nyheter och erbjudanden',cards:startPageFields.get('informationCardLinks'),py:1})),viewstate.get('pageWidth')<__WEBPACK_IMPORTED_MODULE_8__styles_helpers_variables__["f" /* size */].large&&popularProducts&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__styles_blocks_StartPageBlock__["a" /* StartPageBlock */].Section,{backgroundColor:__WEBPACK_IMPORTED_MODULE_8__styles_helpers_variables__["c" /* color */].lightGrey,pt:viewstate.get('pageWidth')<=__WEBPACK_IMPORTED_MODULE_8__styles_helpers_variables__["f" /* size */].large?1:35},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__styles_blocks_StartPageBlock__["a" /* StartPageBlock */].Container,{bgColor:__WEBPACK_IMPORTED_MODULE_8__styles_helpers_variables__["c" /* color */].lightGrey},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_LinedHeading__["a" /* default */],null,startPageFields.get('popularProductsSectionHeadline','')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__components_ProductList__["a" /* default */],{data:popularProducts}))),startPageFields.getIn(['aboutUsImage','url'])&&(startPageFields.get('aboutUsHeadline')||startPageFields.get('aboutUsText'))&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__styles_blocks_StartPageBlock__["a" /* StartPageBlock */].Section,{backgroundColor:__WEBPACK_IMPORTED_MODULE_8__styles_helpers_variables__["c" /* color */].lightGrey,pt:viewstate.get('pageWidth')<=__WEBPACK_IMPORTED_MODULE_8__styles_helpers_variables__["f" /* size */].large?1:35,pb:viewstate.get('pageWidth')<=__WEBPACK_IMPORTED_MODULE_8__styles_helpers_variables__["f" /* size */].large?30:100},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__styles_blocks_StartPageBlock__["a" /* StartPageBlock */].Container,{bgColor:__WEBPACK_IMPORTED_MODULE_8__styles_helpers_variables__["c" /* color */].lightGrey},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_LinedHeading__["a" /* default */],null,startPageFields.get('aboutUsSectionHeading','')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_AboutCard__["a" /* default */],{imageUrl:startPageFields.getIn(['aboutUsImage','url']),imageAlt:startPageFields.getIn(['aboutUsImage','alt']),heading:startPageFields.get('aboutUsHeadline'),body:startPageFields.get('aboutUsText'),linkText:startPageFields.get('aboutUsLinkText'),linkUrl:startPageFields.getIn(['aboutUsLink','url']),defaultLinkText:startPageFields.getIn(['aboutUsLink','name'])}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__components_InstagramSection__["a" /* default */],null));}}]);return StartPage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);StartPage.defaultProps={startPage:Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])(),viewstate:Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])()};StartPage.propTypes={fetchArticlePageView:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,startPage:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"]),viewstate:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"]),location:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5__store_connect__["a" /* default */])(StartPage,{fetchArticlePageView:__WEBPACK_IMPORTED_MODULE_7__actions_actionCreators__["g" /* fetchArticlePageView */]},function(store){return{startPage:store.page.data.get('/'),viewstate:store.viewstate};}));

/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;
exports.Helmet = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactSideEffect = __webpack_require__(590);

var _reactSideEffect2 = _interopRequireDefault(_reactSideEffect);

var _reactFastCompare = __webpack_require__(592);

var _reactFastCompare2 = _interopRequireDefault(_reactFastCompare);

var _HelmetUtils = __webpack_require__(593);

var _HelmetConstants = __webpack_require__(243);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Helmet = function Helmet(Component) {
    var _class, _temp;

    return _temp = _class = function (_React$Component) {
        _inherits(HelmetWrapper, _React$Component);

        function HelmetWrapper() {
            _classCallCheck(this, HelmetWrapper);

            return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
        }

        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
            return !(0, _reactFastCompare2.default)(this.props, nextProps);
        };

        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
            if (!nestedChildren) {
                return null;
            }

            switch (child.type) {
                case _HelmetConstants.TAG_NAMES.SCRIPT:
                case _HelmetConstants.TAG_NAMES.NOSCRIPT:
                    return {
                        innerHTML: nestedChildren
                    };

                case _HelmetConstants.TAG_NAMES.STYLE:
                    return {
                        cssText: nestedChildren
                    };
            }

            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
        };

        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
            var _extends2;

            var child = _ref.child,
                arrayTypeChildren = _ref.arrayTypeChildren,
                newChildProps = _ref.newChildProps,
                nestedChildren = _ref.nestedChildren;

            return _extends({}, arrayTypeChildren, (_extends2 = {}, _extends2[child.type] = [].concat(arrayTypeChildren[child.type] || [], [_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))]), _extends2));
        };

        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
            var _extends3, _extends4;

            var child = _ref2.child,
                newProps = _ref2.newProps,
                newChildProps = _ref2.newChildProps,
                nestedChildren = _ref2.nestedChildren;

            switch (child.type) {
                case _HelmetConstants.TAG_NAMES.TITLE:
                    return _extends({}, newProps, (_extends3 = {}, _extends3[child.type] = nestedChildren, _extends3.titleAttributes = _extends({}, newChildProps), _extends3));

                case _HelmetConstants.TAG_NAMES.BODY:
                    return _extends({}, newProps, {
                        bodyAttributes: _extends({}, newChildProps)
                    });

                case _HelmetConstants.TAG_NAMES.HTML:
                    return _extends({}, newProps, {
                        htmlAttributes: _extends({}, newChildProps)
                    });
            }

            return _extends({}, newProps, (_extends4 = {}, _extends4[child.type] = _extends({}, newChildProps), _extends4));
        };

        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
            var newFlattenedProps = _extends({}, newProps);

            Object.keys(arrayTypeChildren).forEach(function (arrayChildName) {
                var _extends5;

                newFlattenedProps = _extends({}, newFlattenedProps, (_extends5 = {}, _extends5[arrayChildName] = arrayTypeChildren[arrayChildName], _extends5));
            });

            return newFlattenedProps;
        };

        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
            if (false) {
                if (!_HelmetConstants.VALID_TAG_NAMES.some(function (name) {
                    return child.type === name;
                })) {
                    if (typeof child.type === "function") {
                        return (0, _HelmetUtils.warn)("You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.");
                    }

                    return (0, _HelmetUtils.warn)("Only elements types " + _HelmetConstants.VALID_TAG_NAMES.join(", ") + " are allowed. Helmet does not support rendering <" + child.type + "> elements. Refer to our API for more information.");
                }

                if (nestedChildren && typeof nestedChildren !== "string" && (!Array.isArray(nestedChildren) || nestedChildren.some(function (nestedChild) {
                    return typeof nestedChild !== "string";
                }))) {
                    throw new Error("Helmet expects a string as a child of <" + child.type + ">. Did you forget to wrap your children in braces? ( <" + child.type + ">{``}</" + child.type + "> ) Refer to our API for more information.");
                }
            }

            return true;
        };

        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
            var _this2 = this;

            var arrayTypeChildren = {};

            _react2.default.Children.forEach(children, function (child) {
                if (!child || !child.props) {
                    return;
                }

                var _child$props = child.props,
                    nestedChildren = _child$props.children,
                    childProps = _objectWithoutProperties(_child$props, ["children"]);

                var newChildProps = (0, _HelmetUtils.convertReactPropstoHtmlAttributes)(childProps);

                _this2.warnOnInvalidChildren(child, nestedChildren);

                switch (child.type) {
                    case _HelmetConstants.TAG_NAMES.LINK:
                    case _HelmetConstants.TAG_NAMES.META:
                    case _HelmetConstants.TAG_NAMES.NOSCRIPT:
                    case _HelmetConstants.TAG_NAMES.SCRIPT:
                    case _HelmetConstants.TAG_NAMES.STYLE:
                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
                            child: child,
                            arrayTypeChildren: arrayTypeChildren,
                            newChildProps: newChildProps,
                            nestedChildren: nestedChildren
                        });
                        break;

                    default:
                        newProps = _this2.mapObjectTypeChildren({
                            child: child,
                            newProps: newProps,
                            newChildProps: newChildProps,
                            nestedChildren: nestedChildren
                        });
                        break;
                }
            });

            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
            return newProps;
        };

        HelmetWrapper.prototype.render = function render() {
            var _props = this.props,
                children = _props.children,
                props = _objectWithoutProperties(_props, ["children"]);

            var newProps = _extends({}, props);

            if (children) {
                newProps = this.mapChildrenToProps(children, newProps);
            }

            return _react2.default.createElement(Component, newProps);
        };

        _createClass(HelmetWrapper, null, [{
            key: "canUseDOM",


            // Component.peek comes from react-side-effect:
            // For testing, you may use a static peek() method available on the returned component.
            // It lets you get the current state without resetting the mounted instance stack.
            // Don’t use it for anything other than testing.

            /**
             * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
             * @param {Object} bodyAttributes: {"className": "root"}
             * @param {String} defaultTitle: "Default Title"
             * @param {Boolean} defer: true
             * @param {Boolean} encodeSpecialCharacters: true
             * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
             * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
             * @param {Array} meta: [{"name": "description", "content": "Test description"}]
             * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
             * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
             * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
             * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
             * @param {String} title: "Title"
             * @param {Object} titleAttributes: {"itemprop": "name"}
             * @param {String} titleTemplate: "MySite.com - %s"
             */
            set: function set(canUseDOM) {
                Component.canUseDOM = canUseDOM;
            }
        }]);

        return HelmetWrapper;
    }(_react2.default.Component), _class.propTypes = {
        base: _propTypes2.default.object,
        bodyAttributes: _propTypes2.default.object,
        children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
        defaultTitle: _propTypes2.default.string,
        defer: _propTypes2.default.bool,
        encodeSpecialCharacters: _propTypes2.default.bool,
        htmlAttributes: _propTypes2.default.object,
        link: _propTypes2.default.arrayOf(_propTypes2.default.object),
        meta: _propTypes2.default.arrayOf(_propTypes2.default.object),
        noscript: _propTypes2.default.arrayOf(_propTypes2.default.object),
        onChangeClientState: _propTypes2.default.func,
        script: _propTypes2.default.arrayOf(_propTypes2.default.object),
        style: _propTypes2.default.arrayOf(_propTypes2.default.object),
        title: _propTypes2.default.string,
        titleAttributes: _propTypes2.default.object,
        titleTemplate: _propTypes2.default.string
    }, _class.defaultProps = {
        defer: true,
        encodeSpecialCharacters: true
    }, _class.peek = Component.peek, _class.rewind = function () {
        var mappedState = Component.rewind();
        if (!mappedState) {
            // provide fallback if mappedState is undefined
            mappedState = (0, _HelmetUtils.mapStateOnServer)({
                baseTag: [],
                bodyAttributes: {},
                encodeSpecialCharacters: true,
                htmlAttributes: {},
                linkTags: [],
                metaTags: [],
                noscriptTags: [],
                scriptTags: [],
                styleTags: [],
                title: "",
                titleAttributes: {}
            });
        }

        return mappedState;
    }, _temp;
};

var NullComponent = function NullComponent() {
    return null;
};

var HelmetSideEffects = (0, _reactSideEffect2.default)(_HelmetUtils.reducePropsToState, _HelmetUtils.handleClientStateChange, _HelmetUtils.mapStateOnServer)(NullComponent);

var HelmetExport = Helmet(HelmetSideEffects);
HelmetExport.renderStatic = HelmetExport.rewind;

exports.Helmet = HelmetExport;
exports.default = HelmetExport;

/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = __webpack_require__(0);
var React__default = _interopDefault(React);
var shallowEqual = _interopDefault(__webpack_require__(591));

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
  if (typeof reducePropsToState !== 'function') {
    throw new Error('Expected reducePropsToState to be a function.');
  }

  if (typeof handleStateChangeOnClient !== 'function') {
    throw new Error('Expected handleStateChangeOnClient to be a function.');
  }

  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
  }

  function getDisplayName(WrappedComponent) {
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
  }

  return function wrap(WrappedComponent) {
    if (typeof WrappedComponent !== 'function') {
      throw new Error('Expected WrappedComponent to be a React component.');
    }

    var mountedInstances = [];
    var state;

    function emitChange() {
      state = reducePropsToState(mountedInstances.map(function (instance) {
        return instance.props;
      }));

      if (SideEffect.canUseDOM) {
        handleStateChangeOnClient(state);
      } else if (mapStateOnServer) {
        state = mapStateOnServer(state);
      }
    }

    var SideEffect =
    /*#__PURE__*/
    function (_Component) {
      _inheritsLoose(SideEffect, _Component);

      function SideEffect() {
        return _Component.apply(this, arguments) || this;
      }

      // Try to use displayName of wrapped component
      // Expose canUseDOM so tests can monkeypatch it
      SideEffect.peek = function peek() {
        return state;
      };

      SideEffect.rewind = function rewind() {
        if (SideEffect.canUseDOM) {
          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
        }

        var recordedState = state;
        state = undefined;
        mountedInstances = [];
        return recordedState;
      };

      var _proto = SideEffect.prototype;

      _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
        return !shallowEqual(nextProps, this.props);
      };

      _proto.componentWillMount = function componentWillMount() {
        mountedInstances.push(this);
        emitChange();
      };

      _proto.componentDidUpdate = function componentDidUpdate() {
        emitChange();
      };

      _proto.componentWillUnmount = function componentWillUnmount() {
        var index = mountedInstances.indexOf(this);
        mountedInstances.splice(index, 1);
        emitChange();
      };

      _proto.render = function render() {
        return React__default.createElement(WrappedComponent, this.props);
      };

      return SideEffect;
    }(React.Component);

    _defineProperty(SideEffect, "displayName", "SideEffect(" + getDisplayName(WrappedComponent) + ")");

    _defineProperty(SideEffect, "canUseDOM", canUseDOM);

    return SideEffect;
  };
}

module.exports = withSideEffect;


/***/ }),
/* 591 */
/***/ (function(module, exports) {

//

module.exports = function shallowEqual(objA, objB, compare, compareContext) {
  var ret = compare ? compare.call(compareContext, objA, objB) : void 0;

  if (ret !== void 0) {
    return !!ret;
  }

  if (objA === objB) {
    return true;
  }

  if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);

  // Test for A's keys different from B.
  for (var idx = 0; idx < keysA.length; idx++) {
    var key = keysA[idx];

    if (!bHasOwnProperty(key)) {
      return false;
    }

    var valueA = objA[key];
    var valueB = objB[key];

    ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;

    if (ret === false || (ret === void 0 && valueA !== valueB)) {
      return false;
    }
  }

  return true;
};


/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isArray = Array.isArray;
var keyList = Object.keys;
var hasProp = Object.prototype.hasOwnProperty;
var hasElementType = typeof Element !== 'undefined';

function equal(a, b) {
  // fast-deep-equal index.js 2.0.1
  if (a === b) return true;

  if (a && b && typeof a == 'object' && typeof b == 'object') {
    var arrA = isArray(a)
      , arrB = isArray(b)
      , i
      , length
      , key;

    if (arrA && arrB) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (!equal(a[i], b[i])) return false;
      return true;
    }

    if (arrA != arrB) return false;

    var dateA = a instanceof Date
      , dateB = b instanceof Date;
    if (dateA != dateB) return false;
    if (dateA && dateB) return a.getTime() == b.getTime();

    var regexpA = a instanceof RegExp
      , regexpB = b instanceof RegExp;
    if (regexpA != regexpB) return false;
    if (regexpA && regexpB) return a.toString() == b.toString();

    var keys = keyList(a);
    length = keys.length;

    if (length !== keyList(b).length)
      return false;

    for (i = length; i-- !== 0;)
      if (!hasProp.call(b, keys[i])) return false;
    // end fast-deep-equal

    // start react-fast-compare
    // custom handling for DOM elements
    if (hasElementType && a instanceof Element && b instanceof Element)
      return a === b;

    // custom handling for React
    for (i = length; i-- !== 0;) {
      key = keys[i];
      if (key === '_owner' && a.$$typeof) {
        // React-specific: avoid traversing React elements' _owner.
        //  _owner contains circular references
        // and is not needed when comparing the actual elements (and not their owners)
        // .$$typeof and ._store on just reasonable markers of a react element
        continue;
      } else {
        // all other properties should be traversed as usual
        if (!equal(a[key], b[key])) return false;
      }
    }
    // end react-fast-compare

    // fast-deep-equal index.js 2.0.1
    return true;
  }

  return a !== a && b !== b;
}
// end fast-deep-equal

module.exports = function exportedEqual(a, b) {
  try {
    return equal(a, b);
  } catch (error) {
    if ((error.message && error.message.match(/stack|recursion/i)) || (error.number === -2146828260)) {
      // warn on circular references, don't crash
      // browsers give this different errors name and messages:
      // chrome/safari: "RangeError", "Maximum call stack size exceeded"
      // firefox: "InternalError", too much recursion"
      // edge: "Error", "Out of stack space"
      console.warn('Warning: react-fast-compare does not handle circular references.', error.name, error.message);
      return false;
    }
    // some other error. we should definitely know about these
    throw error;
  }
};


/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {exports.__esModule = true;
exports.warn = exports.requestAnimationFrame = exports.reducePropsToState = exports.mapStateOnServer = exports.handleClientStateChange = exports.convertReactPropstoHtmlAttributes = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _objectAssign = __webpack_require__(72);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var _HelmetConstants = __webpack_require__(243);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    if (encode === false) {
        return String(str);
    }

    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
};

var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
    var innermostTitle = getInnermostProperty(propsList, _HelmetConstants.TAG_NAMES.TITLE);
    var innermostTemplate = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.TITLE_TEMPLATE);

    if (innermostTemplate && innermostTitle) {
        // use function arg to avoid need to escape $ characters
        return innermostTemplate.replace(/%s/g, function () {
            return innermostTitle;
        });
    }

    var innermostDefaultTitle = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFAULT_TITLE);

    return innermostTitle || innermostDefaultTitle || undefined;
};

var getOnChangeClientState = function getOnChangeClientState(propsList) {
    return getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function () {};
};

var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
    return propsList.filter(function (props) {
        return typeof props[tagType] !== "undefined";
    }).map(function (props) {
        return props[tagType];
    }).reduce(function (tagAttrs, current) {
        return _extends({}, tagAttrs, current);
    }, {});
};

var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
    return propsList.filter(function (props) {
        return typeof props[_HelmetConstants.TAG_NAMES.BASE] !== "undefined";
    }).map(function (props) {
        return props[_HelmetConstants.TAG_NAMES.BASE];
    }).reverse().reduce(function (innermostBaseTag, tag) {
        if (!innermostBaseTag.length) {
            var keys = Object.keys(tag);

            for (var i = 0; i < keys.length; i++) {
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();

                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
                    return innermostBaseTag.concat(tag);
                }
            }
        }

        return innermostBaseTag;
    }, []);
};

var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
    // Calculate list of tags, giving priority innermost component (end of the propslist)
    var approvedSeenTags = {};

    return propsList.filter(function (props) {
        if (Array.isArray(props[tagName])) {
            return true;
        }
        if (typeof props[tagName] !== "undefined") {
            warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + _typeof(props[tagName]) + "\"");
        }
        return false;
    }).map(function (props) {
        return props[tagName];
    }).reverse().reduce(function (approvedTags, instanceTags) {
        var instanceSeenTags = {};

        instanceTags.filter(function (tag) {
            var primaryAttributeKey = void 0;
            var keys = Object.keys(tag);
            for (var i = 0; i < keys.length; i++) {
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();

                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
                    primaryAttributeKey = lowerCaseAttributeKey;
                }
                // Special case for innerHTML which doesn't work lowercased
                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attributeKey === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT || attributeKey === _HelmetConstants.TAG_PROPERTIES.ITEM_PROP)) {
                    primaryAttributeKey = attributeKey;
                }
            }

            if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
                return false;
            }

            var value = tag[primaryAttributeKey].toLowerCase();

            if (!approvedSeenTags[primaryAttributeKey]) {
                approvedSeenTags[primaryAttributeKey] = {};
            }

            if (!instanceSeenTags[primaryAttributeKey]) {
                instanceSeenTags[primaryAttributeKey] = {};
            }

            if (!approvedSeenTags[primaryAttributeKey][value]) {
                instanceSeenTags[primaryAttributeKey][value] = true;
                return true;
            }

            return false;
        }).reverse().forEach(function (tag) {
            return approvedTags.push(tag);
        });

        // Update seen tags with tags from this instance
        var keys = Object.keys(instanceSeenTags);
        for (var i = 0; i < keys.length; i++) {
            var attributeKey = keys[i];
            var tagUnion = (0, _objectAssign2.default)({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);

            approvedSeenTags[attributeKey] = tagUnion;
        }

        return approvedTags;
    }, []).reverse();
};

var getInnermostProperty = function getInnermostProperty(propsList, property) {
    for (var i = propsList.length - 1; i >= 0; i--) {
        var props = propsList[i];

        if (props.hasOwnProperty(property)) {
            return props[property];
        }
    }

    return null;
};

var reducePropsToState = function reducePropsToState(propsList) {
    return {
        baseTag: getBaseTagFromPropsList([_HelmetConstants.TAG_PROPERTIES.HREF], propsList),
        bodyAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.BODY, propsList),
        defer: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFER),
        encode: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
        htmlAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.HTML, propsList),
        linkTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.LINK, [_HelmetConstants.TAG_PROPERTIES.REL, _HelmetConstants.TAG_PROPERTIES.HREF], propsList),
        metaTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.META, [_HelmetConstants.TAG_PROPERTIES.NAME, _HelmetConstants.TAG_PROPERTIES.CHARSET, _HelmetConstants.TAG_PROPERTIES.HTTPEQUIV, _HelmetConstants.TAG_PROPERTIES.PROPERTY, _HelmetConstants.TAG_PROPERTIES.ITEM_PROP], propsList),
        noscriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.NOSCRIPT, [_HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
        onChangeClientState: getOnChangeClientState(propsList),
        scriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.SCRIPT, [_HelmetConstants.TAG_PROPERTIES.SRC, _HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
        styleTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.STYLE, [_HelmetConstants.TAG_PROPERTIES.CSS_TEXT], propsList),
        title: getTitleFromPropsList(propsList),
        titleAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.TITLE, propsList)
    };
};

var rafPolyfill = function () {
    var clock = Date.now();

    return function (callback) {
        var currentTime = Date.now();

        if (currentTime - clock > 16) {
            clock = currentTime;
            callback(currentTime);
        } else {
            setTimeout(function () {
                rafPolyfill(callback);
            }, 0);
        }
    };
}();

var cafPolyfill = function cafPolyfill(id) {
    return clearTimeout(id);
};

var requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || rafPolyfill : global.requestAnimationFrame || rafPolyfill;

var cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || cafPolyfill : global.cancelAnimationFrame || cafPolyfill;

var warn = function warn(msg) {
    return console && typeof console.warn === "function" && console.warn(msg);
};

var _helmetCallback = null;

var handleClientStateChange = function handleClientStateChange(newState) {
    if (_helmetCallback) {
        cancelAnimationFrame(_helmetCallback);
    }

    if (newState.defer) {
        _helmetCallback = requestAnimationFrame(function () {
            commitTagChanges(newState, function () {
                _helmetCallback = null;
            });
        });
    } else {
        commitTagChanges(newState);
        _helmetCallback = null;
    }
};

var commitTagChanges = function commitTagChanges(newState, cb) {
    var baseTag = newState.baseTag,
        bodyAttributes = newState.bodyAttributes,
        htmlAttributes = newState.htmlAttributes,
        linkTags = newState.linkTags,
        metaTags = newState.metaTags,
        noscriptTags = newState.noscriptTags,
        onChangeClientState = newState.onChangeClientState,
        scriptTags = newState.scriptTags,
        styleTags = newState.styleTags,
        title = newState.title,
        titleAttributes = newState.titleAttributes;

    updateAttributes(_HelmetConstants.TAG_NAMES.BODY, bodyAttributes);
    updateAttributes(_HelmetConstants.TAG_NAMES.HTML, htmlAttributes);

    updateTitle(title, titleAttributes);

    var tagUpdates = {
        baseTag: updateTags(_HelmetConstants.TAG_NAMES.BASE, baseTag),
        linkTags: updateTags(_HelmetConstants.TAG_NAMES.LINK, linkTags),
        metaTags: updateTags(_HelmetConstants.TAG_NAMES.META, metaTags),
        noscriptTags: updateTags(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags),
        scriptTags: updateTags(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags),
        styleTags: updateTags(_HelmetConstants.TAG_NAMES.STYLE, styleTags)
    };

    var addedTags = {};
    var removedTags = {};

    Object.keys(tagUpdates).forEach(function (tagType) {
        var _tagUpdates$tagType = tagUpdates[tagType],
            newTags = _tagUpdates$tagType.newTags,
            oldTags = _tagUpdates$tagType.oldTags;


        if (newTags.length) {
            addedTags[tagType] = newTags;
        }
        if (oldTags.length) {
            removedTags[tagType] = tagUpdates[tagType].oldTags;
        }
    });

    cb && cb();

    onChangeClientState(newState, addedTags, removedTags);
};

var flattenArray = function flattenArray(possibleArray) {
    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
};

var updateTitle = function updateTitle(title, attributes) {
    if (typeof title !== "undefined" && document.title !== title) {
        document.title = flattenArray(title);
    }

    updateAttributes(_HelmetConstants.TAG_NAMES.TITLE, attributes);
};

var updateAttributes = function updateAttributes(tagName, attributes) {
    var elementTag = document.getElementsByTagName(tagName)[0];

    if (!elementTag) {
        return;
    }

    var helmetAttributeString = elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
    var attributesToRemove = [].concat(helmetAttributes);
    var attributeKeys = Object.keys(attributes);

    for (var i = 0; i < attributeKeys.length; i++) {
        var attribute = attributeKeys[i];
        var value = attributes[attribute] || "";

        if (elementTag.getAttribute(attribute) !== value) {
            elementTag.setAttribute(attribute, value);
        }

        if (helmetAttributes.indexOf(attribute) === -1) {
            helmetAttributes.push(attribute);
        }

        var indexToSave = attributesToRemove.indexOf(attribute);
        if (indexToSave !== -1) {
            attributesToRemove.splice(indexToSave, 1);
        }
    }

    for (var _i = attributesToRemove.length - 1; _i >= 0; _i--) {
        elementTag.removeAttribute(attributesToRemove[_i]);
    }

    if (helmetAttributes.length === attributesToRemove.length) {
        elementTag.removeAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
    } else if (elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE) !== attributeKeys.join(",")) {
        elementTag.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, attributeKeys.join(","));
    }
};

var updateTags = function updateTags(type, tags) {
    var headElement = document.head || document.querySelector(_HelmetConstants.TAG_NAMES.HEAD);
    var tagNodes = headElement.querySelectorAll(type + "[" + _HelmetConstants.HELMET_ATTRIBUTE + "]");
    var oldTags = Array.prototype.slice.call(tagNodes);
    var newTags = [];
    var indexToDelete = void 0;

    if (tags && tags.length) {
        tags.forEach(function (tag) {
            var newElement = document.createElement(type);

            for (var attribute in tag) {
                if (tag.hasOwnProperty(attribute)) {
                    if (attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML) {
                        newElement.innerHTML = tag.innerHTML;
                    } else if (attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
                        if (newElement.styleSheet) {
                            newElement.styleSheet.cssText = tag.cssText;
                        } else {
                            newElement.appendChild(document.createTextNode(tag.cssText));
                        }
                    } else {
                        var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
                        newElement.setAttribute(attribute, value);
                    }
                }
            }

            newElement.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, "true");

            // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
            if (oldTags.some(function (existingTag, index) {
                indexToDelete = index;
                return newElement.isEqualNode(existingTag);
            })) {
                oldTags.splice(indexToDelete, 1);
            } else {
                newTags.push(newElement);
            }
        });
    }

    oldTags.forEach(function (tag) {
        return tag.parentNode.removeChild(tag);
    });
    newTags.forEach(function (tag) {
        return headElement.appendChild(tag);
    });

    return {
        oldTags: oldTags,
        newTags: newTags
    };
};

var generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
    return Object.keys(attributes).reduce(function (str, key) {
        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
        return str ? str + " " + attr : attr;
    }, "");
};

var generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
    var attributeString = generateElementAttributesAsString(attributes);
    var flattenedTitle = flattenArray(title);
    return attributeString ? "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
};

var generateTagsAsString = function generateTagsAsString(type, tags, encode) {
    return tags.reduce(function (str, tag) {
        var attributeHtml = Object.keys(tag).filter(function (attribute) {
            return !(attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT);
        }).reduce(function (string, attribute) {
            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + encodeSpecialCharacters(tag[attribute], encode) + "\"";
            return string ? string + " " + attr : attr;
        }, "");

        var tagContent = tag.innerHTML || tag.cssText || "";

        var isSelfClosing = _HelmetConstants.SELF_CLOSING_TAGS.indexOf(type) === -1;

        return str + "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
    }, "");
};

var convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return Object.keys(attributes).reduce(function (obj, key) {
        obj[_HelmetConstants.REACT_TAG_MAP[key] || key] = attributes[key];
        return obj;
    }, initProps);
};

var convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return Object.keys(props).reduce(function (obj, key) {
        obj[_HelmetConstants.HTML_TAG_MAP[key] || key] = props[key];
        return obj;
    }, initAttributes);
};

var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
    var _initProps;

    // assigning into an array to define toString function on it
    var initProps = (_initProps = {
        key: title
    }, _initProps[_HelmetConstants.HELMET_ATTRIBUTE] = true, _initProps);
    var props = convertElementAttributestoReactProps(attributes, initProps);

    return [_react2.default.createElement(_HelmetConstants.TAG_NAMES.TITLE, props, title)];
};

var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
    return tags.map(function (tag, i) {
        var _mappedTag;

        var mappedTag = (_mappedTag = {
            key: i
        }, _mappedTag[_HelmetConstants.HELMET_ATTRIBUTE] = true, _mappedTag);

        Object.keys(tag).forEach(function (attribute) {
            var mappedAttribute = _HelmetConstants.REACT_TAG_MAP[attribute] || attribute;

            if (mappedAttribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || mappedAttribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
                var content = tag.innerHTML || tag.cssText;
                mappedTag.dangerouslySetInnerHTML = { __html: content };
            } else {
                mappedTag[mappedAttribute] = tag[attribute];
            }
        });

        return _react2.default.createElement(type, mappedTag);
    });
};

var getMethodsForTag = function getMethodsForTag(type, tags, encode) {
    switch (type) {
        case _HelmetConstants.TAG_NAMES.TITLE:
            return {
                toComponent: function toComponent() {
                    return generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
                },
                toString: function toString() {
                    return generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
                }
            };
        case _HelmetConstants.ATTRIBUTE_NAMES.BODY:
        case _HelmetConstants.ATTRIBUTE_NAMES.HTML:
            return {
                toComponent: function toComponent() {
                    return convertElementAttributestoReactProps(tags);
                },
                toString: function toString() {
                    return generateElementAttributesAsString(tags);
                }
            };
        default:
            return {
                toComponent: function toComponent() {
                    return generateTagsAsReactComponent(type, tags);
                },
                toString: function toString() {
                    return generateTagsAsString(type, tags, encode);
                }
            };
    }
};

var mapStateOnServer = function mapStateOnServer(_ref) {
    var baseTag = _ref.baseTag,
        bodyAttributes = _ref.bodyAttributes,
        encode = _ref.encode,
        htmlAttributes = _ref.htmlAttributes,
        linkTags = _ref.linkTags,
        metaTags = _ref.metaTags,
        noscriptTags = _ref.noscriptTags,
        scriptTags = _ref.scriptTags,
        styleTags = _ref.styleTags,
        _ref$title = _ref.title,
        title = _ref$title === undefined ? "" : _ref$title,
        titleAttributes = _ref.titleAttributes;
    return {
        base: getMethodsForTag(_HelmetConstants.TAG_NAMES.BASE, baseTag, encode),
        bodyAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
        htmlAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
        link: getMethodsForTag(_HelmetConstants.TAG_NAMES.LINK, linkTags, encode),
        meta: getMethodsForTag(_HelmetConstants.TAG_NAMES.META, metaTags, encode),
        noscript: getMethodsForTag(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags, encode),
        script: getMethodsForTag(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags, encode),
        style: getMethodsForTag(_HelmetConstants.TAG_NAMES.STYLE, styleTags, encode),
        title: getMethodsForTag(_HelmetConstants.TAG_NAMES.TITLE, { title: title, titleAttributes: titleAttributes }, encode)
    };
};

exports.convertReactPropstoHtmlAttributes = convertReactPropstoHtmlAttributes;
exports.handleClientStateChange = handleClientStateChange;
exports.mapStateOnServer = mapStateOnServer;
exports.reducePropsToState = reducePropsToState;
exports.requestAnimationFrame = requestAnimationFrame;
exports.warn = warn;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(71)))

/***/ }),
/* 594 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_immutable__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_helpers_variables__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_Container__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store_connect__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_helpers_mixins__ = __webpack_require__(6);
var _templateObject=_taggedTemplateLiteral(['\n  text-decoration: none;\n  color: ',';\n  transition: opacity 250ms ease-out;\n  font-style: italic;\n\n  &:hover {\n    opacity: 0.6;\n  }\n\n  ',';\n'],['\n  text-decoration: none;\n  color: ',';\n  transition: opacity 250ms ease-out;\n  font-style: italic;\n\n  &:hover {\n    opacity: 0.6;\n  }\n\n  ',';\n']),_templateObject2=_taggedTemplateLiteral(['\n      font-weight: 600;\n    '],['\n      font-weight: 600;\n    ']),_templateObject3=_taggedTemplateLiteral(['\n  ',';\n  padding-top: 7.5px;\n  padding-bottom: 20px;\n  font-size: 12px;\n  @media screen and (min-width: ','px) {\n    padding-top: 12.5px;\n  }\n'],['\n  ',';\n  padding-top: 7.5px;\n  padding-bottom: 20px;\n  font-size: 12px;\n  @media screen and (min-width: ','px) {\n    padding-top: 12.5px;\n  }\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Breadcrumbs=function Breadcrumbs(props){if(props.disabled){return false;}// if sitemap did not load properly, don't render Breadcrumbs (mostly so the pages load properly during development)
if(!props.sitemap.size){return false;}var splitPathname=props.location.pathname.length>1?props.location.pathname.split('/'):[''];var currentSitemapObject=props.sitemap;var pathname='';var breadCrumbs=[];for(var i=0;i<splitPathname.length;i+=1){if(i===0){breadCrumbs.push({title:'Hem',url:'/'});}else{var path=splitPathname[i];pathname+='/'+path;// eslint-disable-next-line no-loop-func
currentSitemapObject=currentSitemapObject.get('children',Object(__WEBPACK_IMPORTED_MODULE_4_immutable__["Map"])()).find(function(item){return item.get('url')===pathname;});// if page is not found in Sitemap, ignore everything and skip rendering of Breadcrumbs
if(!currentSitemapObject){break;}breadCrumbs.push({title:currentSitemapObject.get('title',Object(__WEBPACK_IMPORTED_MODULE_4_immutable__["Map"])())||'hej',url:pathname});}}if(props.currentItem){breadCrumbs.push(props.currentItem);}// remove last breadcrumb on mobile displays (for saving space)
if(props.viewstate.get('pageWidth')<__WEBPACK_IMPORTED_MODULE_5__styles_helpers_variables__["b" /* breakpoint */].medium){breadCrumbs.splice(-1,1);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(BreadcrumbsContainer,null,breadCrumbs.map(function(item,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{key:item.url},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(BreadcrumbNavLink,{to:item.url,active:(item.url===props.location.pathname).toString()},item.title),index<breadCrumbs.length-1?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,' / '):false);}));};var BreadcrumbNavLink=Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* NavLink */])(_templateObject,__WEBPACK_IMPORTED_MODULE_5__styles_helpers_variables__["c" /* color */].black,function(props){return props.active==='true'&&Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["css"])(_templateObject2);});var BreadcrumbsContainer=__WEBPACK_IMPORTED_MODULE_6__styles_Container__["a" /* Container */].extend(_templateObject3,__WEBPACK_IMPORTED_MODULE_8__styles_helpers_mixins__["f" /* hideOnPrint */],__WEBPACK_IMPORTED_MODULE_5__styles_helpers_variables__["b" /* breakpoint */].large);Breadcrumbs.defaultProps={sitemap:Object(__WEBPACK_IMPORTED_MODULE_4_immutable__["Map"])(),viewstate:Object(__WEBPACK_IMPORTED_MODULE_4_immutable__["Map"])(),disabled:false,currentItem:null};Breadcrumbs.propTypes={sitemap:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_4_immutable__["Map"]),viewstate:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_4_immutable__["Map"]),location:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,disabled:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,currentItem:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__store_connect__["a" /* default */])(Breadcrumbs,{},function(store){return{sitemap:Object(__WEBPACK_IMPORTED_MODULE_4_immutable__["fromJS"])(window.sitemap),viewstate:store.viewstate};}));

/***/ }),
/* 595 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_cookie__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_Container__ = __webpack_require__(10);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  position: fixed;\n  z-index: 800;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background-color: #fff;\n  margin: 0;\n  padding: 0;\n  border-top: 1px solid #c1c1c1;\n'],['\n  position: fixed;\n  z-index: 800;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background-color: #fff;\n  margin: 0;\n  padding: 0;\n  border-top: 1px solid #c1c1c1;\n']),_templateObject2=_taggedTemplateLiteral(['\n  margin: 0 auto;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: space-between;\n  padding-top: 14px;\n  padding-bottom: 14px;\n  \n  @media screen and (min-width: ',') {\n    flex-direction: row;\n    padding-top: 24px;\n    padding-bottom: 24px;\n  }\n'],['\n  margin: 0 auto;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: space-between;\n  padding-top: 14px;\n  padding-bottom: 14px;\n  \n  @media screen and (min-width: ',') {\n    flex-direction: row;\n    padding-top: 24px;\n    padding-bottom: 24px;\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  width: 41px;\n  height: 35px;\n  margin-right: 19px;\n  \n  @media screen and (min-width: ',') {\n    width: 60px;\n    height: 50px;\n    margin-right: 23px;\n  }\n'],['\n  width: 41px;\n  height: 35px;\n  margin-right: 19px;\n  \n  @media screen and (min-width: ',') {\n    width: 60px;\n    height: 50px;\n    margin-right: 23px;\n  }\n']),_templateObject4=_taggedTemplateLiteral(['\n  flex: 1;\n  width: 100%;\n  display: flex;\n  align-items: flex-start;\n  margin-bottom: 12px;\n  \n  @media screen and (min-width: ',') {\n    margin-bottom: 0;\n  }\n'],['\n  flex: 1;\n  width: 100%;\n  display: flex;\n  align-items: flex-start;\n  margin-bottom: 12px;\n  \n  @media screen and (min-width: ',') {\n    margin-bottom: 0;\n  }\n']),_templateObject5=_taggedTemplateLiteral(['\n  font-size: 13px;\n  font-stretch: normal;\n  line-height: 1.57;\n  letter-spacing: normal;\n  color: #000;\n\n  > p {\n    margin: 0;\n  }\n  \n  a {\n    text-decoration: none;\n    text-transform: uppercase;\n    color: black;\n    font-weight: 600;\n    letter-spacing: 1.5px;\n    font-size: 12px;\n    margin-top: 5px;\n    display: inline-block;\n    transition: opacity .25s ease-out;\n    \n    &:hover {\n      opacity: .5;\n    }\n  }\n  \n  @media screen and (min-width: ',') {\n    font-size: 14px;\n  }\n'],['\n  font-size: 13px;\n  font-stretch: normal;\n  line-height: 1.57;\n  letter-spacing: normal;\n  color: #000;\n\n  > p {\n    margin: 0;\n  }\n  \n  a {\n    text-decoration: none;\n    text-transform: uppercase;\n    color: black;\n    font-weight: 600;\n    letter-spacing: 1.5px;\n    font-size: 12px;\n    margin-top: 5px;\n    display: inline-block;\n    transition: opacity .25s ease-out;\n    \n    &:hover {\n      opacity: .5;\n    }\n  }\n  \n  @media screen and (min-width: ',') {\n    font-size: 14px;\n  }\n']),_templateObject6=_taggedTemplateLiteral(['\n  font-size: 12px;\n  text-transform: uppercase;\n  font-weight: 600;\n  text-decoration: none;\n  min-width: 160px;\n  min-height: 38px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: white;\n  border: none;\n  background-color: #779182;\n  cursor: pointer;\n  margin-left: 0;\n  width: 100%;\n  transition: opacity .25s ease-out;\n  \n  &:hover {\n    opacity: .85;\n  }\n  \n  @media screen and (min-width: ',') {\n    max-width: 192px;\n    min-height: 50px;\n  }\n'],['\n  font-size: 12px;\n  text-transform: uppercase;\n  font-weight: 600;\n  text-decoration: none;\n  min-width: 160px;\n  min-height: 38px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: white;\n  border: none;\n  background-color: #779182;\n  cursor: pointer;\n  margin-left: 0;\n  width: 100%;\n  transition: opacity .25s ease-out;\n  \n  &:hover {\n    opacity: .85;\n  }\n  \n  @media screen and (min-width: ',') {\n    max-width: 192px;\n    min-height: 50px;\n  }\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CookieBar=function(_React$Component){_inherits(CookieBar,_React$Component);function CookieBar(props){_classCallCheck(this,CookieBar);var _this=_possibleConstructorReturn(this,(CookieBar.__proto__||Object.getPrototypeOf(CookieBar)).call(this,props));_this.handleAccept=_this.handleAccept.bind(_this);return _this;}_createClass(CookieBar,[{key:'handleAccept',value:function handleAccept(){var cookies=this.props.cookies;var d=new Date();d.setTime(d.getTime()+365*24*60*60*1000);cookies.set('cookie_valamagasinet','cookie_valamagasinet',{path:'/',expires:d});}},{key:'render',value:function render(){var _this2=this;var cookies=this.props.cookies;var cookieAccepted=cookies.get('cookie_valamagasinet')!==undefined;if(cookieAccepted)return null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CookieBarContainer,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CookieBarContentContainer,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CookieTextContainer,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CookieImage,{src:'/images/icons/cookies.svg'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CookieText,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Vi sparar cookies f\xF6r att f\xF6rb\xE4ttra upplevelsen p\xE5 Valamagasinet.se'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'/kundservice/integritetspolicy',target:'_blank'},'L\xE4s mer om cookies')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CookieBtn,{onClick:function onClick(){return _this2.handleAccept();},type:'button'},'Jag godk\xE4nner!')));}}]);return CookieBar;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var breakpoint='900px';var CookieBarContainer=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].div(_templateObject);var CookieBarContentContainer=__WEBPACK_IMPORTED_MODULE_4__styles_Container__["a" /* Container */].extend(_templateObject2,breakpoint);var CookieImage=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].img(_templateObject3,breakpoint);var CookieTextContainer=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].div(_templateObject4,breakpoint);var CookieText=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].div(_templateObject5,breakpoint);var CookieBtn=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].button(_templateObject6,breakpoint);CookieBar.propTypes={cookies:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_cookie__["a" /* withCookies */])(CookieBar));

/***/ }),
/* 596 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_cookie__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(597);


// We can't please Rollup and TypeScript at the same time
// Only way to make both of them work
var objectAssign = __webpack_require__(72);
var Cookies = /** @class */ (function () {
    function Cookies(cookies) {
        this.changeListeners = [];
        this.TESTING_ONETWO = 2;
        this.cookies = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["b" /* parseCookies */])(cookies);
        this.HAS_DOCUMENT_COOKIE = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* hasDocumentCookie */])();
    }
    Cookies.prototype._updateBrowserValues = function () {
        if (!this.HAS_DOCUMENT_COOKIE) {
            return;
        }
        this.cookies = __WEBPACK_IMPORTED_MODULE_0_cookie__["parse"](document.cookie);
    };
    Cookies.prototype._emitChange = function (params) {
        for (var i = 0; i < this.changeListeners.length; ++i) {
            this.changeListeners[i](params);
        }
    };
    Cookies.prototype.get = function (name, options) {
        if (options === void 0) { options = {}; }
        this._updateBrowserValues();
        return Object(__WEBPACK_IMPORTED_MODULE_1__utils__["c" /* readCookie */])(this.cookies[name], options);
    };
    Cookies.prototype.getAll = function (options) {
        if (options === void 0) { options = {}; }
        this._updateBrowserValues();
        var result = {};
        for (var name_1 in this.cookies) {
            result[name_1] = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["c" /* readCookie */])(this.cookies[name_1], options);
        }
        return result;
    };
    Cookies.prototype.set = function (name, value, options) {
        var _a;
        if (typeof value === 'object') {
            value = JSON.stringify(value);
        }
        this.cookies = objectAssign({}, this.cookies, (_a = {}, _a[name] = value, _a));
        if (this.HAS_DOCUMENT_COOKIE) {
            document.cookie = __WEBPACK_IMPORTED_MODULE_0_cookie__["serialize"](name, value, options);
        }
        this._emitChange({ name: name, value: value, options: options });
    };
    Cookies.prototype.remove = function (name, options) {
        var finalOptions = (options = objectAssign({}, options, {
            expires: new Date(1970, 1, 1, 0, 0, 1),
            maxAge: 0
        }));
        this.cookies = objectAssign({}, this.cookies);
        delete this.cookies[name];
        if (this.HAS_DOCUMENT_COOKIE) {
            document.cookie = __WEBPACK_IMPORTED_MODULE_0_cookie__["serialize"](name, '', finalOptions);
        }
        this._emitChange({ name: name, value: undefined, options: options });
    };
    Cookies.prototype.addChangeListener = function (callback) {
        this.changeListeners.push(callback);
    };
    Cookies.prototype.removeChangeListener = function (callback) {
        var idx = this.changeListeners.indexOf(callback);
        if (idx >= 0) {
            this.changeListeners.splice(idx, 1);
        }
    };
    return Cookies;
}());
/* harmony default export */ __webpack_exports__["a"] = (Cookies);


/***/ }),
/* 597 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = hasDocumentCookie;
/* unused harmony export cleanCookies */
/* harmony export (immutable) */ __webpack_exports__["b"] = parseCookies;
/* unused harmony export isParsingCookie */
/* harmony export (immutable) */ __webpack_exports__["c"] = readCookie;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_cookie__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_cookie__);

function hasDocumentCookie() {
    // Can we get/set cookies on document.cookie?
    return typeof document === 'object' && typeof document.cookie === 'string';
}
function cleanCookies() {
    document.cookie.split(';').forEach(function (c) {
        document.cookie = c
            .replace(/^ +/, '')
            .replace(/=.*/, '=;expires=' + new Date().toUTCString() + ';path=/');
    });
}
function parseCookies(cookies) {
    if (typeof cookies === 'string') {
        return __WEBPACK_IMPORTED_MODULE_0_cookie__["parse"](cookies);
    }
    else if (typeof cookies === 'object' && cookies !== null) {
        return cookies;
    }
    else {
        return {};
    }
}
function isParsingCookie(value, doNotParse) {
    if (typeof doNotParse === 'undefined') {
        // We guess if the cookie start with { or [, it has been serialized
        doNotParse =
            !value || (value[0] !== '{' && value[0] !== '[' && value[0] !== '"');
    }
    return !doNotParse;
}
function readCookie(value, options) {
    if (options === void 0) { options = {}; }
    var cleanValue = cleanupCookieValue(value);
    if (isParsingCookie(cleanValue, options.doNotParse)) {
        try {
            return JSON.parse(cleanValue);
        }
        catch (e) {
            // At least we tried
        }
    }
    // Ignore clean value if we failed the deserialization
    // It is not relevant anymore to trim those values
    return value;
}
function cleanupCookieValue(value) {
    // express prepend j: before serializing a cookie
    if (value && value[0] === 'j' && value[1] === ':') {
        return value.substr(2);
    }
    return value;
}


/***/ }),
/* 598 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_universal_cookie__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CookiesContext__ = __webpack_require__(158);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var CookiesProvider = /** @class */ (function (_super) {
    __extends(CookiesProvider, _super);
    function CookiesProvider(props) {
        var _this = _super.call(this, props) || this;
        if (props.cookies) {
            _this.cookies = props.cookies;
        }
        else {
            _this.cookies = new __WEBPACK_IMPORTED_MODULE_1_universal_cookie__["a" /* default */]();
        }
        return _this;
    }
    CookiesProvider.prototype.render = function () {
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__CookiesContext__["b" /* Provider */], { value: this.cookies }, this.props.children);
    };
    return CookiesProvider;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* unused harmony default export */ var _unused_webpack_default_export = (CookiesProvider);


/***/ }),
/* 599 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = withCookies;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CookiesContext__ = __webpack_require__(158);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};


// Only way to make function modules work with both TypeScript and Rollup
var hoistStatics = __webpack_require__(208);
function withCookies(WrapperComponent) {
    // @ts-ignore
    var name = WrapperComponent.displayName || WrapperComponent.name;
    var CookieWrapper = /** @class */ (function (_super) {
        __extends(CookieWrapper, _super);
        function CookieWrapper() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.onChange = function () {
                // Make sure to update children with new values
                _this.forceUpdate();
            };
            return _this;
        }
        CookieWrapper.prototype.listen = function () {
            this.props.cookies.addChangeListener(this.onChange);
        };
        CookieWrapper.prototype.unlisten = function (cookies) {
            (cookies || this.props.cookies).removeChangeListener(this.onChange);
        };
        CookieWrapper.prototype.componentDidMount = function () {
            this.listen();
        };
        CookieWrapper.prototype.componentDidUpdate = function (prevProps) {
            if (prevProps.cookies !== this.props.cookies) {
                this.unlisten(prevProps.cookies);
                this.listen();
            }
        };
        CookieWrapper.prototype.componentWillUnmount = function () {
            this.unlisten();
        };
        CookieWrapper.prototype.render = function () {
            var _a = this.props, forwardedRef = _a.forwardedRef, cookies = _a.cookies, restProps = __rest(_a, ["forwardedRef", "cookies"]);
            var allCookies = cookies.getAll();
            return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](WrapperComponent, __assign({}, restProps, { ref: forwardedRef, cookies: cookies, allCookies: allCookies })));
        };
        CookieWrapper.displayName = "withCookies(" + name + ")";
        CookieWrapper.WrapperComponent = WrapperComponent;
        return CookieWrapper;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
    var CookieWrapperWithRefAndCookieConsumer = __WEBPACK_IMPORTED_MODULE_0_react__["forwardRef"](function (props, ref) {
        return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__CookiesContext__["a" /* Consumer */], null, function (cookies) { return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](CookieWrapper, __assign({ cookies: cookies }, props, { forwardedRef: ref }))); }));
    });
    return hoistStatics(CookieWrapperWithRefAndCookieConsumer, WrapperComponent, {
        WrappedComponent: true
    });
}


/***/ }),
/* 600 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CookiesContext__ = __webpack_require__(158);


function useCookies(dependencies) {
    var cookies = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_1__CookiesContext__["c" /* default */]);
    if (!cookies) {
        throw new Error('Missing <CookiesProvider>');
    }
    var initialCookies = cookies.getAll();
    var _a = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(initialCookies), allCookies = _a[0], setCookies = _a[1];
    var previousCookiesRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(allCookies);
    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        function onChange() {
            var newCookies = cookies.getAll();
            if (shouldUpdate(dependencies || null, newCookies, previousCookiesRef.current)) {
                setCookies(newCookies);
            }
            previousCookiesRef.current = newCookies;
        }
        cookies.addChangeListener(onChange);
        return function () {
            cookies.removeChangeListener(onChange);
        };
    }, [cookies]);
    return [allCookies, cookies.set.bind(cookies), cookies.remove.bind(cookies)];
}
function shouldUpdate(dependencies, newCookies, oldCookies) {
    if (!dependencies) {
        return true;
    }
    for (var _i = 0, dependencies_1 = dependencies; _i < dependencies_1.length; _i++) {
        var dependency = dependencies_1[_i];
        if (newCookies[dependency] !== oldCookies[dependency]) {
            return true;
        }
    }
    return false;
}


/***/ }),
/* 601 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_cookie__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_helpers_mixins__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants_status__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__LoadingSpinner__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Conditional__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants_endpoints__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__NewsletterSignUpForm__ = __webpack_require__(248);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  min-height: 207px;\n'],['\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  min-height: 207px;\n']),_templateObject2=_taggedTemplateLiteral(['\n  max-width: 100%;\n  position: fixed;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  height: auto;\n  background-color: black;\n  z-index: 100;\n  box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.3);\n  display: flex;\n\n  @media screen and (min-width: 400px) {\n    right: 20px;\n    bottom: 20px;\n    left: unset;\n    width: 330px;\n  }\n\n  @media screen and (min-width: 680px) {\n    right: 30px;\n    bottom: 30px;\n    left: unset;\n\n    ',';\n  }\n'],['\n  max-width: 100%;\n  position: fixed;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  height: auto;\n  background-color: black;\n  z-index: 100;\n  box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.3);\n  display: flex;\n\n  @media screen and (min-width: 400px) {\n    right: 20px;\n    bottom: 20px;\n    left: unset;\n    width: 330px;\n  }\n\n  @media screen and (min-width: 680px) {\n    right: 30px;\n    bottom: 30px;\n    left: unset;\n\n    ',';\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n        width: 550px;\n      '],['\n        width: 550px;\n      ']),_templateObject4=_taggedTemplateLiteral(['\n  width: 100%;\n  padding: 32px;\n\n  @media screen and (min-width: 680px) {\n    padding: 32px 25px 32px 32px;\n  }\n'],['\n  width: 100%;\n  padding: 32px;\n\n  @media screen and (min-width: 680px) {\n    padding: 32px 25px 32px 32px;\n  }\n']),_templateObject5=_taggedTemplateLiteral(['\n  ',';\n  font-size: 32px;\n  font-weight: normal;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 1.25;\n  letter-spacing: normal;\n  text-align: center;\n  color: #ffffff;\n  margin-top: 0;\n  margin-bottom: 0.25em;\n'],['\n  ',';\n  font-size: 32px;\n  font-weight: normal;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 1.25;\n  letter-spacing: normal;\n  text-align: center;\n  color: #ffffff;\n  margin-top: 0;\n  margin-bottom: 0.25em;\n']),_templateObject6=_taggedTemplateLiteral(['\n  p {\n    ',';\n    font-size: 14px;\n    font-weight: normal;\n    font-stretch: normal;\n    font-style: normal;\n    line-height: 1.57;\n    letter-spacing: normal;\n    text-align: center;\n    color: #ffffff;\n    margin-bottom: 1.5em;\n  }\n'],['\n  p {\n    ',';\n    font-size: 14px;\n    font-weight: normal;\n    font-stretch: normal;\n    font-style: normal;\n    line-height: 1.57;\n    letter-spacing: normal;\n    text-align: center;\n    color: #ffffff;\n    margin-bottom: 1.5em;\n  }\n']),_templateObject7=_taggedTemplateLiteral(['\n  width: 40px;\n  height: 40px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: absolute;\n  top: 0;\n  right: 0;\n  background-color: transparent;\n  border: none;\n\n  &:focus {\n    outline: 0;\n  }\n'],['\n  width: 40px;\n  height: 40px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: absolute;\n  top: 0;\n  right: 0;\n  background-color: transparent;\n  border: none;\n\n  &:focus {\n    outline: 0;\n  }\n']),_templateObject8=_taggedTemplateLiteral(['\n  height: 14px;\n  width: 14px;\n'],['\n  height: 14px;\n  width: 14px;\n']),_templateObject9=_taggedTemplateLiteral(['\n  display: none;\n  min-width: 220px;\n  min-height: 100%;\n  background-image: url("','?width=440&heightratio=1.25&mode=crop");\n  background-size: cover;\n  \n  @media screen and (min-width: 680px) {\n    display: block;\n  }\n'],['\n  display: none;\n  min-width: 220px;\n  min-height: 100%;\n  background-image: url("','?width=440&heightratio=1.25&mode=crop");\n  background-size: cover;\n  \n  @media screen and (min-width: 680px) {\n    display: block;\n  }\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var NewsletterWidget=function(_Component){_inherits(NewsletterWidget,_Component);function NewsletterWidget(props){_classCallCheck(this,NewsletterWidget);var _this=_possibleConstructorReturn(this,(NewsletterWidget.__proto__||Object.getPrototypeOf(NewsletterWidget)).call(this,props));_this.state={status:__WEBPACK_IMPORTED_MODULE_5__constants_status__["c" /* INITIAL */]};_this.setCookieToCloseModal=_this.setCookieToCloseModal.bind(_this);_this.setStatus=_this.setStatus.bind(_this);return _this;}_createClass(NewsletterWidget,[{key:'setCookieToCloseModal',value:function setCookieToCloseModal(){var cookies=this.props.cookies;var d=new Date();d.setTime(d.getTime()+365*24*60*60*1000);cookies.set('newsletter_closed',true,{path:'/',expires:d});}},{key:'setStatus',value:function setStatus(newStatus){this.setState({status:newStatus});}},{key:'render',value:function render(){// if we did not get any data from backend, don't do anything else
if(!window.newsletter)return null;// add hard coded data that is missing in backend
window.newsletter=Object.assign({errorHeadline:'Ops!',errorBody:'<p>Något gick fel, vänligen försök igen.</p>'},window.newsletter);var cookies=this.props.cookies;var status=this.state.status;var _window$newsletter=window.newsletter,active=_window$newsletter.active,title=_window$newsletter.title,body=_window$newsletter.body,successTitle=_window$newsletter.successTitle,successText=_window$newsletter.successText,errorHeadline=_window$newsletter.errorHeadline,errorBody=_window$newsletter.errorBody,inputEmailPlaceholder=_window$newsletter.inputEmailPlaceholder,image=_window$newsletter.image,confirmationText=_window$newsletter.confirmationText;// if any required data is missing, don't render the widget
if(!active||!title||!body||!successTitle||!successText||!confirmationText)return null;// if the user has already closed the widget, don't render it again
if(cookies.get('newsletter_closed'))return null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(NewsletterWidgetContainer,{hasImage:image&&!!image.url},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(NewsletterWidgetContent,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Conditional__["a" /* Conditional */],{show:status===__WEBPACK_IMPORTED_MODULE_5__constants_status__["d" /* LOADING */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__LoadingSpinner__["a" /* LoadingSpinner */],{margin:'66px auto !important'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Conditional__["a" /* Conditional */],{show:status===__WEBPACK_IMPORTED_MODULE_5__constants_status__["b" /* FAILURE */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CenterContent,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(NewsletterWidgetHeadline,null,errorHeadline),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(NewsletterWidgetBody,{dangerouslySetInnerHTML:{__html:errorBody}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Conditional__["a" /* Conditional */],{show:status===__WEBPACK_IMPORTED_MODULE_5__constants_status__["f" /* SUCCESS */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CenterContent,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(NewsletterWidgetHeadline,null,successTitle),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(NewsletterWidgetBody,{dangerouslySetInnerHTML:{__html:successText}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Conditional__["a" /* Conditional */],{show:status===__WEBPACK_IMPORTED_MODULE_5__constants_status__["c" /* INITIAL */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(NewsletterWidgetHeadline,null,title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(NewsletterWidgetBody,{dangerouslySetInnerHTML:{__html:body}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__NewsletterSignUpForm__["a" /* default */],{placeholder:inputEmailPlaceholder,privacyPolicy:confirmationText,onUpdateStatus:this.setStatus,onClose:this.setCookieToCloseModal}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Conditional__["a" /* Conditional */],{show:image&&!!image.url},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(NewsletterWidgetImage,{url:image&&__WEBPACK_IMPORTED_MODULE_8__constants_endpoints__["n" /* SITE_ROOT_URL */]+image.url})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CloseButton,{onClick:this.setCookieToCloseModal},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CloseButtonIcon,{src:'/images/icons/close-white.svg'})));}}]);return NewsletterWidget;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);NewsletterWidget.propTypes={cookies:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_cookie__["a" /* withCookies */])(NewsletterWidget));/*
  STYLES
*/var CenterContent=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].div(_templateObject);var NewsletterWidgetContainer=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].div(_templateObject2,function(props){return props.hasImage&&Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["css"])(_templateObject3);});var NewsletterWidgetContent=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].div(_templateObject4);var NewsletterWidgetHeadline=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].h3(_templateObject5,__WEBPACK_IMPORTED_MODULE_4__styles_helpers_mixins__["e" /* fontFamilyHeading */]);var NewsletterWidgetBody=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].div(_templateObject6,__WEBPACK_IMPORTED_MODULE_4__styles_helpers_mixins__["d" /* fontFamilyBody */]);var CloseButton=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].button(_templateObject7);var CloseButtonIcon=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].img(_templateObject8);var NewsletterWidgetImage=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].div(_templateObject9,function(props){return props.url;});

/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(603);

/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(35);
var bind = __webpack_require__(249);
var Axios = __webpack_require__(605);
var defaults = __webpack_require__(159);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(utils.merge(defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(253);
axios.CancelToken = __webpack_require__(618);
axios.isCancel = __webpack_require__(252);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(619);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),
/* 604 */
/***/ (function(module, exports) {

/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */

module.exports = function isBuffer (obj) {
  return obj != null && obj.constructor != null &&
    typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
}


/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(159);
var utils = __webpack_require__(35);
var InterceptorManager = __webpack_require__(613);
var dispatchRequest = __webpack_require__(614);

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = utils.merge({
      url: arguments[0]
    }, arguments[1]);
  }

  config = utils.merge(defaults, {method: 'get'}, this.defaults, config);
  config.method = config.method.toLowerCase();

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(35);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(251);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  // Note: status is not exposed by XDomainRequest
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }
  error.request = request;
  error.response = response;
  return error;
};


/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(35);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(35);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(35);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  (function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement('a');
    var originURL;

    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
    function resolveURL(url) {
      var href = url;

      if (msie) {
        // IE needs attribute set twice to normalize properties
        urlParsingNode.setAttribute('href', href);
        href = urlParsingNode.href;
      }

      urlParsingNode.setAttribute('href', href);

      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
      return {
        href: urlParsingNode.href,
        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
        host: urlParsingNode.host,
        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
        hostname: urlParsingNode.hostname,
        port: urlParsingNode.port,
        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
                  urlParsingNode.pathname :
                  '/' + urlParsingNode.pathname
      };
    }

    originURL = resolveURL(window.location.href);

    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
    return function isURLSameOrigin(requestURL) {
      var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
      return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
    };
  })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
      return true;
    };
  })()
);


/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(35);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
  (function standardBrowserEnv() {
    return {
      write: function write(name, value, expires, path, domain, secure) {
        var cookie = [];
        cookie.push(name + '=' + encodeURIComponent(value));

        if (utils.isNumber(expires)) {
          cookie.push('expires=' + new Date(expires).toGMTString());
        }

        if (utils.isString(path)) {
          cookie.push('path=' + path);
        }

        if (utils.isString(domain)) {
          cookie.push('domain=' + domain);
        }

        if (secure === true) {
          cookie.push('secure');
        }

        document.cookie = cookie.join('; ');
      },

      read: function read(name) {
        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
        return (match ? decodeURIComponent(match[3]) : null);
      },

      remove: function remove(name) {
        this.write(name, '', Date.now() - 86400000);
      }
    };
  })() :

  // Non standard browser env (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return {
      write: function write() {},
      read: function read() { return null; },
      remove: function remove() {}
    };
  })()
);


/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(35);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(35);
var transformData = __webpack_require__(615);
var isCancel = __webpack_require__(252);
var defaults = __webpack_require__(159);
var isAbsoluteURL = __webpack_require__(616);
var combineURLs = __webpack_require__(617);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Support baseURL config
  if (config.baseURL && !isAbsoluteURL(config.url)) {
    config.url = combineURLs(config.baseURL, config.url);
  }

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers || {}
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(35);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(253);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),
/* 620 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LinedHeadingContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return LinedHeadingText; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_variables__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_mixins__ = __webpack_require__(6);
var _templateObject=_taggedTemplateLiteral(['\n  margin-top: 30px;\n  margin-bottom: 30px;\n  width: 100%;\n  position: relative;\n  display: flex;\n  background-color: ',';\n  justify-content: center;\n  align-items: center;\n  z-index: 1;\n\n  &:before {\n    content: \'\';\n    display: block;\n    width: 100%;\n    height: 1px;\n    position: absolute;\n    top: 50%;\n    left: 0;\n    background-color: ',';\n  }\n\n  ',';\n  \n  ',';\n  \n  ',';\n  \n  @media screen and (min-width: ','px) {\n    margin-top: 65px;\n  }\n'],['\n  margin-top: 30px;\n  margin-bottom: 30px;\n  width: 100%;\n  position: relative;\n  display: flex;\n  background-color: ',';\n  justify-content: center;\n  align-items: center;\n  z-index: 1;\n\n  &:before {\n    content: \'\';\n    display: block;\n    width: 100%;\n    height: 1px;\n    position: absolute;\n    top: 50%;\n    left: 0;\n    background-color: ',';\n  }\n\n  ',';\n  \n  ',';\n  \n  ',';\n  \n  @media screen and (min-width: ','px) {\n    margin-top: 65px;\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n      margin-top: 45px;\n      margin-bottom: 20px;\n    '],['\n      margin-top: 45px;\n      margin-bottom: 20px;\n    ']),_templateObject3=_taggedTemplateLiteral(['\n    margin-top: 0 !important;\n  '],['\n    margin-top: 0 !important;\n  ']),_templateObject4=_taggedTemplateLiteral(['\n    margin-bottom: 0 !important;\n  '],['\n    margin-bottom: 0 !important;\n  ']),_templateObject5=_taggedTemplateLiteral(['\n  ',';\n  ',';\n  ',';\n\n  font-weight: normal;\n  line-height: 1.45;\n  letter-spacing: 2px;\n  text-align: center;\n  color: ',';\n  background-color: inherit;\n  text-transform: uppercase;\n  display: inline-block;\n  position: relative;\n  padding: 0 0.5rem;\n  margin: 0 0.5rem;\n'],['\n  ',';\n  ',';\n  ',';\n\n  font-weight: normal;\n  line-height: 1.45;\n  letter-spacing: 2px;\n  text-align: center;\n  color: ',';\n  background-color: inherit;\n  text-transform: uppercase;\n  display: inline-block;\n  position: relative;\n  padding: 0 0.5rem;\n  margin: 0 0.5rem;\n']),_templateObject6=_taggedTemplateLiteral(['\n      ',';\n    '],['\n      ',';\n    ']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var LinedHeadingContainer=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].div(_templateObject,function(props){return props.bgColor?props.bgColor:'inherit';},__WEBPACK_IMPORTED_MODULE_1__helpers_variables__["c" /* color */].grey,function(props){return props.adjustToScrollMargin&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(_templateObject2);},function(props){return props.noMargin&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(_templateObject3);},function(props){return props.noBottomMargin&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(_templateObject4);},__WEBPACK_IMPORTED_MODULE_1__helpers_variables__["f" /* size */].xLarge);var LinedHeadingText=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].p(_templateObject5,__WEBPACK_IMPORTED_MODULE_2__helpers_mixins__["e" /* fontFamilyHeading */],Object(__WEBPACK_IMPORTED_MODULE_2__helpers_mixins__["b" /* dynamicFontSize */])(14,20,__WEBPACK_IMPORTED_MODULE_1__helpers_variables__["f" /* size */].small,__WEBPACK_IMPORTED_MODULE_1__helpers_variables__["f" /* size */].large),function(props){return!!props.smallestFontSizeBound&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(_templateObject6,Object(__WEBPACK_IMPORTED_MODULE_2__helpers_mixins__["b" /* dynamicFontSize */])(props.smallestFontSizeBound,35,__WEBPACK_IMPORTED_MODULE_1__helpers_variables__["f" /* size */].small,__WEBPACK_IMPORTED_MODULE_1__helpers_variables__["f" /* size */].large));},function(props){return props.color?props.color:__WEBPACK_IMPORTED_MODULE_1__helpers_variables__["c" /* color */].black;});

/***/ }),
/* 621 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NavigationButtonContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return NavigationButtonImage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return NavigationButtonContent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_mixins__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_variables__ = __webpack_require__(4);
var _templateObject=_taggedTemplateLiteral(['\n  ',';\n  position: relative;\n  width: 100%;\n  min-height: 54px;\n  background-color: ',';\n  display: flex;\n  justify-content: space-between;\n  align-items: stretch;\n  text-decoration: none;\n\n  ',';\n'],['\n  ',';\n  position: relative;\n  width: 100%;\n  min-height: 54px;\n  background-color: ',';\n  display: flex;\n  justify-content: space-between;\n  align-items: stretch;\n  text-decoration: none;\n\n  ',';\n']),_templateObject2=_taggedTemplateLiteral(['\n      margin-bottom: ','px;\n    '],['\n      margin-bottom: ','px;\n    ']),_templateObject3=_taggedTemplateLiteral(['\n  content: \'\';\n  display: inline-block;\n  min-width: 54px;\n  height: 54px;\n  background-image: url("','");\n  background-size: cover;\n  background-position: top left;\n\n  @media screen and (min-width: 500px) {\n    width: 72px;\n    height: 72px;\n  }\n'],['\n  content: \'\';\n  display: inline-block;\n  min-width: 54px;\n  height: 54px;\n  background-image: url("','");\n  background-size: cover;\n  background-position: top left;\n\n  @media screen and (min-width: 500px) {\n    width: 72px;\n    height: 72px;\n  }\n']),_templateObject4=_taggedTemplateLiteral(['\n  ',';\n  color: ',';\n  padding: 0 14px;\n  font-weight: 600;\n  letter-spacing: 2.5px;\n  text-align: left;\n  /* width: 100%; */\n  flex: 1;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  text-transform: uppercase;\n  min-height: inherit;\n\n  @media screen and (min-width: 440px) {\n    padding: 0 16px;\n  }\n\n  @media screen and (min-width: 520px) {\n    padding: 0 18px;\n  }\n\n  @media screen and (min-width: 680px) {\n    padding: 0 21px;\n  }\n\n  &:after {\n    content: \'\';\n    background-image: url(\'/images/icons/arrow.svg\');\n    background-size: contain;\n    background-repeat: no-repeat;\n    min-width: 14px;\n    height: 14px;\n    display: inline-block;\n    margin-left: 5px;\n    transform: rotateZ(-90deg);\n    transition: transform ',' ',';\n  }\n\n  &:hover:after {\n    transform: translateX(4px) rotateZ(-90deg);\n  }\n'],['\n  ',';\n  color: ',';\n  padding: 0 14px;\n  font-weight: 600;\n  letter-spacing: 2.5px;\n  text-align: left;\n  /* width: 100%; */\n  flex: 1;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  text-transform: uppercase;\n  min-height: inherit;\n\n  @media screen and (min-width: 440px) {\n    padding: 0 16px;\n  }\n\n  @media screen and (min-width: 520px) {\n    padding: 0 18px;\n  }\n\n  @media screen and (min-width: 680px) {\n    padding: 0 21px;\n  }\n\n  &:after {\n    content: \'\';\n    background-image: url(\'/images/icons/arrow.svg\');\n    background-size: contain;\n    background-repeat: no-repeat;\n    min-width: 14px;\n    height: 14px;\n    display: inline-block;\n    margin-left: 5px;\n    transform: rotateZ(-90deg);\n    transition: transform ',' ',';\n  }\n\n  &:hover:after {\n    transform: translateX(4px) rotateZ(-90deg);\n  }\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var NavigationButtonContainer=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* Link */])(_templateObject,__WEBPACK_IMPORTED_MODULE_2__helpers_mixins__["i" /* shadowOnHover */],__WEBPACK_IMPORTED_MODULE_3__helpers_variables__["c" /* color */].white,function(props){return props.mb&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(_templateObject2,props.mb);});var NavigationButtonImage=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].div(_templateObject3,function(props){return props.url;});var NavigationButtonContent=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].div(_templateObject4,Object(__WEBPACK_IMPORTED_MODULE_2__helpers_mixins__["b" /* dynamicFontSize */])(12,14,320,1360),__WEBPACK_IMPORTED_MODULE_3__helpers_variables__["c" /* color */].black,__WEBPACK_IMPORTED_MODULE_3__helpers_variables__["a" /* animation */].transitionTime,__WEBPACK_IMPORTED_MODULE_3__helpers_variables__["a" /* animation */].easing);

/***/ }),
/* 622 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_blocks_LargeNavigationButtonBlock__ = __webpack_require__(623);
var LargeNavigationButton=function LargeNavigationButton(props){if(!props.image||!props.title||!props.url){return false;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__styles_blocks_LargeNavigationButtonBlock__["a" /* LargeNavigationButtonBlock */].Container,{to:props.url},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__styles_blocks_LargeNavigationButtonBlock__["a" /* LargeNavigationButtonBlock */].Content,{to:props.url,image:props.image},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__styles_blocks_LargeNavigationButtonBlock__["a" /* LargeNavigationButtonBlock */].Title,null,props.title)));};LargeNavigationButton.defaultProps={image:null,url:null,title:null};LargeNavigationButton.propTypes={title:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,url:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,image:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (LargeNavigationButton);

/***/ }),
/* 623 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LargeNavigationButtonBlock; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_variables__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_mixins__ = __webpack_require__(6);
var _templateObject=_taggedTemplateLiteral(['\n  width: 100%;\n  height: 20px;\n  padding-bottom: 100%;\n  position: relative;\n  //margin-bottom: 10px;\n\n  @media screen and (min-width: ','px) {\n    padding-bottom: 135.62%;\n  }\n'],['\n  width: 100%;\n  height: 20px;\n  padding-bottom: 100%;\n  position: relative;\n  //margin-bottom: 10px;\n\n  @media screen and (min-width: ','px) {\n    padding-bottom: 135.62%;\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  display: flex;\n  text-decoration: none;\n  color: inherit;\n  background-image: url("','");\n  justify-content: center;\n  align-items: center;\n  background-size: cover;\n  \n  &:after {\n    content: \'\';\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    background-color: ',';\n    opacity: .25;\n    z-index: 1;\n    transition: opacity 250ms ease-out;\n    \n    ',':hover & {\n      opacity: .45;\n    }\n  }\n'],['\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  display: flex;\n  text-decoration: none;\n  color: inherit;\n  background-image: url("','");\n  justify-content: center;\n  align-items: center;\n  background-size: cover;\n  \n  &:after {\n    content: \'\';\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    background-color: ',';\n    opacity: .25;\n    z-index: 1;\n    transition: opacity 250ms ease-out;\n    \n    ',':hover & {\n      opacity: .45;\n    }\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  ',';\n  ',';\n  font-weight: normal;\n  font-style: normal;\n  font-stretch: normal;\n  line-height: 1.67;\n  letter-spacing: normal;\n  text-align: center;\n  color: ',';\n  z-index: 2;\n  position: relative;\n  display: block;\n  width: 100%;\n  padding-bottom: 0.16667em;\n\n  &:before,\n  &:after {\n    position: absolute;\n    left: 27px;\n    right: 27px;\n    content: \'\';\n    display: inline-block;\n    height: 1px;\n    background-color: ',';\n  }\n\n  &:before {\n    top: -5px;\n  }\n\n  &:after {\n    bottom: -5px;\n  }\n\n  @media screen and (min-width: 800px) {\n    ',';\n  }\n'],['\n  ',';\n  ',';\n  font-weight: normal;\n  font-style: normal;\n  font-stretch: normal;\n  line-height: 1.67;\n  letter-spacing: normal;\n  text-align: center;\n  color: ',';\n  z-index: 2;\n  position: relative;\n  display: block;\n  width: 100%;\n  padding-bottom: 0.16667em;\n\n  &:before,\n  &:after {\n    position: absolute;\n    left: 27px;\n    right: 27px;\n    content: \'\';\n    display: inline-block;\n    height: 1px;\n    background-color: ',';\n  }\n\n  &:before {\n    top: -5px;\n  }\n\n  &:after {\n    bottom: -5px;\n  }\n\n  @media screen and (min-width: 800px) {\n    ',';\n  }\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var LargeNavigationButtonBlock={};LargeNavigationButtonBlock.Container=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].div(_templateObject,__WEBPACK_IMPORTED_MODULE_2__helpers_variables__["f" /* size */].large);LargeNavigationButtonBlock.Content=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* Link */])(_templateObject2,function(props){return props.image;},__WEBPACK_IMPORTED_MODULE_2__helpers_variables__["c" /* color */].black,LargeNavigationButtonBlock.Container);LargeNavigationButtonBlock.Title=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].p(_templateObject3,__WEBPACK_IMPORTED_MODULE_3__helpers_mixins__["e" /* fontFamilyHeading */],Object(__WEBPACK_IMPORTED_MODULE_3__helpers_mixins__["b" /* dynamicFontSize */])(24,34,320,800),__WEBPACK_IMPORTED_MODULE_2__helpers_variables__["c" /* color */].white,__WEBPACK_IMPORTED_MODULE_2__helpers_variables__["c" /* color */].white,Object(__WEBPACK_IMPORTED_MODULE_3__helpers_mixins__["b" /* dynamicFontSize */])(22,34,800,1200));

/***/ }),
/* 624 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_truncate__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_dom__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_helpers_variables__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_blocks_DesignerCardBlock__ = __webpack_require__(625);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants_endpoints__ = __webpack_require__(9);
var _templateObject=_taggedTemplateLiteral(['\n  text-align: center;\n'],['\n  text-align: center;\n']),_templateObject2=_taggedTemplateLiteral(['\n  display: inline-block;\n  padding: 17.5px 40px;\n  border-top: 1px solid ',';\n  border-bottom: 1px solid ',';\n  color: ',';\n  font-size: 12px;\n  font-weight: 600;\n  text-transform: uppercase;\n  text-decoration: none;\n  text-align: center;\n  letter-spacing: 0.125em;\n  line-height: 1.25;\n  transition: background-color 0.25s ease-out, color 0.25s ease-out;\n  @media screen and (min-width: ','px) {\n    padding: 17.5px 60px;\n  }\n  &:hover {\n    background-color: ',';\n    color: ',';\n  }\n'],['\n  display: inline-block;\n  padding: 17.5px 40px;\n  border-top: 1px solid ',';\n  border-bottom: 1px solid ',';\n  color: ',';\n  font-size: 12px;\n  font-weight: 600;\n  text-transform: uppercase;\n  text-decoration: none;\n  text-align: center;\n  letter-spacing: 0.125em;\n  line-height: 1.25;\n  transition: background-color 0.25s ease-out, color 0.25s ease-out;\n  @media screen and (min-width: ','px) {\n    padding: 17.5px 60px;\n  }\n  &:hover {\n    background-color: ',';\n    color: ',';\n  }\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var AboutCard=function AboutCard(props){var imageUrl=props.imageUrl,imageAlt=props.imageAlt,heading=props.heading,body=props.body,linkText=props.linkText,linkUrl=props.linkUrl,defaultLinkText=props.defaultLinkText;if(!imageUrl||!(heading||body)){return false;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__styles_blocks_DesignerCardBlock__["g" /* DesignerCardRootContainer */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__styles_blocks_DesignerCardBlock__["f" /* DesignerCardImageContainer */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__styles_blocks_DesignerCardBlock__["e" /* DesignerCardImage */],{src:__WEBPACK_IMPORTED_MODULE_7__constants_endpoints__["n" /* SITE_ROOT_URL */]+imageUrl,alt:imageAlt})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__styles_blocks_DesignerCardBlock__["b" /* DesignerCardContent */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__styles_blocks_DesignerCardBlock__["c" /* DesignerCardContentContainer */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__styles_blocks_DesignerCardBlock__["d" /* DesignerCardHeading */],null,heading),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__styles_blocks_DesignerCardBlock__["a" /* DesignerCardBody */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_truncate__["a" /* default */],{lines:7},body)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ButtonLinkContainer,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ButtonLink,{to:linkUrl},linkText||defaultLinkText)))));};var ButtonLinkContainer=__WEBPACK_IMPORTED_MODULE_3_styled_components__["default"].div(_templateObject);var ButtonLink=Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["a" /* Link */])(_templateObject2,__WEBPACK_IMPORTED_MODULE_5__styles_helpers_variables__["c" /* color */].black,__WEBPACK_IMPORTED_MODULE_5__styles_helpers_variables__["c" /* color */].black,__WEBPACK_IMPORTED_MODULE_5__styles_helpers_variables__["c" /* color */].black,__WEBPACK_IMPORTED_MODULE_5__styles_helpers_variables__["f" /* size */].xXLarge,__WEBPACK_IMPORTED_MODULE_5__styles_helpers_variables__["c" /* color */].black,__WEBPACK_IMPORTED_MODULE_5__styles_helpers_variables__["c" /* color */].white);AboutCard.defaultProps={imageUrl:null,imageAlt:null,heading:null,body:null,linkText:null,linkUrl:null,defaultLinkText:null};AboutCard.propTypes={imageUrl:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,imageAlt:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,heading:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,body:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,linkText:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,linkUrl:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,defaultLinkText:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (AboutCard);

/***/ }),
/* 625 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return DesignerCardHeading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DesignerCardBody; });
/* unused harmony export DesignerCardParagraph */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return DesignerCardImageContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return DesignerCardImage; });
/* unused harmony export DesignerCardName */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return DesignerCardRootContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DesignerCardContent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return DesignerCardContentContainer; });
/* unused harmony export DesignerCardPortrait */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_variables__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Paragraph__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_mixins__ = __webpack_require__(6);
var _templateObject=_taggedTemplateLiteral(['\n  margin: 0 0 20px;\n  ',';\n  font-size: 30px;\n  font-weight: 400;\n  text-align: center;\n  line-height: 1.25;\n  @media screen and (min-width: ','px) {\n    font-size: 40px;\n  }\n'],['\n  margin: 0 0 20px;\n  ',';\n  font-size: 30px;\n  font-weight: 400;\n  text-align: center;\n  line-height: 1.25;\n  @media screen and (min-width: ','px) {\n    font-size: 40px;\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  margin: 0 0 40px;\n  font-size: 14px;\n  text-align: center;\n  line-height: 1.75;\n'],['\n  margin: 0 0 40px;\n  font-size: 14px;\n  text-align: center;\n  line-height: 1.75;\n']),_templateObject3=_taggedTemplateLiteral(['\n  ',';\n  text-align: center;\n  line-height: 1.79;\n  margin: 47px 0;\n'],['\n  ',';\n  text-align: center;\n  line-height: 1.79;\n  margin: 47px 0;\n']),_templateObject4=_taggedTemplateLiteral(['\n  flex: 1;\n  width: 100%;\n  height: 0;\n  padding-bottom: 100%;\n  position: relative;\n\n  @media screen and (min-width: ','px) {\n    padding-bottom: 0;\n    height: auto;\n  }\n'],['\n  flex: 1;\n  width: 100%;\n  height: 0;\n  padding-bottom: 100%;\n  position: relative;\n\n  @media screen and (min-width: ','px) {\n    padding-bottom: 0;\n    height: auto;\n  }\n']),_templateObject5=_taggedTemplateLiteral(['\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 100%;\n  width: 100%;\n  object-fit: cover;\n'],['\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 100%;\n  width: 100%;\n  object-fit: cover;\n']),_templateObject6=_taggedTemplateLiteral(['\n  display: block;\n  position: relative;\n\n  span {\n    display: block;\n    padding: 9px 0 0;\n    font-size: 12px;\n    font-weight: 600;\n    font-style: normal;\n    font-stretch: normal;\n    line-height: normal;\n    letter-spacing: 1.5px;\n    text-align: center;\n    color: ',';\n    text-transform: uppercase;\n  }\n\n  &:before {\n    content: \'\';\n    display: inline-block;\n    height: 1px;\n    width: 100%;\n    background-color: ',';\n  }\n\n  &:after {\n    content: \'\';\n    display: inline-block;\n    height: 1px;\n    width: 100%;\n    background-color: ',';\n  }\n\n  @media screen and (min-width: ','px) {\n    span {\n      padding: 12px 0 0;\n    }\n  }\n'],['\n  display: block;\n  position: relative;\n\n  span {\n    display: block;\n    padding: 9px 0 0;\n    font-size: 12px;\n    font-weight: 600;\n    font-style: normal;\n    font-stretch: normal;\n    line-height: normal;\n    letter-spacing: 1.5px;\n    text-align: center;\n    color: ',';\n    text-transform: uppercase;\n  }\n\n  &:before {\n    content: \'\';\n    display: inline-block;\n    height: 1px;\n    width: 100%;\n    background-color: ',';\n  }\n\n  &:after {\n    content: \'\';\n    display: inline-block;\n    height: 1px;\n    width: 100%;\n    background-color: ',';\n  }\n\n  @media screen and (min-width: ','px) {\n    span {\n      padding: 12px 0 0;\n    }\n  }\n']),_templateObject7=_taggedTemplateLiteral(['\n  width: 100%;\n  height: auto;\n  display: flex;\n  align-items: stretch;\n  flex-direction: column-reverse;\n\n  @media screen and (min-width: ','px) {\n    flex-direction: row;\n  }\n'],['\n  width: 100%;\n  height: auto;\n  display: flex;\n  align-items: stretch;\n  flex-direction: column-reverse;\n\n  @media screen and (min-width: ','px) {\n    flex-direction: row;\n  }\n']),_templateObject8=_taggedTemplateLiteral(['\n  flex: 1;\n  background-color: ',';\n\n  @media screen and (min-width: 1300px) {\n    height: 0;\n    padding-bottom: 50%;\n    position: relative;\n  }\n'],['\n  flex: 1;\n  background-color: ',';\n\n  @media screen and (min-width: 1300px) {\n    height: 0;\n    padding-bottom: 50%;\n    position: relative;\n  }\n']),_templateObject9=_taggedTemplateLiteral(['\n  width: 100%;\n  height: auto;\n  background: ',';\n  padding: 44px 24px;\n\n  @media screen and (min-width: 440px) {\n    padding: 44px;\n  }\n\n  @media screen and (min-width: ','px) {\n    padding: 68px 68px 87px;\n  }\n\n  @media screen and (min-width: 1300px) {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    padding-top: 0;\n    padding-bottom: 20px;\n  }\n'],['\n  width: 100%;\n  height: auto;\n  background: ',';\n  padding: 44px 24px;\n\n  @media screen and (min-width: 440px) {\n    padding: 44px;\n  }\n\n  @media screen and (min-width: ','px) {\n    padding: 68px 68px 87px;\n  }\n\n  @media screen and (min-width: 1300px) {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    padding-top: 0;\n    padding-bottom: 20px;\n  }\n']),_templateObject10=_taggedTemplateLiteral(['\n  display: block;\n  width: 80px;\n  height: 80px;\n  border-radius: 100%;\n  margin: 10px auto;\n\n  @media screen and (min-width: 400px) {\n    width: 110px;\n    height: 110px;\n  }\n\n  @media screen and (min-width: ','px) {\n    width: 130px;\n    height: 130px;\n  }\n'],['\n  display: block;\n  width: 80px;\n  height: 80px;\n  border-radius: 100%;\n  margin: 10px auto;\n\n  @media screen and (min-width: 400px) {\n    width: 110px;\n    height: 110px;\n  }\n\n  @media screen and (min-width: ','px) {\n    width: 130px;\n    height: 130px;\n  }\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var DesignerCardHeading=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].h2(_templateObject,__WEBPACK_IMPORTED_MODULE_3__helpers_mixins__["e" /* fontFamilyHeading */],__WEBPACK_IMPORTED_MODULE_1__helpers_variables__["f" /* size */].xXLarge);var DesignerCardBody=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].p(_templateObject2);var DesignerCardParagraph=__WEBPACK_IMPORTED_MODULE_2__Paragraph__["a" /* Paragraph */].extend(_templateObject3,Object(__WEBPACK_IMPORTED_MODULE_3__helpers_mixins__["b" /* dynamicFontSize */])(14,16));var DesignerCardImageContainer=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].div(_templateObject4,__WEBPACK_IMPORTED_MODULE_1__helpers_variables__["f" /* size */].large);var DesignerCardImage=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].img(_templateObject5);var DesignerCardName=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].p(_templateObject6,__WEBPACK_IMPORTED_MODULE_1__helpers_variables__["c" /* color */].black,__WEBPACK_IMPORTED_MODULE_1__helpers_variables__["c" /* color */].black,__WEBPACK_IMPORTED_MODULE_1__helpers_variables__["c" /* color */].black,__WEBPACK_IMPORTED_MODULE_1__helpers_variables__["f" /* size */].large);var DesignerCardRootContainer=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].div(_templateObject7,__WEBPACK_IMPORTED_MODULE_1__helpers_variables__["f" /* size */].large);var DesignerCardContent=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].div(_templateObject8,__WEBPACK_IMPORTED_MODULE_1__helpers_variables__["c" /* color */].white);var DesignerCardContentContainer=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].div(_templateObject9,__WEBPACK_IMPORTED_MODULE_1__helpers_variables__["c" /* color */].white,__WEBPACK_IMPORTED_MODULE_1__helpers_variables__["f" /* size */].large);var DesignerCardPortrait=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].img(_templateObject10,__WEBPACK_IMPORTED_MODULE_1__helpers_variables__["f" /* size */].large);

/***/ }),
/* 626 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_color__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_color___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_color__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_blocks_StartPageBlock__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_isValidHexColor__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_helpers_variables__ = __webpack_require__(4);
var HeroSection=function HeroSection(props){if(props.isMobile){var isDark=Object(__WEBPACK_IMPORTED_MODULE_4__util_isValidHexColor__["a" /* isValidHexColor */])(props.backgroundColor)?__WEBPACK_IMPORTED_MODULE_2_color___default()(props.backgroundColor).isDark():false;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styles_blocks_StartPageBlock__["a" /* StartPageBlock */].Section,{backgroundColor:props.backgroundColor,pt:0,pb:30},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styles_blocks_StartPageBlock__["a" /* StartPageBlock */].HeroImageContainer,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styles_blocks_StartPageBlock__["a" /* StartPageBlock */].HeroImage,{image:props.heroImage})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styles_blocks_StartPageBlock__["a" /* StartPageBlock */].Container,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styles_blocks_StartPageBlock__["a" /* StartPageBlock */].HeroHeading,{onDarkBackground:isDark},props.heroTitle),props.heroLinkUrl?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styles_blocks_StartPageBlock__["a" /* StartPageBlock */].HeroLink,{onDarkBackground:isDark,to:props.heroLinkUrl},props.heroLinkLabel):false));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styles_blocks_StartPageBlock__["a" /* StartPageBlock */].Section,{backgroundColor:props.backgroundColor,pt:40,style:{position:'relative'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styles_blocks_StartPageBlock__["a" /* StartPageBlock */].SectionFix,{backgroundColor:__WEBPACK_IMPORTED_MODULE_5__styles_helpers_variables__["c" /* color */].lightGrey}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styles_blocks_StartPageBlock__["a" /* StartPageBlock */].Container,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styles_blocks_StartPageBlock__["a" /* StartPageBlock */].HeroImageContainer,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styles_blocks_StartPageBlock__["a" /* StartPageBlock */].HeroImage,{image:props.heroImage}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styles_blocks_StartPageBlock__["a" /* StartPageBlock */].HeroContentContainer,{alignRight:props.alignRight},props.heroLinkUrl?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styles_blocks_StartPageBlock__["a" /* StartPageBlock */].HeroContent,{to:props.heroLinkUrl,isLight:props.heroBackgroundIsLight},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styles_blocks_StartPageBlock__["a" /* StartPageBlock */].HeroHeading,{isDark:!props.heroBackgroundIsLight},props.heroTitle),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styles_blocks_StartPageBlock__["a" /* StartPageBlock */].HeroLinkAsP,{isDark:!props.heroBackgroundIsLight},props.heroLinkLabel)):false))));};HeroSection.defaultProps={isMobile:false,backgroundColor:null,heroImage:null,heroTitle:null,heroLinkUrl:null,heroLinkLabel:null,alignRight:false,heroBackgroundIsLight:false};HeroSection.propTypes={isMobile:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,backgroundColor:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,heroImage:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,heroTitle:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,heroLinkUrl:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,heroLinkLabel:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,alignRight:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,heroBackgroundIsLight:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (HeroSection);

/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

/* MIT license */
var colorNames = __webpack_require__(256);
var swizzle = __webpack_require__(628);
var hasOwnProperty = Object.hasOwnProperty;

var reverseNames = Object.create(null);

// create a list of reverse color names
for (var name in colorNames) {
	if (hasOwnProperty.call(colorNames, name)) {
		reverseNames[colorNames[name]] = name;
	}
}

var cs = module.exports = {
	to: {},
	get: {}
};

cs.get = function (string) {
	var prefix = string.substring(0, 3).toLowerCase();
	var val;
	var model;
	switch (prefix) {
		case 'hsl':
			val = cs.get.hsl(string);
			model = 'hsl';
			break;
		case 'hwb':
			val = cs.get.hwb(string);
			model = 'hwb';
			break;
		default:
			val = cs.get.rgb(string);
			model = 'rgb';
			break;
	}

	if (!val) {
		return null;
	}

	return {model: model, value: val};
};

cs.get.rgb = function (string) {
	if (!string) {
		return null;
	}

	var abbr = /^#([a-f0-9]{3,4})$/i;
	var hex = /^#([a-f0-9]{6})([a-f0-9]{2})?$/i;
	var rgba = /^rgba?\(\s*([+-]?\d+)(?=[\s,])\s*(?:,\s*)?([+-]?\d+)(?=[\s,])\s*(?:,\s*)?([+-]?\d+)\s*(?:[,|\/]\s*([+-]?[\d\.]+)(%?)\s*)?\)$/;
	var per = /^rgba?\(\s*([+-]?[\d\.]+)\%\s*,?\s*([+-]?[\d\.]+)\%\s*,?\s*([+-]?[\d\.]+)\%\s*(?:[,|\/]\s*([+-]?[\d\.]+)(%?)\s*)?\)$/;
	var keyword = /^(\w+)$/;

	var rgb = [0, 0, 0, 1];
	var match;
	var i;
	var hexAlpha;

	if (match = string.match(hex)) {
		hexAlpha = match[2];
		match = match[1];

		for (i = 0; i < 3; i++) {
			// https://jsperf.com/slice-vs-substr-vs-substring-methods-long-string/19
			var i2 = i * 2;
			rgb[i] = parseInt(match.slice(i2, i2 + 2), 16);
		}

		if (hexAlpha) {
			rgb[3] = parseInt(hexAlpha, 16) / 255;
		}
	} else if (match = string.match(abbr)) {
		match = match[1];
		hexAlpha = match[3];

		for (i = 0; i < 3; i++) {
			rgb[i] = parseInt(match[i] + match[i], 16);
		}

		if (hexAlpha) {
			rgb[3] = parseInt(hexAlpha + hexAlpha, 16) / 255;
		}
	} else if (match = string.match(rgba)) {
		for (i = 0; i < 3; i++) {
			rgb[i] = parseInt(match[i + 1], 0);
		}

		if (match[4]) {
			if (match[5]) {
				rgb[3] = parseFloat(match[4]) * 0.01;
			} else {
				rgb[3] = parseFloat(match[4]);
			}
		}
	} else if (match = string.match(per)) {
		for (i = 0; i < 3; i++) {
			rgb[i] = Math.round(parseFloat(match[i + 1]) * 2.55);
		}

		if (match[4]) {
			if (match[5]) {
				rgb[3] = parseFloat(match[4]) * 0.01;
			} else {
				rgb[3] = parseFloat(match[4]);
			}
		}
	} else if (match = string.match(keyword)) {
		if (match[1] === 'transparent') {
			return [0, 0, 0, 0];
		}

		if (!hasOwnProperty.call(colorNames, match[1])) {
			return null;
		}

		rgb = colorNames[match[1]];
		rgb[3] = 1;

		return rgb;
	} else {
		return null;
	}

	for (i = 0; i < 3; i++) {
		rgb[i] = clamp(rgb[i], 0, 255);
	}
	rgb[3] = clamp(rgb[3], 0, 1);

	return rgb;
};

cs.get.hsl = function (string) {
	if (!string) {
		return null;
	}

	var hsl = /^hsla?\(\s*([+-]?(?:\d{0,3}\.)?\d+)(?:deg)?\s*,?\s*([+-]?[\d\.]+)%\s*,?\s*([+-]?[\d\.]+)%\s*(?:[,|\/]\s*([+-]?(?=\.\d|\d)(?:0|[1-9]\d*)?(?:\.\d*)?(?:[eE][+-]?\d+)?)\s*)?\)$/;
	var match = string.match(hsl);

	if (match) {
		var alpha = parseFloat(match[4]);
		var h = ((parseFloat(match[1]) % 360) + 360) % 360;
		var s = clamp(parseFloat(match[2]), 0, 100);
		var l = clamp(parseFloat(match[3]), 0, 100);
		var a = clamp(isNaN(alpha) ? 1 : alpha, 0, 1);

		return [h, s, l, a];
	}

	return null;
};

cs.get.hwb = function (string) {
	if (!string) {
		return null;
	}

	var hwb = /^hwb\(\s*([+-]?\d{0,3}(?:\.\d+)?)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?(?=\.\d|\d)(?:0|[1-9]\d*)?(?:\.\d*)?(?:[eE][+-]?\d+)?)\s*)?\)$/;
	var match = string.match(hwb);

	if (match) {
		var alpha = parseFloat(match[4]);
		var h = ((parseFloat(match[1]) % 360) + 360) % 360;
		var w = clamp(parseFloat(match[2]), 0, 100);
		var b = clamp(parseFloat(match[3]), 0, 100);
		var a = clamp(isNaN(alpha) ? 1 : alpha, 0, 1);
		return [h, w, b, a];
	}

	return null;
};

cs.to.hex = function () {
	var rgba = swizzle(arguments);

	return (
		'#' +
		hexDouble(rgba[0]) +
		hexDouble(rgba[1]) +
		hexDouble(rgba[2]) +
		(rgba[3] < 1
			? (hexDouble(Math.round(rgba[3] * 255)))
			: '')
	);
};

cs.to.rgb = function () {
	var rgba = swizzle(arguments);

	return rgba.length < 4 || rgba[3] === 1
		? 'rgb(' + Math.round(rgba[0]) + ', ' + Math.round(rgba[1]) + ', ' + Math.round(rgba[2]) + ')'
		: 'rgba(' + Math.round(rgba[0]) + ', ' + Math.round(rgba[1]) + ', ' + Math.round(rgba[2]) + ', ' + rgba[3] + ')';
};

cs.to.rgb.percent = function () {
	var rgba = swizzle(arguments);

	var r = Math.round(rgba[0] / 255 * 100);
	var g = Math.round(rgba[1] / 255 * 100);
	var b = Math.round(rgba[2] / 255 * 100);

	return rgba.length < 4 || rgba[3] === 1
		? 'rgb(' + r + '%, ' + g + '%, ' + b + '%)'
		: 'rgba(' + r + '%, ' + g + '%, ' + b + '%, ' + rgba[3] + ')';
};

cs.to.hsl = function () {
	var hsla = swizzle(arguments);
	return hsla.length < 4 || hsla[3] === 1
		? 'hsl(' + hsla[0] + ', ' + hsla[1] + '%, ' + hsla[2] + '%)'
		: 'hsla(' + hsla[0] + ', ' + hsla[1] + '%, ' + hsla[2] + '%, ' + hsla[3] + ')';
};

// hwb is a bit different than rgb(a) & hsl(a) since there is no alpha specific syntax
// (hwb have alpha optional & 1 is default value)
cs.to.hwb = function () {
	var hwba = swizzle(arguments);

	var a = '';
	if (hwba.length >= 4 && hwba[3] !== 1) {
		a = ', ' + hwba[3];
	}

	return 'hwb(' + hwba[0] + ', ' + hwba[1] + '%, ' + hwba[2] + '%' + a + ')';
};

cs.to.keyword = function (rgb) {
	return reverseNames[rgb.slice(0, 3)];
};

// helpers
function clamp(num, min, max) {
	return Math.min(Math.max(min, num), max);
}

function hexDouble(num) {
	var str = Math.round(num).toString(16).toUpperCase();
	return (str.length < 2) ? '0' + str : str;
}


/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isArrayish = __webpack_require__(629);

var concat = Array.prototype.concat;
var slice = Array.prototype.slice;

var swizzle = module.exports = function swizzle(args) {
	var results = [];

	for (var i = 0, len = args.length; i < len; i++) {
		var arg = args[i];

		if (isArrayish(arg)) {
			// http://jsperf.com/javascript-array-concat-vs-push/98
			results = concat.call(results, slice.call(arg));
		} else {
			results.push(arg);
		}
	}

	return results;
};

swizzle.wrap = function (fn) {
	return function () {
		return fn(swizzle(arguments));
	};
};


/***/ }),
/* 629 */
/***/ (function(module, exports) {

module.exports = function isArrayish(obj) {
	if (!obj || typeof obj === 'string') {
		return false;
	}

	return obj instanceof Array || Array.isArray(obj) ||
		(obj.length >= 0 && (obj.splice instanceof Function ||
			(Object.getOwnPropertyDescriptor(obj, (obj.length - 1)) && obj.constructor.name !== 'String')));
};


/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

var conversions = __webpack_require__(257);
var route = __webpack_require__(631);

var convert = {};

var models = Object.keys(conversions);

function wrapRaw(fn) {
	var wrappedFn = function (args) {
		if (args === undefined || args === null) {
			return args;
		}

		if (arguments.length > 1) {
			args = Array.prototype.slice.call(arguments);
		}

		return fn(args);
	};

	// preserve .conversion property if there is one
	if ('conversion' in fn) {
		wrappedFn.conversion = fn.conversion;
	}

	return wrappedFn;
}

function wrapRounded(fn) {
	var wrappedFn = function (args) {
		if (args === undefined || args === null) {
			return args;
		}

		if (arguments.length > 1) {
			args = Array.prototype.slice.call(arguments);
		}

		var result = fn(args);

		// we're assuming the result is an array here.
		// see notice in conversions.js; don't use box types
		// in conversion functions.
		if (typeof result === 'object') {
			for (var len = result.length, i = 0; i < len; i++) {
				result[i] = Math.round(result[i]);
			}
		}

		return result;
	};

	// preserve .conversion property if there is one
	if ('conversion' in fn) {
		wrappedFn.conversion = fn.conversion;
	}

	return wrappedFn;
}

models.forEach(function (fromModel) {
	convert[fromModel] = {};

	Object.defineProperty(convert[fromModel], 'channels', {value: conversions[fromModel].channels});
	Object.defineProperty(convert[fromModel], 'labels', {value: conversions[fromModel].labels});

	var routes = route(fromModel);
	var routeModels = Object.keys(routes);

	routeModels.forEach(function (toModel) {
		var fn = routes[toModel];

		convert[fromModel][toModel] = wrapRounded(fn);
		convert[fromModel][toModel].raw = wrapRaw(fn);
	});
});

module.exports = convert;


/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

var conversions = __webpack_require__(257);

/*
	this function routes a model to all other models.

	all functions that are routed have a property `.conversion` attached
	to the returned synthetic function. This property is an array
	of strings, each with the steps in between the 'from' and 'to'
	color models (inclusive).

	conversions that are not possible simply are not included.
*/

function buildGraph() {
	var graph = {};
	// https://jsperf.com/object-keys-vs-for-in-with-closure/3
	var models = Object.keys(conversions);

	for (var len = models.length, i = 0; i < len; i++) {
		graph[models[i]] = {
			// http://jsperf.com/1-vs-infinity
			// micro-opt, but this is simple.
			distance: -1,
			parent: null
		};
	}

	return graph;
}

// https://en.wikipedia.org/wiki/Breadth-first_search
function deriveBFS(fromModel) {
	var graph = buildGraph();
	var queue = [fromModel]; // unshift -> queue -> pop

	graph[fromModel].distance = 0;

	while (queue.length) {
		var current = queue.pop();
		var adjacents = Object.keys(conversions[current]);

		for (var len = adjacents.length, i = 0; i < len; i++) {
			var adjacent = adjacents[i];
			var node = graph[adjacent];

			if (node.distance === -1) {
				node.distance = graph[current].distance + 1;
				node.parent = current;
				queue.unshift(adjacent);
			}
		}
	}

	return graph;
}

function link(from, to) {
	return function (args) {
		return to(from(args));
	};
}

function wrapConversion(toModel, graph) {
	var path = [graph[toModel].parent, toModel];
	var fn = conversions[graph[toModel].parent][toModel];

	var cur = graph[toModel].parent;
	while (graph[cur].parent) {
		path.unshift(graph[cur].parent);
		fn = link(conversions[graph[cur].parent][cur], fn);
		cur = graph[cur].parent;
	}

	fn.conversion = path;
	return fn;
}

module.exports = function (fromModel) {
	var graph = deriveBFS(fromModel);
	var conversion = {};

	var models = Object.keys(graph);
	for (var len = models.length, i = 0; i < len; i++) {
		var toModel = models[i];
		var node = graph[toModel];

		if (node.parent === null) {
			// no possible conversion, or this node is the source model.
			continue;
		}

		conversion[toModel] = wrapConversion(toModel, graph);
	}

	return conversion;
};



/***/ }),
/* 632 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_helpers_mixins__ = __webpack_require__(6);
var _templateObject=_taggedTemplateLiteral(['\n  ',';\n  display: block;\n  font-size: 0;\n'],['\n  ',';\n  display: block;\n  font-size: 0;\n']),_templateObject2=_taggedTemplateLiteral(['\n  width: 100%;\n  height: 0;\n  padding-bottom: 100%;\n  position: relative;\n'],['\n  width: 100%;\n  height: 0;\n  padding-bottom: 100%;\n  position: relative;\n']),_templateObject3=_taggedTemplateLiteral(['\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background-image: url("','");\n  background-position: center;\n  background-size: cover;\n'],['\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background-image: url("','");\n  background-position: center;\n  background-size: cover;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var InstragramPost=function InstragramPost(props){if(!props.url||!props.imageUrl){return false;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(InstagramLink,{href:props.url,target:'_blank'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(InstragramImageContainer,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(InstragramImage,{image:props.imageUrl})));};var InstagramLink=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].a(_templateObject,__WEBPACK_IMPORTED_MODULE_3__styles_helpers_mixins__["a" /* darkenOnHover */]);var InstragramImageContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject2);var InstragramImage=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject3,function(props){return props.image;});InstragramPost.defaultProps={url:null,imageUrl:null};InstragramPost.propTypes={url:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,imageUrl:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (InstragramPost);

/***/ }),
/* 633 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return InfoBanner; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_color__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_color___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_color__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_immutable__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_helpers_mixins__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_helpers_variables__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_isValidHexColor__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_blocks_StartPageBlock__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Conditional__ = __webpack_require__(26);
var _templateObject=_taggedTemplateLiteral(['\n  background-color: ',';\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 43px 20px 30px;\n\n  @media screen and (min-width: ','px) {\n    padding: 43px 50px 30px;\n  }\n\n  @media screen and (min-width: ','px) {\n    padding: 43px 100px 30px;\n  }\n'],['\n  background-color: ',';\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 43px 20px 30px;\n\n  @media screen and (min-width: ','px) {\n    padding: 43px 50px 30px;\n  }\n\n  @media screen and (min-width: ','px) {\n    padding: 43px 100px 30px;\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  ',';\n  ',';\n  line-height: 1.1;\n  text-align: center;\n  letter-spacing: normal;\n  font-weight: normal;\n  color: ',';\n  width: 100%;\n  margin: 0;\n'],['\n  ',';\n  ',';\n  line-height: 1.1;\n  text-align: center;\n  letter-spacing: normal;\n  font-weight: normal;\n  color: ',';\n  width: 100%;\n  margin: 0;\n']),_templateObject3=_taggedTemplateLiteral(['\n  max-width: 800px;\n  line-height: 1.56;\n  margin: 2em 0 1.5em;\n  text-align: center;\n  color: ',';\n\n  @media screen and (min-width: ','px) {\n    margin: 1.25em 0 15px;\n  }\n'],['\n  max-width: 800px;\n  line-height: 1.56;\n  margin: 2em 0 1.5em;\n  text-align: center;\n  color: ',';\n\n  @media screen and (min-width: ','px) {\n    margin: 1.25em 0 15px;\n  }\n']),_templateObject4=_taggedTemplateLiteral(['\n  text-decoration: none;\n  margin: 5px 0;\n'],['\n  text-decoration: none;\n  margin: 5px 0;\n']),_templateObject5=_taggedTemplateLiteral(['\n  text-transform: uppercase;\n  letter-spacing: 2px;\n  margin: 0;\n'],['\n  text-transform: uppercase;\n  letter-spacing: 2px;\n  margin: 0;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var InfoBanner=function InfoBanner(props){var backgroundColor=props.backgroundColor,headline=props.headline,linkText=props.linkText,linkUrl=props.linkUrl,text=props.text;if(!Object(__WEBPACK_IMPORTED_MODULE_8__util_isValidHexColor__["a" /* isValidHexColor */])(props.backgroundColor)||!headline||!text)return false;var isDark=Object(__WEBPACK_IMPORTED_MODULE_8__util_isValidHexColor__["a" /* isValidHexColor */])(props.backgroundColor)?__WEBPACK_IMPORTED_MODULE_2_color___default()(props.backgroundColor).isDark():false;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(InfoBannerRoot,{backgroundColor:backgroundColor},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(InfoBannerHeading,{isDark:isDark},headline),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(InfoBannerText,{isDark:isDark},text),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Conditional__["a" /* Conditional */],{show:!!(linkText&&linkUrl.get('url'))},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(InfoBannerLink,{to:linkUrl.get('url')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(InfoBannerLinkText,{isDark:isDark},linkText))));};var InfoBannerRoot=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject,function(props){return props.backgroundColor;},__WEBPACK_IMPORTED_MODULE_7__styles_helpers_variables__["f" /* size */].medium,__WEBPACK_IMPORTED_MODULE_7__styles_helpers_variables__["f" /* size */].xLarge);var InfoBannerHeading=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].h2(_templateObject2,__WEBPACK_IMPORTED_MODULE_6__styles_helpers_mixins__["e" /* fontFamilyHeading */],Object(__WEBPACK_IMPORTED_MODULE_6__styles_helpers_mixins__["b" /* dynamicFontSize */])(28,44),function(props){return props.isDark?__WEBPACK_IMPORTED_MODULE_7__styles_helpers_variables__["c" /* color */].white:__WEBPACK_IMPORTED_MODULE_7__styles_helpers_variables__["c" /* color */].black;});var InfoBannerText=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].p(_templateObject3,function(props){return props.isDark?__WEBPACK_IMPORTED_MODULE_7__styles_helpers_variables__["c" /* color */].white:__WEBPACK_IMPORTED_MODULE_7__styles_helpers_variables__["c" /* color */].black;},__WEBPACK_IMPORTED_MODULE_7__styles_helpers_variables__["f" /* size */].large);var InfoBannerLink=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["a" /* Link */])(_templateObject4);var InfoBannerLinkText=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_9__styles_blocks_StartPageBlock__["a" /* StartPageBlock */].HeroLinkAsP)(_templateObject5);InfoBanner.defaultProps={backgroundColor:null,headline:null,linkText:null,linkUrl:Object(__WEBPACK_IMPORTED_MODULE_4_immutable__["Map"])(),text:null};InfoBanner.propTypes={backgroundColor:__WEBPACK_IMPORTED_MODULE_5_prop_types__["string"],headline:__WEBPACK_IMPORTED_MODULE_5_prop_types__["string"],linkText:__WEBPACK_IMPORTED_MODULE_5_prop_types__["string"],linkUrl:Object(__WEBPACK_IMPORTED_MODULE_5_prop_types__["instanceOf"])(__WEBPACK_IMPORTED_MODULE_4_immutable__["Map"]),text:__WEBPACK_IMPORTED_MODULE_5_prop_types__["string"]};

/***/ }),
/* 634 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return InformationCards; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_grid_styled__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_grid_styled___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_grid_styled__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_helpers_variables__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_blocks_StartPageBlock__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__InformationCard__ = __webpack_require__(635);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants_endpoints__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__LinedHeading__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Conditional__ = __webpack_require__(26);
var InformationCards=function InformationCards(props){var headline=props.headline,cards=props.cards,py=props.py,mb=props.mb;// if there are no cards, don't render anything, not even the headline
if(cards.isEmpty())return false;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__styles_blocks_StartPageBlock__["a" /* StartPageBlock */].Section,{backgroundColor:__WEBPACK_IMPORTED_MODULE_5__styles_helpers_variables__["c" /* color */].lightGrey,py:py,mb:mb},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__styles_blocks_StartPageBlock__["a" /* StartPageBlock */].Container,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Conditional__["a" /* Conditional */],{show:!!headline},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__LinedHeading__["a" /* default */],{bgColor:__WEBPACK_IMPORTED_MODULE_5__styles_helpers_variables__["c" /* color */].lightGrey},headline)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_styled_components__["ThemeProvider"],{theme:{breakpoints:['500px','730px','800px','1200px']}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grid_styled__["Flex"],{flexWrap:'wrap',mx:['0px','-8px','-11px']},cards.map(function(data,index){// data can be structured differently if it's a normal CMS page or a LinkPage
// therefor we define all our InformationCard props up here to simplify things
var url=data.get('url');var imageSrc=data.getIn(['listImage','url'])||data.getIn(['image','url']);var imageAlt=data.getIn(['listImage','alt'])||data.getIn(['image','alt']);var label=data.get('listText')||data.get('label');var title=data.get('listTitle')||data.get('title');// don't return anything if we are missing important data
if(!imageSrc||!label||!title||!url)return null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grid_styled__["Box"],{key:url,width:[1,1,1,1/3],py:['5px','8px','11px'],px:['0px','8px','11px']},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__InformationCard__["a" /* default */],{url:url,imageSrc:__WEBPACK_IMPORTED_MODULE_8__constants_endpoints__["n" /* SITE_ROOT_URL */]+imageSrc+'?width=900&heightRatio=1&mode=crop',imageAlt:imageAlt,label:label,title:title,lastChild:index===cards.size-1}));})))));};InformationCards.defaultProps={headline:undefined,cards:Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])(),py:0,mb:0};InformationCards.propTypes={headline:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,cards:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"]),py:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,mb:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number};

/***/ }),
/* 635 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_blocks_InformationCardBlock__ = __webpack_require__(636);
var InformationCard=function InformationCard(props){// Only render InformationCard if the correct props are sent
if(!props.url||!props.imageSrc||!props.label||!props.title)return false;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__styles_blocks_InformationCardBlock__["a" /* InformationCardBlock */].Container,{to:props.url,lastChild:props.lastChild},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__styles_blocks_InformationCardBlock__["a" /* InformationCardBlock */].ImageContainer,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__styles_blocks_InformationCardBlock__["a" /* InformationCardBlock */].Image,{src:props.imageSrc,alt:props.imageAlt})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__styles_blocks_InformationCardBlock__["a" /* InformationCardBlock */].Content,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__styles_blocks_InformationCardBlock__["a" /* InformationCardBlock */].Title,null,props.title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__styles_blocks_InformationCardBlock__["a" /* InformationCardBlock */].Label,null,props.label)));};InformationCard.defaultProps={url:null,imageSrc:null,imageAlt:null,label:null,title:null,lastChild:false};InformationCard.propTypes={url:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,imageSrc:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,imageAlt:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,label:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,title:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,lastChild:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (InformationCard);

/***/ }),
/* 636 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return InformationCardBlock; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_variables__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_mixins__ = __webpack_require__(6);
var _templateObject=_taggedTemplateLiteral(['\n  width: 100%;\n  display: flex;\n  text-decoration: none;\n  color: inherit;\n  margin-bottom: 50px;\n  flex-direction: column;\n\n  @media screen and (min-width: ','px) {\n    margin-bottom: 20px;\n  }\n\n  ',';\n'],['\n  width: 100%;\n  display: flex;\n  text-decoration: none;\n  color: inherit;\n  margin-bottom: 50px;\n  flex-direction: column;\n\n  @media screen and (min-width: ','px) {\n    margin-bottom: 20px;\n  }\n\n  ',';\n']),_templateObject2=_taggedTemplateLiteral(['\n      margin-bottom: 0;\n    '],['\n      margin-bottom: 0;\n    ']),_templateObject3=_taggedTemplateLiteral(['\n  flex: 1;\n'],['\n  flex: 1;\n']),_templateObject4=_taggedTemplateLiteral(['\n  position: relative;\n  z-index: 1;\n  margin-right: 0;\n  margin-bottom: 22px;\n  height: 100%;\n  &:after {\n    content: \'\';\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    background-color: rgba(0, 0, 0, 0.2);\n    z-index: 999;\n    opacity: 0;\n    transition: opacity ',' ',';\n  }\n\n  ',':hover & {\n    &:after {\n      opacity: 1;\n    }\n  }\n'],['\n  position: relative;\n  z-index: 1;\n  margin-right: 0;\n  margin-bottom: 22px;\n  height: 100%;\n  &:after {\n    content: \'\';\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    background-color: rgba(0, 0, 0, 0.2);\n    z-index: 999;\n    opacity: 0;\n    transition: opacity ',' ',';\n  }\n\n  ',':hover & {\n    &:after {\n      opacity: 1;\n    }\n  }\n']),_templateObject5=_taggedTemplateLiteral(['\n  display: block;\n  width: 100%;\n  height: auto;\n'],['\n  display: block;\n  width: 100%;\n  height: auto;\n']),_templateObject6=_taggedTemplateLiteral(['\n  font-weight: 600;\n  font-style: normal;\n  font-stretch: normal;\n  line-height: normal;\n  letter-spacing: 0.9px;\n  color: #a7a7a7;\n  text-transform: uppercase;\n  margin: 0;\n  font-size: 12px;\n  text-align: center;\n'],['\n  font-weight: 600;\n  font-style: normal;\n  font-stretch: normal;\n  line-height: normal;\n  letter-spacing: 0.9px;\n  color: #a7a7a7;\n  text-transform: uppercase;\n  margin: 0;\n  font-size: 12px;\n  text-align: center;\n']),_templateObject7=_taggedTemplateLiteral(['\n  ',';\n  ',';\n  font-weight: normal;\n  font-style: normal;\n  font-stretch: normal;\n  line-height: 1.38;\n  letter-spacing: normal;\n  color: ',';\n  text-align: center;\n  margin: 12px 0 0;\n'],['\n  ',';\n  ',';\n  font-weight: normal;\n  font-style: normal;\n  font-stretch: normal;\n  line-height: 1.38;\n  letter-spacing: normal;\n  color: ',';\n  text-align: center;\n  margin: 12px 0 0;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var InformationCardBlock={};InformationCardBlock.Container=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* Link */])(_templateObject,__WEBPACK_IMPORTED_MODULE_2__helpers_variables__["f" /* size */].large,function(props){return props.lastChild&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(_templateObject2);});InformationCardBlock.Content=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].div(_templateObject3);InformationCardBlock.ImageContainer=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].div(_templateObject4,__WEBPACK_IMPORTED_MODULE_2__helpers_variables__["a" /* animation */].transitionTime,__WEBPACK_IMPORTED_MODULE_2__helpers_variables__["a" /* animation */].easing,InformationCardBlock.Container);InformationCardBlock.Image=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].img(_templateObject5);InformationCardBlock.Title=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].p(_templateObject6);InformationCardBlock.Label=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].p(_templateObject7,__WEBPACK_IMPORTED_MODULE_3__helpers_mixins__["e" /* fontFamilyHeading */],Object(__WEBPACK_IMPORTED_MODULE_3__helpers_mixins__["b" /* dynamicFontSize */])(26,30,__WEBPACK_IMPORTED_MODULE_2__helpers_variables__["f" /* size */].small,__WEBPACK_IMPORTED_MODULE_2__helpers_variables__["f" /* size */].xLarge),__WEBPACK_IMPORTED_MODULE_2__helpers_variables__["c" /* color */].black);

/***/ }),
/* 637 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProductVariant; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_mixins__ = __webpack_require__(6);
var _templateObject=_taggedTemplateLiteral(['\n  ',';\n  position: absolute;\n  top: 10px;\n  right: 8px;\n  color: #a7a7a7;\n  text-transform: uppercase;\n  font-weight: 600;\n  letter-spacing: 1.5px;\n\n  @media (min-width: 640px) {\n    top: 11px;\n    right: 11px;\n  }\n'],['\n  ',';\n  position: absolute;\n  top: 10px;\n  right: 8px;\n  color: #a7a7a7;\n  text-transform: uppercase;\n  font-weight: 600;\n  letter-spacing: 1.5px;\n\n  @media (min-width: 640px) {\n    top: 11px;\n    right: 11px;\n  }\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var ProductVariant=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].div(_templateObject,Object(__WEBPACK_IMPORTED_MODULE_1__helpers_mixins__["b" /* dynamicFontSize */])(8,12));

/***/ }),
/* 638 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants_endpoints__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_helpers_mixins__ = __webpack_require__(6);
var _templateObject=_taggedTemplateLiteral(['\n  position: relative;\n  width: 100%;\n  height: 100%;\n  min-height: 300px;\n  background-color: #43636d;\n  background-image: url("','");\n'],['\n  position: relative;\n  width: 100%;\n  height: 100%;\n  min-height: 300px;\n  background-color: #43636d;\n  background-image: url("','");\n']),_templateObject2=_taggedTemplateLiteral(['\n  position: absolute;\n  content: \'\';\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 1;\n  background-color: rgba(0, 0, 0, 0.4);\n  padding: 5%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n'],['\n  position: absolute;\n  content: \'\';\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 1;\n  background-color: rgba(0, 0, 0, 0.4);\n  padding: 5%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n']),_templateObject3=_taggedTemplateLiteral(['\n  ','; \n  ',';\n  text-align: center;\n  margin-top: 0;\n  margin-bottom: 25px;\n  line-height: 1.25;\n  color: #ffffff;\n'],['\n  ','; \n  ',';\n  text-align: center;\n  margin-top: 0;\n  margin-bottom: 25px;\n  line-height: 1.25;\n  color: #ffffff;\n']),_templateObject4=_taggedTemplateLiteral(['\n  ',';\n  ',';\n  font-weight: 600;\n  letter-spacing: 2.5px;\n  text-align: center;\n  color: #ffffff;\n  text-transform: uppercase;\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  text-decoration: none;\n  &:after {\n    content: \'\';\n    display: block;\n    background-image: url(\'/images/icons/arrow-white.svg\');\n    background-size: contain;\n    background-repeat: no-repeat;\n    min-width: 10px;\n    height: 10px;\n    justify-self: flex-end;\n    transform: rotate(-90deg);\n    margin-left: 10px;\n  }\n'],['\n  ',';\n  ',';\n  font-weight: 600;\n  letter-spacing: 2.5px;\n  text-align: center;\n  color: #ffffff;\n  text-transform: uppercase;\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  text-decoration: none;\n  &:after {\n    content: \'\';\n    display: block;\n    background-image: url(\'/images/icons/arrow-white.svg\');\n    background-size: contain;\n    background-repeat: no-repeat;\n    min-width: 10px;\n    height: 10px;\n    justify-self: flex-end;\n    transform: rotate(-90deg);\n    margin-left: 10px;\n  }\n']),_templateObject5=_taggedTemplateLiteral(['\n  display: none;\n  @media screen and (min-width: 1140px) {\n    ',';\n    text-align: center;\n    font-size: 18px;\n    font-style: italic;\n    line-height: 1.56;\n    color: #ffffff;\n    display: block;\n    margin-bottom: 50px;\n  }\n'],['\n  display: none;\n  @media screen and (min-width: 1140px) {\n    ',';\n    text-align: center;\n    font-size: 18px;\n    font-style: italic;\n    line-height: 1.56;\n    color: #ffffff;\n    display: block;\n    margin-bottom: 50px;\n  }\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var ProductSplashCard=function ProductSplashCard(props){if(!props.images||!props.body||!props.title)return false;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ProductSplash,{image:__WEBPACK_IMPORTED_MODULE_4__constants_endpoints__["n" /* SITE_ROOT_URL */]+props.images.getIn(['url'])},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ProductSplashOverlay,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ProductSplashHeading,null,props.title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ProductSplashPreamble,null,props.body),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ProductSplashLink,{href:props.link},'L\xE4s vidare')));};var ProductSplash=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject,function(props){return props.image;});var ProductSplashOverlay=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject2);var ProductSplashHeading=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].p(_templateObject3,__WEBPACK_IMPORTED_MODULE_5__styles_helpers_mixins__["e" /* fontFamilyHeading */],Object(__WEBPACK_IMPORTED_MODULE_5__styles_helpers_mixins__["b" /* dynamicFontSize */])(22,34));var ProductSplashLink=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].a(_templateObject4,__WEBPACK_IMPORTED_MODULE_5__styles_helpers_mixins__["d" /* fontFamilyBody */],Object(__WEBPACK_IMPORTED_MODULE_5__styles_helpers_mixins__["b" /* dynamicFontSize */])(10,13));var ProductSplashPreamble=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].span(_templateObject5,__WEBPACK_IMPORTED_MODULE_5__styles_helpers_mixins__["d" /* fontFamilyBody */]);ProductSplashCard.defaultProps={title:null,body:null,link:null,images:Object(__WEBPACK_IMPORTED_MODULE_3_immutable__["Map"])()};ProductSplashCard.propTypes={title:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,body:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,link:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,images:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.instanceOf(Object(__WEBPACK_IMPORTED_MODULE_3_immutable__["Map"])())};/* harmony default export */ __webpack_exports__["a"] = (ProductSplashCard);

/***/ }),
/* 639 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_dom__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Page__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_DynamicBackgroundContainer__ = __webpack_require__(640);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_helpers_mixins__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_Container__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_helpers_variables__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__store_connect__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__actions_actionCreators__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__styles_Heading__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__styles_Preamble__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__styles_HtmlWrapper__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_BlockquoteWithImages__ = __webpack_require__(641);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_SideMenu__ = __webpack_require__(643);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_ReadMoreAbout__ = __webpack_require__(646);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_ArticleImageBlock__ = __webpack_require__(647);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__constants_endpoints__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__styles_LoadingState__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__ErrorPage__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__NotFoundPage__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__util_isIE__ = __webpack_require__(648);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_Conditional__ = __webpack_require__(26);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  ',';\n  ',';\n  font-weight: normal;\n  line-height: 1.25;\n  position: relative;\n  padding-bottom: 37px;\n  margin: 0;\n\n  &:after {\n    content: \'\';\n    display: block;\n    position: absolute;\n    width: 147px;\n    bottom: 0;\n    left: 0;\n    height: 1px;\n    background: #979797;\n  }\n\n  @media screen and (min-width: ','px) {\n    margin-top: 30px;\n    margin-bottom: 16px;\n  }\n'],['\n  ',';\n  ',';\n  font-weight: normal;\n  line-height: 1.25;\n  position: relative;\n  padding-bottom: 37px;\n  margin: 0;\n\n  &:after {\n    content: \'\';\n    display: block;\n    position: absolute;\n    width: 147px;\n    bottom: 0;\n    left: 0;\n    height: 1px;\n    background: #979797;\n  }\n\n  @media screen and (min-width: ','px) {\n    margin-top: 30px;\n    margin-bottom: 16px;\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  width: max-content;\n  font-size: 12px;\n  font-weight: 600;\n  letter-spacing: 2px;\n  color: #6a6a6a;\n  text-transform: uppercase;\n  text-decoration: none;\n  position: relative;\n  &:after,\n  &:before {\n    content: \'\';\n    display: block;\n    position: absolute;\n    width: 6px;\n    height: 1px;\n    background: #6a6a6a;\n    right: -10px;\n  }\n  &:after {\n    transform: rotate(40deg);\n    top: calc(50% - 2px);\n  }\n  &:before {\n    top: calc(50% + 2px);\n    transform: rotate(-40deg);\n  }\n'],['\n  width: max-content;\n  font-size: 12px;\n  font-weight: 600;\n  letter-spacing: 2px;\n  color: #6a6a6a;\n  text-transform: uppercase;\n  text-decoration: none;\n  position: relative;\n  &:after,\n  &:before {\n    content: \'\';\n    display: block;\n    position: absolute;\n    width: 6px;\n    height: 1px;\n    background: #6a6a6a;\n    right: -10px;\n  }\n  &:after {\n    transform: rotate(40deg);\n    top: calc(50% - 2px);\n  }\n  &:before {\n    top: calc(50% + 2px);\n    transform: rotate(-40deg);\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  ',';\n  font-size: 20px;\n  line-height: 0.8;\n  margin: 0 0 11px;\n'],['\n  ',';\n  font-size: 20px;\n  line-height: 0.8;\n  margin: 0 0 11px;\n']),_templateObject4=_taggedTemplateLiteral(['\n  width: 100%;\n  padding-bottom: 100%;\n  position: relative;\n  margin-bottom: 15px;\n  img {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n  }\n'],['\n  width: 100%;\n  padding-bottom: 100%;\n  position: relative;\n  margin-bottom: 15px;\n  img {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n  }\n']),_templateObject5=_taggedTemplateLiteral(['\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background-image: url("','");\n  background-size: cover;\n  background-position-x: center;\n  background-position-y: center;\n'],['\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background-image: url("','");\n  background-size: cover;\n  background-position-x: center;\n  background-position-y: center;\n']),_templateObject6=_taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  margin: 0 0 40px;\n\n  @media screen and (min-width: ','px) {\n    width: calc(100% / 2 - 24px);\n    &:nth-child(3) {\n      width: 100%;\n      margin: 0 0 50px;\n      ',' {\n        padding-bottom: calc((268 / 559) * 100%);\n      }\n    }\n  }\n\n  @media screen and (min-width: ','px) {\n    margin: 0 14px 50px;\n    width: calc(100% / 4 - 28px);\n    &:nth-child(3) {\n      width: calc(100% / 2 - 28px);\n      margin: 0 14px 50px;\n      ',' {\n        padding-bottom: calc((268 / 559) * 100%);\n      }\n    }\n  }\n'],['\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  margin: 0 0 40px;\n\n  @media screen and (min-width: ','px) {\n    width: calc(100% / 2 - 24px);\n    &:nth-child(3) {\n      width: 100%;\n      margin: 0 0 50px;\n      ',' {\n        padding-bottom: calc((268 / 559) * 100%);\n      }\n    }\n  }\n\n  @media screen and (min-width: ','px) {\n    margin: 0 14px 50px;\n    width: calc(100% / 4 - 28px);\n    &:nth-child(3) {\n      width: calc(100% / 2 - 28px);\n      margin: 0 14px 50px;\n      ',' {\n        padding-bottom: calc((268 / 559) * 100%);\n      }\n    }\n  }\n']),_templateObject7=_taggedTemplateLiteral(['\n  list-style: none;\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  margin: 0;\n  padding: 0;\n  width: auto;\n\n  &::after {\n    content: \'\';\n    flex: auto;\n  }\n\n  @media screen and (min-width: ','px) {\n    padding: 0 0 60px;\n    margin: 0 -14px;\n  }\n'],['\n  list-style: none;\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  margin: 0;\n  padding: 0;\n  width: auto;\n\n  &::after {\n    content: \'\';\n    flex: auto;\n  }\n\n  @media screen and (min-width: ','px) {\n    padding: 0 0 60px;\n    margin: 0 -14px;\n  }\n']),_templateObject8=_taggedTemplateLiteral(['\n  width: 100%;\n'],['\n  width: 100%;\n']),_templateObject9=_taggedTemplateLiteral(['\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  @media screen and (min-width: ','px) {\n    align-items: baseline;\n    margin-bottom: 40px;\n  }\n  > div {\n    width: 100%;\n    text-align: left;\n    @media screen and (min-width: ','px) {\n      width: 50%;\n    }\n    &:first-child {\n      border-right: none;\n      border-bottom: 1px solid ',';\n      @media screen and (min-width: ','px) {\n        border-right: 1px solid ',';\n        border-bottom: none;\n      }\n    }\n  }\n  @media screen and (min-width: ','px) {\n    flex-direction: row;\n  }\n'],['\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  @media screen and (min-width: ','px) {\n    align-items: baseline;\n    margin-bottom: 40px;\n  }\n  > div {\n    width: 100%;\n    text-align: left;\n    @media screen and (min-width: ','px) {\n      width: 50%;\n    }\n    &:first-child {\n      border-right: none;\n      border-bottom: 1px solid ',';\n      @media screen and (min-width: ','px) {\n        border-right: 1px solid ',';\n        border-bottom: none;\n      }\n    }\n  }\n  @media screen and (min-width: ','px) {\n    flex-direction: row;\n  }\n']),_templateObject10=_taggedTemplateLiteral(['\n  width: 100%;\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  flex-direction: column-reverse;\n\n  @media screen and (min-width: ','px) {\n    width: 1020px;\n    flex-direction: row;\n    padding-left: 120px;\n    justify-content: space-between;\n  }\n  @media screen and (min-width: ','px) {\n    position: relative;\n    width: 820px;\n    padding-left: 80px !important;\n  }\n'],['\n  width: 100%;\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  flex-direction: column-reverse;\n\n  @media screen and (min-width: ','px) {\n    width: 1020px;\n    flex-direction: row;\n    padding-left: 120px;\n    justify-content: space-between;\n  }\n  @media screen and (min-width: ','px) {\n    position: relative;\n    width: 820px;\n    padding-left: 80px !important;\n  }\n']),_templateObject11=_taggedTemplateLiteral(['\n  ',';\n'],['\n  ',';\n']),_templateObject12=_taggedTemplateLiteral(['\n  ',';\n  margin-bottom: 1.5em !important;\n'],['\n  ',';\n  margin-bottom: 1.5em !important;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ArticlePage=function(_Component){_inherits(ArticlePage,_Component);function ArticlePage(props){_classCallCheck(this,ArticlePage);var _this=_possibleConstructorReturn(this,(ArticlePage.__proto__||Object.getPrototypeOf(ArticlePage)).call(this,props));_this.state={currentBackgroundColor:null};_this.componentScrollHandler=_this.componentScrollHandler.bind(_this);return _this;}_createClass(ArticlePage,[{key:'componentWillMount',value:function componentWillMount(){window.addEventListener('scroll',this.componentScrollHandler);if(this.props.location.pathname.includes(String(document.getElementById('react_root').dataset.litiumPreview))&&document.getElementById('react_root').dataset.litiumPreviewId){this.props.fetchArticlePageView({id:document.getElementById('react_root').dataset.litiumPreviewId,url:document.getElementById('react_root').dataset.litiumPreview,workingCopy:document.getElementById('react_root').dataset.litiumPreview.toString().includes(this.props.location.pathname)});}else{this.props.fetchArticlePageView({urlPath:this.props.location.pathname});}}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){// call action fetchArticlePageView if component updated with a new this.props.location.pathname
if(!prevProps.location.pathname||this.props.location.pathname!==prevProps.location.pathname){if(this.props.location.pathname.includes(String(document.getElementById('react_root').dataset.litiumPreview))&&document.getElementById('react_root').dataset.litiumPreviewId){this.props.fetchArticlePageView({id:document.getElementById('react_root').dataset.litiumPreviewId,url:document.getElementById('react_root').dataset.litiumPreview,workingCopy:document.getElementById('react_root').dataset.litiumPreview.toString().includes(this.props.location.pathname)});}else{this.props.fetchArticlePageView({urlPath:this.props.location.pathname});}}}},{key:'componentWillUnmount',value:function componentWillUnmount(){window.removeEventListener('scroll',this.componentScrollHandler);}},{key:'componentScrollHandler',value:function componentScrollHandler(){var currentPage=this.props.currentPage;var currentPageFields=currentPage.get('fields',Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])());// if quoteSection top and bottom is between the page center, change the background color of the page
if(this.quoteSection&&this.quoteSection.getBoundingClientRect().top<window.innerHeight/2&&this.quoteSection.getBoundingClientRect().bottom>=window.innerHeight/2){this.setState({currentBackgroundColor:currentPageFields.get('imageQuoteColor')});}else if(this.imageSection&&this.imageSection.getBoundingClientRect().top<window.innerHeight/2&&this.imageSection.getBoundingClientRect().bottom>=window.innerHeight/2){// else if imageSection top and bottom is between the page center, change the background color of the page
this.setState({currentBackgroundColor:currentPageFields.get('imageSectionColor')});}else if(this.employeeSection&&this.employeeSection.getBoundingClientRect().top<window.innerHeight/2&&this.employeeSection.getBoundingClientRect().bottom>=window.innerHeight/2){// else if employeeSection top and bottom is between the page center, change the background color of the page
this.setState({currentBackgroundColor:currentPageFields.get('backgroundColor')});}else{// else set the background color to default
this.setState({currentBackgroundColor:null});}}},{key:'render',value:function render(){var _this2=this;var _props=this.props,currentPage=_props.currentPage,request=_props.request;if(request.get('statusCode')===404)return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__NotFoundPage__["a" /* default */],null);if(request.get('status')==='ERROR')return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__ErrorPage__["a" /* default */],null);var currentPageFields=currentPage.get('fields',Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])());var employees=currentPage.get('children',Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["List"])());var topBody=function topBody(){return{__html:currentPageFields.get('text1')||currentPageFields.get('text')};};var bottomBody=function bottomBody(){return{__html:currentPageFields.get('text2')};};if(request.get('status')==='LOADING'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Page__["a" /* default */],{meta:currentPage.get('metaData'),bgColor:__WEBPACK_IMPORTED_MODULE_9__styles_helpers_variables__["c" /* color */].white,loadingState:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TopArticleContainer,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MainContent,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__styles_LoadingState__["b" /* LoadingHeading */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__styles_LoadingState__["c" /* LoadingPreamble */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__styles_LoadingState__["a" /* LoadingBody */],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__components_SideMenu__["a" /* default */],null)));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_DynamicBackgroundContainer__["a" /* default */],{staticColor:__WEBPACK_IMPORTED_MODULE_9__styles_helpers_variables__["c" /* color */].white,dynamicColor:this.state.currentBackgroundColor,active:!!this.state.currentBackgroundColor},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Page__["a" /* default */],{meta:currentPage.get('metaData')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TopArticleContainer,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MainContent,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ArticleHeader,{textAlign:this.props.pageWidth>=__WEBPACK_IMPORTED_MODULE_9__styles_helpers_variables__["f" /* size */].large?'left':'center'},currentPageFields.get('title')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ArticlePreamble,{textAlign:this.props.pageWidth>=__WEBPACK_IMPORTED_MODULE_9__styles_helpers_variables__["f" /* size */].large?'left':'center'},currentPageFields.get('introduction')||currentPageFields.get('preamble')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__styles_HtmlWrapper__["a" /* HtmlWrapper */],{dangerouslySetInnerHTML:topBody()})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__components_SideMenu__["a" /* default */],null)),currentPageFields.get('imageQuoteText')?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{ref:function ref(_ref){_this2.quoteSection=_ref;}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_BlockquoteWithImages__["a" /* default */],{leftImage:__WEBPACK_IMPORTED_MODULE_19__constants_endpoints__["n" /* SITE_ROOT_URL */]+currentPageFields.getIn(['imageQuoteLeftImage','url']),rightImage:__WEBPACK_IMPORTED_MODULE_19__constants_endpoints__["n" /* SITE_ROOT_URL */]+currentPageFields.getIn(['imageQuoteRightImage','url']),quote:currentPageFields.get('imageQuoteText'),paddedBottom:true})):false,currentPageFields.get('text2')?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TopArticleContainer,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__styles_HtmlWrapper__["a" /* HtmlWrapper */],{dangerouslySetInnerHTML:bottomBody()})):false,currentPageFields.getIn(['imageSectionLeftImage','url'])||currentPageFields.getIn(['imageSectionRightImage','url'])?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{ref:function ref(_ref2){_this2.imageSection=_ref2;}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__components_ArticleImageBlock__["a" /* default */],{leftImage:__WEBPACK_IMPORTED_MODULE_19__constants_endpoints__["n" /* SITE_ROOT_URL */]+currentPageFields.getIn(['imageSectionLeftImage','url']),rightImage:__WEBPACK_IMPORTED_MODULE_19__constants_endpoints__["n" /* SITE_ROOT_URL */]+currentPageFields.getIn(['imageSectionRightImage','url'])})):false,!employees.isEmpty()?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{ref:function ref(_ref3){_this2.employeeSection=_ref3;}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TopArticleContainer,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(EmployeeHeading,null,currentPageFields.get('subTitle'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__styles_Container__["a" /* Container */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(EmployeesList,null,employees.map(function(employee){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(EmployeeListItem,{key:employee.get('id')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(EmployeeImage,null,__WEBPACK_IMPORTED_MODULE_23__util_isIE__["a" /* isIE */]?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(EmployeeImageBackground,{imageUrl:__WEBPACK_IMPORTED_MODULE_19__constants_endpoints__["n" /* SITE_ROOT_URL */]+employee.getIn(['fields','image','url'])}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_19__constants_endpoints__["n" /* SITE_ROOT_URL */]+employee.getIn(['fields','image','url']),alt:employee.getIn(['fields','image','alt'])})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(EmployeeName,null,employee.getIn(['fields','name'])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__components_Conditional__["a" /* Conditional */],{show:!!employee.getIn(['fields','productLink'])},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(EmployeeLink,{to:employee.getIn(['fields','productLink'])},employee.getIn(['fields','productLinkText']))));})))):false,currentPageFields.getIn(['readMoreLink1','name'])&&currentPageFields.getIn(['readMoreLink1','name'])?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__styles_Container__["a" /* Container */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ReadMoreContainer,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__components_ReadMoreAbout__["a" /* default */],{pos:'left',pageTitle:currentPageFields.getIn(['readMoreLink1','name']),pageUrl:currentPageFields.getIn(['readMoreLink1','url'])}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__components_ReadMoreAbout__["a" /* default */],{pos:'right',pageTitle:currentPageFields.getIn(['readMoreLink2','name']),pageUrl:currentPageFields.getIn(['readMoreLink2','url'])}))):false));}}]);return ArticlePage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var EmployeeHeading=__WEBPACK_IMPORTED_MODULE_3_styled_components__["default"].h3(_templateObject,__WEBPACK_IMPORTED_MODULE_7__styles_helpers_mixins__["e" /* fontFamilyHeading */],Object(__WEBPACK_IMPORTED_MODULE_7__styles_helpers_mixins__["b" /* dynamicFontSize */])(26,32),__WEBPACK_IMPORTED_MODULE_9__styles_helpers_variables__["f" /* size */].large);var EmployeeLink=Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["a" /* Link */])(_templateObject2);var EmployeeName=__WEBPACK_IMPORTED_MODULE_3_styled_components__["default"].p(_templateObject3,__WEBPACK_IMPORTED_MODULE_7__styles_helpers_mixins__["e" /* fontFamilyHeading */]);var EmployeeImage=__WEBPACK_IMPORTED_MODULE_3_styled_components__["default"].div(_templateObject4);var EmployeeImageBackground=__WEBPACK_IMPORTED_MODULE_3_styled_components__["default"].div(_templateObject5,function(props){return props.imageUrl;});var EmployeeListItem=__WEBPACK_IMPORTED_MODULE_3_styled_components__["default"].li(_templateObject6,__WEBPACK_IMPORTED_MODULE_9__styles_helpers_variables__["f" /* size */].medium,EmployeeImage,__WEBPACK_IMPORTED_MODULE_9__styles_helpers_variables__["f" /* size */].xXLarge,EmployeeImage);var EmployeesList=__WEBPACK_IMPORTED_MODULE_3_styled_components__["default"].ul(_templateObject7,__WEBPACK_IMPORTED_MODULE_9__styles_helpers_variables__["f" /* size */].medium);var MainContent=__WEBPACK_IMPORTED_MODULE_3_styled_components__["default"].div(_templateObject8);var ReadMoreContainer=__WEBPACK_IMPORTED_MODULE_3_styled_components__["default"].div(_templateObject9,__WEBPACK_IMPORTED_MODULE_9__styles_helpers_variables__["f" /* size */].medium,__WEBPACK_IMPORTED_MODULE_9__styles_helpers_variables__["f" /* size */].medium,__WEBPACK_IMPORTED_MODULE_9__styles_helpers_variables__["c" /* color */].darkgrey,__WEBPACK_IMPORTED_MODULE_9__styles_helpers_variables__["f" /* size */].medium,__WEBPACK_IMPORTED_MODULE_9__styles_helpers_variables__["c" /* color */].darkgrey,__WEBPACK_IMPORTED_MODULE_9__styles_helpers_variables__["f" /* size */].medium);var TopArticleContainer=__WEBPACK_IMPORTED_MODULE_8__styles_Container__["a" /* Container */].extend(_templateObject10,__WEBPACK_IMPORTED_MODULE_9__styles_helpers_variables__["f" /* size */].xLarge,__WEBPACK_IMPORTED_MODULE_9__styles_helpers_variables__["f" /* size */].articleSideMenuBreakPoint);var ArticleHeader=__WEBPACK_IMPORTED_MODULE_12__styles_Heading__["a" /* Heading */].h1.extend(_templateObject11,Object(__WEBPACK_IMPORTED_MODULE_7__styles_helpers_mixins__["b" /* dynamicFontSize */])(40,60));var ArticlePreamble=__WEBPACK_IMPORTED_MODULE_13__styles_Preamble__["a" /* Preamble */].extend(_templateObject12,Object(__WEBPACK_IMPORTED_MODULE_7__styles_helpers_mixins__["b" /* dynamicFontSize */])(18,20,__WEBPACK_IMPORTED_MODULE_9__styles_helpers_variables__["f" /* size */].small,__WEBPACK_IMPORTED_MODULE_9__styles_helpers_variables__["f" /* size */].medium));ArticlePage.defaultProps={currentPage:Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])(),pageWidth:1024,request:Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])()};ArticlePage.propTypes={currentPage:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"]),request:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"]),fetchArticlePageView:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,pageWidth:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,location:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_10__store_connect__["a" /* default */])(ArticlePage,{fetchArticlePageView:__WEBPACK_IMPORTED_MODULE_11__actions_actionCreators__["g" /* fetchArticlePageView */]},function(store,props){return{pageWidth:store.viewstate.get('pageWidth'),request:store.page.request.get(props.location.pathname),currentPage:store.page.data.get(props.location.pathname)};}));

/***/ }),
/* 640 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_transition_group__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_transition_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_transition_group__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_helpers_animations__ = __webpack_require__(81);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  position: relative;\n  background-color: ',';\n'],['\n  position: relative;\n  background-color: ',';\n']),_templateObject2=_taggedTemplateLiteral(['\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  transition: opacity 400ms linear;\n  opacity: ',';\n  \n  ','\n  \n  ','\n  \n  ','\n'],['\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  transition: opacity 400ms linear;\n  opacity: ',';\n  \n  ','\n  \n  ','\n  \n  ','\n']),_templateObject3=_taggedTemplateLiteral(['\n      background-color: ',';\n    '],['\n      background-color: ',';\n    ']),_templateObject4=_taggedTemplateLiteral(['\n      background: linear-gradient(\n        135deg,\n        ',' 0%,\n        ',' 100%\n      );\n    '],['\n      background: linear-gradient(\n        135deg,\n        ',' 0%,\n        ',' 100%\n      );\n    ']),_templateObject5=_taggedTemplateLiteral(['\n      background: linear-gradient(\n        135deg,\n        ',' 0%,\n        ',' 50%,\n        ',' 100%\n      );\n    '],['\n      background: linear-gradient(\n        135deg,\n        ',' 0%,\n        ',' 50%,\n        ',' 100%\n      );\n    ']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DynamicBackgroundContainer=function(_Component){_inherits(DynamicBackgroundContainer,_Component);function DynamicBackgroundContainer(props){_classCallCheck(this,DynamicBackgroundContainer);var _this=_possibleConstructorReturn(this,(DynamicBackgroundContainer.__proto__||Object.getPrototypeOf(DynamicBackgroundContainer)).call(this,props));_this.state={backgroundLayers:[_this.props.dynamicColor]};_this.renderBackgroundLayers=_this.renderBackgroundLayers.bind(_this);return _this;}_createClass(DynamicBackgroundContainer,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(this.props.dynamicColor!==nextProps.dynamicColor){this.addBackgroundLayer(nextProps.dynamicColor);}}},{key:'addBackgroundLayer',value:function addBackgroundLayer(color){this.setState({backgroundLayers:[color]});}},{key:'renderBackgroundLayers',value:function renderBackgroundLayers(){var _this2=this;return this.state.backgroundLayers.map(function(item){if(Array.isArray(item)){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles_helpers_animations__["a" /* DynamicBackgroundFade */],{key:item},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DynamicBackground,{active:_this2.props.active,backgroundGradient:item,opacity:_this2.props.opacity}));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles_helpers_animations__["a" /* DynamicBackgroundFade */],{key:item},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DynamicBackground,{active:_this2.props.active,backgroundColor:item,opacity:_this2.props.opacity}));});}},{key:'render',value:function render(){var backgroundLayers=this.renderBackgroundLayers();return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(RootContainer,{backgroundColor:this.props.staticColor},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_transition_group__["TransitionGroup"],null,backgroundLayers),this.props.children);}}]);return DynamicBackgroundContainer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var RootContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject,function(props){return props.backgroundColor;});var DynamicBackground=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject2,function(props){return props.active?1:0;},function(props){return props.backgroundColor&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject3,''+props.backgroundColor+(props.opacity?props.opacity:''));},function(props){return Array.isArray(props.backgroundGradient)&&props.backgroundGradient.length===2&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject4,props.backgroundGradient[0]+'55',props.backgroundGradient[1]+'55');},function(props){return Array.isArray(props.backgroundGradient)&&props.backgroundGradient.length>=3&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject5,props.backgroundGradient[0]+'55',props.backgroundGradient[1]+'55',props.backgroundGradient[2]+'55');});DynamicBackgroundContainer.defaultProps={staticColor:null,dynamicColor:null,active:false,opacity:null};DynamicBackgroundContainer.propTypes={staticColor:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,dynamicColor:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array]),active:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,opacity:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,children:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node),__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node]).isRequired};/* harmony default export */ __webpack_exports__["a"] = (DynamicBackgroundContainer);

/***/ }),
/* 641 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_connect__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_FullWidthContainer__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_Quote__ = __webpack_require__(642);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_Container__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_helpers_variables__ = __webpack_require__(4);
var _templateObject=_taggedTemplateLiteral(['\n  margin-top: 40px;\n  margin-bottom: 40px;\n\n  @media screen and (min-width: ','px) {\n    margin-top: 80px;\n    margin-bottom: 60px;\n  }\n  ',';\n'],['\n  margin-top: 40px;\n  margin-bottom: 40px;\n\n  @media screen and (min-width: ','px) {\n    margin-top: 80px;\n    margin-bottom: 60px;\n  }\n  ',';\n']),_templateObject2=_taggedTemplateLiteral(['\n      margin-bottom: 0 !important;\n      padding-bottom: 40px;\n      @media screen and (min-width: ','px) {\n        padding-bottom: 60px;\n      }\n    '],['\n      margin-bottom: 0 !important;\n      padding-bottom: 40px;\n      @media screen and (min-width: ','px) {\n        padding-bottom: 60px;\n      }\n    ']),_templateObject3=_taggedTemplateLiteral(['\n  @media screen and (min-width: ','px) {\n    width: 820px;\n  }\n'],['\n  @media screen and (min-width: ','px) {\n    width: 820px;\n  }\n']),_templateObject4=_taggedTemplateLiteral(['\n  max-width: 100%;\n  height: auto;\n  margin: 10px 0;\n'],['\n  max-width: 100%;\n  height: auto;\n  margin: 10px 0;\n']),_templateObject5=_taggedTemplateLiteral(['\n  display: flex;\n  max-width: 100%;\n  align-items: stretch;\n  justify-content: space-between;\n'],['\n  display: flex;\n  max-width: 100%;\n  align-items: stretch;\n  justify-content: space-between;\n']),_templateObject6=_taggedTemplateLiteral(['\n  height: auto;\n  flex: 5;\n\n  &:last-of-type {\n    flex: 3;\n    margin-left: 26px;\n  }\n'],['\n  height: auto;\n  flex: 5;\n\n  &:last-of-type {\n    flex: 3;\n    margin-left: 26px;\n  }\n']),_templateObject7=_taggedTemplateLiteral(['\n  width: 100%;\n  height: 100%;\n  background-image: url("','");\n  background-size: cover;\n  background-position: center;\n\n  ',';\n'],['\n  width: 100%;\n  height: 100%;\n  background-image: url("','");\n  background-size: cover;\n  background-position: center;\n\n  ',';\n']),_templateObject8=_taggedTemplateLiteral(['\n      height: 0;\n      padding-bottom: 100%;\n    '],['\n      height: 0;\n      padding-bottom: 100%;\n    ']),_templateObject9=_taggedTemplateLiteral(['\n  margin-bottom: 0;\n'],['\n  margin-bottom: 0;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var BlockquoteWithImages=function BlockquoteWithImages(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(BlockquoteWithImagesContainer,{paddedBottom:props.paddedBottom},props.viewstate.get('pageWidth')<__WEBPACK_IMPORTED_MODULE_8__styles_helpers_variables__["f" /* size */].medium?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__styles_Container__["a" /* Container */],{noPadding:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ArticleImageAsImg,{src:props.leftImage}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ArticleImageAsImg,{src:props.rightImage})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__styles_Container__["a" /* Container */],{noPadding:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ImageContainer,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ArticleImageContainer,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ArticleImage,{url:props.leftImage})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ArticleImageContainer,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ArticleImage,{square:true,url:props.rightImage})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ArticleContainer,{noPadding:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(BlockQoute,null,props.quote)));};var BlockquoteWithImagesContainer=__WEBPACK_IMPORTED_MODULE_5__styles_FullWidthContainer__["a" /* FullWidthContainer */].extend(_templateObject,__WEBPACK_IMPORTED_MODULE_8__styles_helpers_variables__["f" /* size */].medium,function(props){return props.paddedBottom&&Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["css"])(_templateObject2,__WEBPACK_IMPORTED_MODULE_8__styles_helpers_variables__["f" /* size */].medium);});var ArticleContainer=__WEBPACK_IMPORTED_MODULE_7__styles_Container__["a" /* Container */].extend(_templateObject3,__WEBPACK_IMPORTED_MODULE_8__styles_helpers_variables__["f" /* size */].large);var ArticleImageAsImg=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].img(_templateObject4);var ImageContainer=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].div(_templateObject5);var ArticleImageContainer=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].div(_templateObject6);var ArticleImage=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].div(_templateObject7,function(props){return props.url;},function(props){return props.square&&Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["css"])(_templateObject8);});var BlockQoute=__WEBPACK_IMPORTED_MODULE_6__styles_Quote__["a" /* Quote */].extend(_templateObject9);BlockquoteWithImages.defaultProps={leftImage:null,rightImage:null,viewstate:Object(__WEBPACK_IMPORTED_MODULE_3_immutable__["Map"])(),paddedBottom:false};BlockquoteWithImages.propTypes={quote:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,leftImage:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,rightImage:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,viewstate:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_3_immutable__["Map"]),paddedBottom:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4__store_connect__["a" /* default */])(BlockquoteWithImages,{},function(store){return{viewstate:store.viewstate};}));

/***/ }),
/* 642 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Quote; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_mixins__ = __webpack_require__(6);
var _templateObject=_taggedTemplateLiteral(['\n  ',';\n  ',';\n  margin: 2em 0;\n  font-weight: normal;\n  font-style: normal;\n  font-stretch: normal;\n  line-height: 1.44;\n  letter-spacing: normal;\n  text-align: left;\n  color: #000000;\n\n  &:after {\n    content: \'\';\n    display: block;\n    margin-top: 40px;\n    height: 1px;\n    width: 150px;\n    background-color: #979797;\n  }\n'],['\n  ',';\n  ',';\n  margin: 2em 0;\n  font-weight: normal;\n  font-style: normal;\n  font-stretch: normal;\n  line-height: 1.44;\n  letter-spacing: normal;\n  text-align: left;\n  color: #000000;\n\n  &:after {\n    content: \'\';\n    display: block;\n    margin-top: 40px;\n    height: 1px;\n    width: 150px;\n    background-color: #979797;\n  }\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Quote=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].blockquote(_templateObject,__WEBPACK_IMPORTED_MODULE_1__helpers_mixins__["e" /* fontFamilyHeading */],Object(__WEBPACK_IMPORTED_MODULE_1__helpers_mixins__["b" /* dynamicFontSize */])(22,32));

/***/ }),
/* 643 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_animate_height__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_animate_height___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_animate_height__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_helpers_variables__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_helpers_mixins__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__store_connect__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_CustomSelect__ = __webpack_require__(645);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  margin-top: 0;\n  margin-bottom: 5px;\n'],['\n  margin-top: 0;\n  margin-bottom: 5px;\n']),_templateObject2=_taggedTemplateLiteral(['\n  color: ',';\n  text-decoration: none;\n  padding: 2px 0;\n  margin-bottom: 14px;\n  text-transform: uppercase;\n  font-size: 13px;\n  font-weight: 600;\n  letter-spacing: 1.5px;\n  text-align: left;\n  padding-left: 0;\n  margin-left: 15px;\n  white-space: nowrap;\n  transition: opacity 250ms ease-out;\n\n  &:hover {\n    opacity: 0.8;\n  }\n  ',' &:before {\n    opacity: 0;\n    transition: opacity ',' ',';\n  }\n  ',';\n'],['\n  color: ',';\n  text-decoration: none;\n  padding: 2px 0;\n  margin-bottom: 14px;\n  text-transform: uppercase;\n  font-size: 13px;\n  font-weight: 600;\n  letter-spacing: 1.5px;\n  text-align: left;\n  padding-left: 0;\n  margin-left: 15px;\n  white-space: nowrap;\n  transition: opacity 250ms ease-out;\n\n  &:hover {\n    opacity: 0.8;\n  }\n  ',' &:before {\n    opacity: 0;\n    transition: opacity ',' ',';\n  }\n  ',';\n']),_templateObject3=_taggedTemplateLiteral(['\n      &:before {\n        opacity: 1;\n      }\n    '],['\n      &:before {\n        opacity: 1;\n      }\n    ']),_templateObject4=_taggedTemplateLiteral(['\n  color: ',';\n  text-decoration: none;\n  padding: 2px 0;\n  white-space: nowrap;\n  transition: opacity 250ms ease-out;\n  &:hover {\n    opacity: 0.8;\n  }\n  ',' &:before {\n    opacity: 0;\n    transition: opacity ',' ',';\n  }\n  ',';\n'],['\n  color: ',';\n  text-decoration: none;\n  padding: 2px 0;\n  white-space: nowrap;\n  transition: opacity 250ms ease-out;\n  &:hover {\n    opacity: 0.8;\n  }\n  ',' &:before {\n    opacity: 0;\n    transition: opacity ',' ',';\n  }\n  ',';\n']),_templateObject5=_taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: column;\n  list-style: none;\n  padding-left: 15px;\n  margin: 10px 0 5px;\n  color: ',';\n\n  li {\n    margin-bottom: 5px;\n    text-align: left;\n    padding: 0;\n    font-size: 13px;\n    line-height: 2;\n    color: ',';\n    padding-left: 30px;\n  }\n'],['\n  display: flex;\n  flex-direction: column;\n  list-style: none;\n  padding-left: 15px;\n  margin: 10px 0 5px;\n  color: ',';\n\n  li {\n    margin-bottom: 5px;\n    text-align: left;\n    padding: 0;\n    font-size: 13px;\n    line-height: 2;\n    color: ',';\n    padding-left: 30px;\n  }\n']),_templateObject6=_taggedTemplateLiteral(['\n  border-top: 1px solid grey;\n  padding-top: 10px;\n  width: 100%;\n  margin: 0 auto;\n  @media screen and (min-width: ','px) {\n    width: 400px;\n    margin-left: 60px;\n    margin-top: 20px;\n    border: none;\n    padding-top: 0;\n  }\n  @media screen and (min-width: ','px) {\n    width: 230px;\n    margin: 0 -250px 0 0;\n  }\n  @media screen and (min-width: ','px) {\n    margin: 0 -280px 0 0;\n  }\n'],['\n  border-top: 1px solid grey;\n  padding-top: 10px;\n  width: 100%;\n  margin: 0 auto;\n  @media screen and (min-width: ','px) {\n    width: 400px;\n    margin-left: 60px;\n    margin-top: 20px;\n    border: none;\n    padding-top: 0;\n  }\n  @media screen and (min-width: ','px) {\n    width: 230px;\n    margin: 0 -250px 0 0;\n  }\n  @media screen and (min-width: ','px) {\n    margin: 0 -280px 0 0;\n  }\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SideMenu=function(_Component){_inherits(SideMenu,_Component);function SideMenu(props){_classCallCheck(this,SideMenu);var _this=_possibleConstructorReturn(this,(SideMenu.__proto__||Object.getPrototypeOf(SideMenu)).call(this,props));_this.state={active:false};_this.setActive=_this.setActive.bind(_this);return _this;}_createClass(SideMenu,[{key:'setActive',value:function setActive(){this.setState({active:!this.state.active});}},{key:'desktopLinkListRender',value:function desktopLinkListRender(isMobile){var _this2=this;return this.props.footerMenu.map(function(item,index){var siteInFooter=_this2.props.location.pathname.indexOf(item.get('url'))!==-1;var isSelected=_this2.props.location.pathname===item.get('url');return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(HeadingParagraph,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SideDetailLink,{selected:isSelected,to:item.get('url')},item.get('title'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SideLinks,null,!isMobile?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_animate_height___default.a,{className:'animation',duration:400,easing:'ease-out',height:siteInFooter?'auto':0},_this2.renderChildLinks(item)):_this2.renderChildLinks(item)));}).toArray();}},{key:'renderChildLinks',value:function renderChildLinks(item){var _this3=this;return item.get('children').map(function(child,childIndex){var isChildSelected=_this3.props.location.pathname===child.get('url');return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:childIndex},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SideDetailChildLink,{selected:isChildSelected,to:child.get('url')},child.get('title')));});}},{key:'render',value:function render(){var _this4=this;// check if page is part of footermenu
var siteInFooter=!!this.props.footerMenu.filter(function(item){return _this4.props.location.pathname.indexOf(item.get('url'))!==-1;}).size;if(!siteInFooter){return false;}var viewstate=this.props.viewstate;var isMobile=viewstate.get('pageWidth')<__WEBPACK_IMPORTED_MODULE_6__styles_helpers_variables__["f" /* size */].xLarge;var footerDataMobile=this.desktopLinkListRender(true);var footerDataDesktop=this.desktopLinkListRender(false);if(isMobile){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_CustomSelect__["a" /* default */],{title:this.props.currentPage.getIn(['fields','title'])},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SideMenuContainer,null,footerDataMobile));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SideMenuContainer,null,footerDataDesktop);}}]);return SideMenu;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var HeadingParagraph=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].p(_templateObject);var SideDetailLink=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* Link */])(_templateObject2,__WEBPACK_IMPORTED_MODULE_6__styles_helpers_variables__["c" /* color */].black,Object(__WEBPACK_IMPORTED_MODULE_7__styles_helpers_mixins__["h" /* selectedBackground */])(),__WEBPACK_IMPORTED_MODULE_6__styles_helpers_variables__["a" /* animation */].transitionTime,__WEBPACK_IMPORTED_MODULE_6__styles_helpers_variables__["a" /* animation */].easing,function(props){return props.selected&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject3);});var SideDetailChildLink=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* Link */])(_templateObject4,__WEBPACK_IMPORTED_MODULE_6__styles_helpers_variables__["c" /* color */].black,Object(__WEBPACK_IMPORTED_MODULE_7__styles_helpers_mixins__["h" /* selectedBackground */])(),__WEBPACK_IMPORTED_MODULE_6__styles_helpers_variables__["a" /* animation */].transitionTime,__WEBPACK_IMPORTED_MODULE_6__styles_helpers_variables__["a" /* animation */].easing,function(props){return props.selected&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject3);});var SideLinks=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].ul(_templateObject5,__WEBPACK_IMPORTED_MODULE_6__styles_helpers_variables__["c" /* color */].white,__WEBPACK_IMPORTED_MODULE_6__styles_helpers_variables__["c" /* color */].black);var SideMenuContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject6,__WEBPACK_IMPORTED_MODULE_6__styles_helpers_variables__["f" /* size */].xLarge,__WEBPACK_IMPORTED_MODULE_6__styles_helpers_variables__["f" /* size */].articleSideMenuBreakPoint,__WEBPACK_IMPORTED_MODULE_6__styles_helpers_variables__["f" /* size */].articleSideMenuWideBreakPoint);SideMenu.defaultProps={viewstate:Object(__WEBPACK_IMPORTED_MODULE_3_immutable__["Map"])(),footerMenu:Object(__WEBPACK_IMPORTED_MODULE_3_immutable__["List"])(),currentPage:Object(__WEBPACK_IMPORTED_MODULE_3_immutable__["Map"])()};SideMenu.propTypes={location:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object.isRequired,viewstate:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_3_immutable__["Map"]),footerMenu:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_3_immutable__["List"]),currentPage:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_3_immutable__["Map"])};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8__store_connect__["a" /* default */])(SideMenu,{},function(store,props){return{viewstate:store.viewstate,currentPage:store.page.data.get(props.location.pathname,Object(__WEBPACK_IMPORTED_MODULE_3_immutable__["Map"])()),footerMenu:Object(__WEBPACK_IMPORTED_MODULE_3_immutable__["fromJS"])((window.startup||{}).footerLinks)};}));

/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = '';

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (arg) {
				classes = appendClass(classes, parseValue(arg));
			}
		}

		return classes;
	}

	function parseValue (arg) {
		if (typeof arg === 'string' || typeof arg === 'number') {
			return arg;
		}

		if (typeof arg !== 'object') {
			return '';
		}

		if (Array.isArray(arg)) {
			return classNames.apply(null, arg);
		}

		if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
			return arg.toString();
		}

		var classes = '';

		for (var key in arg) {
			if (hasOwn.call(arg, key) && arg[key]) {
				classes = appendClass(classes, key);
			}
		}

		return classes;
	}

	function appendClass (value, newClass) {
		if (!newClass) {
			return value;
		}
	
		if (value) {
			return value + ' ' + newClass;
		}
	
		return value + newClass;
	}

	if (typeof module !== 'undefined' && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 645 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_animate_height__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_animate_height___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_animate_height__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_connect__ = __webpack_require__(8);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  position:relative;\n  width: 100%; \n  background-color: #f2f2f2;\n  margin-bottom: 10px;\n'],['\n  position:relative;\n  width: 100%; \n  background-color: #f2f2f2;\n  margin-bottom: 10px;\n']),_templateObject2=_taggedTemplateLiteral(['\n  position: relative;\n  min-height: 22px;\n  font-size: 13px;\n  background-color: transparent;\n  border: none;\n  padding: 12px 7px 12px 15px;\n  outline: none;\n  cursor: pointer;\n  width: 100%;\n  text-align: left;\n  &:after {\n    content: \'\';\n    position:absolute;\n    right: 12px;\n    top: calc(50% - 6px);\n    background-image: url(/images/icons/arrow.svg);\n    background-size: contain;\n    background-repeat: no-repeat;\n    min-width: 12px;\n    height: 12px;    \n    ',';\n    -webkit-transition: -webkit-transform .25s ease-out;\n    -webkit-transition: transform .25s ease-out;\n    transition: transform .25s ease-out;\n  }\n  }\n'],['\n  position: relative;\n  min-height: 22px;\n  font-size: 13px;\n  background-color: transparent;\n  border: none;\n  padding: 12px 7px 12px 15px;\n  outline: none;\n  cursor: pointer;\n  width: 100%;\n  text-align: left;\n  &:after {\n    content: \'\';\n    position:absolute;\n    right: 12px;\n    top: calc(50% - 6px);\n    background-image: url(/images/icons/arrow.svg);\n    background-size: contain;\n    background-repeat: no-repeat;\n    min-width: 12px;\n    height: 12px;    \n    ',';\n    -webkit-transition: -webkit-transform .25s ease-out;\n    -webkit-transition: transform .25s ease-out;\n    transition: transform .25s ease-out;\n  }\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n      transform: rotateX(180deg);      \n    '],['\n      transform: rotateX(180deg);      \n    ']),_templateObject4=_taggedTemplateLiteral(['\n  position:absolute; \n  left: 0; \n  right: 0; \n  top: 100%;\n  background-color: #f2f2f2;\n'],['\n  position:absolute; \n  left: 0; \n  right: 0; \n  top: 100%;\n  background-color: #f2f2f2;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CustomSelect=function(_Component){_inherits(CustomSelect,_Component);function CustomSelect(props){_classCallCheck(this,CustomSelect);var _this=_possibleConstructorReturn(this,(CustomSelect.__proto__||Object.getPrototypeOf(CustomSelect)).call(this,props));_this.state={active:false};_this.setActive=_this.setActive.bind(_this);return _this;}_createClass(CustomSelect,[{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){if(prevProps.location!==this.props.location){this.setState({active:false});}}},{key:'setActive',value:function setActive(){this.setState({active:!this.state.active});}},{key:'render',value:function render(){var _props=this.props,children=_props.children,title=_props.title;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CustomSelectWrapper,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MenuButton,{isActive:this.state.active,onClick:this.setActive},title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MenuWrapper,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_animate_height___default.a,{className:'animation',duration:400,easing:'ease-out',height:this.state.active?'auto':0},children)));}}]);return CustomSelect;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var CustomSelectWrapper=__WEBPACK_IMPORTED_MODULE_3_styled_components__["default"].div(_templateObject);var MenuButton=__WEBPACK_IMPORTED_MODULE_3_styled_components__["default"].button(_templateObject2,function(props){return props.isActive&&Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["css"])(_templateObject3);});var MenuWrapper=__WEBPACK_IMPORTED_MODULE_3_styled_components__["default"].div(_templateObject4);CustomSelect.defaultProps={title:''};CustomSelect.propTypes={title:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,location:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,children:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node),__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node]).isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4__store_connect__["a" /* default */])(CustomSelect));

/***/ }),
/* 646 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_helpers_variables__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_helpers_mixins__ = __webpack_require__(6);
var _templateObject=_taggedTemplateLiteral(['\n  padding-top: 30px;\n  padding-bottom: 50px;\n  padding-right: 0;\n  padding-left: 0;\n  @media screen and (min-width: ','px) {\n    padding-right: 90px;\n  }\n  ',';\n'],['\n  padding-top: 30px;\n  padding-bottom: 50px;\n  padding-right: 0;\n  padding-left: 0;\n  @media screen and (min-width: ','px) {\n    padding-right: 90px;\n  }\n  ',';\n']),_templateObject2=_taggedTemplateLiteral(['\n      padding-right: 0;\n      padding-left: 0;\n      @media screen and (min-width: ','px) {\n        padding-left: 90px;\n        padding-right: 0;\n      }\n    '],['\n      padding-right: 0;\n      padding-left: 0;\n      @media screen and (min-width: ','px) {\n        padding-left: 90px;\n        padding-right: 0;\n      }\n    ']),_templateObject3=_taggedTemplateLiteral(['\n  ',';\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 2px;\n  color: ',';\n'],['\n  ',';\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 2px;\n  color: ',';\n']),_templateObject4=_taggedTemplateLiteral(['\n  ',';\n  ',';\n  display: block;\n  text-decoration: none;\n  line-height: 1.25;\n  color: #000000;\n  margin-top: 20px;\n'],['\n  ',';\n  ',';\n  display: block;\n  text-decoration: none;\n  line-height: 1.25;\n  color: #000000;\n  margin-top: 20px;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var ReadMoreAbout=function ReadMoreAbout(props){var pageTitle=props.pageTitle,pageUrl=props.pageUrl,pos=props.pos;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ReadMoreContainer,{pos:pos},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ReadMoreTag,null,'L\xE4s mer om'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ReadMoreLink,{to:pageUrl},pageTitle));};var ReadMoreContainer=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].div(_templateObject,__WEBPACK_IMPORTED_MODULE_4__styles_helpers_variables__["f" /* size */].medium,function(props){return props.pos==='right'&&Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["css"])(_templateObject2,__WEBPACK_IMPORTED_MODULE_4__styles_helpers_variables__["f" /* size */].medium);});var ReadMoreTag=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].span(_templateObject3,Object(__WEBPACK_IMPORTED_MODULE_5__styles_helpers_mixins__["b" /* dynamicFontSize */])(10,13,__WEBPACK_IMPORTED_MODULE_4__styles_helpers_variables__["f" /* size */].small,__WEBPACK_IMPORTED_MODULE_4__styles_helpers_variables__["f" /* size */].medium),__WEBPACK_IMPORTED_MODULE_4__styles_helpers_variables__["c" /* color */].black);var ReadMoreLink=Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["a" /* Link */])(_templateObject4,Object(__WEBPACK_IMPORTED_MODULE_5__styles_helpers_mixins__["b" /* dynamicFontSize */])(24,32,__WEBPACK_IMPORTED_MODULE_4__styles_helpers_variables__["f" /* size */].small,__WEBPACK_IMPORTED_MODULE_4__styles_helpers_variables__["f" /* size */].medium),__WEBPACK_IMPORTED_MODULE_5__styles_helpers_mixins__["e" /* fontFamilyHeading */]);ReadMoreAbout.defaultProps={pageTitle:'',pageUrl:'',pos:''};ReadMoreAbout.propTypes={pageTitle:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,pageUrl:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,pos:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (ReadMoreAbout);

/***/ }),
/* 647 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_grid_styled__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_grid_styled___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_grid_styled__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_FullWidthContainer__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_Container__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_helpers_variables__ = __webpack_require__(4);
var _templateObject=_taggedTemplateLiteral(['\n  padding-top: 80px;\n  padding-bottom: 50px;\n'],['\n  padding-top: 80px;\n  padding-bottom: 50px;\n']),_templateObject2=_taggedTemplateLiteral(['\n  width: 100%;\n  height: 0;\n  padding-bottom: 71.5%;\n  background-image: url("','");\n  background-size: cover;\n  background-position: center;\n  margin: 10px 0;\n'],['\n  width: 100%;\n  height: 0;\n  padding-bottom: 71.5%;\n  background-image: url("','");\n  background-size: cover;\n  background-position: center;\n  margin: 10px 0;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var ArticleImageBlock=function ArticleImageBlock(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles_FullWidthContainer__["a" /* FullWidthContainer */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ArticleImageBlockContainer,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_styled_components__["ThemeProvider"],{theme:{breakpoints:[__WEBPACK_IMPORTED_MODULE_6__styles_helpers_variables__["f" /* size */].medium+'px']}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grid_styled__["Flex"],{flexWrap:'wrap',mx:[0,'-14px']},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grid_styled__["Box"],{width:[1,1/2],p:[0,'14px']},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ImageBlock,{image:props.leftImage})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grid_styled__["Box"],{width:[1,1/2],p:[0,'14px']},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ImageBlock,{image:props.rightImage}))))));};var ArticleImageBlockContainer=__WEBPACK_IMPORTED_MODULE_5__styles_Container__["a" /* Container */].extend(_templateObject);var ImageBlock=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject2,function(props){return props.image;});ArticleImageBlock.defaultProps={leftImage:null,rightImage:null};ArticleImageBlock.propTypes={leftImage:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,rightImage:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (ArticleImageBlock);

/***/ }),
/* 648 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isIE; });
var isIE=typeof window!=='undefined'&&'-ms-scroll-limit'in document.documentElement.style&&'-ms-ime-align'in document.documentElement.style;

/***/ }),
/* 649 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_grid_styled__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_grid_styled___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_grid_styled__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_connect__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions_actionCreators__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Page__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_Heading__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_helpers_variables__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__styles_Container__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_NavigationButton__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__styles_Preamble__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__styles_FullWidthContainer__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_HeroImage__ = __webpack_require__(650);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__constants_endpoints__ = __webpack_require__(9);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CategoryLink=function(_Component){_inherits(CategoryLink,_Component);function CategoryLink(){_classCallCheck(this,CategoryLink);return _possibleConstructorReturn(this,(CategoryLink.__proto__||Object.getPrototypeOf(CategoryLink)).apply(this,arguments));}_createClass(CategoryLink,[{key:'componentDidMount',value:function componentDidMount(){this.props.fetchArticlePageView({urlPath:this.props.location.pathname});}},{key:'render',value:function render(){var currentPage=this.props.currentPage;var childRoutes=this.props.item.get('children');var subcategoryButtons=childRoutes.map(function(item){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grid_styled__["Box"],{key:item.get('id'),width:[1,1,1/2,1/2,1/3],py:['5px','8px','11px'],px:['0px','8px','11px']},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_NavigationButton__["a" /* NavigationButton */],{url:item.get('url'),image:item.get('image'),title:item.get('title')}));}).toArray();return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Page__["a" /* default */],{meta:this.props.currentPage.get('metaData'),bgColor:currentPage.getIn(['fields','color'],__WEBPACK_IMPORTED_MODULE_9__styles_helpers_variables__["c" /* color */].lightgrey)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__styles_FullWidthContainer__["a" /* FullWidthContainer */],{bgColor:currentPage.getIn(['fields','color'],__WEBPACK_IMPORTED_MODULE_9__styles_helpers_variables__["c" /* color */].lightgrey)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__styles_Container__["a" /* Container */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__styles_Heading__["a" /* Heading */],{big:true,center:true},currentPage.getIn(['fields','title'])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__styles_Preamble__["a" /* Preamble */],null,currentPage.getIn(['fields','description'])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_styled_components__["ThemeProvider"],{theme:{breakpoints:['500px','800px',__WEBPACK_IMPORTED_MODULE_9__styles_helpers_variables__["f" /* size */].large+'px','1100px']}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grid_styled__["Flex"],{flexWrap:'wrap',mx:['0px','-8px','-11px'],mt:60,mb:20},subcategoryButtons))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_HeroImage__["a" /* HeroImage */],{bgColor:__WEBPACK_IMPORTED_MODULE_9__styles_helpers_variables__["c" /* color */].lightGrey,url:__WEBPACK_IMPORTED_MODULE_15__constants_endpoints__["n" /* SITE_ROOT_URL */]+currentPage.getIn(['fields','image','url'])})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__styles_FullWidthContainer__["a" /* FullWidthContainer */],{bgColor:__WEBPACK_IMPORTED_MODULE_9__styles_helpers_variables__["c" /* color */].lightGrey},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__styles_Container__["a" /* Container */],null)));}}]);return CategoryLink;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);CategoryLink.defaultProps={item:Object(__WEBPACK_IMPORTED_MODULE_3_immutable__["Map"])(),currentPage:Object(__WEBPACK_IMPORTED_MODULE_3_immutable__["Map"])()};CategoryLink.propTypes={item:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_3_immutable__["Map"]),currentPage:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_3_immutable__["Map"]),fetchArticlePageView:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,location:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5__store_connect__["a" /* default */])(CategoryLink,{fetchArticlePageView:__WEBPACK_IMPORTED_MODULE_6__actions_actionCreators__["g" /* fetchArticlePageView */]},function(store,props){return{currentPage:store.page.data.get(props.location.pathname,Object(__WEBPACK_IMPORTED_MODULE_3_immutable__["Map"])())};}));

/***/ }),
/* 650 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HeroImage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_Container__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_HeroImage__ = __webpack_require__(651);
var HeroImage=function HeroImage(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__styles_HeroImage__["b" /* HeroImageContainer */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__styles_HeroImage__["a" /* HeroImageColoredBottom */],{bgColor:props.bgColor}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__styles_Container__["a" /* Container */],{noPadding:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__styles_HeroImage__["c" /* HeroImageContent */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__styles_HeroImage__["d" /* HeroImageImage */],{url:props.url}))));};/* unused harmony default export */ var _unused_webpack_default_export = (HeroImage);

/***/ }),
/* 651 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return HeroImageContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return HeroImageContent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return HeroImageImage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HeroImageColoredBottom; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_variables__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_animations__ = __webpack_require__(81);
var _templateObject=_taggedTemplateLiteral(['\n  position: relative;\n  width: 100%;\n'],['\n  position: relative;\n  width: 100%;\n']),_templateObject2=_taggedTemplateLiteral(['\n  display: block;\n  width: 100%;\n  height: 0;\n  padding-bottom: 33.3%;\n  margin: 0 auto;\n  position: relative;\n  overflow: hidden;\n'],['\n  display: block;\n  width: 100%;\n  height: 0;\n  padding-bottom: 33.3%;\n  margin: 0 auto;\n  position: relative;\n  overflow: hidden;\n']),_templateObject3=_taggedTemplateLiteral(['\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background-image: url("','");\n  background-size: cover;\n  background-position: center;\n  ',';\n'],['\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background-image: url("','");\n  background-size: cover;\n  background-position: center;\n  ',';\n']),_templateObject4=_taggedTemplateLiteral(['\n  position: absolute;\n  top: 50%;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background-color: ',';\n'],['\n  position: absolute;\n  top: 50%;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background-color: ',';\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var HeroImageContainer=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].div(_templateObject);var HeroImageContent=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].div(_templateObject2);var HeroImageImage=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].div(_templateObject3,function(props){return props.url;},__WEBPACK_IMPORTED_MODULE_2__helpers_animations__["e" /* ImageZoomAnimation */]);var HeroImageColoredBottom=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].div(_templateObject4,function(props){return props.bgColor?props.bgColor:__WEBPACK_IMPORTED_MODULE_1__helpers_variables__["c" /* color */].white;});

/***/ }),
/* 652 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_connect__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions_actionCreators__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Page__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_Heading__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_Preamble__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_Container__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_ProductListWithFilters__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__selectors_reselectCategory__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__styles_helpers_variables__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ErrorPage__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__NotFoundPage__ = __webpack_require__(39);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CategoryPage=function(_Component){_inherits(CategoryPage,_Component);function CategoryPage(){_classCallCheck(this,CategoryPage);return _possibleConstructorReturn(this,(CategoryPage.__proto__||Object.getPrototypeOf(CategoryPage)).apply(this,arguments));}_createClass(CategoryPage,[{key:'componentDidMount',value:function componentDidMount(){this.getPageData(this.props.match.url,this.props.item.get('id'));if(this.props.viewstate.get('currentCategory')!==this.props.item.get('id')){this.setDefaultFilters(this.props.item.get('id'));}}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(this.props.viewstate.get('currentCategory')!==nextProps.item.get('id')&&this.props.item.get('id')!==nextProps.item.get('id')){this.getPageData(nextProps.match.url,nextProps.item.get('id'));this.setDefaultFilters(nextProps.item.get('id'));}}},{key:'getPageData',value:function getPageData(pageUrl,categoryId){this.props.fetchCategoryMetaData({url:pageUrl});this.props.fetchProducts({id:categoryId,url:pageUrl});}},{key:'setDefaultFilters',value:function setDefaultFilters(categoryId){this.props.setViewstate('currentCategory',categoryId);this.props.setViewstate('sortAscending',false);this.props.setViewstate('sortBy','name');this.props.removeViewstate('filter');this.props.setViewstate('pagination',0);}},{key:'render',value:function render(){var _props=this.props,currentCategory=_props.currentCategory,categoryProducts=_props.categoryProducts,request=_props.request,productsRequest=_props.productsRequest;var informationCard=currentCategory.getIn(['informationCards',0]);if(request.get('statusCode')===404)return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__NotFoundPage__["a" /* default */],null);if(request.get('status')==='ERROR')return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__ErrorPage__["a" /* default */],null);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Page__["a" /* default */],{meta:currentCategory.get('metaData'),bgColor:__WEBPACK_IMPORTED_MODULE_11__styles_helpers_variables__["c" /* color */].lightGrey},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__styles_Container__["a" /* Container */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__styles_Heading__["a" /* Heading */],{big:true,center:true},currentCategory.get('name')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__styles_Preamble__["a" /* Preamble */],null,currentCategory.get('description'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_ProductListWithFilters__["a" /* default */],{request:productsRequest,allProducts:categoryProducts,informationCard:informationCard}));}}]);return CategoryPage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);CategoryPage.defaultProps={categoryProducts:Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])(),viewstate:Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])(),currentCategory:Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])(),request:Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])(),item:Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])(),productsRequest:Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])()};CategoryPage.propTypes={match:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,fetchProducts:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,setViewstate:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,removeViewstate:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,viewstate:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"]),categoryProducts:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"]),currentCategory:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"]),request:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"]),item:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"]),fetchCategoryMetaData:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,productsRequest:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3__store_connect__["a" /* default */])(CategoryPage,{fetchProducts:__WEBPACK_IMPORTED_MODULE_4__actions_actionCreators__["K" /* fetchProducts */],fetchCategoryMetaData:__WEBPACK_IMPORTED_MODULE_4__actions_actionCreators__["s" /* fetchCategoryMetaData */],setViewstate:__WEBPACK_IMPORTED_MODULE_4__actions_actionCreators__["W" /* setViewstate */],removeViewstate:__WEBPACK_IMPORTED_MODULE_4__actions_actionCreators__["V" /* removeViewstate */]},function(store,props){var pathname=props.location.pathname.replace(/\/$/,'');var categoryProducts=props.item?Object(__WEBPACK_IMPORTED_MODULE_10__selectors_reselectCategory__["d" /* getProductsByKeys */])(store,['categories'],props.item.get('id')):Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])();return{categoryProducts:categoryProducts,viewstate:store.viewstate,currentCategory:store.categories.items.get(pathname),request:store.categories.request.get(pathname),productsRequest:store.products.request.get(pathname)};}));

/***/ }),
/* 653 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions_actionCreators__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_connect__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_FiltersList__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_SortingList__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_Container__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_helpers_variables__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__styles_helpers_mixins__ = __webpack_require__(6);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  background-color: ',';\n  opacity: 0.1;\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 10;\n  display: none;\n\n  ',';\n'],['\n  background-color: ',';\n  opacity: 0.1;\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 10;\n  display: none;\n\n  ',';\n']),_templateObject2=_taggedTemplateLiteral(['\n      display: block;\n    '],['\n      display: block;\n    ']),_templateObject3=_taggedTemplateLiteral(['\n  font-weight: 600;\n  font-style: normal;\n  color: ','!important;\n  margin-right: 0.25em;\n'],['\n  font-weight: 600;\n  font-style: normal;\n  color: ','!important;\n  margin-right: 0.25em;\n']),_templateObject4=_taggedTemplateLiteral(['\n  display: flex;\n  justify-content: center;\n  align-items: stretch;\n  padding: 0;\n  margin: 0;\n  border-top: 1px solid ',';\n  border-bottom: 1px solid ',';\n  list-style: none;\n  position: relative;\n'],['\n  display: flex;\n  justify-content: center;\n  align-items: stretch;\n  padding: 0;\n  margin: 0;\n  border-top: 1px solid ',';\n  border-bottom: 1px solid ',';\n  list-style: none;\n  position: relative;\n']),_templateObject5=_taggedTemplateLiteral(['\n  z-index: 20;\n\n  ',';\n'],['\n  z-index: 20;\n\n  ',';\n']),_templateObject6=_taggedTemplateLiteral(['\n      background-color: ',';\n    '],['\n      background-color: ',';\n    ']),_templateObject7=_taggedTemplateLiteral(['\n  ',';\n  font-size: 13px;\n  font-weight: 600;\n  letter-spacing: 2px;\n  text-align: center;\n  color: ',';\n  text-transform: uppercase;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  padding: 1rem 2rem;\n  border: none;\n  background-color: transparent;\n  outline: 0;\n  position: relative;\n  bottom: -2px;\n  z-index: 30;\n\n  ',';\n\n  &:after {\n    content: \'\';\n    background-image: url(\'/images/icons/arrow.svg\');\n    background-size: contain;\n    background-repeat: no-repeat;\n    min-width: 12px;\n    height: 12px;\n    display: inline-block;\n    margin-left: 5px;\n    transition: transform 0.25s ease-out;\n\n    ',';\n  }\n\n  span {\n    color: ',';\n  }\n'],['\n  ',';\n  font-size: 13px;\n  font-weight: 600;\n  letter-spacing: 2px;\n  text-align: center;\n  color: ',';\n  text-transform: uppercase;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  padding: 1rem 2rem;\n  border: none;\n  background-color: transparent;\n  outline: 0;\n  position: relative;\n  bottom: -2px;\n  z-index: 30;\n\n  ',';\n\n  &:after {\n    content: \'\';\n    background-image: url(\'/images/icons/arrow.svg\');\n    background-size: contain;\n    background-repeat: no-repeat;\n    min-width: 12px;\n    height: 12px;\n    display: inline-block;\n    margin-left: 5px;\n    transition: transform 0.25s ease-out;\n\n    ',';\n  }\n\n  span {\n    color: ',';\n  }\n']),_templateObject8=_taggedTemplateLiteral(['\n        transform: rotateX(180deg);\n      '],['\n        transform: rotateX(180deg);\n      ']),_templateObject9=_taggedTemplateLiteral(['\n  ',';\n  font-size: 14px;\n  font-weight: normal;\n  letter-spacing: normal;\n  text-align: center;\n  font-style: italic;\n  color: ',';\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  padding: 1rem 2rem;\n  border: none;\n  background-color: transparent;\n  outline: 0;\n  position: relative;\n  bottom: -1px;\n  z-index: 30;\n\n  ',';\n\n  &:after {\n    content: \'\';\n    background-image: url(\'/images/icons/arrow.svg\');\n    background-size: contain;\n    background-repeat: no-repeat;\n    min-width: 12px;\n    height: 12px;\n    display: inline-block;\n    margin-left: 8px;\n    transition: transform 0.25s ease-out;\n\n    ',';\n  }\n\n  span {\n    color: ',';\n  }\n'],['\n  ',';\n  font-size: 14px;\n  font-weight: normal;\n  letter-spacing: normal;\n  text-align: center;\n  font-style: italic;\n  color: ',';\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  padding: 1rem 2rem;\n  border: none;\n  background-color: transparent;\n  outline: 0;\n  position: relative;\n  bottom: -1px;\n  z-index: 30;\n\n  ',';\n\n  &:after {\n    content: \'\';\n    background-image: url(\'/images/icons/arrow.svg\');\n    background-size: contain;\n    background-repeat: no-repeat;\n    min-width: 12px;\n    height: 12px;\n    display: inline-block;\n    margin-left: 8px;\n    transition: transform 0.25s ease-out;\n\n    ',';\n  }\n\n  span {\n    color: ',';\n  }\n']),_templateObject10=_taggedTemplateLiteral(['\n  position: absolute;\n  top: 100%;\n  left: 0;\n  right: 0;\n  z-index: 20;\n  padding: 1rem 2rem;\n  cursor: default;\n  background-color: ',';\n  border: solid 1px ',';\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n'],['\n  position: absolute;\n  top: 100%;\n  left: 0;\n  right: 0;\n  z-index: 20;\n  padding: 1rem 2rem;\n  cursor: default;\n  background-color: ',';\n  border: solid 1px ',';\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Filters=function(_Component){_inherits(Filters,_Component);function Filters(props){_classCallCheck(this,Filters);var _this=_possibleConstructorReturn(this,(Filters.__proto__||Object.getPrototypeOf(Filters)).call(this,props));_this.state={activeFilterOption:null};return _this;}_createClass(Filters,[{key:'setSortBy',value:function setSortBy(key,ascending){this.props.setViewstate('sortBy',key);this.props.setViewstate('sortAscending',ascending);}},{key:'setFilterBy',value:function setFilterBy(key,value){if(this.props.viewstate.get('filter/'+key)&&this.props.viewstate.get('filter/'+key).includes(value)){var filterParamIndex=this.props.viewstate.get('filter/'+key).indexOf(value);this.props.setViewstate('filter/'+key,this.props.viewstate.get('filter/'+key).delete(filterParamIndex));}else if(this.props.viewstate.get('filter/'+key)){this.props.setViewstate('filter/'+key,this.props.viewstate.get('filter/'+key).push(value));}else{this.props.setViewstate('filter/'+key,Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["List"])([value]));}}},{key:'activateFilterOptionMenu',value:function activateFilterOptionMenu(id){if(this.state.activeFilterOption===id){this.setState({activeFilterOption:null});}else{this.setState({activeFilterOption:id});}}},{key:'renderFilterOptions',value:function renderFilterOptions(){var _this2=this;var includeCategoryFilter=this.props.includeCategoryFilter;var filterList=void 0;if(includeCategoryFilter){filterList=[{name:'Underkategori',id:'category',selector:['category','name']},{name:'Varumärke',id:'manufacturer',selector:['brand','name']},{name:'Färg',id:'color',selector:['variants',0,'filterColor']}];}else{filterList=[{name:'Varumärke',id:'manufacturer',selector:['brand','name']},{name:'Färg',id:'color',selector:['variants',0,'filterColor']}];}return filterList.map(function(item,index){var realIndex=index+1;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FilterOptionContainer,{key:realIndex,isActive:_this2.state.activeFilterOption===realIndex},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FilterToggleButton,{isActive:_this2.state.activeFilterOption===realIndex,onClick:function onClick(){return _this2.activateFilterOptionMenu(realIndex);}},item.name,_this2.props.viewstate.getIn(['filter',item.id],Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["List"])()).size?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'(',_this2.props.viewstate.getIn(['filter',item.id],Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["List"])()).size,')'):false),_this2.state.activeFilterOption===realIndex&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FilterOptionMenu,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_FiltersList__["a" /* default */],{products:_this2.props.products,type:item.id,selector:item.selector,forColor:item.id==='color'})));});}},{key:'render',value:function render(){var _this3=this;var filterOptions=this.renderFilterOptions();var sortingString='';if(this.props.viewstate.get('sortBy')==='relevance'&&this.props.viewstate.get('sortAscending'))sortingString='sökrelevans';else if(this.props.viewstate.get('sortBy')==='name'&&!this.props.viewstate.get('sortAscending'))sortingString='namn (A-Ö)';else if(this.props.viewstate.get('sortBy')==='name'&&this.props.viewstate.get('sortAscending'))sortingString='namn (Ö-A)';else if(this.props.viewstate.get('sortBy')==='price'&&!this.props.viewstate.get('sortAscending'))sortingString='pris lågt till högt';else if(this.props.viewstate.get('sortBy')==='price'&&this.props.viewstate.get('sortAscending'))sortingString='pris högt till lågt';else if(this.props.viewstate.get('sortBy')==='addedDate'&&this.props.viewstate.get('sortAscending'))sortingString='senast inkommet';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__styles_Container__["a" /* Container */],{noPadding:true,mb:15},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Overlay,{active:this.state.activeFilterOption,onClick:function onClick(){return _this3.setState({activeFilterOption:null});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FilterContainer,null,filterOptions,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FilterOptionContainer,{isActive:this.state.activeFilterOption==='sort'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SortToggleButton,{onClick:function onClick(){return _this3.activateFilterOptionMenu('sort');},isActive:this.state.activeFilterOption==='sort'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SortByTitle,null,'Sortera p\xE5:'),' ',sortingString),this.state.activeFilterOption==='sort'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FilterOptionMenu,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_SortingList__["a" /* default */],{includeRelevance:this.props.includeRelevance})))));}}]);return Filters;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var Overlay=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].div(_templateObject,__WEBPACK_IMPORTED_MODULE_9__styles_helpers_variables__["c" /* color */].black,function(props){return props.active&&Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["css"])(_templateObject2);});var SortByTitle=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].span(_templateObject3,__WEBPACK_IMPORTED_MODULE_9__styles_helpers_variables__["c" /* color */].black);var FilterContainer=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].ul(_templateObject4,__WEBPACK_IMPORTED_MODULE_9__styles_helpers_variables__["c" /* color */].blackTransparent,__WEBPACK_IMPORTED_MODULE_9__styles_helpers_variables__["c" /* color */].blackTransparent);var FilterOptionContainer=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].li(_templateObject5,function(props){return props.isActive&&Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["css"])(_templateObject6,__WEBPACK_IMPORTED_MODULE_9__styles_helpers_variables__["c" /* color */].white);});var FilterToggleButton=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].button(_templateObject7,__WEBPACK_IMPORTED_MODULE_10__styles_helpers_mixins__["d" /* fontFamilyBody */],__WEBPACK_IMPORTED_MODULE_9__styles_helpers_variables__["c" /* color */].black,function(props){return props.isActive&&Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["css"])(_templateObject6,__WEBPACK_IMPORTED_MODULE_9__styles_helpers_variables__["c" /* color */].white);},function(props){return props.isActive&&Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["css"])(_templateObject8);},__WEBPACK_IMPORTED_MODULE_9__styles_helpers_variables__["c" /* color */].success);var SortToggleButton=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].button(_templateObject9,__WEBPACK_IMPORTED_MODULE_10__styles_helpers_mixins__["d" /* fontFamilyBody */],__WEBPACK_IMPORTED_MODULE_9__styles_helpers_variables__["c" /* color */].black,function(props){return props.isActive&&Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["css"])(_templateObject6,__WEBPACK_IMPORTED_MODULE_9__styles_helpers_variables__["c" /* color */].white);},function(props){return props.isActive&&Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["css"])(_templateObject8);},__WEBPACK_IMPORTED_MODULE_9__styles_helpers_variables__["c" /* color */].success);var FilterOptionMenu=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].ul(_templateObject10,__WEBPACK_IMPORTED_MODULE_9__styles_helpers_variables__["c" /* color */].white,__WEBPACK_IMPORTED_MODULE_9__styles_helpers_variables__["c" /* color */].grey);Filters.defaultProps={includeCategoryFilter:false,viewstate:Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])(),products:Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])(),includeRelevance:false};Filters.propTypes={includeCategoryFilter:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,setViewstate:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,viewstate:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"]),products:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"]),includeRelevance:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5__store_connect__["a" /* default */])(Filters,{setViewstate:__WEBPACK_IMPORTED_MODULE_4__actions_actionCreators__["W" /* setViewstate */]},function(store){return{viewstate:store.viewstate};}));

/***/ }),
/* 654 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return filterColors; });
var filterColors={Color1:{value:'#437e99',name:'Blå'},// blue
Color2:{value:'#595448',name:'Brun'},// brown
Color3:{value:['#ffffff','#e8e8e8'],name:'Transparant'},// transparent
Color4:{value:'#959590',name:'Grå'},// grey
Color5:{value:'#536c4b',name:'Grön'},// green
Color6:{value:'#e9ce4e',name:'Gul'},// yellow
Color7:{value:['#b87333','#ffaf65','#b87333'],name:'Koppar'},// copper
Color8:{value:['#3e4147','#ffffff','#3e4147'],name:'Metall'},// metal
Color9:{value:'#614672',name:'Lila'},// purple
Color10:{value:['#32996f','#8bbe57','#db6312','#407aaa'],name:'Flerfärgad'},// multi
Color11:{value:['#b5a642','#ffeb67','#b5a642'],name:'Mässing'},// brass
Color12:{value:'#ca8400',name:'Orange'},// orange
Color13:{value:'#cdadc2',name:'Rosa'},// pink
Color14:{value:'#912113',name:'Röd'},// red
Color15:{value:'#2f2f2D',name:'Svart'},// black
Color16:{value:'#ffffff',name:'Vit'},// white
Color18:{value:'#dbcbaa',name:'Beige'},Color19:{value:'#7c5024',name:'Trä'}};

/***/ }),
/* 655 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_grid_styled__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_grid_styled___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_grid_styled__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_FullWidthContainer__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_helpers_variables__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  width: 100%;\n'],['\n  width: 100%;\n']),_templateObject2=_taggedTemplateLiteral(['\n  padding: 1rem .5rem;\n  font-size: 12px;\n  font-weight: 600;\n  font-style: normal;\n  font-stretch: normal;\n  line-height: normal;\n  letter-spacing: 2px;\n  text-align: center;\n  color: ',';\n  cursor: pointer;\n  \n  &:first-of-type,\n  &:last-of-type {\n    border-top: solid 1px #c5c5c5;\n    border-bottom: solid 1px #c5c5c5;\n  }\n  \n  &:nth-child(2) {\n    border: solid 1px #c5c5c5;\n  }\n'],['\n  padding: 1rem .5rem;\n  font-size: 12px;\n  font-weight: 600;\n  font-style: normal;\n  font-stretch: normal;\n  line-height: normal;\n  letter-spacing: 2px;\n  text-align: center;\n  color: ',';\n  cursor: pointer;\n  \n  &:first-of-type,\n  &:last-of-type {\n    border-top: solid 1px #c5c5c5;\n    border-bottom: solid 1px #c5c5c5;\n  }\n  \n  &:nth-child(2) {\n    border: solid 1px #c5c5c5;\n  }\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MobileNav=function(_Component){_inherits(MobileNav,_Component);function MobileNav(){_classCallCheck(this,MobileNav);return _possibleConstructorReturn(this,(MobileNav.__proto__||Object.getPrototypeOf(MobileNav)).apply(this,arguments));}_createClass(MobileNav,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styles_FullWidthContainer__["a" /* FullWidthContainer */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FullWidthFlex,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MyBox,{onClick:function onClick(){return _this2.props.toggleModal('filter');},width:'37%'},'FILTRERA'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MyBox,{onClick:function onClick(){return _this2.props.toggleModal('page');},width:'26%'},this.props.currentPage,' / ',this.props.pages),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MyBox,{onClick:function onClick(){return _this2.props.toggleModal('sort');},width:'37%'},'SORTERA')));}}]);return MobileNav;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var FullWidthFlex=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_2_grid_styled__["Flex"])(_templateObject);var MyBox=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_2_grid_styled__["Box"])(_templateObject2,__WEBPACK_IMPORTED_MODULE_4__styles_helpers_variables__["c" /* color */].black);/* harmony default export */ __webpack_exports__["a"] = (MobileNav);

/***/ }),
/* 656 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_connect__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions_actionCreators__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_helpers_variables__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__AccordionItemWithText__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_helpers_mixins__ = __webpack_require__(6);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  width: 100%;\n  margin: 30px 0 0;\n  border-bottom: solid 1px ',';\n  ',';\n\n  @media screen and (min-width: ','px) {\n    margin: 34px 0 0;\n  }\n  \n  ',';\n  \n  ',';\n'],['\n  width: 100%;\n  margin: 30px 0 0;\n  border-bottom: solid 1px ',';\n  ',';\n\n  @media screen and (min-width: ','px) {\n    margin: 34px 0 0;\n  }\n  \n  ',';\n  \n  ',';\n']),_templateObject2=_taggedTemplateLiteral(['\n      margin-bottom: ',';\n    '],['\n      margin-bottom: ',';\n    ']),_templateObject3=_taggedTemplateLiteral(['\n      margin: 0 !important;\n  '],['\n      margin: 0 !important;\n  ']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Accordion=function(_Component){_inherits(Accordion,_Component);function Accordion(props){_classCallCheck(this,Accordion);var _this=_possibleConstructorReturn(this,(Accordion.__proto__||Object.getPrototypeOf(Accordion)).call(this,props));_this.state={activeIndex:null};_this.theme={arrow:'url(/images/icons/arrow.svg)',border:'solid 1px'+__WEBPACK_IMPORTED_MODULE_5__styles_helpers_variables__["c" /* color */].grey,borderBottomColor:__WEBPACK_IMPORTED_MODULE_5__styles_helpers_variables__["c" /* color */].grey,fg:__WEBPACK_IMPORTED_MODULE_5__styles_helpers_variables__["c" /* color */].black};if(props.darkTheme){_this.theme.arrow='url(/images/icons/arrow-white.svg)';_this.theme.border='solid 1px #333';_this.theme.borderBottomColor='#333';_this.theme.fg=__WEBPACK_IMPORTED_MODULE_5__styles_helpers_variables__["c" /* color */].white;}_this.setActive=_this.setActive.bind(_this);return _this;}_createClass(Accordion,[{key:'setActive',value:function setActive(index){// set viewstate.brokeDesign to update StickyButton on ProductPage when an Accordion is opened
this.props.setViewstate('brokeDesign',new Date().getTime());this.setState({activeIndex:this.state.activeIndex===index?null:index});this.props.clickOnAccordionCallback();}},{key:'render',value:function render(){var _this2=this;// Return this if there are multiple Accordion items
if(Number.isInteger(this.props.children.length)){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_styled_components__["ThemeProvider"],{theme:this.theme},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(AccordionContainer,{bm:this.props.bm,noMargin:this.props.noMargin,bottomBorder:this.props.children[this.props.children.length-1].type===__WEBPACK_IMPORTED_MODULE_6__AccordionItemWithText__["a" /* default */],darkTheme:this.props.darkTheme},this.props.children.map(function(item,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(item,{key:index,index:index,setActive:_this2.setActive,isActive:_this2.state.activeIndex===index,isFirstItem:index===0||_this2.state.activeIndex===index-1,darkTheme:_this2.props.darkTheme});})));}// Return this if there is only a single Accordion item
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_styled_components__["ThemeProvider"],{theme:this.theme},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(AccordionContainer,{bm:this.props.bm,noMargin:this.props.noMargin,bottomBorder:this.props.children.type===__WEBPACK_IMPORTED_MODULE_6__AccordionItemWithText__["a" /* default */],darkTheme:this.props.darkTheme},__WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(this.props.children,{index:0,setActive:this.setActive,isActive:this.state.activeIndex===0,isFirstItem:true})));}}]);return Accordion;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var AccordionContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject,function(props){return props.bottomBorder?props.theme.borderBottomColor:'none';},function(props){return props.bm&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject2,props.bm);},__WEBPACK_IMPORTED_MODULE_5__styles_helpers_variables__["f" /* size */].large,function(props){return props.noMargin&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject3);},__WEBPACK_IMPORTED_MODULE_7__styles_helpers_mixins__["f" /* hideOnPrint */]);Accordion.defaultProps={bm:null,noMargin:null,darkTheme:false,clickOnAccordionCallback:function clickOnAccordionCallback(){}};Accordion.propTypes={bm:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string]),noMargin:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,darkTheme:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,children:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node),__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node]).isRequired,setViewstate:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,clickOnAccordionCallback:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3__store_connect__["a" /* default */])(Accordion,{setViewstate:__WEBPACK_IMPORTED_MODULE_4__actions_actionCreators__["W" /* setViewstate */]}));

/***/ }),
/* 657 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Pagination; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PaginationDivider; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_variables__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_mixins__ = __webpack_require__(6);
var _templateObject=_taggedTemplateLiteral(['\n  ',';\n  border: none;\n  background-color: transparent;\n  padding: 10px 2px;\n  text-align: center;\n  cursor: pointer;\n  font-size: 12px;\n  font-weight: 600;\n  font-style: normal;\n  font-stretch: normal;\n  line-height: normal;\n  letter-spacing: 2px;\n  color: ',';\n  border-bottom: 1px solid transparent;\n  margin: 0 10px;\n  outline: 0;\n  opacity: 0.31;\n  transition: opacity ',' ',';\n\n  &:hover {\n    opacity: 1;\n  }\n\n  ',';\n\n  @media screen and (min-width: ','px) {\n    font-size: 14px;\n  }\n'],['\n  ',';\n  border: none;\n  background-color: transparent;\n  padding: 10px 2px;\n  text-align: center;\n  cursor: pointer;\n  font-size: 12px;\n  font-weight: 600;\n  font-style: normal;\n  font-stretch: normal;\n  line-height: normal;\n  letter-spacing: 2px;\n  color: ',';\n  border-bottom: 1px solid transparent;\n  margin: 0 10px;\n  outline: 0;\n  opacity: 0.31;\n  transition: opacity ',' ',';\n\n  &:hover {\n    opacity: 1;\n  }\n\n  ',';\n\n  @media screen and (min-width: ','px) {\n    font-size: 14px;\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n      opacity: 1;\n      border-bottom-color: ',';\n    '],['\n      opacity: 1;\n      border-bottom-color: ',';\n    ']),_templateObject3=_taggedTemplateLiteral(['\n  color: ',';\n  opacity: 0.31;\n  padding: 0;\n  margin: 0;\n'],['\n  color: ',';\n  opacity: 0.31;\n  padding: 0;\n  margin: 0;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Pagination=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].button(_templateObject,__WEBPACK_IMPORTED_MODULE_2__helpers_mixins__["d" /* fontFamilyBody */],__WEBPACK_IMPORTED_MODULE_1__helpers_variables__["c" /* color */].black,__WEBPACK_IMPORTED_MODULE_1__helpers_variables__["a" /* animation */].transitionTime,__WEBPACK_IMPORTED_MODULE_1__helpers_variables__["a" /* animation */].easing,function(props){return props.active&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(_templateObject2,__WEBPACK_IMPORTED_MODULE_1__helpers_variables__["c" /* color */].black);},__WEBPACK_IMPORTED_MODULE_1__helpers_variables__["f" /* size */].medium);var PaginationDivider=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].div(_templateObject3,__WEBPACK_IMPORTED_MODULE_1__helpers_variables__["c" /* color */].black);

/***/ }),
/* 658 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PaginationContainer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
var _templateObject=_taggedTemplateLiteral(['\n  width: 100%;\n  margin: 20px 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n'],['\n  width: 100%;\n  margin: 20px 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var PaginationContainer=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].div(_templateObject);

/***/ }),
/* 659 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Icon; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_variables__ = __webpack_require__(4);
var _templateObject=_taggedTemplateLiteral(['\n  width: 44px;\n  height: 44px;\n  background-image: url(',');\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: 14px;\n  cursor: pointer;\n  opacity: 0.8;\n  transition: opacity ',' ',';\n\n  ',' ','\n \n  &:hover {\n    opacity: 1;\n  }\n'],['\n  width: 44px;\n  height: 44px;\n  background-image: url(',');\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: 14px;\n  cursor: pointer;\n  opacity: 0.8;\n  transition: opacity ',' ',';\n\n  ',' ','\n \n  &:hover {\n    opacity: 1;\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n      transform: rotateZ(-90deg);\n    '],['\n      transform: rotateZ(-90deg);\n    ']),_templateObject3=_taggedTemplateLiteral(['\n      transform: rotateZ(90deg);\n    '],['\n      transform: rotateZ(90deg);\n    ']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Icon=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].div(_templateObject,function(props){return props.image?props.image:'/images/icons/arrow.svg';},__WEBPACK_IMPORTED_MODULE_1__helpers_variables__["a" /* animation */].transitionTime,__WEBPACK_IMPORTED_MODULE_1__helpers_variables__["a" /* animation */].easing,function(props){return props.right&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(_templateObject2);},function(props){return props.left&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(_templateObject3);});

/***/ }),
/* 660 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DividerLine; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
var _templateObject=_taggedTemplateLiteral(['\n  border: none;\n  border-top: solid 1px #c5c5c5;\n  margin: 30px 0 23px;\n'],['\n  border: none;\n  border-top: solid 1px #c5c5c5;\n  margin: 30px 0 23px;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var DividerLine=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].hr(_templateObject);

/***/ }),
/* 661 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_grid_styled__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_grid_styled___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_grid_styled__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_decode_html__ = __webpack_require__(662);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_decode_html___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_decode_html__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_qs__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store_connect__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_analyticEvents__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__actions_actionCreators__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_mapToObject__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__api_generalApi__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Page__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ErrorPage__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__NotFoundPage__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_productPage_ProductPageGallery_ProductPageGallery__ = __webpack_require__(663);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_productPage_ProductPageInfo_ProductPageInfo__ = __webpack_require__(664);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_productPage_ProductPageDescription_ProductPageDescription__ = __webpack_require__(665);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_productPage_ProductQuantitySelector_ProductQuantitySelector__ = __webpack_require__(666);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_productPage_ProductUSP_ProductUSP__ = __webpack_require__(667);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_ProductConfiguration__ = __webpack_require__(668);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_ProductList__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_LinedHeading__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_RenderPrice__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_StickyButton__ = __webpack_require__(675);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_SwipeWrapper__ = __webpack_require__(676);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__history__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__constants_endpoints__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__styles_helpers_variables__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__styles_Heading__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__styles_Button__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__styles_SubHeading__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__styles_ListParent__ = __webpack_require__(686);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__styles_ListItem__ = __webpack_require__(687);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__styles_Label__ = __webpack_require__(688);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__styles_Container__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__components_WashIcon__ = __webpack_require__(689);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__styles_helpers_mixins__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__constants_imageTypes__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__components_Conditional__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__components_productPage_ProductPageComplimentaryProducts_ProductPageComplimentaryProducts__ = __webpack_require__(690);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  width: 100%;\n  height: 1500px;\n  background-color: #f2f2f2;\n'],['\n  width: 100%;\n  height: 1500px;\n  background-color: #f2f2f2;\n']),_templateObject2=_taggedTemplateLiteral(['\n  padding-left: 2em;\n  list-style-type: disc;\n'],['\n  padding-left: 2em;\n  list-style-type: disc;\n']),_templateObject3=_taggedTemplateLiteral(['\n  ',';\n  line-height: 1.75;\n  font-size: 14px;\n  font-weight: normal;\n  position: relative;\n'],['\n  ',';\n  line-height: 1.75;\n  font-size: 14px;\n  font-weight: normal;\n  position: relative;\n']),_templateObject4=_taggedTemplateLiteral(['\n  ',';\n  margin: 30px 0 0;\n'],['\n  ',';\n  margin: 30px 0 0;\n']),_templateObject5=_taggedTemplateLiteral(['\n  ',';\n  @media print {\n    width: 100% !important;\n  }\n'],['\n  ',';\n  @media print {\n    width: 100% !important;\n  }\n']),_templateObject6=_taggedTemplateLiteral(['\n      @media screen and (min-width: 1180px) {\n        padding-top: 30px;\n      }\n      @media screen and (min-width: 1440px) {\n        padding-top: 60px;\n      }\n    '],['\n      @media screen and (min-width: 1180px) {\n        padding-top: 30px;\n      }\n      @media screen and (min-width: 1440px) {\n        padding-top: 60px;\n      }\n    ']),_templateObject7=_taggedTemplateLiteral(['\n  display: flex;\n  flex-wrap: wrap;\n  margin: 0 0 15px;\n  @media screen and (min-width: 1150px) {\n    flex-wrap: nowrap;\n  }\n  &:last-child {\n    margin: 0;\n  }\n  > button {\n    margin: 0;\n  }\n'],['\n  display: flex;\n  flex-wrap: wrap;\n  margin: 0 0 15px;\n  @media screen and (min-width: 1150px) {\n    flex-wrap: nowrap;\n  }\n  &:last-child {\n    margin: 0;\n  }\n  > button {\n    margin: 0;\n  }\n']),_templateObject8=_taggedTemplateLiteral(['\n  margin: 30px 0 0;\n  > h2 {\n    margin: 0 0 5px;\n    color: #000000;\n    font-size: 13px;\n    text-transform: uppercase;\n    letter-spacing: 1px;\n    font-weight: 600;\n  }\n'],['\n  margin: 30px 0 0;\n  > h2 {\n    margin: 0 0 5px;\n    color: #000000;\n    font-size: 13px;\n    text-transform: uppercase;\n    letter-spacing: 1px;\n    font-weight: 600;\n  }\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var createProductImageList=function createProductImageList(currentProduct,selectedVariant){var productImage={url:__WEBPACK_IMPORTED_MODULE_27__constants_endpoints__["n" /* SITE_ROOT_URL */]+selectedVariant.getIn(['mainImage','url']),alt:selectedVariant.getIn(['mainImage','alt']),type:selectedVariant.getIn(['mainImage','type']),needsBackground:true};var baseProductImage={url:__WEBPACK_IMPORTED_MODULE_27__constants_endpoints__["n" /* SITE_ROOT_URL */]+currentProduct.getIn(['mainImage','url']),alt:currentProduct.getIn(['mainImage','alt']),needsBackground:true};var productImages=currentProduct.get('images')?currentProduct.get('images').skip(1).map(function(image){if(image.get('type')==='Image'||image.get('type')===__WEBPACK_IMPORTED_MODULE_38__constants_imageTypes__["a" /* BARE_IMAGE */]){return{url:__WEBPACK_IMPORTED_MODULE_27__constants_endpoints__["n" /* SITE_ROOT_URL */]+image.get('url'),alt:image.get('alt'),type:image.get('type'),needsBackground:image.get('type')===__WEBPACK_IMPORTED_MODULE_38__constants_imageTypes__["a" /* BARE_IMAGE */]};}return false;}).toJS():[];var variantImages=selectedVariant.get('images')?selectedVariant.get('images').skip(1).map(function(image){if(image.get('type')==='Image'||image.get('type')===__WEBPACK_IMPORTED_MODULE_38__constants_imageTypes__["a" /* BARE_IMAGE */]){return{url:__WEBPACK_IMPORTED_MODULE_27__constants_endpoints__["n" /* SITE_ROOT_URL */]+image.get('url'),alt:image.get('alt'),type:image.get('type'),needsBackground:image.get('type')===__WEBPACK_IMPORTED_MODULE_38__constants_imageTypes__["a" /* BARE_IMAGE */]};}return false;}).toJS():[];var images=[productImage.type===__WEBPACK_IMPORTED_MODULE_38__constants_imageTypes__["b" /* MATERIAL_IMAGE */]?baseProductImage:{},productImage].concat(_toConsumableArray(variantImages),_toConsumableArray(productImages)).filter(function(item){return Object.keys(item).length;});return images;};var ProductPage=function(_Component){_inherits(ProductPage,_Component);function ProductPage(props){_classCallCheck(this,ProductPage);var _this=_possibleConstructorReturn(this,(ProductPage.__proto__||Object.getPrototypeOf(ProductPage)).call(this,props));_this.buyButtonActiveTimeout=null;_this.state={stickyBoxScrollPositionChanged:false,scrollPosition:window.pageYOffset,selectedOptions:{},buyButtonActive:false,quantity:1,recentlyViewedProducts:[]};_this.setProductVariant=_this.setProductVariant.bind(_this);_this.setProductOption=_this.setProductOption.bind(_this);_this.buyButtonHandler=_this.buyButtonHandler.bind(_this);_this.stickyBoxScrollHandler=_this.stickyBoxScrollHandler.bind(_this);_this.renderRelatedProducts=_this.renderRelatedProducts.bind(_this);_this.renderRecentlyViewedProducts=_this.renderRecentlyViewedProducts.bind(_this);_this.specificationsOpened=_this.specificationsOpened.bind(_this);_this.onChangeQuantity=_this.onChangeQuantity.bind(_this);_this.onIncreaseQuantity=_this.onIncreaseQuantity.bind(_this);_this.onDecreaseQuantity=_this.onDecreaseQuantity.bind(_this);return _this;}_createClass(ProductPage,[{key:'componentDidMount',value:function componentDidMount(){var variantsLoaded=this.props.currentProduct.getIn(['variants',0],Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])()).has('url');this.props.fetchProduct({id:this.props.match.params.productId,url:this.props.match.url});if(!this.props.currentProduct.isEmpty()&&variantsLoaded){this.setDefaultOptions(this.props.currentProduct,this.props.location);}window.addEventListener('scroll',this.stickyBoxScrollHandler);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var nextVariantsLoaded=nextProps.currentProduct.getIn(['variants',0],Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])()).has('url');if(this.props.match.params.productId!==nextProps.match.params.productId){this.props.fetchProduct({id:nextProps.match.params.productId,url:nextProps.match.url});this.setState(function(){return{quantity:1};});}if(!this.props.currentProduct.equals(nextProps.currentProduct)&&nextVariantsLoaded){this.setDefaultOptions(nextProps.currentProduct,nextProps.location);Object(__WEBPACK_IMPORTED_MODULE_8__util_analyticEvents__["b" /* analyticsDetailEvent */])('productDetail',nextProps.currentProduct);}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){// Don't update component if only scrollPosition has been updated
return this.state.scrollPosition===nextState.scrollPosition;}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){var nextVariantsLoaded=this.props.currentProduct.getIn(['variants',0],Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])()).has('url');if(nextVariantsLoaded&&!this.props.currentProduct.equals(prevProps.currentProduct)){this.addToListOfRecentlyViewedProducts();this.fetchRecentlyViewedProducts();}}},{key:'componentWillUnmount',value:function componentWillUnmount(){window.removeEventListener('scroll',this.stickyBoxScrollHandler);}},{key:'onChangeQuantity',value:function onChangeQuantity(quantity){this.setState(function(){return{quantity:(quantity>=999?999:quantity)||1};});}},{key:'onIncreaseQuantity',value:function onIncreaseQuantity(){var _this2=this;this.setState(function(){return{quantity:_this2.state.quantity>=999?999:_this2.state.quantity+1};});}},{key:'onDecreaseQuantity',value:function onDecreaseQuantity(){var _this3=this;this.setState(function(){return{quantity:_this3.state.quantity-1||1};});}},{key:'setDefaultOptions',value:function setDefaultOptions(currentProduct,location){var queryStringOptions=__WEBPACK_IMPORTED_MODULE_5_qs___default.a.parse(location.search.substr(1));var activeVariantId=currentProduct.get('variants',Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["List"])()).filter(function(variant){return variant.get('url')===location.pathname;}).getIn([0,'id'],currentProduct.get('defaultVariantId'));this.setState({variantId:activeVariantId});if(!currentProduct.isEmpty()){var baseProductDefaultOptions=currentProduct.get('configurations',Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["List"])()).reduce(function(memory,item){return Object.assign(_defineProperty({},item.get('name'),item.get('defaultOption')),memory);},{});var currentVariantConfigurations=currentProduct.get('variants',Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["List"])()).find(function(variant){return variant.get('url')===location.pathname;}).get('configurations');// check if the current data model has configurations options, before saying it does
var variantProductsDefaultOptions=currentVariantConfigurations?currentProduct.get('variants',Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["List"])()).filter(function(variant){return variant.get('url')===location.pathname;}).getIn([0,'configurations']).reduce(function(memory,item){return Object.assign(_defineProperty({},item.get('name'),item.get('defaultOption')),memory);},{}):{};// Go through selected product options in the URL:s query string and filter out any options that does not exist on the current product
var filteredQueryStringOptions=Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])(queryStringOptions).filter(function(item,index){// See if current option in the URL:s query string matches an option on the base product
var baseConfigurations=currentProduct.get('configurations',Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["List"])()).find(function(configuration){return configuration.get('name')===index;});if(baseConfigurations){return baseConfigurations.get('options',Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["List"])()).find(function(option){return option.get('id')===item;});}var currentProductConfigurations=currentVariantConfigurations&&currentVariantConfigurations.find(function(configuration){return configuration.get('name')===index;});// See if current option in the URL:s query string matches an option on a product variant
var currentProductVariant=currentProductConfigurations&&currentProductConfigurations.get('options',Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["List"])()).find(function(option){return option.get('id')===item;})||Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])();return!!currentProductVariant;}).toJS();var concatResultOfAllDefaultOptions=Object.assign(baseProductDefaultOptions,variantProductsDefaultOptions,filteredQueryStringOptions);this.setState({selectedOptions:concatResultOfAllDefaultOptions});__WEBPACK_IMPORTED_MODULE_26__history__["a" /* default */].replace(this.generateProductUrl(currentProduct,activeVariantId,concatResultOfAllDefaultOptions));}}},{key:'setProductVariant',value:function setProductVariant(id){this.setState({variantId:id});// removed this line since it seemed to cause issues with swapping selected productVariant...
// this.setDefaultOptions(this.props.currentProduct);
if(this.reactSwipe){this.reactSwipe.jumpToFirst();}if(id&&!this.props.currentProduct.isEmpty()&&!this.props.location.pathname.includes(id)){__WEBPACK_IMPORTED_MODULE_26__history__["a" /* default */].replace(this.generateProductUrl(undefined,id));}}},{key:'setProductOption',value:function setProductOption(id,type){var selectedOption=_defineProperty({},type,id);var newSelectedOptions=Object.assign(this.state.selectedOptions,selectedOption);this.setState({selectedOptions:newSelectedOptions});if(newSelectedOptions&&!this.props.currentProduct.isEmpty()){__WEBPACK_IMPORTED_MODULE_26__history__["a" /* default */].replace(this.generateProductUrl(undefined,undefined,newSelectedOptions));}}},{key:'getProductSpecificationsList',value:function getProductSpecificationsList(){var _this4=this;// a function that takes the specifications from the base product and merges them with the specifications from the selected variant product
if(!this.state.variantId||!this.props.currentProduct){return false;}var baseSpecifications=this.props.currentProduct.get('specifications',Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["List"])());var variantSpecificationsBase=this.props.currentProduct.get('variants',Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["List"])()).find(function(variant){return variant.get('id')===_this4.state.variantId;});var variantSpecifications=typeof variantSpecificationsBase==='undefined'?{}:variantSpecificationsBase.get('specifications',Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["List"])());return baseSpecifications.mergeDeep(variantSpecifications).map(function(item,index){if(!item.get('key')||!item.get('value'))return false;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33__styles_ListItem__["a" /* ListItem */],{key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_34__styles_Label__["a" /* Label */],null,item.get('key'),':'),' ',item.get('value'));}).toArray();}},{key:'getRecentlyViewedProducts',value:function getRecentlyViewedProducts(){if(this.localStorageAvailable()){var currentProductId=this.props.currentProduct.get('id');var recentlyViewedProducts=JSON.parse(window.localStorage.getItem('recentlyViewedProducts'))||[];var recentlyViewedProductsExcludingCurrentProduct=recentlyViewedProducts.filter(function(product){return product!==currentProductId;});return recentlyViewedProductsExcludingCurrentProduct;}return[];}},{key:'localStorageAvailable',value:function localStorageAvailable(){if(typeof window==='undefined'){return false;}var test='localStorageAvailable';try{window.localStorage.setItem(test,test);window.localStorage.removeItem(test);return true;}catch(error){return false;}}},{key:'fetchRecentlyViewedProducts',value:function fetchRecentlyViewedProducts(){var _this5=this;var recentlyViewedProducts=this.getRecentlyViewedProducts();if(recentlyViewedProducts.length){__WEBPACK_IMPORTED_MODULE_11__api_generalApi__["a" /* axiosSingleton */].get('/products/',{params:{productIds:recentlyViewedProducts}}).then(function(_ref){var recentlyViewedProductData=_ref.data;var sortedRecentlyViewedProductData=recentlyViewedProductData.sort(function(a,b){return recentlyViewedProducts.indexOf(b.id)-recentlyViewedProducts.indexOf(a.id);});_this5.setState(function(){return{recentlyViewedProducts:Object(__WEBPACK_IMPORTED_MODULE_10__util_mapToObject__["b" /* mapToObject */])(sortedRecentlyViewedProductData)};});}).catch(function(error){throw error;});}}},{key:'addToListOfRecentlyViewedProducts',value:function addToListOfRecentlyViewedProducts(){var recentlyViewedProducts=this.getRecentlyViewedProducts();var productId=this.props.currentProduct.get('id');var updatedRecentlyViewedProducts=[].concat(_toConsumableArray(recentlyViewedProducts),[productId]);var numberOfStoredRecentlyViewedProducts=6+1;if(updatedRecentlyViewedProducts.length>numberOfStoredRecentlyViewedProducts){updatedRecentlyViewedProducts=updatedRecentlyViewedProducts.slice(numberOfStoredRecentlyViewedProducts*-1);}window.localStorage.setItem('recentlyViewedProducts',JSON.stringify(updatedRecentlyViewedProducts));}},{key:'productIdsToObjects',value:function productIdsToObjects(ids){var _this6=this;return ids.map(function(item){return _this6.props.products.filter(function(x,index){return index===item;});}).toMap().flatten(1);}},{key:'productListToMap',value:function productListToMap(productList){return productList.toMap().mapEntries(function(entry){var newEntry=entry;newEntry[0]=entry[1].get('id');return newEntry;});}},{key:'buyButtonHandler',value:function buyButtonHandler(id){var _this7=this;clearTimeout(this.buyButtonActiveTimeout);this.setState(function(){return{buyButtonActive:true};});this.props.addCartItem({endpointUrl:__WEBPACK_IMPORTED_MODULE_27__constants_endpoints__["c" /* CART_ADD_URL */],body:{id:id,Quantity:this.state.quantity,Options:Object.values(this.state.activeAndSelectedOptions)}});this.setState(function(){return{quantity:1};});this.buyButtonActiveTimeout=setTimeout(function(){return _this7.setState(function(){return{buyButtonActive:false};});},1800);this.props.setViewstate('productAddedToCart',true);}},{key:'stickyBoxScrollHandler',value:function stickyBoxScrollHandler(){var _this8=this;var currentScrollPosition=window.pageYOffset;if(this.props.viewstate.get('pageWidth')>=960){if(this.stickyContent&&!this.state.stickyBoxScrollPositionChanged&&window.scrollTo){setTimeout(function(){_this8.stickyContent.scrollTo(0,0);_this8.setState({stickyBoxScrollPositionChanged:true});},0);}else if(this.stickyContent&&window.scrollBy){var diff=this.state.scrollPosition-currentScrollPosition;this.stickyContent.scrollBy(0,-diff);}}this.setState({scrollPosition:window.pageYOffset});}},{key:'specificationsOpened',value:function specificationsOpened(){var _this9=this;setTimeout(function(){if(_this9.stickyContent.scrollHeight>_this9.stickyContent.parentElement.scrollHeight&&Object.scrollTo){_this9.stickyContent.scrollTo({left:0,top:_this9.stickyContent.scrollHeight,behavior:'smooth'});}},200);}},{key:'generateProductUrl',value:function generateProductUrl(){var currentProduct=arguments.length>0&&arguments[0]!==undefined?arguments[0]:this.props.currentProduct;var variantId=arguments.length>1&&arguments[1]!==undefined?arguments[1]:this.state.variantId;var selectedOptions=arguments.length>2&&arguments[2]!==undefined?arguments[2]:this.state.selectedOptions;var baseConfigurations=currentProduct.get('configurations',Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["List"])()).toMap().mapKeys(function(key,value){return value.get('name');});var variantConfigurations=currentProduct.get('variants',Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["List"])()).find(function(variant){return variant.get('id')===variantId;}).get('configurations',Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["List"])()).toMap().mapKeys(function(key,value){return value.get('name');});var activeConfigurations=baseConfigurations.mergeDeep(variantConfigurations);var activeAndSelectedOptions=Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])(selectedOptions).filter(function(item,index){return Object.keys(activeConfigurations.toJS()).includes(index);});var isSelectedOptionsValid=activeAndSelectedOptions.map(function(option,index){var isValid=!!activeConfigurations.getIn([index,'options']).find(function(x){return x.get('id')===option;});// the selected configuration option still exists on the new variant, so we'll keep it
if(isValid)return option;// the selected configuration option does NOT exist on the new variant, revert to the defaultOption
return activeConfigurations.getIn([index,'defaultOption']);}).toJS();this.setState({activeAndSelectedOptions:isSelectedOptionsValid});var configurationQueryString=__WEBPACK_IMPORTED_MODULE_5_qs___default.a.stringify(selectedOptions);return currentProduct.get('variants',Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["List"])()).find(function(variant){return variant.get('id')===variantId;}).get('url')+'?'+configurationQueryString;}},{key:'renderRelatedProducts',value:function renderRelatedProducts(){if(!this.props.currentProduct.get('relatedProducts',[]).size){return false;}var products=this.productListToMap(this.props.currentProduct.get('relatedProducts'));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_35__styles_Container__["a" /* Container */],{hideOnPrint:true,productPage:!(this.props.viewstate.get('pageWidth')<960)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__components_LinedHeading__["a" /* default */],{noMargin:true,bgColor:__WEBPACK_IMPORTED_MODULE_28__styles_helpers_variables__["c" /* color */].lightGrey},'Relaterade Produkter'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__components_ProductList__["a" /* default */],{data:products}));}},{key:'renderRecentlyViewedProducts',value:function renderRecentlyViewedProducts(){if(!(this.state.recentlyViewedProducts&&this.state.recentlyViewedProducts.size)){return null;}var products=this.productListToMap(this.state.recentlyViewedProducts);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_35__styles_Container__["a" /* Container */],{hideOnPrint:true,productPage:!(this.props.viewstate.get('pageWidth')<960)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__components_LinedHeading__["a" /* default */],{noMargin:true,bgColor:__WEBPACK_IMPORTED_MODULE_28__styles_helpers_variables__["c" /* color */].lightGrey},'Senaste visade produkter'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__components_ProductList__["a" /* default */],{columns:6,center:true,data:products}));}},{key:'renderProductSpecifications',value:function renderProductSpecifications(selectedVariant){var washingInstructionsSize=selectedVariant.get('washingInstructions',Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["List"])()).size;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_32__styles_ListParent__["a" /* ListParent */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_39__components_Conditional__["a" /* Conditional */],{show:!!selectedVariant.get('id')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33__styles_ListItem__["a" /* ListItem */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_34__styles_Label__["a" /* Label */],null,'Artikelnummer:'),' ',selectedVariant.get('id'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_39__components_Conditional__["a" /* Conditional */],{show:!!this.props.currentProduct.getIn(['brand','name'])},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33__styles_ListItem__["a" /* ListItem */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_34__styles_Label__["a" /* Label */],null,'Varum\xE4rke:'),' ',this.props.currentProduct.getIn(['brand','name']))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_39__components_Conditional__["a" /* Conditional */],{show:!!this.props.currentProduct.getIn(['designer','name'])},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33__styles_ListItem__["a" /* ListItem */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_34__styles_Label__["a" /* Label */],null,'Formgivare:'),' ',this.props.currentProduct.getIn(['designer','name']))),this.getProductSpecificationsList(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_39__components_Conditional__["a" /* Conditional */],{show:washingInstructionsSize===1},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33__styles_ListItem__["a" /* ListItem */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_34__styles_Label__["a" /* Label */],null,'Tv\xE4ttr\xE5d:'),selectedVariant.get('washingInstructions',Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["List"])()).map(function(icon){return icon.get('value')!=='#tomt#'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,' '+icon.get('value'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_36__components_WashIcon__["a" /* WashIcon */],{id:icon.get('key')}));}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_39__components_Conditional__["a" /* Conditional */],{show:washingInstructionsSize>1},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33__styles_ListItem__["a" /* ListItem */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_34__styles_Label__["a" /* Label */],null,'Tv\xE4ttr\xE5d:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WashList,null,selectedVariant.get('washingInstructions',Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["List"])()).map(function(icon){return icon.get('value')!=='#tomt#'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WashListItem,null,icon.get('value'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_36__components_WashIcon__["a" /* WashIcon */],{id:icon.get('key')}));})))));}},{key:'render',value:function render(){var _this10=this;var _props=this.props,currentProduct=_props.currentProduct,viewstate=_props.viewstate,request=_props.request;var activeAndSelectedOptions=this.state.activeAndSelectedOptions;var pageWidth=viewstate.get('pageWidth');if(request.get('statusCode')===404)return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__NotFoundPage__["a" /* default */],null);if(request.get('status')==='ERROR')return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__ErrorPage__["a" /* default */],null);if(!currentProduct.size||!this.state.variantId)return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LoadingProductPage,null);var selectedVariant=currentProduct.get('variants',Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])()).find(function(variant){return variant.get('url')===_this10.props.location.pathname;})||Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])();var productSpecifications=this.renderProductSpecifications(selectedVariant);var productImageUrl=__WEBPACK_IMPORTED_MODULE_27__constants_endpoints__["n" /* SITE_ROOT_URL */]+selectedVariant.getIn(['mainImage','url'],Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])());var productImageAlt=selectedVariant.getIn(['mainImage','alt'],Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])());var productImageType=selectedVariant.getIn(['mainImage','type'],Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])());var baseProductImageUrl=__WEBPACK_IMPORTED_MODULE_27__constants_endpoints__["n" /* SITE_ROOT_URL */]+currentProduct.getIn(['mainImage','url'],Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])());var baseProductImageAlt=currentProduct.getIn(['mainImage','alt'],Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])());var complementaryProducts=this.productListToMap(currentProduct.get('complementaryProducts',Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["List"])()));var relatedProducts=this.renderRelatedProducts();var recentlyViewedProducts=this.renderRecentlyViewedProducts();var allOptions=currentProduct.get('configurations',Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["List"])()).toSet().union(selectedVariant.get('configurations',Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["List"])().toSet())).toList();var optionsPrice=allOptions.map(function(item){return item.get('options').find(function(x){return x.get('id')===activeAndSelectedOptions[item.get('name')];}).get('price');});var currentOptionsPrice=optionsPrice.reduce(function(memory,optionPrice){return memory+optionPrice;},0);if(pageWidth<960){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Page__["a" /* default */],{meta:selectedVariant.get('metaData'),canonical:currentProduct.get('url'),bgColor:__WEBPACK_IMPORTED_MODULE_28__styles_helpers_variables__["c" /* color */].lightGrey,lastBreadcrumbItem:{title:currentProduct.get('name'),url:this.props.location.pathname}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__components_SwipeWrapper__["a" /* default */],{ref:function ref(reactSwipe){_this10.reactSwipe=reactSwipe;},currentProduct:currentProduct,selectedVariant:selectedVariant,pageWidth:pageWidth,productImageUrl:productImageUrl,productImageAlt:productImageAlt,baseProductImageUrl:baseProductImageUrl,baseProductImageAlt:baseProductImageAlt,productImageType:productImageType}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_35__styles_Container__["a" /* Container */],{noPadding:true,noPaddingBottom:true,pageWidth:pageWidth,productPageMobileFirst:true},currentProduct.getIn(['brand','url'])&&currentProduct.getIn(['brand','name'])?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_31__styles_SubHeading__["a" /* SubHeading */].link,{to:currentProduct.getIn(['brand','url']),uppercase:true,color:__WEBPACK_IMPORTED_MODULE_28__styles_helpers_variables__["c" /* color */].black,productPageMoble:true},currentProduct.getIn(['brand','name'])):false,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29__styles_Heading__["a" /* Heading */],{productPageMoble:true},selectedVariant.get('name'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_35__styles_Container__["a" /* Container */],{pageWidth:pageWidth,pb:16},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__components_ProductConfiguration__["a" /* default */],{isMobileDevice:true,location:this.props.location.pathname,data:currentProduct.get('variants',Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])()),optionsData:allOptions,setProductVariant:this.setProductVariant,setProductOption:this.setProductOption,selected:this.state.variantId,selectedOptions:this.state.activeAndSelectedOptions,currentProduct:currentProduct,price:selectedVariant.get('price')+currentOptionsPrice})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__components_productPage_ProductPageInfo_ProductPageInfo__["a" /* default */],{product:currentProduct}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__components_StickyButton__["a" /* default */],{success:true,disabled:this.state.buyButtonActive,active:this.state.buyButtonActive,onClick:function onClick(){_this10.buyButtonHandler(selectedVariant.get('id'));},selectedVariant:selectedVariant,currentOptionsPrice:currentOptionsPrice,quantitySelector:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__components_productPage_ProductQuantitySelector_ProductQuantitySelector__["a" /* default */],{quantity:this.state.quantity,handleChange:this.onChangeQuantity,handleDecrease:this.onDecreaseQuantity,handleIncrease:this.onIncreaseQuantity,mobile:true})}),complementaryProducts.size>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_35__styles_Container__["a" /* Container */],{pt:2,pb:28,pageWidth:pageWidth},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ComplimentaryProductsContainer,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'Komplettera med'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_40__components_productPage_ProductPageComplimentaryProducts_ProductPageComplimentaryProducts__["a" /* default */],{complementaryProducts:complementaryProducts}))),relatedProducts,recentlyViewedProducts);}var numberOfProductConfigurations=(currentProduct.get('variants',Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])()).toJS().length>1?1:0)+allOptions.toJS().length;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Page__["a" /* default */],{meta:selectedVariant.get('metaData'),canonical:currentProduct.get('url'),bgColor:__WEBPACK_IMPORTED_MODULE_28__styles_helpers_variables__["c" /* color */].lightGrey,lastBreadcrumbItem:{title:currentProduct.get('name'),url:this.props.location.pathname}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_35__styles_Container__["a" /* Container */],{padded:true,pageWidth:pageWidth,productPage:true,productPageFirst:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grid_styled__["Flex"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MainProductContent,{width:5/12,pr:60,numberOfProductConfigurations:numberOfProductConfigurations},currentProduct.getIn(['brand','url'])&&currentProduct.getIn(['brand','name'])&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_31__styles_SubHeading__["a" /* SubHeading */].link,{to:currentProduct.getIn(['brand','url']),color:__WEBPACK_IMPORTED_MODULE_28__styles_helpers_variables__["c" /* color */].black,margin:'0',uppercase:true,productPage:true},currentProduct.getIn(['brand','name'])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29__styles_Heading__["a" /* Heading */],{margin:'0',productPage:true},selectedVariant.get('name')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__components_RenderPrice__["a" /* default */],{currentOptionsPrice:currentOptionsPrice,price:selectedVariant.get('price'),originalPrice:selectedVariant.get('originalPrice'),productPage:true,fontWeight:'700'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__components_productPage_ProductPageDescription_ProductPageDescription__["a" /* default */],{description:__WEBPACK_IMPORTED_MODULE_4_decode_html___default()(currentProduct.get('description',''))}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__components_ProductConfiguration__["a" /* default */],{location:this.props.location.pathname,data:currentProduct.get('variants',Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])()),optionsData:allOptions,setProductVariant:this.setProductVariant,setProductOption:this.setProductOption,selected:this.state.variantId,selectedOptions:this.state.activeAndSelectedOptions,currentProduct:currentProduct,price:selectedVariant.get('price')+currentOptionsPrice}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ProductBuyContainer,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__components_productPage_ProductQuantitySelector_ProductQuantitySelector__["a" /* default */],{quantity:this.state.quantity,handleChange:this.onChangeQuantity,handleDecrease:this.onDecreaseQuantity,handleIncrease:this.onIncreaseQuantity}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_30__styles_Button__["a" /* Button */],{success:true,buy:true,disabled:this.state.buyButtonActive,active:this.state.buyButtonActive,onClick:function onClick(){_this10.buyButtonHandler(selectedVariant.get('id'));}},'L\xE4gg i varukorg')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__components_productPage_ProductUSP_ProductUSP__["a" /* default */],{deliveryInformation:selectedVariant.get('deliveryInformation')}),complementaryProducts.size>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ComplimentaryProductsContainer,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'Komplettera med'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_40__components_productPage_ProductPageComplimentaryProducts_ProductPageComplimentaryProducts__["a" /* default */],{complementaryProducts:complementaryProducts})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PrintSpecifications,null,productSpecifications)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grid_styled__["Box"],{width:7/12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_productPage_ProductPageGallery_ProductPageGallery__["a" /* default */],{images:createProductImageList(currentProduct,selectedVariant),tags:selectedVariant.get('tags',Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["List"])()),variantId:this.state.variantId})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__components_productPage_ProductPageInfo_ProductPageInfo__["a" /* default */],{product:currentProduct}),relatedProducts,recentlyViewedProducts);}}]);return ProductPage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var LoadingProductPage=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].div(_templateObject);var WashList=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].ul(_templateObject2);var WashListItem=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].li(_templateObject3,__WEBPACK_IMPORTED_MODULE_37__styles_helpers_mixins__["d" /* fontFamilyBody */]);var PrintSpecifications=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].div(_templateObject4,__WEBPACK_IMPORTED_MODULE_37__styles_helpers_mixins__["j" /* showOnPrint */]);var MainProductContent=Object(__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_2_grid_styled__["Box"])(_templateObject5,function(props){return props.numberOfProductConfigurations===0&&Object(__WEBPACK_IMPORTED_MODULE_6_styled_components__["css"])(_templateObject6);});var ProductBuyContainer=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].div(_templateObject7);var ComplimentaryProductsContainer=__WEBPACK_IMPORTED_MODULE_6_styled_components__["default"].div(_templateObject8);ProductPage.defaultProps={currentProduct:Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])(),products:Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])(),request:Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])(),viewstate:Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])()};ProductPage.propTypes={currentProduct:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"]),products:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"]),request:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"]),viewstate:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"]),setViewstate:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,fetchProduct:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,addCartItem:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,match:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,location:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__store_connect__["a" /* default */])(ProductPage,{addCartItem:__WEBPACK_IMPORTED_MODULE_9__actions_actionCreators__["a" /* addCartItem */],setViewstate:__WEBPACK_IMPORTED_MODULE_9__actions_actionCreators__["W" /* setViewstate */],fetchProduct:__WEBPACK_IMPORTED_MODULE_9__actions_actionCreators__["H" /* fetchProduct */]},function(store,props){return{currentProduct:store.products.data.find(function(product){return product.get('url')===props.location.pathname.replace(/\/$/,'');})||store.products.data.find(function(product){return product.get('variants',Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["List"])()).find(function(variant){return variant.get('url')===props.location.pathname.replace(/\/$/,'');});}),products:store.products.data,request:store.products.request.get(props.location.pathname.replace(/\/$/,'')),viewstate:store.viewstate};}));

/***/ }),
/* 662 */
/***/ (function(module, exports) {

// Store markers outside of the function scope,
// not to recreate them on every call
var entities = {
  'amp': '&',
  'apos': '\'',
  'lt': '<',
  'gt': '>',
  'quot': '"',
  'nbsp': '\xa0'
};
var entityPattern = /&([a-z]+);/ig;

module.exports = function decodeHTMLEntities(text) {
  // A single replace pass with a static RegExp is faster than a loop
  return text.replace(entityPattern, function(match, entity) {
    entity = entity.toLowerCase();
    if (entities.hasOwnProperty(entity)) {
      return entities[entity];
    }
    // return original string if there is no matching entity (no replace)
    return match;
  });
};


/***/ }),
/* 663 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export GalleryThumbnails */
/* unused harmony export GalleryThumbnailScrollButton */
/* unused harmony export GalleryThumbnailList */
/* unused harmony export GalleryThumbnailListItem */
/* unused harmony export GalleryThumbnailButton */
/* unused harmony export GalleryThumbnailImage */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_helpers_variables__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  position: relative;\n'],['\n  position: relative;\n']),_templateObject2=_taggedTemplateLiteral(['\n  position: relative;\n  width: 83%;\n  background-color: ',';\n  ',';\n  @media print {\n    width: 100%;\n  }\n  &:after {\n    content: \'\';\n    display: block;\n    padding: 0 0 100%;\n  }\n'],['\n  position: relative;\n  width: 83%;\n  background-color: ',';\n  ',';\n  @media print {\n    width: 100%;\n  }\n  &:after {\n    content: \'\';\n    display: block;\n    padding: 0 0 100%;\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n      background-color: transparent;\n    '],['\n      background-color: transparent;\n    ']),_templateObject4=_taggedTemplateLiteral(['\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 100%;\n  width: 100%;\n  object-fit: contain;\n'],['\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 100%;\n  width: 100%;\n  object-fit: contain;\n']),_templateObject5=_taggedTemplateLiteral(['\n  display: flex;\n  flex-wrap: wrap;\n  list-style: none;\n  position: absolute;\n  top: 0;\n  left: 0;\n  max-width: calc(100% + 5px);\n  margin: 0 -5px -5px 0;\n  padding: 10px;\n'],['\n  display: flex;\n  flex-wrap: wrap;\n  list-style: none;\n  position: absolute;\n  top: 0;\n  left: 0;\n  max-width: calc(100% + 5px);\n  margin: 0 -5px -5px 0;\n  padding: 10px;\n']),_templateObject6=_taggedTemplateLiteral(['\n  min-width: 0;\n  padding: 0 5px 5px 0;\n'],['\n  min-width: 0;\n  padding: 0 5px 5px 0;\n']),_templateObject7=_taggedTemplateLiteral(['\n  padding: 8px 10px;\n  background-color: #a5c4c3;\n  background-color: ',';\n  color: ',';\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 0.75;\n  letter-spacing: 0.125em;\n  text-transform: uppercase;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n'],['\n  padding: 8px 10px;\n  background-color: #a5c4c3;\n  background-color: ',';\n  color: ',';\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 0.75;\n  letter-spacing: 0.125em;\n  text-transform: uppercase;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n']),_templateObject8=_taggedTemplateLiteral(['\n  position: absolute;\n  top: 0;\n  right: 0;\n  height: 100%;\n  width: 17.1%;\n  padding: 0 0 0 20px;\n  @media print {\n    display: none;\n  }\n'],['\n  position: absolute;\n  top: 0;\n  right: 0;\n  height: 100%;\n  width: 17.1%;\n  padding: 0 0 0 20px;\n  @media print {\n    display: none;\n  }\n']),_templateObject9=_taggedTemplateLiteral(['\n  position: absolute;\n  left: 50%;\n  margin: 0 0 0 10px;\n  outline: none; // \u2026\n  border: none;\n  padding: 20px;\n  background-color: transparent;\n  cursor: pointer;\n  opacity: 0;\n  visibility: hidden;\n  transition: opacity 0.125s ease, visibility 0s linear 0.125s;\n  ',';\n  ',';\n  ',';\n  ',';\n  &:after {\n    content: \'\';\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    height: 15px;\n    width: 15px;\n    background-image: url(\'/images/icons/arrow.svg\');\n    background-position: center;\n    background-repeat: no-repeat;\n    background-size: contain;\n    transform: translate(-50%, -50%);\n    ',';\n  }\n'],['\n  position: absolute;\n  left: 50%;\n  margin: 0 0 0 10px;\n  outline: none; // \u2026\n  border: none;\n  padding: 20px;\n  background-color: transparent;\n  cursor: pointer;\n  opacity: 0;\n  visibility: hidden;\n  transition: opacity 0.125s ease, visibility 0s linear 0.125s;\n  ',';\n  ',';\n  ',';\n  ',';\n  &:after {\n    content: \'\';\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    height: 15px;\n    width: 15px;\n    background-image: url(\'/images/icons/arrow.svg\');\n    background-position: center;\n    background-repeat: no-repeat;\n    background-size: contain;\n    transform: translate(-50%, -50%);\n    ',';\n  }\n']),_templateObject10=_taggedTemplateLiteral(['\n      top: 0;\n      transform: translate(-50%, -100%);\n    '],['\n      top: 0;\n      transform: translate(-50%, -100%);\n    ']),_templateObject11=_taggedTemplateLiteral(['\n      bottom: 0;\n      transform: translate(-50%, 100%);\n    '],['\n      bottom: 0;\n      transform: translate(-50%, 100%);\n    ']),_templateObject12=_taggedTemplateLiteral(['\n      opacity: 1;\n      visibility: visible;\n      transition: opacity 0.125s ease, visibility 0s linear 0s;\n    '],['\n      opacity: 1;\n      visibility: visible;\n      transition: opacity 0.125s ease, visibility 0s linear 0s;\n    ']),_templateObject13=_taggedTemplateLiteral(['\n      opacity: 0.5;\n    '],['\n      opacity: 0.5;\n    ']),_templateObject14=_taggedTemplateLiteral(['\n        transform: translate(-50%, -50%) rotate(180deg);\n      '],['\n        transform: translate(-50%, -50%) rotate(180deg);\n      ']),_templateObject15=_taggedTemplateLiteral(['\n  list-style: none;\n  height: 100%;\n  margin: 0;\n  padding: 0;\n  overflow-y: auto;\n  scroll-snap-type: y;\n'],['\n  list-style: none;\n  height: 100%;\n  margin: 0;\n  padding: 0;\n  overflow-y: auto;\n  scroll-snap-type: y;\n']),_templateObject16=_taggedTemplateLiteral(['\n  margin: 0 0 20px;\n  scroll-snap-align: start;\n  &:last-child {\n    margin: 0;\n  }\n'],['\n  margin: 0 0 20px;\n  scroll-snap-align: start;\n  &:last-child {\n    margin: 0;\n  }\n']),_templateObject17=_taggedTemplateLiteral(['\n  display: block;\n  position: relative;\n  width: 100%;\n  padding: 0;\n  border: none;\n  outline: none;\n  background-color: ',';\n  cursor: pointer;\n  ',';\n  &:after {\n    content: \'\';\n    display: block;\n    padding: 0 0 100%;\n  }\n'],['\n  display: block;\n  position: relative;\n  width: 100%;\n  padding: 0;\n  border: none;\n  outline: none;\n  background-color: ',';\n  cursor: pointer;\n  ',';\n  &:after {\n    content: \'\';\n    display: block;\n    padding: 0 0 100%;\n  }\n']),_templateObject18=_taggedTemplateLiteral(['\n    /* border: 2.5px solid ','; */\n  '],['\n    /* border: 2.5px solid ','; */\n  ']),_templateObject19=_taggedTemplateLiteral(['\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 100%;\n  width: 100%;\n  object-fit: contain;\n  ',';\n'],['\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 100%;\n  width: 100%;\n  object-fit: contain;\n  ',';\n']),_templateObject20=_taggedTemplateLiteral(['\n      object-fit: cover;\n    '],['\n      object-fit: cover;\n    ']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProductPageGallery=function(_React$Component){_inherits(ProductPageGallery,_React$Component);function ProductPageGallery(props){_classCallCheck(this,ProductPageGallery);var _this=_possibleConstructorReturn(this,(ProductPageGallery.__proto__||Object.getPrototypeOf(ProductPageGallery)).call(this,props));_this.galleryThumbnailListRef=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();_this.setAsMainImage=_this.setAsMainImage.bind(_this);_this.checkScrollArrowVisibility=_this.checkScrollArrowVisibility.bind(_this);_this.scrollThumbnails=_this.scrollThumbnails.bind(_this);_this.onResize=_this.onResize.bind(_this);_this.onThumbnailListScroll=_this.onThumbnailListScroll.bind(_this);_this.state={variantId:_this.props.variantId,mainImage:_this.props.images[0]||{},thumbnailArrowsVisible:false,thumbnailScrolledToTop:true,thumbnailScrolledToBottom:false,lastTime:0};return _this;}_createClass(ProductPageGallery,[{key:'componentDidMount',value:function componentDidMount(){this.checkScrollArrowVisibility();window.addEventListener('resize',this.onResize);var galleryThumbnailListRefCurrent=this.galleryThumbnailListRef.current;if(galleryThumbnailListRefCurrent){galleryThumbnailListRefCurrent.addEventListener('scroll',this.onThumbnailListScroll);}}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){if(this.props.variantId!==prevProps.variantId){this.checkScrollArrowVisibility();var galleryThumbnailListRefCurrent=this.galleryThumbnailListRef.current;if(galleryThumbnailListRefCurrent&&galleryThumbnailListRefCurrent.scrollTop>0){galleryThumbnailListRefCurrent.scrollTop=0;}}}},{key:'componentWillUnmount',value:function componentWillUnmount(){window.removeEventListener('resize',this.onResize);var galleryThumbnailListRefCurrent=this.galleryThumbnailListRef.current;if(galleryThumbnailListRefCurrent){galleryThumbnailListRefCurrent.removeEventListener('scroll',this.onThumbnailListScroll);}}},{key:'onResize',value:function onResize(){this.checkScrollArrowVisibility();}},{key:'onThumbnailListScroll',value:function onThumbnailListScroll(){this.checkScrollArrowVisibility(true);}},{key:'setAsMainImage',value:function setAsMainImage(newMainImageUrl){this.setState({mainImage:this.props.images.find(function(image){return image.url===newMainImageUrl;})});}},{key:'checkScrollArrowVisibility',value:function checkScrollArrowVisibility(throttle){if(throttle&&!(this.state.lastTime+1<Date.now())){return;}var galleryThumbnailListRefCurrent=this.galleryThumbnailListRef.current;if(galleryThumbnailListRefCurrent){this.setState({thumbnailArrowsVisible:galleryThumbnailListRefCurrent.offsetHeight<galleryThumbnailListRefCurrent.scrollHeight,thumbnailScrolledToTop:galleryThumbnailListRefCurrent.scrollTop===0,thumbnailScrolledToBottom:galleryThumbnailListRefCurrent.scrollTop===galleryThumbnailListRefCurrent.scrollHeight-galleryThumbnailListRefCurrent.offsetHeight,lastTime:Date.now()});}}},{key:'scrollThumbnails',value:function scrollThumbnails(direction){var galleryThumbnailListRefCurrent=this.galleryThumbnailListRef.current;if(galleryThumbnailListRefCurrent){var distance=galleryThumbnailListRefCurrent.offsetWidth+20;galleryThumbnailListRefCurrent.scrollBy({top:distance*direction,left:0,behavior:'smooth'});}}},{key:'render',value:function render(){var _this2=this;var _props=this.props,images=_props.images,tags=_props.tags;var _state=this.state,mainImage=_state.mainImage,thumbnailArrowsVisible=_state.thumbnailArrowsVisible,thumbnailScrolledToTop=_state.thumbnailScrolledToTop,thumbnailScrolledToBottom=_state.thumbnailScrolledToBottom;if(!images||!images.length||!mainImage){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Gallery,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(GalleryMain,{needsBackground:mainImage.needsBackground},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(GalleryMainImage,{src:mainImage.url,alt:mainImage.alt}),tags.size>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(GalleryTagList,null,tags.map(function(tag,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(GalleryTagListItem,{key:'gallery-tag-list-item-'+tag.get('key')+'-'+tag.get('value')+'-'+index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(GalleryTag,{color:tag.get('key')},tag.get('value')));}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(GalleryThumbnails,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(GalleryThumbnailScrollButton,{type:'button',title:'Scrolla upp',direction:'up',visible:thumbnailArrowsVisible,disabled:thumbnailArrowsVisible&&thumbnailScrolledToTop,onClick:function onClick(){return _this2.scrollThumbnails(-1);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(GalleryThumbnailList,{innerRef:this.galleryThumbnailListRef},images.map(function(image,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(GalleryThumbnailListItem,{key:'gallery-thumbnail-list-item-'+image.url+'-'+index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(GalleryThumbnailButton,{type:'button',active:image.url===mainImage.url,onClick:function onClick(){return _this2.setAsMainImage(image.url);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(GalleryThumbnailImage,{src:image.url,alt:image.alt,needsBackground:image.needsBackground})));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(GalleryThumbnailScrollButton,{type:'button',title:'Scrolla ner',direction:'down',visible:thumbnailArrowsVisible,disabled:thumbnailArrowsVisible&&thumbnailScrolledToBottom,onClick:function onClick(){return _this2.scrollThumbnails(1);}})));}}],[{key:'getDerivedStateFromProps',value:function getDerivedStateFromProps(props,state){if(props.variantId!==state.variantId){return{variantId:props.variantId,mainImage:props.images[0]||{}};}return null;}}]);return ProductPageGallery;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);ProductPageGallery.defaultProps={images:[],tags:Object(__WEBPACK_IMPORTED_MODULE_3_immutable__["List"])(),variantId:''};ProductPageGallery.propTypes={images:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,tags:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_3_immutable__["List"]),variantId:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (ProductPageGallery);var Gallery=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject);var GalleryMain=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject2,__WEBPACK_IMPORTED_MODULE_4__styles_helpers_variables__["c" /* color */].white,function(props){return!props.needsBackground&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject3);});var GalleryMainImage=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].img(_templateObject4);var GalleryTagList=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].ul(_templateObject5);var GalleryTagListItem=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].li(_templateObject6);var GalleryTag=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject7,function(props){return props.color;},__WEBPACK_IMPORTED_MODULE_4__styles_helpers_variables__["c" /* color */].white);var GalleryThumbnails=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject8);var GalleryThumbnailScrollButton=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].button(_templateObject9,function(props){return props.direction==='up'&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject10);},function(props){return props.direction==='down'&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject11);},function(props){return props.visible&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject12);},function(props){return props.disabled&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject13);},function(props){return props.direction==='up'&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject14);});var GalleryThumbnailList=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].ul(_templateObject15);var GalleryThumbnailListItem=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].li(_templateObject16);var GalleryThumbnailButton=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].button(_templateObject17,__WEBPACK_IMPORTED_MODULE_4__styles_helpers_variables__["c" /* color */].white,function(props){return props.active&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject18,__WEBPACK_IMPORTED_MODULE_4__styles_helpers_variables__["c" /* color */].black);});var GalleryThumbnailImage=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].img(_templateObject19,function(props){return!props.needsBackground&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject20);});

/***/ }),
/* 664 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_Container__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_helpers_variables__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants_endpoints__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_helpers_mixins__ = __webpack_require__(6);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  display: flex;\n  flex-wrap: wrap;\n  @media screen and (min-width: 960px) {\n    margin: 0 -40px 0 0;\n  }\n  @media screen and (min-width: 1440px) {\n    margin: 0 -60px 0 0;\n  }\n  @media print {\n    display: none;\n  }\n'],['\n  display: flex;\n  flex-wrap: wrap;\n  @media screen and (min-width: 960px) {\n    margin: 0 -40px 0 0;\n  }\n  @media screen and (min-width: 1440px) {\n    margin: 0 -60px 0 0;\n  }\n  @media print {\n    display: none;\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  flex: 0 0 100%;\n  max-width: 100%;\n  margin: 0 0 10px;\n  @media screen and (min-width: 960px) {\n    flex: 0 0 33.333%;\n    max-width: 33.333%;\n    margin: 0;\n    padding: 0 40px 0 0;\n  }\n  @media screen and (min-width: 1440px) {\n    flex: 0 0 37.5%;\n    max-width: 37.5%;\n    padding: 0 60px 0 0;\n    &:first-child {\n      flex: 0 0 25%;\n      max-width: 25%;\n    }\n  }\n  &:last-child {\n    margin: 0;\n  }\n'],['\n  flex: 0 0 100%;\n  max-width: 100%;\n  margin: 0 0 10px;\n  @media screen and (min-width: 960px) {\n    flex: 0 0 33.333%;\n    max-width: 33.333%;\n    margin: 0;\n    padding: 0 40px 0 0;\n  }\n  @media screen and (min-width: 1440px) {\n    flex: 0 0 37.5%;\n    max-width: 37.5%;\n    padding: 0 60px 0 0;\n    &:first-child {\n      flex: 0 0 25%;\n      max-width: 25%;\n    }\n  }\n  &:last-child {\n    margin: 0;\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  background-color: ',';\n  @media screen and (min-width: 960px) {\n    background-color: transparent;\n  }\n'],['\n  background-color: ',';\n  @media screen and (min-width: 960px) {\n    background-color: transparent;\n  }\n']),_templateObject4=_taggedTemplateLiteral(['\n  display: flex;\n  align-items: center;\n  position: relative;\n  height: 60px;\n  padding: 10px 50px 10px 20px;\n  cursor: pointer;\n  @media screen and (min-width: 960px) {\n    height: 50px;\n    margin: 0 0 20px;\n    padding: 0;\n    cursor: default;\n  }\n  &:after {\n    content: \'\';\n    position: absolute;\n    top: 50%;\n    right: 20px;\n    height: 10px;\n    width: 10px;\n    background-image: url(\'/images/icons/arrow.svg\');\n    background-position: center;\n    background-repeat: no-repeat;\n    background-size: contain;\n    transform: translateY(-50%);\n    ',';\n    @media screen and (min-width: 960px) {\n      display: none;\n    }\n  }\n'],['\n  display: flex;\n  align-items: center;\n  position: relative;\n  height: 60px;\n  padding: 10px 50px 10px 20px;\n  cursor: pointer;\n  @media screen and (min-width: 960px) {\n    height: 50px;\n    margin: 0 0 20px;\n    padding: 0;\n    cursor: default;\n  }\n  &:after {\n    content: \'\';\n    position: absolute;\n    top: 50%;\n    right: 20px;\n    height: 10px;\n    width: 10px;\n    background-image: url(\'/images/icons/arrow.svg\');\n    background-position: center;\n    background-repeat: no-repeat;\n    background-size: contain;\n    transform: translateY(-50%);\n    ',';\n    @media screen and (min-width: 960px) {\n      display: none;\n    }\n  }\n']),_templateObject5=_taggedTemplateLiteral(['\n        transform: translateY(-50%) rotate(180deg);\n      '],['\n        transform: translateY(-50%) rotate(180deg);\n      ']),_templateObject6=_taggedTemplateLiteral(['\n  flex: 0 0 auto;\n  position: relative;\n  height: 40px;\n  width: 40px;\n  margin: 0 10px 0 0;\n  border-radius: 50%;\n  background-color: ',';\n  color: transparent;\n  overflow: hidden;\n  @media screen and (min-width: 960px) {\n    height: 50px;\n    width: 50px;\n  }\n  ',';\n  ',';\n  > a {\n    color: inherit;\n  }\n  > img,\n  > a > img {\n    position: absolute;\n    top: 0;\n    left: 0;\n    height: 100%;\n    width: 100%;\n    object-fit: contain;\n  }\n'],['\n  flex: 0 0 auto;\n  position: relative;\n  height: 40px;\n  width: 40px;\n  margin: 0 10px 0 0;\n  border-radius: 50%;\n  background-color: ',';\n  color: transparent;\n  overflow: hidden;\n  @media screen and (min-width: 960px) {\n    height: 50px;\n    width: 50px;\n  }\n  ',';\n  ',';\n  > a {\n    color: inherit;\n  }\n  > img,\n  > a > img {\n    position: absolute;\n    top: 0;\n    left: 0;\n    height: 100%;\n    width: 100%;\n    object-fit: contain;\n  }\n']),_templateObject7=_taggedTemplateLiteral(['\n      > img,\n      > a > img {\n        padding: 5px;\n      }\n    '],['\n      > img,\n      > a > img {\n        padding: 5px;\n      }\n    ']),_templateObject8=_taggedTemplateLiteral(['\n      display: none;\n      @media screen and (min-width: 960px) {\n        display: block;\n      }\n      > img,\n      > a > img {\n        padding: 7.5px;\n      }\n    '],['\n      display: none;\n      @media screen and (min-width: 960px) {\n        display: block;\n      }\n      > img,\n      > a > img {\n        padding: 7.5px;\n      }\n    ']),_templateObject9=_taggedTemplateLiteral(['\n  margin: 0;\n  color: ',';\n  ',';\n  font-size: 14px;\n  font-weight: 400;\n  text-transform: uppercase;\n  line-height: 1.25;\n  letter-spacing: 0.1125em;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n  @media screen and (min-width: 960px) {\n    font-size: 17px;\n  }\n  > a {\n    color: inherit;\n    text-decoration: none;\n  }\n'],['\n  margin: 0;\n  color: ',';\n  ',';\n  font-size: 14px;\n  font-weight: 400;\n  text-transform: uppercase;\n  line-height: 1.25;\n  letter-spacing: 0.1125em;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n  @media screen and (min-width: 960px) {\n    font-size: 17px;\n  }\n  > a {\n    color: inherit;\n    text-decoration: none;\n  }\n']),_templateObject10=_taggedTemplateLiteral(['\n  ','\n  font-size: 14px;\n  font-weight: normal;\n  line-height: 1.57;\n  color: ',';\n  overflow: hidden;\n  transition: height 0.125s ease;\n  ',';\n  @media screen and (min-width: 960px) {\n    height: auto !important;\n    overflow: visible;\n    transition: none;\n  }\n'],['\n  ','\n  font-size: 14px;\n  font-weight: normal;\n  line-height: 1.57;\n  color: ',';\n  overflow: hidden;\n  transition: height 0.125s ease;\n  ',';\n  @media screen and (min-width: 960px) {\n    height: auto !important;\n    overflow: visible;\n    transition: none;\n  }\n']),_templateObject11=_taggedTemplateLiteral(['\n      height: 0 !important;\n    '],['\n      height: 0 !important;\n    ']),_templateObject12=_taggedTemplateLiteral(['\n  > a {\n    color: ',';\n    text-decoration: underline;\n  }\n'],['\n  > a {\n    color: ',';\n    text-decoration: underline;\n  }\n']),_templateObject13=_taggedTemplateLiteral(['\n  padding: 0 20px 20px;\n  @media screen and (min-width: 960px) {\n    padding: 0;\n  }\n  > p {\n    margin: 0 0 10px;\n    &:last-child {\n      margin: 0;\n    }\n    + ',' {\n      margin: -5px 0 0;\n      @media screen and (min-width: 960px) {\n        margin: 0;\n      }\n    }\n  }\n'],['\n  padding: 0 20px 20px;\n  @media screen and (min-width: 960px) {\n    padding: 0;\n  }\n  > p {\n    margin: 0 0 10px;\n    &:last-child {\n      margin: 0;\n    }\n    + ',' {\n      margin: -5px 0 0;\n      @media screen and (min-width: 960px) {\n        margin: 0;\n      }\n    }\n  }\n']),_templateObject14=_taggedTemplateLiteral(['\n  list-style: none;\n  margin: 0;\n  padding: 0;\n'],['\n  list-style: none;\n  margin: 0;\n  padding: 0;\n']),_templateObject15=_taggedTemplateLiteral(['\n  overflow: hidden;\n  display: -webkit-box;\n  -webkit-line-clamp: 12;\n  -webkit-box-orient: vertical;\n'],['\n  overflow: hidden;\n  display: -webkit-box;\n  -webkit-line-clamp: 12;\n  -webkit-box-orient: vertical;\n']),_templateObject16=_taggedTemplateLiteral(['\n  margin: 0 0 10px;\n  &:last-child {\n    margin: 0;\n  }\n  > a {\n    color: ',';\n    text-decoration: underline;\n  }\n'],['\n  margin: 0 0 10px;\n  &:last-child {\n    margin: 0;\n  }\n  > a {\n    color: ',';\n    text-decoration: underline;\n  }\n']),_templateObject17=_taggedTemplateLiteral(['\n  font-weight: 600;\n'],['\n  font-weight: 600;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var InfoSectionComponent=function(_React$Component){_inherits(InfoSectionComponent,_React$Component);function InfoSectionComponent(props){_classCallCheck(this,InfoSectionComponent);var _this=_possibleConstructorReturn(this,(InfoSectionComponent.__proto__||Object.getPrototypeOf(InfoSectionComponent)).call(this,props));_this.innerContentRef=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();_this.onHeaderClick=_this.onHeaderClick.bind(_this);_this.onResize=_this.onResize.bind(_this);_this.setHeight=_this.setHeight.bind(_this);_this.state={active:_this.props.type==='description',height:0};return _this;}_createClass(InfoSectionComponent,[{key:'componentDidMount',value:function componentDidMount(){this.setHeight();window.addEventListener('resize',this.onResize);}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){if(this.props.children!==prevProps.children){this.setHeight();}}},{key:'componentWillUnmount',value:function componentWillUnmount(){window.removeEventListener('resize',this.onResize);}},{key:'onResize',value:function onResize(){this.setHeight();}},{key:'onHeaderClick',value:function onHeaderClick(){if(window.innerWidth<960){this.setState({active:!this.state.active});}}},{key:'onHeaderLinkClick',value:function onHeaderLinkClick(event){if(window.innerWidth<960){event.preventDefault();}}},{key:'setHeight',value:function setHeight(){this.setState({height:this.innerContentRef.current.clientHeight});}},{key:'render',value:function render(){var _props=this.props,children=_props.children,type=_props.type,name=_props.name,url=_props.url,imageUrl=_props.imageUrl,imageAlt=_props.imageAlt;var _state=this.state,active=_state.active,height=_state.height;if(!children){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(InfoSection,{type:type},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(InfoSectionHeader,{active:active,onClick:this.onHeaderClick,role:window.innerWidth<960?'button':undefined},imageUrl&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(InfoSectionHeaderImage,{type:type},url?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:url,onClick:this.onHeaderLinkClick},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:imageUrl,alt:imageAlt})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:imageUrl,alt:imageAlt})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(InfoSectionHeaderTitle,null,url?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:url,onClick:this.onHeaderLinkClick},name):name)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(InfoSectionContent,{active:active,style:{height:height}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(InfoSectionContentInner,{innerRef:this.innerContentRef},children)));}}]);return InfoSectionComponent;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);InfoSectionComponent.defaultProps={children:null,type:'',name:'',url:'',imageUrl:'',imageAlt:''};InfoSectionComponent.propTypes={children:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node,type:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,name:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,url:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,imageUrl:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,imageAlt:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string};var ProductPageInfo=function ProductPageInfo(_ref){var product=_ref.product;var variantId=product.get('defaultVariantId');var variant=product.get('variants').filter(function(item){return item.get('id')===variantId;}).get(0);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles_Container__["a" /* Container */],{productPage:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(InfoList,null,window.innerWidth<960&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(InfoListItem,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(InfoSectionComponent,{type:'description',name:'Beskrivning'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{dangerouslySetInnerHTML:{__html:product.get('description')}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(InfoListItem,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(InfoSectionComponent,{type:'specification',name:'Specifikationer',imageUrl:'/images/icons/ruler.svg',imageAlt:'Specifikationer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(InfoSectionList,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(InfoSectionListItem,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(InfoSectionListItemLabel,null,'Artikelnummer:'),' ',variant.get('id')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(InfoSectionListItem,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(InfoSectionListItemLabel,null,'Varum\xE4rke:'),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:variant.getIn(['brand','url'])},variant.getIn(['brand','name']))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(InfoSectionListItem,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(InfoSectionListItemLabel,null,'Formgivare:'),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:variant.getIn(['designer','url'])},variant.getIn(['designer','name']))),(variant.get('specifications')||[]).map(function(specification){return specification.get('value')&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(InfoSectionListItem,{key:'info-section-list-item-'+specification.get('key')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(InfoSectionListItemLabel,null,specification.get('key'),':'),' ',specification.get('value'));})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(InfoListItem,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(InfoSectionComponent,{type:'brand',name:variant.getIn(['brand','name']),url:variant.getIn(['brand','url']),imageUrl:__WEBPACK_IMPORTED_MODULE_6__constants_endpoints__["n" /* SITE_ROOT_URL */]+'/'+variant.getIn(['brand','images',0,'url']),imageAlt:variant.getIn(['brand','images',0,'alt'])},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LineClampedParagraph,null,variant.getIn(['brand','description'])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(InfoSectionReadMore,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:variant.getIn(['brand','url'])},'L\xE4s mer')))),variant.getIn(['designer','name'])&&variant.getIn(['designer','url'])&&variant.getIn(['designer','images',0,'url'])&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(InfoListItem,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(InfoSectionComponent,{type:'designer',name:variant.getIn(['designer','name']),url:variant.getIn(['designer','url']),imageUrl:__WEBPACK_IMPORTED_MODULE_6__constants_endpoints__["n" /* SITE_ROOT_URL */]+'/'+variant.getIn(['designer','images',0,'url']),imageAlt:variant.getIn(['designer','images',0,'alt'])},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LineClampedParagraph,null,variant.getIn(['designer','description'])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(InfoSectionReadMore,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:variant.getIn(['designer','url'])},'L\xE4s mer'))))));};ProductPageInfo.defaultProps={product:Object(__WEBPACK_IMPORTED_MODULE_3_immutable__["Map"])()};ProductPageInfo.propTypes={product:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_3_immutable__["Map"])};/* harmony default export */ __webpack_exports__["a"] = (ProductPageInfo);var InfoList=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject);var InfoListItem=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject2);var InfoSection=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject3,__WEBPACK_IMPORTED_MODULE_5__styles_helpers_variables__["c" /* color */].white);var InfoSectionHeader=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject4,function(props){return props.active&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject5);});var InfoSectionHeaderImage=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject6,__WEBPACK_IMPORTED_MODULE_5__styles_helpers_variables__["c" /* color */].white,function(props){return props.type==='brand'&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject7);},function(props){return props.type==='specification'&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject8);});var InfoSectionHeaderTitle=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].h2(_templateObject9,__WEBPACK_IMPORTED_MODULE_5__styles_helpers_variables__["c" /* color */].black,__WEBPACK_IMPORTED_MODULE_7__styles_helpers_mixins__["e" /* fontFamilyHeading */]);var InfoSectionContent=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject10,__WEBPACK_IMPORTED_MODULE_7__styles_helpers_mixins__["d" /* fontFamilyBody */],__WEBPACK_IMPORTED_MODULE_5__styles_helpers_variables__["c" /* color */].black,function(props){return!props.active&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject11);});var InfoSectionReadMore=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject12,__WEBPACK_IMPORTED_MODULE_5__styles_helpers_variables__["c" /* color */].black);var InfoSectionContentInner=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject13,InfoSectionReadMore);var InfoSectionList=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].ul(_templateObject14);var LineClampedParagraph=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].p(_templateObject15);var InfoSectionListItem=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].li(_templateObject16,__WEBPACK_IMPORTED_MODULE_5__styles_helpers_variables__["c" /* color */].black);var InfoSectionListItemLabel=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].span(_templateObject17);

/***/ }),
/* 665 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Paragraph */
/* unused harmony export Button */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_helpers_variables__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_helpers_mixins__ = __webpack_require__(6);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  margin: 0 0 30px;\n'],['\n  margin: 0 0 30px;\n']),_templateObject2=_taggedTemplateLiteral(['\n  margin: 0;\n  ','\n  font-size: 14px;\n  font-weight: normal;\n  line-height: 1.57;\n  color: ',';\n  overflow: hidden;\n  ',';\n  @media print {\n    display: block;\n  }\n'],['\n  margin: 0;\n  ','\n  font-size: 14px;\n  font-weight: normal;\n  line-height: 1.57;\n  color: ',';\n  overflow: hidden;\n  ',';\n  @media print {\n    display: block;\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n      display: -webkit-box;\n      -webkit-line-clamp: 3;\n      -webkit-box-orient: vertical;\n    '],['\n      display: -webkit-box;\n      -webkit-line-clamp: 3;\n      -webkit-box-orient: vertical;\n    ']),_templateObject4=_taggedTemplateLiteral(['\n  margin: 5px 0 0;\n  padding: 0;\n  border: none;\n  outline: none; // \u2026\n  ','\n  font-size: 14px;\n  font-weight: normal;\n  line-height: 1.57;\n  color: ',';\n  text-decoration: underline;\n  cursor: pointer;\n  @media print {\n    display: none;\n  }\n'],['\n  margin: 5px 0 0;\n  padding: 0;\n  border: none;\n  outline: none; // \u2026\n  ','\n  font-size: 14px;\n  font-weight: normal;\n  line-height: 1.57;\n  color: ',';\n  text-decoration: underline;\n  cursor: pointer;\n  @media print {\n    display: none;\n  }\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProductPageDescription=function(_React$Component){_inherits(ProductPageDescription,_React$Component);function ProductPageDescription(props){_classCallCheck(this,ProductPageDescription);var _this=_possibleConstructorReturn(this,(ProductPageDescription.__proto__||Object.getPrototypeOf(ProductPageDescription)).call(this,props));_this.descriptionRef=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();_this.toggleMoreToRead=_this.toggleMoreToRead.bind(_this);_this.toggleExpanded=_this.toggleExpanded.bind(_this);_this.onResize=_this.onResize.bind(_this);_this.state={moreToRead:false,expanded:false};return _this;}_createClass(ProductPageDescription,[{key:'componentDidMount',value:function componentDidMount(){this.toggleMoreToRead();window.addEventListener('resize',this.onResize);}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){if(this.props.description!==prevProps.description){this.toggleMoreToRead();}}},{key:'componentWillUnmount',value:function componentWillUnmount(){window.removeEventListener('resize',this.onResize);}},{key:'onResize',value:function onResize(){this.setState({expanded:false});this.toggleMoreToRead();}},{key:'toggleMoreToRead',value:function toggleMoreToRead(){var contenteRefCurrent=this.descriptionRef.current;if(contenteRefCurrent){this.setState({moreToRead:contenteRefCurrent.offsetHeight<contenteRefCurrent.scrollHeight});}}},{key:'toggleExpanded',value:function toggleExpanded(){this.setState({expanded:!this.state.expanded});}},{key:'render',value:function render(){var description=this.props.description;var _state=this.state,moreToRead=_state.moreToRead,expanded=_state.expanded;if(!description){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Description,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Paragraph,{expanded:expanded,dangerouslySetInnerHTML:{__html:description},innerRef:this.descriptionRef}),moreToRead&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Button,{type:'button',onClick:this.toggleExpanded},!expanded?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Visa mer'):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Visa mindre')));}}]);return ProductPageDescription;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);ProductPageDescription.defaultProps={description:''};ProductPageDescription.propTypes={description:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (ProductPageDescription);var Description=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject);var Paragraph=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].p(_templateObject2,__WEBPACK_IMPORTED_MODULE_4__styles_helpers_mixins__["d" /* fontFamilyBody */],__WEBPACK_IMPORTED_MODULE_3__styles_helpers_variables__["c" /* color */].black,function(props){return!props.expanded&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject3);});var Button=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].button(_templateObject4,__WEBPACK_IMPORTED_MODULE_4__styles_helpers_mixins__["d" /* fontFamilyBody */],__WEBPACK_IMPORTED_MODULE_3__styles_helpers_variables__["c" /* color */].black);

/***/ }),
/* 666 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
var _templateObject=_taggedTemplateLiteral(['\n  flex: 0 0 100%;\n  display: flex;\n  align-items: center;\n  margin: 0 0 15px 0;\n  @media screen and (min-width: 1150px) {\n    flex: 1 1 auto;\n    margin: 0 15px 0 0;\n  }\n  &:last-child {\n    margin: 0;\n  }\n  ',';\n'],['\n  flex: 0 0 100%;\n  display: flex;\n  align-items: center;\n  margin: 0 0 15px 0;\n  @media screen and (min-width: 1150px) {\n    flex: 1 1 auto;\n    margin: 0 15px 0 0;\n  }\n  &:last-child {\n    margin: 0;\n  }\n  ',';\n']),_templateObject2=_taggedTemplateLiteral(['\n    @media screen and (min-width: 320px) {\n      flex: 1 1 auto;\n      margin: 0 15px 0 0;\n    }\n  '],['\n    @media screen and (min-width: 320px) {\n      flex: 1 1 auto;\n      margin: 0 15px 0 0;\n    }\n  ']),_templateObject3=_taggedTemplateLiteral(['\n  height: 56px;\n  width: 45px;\n  padding: 15px;\n  border: none;\n  outline: none;\n  background-color: white;\n  &:active {\n    box-shadow: 0 0 10px rgb(0 0 0 / 0.1);\n  }\n  &:disabled {\n    &:before,\n    &:after {\n      opacity: 0.5;\n    }\n  }\n  ',';\n  ',';\n  ',';\n'],['\n  height: 56px;\n  width: 45px;\n  padding: 15px;\n  border: none;\n  outline: none;\n  background-color: white;\n  &:active {\n    box-shadow: 0 0 10px rgb(0 0 0 / 0.1);\n  }\n  &:disabled {\n    &:before,\n    &:after {\n      opacity: 0.5;\n    }\n  }\n  ',';\n  ',';\n  ',';\n']),_templateObject4=_taggedTemplateLiteral(['\n    position: relative;\n    &:after {\n      content: \'\';\n      position: absolute;\n      top: 50%;\n      left: 50%;\n      height: 1px;\n      width: 10px;\n      background-color: black;\n      transform: translate(-50%, -50%);\n    }\n    '],['\n    position: relative;\n    &:after {\n      content: \'\';\n      position: absolute;\n      top: 50%;\n      left: 50%;\n      height: 1px;\n      width: 10px;\n      background-color: black;\n      transform: translate(-50%, -50%);\n    }\n    ']),_templateObject5=_taggedTemplateLiteral(['\n    position: relative;\n    &:before,\n    &:after {\n      content: \'\';\n      position: absolute;\n      top: 50%;\n      left: 50%;\n      background-color: black;\n      transform: translate(-50%, -50%);\n    }\n    &:before {\n      height: 1px;\n      width: 10px;\n    }\n    &:after {\n      height: 10px;\n      width: 1px;\n    }\n    '],['\n    position: relative;\n    &:before,\n    &:after {\n      content: \'\';\n      position: absolute;\n      top: 50%;\n      left: 50%;\n      background-color: black;\n      transform: translate(-50%, -50%);\n    }\n    &:before {\n      height: 1px;\n      width: 10px;\n    }\n    &:after {\n      height: 10px;\n      width: 1px;\n    }\n    ']),_templateObject6=_taggedTemplateLiteral(['\n    height: 43px;\n    width: 40px;\n  '],['\n    height: 43px;\n    width: 40px;\n  ']),_templateObject7=_taggedTemplateLiteral(['\n  flex: 1 1 auto;\n  height: 56px;\n  width: 30px;\n  padding: 15px 0;\n  border: none;\n  outline: none;\n  background-color: white;\n  color: black;\n  font-family: \'Open Sans\';\n  font-size: 16px;\n  line-height: 1.25;\n  font-weight: 400;\n  text-align: center;\n  &::-webkit-outer-spin-button,\n  &::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n  }\n  &[type=number] {\n    -moz-appearance: textfield;\n  }\n  ',';\n'],['\n  flex: 1 1 auto;\n  height: 56px;\n  width: 30px;\n  padding: 15px 0;\n  border: none;\n  outline: none;\n  background-color: white;\n  color: black;\n  font-family: \'Open Sans\';\n  font-size: 16px;\n  line-height: 1.25;\n  font-weight: 400;\n  text-align: center;\n  &::-webkit-outer-spin-button,\n  &::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n  }\n  &[type=number] {\n    -moz-appearance: textfield;\n  }\n  ',';\n']),_templateObject8=_taggedTemplateLiteral(['\n    height: 43px;\n  '],['\n    height: 43px;\n  ']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var ProductQuantitySelector=function ProductQuantitySelector(_ref){var quantity=_ref.quantity,handleChange=_ref.handleChange,handleDecrease=_ref.handleDecrease,handleIncrease=_ref.handleIncrease,mobile=_ref.mobile;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Quantity,{mobile:mobile},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(QuantityButton,{type:'button',title:'\xD6ka kvantitet',icon:'-',onClick:handleDecrease,disabled:quantity<=1,mobile:mobile}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(QuantityInput,{value:quantity,type:'number',pattern:'[0-9]*',onChange:function onChange(event){return handleChange(event.target.validity.valid&&event.target.valueAsNumber?event.target.valueAsNumber:1);},mobile:mobile}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(QuantityButton,{type:'button',title:'Minska kvantitet',icon:'+',onClick:handleIncrease,disabled:quantity>=999,mobile:mobile}));};ProductQuantitySelector.defaultProps={quantity:1,handleChange:function handleChange(){},handleDecrease:function handleDecrease(){},handleIncrease:function handleIncrease(){},mobile:false};ProductQuantitySelector.propTypes={quantity:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,handleChange:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,handleDecrease:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,handleIncrease:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,mobile:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (ProductQuantitySelector);var Quantity=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject,function(props){return props.mobile&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject2);});var QuantityButton=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].button(_templateObject3,function(props){return props.icon==='-'&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject4);},function(props){return props.icon==='+'&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject5);},function(props){return props.mobile&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject6);});var QuantityInput=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].input(_templateObject7,function(props){return props.mobile&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject8);});

/***/ }),
/* 667 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_helpers_variables__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_helpers_mixins__ = __webpack_require__(6);
var _templateObject=_taggedTemplateLiteral(['\n  display: flex;\n  flex-wrap: wrap;\n  list-style: none;\n  margin: 0 -10px -5px 0;\n  padding: 0;\n  ','\n  font-size: 14px;\n  font-weight: normal;\n  line-height: 1.375;\n  color: ',';\n'],['\n  display: flex;\n  flex-wrap: wrap;\n  list-style: none;\n  margin: 0 -10px -5px 0;\n  padding: 0;\n  ','\n  font-size: 14px;\n  font-weight: normal;\n  line-height: 1.375;\n  color: ',';\n']),_templateObject2=_taggedTemplateLiteral(['\n  flex: 0 0 100%;\n  position: relative;\n  max-width: 100%;\n  padding: 0 10px 5px 18.5px;\n  @media screen and (min-width: 1250px) {\n    flex: 0 0 50%;\n    max-width: 50%;\n  }\n  &:before {\n    content: \'\';\n    position: absolute;\n    top: 7px;\n    left: 1px;\n    height: 4px;\n    width: 8px;\n    border-left: 1px solid ',';\n    border-bottom: 1px solid ',';\n    transform: rotate(-45deg);\n  }\n'],['\n  flex: 0 0 100%;\n  position: relative;\n  max-width: 100%;\n  padding: 0 10px 5px 18.5px;\n  @media screen and (min-width: 1250px) {\n    flex: 0 0 50%;\n    max-width: 50%;\n  }\n  &:before {\n    content: \'\';\n    position: absolute;\n    top: 7px;\n    left: 1px;\n    height: 4px;\n    width: 8px;\n    border-left: 1px solid ',';\n    border-bottom: 1px solid ',';\n    transform: rotate(-45deg);\n  }\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var ProductPageUSP=function ProductPageUSP(_ref){var deliveryInformation=_ref.deliveryInformation;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(List,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ListItem,null,'Frakt fr\xE5n 99 \u2013 790 kr'),deliveryInformation&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ListItem,null,'Leveranstid: ',deliveryInformation),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ListItem,null,'14 Dagar returr\xE4tt'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ListItem,null,'3 \xC5rs reklamationsr\xE4tt'));};ProductPageUSP.defaultProps={deliveryInformation:null};ProductPageUSP.propTypes={deliveryInformation:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (ProductPageUSP);var List=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].ul(_templateObject,__WEBPACK_IMPORTED_MODULE_4__styles_helpers_mixins__["d" /* fontFamilyBody */],__WEBPACK_IMPORTED_MODULE_3__styles_helpers_variables__["c" /* color */].black);var ListItem=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].li(_templateObject2,__WEBPACK_IMPORTED_MODULE_3__styles_helpers_variables__["c" /* color */].primary,__WEBPACK_IMPORTED_MODULE_3__styles_helpers_variables__["c" /* color */].primary);

/***/ }),
/* 668 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_productPage_ProductPageSelect_ProductPageSelect__ = __webpack_require__(669);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ProductConfigurationList__ = __webpack_require__(670);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_helpers_mixins__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants_endpoints__ = __webpack_require__(9);
var _templateObject=_taggedTemplateLiteral(['\n  ',';\n  width: 100%;\n  margin: 0 0 30px;\n'],['\n  ',';\n  width: 100%;\n  margin: 0 0 30px;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var ProductConfiguration=function ProductConfiguration(props){var selectedVariantMatchesURL=!!props.data.filter(function(variant){return variant.get('url')===props.location;}).size;var currentSelectedVariant=props.data.find(function(variant){return variant.get('url')===props.location;});if(!selectedVariantMatchesURL){// TODO: Reset selected product variant if !selectedVariantMatchesURL
return false;}var data=props.data,optionsData=props.optionsData,selectedOptions=props.selectedOptions,isMobileDevice=props.isMobileDevice,currentProduct=props.currentProduct;if(!data||!optionsData||!selectedOptions||!props.selected||data.size<=1&&optionsData.size===0)return false;var totalSelectedOptionPrice=0;var optionsListMobile=props.optionsData.map(function(option){var selectedOptionId=props.selectedOptions[option.get('name')];if(!selectedOptionId){return false;}var selectedOptionsObject={name:option.get('options').find(function(item){return item.get('id')===selectedOptionId;}).get('name'),image:__WEBPACK_IMPORTED_MODULE_7__constants_endpoints__["n" /* SITE_ROOT_URL */]+option.get('options').find(function(item){return item.get('id')===selectedOptionId;}).getIn(['images',0,'url']),price:option.get('options').find(function(item){return item.get('id')===selectedOptionId;}).get('price')};if(!selectedOptionsObject.name||!selectedOptionsObject.image){return false;}totalSelectedOptionPrice+=selectedOptionsObject.price;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ProductConfigurationContainer,{key:option.get('name')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__ProductConfigurationList__["a" /* default */],{fullImages:true,title:option.get('name'),type:option.get('name'),location:props.location,selected:selectedOptionId,selectedOptionPrice:selectedOptionsObject.price,setProductVariant:props.setProductOption,isMobileDevice:isMobileDevice,price:props.price},option.get('options')));}).toArray();var VariantListMobile=function VariantListMobile(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ProductConfigurationContainer,{key:'Utf\xF6rande'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__ProductConfigurationList__["a" /* default */],{title:currentProduct.get('variantHeading')||'Utförande',isMobileDevice:isMobileDevice,selected:props.selected,location:props.location,setProductVariant:props.setProductVariant,price:props.price,totalSelectedOptionPrice:totalSelectedOptionPrice},data));};var mergedMobile=[VariantListMobile()].concat(_toConsumableArray(optionsListMobile));if(isMobileDevice){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,mergedMobile);}var totalSelectedOptionPrice2=0;var optionsList=props.optionsData.map(function(option){var selectedOptionId=props.selectedOptions[option.get('name')];if(!selectedOptionId){return false;}var selectedOptions2={name:option.get('options').find(function(item){return item.get('id')===selectedOptionId;}).get('name'),image:__WEBPACK_IMPORTED_MODULE_7__constants_endpoints__["n" /* SITE_ROOT_URL */]+option.get('options').find(function(item){return item.get('id')===selectedOptionId;}).getIn(['images',0,'url']),price:option.get('options').find(function(item){return item.get('id')===selectedOptionId;}).get('price')};if(!selectedOptions2.name||!selectedOptions2.image){return false;}totalSelectedOptionPrice2+=selectedOptions2.price;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_productPage_ProductPageSelect_ProductPageSelect__["a" /* default */],{key:selectedOptions2.name,type:option.get('name'),label:option.get('name'),title:selectedOptions2.name,image:selectedOptions2.image,selectedOptionPrice:selectedOptions2.price,selected:selectedOptionId,location:props.location,setProductVariant:props.setProductOption,options:option.get('options'),price:props.price});}).toArray();var selectedVariant={name:currentSelectedVariant.get('cleanVariantName'),image:__WEBPACK_IMPORTED_MODULE_7__constants_endpoints__["n" /* SITE_ROOT_URL */]+currentSelectedVariant.getIn(['mainImage','url'])};var VariantList=function VariantList(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_productPage_ProductPageSelect_ProductPageSelect__["a" /* default */],{key:'variant',type:'variant',label:currentProduct.get('variantHeading'),title:selectedVariant.name,image:selectedVariant.image,selected:props.selected,location:props.location,setProductVariant:props.setProductVariant,options:data,price:props.price,totalSelectedOptionPrice:totalSelectedOptionPrice2});};var combinedArrayOfVariantsAndOptions=[VariantList()].concat(_toConsumableArray(optionsList)).filter(function(item){return item!==false;});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ProductConfigurationContainer,null,combinedArrayOfVariantsAndOptions);};var ProductConfigurationContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject,__WEBPACK_IMPORTED_MODULE_6__styles_helpers_mixins__["f" /* hideOnPrint */]);ProductConfiguration.defaultProps={isMobileDevice:false,selected:'',optionsData:Object(__WEBPACK_IMPORTED_MODULE_3_immutable__["List"])(),selectedOptions:[],currentProduct:Object(__WEBPACK_IMPORTED_MODULE_3_immutable__["Map"])(),price:null};ProductConfiguration.propTypes={selected:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,setProductVariant:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,setProductOption:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,isMobileDevice:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,data:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_3_immutable__["Map"]),__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_3_immutable__["List"])]).isRequired,optionsData:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_3_immutable__["List"]),selectedOptions:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,location:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,currentProduct:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_3_immutable__["Map"]),price:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number};/* harmony default export */ __webpack_exports__["a"] = (ProductConfiguration);

/***/ }),
/* 669 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Paragraph */
/* unused harmony export Button */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_helpers_variables__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants_endpoints__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_toCurrency__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_getProductVariantName__ = __webpack_require__(167);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  margin: 0 0 10px;\n  &:last-child {\n    margin: 0;\n  }\n'],['\n  margin: 0 0 10px;\n  &:last-child {\n    margin: 0;\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  margin: 0 0 5px;\n  color: #000000;\n  font-size: 13px;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  font-weight: 600;\n'],['\n  margin: 0 0 5px;\n  color: #000000;\n  font-size: 13px;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  font-weight: 600;\n']),_templateObject3=_taggedTemplateLiteral(['\n  position: relative;\n  height: 56px;\n'],['\n  position: relative;\n  height: 56px;\n']),_templateObject4=_taggedTemplateLiteral(['\n  position: absolute;\n  width: 100%;\n  z-index: 1;\n  ',';\n'],['\n  position: absolute;\n  width: 100%;\n  z-index: 1;\n  ',';\n']),_templateObject5=_taggedTemplateLiteral(['\n      box-shadow: 0 0 10px rgb(0 0 0 / 0.1);\n      z-index: 2;\n    '],['\n      box-shadow: 0 0 10px rgb(0 0 0 / 0.1);\n      z-index: 2;\n    ']),_templateObject6=_taggedTemplateLiteral(['\n  display: flex;\n  align-items: center;\n  position: relative;\n  width: 100%;\n  margin: 0;\n  padding: 8px 45px 8px 8px;\n  border: none;\n  outline: none; // \u2026\n  background-color: #ffffff;\n  cursor: pointer;\n  &:after {\n    content: \'\';\n    position: absolute;\n    top: 50%;\n    right: 15px;\n    height: 15px;\n    width: 15px;\n    background-image: url(\'/images/icons/arrow.svg\');\n    background-position: center;\n    background-repeat: no-repeat;\n    background-size: contain;\n    transform: translateY(-50%);\n    ',';\n  }\n'],['\n  display: flex;\n  align-items: center;\n  position: relative;\n  width: 100%;\n  margin: 0;\n  padding: 8px 45px 8px 8px;\n  border: none;\n  outline: none; // \u2026\n  background-color: #ffffff;\n  cursor: pointer;\n  &:after {\n    content: \'\';\n    position: absolute;\n    top: 50%;\n    right: 15px;\n    height: 15px;\n    width: 15px;\n    background-image: url(\'/images/icons/arrow.svg\');\n    background-position: center;\n    background-repeat: no-repeat;\n    background-size: contain;\n    transform: translateY(-50%);\n    ',';\n  }\n']),_templateObject7=_taggedTemplateLiteral(['\n        transform: translateY(-50%) rotate(180deg);\n      '],['\n        transform: translateY(-50%) rotate(180deg);\n      ']),_templateObject8=_taggedTemplateLiteral(['\n  flex: 0 0 auto;\n  position: relative;\n  height: 40px;\n  width: 40px;\n  margin: 0 15px 0 0;\n  > img {\n    position: absolute;\n    top: 0;\n    left: 0;\n    height: 100%;\n    width: 100%;\n    object-fit: contain;\n  }\n'],['\n  flex: 0 0 auto;\n  position: relative;\n  height: 40px;\n  width: 40px;\n  margin: 0 15px 0 0;\n  > img {\n    position: absolute;\n    top: 0;\n    left: 0;\n    height: 100%;\n    width: 100%;\n    object-fit: contain;\n  }\n']),_templateObject9=_taggedTemplateLiteral(['\n  color: ',';\n  font-family: \'Open Sans\';\n  font-size: 16px;\n  line-height: 1.25;\n  font-weight: 400;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n'],['\n  color: ',';\n  font-family: \'Open Sans\';\n  font-size: 16px;\n  line-height: 1.25;\n  font-weight: 400;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n']),_templateObject10=_taggedTemplateLiteral(['\n  display: none;\n  list-style: none;\n  max-height: 225px;\n  margin: 0;\n  padding: 0;\n  border-top: 1px solid #f2f2f2;\n  background-color: ',';\n  overflow-y: auto;\n  ',';\n'],['\n  display: none;\n  list-style: none;\n  max-height: 225px;\n  margin: 0;\n  padding: 0;\n  border-top: 1px solid #f2f2f2;\n  background-color: ',';\n  overflow-y: auto;\n  ',';\n']),_templateObject11=_taggedTemplateLiteral(['\n      display: block;\n    '],['\n      display: block;\n    ']),_templateObject12=_taggedTemplateLiteral(['\n  border-bottom: 1px solid #f2f2f2;\n  &:first-child {\n    > button {\n      padding-top: 8px;\n    }\n  }\n  &:last-child {\n    border-bottom: none;\n    > button {\n      padding-bottom: 8px;\n    }\n  }\n'],['\n  border-bottom: 1px solid #f2f2f2;\n  &:first-child {\n    > button {\n      padding-top: 8px;\n    }\n  }\n  &:last-child {\n    border-bottom: none;\n    > button {\n      padding-bottom: 8px;\n    }\n  }\n']),_templateObject13=_taggedTemplateLiteral(['\n  display: flex;\n  align-items: center;\n  width: 100%;\n  padding: 4px 15px 4px 8px;\n  border: none;\n  outline: none; // \u2026\n  background-color: transparent;\n  color: inherit;\n  font-size: inherit;\n  font-family: inherit;\n  text-align: left;\n  cursor: pointer;\n'],['\n  display: flex;\n  align-items: center;\n  width: 100%;\n  padding: 4px 15px 4px 8px;\n  border: none;\n  outline: none; // \u2026\n  background-color: transparent;\n  color: inherit;\n  font-size: inherit;\n  font-family: inherit;\n  text-align: left;\n  cursor: pointer;\n']),_templateObject14=_taggedTemplateLiteral(['\n  flex: 0 0 auto;\n  position: relative;\n  height: 40px;\n  width: 40px;\n  margin: 0 15px 0 0;\n  color: transparent;\n  overflow: hidden;\n  > img {\n    position: absolute;\n    top: 0;\n    left: 0;\n    height: 100%;\n    width: 100%;\n    object-fit: contain;\n  }\n'],['\n  flex: 0 0 auto;\n  position: relative;\n  height: 40px;\n  width: 40px;\n  margin: 0 15px 0 0;\n  color: transparent;\n  overflow: hidden;\n  > img {\n    position: absolute;\n    top: 0;\n    left: 0;\n    height: 100%;\n    width: 100%;\n    object-fit: contain;\n  }\n']),_templateObject15=_taggedTemplateLiteral(['\n  flex: 1 1 auto;\n  margin: 0 15px 0 0;\n  color: #000000;\n  font-family: \'Open Sans\';\n  font-size: 16px;\n  line-height: 1.25;\n  font-weight: 400;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  &:last-child {\n    margin: 0;\n  }\n'],['\n  flex: 1 1 auto;\n  margin: 0 15px 0 0;\n  color: #000000;\n  font-family: \'Open Sans\';\n  font-size: 16px;\n  line-height: 1.25;\n  font-weight: 400;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  &:last-child {\n    margin: 0;\n  }\n']),_templateObject16=_taggedTemplateLiteral(['\n  flex: 0 0 auto;\n  display: flex;\n  align-items: center;\n  margin: 0 15px 0 0;\n  color: #6a6a6a;\n  font-size: 0.875em;\n  &:last-child {\n    margin: 0;\n  }\n  &:before {\n    content: \'\';\n    flex: 0 0 auto;\n    height: 5px;\n    width: 5px;\n    border-radius: 50%;\n    background-color: ',';\n    @media screen and (min-width: 1150px) {\n      margin: 0 5px 0 0;\n    }\n  }\n'],['\n  flex: 0 0 auto;\n  display: flex;\n  align-items: center;\n  margin: 0 15px 0 0;\n  color: #6a6a6a;\n  font-size: 0.875em;\n  &:last-child {\n    margin: 0;\n  }\n  &:before {\n    content: \'\';\n    flex: 0 0 auto;\n    height: 5px;\n    width: 5px;\n    border-radius: 50%;\n    background-color: ',';\n    @media screen and (min-width: 1150px) {\n      margin: 0 5px 0 0;\n    }\n  }\n']),_templateObject17=_taggedTemplateLiteral(['\n  display: none;\n  @media screen and (min-width: 1150px) {\n    display: inline;\n  }\n'],['\n  display: none;\n  @media screen and (min-width: 1150px) {\n    display: inline;\n  }\n']),_templateObject18=_taggedTemplateLiteral(['\n  flex: 0 0 auto;\n  color: #6a6a6a;\n  font-style: italic;\n'],['\n  flex: 0 0 auto;\n  color: #6a6a6a;\n  font-style: italic;\n']),_templateObject19=_taggedTemplateLiteral(['\n  margin: 0 0 5px;\n  font-size: 14px;\n  font-weight: normal;\n  line-height: 1.57;\n  text-align: left;\n  color: ',';\n  overflow: hidden;\n  ',';\n'],['\n  margin: 0 0 5px;\n  font-size: 14px;\n  font-weight: normal;\n  line-height: 1.57;\n  text-align: left;\n  color: ',';\n  overflow: hidden;\n  ',';\n']),_templateObject20=_taggedTemplateLiteral(['\n      display: -webkit-box;\n      -webkit-line-clamp: 3;\n      -webkit-box-orient: vertical;\n    '],['\n      display: -webkit-box;\n      -webkit-line-clamp: 3;\n      -webkit-box-orient: vertical;\n    ']),_templateObject21=_taggedTemplateLiteral(['\n  padding: 0;\n  border: none;\n  font-size: 14px;\n  font-weight: normal;\n  line-height: 1.57;\n  text-align: left;\n  color: ',';\n  text-decoration: underline;\n  cursor: pointer;\n'],['\n  padding: 0;\n  border: none;\n  font-size: 14px;\n  font-weight: normal;\n  line-height: 1.57;\n  text-align: left;\n  color: ',';\n  text-decoration: underline;\n  cursor: pointer;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProductPageSelect=function(_React$Component){_inherits(ProductPageSelect,_React$Component);function ProductPageSelect(props){_classCallCheck(this,ProductPageSelect);var _this=_possibleConstructorReturn(this,(ProductPageSelect.__proto__||Object.getPrototypeOf(ProductPageSelect)).call(this,props));_this.selectContainerRef=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();_this.handleMouseDown=_this.handleMouseDown.bind(_this);_this.handleKeyDown=_this.handleKeyDown.bind(_this);_this.toggleActive=_this.toggleActive.bind(_this);_this.state={active:false};return _this;}_createClass(ProductPageSelect,[{key:'componentDidMount',value:function componentDidMount(){document.addEventListener('mousedown',this.handleMouseDown);document.addEventListener('keydown',this.handleKeyDown);}},{key:'componentWillUnmount',value:function componentWillUnmount(){document.removeEventListener('mousedown',this.handleMouseDown);document.removeEventListener('keydown',this.handleKeyDown);}},{key:'handleMouseDown',value:function handleMouseDown(event){var element=this.selectContainerRef.current;if((!element||!element.contains(event.target))&&this.state.active){this.setState({active:false});}}},{key:'handleKeyDown',value:function handleKeyDown(event){if(event.keyCode===27&&this.state.active){this.setState({active:false});}}},{key:'toggleActive',value:function toggleActive(){this.setState({active:!this.state.active});}},{key:'render',value:function render(){var _this2=this;var _props=this.props,label=_props.label,image=_props.image,title=_props.title,type=_props.type,options=_props.options,setProductVariant=_props.setProductVariant,selected=_props.selected,location=_props.location,price=_props.price,selectedOptionPrice=_props.selectedOptionPrice,totalSelectedOptionPrice=_props.totalSelectedOptionPrice;var active=this.state.active;var formattedTitle=Object(__WEBPACK_IMPORTED_MODULE_7__util_getProductVariantName__["a" /* getProductVariantName */])(title);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Select,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SelectLabel,null,label||'Utförande'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SelectPlaceholderContainer,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SelectContainer,{active:active,innerRef:this.selectContainerRef},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SelectButton,{active:active,onClick:this.toggleActive},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SelectButtonImage,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:image,alt:formattedTitle})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SelectButtonText,null,formattedTitle)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SelectOptionList,{active:active},options.map(function(option){var isSelected=type?selected===option.get('id'):location===option.get('url');if(isSelected){return null;}var relativePrice=null;if(type==='variant'){relativePrice=option.get('price')-price+totalSelectedOptionPrice!==0?option.get('price')-price+totalSelectedOptionPrice:null;}else{relativePrice=option.get('price')-selectedOptionPrice!==0?option.get('price')-selectedOptionPrice:null;}var relativePricePrefix=null;if(relativePrice&&relativePrice<0){relativePricePrefix='-';}else if(relativePrice&&relativePrice>0){relativePricePrefix='+';}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SelectOptionListItem,{key:'select-option-list-item-'+option.get('name')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SelectOptionButton,{type:'button',onClick:function onClick(){_this2.toggleActive();setProductVariant(option.get('id'),type);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SelectOptionImage,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_5__constants_endpoints__["n" /* SITE_ROOT_URL */]+(option.getIn(['mainImage','url'])||option.getIn(['images',0,'url'])),alt:option.get('name')})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SelectOptionName,null,Object(__WEBPACK_IMPORTED_MODULE_7__util_getProductVariantName__["a" /* getProductVariantName */])(option.get('cleanVariantName')||option.get('name'))),option.get('inStock')&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SelectOptionInStock,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SelectOptionInStockText,null,'I lager')),relativePrice&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SelectOptionPrice,null,relativePricePrefix&&relativePricePrefix+' ',Object(__WEBPACK_IMPORTED_MODULE_6__util_toCurrency__["a" /* toCurrency */])(Math.abs(relativePrice)))));})))));}}]);return ProductPageSelect;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);ProductPageSelect.defaultProps={label:'',image:'',title:'',type:'',options:Object(__WEBPACK_IMPORTED_MODULE_3_immutable__["List"])(),setProductVariant:function setProductVariant(){},selected:'',location:'',price:null,selectedOptionPrice:null,totalSelectedOptionPrice:null};ProductPageSelect.propTypes={label:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,image:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,title:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,type:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,options:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_3_immutable__["List"]),setProductVariant:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,selected:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,location:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,price:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,selectedOptionPrice:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,totalSelectedOptionPrice:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number};/* harmony default export */ __webpack_exports__["a"] = (ProductPageSelect);var Select=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject);var SelectLabel=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject2);var SelectPlaceholderContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject3);var SelectContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject4,function(props){return props.active&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject5);});var SelectButton=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].button(_templateObject6,function(props){return props.active&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject7);});var SelectButtonImage=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject8);var SelectButtonText=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject9,__WEBPACK_IMPORTED_MODULE_4__styles_helpers_variables__["c" /* color */].black);var SelectOptionList=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].ul(_templateObject10,__WEBPACK_IMPORTED_MODULE_4__styles_helpers_variables__["c" /* color */].white,function(props){return props.active&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject11);});var SelectOptionListItem=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].li(_templateObject12);var SelectOptionButton=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].button(_templateObject13);var SelectOptionImage=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject14);var SelectOptionName=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject15);var SelectOptionInStock=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject16,__WEBPACK_IMPORTED_MODULE_4__styles_helpers_variables__["c" /* color */].success);var SelectOptionInStockText=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].span(_templateObject17);var SelectOptionPrice=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject18);var Paragraph=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].p(_templateObject19,__WEBPACK_IMPORTED_MODULE_4__styles_helpers_variables__["c" /* color */].black,function(props){return props.active&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject20);});var Button=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].button(_templateObject21,__WEBPACK_IMPORTED_MODULE_4__styles_helpers_variables__["c" /* color */].black);

/***/ }),
/* 670 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_grid_styled__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_grid_styled___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_grid_styled__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_UnderlinedHeading__ = __webpack_require__(671);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ProductConfigurationListItem__ = __webpack_require__(672);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ProductConfigurationListItemMobile__ = __webpack_require__(673);
var _templateObject=_taggedTemplateLiteral(['\n  width: 100%;\n  margin: 10px 0;\n'],['\n  width: 100%;\n  margin: 10px 0;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var ProductConfigurationList=function ProductConfigurationList(props){var childrenList=props.children.map(function(item,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_styled_components__["ThemeProvider"],{key:index,theme:{breakpoints:['1200px']}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grid_styled__["Box"],{width:[1/3,1/4],px:'5px'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__ProductConfigurationListItem__["a" /* default */],{fullImages:props.fullImages,type:props.type,selected:props.selected,location:props.location,setProductVariant:props.setProductVariant},item)));});var childrenListMobile=props.children.map(function(item,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__ProductConfigurationListItemMobile__["a" /* default */],{roundImages:props.roundImages,key:index,type:props.type,selected:props.selected,location:props.location,setProductVariant:props.setProductVariant,price:props.price,selectedOptionPrice:props.selectedOptionPrice,totalSelectedOptionPrice:props.totalSelectedOptionPrice},item);});if(props.isMobileDevice){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ProductConfigurationListContainer,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles_UnderlinedHeading__["a" /* UnderlinedHeading */],null,props.title),childrenListMobile);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ProductConfigurationListContainer,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grid_styled__["Flex"],{flexWrap:'wrap',mx:'-5px'},childrenList));};var ProductConfigurationListContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject);ProductConfigurationList.defaultProps={fullImages:false,roundImages:false,isMobileDevice:false,title:'',selected:'',type:null,price:null,selectedOptionPrice:null,totalSelectedOptionPrice:null};ProductConfigurationList.propTypes={selected:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,setProductVariant:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,fullImages:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,roundImages:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,isMobileDevice:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,title:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,children:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node),__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node]).isRequired,type:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,location:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string.isRequired,price:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,selectedOptionPrice:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,totalSelectedOptionPrice:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number};/* harmony default export */ __webpack_exports__["a"] = (ProductConfigurationList);

/***/ }),
/* 671 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UnderlinedHeading; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_variables__ = __webpack_require__(4);
var _templateObject=_taggedTemplateLiteral(["\n  font-size: 12px;\n  font-weight: 600;\n  font-style: normal;\n  font-stretch: normal;\n  line-height: normal;\n  letter-spacing: 2px;\n  text-align: left;\n  color: ",";\n  display: block;\n  border-bottom: solid 1px #c5c5c5;\n  text-transform: uppercase;\n  padding-bottom: 4px;\n  margin: 30px 0 15px;\n  \n  @media screen and (min-width: ","px) {\n    font-size: 13px;\n  }\n"],["\n  font-size: 12px;\n  font-weight: 600;\n  font-style: normal;\n  font-stretch: normal;\n  line-height: normal;\n  letter-spacing: 2px;\n  text-align: left;\n  color: ",";\n  display: block;\n  border-bottom: solid 1px #c5c5c5;\n  text-transform: uppercase;\n  padding-bottom: 4px;\n  margin: 30px 0 15px;\n  \n  @media screen and (min-width: ","px) {\n    font-size: 13px;\n  }\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var UnderlinedHeading=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].p(_templateObject,__WEBPACK_IMPORTED_MODULE_1__helpers_variables__["c" /* color */].black,__WEBPACK_IMPORTED_MODULE_1__helpers_variables__["f" /* size */].large);

/***/ }),
/* 672 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_helpers_variables__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_MainProductImage__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_ProductImage__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_toCurrency__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants_endpoints__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_getProductVariantName__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Conditional__ = __webpack_require__(26);
var _templateObject=_taggedTemplateLiteral(['\n  width: 100%;\n  height: 8px;\n  position: absolute;\n  top: 5px;\n  left: 5px;\n  display: flex;\n'],['\n  width: 100%;\n  height: 8px;\n  position: absolute;\n  top: 5px;\n  left: 5px;\n  display: flex;\n']),_templateObject2=_taggedTemplateLiteral(['\n  width: 8px;\n  height: 8px;\n  margin-right: 2px;\n  background-color: ',';\n'],['\n  width: 8px;\n  height: 8px;\n  margin-right: 2px;\n  background-color: ',';\n']),_templateObject3=_taggedTemplateLiteral(['\n  position: relative;\n\n  &:after {\n    content: \'\';\n    background-color: ',';\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    z-index: 1;\n    opacity: 0;\n    transition: opacity 0.25s ease-out;\n    pointer-events: none;\n  }\n'],['\n  position: relative;\n\n  &:after {\n    content: \'\';\n    background-color: ',';\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    z-index: 1;\n    opacity: 0;\n    transition: opacity 0.25s ease-out;\n    pointer-events: none;\n  }\n']),_templateObject4=_taggedTemplateLiteral(['\n  width: 100%;\n  margin: 5px 0 2px;\n  cursor: pointer;\n\n  &:hover {\n    ',' {\n      &:after {\n        opacity: 0.05;\n      }\n    }\n  }\n'],['\n  width: 100%;\n  margin: 5px 0 2px;\n  cursor: pointer;\n\n  &:hover {\n    ',' {\n      &:after {\n        opacity: 0.05;\n      }\n    }\n  }\n']),_templateObject5=_taggedTemplateLiteral(['\n  font-size: 14px;\n  line-height: 1.57;\n  font-weight: 500;\n  text-align: left;\n  color: ',';\n  margin: 0;\n'],['\n  font-size: 14px;\n  line-height: 1.57;\n  font-weight: 500;\n  text-align: left;\n  color: ',';\n  margin: 0;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var ProductConfigurationListItem=function ProductConfigurationListItem(props){var tagKey=props.children.get('tags')&&props.children.get('tags').toKeyedSeq();return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ProductConfigurationListItemContainer,{onClick:function onClick(){return props.setProductVariant(props.children.get('id'),props.type);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ImageContainer,null,props.fullImages?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__styles_ProductImage__["a" /* ProductImage */],{selected:props.type?props.selected===props.children.get('id'):props.location===props.children.get('url'),margin:'0 0 .5rem',src:__WEBPACK_IMPORTED_MODULE_7__constants_endpoints__["n" /* SITE_ROOT_URL */]+props.children.getIn(['images',0,'url'])}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_MainProductImage__["a" /* default */],{selected:props.selected===props.children.get('id'),small:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__styles_ProductImage__["a" /* ProductImage */],{src:__WEBPACK_IMPORTED_MODULE_7__constants_endpoints__["n" /* SITE_ROOT_URL */]+props.children.getIn(['mainImage','url'])})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Conditional__["a" /* Conditional */],{show:tagKey&&!tagKey.isEmpty()},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TagIndicatorContainer,null,tagKey&&tagKey.map(function(item){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TagIndicator,{color:item.get('key')});}).toArray()))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Title,null,Object(__WEBPACK_IMPORTED_MODULE_8__util_getProductVariantName__["a" /* getProductVariantName */])(props.children.get('name'),true),props.children.get('price')?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{display:'block',margin:0,fontSize:'14px'}},Object(__WEBPACK_IMPORTED_MODULE_6__util_toCurrency__["a" /* toCurrency */])(props.children.get('price'))):false));};var TagIndicatorContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject);var TagIndicator=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject2,function(props){return props.color;});var ImageContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject3,__WEBPACK_IMPORTED_MODULE_3__styles_helpers_variables__["c" /* color */].black);var ProductConfigurationListItemContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject4,ImageContainer);var Title=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].p(_templateObject5,__WEBPACK_IMPORTED_MODULE_3__styles_helpers_variables__["c" /* color */].black);ProductConfigurationListItem.defaultProps={fullImages:false,selected:'',type:''};ProductConfigurationListItem.propTypes={selected:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,setProductVariant:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,fullImages:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,type:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,children:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node),__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node]).isRequired,location:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired};/* harmony default export */ __webpack_exports__["a"] = (ProductConfigurationListItem);

/***/ }),
/* 673 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_helpers_variables__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_Image__ = __webpack_require__(674);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_toCurrency__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants_endpoints__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_getProductVariantName__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Conditional__ = __webpack_require__(26);
var _templateObject=_taggedTemplateLiteral(['\n  width: 100%;\n  height: 6px;\n  position: absolute;\n  top: 3px;\n  left: 3px;\n  display: flex;\n'],['\n  width: 100%;\n  height: 6px;\n  position: absolute;\n  top: 3px;\n  left: 3px;\n  display: flex;\n']),_templateObject2=_taggedTemplateLiteral(['\n  width: 6px;\n  height: 6px;\n  margin-right: 2px;\n  background-color: ',';\n'],['\n  width: 6px;\n  height: 6px;\n  margin-right: 2px;\n  background-color: ',';\n']),_templateObject3=_taggedTemplateLiteral(['\n  flex: 1 1 auto;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n'],['\n  flex: 1 1 auto;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n']),_templateObject4=_taggedTemplateLiteral(['\n  flex: 0 0 auto;\n  display: flex;\n  align-items: center;\n  margin: 0 0 0 10px;\n  color: #6a6a6a;\n  font-size: 0.875em;\n  &:last-child {\n    margin: 0 10px;\n  }\n  &:before {\n    content: \'\';\n    flex: 0 0 auto;\n    height: 5px;\n    width: 5px;\n    border-radius: 50%;\n    background-color: ',';\n    @media screen and (min-width: 321px) {\n      margin: 0 5px 0 0;\n    }\n  }\n'],['\n  flex: 0 0 auto;\n  display: flex;\n  align-items: center;\n  margin: 0 0 0 10px;\n  color: #6a6a6a;\n  font-size: 0.875em;\n  &:last-child {\n    margin: 0 10px;\n  }\n  &:before {\n    content: \'\';\n    flex: 0 0 auto;\n    height: 5px;\n    width: 5px;\n    border-radius: 50%;\n    background-color: ',';\n    @media screen and (min-width: 321px) {\n      margin: 0 5px 0 0;\n    }\n  }\n']),_templateObject5=_taggedTemplateLiteral(['\n  display: none;\n  @media screen and (min-width: 321px) {\n    display: inline;\n  }\n'],['\n  display: none;\n  @media screen and (min-width: 321px) {\n    display: inline;\n  }\n']),_templateObject6=_taggedTemplateLiteral(['\n  flex: 0 0 auto;\n  padding: 0 10px;\n  color: #6a6a6a;\n  font-style: italic;\n'],['\n  flex: 0 0 auto;\n  padding: 0 10px;\n  color: #6a6a6a;\n  font-style: italic;\n']),_templateObject7=_taggedTemplateLiteral(['\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  background-color: ',';\n  width: 100%;\n  height: 100%;\n  padding: 2px 5px;\n  transition: transform ',' ',';\n\n  ',' &:before {\n    content: \'\';\n    width: 12px;\n    height: 12px;\n    position: absolute;\n    background-image: url(\'/images/icons/checkmark.svg\');\n    background-repeat: no-repeat;\n    background-size: contain;\n    left: -16px;\n    display: block;\n  }\n'],['\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  background-color: ',';\n  width: 100%;\n  height: 100%;\n  padding: 2px 5px;\n  transition: transform ',' ',';\n\n  ',' &:before {\n    content: \'\';\n    width: 12px;\n    height: 12px;\n    position: absolute;\n    background-image: url(\'/images/icons/checkmark.svg\');\n    background-repeat: no-repeat;\n    background-size: contain;\n    left: -16px;\n    display: block;\n  }\n']),_templateObject8=_taggedTemplateLiteral(['\n      transform: translateX(20px);\n      padding: 2px 20px 2px 5px;\n    '],['\n      transform: translateX(20px);\n      padding: 2px 20px 2px 5px;\n    ']),_templateObject9=_taggedTemplateLiteral(['\n  background-color: ',';\n  border: solid 1px #c5c5c5;\n  border-bottom-color: transparent;\n  overflow: hidden;\n  width: 100%;\n  margin: 0;\n  cursor: pointer;\n  max-height: 56px;\n\n  &:last-of-type {\n    border-bottom-color: #c5c5c5;\n  }\n\n  ',';\n'],['\n  background-color: ',';\n  border: solid 1px #c5c5c5;\n  border-bottom-color: transparent;\n  overflow: hidden;\n  width: 100%;\n  margin: 0;\n  cursor: pointer;\n  max-height: 56px;\n\n  &:last-of-type {\n    border-bottom-color: #c5c5c5;\n  }\n\n  ',';\n']),_templateObject10=_taggedTemplateLiteral(['\n      border-color: ',' !important;\n      background-color: ',';\n\n      & + div {\n        border-top-color: transparent;\n      }\n    '],['\n      border-color: ',' !important;\n      background-color: ',';\n\n      & + div {\n        border-top-color: transparent;\n      }\n    ']),_templateObject11=_taggedTemplateLiteral(['\n  display: flex;\n  flex: 1 1 auto;\n  min-width: 0;\n  font-size: 14px;\n  line-height: 1.57;\n  text-align: left;\n  color: ',';\n  margin: 0;\n'],['\n  display: flex;\n  flex: 1 1 auto;\n  min-width: 0;\n  font-size: 14px;\n  line-height: 1.57;\n  text-align: left;\n  color: ',';\n  margin: 0;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var ProductConfigurationListItemMobile=function ProductConfigurationListItemMobile(props){var tagKey=props.children.get('tags')&&props.children.get('tags').toKeyedSeq();var relativePrice=null;if(!props.type){relativePrice=props.children.get('price')-props.price+props.totalSelectedOptionPrice!==0?props.children.get('price')-props.price+props.totalSelectedOptionPrice:null;}else{relativePrice=props.children.get('price')-props.selectedOptionPrice!==0?props.children.get('price')-props.selectedOptionPrice:null;}var relativePricePrefix=null;if(relativePrice<0){relativePricePrefix='-';}else if(relativePrice>0){relativePricePrefix='+';}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ProductConfigurationListItemMobileContainer,{selected:props.type?props.selected===props.children.get('id'):props.location===props.children.get('url'),onClick:function onClick(){return props.setProductVariant(props.children.get('id'),props.type);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ProductConfigurationListItemMobileContent,{selected:props.type?props.selected===props.children.get('id'):props.location===props.children.get('url')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Conditional__["a" /* Conditional */],{show:tagKey&&!tagKey.isEmpty()},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TagIndicatorContainer,null,tagKey&&tagKey.map(function(item){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TagIndicator,{color:item.get('key')});}).toArray())),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styles_Image__["a" /* Image */],{style:{flex:'0 0 auto'},round:props.roundImages,url:__WEBPACK_IMPORTED_MODULE_6__constants_endpoints__["n" /* SITE_ROOT_URL */]+(props.children.getIn(['mainImage','url'])?props.children.getIn(['mainImage','url']):props.children.getIn(['images',0,'url'])),width:50,height:50}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Title,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Name,null,Object(__WEBPACK_IMPORTED_MODULE_7__util_getProductVariantName__["a" /* getProductVariantName */])(props.children.get('cleanVariantName')||props.children.get('name'))),props.children.get('inStock')&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SelectOptionInStock,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SelectOptionInStockText,null,'I lager')),relativePrice&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Price,null,relativePricePrefix&&relativePricePrefix+' ',Object(__WEBPACK_IMPORTED_MODULE_5__util_toCurrency__["a" /* toCurrency */])(Math.abs(relativePrice))))));};var TagIndicatorContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject);var TagIndicator=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject2,function(props){return props.color;});var Name=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].span(_templateObject3);var SelectOptionInStock=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject4,__WEBPACK_IMPORTED_MODULE_3__styles_helpers_variables__["c" /* color */].success);var SelectOptionInStockText=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].span(_templateObject5);var Price=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].span(_templateObject6);var ProductConfigurationListItemMobileContent=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject7,__WEBPACK_IMPORTED_MODULE_3__styles_helpers_variables__["c" /* color */].white,__WEBPACK_IMPORTED_MODULE_3__styles_helpers_variables__["a" /* animation */].transitionTime,__WEBPACK_IMPORTED_MODULE_3__styles_helpers_variables__["a" /* animation */].easing,function(props){return props.selected&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject8);});var ProductConfigurationListItemMobileContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject9,__WEBPACK_IMPORTED_MODULE_3__styles_helpers_variables__["c" /* color */].white,function(props){return props.selected&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject10,__WEBPACK_IMPORTED_MODULE_3__styles_helpers_variables__["c" /* color */].primary,__WEBPACK_IMPORTED_MODULE_3__styles_helpers_variables__["c" /* color */].primary);});var Title=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].p(_templateObject11,__WEBPACK_IMPORTED_MODULE_3__styles_helpers_variables__["c" /* color */].black);ProductConfigurationListItemMobile.defaultProps={roundImages:false,selected:'',type:null,price:null,selectedOptionPrice:null,totalSelectedOptionPrice:null};ProductConfigurationListItemMobile.propTypes={selected:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,setProductVariant:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,roundImages:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,children:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node),__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node]).isRequired,type:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,location:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,price:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,selectedOptionPrice:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,totalSelectedOptionPrice:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number};/* harmony default export */ __webpack_exports__["a"] = (ProductConfigurationListItemMobile);

/***/ }),
/* 674 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Image; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
var _templateObject=_taggedTemplateLiteral(['\n  width: ',';\n  height: ',';\n  background-color: ',';\n  background-image: url("','");\n  background-size: contain;\n  background-position: center;\n  background-repeat: no-repeat;\n  margin-right: 15px;\n  \n  ','\n'],['\n  width: ',';\n  height: ',';\n  background-color: ',';\n  background-image: url("','");\n  background-size: contain;\n  background-position: center;\n  background-repeat: no-repeat;\n  margin-right: 15px;\n  \n  ','\n']),_templateObject2=_taggedTemplateLiteral(['\n      border-radius: 100%;\n      width: 44px;\n      height: 44px;\n      margin-top: 3px;\n      margin-bottom: 3px;\n    '],['\n      border-radius: 100%;\n      width: 44px;\n      height: 44px;\n      margin-top: 3px;\n      margin-bottom: 3px;\n    ']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Image=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].div(_templateObject,function(props){return props.width?props.width+'px':'100%';},function(props){return props.height?props.height+'px':'auto';},function(props){return props.background?props.background:'transparent';},function(props){return props.url;},function(props){return props.round&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["css"])(_templateObject2);});

/***/ }),
/* 675 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_connect__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions_actionCreators__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_helpers_variables__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_helpers_mixins__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_RenderPrice__ = __webpack_require__(66);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  height: 106px;\n  margin: -40px 0 7px;\n'],['\n  height: 106px;\n  margin: -40px 0 7px;\n']),_templateObject2=_taggedTemplateLiteral(['\n  position: absolute;\n  left: 0;\n  width: 100%;\n  padding: 10px calc(8px + ((80 - 8) * ((100vw - ','px) / (',' - ',')))) 21px\n    calc(8px + ((80 - 8) * ((100vw - ','px) / (',' - ','))));\n  background-color: #f2f2f2;\n  z-index: 100;\n  // transition: box-shadow 0.125s ease;\n  ',';\n'],['\n  position: absolute;\n  left: 0;\n  width: 100%;\n  padding: 10px calc(8px + ((80 - 8) * ((100vw - ','px) / (',' - ',')))) 21px\n    calc(8px + ((80 - 8) * ((100vw - ','px) / (',' - ','))));\n  background-color: #f2f2f2;\n  z-index: 100;\n  // transition: box-shadow 0.125s ease;\n  ',';\n']),_templateObject3=_taggedTemplateLiteral(['\n      position: fixed;\n      bottom: 0;\n      box-shadow: 0 0 10px rgb(000, 000, 000, 25%);\n    '],['\n      position: fixed;\n      bottom: 0;\n      box-shadow: 0 0 10px rgb(000, 000, 000, 25%);\n    ']),_templateObject4=_taggedTemplateLiteral(['\n  display: flex;\n  align-items: flex-end;\n  margin: 0 0 10px;\n'],['\n  display: flex;\n  align-items: flex-end;\n  margin: 0 0 10px;\n']),_templateObject5=_taggedTemplateLiteral(['\n  flex: 0 0 auto;\n  > div {\n    margin: 0;\n    line-height: 1;\n    > p {\n      display: block;\n      margin: 0;\n      font-size: 14px;\n      line-height: 1;\n      + p {\n        margin: 2.5px 0 0;\n        font-size: 12px;\n      }\n    }\n  }\n'],['\n  flex: 0 0 auto;\n  > div {\n    margin: 0;\n    line-height: 1;\n    > p {\n      display: block;\n      margin: 0;\n      font-size: 14px;\n      line-height: 1;\n      + p {\n        margin: 2.5px 0 0;\n        font-size: 12px;\n      }\n    }\n  }\n']),_templateObject6=_taggedTemplateLiteral(['\n  list-style: none;\n  flex: 1 1 auto;\n  min-width: 0;\n  margin: 0;\n  padding: 0 10px 0 0;\n  color: ',';\n  font-size: 9px;\n  font-weight: 600;\n  line-height: 1.25;\n'],['\n  list-style: none;\n  flex: 1 1 auto;\n  min-width: 0;\n  margin: 0;\n  padding: 0 10px 0 0;\n  color: ',';\n  font-size: 9px;\n  font-weight: 600;\n  line-height: 1.25;\n']),_templateObject7=_taggedTemplateLiteral(['\n  margin: 0 0 2.5px;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n  &:last-child {\n    margin: 0;\n  }\n'],['\n  margin: 0 0 2.5px;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n  &:last-child {\n    margin: 0;\n  }\n']),_templateObject8=_taggedTemplateLiteral(['\n  margin: 0 10px 0 0;\n  &:last-child {\n    margin: 0;\n  }\n  &:before {\n    content: \'\';\n    display: inline-block;\n    height: 3px;\n    width: 6px;\n    margin: -3px 5px 0 0;\n    border-left: 1px solid ',';\n    border-bottom: 1px solid ',';\n    transform: rotate(-45deg);\n    vertical-align: middle;\n  }\n'],['\n  margin: 0 10px 0 0;\n  &:last-child {\n    margin: 0;\n  }\n  &:before {\n    content: \'\';\n    display: inline-block;\n    height: 3px;\n    width: 6px;\n    margin: -3px 5px 0 0;\n    border-left: 1px solid ',';\n    border-bottom: 1px solid ',';\n    transform: rotate(-45deg);\n    vertical-align: middle;\n  }\n']),_templateObject9=_taggedTemplateLiteral(['\n  display: flex;\n  flex-wrap: wrap;\n  @media screen and (min-width: 320px) {\n    flex-wrap: nowrap;\n  }\n'],['\n  display: flex;\n  flex-wrap: wrap;\n  @media screen and (min-width: 320px) {\n    flex-wrap: nowrap;\n  }\n']),_templateObject10=_taggedTemplateLiteral(['\n  display: block;\n  position: relative;\n  width: 100%;\n  padding: 15px 20px;\n  border: 1px solid ',';\n  outline: none;\n  background-color: ',';\n  color: ',';\n  ',';\n  font-size: 11px;\n  font-weight: 600;\n  line-height: 1;\n  letter-spacing: 0.125em;\n  text-transform: uppercase;\n  text-align: center;\n  overflow: hidden;\n  cursor: pointer;\n  transition: opacity 0.125s ease, border-color 0.125s ease;\n  &:hover {\n    opacity: 0.875;\n  }\n  &:focus {\n    border-color: ',';\n  }\n  &:after {\n    content: \'\';\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    background-color: ',';\n    background-image: url(\'/images/icons/checkmark.svg\');\n    background-position: center;\n    background-repeat: no-repeat;\n    background-size: 20px;\n    opacity: 0;\n    transform: translateY(-100%);\n    transition: opacity 0.5s ease-in-out, transform 0.25s ease-in-out;\n  }\n  ',';\n'],['\n  display: block;\n  position: relative;\n  width: 100%;\n  padding: 15px 20px;\n  border: 1px solid ',';\n  outline: none;\n  background-color: ',';\n  color: ',';\n  ',';\n  font-size: 11px;\n  font-weight: 600;\n  line-height: 1;\n  letter-spacing: 0.125em;\n  text-transform: uppercase;\n  text-align: center;\n  overflow: hidden;\n  cursor: pointer;\n  transition: opacity 0.125s ease, border-color 0.125s ease;\n  &:hover {\n    opacity: 0.875;\n  }\n  &:focus {\n    border-color: ',';\n  }\n  &:after {\n    content: \'\';\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    background-color: ',';\n    background-image: url(\'/images/icons/checkmark.svg\');\n    background-position: center;\n    background-repeat: no-repeat;\n    background-size: 20px;\n    opacity: 0;\n    transform: translateY(-100%);\n    transition: opacity 0.5s ease-in-out, transform 0.25s ease-in-out;\n  }\n  ',';\n']),_templateObject11=_taggedTemplateLiteral(['\n      border-color: ',';\n      opacity: 1;\n      cursor: default;\n      &:after {\n        opacity: 1;\n        transform: translateY(0);\n      }\n    '],['\n      border-color: ',';\n      opacity: 1;\n      cursor: default;\n      &:after {\n        opacity: 1;\n        transform: translateY(0);\n      }\n    ']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var probableHeightOfStickyBuy=106;var StickyButton=function(_Component){_inherits(StickyButton,_Component);function StickyButton(props){_classCallCheck(this,StickyButton);var _this=_possibleConstructorReturn(this,(StickyButton.__proto__||Object.getPrototypeOf(StickyButton)).call(this,props));_this.state={placeholderHeight:probableHeightOfStickyBuy,isFixed:true};_this.checkIfFixed=_this.checkIfFixed.bind(_this);_this.setPlaceholderHeight=_this.setPlaceholderHeight.bind(_this);return _this;}_createClass(StickyButton,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;this.setPlaceholderHeight();this.checkIfFixed();window.addEventListener('resize',this.setPlaceholderHeight);window.addEventListener('scroll',this.checkIfFixed);if('ResizeObserver'in window){this.resizeObserver=new ResizeObserver(function(){return _this2.checkIfFixed();});// eslint-disable-line no-undef
this.resizeObserver.observe(document.body);}}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var _this3=this;if(nextProps.viewstate.get('brokeDesign')!==this.props.viewstate.get('brokeDesign')){setTimeout(function(){_this3.setPlaceholderHeight();_this3.checkIfFixed();},0);}}},{key:'componentWillUnmount',value:function componentWillUnmount(){window.removeEventListener('resize',this.setPlaceholderHeight);window.removeEventListener('scroll',this.checkIfFixed);if(this.resizeObserver){this.resizeObserver.disconnect();}}},{key:'setPlaceholderHeight',value:function setPlaceholderHeight(){this.setState({placeholderHeight:this.stickyBuyRef?this.stickyBuyRef.offsetHeight:probableHeightOfStickyBuy});}},{key:'checkIfFixed',value:function checkIfFixed(){this.setState({isFixed:this.placeholderRef&&this.placeholderRef.getBoundingClientRect().bottom>=window.innerHeight});}},{key:'render',value:function render(){var _this4=this;var _state=this.state,placeholderHeight=_state.placeholderHeight,isFixed=_state.isFixed;var _props=this.props,active=_props.active,disabled=_props.disabled,selectedVariant=_props.selectedVariant,currentOptionsPrice=_props.currentOptionsPrice,quantitySelector=_props.quantitySelector;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ProductPageStickyBuyPlaceholder,{style:{height:placeholderHeight},innerRef:function innerRef(element){_this4.placeholderRef=element;}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ProductPageStickyBuy,{fixed:isFixed,innerRef:function innerRef(element){_this4.stickyBuyRef=element;}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ProductPageStickyBuyContent,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ProductPageStickyBuyUSPList,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ProductPageStickyBuyUSPListItem,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ProductPageStickyBuyUSPListItemItem,null,'Frakt fr\xE5n 99 \u2013 790 kr'),selectedVariant.get('deliveryInformation')&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ProductPageStickyBuyUSPListItemItem,null,'Leveranstid: '+selectedVariant.get('deliveryInformation'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ProductPageStickyBuyUSPListItem,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ProductPageStickyBuyUSPListItemItem,null,'14 Dagar returr\xE4tt'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ProductPageStickyBuyUSPListItemItem,null,'3 \xC5rs reklamationsr\xE4tt'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ProductPageStickyBuyPrice,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_RenderPrice__["a" /* default */],{currentOptionsPrice:currentOptionsPrice,price:selectedVariant.get('price'),originalPrice:selectedVariant.get('originalPrice'),fontWeight:'700'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ProductPageStickyBuyButtonContent,null,quantitySelector,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ProductPageStickyBuyButton,{active:active,disabled:disabled,onClick:this.props.onClick},'L\xE4gg i varukorg'))));}}]);return StickyButton;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);StickyButton.defaultProps={viewstate:Object(__WEBPACK_IMPORTED_MODULE_3_immutable__["Map"])(),active:false,disabled:false,selectedVariant:Object(__WEBPACK_IMPORTED_MODULE_3_immutable__["Map"])(),currentOptionsPrice:null,quantitySelector:null};StickyButton.propTypes={onClick:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,viewstate:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_3_immutable__["Map"]),active:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,disabled:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,selectedVariant:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_3_immutable__["Map"]),currentOptionsPrice:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,quantitySelector:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.element};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4__store_connect__["a" /* default */])(StickyButton,{setViewstate:__WEBPACK_IMPORTED_MODULE_5__actions_actionCreators__["W" /* setViewstate */]},function(store){return{viewstate:store.viewstate};}));var ProductPageStickyBuyPlaceholder=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject);var ProductPageStickyBuy=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject2,__WEBPACK_IMPORTED_MODULE_6__styles_helpers_variables__["f" /* size */].small,__WEBPACK_IMPORTED_MODULE_6__styles_helpers_variables__["f" /* size */].xLarge,__WEBPACK_IMPORTED_MODULE_6__styles_helpers_variables__["f" /* size */].small,__WEBPACK_IMPORTED_MODULE_6__styles_helpers_variables__["f" /* size */].small,__WEBPACK_IMPORTED_MODULE_6__styles_helpers_variables__["f" /* size */].xLarge,__WEBPACK_IMPORTED_MODULE_6__styles_helpers_variables__["f" /* size */].small,function(props){return props.fixed&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject3);});var ProductPageStickyBuyContent=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject4);var ProductPageStickyBuyPrice=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject5);var ProductPageStickyBuyUSPList=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].ul(_templateObject6,__WEBPACK_IMPORTED_MODULE_6__styles_helpers_variables__["c" /* color */].black);var ProductPageStickyBuyUSPListItem=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].li(_templateObject7);var ProductPageStickyBuyUSPListItemItem=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].span(_templateObject8,__WEBPACK_IMPORTED_MODULE_6__styles_helpers_variables__["c" /* color */].primary,__WEBPACK_IMPORTED_MODULE_6__styles_helpers_variables__["c" /* color */].primary);var ProductPageStickyBuyButtonContent=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject9);var ProductPageStickyBuyButton=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].button(_templateObject10,__WEBPACK_IMPORTED_MODULE_6__styles_helpers_variables__["c" /* color */].success,__WEBPACK_IMPORTED_MODULE_6__styles_helpers_variables__["c" /* color */].success,__WEBPACK_IMPORTED_MODULE_6__styles_helpers_variables__["c" /* color */].white,__WEBPACK_IMPORTED_MODULE_7__styles_helpers_mixins__["d" /* fontFamilyBody */],__WEBPACK_IMPORTED_MODULE_6__styles_helpers_variables__["c" /* color */].black,__WEBPACK_IMPORTED_MODULE_6__styles_helpers_variables__["c" /* color */].success,function(props){return props.active&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject11,__WEBPACK_IMPORTED_MODULE_6__styles_helpers_variables__["c" /* color */].success);});

/***/ }),
/* 676 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_swipe__ = __webpack_require__(677);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_swipe___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_swipe__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_immutable__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ReactSwipeDots__ = __webpack_require__(679);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_Container__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__MainProductImage__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants_endpoints__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_helpers_variables__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__styles_ProductImageBackground__ = __webpack_require__(681);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__styles_ProductImage__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__styles_ProductTag__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__constants_imageTypes__ = __webpack_require__(110);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  position: absolute;\n  display: flex;\n  flex-wrap: wrap;\n  width: 100%;\n  top: 10px;\n  left: 8px;\n  @media screen and (min-width: ','px) {\n    top: 11px;\n    left: 11px;\n  }\n'],['\n  position: absolute;\n  display: flex;\n  flex-wrap: wrap;\n  width: 100%;\n  top: 10px;\n  left: 8px;\n  @media screen and (min-width: ','px) {\n    top: 11px;\n    left: 11px;\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  display: block;\n'],['\n  display: block;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SwipeWrapper=function(_Component){_inherits(SwipeWrapper,_Component);function SwipeWrapper(props){_classCallCheck(this,SwipeWrapper);var _this=_possibleConstructorReturn(this,(SwipeWrapper.__proto__||Object.getPrototypeOf(SwipeWrapper)).call(this,props));_this.state={swipeIndex:0,allImages:[]};_this.onSwipeChangeCallback=_this.onSwipeChangeCallback.bind(_this);_this.getAllImages=_this.getAllImages.bind(_this);return _this;}_createClass(SwipeWrapper,[{key:'componentDidMount',value:function componentDidMount(){this.getAllImages(this.props);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){this.getAllImages(nextProps);}},{key:'onSwipeChangeCallback',value:function onSwipeChangeCallback(index){this.setState({swipeIndex:index});}},{key:'getAllImages',value:function getAllImages(props){var productImages=props.currentProduct.get('images')&&props.currentProduct.get('images').skip(1).toArray();var variantImages=props.selectedVariant.get('images')&&props.selectedVariant.get('images').skip(props.productImageType===__WEBPACK_IMPORTED_MODULE_13__constants_imageTypes__["b" /* MATERIAL_IMAGE */]?0:1).toArray();var allImages=[].concat(_toConsumableArray(variantImages||[]),_toConsumableArray(productImages||[]));this.setState({allImages:allImages});}},{key:'jumpToFirst',value:function jumpToFirst(){if(this.reactSwipe){this.reactSwipe.slide(0);}}},{key:'render',value:function render(){var _this2=this;var _props=this.props,pageWidth=_props.pageWidth,productImageUrl=_props.productImageUrl,productImageAlt=_props.productImageAlt,productImageType=_props.productImageType,baseProductImageUrl=_props.baseProductImageUrl,baseProductImageAlt=_props.baseProductImageAlt;var allImages=this.state.allImages;var productImagesInSwipe=allImages.map(function(image,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__styles_Container__["a" /* Container */],{swipe:true,noPadding:true,pageWidth:pageWidth,key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__styles_ProductImageBackground__["a" /* ProductImageBackground */],{backGroundImg:__WEBPACK_IMPORTED_MODULE_8__constants_endpoints__["n" /* SITE_ROOT_URL */]+encodeURI(image.get('url'))}));});var reactSwipeDots=allImages.length!==0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__ReactSwipeDots__["a" /* ReactSwipeDots */],{swipeIndex:this.state.swipeIndex,numberOfDots:allImages.length+1}):'';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SwipeContainer,{className:'SwipeContainer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_swipe___default.a,{className:'carousel',ref:function ref(reactSwipe){_this2.reactSwipe=reactSwipe;},childCount:allImages.length+1,swipeOptions:{continuous:false,callback:this.onSwipeChangeCallback}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__styles_Container__["a" /* Container */],{swipe:true,noPadding:true,pageWidth:pageWidth,key:8},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__MainProductImage__["a" /* default */],{className:'mainProductImage',swipe:allImages.length!==0},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ProductTagContainer,null,this.props.selectedVariant.get('tags',Object(__WEBPACK_IMPORTED_MODULE_4_immutable__["List"])()).map(function(tag){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__styles_ProductTag__["a" /* ProductTag */],{color:tag.get('key')},tag.get('value'));})),productImageType===__WEBPACK_IMPORTED_MODULE_13__constants_imageTypes__["b" /* MATERIAL_IMAGE */]?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__styles_ProductImage__["a" /* ProductImage */],{src:baseProductImageUrl,alt:baseProductImageAlt}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__styles_ProductImage__["a" /* ProductImage */],{src:productImageUrl,alt:productImageAlt}))),productImagesInSwipe),reactSwipeDots);}}]);return SwipeWrapper;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var ProductTagContainer=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].div(_templateObject,__WEBPACK_IMPORTED_MODULE_9__styles_helpers_variables__["f" /* size */].medium);var SwipeContainer=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].div(_templateObject2);SwipeWrapper.defaultProps={currentProduct:Object(__WEBPACK_IMPORTED_MODULE_4_immutable__["Map"])(),selectedVariant:Object(__WEBPACK_IMPORTED_MODULE_4_immutable__["Map"])(),pageWidth:0,productImageUrl:null,productImageAlt:'',baseProductImageUrl:null,baseProductImageAlt:''};SwipeWrapper.propTypes={currentProduct:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_4_immutable__["Map"]),selectedVariant:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_4_immutable__["Map"]),pageWidth:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,productImageUrl:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,productImageAlt:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,baseProductImageUrl:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,baseProductImageAlt:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (SwipeWrapper);

/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _swipeJsIso = __webpack_require__(678);

var _swipeJsIso2 = _interopRequireDefault(_swipeJsIso);

var _objectAssign = __webpack_require__(72);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ReactSwipe = function (_Component) {
  _inherits(ReactSwipe, _Component);

  function ReactSwipe() {
    _classCallCheck(this, ReactSwipe);

    return _possibleConstructorReturn(this, (ReactSwipe.__proto__ || Object.getPrototypeOf(ReactSwipe)).apply(this, arguments));
  }

  _createClass(ReactSwipe, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var swipeOptions = this.props.swipeOptions;


      this.swipe = (0, _swipeJsIso2.default)(this.container, swipeOptions);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var _props = this.props,
          childCount = _props.childCount,
          swipeOptions = _props.swipeOptions;


      if (prevProps.childCount !== childCount) {
        this.swipe.kill();
        this.swipe = (0, _swipeJsIso2.default)(this.container, swipeOptions);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.swipe.kill();
      this.swipe = void 0;
    }
  }, {
    key: 'next',
    value: function next() {
      this.swipe.next();
    }
  }, {
    key: 'prev',
    value: function prev() {
      this.swipe.prev();
    }
  }, {
    key: 'slide',
    value: function slide() {
      var _swipe;

      (_swipe = this.swipe).slide.apply(_swipe, arguments);
    }
  }, {
    key: 'getPos',
    value: function getPos() {
      return this.swipe.getPos();
    }
  }, {
    key: 'getNumSlides',
    value: function getNumSlides() {
      return this.swipe.getNumSlides();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props2 = this.props,
          id = _props2.id,
          className = _props2.className,
          style = _props2.style,
          children = _props2.children;


      return _react2.default.createElement(
        'div',
        { ref: function ref(container) {
            return _this2.container = container;
          }, id: id, className: 'react-swipe-container ' + className, style: style.container },
        _react2.default.createElement(
          'div',
          { style: style.wrapper },
          _react2.default.Children.map(children, function (child) {
            if (!child) {
              return null;
            }

            var childStyle = child.props.style ? (0, _objectAssign2.default)({}, style.child, child.props.style) : style.child;

            return _react2.default.cloneElement(child, { style: childStyle });
          })
        )
      );
    }
  }]);

  return ReactSwipe;
}(_react.Component);

ReactSwipe.propTypes = {
  swipeOptions: _propTypes2.default.shape({
    startSlide: _propTypes2.default.number,
    speed: _propTypes2.default.number,
    auto: _propTypes2.default.number,
    continuous: _propTypes2.default.bool,
    disableScroll: _propTypes2.default.bool,
    stopPropagation: _propTypes2.default.bool,
    swiping: _propTypes2.default.func,
    callback: _propTypes2.default.func,
    transitionEnd: _propTypes2.default.func
  }),
  style: _propTypes2.default.shape({
    container: _propTypes2.default.object,
    wrapper: _propTypes2.default.object,
    child: _propTypes2.default.object
  }),
  id: _propTypes2.default.string,
  className: _propTypes2.default.string,
  childCount: _propTypes2.default.number
};
ReactSwipe.defaultProps = {
  swipeOptions: {},
  style: {
    container: {
      overflow: 'hidden',
      visibility: 'hidden',
      position: 'relative'
    },

    wrapper: {
      overflow: 'hidden',
      position: 'relative'
    },

    child: {
      float: 'left',
      width: '100%',
      position: 'relative',
      transitionProperty: 'transform'
    }
  },
  className: '',
  childCount: 0
};
exports.default = ReactSwipe;
module.exports = exports['default'];


/***/ }),
/* 678 */
/***/ (function(module, exports) {

/*
 * Swipe 2.0.0
 * Brad Birdsall
 * https://github.com/thebird/Swipe
 * Copyright 2013-2015, MIT License
 *
 */

(function(root, factory) {
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = factory();
  } else {
    root.Swipe = factory();
  }
})(this, function() {
  'use strict';

  return function Swipe(container, options) {
    // utilities
    var noop = function() {}; // simple no operation function
    var offloadFn = function(fn) {
      setTimeout(fn || noop, 0);
    }; // offload a functions execution

    // check browser capabilities
    var browser = {
      addEventListener: !!window.addEventListener,
      touch:
        'ontouchstart' in window ||
        (window.DocumentTouch && document instanceof window.DocumentTouch),
      transitions: (function(temp) {
        var props = [
          'transitionProperty',
          'WebkitTransition',
          'MozTransition',
          'OTransition',
          'msTransition'
        ];
        for (var i in props)
          if (temp.style[props[i]] !== undefined) return true;
        return false;
      })(document.createElement('swipe'))
    };

    // quit if no root element
    if (!container) return;
    var element = container.children[0];
    var slides, slidePos, width, length;
    options = options || {};
    var index = parseInt(options.startSlide, 10) || 0;
    var speed = options.speed || 300;
    var widthOfSiblingSlidePreview =
      parseInt(options.widthOfSiblingSlidePreview, 10) || 0;
    var continuous = (options.continuous =
      options.continuous !== undefined ? options.continuous : true);

    function setup() {
      // cache slides
      slides = element.children;
      length = slides.length;

      // set continuous to false if only one slide
      continuous = slides.length < 2 ? false : options.continuous;

      // create an array to store current positions of each slide
      slidePos = new Array(slides.length);

      // determine width of each slide
      width =
        Math.round(
          container.getBoundingClientRect().width || container.offsetWidth
        ) -
        widthOfSiblingSlidePreview * 2;

      element.style.width = slides.length * width + 'px';

      // stack elements
      var pos = slides.length;
      while (pos--) {
        var slide = slides[pos];

        slide.style.width = width + 'px';
        slide.setAttribute('data-index', pos);

        if (browser.transitions) {
          slide.style.left = pos * -width + widthOfSiblingSlidePreview + 'px';
          move(pos, index > pos ? -width : index < pos ? width : 0, 0);
        }
      }

      // reposition elements before and after index
      if (continuous && browser.transitions) {
        move(circle(index - 1), -width, 0);
        move(circle(index + 1), width, 0);
      }

      if (!browser.transitions)
        element.style.left = index * -width + widthOfSiblingSlidePreview + 'px';

      container.style.visibility = 'visible';
    }

    function prev() {
      if (continuous) slide(index - 1);
      else if (index) slide(index - 1);
    }

    function next() {
      if (continuous) slide(index + 1);
      else if (index < slides.length - 1) slide(index + 1);
    }

    function circle(index) {
      // a simple positive modulo using slides.length
      return (slides.length + (index % slides.length)) % slides.length;
    }

    function slide(to, slideSpeed) {
      // do nothing if already on requested slide
      if (index == to) return;

      if (browser.transitions) {
        var direction = Math.abs(index - to) / (index - to); // 1: backward, -1: forward

        // get the actual position of the slide
        if (continuous) {
          var natural_direction = direction;
          direction = -slidePos[circle(to)] / width;

          // if going forward but to < index, use to = slides.length + to
          // if going backward but to > index, use to = -slides.length + to
          if (direction !== natural_direction)
            to = -direction * slides.length + to;
        }

        var diff = Math.abs(index - to) - 1;

        // move all the slides between index and to in the right direction
        while (diff--)
          move(
            circle((to > index ? to : index) - diff - 1),
            width * direction,
            0
          );

        to = circle(to);

        move(index, width * direction, slideSpeed || speed);
        move(to, 0, slideSpeed || speed);

        if (continuous) move(circle(to - direction), -(width * direction), 0); // we need to get the next in place
      } else {
        to = circle(to);
        animate(index * -width, to * -width, slideSpeed || speed);
        //no fallback for a circular continuous if the browser does not accept transitions
      }

      index = to;
      offloadFn(options.callback && options.callback(index, slides[index]));
    }

    function move(index, dist, speed) {
      translate(index, dist, speed);
      slidePos[index] = dist;
    }

    function translate(index, dist, speed) {
      var slide = slides[index];
      var style = slide && slide.style;

      if (!style) return;

      style.webkitTransitionDuration = style.MozTransitionDuration = style.msTransitionDuration = style.OTransitionDuration = style.transitionDuration =
        speed + 'ms';

      style.webkitTransform = 'translate(' + dist + 'px,0)' + 'translateZ(0)';
      style.msTransform = style.MozTransform = style.OTransform =
        'translateX(' + dist + 'px)';
    }

    function animate(from, to, speed) {
      // if not an animation, just reposition
      if (!speed) {
        element.style.left = to + 'px';
        return;
      }

      var start = +new Date();

      var timer = setInterval(function() {
        var timeElap = +new Date() - start;

        if (timeElap > speed) {
          element.style.left = to + 'px';

          if (delay) begin();

          options.transitionEnd &&
            options.transitionEnd.call(event, index, slides[index]);

          clearInterval(timer);
          return;
        }

        element.style.left =
          (to - from) * (Math.floor((timeElap / speed) * 100) / 100) +
          from +
          'px';
      }, 4);
    }

    // setup auto slideshow
    var delay = options.auto || 0;
    var interval;

    function begin() {
      clearTimeout(interval);
      interval = setTimeout(next, delay);
    }

    function stop() {
      delay = 0;
      clearTimeout(interval);
    }

    // setup initial vars
    var start = {};
    var delta = {};
    var isScrolling;

    // setup event capturing
    var events = {
      handleEvent: function(event) {
        switch (event.type) {
          case 'touchstart':
            this.start(event);
            break;
          case 'touchmove':
            this.move(event);
            break;
          case 'touchend':
            offloadFn(this.end(event));
            break;
          case 'webkitTransitionEnd':
          case 'msTransitionEnd':
          case 'oTransitionEnd':
          case 'otransitionend':
          case 'transitionend':
            offloadFn(this.transitionEnd(event));
            break;
          case 'resize':
            offloadFn(setup);
            break;
        }

        if (options.stopPropagation) event.stopPropagation();
      },
      start: function(event) {
        var touches = event.touches[0];

        // measure start values
        start = {
          // get initial touch coords
          x: touches.pageX,
          y: touches.pageY,

          // store time to determine touch duration
          time: +new Date()
        };

        // used for testing first move event
        isScrolling = undefined;

        // reset delta and end measurements
        delta = {};

        // attach touchmove and touchend listeners
        element.addEventListener('touchmove', this, false);
        element.addEventListener('touchend', this, false);
      },
      move: function(event) {
        // ensure swiping with one touch and not pinching
        if (event.touches.length > 1 || (event.scale && event.scale !== 1))
          return;

        if (options.disableScroll) return;

        var touches = event.touches[0];

        // measure change in x and y
        delta = {
          x: touches.pageX - start.x,
          y: touches.pageY - start.y
        };

        // determine if scrolling test has run - one time test
        if (typeof isScrolling == 'undefined') {
          isScrolling = !!(
            isScrolling || Math.abs(delta.x) < Math.abs(delta.y)
          );
        }

        // if user is not trying to scroll vertically
        if (!isScrolling) {
          // prevent native scrolling
          event.preventDefault();

          // stop slideshow
          stop();

          // increase resistance if first or last slide
          if (continuous) {
            // we don't add resistance at the end

            translate(
              circle(index - 1),
              delta.x + slidePos[circle(index - 1)],
              0
            );
            translate(index, delta.x + slidePos[index], 0);
            translate(
              circle(index + 1),
              delta.x + slidePos[circle(index + 1)],
              0
            );
          } else {
            delta.x =
              delta.x /
              ((!index && delta.x > 0) || // if first slide and sliding left
              (index == slides.length - 1 && // or if last slide and sliding right
                delta.x < 0) // and if sliding at all
                ? Math.abs(delta.x) / width + 1 // determine resistance level
                : 1); // no resistance if false

            // translate 1:1
            translate(index - 1, delta.x + slidePos[index - 1], 0);
            translate(index, delta.x + slidePos[index], 0);
            translate(index + 1, delta.x + slidePos[index + 1], 0);
          }
          options.swiping && options.swiping(-delta.x / width);
        }
      },
      end: function(event) {
        // measure duration
        var duration = +new Date() - start.time;

        // determine if slide attempt triggers next/prev slide
        var isValidSlide =
          (Number(duration) < 250 && // if slide duration is less than 250ms
            Math.abs(delta.x) > 20) || // and if slide amt is greater than 20px
          Math.abs(delta.x) > width / 2; // or if slide amt is greater than half the width

        // determine if slide attempt is past start and end
        var isPastBounds =
          (!index && delta.x > 0) || // if first slide and slide amt is greater than 0
          (index == slides.length - 1 && delta.x < 0); // or if last slide and slide amt is less than 0

        if (continuous) isPastBounds = false;

        // determine direction of swipe (true:right, false:left)
        var direction = delta.x < 0;

        // if not scrolling vertically
        if (!isScrolling) {
          if (isValidSlide && !isPastBounds) {
            if (direction) {
              if (continuous) {
                // we need to get the next in this direction in place

                move(circle(index - 1), -width, 0);
                move(circle(index + 2), width, 0);
              } else {
                move(index - 1, -width, 0);
              }

              move(index, slidePos[index] - width, speed);
              move(
                circle(index + 1),
                slidePos[circle(index + 1)] - width,
                speed
              );
              index = circle(index + 1);
            } else {
              if (continuous) {
                // we need to get the next in this direction in place

                move(circle(index + 1), width, 0);
                move(circle(index - 2), -width, 0);
              } else {
                move(index + 1, width, 0);
              }

              move(index, slidePos[index] + width, speed);
              move(
                circle(index - 1),
                slidePos[circle(index - 1)] + width,
                speed
              );
              index = circle(index - 1);
            }

            options.callback && options.callback(index, slides[index]);
          } else {
            if (continuous) {
              move(circle(index - 1), -width, speed);
              move(index, 0, speed);
              move(circle(index + 1), width, speed);
            } else {
              move(index - 1, -width, speed);
              move(index, 0, speed);
              move(index + 1, width, speed);
            }
          }
        }

        // kill touchmove and touchend event listeners until touchstart called again
        element.removeEventListener('touchmove', events, false);
        element.removeEventListener('touchend', events, false);
        element.removeEventListener('touchforcechange', function() {}, false);
      },
      transitionEnd: function(event) {
        if (parseInt(event.target.getAttribute('data-index'), 10) == index) {
          if (delay) begin();

          options.transitionEnd &&
            options.transitionEnd.call(event, index, slides[index]);
        }
      }
    };

    // trigger setup
    setup();

    // start auto slideshow if applicable
    if (delay) begin();

    // add event listeners
    if (browser.addEventListener) {
      // set touchstart event on element
      if (browser.touch) {
        element.addEventListener('touchstart', events, false);
        element.addEventListener('touchforcechange', function() {}, false);
      }

      if (browser.transitions) {
        element.addEventListener('webkitTransitionEnd', events, false);
        element.addEventListener('msTransitionEnd', events, false);
        element.addEventListener('oTransitionEnd', events, false);
        element.addEventListener('otransitionend', events, false);
        element.addEventListener('transitionend', events, false);
      }

      // set resize event on window
      window.addEventListener('resize', events, false);
    } else {
      window.onresize = function() {
        setup();
      }; // to play nice with old IE
    }

    // expose the Swipe API
    return {
      setup: function() {
        setup();
      },
      slide: function(to, speed) {
        // cancel slideshow
        stop();

        slide(to, speed);
      },
      prev: function() {
        // cancel slideshow
        stop();

        prev();
      },
      next: function() {
        // cancel slideshow
        stop();

        next();
      },
      stop: function() {
        // cancel slideshow
        stop();
      },
      getPos: function() {
        // return current index position
        return index;
      },
      getNumSlides: function() {
        // return total number of slides
        return length;
      },
      kill: function() {
        // cancel slideshow
        stop();

        // reset element
        element.style.width = '';
        element.style.left = '';

        // reset slides
        var pos = slides.length;
        while (pos--) {
          var slide = slides[pos];
          slide.style.width = '';
          slide.style.left = '';

          if (browser.transitions) translate(pos, 0, 0);
        }

        // removed event listeners
        if (browser.addEventListener) {
          // remove current event listeners
          element.removeEventListener('touchstart', events, false);
          element.removeEventListener('webkitTransitionEnd', events, false);
          element.removeEventListener('msTransitionEnd', events, false);
          element.removeEventListener('oTransitionEnd', events, false);
          element.removeEventListener('otransitionend', events, false);
          element.removeEventListener('transitionend', events, false);
          window.removeEventListener('resize', events, false);
        } else {
          window.onresize = null;
        }
      }
    };
  };
});


/***/ }),
/* 679 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ReactSwipeDots; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_Dot__ = __webpack_require__(680);
var _templateObject=_taggedTemplateLiteral(['\n  text-align: center;\n  margin: 0 auto;\n'],['\n  text-align: center;\n  margin: 0 auto;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var ReactSwipeDots=function ReactSwipeDots(props){var swipeIndex=props.swipeIndex,numberOfDots=props.numberOfDots;var dots=[];for(var i=0;i<numberOfDots;i+=1){if(i===swipeIndex){dots.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styles_Dot__["a" /* Dot */],{key:i,active:true}));}else{dots.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styles_Dot__["a" /* Dot */],{key:i}));}}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Container,null,dots);};var Container=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].div(_templateObject);ReactSwipeDots.defaultProps={swipeIndex:0,numberOfDots:0};ReactSwipeDots.propTypes={swipeIndex:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,numberOfDots:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number};

/***/ }),
/* 680 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Dot; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
var _templateObject=_taggedTemplateLiteral(['\n  border-radius: 50%;\n  background-color: #000;\n  display: inline-block;\n  margin:0 10px;\n  width: 5px;\n  height: 5px;\n\n  &:after {\n    content:\'\';\n    position: relative;\n    bottom: 3px;\n    right: 3px;\n    border-radius: 50%;\n    width: 9px;\n    height: 9px;\n    border: 1px solid #c5c5c5;\n    display: ',';\n  }\n'],['\n  border-radius: 50%;\n  background-color: #000;\n  display: inline-block;\n  margin:0 10px;\n  width: 5px;\n  height: 5px;\n\n  &:after {\n    content:\'\';\n    position: relative;\n    bottom: 3px;\n    right: 3px;\n    border-radius: 50%;\n    width: 9px;\n    height: 9px;\n    border: 1px solid #c5c5c5;\n    display: ',';\n  }\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Dot=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].span(_templateObject,function(props){return props.active?'block':'none';});

/***/ }),
/* 681 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProductImageBackground; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
var _templateObject=_taggedTemplateLiteral(['\n  width: 100%;\n  height: 0;\n  padding-bottom: 100%;\n  background-image: ',';\n  background-size: cover;\n  background-position: center;\n'],['\n  width: 100%;\n  height: 0;\n  padding-bottom: 100%;\n  background-image: ',';\n  background-size: cover;\n  background-position: center;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var ProductImageBackground=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].div(_templateObject,function(props){return props.backGroundImg?'url("'+props.backGroundImg+'")':'none';});

/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(683)('createBrowserHistory');
module.exports = __webpack_require__(684).createBrowserHistory;


/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var printWarning = function() {};

if (false) {
  printWarning = function(format, subs) {
    var index = 0;
    var message =
      'Warning: ' +
      (subs.length > 0
        ? format.replace(/%s/g, function() {
            return subs[index++];
          })
        : format);

    if (typeof console !== 'undefined') {
      console.error(message);
    }

    try {
      // --- Welcome to debugging history ---
      // This error was thrown as a convenience so that you can use the
      // stack trace to find the callsite that triggered this warning.
      throw new Error(message);
    } catch (e) {}
  };
}

module.exports = function(member) {
  printWarning(
    'Please use `require("history").%s` instead of `require("history/%s")`. ' +
      'Support for the latter will be removed in the next major release.',
    [member, member]
  );
};


/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(685);
} else {
  module.exports = require('./cjs/history.js');
}


/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
function _interopDefault(t){return t&&"object"==typeof t&&"default"in t?t.default:t}Object.defineProperty(exports,"__esModule",{value:!0});var resolvePathname=_interopDefault(__webpack_require__(217)),valueEqual=_interopDefault(__webpack_require__(218));__webpack_require__(219);var invariant=_interopDefault(__webpack_require__(220));function _extends(){return(_extends=Object.assign||function(t){for(var n=1;n<arguments.length;n++){var e=arguments[n];for(var a in e)Object.prototype.hasOwnProperty.call(e,a)&&(t[a]=e[a])}return t}).apply(this,arguments)}function addLeadingSlash(t){return"/"===t.charAt(0)?t:"/"+t}function stripLeadingSlash(t){return"/"===t.charAt(0)?t.substr(1):t}function hasBasename(t,n){return 0===t.toLowerCase().indexOf(n.toLowerCase())&&-1!=="/?#".indexOf(t.charAt(n.length))}function stripBasename(t,n){return hasBasename(t,n)?t.substr(n.length):t}function stripTrailingSlash(t){return"/"===t.charAt(t.length-1)?t.slice(0,-1):t}function parsePath(t){var n=t||"/",e="",a="",r=n.indexOf("#");-1!==r&&(a=n.substr(r),n=n.substr(0,r));var o=n.indexOf("?");return-1!==o&&(e=n.substr(o),n=n.substr(0,o)),{pathname:n,search:"?"===e?"":e,hash:"#"===a?"":a}}function createPath(t){var n=t.pathname,e=t.search,a=t.hash,r=n||"/";return e&&"?"!==e&&(r+="?"===e.charAt(0)?e:"?"+e),a&&"#"!==a&&(r+="#"===a.charAt(0)?a:"#"+a),r}function createLocation(t,n,e,a){var r;"string"==typeof t?(r=parsePath(t)).state=n:(void 0===(r=_extends({},t)).pathname&&(r.pathname=""),r.search?"?"!==r.search.charAt(0)&&(r.search="?"+r.search):r.search="",r.hash?"#"!==r.hash.charAt(0)&&(r.hash="#"+r.hash):r.hash="",void 0!==n&&void 0===r.state&&(r.state=n));try{r.pathname=decodeURI(r.pathname)}catch(t){throw t instanceof URIError?new URIError('Pathname "'+r.pathname+'" could not be decoded. This is likely caused by an invalid percent-encoding.'):t}return e&&(r.key=e),a?r.pathname?"/"!==r.pathname.charAt(0)&&(r.pathname=resolvePathname(r.pathname,a.pathname)):r.pathname=a.pathname:r.pathname||(r.pathname="/"),r}function locationsAreEqual(t,n){return t.pathname===n.pathname&&t.search===n.search&&t.hash===n.hash&&t.key===n.key&&valueEqual(t.state,n.state)}function createTransitionManager(){var o=null;var a=[];return{setPrompt:function(t){return o=t,function(){o===t&&(o=null)}},confirmTransitionTo:function(t,n,e,a){if(null!=o){var r="function"==typeof o?o(t,n):o;"string"==typeof r?"function"==typeof e?e(r,a):a(!0):a(!1!==r)}else a(!0)},appendListener:function(t){var n=!0;function e(){n&&t.apply(void 0,arguments)}return a.push(e),function(){n=!1,a=a.filter(function(t){return t!==e})}},notifyListeners:function(){for(var t=arguments.length,n=new Array(t),e=0;e<t;e++)n[e]=arguments[e];a.forEach(function(t){return t.apply(void 0,n)})}}}var canUseDOM=!("undefined"==typeof window||!window.document||!window.document.createElement);function getConfirmation(t,n){n(window.confirm(t))}function supportsHistory(){var t=window.navigator.userAgent;return(-1===t.indexOf("Android 2.")&&-1===t.indexOf("Android 4.0")||-1===t.indexOf("Mobile Safari")||-1!==t.indexOf("Chrome")||-1!==t.indexOf("Windows Phone"))&&(window.history&&"pushState"in window.history)}function supportsPopStateOnHashChange(){return-1===window.navigator.userAgent.indexOf("Trident")}function supportsGoWithoutReloadUsingHash(){return-1===window.navigator.userAgent.indexOf("Firefox")}function isExtraneousPopstateEvent(t){return void 0===t.state&&-1===navigator.userAgent.indexOf("CriOS")}var PopStateEvent="popstate",HashChangeEvent="hashchange";function getHistoryState(){try{return window.history.state||{}}catch(t){return{}}}function createBrowserHistory(t){void 0===t&&(t={}),canUseDOM||invariant(!1);var s=window.history,c=supportsHistory(),n=!supportsPopStateOnHashChange(),e=t,a=e.forceRefresh,h=void 0!==a&&a,r=e.getUserConfirmation,u=void 0===r?getConfirmation:r,o=e.keyLength,i=void 0===o?6:o,f=t.basename?stripTrailingSlash(addLeadingSlash(t.basename)):"";function l(t){var n=t||{},e=n.key,a=n.state,r=window.location,o=r.pathname+r.search+r.hash;return f&&(o=stripBasename(o,f)),createLocation(o,a,e)}function d(){return Math.random().toString(36).substr(2,i)}var v=createTransitionManager();function p(t){_extends(T,t),T.length=s.length,v.notifyListeners(T.location,T.action)}function g(t){isExtraneousPopstateEvent(t)||w(l(t.state))}function P(){w(l(getHistoryState()))}var m=!1;function w(n){if(m)m=!1,p();else{v.confirmTransitionTo(n,"POP",u,function(t){t?p({action:"POP",location:n}):function(t){var n=T.location,e=H.indexOf(n.key);-1===e&&(e=0);var a=H.indexOf(t.key);-1===a&&(a=0);var r=e-a;r&&(m=!0,L(r))}(n)})}}var y=l(getHistoryState()),H=[y.key];function x(t){return f+createPath(t)}function L(t){s.go(t)}var O=0;function E(t){1===(O+=t)&&1===t?(window.addEventListener(PopStateEvent,g),n&&window.addEventListener(HashChangeEvent,P)):0===O&&(window.removeEventListener(PopStateEvent,g),n&&window.removeEventListener(HashChangeEvent,P))}var S=!1;var T={length:s.length,action:"POP",location:y,createHref:x,push:function(t,n){var i=createLocation(t,n,d(),T.location);v.confirmTransitionTo(i,"PUSH",u,function(t){if(t){var n=x(i),e=i.key,a=i.state;if(c)if(s.pushState({key:e,state:a},null,n),h)window.location.href=n;else{var r=H.indexOf(T.location.key),o=H.slice(0,r+1);o.push(i.key),H=o,p({action:"PUSH",location:i})}else window.location.href=n}})},replace:function(t,n){var o="REPLACE",i=createLocation(t,n,d(),T.location);v.confirmTransitionTo(i,o,u,function(t){if(t){var n=x(i),e=i.key,a=i.state;if(c)if(s.replaceState({key:e,state:a},null,n),h)window.location.replace(n);else{var r=H.indexOf(T.location.key);-1!==r&&(H[r]=i.key),p({action:o,location:i})}else window.location.replace(n)}})},go:L,goBack:function(){L(-1)},goForward:function(){L(1)},block:function(t){void 0===t&&(t=!1);var n=v.setPrompt(t);return S||(E(1),S=!0),function(){return S&&(S=!1,E(-1)),n()}},listen:function(t){var n=v.appendListener(t);return E(1),function(){E(-1),n()}}};return T}var HashChangeEvent$1="hashchange",HashPathCoders={hashbang:{encodePath:function(t){return"!"===t.charAt(0)?t:"!/"+stripLeadingSlash(t)},decodePath:function(t){return"!"===t.charAt(0)?t.substr(1):t}},noslash:{encodePath:stripLeadingSlash,decodePath:addLeadingSlash},slash:{encodePath:addLeadingSlash,decodePath:addLeadingSlash}};function stripHash(t){var n=t.indexOf("#");return-1===n?t:t.slice(0,n)}function getHashPath(){var t=window.location.href,n=t.indexOf("#");return-1===n?"":t.substring(n+1)}function pushHashPath(t){window.location.hash=t}function replaceHashPath(t){window.location.replace(stripHash(window.location.href)+"#"+t)}function createHashHistory(t){void 0===t&&(t={}),canUseDOM||invariant(!1);var n=window.history,e=(supportsGoWithoutReloadUsingHash(),t),a=e.getUserConfirmation,i=void 0===a?getConfirmation:a,r=e.hashType,o=void 0===r?"slash":r,s=t.basename?stripTrailingSlash(addLeadingSlash(t.basename)):"",c=HashPathCoders[o],h=c.encodePath,u=c.decodePath;function f(){var t=u(getHashPath());return s&&(t=stripBasename(t,s)),createLocation(t)}var l=createTransitionManager();function d(t){_extends(E,t),E.length=n.length,l.notifyListeners(E.location,E.action)}var v=!1,p=null;function g(){var t=getHashPath(),n=h(t);if(t!==n)replaceHashPath(n);else{var e=f(),a=E.location;if(!v&&function(t,n){return t.pathname===n.pathname&&t.search===n.search&&t.hash===n.hash}(a,e))return;if(p===createPath(e))return;p=null,function(n){if(v)v=!1,d();else{l.confirmTransitionTo(n,"POP",i,function(t){t?d({action:"POP",location:n}):function(t){var n=E.location,e=y.lastIndexOf(createPath(n));-1===e&&(e=0);var a=y.lastIndexOf(createPath(t));-1===a&&(a=0);var r=e-a;r&&(v=!0,H(r))}(n)})}}(e)}}var P=getHashPath(),m=h(P);P!==m&&replaceHashPath(m);var w=f(),y=[createPath(w)];function H(t){n.go(t)}var x=0;function L(t){1===(x+=t)&&1===t?window.addEventListener(HashChangeEvent$1,g):0===x&&window.removeEventListener(HashChangeEvent$1,g)}var O=!1;var E={length:n.length,action:"POP",location:w,createHref:function(t){var n=document.querySelector("base"),e="";return n&&n.getAttribute("href")&&(e=stripHash(window.location.href)),e+"#"+h(s+createPath(t))},push:function(t,n){var o=createLocation(t,void 0,void 0,E.location);l.confirmTransitionTo(o,"PUSH",i,function(t){if(t){var n=createPath(o),e=h(s+n);if(getHashPath()!==e){p=n,pushHashPath(e);var a=y.lastIndexOf(createPath(E.location)),r=y.slice(0,a+1);r.push(n),y=r,d({action:"PUSH",location:o})}else d()}})},replace:function(t,n){var r="REPLACE",o=createLocation(t,void 0,void 0,E.location);l.confirmTransitionTo(o,r,i,function(t){if(t){var n=createPath(o),e=h(s+n);getHashPath()!==e&&(p=n,replaceHashPath(e));var a=y.indexOf(createPath(E.location));-1!==a&&(y[a]=n),d({action:r,location:o})}})},go:H,goBack:function(){H(-1)},goForward:function(){H(1)},block:function(t){void 0===t&&(t=!1);var n=l.setPrompt(t);return O||(L(1),O=!0),function(){return O&&(O=!1,L(-1)),n()}},listen:function(t){var n=l.appendListener(t);return L(1),function(){L(-1),n()}}};return E}function clamp(t,n,e){return Math.min(Math.max(t,n),e)}function createMemoryHistory(t){void 0===t&&(t={});var n=t,r=n.getUserConfirmation,e=n.initialEntries,a=void 0===e?["/"]:e,o=n.initialIndex,i=void 0===o?0:o,s=n.keyLength,c=void 0===s?6:s,h=createTransitionManager();function u(t){_extends(g,t),g.length=g.entries.length,h.notifyListeners(g.location,g.action)}function f(){return Math.random().toString(36).substr(2,c)}var l=clamp(i,0,a.length-1),d=a.map(function(t){return createLocation(t,void 0,"string"==typeof t?f():t.key||f())}),v=createPath;function p(t){var n=clamp(g.index+t,0,g.entries.length-1),e=g.entries[n];h.confirmTransitionTo(e,"POP",r,function(t){t?u({action:"POP",location:e,index:n}):u()})}var g={length:d.length,action:"POP",location:d[l],index:l,entries:d,createHref:v,push:function(t,n){var a=createLocation(t,n,f(),g.location);h.confirmTransitionTo(a,"PUSH",r,function(t){if(t){var n=g.index+1,e=g.entries.slice(0);e.length>n?e.splice(n,e.length-n,a):e.push(a),u({action:"PUSH",location:a,index:n,entries:e})}})},replace:function(t,n){var e="REPLACE",a=createLocation(t,n,f(),g.location);h.confirmTransitionTo(a,e,r,function(t){t&&(g.entries[g.index]=a,u({action:e,location:a}))})},go:p,goBack:function(){p(-1)},goForward:function(){p(1)},canGo:function(t){var n=g.index+t;return 0<=n&&n<g.entries.length},block:function(t){return void 0===t&&(t=!1),h.setPrompt(t)},listen:function(t){return h.appendListener(t)}};return g}exports.createBrowserHistory=createBrowserHistory,exports.createHashHistory=createHashHistory,exports.createMemoryHistory=createMemoryHistory,exports.createLocation=createLocation,exports.locationsAreEqual=locationsAreEqual,exports.parsePath=parsePath,exports.createPath=createPath;


/***/ }),
/* 686 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ListParent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
var _templateObject=_taggedTemplateLiteral(['\n  list-style: none;\n  margin: 10px 0 30px;\n  padding: 0;\n'],['\n  list-style: none;\n  margin: 10px 0 30px;\n  padding: 0;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var ListParent=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].ul(_templateObject);

/***/ }),
/* 687 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ListItem; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_mixins__ = __webpack_require__(6);
var _templateObject=_taggedTemplateLiteral(['\n  ',';\n  margin-bottom: 10px;\n  font-size: 14px;\n  font-weight: normal;\n'],['\n  ',';\n  margin-bottom: 10px;\n  font-size: 14px;\n  font-weight: normal;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var ListItem=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].li(_templateObject,__WEBPACK_IMPORTED_MODULE_1__helpers_mixins__["d" /* fontFamilyBody */]);

/***/ }),
/* 688 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Label; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
var _templateObject=_taggedTemplateLiteral(['\n  display: inline-block;\n  font-weight: 600;\n'],['\n  display: inline-block;\n  font-weight: 600;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Label=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].span(_templateObject);

/***/ }),
/* 689 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return WashIcon; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
var _templateObject=_taggedTemplateLiteral(['\n  color: black;\n  font-size: 14px;\n  font-family: WashingMachine;\n  font-weight: normal;\n  font-style: normal;\n  line-height: 0;\n'],['\n  color: black;\n  font-size: 14px;\n  font-family: WashingMachine;\n  font-weight: normal;\n  font-style: normal;\n  line-height: 0;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var WashIcon=function WashIcon(_ref){var id=_ref.id;if(id==='Washing1')return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(IconDiv,null,'(');if(id==='Washing2')return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(IconDiv,null,',');if(id==='Washing3')return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(IconDiv,null,'4');if(id==='Washing4')return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(IconDiv,null,'\xB5');if(id==='Washing5')return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(IconDiv,null,'c');if(id==='Washing6')return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(IconDiv,null,'d');if(id==='Washing7')return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(IconDiv,null,'e');if(id==='Washing8')return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(IconDiv,null,'\xAB');if(id==='Washing9')return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(IconDiv,null,'\u201E');if(id==='Washing10')return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(IconDiv,null,'\xB6');if(id==='Washing11')return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(IconDiv,null,'"');if(id==='Washing12')return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(IconDiv,null,'*');if(id==='Washing13')return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(IconDiv,null,'"*');if(id==='Washing14')return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(IconDiv,null,'\xC7');if(id==='Washing15')return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(IconDiv,null,'&');return false;};var IconDiv=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].span(_templateObject);

/***/ }),
/* 690 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_connect__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_helpers_variables__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_helpers_mixins__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_RenderPrice__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_Button__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__constants_endpoints__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__actions_actionCreators__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util_analyticEvents__ = __webpack_require__(68);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  display: flex;\n'],['\n  display: flex;\n']),_templateObject2=_taggedTemplateLiteral(['\n  flex: 0 0 120px;\n  align-self: flex-start;\n  position: relative;\n  max-width: 120px;\n  background-color: #ffffff;\n  &:after {\n    content: \'\';\n    display: block;\n    padding: 0 0 100%;\n  }\n  >a {\n    >img {\n      position: absolute;\n      top: 0;\n      left: 0;\n      height: 100%;\n      width: 100%;\n      padding: 10px;\n      object-fit: contain;\n    }\n  }\n'],['\n  flex: 0 0 120px;\n  align-self: flex-start;\n  position: relative;\n  max-width: 120px;\n  background-color: #ffffff;\n  &:after {\n    content: \'\';\n    display: block;\n    padding: 0 0 100%;\n  }\n  >a {\n    >img {\n      position: absolute;\n      top: 0;\n      left: 0;\n      height: 100%;\n      width: 100%;\n      padding: 10px;\n      object-fit: contain;\n    }\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  flex: 1 1 auto;\n  display: flex;\n  flex-direction: column;\n  padding: 0 0 0 15px;\n'],['\n  flex: 1 1 auto;\n  display: flex;\n  flex-direction: column;\n  padding: 0 0 0 15px;\n']),_templateObject4=_taggedTemplateLiteral(['\n  margin: 0 0 2.5px;\n  color: #a7a7a7;\n  font-size: 12px;\n  font-weight: 600;\n  letter-spacing: 0.125em;\n  text-transform: uppercase;\n'],['\n  margin: 0 0 2.5px;\n  color: #a7a7a7;\n  font-size: 12px;\n  font-weight: 600;\n  letter-spacing: 0.125em;\n  text-transform: uppercase;\n']),_templateObject5=_taggedTemplateLiteral(['\n  margin: 0 0 2.5px;\n  color: ',';\n  ',';\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 1.25;\n  @media screen and (min-width: 960px) {\n    font-size: 17px;\n  }\n  >a {\n    color: inherit;\n    text-decoration: none;\n  }\n  +div {\n    margin: 0 !important;\n    >p {\n      font-size: 14px;\n      >span {\n        font-size: 10px;\n      }\n    }\n  }\n'],['\n  margin: 0 0 2.5px;\n  color: ',';\n  ',';\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 1.25;\n  @media screen and (min-width: 960px) {\n    font-size: 17px;\n  }\n  >a {\n    color: inherit;\n    text-decoration: none;\n  }\n  +div {\n    margin: 0 !important;\n    >p {\n      font-size: 14px;\n      >span {\n        font-size: 10px;\n      }\n    }\n  }\n']),_templateObject6=_taggedTemplateLiteral(['\n  margin: auto 0 0;\n  padding: 7.5px 0 0;\n  >button {\n    margin: 0;\n  }\n'],['\n  margin: auto 0 0;\n  padding: 7.5px 0 0;\n  >button {\n    margin: 0;\n  }\n']),_templateObject7=_taggedTemplateLiteral(['\n  list-style: none;\n  margin: 0;\n  padding: 0;\n'],['\n  list-style: none;\n  margin: 0;\n  padding: 0;\n']),_templateObject8=_taggedTemplateLiteral(['\n  margin: 0 0 15px;\n  &:last-child {\n    margin: 0;\n  }\n'],['\n  margin: 0 0 15px;\n  &:last-child {\n    margin: 0;\n  }\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProductPageComplimentaryComponent=function(_Component){_inherits(ProductPageComplimentaryComponent,_Component);function ProductPageComplimentaryComponent(props){_classCallCheck(this,ProductPageComplimentaryComponent);var _this=_possibleConstructorReturn(this,(ProductPageComplimentaryComponent.__proto__||Object.getPrototypeOf(ProductPageComplimentaryComponent)).call(this,props));_this.buyButtonActiveTimeout=null;_this.state={buyButtonActive:false};_this.buyButtonHandler=_this.buyButtonHandler.bind(_this);return _this;}_createClass(ProductPageComplimentaryComponent,[{key:'buyButtonHandler',value:function buyButtonHandler(id){var _this2=this;clearTimeout(this.buyButtonActiveTimeout);this.setState(function(){return{buyButtonActive:true};});this.props.addCartItem({endpointUrl:__WEBPACK_IMPORTED_MODULE_9__constants_endpoints__["c" /* CART_ADD_URL */],body:{id:id,Quantity:1,Options:[]}});this.buyButtonActiveTimeout=setTimeout(function(){return _this2.setState(function(){return{buyButtonActive:false};});},1800);this.props.setViewstate('productAddedToCart',true);}},{key:'render',value:function render(){var _this3=this;var product=this.props.product;if(!product.get('url')){return null;}if(!product.get('variants',__WEBPACK_IMPORTED_MODULE_3_immutable__["List"]).size){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ComplimentaryProduct,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ComplimentaryProductImage,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:product.get('url'),onClick:function onClick(){Object(__WEBPACK_IMPORTED_MODULE_11__util_analyticEvents__["e" /* analyticsProductClickEvent */])('productClick','Complimentary Products',product);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_9__constants_endpoints__["n" /* SITE_ROOT_URL */]+product.getIn(['images',0,'url']),alt:product.getIn(['images',0,'alt'])}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ComplimentaryProductContent,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ComplimentaryProductBrand,null,product.getIn(['brand','name'])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ComplimentaryProductName,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:product.get('url'),onClick:function onClick(){Object(__WEBPACK_IMPORTED_MODULE_11__util_analyticEvents__["e" /* analyticsProductClickEvent */])('productClick','Complimentary Products',product);}},product.get('name'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_RenderPrice__["a" /* default */],{small:true,fontWeight:'600',price:product.get('price'),originalPrice:product.get('originalPrice')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ButtonContainer,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__styles_Button__["a" /* Button */],{success:true,smallBuy:true,disabled:this.state.buyButtonActive,active:this.state.buyButtonActive,onClick:function onClick(){_this3.buyButtonHandler(product.get('defaultVariantId'));}},'L\xE4gg i varukorg'))));}var cheapestVariant=product.get('variants').sortBy(function(variant){return variant.get('price');}).take(1).get(0);var usePriceFrom=product.get('variants').filter(function(variant){return variant.get('price')===cheapestVariant.get('price');}).size!==product.get('variants').size;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ComplimentaryProduct,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ComplimentaryProductImage,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:product.get('url'),onClick:function onClick(){Object(__WEBPACK_IMPORTED_MODULE_11__util_analyticEvents__["e" /* analyticsProductClickEvent */])('productClick','Complimentary Products',product);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_9__constants_endpoints__["n" /* SITE_ROOT_URL */]+product.getIn(['mainImage','url']),alt:product.getIn(['mainImage','alt'])}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ComplimentaryProductContent,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ComplimentaryProductBrand,null,product.getIn(['brand','name'])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ComplimentaryProductName,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:product.get('url'),onClick:function onClick(){Object(__WEBPACK_IMPORTED_MODULE_11__util_analyticEvents__["e" /* analyticsProductClickEvent */])('productClick','Complimentary Products',product);}},product.get('name'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_RenderPrice__["a" /* default */],{small:true,fontWeight:'600',priceFrom:usePriceFrom,price:cheapestVariant.get('price'),originalPrice:cheapestVariant.get('originalPrice')}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ButtonContainer,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__styles_Button__["a" /* Button */],{success:true,smallBuy:true,disabled:this.state.buyButtonActive,active:this.state.buyButtonActive,onClick:function onClick(){_this3.buyButtonHandler(product.get('defaultVariantId'));}},'L\xE4gg i varukorg'))));}}]);return ProductPageComplimentaryComponent;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);;ProductPageComplimentaryComponent.defaultProps={product:Object(__WEBPACK_IMPORTED_MODULE_3_immutable__["Map"])()};ProductPageComplimentaryComponent.propTypes={product:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_3_immutable__["Map"]),setViewstate:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,addCartItem:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired};var ProductPageComplimentary=Object(__WEBPACK_IMPORTED_MODULE_4__store_connect__["a" /* default */])(ProductPageComplimentaryComponent,{addCartItem:__WEBPACK_IMPORTED_MODULE_10__actions_actionCreators__["a" /* addCartItem */],setViewstate:__WEBPACK_IMPORTED_MODULE_10__actions_actionCreators__["W" /* setViewstate */]},function(){return{};});var ComplimentaryProduct=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject);var ComplimentaryProductImage=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject2);var ComplimentaryProductContent=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject3);var ComplimentaryProductBrand=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject4);var ComplimentaryProductName=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].h3(_templateObject5,__WEBPACK_IMPORTED_MODULE_5__styles_helpers_variables__["c" /* color */].black,__WEBPACK_IMPORTED_MODULE_6__styles_helpers_mixins__["e" /* fontFamilyHeading */]);var ButtonContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject6);var ProductPageComplimentaryProducts=function ProductPageComplimentaryProducts(_ref){var complementaryProducts=_ref.complementaryProducts;if(!complementaryProducts.size){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ComplementaryProductsList,null,complementaryProducts.map(function(product){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ComplementaryProductsListItem,{key:'complementary-product-list-item-'+product.get('id')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ProductPageComplimentary,{product:product}));}).toArray());};var ComplementaryProductsList=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].ul(_templateObject7);var ComplementaryProductsListItem=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].li(_templateObject8);ProductPageComplimentaryProducts.defaultProps={complementaryProducts:Object(__WEBPACK_IMPORTED_MODULE_3_immutable__["Map"])()};ProductPageComplimentaryProducts.propTypes={complementaryProducts:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_3_immutable__["Map"]),__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_3_immutable__["List"])])};/* harmony default export */ __webpack_exports__["a"] = (ProductPageComplimentaryProducts);

/***/ }),
/* 691 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_grid_styled__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_grid_styled___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_grid_styled__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_immutable__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_qs__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__history__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store_connect__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Page__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Cart__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__styles_Container__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__styles_Heading__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__styles_Preamble__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_NavigationButton__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__styles_helpers_variables__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_LinedHeading__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__styles_Paragraph__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__OrderConfirmationPage__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_DeliveryRow__ = __webpack_require__(692);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_CartWrapperCheckoutPage__ = __webpack_require__(693);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__util_getTotalCartItems__ = __webpack_require__(694);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__api_checkoutApi__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_AvardaCheckoutForm__ = __webpack_require__(695);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__actions_actionCreators__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__util_analyticEvents__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_Conditional__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_LoadingSpinner__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__constants_endpoints__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_CampaignCodeInput__ = __webpack_require__(696);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__constants_status__ = __webpack_require__(113);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n'],['\n']),_templateObject2=_taggedTemplateLiteral(['\n  padding: 42px 0 66px 0;\n'],['\n  padding: 42px 0 66px 0;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CheckoutPage=function(_Component){_inherits(CheckoutPage,_Component);function CheckoutPage(props){_classCallCheck(this,CheckoutPage);var _this=_possibleConstructorReturn(this,(CheckoutPage.__proto__||Object.getPrototypeOf(CheckoutPage)).call(this,props));_this.queryStringObject=__WEBPACK_IMPORTED_MODULE_5_qs___default.a.parse(window.location.search.substring(1));_this.state={avardaSessionId:null,deliveryMethodId:null,showAvardaError:false,serverSideCallbackUrl:null};_this.selectDeliveryMethodHandler=_this.selectDeliveryMethodHandler.bind(_this);_this.completeFirstStep=_this.completeFirstStep.bind(_this);_this.firstStep=_this.firstStep.bind(_this);return _this;}_createClass(CheckoutPage,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;this.props.removeViewstate('cartActive');this.props.fetchDeliveryMethods();this.props.fetchArticlePageView({urlPath:this.props.location.pathname});Object(__WEBPACK_IMPORTED_MODULE_24__util_analyticEvents__["a" /* analyticsCheckoutEvent */])("checkoutStep2",2,this.props.cart.get('cart',Object(__WEBPACK_IMPORTED_MODULE_4_immutable__["List"])()));// callback in query string is "1" on Avardas redirect back to the client AFTER purchase.
if(this.queryStringObject.callback==="1"){Object(__WEBPACK_IMPORTED_MODULE_21__api_checkoutApi__["a" /* finalizePayment */])(this.queryStringObject.purchaseId).then(function(response){if(response&&response.status===__WEBPACK_IMPORTED_MODULE_29__constants_status__["a" /* COMPLETE */]){var cart=Object(__WEBPACK_IMPORTED_MODULE_4_immutable__["fromJS"])(response.cart);Object(__WEBPACK_IMPORTED_MODULE_24__util_analyticEvents__["f" /* analyticsPurchaseEvent */])(_this2.queryStringObject.purchaseId,cart);__WEBPACK_IMPORTED_MODULE_6__history__["a" /* default */].push('/tack',{order:response});}else if(response&&response.status===__WEBPACK_IMPORTED_MODULE_29__constants_status__["e" /* PENDING */]){_this2.setState({avardaSessionId:_this2.queryStringObject.purchaseId,deliveryMethodId:_this2.queryStringObject.deliveryMethodId,serverSideCallbackUrl:_this2.queryStringObject.serverSideCallbackUrl});}else{__WEBPACK_IMPORTED_MODULE_6__history__["a" /* default */].push('/error');}/*
        if (response && response.success) {
          const cart = fromJS(response.cart);
          analyticsPurchaseEvent(this.queryStringObject.purchaseId, cart);

          History.push('/tack', {order: response});
        } else {
          History.push('/error');
        }
        */});}// callback in query string is "2" on Avardas redirect back to the client BEFORE purchase (special case for Safari browser).
else if(this.queryStringObject.callback==="2"){this.setState({avardaSessionId:this.queryStringObject.purchaseId,deliveryMethodId:this.queryStringObject.deliveryMethodId});this.completeFirstStep(this.queryStringObject.deliveryMethodId);}if(!this.state.avardaSessionId&&!this.state.deliveryMethodId&&!this.props.deliveryMethods.isEmpty()&&this.queryStringObject.callback!=="1"){this.firstStep(this.props.deliveryMethods.first().get('id'));}}},{key:'componentWillUpdate',value:function componentWillUpdate(nextProps,nextState){if(!nextState.avardaSessionId&&!nextState.deliveryMethodId&&this.props.deliveryMethods.isEmpty()&&!nextProps.deliveryMethods.isEmpty()&&this.queryStringObject.callback!=="1"){this.firstStep(nextProps.deliveryMethods.first().get('id'));}}},{key:'selectDeliveryMethodHandler',value:function selectDeliveryMethodHandler(event){var deliveryMethodId=event.target.value;this.firstStep(deliveryMethodId);}},{key:'firstStep',value:function firstStep(deliveryMethodId){var _this3=this;Object(__WEBPACK_IMPORTED_MODULE_21__api_checkoutApi__["d" /* setDeliveryMethod */])(deliveryMethodId,this.state.avardaSessionId).then(function(data){var success=data===200;_this3.setState({showAvardaError:false});if(success){if(window.AvardaCheckOutClient&&_this3.state.avardaSessionId){window.AvardaCheckOutClient.updateItems();}_this3.setState({deliveryMethodId:deliveryMethodId});if(_this3.state.avardaSessionId===null){_this3.completeFirstStep(deliveryMethodId);}}else{_this3.setState({showAvardaError:true});}// fetch updated cart with current delivery cost
_this3.props.fetchCart({endpointUrl:__WEBPACK_IMPORTED_MODULE_27__constants_endpoints__["d" /* CART_API_BASE_URL */]+'/get',method:'GET'});});}},{key:'completeFirstStep',value:function completeFirstStep(){var _this4=this;Object(__WEBPACK_IMPORTED_MODULE_21__api_checkoutApi__["c" /* initializePayment */])().then(function(response){if(response&&response.purchaseId){_this4.setState({avardaSessionId:response.purchaseId,serverSideCallbackUrl:response.serverSideCallbackUrl});}else{console.error('No purchase id in response from server:',response);}});}},{key:'renderInfoLinks',value:function renderInfoLinks(){return this.props.currentPage.getIn(['fields','buyingInfoLinks'],Object(__WEBPACK_IMPORTED_MODULE_4_immutable__["List"])()).map(function(item){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grid_styled__["Box"],{key:item.get('id'),width:[1,1/2],px:'4px'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_NavigationButton__["a" /* NavigationButton */],{mb:8,url:item.get('url'),title:item.get('name'),bgColor:__WEBPACK_IMPORTED_MODULE_14__styles_helpers_variables__["c" /* color */].lightGrey}));}).toArray();}},{key:'renderDeliveryMethods',value:function renderDeliveryMethods(){var _this5=this;return this.props.deliveryMethods.map(function(item){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__components_DeliveryRow__["a" /* default */],{key:item.get('id'),id:item.get('id'),title:item.get('name'),text:item.get('description'),onChange:_this5.selectDeliveryMethodHandler,defaultChecked:_this5.queryStringObject.deliveryMethodId,cost:item.get('id','').toLowerCase().includes('fri')?0:item.get('cost'),activeValue:_this5.state.deliveryMethodId});}).toArray();}},{key:'render',value:function render(){var _props=this.props,viewstate=_props.viewstate,currentPage=_props.currentPage;var _state=this.state,avardaSessionId=_state.avardaSessionId,deliveryMethodId=_state.deliveryMethodId,serverSideCallbackUrl=_state.serverSideCallbackUrl;var isMobile=viewstate.get('pageWidth')<__WEBPACK_IMPORTED_MODULE_14__styles_helpers_variables__["f" /* size */].xLarge;var infoLinks=this.renderInfoLinks();var deliveryMethods=this.renderDeliveryMethods();if(!this.props.cart.size&&!this.queryStringObject.callback){__WEBPACK_IMPORTED_MODULE_6__history__["a" /* default */].push('/');}var isWaitingForPaymentToFinalize=this.queryStringObject.callback==="1"&&!(avardaSessionId&&deliveryMethodId&&serverSideCallbackUrl);if(isWaitingForPaymentToFinalize){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Page__["a" /* default */],{title:'Vi behandlar din order',noBreadcrumbs:true,bgImg:__WEBPACK_IMPORTED_MODULE_27__constants_endpoints__["n" /* SITE_ROOT_URL */]+'/_images/73fdd938-8f5d-42f4-b26d-ea85ce187812/xander-ashwell-25528-unsplash.jpg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__styles_Container__["a" /* Container */],{bgColor:'transparent',style:{paddingTop:'0',paddingBottom:'0',minHeight:'60vh'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__OrderConfirmationPage__["a" /* InnerContainer */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__OrderConfirmationPage__["b" /* WhiteContainer */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__styles_Heading__["a" /* Heading */],{big:true,margin:'0 0 1rem'},'V\xE4nligen v\xE4nta'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__styles_Preamble__["a" /* Preamble */],null,'Vi behandlar din order.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__components_LoadingSpinner__["a" /* LoadingSpinner */],{margin:'4rem auto !important'})))));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Page__["a" /* default */],{meta:currentPage.get('metaData'),bgColor:__WEBPACK_IMPORTED_MODULE_14__styles_helpers_variables__["c" /* color */].white,noBreadcrumbs:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grid_styled__["Flex"],{flexWrap:isMobile?'wrap':'nowrap',style:{margin:'0 auto'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grid_styled__["Flex"],{flexWrap:isMobile?'wrap':'nowrap',style:{maxWidth:'750px',margin:'0 auto',width:"100%"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grid_styled__["Box"],{width:isMobile?1:"100%",style:{order:isMobile?2:1,flex:1}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__styles_Container__["a" /* Container */],{bgColor:__WEBPACK_IMPORTED_MODULE_14__styles_helpers_variables__["c" /* color */].white,noPadding:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ContentContainer,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__styles_Heading__["a" /* Heading */].h1,null,currentPage.getIn(['fields','title'])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__components_Conditional__["a" /* Conditional */],{show:!!currentPage.getIn(['fields','introduction'])},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__styles_Preamble__["a" /* Preamble */],{textAlign:'left'},currentPage.getIn(['fields','introduction']))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__components_Conditional__["a" /* Conditional */],{show:!currentPage.getIn(['fields','buyingInfoLinks'],Object(__WEBPACK_IMPORTED_MODULE_4_immutable__["List"])()).isEmpty()},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grid_styled__["Flex"],{flexWrap:'wrap',mx:'-4px'},infoLinks)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_LinedHeading__["a" /* default */],{bgColor:__WEBPACK_IMPORTED_MODULE_14__styles_helpers_variables__["c" /* color */].white},currentPage.getIn(['fields','titleDeliveries'])),deliveryMethods,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__components_Conditional__["a" /* Conditional */],{show:this.state.showAvardaError},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__styles_Paragraph__["a" /* Paragraph */],{style:{color:__WEBPACK_IMPORTED_MODULE_14__styles_helpers_variables__["c" /* color */].warning}},'\u2022 N\xE5got gick fel n\xE4r vi f\xF6rs\xF6kte kommunicera med betalleverant\xF6ren, v\xE4nligen f\xF6rs\xF6k igen senare.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_LinedHeading__["a" /* default */],{bgColor:__WEBPACK_IMPORTED_MODULE_14__styles_helpers_variables__["c" /* color */].white},currentPage.getIn(['fields','titleCustomerDetails'])),deliveryMethodId&&avardaSessionId?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__styles_Paragraph__["a" /* Paragraph */],null,currentPage.getIn(['fields','textCustomerDetails'])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__components_CampaignCodeInput__["a" /* CampaignCodeInput */],{avardaSessionId:avardaSessionId}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__components_AvardaCheckoutForm__["a" /* default */],{avardaSessionId:avardaSessionId,deliveryMethodId:deliveryMethodId,serverSideCallbackUrl:serverSideCallbackUrl,cart:this.props.cart})):false))),isMobile&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CartBox,{width:1,ml:0,style:{order:1}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__styles_Container__["a" /* Container */],{bgColor:__WEBPACK_IMPORTED_MODULE_14__styles_helpers_variables__["c" /* color */].lightGrey,noPadding:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__components_CartWrapperCheckoutPage__["a" /* default */],{totalCartItems:Object(__WEBPACK_IMPORTED_MODULE_20__util_getTotalCartItems__["a" /* getTotalCartItems */])(this.props.cart)})))),!isMobile&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CartBox,{width:'560px',ml:20,style:{order:2}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Cart__["a" /* default */],{onCheckoutPage:true}))));}}]);return CheckoutPage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var CartBox=Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_1_grid_styled__["Box"])(_templateObject);var ContentContainer=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].div(_templateObject2);CheckoutPage.defaultProps={cart:Object(__WEBPACK_IMPORTED_MODULE_4_immutable__["Map"])(),viewstate:Object(__WEBPACK_IMPORTED_MODULE_4_immutable__["Map"])(),currentPage:Object(__WEBPACK_IMPORTED_MODULE_4_immutable__["Map"])(),deliveryMethods:Object(__WEBPACK_IMPORTED_MODULE_4_immutable__["Map"])()};CheckoutPage.propTypes={cart:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_4_immutable__["Map"]),viewstate:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_4_immutable__["Map"]),currentPage:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_4_immutable__["Map"]),deliveryMethods:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_4_immutable__["Map"]),location:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,removeViewstate:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,fetchArticlePageView:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,fetchDeliveryMethods:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,fetchCart:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__store_connect__["a" /* default */])(CheckoutPage,{removeViewstate:__WEBPACK_IMPORTED_MODULE_23__actions_actionCreators__["V" /* removeViewstate */],fetchArticlePageView:__WEBPACK_IMPORTED_MODULE_23__actions_actionCreators__["g" /* fetchArticlePageView */],fetchDeliveryMethods:__WEBPACK_IMPORTED_MODULE_23__actions_actionCreators__["v" /* fetchDeliveryMethods */],fetchCart:__WEBPACK_IMPORTED_MODULE_23__actions_actionCreators__["p" /* fetchCart */]},function(store,props){return{cart:store.cart,viewstate:store.viewstate,currentPage:store.page.data.get(props.location.pathname),deliveryMethods:store.deliveryMethods};}));

/***/ }),
/* 692 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_connect__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_RadioButton__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_helpers_variables__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_toCurrency__ = __webpack_require__(67);
var _templateObject=_taggedTemplateLiteral(['\n  display: block;\n  margin: 38px 0;\n'],['\n  display: block;\n  margin: 38px 0;\n']),_templateObject2=_taggedTemplateLiteral(['\n  margin-left: 18px;\n  font-size: 14px;\n  font-weight: 600;\n  font-style: normal;\n  font-stretch: normal;\n  line-height: 1.57;\n  letter-spacing: normal;\n  text-align: left;\n  display: block;\n  color: #000000;\n'],['\n  margin-left: 18px;\n  font-size: 14px;\n  font-weight: 600;\n  font-style: normal;\n  font-stretch: normal;\n  line-height: 1.57;\n  letter-spacing: normal;\n  text-align: left;\n  display: block;\n  color: #000000;\n']),_templateObject3=_taggedTemplateLiteral(['\n  font-weight: normal;\n  font-style: italic;\n'],['\n  font-weight: normal;\n  font-style: italic;\n']),_templateObject4=_taggedTemplateLiteral(['\n  font-size: 14px;\n  font-weight: 600;\n  font-style: normal;\n  font-stretch: normal;\n  line-height: 1.57;\n  letter-spacing: normal;\n  text-align: right;\n  display: inline-block;\n  flex: 1;\n  min-width: 60px;\n  color: #000000;\n'],['\n  font-size: 14px;\n  font-weight: 600;\n  font-style: normal;\n  font-stretch: normal;\n  line-height: 1.57;\n  letter-spacing: normal;\n  text-align: right;\n  display: inline-block;\n  flex: 1;\n  min-width: 60px;\n  color: #000000;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var DeliveryRow=function DeliveryRow(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DeliveryRowWrapper,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_RadioButton__["a" /* default */],{id:props.id,name:'DeliveryRow',defaultChecked:props.defaultChecked===props.id,value:props.id,checked:props.id===props.activeValue,onChange:function onChange(event){props.onChange(event);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DeliveryRowTitle,null,props.title,props.viewstate.get('pageWidth')<__WEBPACK_IMPORTED_MODULE_6__styles_helpers_variables__["f" /* size */].large?' - '+Object(__WEBPACK_IMPORTED_MODULE_7__util_toCurrency__["a" /* toCurrency */])(props.cost):false),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DeliveryRowText,null,props.text)),props.viewstate.get('pageWidth')>=__WEBPACK_IMPORTED_MODULE_6__styles_helpers_variables__["f" /* size */].large?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DeliveryRowPrice,null,Object(__WEBPACK_IMPORTED_MODULE_7__util_toCurrency__["a" /* toCurrency */])(props.cost)):false));};var DeliveryRowWrapper=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject);var DeliveryRowTitle=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject2);var DeliveryRowText=DeliveryRowTitle.extend(_templateObject3);var DeliveryRowPrice=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject4);DeliveryRow.defaultProps={title:null,text:null,cost:null,defaultChecked:false,viewstate:Object(__WEBPACK_IMPORTED_MODULE_3_immutable__["Map"])(),onChange:function onChange(){},activeValue:undefined};DeliveryRow.propTypes={id:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,title:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,text:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,cost:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,defaultChecked:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,viewstate:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_3_immutable__["Map"]),onChange:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,activeValue:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4__store_connect__["a" /* default */])(DeliveryRow,{},function(store){return{viewstate:store.viewstate};}));

/***/ }),
/* 693 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Cart__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_helpers_variables__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  padding: 3px 0;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n'],['\n  padding: 3px 0;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n']),_templateObject2=_taggedTemplateLiteral(['\n  font-size: 12px;\n  font-weight: 600;\n  font-style: normal;\n  font-stretch: normal;\n  line-height: normal;\n  letter-spacing: normal;\n  color: ',';\n\n  span {\n    color: ',';\n    font-weight: 600;\n  }\n'],['\n  font-size: 12px;\n  font-weight: 600;\n  font-style: normal;\n  font-stretch: normal;\n  line-height: normal;\n  letter-spacing: normal;\n  color: ',';\n\n  span {\n    color: ',';\n    font-weight: 600;\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  background-color: transparent;\n  outline: 0;\n  border: none;\n  width: 14px;\n  height: 44px;\n  background-image: url(\'/images/icons/close.svg\');\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: 14px;\n  cursor: pointer;\n  opacity: 1;\n  transform: rotateZ(-45deg);\n  transition: opacity ',' ',',\n    transform ',' ',';\n\n  &:hover {\n    opacity: 0.8;\n  }\n\n  ',';\n'],['\n  background-color: transparent;\n  outline: 0;\n  border: none;\n  width: 14px;\n  height: 44px;\n  background-image: url(\'/images/icons/close.svg\');\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: 14px;\n  cursor: pointer;\n  opacity: 1;\n  transform: rotateZ(-45deg);\n  transition: opacity ',' ',',\n    transform ',' ',';\n\n  &:hover {\n    opacity: 0.8;\n  }\n\n  ',';\n']),_templateObject4=_taggedTemplateLiteral(['\n      transform: rotateZ(0);\n    '],['\n      transform: rotateZ(0);\n    ']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CartWrapperCheckoutPage=function(_Component){_inherits(CartWrapperCheckoutPage,_Component);function CartWrapperCheckoutPage(props){_classCallCheck(this,CartWrapperCheckoutPage);var _this=_possibleConstructorReturn(this,(CartWrapperCheckoutPage.__proto__||Object.getPrototypeOf(CartWrapperCheckoutPage)).call(this,props));_this.state={isCartOpened:true};return _this;}_createClass(CartWrapperCheckoutPage,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CartWrapperCheckoutPageContainer,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ToggleButton,null,'Min varukorg (',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.props.totalCartItems),')'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Icon,{active:this.state.isCartOpened,onClick:function onClick(){_this2.setState({isCartOpened:!_this2.state.isCartOpened});}})),this.state.isCartOpened?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_Cart__["a" /* default */],{onCheckoutPage:true,onMobile:true}):false);}}]);return CartWrapperCheckoutPage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var CartWrapperCheckoutPageContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject);var ToggleButton=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].p(_templateObject2,__WEBPACK_IMPORTED_MODULE_4__styles_helpers_variables__["c" /* color */].black,__WEBPACK_IMPORTED_MODULE_4__styles_helpers_variables__["c" /* color */].primary);var Icon=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].button(_templateObject3,__WEBPACK_IMPORTED_MODULE_4__styles_helpers_variables__["a" /* animation */].transitionTime,__WEBPACK_IMPORTED_MODULE_4__styles_helpers_variables__["a" /* animation */].easing,__WEBPACK_IMPORTED_MODULE_4__styles_helpers_variables__["a" /* animation */].transitionTime,__WEBPACK_IMPORTED_MODULE_4__styles_helpers_variables__["a" /* animation */].easing,function(props){return props.active&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject4);});CartWrapperCheckoutPage.propTypes={totalCartItems:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number.isRequired};/* harmony default export */ __webpack_exports__["a"] = (CartWrapperCheckoutPage);

/***/ }),
/* 694 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getTotalCartItems; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
var getTotalCartItems=function getTotalCartItems(cart){return cart.get('cart',Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])()).reduce(function(memory,item){return memory+item.get('quantity');},0);};

/***/ }),
/* 695 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__history__ = __webpack_require__(87);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import { analyticsCheckoutEvent } from '../util/analyticEvents';
var AvardaCheckoutForm=function(_Component){_inherits(AvardaCheckoutForm,_Component);function AvardaCheckoutForm(props){_classCallCheck(this,AvardaCheckoutForm);var _this=_possibleConstructorReturn(this,(AvardaCheckoutForm.__proto__||Object.getPrototypeOf(AvardaCheckoutForm)).call(this,props));_this.iteration=0;_this.waitUntilAvardaScriptIsLoaded=_this.waitUntilAvardaScriptIsLoaded.bind(_this);return _this;}_createClass(AvardaCheckoutForm,[{key:'componentDidMount',value:function componentDidMount(){if(this.props.avardaSessionId){this.initializeAvardaSession();}}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps){return nextProps.avardaSessionId&&nextProps.avardaSessionId!==this.props.avardaSessionId||nextProps.deliveryMethodId&&nextProps.deliveryMethodId!==this.props.deliveryMethodId;}},{key:'componentDidUpdate',value:function componentDidUpdate(){if(this.props.avardaSessionId){// clear old iframe when a new on is initialized
document.getElementById('checkOutDiv').innerHTML='';this.initializeAvardaSession();}}},{key:'initializeAvardaSession',value:function initializeAvardaSession(){this.waitUntilAvardaScriptIsLoaded();}},{key:'waitUntilAvardaScriptIsLoaded',value:function waitUntilAvardaScriptIsLoaded(){var _this2=this;var deliveryMethodId=this.props.deliveryMethodId;if(typeof window.AvardaCheckOutClient!=='undefined'){var callbackUrl=window.location.origin+'/kassa?purchaseId='+this.props.avardaSessionId+'&deliveryMethodId='+this.props.deliveryMethodId+'&serverSideCallbackUrl='+this.props.serverSideCallbackUrl;var options={// ID of the <div> inside which to render the form
divId:'checkOutDiv',// The Purchase ID obtained in the previous step
purchaseId:this.props.avardaSessionId,purchaseCompletedCallbackUrl:this.props.serverSideCallbackUrl,callbackUrl:callbackUrl,done:function done(purchaseId){window.location.href='/kassa?purchaseId='+purchaseId+'&deliveryMethodId='+deliveryMethodId+'&callback=1';},customCssUrl:window.location.origin+'/avardaStyles.css',replaceDefaultCss:true};window.AvardaCheckOutClient.init(options);return true;}this.iteration=this.iteration+1;if(this.iteration>10){__WEBPACK_IMPORTED_MODULE_2__history__["a" /* default */].push('/error');}else{setTimeout(function(){_this2.waitUntilAvardaScriptIsLoaded();},500);}return false;}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'checkOutDiv'});}}]);return AvardaCheckoutForm;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);AvardaCheckoutForm.defaultProps={avardaSessionId:undefined,deliveryMethodId:undefined,serverSideCallbackUrl:undefined};AvardaCheckoutForm.propTypes={avardaSessionId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,deliveryMethodId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,serverSideCallbackUrl:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (AvardaCheckoutForm);

/***/ }),
/* 696 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CampaignCodeInput; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_generalApi__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_helpers_variables__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_helpers_mixins__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants_websiteStrings__ = __webpack_require__(697);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store_connect__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__actions_actionCreators__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__constants_endpoints__ = __webpack_require__(9);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  margin: 40px 0 20px;\n'],['\n  margin: 40px 0 20px;\n']),_templateObject2=_taggedTemplateLiteral(['\n  ',';\n  display: block;\n  margin: 0;\n  font-size: 12px;\n  text-transform: uppercase;\n  letter-spacing: 1.5px;\n  font-weight: 600;\n'],['\n  ',';\n  display: block;\n  margin: 0;\n  font-size: 12px;\n  text-transform: uppercase;\n  letter-spacing: 1.5px;\n  font-weight: 600;\n']),_templateObject3=_taggedTemplateLiteral(['\n  cursor: pointer;\n  background-color: transparent;\n  border: none;\n  padding: 0;\n'],['\n  cursor: pointer;\n  background-color: transparent;\n  border: none;\n  padding: 0;\n']),_templateObject4=_taggedTemplateLiteral(['\n  width: 100%;\n  height: 50px;\n  margin: 15px 0 0;\n  max-width: 400px;\n  display: flex;\n'],['\n  width: 100%;\n  height: 50px;\n  margin: 15px 0 0;\n  max-width: 400px;\n  display: flex;\n']),_templateObject5=_taggedTemplateLiteral(['\n  background-color: ',';\n  border: solid 1px #dcdcdc;\n  color: ',';\n  outline: 0;\n  font-size: 16px;\n  font-weight: normal;\n  padding: 15px 40px 15px 14px;\n  width: 100%;\n  display: inline-block;\n  margin: 0;\n  -webkit-appearance: none;\n  border-radius: 0;\n\n  &::placeholder {\n    color: ',';\n    font-style: italic;\n  }\n'],['\n  background-color: ',';\n  border: solid 1px #dcdcdc;\n  color: ',';\n  outline: 0;\n  font-size: 16px;\n  font-weight: normal;\n  padding: 15px 40px 15px 14px;\n  width: 100%;\n  display: inline-block;\n  margin: 0;\n  -webkit-appearance: none;\n  border-radius: 0;\n\n  &::placeholder {\n    color: ',';\n    font-style: italic;\n  }\n']),_templateObject6=_taggedTemplateLiteral(['\n  ',';\n  font-size: 13px;\n  text-align: center;\n  text-transform: uppercase;\n  background-color: ',';\n  padding: 0 15px;\n  height: 100%;\n  border: none;\n  font-weight: 600;\n  font-style: normal;\n  font-stretch: normal;\n  line-height: normal;\n  letter-spacing: 1.1px;\n  color: ',';\n  cursor: pointer;\n'],['\n  ',';\n  font-size: 13px;\n  text-align: center;\n  text-transform: uppercase;\n  background-color: ',';\n  padding: 0 15px;\n  height: 100%;\n  border: none;\n  font-weight: 600;\n  font-style: normal;\n  font-stretch: normal;\n  line-height: normal;\n  letter-spacing: 1.1px;\n  color: ',';\n  cursor: pointer;\n']),_templateObject7=_taggedTemplateLiteral(['\n  ',';\n  font-size: 16px;\n  text-align: center;\n  background-color: ',';\n  padding: 0 55px 0 15px;\n  height: 100%;\n  border: none;\n  font-weight: 600;\n  font-style: normal;\n  font-stretch: normal;\n  line-height: normal;\n  letter-spacing: 1.1px;\n  color: ',';\n  margin: 0;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  width: 100%;\n  position: relative;\n'],['\n  ',';\n  font-size: 16px;\n  text-align: center;\n  background-color: ',';\n  padding: 0 55px 0 15px;\n  height: 100%;\n  border: none;\n  font-weight: 600;\n  font-style: normal;\n  font-stretch: normal;\n  line-height: normal;\n  letter-spacing: 1.1px;\n  color: ',';\n  margin: 0;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  width: 100%;\n  position: relative;\n']),_templateObject8=_taggedTemplateLiteral(['\n  position: absolute;\n  top: 0;\n  right: 0;\n  width: 50px;\n  height: 50px;\n  border: none;\n  cursor: pointer;\n  background-color: transparent;\n  background-image: url(\'/images/icons/close-white.svg\');\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: 10px;\n'],['\n  position: absolute;\n  top: 0;\n  right: 0;\n  width: 50px;\n  height: 50px;\n  border: none;\n  cursor: pointer;\n  background-color: transparent;\n  background-image: url(\'/images/icons/close-white.svg\');\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: 10px;\n']),_templateObject9=_taggedTemplateLiteral(['\n  margin: 0.5em 0;\n  min-height: 17px;\n  font-size: 12px;\n  color: ',';\n'],['\n  margin: 0.5em 0;\n  min-height: 17px;\n  font-size: 12px;\n  color: ',';\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CampaignCodeComponent=function(_PureComponent){_inherits(CampaignCodeComponent,_PureComponent);function CampaignCodeComponent(props){_classCallCheck(this,CampaignCodeComponent);var _this=_possibleConstructorReturn(this,(CampaignCodeComponent.__proto__||Object.getPrototypeOf(CampaignCodeComponent)).call(this,props));_this.state={isComponentExpanded:false,campaignCodeValue:undefined,invalidCampaignCode:undefined};_this.formHandler=_this.formHandler.bind(_this);_this.inputChangeHandler=_this.inputChangeHandler.bind(_this);_this.removeCampaignCodeHandler=_this.removeCampaignCodeHandler.bind(_this);_this.expandButtonHandler=_this.expandButtonHandler.bind(_this);return _this;}_createClass(CampaignCodeComponent,[{key:'formHandler',value:function formHandler(event){var _this2=this;event.preventDefault();var avardaSessionId=this.props.avardaSessionId;var campaignCodeValue=this.state.campaignCodeValue;if(campaignCodeValue){__WEBPACK_IMPORTED_MODULE_3__api_generalApi__["a" /* axiosSingleton */].post('/shoppingcart/setcampaigncode',{CampaignCode:campaignCodeValue,avardaSessionId:avardaSessionId}).then(function(response){if(response.data.changeOccured){_this2.props.fetchCart({endpointUrl:__WEBPACK_IMPORTED_MODULE_9__constants_endpoints__["d" /* CART_API_BASE_URL */]+'/get',method:'GET'});if(window.AvardaCheckOutClient){window.AvardaCheckOutClient.updateItems();}}else{_this2.setState({invalidCampaignCode:campaignCodeValue});}}).catch(function(error){console.error(error);});}}},{key:'inputChangeHandler',value:function inputChangeHandler(event){var campaignCodeValue=event.target.value;this.setState({campaignCodeValue:campaignCodeValue,invalidCampaignCode:undefined});}},{key:'removeCampaignCodeHandler',value:function removeCampaignCodeHandler(){var _this3=this;var _props=this.props,activeCampaignCode=_props.activeCampaignCode,avardaSessionId=_props.avardaSessionId;if(activeCampaignCode){__WEBPACK_IMPORTED_MODULE_3__api_generalApi__["a" /* axiosSingleton */].post('/shoppingcart/removecampaigncode',{CampaignCode:activeCampaignCode,avardaSessionId:avardaSessionId}).then(function(){_this3.props.fetchCart({endpointUrl:__WEBPACK_IMPORTED_MODULE_9__constants_endpoints__["d" /* CART_API_BASE_URL */]+'/get',method:'GET'});if(window.AvardaCheckOutClient){window.AvardaCheckOutClient.updateItems();}_this3.setState({invalidCampaignCode:undefined,campaignCodeValue:undefined});}).catch(function(error){console.error(error);});}}},{key:'expandButtonHandler',value:function expandButtonHandler(){this.setState({isComponentExpanded:true});}},{key:'render',value:function render(){var _props2=this.props,activeCampaignCode=_props2.activeCampaignCode,avardaSessionId=_props2.avardaSessionId;var _state=this.state,isComponentExpanded=_state.isComponentExpanded,invalidCampaignCode=_state.invalidCampaignCode;if(!avardaSessionId){return false;}// component is expanded with an active code, render the active code
if(activeCampaignCode){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CampaignCodeContainer,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ActiveCodeTitle,null,__WEBPACK_IMPORTED_MODULE_6__constants_websiteStrings__["a" /* websiteStrings */].campaignCodeActiveTitle),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CampaignCodeInputContainer,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ActiveCode,null,activeCampaignCode,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(RemoveCampaignCode,{onClick:this.removeCampaignCodeHandler}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(InputError,null));}// component is expanded without a active code, render the input field
if(isComponentExpanded&&!activeCampaignCode){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CampaignCodeContainer,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:this.formHandler},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CampaignCodeLabel,{htmlFor:'campaign-code-input'},__WEBPACK_IMPORTED_MODULE_6__constants_websiteStrings__["a" /* websiteStrings */].campaignCodeInputLabel),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CampaignCodeInputContainer,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CampaignCodeInputElement,{name:'campaign-code',id:'campaign-code-input',onChange:this.inputChangeHandler}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CampaignCodeButton,{type:'submit'},__WEBPACK_IMPORTED_MODULE_6__constants_websiteStrings__["a" /* websiteStrings */].campaignCodeSubmitLabel)),invalidCampaignCode?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(InputError,null,invalidCampaignCode,' ',__WEBPACK_IMPORTED_MODULE_6__constants_websiteStrings__["a" /* websiteStrings */].campaignCodeError):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(InputError,null)));}// component is not expanded, render expand button
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CampaignCodeContainer,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ExpandButton,{onClick:this.expandButtonHandler},__WEBPACK_IMPORTED_MODULE_6__constants_websiteStrings__["a" /* websiteStrings */].campaignCodeInputLabel));}}]);return CampaignCodeComponent;}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);CampaignCodeComponent.defaultProps={activeCampaignCode:undefined};CampaignCodeComponent.propTypes={fetchCart:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,avardaSessionId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,activeCampaignCode:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};var CampaignCodeInput=Object(__WEBPACK_IMPORTED_MODULE_7__store_connect__["a" /* default */])(CampaignCodeComponent,{fetchCart:__WEBPACK_IMPORTED_MODULE_8__actions_actionCreators__["p" /* fetchCart */]},function(store){return{activeCampaignCode:store.cart.get('campaignCode')};});var CampaignCodeContainer=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].div(_templateObject);var ActiveCodeTitle=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].p(_templateObject2,__WEBPACK_IMPORTED_MODULE_5__styles_helpers_mixins__["d" /* fontFamilyBody */]);var CampaignCodeLabel=ActiveCodeTitle.withComponent('label');var ExpandButton=ActiveCodeTitle.extend(_templateObject3).withComponent('button');var CampaignCodeInputContainer=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].div(_templateObject4);var CampaignCodeInputElement=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].input.attrs({type:'text',placeholder:__WEBPACK_IMPORTED_MODULE_6__constants_websiteStrings__["a" /* websiteStrings */].campaignCodeInputPlaceholder,autocomplete:'off'})(_templateObject5,__WEBPACK_IMPORTED_MODULE_4__styles_helpers_variables__["c" /* color */].white,__WEBPACK_IMPORTED_MODULE_4__styles_helpers_variables__["c" /* color */].black,__WEBPACK_IMPORTED_MODULE_4__styles_helpers_variables__["c" /* color */].darkgrey);var CampaignCodeButton=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].button(_templateObject6,__WEBPACK_IMPORTED_MODULE_5__styles_helpers_mixins__["d" /* fontFamilyBody */],__WEBPACK_IMPORTED_MODULE_4__styles_helpers_variables__["c" /* color */].primary,__WEBPACK_IMPORTED_MODULE_4__styles_helpers_variables__["c" /* color */].white);var ActiveCode=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].div(_templateObject7,__WEBPACK_IMPORTED_MODULE_5__styles_helpers_mixins__["d" /* fontFamilyBody */],__WEBPACK_IMPORTED_MODULE_4__styles_helpers_variables__["c" /* color */].primary,__WEBPACK_IMPORTED_MODULE_4__styles_helpers_variables__["c" /* color */].white);var RemoveCampaignCode=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].button.attrs({title:__WEBPACK_IMPORTED_MODULE_6__constants_websiteStrings__["a" /* websiteStrings */].campaignCodeRemoveCodeTitle})(_templateObject8);var InputError=__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].p(_templateObject9,__WEBPACK_IMPORTED_MODULE_4__styles_helpers_variables__["c" /* color */].warning);

/***/ }),
/* 697 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return websiteStrings; });
var websiteStrings={campaignCodeInputLabel:'Har du en kampanjkod?',campaignCodeInputPlaceholder:'',campaignCodeSubmitLabel:'Aktivera',campaignCodeError:'är inte en giltig kampanjkod',campaignCodeActiveTitle:'Aktiv kampanjkod',campaignCodeRemoveCodeTitle:'Avaktivera den aktiva kampanjkoden'};

/***/ }),
/* 698 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_grid_styled__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_grid_styled___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_grid_styled__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_connect__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_RadioButton__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__actions_actionCreators__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Page__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__styles_helpers_variables__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__styles_helpers_mixins__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__styles_Heading__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__styles_Container__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__styles_ProductImage__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__styles_NoProductsFound__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_ProductListWithFilters__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_PageList__ = __webpack_require__(699);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__selectors_reselectCategory__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_NavigationButton__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_MainProductImage__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__constants_endpoints__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_LoadingSpinner__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__history__ = __webpack_require__(87);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  background-color: ',';\n  line-height: 1.3;\n  text-align: center;\n  margin: 0;\n  padding: 30px 5px;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n  ',';\n\n  ',';\n  @media screen and (min-width: ','px) {\n    ',';\n  }\n  @media screen and (min-width: 850px) {\n    font-size: 20px;\n  }\n'],['\n  background-color: ',';\n  line-height: 1.3;\n  text-align: center;\n  margin: 0;\n  padding: 30px 5px;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n  ',';\n\n  ',';\n  @media screen and (min-width: ','px) {\n    ',';\n  }\n  @media screen and (min-width: 850px) {\n    font-size: 20px;\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  background-color: #fff;\n  margin: 0;\n  padding: 0 0 10px;\n  position: relative;\n\n  &:after {\n    content: \'\';\n    transition: opacity 0.4s ',';\n    box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.2);\n    opacity: 0;\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n  }\n'],['\n  background-color: #fff;\n  margin: 0;\n  padding: 0 0 10px;\n  position: relative;\n\n  &:after {\n    content: \'\';\n    transition: opacity 0.4s ',';\n    box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.2);\n    opacity: 0;\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  color: inherit;\n  text-decoration: none;\n  transition: opacity ',' ',';\n\n  &:hover {\n    opacity: 0.8;\n    ',':after {\n      opacity: 1;\n    }\n  }\n'],['\n  color: inherit;\n  text-decoration: none;\n  transition: opacity ',' ',';\n\n  &:hover {\n    opacity: 0.8;\n    ',':after {\n      opacity: 1;\n    }\n  }\n']),_templateObject4=_taggedTemplateLiteral(['\n  max-width: 700px;\n  margin: 0 auto;\n  display: flex;\n  justify-content: space-around;\n  align-items: center;\n  flex-direction: column;\n\n  @media screen and (min-width: ','px) {\n    flex-direction: row;\n  }\n'],['\n  max-width: 700px;\n  margin: 0 auto;\n  display: flex;\n  justify-content: space-around;\n  align-items: center;\n  flex-direction: column;\n\n  @media screen and (min-width: ','px) {\n    flex-direction: row;\n  }\n']),_templateObject5=_taggedTemplateLiteral(['\n  font-size: 14px;\n  font-weight: normal;\n  font-style: normal;\n  font-stretch: normal;\n  line-height: 1.57;\n  letter-spacing: normal;\n  text-align: left;\n  color: #000000;\n  padding-left: 10px;\n'],['\n  font-size: 14px;\n  font-weight: normal;\n  font-style: normal;\n  font-stretch: normal;\n  line-height: 1.57;\n  letter-spacing: normal;\n  text-align: left;\n  color: #000000;\n  padding-left: 10px;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SearchResultPage=function(_Component){_inherits(SearchResultPage,_Component);function SearchResultPage(props){_classCallCheck(this,SearchResultPage);var _this=_possibleConstructorReturn(this,(SearchResultPage.__proto__||Object.getPrototypeOf(SearchResultPage)).call(this,props));_this.state={activeSearchResults:'',highestRelevance:0,hits:props.globalSearchResults.reduce(function(memo,item){return item.get('hits').size+memo;},0)};_this.highestRelevanceInIndexHits=_this.highestRelevanceInIndexHits.bind(_this);return _this;}_createClass(SearchResultPage,[{key:'componentWillMount',value:function componentWillMount(){if(this.props.globalSearchQuery!==window.decodeURIComponent(this.props.match.params.searchQuery)){this.props.removeGlobalSearch();this.props.fetchGlobalSearch(window.decodeURIComponent(this.props.match.params.searchQuery));}}},{key:'componentDidMount',value:function componentDidMount(){this.highestRelevanceInIndexHits(this.props.globalSearchResults);this.props.removeQuickSearch();}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){this.setState(function(){return{hits:nextProps.globalSearchResults.reduce(function(memo,item){return item.get('hits').size+memo;},0)};});if(this.props.viewstate.get('currentCategory')!==nextProps.location.pathname){this.props.setViewstate('currentCategory',nextProps.location.pathname);this.props.removeViewstate('filter');this.props.setViewstate('pagination',0);this.props.setViewstate('sortAscending',true);this.props.setViewstate('sortBy','relevance');}if(this.props.globalSearchQuery!==nextProps.globalSearchQuery){this.props.removeViewstate('filter');__WEBPACK_IMPORTED_MODULE_23__history__["a" /* default */].replace('/sok/'+window.encodeURIComponent(nextProps.globalSearchQuery));}if(this.props.globalSearchResults!==nextProps.globalSearchResults){this.props.removeQuickSearch();this.setState(function(){return{activeSearchResults:'',highestRelevance:0};});this.highestRelevanceInIndexHits(nextProps.globalSearchResults);}}},{key:'changeSearchOption',value:function changeSearchOption(event){this.setState({activeSearchResults:event.target.value});}},{key:'highestRelevanceInIndexHits',value:function highestRelevanceInIndexHits(globalSearchResults){var _this2=this;globalSearchResults.map(function(item,index){var first=item.get('hits',Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["List"])()).first();var hits=item.get('hits',Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["List"])());if(!item.isEmpty()&&!hits.isEmpty()){// TODO: this is a temp fix until backend can solve relevance properly
var firstItemWithRelevanceBoost=first.get('id')?first.get('relevance')+10:first.get('relevance');_this2.setState(function(prevState){return{highestRelevance:prevState.highestRelevance<firstItemWithRelevanceBoost?firstItemWithRelevanceBoost:prevState.highestRelevance,activeSearchResults:prevState.highestRelevance<firstItemWithRelevanceBoost?index:prevState.activeSearchResults};});}return true;});}},{key:'renderSearchOptions',value:function renderSearchOptions(){var _this3=this;return this.props.globalSearchResults.map(function(item,index){var isHitsEmpty=item.get('hits').isEmpty();var name='';if(index==='products'&&!isHitsEmpty)name='Produkter';if(index==='pages'&&!isHitsEmpty)name='Sidor';if(index==='categories'&&!isHitsEmpty)name='Kategorier';if(index==='designers'&&!isHitsEmpty)name='Formgivare';if(index==='brands'&&!isHitsEmpty)name='Varumärken';if(!name)return false;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_RadioButton__["a" /* default */],{theme:'white',key:index,id:'search-option-'+index,name:'searchOptions',value:index,checked:_this3.state.activeSearchResults===index,onChange:function onChange(e){_this3.changeSearchOption(e);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SearchOptionLabel,null,name));}).toArray();}},{key:'renderSearchResults',value:function renderSearchResults(){var brands=this.props.globalSearchResults.getIn(['brands','hits'],Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["List"])()).map(function(item){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grid_styled__["Box"],{key:item.getIn(['item','systemId']),width:[1/2,1/3,1/4,1/5,1/6],p:['4px','6px','8px','12px']},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ProductCardLink,{to:''+item.getIn(['item','url'])},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ProductCardContainer,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__components_MainProductImage__["a" /* default */],{insideList:true},item.getIn(['item','images',0,'url'])?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__styles_ProductImage__["a" /* ProductImage */],{src:__WEBPACK_IMPORTED_MODULE_21__constants_endpoints__["n" /* SITE_ROOT_URL */]+item.getIn(['item','images',0,'url'])}):false),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(NameTag,null,item.getIn(['item','name'])))));}).toArray();var designers=this.props.globalSearchResults.getIn(['designers','hits'],Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["List"])()).map(function(item){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grid_styled__["Box"],{key:item.getIn(['item','systemId']),width:[1/2,1/3,1/4,1/5],p:['4px','6px','8px','12px']},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ProductCardLink,{to:''+item.getIn(['item','url'])},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ProductCardContainer,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__components_MainProductImage__["a" /* default */],{round:true,insideList:true},item.getIn(['item','images',0,'url'])?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__styles_ProductImage__["a" /* ProductImage */],{round:true,src:__WEBPACK_IMPORTED_MODULE_21__constants_endpoints__["n" /* SITE_ROOT_URL */]+item.getIn(['item','images',0,'url'])}):false),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(NameTag,null,item.getIn(['item','name'])))));}).toArray();if(this.props.globalSearchStatus==='LOADING'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__styles_Container__["a" /* Container */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__components_LoadingSpinner__["a" /* LoadingSpinner */],null));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,this.state.activeSearchResults==='products'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__components_ProductListWithFilters__["a" /* default */],{includeRelevance:true,includeCategoryFilter:true,allProducts:this.props.products}):false,this.state.activeSearchResults==='pages'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__styles_Container__["a" /* Container */],{style:{paddingTop:'0',paddingBottom:'2em'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__components_PageList__["a" /* default */],{pages:this.props.globalSearchResults.getIn(['pages','hits'],Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["List"])()),searchQuery:this.props.globalSearchQuery})):false,this.state.activeSearchResults==='brands'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__styles_Container__["a" /* Container */],{style:{paddingTop:'0',paddingBottom:'2em'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_styled_components__["ThemeProvider"],{theme:{breakpoints:['40em','53.125em','68.75em','99.625em']}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grid_styled__["Flex"],{flexWrap:'wrap',ml:['-4px','-6px','-8px','-12px'],mr:['-4px','-6px','-8px','-12px']},brands))):false,this.state.activeSearchResults==='designers'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__styles_Container__["a" /* Container */],{style:{paddingTop:'0',paddingBottom:'2em'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grid_styled__["Flex"],{flexWrap:'wrap',ml:['-4px','-6px','-8px','-12px'],mr:['-4px','-6px','-8px','-12px']},designers)):false,this.state.activeSearchResults==='categories'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__styles_Container__["a" /* Container */],{style:{paddingTop:'0',paddingBottom:'2em'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_styled_components__["ThemeProvider"],{theme:{breakpoints:['500px','730px','800px','1200px']}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grid_styled__["Flex"],{flexWrap:'wrap',mx:['0px','-8px','-11px'],my:30},this.props.globalSearchResults.getIn(['categories','hits'],Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["List"])()).filter(function(category){return category.hasIn(['item','url']);}).filter(function(category){return category.getIn(['item','url']).split('/')[1]!=='varumarke';})// TODO: Remove this line once this is fixed on backend
.map(function(category){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grid_styled__["Box"],{key:category.getIn(['item','systemId']),width:[1,1,1/2,1/2,1/3],py:['5px','8px','11px'],px:['0px','8px','11px']},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__components_NavigationButton__["a" /* NavigationButton */],{title:category.getIn(['item','name']),url:category.getIn(['item','url']),image:category.getIn(['item','images',0,'url'],null)}));})))):false,!this.state.activeSearchResults&&this.props.globalSearchResults.isEmpty()&&this.props.globalSearchStatus==='SUCCESS'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__styles_Container__["a" /* Container */],{style:{paddingTop:'0',paddingBottom:'2em'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__styles_NoProductsFound__["a" /* NoProductsFound */],null,'Inga s\xF6ktr\xE4ffar')));}},{key:'render',value:function render(){var globalSearchQuery=this.props.globalSearchQuery;var searchResults=this.renderSearchResults();var searchOptions=this.renderSearchOptions();var metaData=Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])({title:'S\xF6kresultat f\xF6r \u201C'+globalSearchQuery+'\u201D',metaTitle:'S\xF6kresultat f\xF6r \u201C'+globalSearchQuery+'\u201D | V\xE5lamagasinet',follow:false,index:false,metaDescription:''});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Page__["a" /* default */],{meta:metaData,bgColor:__WEBPACK_IMPORTED_MODULE_10__styles_helpers_variables__["c" /* color */].lightGrey,lastBreadcrumbItem:{title:'Sök',url:this.props.location.pathname}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__styles_Container__["a" /* Container */],{style:{paddingTop:'1em',paddingBottom:'0'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__styles_Heading__["a" /* Heading */],{big:true,center:true},'S\xF6kresultat f\xF6r \u201C',globalSearchQuery,'\u201D ',this.state.hits>0&&'('+this.state.hits+')')),this.state.activeSearchResults&&this.props.globalSearchStatus==='SUCCESS'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__styles_Container__["a" /* Container */],{style:{paddingTop:'0',paddingBottom:'1em'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SearchOptionsContainer,null,searchOptions)),searchResults);}}]);return SearchResultPage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var NameTag=__WEBPACK_IMPORTED_MODULE_4_styled_components__["default"].p(_templateObject,__WEBPACK_IMPORTED_MODULE_10__styles_helpers_variables__["c" /* color */].white,__WEBPACK_IMPORTED_MODULE_11__styles_helpers_mixins__["e" /* fontFamilyHeading */],Object(__WEBPACK_IMPORTED_MODULE_11__styles_helpers_mixins__["b" /* dynamicFontSize */])(14,18),__WEBPACK_IMPORTED_MODULE_10__styles_helpers_variables__["f" /* size */].medium,Object(__WEBPACK_IMPORTED_MODULE_11__styles_helpers_mixins__["b" /* dynamicFontSize */])(18,20));var ProductCardContainer=__WEBPACK_IMPORTED_MODULE_4_styled_components__["default"].div(_templateObject2,__WEBPACK_IMPORTED_MODULE_10__styles_helpers_variables__["a" /* animation */].easing);var ProductCardLink=Object(__WEBPACK_IMPORTED_MODULE_4_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["a" /* Link */])(_templateObject3,__WEBPACK_IMPORTED_MODULE_10__styles_helpers_variables__["a" /* animation */].transitionTime,__WEBPACK_IMPORTED_MODULE_10__styles_helpers_variables__["a" /* animation */].easing,ProductCardContainer);var SearchOptionsContainer=__WEBPACK_IMPORTED_MODULE_4_styled_components__["default"].div(_templateObject4,__WEBPACK_IMPORTED_MODULE_10__styles_helpers_variables__["f" /* size */].medium);var SearchOptionLabel=__WEBPACK_IMPORTED_MODULE_4_styled_components__["default"].span(_templateObject5);SearchResultPage.defaultProps={globalSearchResults:Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])(),products:Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])(),globalSearchQuery:null,globalSearchStatus:null,viewstate:Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])()};SearchResultPage.propTypes={fetchGlobalSearch:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,removeGlobalSearch:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,removeQuickSearch:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,setViewstate:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,removeViewstate:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,match:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,globalSearchResults:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"]),globalSearchQuery:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,globalSearchStatus:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,products:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"]),location:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,viewstate:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6__store_connect__["a" /* default */])(SearchResultPage,{setViewstate:__WEBPACK_IMPORTED_MODULE_8__actions_actionCreators__["W" /* setViewstate */],removeViewstate:__WEBPACK_IMPORTED_MODULE_8__actions_actionCreators__["V" /* removeViewstate */],fetchGlobalSearch:__WEBPACK_IMPORTED_MODULE_8__actions_actionCreators__["B" /* fetchGlobalSearch */],removeGlobalSearch:__WEBPACK_IMPORTED_MODULE_8__actions_actionCreators__["T" /* removeGlobalSearch */],removeQuickSearch:__WEBPACK_IMPORTED_MODULE_8__actions_actionCreators__["U" /* removeQuickSearch */]},function(store){var searchResultProducts=Object(__WEBPACK_IMPORTED_MODULE_18__selectors_reselectCategory__["e" /* getProductsByList */])(store);return{globalSearchResults:store.globalSearch.results,globalSearchQuery:store.globalSearch.query,globalSearchStatus:store.globalSearch.status,products:searchResultProducts,viewstate:store.viewstate};}));

/***/ }),
/* 699 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PageListItem__ = __webpack_require__(700);
var renderPages=function renderPages(pages,searchQuery){return pages.map(function(item){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__PageListItem__["a" /* default */],{key:item.getIn(['item','id']),title:item.getIn(['item','fields','title']),description:item.getIn(['item','fields','introduction']),url:item.getIn(['item','url']),searchQuery:searchQuery});}).toArray();};var PageList=function PageList(props){var pages=renderPages(props.pages,props.searchQuery);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,pages);};PageList.defaultProps={pages:Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["List"])(),searchQuery:null};PageList.propTypes={pages:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_2_immutable__["List"]),searchQuery:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (PageList);

/***/ }),
/* 700 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_Heading__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_helpers_variables__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_NoStyleLink__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_helpers_mixins__ = __webpack_require__(6);
var _templateObject=_taggedTemplateLiteral(['\n  margin: 15px 0;\n  ',';\n\n  @media screen and (min-width: ','px) {\n    margin: 30px 0;\n  }\n'],['\n  margin: 15px 0;\n  ',';\n\n  @media screen and (min-width: ','px) {\n    margin: 30px 0;\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  width: 100%;\n  background: ',';\n  padding: 22px;\n  display: flex;\n  justify-content: flex-start;\n  align-items: flex-start;\n  flex-direction: column;\n\n  @media screen and (min-width: ','px) {\n    padding: 40px 100px 40px 40px;\n    justify-content: space-between;\n    align-items: center;\n    flex-direction: row;\n  }\n'],['\n  width: 100%;\n  background: ',';\n  padding: 22px;\n  display: flex;\n  justify-content: flex-start;\n  align-items: flex-start;\n  flex-direction: column;\n\n  @media screen and (min-width: ','px) {\n    padding: 40px 100px 40px 40px;\n    justify-content: space-between;\n    align-items: center;\n    flex-direction: row;\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  z-index: 1;\n  @media screen and (min-width: ','px) {\n    padding-right: 1em;\n  }\n  span {\n    position: relative;\n\n    &:before {\n      content: \'\';\n      position: absolute;\n      right: 0;\n      bottom: 0;\n      left: 0;\n      height: 90%;\n      opacity: 0.5;\n      background-color: #d3d3d3;\n      z-index: -1;\n    }\n  }\n'],['\n  z-index: 1;\n  @media screen and (min-width: ','px) {\n    padding-right: 1em;\n  }\n  span {\n    position: relative;\n\n    &:before {\n      content: \'\';\n      position: absolute;\n      right: 0;\n      bottom: 0;\n      left: 0;\n      height: 90%;\n      opacity: 0.5;\n      background-color: #d3d3d3;\n      z-index: -1;\n    }\n  }\n']),_templateObject4=_taggedTemplateLiteral(['\n  font-size: 15px;\n  font-weight: 300;\n  font-style: italic;\n  font-stretch: normal;\n  line-height: 1.5;\n  letter-spacing: normal;\n  text-align: left;\n  color: ',';\n  margin: 0;\n  z-index: 1;\n\n  span {\n    font-weight: 600;\n    position: relative;\n\n    &:before {\n      content: \'\';\n      position: absolute;\n      right: -0.1em;\n      bottom: 0;\n      left: -0.1em;\n      height: 90%;\n      opacity: 0.5;\n      background-color: #d3d3d3;\n      z-index: -1;\n    }\n  }\n\n  @media screen and (min-width: ','px) {\n    font-size: 20px;\n    max-width: 60%;\n  }\n'],['\n  font-size: 15px;\n  font-weight: 300;\n  font-style: italic;\n  font-stretch: normal;\n  line-height: 1.5;\n  letter-spacing: normal;\n  text-align: left;\n  color: ',';\n  margin: 0;\n  z-index: 1;\n\n  span {\n    font-weight: 600;\n    position: relative;\n\n    &:before {\n      content: \'\';\n      position: absolute;\n      right: -0.1em;\n      bottom: 0;\n      left: -0.1em;\n      height: 90%;\n      opacity: 0.5;\n      background-color: #d3d3d3;\n      z-index: -1;\n    }\n  }\n\n  @media screen and (min-width: ','px) {\n    font-size: 20px;\n    max-width: 60%;\n  }\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var PageListItem=function PageListItem(props){var itemTitle=props.title.replace(new RegExp(props.searchQuery,'gi'),function(p1){return'<span>'+p1+'</span>';});var itemDescription=props.description.replace(new RegExp(props.searchQuery,'gi'),function(p1){return'<span>'+p1+'</span>';});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Root,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__styles_NoStyleLink__["a" /* NoStyleLink */],{to:props.url},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PageListItemContainer,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PageListItemTitle,{dangerouslySetInnerHTML:{__html:itemTitle}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PageListItemDescription,{dangerouslySetInnerHTML:{__html:itemDescription}}))));};var Root=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject,__WEBPACK_IMPORTED_MODULE_6__styles_helpers_mixins__["i" /* shadowOnHover */],__WEBPACK_IMPORTED_MODULE_4__styles_helpers_variables__["f" /* size */].xLarge);var PageListItemContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject2,__WEBPACK_IMPORTED_MODULE_4__styles_helpers_variables__["c" /* color */].white,__WEBPACK_IMPORTED_MODULE_4__styles_helpers_variables__["f" /* size */].xLarge);var PageListItemTitle=__WEBPACK_IMPORTED_MODULE_3__styles_Heading__["a" /* Heading */].extend(_templateObject3,__WEBPACK_IMPORTED_MODULE_4__styles_helpers_variables__["f" /* size */].xLarge);var PageListItemDescription=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].p(_templateObject4,__WEBPACK_IMPORTED_MODULE_4__styles_helpers_variables__["c" /* color */].black,__WEBPACK_IMPORTED_MODULE_4__styles_helpers_variables__["f" /* size */].xLarge);PageListItem.defaultProps={title:'',description:'',url:'',searchQuery:null};PageListItem.propTypes={title:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,description:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,url:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,searchQuery:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (PageListItem);

/***/ }),
/* 701 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_grid_styled__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_grid_styled___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_grid_styled__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_immutable__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_dom__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Page__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store_connect__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_helpers_mixins__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_MainProductImage__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__actions_actionCreators__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__styles_ProductImage__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__styles_helpers_variables__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__styles_Container__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__styles_Heading__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__styles_Preamble__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_LinedHeading__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__constants_endpoints__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__ErrorPage__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__NotFoundPage__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__util_isTouchDevice__ = __webpack_require__(702);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  margin-bottom: 85px;\n'],['\n  margin-bottom: 85px;\n']),_templateObject2=_taggedTemplateLiteral(['\n  padding-top: 35px;\n  &:first-child {\n    padding-top: 0;\n  }\n'],['\n  padding-top: 35px;\n  &:first-child {\n    padding-top: 0;\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  position: relative;\n  margin: 0 auto;\n  max-width: 600px;\n'],['\n  position: relative;\n  margin: 0 auto;\n  max-width: 600px;\n']),_templateObject4=_taggedTemplateLiteral(['\n  position: absolute;\n  top: 15px;\n  right: 15px;\n  display: inline-block;\n  background-image: url(/images/icons/search-black.svg);\n  background-size: contain;\n  background-repeat: no-repeat;\n  background-position: center;\n  width: 20px;\n  height: 20px;\n'],['\n  position: absolute;\n  top: 15px;\n  right: 15px;\n  display: inline-block;\n  background-image: url(/images/icons/search-black.svg);\n  background-size: contain;\n  background-repeat: no-repeat;\n  background-position: center;\n  width: 20px;\n  height: 20px;\n']),_templateObject5=_taggedTemplateLiteral(['\n  background-color: #fff;\n  margin: 0;\n  padding: 0 0 10px;\n  position: relative;\n\n  &:after {\n    content: \'\';\n    transition: opacity 0.4s ',';\n    box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.2);\n    opacity: 0;\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n  }\n'],['\n  background-color: #fff;\n  margin: 0;\n  padding: 0 0 10px;\n  position: relative;\n\n  &:after {\n    content: \'\';\n    transition: opacity 0.4s ',';\n    box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.2);\n    opacity: 0;\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n  }\n']),_templateObject6=_taggedTemplateLiteral(['\n  color: inherit;\n  text-decoration: none;\n  transition: opacity ',' ',';\n\n  &:hover {\n    opacity: 0.8;\n    ',':after {\n      opacity: 1;\n    }\n  }\n'],['\n  color: inherit;\n  text-decoration: none;\n  transition: opacity ',' ',';\n\n  &:hover {\n    opacity: 0.8;\n    ',':after {\n      opacity: 1;\n    }\n  }\n']),_templateObject7=_taggedTemplateLiteral(['\n  background-color: ',';\n  line-height: 1.3;\n  text-align: center;\n  margin: 0;\n  padding: 30px 5px;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n  ',';\n\n  ','\n\n  ',';\n  @media screen and (min-width: ','px) {\n    ',';\n  }\n  @media screen and (min-width: 850px) {\n    font-size: 20px;\n  }\n'],['\n  background-color: ',';\n  line-height: 1.3;\n  text-align: center;\n  margin: 0;\n  padding: 30px 5px;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n  ',';\n\n  ','\n\n  ',';\n  @media screen and (min-width: ','px) {\n    ',';\n  }\n  @media screen and (min-width: 850px) {\n    font-size: 20px;\n  }\n']),_templateObject8=_taggedTemplateLiteral(['\n    opacity: .6;\n  '],['\n    opacity: .6;\n  ']),_templateObject9=_taggedTemplateLiteral(['\n  list-style-type: none;\n  display: block;\n  text-align: center;\n  padding: 0;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: center;\n'],['\n  list-style-type: none;\n  display: block;\n  text-align: center;\n  padding: 0;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: center;\n']),_templateObject10=_taggedTemplateLiteral(['\n  transition: opacity 0.25s ease-out;\n  display: block;\n  font-weight: 600;\n  font-size: 15px;\n  margin-bottom: 5px;\n\n  ',';\n  button {\n    cursor: pointer;\n    color: ',';\n    text-decoration: none;\n    font-size: 16px;\n    border: none;\n    background-color: transparent;\n    padding: 0;\n    font-family: inherit;\n    font-weight: 600;\n    outline: 0;\n    padding: 3px 7px;\n    @media all and (hover: none) {\n      padding: 5px 10px;\n    }\n  }\n'],['\n  transition: opacity 0.25s ease-out;\n  display: block;\n  font-weight: 600;\n  font-size: 15px;\n  margin-bottom: 5px;\n\n  ',';\n  button {\n    cursor: pointer;\n    color: ',';\n    text-decoration: none;\n    font-size: 16px;\n    border: none;\n    background-color: transparent;\n    padding: 0;\n    font-family: inherit;\n    font-weight: 600;\n    outline: 0;\n    padding: 3px 7px;\n    @media all and (hover: none) {\n      padding: 5px 10px;\n    }\n  }\n']),_templateObject11=_taggedTemplateLiteral(['\n      opacity: 0.3;\n    '],['\n      opacity: 0.3;\n    ']),_templateObject12=_taggedTemplateLiteral(['\n  background-color: #ffffff;\n  border: solid 1px ',';\n  color: ',';\n  outline: 0;\n  font-size: 16px;\n  font-weight: normal;\n  padding: 16px 40px 16px 14px;\n  width: 100%;\n  max-width: 600px;\n  display: block;\n  margin: 25px 0 30px;\n  -webkit-appearance: none;\n  border-radius: 0;\n\n  &::placeholder {\n    color: ',';\n    font-style: italic;\n  }\n'],['\n  background-color: #ffffff;\n  border: solid 1px ',';\n  color: ',';\n  outline: 0;\n  font-size: 16px;\n  font-weight: normal;\n  padding: 16px 40px 16px 14px;\n  width: 100%;\n  max-width: 600px;\n  display: block;\n  margin: 25px 0 30px;\n  -webkit-appearance: none;\n  border-radius: 0;\n\n  &::placeholder {\n    color: ',';\n    font-style: italic;\n  }\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var BrandListPage=function(_Component){_inherits(BrandListPage,_Component);function BrandListPage(props){_classCallCheck(this,BrandListPage);var _this=_possibleConstructorReturn(this,(BrandListPage.__proto__||Object.getPrototypeOf(BrandListPage)).call(this,props));_this.spans=[];_this.specialCharacterCategory='#';_this.alphabetArray=[_this.specialCharacterCategory].concat(_toConsumableArray([].concat(_toConsumableArray(Array(26))).map(function(q,w){return String.fromCharCode(w+97).toUpperCase();})),['Å','Ä','Ö']);_this.state={searchString:'',availableLetters:''};return _this;}_createClass(BrandListPage,[{key:'componentWillMount',value:function componentWillMount(){if(this.props.type==='brands'){this.props.fetchBrandData();}else if(this.props.type==='designers'){this.props.fetchDesignerData();}this.props.fetchArticlePageView({urlPath:this.props.location.pathname});}},{key:'componentDidMount',value:function componentDidMount(){if(!Object(__WEBPACK_IMPORTED_MODULE_20__util_isTouchDevice__["a" /* isTouchDevice */])()){this.inputField.focus();}}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps,nextContext){if(this.props.match.path!==nextProps.match.path){this.setState({searchString:''});this.inputField.value='';if(!Object(__WEBPACK_IMPORTED_MODULE_20__util_isTouchDevice__["a" /* isTouchDevice */])()){this.inputField.focus();}if(nextProps.type==='brands'){nextProps.fetchBrandData();}else if(nextProps.type==='designers'){nextProps.fetchDesignerData();}nextProps.fetchArticlePageView({urlPath:nextProps.location.pathname});}}},{key:'brandSearchInputHandler',value:function brandSearchInputHandler(event){this.setState({searchString:event.target.value});}},{key:'handleScrollToElement',value:function handleScrollToElement(id){var _this2=this;return function(e){e.preventDefault();_this2['lineHeadingRef'+id].scrollIntoView({block:'start'});};}},{key:'addSpanRef',value:function addSpanRef(node){this.spans=[].concat(_toConsumableArray(this.spans),[node]);}},{key:'renderBrandsLetters',value:function renderBrandsLetters(){var _this3=this;var availableLetters='';var brandsLetters=this.props.brands.filter(function(x){return x.get('name').toLowerCase().indexOf(_this3.state.searchString.toLowerCase())!==-1;}).groupBy(function(item){return _this3.alphabetArray.includes(item.get('name').toUpperCase()[0])?item.get('name').toLowerCase()[0]:_this3.specialCharacterCategory;}).sortBy(function(item,index){return index;}).map(function(item,index){var currentLetter=index;if(availableLetters.indexOf(currentLetter)===-1){availableLetters+=currentLetter;}return(/** adjustScroll and style with paddingTop: 35px: (ScrollRefElem), temporary solution for scrolling to correct pos. See handleScrollToElement */__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ScrollRefElem,{key:'letter-section-'+currentLetter,innerRef:function innerRef(x){_this3['lineHeadingRef'+currentLetter]=x;}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__components_LinedHeading__["a" /* default */],{adjustScroll:true,smallestFontSizeBound:20,bgColor:__WEBPACK_IMPORTED_MODULE_12__styles_helpers_variables__["c" /* color */].lightGrey},currentLetter),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grid_styled__["Flex"],{flexWrap:'wrap',mx:['-4px','-6px','-8px','-12px'],mb:0},_this3.renderBrands(item))));}).toArray();if(this.state.availableLetters!==availableLetters){this.setState({availableLetters:availableLetters});}return brandsLetters;}},{key:'renderBrands',value:function renderBrands(brands){var _this4=this;return brands.sortBy(function(item){return item.get('name').toLowerCase();}).map(function(item){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grid_styled__["Box"],{key:item.get('systemId'),width:[1/2,1/3,1/4,1/5,1/6],p:['4px','6px','8px','12px']},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ProductCardLink,{to:item.get('url')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ProductCardContainer,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_MainProductImage__["a" /* default */],{insideList:true,round:_this4.props.endpoint==='designers'},item.getIn(['images',0,'url'])?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__styles_ProductImage__["a" /* ProductImage */],{round:_this4.props.type==='designers',src:__WEBPACK_IMPORTED_MODULE_17__constants_endpoints__["n" /* SITE_ROOT_URL */]+item.getIn(['images',0,'url'])}):false),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(NameTag,null,item.get('name')))));}).toArray();}},{key:'renderAlphabet',value:function renderAlphabet(){var _this5=this;return this.alphabetArray.map(function(item){var disabled=!(_this5.state.availableLetters.indexOf(item.toLowerCase())!==-1);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ListItem,{key:'alphabet-'+item,disabled:disabled},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{disabled:disabled,onClick:_this5.handleScrollToElement(item.toLowerCase())},item));});}},{key:'render',value:function render(){var _this6=this;var request=this.props.request;if(request.get('statusCode')===404)return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__NotFoundPage__["a" /* default */],null);if(request.get('status')==='ERROR')return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__ErrorPage__["a" /* default */],null);var brandsList=this.renderBrandsLetters();var alphabet=this.renderAlphabet();return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Page__["a" /* default */],{meta:this.props.currentPage.get('metaData'),bgColor:__WEBPACK_IMPORTED_MODULE_12__styles_helpers_variables__["c" /* color */].lightGrey},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__styles_Container__["a" /* Container */],{bgColor:__WEBPACK_IMPORTED_MODULE_12__styles_helpers_variables__["c" /* color */].lightGrey},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__styles_Heading__["a" /* Heading */],{big:true,center:true},this.props.currentPage.getIn(['fields','title'])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__styles_Preamble__["a" /* Preamble */],null,this.props.currentPage.getIn(['fields','introduction'])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(BrandsInputContainer,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FilterBrandsInput,{innerRef:function innerRef(e){_this6.inputField=e;},onChange:function onChange(event){_this6.brandSearchInputHandler(event);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SearchSvg,null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(AlphabetList,null,alphabet),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_styled_components__["ThemeProvider"],{theme:{breakpoints:['40em','53.125em','68.75em','99.625em']}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(BrandsListContainer,null,brandsList))));}}]);return BrandListPage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var BrandsListContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject);var ScrollRefElem=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject2);var BrandsInputContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject3);var SearchSvg=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].span(_templateObject4);var ProductCardContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject5,__WEBPACK_IMPORTED_MODULE_12__styles_helpers_variables__["a" /* animation */].easing);var ProductCardLink=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_5_react_router_dom__["a" /* Link */])(_templateObject6,__WEBPACK_IMPORTED_MODULE_12__styles_helpers_variables__["a" /* animation */].transitionTime,__WEBPACK_IMPORTED_MODULE_12__styles_helpers_variables__["a" /* animation */].easing,ProductCardContainer);var NameTag=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].p(_templateObject7,__WEBPACK_IMPORTED_MODULE_12__styles_helpers_variables__["c" /* color */].white,__WEBPACK_IMPORTED_MODULE_8__styles_helpers_mixins__["e" /* fontFamilyHeading */],function(props){return props.disabled&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject8);},Object(__WEBPACK_IMPORTED_MODULE_8__styles_helpers_mixins__["b" /* dynamicFontSize */])(14,18),__WEBPACK_IMPORTED_MODULE_12__styles_helpers_variables__["f" /* size */].medium,Object(__WEBPACK_IMPORTED_MODULE_8__styles_helpers_mixins__["b" /* dynamicFontSize */])(18,20));var AlphabetList=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].ul(_templateObject9);var ListItem=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].li(_templateObject10,function(props){return props.disabled&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject11);},__WEBPACK_IMPORTED_MODULE_12__styles_helpers_variables__["c" /* color */].black);var FilterBrandsInput=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].input.attrs({type:'text',placeholder:'Sök...'})(_templateObject12,__WEBPACK_IMPORTED_MODULE_12__styles_helpers_variables__["c" /* color */].darkgrey,__WEBPACK_IMPORTED_MODULE_12__styles_helpers_variables__["c" /* color */].black,__WEBPACK_IMPORTED_MODULE_12__styles_helpers_variables__["c" /* color */].black);BrandListPage.defaultProps={brands:Object(__WEBPACK_IMPORTED_MODULE_4_immutable__["Map"])(),currentPage:Object(__WEBPACK_IMPORTED_MODULE_4_immutable__["Map"])(),request:Object(__WEBPACK_IMPORTED_MODULE_4_immutable__["Map"])(),endpoint:''};BrandListPage.propTypes={brands:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_4_immutable__["Map"]),location:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,currentPage:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_4_immutable__["Map"]),request:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_4_immutable__["Map"]),fetchArticlePageView:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,fetchBrandData:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,endpoint:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__store_connect__["a" /* default */])(BrandListPage,{fetchArticlePageView:__WEBPACK_IMPORTED_MODULE_10__actions_actionCreators__["g" /* fetchArticlePageView */],fetchBrandData:__WEBPACK_IMPORTED_MODULE_10__actions_actionCreators__["j" /* fetchBrandData */],fetchDesignerData:__WEBPACK_IMPORTED_MODULE_10__actions_actionCreators__["y" /* fetchDesignerData */]},function(store,props){return{request:store.page.request.get(props.location.pathname),currentPage:store.page.data.get(props.location.pathname),brands:store[props.type]};}));

/***/ }),
/* 702 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isTouchDevice; });
// eslint-disable-next-line
var isTouchDevice=function isTouchDevice(){if(typeof window==='undefined')return null;var prefixes=' -webkit- -moz- -o- -ms- '.split(' ');var mq=function mq(query){return window.matchMedia(query).matches;};// eslint-disable-next-line
if('ontouchstart'in window||window.DocumentTouch&&document instanceof DocumentTouch){return true;}// include the 'heartz' as a way to have a non matching MQ to help terminate the join
// https://git.io/vznFH
var query=['(',prefixes.join('touch-enabled),('),'heartz',')'].join('');return mq(query);};

/***/ }),
/* 703 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_connect__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions_actionCreators__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__selectors_reselectCategory__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Page__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_Heading__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_Container__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_ProductListWithFilters__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_TruncatedPreamble__ = __webpack_require__(704);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ErrorPage__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__NotFoundPage__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__styles_NoProductsFound__ = __webpack_require__(165);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var BrandPage=function(_Component){_inherits(BrandPage,_Component);function BrandPage(){_classCallCheck(this,BrandPage);return _possibleConstructorReturn(this,(BrandPage.__proto__||Object.getPrototypeOf(BrandPage)).apply(this,arguments));}_createClass(BrandPage,[{key:'componentDidMount',value:function componentDidMount(){this.props.fetchCategoryMetaData({url:this.props.match.url});if(!this.props.viewstate.has('currentCategory')||this.props.viewstate.get('currentCategory')!==this.props.currentPage.get('id')){this.props.setViewstate('currentCategory',this.props.currentPage.get('id'));this.props.setViewstate('sortAscending',false);this.props.setViewstate('sortBy','name');this.props.removeViewstate('filter');this.props.setViewstate('pagination',0);}}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(nextProps.currentPage.get('systemId')&&!this.props.currentPage.get('systemId')){this.props.fetchProducts({id:nextProps.currentPage.get('systemId'),url:nextProps.match.url});}}},{key:'componentDidUpdate',value:function componentDidUpdate(){if(!this.props.viewstate.has('currentCategory')||this.props.viewstate.get('currentCategory')!==this.props.currentPage.get('id')){this.props.setViewstate('currentCategory',this.props.currentPage.get('id'));this.props.setViewstate('sortAscending',false);this.props.setViewstate('sortBy','name');this.props.removeViewstate('filter');this.props.setViewstate('pagination',0);}}},{key:'render',value:function render(){var _props=this.props,request=_props.request,productsRequest=_props.productsRequest;if(request.get('statusCode')===404)return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__NotFoundPage__["a" /* default */],null);if(request.get('status')==='ERROR')return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__ErrorPage__["a" /* default */],null);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Page__["a" /* default */],{meta:this.props.currentPage.get('metaData'),bgColor:'#f2f2f2',lastBreadcrumbItem:{title:this.props.currentPage.get('name'),url:this.props.location.pathname}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__styles_Container__["a" /* Container */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__styles_Heading__["a" /* Heading */],{big:true,center:true},this.props.currentPage.get('name')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_TruncatedPreamble__["a" /* default */],null,this.props.currentPage.get('description'))),productsRequest.get('statusCode')===200&&this.props.products.size<=0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__styles_Container__["a" /* Container */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__styles_NoProductsFound__["a" /* NoProductsFound */],null,'Vi jobbar med att berika v\xE5r webbplats med produkter fr\xE5n ',this.props.currentPage.get('name'),'. Nya produkter kommer inom kort.')):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_ProductListWithFilters__["a" /* default */],{includeCategoryFilter:true,request:productsRequest,allProducts:this.props.products}));}}]);return BrandPage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);BrandPage.defaultProps={products:Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])(),currentPage:Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])(),request:Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])(),productsRequest:Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])(),viewstate:Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])()};BrandPage.propTypes={location:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,setViewstate:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,removeViewstate:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,fetchProducts:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,fetchCategoryMetaData:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,products:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"]),currentPage:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"]),request:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"]),productsRequest:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"]),match:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,viewstate:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])};// get data product list data from endpoint
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3__store_connect__["a" /* default */])(BrandPage,{setViewstate:__WEBPACK_IMPORTED_MODULE_4__actions_actionCreators__["W" /* setViewstate */],removeViewstate:__WEBPACK_IMPORTED_MODULE_4__actions_actionCreators__["V" /* removeViewstate */],fetchProducts:__WEBPACK_IMPORTED_MODULE_4__actions_actionCreators__["K" /* fetchProducts */],fetchCategoryMetaData:__WEBPACK_IMPORTED_MODULE_4__actions_actionCreators__["s" /* fetchCategoryMetaData */]},function(store,props){var pathname=props.location.pathname.replace(/\/$/,'');var currentPage=store.categories.items.get(pathname);var products=!currentPage?Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])():Object(__WEBPACK_IMPORTED_MODULE_5__selectors_reselectCategory__["c" /* getProductsByKey */])(store,[props.type,'systemId'],currentPage.get('systemId'));return{products:products,viewstate:store.viewstate,currentPage:currentPage,request:store.categories.request.get(pathname),productsRequest:store.products.request.get(pathname)};}));

/***/ }),
/* 704 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_truncate__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_Preamble__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_connect__ = __webpack_require__(8);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(["\n  overflow: hidden;\n  position: relative;\n  margin-bottom: 0 !important;\n  transition: border .25s ease-out, opacity .25s ease-out;\n  \n  &:after {\n    content: \"\";\n    display: block;\n    position: absolute;\n    top: 30%;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    background: linear-gradient(\n      to top,\n      hsl(0, 0%, 95%),\n      hsla(0, 0%, 95%, 0.94505) 7.9%,\n      hsla(0, 0%, 95%, 0.88294) 15.3%,\n      hsla(0, 0%, 95%, 0.81522) 22.2%,\n      hsla(0, 0%, 95%, 0.7426) 28.7%,\n      hsla(0, 0%, 95%, 0.66692) 34.8%,\n      hsla(0, 0%, 95%, 0.58891) 40.6%,\n      hsla(0, 0%, 95%, 0.50925) 46.2%,\n      hsla(0, 0%, 95%, 0.42866) 51.7%,\n      hsla(0, 0%, 95%, 0.34817) 57.2%,\n      hsla(0, 0%, 95%, 0.2693) 62.8%,\n      hsla(0, 0%, 95%, 0.19309) 68.7%,\n      hsla(0, 0%, 95%, 0.12126) 75.2%,\n      hsla(0, 0%, 95%, 0.05882) 82.6%,\n      hsla(0, 0%, 95%, 0.01457) 91.2%,\n      hsla(0, 0%, 95%, 0)\n    );\n  }\n  \n  ","\n"],["\n  overflow: hidden;\n  position: relative;\n  margin-bottom: 0 !important;\n  transition: border .25s ease-out, opacity .25s ease-out;\n  \n  &:after {\n    content: \"\";\n    display: block;\n    position: absolute;\n    top: 30%;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    background: linear-gradient(\n      to top,\n      hsl(0, 0%, 95%),\n      hsla(0, 0%, 95%, 0.94505) 7.9%,\n      hsla(0, 0%, 95%, 0.88294) 15.3%,\n      hsla(0, 0%, 95%, 0.81522) 22.2%,\n      hsla(0, 0%, 95%, 0.7426) 28.7%,\n      hsla(0, 0%, 95%, 0.66692) 34.8%,\n      hsla(0, 0%, 95%, 0.58891) 40.6%,\n      hsla(0, 0%, 95%, 0.50925) 46.2%,\n      hsla(0, 0%, 95%, 0.42866) 51.7%,\n      hsla(0, 0%, 95%, 0.34817) 57.2%,\n      hsla(0, 0%, 95%, 0.2693) 62.8%,\n      hsla(0, 0%, 95%, 0.19309) 68.7%,\n      hsla(0, 0%, 95%, 0.12126) 75.2%,\n      hsla(0, 0%, 95%, 0.05882) 82.6%,\n      hsla(0, 0%, 95%, 0.01457) 91.2%,\n      hsla(0, 0%, 95%, 0)\n    );\n  }\n  \n  ","\n"]),_templateObject2=_taggedTemplateLiteral(["\n    max-height: initial;\n    margin-bottom: 10px !important;\n    &:after {\n      display: none;\n    }\n  "],["\n    max-height: initial;\n    margin-bottom: 10px !important;\n    &:after {\n      display: none;\n    }\n  "]),_templateObject3=_taggedTemplateLiteral(["\n  font-family: \"Open Sans\", Helvetica, Arial, sans-serif;\n  text-transform: uppercase;\n  font-weight: 600;\n  background-color: transparent;\n  display: block;\n  border: none;\n  margin: 0 auto 0;\n  width: auto;\n  padding: 10px;\n  font-size: 14px;\n  cursor: pointer;\n  transition: opacity .25s ease-out;\n  \n  &:focus {\n    outline: 0;\n  }\n  \n  &:hover {\n    opacity: .65;\n  }\n"],["\n  font-family: \"Open Sans\", Helvetica, Arial, sans-serif;\n  text-transform: uppercase;\n  font-weight: 600;\n  background-color: transparent;\n  display: block;\n  border: none;\n  margin: 0 auto 0;\n  width: auto;\n  padding: 10px;\n  font-size: 14px;\n  cursor: pointer;\n  transition: opacity .25s ease-out;\n  \n  &:focus {\n    outline: 0;\n  }\n  \n  &:hover {\n    opacity: .65;\n  }\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TruncatedPreamble=function(_Component){_inherits(TruncatedPreamble,_Component);function TruncatedPreamble(props){_classCallCheck(this,TruncatedPreamble);var _this=_possibleConstructorReturn(this,(TruncatedPreamble.__proto__||Object.getPrototypeOf(TruncatedPreamble)).call(this,props));_this.state={isExtended:false,isTruncated:false};return _this;}_createClass(TruncatedPreamble,[{key:"onTruncateHandler",value:function onTruncateHandler(isTruncated){if(isTruncated!==this.state.isTruncated){this.setState({isTruncated:isTruncated});}}},{key:"onExtendHandler",value:function onExtendHandler(){this.setState(function(currentState){return{isExtended:!currentState.isExtended};});}},{key:"render",value:function render(){var _this2=this;var _state=this.state,isExtended=_state.isExtended,isTruncated=_state.isTruncated;var rowsToShow=this.props.pageWidth>768?4:5;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DesignerPreamble,{isExtended:isExtended,isTruncated:isTruncated},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_truncate__["a" /* default */],{lines:isExtended?0:rowsToShow,onTruncate:function onTruncate(isTruncated){return _this2.onTruncateHandler(isTruncated);}},this.props.children)),isTruncated||isExtended?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ReadMoreButton,{onClick:function onClick(){_this2.onExtendHandler();}},isExtended?'Visa mindre −':'Visa mer +'):false);}}]);return TruncatedPreamble;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var DesignerPreamble=__WEBPACK_IMPORTED_MODULE_3__styles_Preamble__["a" /* Preamble */].extend(_templateObject,function(props){return(props.isExtended||!props.isTruncated)&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject2);});var ReadMoreButton=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].button(_templateObject3);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4__store_connect__["a" /* default */])(TruncatedPreamble,{},function(store){return{pageWidth:store.viewstate.get('pageWidth')};}));

/***/ }),
/* 705 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_grid_styled__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_grid_styled___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_grid_styled__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_connect__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions_actionCreators__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Page__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_InstagramSection__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_ProductListWithFilters__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__styles_Container__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__styles_Heading__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__styles_Preamble__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__NotFoundPage__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__ErrorPage__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_NavigationButton__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__styles_helpers_mixins__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_Conditional__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_CampaignListItem__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__constants_endpoints__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__styles_Section__ = __webpack_require__(114);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  ',';\n  font-size: 12px;\n  font-weight: 600;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: normal;\n  letter-spacing: 3px;\n  text-align: center;\n  color: #000000;\n  text-transform: uppercase;\n  padding: 8px;\n  margin: 20px auto 4px;\n  display: block;\n  background-color: transparent;\n  border: none;\n  cursor: pointer;\n'],['\n  ',';\n  font-size: 12px;\n  font-weight: 600;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: normal;\n  letter-spacing: 3px;\n  text-align: center;\n  color: #000000;\n  text-transform: uppercase;\n  padding: 8px;\n  margin: 20px auto 4px;\n  display: block;\n  background-color: transparent;\n  border: none;\n  cursor: pointer;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CampaignListPage=function(_Component){_inherits(CampaignListPage,_Component);function CampaignListPage(props){_classCallCheck(this,CampaignListPage);var _this=_possibleConstructorReturn(this,(CampaignListPage.__proto__||Object.getPrototypeOf(CampaignListPage)).call(this,props));_this.state={showAllCampaigns:true};_this.toggleShowAllCampaigns=_this.toggleShowAllCampaigns.bind(_this);return _this;}_createClass(CampaignListPage,[{key:'componentDidMount',value:function componentDidMount(){var pageUrl=this.props.location.pathname;this.props.fetchArticlePageView({urlPath:pageUrl,includeChildren:true});var productListId=this.props.currentPage.getIn(['fields','campaignProductListId','id']);if(productListId){this.props.fetchCampaignProducts({id:productListId,url:pageUrl});}this.setDefaultFilters(pageUrl);}},{key:'componentDidUpdate',value:function componentDidUpdate(){var pageUrl=this.props.location.pathname;var productListId=this.props.currentPage.getIn(['fields','campaignProductListId','id']);if(this.props.productsRequest.isEmpty()&&productListId){this.props.fetchCampaignProducts({id:productListId,url:pageUrl});this.setDefaultFilters(pageUrl);}}},{key:'setDefaultFilters',value:function setDefaultFilters(categoryId){var currentCategory=this.props.currentCategory;if(currentCategory!==categoryId){this.props.setViewstate('currentCategory',categoryId);this.props.setViewstate('sortAscending',false);this.props.setViewstate('sortBy','name');this.props.removeViewstate('filter');this.props.setViewstate('pagination',0);}}},{key:'toggleShowAllCampaigns',value:function toggleShowAllCampaigns(){this.setState(function(state){return{showAllCampaigns:!state.showAllCampaigns};});}},{key:'renderCampaignItems',value:function renderCampaignItems(){return this.props.currentPage.get('children',Object(__WEBPACK_IMPORTED_MODULE_3_immutable__["List"])()).map(function(child){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__components_CampaignListItem__["a" /* default */],{to:child.get('url'),key:child.get('id'),title:child.getIn(['fields','title']),preamble:child.getIn(['fields','introduction']),linkTitle:'Se '+child.getIn(['fields','title']),image:__WEBPACK_IMPORTED_MODULE_19__constants_endpoints__["n" /* SITE_ROOT_URL */]+child.getIn(['fields','listImage','url'])});}).toArray();}},{key:'render',value:function render(){var _props=this.props,currentPage=_props.currentPage,request=_props.request,campaign=_props.campaign,products=_props.products,productsRequest=_props.productsRequest;var showAllCampaigns=this.state.showAllCampaigns;if(request.get('statusCode')===404)return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__NotFoundPage__["a" /* default */],null);if(request.get('status')==='ERROR')return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__ErrorPage__["a" /* default */],null);var campaigns=this.renderCampaignItems();var productListId=this.props.currentPage.getIn(['fields','campaignProductListId','id']);var campaignProductIds=Object(__WEBPACK_IMPORTED_MODULE_3_immutable__["fromJS"])(campaign.get(productListId)||[]);var campaignProducts=campaignProductIds.map(function(id){return products.get(id);});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Page__["a" /* default */],{meta:this.props.currentPage.get('metaData'),bgColor:'#f2f2f2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__styles_Container__["a" /* Container */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__styles_Heading__["a" /* Heading */],{big:true,center:true},currentPage.getIn(['fields','title'])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__styles_Preamble__["a" /* Preamble */],null,currentPage.getIn(['fields','introduction'])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__components_Conditional__["a" /* Conditional */],{show:!showAllCampaigns},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_styled_components__["ThemeProvider"],{theme:{breakpoints:['1100px']}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grid_styled__["Flex"],{flexWrap:'wrap',mx:[0,-15],mt:[30,50]},this.props.currentPage.get('children')&&this.props.currentPage.get('children').take(3).map(function(item){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grid_styled__["Box"],{key:item.get('url'),width:[1,1/3],px:[0,15],py:['5px',0]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_NavigationButton__["a" /* NavigationButton */],{url:item.get('url'),title:item.getIn(['fields','title']),image:item.getIn(['fields','listImage','url'])}));}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SeAllCampaignsButton,{onClick:this.toggleShowAllCampaigns},'Se v\xE5ra kampanjer')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__components_Conditional__["a" /* Conditional */],{show:showAllCampaigns},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SeAllCampaignsButton,{onClick:this.toggleShowAllCampaigns},'Se alla kampanjprodukter'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__components_Conditional__["a" /* Conditional */],{show:!showAllCampaigns},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_ProductListWithFilters__["a" /* default */],{includeCategoryFilter:true,request:productsRequest,allProducts:campaignProducts})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__components_Conditional__["a" /* Conditional */],{show:showAllCampaigns},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__styles_Section__["a" /* Section */],{pb:80},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__styles_Container__["a" /* Container */],null,campaigns))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_InstagramSection__["a" /* default */],null));}}]);return CampaignListPage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);CampaignListPage.defaultProps={currentPage:Object(__WEBPACK_IMPORTED_MODULE_3_immutable__["Map"])(),request:Object(__WEBPACK_IMPORTED_MODULE_3_immutable__["Map"])(),productsRequest:Object(__WEBPACK_IMPORTED_MODULE_3_immutable__["Map"])(),campaign:Object(__WEBPACK_IMPORTED_MODULE_3_immutable__["Map"])(),products:Object(__WEBPACK_IMPORTED_MODULE_3_immutable__["Map"])(),currentCategory:undefined};CampaignListPage.propTypes={fetchArticlePageView:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,fetchCampaignProducts:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,setViewstate:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,removeViewstate:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,currentPage:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_3_immutable__["Map"]),request:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_3_immutable__["Map"]),location:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,productsRequest:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_3_immutable__["Map"]),campaign:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_3_immutable__["Map"]),products:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_3_immutable__["Map"]),currentCategory:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5__store_connect__["a" /* default */])(CampaignListPage,{fetchArticlePageView:__WEBPACK_IMPORTED_MODULE_6__actions_actionCreators__["g" /* fetchArticlePageView */],fetchCampaignProducts:__WEBPACK_IMPORTED_MODULE_6__actions_actionCreators__["m" /* fetchCampaignProducts */],setViewstate:__WEBPACK_IMPORTED_MODULE_6__actions_actionCreators__["W" /* setViewstate */],removeViewstate:__WEBPACK_IMPORTED_MODULE_6__actions_actionCreators__["V" /* removeViewstate */]},function(store,props){return{currentPage:store.page.data.get(props.location.pathname),request:store.page.request.get(props.location.pathname),campaign:store.campaign,products:store.products.data,productsRequest:store.products.request.get(props.location.pathname),currentCategory:store.viewstate.get('currentCategory')};}));var SeAllCampaignsButton=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].button(_templateObject,__WEBPACK_IMPORTED_MODULE_16__styles_helpers_mixins__["d" /* fontFamilyBody */]);

/***/ }),
/* 706 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_connect__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions_actionCreators__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__selectors_reselectCategory__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Page__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_helpers_variables__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_Container__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_ProductListWithFilters__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_CampaignListItem__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__NotFoundPage__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ErrorPage__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__constants_endpoints__ = __webpack_require__(9);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CampaignPage=function(_Component){_inherits(CampaignPage,_Component);function CampaignPage(){_classCallCheck(this,CampaignPage);return _possibleConstructorReturn(this,(CampaignPage.__proto__||Object.getPrototypeOf(CampaignPage)).apply(this,arguments));}_createClass(CampaignPage,[{key:'componentDidMount',value:function componentDidMount(){var pageUrl=this.props.location.pathname;this.props.fetchArticlePageView({urlPath:pageUrl});var productListId=this.props.currentPage.getIn(['fields','campaignProductListId','id']);if(productListId){this.props.fetchCampaignProducts({id:productListId,url:pageUrl});}this.setDefaultFilters(pageUrl);}},{key:'componentDidUpdate',value:function componentDidUpdate(){var pageUrl=this.props.location.pathname;var productListId=this.props.currentPage.getIn(['fields','campaignProductListId','id']);if(this.props.productsRequest.isEmpty()&&productListId){this.props.fetchCampaignProducts({id:productListId,url:pageUrl});this.setDefaultFilters(pageUrl);}}},{key:'setDefaultFilters',value:function setDefaultFilters(categoryId){var currentCategory=this.props.currentCategory;if(currentCategory!==categoryId){this.props.setViewstate('currentCategory',categoryId);this.props.setViewstate('sortAscending',false);this.props.setViewstate('sortBy','name');this.props.removeViewstate('filter');this.props.setViewstate('pagination',0);}}},{key:'render',value:function render(){var _props=this.props,request=_props.request,productsRequest=_props.productsRequest,campaignProducts=_props.campaignProducts;if(request.get('statusCode')===404)return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__NotFoundPage__["a" /* default */],null);if(request.get('status')==='ERROR')return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__ErrorPage__["a" /* default */],null);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Page__["a" /* default */],{meta:this.props.currentPage.get('metaData'),bgColor:__WEBPACK_IMPORTED_MODULE_7__styles_helpers_variables__["c" /* color */].lightGrey,lastBreadcrumbItem:{title:this.props.currentPage.getIn(['fields','title']),url:this.props.location.pathname}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__styles_Container__["a" /* Container */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_CampaignListItem__["a" /* default */],{title:this.props.currentPage.getIn(['fields','title']),preamble:this.props.currentPage.getIn(['fields','introduction']),image:__WEBPACK_IMPORTED_MODULE_13__constants_endpoints__["n" /* SITE_ROOT_URL */]+this.props.currentPage.getIn(['fields','listImage','url'])})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_ProductListWithFilters__["a" /* default */],{includeCategoryFilter:true,request:productsRequest,allProducts:campaignProducts}));}}]);return CampaignPage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);CampaignPage.defaultProps={campaignProducts:Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])(),currentPage:Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])(),request:Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])(),productsRequest:Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])(),currentCategory:undefined};CampaignPage.propTypes={fetchArticlePageView:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,setViewstate:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,location:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,removeViewstate:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,fetchCampaignProducts:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,campaignProducts:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"]),currentPage:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"]),request:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"]),productsRequest:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"]),currentCategory:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3__store_connect__["a" /* default */])(CampaignPage,{setViewstate:__WEBPACK_IMPORTED_MODULE_4__actions_actionCreators__["W" /* setViewstate */],fetchArticlePageView:__WEBPACK_IMPORTED_MODULE_4__actions_actionCreators__["g" /* fetchArticlePageView */],removeViewstate:__WEBPACK_IMPORTED_MODULE_4__actions_actionCreators__["V" /* removeViewstate */],fetchCampaignProducts:__WEBPACK_IMPORTED_MODULE_4__actions_actionCreators__["m" /* fetchCampaignProducts */]},function(store,props){var currentPage=store.page.data.get(props.location.pathname,Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])());var listId=currentPage.getIn(['fields','campaignProductListId','id'],'');var campaignProductIds=store.campaign.get(listId);var campaignProducts=Object(__WEBPACK_IMPORTED_MODULE_5__selectors_reselectCategory__["b" /* getProductsByArray */])(store,campaignProductIds);return{currentPage:currentPage,request:store.page.request.get(props.location.pathname),campaignProducts:campaignProducts,productsRequest:store.products.request.get(props.location.pathname),currentCategory:store.viewstate.get('currentCategory')};}));

/***/ }),
/* 707 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_grid_styled__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_grid_styled___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_grid_styled__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Page__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_connect__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__actions_actionCreators__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_Heading__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_helpers_variables__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__styles_Container__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_NavigationButton__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__styles_Preamble__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__styles_FullWidthContainer__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__NotFoundPage__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__ErrorPage__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_ProductListWithFilters__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__selectors_reselectCategory__ = __webpack_require__(55);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ParentCategoryPage=function(_Component){_inherits(ParentCategoryPage,_Component);function ParentCategoryPage(){_classCallCheck(this,ParentCategoryPage);return _possibleConstructorReturn(this,(ParentCategoryPage.__proto__||Object.getPrototypeOf(ParentCategoryPage)).apply(this,arguments));}_createClass(ParentCategoryPage,[{key:'componentDidMount',value:function componentDidMount(){this.getPageData(this.props.match.url,this.props.item.get('id'));if(this.props.viewstate.get('currentCategory')!==this.props.item.get('id')){this.setDefaultFilters(this.props.item.get('id'));}}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(this.props.viewstate.get('currentCategory')!==nextProps.item.get('id')&&this.props.item.get('id')!==nextProps.item.get('id')){this.getPageData(nextProps.match.url,nextProps.item.get('id'));this.setDefaultFilters(nextProps.item.get('id'));}}},{key:'getPageData',value:function getPageData(pageUrl,categoryId){this.props.fetchCategoryMetaData({url:pageUrl});this.props.fetchProducts({id:categoryId,url:pageUrl});}},{key:'setDefaultFilters',value:function setDefaultFilters(categoryId){this.props.setViewstate('currentCategory',categoryId);this.props.setViewstate('sortAscending',false);this.props.setViewstate('sortBy','name');this.props.removeViewstate('filter');this.props.setViewstate('pagination',0);}},{key:'render',value:function render(){var _props=this.props,currentCategory=_props.currentCategory,item=_props.item,request=_props.request;if(request.get('statusCode')===404||item.isEmpty())return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__NotFoundPage__["a" /* default */],null);if(request.get('status')==='ERROR')return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__ErrorPage__["a" /* default */],null);var childRoutes=this.props.item.get('children');var subcategoryButtons=childRoutes.map(function(childRoute){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grid_styled__["Box"],{key:childRoute.get('id'),width:[1,1,1/2,1/2,1/3],py:['5px','8px','11px'],px:['0px','8px','11px']},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_NavigationButton__["a" /* NavigationButton */],{url:childRoute.get('url'),image:childRoute.get('image'),title:childRoute.get('title')}));}).toArray();return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Page__["a" /* default */],{meta:currentCategory.get('metaData'),bgColor:__WEBPACK_IMPORTED_MODULE_9__styles_helpers_variables__["c" /* color */].lightGrey},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__styles_FullWidthContainer__["a" /* FullWidthContainer */],{bgColor:__WEBPACK_IMPORTED_MODULE_9__styles_helpers_variables__["c" /* color */].lightGrey},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__styles_Container__["a" /* Container */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__styles_Heading__["a" /* Heading */],{big:true,center:true},currentCategory.get('name')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__styles_Preamble__["a" /* Preamble */],null,currentCategory.get('description')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_styled_components__["ThemeProvider"],{theme:{breakpoints:['500px','800px',__WEBPACK_IMPORTED_MODULE_9__styles_helpers_variables__["f" /* size */].large+'px','1100px']}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grid_styled__["Flex"],{flexWrap:'wrap',mx:['0px','-8px','-11px'],mt:60,mb:20},subcategoryButtons))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__components_ProductListWithFilters__["a" /* default */],{includeCategoryFilter:true,request:this.props.productRequest,allProducts:this.props.products})));}}]);return ParentCategoryPage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ParentCategoryPage.defaultProps={item:Object(__WEBPACK_IMPORTED_MODULE_3_immutable__["Map"])(),currentCategory:Object(__WEBPACK_IMPORTED_MODULE_3_immutable__["Map"])(),request:Object(__WEBPACK_IMPORTED_MODULE_3_immutable__["Map"])(),productRequest:Object(__WEBPACK_IMPORTED_MODULE_3_immutable__["Map"])(),products:Object(__WEBPACK_IMPORTED_MODULE_3_immutable__["Map"])(),viewstate:Object(__WEBPACK_IMPORTED_MODULE_3_immutable__["Map"])()};ParentCategoryPage.propTypes={match:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,item:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_3_immutable__["Map"]),currentCategory:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_3_immutable__["Map"]),request:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_3_immutable__["Map"]),productRequest:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_3_immutable__["Map"]),products:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_3_immutable__["Map"]),viewstate:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_3_immutable__["Map"]),fetchCategoryMetaData:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,fetchProducts:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,setViewstate:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,removeViewstate:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6__store_connect__["a" /* default */])(ParentCategoryPage,{fetchCategoryMetaData:__WEBPACK_IMPORTED_MODULE_7__actions_actionCreators__["s" /* fetchCategoryMetaData */],fetchProducts:__WEBPACK_IMPORTED_MODULE_7__actions_actionCreators__["K" /* fetchProducts */],setViewstate:__WEBPACK_IMPORTED_MODULE_7__actions_actionCreators__["W" /* setViewstate */],removeViewstate:__WEBPACK_IMPORTED_MODULE_7__actions_actionCreators__["V" /* removeViewstate */]},function(store,props){var currentCategory=store.categories.items.get(props.location.pathname.replace(/\/$/,''))||Object(__WEBPACK_IMPORTED_MODULE_3_immutable__["Map"])();return{viewstate:store.viewstate,currentCategory:currentCategory,request:store.categories.request.get(props.location.pathname.replace(/\/$/,'')),productRequest:store.products.request.get(props.location.pathname.replace(/\/$/,'')),products:Object(__WEBPACK_IMPORTED_MODULE_17__selectors_reselectCategory__["c" /* getProductsByKey */])(store,['category','url'],currentCategory.get('url'))};}));

/***/ }),
/* 708 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_grid_styled__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_grid_styled___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_grid_styled__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_connect__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions_actionCreators__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Page__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_Section__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_Container__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_Heading__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__styles_Preamble__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_StoreItemCard__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__NotFoundPage__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ErrorPage__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__styles_LoadingState__ = __webpack_require__(163);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var StoreItemListPage=function(_Component){_inherits(StoreItemListPage,_Component);function StoreItemListPage(){_classCallCheck(this,StoreItemListPage);return _possibleConstructorReturn(this,(StoreItemListPage.__proto__||Object.getPrototypeOf(StoreItemListPage)).apply(this,arguments));}_createClass(StoreItemListPage,[{key:'componentDidMount',value:function componentDidMount(){this.props.fetchArticlePageView({urlPath:this.props.location.pathname,includeChildren:true});}},{key:'render',value:function render(){var _props=this.props,currentPage=_props.currentPage,request=_props.request;if(request.get('statusCode')===404)return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__NotFoundPage__["a" /* default */],null);if(request.get('status')==='ERROR')return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__ErrorPage__["a" /* default */],null);if(request.get('status')==='LOADING')return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Page__["a" /* default */],{meta:currentPage.get('metaData'),bgColor:'#f2f2f2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__styles_Container__["a" /* Container */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__styles_LoadingState__["b" /* LoadingHeading */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__styles_LoadingState__["c" /* LoadingPreamble */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__styles_LoadingState__["a" /* LoadingBody */],null)));var responsiveGridArrayFour=[1/2,1/2,1/3,1/4];var gridPadding=['5px','7px','10px'];var negativeGridPadding=['-5px','-7px','-10px'];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Page__["a" /* default */],{meta:this.props.currentPage.get('metaData'),bgColor:'#f2f2f2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__styles_Container__["a" /* Container */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__styles_Heading__["a" /* Heading */],{big:true,center:true},currentPage.getIn(['fields','title'])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__styles_Preamble__["a" /* Preamble */],null,currentPage.getIn(['fields','introduction']))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__styles_Container__["a" /* Container */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__styles_Section__["a" /* Section */],{pb:80},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grid_styled__["Flex"],{flexWrap:'wrap',mx:negativeGridPadding},currentPage.get('children')&&currentPage.get('children').map(function(child){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grid_styled__["Box"],{key:child.get('url'),width:responsiveGridArrayFour,px:gridPadding,my:gridPadding},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_StoreItemCard__["a" /* default */],{url:child.get('url'),productName:child.getIn(['fields','listTitle'])||child.getIn(['fields','productName']),brand:child.getIn(['fields','brand']),image:child.getIn(['fields','listImage'])||child.getIn(['fields','productImage']),tag:child.getIn(['fields','tag']),price:Number(child.getIn(['fields','productPrice'])),originalPrice:Number(child.getIn(['fields','productOriginalPrice']))}));})))));}}]);return StoreItemListPage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);StoreItemListPage.defaultProps={currentPage:Object(__WEBPACK_IMPORTED_MODULE_3_immutable__["Map"])(),request:Object(__WEBPACK_IMPORTED_MODULE_3_immutable__["Map"])()};StoreItemListPage.propTypes={fetchArticlePageView:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,currentPage:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_3_immutable__["Map"]),request:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_3_immutable__["Map"]),location:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4__store_connect__["a" /* default */])(StoreItemListPage,{fetchArticlePageView:__WEBPACK_IMPORTED_MODULE_5__actions_actionCreators__["g" /* fetchArticlePageView */]},function(store,props){return{currentPage:store.page.data.get(props.location.pathname),request:store.page.request.get(props.location.pathname)};}));

/***/ }),
/* 709 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_grid_styled__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_grid_styled___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_grid_styled__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_dom__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_connect__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__actions_actionCreators__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Page__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_Container__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__styles_Heading__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__NotFoundPage__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ErrorPage__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__constants_endpoints__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__styles_SubHeading__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__styles_helpers_variables__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__styles_HtmlWrapper__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_RenderPrice__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__styles_helpers_mixins__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_Conditional__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__styles_Section__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_StoreItemCard__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_LinedHeading__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__styles_LoadingState__ = __webpack_require__(163);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  width: 100%;\n'],['\n  width: 100%;\n']),_templateObject2=_taggedTemplateLiteral(['\n  color: black;\n'],['\n  color: black;\n']),_templateObject3=_taggedTemplateLiteral(['\n  ',';\n  font-size: 14px;\n  font-weight: 600;\n  font-style: normal;\n  font-stretch: normal;\n  line-height: 1.57;\n  letter-spacing: normal;\n  color: ',';\n  margin-bottom: 5px;\n'],['\n  ',';\n  font-size: 14px;\n  font-weight: 600;\n  font-style: normal;\n  font-stretch: normal;\n  line-height: 1.57;\n  letter-spacing: normal;\n  color: ',';\n  margin-bottom: 5px;\n']),_templateObject4=_taggedTemplateLiteral(['\n  ',';\n  font-size: 16px;\n  font-weight: 600;\n  font-style: normal;\n  font-stretch: normal;\n  line-height: 1.69;\n  letter-spacing: normal;\n  color: ',';\n  margin: 3px 0;\n  display: block;\n  text-decoration: none;\n  transition: opacity 0.25s ease-out;\n\n  &:hover {\n    opacity: 0.8;\n  }\n'],['\n  ',';\n  font-size: 16px;\n  font-weight: 600;\n  font-style: normal;\n  font-stretch: normal;\n  line-height: 1.69;\n  letter-spacing: normal;\n  color: ',';\n  margin: 3px 0;\n  display: block;\n  text-decoration: none;\n  transition: opacity 0.25s ease-out;\n\n  &:hover {\n    opacity: 0.8;\n  }\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var StoreItemPage=function(_Component){_inherits(StoreItemPage,_Component);function StoreItemPage(){_classCallCheck(this,StoreItemPage);return _possibleConstructorReturn(this,(StoreItemPage.__proto__||Object.getPrototypeOf(StoreItemPage)).apply(this,arguments));}_createClass(StoreItemPage,[{key:'componentDidMount',value:function componentDidMount(){this.props.fetchArticlePageView({urlPath:this.props.location.pathname,hasLinkedContent:true});}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){if(this.props.location.pathname!==prevProps.location.pathname){this.props.fetchArticlePageView({urlPath:this.props.location.pathname,hasLinkedContent:true});}}},{key:'render',value:function render(){var _props=this.props,currentPage=_props.currentPage,request=_props.request;var imageProps='?width=1600';var responsiveGridArrayFour=[1/2,1/2,1/3,1/4];var gridPadding=['5px','7px','10px'];var negativeGridPadding=['-5px','-7px','-10px'];if(request.get('statusCode')===404)return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__NotFoundPage__["a" /* default */],null);if(request.get('status')==='ERROR')return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__ErrorPage__["a" /* default */],null);if(request.get('status')==='LOADING')return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Page__["a" /* default */],{meta:currentPage.get('metaData'),bgColor:'#f2f2f2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__styles_Container__["a" /* Container */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__styles_LoadingState__["b" /* LoadingHeading */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__styles_LoadingState__["c" /* LoadingPreamble */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__styles_LoadingState__["a" /* LoadingBody */],null)));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Page__["a" /* default */],{meta:currentPage.get('metaData'),bgColor:'#f2f2f2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__styles_Container__["a" /* Container */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grid_styled__["Flex"],{flexWrap:'wrap'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grid_styled__["Box"],{width:[1,7/12,5/12],py:[0,32,32],pr:[0,40,80]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__components_Conditional__["a" /* Conditional */],{show:!!currentPage.getIn(['fields','brand','url'])},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__styles_SubHeading__["a" /* SubHeading */].link,{to:currentPage.getIn(['fields','brand','url']),color:__WEBPACK_IMPORTED_MODULE_15__styles_helpers_variables__["c" /* color */].black,margin:'0',uppercase:true},currentPage.getIn(['fields','brand','name']))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__styles_Heading__["a" /* Heading */],{margin:'0',style:{lineHeight:1.2}},currentPage.getIn(['fields','productName'])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__components_RenderPrice__["a" /* default */],{price:Number(currentPage.getIn(['fields','productPrice'])),originalPrice:Number(currentPage.getIn(['fields','productOriginalPrice']))}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__styles_HtmlWrapper__["a" /* HtmlWrapper */],{dangerouslySetInnerHTML:{__html:currentPage.getIn(['fields','description'])}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__components_Conditional__["a" /* Conditional */],{show:!!currentPage.getIn(['fields','originalProduct'])},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LinkToProduct,{to:currentPage.getIn(['fields','originalProduct'])},'L\xE4s mer om produkten')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ContactStoreTitle,null,'Kontakta butiken:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__components_Conditional__["a" /* Conditional */],{show:!!currentPage.getIn(['fields','emailAddress'])},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ContactStoreLink,{href:'mailto:'+currentPage.getIn(['fields','emailAddress'])},currentPage.getIn(['fields','emailAddress']))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__components_Conditional__["a" /* Conditional */],{show:!!currentPage.getIn(['fields','phoneNumber'])},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ContactStoreLink,{href:'tel:'+currentPage.getIn(['fields','phoneNumber'])},currentPage.getIn(['fields','phoneNumber'])))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grid_styled__["Box"],{width:[1,5/12,7/12],py:[20,32,32]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__components_Conditional__["a" /* Conditional */],{show:!!currentPage.getIn(['fields','productImage','url'])},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ProductImage,{src:__WEBPACK_IMPORTED_MODULE_13__constants_endpoints__["n" /* SITE_ROOT_URL */]+currentPage.getIn(['fields','productImage','url'])+imageProps,alt:currentPage.getIn(['fields','productImage','alt'])}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__components_Conditional__["a" /* Conditional */],{show:!!currentPage.get('linkedContent')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__styles_Container__["a" /* Container */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__styles_Section__["a" /* Section */],{pb:80},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__components_LinedHeading__["a" /* default */],{bgColor:'#f2f2f2'},'Fler ust\xE4llningsexemplar'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grid_styled__["Flex"],{flexWrap:'wrap',mx:negativeGridPadding},currentPage.get('linkedContent')&&currentPage.get('linkedContent').map(function(child){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grid_styled__["Box"],{key:child.get('url'),width:responsiveGridArrayFour,px:gridPadding,my:gridPadding},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__components_StoreItemCard__["a" /* default */],{url:child.get('url'),productName:child.getIn(['fields','listTitle'])||child.getIn(['fields','productName']),brand:child.getIn(['fields','brand']),image:child.getIn(['fields','listImage'])||child.getIn(['fields','productImage']),tag:child.getIn(['fields','tag']),price:Number(child.getIn(['fields','productPrice'])),originalPrice:Number(child.getIn(['fields','productOriginalPrice']))}));}))))));}}]);return StoreItemPage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);StoreItemPage.defaultProps={currentPage:Object(__WEBPACK_IMPORTED_MODULE_3_immutable__["Map"])(),request:Object(__WEBPACK_IMPORTED_MODULE_3_immutable__["Map"])()};StoreItemPage.propTypes={fetchArticlePageView:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,currentPage:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_3_immutable__["Map"]),request:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_3_immutable__["Map"]),location:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6__store_connect__["a" /* default */])(StoreItemPage,{fetchArticlePageView:__WEBPACK_IMPORTED_MODULE_7__actions_actionCreators__["g" /* fetchArticlePageView */]},function(store,props){return{currentPage:store.page.data.get(props.location.pathname),request:store.page.request.get(props.location.pathname)};}));var ProductImage=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].img(_templateObject);var LinkToProduct=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_5_react_router_dom__["a" /* Link */])(_templateObject2);var ContactStoreTitle=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].h3(_templateObject3,__WEBPACK_IMPORTED_MODULE_18__styles_helpers_mixins__["d" /* fontFamilyBody */],__WEBPACK_IMPORTED_MODULE_15__styles_helpers_variables__["c" /* color */].black);var ContactStoreLink=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].a(_templateObject4,__WEBPACK_IMPORTED_MODULE_18__styles_helpers_mixins__["d" /* fontFamilyBody */],__WEBPACK_IMPORTED_MODULE_15__styles_helpers_variables__["c" /* color */].primary);

/***/ }),
/* 710 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_connect__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions_actionCreators__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__selectors_reselectCategory__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Page__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_helpers_variables__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_Heading__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_Preamble__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__styles_Container__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_ProductListWithFilters__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__NotFoundPage__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ErrorPage__ = __webpack_require__(36);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProductListPage=function(_Component){_inherits(ProductListPage,_Component);function ProductListPage(){_classCallCheck(this,ProductListPage);return _possibleConstructorReturn(this,(ProductListPage.__proto__||Object.getPrototypeOf(ProductListPage)).apply(this,arguments));}_createClass(ProductListPage,[{key:'componentDidMount',value:function componentDidMount(){var pageUrl=this.props.location.pathname;this.props.fetchArticlePageView({urlPath:pageUrl});var productListId=this.props.currentPage.getIn(['fields','productListId','id']);if(productListId){this.props.fetchCampaignProducts({id:productListId,url:pageUrl});}this.setDefaultFilters(pageUrl);}},{key:'componentDidUpdate',value:function componentDidUpdate(){var pageUrl=this.props.location.pathname;var productListId=this.props.currentPage.getIn(['fields','productListId','id']);if(this.props.productsRequest.isEmpty()&&productListId){this.props.fetchCampaignProducts({id:productListId,url:pageUrl});this.setDefaultFilters(pageUrl);}}},{key:'setDefaultFilters',value:function setDefaultFilters(categoryId){var currentCategory=this.props.currentCategory;if(currentCategory!==categoryId){this.props.setViewstate('currentCategory',categoryId);this.props.setViewstate('sortAscending',false);this.props.setViewstate('sortBy','name');this.props.removeViewstate('filter');this.props.setViewstate('pagination',0);}}},{key:'render',value:function render(){var _props=this.props,request=_props.request,productsRequest=_props.productsRequest,campaignProducts=_props.campaignProducts;if(request.get('statusCode')===404)return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__NotFoundPage__["a" /* default */],null);if(request.get('status')==='ERROR')return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__ErrorPage__["a" /* default */],null);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Page__["a" /* default */],{meta:this.props.currentPage.get('metaData'),bgColor:__WEBPACK_IMPORTED_MODULE_7__styles_helpers_variables__["c" /* color */].lightGrey},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__styles_Container__["a" /* Container */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__styles_Heading__["a" /* Heading */],{big:true,center:true},this.props.currentPage.getIn(['fields','title'])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__styles_Preamble__["a" /* Preamble */],null,this.props.currentPage.getIn(['fields','introduction']))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_ProductListWithFilters__["a" /* default */],{includeCategoryFilter:true,request:productsRequest,allProducts:campaignProducts}));}}]);return ProductListPage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ProductListPage.defaultProps={campaignProducts:Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])(),currentPage:Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])(),request:Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])(),productsRequest:Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])(),currentCategory:undefined};ProductListPage.propTypes={fetchArticlePageView:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,setViewstate:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,location:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,removeViewstate:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,fetchCampaignProducts:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,campaignProducts:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"]),currentPage:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"]),request:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"]),productsRequest:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"]),currentCategory:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3__store_connect__["a" /* default */])(ProductListPage,{setViewstate:__WEBPACK_IMPORTED_MODULE_4__actions_actionCreators__["W" /* setViewstate */],fetchArticlePageView:__WEBPACK_IMPORTED_MODULE_4__actions_actionCreators__["g" /* fetchArticlePageView */],removeViewstate:__WEBPACK_IMPORTED_MODULE_4__actions_actionCreators__["V" /* removeViewstate */],fetchCampaignProducts:__WEBPACK_IMPORTED_MODULE_4__actions_actionCreators__["m" /* fetchCampaignProducts */]},function(store,props){var currentPage=store.page.data.get(props.location.pathname,Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])());var listId=currentPage.getIn(['fields','productListId','id'],'');var campaignProductIds=store.campaign.get(listId);var campaignProducts=Object(__WEBPACK_IMPORTED_MODULE_5__selectors_reselectCategory__["b" /* getProductsByArray */])(store,campaignProductIds);return{currentPage:currentPage,request:store.page.request.get(props.location.pathname),campaignProducts:campaignProducts,productsRequest:store.products.request.get(props.location.pathname),currentCategory:store.viewstate.get('currentCategory')};}));

/***/ }),
/* 711 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Page__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_connect__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_Container__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants_endpoints__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__OrderConfirmationPage__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__actions_actionCreators__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_NewsletterSignUpForm__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__styles_helpers_variables__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__constants_status__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Conditional__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__styles_helpers_mixins__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__styles_Heading__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_LoadingSpinner__ = __webpack_require__(94);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  width: 100%;\n  margin: 0 auto 20px;\n  max-width: 950px;\n  background-color: white !important;\n  display: flex;\n  min-height: 450px;\n\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  padding: 27px 17px;\n\n  @media screen and (min-width: ','px) {\n    margin: 0 auto 28px;\n    padding: 57px 100px;\n    min-height: 550px;\n  }\n'],['\n  width: 100%;\n  margin: 0 auto 20px;\n  max-width: 950px;\n  background-color: white !important;\n  display: flex;\n  min-height: 450px;\n\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  padding: 27px 17px;\n\n  @media screen and (min-width: ','px) {\n    margin: 0 auto 28px;\n    padding: 57px 100px;\n    min-height: 550px;\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  max-width: 560px;\n  width: 100%;\n  margin: 0 0 30px;\n\n  @media screen and (min-width: ','px) {\n    margin: 0 0 50px;\n  }\n\n  @media screen and (min-width: ','px) {\n    margin: 0 0 70px;\n  }\n'],['\n  max-width: 560px;\n  width: 100%;\n  margin: 0 0 30px;\n\n  @media screen and (min-width: ','px) {\n    margin: 0 0 50px;\n  }\n\n  @media screen and (min-width: ','px) {\n    margin: 0 0 70px;\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  margin: 0 0 0.5rem;\n  @media screen and (min-width: ','px) {\n    margin: 0 0 2rem;\n  }\n'],['\n  margin: 0 0 0.5rem;\n  @media screen and (min-width: ','px) {\n    margin: 0 0 2rem;\n  }\n']),_templateObject4=_taggedTemplateLiteral(['\n  margin-bottom: 17px;\n\n  p {\n    ',';\n    font-weight: 300;\n    line-height: 1.55;\n    text-align: center;\n    margin: 0 0 1em;\n  }\n\n  a {\n    text-decoration: none;\n    color: inherit;\n    cursor: pointer;\n  }\n\n  span {\n    font-weight: 600;\n  }\n\n  ',';\n\n  @media screen and (min-width: ','px) {\n    margin-bottom: 33px;\n  }\n'],['\n  margin-bottom: 17px;\n\n  p {\n    ',';\n    font-weight: 300;\n    line-height: 1.55;\n    text-align: center;\n    margin: 0 0 1em;\n  }\n\n  a {\n    text-decoration: none;\n    color: inherit;\n    cursor: pointer;\n  }\n\n  span {\n    font-weight: 600;\n  }\n\n  ',';\n\n  @media screen and (min-width: ','px) {\n    margin-bottom: 33px;\n  }\n']),_templateObject5=_taggedTemplateLiteral(['\n      color: ',';\n    '],['\n      color: ',';\n    ']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var NewsletterPage=function(_Component){_inherits(NewsletterPage,_Component);function NewsletterPage(props){_classCallCheck(this,NewsletterPage);var _this=_possibleConstructorReturn(this,(NewsletterPage.__proto__||Object.getPrototypeOf(NewsletterPage)).call(this,props));_this.state={status:__WEBPACK_IMPORTED_MODULE_12__constants_status__["c" /* INITIAL */]};_this.setStatus=_this.setStatus.bind(_this);return _this;}_createClass(NewsletterPage,[{key:'componentWillMount',value:function componentWillMount(){this.props.fetchArticlePageView({urlPath:this.props.location.pathname});}},{key:'setStatus',value:function setStatus(newStatus){this.setState({status:newStatus});}},{key:'render',value:function render(){var currentPage=this.props.currentPage;var status=this.state.status;var imageUrl=currentPage.getIn(['fields','image','url']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Page__["a" /* default */],{title:'Nyhetsbrev',bgImg:imageUrl&&''+__WEBPACK_IMPORTED_MODULE_7__constants_endpoints__["n" /* SITE_ROOT_URL */]+imageUrl,noBreadcrumbs:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__styles_Container__["a" /* Container */],{bgColor:'transparent',style:{paddingTop:'0',paddingBottom:'0',minHeight:'60vh'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__OrderConfirmationPage__["a" /* InnerContainer */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WhiteContainer,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_Conditional__["a" /* Conditional */],{show:status===__WEBPACK_IMPORTED_MODULE_12__constants_status__["c" /* INITIAL */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(NewsletterPageHeading,{big:true,margin:'0 0 1rem'},currentPage.getIn(['fields','title'])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(NewsletterPageBodyText,{dangerouslySetInnerHTML:{__html:currentPage.getIn(['fields','bodyText'])}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FormContainer,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_NewsletterSignUpForm__["a" /* default */],{placeholder:currentPage.getIn(['fields','inputEmailPlaceholder']),privacyPolicy:currentPage.getIn(['fields','acceptTermsText']),buttonText:currentPage.getIn(['fields','subscribeButtonText']),onUpdateStatus:this.setStatus}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_Conditional__["a" /* Conditional */],{show:status===__WEBPACK_IMPORTED_MODULE_12__constants_status__["d" /* LOADING */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__components_LoadingSpinner__["a" /* LoadingSpinner */],{margin:'66px auto !important'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_Conditional__["a" /* Conditional */],{show:status===__WEBPACK_IMPORTED_MODULE_12__constants_status__["f" /* SUCCESS */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(NewsletterPageHeading,{big:true,margin:'0 0 1rem'},currentPage.getIn(['fields','subscriptionSuccessTitle'])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(NewsletterPageBodyText,{dangerouslySetInnerHTML:{__html:currentPage.getIn(['fields','subscriptionSuccessText'])}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_Conditional__["a" /* Conditional */],{show:status===__WEBPACK_IMPORTED_MODULE_12__constants_status__["b" /* FAILURE */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(NewsletterPageHeading,{big:true,margin:'0 0 1rem'},'Ops!'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(NewsletterPageBodyText,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'N\xE5got gick fel, v\xE4nligen f\xF6rs\xF6k igen.')))))));}}]);return NewsletterPage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);NewsletterPage.defaultProps={currentPage:Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])()};NewsletterPage.propTypes={fetchArticlePageView:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,location:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,currentPage:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5__store_connect__["a" /* default */])(NewsletterPage,{fetchArticlePageView:__WEBPACK_IMPORTED_MODULE_9__actions_actionCreators__["g" /* fetchArticlePageView */]},function(store,props){return{currentPage:store.page.data.get(props.location.pathname)};}));var WhiteContainer=__WEBPACK_IMPORTED_MODULE_3_styled_components__["default"].div(_templateObject,__WEBPACK_IMPORTED_MODULE_11__styles_helpers_variables__["f" /* size */].large);var FormContainer=__WEBPACK_IMPORTED_MODULE_3_styled_components__["default"].div(_templateObject2,__WEBPACK_IMPORTED_MODULE_11__styles_helpers_variables__["f" /* size */].large,__WEBPACK_IMPORTED_MODULE_11__styles_helpers_variables__["f" /* size */].xLarge);var NewsletterPageHeading=Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_15__styles_Heading__["a" /* Heading */])(_templateObject3,__WEBPACK_IMPORTED_MODULE_11__styles_helpers_variables__["f" /* size */].large);var NewsletterPageBodyText=__WEBPACK_IMPORTED_MODULE_3_styled_components__["default"].div(_templateObject4,Object(__WEBPACK_IMPORTED_MODULE_14__styles_helpers_mixins__["b" /* dynamicFontSize */])(16,20),function(props){return props.color&&Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["css"])(_templateObject5,props.color);},__WEBPACK_IMPORTED_MODULE_11__styles_helpers_variables__["f" /* size */].large);

/***/ }),
/* 712 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export globalStyles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__variables__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__webfonts_389094_0_0_eot__ = __webpack_require__(713);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__webfonts_389094_0_0_eot___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__webfonts_389094_0_0_eot__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__webfonts_389094_0_0_eot_iefix__ = __webpack_require__(714);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__webfonts_389094_0_0_eot_iefix___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__webfonts_389094_0_0_eot_iefix__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__webfonts_389094_0_0_woff2__ = __webpack_require__(715);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__webfonts_389094_0_0_woff2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__webfonts_389094_0_0_woff2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__webfonts_389094_0_0_woff__ = __webpack_require__(716);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__webfonts_389094_0_0_woff___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__webfonts_389094_0_0_woff__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__webfonts_389094_0_0_ttf__ = __webpack_require__(717);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__webfonts_389094_0_0_ttf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__webfonts_389094_0_0_ttf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__webfonts_389094_1_0_eot__ = __webpack_require__(718);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__webfonts_389094_1_0_eot___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__webfonts_389094_1_0_eot__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__webfonts_389094_1_0_eot_iefix__ = __webpack_require__(719);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__webfonts_389094_1_0_eot_iefix___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__webfonts_389094_1_0_eot_iefix__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__webfonts_389094_1_0_woff2__ = __webpack_require__(720);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__webfonts_389094_1_0_woff2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__webfonts_389094_1_0_woff2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__webfonts_389094_1_0_woff__ = __webpack_require__(721);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__webfonts_389094_1_0_woff___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__webfonts_389094_1_0_woff__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__webfonts_389094_1_0_ttf__ = __webpack_require__(722);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__webfonts_389094_1_0_ttf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__webfonts_389094_1_0_ttf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__webfonts_389094_2_0_eot__ = __webpack_require__(723);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__webfonts_389094_2_0_eot___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__webfonts_389094_2_0_eot__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__webfonts_389094_2_0_eot_iefix__ = __webpack_require__(724);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__webfonts_389094_2_0_eot_iefix___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__webfonts_389094_2_0_eot_iefix__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__webfonts_389094_2_0_woff2__ = __webpack_require__(725);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__webfonts_389094_2_0_woff2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__webfonts_389094_2_0_woff2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__webfonts_389094_2_0_woff__ = __webpack_require__(726);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__webfonts_389094_2_0_woff___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__webfonts_389094_2_0_woff__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__webfonts_389094_2_0_ttf__ = __webpack_require__(727);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__webfonts_389094_2_0_ttf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__webfonts_389094_2_0_ttf__);
var _templateObject=_taggedTemplateLiteral(['\n  @import url(\'https://fonts.googleapis.com/css?family=Playfair+Display|Open+Sans:300,400,500,600,700\');\n  @import url("https://hello.myfonts.net/count/389094");\n    \n  @font-face {\n    font-family: \'WashingMachineExtras\';\n    src: url(',');\n    src: url(',') format(\'embedded-opentype\'),\n    url(',') format(\'woff2\'),\n    url(',') format(\'woff\'),\n    url(',') format(\'truetype\');\n  }\n\n  @font-face {\n    font-family: \'WashingMachine\';\n    src: url(',');\n    src: url(',') format(\'embedded-opentype\'),\n    url(',') format(\'woff2\'),\n    url(',') format(\'woff\'),\n    url(',') format(\'truetype\');\n  }\n  \n  @font-face {\n    font-family: \'WashingMachine-Bold\';\n    src: url(',');\n    src: url(',') format(\'embedded-opentype\'),\n    url(',') format(\'woff2\'),\n    url(',') format(\'woff\'),\n    url(',') format(\'truetype\');\n  }  \n  \n  * {\n    box-sizing: border-box;\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n  }\n  \n  html {\n    background-color: ',';\n    -webkit-text-size-adjust: 100%;\n  }\n  \n  body {\n    font-family: \'Open Sans\', Helvetica, Arial, sans-serif;\n    position: relative;\n    -webkit-font-smoothing: antialiased;\n  }\n'],['\n  @import url(\'https://fonts.googleapis.com/css?family=Playfair+Display|Open+Sans:300,400,500,600,700\');\n  @import url("https://hello.myfonts.net/count/389094");\n    \n  @font-face {\n    font-family: \'WashingMachineExtras\';\n    src: url(',');\n    src: url(',') format(\'embedded-opentype\'),\n    url(',') format(\'woff2\'),\n    url(',') format(\'woff\'),\n    url(',') format(\'truetype\');\n  }\n\n  @font-face {\n    font-family: \'WashingMachine\';\n    src: url(',');\n    src: url(',') format(\'embedded-opentype\'),\n    url(',') format(\'woff2\'),\n    url(',') format(\'woff\'),\n    url(',') format(\'truetype\');\n  }\n  \n  @font-face {\n    font-family: \'WashingMachine-Bold\';\n    src: url(',');\n    src: url(',') format(\'embedded-opentype\'),\n    url(',') format(\'woff2\'),\n    url(',') format(\'woff\'),\n    url(',') format(\'truetype\');\n  }  \n  \n  * {\n    box-sizing: border-box;\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n  }\n  \n  html {\n    background-color: ',';\n    -webkit-text-size-adjust: 100%;\n  }\n  \n  body {\n    font-family: \'Open Sans\', Helvetica, Arial, sans-serif;\n    position: relative;\n    -webkit-font-smoothing: antialiased;\n  }\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}// Wash fonts
var globalStyles=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["injectGlobal"])(_templateObject,__WEBPACK_IMPORTED_MODULE_2__webfonts_389094_0_0_eot___default.a,__WEBPACK_IMPORTED_MODULE_3__webfonts_389094_0_0_eot_iefix___default.a,__WEBPACK_IMPORTED_MODULE_4__webfonts_389094_0_0_woff2___default.a,__WEBPACK_IMPORTED_MODULE_5__webfonts_389094_0_0_woff___default.a,__WEBPACK_IMPORTED_MODULE_6__webfonts_389094_0_0_ttf___default.a,__WEBPACK_IMPORTED_MODULE_7__webfonts_389094_1_0_eot___default.a,__WEBPACK_IMPORTED_MODULE_8__webfonts_389094_1_0_eot_iefix___default.a,__WEBPACK_IMPORTED_MODULE_9__webfonts_389094_1_0_woff2___default.a,__WEBPACK_IMPORTED_MODULE_10__webfonts_389094_1_0_woff___default.a,__WEBPACK_IMPORTED_MODULE_11__webfonts_389094_1_0_ttf___default.a,__WEBPACK_IMPORTED_MODULE_12__webfonts_389094_2_0_eot___default.a,__WEBPACK_IMPORTED_MODULE_13__webfonts_389094_2_0_eot_iefix___default.a,__WEBPACK_IMPORTED_MODULE_14__webfonts_389094_2_0_woff2___default.a,__WEBPACK_IMPORTED_MODULE_15__webfonts_389094_2_0_woff___default.a,__WEBPACK_IMPORTED_MODULE_16__webfonts_389094_2_0_ttf___default.a,__WEBPACK_IMPORTED_MODULE_1__variables__["c" /* color */].black);

/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/389094_0_0.714b72f3.eot";

/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/389094_0_0.714b72f3.eot";

/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/389094_0_0.00e931b2.woff2";

/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/389094_0_0.b4dc64a7.woff";

/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/389094_0_0.d906b4fd.ttf";

/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/389094_1_0.cc91bfd2.eot";

/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/389094_1_0.cc91bfd2.eot";

/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/389094_1_0.93cf3cf3.woff2";

/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/389094_1_0.17e8863d.woff";

/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/389094_1_0.0d95e5ea.ttf";

/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/389094_2_0.367596fa.eot";

/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/389094_2_0.367596fa.eot";

/***/ }),
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/389094_2_0.af7c2150.woff2";

/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/389094_2_0.6525b583.woff";

/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/389094_2_0.eae7cf3a.ttf";

/***/ }),
/* 728 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = startForman;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__watcher__ = __webpack_require__(731);
var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(startForman);function startForman(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function startForman$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* fork */])(__WEBPACK_IMPORTED_MODULE_2__watcher__["a" /* watchObjectData */]);case 2:case"end":return _context.stop();}}},_marked,this);}

/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

// This method of obtaining a reference to the global object needs to be
// kept identical to the way it is obtained in runtime.js
var g = (function() { return this })() || Function("return this")();

// Use `getOwnPropertyNames` because not all browsers support calling
// `hasOwnProperty` on the global `self` object in a worker. See #183.
var hadRuntime = g.regeneratorRuntime &&
  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

// Save the old regeneratorRuntime in case it needs to be restored later.
var oldRuntime = hadRuntime && g.regeneratorRuntime;

// Force reevalutation of runtime.js.
g.regeneratorRuntime = undefined;

module.exports = __webpack_require__(730);

if (hadRuntime) {
  // Restore the original runtime.
  g.regeneratorRuntime = oldRuntime;
} else {
  // Remove the global property added by runtime.js.
  try {
    delete g.regeneratorRuntime;
  } catch(e) {
    g.regeneratorRuntime = undefined;
  }
}


/***/ }),
/* 730 */
/***/ (function(module, exports) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // In sloppy mode, unbound `this` refers to the global object, fallback to
  // Function constructor if we're in global strict mode. That is sadly a form
  // of indirect eval which violates Content Security Policy.
  (function() { return this })() || Function("return this")()
);


/***/ }),
/* 731 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = watchObjectData;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_actionTypes__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__dataFromLitiumSaga__ = __webpack_require__(732);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__globalSearch__ = __webpack_require__(733);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__articlePage__ = __webpack_require__(735);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__brands__ = __webpack_require__(737);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__products__ = __webpack_require__(738);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__category__ = __webpack_require__(739);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__cart__ = __webpack_require__(740);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__instagram__ = __webpack_require__(742);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__deliveryMethods__ = __webpack_require__(743);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__designers__ = __webpack_require__(744);
var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(watchObjectData);function watchObjectData(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function watchObjectData$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* takeEvery */])(__WEBPACK_IMPORTED_MODULE_2__actions_actionTypes__["L" /* FETCH_PRODUCTS_PAGE_VIEW */],__WEBPACK_IMPORTED_MODULE_3__dataFromLitiumSaga__["a" /* dataFromLitiumSaga */]);case 2:_context.next=4;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* takeEvery */])(__WEBPACK_IMPORTED_MODULE_2__actions_actionTypes__["J" /* FETCH_PRODUCTS_CATEGORY_PAGE_VIEW */],__WEBPACK_IMPORTED_MODULE_3__dataFromLitiumSaga__["a" /* dataFromLitiumSaga */]);case 4:_context.next=6;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* takeEvery */])(__WEBPACK_IMPORTED_MODULE_2__actions_actionTypes__["S" /* FETCH_TEST_CART */],__WEBPACK_IMPORTED_MODULE_3__dataFromLitiumSaga__["a" /* dataFromLitiumSaga */]);case 6:_context.next=8;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* takeEvery */])(__WEBPACK_IMPORTED_MODULE_2__actions_actionTypes__["g" /* FETCH_ARTICLE_PAGE_VIEW */],__WEBPACK_IMPORTED_MODULE_5__articlePage__["a" /* cmsPage */]);case 8:_context.next=10;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_2__actions_actionTypes__["B" /* FETCH_GLOBAL_SEARCH */],__WEBPACK_IMPORTED_MODULE_4__globalSearch__["a" /* globalSearch */]);case 10:_context.next=12;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_2__actions_actionTypes__["P" /* FETCH_QUICK_SEARCH */],__WEBPACK_IMPORTED_MODULE_4__globalSearch__["b" /* quickSearch */]);case 12:_context.next=14;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* takeEvery */])(__WEBPACK_IMPORTED_MODULE_2__actions_actionTypes__["j" /* FETCH_BRAND_DATA */],__WEBPACK_IMPORTED_MODULE_6__brands__["a" /* brands */]);case 14:_context.next=16;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* takeEvery */])(__WEBPACK_IMPORTED_MODULE_2__actions_actionTypes__["y" /* FETCH_DESIGNERS_DATA */],__WEBPACK_IMPORTED_MODULE_12__designers__["a" /* designers */]);case 16:_context.next=18;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* takeEvery */])(__WEBPACK_IMPORTED_MODULE_2__actions_actionTypes__["I" /* FETCH_PRODUCTS */],__WEBPACK_IMPORTED_MODULE_7__products__["b" /* products */]);case 18:_context.next=20;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* takeEvery */])(__WEBPACK_IMPORTED_MODULE_2__actions_actionTypes__["m" /* FETCH_CAMPAIGN_PRODUCTS */],__WEBPACK_IMPORTED_MODULE_7__products__["c" /* productsList */]);case 20:_context.next=22;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* takeEvery */])(__WEBPACK_IMPORTED_MODULE_2__actions_actionTypes__["s" /* FETCH_CATEGORY_META_DATA */],__WEBPACK_IMPORTED_MODULE_8__category__["a" /* category */]);case 22:_context.next=24;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_2__actions_actionTypes__["a" /* ADD_PRODUCT_TO_CART */],__WEBPACK_IMPORTED_MODULE_9__cart__["a" /* addCartItem */]);case 24:_context.next=26;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_2__actions_actionTypes__["p" /* FETCH_CART */],__WEBPACK_IMPORTED_MODULE_9__cart__["b" /* cart */]);case 26:_context.next=28;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_2__actions_actionTypes__["U" /* REMOVE_PRODUCT_FROM_CART */],__WEBPACK_IMPORTED_MODULE_9__cart__["d" /* removeCartItem */]);case 28:_context.next=30;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_2__actions_actionTypes__["d" /* DELETE_CART_ROW */],__WEBPACK_IMPORTED_MODULE_9__cart__["c" /* deleteCartRow */]);case 30:_context.next=32;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* takeEvery */])(__WEBPACK_IMPORTED_MODULE_2__actions_actionTypes__["E" /* FETCH_INSTAGRAM_POSTS */],__WEBPACK_IMPORTED_MODULE_10__instagram__["a" /* instagram */]);case 32:_context.next=34;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_2__actions_actionTypes__["v" /* FETCH_DELIVERY_METHODS */],__WEBPACK_IMPORTED_MODULE_11__deliveryMethods__["a" /* deliveryMethods */]);case 34:_context.next=36;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* takeEvery */])(__WEBPACK_IMPORTED_MODULE_2__actions_actionTypes__["H" /* FETCH_PRODUCT */],__WEBPACK_IMPORTED_MODULE_7__products__["a" /* product */]);case 36:case'end':return _context.stop();}}},_marked,this);}

/***/ }),
/* 732 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = dataFromLitiumSaga;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_productData__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions_actionCreators__ = __webpack_require__(7);
var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(dataFromLitiumSaga);function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}// API Calls
// Actions
var formatData=function formatData(arrayData){var key=arguments.length>1&&arguments[1]!==undefined?arguments[1]:'id';return arrayData.reduce(function(memory,item){return memory.merge(_defineProperty({},item.get(key),item));},Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])());};function dataFromLitiumSaga(_ref){var payload=_ref.payload;var result,formatResponse;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function dataFromLitiumSaga$(_context){while(1){switch(_context.prev=_context.next){case 0:if(!(payload&&payload.payload)){_context.next=5;break;}_context.next=3;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["c" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_4__actions_actionCreators__["r" /* fetchCartSuccess */])(Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["fromJS"])(payload.payload)));case 3:_context.next=34;break;case 5:_context.prev=5;_context.next=8;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["a" /* call */])(function(){return Object(__WEBPACK_IMPORTED_MODULE_3__api_productData__["c" /* fetchProductsData */])(payload);});case 8:result=_context.sent;if(!result.products){_context.next=12;break;}_context.next=12;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["c" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_4__actions_actionCreators__["M" /* fetchProductsDataSuccess */])(formatData(Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["fromJS"])(result.products))));case 12:if(!result.designers){_context.next=15;break;}_context.next=15;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["c" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_4__actions_actionCreators__["A" /* fetchDesignerDataSuccess */])(formatData(Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["fromJS"])(result.designers))));case 15:if(!result.cart){_context.next=18;break;}_context.next=18;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["c" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_4__actions_actionCreators__["r" /* fetchCartSuccess */])(formatData(Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["fromJS"])(result.cart))));case 18:if(!result.title){_context.next=22;break;}formatResponse=[result];_context.next=22;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["c" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_4__actions_actionCreators__["i" /* fetchArticlePageViewSuccess */])(formatData(Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["fromJS"])(formatResponse),'title')));case 22:_context.next=34;break;case 24:_context.prev=24;_context.t0=_context['catch'](5);_context.next=28;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["c" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_4__actions_actionCreators__["L" /* fetchProductsDataError */])(_context.t0));case 28:_context.next=30;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["c" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_4__actions_actionCreators__["z" /* fetchDesignerDataError */])(_context.t0));case 30:_context.next=32;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["c" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_4__actions_actionCreators__["q" /* fetchCartFail */])(_context.t0));case 32:_context.next=34;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["c" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_4__actions_actionCreators__["h" /* fetchArticlePageViewFail */])(_context.t0));case 34:case'end':return _context.stop();}}},_marked,this,[[5,24]]);}

/***/ }),
/* 733 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = globalSearch;
/* harmony export (immutable) */ __webpack_exports__["b"] = quickSearch;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_globalSearchApi__ = __webpack_require__(734);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions_actionCreators__ = __webpack_require__(7);
var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(globalSearch),_marked2=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(quickSearch);// API Calls
// Actions
function globalSearch(_ref){var payload=_ref.payload;var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function globalSearch$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.prev=0;_context.next=3;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["a" /* call */])(function(){return Object(__WEBPACK_IMPORTED_MODULE_3__api_globalSearchApi__["a" /* globalSearchApi */])(payload);});case 3:result=_context.sent;_context.next=6;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["c" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_4__actions_actionCreators__["D" /* fetchGlobalSearchSuccess */])(Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["fromJS"])(result)));case 6:_context.next=12;break;case 8:_context.prev=8;_context.t0=_context['catch'](0);_context.next=12;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["c" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_4__actions_actionCreators__["C" /* fetchGlobalSearchFail */])(_context.t0));case 12:case'end':return _context.stop();}}},_marked,this,[[0,8]]);}function quickSearch(_ref2){var payload=_ref2.payload;var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function quickSearch$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.prev=0;_context2.next=3;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["a" /* call */])(function(){return Object(__WEBPACK_IMPORTED_MODULE_3__api_globalSearchApi__["a" /* globalSearchApi */])(payload);});case 3:result=_context2.sent;_context2.next=6;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["c" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_4__actions_actionCreators__["P" /* fetchQuickSearchSuccess */])(Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["fromJS"])(result)));case 6:_context2.next=12;break;case 8:_context2.prev=8;_context2.t0=_context2['catch'](0);_context2.next=12;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["c" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_4__actions_actionCreators__["O" /* fetchQuickSearchFail */])(_context2.t0));case 12:case'end':return _context2.stop();}}},_marked2,this,[[0,8]]);}

/***/ }),
/* 734 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return globalSearchApi; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_endpoints__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_mapToObject__ = __webpack_require__(166);
var globalSearchApi=function globalSearchApi(query){var method='GET';var headers=new window.Headers();var mode='cors';var url=__WEBPACK_IMPORTED_MODULE_1__constants_endpoints__["k" /* GLOBAL_SEARCH_BASE_API */]+'?query='+query;headers.append('Accept','application/json');headers.append('Content-Type','application/json');var options={headers:headers,method:method,mode:mode};return window.fetch(url,options).then(function(response){if(response.ok){return response.json();}return'error';}).then(function(data){if(data&&data.products&&data.products.hits&&data.products.hits.length){return Object.assign({},data,{products:{hits:data.products.hits.map(function(productHit){return Object.assign({},productHit,{item:Object(__WEBPACK_IMPORTED_MODULE_2__util_mapToObject__["a" /* addPriceToBaseProduct */])(Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(productHit.item))});})}});}return data;}).catch(function(error){throw error;});};

/***/ }),
/* 735 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = cmsPage;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_CmsPageApi__ = __webpack_require__(736);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions_actionCreators__ = __webpack_require__(7);
var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(cmsPage);// API Calls
// Actions
function cmsPage(_ref){var meta=_ref.meta;var payload;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function cmsPage$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.prev=0;_context.next=3;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["a" /* call */])(function(){return Object(__WEBPACK_IMPORTED_MODULE_2__api_CmsPageApi__["a" /* fetchCmsPage */])(meta);});case 3:payload=_context.sent;_context.next=6;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["c" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_3__actions_actionCreators__["i" /* fetchArticlePageViewSuccess */])({payload:payload,meta:meta}));case 6:_context.next=12;break;case 8:_context.prev=8;_context.t0=_context['catch'](0);_context.next=12;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["c" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_3__actions_actionCreators__["h" /* fetchArticlePageViewFail */])({error:_context.t0,meta:meta}));case 12:case'end':return _context.stop();}}},_marked,this,[[0,8]]);}

/***/ }),
/* 736 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fetchCmsPage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_qs__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__generalApi__ = __webpack_require__(85);
var fetchCmsPage=function fetchCmsPage(params){// add query strings from URL as params in "/api/content" requests
var queryObject=__WEBPACK_IMPORTED_MODULE_0_qs___default.a.parse(window.location.search.substring(1));return __WEBPACK_IMPORTED_MODULE_1__generalApi__["a" /* axiosSingleton */].get('/content',{params:Object.assign({},params,queryObject)}).then(function(_ref){var data=_ref.data;return data;}).catch(function(error){throw error;});};

/***/ }),
/* 737 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = brands;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_cmsBrandApi__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions_actionCreators__ = __webpack_require__(7);
var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(brands);// API Calls
// Actions
function brands(_ref){var payload=_ref.payload;var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function brands$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.prev=0;_context.next=3;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["a" /* call */])(function(){return Object(__WEBPACK_IMPORTED_MODULE_3__api_cmsBrandApi__["a" /* fetchBrandData */])(payload);});case 3:result=_context.sent;_context.next=6;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["c" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_4__actions_actionCreators__["l" /* fetchBrandDataSuccess */])(Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["fromJS"])(result)));case 6:_context.next=12;break;case 8:_context.prev=8;_context.t0=_context['catch'](0);_context.next=12;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["c" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_4__actions_actionCreators__["k" /* fetchBrandDataFail */])(_context.t0));case 12:case'end':return _context.stop();}}},_marked,this,[[0,8]]);}

/***/ }),
/* 738 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = products;
/* harmony export (immutable) */ __webpack_exports__["c"] = productsList;
/* harmony export (immutable) */ __webpack_exports__["a"] = product;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_productData__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions_actionCreators__ = __webpack_require__(7);
var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(products),_marked2=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(productsList),_marked3=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(product);// API Calls
// Actions
function products(_ref){var meta=_ref.meta;var id,payload;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function products$(_context){while(1){switch(_context.prev=_context.next){case 0:id=meta.id;_context.prev=1;_context.next=4;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["a" /* call */])(function(){return Object(__WEBPACK_IMPORTED_MODULE_2__api_productData__["c" /* fetchProductsData */])(id);});case 4:payload=_context.sent;_context.next=7;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["c" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_3__actions_actionCreators__["M" /* fetchProductsDataSuccess */])({payload:payload,meta:meta}));case 7:_context.next=13;break;case 9:_context.prev=9;_context.t0=_context['catch'](1);_context.next=13;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["c" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_3__actions_actionCreators__["L" /* fetchProductsDataError */])({error:_context.t0,meta:meta}));case 13:case'end':return _context.stop();}}},_marked,this,[[1,9]]);}function productsList(_ref2){var meta=_ref2.meta;var id,payload;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function productsList$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:id=meta.id;_context2.prev=1;_context2.next=4;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["a" /* call */])(function(){return Object(__WEBPACK_IMPORTED_MODULE_2__api_productData__["d" /* fetchProductsDataList */])(id);});case 4:payload=_context2.sent;_context2.next=7;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["c" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_3__actions_actionCreators__["o" /* fetchCampaignProductsSuccess */])({payload:payload,meta:meta}));case 7:_context2.next=13;break;case 9:_context2.prev=9;_context2.t0=_context2['catch'](1);_context2.next=13;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["c" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_3__actions_actionCreators__["n" /* fetchCampaignProductsError */])({error:_context2.t0,meta:meta}));case 13:case'end':return _context2.stop();}}},_marked2,this,[[1,9]]);}function product(_ref3){var meta=_ref3.meta;var id,payload;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function product$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:id=meta.id;_context3.prev=1;_context3.next=4;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["a" /* call */])(function(){return Object(__WEBPACK_IMPORTED_MODULE_2__api_productData__["b" /* fetchProductData */])(id);});case 4:payload=_context3.sent;_context3.next=7;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["c" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_3__actions_actionCreators__["J" /* fetchProductSuccess */])({payload:payload,meta:meta}));case 7:_context3.next=13;break;case 9:_context3.prev=9;_context3.t0=_context3['catch'](1);_context3.next=13;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["c" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_3__actions_actionCreators__["I" /* fetchProductError */])({error:_context3.t0,meta:meta}));case 13:case'end':return _context3.stop();}}},_marked3,this,[[1,9]]);}

/***/ }),
/* 739 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = category;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_productData__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions_actionCreators__ = __webpack_require__(7);
var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(category);// API Calls
// Actions
function category(_ref){var meta=_ref.meta;var url,payload;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function category$(_context){while(1){switch(_context.prev=_context.next){case 0:url=meta.url;_context.prev=1;_context.next=4;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["a" /* call */])(function(){return Object(__WEBPACK_IMPORTED_MODULE_2__api_productData__["a" /* fetchCategoryMetaData */])(url);});case 4:payload=_context.sent;_context.next=7;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["c" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_3__actions_actionCreators__["u" /* fetchCategoryMetaDataSuccess */])({payload:payload,meta:meta}));case 7:_context.next=13;break;case 9:_context.prev=9;_context.t0=_context['catch'](1);_context.next=13;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["c" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_3__actions_actionCreators__["t" /* fetchCategoryMetaDataFail */])({error:_context.t0,meta:meta}));case 13:case'end':return _context.stop();}}},_marked,this,[[1,9]]);}

/***/ }),
/* 740 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = cart;
/* harmony export (immutable) */ __webpack_exports__["a"] = addCartItem;
/* harmony export (immutable) */ __webpack_exports__["d"] = removeCartItem;
/* harmony export (immutable) */ __webpack_exports__["c"] = deleteCartRow;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_cartApi__ = __webpack_require__(741);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions_actionCreators__ = __webpack_require__(7);
var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(cart),_marked2=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(addCartItem),_marked3=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(removeCartItem),_marked4=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(deleteCartRow);// API Calls
// Actions
function cart(_ref){var payload=_ref.payload;var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function cart$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.prev=0;_context.next=3;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["a" /* call */])(function(){return Object(__WEBPACK_IMPORTED_MODULE_3__api_cartApi__["a" /* cartApi */])(payload);});case 3:result=_context.sent;_context.next=6;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["c" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_4__actions_actionCreators__["r" /* fetchCartSuccess */])(Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["fromJS"])(result)));case 6:_context.next=12;break;case 8:_context.prev=8;_context.t0=_context['catch'](0);_context.next=12;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["c" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_4__actions_actionCreators__["q" /* fetchCartFail */])(_context.t0));case 12:case'end':return _context.stop();}}},_marked,this,[[0,8]]);}function addCartItem(_ref2){var payload=_ref2.payload;var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function addCartItem$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.prev=0;_context2.next=3;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["a" /* call */])(function(){return Object(__WEBPACK_IMPORTED_MODULE_3__api_cartApi__["a" /* cartApi */])(payload);});case 3:result=_context2.sent;_context2.next=6;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["c" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_4__actions_actionCreators__["c" /* addCartItemSuccess */])(Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["fromJS"])(result)));case 6:_context2.next=12;break;case 8:_context2.prev=8;_context2.t0=_context2['catch'](0);_context2.next=12;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["c" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_4__actions_actionCreators__["b" /* addCartItemFail */])(_context2.t0));case 12:case'end':return _context2.stop();}}},_marked2,this,[[0,8]]);}function removeCartItem(_ref3){var payload=_ref3.payload,cartRow=_ref3.cartRow;var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function removeCartItem$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.prev=0;_context3.next=3;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["a" /* call */])(function(){return Object(__WEBPACK_IMPORTED_MODULE_3__api_cartApi__["a" /* cartApi */])(payload);});case 3:result=_context3.sent;_context3.next=6;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["c" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_4__actions_actionCreators__["S" /* removeCartItemSuccess */])(Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["fromJS"])(result),cartRow));case 6:_context3.next=12;break;case 8:_context3.prev=8;_context3.t0=_context3['catch'](0);_context3.next=12;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["c" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_4__actions_actionCreators__["R" /* removeCartItemFail */])(_context3.t0));case 12:case'end':return _context3.stop();}}},_marked3,this,[[0,8]]);}function deleteCartRow(_ref4){var payload=_ref4.payload,cartRow=_ref4.cartRow;var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function deleteCartRow$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_context4.prev=0;_context4.next=3;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["a" /* call */])(function(){return Object(__WEBPACK_IMPORTED_MODULE_3__api_cartApi__["a" /* cartApi */])(payload);});case 3:result=_context4.sent;_context4.next=6;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["c" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_4__actions_actionCreators__["f" /* deleteCartRowSuccess */])(Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["fromJS"])(result),cartRow));case 6:_context4.next=12;break;case 8:_context4.prev=8;_context4.t0=_context4['catch'](0);_context4.next=12;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["c" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_4__actions_actionCreators__["e" /* deleteCartRowFail */])(_context4.t0));case 12:case'end':return _context4.stop();}}},_marked4,this,[[0,8]]);}

/***/ }),
/* 741 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return cartApi; });
var cartApi=function cartApi(args){var method=args.method||'POST';var headers=new window.Headers();var credentials='include';var mode='cors';var url=args.endpointUrl;var body=JSON.stringify(args.body);headers.append('Accept','application/json');headers.append('Content-Type','application/json');var options={headers:headers,method:method,credentials:credentials,mode:mode,body:body};return window.fetch(url,options).then(function(response){if(response.ok){return response.json();}return response.error();}).then(function(json){return json;}).catch(function(error){throw error;});};

/***/ }),
/* 742 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = instagram;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_generalApi__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions_actionCreators__ = __webpack_require__(7);
var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(instagram);// API Calls
// Actions
function instagram(_ref){var payload=_ref.payload;var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function instagram$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.prev=0;_context.next=3;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["a" /* call */])(function(){return Object(__WEBPACK_IMPORTED_MODULE_3__api_generalApi__["b" /* generalGetRequest */])(payload);});case 3:result=_context.sent;_context.next=6;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["c" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_4__actions_actionCreators__["G" /* fetchInstagramPostsSuccess */])(Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["fromJS"])(result)));case 6:_context.next=12;break;case 8:_context.prev=8;_context.t0=_context['catch'](0);_context.next=12;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["c" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_4__actions_actionCreators__["F" /* fetchInstagramPostsFail */])(_context.t0));case 12:case'end':return _context.stop();}}},_marked,this,[[0,8]]);}

/***/ }),
/* 743 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = deliveryMethods;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_checkoutApi__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions_actionCreators__ = __webpack_require__(7);
var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(deliveryMethods);// API Calls
// Actions
function deliveryMethods(_ref){var payload=_ref.payload;var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function deliveryMethods$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.prev=0;_context.next=3;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["a" /* call */])(function(){return Object(__WEBPACK_IMPORTED_MODULE_3__api_checkoutApi__["b" /* getDeliveryMethods */])(payload);});case 3:result=_context.sent;_context.next=6;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["c" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_4__actions_actionCreators__["x" /* fetchDeliveryMethodsSuccess */])(Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["fromJS"])(result)));case 6:_context.next=12;break;case 8:_context.prev=8;_context.t0=_context['catch'](0);_context.next=12;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["c" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_4__actions_actionCreators__["w" /* fetchDeliveryMethodsFail */])(_context.t0));case 12:case'end':return _context.stop();}}},_marked,this,[[0,8]]);}

/***/ }),
/* 744 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = designers;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_cmsBrandApi__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions_actionCreators__ = __webpack_require__(7);
var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(designers);// API Calls
// Actions
function designers(_ref){var payload=_ref.payload;var result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function designers$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.prev=0;_context.next=3;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["a" /* call */])(function(){return Object(__WEBPACK_IMPORTED_MODULE_3__api_cmsBrandApi__["b" /* fetchDesignerData */])(payload);});case 3:result=_context.sent;_context.next=6;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["c" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_4__actions_actionCreators__["A" /* fetchDesignerDataSuccess */])(Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["fromJS"])(result)));case 6:_context.next=12;break;case 8:_context.prev=8;_context.t0=_context['catch'](0);_context.next=12;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["c" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_4__actions_actionCreators__["z" /* fetchDesignerDataError */])(_context.t0));case 12:case'end':return _context.stop();}}},_marked,this,[[0,8]]);}

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// static/js/main.9fe4d2a5.js